
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*! choices.js v11.0.2 | © 2024 Josh Johnson | https://github.com/jshjohnson/Choices#readme */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $a72ba5db1effc4ca$var$extendStatics = function(d, b) {
    $a72ba5db1effc4ca$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a72ba5db1effc4ca$var$extendStatics(d, b);
};
function $a72ba5db1effc4ca$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a72ba5db1effc4ca$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a72ba5db1effc4ca$var$__assign = function() {
    $a72ba5db1effc4ca$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a72ba5db1effc4ca$var$__assign.apply(this, arguments);
};
function $a72ba5db1effc4ca$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $a72ba5db1effc4ca$var$ActionType = {
    ADD_CHOICE: "ADD_CHOICE",
    REMOVE_CHOICE: "REMOVE_CHOICE",
    FILTER_CHOICES: "FILTER_CHOICES",
    ACTIVATE_CHOICES: "ACTIVATE_CHOICES",
    CLEAR_CHOICES: "CLEAR_CHOICES",
    ADD_GROUP: "ADD_GROUP",
    ADD_ITEM: "ADD_ITEM",
    REMOVE_ITEM: "REMOVE_ITEM",
    HIGHLIGHT_ITEM: "HIGHLIGHT_ITEM"
};
var $a72ba5db1effc4ca$var$EventType = {
    showDropdown: "showDropdown",
    hideDropdown: "hideDropdown",
    change: "change",
    choice: "choice",
    search: "search",
    addItem: "addItem",
    removeItem: "removeItem",
    highlightItem: "highlightItem",
    highlightChoice: "highlightChoice",
    unhighlightItem: "unhighlightItem"
};
var $a72ba5db1effc4ca$var$ObjectsInConfig = [
    "fuseOptions",
    "classNames"
];
var $a72ba5db1effc4ca$var$PassedElementTypes = {
    Text: "text",
    SelectOne: "select-one",
    SelectMultiple: "select-multiple"
};
var $a72ba5db1effc4ca$var$addChoice = function(choice) {
    return {
        type: $a72ba5db1effc4ca$var$ActionType.ADD_CHOICE,
        choice: choice
    };
};
var $a72ba5db1effc4ca$var$removeChoice = function(choice) {
    return {
        type: $a72ba5db1effc4ca$var$ActionType.REMOVE_CHOICE,
        choice: choice
    };
};
var $a72ba5db1effc4ca$var$filterChoices = function(results) {
    return {
        type: $a72ba5db1effc4ca$var$ActionType.FILTER_CHOICES,
        results: results
    };
};
var $a72ba5db1effc4ca$var$activateChoices = function(active) {
    return {
        type: $a72ba5db1effc4ca$var$ActionType.ACTIVATE_CHOICES,
        active: active
    };
};
var $a72ba5db1effc4ca$var$addGroup = function(group) {
    return {
        type: $a72ba5db1effc4ca$var$ActionType.ADD_GROUP,
        group: group
    };
};
var $a72ba5db1effc4ca$var$addItem = function(item) {
    return {
        type: $a72ba5db1effc4ca$var$ActionType.ADD_ITEM,
        item: item
    };
};
var $a72ba5db1effc4ca$var$removeItem$1 = function(item) {
    return {
        type: $a72ba5db1effc4ca$var$ActionType.REMOVE_ITEM,
        item: item
    };
};
var $a72ba5db1effc4ca$var$highlightItem = function(item, highlighted) {
    return {
        type: $a72ba5db1effc4ca$var$ActionType.HIGHLIGHT_ITEM,
        item: item,
        highlighted: highlighted
    };
};
var $a72ba5db1effc4ca$var$getRandomNumber = function(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
};
var $a72ba5db1effc4ca$var$generateChars = function(length) {
    return Array.from({
        length: length
    }, function() {
        return $a72ba5db1effc4ca$var$getRandomNumber(0, 36).toString(36);
    }).join("");
};
var $a72ba5db1effc4ca$var$generateId = function(element, prefix) {
    var id = element.id || element.name && "".concat(element.name, "-").concat($a72ba5db1effc4ca$var$generateChars(2)) || $a72ba5db1effc4ca$var$generateChars(4);
    id = id.replace(/(:|\.|\[|\]|,)/g, "");
    id = "".concat(prefix, "-").concat(id);
    return id;
};
var $a72ba5db1effc4ca$var$getAdjacentEl = function(startEl, selector, direction) {
    if (direction === void 0) direction = 1;
    var prop = "".concat(direction > 0 ? "next" : "previous", "ElementSibling");
    var sibling = startEl[prop];
    while(sibling){
        if (sibling.matches(selector)) return sibling;
        sibling = sibling[prop];
    }
    return null;
};
var $a72ba5db1effc4ca$var$isScrolledIntoView = function(element, parent, direction) {
    if (direction === void 0) direction = 1;
    var isVisible;
    if (direction > 0) // In view from bottom
    isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
    else // In view from top
    isVisible = element.offsetTop >= parent.scrollTop;
    return isVisible;
};
var $a72ba5db1effc4ca$var$sanitise = function(value) {
    if (typeof value !== "string") {
        if (value === null || value === undefined) return "";
        if (typeof value === "object") {
            if ("raw" in value) return $a72ba5db1effc4ca$var$sanitise(value.raw);
            if ("trusted" in value) return value.trusted;
        }
        return value;
    }
    return value.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/'/g, "&#039;").replace(/"/g, "&quot;");
};
var $a72ba5db1effc4ca$var$strToEl = function() {
    var tmpEl = document.createElement("div");
    return function(str) {
        tmpEl.innerHTML = str.trim();
        var firstChild = tmpEl.children[0];
        while(tmpEl.firstChild)tmpEl.removeChild(tmpEl.firstChild);
        return firstChild;
    };
}();
var $a72ba5db1effc4ca$var$resolveNoticeFunction = function(fn, value) {
    return typeof fn === "function" ? fn($a72ba5db1effc4ca$var$sanitise(value), value) : fn;
};
var $a72ba5db1effc4ca$var$resolveStringFunction = function(fn) {
    return typeof fn === "function" ? fn() : fn;
};
var $a72ba5db1effc4ca$var$unwrapStringForRaw = function(s) {
    if (typeof s === "string") return s;
    if (typeof s === "object") {
        if ("trusted" in s) return s.trusted;
        if ("raw" in s) return s.raw;
    }
    return "";
};
var $a72ba5db1effc4ca$var$unwrapStringForEscaped = function(s) {
    if (typeof s === "string") return s;
    if (typeof s === "object") {
        if ("escaped" in s) return s.escaped;
        if ("trusted" in s) return s.trusted;
    }
    return "";
};
var $a72ba5db1effc4ca$var$escapeForTemplate = function(allowHTML, s) {
    return allowHTML ? $a72ba5db1effc4ca$var$unwrapStringForEscaped(s) : $a72ba5db1effc4ca$var$sanitise(s);
};
var $a72ba5db1effc4ca$var$setElementHtml = function(el, allowHtml, html) {
    el.innerHTML = $a72ba5db1effc4ca$var$escapeForTemplate(allowHtml, html);
};
var $a72ba5db1effc4ca$var$sortByAlpha = function(_a, _b) {
    var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
    var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
    return $a72ba5db1effc4ca$var$unwrapStringForRaw(label).localeCompare($a72ba5db1effc4ca$var$unwrapStringForRaw(label2), [], {
        sensitivity: "base",
        ignorePunctuation: true,
        numeric: true
    });
};
var $a72ba5db1effc4ca$var$sortByRank = function(a, b) {
    return a.rank - b.rank;
};
var $a72ba5db1effc4ca$var$dispatchEvent = function(element, type, customArgs) {
    if (customArgs === void 0) customArgs = null;
    var event = new CustomEvent(type, {
        detail: customArgs,
        bubbles: true,
        cancelable: true
    });
    return element.dispatchEvent(event);
};
/**
 * Returns an array of keys present on the first but missing on the second object
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $a72ba5db1effc4ca$var$diff = function(a, b) {
    var aKeys = Object.keys(a).sort();
    var bKeys = Object.keys(b).sort();
    return aKeys.filter(function(i) {
        return bKeys.indexOf(i) < 0;
    });
};
var $a72ba5db1effc4ca$var$getClassNames = function(ClassNames) {
    return Array.isArray(ClassNames) ? ClassNames : [
        ClassNames
    ];
};
var $a72ba5db1effc4ca$var$getClassNamesSelector = function(option) {
    if (option && Array.isArray(option)) return option.map(function(item) {
        return ".".concat(item);
    }).join("");
    return ".".concat(option);
};
var $a72ba5db1effc4ca$var$addClassesToElement = function(element, className) {
    var _a;
    (_a = element.classList).add.apply(_a, $a72ba5db1effc4ca$var$getClassNames(className));
};
var $a72ba5db1effc4ca$var$removeClassesFromElement = function(element, className) {
    var _a;
    (_a = element.classList).remove.apply(_a, $a72ba5db1effc4ca$var$getClassNames(className));
};
var $a72ba5db1effc4ca$var$parseCustomProperties = function(customProperties) {
    if (typeof customProperties !== "undefined") try {
        return JSON.parse(customProperties);
    } catch (e) {
        return customProperties;
    }
    return {};
};
var $a72ba5db1effc4ca$var$updateClassList = function(item, add, remove) {
    var itemEl = item.itemEl;
    if (itemEl) {
        $a72ba5db1effc4ca$var$removeClassesFromElement(itemEl, remove);
        $a72ba5db1effc4ca$var$addClassesToElement(itemEl, add);
    }
};
var $a72ba5db1effc4ca$var$Dropdown = /** @class */ function() {
    function Dropdown(_a) {
        var element = _a.element, type = _a.type, classNames = _a.classNames;
        this.element = element;
        this.classNames = classNames;
        this.type = type;
        this.isActive = false;
    }
    /**
     * Show dropdown to user by adding active state class
     */ Dropdown.prototype.show = function() {
        $a72ba5db1effc4ca$var$addClassesToElement(this.element, this.classNames.activeState);
        this.element.setAttribute("aria-expanded", "true");
        this.isActive = true;
        return this;
    };
    /**
     * Hide dropdown from user
     */ Dropdown.prototype.hide = function() {
        $a72ba5db1effc4ca$var$removeClassesFromElement(this.element, this.classNames.activeState);
        this.element.setAttribute("aria-expanded", "false");
        this.isActive = false;
        return this;
    };
    return Dropdown;
}();
var $a72ba5db1effc4ca$var$Container = /** @class */ function() {
    function Container(_a) {
        var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
        this.element = element;
        this.classNames = classNames;
        this.type = type;
        this.position = position;
        this.isOpen = false;
        this.isFlipped = false;
        this.isDisabled = false;
        this.isLoading = false;
    }
    /**
     * Determine whether container should be flipped based on passed
     * dropdown position
     */ Container.prototype.shouldFlip = function(dropdownPos, dropdownHeight) {
        // If flip is enabled and the dropdown bottom position is
        // greater than the window height flip the dropdown.
        var shouldFlip = false;
        if (this.position === "auto") shouldFlip = this.element.getBoundingClientRect().top - dropdownHeight >= 0 && !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
        else if (this.position === "top") shouldFlip = true;
        return shouldFlip;
    };
    Container.prototype.setActiveDescendant = function(activeDescendantID) {
        this.element.setAttribute("aria-activedescendant", activeDescendantID);
    };
    Container.prototype.removeActiveDescendant = function() {
        this.element.removeAttribute("aria-activedescendant");
    };
    Container.prototype.open = function(dropdownPos, dropdownHeight) {
        $a72ba5db1effc4ca$var$addClassesToElement(this.element, this.classNames.openState);
        this.element.setAttribute("aria-expanded", "true");
        this.isOpen = true;
        if (this.shouldFlip(dropdownPos, dropdownHeight)) {
            $a72ba5db1effc4ca$var$addClassesToElement(this.element, this.classNames.flippedState);
            this.isFlipped = true;
        }
    };
    Container.prototype.close = function() {
        $a72ba5db1effc4ca$var$removeClassesFromElement(this.element, this.classNames.openState);
        this.element.setAttribute("aria-expanded", "false");
        this.removeActiveDescendant();
        this.isOpen = false;
        // A dropdown flips if it does not have space within the page
        if (this.isFlipped) {
            $a72ba5db1effc4ca$var$removeClassesFromElement(this.element, this.classNames.flippedState);
            this.isFlipped = false;
        }
    };
    Container.prototype.addFocusState = function() {
        $a72ba5db1effc4ca$var$addClassesToElement(this.element, this.classNames.focusState);
    };
    Container.prototype.removeFocusState = function() {
        $a72ba5db1effc4ca$var$removeClassesFromElement(this.element, this.classNames.focusState);
    };
    Container.prototype.enable = function() {
        $a72ba5db1effc4ca$var$removeClassesFromElement(this.element, this.classNames.disabledState);
        this.element.removeAttribute("aria-disabled");
        if (this.type === $a72ba5db1effc4ca$var$PassedElementTypes.SelectOne) this.element.setAttribute("tabindex", "0");
        this.isDisabled = false;
    };
    Container.prototype.disable = function() {
        $a72ba5db1effc4ca$var$addClassesToElement(this.element, this.classNames.disabledState);
        this.element.setAttribute("aria-disabled", "true");
        if (this.type === $a72ba5db1effc4ca$var$PassedElementTypes.SelectOne) this.element.setAttribute("tabindex", "-1");
        this.isDisabled = true;
    };
    Container.prototype.wrap = function(element) {
        var el = this.element;
        var parentNode = element.parentNode;
        if (parentNode) {
            if (element.nextSibling) parentNode.insertBefore(el, element.nextSibling);
            else parentNode.appendChild(el);
        }
        el.appendChild(element);
    };
    Container.prototype.unwrap = function(element) {
        var el = this.element;
        var parentNode = el.parentNode;
        if (parentNode) {
            // Move passed element outside this element
            parentNode.insertBefore(element, el);
            // Remove this element
            parentNode.removeChild(el);
        }
    };
    Container.prototype.addLoadingState = function() {
        $a72ba5db1effc4ca$var$addClassesToElement(this.element, this.classNames.loadingState);
        this.element.setAttribute("aria-busy", "true");
        this.isLoading = true;
    };
    Container.prototype.removeLoadingState = function() {
        $a72ba5db1effc4ca$var$removeClassesFromElement(this.element, this.classNames.loadingState);
        this.element.removeAttribute("aria-busy");
        this.isLoading = false;
    };
    return Container;
}();
var $a72ba5db1effc4ca$var$Input = /** @class */ function() {
    function Input(_a) {
        var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
        this.element = element;
        this.type = type;
        this.classNames = classNames;
        this.preventPaste = preventPaste;
        this.isFocussed = this.element.isEqualNode(document.activeElement);
        this.isDisabled = element.disabled;
        this._onPaste = this._onPaste.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onBlur = this._onBlur.bind(this);
    }
    Object.defineProperty(Input.prototype, "placeholder", {
        set: function(placeholder) {
            this.element.placeholder = placeholder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "value", {
        get: function() {
            return this.element.value;
        },
        set: function(value) {
            this.element.value = value;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.addEventListeners = function() {
        var el = this.element;
        el.addEventListener("paste", this._onPaste);
        el.addEventListener("input", this._onInput, {
            passive: true
        });
        el.addEventListener("focus", this._onFocus, {
            passive: true
        });
        el.addEventListener("blur", this._onBlur, {
            passive: true
        });
    };
    Input.prototype.removeEventListeners = function() {
        var el = this.element;
        el.removeEventListener("input", this._onInput);
        el.removeEventListener("paste", this._onPaste);
        el.removeEventListener("focus", this._onFocus);
        el.removeEventListener("blur", this._onBlur);
    };
    Input.prototype.enable = function() {
        var el = this.element;
        el.removeAttribute("disabled");
        this.isDisabled = false;
    };
    Input.prototype.disable = function() {
        var el = this.element;
        el.setAttribute("disabled", "");
        this.isDisabled = true;
    };
    Input.prototype.focus = function() {
        if (!this.isFocussed) this.element.focus();
    };
    Input.prototype.blur = function() {
        if (this.isFocussed) this.element.blur();
    };
    Input.prototype.clear = function(setWidth) {
        if (setWidth === void 0) setWidth = true;
        this.element.value = "";
        if (setWidth) this.setWidth();
        return this;
    };
    /**
     * Set the correct input width based on placeholder
     * value or input value
     */ Input.prototype.setWidth = function() {
        // Resize input to contents or placeholder
        var element = this.element;
        element.style.minWidth = "".concat(element.placeholder.length + 1, "ch");
        element.style.width = "".concat(element.value.length + 1, "ch");
    };
    Input.prototype.setActiveDescendant = function(activeDescendantID) {
        this.element.setAttribute("aria-activedescendant", activeDescendantID);
    };
    Input.prototype.removeActiveDescendant = function() {
        this.element.removeAttribute("aria-activedescendant");
    };
    Input.prototype._onInput = function() {
        if (this.type !== $a72ba5db1effc4ca$var$PassedElementTypes.SelectOne) this.setWidth();
    };
    Input.prototype._onPaste = function(event) {
        if (this.preventPaste) event.preventDefault();
    };
    Input.prototype._onFocus = function() {
        this.isFocussed = true;
    };
    Input.prototype._onBlur = function() {
        this.isFocussed = false;
    };
    return Input;
}();
var $a72ba5db1effc4ca$var$SCROLLING_SPEED = 4;
var $a72ba5db1effc4ca$var$List = /** @class */ function() {
    function List(_a) {
        var element = _a.element;
        this.element = element;
        this.scrollPos = this.element.scrollTop;
        this.height = this.element.offsetHeight;
    }
    List.prototype.prepend = function(node) {
        var child = this.element.firstElementChild;
        if (child) this.element.insertBefore(node, child);
        else this.element.append(node);
    };
    List.prototype.scrollToTop = function() {
        this.element.scrollTop = 0;
    };
    List.prototype.scrollToChildElement = function(element, direction) {
        var _this = this;
        if (!element) return;
        var listHeight = this.element.offsetHeight;
        // Scroll position of dropdown
        var listScrollPosition = this.element.scrollTop + listHeight;
        var elementHeight = element.offsetHeight;
        // Distance from bottom of element to top of parent
        var elementPos = element.offsetTop + elementHeight;
        // Difference between the element and scroll position
        var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
        requestAnimationFrame(function() {
            _this._animateScroll(destination, direction);
        });
    };
    List.prototype._scrollDown = function(scrollPos, strength, destination) {
        var easing = (destination - scrollPos) / strength;
        var distance = easing > 1 ? easing : 1;
        this.element.scrollTop = scrollPos + distance;
    };
    List.prototype._scrollUp = function(scrollPos, strength, destination) {
        var easing = (scrollPos - destination) / strength;
        var distance = easing > 1 ? easing : 1;
        this.element.scrollTop = scrollPos - distance;
    };
    List.prototype._animateScroll = function(destination, direction) {
        var _this = this;
        var strength = $a72ba5db1effc4ca$var$SCROLLING_SPEED;
        var choiceListScrollTop = this.element.scrollTop;
        var continueAnimation = false;
        if (direction > 0) {
            this._scrollDown(choiceListScrollTop, strength, destination);
            if (choiceListScrollTop < destination) continueAnimation = true;
        } else {
            this._scrollUp(choiceListScrollTop, strength, destination);
            if (choiceListScrollTop > destination) continueAnimation = true;
        }
        if (continueAnimation) requestAnimationFrame(function() {
            _this._animateScroll(destination, direction);
        });
    };
    return List;
}();
var $a72ba5db1effc4ca$var$WrappedElement = /** @class */ function() {
    function WrappedElement(_a) {
        var element = _a.element, classNames = _a.classNames;
        this.element = element;
        this.classNames = classNames;
        this.isDisabled = false;
    }
    Object.defineProperty(WrappedElement.prototype, "isActive", {
        get: function() {
            return this.element.dataset.choice === "active";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedElement.prototype, "dir", {
        get: function() {
            return this.element.dir;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedElement.prototype, "value", {
        get: function() {
            return this.element.value;
        },
        set: function(value) {
            this.element.setAttribute("value", value);
            this.element.value = value;
        },
        enumerable: false,
        configurable: true
    });
    WrappedElement.prototype.conceal = function() {
        var el = this.element;
        // Hide passed input
        $a72ba5db1effc4ca$var$addClassesToElement(el, this.classNames.input);
        el.hidden = true;
        // Remove element from tab index
        el.tabIndex = -1;
        // Backup original styles if any
        var origStyle = el.getAttribute("style");
        if (origStyle) el.setAttribute("data-choice-orig-style", origStyle);
        el.setAttribute("data-choice", "active");
    };
    WrappedElement.prototype.reveal = function() {
        var el = this.element;
        // Reinstate passed element
        $a72ba5db1effc4ca$var$removeClassesFromElement(el, this.classNames.input);
        el.hidden = false;
        el.removeAttribute("tabindex");
        // Recover original styles if any
        var origStyle = el.getAttribute("data-choice-orig-style");
        if (origStyle) {
            el.removeAttribute("data-choice-orig-style");
            el.setAttribute("style", origStyle);
        } else el.removeAttribute("style");
        el.removeAttribute("data-choice");
    };
    WrappedElement.prototype.enable = function() {
        this.element.removeAttribute("disabled");
        this.element.disabled = false;
        this.isDisabled = false;
    };
    WrappedElement.prototype.disable = function() {
        this.element.setAttribute("disabled", "");
        this.element.disabled = true;
        this.isDisabled = true;
    };
    WrappedElement.prototype.triggerEvent = function(eventType, data) {
        $a72ba5db1effc4ca$var$dispatchEvent(this.element, eventType, data || {});
    };
    return WrappedElement;
}();
var $a72ba5db1effc4ca$var$WrappedInput = /** @class */ function(_super) {
    $a72ba5db1effc4ca$var$__extends(WrappedInput, _super);
    function WrappedInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WrappedInput;
}($a72ba5db1effc4ca$var$WrappedElement);
var $a72ba5db1effc4ca$var$coerceBool = function(arg, defaultValue) {
    if (defaultValue === void 0) defaultValue = true;
    return typeof arg === "undefined" ? defaultValue : !!arg;
};
var $a72ba5db1effc4ca$var$stringToHtmlClass = function(input) {
    if (typeof input === "string") // eslint-disable-next-line no-param-reassign
    input = input.split(" ").filter(function(s) {
        return s.length;
    });
    if (Array.isArray(input) && input.length) return input;
    return undefined;
};
var $a72ba5db1effc4ca$var$mapInputToChoice = function(value, allowGroup) {
    if (typeof value === "string") {
        var result_1 = $a72ba5db1effc4ca$var$mapInputToChoice({
            value: value,
            label: value
        }, false);
        return result_1;
    }
    var groupOrChoice = value;
    if ("choices" in groupOrChoice) {
        if (!allowGroup) // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/optgroup
        throw new TypeError("optGroup is not allowed");
        var group = groupOrChoice;
        var choices = group.choices.map(function(e) {
            return $a72ba5db1effc4ca$var$mapInputToChoice(e, false);
        });
        var result_2 = {
            id: 0,
            label: $a72ba5db1effc4ca$var$unwrapStringForRaw(group.label) || group.value,
            active: !!choices.length,
            disabled: !!group.disabled,
            choices: choices
        };
        return result_2;
    }
    var choice = groupOrChoice;
    var result = {
        id: 0,
        group: null,
        score: 0,
        rank: 0,
        value: choice.value,
        label: choice.label || choice.value,
        active: $a72ba5db1effc4ca$var$coerceBool(choice.active),
        selected: $a72ba5db1effc4ca$var$coerceBool(choice.selected, false),
        disabled: $a72ba5db1effc4ca$var$coerceBool(choice.disabled, false),
        placeholder: $a72ba5db1effc4ca$var$coerceBool(choice.placeholder, false),
        highlighted: false,
        labelClass: $a72ba5db1effc4ca$var$stringToHtmlClass(choice.labelClass),
        labelDescription: choice.labelDescription,
        customProperties: choice.customProperties
    };
    return result;
};
var $a72ba5db1effc4ca$var$isHtmlInputElement = function(e) {
    return e.tagName === "INPUT";
};
var $a72ba5db1effc4ca$var$isHtmlSelectElement = function(e) {
    return e.tagName === "SELECT";
};
var $a72ba5db1effc4ca$var$isHtmlOption = function(e) {
    return e.tagName === "OPTION";
};
var $a72ba5db1effc4ca$var$isHtmlOptgroup = function(e) {
    return e.tagName === "OPTGROUP";
};
var $a72ba5db1effc4ca$var$WrappedSelect = /** @class */ function(_super) {
    $a72ba5db1effc4ca$var$__extends(WrappedSelect, _super);
    function WrappedSelect(_a) {
        var element = _a.element, classNames = _a.classNames, template = _a.template, extractPlaceholder = _a.extractPlaceholder;
        var _this = _super.call(this, {
            element: element,
            classNames: classNames
        }) || this;
        _this.template = template;
        _this.extractPlaceholder = extractPlaceholder;
        return _this;
    }
    Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
        get: function() {
            return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
            this.element.querySelector("option[placeholder]");
        },
        enumerable: false,
        configurable: true
    });
    WrappedSelect.prototype.addOptions = function(choices) {
        var _this = this;
        var fragment = document.createDocumentFragment();
        choices.forEach(function(obj) {
            var choice = obj;
            if (choice.element) return;
            var option = _this.template(choice);
            fragment.appendChild(option);
            choice.element = option;
        });
        this.element.appendChild(fragment);
    };
    WrappedSelect.prototype.optionsAsChoices = function() {
        var _this = this;
        var choices = [];
        this.element.querySelectorAll(":scope > option, :scope > optgroup").forEach(function(e) {
            if ($a72ba5db1effc4ca$var$isHtmlOption(e)) choices.push(_this._optionToChoice(e));
            else if ($a72ba5db1effc4ca$var$isHtmlOptgroup(e)) choices.push(_this._optgroupToChoice(e));
        // todo: hr as empty optgroup, requires displaying empty opt-groups to be useful
        });
        return choices;
    };
    // eslint-disable-next-line class-methods-use-this
    WrappedSelect.prototype._optionToChoice = function(option) {
        // option.value returns the label if there is no value attribute, which can break legacy placeholder attribute support
        if (!option.hasAttribute("value") && option.hasAttribute("placeholder")) {
            option.setAttribute("value", "");
            option.value = "";
        }
        return {
            id: 0,
            group: null,
            score: 0,
            rank: 0,
            value: option.value,
            label: option.innerHTML,
            element: option,
            active: true,
            // this returns true if nothing is selected on initial load, which will break placeholder support
            selected: this.extractPlaceholder ? option.selected : option.hasAttribute("selected"),
            disabled: option.disabled,
            highlighted: false,
            placeholder: this.extractPlaceholder && (!option.value || option.hasAttribute("placeholder")),
            labelClass: typeof option.dataset.labelClass !== "undefined" ? $a72ba5db1effc4ca$var$stringToHtmlClass(option.dataset.labelClass) : undefined,
            labelDescription: typeof option.dataset.labelDescription !== "undefined" ? option.dataset.labelDescription : undefined,
            customProperties: $a72ba5db1effc4ca$var$parseCustomProperties(option.dataset.customProperties)
        };
    };
    WrappedSelect.prototype._optgroupToChoice = function(optgroup) {
        var _this = this;
        var options = optgroup.querySelectorAll("option");
        var choices = Array.from(options).map(function(option) {
            return _this._optionToChoice(option);
        });
        return {
            id: 0,
            label: optgroup.label || "",
            element: optgroup,
            active: !!choices.length,
            disabled: optgroup.disabled,
            choices: choices
        };
    };
    return WrappedSelect;
}($a72ba5db1effc4ca$var$WrappedElement);
var $a72ba5db1effc4ca$var$DEFAULT_CLASSNAMES = {
    containerOuter: [
        "choices"
    ],
    containerInner: [
        "choices__inner"
    ],
    input: [
        "choices__input"
    ],
    inputCloned: [
        "choices__input--cloned"
    ],
    list: [
        "choices__list"
    ],
    listItems: [
        "choices__list--multiple"
    ],
    listSingle: [
        "choices__list--single"
    ],
    listDropdown: [
        "choices__list--dropdown"
    ],
    item: [
        "choices__item"
    ],
    itemSelectable: [
        "choices__item--selectable"
    ],
    itemDisabled: [
        "choices__item--disabled"
    ],
    itemChoice: [
        "choices__item--choice"
    ],
    description: [
        "choices__description"
    ],
    placeholder: [
        "choices__placeholder"
    ],
    group: [
        "choices__group"
    ],
    groupHeading: [
        "choices__heading"
    ],
    button: [
        "choices__button"
    ],
    activeState: [
        "is-active"
    ],
    focusState: [
        "is-focused"
    ],
    openState: [
        "is-open"
    ],
    disabledState: [
        "is-disabled"
    ],
    highlightedState: [
        "is-highlighted"
    ],
    selectedState: [
        "is-selected"
    ],
    flippedState: [
        "is-flipped"
    ],
    loadingState: [
        "is-loading"
    ],
    notice: [
        "choices__notice"
    ],
    addChoice: [
        "choices__item--selectable",
        "add-choice"
    ],
    noResults: [
        "has-no-results"
    ],
    noChoices: [
        "has-no-choices"
    ]
};
var $a72ba5db1effc4ca$var$DEFAULT_CONFIG = {
    items: [],
    choices: [],
    silent: false,
    renderChoiceLimit: -1,
    maxItemCount: -1,
    closeDropdownOnSelect: "auto",
    singleModeForMultiSelect: false,
    addChoices: false,
    addItems: true,
    addItemFilter: function(value) {
        return !!value && value !== "";
    },
    removeItems: true,
    removeItemButton: false,
    removeItemButtonAlignLeft: false,
    editItems: false,
    allowHTML: false,
    allowHtmlUserInput: false,
    duplicateItemsAllowed: true,
    delimiter: ",",
    paste: true,
    searchEnabled: true,
    searchChoices: true,
    searchFloor: 1,
    searchResultLimit: 4,
    searchFields: [
        "label",
        "value"
    ],
    position: "auto",
    resetScrollPosition: true,
    shouldSort: true,
    shouldSortItems: false,
    sorter: $a72ba5db1effc4ca$var$sortByAlpha,
    shadowRoot: null,
    placeholder: true,
    placeholderValue: null,
    searchPlaceholderValue: null,
    prependValue: null,
    appendValue: null,
    renderSelectedChoices: "auto",
    loadingText: "Loading...",
    noResultsText: "No results found",
    noChoicesText: "No choices to choose from",
    itemSelectText: "Press to select",
    uniqueItemText: "Only unique values can be added",
    customAddItemText: "Only values matching specific conditions can be added",
    addItemText: function(value) {
        return 'Press Enter to add <b>"'.concat(value, '"</b>');
    },
    removeItemIconText: function() {
        return "Remove item";
    },
    removeItemLabelText: function(value) {
        return "Remove item: ".concat(value);
    },
    maxItemText: function(maxItemCount) {
        return "Only ".concat(maxItemCount, " values can be added");
    },
    valueComparer: function(value1, value2) {
        return value1 === value2;
    },
    fuseOptions: {
        includeScore: true
    },
    labelId: "",
    callbackOnInit: null,
    callbackOnCreateTemplates: null,
    classNames: $a72ba5db1effc4ca$var$DEFAULT_CLASSNAMES,
    appendGroupInSearch: false
};
var $a72ba5db1effc4ca$var$removeItem = function(item) {
    var itemEl = item.itemEl;
    if (itemEl) {
        itemEl.remove();
        item.itemEl = undefined;
    }
};
function $a72ba5db1effc4ca$var$items(s, action, context) {
    var state = s;
    var update = true;
    switch(action.type){
        case $a72ba5db1effc4ca$var$ActionType.ADD_ITEM:
            action.item.selected = true;
            var el = action.item.element;
            if (el) {
                el.selected = true;
                el.setAttribute("selected", "");
            }
            state.push(action.item);
            break;
        case $a72ba5db1effc4ca$var$ActionType.REMOVE_ITEM:
            action.item.selected = false;
            var el = action.item.element;
            if (el) {
                el.selected = false;
                el.removeAttribute("selected");
                // For a select-one, if all options are deselected, the first item is selected. To set a black value, select.value needs to be set
                var select = el.parentElement;
                if (select && $a72ba5db1effc4ca$var$isHtmlSelectElement(select) && select.type === $a72ba5db1effc4ca$var$PassedElementTypes.SelectOne) select.value = "";
            }
            // this is mixing concerns, but this is *so much faster*
            $a72ba5db1effc4ca$var$removeItem(action.item);
            state = state.filter(function(choice) {
                return choice.id !== action.item.id;
            });
            break;
        case $a72ba5db1effc4ca$var$ActionType.REMOVE_CHOICE:
            $a72ba5db1effc4ca$var$removeItem(action.choice);
            state = state.filter(function(item) {
                return item.id !== action.choice.id;
            });
            break;
        case $a72ba5db1effc4ca$var$ActionType.HIGHLIGHT_ITEM:
            var highlighted = action.highlighted;
            var item = state.find(function(obj) {
                return obj.id === action.item.id;
            });
            if (item && item.highlighted !== highlighted) {
                item.highlighted = highlighted;
                if (context) $a72ba5db1effc4ca$var$updateClassList(item, highlighted ? context.classNames.highlightedState : context.classNames.selectedState, highlighted ? context.classNames.selectedState : context.classNames.highlightedState);
            }
            break;
        default:
            update = false;
            break;
    }
    return {
        state: state,
        update: update
    };
}
function $a72ba5db1effc4ca$var$groups(s, action) {
    var state = s;
    var update = true;
    switch(action.type){
        case $a72ba5db1effc4ca$var$ActionType.ADD_GROUP:
            state.push(action.group);
            break;
        case $a72ba5db1effc4ca$var$ActionType.CLEAR_CHOICES:
            state = [];
            break;
        default:
            update = false;
            break;
    }
    return {
        state: state,
        update: update
    };
}
/* eslint-disable */ function $a72ba5db1effc4ca$var$choices(s, action, context) {
    var state = s;
    var update = true;
    switch(action.type){
        case $a72ba5db1effc4ca$var$ActionType.ADD_CHOICE:
            state.push(action.choice);
            break;
        case $a72ba5db1effc4ca$var$ActionType.REMOVE_CHOICE:
            action.choice.choiceEl = undefined;
            if (action.choice.group) action.choice.group.choices = action.choice.group.choices.filter(function(obj) {
                return obj.id !== action.choice.id;
            });
            state = state.filter(function(obj) {
                return obj.id !== action.choice.id;
            });
            break;
        case $a72ba5db1effc4ca$var$ActionType.ADD_ITEM:
        case $a72ba5db1effc4ca$var$ActionType.REMOVE_ITEM:
            action.item.choiceEl = undefined;
            break;
        case $a72ba5db1effc4ca$var$ActionType.FILTER_CHOICES:
            // avoid O(n^2) algorithm complexity when searching/filtering choices
            var scoreLookup_1 = [];
            action.results.forEach(function(result) {
                scoreLookup_1[result.item.id] = result;
            });
            state.forEach(function(choice) {
                var result = scoreLookup_1[choice.id];
                if (result !== undefined) {
                    choice.score = result.score;
                    choice.rank = result.rank;
                    choice.active = true;
                } else {
                    choice.score = 0;
                    choice.rank = 0;
                    choice.active = false;
                }
                if (context && context.appendGroupInSearch) choice.choiceEl = undefined;
            });
            break;
        case $a72ba5db1effc4ca$var$ActionType.ACTIVATE_CHOICES:
            state.forEach(function(choice) {
                choice.active = action.active;
                if (context && context.appendGroupInSearch) choice.choiceEl = undefined;
            });
            break;
        case $a72ba5db1effc4ca$var$ActionType.CLEAR_CHOICES:
            state = [];
            break;
        default:
            update = false;
            break;
    }
    return {
        state: state,
        update: update
    };
}
var $a72ba5db1effc4ca$var$reducers = {
    groups: $a72ba5db1effc4ca$var$groups,
    items: $a72ba5db1effc4ca$var$items,
    choices: $a72ba5db1effc4ca$var$choices
};
var $a72ba5db1effc4ca$var$Store = /** @class */ function() {
    function Store(context) {
        this._state = this.defaultState;
        this._listeners = [];
        this._txn = 0;
        this._context = context;
    }
    Object.defineProperty(Store.prototype, "defaultState", {
        // eslint-disable-next-line class-methods-use-this
        get: function() {
            return {
                groups: [],
                items: [],
                choices: []
            };
        },
        enumerable: false,
        configurable: true
    });
    // eslint-disable-next-line class-methods-use-this
    Store.prototype.changeSet = function(init) {
        return {
            groups: init,
            items: init,
            choices: init
        };
    };
    Store.prototype.reset = function() {
        this._state = this.defaultState;
        var changes = this.changeSet(true);
        if (this._txn) this._changeSet = changes;
        else this._listeners.forEach(function(l) {
            return l(changes);
        });
    };
    Store.prototype.subscribe = function(onChange) {
        this._listeners.push(onChange);
        return this;
    };
    Store.prototype.dispatch = function(action) {
        var _this = this;
        var state = this._state;
        var hasChanges = false;
        var changes = this._changeSet || this.changeSet(false);
        Object.keys($a72ba5db1effc4ca$var$reducers).forEach(function(key) {
            var stateUpdate = $a72ba5db1effc4ca$var$reducers[key](state[key], action, _this._context);
            if (stateUpdate.update) {
                hasChanges = true;
                changes[key] = true;
                state[key] = stateUpdate.state;
            }
        });
        if (hasChanges) {
            if (this._txn) this._changeSet = changes;
            else this._listeners.forEach(function(l) {
                return l(changes);
            });
        }
    };
    Store.prototype.withTxn = function(func) {
        this._txn++;
        try {
            func();
        } finally{
            this._txn = Math.max(0, this._txn - 1);
            if (!this._txn) {
                var changeSet_1 = this._changeSet;
                if (changeSet_1) {
                    this._changeSet = undefined;
                    this._listeners.forEach(function(l) {
                        return l(changeSet_1);
                    });
                }
            }
        }
    };
    Object.defineProperty(Store.prototype, "state", {
        /**
         * Get store object
         */ get: function() {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "items", {
        /**
         * Get items from store
         */ get: function() {
            return this.state.items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "highlightedActiveItems", {
        /**
         * Get highlighted items from store
         */ get: function() {
            return this.items.filter(function(item) {
                return !item.disabled && item.active && item.highlighted;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "choices", {
        /**
         * Get choices from store
         */ get: function() {
            return this.state.choices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "activeChoices", {
        /**
         * Get active choices from store
         */ get: function() {
            return this.choices.filter(function(choice) {
                return choice.active;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "searchableChoices", {
        /**
         * Get choices that can be searched (excluding placeholders)
         */ get: function() {
            return this.choices.filter(function(choice) {
                return !choice.disabled && !choice.placeholder;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "groups", {
        /**
         * Get groups from store
         */ get: function() {
            return this.state.groups;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "activeGroups", {
        /**
         * Get active groups from store
         */ get: function() {
            var _this = this;
            return this.state.groups.filter(function(group) {
                var isActive = group.active && !group.disabled;
                var hasActiveOptions = _this.state.choices.some(function(choice) {
                    return choice.active && !choice.disabled;
                });
                return isActive && hasActiveOptions;
            }, []);
        },
        enumerable: false,
        configurable: true
    });
    Store.prototype.inTxn = function() {
        return this._txn > 0;
    };
    /**
     * Get single choice by it's ID
     */ Store.prototype.getChoiceById = function(id) {
        return this.activeChoices.find(function(choice) {
            return choice.id === id;
        });
    };
    /**
     * Get group by group id
     */ Store.prototype.getGroupById = function(id) {
        return this.groups.find(function(group) {
            return group.id === id;
        });
    };
    return Store;
}();
var $a72ba5db1effc4ca$var$NoticeTypes = {
    noChoices: "no-choices",
    noResults: "no-results",
    addChoice: "add-choice",
    generic: ""
};
function $a72ba5db1effc4ca$var$_defineProperty(e, r, t) {
    return (r = $a72ba5db1effc4ca$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a72ba5db1effc4ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a72ba5db1effc4ca$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a72ba5db1effc4ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a72ba5db1effc4ca$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a72ba5db1effc4ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a72ba5db1effc4ca$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a72ba5db1effc4ca$var$_toPropertyKey(t) {
    var i = $a72ba5db1effc4ca$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $a72ba5db1effc4ca$var$isArray(value) {
    return !Array.isArray ? $a72ba5db1effc4ca$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $a72ba5db1effc4ca$var$INFINITY = 1 / 0;
function $a72ba5db1effc4ca$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    let result = value + "";
    return result == "0" && 1 / value == -$a72ba5db1effc4ca$var$INFINITY ? "-0" : result;
}
function $a72ba5db1effc4ca$var$toString(value) {
    return value == null ? "" : $a72ba5db1effc4ca$var$baseToString(value);
}
function $a72ba5db1effc4ca$var$isString(value) {
    return typeof value === "string";
}
function $a72ba5db1effc4ca$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $a72ba5db1effc4ca$var$isBoolean(value) {
    return value === true || value === false || $a72ba5db1effc4ca$var$isObjectLike(value) && $a72ba5db1effc4ca$var$getTag(value) == "[object Boolean]";
}
function $a72ba5db1effc4ca$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $a72ba5db1effc4ca$var$isObjectLike(value) {
    return $a72ba5db1effc4ca$var$isObject(value) && value !== null;
}
function $a72ba5db1effc4ca$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $a72ba5db1effc4ca$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $a72ba5db1effc4ca$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const $a72ba5db1effc4ca$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const $a72ba5db1effc4ca$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $a72ba5db1effc4ca$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $a72ba5db1effc4ca$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $a72ba5db1effc4ca$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $a72ba5db1effc4ca$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $a72ba5db1effc4ca$var$hasOwn = Object.prototype.hasOwnProperty;
class $a72ba5db1effc4ca$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $a72ba5db1effc4ca$var$createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $a72ba5db1effc4ca$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($a72ba5db1effc4ca$var$isString(key) || $a72ba5db1effc4ca$var$isArray(key)) {
        src = key;
        path = $a72ba5db1effc4ca$var$createKeyPath(key);
        id = $a72ba5db1effc4ca$var$createKeyId(key);
    } else {
        if (!$a72ba5db1effc4ca$var$hasOwn.call(key, "name")) throw new Error($a72ba5db1effc4ca$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($a72ba5db1effc4ca$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($a72ba5db1effc4ca$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $a72ba5db1effc4ca$var$createKeyPath(name);
        id = $a72ba5db1effc4ca$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $a72ba5db1effc4ca$var$createKeyPath(key) {
    return $a72ba5db1effc4ca$var$isArray(key) ? key : key.split(".");
}
function $a72ba5db1effc4ca$var$createKeyId(key) {
    return $a72ba5db1effc4ca$var$isArray(key) ? key.join(".") : key;
}
function $a72ba5db1effc4ca$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$a72ba5db1effc4ca$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$a72ba5db1effc4ca$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($a72ba5db1effc4ca$var$isString(value) || $a72ba5db1effc4ca$var$isNumber(value) || $a72ba5db1effc4ca$var$isBoolean(value))) list.push($a72ba5db1effc4ca$var$toString(value));
            else if ($a72ba5db1effc4ca$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $a72ba5db1effc4ca$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
const $a72ba5db1effc4ca$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $a72ba5db1effc4ca$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $a72ba5db1effc4ca$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $a72ba5db1effc4ca$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $a72ba5db1effc4ca$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $a72ba5db1effc4ca$var$Config = $a72ba5db1effc4ca$var$_objectSpread2($a72ba5db1effc4ca$var$_objectSpread2($a72ba5db1effc4ca$var$_objectSpread2($a72ba5db1effc4ca$var$_objectSpread2({}, $a72ba5db1effc4ca$var$BasicOptions), $a72ba5db1effc4ca$var$MatchOptions), $a72ba5db1effc4ca$var$FuzzyOptions), $a72ba5db1effc4ca$var$AdvancedOptions);
const $a72ba5db1effc4ca$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $a72ba5db1effc4ca$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($a72ba5db1effc4ca$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $a72ba5db1effc4ca$var$FuseIndex {
    constructor({ getFn: getFn = $a72ba5db1effc4ca$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a72ba5db1effc4ca$var$Config.fieldNormWeight } = {}){
        this.norm = $a72ba5db1effc4ca$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($a72ba5db1effc4ca$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($a72ba5db1effc4ca$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$a72ba5db1effc4ca$var$isDefined(doc) || $a72ba5db1effc4ca$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$a72ba5db1effc4ca$var$isDefined(value)) return;
            if ($a72ba5db1effc4ca$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$a72ba5db1effc4ca$var$isDefined(value)) continue;
                    if ($a72ba5db1effc4ca$var$isString(value) && !$a72ba5db1effc4ca$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($a72ba5db1effc4ca$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($a72ba5db1effc4ca$var$isString(value) && !$a72ba5db1effc4ca$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $a72ba5db1effc4ca$var$createIndex(keys, docs, { getFn: getFn = $a72ba5db1effc4ca$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a72ba5db1effc4ca$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $a72ba5db1effc4ca$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($a72ba5db1effc4ca$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $a72ba5db1effc4ca$var$parseIndex(data, { getFn: getFn = $a72ba5db1effc4ca$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a72ba5db1effc4ca$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $a72ba5db1effc4ca$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $a72ba5db1effc4ca$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $a72ba5db1effc4ca$var$Config.distance, ignoreLocation: ignoreLocation = $a72ba5db1effc4ca$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $a72ba5db1effc4ca$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $a72ba5db1effc4ca$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $a72ba5db1effc4ca$var$MAX_BITS = 32;
function $a72ba5db1effc4ca$var$search(text, pattern, patternAlphabet, { location: location = $a72ba5db1effc4ca$var$Config.location, distance: distance = $a72ba5db1effc4ca$var$Config.distance, threshold: threshold = $a72ba5db1effc4ca$var$Config.threshold, findAllMatches: findAllMatches = $a72ba5db1effc4ca$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a72ba5db1effc4ca$var$Config.minMatchCharLength, includeMatches: includeMatches = $a72ba5db1effc4ca$var$Config.includeMatches, ignoreLocation: ignoreLocation = $a72ba5db1effc4ca$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $a72ba5db1effc4ca$var$MAX_BITS) throw new Error($a72ba5db1effc4ca$var$PATTERN_LENGTH_TOO_LARGE($a72ba5db1effc4ca$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $a72ba5db1effc4ca$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $a72ba5db1effc4ca$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $a72ba5db1effc4ca$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $a72ba5db1effc4ca$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $a72ba5db1effc4ca$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $a72ba5db1effc4ca$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $a72ba5db1effc4ca$var$BitapSearch {
    constructor(pattern, { location: location = $a72ba5db1effc4ca$var$Config.location, threshold: threshold = $a72ba5db1effc4ca$var$Config.threshold, distance: distance = $a72ba5db1effc4ca$var$Config.distance, includeMatches: includeMatches = $a72ba5db1effc4ca$var$Config.includeMatches, findAllMatches: findAllMatches = $a72ba5db1effc4ca$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a72ba5db1effc4ca$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $a72ba5db1effc4ca$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $a72ba5db1effc4ca$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $a72ba5db1effc4ca$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $a72ba5db1effc4ca$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $a72ba5db1effc4ca$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $a72ba5db1effc4ca$var$MAX_BITS), i);
                i += $a72ba5db1effc4ca$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $a72ba5db1effc4ca$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $a72ba5db1effc4ca$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $a72ba5db1effc4ca$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $a72ba5db1effc4ca$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $a72ba5db1effc4ca$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $a72ba5db1effc4ca$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $a72ba5db1effc4ca$var$ExactMatch extends $a72ba5db1effc4ca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $a72ba5db1effc4ca$var$InverseExactMatch extends $a72ba5db1effc4ca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $a72ba5db1effc4ca$var$PrefixExactMatch extends $a72ba5db1effc4ca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $a72ba5db1effc4ca$var$InversePrefixExactMatch extends $a72ba5db1effc4ca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $a72ba5db1effc4ca$var$SuffixExactMatch extends $a72ba5db1effc4ca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $a72ba5db1effc4ca$var$InverseSuffixExactMatch extends $a72ba5db1effc4ca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $a72ba5db1effc4ca$var$FuzzyMatch extends $a72ba5db1effc4ca$var$BaseMatch {
    constructor(pattern, { location: location = $a72ba5db1effc4ca$var$Config.location, threshold: threshold = $a72ba5db1effc4ca$var$Config.threshold, distance: distance = $a72ba5db1effc4ca$var$Config.distance, includeMatches: includeMatches = $a72ba5db1effc4ca$var$Config.includeMatches, findAllMatches: findAllMatches = $a72ba5db1effc4ca$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a72ba5db1effc4ca$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $a72ba5db1effc4ca$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $a72ba5db1effc4ca$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $a72ba5db1effc4ca$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $a72ba5db1effc4ca$var$IncludeMatch extends $a72ba5db1effc4ca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $a72ba5db1effc4ca$var$searchers = [
    $a72ba5db1effc4ca$var$ExactMatch,
    $a72ba5db1effc4ca$var$IncludeMatch,
    $a72ba5db1effc4ca$var$PrefixExactMatch,
    $a72ba5db1effc4ca$var$InversePrefixExactMatch,
    $a72ba5db1effc4ca$var$InverseSuffixExactMatch,
    $a72ba5db1effc4ca$var$SuffixExactMatch,
    $a72ba5db1effc4ca$var$InverseExactMatch,
    $a72ba5db1effc4ca$var$FuzzyMatch
];
const $a72ba5db1effc4ca$var$searchersLen = $a72ba5db1effc4ca$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $a72ba5db1effc4ca$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $a72ba5db1effc4ca$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $a72ba5db1effc4ca$var$parseQuery(pattern, options = {}) {
    return pattern.split($a72ba5db1effc4ca$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($a72ba5db1effc4ca$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $a72ba5db1effc4ca$var$searchersLen){
                const searcher = $a72ba5db1effc4ca$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $a72ba5db1effc4ca$var$searchersLen){
                const searcher = $a72ba5db1effc4ca$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $a72ba5db1effc4ca$var$MultiMatchSet = new Set([
    $a72ba5db1effc4ca$var$FuzzyMatch.type,
    $a72ba5db1effc4ca$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $a72ba5db1effc4ca$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $a72ba5db1effc4ca$var$Config.isCaseSensitive, includeMatches: includeMatches = $a72ba5db1effc4ca$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $a72ba5db1effc4ca$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $a72ba5db1effc4ca$var$Config.ignoreLocation, findAllMatches: findAllMatches = $a72ba5db1effc4ca$var$Config.findAllMatches, location: location = $a72ba5db1effc4ca$var$Config.location, threshold: threshold = $a72ba5db1effc4ca$var$Config.threshold, distance: distance = $a72ba5db1effc4ca$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $a72ba5db1effc4ca$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($a72ba5db1effc4ca$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $a72ba5db1effc4ca$var$registeredSearchers = [];
function $a72ba5db1effc4ca$var$register(...args) {
    $a72ba5db1effc4ca$var$registeredSearchers.push(...args);
}
function $a72ba5db1effc4ca$var$createSearcher(pattern, options) {
    for(let i = 0, len = $a72ba5db1effc4ca$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $a72ba5db1effc4ca$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $a72ba5db1effc4ca$var$BitapSearch(pattern, options);
}
const $a72ba5db1effc4ca$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $a72ba5db1effc4ca$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $a72ba5db1effc4ca$var$isExpression = (query)=>!!(query[$a72ba5db1effc4ca$var$LogicalOperator.AND] || query[$a72ba5db1effc4ca$var$LogicalOperator.OR]);
const $a72ba5db1effc4ca$var$isPath = (query)=>!!query[$a72ba5db1effc4ca$var$KeyType.PATH];
const $a72ba5db1effc4ca$var$isLeaf = (query)=>!$a72ba5db1effc4ca$var$isArray(query) && $a72ba5db1effc4ca$var$isObject(query) && !$a72ba5db1effc4ca$var$isExpression(query);
const $a72ba5db1effc4ca$var$convertToExplicit = (query)=>({
        [$a72ba5db1effc4ca$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $a72ba5db1effc4ca$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $a72ba5db1effc4ca$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$a72ba5db1effc4ca$var$isExpression(query)) return next($a72ba5db1effc4ca$var$convertToExplicit(query));
        if ($a72ba5db1effc4ca$var$isLeaf(query)) {
            const key = isQueryPath ? query[$a72ba5db1effc4ca$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$a72ba5db1effc4ca$var$KeyType.PATTERN] : query[key];
            if (!$a72ba5db1effc4ca$var$isString(pattern)) throw new Error($a72ba5db1effc4ca$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $a72ba5db1effc4ca$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $a72ba5db1effc4ca$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($a72ba5db1effc4ca$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$a72ba5db1effc4ca$var$isExpression(query)) query = $a72ba5db1effc4ca$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $a72ba5db1effc4ca$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $a72ba5db1effc4ca$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $a72ba5db1effc4ca$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$a72ba5db1effc4ca$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$a72ba5db1effc4ca$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $a72ba5db1effc4ca$var$transformScore(result, data) {
    data.score = result.score;
}
function $a72ba5db1effc4ca$var$format(results, docs, { includeMatches: includeMatches = $a72ba5db1effc4ca$var$Config.includeMatches, includeScore: includeScore = $a72ba5db1effc4ca$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($a72ba5db1effc4ca$var$transformMatches);
    if (includeScore) transformers.push($a72ba5db1effc4ca$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $a72ba5db1effc4ca$var$Fuse {
    constructor(docs, options = {}, index){
        this.options = $a72ba5db1effc4ca$var$_objectSpread2($a72ba5db1effc4ca$var$_objectSpread2({}, $a72ba5db1effc4ca$var$Config), options);
        this.options.useExtendedSearch;
        this._keyStore = new $a72ba5db1effc4ca$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $a72ba5db1effc4ca$var$FuseIndex)) throw new Error($a72ba5db1effc4ca$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $a72ba5db1effc4ca$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$a72ba5db1effc4ca$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $a72ba5db1effc4ca$var$isString(query) ? $a72ba5db1effc4ca$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $a72ba5db1effc4ca$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($a72ba5db1effc4ca$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $a72ba5db1effc4ca$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $a72ba5db1effc4ca$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$a72ba5db1effc4ca$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $a72ba5db1effc4ca$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $a72ba5db1effc4ca$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($a72ba5db1effc4ca$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $a72ba5db1effc4ca$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$a72ba5db1effc4ca$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$a72ba5db1effc4ca$var$isDefined(value)) return [];
        let matches = [];
        if ($a72ba5db1effc4ca$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$a72ba5db1effc4ca$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$a72ba5db1effc4ca$var$Fuse.version = "7.0.0";
$a72ba5db1effc4ca$var$Fuse.createIndex = $a72ba5db1effc4ca$var$createIndex;
$a72ba5db1effc4ca$var$Fuse.parseIndex = $a72ba5db1effc4ca$var$parseIndex;
$a72ba5db1effc4ca$var$Fuse.config = $a72ba5db1effc4ca$var$Config;
$a72ba5db1effc4ca$var$Fuse.parseQuery = $a72ba5db1effc4ca$var$parse;
$a72ba5db1effc4ca$var$register($a72ba5db1effc4ca$var$ExtendedSearch);
var $a72ba5db1effc4ca$var$SearchByFuse = /** @class */ function() {
    function SearchByFuse(config) {
        this._haystack = [];
        this._fuseOptions = $a72ba5db1effc4ca$var$__assign($a72ba5db1effc4ca$var$__assign({}, config.fuseOptions), {
            keys: $a72ba5db1effc4ca$var$__spreadArray([], config.searchFields, true),
            includeMatches: true
        });
    }
    SearchByFuse.prototype.index = function(data) {
        this._haystack = data;
        if (this._fuse) this._fuse.setCollection(data);
    };
    SearchByFuse.prototype.reset = function() {
        this._haystack = [];
        this._fuse = undefined;
    };
    SearchByFuse.prototype.isEmptyIndex = function() {
        return !this._haystack.length;
    };
    SearchByFuse.prototype.search = function(needle) {
        if (!this._fuse) this._fuse = new $a72ba5db1effc4ca$var$Fuse(this._haystack, this._fuseOptions);
        var results = this._fuse.search(needle);
        return results.map(function(value, i) {
            return {
                item: value.item,
                score: value.score || 0,
                rank: i + 1
            };
        });
    };
    return SearchByFuse;
}();
function $a72ba5db1effc4ca$var$getSearcher(config) {
    return new $a72ba5db1effc4ca$var$SearchByFuse(config);
}
/**
 * Helpers to create HTML elements used by Choices
 * Can be overridden by providing `callbackOnCreateTemplates` option.
 * `Choices.defaults.templates` allows access to the default template methods from `callbackOnCreateTemplates`
 */ var $a72ba5db1effc4ca$var$isEmptyObject = function(obj) {
    // eslint-disable-next-line no-restricted-syntax
    for(var prop in obj){
        if (Object.prototype.hasOwnProperty.call(obj, prop)) return false;
    }
    return true;
};
var $a72ba5db1effc4ca$var$assignCustomProperties = function(el, choice, withCustomProperties) {
    var dataset = el.dataset;
    var customProperties = choice.customProperties, labelClass = choice.labelClass, labelDescription = choice.labelDescription;
    if (labelClass) dataset.labelClass = $a72ba5db1effc4ca$var$getClassNames(labelClass).join(" ");
    if (labelDescription) dataset.labelDescription = labelDescription;
    if (withCustomProperties && customProperties) {
        if (typeof customProperties === "string") dataset.customProperties = customProperties;
        else if (typeof customProperties === "object" && !$a72ba5db1effc4ca$var$isEmptyObject(customProperties)) dataset.customProperties = JSON.stringify(customProperties);
    }
};
var $a72ba5db1effc4ca$var$addAriaLabel = function(docRoot, id, element) {
    var label = id && docRoot.querySelector("label[for='".concat(id, "']"));
    var text = label && label.innerText;
    if (text) element.setAttribute("aria-label", text);
};
var $a72ba5db1effc4ca$var$templates = {
    containerOuter: function(_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
        var containerOuter = _a.classNames.containerOuter;
        var div = document.createElement("div");
        $a72ba5db1effc4ca$var$addClassesToElement(div, containerOuter);
        div.dataset.type = passedElementType;
        if (dir) div.dir = dir;
        if (isSelectOneElement) div.tabIndex = 0;
        if (isSelectElement) {
            div.setAttribute("role", searchEnabled ? "combobox" : "listbox");
            if (searchEnabled) div.setAttribute("aria-autocomplete", "list");
            else if (!labelId) $a72ba5db1effc4ca$var$addAriaLabel(this._docRoot, this.passedElement.element.id, div);
            div.setAttribute("aria-haspopup", "true");
            div.setAttribute("aria-expanded", "false");
        }
        if (labelId) div.setAttribute("aria-labelledby", labelId);
        return div;
    },
    containerInner: function(_a) {
        var containerInner = _a.classNames.containerInner;
        var div = document.createElement("div");
        $a72ba5db1effc4ca$var$addClassesToElement(div, containerInner);
        return div;
    },
    itemList: function(_a, isSelectOneElement) {
        var searchEnabled = _a.searchEnabled, _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
        var div = document.createElement("div");
        $a72ba5db1effc4ca$var$addClassesToElement(div, list);
        $a72ba5db1effc4ca$var$addClassesToElement(div, isSelectOneElement ? listSingle : listItems);
        if (this._isSelectElement && searchEnabled) div.setAttribute("role", "listbox");
        return div;
    },
    placeholder: function(_a, value) {
        var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
        var div = document.createElement("div");
        $a72ba5db1effc4ca$var$addClassesToElement(div, placeholder);
        $a72ba5db1effc4ca$var$setElementHtml(div, allowHTML, value);
        return div;
    },
    item: function(_a, choice, removeItemButton) {
        var allowHTML = _a.allowHTML, removeItemButtonAlignLeft = _a.removeItemButtonAlignLeft, removeItemIconText = _a.removeItemIconText, removeItemLabelText = _a.removeItemLabelText, _b = _a.classNames, item = _b.item, button = _b.button, highlightedState = _b.highlightedState, itemSelectable = _b.itemSelectable, placeholder = _b.placeholder;
        var rawValue = $a72ba5db1effc4ca$var$unwrapStringForRaw(choice.value);
        var div = document.createElement("div");
        $a72ba5db1effc4ca$var$addClassesToElement(div, item);
        if (choice.labelClass) {
            var spanLabel = document.createElement("span");
            $a72ba5db1effc4ca$var$setElementHtml(spanLabel, allowHTML, choice.label);
            $a72ba5db1effc4ca$var$addClassesToElement(spanLabel, choice.labelClass);
            div.appendChild(spanLabel);
        } else $a72ba5db1effc4ca$var$setElementHtml(div, allowHTML, choice.label);
        div.dataset.item = "";
        div.dataset.id = choice.id;
        div.dataset.value = rawValue;
        $a72ba5db1effc4ca$var$assignCustomProperties(div, choice, true);
        if (choice.disabled || this.containerOuter.isDisabled) div.setAttribute("aria-disabled", "true");
        if (this._isSelectElement) {
            div.setAttribute("aria-selected", "true");
            div.setAttribute("role", "option");
        }
        if (choice.placeholder) {
            $a72ba5db1effc4ca$var$addClassesToElement(div, placeholder);
            div.dataset.placeholder = "";
        }
        $a72ba5db1effc4ca$var$addClassesToElement(div, choice.highlighted ? highlightedState : itemSelectable);
        if (removeItemButton) {
            if (choice.disabled) $a72ba5db1effc4ca$var$removeClassesFromElement(div, itemSelectable);
            div.dataset.deletable = "";
            var removeButton = document.createElement("button");
            removeButton.type = "button";
            $a72ba5db1effc4ca$var$addClassesToElement(removeButton, button);
            $a72ba5db1effc4ca$var$setElementHtml(removeButton, true, $a72ba5db1effc4ca$var$resolveNoticeFunction(removeItemIconText, choice.value));
            var REMOVE_ITEM_LABEL = $a72ba5db1effc4ca$var$resolveNoticeFunction(removeItemLabelText, choice.value);
            if (REMOVE_ITEM_LABEL) removeButton.setAttribute("aria-label", REMOVE_ITEM_LABEL);
            removeButton.dataset.button = "";
            if (removeItemButtonAlignLeft) div.insertAdjacentElement("afterbegin", removeButton);
            else div.appendChild(removeButton);
        }
        return div;
    },
    choiceList: function(_a, isSelectOneElement) {
        var list = _a.classNames.list;
        var div = document.createElement("div");
        $a72ba5db1effc4ca$var$addClassesToElement(div, list);
        if (!isSelectOneElement) div.setAttribute("aria-multiselectable", "true");
        div.setAttribute("role", "listbox");
        return div;
    },
    choiceGroup: function(_a, _b) {
        var allowHTML = _a.allowHTML, _c = _a.classNames, group = _c.group, groupHeading = _c.groupHeading, itemDisabled = _c.itemDisabled;
        var id = _b.id, label = _b.label, disabled = _b.disabled;
        var rawLabel = $a72ba5db1effc4ca$var$unwrapStringForRaw(label);
        var div = document.createElement("div");
        $a72ba5db1effc4ca$var$addClassesToElement(div, group);
        if (disabled) $a72ba5db1effc4ca$var$addClassesToElement(div, itemDisabled);
        div.setAttribute("role", "group");
        div.dataset.group = "";
        div.dataset.id = id;
        div.dataset.value = rawLabel;
        if (disabled) div.setAttribute("aria-disabled", "true");
        var heading = document.createElement("div");
        $a72ba5db1effc4ca$var$addClassesToElement(heading, groupHeading);
        $a72ba5db1effc4ca$var$setElementHtml(heading, allowHTML, label || "");
        div.appendChild(heading);
        return div;
    },
    choice: function(_a, choice, selectText, groupName) {
        var allowHTML = _a.allowHTML, _b = _a.classNames, item = _b.item, itemChoice = _b.itemChoice, itemSelectable = _b.itemSelectable, selectedState = _b.selectedState, itemDisabled = _b.itemDisabled, description = _b.description, placeholder = _b.placeholder;
        // eslint-disable-next-line prefer-destructuring
        var label = choice.label;
        var rawValue = $a72ba5db1effc4ca$var$unwrapStringForRaw(choice.value);
        var div = document.createElement("div");
        div.id = choice.elementId;
        $a72ba5db1effc4ca$var$addClassesToElement(div, item);
        $a72ba5db1effc4ca$var$addClassesToElement(div, itemChoice);
        if (groupName && typeof label === "string") {
            label = $a72ba5db1effc4ca$var$escapeForTemplate(allowHTML, label);
            label += " (".concat(groupName, ")");
            label = {
                trusted: label
            };
        }
        var describedBy = div;
        if (choice.labelClass) {
            var spanLabel = document.createElement("span");
            $a72ba5db1effc4ca$var$setElementHtml(spanLabel, allowHTML, label);
            $a72ba5db1effc4ca$var$addClassesToElement(spanLabel, choice.labelClass);
            describedBy = spanLabel;
            div.appendChild(spanLabel);
        } else $a72ba5db1effc4ca$var$setElementHtml(div, allowHTML, label);
        if (choice.labelDescription) {
            var descId = "".concat(choice.elementId, "-description");
            describedBy.setAttribute("aria-describedby", descId);
            var spanDesc = document.createElement("span");
            $a72ba5db1effc4ca$var$setElementHtml(spanDesc, allowHTML, choice.labelDescription);
            spanDesc.id = descId;
            $a72ba5db1effc4ca$var$addClassesToElement(spanDesc, description);
            div.appendChild(spanDesc);
        }
        if (choice.selected) $a72ba5db1effc4ca$var$addClassesToElement(div, selectedState);
        if (choice.placeholder) $a72ba5db1effc4ca$var$addClassesToElement(div, placeholder);
        div.setAttribute("role", choice.group ? "treeitem" : "option");
        div.dataset.choice = "";
        div.dataset.id = choice.id;
        div.dataset.value = rawValue;
        if (selectText) div.dataset.selectText = selectText;
        if (choice.group) div.dataset.groupId = "".concat(choice.group.id);
        $a72ba5db1effc4ca$var$assignCustomProperties(div, choice, false);
        if (choice.disabled) {
            $a72ba5db1effc4ca$var$addClassesToElement(div, itemDisabled);
            div.dataset.choiceDisabled = "";
            div.setAttribute("aria-disabled", "true");
        } else {
            $a72ba5db1effc4ca$var$addClassesToElement(div, itemSelectable);
            div.dataset.choiceSelectable = "";
        }
        return div;
    },
    input: function(_a, placeholderValue) {
        var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned, labelId = _a.labelId;
        var inp = document.createElement("input");
        inp.type = "search";
        $a72ba5db1effc4ca$var$addClassesToElement(inp, input);
        $a72ba5db1effc4ca$var$addClassesToElement(inp, inputCloned);
        inp.autocomplete = "off";
        inp.autocapitalize = "off";
        inp.spellcheck = false;
        inp.setAttribute("role", "textbox");
        inp.setAttribute("aria-autocomplete", "list");
        if (placeholderValue) inp.setAttribute("aria-label", placeholderValue);
        else if (!labelId) $a72ba5db1effc4ca$var$addAriaLabel(this._docRoot, this.passedElement.element.id, inp);
        return inp;
    },
    dropdown: function(_a) {
        var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
        var div = document.createElement("div");
        $a72ba5db1effc4ca$var$addClassesToElement(div, list);
        $a72ba5db1effc4ca$var$addClassesToElement(div, listDropdown);
        div.setAttribute("aria-expanded", "false");
        return div;
    },
    notice: function(_a, innerHTML, type) {
        var _b = _a.classNames, item = _b.item, itemChoice = _b.itemChoice, addChoice = _b.addChoice, noResults = _b.noResults, noChoices = _b.noChoices, noticeItem = _b.notice;
        if (type === void 0) type = $a72ba5db1effc4ca$var$NoticeTypes.generic;
        var notice = document.createElement("div");
        $a72ba5db1effc4ca$var$setElementHtml(notice, true, innerHTML);
        $a72ba5db1effc4ca$var$addClassesToElement(notice, item);
        $a72ba5db1effc4ca$var$addClassesToElement(notice, itemChoice);
        $a72ba5db1effc4ca$var$addClassesToElement(notice, noticeItem);
        // eslint-disable-next-line default-case
        switch(type){
            case $a72ba5db1effc4ca$var$NoticeTypes.addChoice:
                $a72ba5db1effc4ca$var$addClassesToElement(notice, addChoice);
                break;
            case $a72ba5db1effc4ca$var$NoticeTypes.noResults:
                $a72ba5db1effc4ca$var$addClassesToElement(notice, noResults);
                break;
            case $a72ba5db1effc4ca$var$NoticeTypes.noChoices:
                $a72ba5db1effc4ca$var$addClassesToElement(notice, noChoices);
                break;
        }
        if (type === $a72ba5db1effc4ca$var$NoticeTypes.addChoice) {
            notice.dataset.choiceSelectable = "";
            notice.dataset.choice = "";
        }
        return notice;
    },
    option: function(choice) {
        // HtmlOptionElement's label value does not support HTML, so the avoid double escaping unwrap the untrusted string.
        var labelValue = $a72ba5db1effc4ca$var$unwrapStringForRaw(choice.label);
        var opt = new Option(labelValue, choice.value, false, choice.selected);
        $a72ba5db1effc4ca$var$assignCustomProperties(opt, choice, true);
        opt.disabled = choice.disabled;
        if (choice.selected) opt.setAttribute("selected", "");
        return opt;
    }
};
/** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */ var $a72ba5db1effc4ca$var$IS_IE11 = "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style;
var $a72ba5db1effc4ca$var$USER_DEFAULTS = {};
var $a72ba5db1effc4ca$var$parseDataSetId = function(element) {
    if (!element) return undefined;
    return element.dataset.id ? parseInt(element.dataset.id, 10) : undefined;
};
var $a72ba5db1effc4ca$var$selectableChoiceIdentifier = "[data-choice-selectable]";
/**
 * Choices
 * @author Josh Johnson<josh@joshuajohnson.co.uk>
 */ var $a72ba5db1effc4ca$export$2e2bcd8739ae039 = /** @class */ function() {
    function Choices(element, userConfig) {
        if (element === void 0) element = "[data-choice]";
        if (userConfig === void 0) userConfig = {};
        var _this = this;
        this.initialisedOK = undefined;
        this._hasNonChoicePlaceholder = false;
        this._lastAddedChoiceId = 0;
        this._lastAddedGroupId = 0;
        var defaults = Choices.defaults;
        this.config = $a72ba5db1effc4ca$var$__assign($a72ba5db1effc4ca$var$__assign($a72ba5db1effc4ca$var$__assign({}, defaults.allOptions), defaults.options), userConfig);
        $a72ba5db1effc4ca$var$ObjectsInConfig.forEach(function(key) {
            _this.config[key] = $a72ba5db1effc4ca$var$__assign($a72ba5db1effc4ca$var$__assign($a72ba5db1effc4ca$var$__assign({}, defaults.allOptions[key]), defaults.options[key]), userConfig[key]);
        });
        var config = this.config;
        if (!config.silent) this._validateConfig();
        var docRoot = config.shadowRoot || document.documentElement;
        this._docRoot = docRoot;
        var passedElement = typeof element === "string" ? docRoot.querySelector(element) : element;
        if (!passedElement || typeof passedElement !== "object" || !($a72ba5db1effc4ca$var$isHtmlInputElement(passedElement) || $a72ba5db1effc4ca$var$isHtmlSelectElement(passedElement))) {
            if (!passedElement && typeof element === "string") throw TypeError("Selector ".concat(element, " failed to find an element"));
            throw TypeError("Expected one of the following types text|select-one|select-multiple");
        }
        var elementType = passedElement.type;
        var isText = elementType === $a72ba5db1effc4ca$var$PassedElementTypes.Text;
        if (isText || config.maxItemCount !== 1) config.singleModeForMultiSelect = false;
        if (config.singleModeForMultiSelect) elementType = $a72ba5db1effc4ca$var$PassedElementTypes.SelectMultiple;
        var isSelectOne = elementType === $a72ba5db1effc4ca$var$PassedElementTypes.SelectOne;
        var isSelectMultiple = elementType === $a72ba5db1effc4ca$var$PassedElementTypes.SelectMultiple;
        var isSelect = isSelectOne || isSelectMultiple;
        this._elementType = elementType;
        this._isTextElement = isText;
        this._isSelectOneElement = isSelectOne;
        this._isSelectMultipleElement = isSelectMultiple;
        this._isSelectElement = isSelectOne || isSelectMultiple;
        this._canAddUserChoices = isText && config.addItems || isSelect && config.addChoices;
        if (typeof config.renderSelectedChoices !== "boolean") config.renderSelectedChoices = config.renderSelectedChoices === "always" || isSelectOne;
        if (config.closeDropdownOnSelect === "auto") config.closeDropdownOnSelect = isText || isSelectOne || config.singleModeForMultiSelect;
        else config.closeDropdownOnSelect = $a72ba5db1effc4ca$var$coerceBool(config.closeDropdownOnSelect);
        if (config.placeholder) {
            if (config.placeholderValue) this._hasNonChoicePlaceholder = true;
            else if (passedElement.dataset.placeholder) {
                this._hasNonChoicePlaceholder = true;
                config.placeholderValue = passedElement.dataset.placeholder;
            }
        }
        if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== "function") {
            var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
            config.addItemFilter = re.test.bind(re);
        }
        if (this._isTextElement) this.passedElement = new $a72ba5db1effc4ca$var$WrappedInput({
            element: passedElement,
            classNames: config.classNames
        });
        else {
            var selectEl = passedElement;
            this.passedElement = new $a72ba5db1effc4ca$var$WrappedSelect({
                element: selectEl,
                classNames: config.classNames,
                template: function(data) {
                    return _this._templates.option(data);
                },
                extractPlaceholder: config.placeholder && !this._hasNonChoicePlaceholder
            });
        }
        this.initialised = false;
        this._store = new $a72ba5db1effc4ca$var$Store(config);
        this._currentValue = "";
        config.searchEnabled = !isText && config.searchEnabled || isSelectMultiple;
        this._canSearch = config.searchEnabled;
        this._isScrollingOnIe = false;
        this._highlightPosition = 0;
        this._wasTap = true;
        this._placeholderValue = this._generatePlaceholderValue();
        this._baseId = $a72ba5db1effc4ca$var$generateId(passedElement, "choices-");
        /**
         * setting direction in cases where it's explicitly set on passedElement
         * or when calculated direction is different from the document
         */ this._direction = passedElement.dir;
        if (!this._direction) {
            var elementDirection = window.getComputedStyle(passedElement).direction;
            var documentDirection = window.getComputedStyle(document.documentElement).direction;
            if (elementDirection !== documentDirection) this._direction = elementDirection;
        }
        this._idNames = {
            itemChoice: "item-choice"
        };
        this._templates = defaults.templates;
        this._render = this._render.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onBlur = this._onBlur.bind(this);
        this._onKeyUp = this._onKeyUp.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onTouchMove = this._onTouchMove.bind(this);
        this._onTouchEnd = this._onTouchEnd.bind(this);
        this._onMouseDown = this._onMouseDown.bind(this);
        this._onMouseOver = this._onMouseOver.bind(this);
        this._onFormReset = this._onFormReset.bind(this);
        this._onSelectKey = this._onSelectKey.bind(this);
        this._onEnterKey = this._onEnterKey.bind(this);
        this._onEscapeKey = this._onEscapeKey.bind(this);
        this._onDirectionKey = this._onDirectionKey.bind(this);
        this._onDeleteKey = this._onDeleteKey.bind(this);
        // If element has already been initialised with Choices, fail silently
        if (this.passedElement.isActive) {
            if (!config.silent) console.warn("Trying to initialise Choices on element already initialised", {
                element: element
            });
            this.initialised = true;
            this.initialisedOK = false;
            return;
        }
        // Let's go
        this.init();
        // preserve the selected item list after setup for form reset
        this._initialItems = this._store.items.map(function(choice) {
            return choice.value;
        });
    }
    Object.defineProperty(Choices, "defaults", {
        get: function() {
            return Object.preventExtensions({
                get options () {
                    return $a72ba5db1effc4ca$var$USER_DEFAULTS;
                },
                get allOptions () {
                    return $a72ba5db1effc4ca$var$DEFAULT_CONFIG;
                },
                get templates () {
                    return $a72ba5db1effc4ca$var$templates;
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    Choices.prototype.init = function() {
        if (this.initialised || this.initialisedOK !== undefined) return;
        this._searcher = $a72ba5db1effc4ca$var$getSearcher(this.config);
        this._loadChoices();
        this._createTemplates();
        this._createElements();
        this._createStructure();
        if (this._isTextElement && !this.config.addItems || this.passedElement.element.hasAttribute("disabled") || !!this.passedElement.element.closest("fieldset:disabled")) this.disable();
        else {
            this.enable();
            this._addEventListeners();
        }
        // should be triggered **after** disabled state to avoid additional re-draws
        this._initStore();
        this.initialised = true;
        this.initialisedOK = true;
        var callbackOnInit = this.config.callbackOnInit;
        // Run callback if it is a function
        if (typeof callbackOnInit === "function") callbackOnInit.call(this);
    };
    Choices.prototype.destroy = function() {
        if (!this.initialised) return;
        this._removeEventListeners();
        this.passedElement.reveal();
        this.containerOuter.unwrap(this.passedElement.element);
        this._store._listeners = []; // prevents select/input value being wiped
        this.clearStore(false);
        this._stopSearch();
        this._templates = Choices.defaults.templates;
        this.initialised = false;
        this.initialisedOK = undefined;
    };
    Choices.prototype.enable = function() {
        if (this.passedElement.isDisabled) this.passedElement.enable();
        if (this.containerOuter.isDisabled) {
            this._addEventListeners();
            this.input.enable();
            this.containerOuter.enable();
        }
        return this;
    };
    Choices.prototype.disable = function() {
        if (!this.passedElement.isDisabled) this.passedElement.disable();
        if (!this.containerOuter.isDisabled) {
            this._removeEventListeners();
            this.input.disable();
            this.containerOuter.disable();
        }
        return this;
    };
    Choices.prototype.highlightItem = function(item, runEvent) {
        if (runEvent === void 0) runEvent = true;
        if (!item || !item.id) return this;
        var choice = this._store.items.find(function(c) {
            return c.id === item.id;
        });
        if (!choice || choice.highlighted) return this;
        this._store.dispatch($a72ba5db1effc4ca$var$highlightItem(choice, true));
        if (runEvent) this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.highlightItem, this._getChoiceForOutput(choice));
        return this;
    };
    Choices.prototype.unhighlightItem = function(item, runEvent) {
        if (runEvent === void 0) runEvent = true;
        if (!item || !item.id) return this;
        var choice = this._store.items.find(function(c) {
            return c.id === item.id;
        });
        if (!choice || !choice.highlighted) return this;
        this._store.dispatch($a72ba5db1effc4ca$var$highlightItem(choice, false));
        if (runEvent) this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.unhighlightItem, this._getChoiceForOutput(choice));
        return this;
    };
    Choices.prototype.highlightAll = function() {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.items.forEach(function(item) {
                if (!item.highlighted) {
                    _this._store.dispatch($a72ba5db1effc4ca$var$highlightItem(item, true));
                    _this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.highlightItem, _this._getChoiceForOutput(item));
                }
            });
        });
        return this;
    };
    Choices.prototype.unhighlightAll = function() {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.items.forEach(function(item) {
                if (item.highlighted) {
                    _this._store.dispatch($a72ba5db1effc4ca$var$highlightItem(item, false));
                    _this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.highlightItem, _this._getChoiceForOutput(item));
                }
            });
        });
        return this;
    };
    Choices.prototype.removeActiveItemsByValue = function(value) {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.items.filter(function(item) {
                return item.value === value;
            }).forEach(function(item) {
                return _this._removeItem(item);
            });
        });
        return this;
    };
    Choices.prototype.removeActiveItems = function(excludedId) {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.items.filter(function(_a) {
                var id = _a.id;
                return id !== excludedId;
            }).forEach(function(item) {
                return _this._removeItem(item);
            });
        });
        return this;
    };
    Choices.prototype.removeHighlightedItems = function(runEvent) {
        var _this = this;
        if (runEvent === void 0) runEvent = false;
        this._store.withTxn(function() {
            _this._store.highlightedActiveItems.forEach(function(item) {
                _this._removeItem(item);
                // If this action was performed by the user
                // trigger the event
                if (runEvent) _this._triggerChange(item.value);
            });
        });
        return this;
    };
    Choices.prototype.showDropdown = function(preventInputFocus) {
        var _this = this;
        if (this.dropdown.isActive) return this;
        requestAnimationFrame(function() {
            _this.dropdown.show();
            var rect = _this.dropdown.element.getBoundingClientRect();
            _this.containerOuter.open(rect.bottom, rect.height);
            if (!preventInputFocus && _this._canSearch) _this.input.focus();
            _this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.showDropdown);
        });
        return this;
    };
    Choices.prototype.hideDropdown = function(preventInputBlur) {
        var _this = this;
        if (!this.dropdown.isActive) return this;
        requestAnimationFrame(function() {
            _this.dropdown.hide();
            _this.containerOuter.close();
            if (!preventInputBlur && _this._canSearch) {
                _this.input.removeActiveDescendant();
                _this.input.blur();
            }
            _this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.hideDropdown);
        });
        return this;
    };
    Choices.prototype.getValue = function(valueOnly) {
        var _this = this;
        var values = this._store.items.map(function(item) {
            return valueOnly ? item.value : _this._getChoiceForOutput(item);
        });
        return this._isSelectOneElement || this.config.singleModeForMultiSelect ? values[0] : values;
    };
    Choices.prototype.setValue = function(items) {
        var _this = this;
        if (!this.initialisedOK) {
            this._warnChoicesInitFailed("setValue");
            return this;
        }
        this._store.withTxn(function() {
            items.forEach(function(value) {
                if (value) _this._addChoice($a72ba5db1effc4ca$var$mapInputToChoice(value, false));
            });
        });
        // @todo integrate with Store
        this._searcher.reset();
        return this;
    };
    Choices.prototype.setChoiceByValue = function(value) {
        var _this = this;
        if (!this.initialisedOK) {
            this._warnChoicesInitFailed("setChoiceByValue");
            return this;
        }
        if (this._isTextElement) return this;
        this._store.withTxn(function() {
            // If only one value has been passed, convert to array
            var choiceValue = Array.isArray(value) ? value : [
                value
            ];
            // Loop through each value and
            choiceValue.forEach(function(val) {
                return _this._findAndSelectChoiceByValue(val);
            });
            _this.unhighlightAll();
        });
        // @todo integrate with Store
        this._searcher.reset();
        return this;
    };
    /**
     * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
     * a value field name and a label field name.
     * This behaves the same as passing items via the choices option but can be called after initialising Choices.
     * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
     * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
     *
     * **Input types affected:** select-one, select-multiple
     *
     * @example
     * ```js
     * const example = new Choices(element);
     *
     * example.setChoices([
     *   {value: 'One', label: 'Label One', disabled: true},
     *   {value: 'Two', label: 'Label Two', selected: true},
     *   {value: 'Three', label: 'Label Three'},
     * ], 'value', 'label', false);
     * ```
     *
     * @example
     * ```js
     * const example = new Choices(element);
     *
     * example.setChoices(async () => {
     *   try {
     *      const items = await fetch('/items');
     *      return items.json()
     *   } catch(err) {
     *      console.error(err)
     *   }
     * });
     * ```
     *
     * @example
     * ```js
     * const example = new Choices(element);
     *
     * example.setChoices([{
     *   label: 'Group one',
     *   id: 1,
     *   disabled: false,
     *   choices: [
     *     {value: 'Child One', label: 'Child One', selected: true},
     *     {value: 'Child Two', label: 'Child Two',  disabled: true},
     *     {value: 'Child Three', label: 'Child Three'},
     *   ]
     * },
     * {
     *   label: 'Group two',
     *   id: 2,
     *   disabled: false,
     *   choices: [
     *     {value: 'Child Four', label: 'Child Four', disabled: true},
     *     {value: 'Child Five', label: 'Child Five'},
     *     {value: 'Child Six', label: 'Child Six', customProperties: {
     *       description: 'Custom description about child six',
     *       random: 'Another random custom property'
     *     }},
     *   ]
     * }], 'value', 'label', false);
     * ```
     */ Choices.prototype.setChoices = function(choicesArrayOrFetcher, value, label, replaceChoices, clearSearchFlag) {
        var _this = this;
        if (choicesArrayOrFetcher === void 0) choicesArrayOrFetcher = [];
        if (value === void 0) value = "value";
        if (label === void 0) label = "label";
        if (replaceChoices === void 0) replaceChoices = false;
        if (clearSearchFlag === void 0) clearSearchFlag = true;
        if (!this.initialisedOK) {
            this._warnChoicesInitFailed("setChoices");
            return this;
        }
        if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
        if (typeof value !== "string" || !value) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
        // Clear choices if needed
        if (replaceChoices) this.clearChoices();
        if (typeof choicesArrayOrFetcher === "function") {
            // it's a choices fetcher function
            var fetcher_1 = choicesArrayOrFetcher(this);
            if (typeof Promise === "function" && fetcher_1 instanceof Promise) // that's a promise
            // eslint-disable-next-line no-promise-executor-return
            return new Promise(function(resolve) {
                return requestAnimationFrame(resolve);
            }).then(function() {
                return _this._handleLoadingState(true);
            }).then(function() {
                return fetcher_1;
            }).then(function(data) {
                return _this.setChoices(data, value, label, replaceChoices);
            }).catch(function(err) {
                if (!_this.config.silent) console.error(err);
            }).then(function() {
                return _this._handleLoadingState(false);
            }).then(function() {
                return _this;
            });
            // function returned something else than promise, let's check if it's an array of choices
            if (!Array.isArray(fetcher_1)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
            // recursion with results, it's sync and choices were cleared already
            return this.setChoices(fetcher_1, value, label, false);
        }
        if (!Array.isArray(choicesArrayOrFetcher)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
        this.containerOuter.removeLoadingState();
        this._store.withTxn(function() {
            if (clearSearchFlag) _this._isSearching = false;
            var isDefaultValue = value === "value";
            var isDefaultLabel = label === "label";
            choicesArrayOrFetcher.forEach(function(groupOrChoice) {
                if ("choices" in groupOrChoice) {
                    var group = groupOrChoice;
                    if (!isDefaultLabel) group = $a72ba5db1effc4ca$var$__assign($a72ba5db1effc4ca$var$__assign({}, group), {
                        label: group[label]
                    });
                    _this._addGroup($a72ba5db1effc4ca$var$mapInputToChoice(group, true));
                } else {
                    var choice = groupOrChoice;
                    if (!isDefaultLabel || !isDefaultValue) choice = $a72ba5db1effc4ca$var$__assign($a72ba5db1effc4ca$var$__assign({}, choice), {
                        value: choice[value],
                        label: choice[label]
                    });
                    _this._addChoice($a72ba5db1effc4ca$var$mapInputToChoice(choice, false));
                }
            });
            _this.unhighlightAll();
        });
        // @todo integrate with Store
        this._searcher.reset();
        return this;
    };
    Choices.prototype.refresh = function(withEvents, selectFirstOption, deselectAll) {
        var _this = this;
        if (withEvents === void 0) withEvents = false;
        if (selectFirstOption === void 0) selectFirstOption = false;
        if (deselectAll === void 0) deselectAll = false;
        if (!this._isSelectElement) {
            if (!this.config.silent) console.warn("refresh method can only be used on choices backed by a <select> element");
            return this;
        }
        this._store.withTxn(function() {
            var choicesFromOptions = _this.passedElement.optionsAsChoices();
            // Build the list of items which require preserving
            var existingItems = {};
            if (!deselectAll) _this._store.items.forEach(function(choice) {
                if (choice.id && choice.active && choice.selected && !choice.disabled) existingItems[choice.value] = true;
            });
            _this.clearStore(false);
            var updateChoice = function(choice) {
                if (deselectAll) _this._store.dispatch($a72ba5db1effc4ca$var$removeItem$1(choice));
                else if (existingItems[choice.value]) choice.selected = true;
            };
            choicesFromOptions.forEach(function(groupOrChoice) {
                if ("choices" in groupOrChoice) {
                    groupOrChoice.choices.forEach(updateChoice);
                    return;
                }
                updateChoice(groupOrChoice);
            });
            /* @todo only generate add events for the added options instead of all
            if (withEvents) {
              items.forEach((choice) => {
                if (existingItems[choice.value]) {
                  this.passedElement.triggerEvent(
                    EventType.removeItem,
                    this._getChoiceForEvent(choice),
                  );
                }
              });
            }
            */ // load new choices & items
            _this._addPredefinedChoices(choicesFromOptions, selectFirstOption, withEvents);
            // re-do search if required
            if (_this._isSearching) _this._searchChoices(_this.input.value);
        });
        return this;
    };
    Choices.prototype.removeChoice = function(value) {
        var choice = this._store.choices.find(function(c) {
            return c.value === value;
        });
        if (!choice) return this;
        this._clearNotice();
        this._store.dispatch($a72ba5db1effc4ca$var$removeChoice(choice));
        // @todo integrate with Store
        this._searcher.reset();
        if (choice.selected) this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.removeItem, this._getChoiceForOutput(choice));
        return this;
    };
    Choices.prototype.clearChoices = function() {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.choices.forEach(function(choice) {
                if (!choice.selected) _this._store.dispatch($a72ba5db1effc4ca$var$removeChoice(choice));
            });
        });
        // @todo integrate with Store
        this._searcher.reset();
        return this;
    };
    Choices.prototype.clearStore = function(clearOptions) {
        if (clearOptions === void 0) clearOptions = true;
        this._stopSearch();
        if (clearOptions) this.passedElement.element.replaceChildren("");
        this.itemList.element.replaceChildren("");
        this.choiceList.element.replaceChildren("");
        this._store.reset();
        this._lastAddedChoiceId = 0;
        this._lastAddedGroupId = 0;
        // @todo integrate with Store
        this._searcher.reset();
        return this;
    };
    Choices.prototype.clearInput = function() {
        var shouldSetInputWidth = !this._isSelectOneElement;
        this.input.clear(shouldSetInputWidth);
        this._stopSearch();
        return this;
    };
    Choices.prototype._validateConfig = function() {
        var config = this.config;
        var invalidConfigOptions = $a72ba5db1effc4ca$var$diff(config, $a72ba5db1effc4ca$var$DEFAULT_CONFIG);
        if (invalidConfigOptions.length) console.warn("Unknown config option(s) passed", invalidConfigOptions.join(", "));
        if (config.allowHTML && config.allowHtmlUserInput) {
            if (config.addItems) console.warn("Warning: allowHTML/allowHtmlUserInput/addItems all being true is strongly not recommended and may lead to XSS attacks");
            if (config.addChoices) console.warn("Warning: allowHTML/allowHtmlUserInput/addChoices all being true is strongly not recommended and may lead to XSS attacks");
        }
    };
    Choices.prototype._render = function(changes) {
        if (changes === void 0) changes = {
            choices: true,
            groups: true,
            items: true
        };
        if (this._store.inTxn()) return;
        if (this._isSelectElement) {
            if (changes.choices || changes.groups) this._renderChoices();
        }
        if (changes.items) this._renderItems();
    };
    Choices.prototype._renderChoices = function() {
        var _this = this;
        if (!this._canAddItems()) return; // block rendering choices if the input limit is reached.
        var _a = this, config = _a.config, isSearching = _a._isSearching;
        var _b = this._store, activeGroups = _b.activeGroups, activeChoices = _b.activeChoices;
        var renderLimit = 0;
        if (isSearching && config.searchResultLimit > 0) renderLimit = config.searchResultLimit;
        else if (config.renderChoiceLimit > 0) renderLimit = config.renderChoiceLimit;
        if (this._isSelectElement) {
            var backingOptions = activeChoices.filter(function(choice) {
                return !choice.element;
            });
            if (backingOptions.length) this.passedElement.addOptions(backingOptions);
        }
        var fragment = document.createDocumentFragment();
        var renderableChoices = function(choices) {
            return choices.filter(function(choice) {
                return !choice.placeholder && (isSearching ? !!choice.rank : config.renderSelectedChoices || !choice.selected);
            });
        };
        var selectableChoices = false;
        var renderChoices = function(choices, withinGroup, groupLabel) {
            if (isSearching) // sortByRank is used to ensure stable sorting, as scores are non-unique
            // this additionally ensures fuseOptions.sortFn is not ignored
            choices.sort($a72ba5db1effc4ca$var$sortByRank);
            else if (config.shouldSort) choices.sort(config.sorter);
            var choiceLimit = choices.length;
            choiceLimit = !withinGroup && renderLimit && choiceLimit > renderLimit ? renderLimit : choiceLimit;
            choiceLimit--;
            choices.every(function(choice, index) {
                // choiceEl being empty signals the contents has probably significantly changed
                var dropdownItem = choice.choiceEl || _this._templates.choice(config, choice, config.itemSelectText, groupLabel);
                choice.choiceEl = dropdownItem;
                fragment.appendChild(dropdownItem);
                if (!choice.disabled && (isSearching || !choice.selected)) selectableChoices = true;
                return index < choiceLimit;
            });
        };
        if (activeChoices.length) {
            if (config.resetScrollPosition) requestAnimationFrame(function() {
                return _this.choiceList.scrollToTop();
            });
            if (!this._hasNonChoicePlaceholder && !isSearching && this._isSelectOneElement) // If we have a placeholder choice along with groups
            renderChoices(activeChoices.filter(function(choice) {
                return choice.placeholder && !choice.group;
            }), false, undefined);
            // If we have grouped options
            if (activeGroups.length && !isSearching) {
                if (config.shouldSort) activeGroups.sort(config.sorter);
                // render Choices without group first, regardless of sort, otherwise they won't be distinguishable
                // from the last group
                renderChoices(activeChoices.filter(function(choice) {
                    return !choice.placeholder && !choice.group;
                }), false, undefined);
                activeGroups.forEach(function(group) {
                    var groupChoices = renderableChoices(group.choices);
                    if (groupChoices.length) {
                        if (group.label) {
                            var dropdownGroup = group.groupEl || _this._templates.choiceGroup(_this.config, group);
                            group.groupEl = dropdownGroup;
                            dropdownGroup.remove();
                            fragment.appendChild(dropdownGroup);
                        }
                        renderChoices(groupChoices, true, config.appendGroupInSearch && isSearching ? group.label : undefined);
                    }
                });
            } else renderChoices(renderableChoices(activeChoices), false, undefined);
        }
        if (!selectableChoices) {
            if (!this._notice) this._notice = {
                text: $a72ba5db1effc4ca$var$resolveStringFunction(isSearching ? config.noResultsText : config.noChoicesText),
                type: isSearching ? $a72ba5db1effc4ca$var$NoticeTypes.noResults : $a72ba5db1effc4ca$var$NoticeTypes.noChoices
            };
            fragment.replaceChildren("");
        }
        this._renderNotice(fragment);
        this.choiceList.element.replaceChildren(fragment);
        if (selectableChoices) this._highlightChoice();
    };
    Choices.prototype._renderItems = function() {
        var _this = this;
        var items = this._store.items || [];
        var itemList = this.itemList.element;
        var config = this.config;
        var fragment = document.createDocumentFragment();
        var itemFromList = function(item) {
            return itemList.querySelector('[data-item][data-id="'.concat(item.id, '"]'));
        };
        var addItemToFragment = function(item) {
            var el = item.itemEl;
            if (el && el.parentElement) return;
            el = itemFromList(item) || _this._templates.item(config, item, config.removeItemButton);
            item.itemEl = el;
            fragment.appendChild(el);
        };
        // new items
        items.forEach(addItemToFragment);
        var addItems = !!fragment.childNodes.length;
        if (this._isSelectOneElement && this._hasNonChoicePlaceholder) {
            var existingItems = itemList.children.length;
            if (addItems || existingItems > 1) {
                var placeholder = itemList.querySelector($a72ba5db1effc4ca$var$getClassNamesSelector(config.classNames.placeholder));
                if (placeholder) placeholder.remove();
            } else if (!existingItems) {
                addItems = true;
                addItemToFragment($a72ba5db1effc4ca$var$mapInputToChoice({
                    selected: true,
                    value: "",
                    label: config.placeholderValue || "",
                    placeholder: true
                }, false));
            }
        }
        if (addItems) {
            itemList.append(fragment);
            if (config.shouldSortItems && !this._isSelectOneElement) {
                items.sort(config.sorter);
                // push sorting into the DOM
                items.forEach(function(item) {
                    var el = itemFromList(item);
                    if (el) {
                        el.remove();
                        fragment.append(el);
                    }
                });
                itemList.append(fragment);
            }
        }
        if (this._isTextElement) // Update the value of the hidden input
        this.passedElement.value = items.map(function(_a) {
            var value = _a.value;
            return value;
        }).join(config.delimiter);
    };
    Choices.prototype._displayNotice = function(text, type, openDropdown) {
        if (openDropdown === void 0) openDropdown = true;
        var oldNotice = this._notice;
        if (oldNotice && (oldNotice.type === type && oldNotice.text === text || oldNotice.type === $a72ba5db1effc4ca$var$NoticeTypes.addChoice && (type === $a72ba5db1effc4ca$var$NoticeTypes.noResults || type === $a72ba5db1effc4ca$var$NoticeTypes.noChoices))) {
            if (openDropdown) this.showDropdown(true);
            return;
        }
        this._clearNotice();
        this._notice = text ? {
            text: text,
            type: type
        } : undefined;
        this._renderNotice();
        if (openDropdown && text) this.showDropdown(true);
    };
    Choices.prototype._clearNotice = function() {
        if (!this._notice) return;
        var noticeElement = this.choiceList.element.querySelector($a72ba5db1effc4ca$var$getClassNamesSelector(this.config.classNames.notice));
        if (noticeElement) noticeElement.remove();
        this._notice = undefined;
    };
    Choices.prototype._renderNotice = function(fragment) {
        var noticeConf = this._notice;
        if (noticeConf) {
            var notice = this._templates.notice(this.config, noticeConf.text, noticeConf.type);
            if (fragment) fragment.append(notice);
            else this.choiceList.prepend(notice);
        }
    };
    // eslint-disable-next-line class-methods-use-this
    Choices.prototype._getChoiceForOutput = function(choice, keyCode) {
        return {
            id: choice.id,
            highlighted: choice.highlighted,
            labelClass: choice.labelClass,
            labelDescription: choice.labelDescription,
            customProperties: choice.customProperties,
            disabled: choice.disabled,
            active: choice.active,
            label: choice.label,
            placeholder: choice.placeholder,
            value: choice.value,
            groupValue: choice.group ? choice.group.label : undefined,
            element: choice.element,
            keyCode: keyCode
        };
    };
    Choices.prototype._triggerChange = function(value) {
        if (value === undefined || value === null) return;
        this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.change, {
            value: value
        });
    };
    Choices.prototype._handleButtonAction = function(element) {
        var _this = this;
        var items = this._store.items;
        if (!items.length || !this.config.removeItems || !this.config.removeItemButton) return;
        var id = element && $a72ba5db1effc4ca$var$parseDataSetId(element.parentElement);
        var itemToRemove = id && items.find(function(item) {
            return item.id === id;
        });
        if (!itemToRemove) return;
        this._store.withTxn(function() {
            // Remove item associated with button
            _this._removeItem(itemToRemove);
            _this._triggerChange(itemToRemove.value);
            if (_this._isSelectOneElement && !_this._hasNonChoicePlaceholder) {
                var placeholderChoice = _this._store.choices.reverse().find(function(choice) {
                    return !choice.disabled && choice.placeholder;
                });
                if (placeholderChoice) {
                    _this._addItem(placeholderChoice);
                    _this.unhighlightAll();
                    if (placeholderChoice.value) _this._triggerChange(placeholderChoice.value);
                }
            }
        });
    };
    Choices.prototype._handleItemAction = function(element, hasShiftKey) {
        var _this = this;
        if (hasShiftKey === void 0) hasShiftKey = false;
        var items = this._store.items;
        if (!items.length || !this.config.removeItems || this._isSelectOneElement) return;
        var id = $a72ba5db1effc4ca$var$parseDataSetId(element);
        if (!id) return;
        // We only want to select one item with a click
        // so we deselect any items that aren't the target
        // unless shift is being pressed
        items.forEach(function(item) {
            if (item.id === id && !item.highlighted) _this.highlightItem(item);
            else if (!hasShiftKey && item.highlighted) _this.unhighlightItem(item);
        });
        // Focus input as without focus, a user cannot do anything with a
        // highlighted item
        this.input.focus();
    };
    Choices.prototype._handleChoiceAction = function(element) {
        var _this = this;
        // If we are clicking on an option
        var id = $a72ba5db1effc4ca$var$parseDataSetId(element);
        var choice = id && this._store.getChoiceById(id);
        if (!choice || choice.disabled) return false;
        var hasActiveDropdown = this.dropdown.isActive;
        if (!choice.selected) {
            if (!this._canAddItems()) return true; // causes _onEnterKey to early out
            this._store.withTxn(function() {
                _this._addItem(choice, true, true);
                _this.clearInput();
                _this.unhighlightAll();
            });
            this._triggerChange(choice.value);
        }
        // We want to close the dropdown if we are dealing with a single select box
        if (hasActiveDropdown && this.config.closeDropdownOnSelect) {
            this.hideDropdown(true);
            this.containerOuter.element.focus();
        }
        return true;
    };
    Choices.prototype._handleBackspace = function(items) {
        var config = this.config;
        if (!config.removeItems || !items.length) return;
        var lastItem = items[items.length - 1];
        var hasHighlightedItems = items.some(function(item) {
            return item.highlighted;
        });
        // If editing the last item is allowed and there are not other selected items,
        // we can edit the item value. Otherwise if we can remove items, remove all selected items
        if (config.editItems && !hasHighlightedItems && lastItem) {
            this.input.value = lastItem.value;
            this.input.setWidth();
            this._removeItem(lastItem);
            this._triggerChange(lastItem.value);
        } else {
            if (!hasHighlightedItems) // Highlight last item if none already highlighted
            this.highlightItem(lastItem, false);
            this.removeHighlightedItems(true);
        }
    };
    Choices.prototype._loadChoices = function() {
        var _a;
        var config = this.config;
        if (this._isTextElement) {
            // Assign preset items from passed object first
            this._presetChoices = config.items.map(function(e) {
                return $a72ba5db1effc4ca$var$mapInputToChoice(e, false);
            });
            // Add any values passed from attribute
            if (this.passedElement.value) {
                var elementItems = this.passedElement.value.split(config.delimiter).map(function(e) {
                    return $a72ba5db1effc4ca$var$mapInputToChoice(e, false);
                });
                this._presetChoices = this._presetChoices.concat(elementItems);
            }
            this._presetChoices.forEach(function(choice) {
                choice.selected = true;
            });
        } else if (this._isSelectElement) {
            // Assign preset choices from passed object
            this._presetChoices = config.choices.map(function(e) {
                return $a72ba5db1effc4ca$var$mapInputToChoice(e, true);
            });
            // Create array of choices from option elements
            var choicesFromOptions = this.passedElement.optionsAsChoices();
            if (choicesFromOptions) (_a = this._presetChoices).push.apply(_a, choicesFromOptions);
        }
    };
    Choices.prototype._handleLoadingState = function(setLoading) {
        if (setLoading === void 0) setLoading = true;
        var el = this.itemList.element;
        if (setLoading) {
            this.disable();
            this.containerOuter.addLoadingState();
            if (this._isSelectOneElement) el.replaceChildren(this._templates.placeholder(this.config, this.config.loadingText));
            else this.input.placeholder = this.config.loadingText;
        } else {
            this.enable();
            this.containerOuter.removeLoadingState();
            if (this._isSelectOneElement) {
                el.replaceChildren("");
                this._render();
            } else this.input.placeholder = this._placeholderValue || "";
        }
    };
    Choices.prototype._handleSearch = function(value) {
        if (!this.input.isFocussed) return;
        // Check that we have a value to search and the input was an alphanumeric character
        if (value !== null && typeof value !== "undefined" && value.length >= this.config.searchFloor) {
            var resultCount = this.config.searchChoices ? this._searchChoices(value) : 0;
            if (resultCount !== null) // Trigger search event
            this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.search, {
                value: value,
                resultCount: resultCount
            });
        } else if (this._store.choices.some(function(option) {
            return !option.active;
        })) this._stopSearch();
    };
    Choices.prototype._canAddItems = function() {
        var config = this.config;
        var maxItemCount = config.maxItemCount, maxItemText = config.maxItemText;
        if (!config.singleModeForMultiSelect && maxItemCount > 0 && maxItemCount <= this._store.items.length) {
            this.choiceList.element.replaceChildren("");
            this._displayNotice(typeof maxItemText === "function" ? maxItemText(maxItemCount) : maxItemText, $a72ba5db1effc4ca$var$NoticeTypes.addChoice);
            return false;
        }
        return true;
    };
    Choices.prototype._canCreateItem = function(value) {
        var config = this.config;
        var canAddItem = true;
        var notice = "";
        if (canAddItem && typeof config.addItemFilter === "function" && !config.addItemFilter(value)) {
            canAddItem = false;
            notice = $a72ba5db1effc4ca$var$resolveNoticeFunction(config.customAddItemText, value);
        }
        if (canAddItem) {
            var foundChoice = this._store.choices.find(function(choice) {
                return config.valueComparer(choice.value, value);
            });
            if (this._isSelectElement) // for exact matches, do not prompt to add it as a custom choice
            {
                if (foundChoice) {
                    this._displayNotice("", $a72ba5db1effc4ca$var$NoticeTypes.addChoice);
                    return false;
                }
            } else if (this._isTextElement && !config.duplicateItemsAllowed) {
                if (foundChoice) {
                    canAddItem = false;
                    notice = $a72ba5db1effc4ca$var$resolveNoticeFunction(config.uniqueItemText, value);
                }
            }
        }
        if (canAddItem) notice = $a72ba5db1effc4ca$var$resolveNoticeFunction(config.addItemText, value);
        if (notice) this._displayNotice(notice, $a72ba5db1effc4ca$var$NoticeTypes.addChoice);
        return canAddItem;
    };
    Choices.prototype._searchChoices = function(value) {
        var newValue = value.trim().replace(/\s{2,}/, " ");
        // signal input didn't change search
        if (!newValue.length || newValue === this._currentValue) return null;
        var searcher = this._searcher;
        if (searcher.isEmptyIndex()) searcher.index(this._store.searchableChoices);
        // If new value matches the desired length and is not the same as the current value with a space
        var results = searcher.search(newValue);
        this._currentValue = newValue;
        this._highlightPosition = 0;
        this._isSearching = true;
        var notice = this._notice;
        var noticeType = notice && notice.type;
        if (noticeType !== $a72ba5db1effc4ca$var$NoticeTypes.addChoice) {
            if (!results.length) this._displayNotice($a72ba5db1effc4ca$var$resolveStringFunction(this.config.noResultsText), $a72ba5db1effc4ca$var$NoticeTypes.noResults);
            else this._clearNotice();
        }
        this._store.dispatch($a72ba5db1effc4ca$var$filterChoices(results));
        return results.length;
    };
    Choices.prototype._stopSearch = function() {
        if (this._isSearching) {
            this._currentValue = "";
            this._isSearching = false;
            this._clearNotice();
            this._store.dispatch($a72ba5db1effc4ca$var$activateChoices(true));
            this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.search, {
                value: "",
                resultCount: 0
            });
        }
    };
    Choices.prototype._addEventListeners = function() {
        var documentElement = this._docRoot;
        var outerElement = this.containerOuter.element;
        var inputElement = this.input.element;
        // capture events - can cancel event processing or propagation
        documentElement.addEventListener("touchend", this._onTouchEnd, true);
        outerElement.addEventListener("keydown", this._onKeyDown, true);
        outerElement.addEventListener("mousedown", this._onMouseDown, true);
        // passive events - doesn't call `preventDefault` or `stopPropagation`
        documentElement.addEventListener("click", this._onClick, {
            passive: true
        });
        documentElement.addEventListener("touchmove", this._onTouchMove, {
            passive: true
        });
        this.dropdown.element.addEventListener("mouseover", this._onMouseOver, {
            passive: true
        });
        if (this._isSelectOneElement) {
            outerElement.addEventListener("focus", this._onFocus, {
                passive: true
            });
            outerElement.addEventListener("blur", this._onBlur, {
                passive: true
            });
        }
        inputElement.addEventListener("keyup", this._onKeyUp, {
            passive: true
        });
        inputElement.addEventListener("input", this._onInput, {
            passive: true
        });
        inputElement.addEventListener("focus", this._onFocus, {
            passive: true
        });
        inputElement.addEventListener("blur", this._onBlur, {
            passive: true
        });
        if (inputElement.form) inputElement.form.addEventListener("reset", this._onFormReset, {
            passive: true
        });
        this.input.addEventListeners();
    };
    Choices.prototype._removeEventListeners = function() {
        var documentElement = this._docRoot;
        var outerElement = this.containerOuter.element;
        var inputElement = this.input.element;
        documentElement.removeEventListener("touchend", this._onTouchEnd, true);
        outerElement.removeEventListener("keydown", this._onKeyDown, true);
        outerElement.removeEventListener("mousedown", this._onMouseDown, true);
        documentElement.removeEventListener("click", this._onClick);
        documentElement.removeEventListener("touchmove", this._onTouchMove);
        this.dropdown.element.removeEventListener("mouseover", this._onMouseOver);
        if (this._isSelectOneElement) {
            outerElement.removeEventListener("focus", this._onFocus);
            outerElement.removeEventListener("blur", this._onBlur);
        }
        inputElement.removeEventListener("keyup", this._onKeyUp);
        inputElement.removeEventListener("input", this._onInput);
        inputElement.removeEventListener("focus", this._onFocus);
        inputElement.removeEventListener("blur", this._onBlur);
        if (inputElement.form) inputElement.form.removeEventListener("reset", this._onFormReset);
        this.input.removeEventListeners();
    };
    Choices.prototype._onKeyDown = function(event) {
        var keyCode = event.keyCode;
        var hasActiveDropdown = this.dropdown.isActive;
        /*
        See:
        https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
        https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
        https://en.wikipedia.org/wiki/UTF-16#Code_points_from_U+010000_to_U+10FFFF - UTF-16 surrogate pairs
        https://stackoverflow.com/a/70866532 - "Unidentified" for mobile
        http://www.unicode.org/versions/Unicode5.2.0/ch16.pdf#G19635 - U+FFFF is reserved (Section 16.7)
    
        Logic: when a key event is sent, `event.key` represents its printable value _or_ one
        of a large list of special values indicating meta keys/functionality. In addition,
        key events for compose functionality contain a value of `Dead` when mid-composition.
    
        I can't quite verify it, but non-English IMEs may also be able to generate key codes
        for code points in the surrogate-pair range, which could potentially be seen as having
        key.length > 1. Since `Fn` is one of the special keys, we can't distinguish by that
        alone.
    
        Here, key.length === 1 means we know for sure the input was printable and not a special
        `key` value. When the length is greater than 1, it could be either a printable surrogate
        pair or a special `key` value. We can tell the difference by checking if the _character
        code_ value (not code point!) is in the "surrogate pair" range or not.
    
        We don't use .codePointAt because an invalid code point would return 65535, which wouldn't
        pass the >= 0x10000 check we would otherwise use.
    
        > ...The Unicode Standard sets aside 66 noncharacter code points. The last two code points
        > of each plane are noncharacters: U+FFFE and U+FFFF on the BMP...
        */ var wasPrintableChar = event.key.length === 1 || event.key.length === 2 && event.key.charCodeAt(0) >= 0xd800 || event.key === "Unidentified";
        if (!this._isTextElement && !hasActiveDropdown) {
            this.showDropdown();
            if (!this.input.isFocussed && wasPrintableChar) {
                /*
                  We update the input value with the pressed key as
                  the input was not focussed at the time of key press
                  therefore does not have the value of the key.
                */ this.input.value += event.key;
                // browsers interpret a space as pagedown
                if (event.key === " ") event.preventDefault();
            }
        }
        switch(keyCode){
            case 65 /* KeyCodeMap.A_KEY */ :
                return this._onSelectKey(event, this.itemList.element.hasChildNodes());
            case 13 /* KeyCodeMap.ENTER_KEY */ :
                return this._onEnterKey(event, hasActiveDropdown);
            case 27 /* KeyCodeMap.ESC_KEY */ :
                return this._onEscapeKey(event, hasActiveDropdown);
            case 38 /* KeyCodeMap.UP_KEY */ :
            case 33 /* KeyCodeMap.PAGE_UP_KEY */ :
            case 40 /* KeyCodeMap.DOWN_KEY */ :
            case 34 /* KeyCodeMap.PAGE_DOWN_KEY */ :
                return this._onDirectionKey(event, hasActiveDropdown);
            case 8 /* KeyCodeMap.DELETE_KEY */ :
            case 46 /* KeyCodeMap.BACK_KEY */ :
                return this._onDeleteKey(event, this._store.items, this.input.isFocussed);
        }
    };
    Choices.prototype._onKeyUp = function() {
        this._canSearch = this.config.searchEnabled;
    };
    Choices.prototype._onInput = function() {
        var value = this.input.value;
        if (!value) {
            if (this._isTextElement) this.hideDropdown(true);
            else this._stopSearch();
            return;
        }
        if (!this._canAddItems()) return;
        if (this._canSearch) // do the search even if the entered text can not be added
        this._handleSearch(value);
        if (!this._canAddUserChoices) return;
        // determine if a notice needs to be displayed for why a search result can't be added
        this._canCreateItem(value);
        if (this._isSelectElement) {
            this._highlightPosition = 0; // reset to select the notice and/or exact match
            this._highlightChoice();
        }
    };
    Choices.prototype._onSelectKey = function(event, hasItems) {
        // If CTRL + A or CMD + A have been pressed and there are items to select
        if ((event.ctrlKey || event.metaKey) && hasItems) {
            this._canSearch = false;
            var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
            if (shouldHightlightAll) this.highlightAll();
        }
    };
    Choices.prototype._onEnterKey = function(event, hasActiveDropdown) {
        var _this = this;
        var value = this.input.value;
        var target = event.target;
        event.preventDefault();
        if (target && target.hasAttribute("data-button")) {
            this._handleButtonAction(target);
            return;
        }
        if (!hasActiveDropdown) {
            if (this._isSelectElement || this._notice) this.showDropdown();
            return;
        }
        var highlightedChoice = this.dropdown.element.querySelector($a72ba5db1effc4ca$var$getClassNamesSelector(this.config.classNames.highlightedState));
        if (highlightedChoice && this._handleChoiceAction(highlightedChoice)) return;
        if (!target || !value) {
            this.hideDropdown(true);
            return;
        }
        if (!this._canAddItems()) return;
        var addedItem = false;
        this._store.withTxn(function() {
            addedItem = _this._findAndSelectChoiceByValue(value, true);
            if (!addedItem) {
                if (!_this._canAddUserChoices) return;
                if (!_this._canCreateItem(value)) return;
                var sanitisedValue = $a72ba5db1effc4ca$var$sanitise(value);
                var userValue = _this.config.allowHtmlUserInput || sanitisedValue === value ? value : {
                    escaped: sanitisedValue,
                    raw: value
                };
                _this._addChoice($a72ba5db1effc4ca$var$mapInputToChoice({
                    value: userValue,
                    label: userValue,
                    selected: true
                }, false), true, true);
                addedItem = true;
            }
            _this.clearInput();
            _this.unhighlightAll();
        });
        if (!addedItem) return;
        this._triggerChange(value);
        if (this.config.closeDropdownOnSelect) this.hideDropdown(true);
    };
    Choices.prototype._onEscapeKey = function(event, hasActiveDropdown) {
        if (hasActiveDropdown) {
            event.stopPropagation();
            this.hideDropdown(true);
            this.containerOuter.element.focus();
        }
    };
    Choices.prototype._onDirectionKey = function(event, hasActiveDropdown) {
        var keyCode = event.keyCode;
        // If up or down key is pressed, traverse through options
        if (hasActiveDropdown || this._isSelectOneElement) {
            this.showDropdown();
            this._canSearch = false;
            var directionInt = keyCode === 40 /* KeyCodeMap.DOWN_KEY */  || keyCode === 34 /* KeyCodeMap.PAGE_DOWN_KEY */  ? 1 : -1;
            var skipKey = event.metaKey || keyCode === 34 /* KeyCodeMap.PAGE_DOWN_KEY */  || keyCode === 33 /* KeyCodeMap.PAGE_UP_KEY */ ;
            var nextEl = void 0;
            if (skipKey) {
                if (directionInt > 0) nextEl = this.dropdown.element.querySelector("".concat($a72ba5db1effc4ca$var$selectableChoiceIdentifier, ":last-of-type"));
                else nextEl = this.dropdown.element.querySelector($a72ba5db1effc4ca$var$selectableChoiceIdentifier);
            } else {
                var currentEl = this.dropdown.element.querySelector($a72ba5db1effc4ca$var$getClassNamesSelector(this.config.classNames.highlightedState));
                if (currentEl) nextEl = $a72ba5db1effc4ca$var$getAdjacentEl(currentEl, $a72ba5db1effc4ca$var$selectableChoiceIdentifier, directionInt);
                else nextEl = this.dropdown.element.querySelector($a72ba5db1effc4ca$var$selectableChoiceIdentifier);
            }
            if (nextEl) {
                // We prevent default to stop the cursor moving
                // when pressing the arrow
                if (!$a72ba5db1effc4ca$var$isScrolledIntoView(nextEl, this.choiceList.element, directionInt)) this.choiceList.scrollToChildElement(nextEl, directionInt);
                this._highlightChoice(nextEl);
            }
            // Prevent default to maintain cursor position whilst
            // traversing dropdown options
            event.preventDefault();
        }
    };
    Choices.prototype._onDeleteKey = function(event, items, hasFocusedInput) {
        // If backspace or delete key is pressed and the input has no value
        if (!this._isSelectOneElement && !event.target.value && hasFocusedInput) {
            this._handleBackspace(items);
            event.preventDefault();
        }
    };
    Choices.prototype._onTouchMove = function() {
        if (this._wasTap) this._wasTap = false;
    };
    Choices.prototype._onTouchEnd = function(event) {
        var target = (event || event.touches[0]).target;
        var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
        if (touchWasWithinContainer) {
            var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
            if (containerWasExactTarget) {
                if (this._isTextElement) this.input.focus();
                else if (this._isSelectMultipleElement) this.showDropdown();
            }
            // Prevents focus event firing
            event.stopPropagation();
        }
        this._wasTap = true;
    };
    /**
     * Handles mousedown event in capture mode for containetOuter.element
     */ Choices.prototype._onMouseDown = function(event) {
        var target = event.target;
        if (!(target instanceof HTMLElement)) return;
        // If we have our mouse down on the scrollbar and are on IE11...
        if ($a72ba5db1effc4ca$var$IS_IE11 && this.choiceList.element.contains(target)) {
            // check if click was on a scrollbar area
            var firstChoice = this.choiceList.element.firstElementChild;
            this._isScrollingOnIe = this._direction === "ltr" ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
        }
        if (target === this.input.element) return;
        var item = target.closest("[data-button],[data-item],[data-choice]");
        if (item instanceof HTMLElement) {
            if ("button" in item.dataset) this._handleButtonAction(item);
            else if ("item" in item.dataset) this._handleItemAction(item, event.shiftKey);
            else if ("choice" in item.dataset) this._handleChoiceAction(item);
        }
        event.preventDefault();
    };
    /**
     * Handles mouseover event over this.dropdown
     * @param {MouseEvent} event
     */ Choices.prototype._onMouseOver = function(_a) {
        var target = _a.target;
        if (target instanceof HTMLElement && "choice" in target.dataset) this._highlightChoice(target);
    };
    Choices.prototype._onClick = function(_a) {
        var target = _a.target;
        var containerOuter = this.containerOuter;
        var clickWasWithinContainer = containerOuter.element.contains(target);
        if (clickWasWithinContainer) {
            if (!this.dropdown.isActive && !containerOuter.isDisabled) {
                if (this._isTextElement) {
                    if (document.activeElement !== this.input.element) this.input.focus();
                } else {
                    this.showDropdown();
                    containerOuter.element.focus();
                }
            } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) this.hideDropdown();
        } else {
            containerOuter.removeFocusState();
            this.hideDropdown(true);
            this.unhighlightAll();
        }
    };
    Choices.prototype._onFocus = function(_a) {
        var target = _a.target;
        var containerOuter = this.containerOuter;
        var focusWasWithinContainer = target && containerOuter.element.contains(target);
        if (!focusWasWithinContainer) return;
        var targetIsInput = target === this.input.element;
        if (this._isTextElement) {
            if (targetIsInput) containerOuter.addFocusState();
        } else if (this._isSelectMultipleElement) {
            if (targetIsInput) {
                this.showDropdown(true);
                // If element is a select box, the focused element is the container and the dropdown
                // isn't already open, focus and show dropdown
                containerOuter.addFocusState();
            }
        } else {
            containerOuter.addFocusState();
            if (targetIsInput) this.showDropdown(true);
        }
    };
    Choices.prototype._onBlur = function(_a) {
        var target = _a.target;
        var containerOuter = this.containerOuter;
        var blurWasWithinContainer = target && containerOuter.element.contains(target);
        if (blurWasWithinContainer && !this._isScrollingOnIe) {
            var targetIsInput = target === this.input.element;
            if (this._isTextElement || this._isSelectMultipleElement) {
                if (targetIsInput) {
                    containerOuter.removeFocusState();
                    this.hideDropdown(true);
                    this.unhighlightAll();
                }
            } else {
                containerOuter.removeFocusState();
                if (targetIsInput || target === containerOuter.element && !this._canSearch) this.hideDropdown(true);
            }
        } else {
            // On IE11, clicking the scollbar blurs our input and thus
            // closes the dropdown. To stop this, we refocus our input
            // if we know we are on IE *and* are scrolling.
            this._isScrollingOnIe = false;
            this.input.element.focus();
        }
    };
    Choices.prototype._onFormReset = function() {
        var _this = this;
        this._store.withTxn(function() {
            _this.clearInput();
            _this.hideDropdown();
            _this.refresh(false, false, true);
            if (_this._initialItems.length) _this.setChoiceByValue(_this._initialItems);
        });
    };
    Choices.prototype._highlightChoice = function(el) {
        if (el === void 0) el = null;
        var choices = Array.from(this.dropdown.element.querySelectorAll($a72ba5db1effc4ca$var$selectableChoiceIdentifier));
        if (!choices.length) return;
        var passedEl = el;
        var highlightedState = this.config.classNames.highlightedState;
        var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll($a72ba5db1effc4ca$var$getClassNamesSelector(highlightedState)));
        // Remove any highlighted choices
        highlightedChoices.forEach(function(choice) {
            $a72ba5db1effc4ca$var$removeClassesFromElement(choice, highlightedState);
            choice.setAttribute("aria-selected", "false");
        });
        if (passedEl) this._highlightPosition = choices.indexOf(passedEl);
        else {
            // Highlight choice based on last known highlight location
            if (choices.length > this._highlightPosition) // If we have an option to highlight
            passedEl = choices[this._highlightPosition];
            else // Otherwise highlight the option before
            passedEl = choices[choices.length - 1];
            if (!passedEl) passedEl = choices[0];
        }
        $a72ba5db1effc4ca$var$addClassesToElement(passedEl, highlightedState);
        passedEl.setAttribute("aria-selected", "true");
        this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.highlightChoice, {
            el: passedEl
        });
        if (this.dropdown.isActive) {
            // IE11 ignores aria-label and blocks virtual keyboard
            // if aria-activedescendant is set without a dropdown
            this.input.setActiveDescendant(passedEl.id);
            this.containerOuter.setActiveDescendant(passedEl.id);
        }
    };
    Choices.prototype._addItem = function(item, withEvents, userTriggered) {
        if (withEvents === void 0) withEvents = true;
        if (userTriggered === void 0) userTriggered = false;
        if (!item.id) throw new TypeError("item.id must be set before _addItem is called for a choice/item");
        if (this.config.singleModeForMultiSelect || this._isSelectOneElement) this.removeActiveItems(item.id);
        this._store.dispatch($a72ba5db1effc4ca$var$addItem(item));
        if (withEvents) {
            this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.addItem, this._getChoiceForOutput(item));
            if (userTriggered) this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.choice, this._getChoiceForOutput(item));
        }
    };
    Choices.prototype._removeItem = function(item) {
        if (!item.id) return;
        this._store.dispatch($a72ba5db1effc4ca$var$removeItem$1(item));
        this.passedElement.triggerEvent($a72ba5db1effc4ca$var$EventType.removeItem, this._getChoiceForOutput(item));
    };
    Choices.prototype._addChoice = function(choice, withEvents, userTriggered) {
        if (withEvents === void 0) withEvents = true;
        if (userTriggered === void 0) userTriggered = false;
        if (choice.id) throw new TypeError("Can not re-add a choice which has already been added");
        var config = this.config;
        if ((this._isSelectElement || !config.duplicateItemsAllowed) && this._store.choices.find(function(c) {
            return config.valueComparer(c.value, choice.value);
        })) return;
        // Generate unique id, in-place update is required so chaining _addItem works as expected
        this._lastAddedChoiceId++;
        choice.id = this._lastAddedChoiceId;
        choice.elementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choice.id);
        var prependValue = config.prependValue, appendValue = config.appendValue;
        if (prependValue) choice.value = prependValue + choice.value;
        if (appendValue) choice.value += appendValue.toString();
        if ((prependValue || appendValue) && choice.element) choice.element.value = choice.value;
        this._clearNotice();
        this._store.dispatch($a72ba5db1effc4ca$var$addChoice(choice));
        if (choice.selected) this._addItem(choice, withEvents, userTriggered);
    };
    Choices.prototype._addGroup = function(group, withEvents) {
        var _this = this;
        if (withEvents === void 0) withEvents = true;
        if (group.id) throw new TypeError("Can not re-add a group which has already been added");
        this._store.dispatch($a72ba5db1effc4ca$var$addGroup(group));
        if (!group.choices) return;
        // add unique id for the group(s), and do not store the full list of choices in this group
        this._lastAddedGroupId++;
        group.id = this._lastAddedGroupId;
        group.choices.forEach(function(item) {
            item.group = group;
            if (group.disabled) item.disabled = true;
            _this._addChoice(item, withEvents);
        });
    };
    Choices.prototype._createTemplates = function() {
        var _this = this;
        var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
        var userTemplates = {};
        if (typeof callbackOnCreateTemplates === "function") userTemplates = callbackOnCreateTemplates.call(this, $a72ba5db1effc4ca$var$strToEl, $a72ba5db1effc4ca$var$escapeForTemplate, $a72ba5db1effc4ca$var$getClassNames);
        var templating = {};
        Object.keys(this._templates).forEach(function(name) {
            if (name in userTemplates) templating[name] = userTemplates[name].bind(_this);
            else templating[name] = _this._templates[name].bind(_this);
        });
        this._templates = templating;
    };
    Choices.prototype._createElements = function() {
        var templating = this._templates;
        var _a = this, config = _a.config, isSelectOneElement = _a._isSelectOneElement;
        var position = config.position, classNames = config.classNames;
        var elementType = this._elementType;
        this.containerOuter = new $a72ba5db1effc4ca$var$Container({
            element: templating.containerOuter(config, this._direction, this._isSelectElement, isSelectOneElement, config.searchEnabled, elementType, config.labelId),
            classNames: classNames,
            type: elementType,
            position: position
        });
        this.containerInner = new $a72ba5db1effc4ca$var$Container({
            element: templating.containerInner(config),
            classNames: classNames,
            type: elementType,
            position: position
        });
        this.input = new $a72ba5db1effc4ca$var$Input({
            element: templating.input(config, this._placeholderValue),
            classNames: classNames,
            type: elementType,
            preventPaste: !config.paste
        });
        this.choiceList = new $a72ba5db1effc4ca$var$List({
            element: templating.choiceList(config, isSelectOneElement)
        });
        this.itemList = new $a72ba5db1effc4ca$var$List({
            element: templating.itemList(config, isSelectOneElement)
        });
        this.dropdown = new $a72ba5db1effc4ca$var$Dropdown({
            element: templating.dropdown(config),
            classNames: classNames,
            type: elementType
        });
    };
    Choices.prototype._createStructure = function() {
        var _a = this, containerInner = _a.containerInner, containerOuter = _a.containerOuter, passedElement = _a.passedElement;
        var dropdownElement = this.dropdown.element;
        // Hide original element
        passedElement.conceal();
        // Wrap input in container preserving DOM ordering
        containerInner.wrap(passedElement.element);
        // Wrapper inner container with outer container
        containerOuter.wrap(containerInner.element);
        if (this._isSelectOneElement) this.input.placeholder = this.config.searchPlaceholderValue || "";
        else {
            if (this._placeholderValue) this.input.placeholder = this._placeholderValue;
            this.input.setWidth();
        }
        containerOuter.element.appendChild(containerInner.element);
        containerOuter.element.appendChild(dropdownElement);
        containerInner.element.appendChild(this.itemList.element);
        dropdownElement.appendChild(this.choiceList.element);
        if (!this._isSelectOneElement) containerInner.element.appendChild(this.input.element);
        else if (this.config.searchEnabled) dropdownElement.insertBefore(this.input.element, dropdownElement.firstChild);
        this._highlightPosition = 0;
        this._isSearching = false;
    };
    Choices.prototype._initStore = function() {
        var _this = this;
        this._store.subscribe(this._render).withTxn(function() {
            _this._addPredefinedChoices(_this._presetChoices, _this._isSelectOneElement && !_this._hasNonChoicePlaceholder, false);
        });
        if (!this._store.choices.length || this._isSelectOneElement && this._hasNonChoicePlaceholder) this._render();
    };
    Choices.prototype._addPredefinedChoices = function(choices, selectFirstOption, withEvents) {
        var _this = this;
        if (selectFirstOption === void 0) selectFirstOption = false;
        if (withEvents === void 0) withEvents = true;
        if (selectFirstOption) {
            /**
             * If there is a selected choice already or the choice is not the first in
             * the array, add each choice normally.
             *
             * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
             */ var noSelectedChoices = choices.findIndex(function(choice) {
                return choice.selected;
            }) === -1;
            if (noSelectedChoices) choices.some(function(choice) {
                if (choice.disabled || "choices" in choice) return false;
                choice.selected = true;
                return true;
            });
        }
        choices.forEach(function(item) {
            if ("choices" in item) {
                if (_this._isSelectElement) _this._addGroup(item, withEvents);
            } else _this._addChoice(item, withEvents);
        });
    };
    Choices.prototype._findAndSelectChoiceByValue = function(value, userTriggered) {
        var _this = this;
        if (userTriggered === void 0) userTriggered = false;
        // Check 'value' property exists and the choice isn't already selected
        var foundChoice = this._store.choices.find(function(choice) {
            return _this.config.valueComparer(choice.value, value);
        });
        if (foundChoice && !foundChoice.disabled && !foundChoice.selected) {
            this._addItem(foundChoice, true, userTriggered);
            return true;
        }
        return false;
    };
    Choices.prototype._generatePlaceholderValue = function() {
        var config = this.config;
        if (!config.placeholder) return null;
        if (this._hasNonChoicePlaceholder) return config.placeholderValue;
        if (this._isSelectElement) {
            var placeholderOption = this.passedElement.placeholderOption;
            return placeholderOption ? placeholderOption.text : null;
        }
        return null;
    };
    Choices.prototype._warnChoicesInitFailed = function(caller) {
        if (this.config.silent) return;
        if (!this.initialised) throw new TypeError("".concat(caller, " called on a non-initialised instance of Choices"));
        else if (!this.initialisedOK) throw new TypeError("".concat(caller, " called for an element which has multiple instances of Choices initialised on it"));
    };
    Choices.version = "11.0.2";
    return Choices;
}();


var $01f711fe40ba0e9e$exports = {};
/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */ (function(global, factory) {
    $01f711fe40ba0e9e$exports = factory();
})($01f711fe40ba0e9e$exports, function() {
    "use strict";
    /* eslint-disable */ var shared, worker, mapboxgl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
            var sharedChunk = {};
            shared(sharedChunk);
            mapboxgl = chunk(sharedChunk);
            if (typeof window !== "undefined" && window && window.URL && window.URL.createObjectURL) mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: "text/javascript"
            }));
        }
    }
    define([
        "exports"
    ], function(t1) {
        function e(t1) {
            return t1 && t1.__esModule && Object.prototype.hasOwnProperty.call(t1, "default") ? t1.default : t1;
        }
        var r, n = {}, i = {};
        function s() {
            if (r) return i;
            r = 1, Object.defineProperty(i, "__esModule", {
                value: !0
            }), i.setMatrixArrayType = function(t1) {
                i.ARRAY_TYPE = e = t1;
            }, i.toRadian = function(t1) {
                return t1 * s;
            }, i.equals = function(e, r) {
                return Math.abs(e - r) <= t1 * Math.max(1, Math.abs(e), Math.abs(r));
            }, i.RANDOM = i.ARRAY_TYPE = i.EPSILON = void 0;
            var t1 = 1e-6;
            i.EPSILON = t1;
            var e = "undefined" != typeof Float32Array ? Float32Array : Array;
            i.ARRAY_TYPE = e;
            var n = Math.random;
            i.RANDOM = n;
            var s = Math.PI / 180;
            return Math.hypot || (Math.hypot = function() {
                for(var t1 = 0, e = arguments.length; e--;)t1 += arguments[e] * arguments[e];
                return Math.sqrt(t1);
            }), i;
        }
        var a, o = {};
        function l() {
            if (a) return o;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            a = 1, Object.defineProperty(o, "__esModule", {
                value: !0
            }), o.create = function() {
                var t1 = new e.ARRAY_TYPE(4);
                return e.ARRAY_TYPE != Float32Array && (t1[1] = 0, t1[2] = 0), t1[0] = 1, t1[3] = 1, t1;
            }, o.clone = function(t1) {
                var r = new e.ARRAY_TYPE(4);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = t1[3], r;
            }, o.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1;
            }, o.identity = function(t1) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1;
            }, o.fromValues = function(t1, r, n, i) {
                var s = new e.ARRAY_TYPE(4);
                return s[0] = t1, s[1] = r, s[2] = n, s[3] = i, s;
            }, o.set = function(t1, e, r, n, i) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = i, t1;
            }, o.transpose = function(t1, e) {
                if (t1 === e) {
                    var r = e[1];
                    t1[1] = e[2], t1[2] = r;
                } else t1[0] = e[0], t1[1] = e[2], t1[2] = e[1], t1[3] = e[3];
                return t1;
            }, o.invert = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = r * s - i * n;
                return a ? (t1[0] = s * (a = 1 / a), t1[1] = -n * a, t1[2] = -i * a, t1[3] = r * a, t1) : null;
            }, o.adjoint = function(t1, e) {
                var r = e[0];
                return t1[0] = e[3], t1[1] = -e[1], t1[2] = -e[2], t1[3] = r, t1;
            }, o.determinant = function(t1) {
                return t1[0] * t1[3] - t1[2] * t1[1];
            }, o.multiply = n, o.rotate = function(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = Math.sin(r), l = Math.cos(r);
                return t1[0] = n * l + s * o, t1[1] = i * l + a * o, t1[2] = n * -o + s * l, t1[3] = i * -o + a * l, t1;
            }, o.scale = function(t1, e, r) {
                var n = e[1], i = e[2], s = e[3], a = r[0], o = r[1];
                return t1[0] = e[0] * a, t1[1] = n * a, t1[2] = i * o, t1[3] = s * o, t1;
            }, o.fromRotation = function(t1, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t1[0] = n, t1[1] = r, t1[2] = -r, t1[3] = n, t1;
            }, o.fromScaling = function(t1, e) {
                return t1[0] = e[0], t1[1] = 0, t1[2] = 0, t1[3] = e[1], t1;
            }, o.str = function(t1) {
                return "mat2(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ")";
            }, o.frob = function(t1) {
                return Math.hypot(t1[0], t1[1], t1[2], t1[3]);
            }, o.LDU = function(t1, e, r, n) {
                return t1[2] = n[2] / n[0], r[0] = n[0], r[1] = n[1], r[3] = n[3] - t1[2] * r[1], [
                    t1,
                    e,
                    r
                ];
            }, o.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1[3] = e[3] + r[3], t1;
            }, o.subtract = i, o.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3];
            }, o.equals = function(t1, r) {
                var n = t1[0], i = t1[1], s = t1[2], a = t1[3], o = r[0], l = r[1], u = r[2], c = r[3];
                return Math.abs(n - o) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(o)) && Math.abs(i - l) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(l)) && Math.abs(s - u) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(u)) && Math.abs(a - c) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(c));
            }, o.multiplyScalar = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1;
            }, o.multiplyScalarAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1[3] = e[3] + r[3] * n, t1;
            }, o.sub = o.mul = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var s = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = a ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(s, o, l) : s[o] = e[o];
                }
                return s.default = e, i && i.set(e, s), s;
            }(s());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = r[0], l = r[1], u = r[2], c = r[3];
                return t1[0] = n * o + s * l, t1[1] = i * o + a * l, t1[2] = n * u + s * c, t1[3] = i * u + a * c, t1;
            }
            function i(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1[3] = e[3] - r[3], t1;
            }
            return o.mul = n, o.sub = i, o;
        }
        var u, c = {};
        function h() {
            if (u) return c;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            u = 1, Object.defineProperty(c, "__esModule", {
                value: !0
            }), c.create = function() {
                var t1 = new e.ARRAY_TYPE(6);
                return e.ARRAY_TYPE != Float32Array && (t1[1] = 0, t1[2] = 0, t1[4] = 0, t1[5] = 0), t1[0] = 1, t1[3] = 1, t1;
            }, c.clone = function(t1) {
                var r = new e.ARRAY_TYPE(6);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = t1[3], r[4] = t1[4], r[5] = t1[5], r;
            }, c.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[4] = e[4], t1[5] = e[5], t1;
            }, c.identity = function(t1) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1[4] = 0, t1[5] = 0, t1;
            }, c.fromValues = function(t1, r, n, i, s, a) {
                var o = new e.ARRAY_TYPE(6);
                return o[0] = t1, o[1] = r, o[2] = n, o[3] = i, o[4] = s, o[5] = a, o;
            }, c.set = function(t1, e, r, n, i, s, a) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = i, t1[4] = s, t1[5] = a, t1;
            }, c.invert = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], l = r * s - n * i;
                return l ? (t1[0] = s * (l = 1 / l), t1[1] = -n * l, t1[2] = -i * l, t1[3] = r * l, t1[4] = (i * o - s * a) * l, t1[5] = (n * a - r * o) * l, t1) : null;
            }, c.determinant = function(t1) {
                return t1[0] * t1[3] - t1[1] * t1[2];
            }, c.multiply = n, c.rotate = function(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = Math.sin(r), c = Math.cos(r);
                return t1[0] = n * c + s * u, t1[1] = i * c + a * u, t1[2] = n * -u + s * c, t1[3] = i * -u + a * c, t1[4] = o, t1[5] = l, t1;
            }, c.scale = function(t1, e, r) {
                var n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], l = r[0], u = r[1];
                return t1[0] = e[0] * l, t1[1] = n * l, t1[2] = i * u, t1[3] = s * u, t1[4] = a, t1[5] = o, t1;
            }, c.translate = function(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = r[0], c = r[1];
                return t1[0] = n, t1[1] = i, t1[2] = s, t1[3] = a, t1[4] = n * u + s * c + o, t1[5] = i * u + a * c + l, t1;
            }, c.fromRotation = function(t1, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t1[0] = n, t1[1] = r, t1[2] = -r, t1[3] = n, t1[4] = 0, t1[5] = 0, t1;
            }, c.fromScaling = function(t1, e) {
                return t1[0] = e[0], t1[1] = 0, t1[2] = 0, t1[3] = e[1], t1[4] = 0, t1[5] = 0, t1;
            }, c.fromTranslation = function(t1, e) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1[4] = e[0], t1[5] = e[1], t1;
            }, c.str = function(t1) {
                return "mat2d(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ", " + t1[4] + ", " + t1[5] + ")";
            }, c.frob = function(t1) {
                return Math.hypot(t1[0], t1[1], t1[2], t1[3], t1[4], t1[5], 1);
            }, c.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1[3] = e[3] + r[3], t1[4] = e[4] + r[4], t1[5] = e[5] + r[5], t1;
            }, c.subtract = i, c.multiplyScalar = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1[4] = e[4] * r, t1[5] = e[5] * r, t1;
            }, c.multiplyScalarAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1[3] = e[3] + r[3] * n, t1[4] = e[4] + r[4] * n, t1[5] = e[5] + r[5] * n, t1;
            }, c.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3] && t1[4] === e[4] && t1[5] === e[5];
            }, c.equals = function(t1, r) {
                var n = t1[0], i = t1[1], s = t1[2], a = t1[3], o = t1[4], l = t1[5], u = r[0], c = r[1], h = r[2], p = r[3], f = r[4], d = r[5];
                return Math.abs(n - u) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(u)) && Math.abs(i - c) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(c)) && Math.abs(s - h) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(h)) && Math.abs(a - p) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(p)) && Math.abs(o - f) <= e.EPSILON * Math.max(1, Math.abs(o), Math.abs(f)) && Math.abs(l - d) <= e.EPSILON * Math.max(1, Math.abs(l), Math.abs(d));
            }, c.sub = c.mul = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var s = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = a ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(s, o, l) : s[o] = e[o];
                }
                return s.default = e, i && i.set(e, s), s;
            }(s());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = r[0], c = r[1], h = r[2], p = r[3], f = r[4], d = r[5];
                return t1[0] = n * u + s * c, t1[1] = i * u + a * c, t1[2] = n * h + s * p, t1[3] = i * h + a * p, t1[4] = n * f + s * d + o, t1[5] = i * f + a * d + l, t1;
            }
            function i(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1[3] = e[3] - r[3], t1[4] = e[4] - r[4], t1[5] = e[5] - r[5], t1;
            }
            return c.mul = n, c.sub = i, c;
        }
        var p, f = {};
        function d() {
            if (p) return f;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            p = 1, Object.defineProperty(f, "__esModule", {
                value: !0
            }), f.create = function() {
                var t1 = new e.ARRAY_TYPE(9);
                return e.ARRAY_TYPE != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[0] = 1, t1[4] = 1, t1[8] = 1, t1;
            }, f.fromMat4 = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[4], t1[4] = e[5], t1[5] = e[6], t1[6] = e[8], t1[7] = e[9], t1[8] = e[10], t1;
            }, f.clone = function(t1) {
                var r = new e.ARRAY_TYPE(9);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = t1[3], r[4] = t1[4], r[5] = t1[5], r[6] = t1[6], r[7] = t1[7], r[8] = t1[8], r;
            }, f.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[4] = e[4], t1[5] = e[5], t1[6] = e[6], t1[7] = e[7], t1[8] = e[8], t1;
            }, f.fromValues = function(t1, r, n, i, s, a, o, l, u) {
                var c = new e.ARRAY_TYPE(9);
                return c[0] = t1, c[1] = r, c[2] = n, c[3] = i, c[4] = s, c[5] = a, c[6] = o, c[7] = l, c[8] = u, c;
            }, f.set = function(t1, e, r, n, i, s, a, o, l, u) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = i, t1[4] = s, t1[5] = a, t1[6] = o, t1[7] = l, t1[8] = u, t1;
            }, f.identity = function(t1) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 1, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
            }, f.transpose = function(t1, e) {
                if (t1 === e) {
                    var r = e[1], n = e[2], i = e[5];
                    t1[1] = e[3], t1[2] = e[6], t1[3] = r, t1[5] = e[7], t1[6] = n, t1[7] = i;
                } else t1[0] = e[0], t1[1] = e[3], t1[2] = e[6], t1[3] = e[1], t1[4] = e[4], t1[5] = e[7], t1[6] = e[2], t1[7] = e[5], t1[8] = e[8];
                return t1;
            }, f.invert = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], l = e[6], u = e[7], c = e[8], h = c * a - o * u, p = -c * s + o * l, f = u * s - a * l, d = r * h + n * p + i * f;
                return d ? (t1[0] = h * (d = 1 / d), t1[1] = (-c * n + i * u) * d, t1[2] = (o * n - i * a) * d, t1[3] = p * d, t1[4] = (c * r - i * l) * d, t1[5] = (-o * r + i * s) * d, t1[6] = f * d, t1[7] = (-u * r + n * l) * d, t1[8] = (a * r - n * s) * d, t1) : null;
            }, f.adjoint = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], l = e[6], u = e[7], c = e[8];
                return t1[0] = a * c - o * u, t1[1] = i * u - n * c, t1[2] = n * o - i * a, t1[3] = o * l - s * c, t1[4] = r * c - i * l, t1[5] = i * s - r * o, t1[6] = s * u - a * l, t1[7] = n * l - r * u, t1[8] = r * a - n * s, t1;
            }, f.determinant = function(t1) {
                var e = t1[3], r = t1[4], n = t1[5], i = t1[6], s = t1[7], a = t1[8];
                return t1[0] * (a * r - n * s) + t1[1] * (-a * e + n * i) + t1[2] * (s * e - r * i);
            }, f.multiply = n, f.translate = function(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = r[0], f = r[1];
                return t1[0] = n, t1[1] = i, t1[2] = s, t1[3] = a, t1[4] = o, t1[5] = l, t1[6] = p * n + f * a + u, t1[7] = p * i + f * o + c, t1[8] = p * s + f * l + h, t1;
            }, f.rotate = function(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = Math.sin(r), f = Math.cos(r);
                return t1[0] = f * n + p * a, t1[1] = f * i + p * o, t1[2] = f * s + p * l, t1[3] = f * a - p * n, t1[4] = f * o - p * i, t1[5] = f * l - p * s, t1[6] = u, t1[7] = c, t1[8] = h, t1;
            }, f.scale = function(t1, e, r) {
                var n = r[0], i = r[1];
                return t1[0] = n * e[0], t1[1] = n * e[1], t1[2] = n * e[2], t1[3] = i * e[3], t1[4] = i * e[4], t1[5] = i * e[5], t1[6] = e[6], t1[7] = e[7], t1[8] = e[8], t1;
            }, f.fromTranslation = function(t1, e) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 1, t1[5] = 0, t1[6] = e[0], t1[7] = e[1], t1[8] = 1, t1;
            }, f.fromRotation = function(t1, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = -r, t1[4] = n, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
            }, f.fromScaling = function(t1, e) {
                return t1[0] = e[0], t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = e[1], t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
            }, f.fromMat2d = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = 0, t1[3] = e[2], t1[4] = e[3], t1[5] = 0, t1[6] = e[4], t1[7] = e[5], t1[8] = 1, t1;
            }, f.fromQuat = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = r + r, o = n + n, l = i + i, u = r * a, c = n * a, h = n * o, p = i * a, f = i * o, d = i * l, m = s * a, y = s * o, g = s * l;
                return t1[0] = 1 - h - d, t1[3] = c - g, t1[6] = p + y, t1[1] = c + g, t1[4] = 1 - u - d, t1[7] = f - m, t1[2] = p - y, t1[5] = f + m, t1[8] = 1 - u - h, t1;
            }, f.normalFromMat4 = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], l = e[6], u = e[7], c = e[8], h = e[9], p = e[10], f = e[11], d = e[12], m = e[13], y = e[14], g = e[15], x = r * o - n * a, b = r * l - i * a, v = r * u - s * a, w = n * l - i * o, _ = n * u - s * o, M = i * u - s * l, A = c * m - h * d, S = c * y - p * d, I = c * g - f * d, P = h * y - p * m, z = h * g - f * m, k = p * g - f * y, T = x * k - b * z + v * P + w * I - _ * S + M * A;
                return T ? (t1[0] = (o * k - l * z + u * P) * (T = 1 / T), t1[1] = (l * I - a * k - u * S) * T, t1[2] = (a * z - o * I + u * A) * T, t1[3] = (i * z - n * k - s * P) * T, t1[4] = (r * k - i * I + s * S) * T, t1[5] = (n * I - r * z - s * A) * T, t1[6] = (m * M - y * _ + g * w) * T, t1[7] = (y * v - d * M - g * b) * T, t1[8] = (d * _ - m * v + g * x) * T, t1) : null;
            }, f.projection = function(t1, e, r) {
                return t1[0] = 2 / e, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = -2 / r, t1[5] = 0, t1[6] = -1, t1[7] = 1, t1[8] = 1, t1;
            }, f.str = function(t1) {
                return "mat3(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ", " + t1[4] + ", " + t1[5] + ", " + t1[6] + ", " + t1[7] + ", " + t1[8] + ")";
            }, f.frob = function(t1) {
                return Math.hypot(t1[0], t1[1], t1[2], t1[3], t1[4], t1[5], t1[6], t1[7], t1[8]);
            }, f.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1[3] = e[3] + r[3], t1[4] = e[4] + r[4], t1[5] = e[5] + r[5], t1[6] = e[6] + r[6], t1[7] = e[7] + r[7], t1[8] = e[8] + r[8], t1;
            }, f.subtract = i, f.multiplyScalar = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1[4] = e[4] * r, t1[5] = e[5] * r, t1[6] = e[6] * r, t1[7] = e[7] * r, t1[8] = e[8] * r, t1;
            }, f.multiplyScalarAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1[3] = e[3] + r[3] * n, t1[4] = e[4] + r[4] * n, t1[5] = e[5] + r[5] * n, t1[6] = e[6] + r[6] * n, t1[7] = e[7] + r[7] * n, t1[8] = e[8] + r[8] * n, t1;
            }, f.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3] && t1[4] === e[4] && t1[5] === e[5] && t1[6] === e[6] && t1[7] === e[7] && t1[8] === e[8];
            }, f.equals = function(t1, r) {
                var n = t1[0], i = t1[1], s = t1[2], a = t1[3], o = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], p = r[0], f = r[1], d = r[2], m = r[3], y = r[4], g = r[5], x = r[6], b = r[7], v = r[8];
                return Math.abs(n - p) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(p)) && Math.abs(i - f) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(f)) && Math.abs(s - d) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(d)) && Math.abs(a - m) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(m)) && Math.abs(o - y) <= e.EPSILON * Math.max(1, Math.abs(o), Math.abs(y)) && Math.abs(l - g) <= e.EPSILON * Math.max(1, Math.abs(l), Math.abs(g)) && Math.abs(u - x) <= e.EPSILON * Math.max(1, Math.abs(u), Math.abs(x)) && Math.abs(c - b) <= e.EPSILON * Math.max(1, Math.abs(c), Math.abs(b)) && Math.abs(h - v) <= e.EPSILON * Math.max(1, Math.abs(h), Math.abs(v));
            }, f.sub = f.mul = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var s = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = a ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(s, o, l) : s[o] = e[o];
                }
                return s.default = e, i && i.set(e, s), s;
            }(s());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = r[0], f = r[1], d = r[2], m = r[3], y = r[4], g = r[5], x = r[6], b = r[7], v = r[8];
                return t1[0] = p * n + f * a + d * u, t1[1] = p * i + f * o + d * c, t1[2] = p * s + f * l + d * h, t1[3] = m * n + y * a + g * u, t1[4] = m * i + y * o + g * c, t1[5] = m * s + y * l + g * h, t1[6] = x * n + b * a + v * u, t1[7] = x * i + b * o + v * c, t1[8] = x * s + b * l + v * h, t1;
            }
            function i(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1[3] = e[3] - r[3], t1[4] = e[4] - r[4], t1[5] = e[5] - r[5], t1[6] = e[6] - r[6], t1[7] = e[7] - r[7], t1[8] = e[8] - r[8], t1;
            }
            return f.mul = n, f.sub = i, f;
        }
        var m, y = {};
        function g() {
            if (m) return y;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            m = 1, Object.defineProperty(y, "__esModule", {
                value: !0
            }), y.create = function() {
                var t1 = new e.ARRAY_TYPE(16);
                return e.ARRAY_TYPE != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0), t1[0] = 1, t1[5] = 1, t1[10] = 1, t1[15] = 1, t1;
            }, y.clone = function(t1) {
                var r = new e.ARRAY_TYPE(16);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = t1[3], r[4] = t1[4], r[5] = t1[5], r[6] = t1[6], r[7] = t1[7], r[8] = t1[8], r[9] = t1[9], r[10] = t1[10], r[11] = t1[11], r[12] = t1[12], r[13] = t1[13], r[14] = t1[14], r[15] = t1[15], r;
            }, y.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[4] = e[4], t1[5] = e[5], t1[6] = e[6], t1[7] = e[7], t1[8] = e[8], t1[9] = e[9], t1[10] = e[10], t1[11] = e[11], t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15], t1;
            }, y.fromValues = function(t1, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y) {
                var g = new e.ARRAY_TYPE(16);
                return g[0] = t1, g[1] = r, g[2] = n, g[3] = i, g[4] = s, g[5] = a, g[6] = o, g[7] = l, g[8] = u, g[9] = c, g[10] = h, g[11] = p, g[12] = f, g[13] = d, g[14] = m, g[15] = y, g;
            }, y.set = function(t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = i, t1[4] = s, t1[5] = a, t1[6] = o, t1[7] = l, t1[8] = u, t1[9] = c, t1[10] = h, t1[11] = p, t1[12] = f, t1[13] = d, t1[14] = m, t1[15] = y, t1;
            }, y.identity = n, y.transpose = function(t1, e) {
                if (t1 === e) {
                    var r = e[1], n = e[2], i = e[3], s = e[6], a = e[7], o = e[11];
                    t1[1] = e[4], t1[2] = e[8], t1[3] = e[12], t1[4] = r, t1[6] = e[9], t1[7] = e[13], t1[8] = n, t1[9] = s, t1[11] = e[14], t1[12] = i, t1[13] = a, t1[14] = o;
                } else t1[0] = e[0], t1[1] = e[4], t1[2] = e[8], t1[3] = e[12], t1[4] = e[1], t1[5] = e[5], t1[6] = e[9], t1[7] = e[13], t1[8] = e[2], t1[9] = e[6], t1[10] = e[10], t1[11] = e[14], t1[12] = e[3], t1[13] = e[7], t1[14] = e[11], t1[15] = e[15];
                return t1;
            }, y.invert = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], l = e[6], u = e[7], c = e[8], h = e[9], p = e[10], f = e[11], d = e[12], m = e[13], y = e[14], g = e[15], x = r * o - n * a, b = r * l - i * a, v = r * u - s * a, w = n * l - i * o, _ = n * u - s * o, M = i * u - s * l, A = c * m - h * d, S = c * y - p * d, I = c * g - f * d, P = h * y - p * m, z = h * g - f * m, k = p * g - f * y, T = x * k - b * z + v * P + w * I - _ * S + M * A;
                return T ? (t1[0] = (o * k - l * z + u * P) * (T = 1 / T), t1[1] = (i * z - n * k - s * P) * T, t1[2] = (m * M - y * _ + g * w) * T, t1[3] = (p * _ - h * M - f * w) * T, t1[4] = (l * I - a * k - u * S) * T, t1[5] = (r * k - i * I + s * S) * T, t1[6] = (y * v - d * M - g * b) * T, t1[7] = (c * M - p * v + f * b) * T, t1[8] = (a * z - o * I + u * A) * T, t1[9] = (n * I - r * z - s * A) * T, t1[10] = (d * _ - m * v + g * x) * T, t1[11] = (h * v - c * _ - f * x) * T, t1[12] = (o * S - a * P - l * A) * T, t1[13] = (r * P - n * S + i * A) * T, t1[14] = (m * b - d * w - y * x) * T, t1[15] = (c * w - h * b + p * x) * T, t1) : null;
            }, y.adjoint = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], l = e[6], u = e[7], c = e[8], h = e[9], p = e[10], f = e[11], d = e[12], m = e[13], y = e[14], g = e[15];
                return t1[0] = o * (p * g - f * y) - h * (l * g - u * y) + m * (l * f - u * p), t1[1] = -(n * (p * g - f * y) - h * (i * g - s * y) + m * (i * f - s * p)), t1[2] = n * (l * g - u * y) - o * (i * g - s * y) + m * (i * u - s * l), t1[3] = -(n * (l * f - u * p) - o * (i * f - s * p) + h * (i * u - s * l)), t1[4] = -(a * (p * g - f * y) - c * (l * g - u * y) + d * (l * f - u * p)), t1[5] = r * (p * g - f * y) - c * (i * g - s * y) + d * (i * f - s * p), t1[6] = -(r * (l * g - u * y) - a * (i * g - s * y) + d * (i * u - s * l)), t1[7] = r * (l * f - u * p) - a * (i * f - s * p) + c * (i * u - s * l), t1[8] = a * (h * g - f * m) - c * (o * g - u * m) + d * (o * f - u * h), t1[9] = -(r * (h * g - f * m) - c * (n * g - s * m) + d * (n * f - s * h)), t1[10] = r * (o * g - u * m) - a * (n * g - s * m) + d * (n * u - s * o), t1[11] = -(r * (o * f - u * h) - a * (n * f - s * h) + c * (n * u - s * o)), t1[12] = -(a * (h * y - p * m) - c * (o * y - l * m) + d * (o * p - l * h)), t1[13] = r * (h * y - p * m) - c * (n * y - i * m) + d * (n * p - i * h), t1[14] = -(r * (o * y - l * m) - a * (n * y - i * m) + d * (n * l - i * o)), t1[15] = r * (o * p - l * h) - a * (n * p - i * h) + c * (n * l - i * o), t1;
            }, y.determinant = function(t1) {
                var e = t1[0], r = t1[1], n = t1[2], i = t1[3], s = t1[4], a = t1[5], o = t1[6], l = t1[7], u = t1[8], c = t1[9], h = t1[10], p = t1[11], f = t1[12], d = t1[13], m = t1[14], y = t1[15];
                return (e * a - r * s) * (h * y - p * m) - (e * o - n * s) * (c * y - p * d) + (e * l - i * s) * (c * m - h * d) + (r * o - n * a) * (u * y - p * f) - (r * l - i * a) * (u * m - h * f) + (n * l - i * o) * (u * d - c * f);
            }, y.multiply = i, y.translate = function(t1, e, r) {
                var n, i, s, a, o, l, u, c, h, p, f, d, m = r[0], y = r[1], g = r[2];
                return e === t1 ? (t1[12] = e[0] * m + e[4] * y + e[8] * g + e[12], t1[13] = e[1] * m + e[5] * y + e[9] * g + e[13], t1[14] = e[2] * m + e[6] * y + e[10] * g + e[14], t1[15] = e[3] * m + e[7] * y + e[11] * g + e[15]) : (i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], t1[0] = n = e[0], t1[1] = i, t1[2] = s, t1[3] = a, t1[4] = o, t1[5] = l, t1[6] = u, t1[7] = c, t1[8] = h, t1[9] = p, t1[10] = f, t1[11] = d, t1[12] = n * m + o * y + h * g + e[12], t1[13] = i * m + l * y + p * g + e[13], t1[14] = s * m + u * y + f * g + e[14], t1[15] = a * m + c * y + d * g + e[15]), t1;
            }, y.scale = function(t1, e, r) {
                var n = r[0], i = r[1], s = r[2];
                return t1[0] = e[0] * n, t1[1] = e[1] * n, t1[2] = e[2] * n, t1[3] = e[3] * n, t1[4] = e[4] * i, t1[5] = e[5] * i, t1[6] = e[6] * i, t1[7] = e[7] * i, t1[8] = e[8] * s, t1[9] = e[9] * s, t1[10] = e[10] * s, t1[11] = e[11] * s, t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15], t1;
            }, y.rotate = function(t1, r, n, i) {
                var s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v, w, _, M, A, S, I, P, z, k = i[0], T = i[1], E = i[2], B = Math.hypot(k, T, E);
                return B < e.EPSILON ? null : (k *= B = 1 / B, T *= B, E *= B, s = Math.sin(n), a = Math.cos(n), u = r[1], c = r[2], h = r[3], f = r[5], d = r[6], m = r[7], g = r[9], x = r[10], b = r[11], v = k * k * (o = 1 - a) + a, M = k * T * o - E * s, A = T * T * o + a, S = E * T * o + k * s, I = k * E * o + T * s, P = T * E * o - k * s, z = E * E * o + a, t1[0] = (l = r[0]) * v + (p = r[4]) * (w = T * k * o + E * s) + (y = r[8]) * (_ = E * k * o - T * s), t1[1] = u * v + f * w + g * _, t1[2] = c * v + d * w + x * _, t1[3] = h * v + m * w + b * _, t1[4] = l * M + p * A + y * S, t1[5] = u * M + f * A + g * S, t1[6] = c * M + d * A + x * S, t1[7] = h * M + m * A + b * S, t1[8] = l * I + p * P + y * z, t1[9] = u * I + f * P + g * z, t1[10] = c * I + d * P + x * z, t1[11] = h * I + m * P + b * z, r !== t1 && (t1[12] = r[12], t1[13] = r[13], t1[14] = r[14], t1[15] = r[15]), t1);
            }, y.rotateX = function(t1, e, r) {
                var n = Math.sin(r), i = Math.cos(r), s = e[4], a = e[5], o = e[6], l = e[7], u = e[8], c = e[9], h = e[10], p = e[11];
                return e !== t1 && (t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15]), t1[4] = s * i + u * n, t1[5] = a * i + c * n, t1[6] = o * i + h * n, t1[7] = l * i + p * n, t1[8] = u * i - s * n, t1[9] = c * i - a * n, t1[10] = h * i - o * n, t1[11] = p * i - l * n, t1;
            }, y.rotateY = function(t1, e, r) {
                var n = Math.sin(r), i = Math.cos(r), s = e[0], a = e[1], o = e[2], l = e[3], u = e[8], c = e[9], h = e[10], p = e[11];
                return e !== t1 && (t1[4] = e[4], t1[5] = e[5], t1[6] = e[6], t1[7] = e[7], t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15]), t1[0] = s * i - u * n, t1[1] = a * i - c * n, t1[2] = o * i - h * n, t1[3] = l * i - p * n, t1[8] = s * n + u * i, t1[9] = a * n + c * i, t1[10] = o * n + h * i, t1[11] = l * n + p * i, t1;
            }, y.rotateZ = function(t1, e, r) {
                var n = Math.sin(r), i = Math.cos(r), s = e[0], a = e[1], o = e[2], l = e[3], u = e[4], c = e[5], h = e[6], p = e[7];
                return e !== t1 && (t1[8] = e[8], t1[9] = e[9], t1[10] = e[10], t1[11] = e[11], t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15]), t1[0] = s * i + u * n, t1[1] = a * i + c * n, t1[2] = o * i + h * n, t1[3] = l * i + p * n, t1[4] = u * i - s * n, t1[5] = c * i - a * n, t1[6] = h * i - o * n, t1[7] = p * i - l * n, t1;
            }, y.fromTranslation = function(t1, e) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = e[0], t1[13] = e[1], t1[14] = e[2], t1[15] = 1, t1;
            }, y.fromScaling = function(t1, e) {
                return t1[0] = e[0], t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = e[1], t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = e[2], t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
            }, y.fromRotation = function(t1, r, n) {
                var i, s, a, o = n[0], l = n[1], u = n[2], c = Math.hypot(o, l, u);
                return c < e.EPSILON ? null : (o *= c = 1 / c, l *= c, u *= c, i = Math.sin(r), s = Math.cos(r), t1[0] = o * o * (a = 1 - s) + s, t1[1] = l * o * a + u * i, t1[2] = u * o * a - l * i, t1[3] = 0, t1[4] = o * l * a - u * i, t1[5] = l * l * a + s, t1[6] = u * l * a + o * i, t1[7] = 0, t1[8] = o * u * a + l * i, t1[9] = l * u * a - o * i, t1[10] = u * u * a + s, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1);
            }, y.fromXRotation = function(t1, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = n, t1[6] = r, t1[7] = 0, t1[8] = 0, t1[9] = -r, t1[10] = n, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
            }, y.fromYRotation = function(t1, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t1[0] = n, t1[1] = 0, t1[2] = -r, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = r, t1[9] = 0, t1[10] = n, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
            }, y.fromZRotation = function(t1, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = 0, t1[4] = -r, t1[5] = n, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
            }, y.fromRotationTranslation = a, y.fromQuat2 = function(t1, r) {
                var n = new e.ARRAY_TYPE(3), i = -r[0], s = -r[1], o = -r[2], l = r[3], u = r[4], c = r[5], h = r[6], p = r[7], f = i * i + s * s + o * o + l * l;
                return f > 0 ? (n[0] = 2 * (u * l + p * i + c * o - h * s) / f, n[1] = 2 * (c * l + p * s + h * i - u * o) / f, n[2] = 2 * (h * l + p * o + u * s - c * i) / f) : (n[0] = 2 * (u * l + p * i + c * o - h * s), n[1] = 2 * (c * l + p * s + h * i - u * o), n[2] = 2 * (h * l + p * o + u * s - c * i)), a(t1, r, n), t1;
            }, y.getTranslation = function(t1, e) {
                return t1[0] = e[12], t1[1] = e[13], t1[2] = e[14], t1;
            }, y.getScaling = o, y.getRotation = function(t1, r) {
                var n = new e.ARRAY_TYPE(3);
                o(n, r);
                var i = 1 / n[0], s = 1 / n[1], a = 1 / n[2], l = r[0] * i, u = r[1] * s, c = r[2] * a, h = r[4] * i, p = r[5] * s, f = r[6] * a, d = r[8] * i, m = r[9] * s, y = r[10] * a, g = l + p + y, x = 0;
                return g > 0 ? (x = 2 * Math.sqrt(g + 1), t1[3] = .25 * x, t1[0] = (f - m) / x, t1[1] = (d - c) / x, t1[2] = (u - h) / x) : l > p && l > y ? (x = 2 * Math.sqrt(1 + l - p - y), t1[3] = (f - m) / x, t1[0] = .25 * x, t1[1] = (u + h) / x, t1[2] = (d + c) / x) : p > y ? (x = 2 * Math.sqrt(1 + p - l - y), t1[3] = (d - c) / x, t1[0] = (u + h) / x, t1[1] = .25 * x, t1[2] = (f + m) / x) : (x = 2 * Math.sqrt(1 + y - l - p), t1[3] = (u - h) / x, t1[0] = (d + c) / x, t1[1] = (f + m) / x, t1[2] = .25 * x), t1;
            }, y.fromRotationTranslationScale = function(t1, e, r, n) {
                var i = e[0], s = e[1], a = e[2], o = e[3], l = i + i, u = s + s, c = a + a, h = i * l, p = i * u, f = i * c, d = s * u, m = s * c, y = a * c, g = o * l, x = o * u, b = o * c, v = n[0], w = n[1], _ = n[2];
                return t1[0] = (1 - (d + y)) * v, t1[1] = (p + b) * v, t1[2] = (f - x) * v, t1[3] = 0, t1[4] = (p - b) * w, t1[5] = (1 - (h + y)) * w, t1[6] = (m + g) * w, t1[7] = 0, t1[8] = (f + x) * _, t1[9] = (m - g) * _, t1[10] = (1 - (h + d)) * _, t1[11] = 0, t1[12] = r[0], t1[13] = r[1], t1[14] = r[2], t1[15] = 1, t1;
            }, y.fromRotationTranslationScaleOrigin = function(t1, e, r, n, i) {
                var s = e[0], a = e[1], o = e[2], l = e[3], u = s + s, c = a + a, h = o + o, p = s * u, f = s * c, d = s * h, m = a * c, y = a * h, g = o * h, x = l * u, b = l * c, v = l * h, w = n[0], _ = n[1], M = n[2], A = i[0], S = i[1], I = i[2], P = (1 - (m + g)) * w, z = (f + v) * w, k = (d - b) * w, T = (f - v) * _, E = (1 - (p + g)) * _, B = (y + x) * _, V = (d + b) * M, C = (y - x) * M, R = (1 - (p + m)) * M;
                return t1[0] = P, t1[1] = z, t1[2] = k, t1[3] = 0, t1[4] = T, t1[5] = E, t1[6] = B, t1[7] = 0, t1[8] = V, t1[9] = C, t1[10] = R, t1[11] = 0, t1[12] = r[0] + A - (P * A + T * S + V * I), t1[13] = r[1] + S - (z * A + E * S + C * I), t1[14] = r[2] + I - (k * A + B * S + R * I), t1[15] = 1, t1;
            }, y.fromQuat = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = r + r, o = n + n, l = i + i, u = r * a, c = n * a, h = n * o, p = i * a, f = i * o, d = i * l, m = s * a, y = s * o, g = s * l;
                return t1[0] = 1 - h - d, t1[1] = c + g, t1[2] = p - y, t1[3] = 0, t1[4] = c - g, t1[5] = 1 - u - d, t1[6] = f + m, t1[7] = 0, t1[8] = p + y, t1[9] = f - m, t1[10] = 1 - u - h, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
            }, y.frustum = function(t1, e, r, n, i, s, a) {
                var o = 1 / (r - e), l = 1 / (i - n), u = 1 / (s - a);
                return t1[0] = 2 * s * o, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 2 * s * l, t1[6] = 0, t1[7] = 0, t1[8] = (r + e) * o, t1[9] = (i + n) * l, t1[10] = (a + s) * u, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[14] = a * s * 2 * u, t1[15] = 0, t1;
            }, y.perspectiveNO = l, y.perspectiveZO = function(t1, e, r, n, i) {
                var s, a = 1 / Math.tan(e / 2);
                return t1[0] = a / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = a, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (t1[10] = i * (s = 1 / (n - i)), t1[14] = i * n * s) : (t1[10] = -1, t1[14] = -n), t1;
            }, y.perspectiveFromFieldOfView = function(t1, e, r, n) {
                var i = Math.tan(e.upDegrees * Math.PI / 180), s = Math.tan(e.downDegrees * Math.PI / 180), a = Math.tan(e.leftDegrees * Math.PI / 180), o = Math.tan(e.rightDegrees * Math.PI / 180), l = 2 / (a + o), u = 2 / (i + s);
                return t1[0] = l, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = u, t1[6] = 0, t1[7] = 0, t1[8] = -(a - o) * l * .5, t1[9] = (i - s) * u * .5, t1[10] = n / (r - n), t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[14] = n * r / (r - n), t1[15] = 0, t1;
            }, y.orthoNO = u, y.orthoZO = function(t1, e, r, n, i, s, a) {
                var o = 1 / (e - r), l = 1 / (n - i), u = 1 / (s - a);
                return t1[0] = -2 * o, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = u, t1[11] = 0, t1[12] = (e + r) * o, t1[13] = (i + n) * l, t1[14] = s * u, t1[15] = 1, t1;
            }, y.lookAt = function(t1, r, i, s) {
                var a, o, l, u, c, h, p, f, d, m, y = r[0], g = r[1], x = r[2], b = s[0], v = s[1], w = s[2], _ = i[0], M = i[1], A = i[2];
                return Math.abs(y - _) < e.EPSILON && Math.abs(g - M) < e.EPSILON && Math.abs(x - A) < e.EPSILON ? n(t1) : (p = y - _, f = g - M, d = x - A, a = v * (d *= m = 1 / Math.hypot(p, f, d)) - w * (f *= m), o = w * (p *= m) - b * d, l = b * f - v * p, (m = Math.hypot(a, o, l)) ? (a *= m = 1 / m, o *= m, l *= m) : (a = 0, o = 0, l = 0), u = f * l - d * o, c = d * a - p * l, h = p * o - f * a, (m = Math.hypot(u, c, h)) ? (u *= m = 1 / m, c *= m, h *= m) : (u = 0, c = 0, h = 0), t1[0] = a, t1[1] = u, t1[2] = p, t1[3] = 0, t1[4] = o, t1[5] = c, t1[6] = f, t1[7] = 0, t1[8] = l, t1[9] = h, t1[10] = d, t1[11] = 0, t1[12] = -(a * y + o * g + l * x), t1[13] = -(u * y + c * g + h * x), t1[14] = -(p * y + f * g + d * x), t1[15] = 1, t1);
            }, y.targetTo = function(t1, e, r, n) {
                var i = e[0], s = e[1], a = e[2], o = n[0], l = n[1], u = n[2], c = i - r[0], h = s - r[1], p = a - r[2], f = c * c + h * h + p * p;
                f > 0 && (c *= f = 1 / Math.sqrt(f), h *= f, p *= f);
                var d = l * p - u * h, m = u * c - o * p, y = o * h - l * c;
                return (f = d * d + m * m + y * y) > 0 && (d *= f = 1 / Math.sqrt(f), m *= f, y *= f), t1[0] = d, t1[1] = m, t1[2] = y, t1[3] = 0, t1[4] = h * y - p * m, t1[5] = p * d - c * y, t1[6] = c * m - h * d, t1[7] = 0, t1[8] = c, t1[9] = h, t1[10] = p, t1[11] = 0, t1[12] = i, t1[13] = s, t1[14] = a, t1[15] = 1, t1;
            }, y.str = function(t1) {
                return "mat4(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ", " + t1[4] + ", " + t1[5] + ", " + t1[6] + ", " + t1[7] + ", " + t1[8] + ", " + t1[9] + ", " + t1[10] + ", " + t1[11] + ", " + t1[12] + ", " + t1[13] + ", " + t1[14] + ", " + t1[15] + ")";
            }, y.frob = function(t1) {
                return Math.hypot(t1[0], t1[1], t1[2], t1[3], t1[4], t1[5], t1[6], t1[7], t1[8], t1[9], t1[10], t1[11], t1[12], t1[13], t1[14], t1[15]);
            }, y.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1[3] = e[3] + r[3], t1[4] = e[4] + r[4], t1[5] = e[5] + r[5], t1[6] = e[6] + r[6], t1[7] = e[7] + r[7], t1[8] = e[8] + r[8], t1[9] = e[9] + r[9], t1[10] = e[10] + r[10], t1[11] = e[11] + r[11], t1[12] = e[12] + r[12], t1[13] = e[13] + r[13], t1[14] = e[14] + r[14], t1[15] = e[15] + r[15], t1;
            }, y.subtract = c, y.multiplyScalar = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1[4] = e[4] * r, t1[5] = e[5] * r, t1[6] = e[6] * r, t1[7] = e[7] * r, t1[8] = e[8] * r, t1[9] = e[9] * r, t1[10] = e[10] * r, t1[11] = e[11] * r, t1[12] = e[12] * r, t1[13] = e[13] * r, t1[14] = e[14] * r, t1[15] = e[15] * r, t1;
            }, y.multiplyScalarAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1[3] = e[3] + r[3] * n, t1[4] = e[4] + r[4] * n, t1[5] = e[5] + r[5] * n, t1[6] = e[6] + r[6] * n, t1[7] = e[7] + r[7] * n, t1[8] = e[8] + r[8] * n, t1[9] = e[9] + r[9] * n, t1[10] = e[10] + r[10] * n, t1[11] = e[11] + r[11] * n, t1[12] = e[12] + r[12] * n, t1[13] = e[13] + r[13] * n, t1[14] = e[14] + r[14] * n, t1[15] = e[15] + r[15] * n, t1;
            }, y.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3] && t1[4] === e[4] && t1[5] === e[5] && t1[6] === e[6] && t1[7] === e[7] && t1[8] === e[8] && t1[9] === e[9] && t1[10] === e[10] && t1[11] === e[11] && t1[12] === e[12] && t1[13] === e[13] && t1[14] === e[14] && t1[15] === e[15];
            }, y.equals = function(t1, r) {
                var n = t1[0], i = t1[1], s = t1[2], a = t1[3], o = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], p = t1[9], f = t1[10], d = t1[11], m = t1[12], y = t1[13], g = t1[14], x = t1[15], b = r[0], v = r[1], w = r[2], _ = r[3], M = r[4], A = r[5], S = r[6], I = r[7], P = r[8], z = r[9], k = r[10], T = r[11], E = r[12], B = r[13], V = r[14], C = r[15];
                return Math.abs(n - b) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(b)) && Math.abs(i - v) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(v)) && Math.abs(s - w) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(w)) && Math.abs(a - _) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(_)) && Math.abs(o - M) <= e.EPSILON * Math.max(1, Math.abs(o), Math.abs(M)) && Math.abs(l - A) <= e.EPSILON * Math.max(1, Math.abs(l), Math.abs(A)) && Math.abs(u - S) <= e.EPSILON * Math.max(1, Math.abs(u), Math.abs(S)) && Math.abs(c - I) <= e.EPSILON * Math.max(1, Math.abs(c), Math.abs(I)) && Math.abs(h - P) <= e.EPSILON * Math.max(1, Math.abs(h), Math.abs(P)) && Math.abs(p - z) <= e.EPSILON * Math.max(1, Math.abs(p), Math.abs(z)) && Math.abs(f - k) <= e.EPSILON * Math.max(1, Math.abs(f), Math.abs(k)) && Math.abs(d - T) <= e.EPSILON * Math.max(1, Math.abs(d), Math.abs(T)) && Math.abs(m - E) <= e.EPSILON * Math.max(1, Math.abs(m), Math.abs(E)) && Math.abs(y - B) <= e.EPSILON * Math.max(1, Math.abs(y), Math.abs(B)) && Math.abs(g - V) <= e.EPSILON * Math.max(1, Math.abs(g), Math.abs(V)) && Math.abs(x - C) <= e.EPSILON * Math.max(1, Math.abs(x), Math.abs(C));
            }, y.sub = y.mul = y.ortho = y.perspective = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var s = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = a ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(s, o, l) : s[o] = e[o];
                }
                return s.default = e, i && i.set(e, s), s;
            }(s());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n(t1) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
            }
            function i(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], m = e[12], y = e[13], g = e[14], x = e[15], b = r[0], v = r[1], w = r[2], _ = r[3];
                return t1[0] = b * n + v * o + w * h + _ * m, t1[1] = b * i + v * l + w * p + _ * y, t1[2] = b * s + v * u + w * f + _ * g, t1[3] = b * a + v * c + w * d + _ * x, t1[4] = (b = r[4]) * n + (v = r[5]) * o + (w = r[6]) * h + (_ = r[7]) * m, t1[5] = b * i + v * l + w * p + _ * y, t1[6] = b * s + v * u + w * f + _ * g, t1[7] = b * a + v * c + w * d + _ * x, t1[8] = (b = r[8]) * n + (v = r[9]) * o + (w = r[10]) * h + (_ = r[11]) * m, t1[9] = b * i + v * l + w * p + _ * y, t1[10] = b * s + v * u + w * f + _ * g, t1[11] = b * a + v * c + w * d + _ * x, t1[12] = (b = r[12]) * n + (v = r[13]) * o + (w = r[14]) * h + (_ = r[15]) * m, t1[13] = b * i + v * l + w * p + _ * y, t1[14] = b * s + v * u + w * f + _ * g, t1[15] = b * a + v * c + w * d + _ * x, t1;
            }
            function a(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = n + n, l = i + i, u = s + s, c = n * o, h = n * l, p = n * u, f = i * l, d = i * u, m = s * u, y = a * o, g = a * l, x = a * u;
                return t1[0] = 1 - (f + m), t1[1] = h + x, t1[2] = p - g, t1[3] = 0, t1[4] = h - x, t1[5] = 1 - (c + m), t1[6] = d + y, t1[7] = 0, t1[8] = p + g, t1[9] = d - y, t1[10] = 1 - (c + f), t1[11] = 0, t1[12] = r[0], t1[13] = r[1], t1[14] = r[2], t1[15] = 1, t1;
            }
            function o(t1, e) {
                var r = e[4], n = e[5], i = e[6], s = e[8], a = e[9], o = e[10];
                return t1[0] = Math.hypot(e[0], e[1], e[2]), t1[1] = Math.hypot(r, n, i), t1[2] = Math.hypot(s, a, o), t1;
            }
            function l(t1, e, r, n, i) {
                var s, a = 1 / Math.tan(e / 2);
                return t1[0] = a / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = a, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (t1[10] = (i + n) * (s = 1 / (n - i)), t1[14] = 2 * i * n * s) : (t1[10] = -1, t1[14] = -2 * n), t1;
            }
            function u(t1, e, r, n, i, s, a) {
                var o = 1 / (e - r), l = 1 / (n - i), u = 1 / (s - a);
                return t1[0] = -2 * o, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * u, t1[11] = 0, t1[12] = (e + r) * o, t1[13] = (i + n) * l, t1[14] = (a + s) * u, t1[15] = 1, t1;
            }
            function c(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1[3] = e[3] - r[3], t1[4] = e[4] - r[4], t1[5] = e[5] - r[5], t1[6] = e[6] - r[6], t1[7] = e[7] - r[7], t1[8] = e[8] - r[8], t1[9] = e[9] - r[9], t1[10] = e[10] - r[10], t1[11] = e[11] - r[11], t1[12] = e[12] - r[12], t1[13] = e[13] - r[13], t1[14] = e[14] - r[14], t1[15] = e[15] - r[15], t1;
            }
            return y.perspective = l, y.ortho = u, y.mul = i, y.sub = c, y;
        }
        var x, b = {}, v = {};
        function w() {
            if (x) return v;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            x = 1, Object.defineProperty(v, "__esModule", {
                value: !0
            }), v.create = n, v.clone = function(t1) {
                var r = new e.ARRAY_TYPE(3);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r;
            }, v.length = i, v.fromValues = function(t1, r, n) {
                var i = new e.ARRAY_TYPE(3);
                return i[0] = t1, i[1] = r, i[2] = n, i;
            }, v.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1;
            }, v.set = function(t1, e, r, n) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1;
            }, v.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1;
            }, v.subtract = a, v.multiply = o, v.divide = l, v.ceil = function(t1, e) {
                return t1[0] = Math.ceil(e[0]), t1[1] = Math.ceil(e[1]), t1[2] = Math.ceil(e[2]), t1;
            }, v.floor = function(t1, e) {
                return t1[0] = Math.floor(e[0]), t1[1] = Math.floor(e[1]), t1[2] = Math.floor(e[2]), t1;
            }, v.min = function(t1, e, r) {
                return t1[0] = Math.min(e[0], r[0]), t1[1] = Math.min(e[1], r[1]), t1[2] = Math.min(e[2], r[2]), t1;
            }, v.max = function(t1, e, r) {
                return t1[0] = Math.max(e[0], r[0]), t1[1] = Math.max(e[1], r[1]), t1[2] = Math.max(e[2], r[2]), t1;
            }, v.round = function(t1, e) {
                return t1[0] = Math.round(e[0]), t1[1] = Math.round(e[1]), t1[2] = Math.round(e[2]), t1;
            }, v.scale = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1;
            }, v.scaleAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1;
            }, v.distance = u, v.squaredDistance = c, v.squaredLength = h, v.negate = function(t1, e) {
                return t1[0] = -e[0], t1[1] = -e[1], t1[2] = -e[2], t1;
            }, v.inverse = function(t1, e) {
                return t1[0] = 1 / e[0], t1[1] = 1 / e[1], t1[2] = 1 / e[2], t1;
            }, v.normalize = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = r * r + n * n + i * i;
                return s > 0 && (s = 1 / Math.sqrt(s)), t1[0] = e[0] * s, t1[1] = e[1] * s, t1[2] = e[2] * s, t1;
            }, v.dot = p, v.cross = function(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = r[0], o = r[1], l = r[2];
                return t1[0] = i * l - s * o, t1[1] = s * a - n * l, t1[2] = n * o - i * a, t1;
            }, v.lerp = function(t1, e, r, n) {
                var i = e[0], s = e[1], a = e[2];
                return t1[0] = i + n * (r[0] - i), t1[1] = s + n * (r[1] - s), t1[2] = a + n * (r[2] - a), t1;
            }, v.hermite = function(t1, e, r, n, i, s) {
                var a = s * s, o = a * (2 * s - 3) + 1, l = a * (s - 2) + s, u = a * (s - 1), c = a * (3 - 2 * s);
                return t1[0] = e[0] * o + r[0] * l + n[0] * u + i[0] * c, t1[1] = e[1] * o + r[1] * l + n[1] * u + i[1] * c, t1[2] = e[2] * o + r[2] * l + n[2] * u + i[2] * c, t1;
            }, v.bezier = function(t1, e, r, n, i, s) {
                var a = 1 - s, o = a * a, l = s * s, u = o * a, c = 3 * s * o, h = 3 * l * a, p = l * s;
                return t1[0] = e[0] * u + r[0] * c + n[0] * h + i[0] * p, t1[1] = e[1] * u + r[1] * c + n[1] * h + i[1] * p, t1[2] = e[2] * u + r[2] * c + n[2] * h + i[2] * p, t1;
            }, v.random = function(t1, r) {
                r = r || 1;
                var n = 2 * e.RANDOM() * Math.PI, i = 2 * e.RANDOM() - 1, s = Math.sqrt(1 - i * i) * r;
                return t1[0] = Math.cos(n) * s, t1[1] = Math.sin(n) * s, t1[2] = i * r, t1;
            }, v.transformMat4 = function(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = r[3] * n + r[7] * i + r[11] * s + r[15];
                return t1[0] = (r[0] * n + r[4] * i + r[8] * s + r[12]) / (a = a || 1), t1[1] = (r[1] * n + r[5] * i + r[9] * s + r[13]) / a, t1[2] = (r[2] * n + r[6] * i + r[10] * s + r[14]) / a, t1;
            }, v.transformMat3 = function(t1, e, r) {
                var n = e[0], i = e[1], s = e[2];
                return t1[0] = n * r[0] + i * r[3] + s * r[6], t1[1] = n * r[1] + i * r[4] + s * r[7], t1[2] = n * r[2] + i * r[5] + s * r[8], t1;
            }, v.transformQuat = function(t1, e, r) {
                var n = r[0], i = r[1], s = r[2], a = e[0], o = e[1], l = e[2], u = i * l - s * o, c = s * a - n * l, h = n * o - i * a, p = i * h - s * c, f = s * u - n * h, d = n * c - i * u, m = 2 * r[3];
                return c *= m, h *= m, f *= 2, d *= 2, t1[0] = a + (u *= m) + (p *= 2), t1[1] = o + c + f, t1[2] = l + h + d, t1;
            }, v.rotateX = function(t1, e, r, n) {
                var i = [], s = [];
                return i[0] = e[0] - r[0], i[1] = e[1] - r[1], i[2] = e[2] - r[2], s[0] = i[0], s[1] = i[1] * Math.cos(n) - i[2] * Math.sin(n), s[2] = i[1] * Math.sin(n) + i[2] * Math.cos(n), t1[0] = s[0] + r[0], t1[1] = s[1] + r[1], t1[2] = s[2] + r[2], t1;
            }, v.rotateY = function(t1, e, r, n) {
                var i = [], s = [];
                return i[0] = e[0] - r[0], i[1] = e[1] - r[1], i[2] = e[2] - r[2], s[0] = i[2] * Math.sin(n) + i[0] * Math.cos(n), s[1] = i[1], s[2] = i[2] * Math.cos(n) - i[0] * Math.sin(n), t1[0] = s[0] + r[0], t1[1] = s[1] + r[1], t1[2] = s[2] + r[2], t1;
            }, v.rotateZ = function(t1, e, r, n) {
                var i = [], s = [];
                return i[0] = e[0] - r[0], i[1] = e[1] - r[1], i[2] = e[2] - r[2], s[0] = i[0] * Math.cos(n) - i[1] * Math.sin(n), s[1] = i[0] * Math.sin(n) + i[1] * Math.cos(n), s[2] = i[2], t1[0] = s[0] + r[0], t1[1] = s[1] + r[1], t1[2] = s[2] + r[2], t1;
            }, v.angle = function(t1, e) {
                var r = t1[0], n = t1[1], i = t1[2], s = e[0], a = e[1], o = e[2], l = Math.sqrt(r * r + n * n + i * i) * Math.sqrt(s * s + a * a + o * o), u = l && p(t1, e) / l;
                return Math.acos(Math.min(Math.max(u, -1), 1));
            }, v.zero = function(t1) {
                return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1;
            }, v.str = function(t1) {
                return "vec3(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ")";
            }, v.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2];
            }, v.equals = function(t1, r) {
                var n = t1[0], i = t1[1], s = t1[2], a = r[0], o = r[1], l = r[2];
                return Math.abs(n - a) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(a)) && Math.abs(i - o) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(o)) && Math.abs(s - l) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(l));
            }, v.forEach = v.sqrLen = v.len = v.sqrDist = v.dist = v.div = v.mul = v.sub = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var s = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = a ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(s, o, l) : s[o] = e[o];
                }
                return s.default = e, i && i.set(e, s), s;
            }(s());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n() {
                var t1 = new e.ARRAY_TYPE(3);
                return e.ARRAY_TYPE != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0), t1;
            }
            function i(t1) {
                return Math.hypot(t1[0], t1[1], t1[2]);
            }
            function a(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1;
            }
            function o(t1, e, r) {
                return t1[0] = e[0] * r[0], t1[1] = e[1] * r[1], t1[2] = e[2] * r[2], t1;
            }
            function l(t1, e, r) {
                return t1[0] = e[0] / r[0], t1[1] = e[1] / r[1], t1[2] = e[2] / r[2], t1;
            }
            function u(t1, e) {
                return Math.hypot(e[0] - t1[0], e[1] - t1[1], e[2] - t1[2]);
            }
            function c(t1, e) {
                var r = e[0] - t1[0], n = e[1] - t1[1], i = e[2] - t1[2];
                return r * r + n * n + i * i;
            }
            function h(t1) {
                var e = t1[0], r = t1[1], n = t1[2];
                return e * e + r * r + n * n;
            }
            function p(t1, e) {
                return t1[0] * e[0] + t1[1] * e[1] + t1[2] * e[2];
            }
            v.sub = a, v.mul = o, v.div = l, v.dist = u, v.sqrDist = c, v.len = i, v.sqrLen = h;
            var f, d = (f = n(), function(t1, e, r, n, i, s) {
                var a, o;
                for(e || (e = 3), r || (r = 0), o = n ? Math.min(n * e + r, t1.length) : t1.length, a = r; a < o; a += e)f[0] = t1[a], f[1] = t1[a + 1], f[2] = t1[a + 2], i(f, f, s), t1[a] = f[0], t1[a + 1] = f[1], t1[a + 2] = f[2];
                return t1;
            });
            return v.forEach = d, v;
        }
        var _, M, A = {};
        function S() {
            if (_) return A;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            _ = 1, Object.defineProperty(A, "__esModule", {
                value: !0
            }), A.create = n, A.clone = function(t1) {
                var r = new e.ARRAY_TYPE(4);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = t1[3], r;
            }, A.fromValues = function(t1, r, n, i) {
                var s = new e.ARRAY_TYPE(4);
                return s[0] = t1, s[1] = r, s[2] = n, s[3] = i, s;
            }, A.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1;
            }, A.set = function(t1, e, r, n, i) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = i, t1;
            }, A.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1[3] = e[3] + r[3], t1;
            }, A.subtract = i, A.multiply = a, A.divide = o, A.ceil = function(t1, e) {
                return t1[0] = Math.ceil(e[0]), t1[1] = Math.ceil(e[1]), t1[2] = Math.ceil(e[2]), t1[3] = Math.ceil(e[3]), t1;
            }, A.floor = function(t1, e) {
                return t1[0] = Math.floor(e[0]), t1[1] = Math.floor(e[1]), t1[2] = Math.floor(e[2]), t1[3] = Math.floor(e[3]), t1;
            }, A.min = function(t1, e, r) {
                return t1[0] = Math.min(e[0], r[0]), t1[1] = Math.min(e[1], r[1]), t1[2] = Math.min(e[2], r[2]), t1[3] = Math.min(e[3], r[3]), t1;
            }, A.max = function(t1, e, r) {
                return t1[0] = Math.max(e[0], r[0]), t1[1] = Math.max(e[1], r[1]), t1[2] = Math.max(e[2], r[2]), t1[3] = Math.max(e[3], r[3]), t1;
            }, A.round = function(t1, e) {
                return t1[0] = Math.round(e[0]), t1[1] = Math.round(e[1]), t1[2] = Math.round(e[2]), t1[3] = Math.round(e[3]), t1;
            }, A.scale = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1;
            }, A.scaleAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1[3] = e[3] + r[3] * n, t1;
            }, A.distance = l, A.squaredDistance = u, A.length = c, A.squaredLength = h, A.negate = function(t1, e) {
                return t1[0] = -e[0], t1[1] = -e[1], t1[2] = -e[2], t1[3] = -e[3], t1;
            }, A.inverse = function(t1, e) {
                return t1[0] = 1 / e[0], t1[1] = 1 / e[1], t1[2] = 1 / e[2], t1[3] = 1 / e[3], t1;
            }, A.normalize = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = r * r + n * n + i * i + s * s;
                return a > 0 && (a = 1 / Math.sqrt(a)), t1[0] = r * a, t1[1] = n * a, t1[2] = i * a, t1[3] = s * a, t1;
            }, A.dot = function(t1, e) {
                return t1[0] * e[0] + t1[1] * e[1] + t1[2] * e[2] + t1[3] * e[3];
            }, A.cross = function(t1, e, r, n) {
                var i = r[0] * n[1] - r[1] * n[0], s = r[0] * n[2] - r[2] * n[0], a = r[0] * n[3] - r[3] * n[0], o = r[1] * n[2] - r[2] * n[1], l = r[1] * n[3] - r[3] * n[1], u = r[2] * n[3] - r[3] * n[2], c = e[0], h = e[1], p = e[2], f = e[3];
                return t1[0] = h * u - p * l + f * o, t1[1] = -c * u + p * a - f * s, t1[2] = c * l - h * a + f * i, t1[3] = -c * o + h * s - p * i, t1;
            }, A.lerp = function(t1, e, r, n) {
                var i = e[0], s = e[1], a = e[2], o = e[3];
                return t1[0] = i + n * (r[0] - i), t1[1] = s + n * (r[1] - s), t1[2] = a + n * (r[2] - a), t1[3] = o + n * (r[3] - o), t1;
            }, A.random = function(t1, r) {
                var n, i, s, a, o, l;
                r = r || 1;
                do o = (n = 2 * e.RANDOM() - 1) * n + (i = 2 * e.RANDOM() - 1) * i;
                while (o >= 1);
                do l = (s = 2 * e.RANDOM() - 1) * s + (a = 2 * e.RANDOM() - 1) * a;
                while (l >= 1);
                var u = Math.sqrt((1 - o) / l);
                return t1[0] = r * n, t1[1] = r * i, t1[2] = r * s * u, t1[3] = r * a * u, t1;
            }, A.transformMat4 = function(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3];
                return t1[0] = r[0] * n + r[4] * i + r[8] * s + r[12] * a, t1[1] = r[1] * n + r[5] * i + r[9] * s + r[13] * a, t1[2] = r[2] * n + r[6] * i + r[10] * s + r[14] * a, t1[3] = r[3] * n + r[7] * i + r[11] * s + r[15] * a, t1;
            }, A.transformQuat = function(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = r[0], o = r[1], l = r[2], u = r[3], c = u * n + o * s - l * i, h = u * i + l * n - a * s, p = u * s + a * i - o * n, f = -a * n - o * i - l * s;
                return t1[0] = c * u + f * -a + h * -l - p * -o, t1[1] = h * u + f * -o + p * -a - c * -l, t1[2] = p * u + f * -l + c * -o - h * -a, t1[3] = e[3], t1;
            }, A.zero = function(t1) {
                return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1;
            }, A.str = function(t1) {
                return "vec4(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ")";
            }, A.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3];
            }, A.equals = function(t1, r) {
                var n = t1[0], i = t1[1], s = t1[2], a = t1[3], o = r[0], l = r[1], u = r[2], c = r[3];
                return Math.abs(n - o) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(o)) && Math.abs(i - l) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(l)) && Math.abs(s - u) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(u)) && Math.abs(a - c) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(c));
            }, A.forEach = A.sqrLen = A.len = A.sqrDist = A.dist = A.div = A.mul = A.sub = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var s = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = a ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(s, o, l) : s[o] = e[o];
                }
                return s.default = e, i && i.set(e, s), s;
            }(s());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n() {
                var t1 = new e.ARRAY_TYPE(4);
                return e.ARRAY_TYPE != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 0), t1;
            }
            function i(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1[3] = e[3] - r[3], t1;
            }
            function a(t1, e, r) {
                return t1[0] = e[0] * r[0], t1[1] = e[1] * r[1], t1[2] = e[2] * r[2], t1[3] = e[3] * r[3], t1;
            }
            function o(t1, e, r) {
                return t1[0] = e[0] / r[0], t1[1] = e[1] / r[1], t1[2] = e[2] / r[2], t1[3] = e[3] / r[3], t1;
            }
            function l(t1, e) {
                return Math.hypot(e[0] - t1[0], e[1] - t1[1], e[2] - t1[2], e[3] - t1[3]);
            }
            function u(t1, e) {
                var r = e[0] - t1[0], n = e[1] - t1[1], i = e[2] - t1[2], s = e[3] - t1[3];
                return r * r + n * n + i * i + s * s;
            }
            function c(t1) {
                return Math.hypot(t1[0], t1[1], t1[2], t1[3]);
            }
            function h(t1) {
                var e = t1[0], r = t1[1], n = t1[2], i = t1[3];
                return e * e + r * r + n * n + i * i;
            }
            A.sub = i, A.mul = a, A.div = o, A.dist = l, A.sqrDist = u, A.len = c, A.sqrLen = h;
            var p, f = (p = n(), function(t1, e, r, n, i, s) {
                var a, o;
                for(e || (e = 4), r || (r = 0), o = n ? Math.min(n * e + r, t1.length) : t1.length, a = r; a < o; a += e)p[0] = t1[a], p[1] = t1[a + 1], p[2] = t1[a + 2], p[3] = t1[a + 3], i(p, p, s), t1[a] = p[0], t1[a + 1] = p[1], t1[a + 2] = p[2], t1[a + 3] = p[3];
                return t1;
            });
            return A.forEach = f, A;
        }
        function I() {
            if (M) return b;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            M = 1, Object.defineProperty(b, "__esModule", {
                value: !0
            }), b.create = l, b.identity = function(t1) {
                return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1;
            }, b.setAxisAngle = u, b.getAxisAngle = function(t1, r) {
                var n = 2 * Math.acos(r[3]), i = Math.sin(n / 2);
                return i > e.EPSILON ? (t1[0] = r[0] / i, t1[1] = r[1] / i, t1[2] = r[2] / i) : (t1[0] = 1, t1[1] = 0, t1[2] = 0), n;
            }, b.getAngle = function(t1, e) {
                var r = g(t1, e);
                return Math.acos(2 * r * r - 1);
            }, b.multiply = c, b.rotateX = function(t1, e, r) {
                r *= .5;
                var n = e[0], i = e[1], s = e[2], a = e[3], o = Math.sin(r), l = Math.cos(r);
                return t1[0] = n * l + a * o, t1[1] = i * l + s * o, t1[2] = s * l - i * o, t1[3] = a * l - n * o, t1;
            }, b.rotateY = function(t1, e, r) {
                r *= .5;
                var n = e[0], i = e[1], s = e[2], a = e[3], o = Math.sin(r), l = Math.cos(r);
                return t1[0] = n * l - s * o, t1[1] = i * l + a * o, t1[2] = s * l + n * o, t1[3] = a * l - i * o, t1;
            }, b.rotateZ = function(t1, e, r) {
                r *= .5;
                var n = e[0], i = e[1], s = e[2], a = e[3], o = Math.sin(r), l = Math.cos(r);
                return t1[0] = n * l + i * o, t1[1] = i * l - n * o, t1[2] = s * l + a * o, t1[3] = a * l - s * o, t1;
            }, b.calculateW = function(t1, e) {
                var r = e[0], n = e[1], i = e[2];
                return t1[0] = r, t1[1] = n, t1[2] = i, t1[3] = Math.sqrt(Math.abs(1 - r * r - n * n - i * i)), t1;
            }, b.exp = h, b.ln = p, b.pow = function(t1, e, r) {
                return p(t1, e), y(t1, t1, r), h(t1, t1), t1;
            }, b.slerp = f, b.random = function(t1) {
                var r = e.RANDOM(), n = e.RANDOM(), i = e.RANDOM(), s = Math.sqrt(1 - r), a = Math.sqrt(r);
                return t1[0] = s * Math.sin(2 * Math.PI * n), t1[1] = s * Math.cos(2 * Math.PI * n), t1[2] = a * Math.sin(2 * Math.PI * i), t1[3] = a * Math.cos(2 * Math.PI * i), t1;
            }, b.invert = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = r * r + n * n + i * i + s * s, o = a ? 1 / a : 0;
                return t1[0] = -r * o, t1[1] = -n * o, t1[2] = -i * o, t1[3] = s * o, t1;
            }, b.conjugate = function(t1, e) {
                return t1[0] = -e[0], t1[1] = -e[1], t1[2] = -e[2], t1[3] = e[3], t1;
            }, b.fromMat3 = m, b.fromEuler = function(t1, e, r, n) {
                var i = .5 * Math.PI / 180;
                e *= i, r *= i, n *= i;
                var s = Math.sin(e), a = Math.cos(e), o = Math.sin(r), l = Math.cos(r), u = Math.sin(n), c = Math.cos(n);
                return t1[0] = s * l * c - a * o * u, t1[1] = a * o * c + s * l * u, t1[2] = a * l * u - s * o * c, t1[3] = a * l * c + s * o * u, t1;
            }, b.str = function(t1) {
                return "quat(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ")";
            }, b.setAxes = b.sqlerp = b.rotationTo = b.equals = b.exactEquals = b.normalize = b.sqrLen = b.squaredLength = b.len = b.length = b.lerp = b.dot = b.scale = b.mul = b.add = b.set = b.copy = b.fromValues = b.clone = void 0;
            var e = o(s()), r = o(d()), n = o(w()), i = o(S());
            function a(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, r = new WeakMap;
                return (a = function(t1) {
                    return t1 ? r : e;
                })(t1);
            }
            function o(e, r) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var n = a(r);
                if (n && n.has(e)) return n.get(e);
                var i = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = s ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(i, o, l) : i[o] = e[o];
                }
                return i.default = e, n && n.set(e, i), i;
            }
            function l() {
                var t1 = new e.ARRAY_TYPE(4);
                return e.ARRAY_TYPE != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0), t1[3] = 1, t1;
            }
            function u(t1, e, r) {
                r *= .5;
                var n = Math.sin(r);
                return t1[0] = n * e[0], t1[1] = n * e[1], t1[2] = n * e[2], t1[3] = Math.cos(r), t1;
            }
            function c(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = r[0], l = r[1], u = r[2], c = r[3];
                return t1[0] = n * c + a * o + i * u - s * l, t1[1] = i * c + a * l + s * o - n * u, t1[2] = s * c + a * u + n * l - i * o, t1[3] = a * c - n * o - i * l - s * u, t1;
            }
            function h(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = Math.sqrt(r * r + n * n + i * i), o = Math.exp(s), l = a > 0 ? o * Math.sin(a) / a : 0;
                return t1[0] = r * l, t1[1] = n * l, t1[2] = i * l, t1[3] = o * Math.cos(a), t1;
            }
            function p(t1, e) {
                var r = e[0], n = e[1], i = e[2], s = e[3], a = Math.sqrt(r * r + n * n + i * i), o = a > 0 ? Math.atan2(a, s) / a : 0;
                return t1[0] = r * o, t1[1] = n * o, t1[2] = i * o, t1[3] = .5 * Math.log(r * r + n * n + i * i + s * s), t1;
            }
            function f(t1, r, n, i) {
                var s, a, o, l, u, c = r[0], h = r[1], p = r[2], f = r[3], d = n[0], m = n[1], y = n[2], g = n[3];
                return (a = c * d + h * m + p * y + f * g) < 0 && (a = -a, d = -d, m = -m, y = -y, g = -g), 1 - a > e.EPSILON ? (s = Math.acos(a), o = Math.sin(s), l = Math.sin((1 - i) * s) / o, u = Math.sin(i * s) / o) : (l = 1 - i, u = i), t1[0] = l * c + u * d, t1[1] = l * h + u * m, t1[2] = l * p + u * y, t1[3] = l * f + u * g, t1;
            }
            function m(t1, e) {
                var r, n = e[0] + e[4] + e[8];
                if (n > 0) r = Math.sqrt(n + 1), t1[3] = .5 * r, t1[0] = (e[5] - e[7]) * (r = .5 / r), t1[1] = (e[6] - e[2]) * r, t1[2] = (e[1] - e[3]) * r;
                else {
                    var i = 0;
                    e[4] > e[0] && (i = 1), e[8] > e[3 * i + i] && (i = 2);
                    var s = (i + 1) % 3, a = (i + 2) % 3;
                    r = Math.sqrt(e[3 * i + i] - e[3 * s + s] - e[3 * a + a] + 1), t1[i] = .5 * r, t1[3] = (e[3 * s + a] - e[3 * a + s]) * (r = .5 / r), t1[s] = (e[3 * s + i] + e[3 * i + s]) * r, t1[a] = (e[3 * a + i] + e[3 * i + a]) * r;
                }
                return t1;
            }
            b.clone = i.clone, b.fromValues = i.fromValues, b.copy = i.copy, b.set = i.set, b.add = i.add, b.mul = c;
            var y = i.scale;
            b.scale = y;
            var g = i.dot;
            b.dot = g, b.lerp = i.lerp;
            var x = i.length;
            b.length = x, b.len = x;
            var v = i.squaredLength;
            b.squaredLength = v, b.sqrLen = v;
            var _ = i.normalize;
            b.normalize = _, b.exactEquals = i.exactEquals, b.equals = i.equals;
            var A, I, P, z = (A = n.create(), I = n.fromValues(1, 0, 0), P = n.fromValues(0, 1, 0), function(t1, e, r) {
                var i = n.dot(e, r);
                return i < -0.999999 ? (n.cross(A, I, e), n.len(A) < 1e-6 && n.cross(A, P, e), n.normalize(A, A), u(t1, A, Math.PI), t1) : i > .999999 ? (t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1) : (n.cross(A, e, r), t1[0] = A[0], t1[1] = A[1], t1[2] = A[2], t1[3] = 1 + i, _(t1, t1));
            });
            b.rotationTo = z;
            var k, T, E = (k = l(), T = l(), function(t1, e, r, n, i, s) {
                return f(k, e, i, s), f(T, r, n, s), f(t1, k, T, 2 * s * (1 - s)), t1;
            });
            b.sqlerp = E;
            var B, V = (B = r.create(), function(t1, e, r, n) {
                return B[0] = r[0], B[3] = r[1], B[6] = r[2], B[1] = n[0], B[4] = n[1], B[7] = n[2], B[2] = -e[0], B[5] = -e[1], B[8] = -e[2], _(t1, m(t1, B));
            });
            return b.setAxes = V, b;
        }
        var P, z = {};
        function k() {
            if (P) return z;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            P = 1, Object.defineProperty(z, "__esModule", {
                value: !0
            }), z.create = function() {
                var t1 = new e.ARRAY_TYPE(8);
                return e.ARRAY_TYPE != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[4] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[3] = 1, t1;
            }, z.clone = function(t1) {
                var r = new e.ARRAY_TYPE(8);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = t1[3], r[4] = t1[4], r[5] = t1[5], r[6] = t1[6], r[7] = t1[7], r;
            }, z.fromValues = function(t1, r, n, i, s, a, o, l) {
                var u = new e.ARRAY_TYPE(8);
                return u[0] = t1, u[1] = r, u[2] = n, u[3] = i, u[4] = s, u[5] = a, u[6] = o, u[7] = l, u;
            }, z.fromRotationTranslationValues = function(t1, r, n, i, s, a, o) {
                var l = new e.ARRAY_TYPE(8);
                l[0] = t1, l[1] = r, l[2] = n, l[3] = i;
                var u = .5 * s, c = .5 * a, h = .5 * o;
                return l[4] = u * i + c * n - h * r, l[5] = c * i + h * t1 - u * n, l[6] = h * i + u * r - c * t1, l[7] = -u * t1 - c * r - h * n, l;
            }, z.fromRotationTranslation = o, z.fromTranslation = function(t1, e) {
                return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1[4] = .5 * e[0], t1[5] = .5 * e[1], t1[6] = .5 * e[2], t1[7] = 0, t1;
            }, z.fromRotation = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[4] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1;
            }, z.fromMat4 = function(t1, i) {
                var s = r.create();
                n.getRotation(s, i);
                var a = new e.ARRAY_TYPE(3);
                return n.getTranslation(a, i), o(t1, s, a), t1;
            }, z.copy = l, z.identity = function(t1) {
                return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1[4] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1;
            }, z.set = function(t1, e, r, n, i, s, a, o, l) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = i, t1[4] = s, t1[5] = a, t1[6] = o, t1[7] = l, t1;
            }, z.getDual = function(t1, e) {
                return t1[0] = e[4], t1[1] = e[5], t1[2] = e[6], t1[3] = e[7], t1;
            }, z.setDual = function(t1, e) {
                return t1[4] = e[0], t1[5] = e[1], t1[6] = e[2], t1[7] = e[3], t1;
            }, z.getTranslation = function(t1, e) {
                var r = e[4], n = e[5], i = e[6], s = e[7], a = -e[0], o = -e[1], l = -e[2], u = e[3];
                return t1[0] = 2 * (r * u + s * a + n * l - i * o), t1[1] = 2 * (n * u + s * o + i * a - r * l), t1[2] = 2 * (i * u + s * l + r * o - n * a), t1;
            }, z.translate = function(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = .5 * r[0], l = .5 * r[1], u = .5 * r[2], c = e[4], h = e[5], p = e[6], f = e[7];
                return t1[0] = n, t1[1] = i, t1[2] = s, t1[3] = a, t1[4] = a * o + i * u - s * l + c, t1[5] = a * l + s * o - n * u + h, t1[6] = a * u + n * l - i * o + p, t1[7] = -n * o - i * l - s * u + f, t1;
            }, z.rotateX = function(t1, e, n) {
                var i = -e[0], s = -e[1], a = -e[2], o = e[3], l = e[4], u = e[5], c = e[6], h = e[7], p = l * o + h * i + u * a - c * s, f = u * o + h * s + c * i - l * a, d = c * o + h * a + l * s - u * i, m = h * o - l * i - u * s - c * a;
                return r.rotateX(t1, e, n), t1[4] = p * (o = t1[3]) + m * (i = t1[0]) + f * (a = t1[2]) - d * (s = t1[1]), t1[5] = f * o + m * s + d * i - p * a, t1[6] = d * o + m * a + p * s - f * i, t1[7] = m * o - p * i - f * s - d * a, t1;
            }, z.rotateY = function(t1, e, n) {
                var i = -e[0], s = -e[1], a = -e[2], o = e[3], l = e[4], u = e[5], c = e[6], h = e[7], p = l * o + h * i + u * a - c * s, f = u * o + h * s + c * i - l * a, d = c * o + h * a + l * s - u * i, m = h * o - l * i - u * s - c * a;
                return r.rotateY(t1, e, n), t1[4] = p * (o = t1[3]) + m * (i = t1[0]) + f * (a = t1[2]) - d * (s = t1[1]), t1[5] = f * o + m * s + d * i - p * a, t1[6] = d * o + m * a + p * s - f * i, t1[7] = m * o - p * i - f * s - d * a, t1;
            }, z.rotateZ = function(t1, e, n) {
                var i = -e[0], s = -e[1], a = -e[2], o = e[3], l = e[4], u = e[5], c = e[6], h = e[7], p = l * o + h * i + u * a - c * s, f = u * o + h * s + c * i - l * a, d = c * o + h * a + l * s - u * i, m = h * o - l * i - u * s - c * a;
                return r.rotateZ(t1, e, n), t1[4] = p * (o = t1[3]) + m * (i = t1[0]) + f * (a = t1[2]) - d * (s = t1[1]), t1[5] = f * o + m * s + d * i - p * a, t1[6] = d * o + m * a + p * s - f * i, t1[7] = m * o - p * i - f * s - d * a, t1;
            }, z.rotateByQuatAppend = function(t1, e, r) {
                var n = r[0], i = r[1], s = r[2], a = r[3], o = e[0], l = e[1], u = e[2], c = e[3];
                return t1[0] = o * a + c * n + l * s - u * i, t1[1] = l * a + c * i + u * n - o * s, t1[2] = u * a + c * s + o * i - l * n, t1[3] = c * a - o * n - l * i - u * s, t1[4] = (o = e[4]) * a + (c = e[7]) * n + (l = e[5]) * s - (u = e[6]) * i, t1[5] = l * a + c * i + u * n - o * s, t1[6] = u * a + c * s + o * i - l * n, t1[7] = c * a - o * n - l * i - u * s, t1;
            }, z.rotateByQuatPrepend = function(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = r[0], l = r[1], u = r[2], c = r[3];
                return t1[0] = n * c + a * o + i * u - s * l, t1[1] = i * c + a * l + s * o - n * u, t1[2] = s * c + a * u + n * l - i * o, t1[3] = a * c - n * o - i * l - s * u, t1[4] = n * (c = r[7]) + a * (o = r[4]) + i * (u = r[6]) - s * (l = r[5]), t1[5] = i * c + a * l + s * o - n * u, t1[6] = s * c + a * u + n * l - i * o, t1[7] = a * c - n * o - i * l - s * u, t1;
            }, z.rotateAroundAxis = function(t1, r, n, i) {
                if (Math.abs(i) < e.EPSILON) return l(t1, r);
                var s = Math.hypot(n[0], n[1], n[2]);
                i *= .5;
                var a = Math.sin(i), o = a * n[0] / s, u = a * n[1] / s, c = a * n[2] / s, h = Math.cos(i), p = r[0], f = r[1], d = r[2], m = r[3];
                t1[0] = p * h + m * o + f * c - d * u, t1[1] = f * h + m * u + d * o - p * c, t1[2] = d * h + m * c + p * u - f * o, t1[3] = m * h - p * o - f * u - d * c;
                var y = r[4], g = r[5], x = r[6], b = r[7];
                return t1[4] = y * h + b * o + g * c - x * u, t1[5] = g * h + b * u + x * o - y * c, t1[6] = x * h + b * c + y * u - g * o, t1[7] = b * h - y * o - g * u - x * c, t1;
            }, z.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1[3] = e[3] + r[3], t1[4] = e[4] + r[4], t1[5] = e[5] + r[5], t1[6] = e[6] + r[6], t1[7] = e[7] + r[7], t1;
            }, z.multiply = u, z.scale = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1[4] = e[4] * r, t1[5] = e[5] * r, t1[6] = e[6] * r, t1[7] = e[7] * r, t1;
            }, z.lerp = function(t1, e, r, n) {
                var i = 1 - n;
                return c(e, r) < 0 && (n = -n), t1[0] = e[0] * i + r[0] * n, t1[1] = e[1] * i + r[1] * n, t1[2] = e[2] * i + r[2] * n, t1[3] = e[3] * i + r[3] * n, t1[4] = e[4] * i + r[4] * n, t1[5] = e[5] * i + r[5] * n, t1[6] = e[6] * i + r[6] * n, t1[7] = e[7] * i + r[7] * n, t1;
            }, z.invert = function(t1, e) {
                var r = p(e);
                return t1[0] = -e[0] / r, t1[1] = -e[1] / r, t1[2] = -e[2] / r, t1[3] = e[3] / r, t1[4] = -e[4] / r, t1[5] = -e[5] / r, t1[6] = -e[6] / r, t1[7] = e[7] / r, t1;
            }, z.conjugate = function(t1, e) {
                return t1[0] = -e[0], t1[1] = -e[1], t1[2] = -e[2], t1[3] = e[3], t1[4] = -e[4], t1[5] = -e[5], t1[6] = -e[6], t1[7] = e[7], t1;
            }, z.normalize = function(t1, e) {
                var r = p(e);
                if (r > 0) {
                    r = Math.sqrt(r);
                    var n = e[0] / r, i = e[1] / r, s = e[2] / r, a = e[3] / r, o = e[4], l = e[5], u = e[6], c = e[7], h = n * o + i * l + s * u + a * c;
                    t1[0] = n, t1[1] = i, t1[2] = s, t1[3] = a, t1[4] = (o - n * h) / r, t1[5] = (l - i * h) / r, t1[6] = (u - s * h) / r, t1[7] = (c - a * h) / r;
                }
                return t1;
            }, z.str = function(t1) {
                return "quat2(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ", " + t1[4] + ", " + t1[5] + ", " + t1[6] + ", " + t1[7] + ")";
            }, z.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3] && t1[4] === e[4] && t1[5] === e[5] && t1[6] === e[6] && t1[7] === e[7];
            }, z.equals = function(t1, r) {
                var n = t1[0], i = t1[1], s = t1[2], a = t1[3], o = t1[4], l = t1[5], u = t1[6], c = t1[7], h = r[0], p = r[1], f = r[2], d = r[3], m = r[4], y = r[5], g = r[6], x = r[7];
                return Math.abs(n - h) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(h)) && Math.abs(i - p) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(p)) && Math.abs(s - f) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(f)) && Math.abs(a - d) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(d)) && Math.abs(o - m) <= e.EPSILON * Math.max(1, Math.abs(o), Math.abs(m)) && Math.abs(l - y) <= e.EPSILON * Math.max(1, Math.abs(l), Math.abs(y)) && Math.abs(u - g) <= e.EPSILON * Math.max(1, Math.abs(u), Math.abs(g)) && Math.abs(c - x) <= e.EPSILON * Math.max(1, Math.abs(c), Math.abs(x));
            }, z.sqrLen = z.squaredLength = z.len = z.length = z.dot = z.mul = z.setReal = z.getReal = void 0;
            var e = a(s()), r = a(I()), n = a(g());
            function i(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, r = new WeakMap;
                return (i = function(t1) {
                    return t1 ? r : e;
                })(t1);
            }
            function a(e, r) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var n = i(r);
                if (n && n.has(e)) return n.get(e);
                var s = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = a ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(s, o, l) : s[o] = e[o];
                }
                return s.default = e, n && n.set(e, s), s;
            }
            function o(t1, e, r) {
                var n = .5 * r[0], i = .5 * r[1], s = .5 * r[2], a = e[0], o = e[1], l = e[2], u = e[3];
                return t1[0] = a, t1[1] = o, t1[2] = l, t1[3] = u, t1[4] = n * u + i * l - s * o, t1[5] = i * u + s * a - n * l, t1[6] = s * u + n * o - i * a, t1[7] = -n * a - i * o - s * l, t1;
            }
            function l(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[4] = e[4], t1[5] = e[5], t1[6] = e[6], t1[7] = e[7], t1;
            }
            function u(t1, e, r) {
                var n = e[0], i = e[1], s = e[2], a = e[3], o = r[4], l = r[5], u = r[6], c = r[7], h = e[4], p = e[5], f = e[6], d = e[7], m = r[0], y = r[1], g = r[2], x = r[3];
                return t1[0] = n * x + a * m + i * g - s * y, t1[1] = i * x + a * y + s * m - n * g, t1[2] = s * x + a * g + n * y - i * m, t1[3] = a * x - n * m - i * y - s * g, t1[4] = n * c + a * o + i * u - s * l + h * x + d * m + p * g - f * y, t1[5] = i * c + a * l + s * o - n * u + p * x + d * y + f * m - h * g, t1[6] = s * c + a * u + n * l - i * o + f * x + d * g + h * y - p * m, t1[7] = a * c - n * o - i * l - s * u + d * x - h * m - p * y - f * g, t1;
            }
            z.getReal = r.copy, z.setReal = r.copy, z.mul = u;
            var c = r.dot;
            z.dot = c;
            var h = r.length;
            z.length = h, z.len = h;
            var p = r.squaredLength;
            return z.squaredLength = p, z.sqrLen = p, z;
        }
        var T, E, B = {};
        function V() {
            if (T) return B;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            T = 1, Object.defineProperty(B, "__esModule", {
                value: !0
            }), B.create = n, B.clone = function(t1) {
                var r = new e.ARRAY_TYPE(2);
                return r[0] = t1[0], r[1] = t1[1], r;
            }, B.fromValues = function(t1, r) {
                var n = new e.ARRAY_TYPE(2);
                return n[0] = t1, n[1] = r, n;
            }, B.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1;
            }, B.set = function(t1, e, r) {
                return t1[0] = e, t1[1] = r, t1;
            }, B.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1;
            }, B.subtract = i, B.multiply = a, B.divide = o, B.ceil = function(t1, e) {
                return t1[0] = Math.ceil(e[0]), t1[1] = Math.ceil(e[1]), t1;
            }, B.floor = function(t1, e) {
                return t1[0] = Math.floor(e[0]), t1[1] = Math.floor(e[1]), t1;
            }, B.min = function(t1, e, r) {
                return t1[0] = Math.min(e[0], r[0]), t1[1] = Math.min(e[1], r[1]), t1;
            }, B.max = function(t1, e, r) {
                return t1[0] = Math.max(e[0], r[0]), t1[1] = Math.max(e[1], r[1]), t1;
            }, B.round = function(t1, e) {
                return t1[0] = Math.round(e[0]), t1[1] = Math.round(e[1]), t1;
            }, B.scale = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1;
            }, B.scaleAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1;
            }, B.distance = l, B.squaredDistance = u, B.length = c, B.squaredLength = h, B.negate = function(t1, e) {
                return t1[0] = -e[0], t1[1] = -e[1], t1;
            }, B.inverse = function(t1, e) {
                return t1[0] = 1 / e[0], t1[1] = 1 / e[1], t1;
            }, B.normalize = function(t1, e) {
                var r = e[0], n = e[1], i = r * r + n * n;
                return i > 0 && (i = 1 / Math.sqrt(i)), t1[0] = e[0] * i, t1[1] = e[1] * i, t1;
            }, B.dot = function(t1, e) {
                return t1[0] * e[0] + t1[1] * e[1];
            }, B.cross = function(t1, e, r) {
                var n = e[0] * r[1] - e[1] * r[0];
                return t1[0] = t1[1] = 0, t1[2] = n, t1;
            }, B.lerp = function(t1, e, r, n) {
                var i = e[0], s = e[1];
                return t1[0] = i + n * (r[0] - i), t1[1] = s + n * (r[1] - s), t1;
            }, B.random = function(t1, r) {
                r = r || 1;
                var n = 2 * e.RANDOM() * Math.PI;
                return t1[0] = Math.cos(n) * r, t1[1] = Math.sin(n) * r, t1;
            }, B.transformMat2 = function(t1, e, r) {
                var n = e[0], i = e[1];
                return t1[0] = r[0] * n + r[2] * i, t1[1] = r[1] * n + r[3] * i, t1;
            }, B.transformMat2d = function(t1, e, r) {
                var n = e[0], i = e[1];
                return t1[0] = r[0] * n + r[2] * i + r[4], t1[1] = r[1] * n + r[3] * i + r[5], t1;
            }, B.transformMat3 = function(t1, e, r) {
                var n = e[0], i = e[1];
                return t1[0] = r[0] * n + r[3] * i + r[6], t1[1] = r[1] * n + r[4] * i + r[7], t1;
            }, B.transformMat4 = function(t1, e, r) {
                var n = e[0], i = e[1];
                return t1[0] = r[0] * n + r[4] * i + r[12], t1[1] = r[1] * n + r[5] * i + r[13], t1;
            }, B.rotate = function(t1, e, r, n) {
                var i = e[0] - r[0], s = e[1] - r[1], a = Math.sin(n), o = Math.cos(n);
                return t1[0] = i * o - s * a + r[0], t1[1] = i * a + s * o + r[1], t1;
            }, B.angle = function(t1, e) {
                var r = t1[0], n = t1[1], i = e[0], s = e[1], a = Math.sqrt(r * r + n * n) * Math.sqrt(i * i + s * s);
                return Math.acos(Math.min(Math.max(a && (r * i + n * s) / a, -1), 1));
            }, B.zero = function(t1) {
                return t1[0] = 0, t1[1] = 0, t1;
            }, B.str = function(t1) {
                return "vec2(" + t1[0] + ", " + t1[1] + ")";
            }, B.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1];
            }, B.equals = function(t1, r) {
                var n = t1[0], i = t1[1], s = r[0], a = r[1];
                return Math.abs(n - s) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(s)) && Math.abs(i - a) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(a));
            }, B.forEach = B.sqrLen = B.sqrDist = B.dist = B.div = B.mul = B.sub = B.len = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var s = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = a ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(s, o, l) : s[o] = e[o];
                }
                return s.default = e, i && i.set(e, s), s;
            }(s());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n() {
                var t1 = new e.ARRAY_TYPE(2);
                return e.ARRAY_TYPE != Float32Array && (t1[0] = 0, t1[1] = 0), t1;
            }
            function i(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1;
            }
            function a(t1, e, r) {
                return t1[0] = e[0] * r[0], t1[1] = e[1] * r[1], t1;
            }
            function o(t1, e, r) {
                return t1[0] = e[0] / r[0], t1[1] = e[1] / r[1], t1;
            }
            function l(t1, e) {
                return Math.hypot(e[0] - t1[0], e[1] - t1[1]);
            }
            function u(t1, e) {
                var r = e[0] - t1[0], n = e[1] - t1[1];
                return r * r + n * n;
            }
            function c(t1) {
                return Math.hypot(t1[0], t1[1]);
            }
            function h(t1) {
                var e = t1[0], r = t1[1];
                return e * e + r * r;
            }
            B.len = c, B.sub = i, B.mul = a, B.div = o, B.dist = l, B.sqrDist = u, B.sqrLen = h;
            var p, f = (p = n(), function(t1, e, r, n, i, s) {
                var a, o;
                for(e || (e = 2), r || (r = 0), o = n ? Math.min(n * e + r, t1.length) : t1.length, a = r; a < o; a += e)p[0] = t1[a], p[1] = t1[a + 1], i(p, p, s), t1[a] = p[0], t1[a + 1] = p[1];
                return t1;
            });
            return B.forEach = f, B;
        }
        function C() {
            if (E) return n;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            E = 1, Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.vec4 = n.vec3 = n.vec2 = n.quat2 = n.quat = n.mat4 = n.mat3 = n.mat2d = n.mat2 = n.glMatrix = void 0;
            var e = x(s());
            n.glMatrix = e;
            var r = x(l());
            n.mat2 = r;
            var i = x(h());
            n.mat2d = i;
            var a = x(d());
            n.mat3 = a;
            var o = x(g());
            n.mat4 = o;
            var u = x(I());
            n.quat = u;
            var c = x(k());
            n.quat2 = c;
            var p = x(V());
            n.vec2 = p;
            var f = x(w());
            n.vec3 = f;
            var m = x(S());
            function y(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, r = new WeakMap;
                return (y = function(t1) {
                    return t1 ? r : e;
                })(t1);
            }
            function x(e, r) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var n = y(r);
                if (n && n.has(e)) return n.get(e);
                var i = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var a in e)if ("default" !== a && Object.prototype.hasOwnProperty.call(e, a)) {
                    var o = s ? Object.getOwnPropertyDescriptor(e, a) : null;
                    o && (o.get || o.set) ? Object.defineProperty(i, a, o) : i[a] = e[a];
                }
                return i.default = e, n && n.set(e, i), i;
            }
            return n.vec4 = m, n;
        }
        var R, D, L, F, O = C(), U = function() {
            if (D) return R;
            function t1(t1, e, r, n) {
                this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e, this.by = 3 * (n - e) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = e, this.p2x = r, this.p2y = n;
            }
            return D = 1, R = t1, t1.prototype = {
                sampleCurveX: function(t1) {
                    return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
                },
                sampleCurveY: function(t1) {
                    return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
                },
                sampleCurveDerivativeX: function(t1) {
                    return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
                },
                solveCurveX: function(t1, e) {
                    if (void 0 === e && (e = 1e-6), t1 < 0) return 0;
                    if (t1 > 1) return 1;
                    for(var r = t1, n = 0; n < 8; n++){
                        var i = this.sampleCurveX(r) - t1;
                        if (Math.abs(i) < e) return r;
                        var s = this.sampleCurveDerivativeX(r);
                        if (Math.abs(s) < 1e-6) break;
                        r -= i / s;
                    }
                    var a = 0, o = 1;
                    for(r = t1, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t1) < e)); n++)t1 > i ? a = r : o = r, r = .5 * (o - a) + a;
                    return r;
                },
                solve: function(t1, e) {
                    return this.sampleCurveY(this.solveCurveX(t1, e));
                }
            }, R;
        }(), j = e(U);
        function N() {
            if (F) return L;
            function t1(t1, e) {
                this.x = t1, this.y = e;
            }
            return F = 1, L = t1, t1.prototype = {
                clone: function() {
                    return new t1(this.x, this.y);
                },
                add: function(t1) {
                    return this.clone()._add(t1);
                },
                sub: function(t1) {
                    return this.clone()._sub(t1);
                },
                multByPoint: function(t1) {
                    return this.clone()._multByPoint(t1);
                },
                divByPoint: function(t1) {
                    return this.clone()._divByPoint(t1);
                },
                mult: function(t1) {
                    return this.clone()._mult(t1);
                },
                div: function(t1) {
                    return this.clone()._div(t1);
                },
                rotate: function(t1) {
                    return this.clone()._rotate(t1);
                },
                rotateAround: function(t1, e) {
                    return this.clone()._rotateAround(t1, e);
                },
                matMult: function(t1) {
                    return this.clone()._matMult(t1);
                },
                unit: function() {
                    return this.clone()._unit();
                },
                perp: function() {
                    return this.clone()._perp();
                },
                round: function() {
                    return this.clone()._round();
                },
                mag: function() {
                    return Math.sqrt(this.x * this.x + this.y * this.y);
                },
                equals: function(t1) {
                    return this.x === t1.x && this.y === t1.y;
                },
                dist: function(t1) {
                    return Math.sqrt(this.distSqr(t1));
                },
                distSqr: function(t1) {
                    var e = t1.x - this.x, r = t1.y - this.y;
                    return e * e + r * r;
                },
                angle: function() {
                    return Math.atan2(this.y, this.x);
                },
                angleTo: function(t1) {
                    return Math.atan2(this.y - t1.y, this.x - t1.x);
                },
                angleWith: function(t1) {
                    return this.angleWithSep(t1.x, t1.y);
                },
                angleWithSep: function(t1, e) {
                    return Math.atan2(this.x * e - this.y * t1, this.x * t1 + this.y * e);
                },
                _matMult: function(t1) {
                    var e = t1[2] * this.x + t1[3] * this.y;
                    return this.x = t1[0] * this.x + t1[1] * this.y, this.y = e, this;
                },
                _add: function(t1) {
                    return this.x += t1.x, this.y += t1.y, this;
                },
                _sub: function(t1) {
                    return this.x -= t1.x, this.y -= t1.y, this;
                },
                _mult: function(t1) {
                    return this.x *= t1, this.y *= t1, this;
                },
                _div: function(t1) {
                    return this.x /= t1, this.y /= t1, this;
                },
                _multByPoint: function(t1) {
                    return this.x *= t1.x, this.y *= t1.y, this;
                },
                _divByPoint: function(t1) {
                    return this.x /= t1.x, this.y /= t1.y, this;
                },
                _unit: function() {
                    return this._div(this.mag()), this;
                },
                _perp: function() {
                    var t1 = this.y;
                    return this.y = this.x, this.x = -t1, this;
                },
                _rotate: function(t1) {
                    var e = Math.cos(t1), r = Math.sin(t1), n = r * this.x + e * this.y;
                    return this.x = e * this.x - r * this.y, this.y = n, this;
                },
                _rotateAround: function(t1, e) {
                    var r = Math.cos(t1), n = Math.sin(t1), i = e.y + n * (this.x - e.x) + r * (this.y - e.y);
                    return this.x = e.x + r * (this.x - e.x) - n * (this.y - e.y), this.y = i, this;
                },
                _round: function() {
                    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                }
            }, t1.convert = function(e) {
                return e instanceof t1 ? e : Array.isArray(e) ? new t1(e[0], e[1]) : e;
            }, L;
        }
        var q = e(N());
        function $(t1, e) {
            if (Array.isArray(t1)) {
                if (!Array.isArray(e) || t1.length !== e.length) return !1;
                for(let r = 0; r < t1.length; r++)if (!$(t1[r], e[r])) return !1;
                return !0;
            }
            if ("object" == typeof t1 && null !== t1 && null !== e) {
                if ("object" != typeof e) return !1;
                if (Object.keys(t1).length !== Object.keys(e).length) return !1;
                for(const r in t1)if (!$(t1[r], e[r])) return !1;
                return !0;
            }
            return t1 === e;
        }
        const G = Math.PI / 180, X = 180 / Math.PI;
        function Y(t1) {
            return t1 * G;
        }
        function Z(t1) {
            return t1 * X;
        }
        const W = [
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ];
        function H(t1) {
            if (t1 <= 0) return 0;
            if (t1 >= 1) return 1;
            const e = t1 * t1, r = e * t1;
            return 4 * (t1 < .5 ? r : 3 * (t1 - e) + r - .75);
        }
        function K(t1, e, r, n) {
            const i = new j(t1, e, r, n);
            return function(t1) {
                return i.solve(t1);
            };
        }
        const J = K(.25, .1, .25, 1);
        function Q(t1, e, r) {
            return Math.min(r, Math.max(e, t1));
        }
        function tt(t1, e, r) {
            return (r = Q((r - t1) / (e - t1), 0, 1)) * r * (3 - 2 * r);
        }
        function et(t1, e, r) {
            const n = r - e, i = ((t1 - e) % n + n) % n + e;
            return i === e ? r : i;
        }
        function rt(t1, e, r) {
            if (!t1.length) return r(null, []);
            let n = t1.length;
            const i = new Array(t1.length);
            let s = null;
            t1.forEach((t1, a)=>{
                e(t1, (t1, e)=>{
                    t1 && (s = t1), i[a] = e, 0 == --n && r(s, i);
                });
            });
        }
        function nt(t1, ...e) {
            for (const r of e)for(const e in r)t1[e] = r[e];
            return t1;
        }
        let it = 1;
        function st() {
            return it++;
        }
        function at(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
        }
        function ot(t1, e) {
            t1.forEach((t1)=>{
                e[t1] && (e[t1] = e[t1].bind(e));
            });
        }
        function lt(t1, e) {
            return -1 !== t1.indexOf(e, t1.length - e.length);
        }
        function ut(t1, e, r) {
            const n = {};
            for(const r in t1)n[r] = e.call(this, t1[r], r, t1);
            return n;
        }
        function ct(t1, e, r) {
            const n = {};
            for(const r in t1)e.call(this, t1[r], r, t1) && (n[r] = t1[r]);
            return n;
        }
        function ht(t1) {
            return Array.isArray(t1) ? t1.map(ht) : "object" == typeof t1 && t1 ? ut(t1, ht) : t1;
        }
        const pt = {};
        function ft(t1) {
            pt[t1] || ("undefined" != typeof console && console.warn(t1), pt[t1] = !0);
        }
        function dt(t1, e, r) {
            return (r.y - t1.y) * (e.x - t1.x) > (e.y - t1.y) * (r.x - t1.x);
        }
        function mt(t1) {
            let e = 0;
            for(let r, n, i = 0, s = t1.length, a = s - 1; i < s; a = i++)r = t1[i], n = t1[a], e += (n.x - r.x) * (r.y + n.y);
            return e;
        }
        function yt([t1, e, r]) {
            const n = Y(e + 90), i = Y(r);
            return {
                x: t1 * Math.cos(n) * Math.sin(i),
                y: t1 * Math.sin(n) * Math.sin(i),
                z: t1 * Math.cos(i),
                azimuthal: e,
                polar: r
            };
        }
        function gt() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        function xt(t1) {
            const e = {};
            if (t1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t1, r, n, i)=>{
                const s = n || i;
                return e[r] = !s || s.toLowerCase(), "";
            }), e["max-age"]) {
                const t1 = parseInt(e["max-age"], 10);
                isNaN(t1) ? delete e["max-age"] : e["max-age"] = t1;
            }
            return e;
        }
        let bt, vt = null;
        function wt(t1, e) {
            return [
                t1[4 * e],
                t1[4 * e + 1],
                t1[4 * e + 2],
                t1[4 * e + 3]
            ];
        }
        function _t(t1, e, r, n) {
            for(; e < r;){
                const i = e + r >> 1;
                t1[i] < n ? e = i + 1 : r = i;
            }
            return e;
        }
        function Mt(t1, e, r, n) {
            for(; e < r;){
                const i = e + r >> 1;
                t1[i] <= n ? e = i + 1 : r = i;
            }
            return e;
        }
        function At(t1) {
            return t1 > 0 ? 1 / (1.001 - t1) : 1 + t1;
        }
        function St(t1) {
            return t1 > 0 ? 1 - 1 / (1.001 - t1) : -t1;
        }
        const It = {
            API_URL: "https://api.mapbox.com",
            get API_URL_REGEX () {
                if (null == bt) {
                    const t1 = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
                    try {
                        bt = t1;
                    } catch (e) {
                        bt = t1;
                    }
                }
                return bt;
            },
            get API_TILEJSON_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
            },
            get API_SPRITE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
            },
            get API_FONTS_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
            },
            get API_STYLE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
            },
            get API_CDN_URL_REGEX () {
                return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
            },
            get EVENTS_URL () {
                if (!It.API_URL) return null;
                try {
                    const t1 = new URL(It.API_URL);
                    return "api.mapbox.cn" === t1.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === t1.hostname ? "https://events.mapbox.com/events/v2" : null;
                } catch (t1) {
                    return null;
                }
            },
            SESSION_PATH: "/map-sessions/v1",
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            TILE_URL_VERSION: "v4",
            RASTER_URL_PREFIX: "raster/v1",
            RASTERARRAYS_URL_PREFIX: "rasterarrays/v1",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            DEFAULT_STYLE: "mapbox://styles/mapbox/standard",
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            DRACO_URL: "https://api.mapbox.com/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm",
            MESHOPT_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_base_v0.20.wasm",
            MESHOPT_SIMD_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_simd_v0.20.wasm",
            GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
            TILES3D_URL_PREFIX: "3dtiles/v1"
        };
        function Pt(t1) {
            return It.API_URL_REGEX.test(t1);
        }
        function zt(t1) {
            return It.API_SPRITE_REGEX.test(t1);
        }
        let kt, Tt, Et, Bt, Vt, Ct;
        function Rt() {
            return null == kt && (kt = self.OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap), kt;
        }
        const Dt = {
            now: ()=>void 0 !== Bt ? Bt : performance.now(),
            setNow (t1) {
                Bt = t1;
            },
            restoreNow () {
                Bt = void 0;
            },
            frame (t1) {
                const e = requestAnimationFrame(t1);
                return {
                    cancel: ()=>cancelAnimationFrame(e)
                };
            },
            getImageData (t1, e = 0) {
                const { width: r, height: n } = t1;
                Vt || (Vt = document.createElement("canvas"));
                const i = Vt.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!i) throw new Error("failed to create canvas 2d context");
                return (r > Vt.width || n > Vt.height) && (Vt.width = r, Vt.height = n), i.clearRect(-e, -e, r + 2 * e, n + 2 * e), i.drawImage(t1, 0, 0, r, n), i.getImageData(-e, -e, r + 2 * e, n + 2 * e);
            },
            resolveURL: (t1)=>(Tt || (Tt = document.createElement("a")), Tt.href = t1, Tt.href),
            get devicePixelRatio () {
                return window.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!window.matchMedia && (null == Et && (Et = window.matchMedia("(prefers-reduced-motion: reduce)")), Et.matches);
            },
            hasCanvasFingerprintNoise () {
                if (void 0 !== Ct) return Ct;
                if (!Rt()) return Ct = !1, !1;
                const t1 = new OffscreenCanvas(85, 1), e = t1.getContext("2d", {
                    willReadFrequently: !0
                });
                let r = 0;
                for(let n = 0; n < t1.width; ++n)e.fillStyle = `rgba(${r++},${r++},${r++}, 255)`, e.fillRect(n, 0, 1, 1);
                const n = e.getImageData(0, 0, t1.width, t1.height);
                r = 0;
                for(let t1 = 0; t1 < n.data.length; ++t1)if (t1 % 4 != 3 && r++ !== n.data[t1]) return Ct = !0, !0;
                return Ct = !1, !1;
            }
        };
        function Lt(t1, e) {
            const r = t1.indexOf("?");
            if (r < 0) return `${t1}?${new URLSearchParams(e).toString()}`;
            const n = new URLSearchParams(t1.slice(r));
            for(const t1 in e)n.set(t1, e[t1]);
            return `${t1.slice(0, r)}?${n.toString()}`;
        }
        function Ft(t1, e = {
            persistentParams: []
        }) {
            const r = t1.indexOf("?");
            if (r < 0) return t1;
            const n = new URLSearchParams, i = new URLSearchParams(t1.slice(r));
            for (const t1 of e.persistentParams){
                const e = i.get(t1);
                e && n.set(t1, e);
            }
            const s = n.toString();
            return `${t1.slice(0, r)}${s.length > 0 ? `?${s}` : ""}`;
        }
        const Ot = "mapbox-tiles";
        let Ut = 500, jt = 50;
        const Nt = [
            "language",
            "worldview",
            "jobid"
        ];
        let qt, $t;
        function Gt() {
            try {
                return caches;
            } catch (t1) {}
        }
        function Xt() {
            const t1 = Gt();
            t1 && null == qt && (qt = t1.open(Ot));
        }
        let Yt = 1 / 0;
        const Zt = {
            supported: !1,
            testSupport: function(t1) {
                !Kt && Ht && (Jt ? te(t1) : Wt = t1);
            }
        };
        let Wt, Ht, Kt = !1, Jt = !1;
        const Qt = "undefined" != typeof self ? self : {};
        function te(t1) {
            const e = t1.createTexture();
            t1.bindTexture(t1.TEXTURE_2D, e);
            try {
                if (t1.texImage2D(t1.TEXTURE_2D, 0, t1.RGBA, t1.RGBA, t1.UNSIGNED_BYTE, Ht), t1.isContextLost()) return;
                Zt.supported = !0;
            } catch (t1) {}
            t1.deleteTexture(e), Kt = !0;
        }
        Qt.document && (Ht = Qt.document.createElement("img"), Ht.onload = function() {
            Wt && te(Wt), Wt = null, Jt = !0;
        }, Ht.onerror = function() {
            Kt = !0, Wt = null;
        }, Ht.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        const ee = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Image: "Image",
            Model: "Model"
        };
        "function" == typeof Object.freeze && Object.freeze(ee);
        class re extends Error {
            constructor(t1, e, r){
                401 === e && Pt(r) && (t1 += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), super(t1), this.status = e, this.url = r;
            }
            toString() {
                return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
            }
        }
        const ne = gt() ? ()=>self.worker && self.worker.referrer : ()=>("blob:" === location.protocol ? parent : self).location.href;
        const ie = function(t1, e) {
            if (!(/^file:/.test(r = t1.url) || /^file:/.test(ne()) && !/^\w+:/.test(r))) {
                if (self.fetch && self.Request && self.AbortController && Request.prototype.hasOwnProperty("signal")) return function(t1, e) {
                    const r = new AbortController, n = new Request(t1.url, {
                        method: t1.method || "GET",
                        body: t1.body,
                        credentials: t1.credentials,
                        headers: t1.headers,
                        referrer: ne(),
                        referrerPolicy: t1.referrerPolicy,
                        signal: r.signal
                    });
                    let i = !1, s = !1;
                    const a = (o = n.url).indexOf("sku=") > 0 && Pt(o);
                    var o;
                    "json" === t1.type && n.headers.set("Accept", "application/json");
                    const l = (r, i, o)=>{
                        if (s) return;
                        if (r && "SecurityError" !== r.message && ft(r.toString()), i && o) return u(i);
                        const l = Date.now();
                        fetch(n).then((r)=>{
                            if (r.ok) {
                                const t1 = a ? r.clone() : null;
                                return u(r, t1, l);
                            }
                            return e(new re(r.statusText, r.status, t1.url));
                        }).catch((r)=>{
                            "AbortError" !== r.name && e(new Error(`${r.message} ${t1.url}`));
                        });
                    }, u = (r, a, o)=>{
                        ("arrayBuffer" === t1.type ? r.arrayBuffer() : "json" === t1.type ? r.json() : r.text()).then((t1)=>{
                            s || (a && o && function(t1, e, r) {
                                if (Xt(), null == qt) return;
                                const n = xt(e.headers.get("Cache-Control") || "");
                                if (n["no-store"]) return;
                                const i = {
                                    status: e.status,
                                    statusText: e.statusText,
                                    headers: new Headers
                                };
                                e.headers.forEach((t1, e)=>i.headers.set(e, t1)), n["max-age"] && i.headers.set("Expires", new Date(r + 1e3 * n["max-age"]).toUTCString());
                                const s = i.headers.get("Expires");
                                if (!s) return;
                                if (new Date(s).getTime() - r < 42e4) return;
                                let a = Ft(t1.url, {
                                    persistentParams: Nt
                                });
                                if (206 === e.status) {
                                    const e = t1.headers.get("Range");
                                    if (!e) return;
                                    i.status = 200, a = Lt(a, {
                                        range: e
                                    });
                                }
                                !function(t1, e) {
                                    if (void 0 === $t) try {
                                        new Response(new ReadableStream), $t = !0;
                                    } catch (t1) {
                                        $t = !1;
                                    }
                                    $t ? e(t1.body) : t1.blob().then(e);
                                }(e, (t1)=>{
                                    const r = new Response(200 !== (n = e.status) && 404 !== n && [
                                        101,
                                        103,
                                        204,
                                        205,
                                        304
                                    ].includes(n) ? null : t1, i);
                                    var n;
                                    Xt(), null != qt && qt.then((t1)=>t1.put(a, r)).catch((t1)=>ft(t1.message));
                                });
                            }(n, a, o), i = !0, e(null, t1, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                        }).catch((t1)=>{
                            s || e(new Error(t1.message));
                        });
                    };
                    return a ? function(t1, e) {
                        if (Xt(), null == qt) return e(null);
                        qt.then((r)=>{
                            let n = Ft(t1.url, {
                                persistentParams: Nt
                            });
                            const i = t1.headers.get("Range");
                            i && (n = Lt(n, {
                                range: i
                            })), r.match(n).then((t1)=>{
                                const i = function(t1) {
                                    if (!t1) return !1;
                                    const e = new Date(t1.headers.get("Expires") || 0), r = xt(t1.headers.get("Cache-Control") || "");
                                    return e > Date.now() && !r["no-cache"];
                                }(t1);
                                r.delete(n), i && r.put(n, t1.clone()), e(null, t1, i);
                            }).catch(e);
                        }).catch(e);
                    }(n, l) : l(null, null), {
                        cancel: ()=>{
                            s = !0, i || r.abort();
                        }
                    };
                }(t1, e);
                if (gt() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t1, e, void 0, !0);
            }
            var r;
            return function(t1, e) {
                const r = new XMLHttpRequest;
                r.open(t1.method || "GET", t1.url, !0), "arrayBuffer" === t1.type && (r.responseType = "arraybuffer");
                for(const e in t1.headers)r.setRequestHeader(e, t1.headers[e]);
                return "json" === t1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t1.credentials, r.onerror = ()=>{
                    e(new Error(r.statusText));
                }, r.onload = ()=>{
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        let n = r.response;
                        if ("json" === t1.type) try {
                            n = JSON.parse(r.response);
                        } catch (t1) {
                            return e(t1);
                        }
                        e(null, n, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                    } else e(new re(r.statusText, r.status, t1.url));
                }, r.send(t1.body), {
                    cancel: ()=>r.abort()
                };
            }(t1, e);
        }, se = function(t1, e) {
            return ie(nt(t1, {
                type: "arrayBuffer"
            }), e);
        };
        function ae(t1) {
            const e = document.createElement("a");
            return e.href = t1, e.protocol === location.protocol && e.host === location.host;
        }
        const oe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        let le, ue;
        le = [], ue = 0;
        const ce = function(t1, e) {
            if (Zt.supported && (t1.headers || (t1.headers = {}), t1.headers.accept = "image/webp,*/*"), ue >= It.MAX_PARALLEL_IMAGE_REQUESTS) {
                const r = {
                    requestParameters: t1,
                    callback: e,
                    cancelled: !1,
                    cancel () {
                        this.cancelled = !0;
                    }
                };
                return le.push(r), r;
            }
            ue++;
            let r = !1;
            const n = ()=>{
                if (!r) for(r = !0, ue--; le.length && ue < It.MAX_PARALLEL_IMAGE_REQUESTS;){
                    const t1 = le.shift(), { requestParameters: e, callback: r, cancelled: n } = t1;
                    n || (t1.cancel = ce(e, r).cancel);
                }
            }, i = se(t1, (t1, r, i, s)=>{
                n(), t1 ? e(t1) : r && (self.createImageBitmap ? function(t1, e) {
                    const r = new Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    createImageBitmap(r).then((t1)=>{
                        e(null, t1);
                    }).catch((t1)=>{
                        e(new Error(`Could not load image because of ${t1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
                    });
                }(r, (t1, r)=>e(t1, r, i, s)) : function(t1, e) {
                    const r = new Image;
                    r.onload = ()=>{
                        e(null, r), URL.revokeObjectURL(r.src), r.onload = null, requestAnimationFrame(()=>{
                            r.src = oe;
                        });
                    }, r.onerror = ()=>e(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    const n = new Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    r.src = t1.byteLength ? URL.createObjectURL(n) : oe;
                }(r, (t1, r)=>e(t1, r, i, s)));
            });
            return {
                cancel: ()=>{
                    i.cancel(), n();
                }
            };
        };
        var he, pe, fe, de = {
            exports: {}
        }, me = {
            exports: {}
        }, ye = {
            exports: {}
        }, ge = function() {
            if (fe) return de.exports;
            fe = 1;
            var t1 = (he || (he = 1, me.exports = function(t1, e) {
                var r, n, i, s, a, o, l, u;
                for(n = t1.length - (r = 3 & t1.length), i = e, a = 3432918353, o = 461845907, u = 0; u < n;)l = 255 & t1.charCodeAt(u) | (255 & t1.charCodeAt(++u)) << 8 | (255 & t1.charCodeAt(++u)) << 16 | (255 & t1.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (s = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s >>> 16) & 65535) << 16);
                switch(l = 0, r){
                    case 3:
                        l ^= (255 & t1.charCodeAt(u + 2)) << 16;
                    case 2:
                        l ^= (255 & t1.charCodeAt(u + 1)) << 8;
                    case 1:
                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t1.charCodeAt(u))) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
                }
                return i ^= t1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            }), me.exports), e = (pe || (pe = 1, ye.exports = function(t1, e) {
                for(var r, n = t1.length, i = e ^ n, s = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t1.charCodeAt(s) | (255 & t1.charCodeAt(++s)) << 8 | (255 & t1.charCodeAt(++s)) << 16 | (255 & t1.charCodeAt(++s)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++s;
                switch(n){
                    case 3:
                        i ^= (255 & t1.charCodeAt(s + 2)) << 16;
                    case 2:
                        i ^= (255 & t1.charCodeAt(s + 1)) << 8;
                    case 1:
                        i = 1540483477 * (65535 & (i ^= 255 & t1.charCodeAt(s))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                }
                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            }), ye.exports);
            return de.exports = t1, de.exports.murmur3 = t1, de.exports.murmur2 = e, de.exports;
        }(), xe = e(ge);
        class be {
            constructor(t1, ...e){
                nt(this, e[0] || {}), this.type = t1;
            }
        }
        class ve extends be {
            constructor(t1, e = {}){
                super("error", nt({
                    error: t1
                }, e));
            }
        }
        function we(t1, e, r) {
            r[t1] && -1 !== r[t1].indexOf(e) || (r[t1] = r[t1] || [], r[t1].push(e));
        }
        function _e(t1, e, r) {
            if (r && r[t1]) {
                const n = r[t1].indexOf(e);
                -1 !== n && r[t1].splice(n, 1);
            }
        }
        class Me {
            on(t1, e) {
                return this._listeners = this._listeners || {}, we(t1, e, this._listeners), this;
            }
            off(t1, e) {
                return _e(t1, e, this._listeners), _e(t1, e, this._oneTimeListeners), this;
            }
            once(t1, e) {
                return e ? (this._oneTimeListeners = this._oneTimeListeners || {}, we(t1, e, this._oneTimeListeners), this) : new Promise((e)=>this.once(t1, e));
            }
            fire(t1, e) {
                const r = "string" == typeof t1 ? new be(t1, e) : t1, n = r.type;
                if (this.listens(n)) {
                    r.target = this;
                    const t1 = this._listeners && this._listeners[n] ? this._listeners[n].slice() : [];
                    for (const e of t1)e.call(this, r);
                    const e = this._oneTimeListeners && this._oneTimeListeners[n] ? this._oneTimeListeners[n].slice() : [];
                    for (const t1 of e)_e(n, t1, this._oneTimeListeners), t1.call(this, r);
                    const i = this._eventedParent;
                    i && (nt(r, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(r));
                } else r instanceof ve && console.error(r.error);
                return this;
            }
            listens(t1) {
                return !!(this._listeners && this._listeners[t1] && this._listeners[t1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t1] && this._oneTimeListeners[t1].length > 0 || this._eventedParent && this._eventedParent.listens(t1));
            }
            setEventedParent(t1, e) {
                return this._eventedParent = t1, this._eventedParentData = e, this;
            }
        }
        var Ae, Se = {}, Ie = function() {
            if (Ae) return Se;
            Ae = 1;
            var t1 = {
                transparent: [
                    0,
                    0,
                    0,
                    0
                ],
                aliceblue: [
                    240,
                    248,
                    255,
                    1
                ],
                antiquewhite: [
                    250,
                    235,
                    215,
                    1
                ],
                aqua: [
                    0,
                    255,
                    255,
                    1
                ],
                aquamarine: [
                    127,
                    255,
                    212,
                    1
                ],
                azure: [
                    240,
                    255,
                    255,
                    1
                ],
                beige: [
                    245,
                    245,
                    220,
                    1
                ],
                bisque: [
                    255,
                    228,
                    196,
                    1
                ],
                black: [
                    0,
                    0,
                    0,
                    1
                ],
                blanchedalmond: [
                    255,
                    235,
                    205,
                    1
                ],
                blue: [
                    0,
                    0,
                    255,
                    1
                ],
                blueviolet: [
                    138,
                    43,
                    226,
                    1
                ],
                brown: [
                    165,
                    42,
                    42,
                    1
                ],
                burlywood: [
                    222,
                    184,
                    135,
                    1
                ],
                cadetblue: [
                    95,
                    158,
                    160,
                    1
                ],
                chartreuse: [
                    127,
                    255,
                    0,
                    1
                ],
                chocolate: [
                    210,
                    105,
                    30,
                    1
                ],
                coral: [
                    255,
                    127,
                    80,
                    1
                ],
                cornflowerblue: [
                    100,
                    149,
                    237,
                    1
                ],
                cornsilk: [
                    255,
                    248,
                    220,
                    1
                ],
                crimson: [
                    220,
                    20,
                    60,
                    1
                ],
                cyan: [
                    0,
                    255,
                    255,
                    1
                ],
                darkblue: [
                    0,
                    0,
                    139,
                    1
                ],
                darkcyan: [
                    0,
                    139,
                    139,
                    1
                ],
                darkgoldenrod: [
                    184,
                    134,
                    11,
                    1
                ],
                darkgray: [
                    169,
                    169,
                    169,
                    1
                ],
                darkgreen: [
                    0,
                    100,
                    0,
                    1
                ],
                darkgrey: [
                    169,
                    169,
                    169,
                    1
                ],
                darkkhaki: [
                    189,
                    183,
                    107,
                    1
                ],
                darkmagenta: [
                    139,
                    0,
                    139,
                    1
                ],
                darkolivegreen: [
                    85,
                    107,
                    47,
                    1
                ],
                darkorange: [
                    255,
                    140,
                    0,
                    1
                ],
                darkorchid: [
                    153,
                    50,
                    204,
                    1
                ],
                darkred: [
                    139,
                    0,
                    0,
                    1
                ],
                darksalmon: [
                    233,
                    150,
                    122,
                    1
                ],
                darkseagreen: [
                    143,
                    188,
                    143,
                    1
                ],
                darkslateblue: [
                    72,
                    61,
                    139,
                    1
                ],
                darkslategray: [
                    47,
                    79,
                    79,
                    1
                ],
                darkslategrey: [
                    47,
                    79,
                    79,
                    1
                ],
                darkturquoise: [
                    0,
                    206,
                    209,
                    1
                ],
                darkviolet: [
                    148,
                    0,
                    211,
                    1
                ],
                deeppink: [
                    255,
                    20,
                    147,
                    1
                ],
                deepskyblue: [
                    0,
                    191,
                    255,
                    1
                ],
                dimgray: [
                    105,
                    105,
                    105,
                    1
                ],
                dimgrey: [
                    105,
                    105,
                    105,
                    1
                ],
                dodgerblue: [
                    30,
                    144,
                    255,
                    1
                ],
                firebrick: [
                    178,
                    34,
                    34,
                    1
                ],
                floralwhite: [
                    255,
                    250,
                    240,
                    1
                ],
                forestgreen: [
                    34,
                    139,
                    34,
                    1
                ],
                fuchsia: [
                    255,
                    0,
                    255,
                    1
                ],
                gainsboro: [
                    220,
                    220,
                    220,
                    1
                ],
                ghostwhite: [
                    248,
                    248,
                    255,
                    1
                ],
                gold: [
                    255,
                    215,
                    0,
                    1
                ],
                goldenrod: [
                    218,
                    165,
                    32,
                    1
                ],
                gray: [
                    128,
                    128,
                    128,
                    1
                ],
                green: [
                    0,
                    128,
                    0,
                    1
                ],
                greenyellow: [
                    173,
                    255,
                    47,
                    1
                ],
                grey: [
                    128,
                    128,
                    128,
                    1
                ],
                honeydew: [
                    240,
                    255,
                    240,
                    1
                ],
                hotpink: [
                    255,
                    105,
                    180,
                    1
                ],
                indianred: [
                    205,
                    92,
                    92,
                    1
                ],
                indigo: [
                    75,
                    0,
                    130,
                    1
                ],
                ivory: [
                    255,
                    255,
                    240,
                    1
                ],
                khaki: [
                    240,
                    230,
                    140,
                    1
                ],
                lavender: [
                    230,
                    230,
                    250,
                    1
                ],
                lavenderblush: [
                    255,
                    240,
                    245,
                    1
                ],
                lawngreen: [
                    124,
                    252,
                    0,
                    1
                ],
                lemonchiffon: [
                    255,
                    250,
                    205,
                    1
                ],
                lightblue: [
                    173,
                    216,
                    230,
                    1
                ],
                lightcoral: [
                    240,
                    128,
                    128,
                    1
                ],
                lightcyan: [
                    224,
                    255,
                    255,
                    1
                ],
                lightgoldenrodyellow: [
                    250,
                    250,
                    210,
                    1
                ],
                lightgray: [
                    211,
                    211,
                    211,
                    1
                ],
                lightgreen: [
                    144,
                    238,
                    144,
                    1
                ],
                lightgrey: [
                    211,
                    211,
                    211,
                    1
                ],
                lightpink: [
                    255,
                    182,
                    193,
                    1
                ],
                lightsalmon: [
                    255,
                    160,
                    122,
                    1
                ],
                lightseagreen: [
                    32,
                    178,
                    170,
                    1
                ],
                lightskyblue: [
                    135,
                    206,
                    250,
                    1
                ],
                lightslategray: [
                    119,
                    136,
                    153,
                    1
                ],
                lightslategrey: [
                    119,
                    136,
                    153,
                    1
                ],
                lightsteelblue: [
                    176,
                    196,
                    222,
                    1
                ],
                lightyellow: [
                    255,
                    255,
                    224,
                    1
                ],
                lime: [
                    0,
                    255,
                    0,
                    1
                ],
                limegreen: [
                    50,
                    205,
                    50,
                    1
                ],
                linen: [
                    250,
                    240,
                    230,
                    1
                ],
                magenta: [
                    255,
                    0,
                    255,
                    1
                ],
                maroon: [
                    128,
                    0,
                    0,
                    1
                ],
                mediumaquamarine: [
                    102,
                    205,
                    170,
                    1
                ],
                mediumblue: [
                    0,
                    0,
                    205,
                    1
                ],
                mediumorchid: [
                    186,
                    85,
                    211,
                    1
                ],
                mediumpurple: [
                    147,
                    112,
                    219,
                    1
                ],
                mediumseagreen: [
                    60,
                    179,
                    113,
                    1
                ],
                mediumslateblue: [
                    123,
                    104,
                    238,
                    1
                ],
                mediumspringgreen: [
                    0,
                    250,
                    154,
                    1
                ],
                mediumturquoise: [
                    72,
                    209,
                    204,
                    1
                ],
                mediumvioletred: [
                    199,
                    21,
                    133,
                    1
                ],
                midnightblue: [
                    25,
                    25,
                    112,
                    1
                ],
                mintcream: [
                    245,
                    255,
                    250,
                    1
                ],
                mistyrose: [
                    255,
                    228,
                    225,
                    1
                ],
                moccasin: [
                    255,
                    228,
                    181,
                    1
                ],
                navajowhite: [
                    255,
                    222,
                    173,
                    1
                ],
                navy: [
                    0,
                    0,
                    128,
                    1
                ],
                oldlace: [
                    253,
                    245,
                    230,
                    1
                ],
                olive: [
                    128,
                    128,
                    0,
                    1
                ],
                olivedrab: [
                    107,
                    142,
                    35,
                    1
                ],
                orange: [
                    255,
                    165,
                    0,
                    1
                ],
                orangered: [
                    255,
                    69,
                    0,
                    1
                ],
                orchid: [
                    218,
                    112,
                    214,
                    1
                ],
                palegoldenrod: [
                    238,
                    232,
                    170,
                    1
                ],
                palegreen: [
                    152,
                    251,
                    152,
                    1
                ],
                paleturquoise: [
                    175,
                    238,
                    238,
                    1
                ],
                palevioletred: [
                    219,
                    112,
                    147,
                    1
                ],
                papayawhip: [
                    255,
                    239,
                    213,
                    1
                ],
                peachpuff: [
                    255,
                    218,
                    185,
                    1
                ],
                peru: [
                    205,
                    133,
                    63,
                    1
                ],
                pink: [
                    255,
                    192,
                    203,
                    1
                ],
                plum: [
                    221,
                    160,
                    221,
                    1
                ],
                powderblue: [
                    176,
                    224,
                    230,
                    1
                ],
                purple: [
                    128,
                    0,
                    128,
                    1
                ],
                rebeccapurple: [
                    102,
                    51,
                    153,
                    1
                ],
                red: [
                    255,
                    0,
                    0,
                    1
                ],
                rosybrown: [
                    188,
                    143,
                    143,
                    1
                ],
                royalblue: [
                    65,
                    105,
                    225,
                    1
                ],
                saddlebrown: [
                    139,
                    69,
                    19,
                    1
                ],
                salmon: [
                    250,
                    128,
                    114,
                    1
                ],
                sandybrown: [
                    244,
                    164,
                    96,
                    1
                ],
                seagreen: [
                    46,
                    139,
                    87,
                    1
                ],
                seashell: [
                    255,
                    245,
                    238,
                    1
                ],
                sienna: [
                    160,
                    82,
                    45,
                    1
                ],
                silver: [
                    192,
                    192,
                    192,
                    1
                ],
                skyblue: [
                    135,
                    206,
                    235,
                    1
                ],
                slateblue: [
                    106,
                    90,
                    205,
                    1
                ],
                slategray: [
                    112,
                    128,
                    144,
                    1
                ],
                slategrey: [
                    112,
                    128,
                    144,
                    1
                ],
                snow: [
                    255,
                    250,
                    250,
                    1
                ],
                springgreen: [
                    0,
                    255,
                    127,
                    1
                ],
                steelblue: [
                    70,
                    130,
                    180,
                    1
                ],
                tan: [
                    210,
                    180,
                    140,
                    1
                ],
                teal: [
                    0,
                    128,
                    128,
                    1
                ],
                thistle: [
                    216,
                    191,
                    216,
                    1
                ],
                tomato: [
                    255,
                    99,
                    71,
                    1
                ],
                turquoise: [
                    64,
                    224,
                    208,
                    1
                ],
                violet: [
                    238,
                    130,
                    238,
                    1
                ],
                wheat: [
                    245,
                    222,
                    179,
                    1
                ],
                white: [
                    255,
                    255,
                    255,
                    1
                ],
                whitesmoke: [
                    245,
                    245,
                    245,
                    1
                ],
                yellow: [
                    255,
                    255,
                    0,
                    1
                ],
                yellowgreen: [
                    154,
                    205,
                    50,
                    1
                ]
            };
            function e(t1) {
                return (t1 = Math.round(t1)) < 0 ? 0 : t1 > 255 ? 255 : t1;
            }
            function r(t1) {
                return e("%" === t1[t1.length - 1] ? parseFloat(t1) / 100 * 255 : parseInt(t1));
            }
            function n(t1) {
                var e;
                return (e = "%" === t1[t1.length - 1] ? parseFloat(t1) / 100 : parseFloat(t1)) < 0 ? 0 : e > 1 ? 1 : e;
            }
            function i(t1, e, r) {
                return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? t1 + (e - t1) * r * 6 : 2 * r < 1 ? e : 3 * r < 2 ? t1 + (e - t1) * (2 / 3 - r) * 6 : t1;
            }
            try {
                Se.parseCSSColor = function(s) {
                    var a, o = s.replace(/ /g, "").toLowerCase();
                    if (o in t1) return t1[o].slice();
                    if ("#" === o[0]) return 4 === o.length ? (a = parseInt(o.substr(1), 16)) >= 0 && a <= 4095 ? [
                        (3840 & a) >> 4 | (3840 & a) >> 8,
                        240 & a | (240 & a) >> 4,
                        15 & a | (15 & a) << 4,
                        1
                    ] : null : 7 === o.length && (a = parseInt(o.substr(1), 16)) >= 0 && a <= 16777215 ? [
                        (16711680 & a) >> 16,
                        (65280 & a) >> 8,
                        255 & a,
                        1
                    ] : null;
                    var l = o.indexOf("("), u = o.indexOf(")");
                    if (-1 !== l && u + 1 === o.length) {
                        var c = o.substr(0, l), h = o.substr(l + 1, u - (l + 1)).split(","), p = 1;
                        switch(c){
                            case "rgba":
                                if (4 !== h.length) return null;
                                p = n(h.pop());
                            case "rgb":
                                return 3 !== h.length ? null : [
                                    r(h[0]),
                                    r(h[1]),
                                    r(h[2]),
                                    p
                                ];
                            case "hsla":
                                if (4 !== h.length) return null;
                                p = n(h.pop());
                            case "hsl":
                                if (3 !== h.length) return null;
                                var f = (parseFloat(h[0]) % 360 + 360) % 360 / 360, d = n(h[1]), m = n(h[2]), y = m <= .5 ? m * (d + 1) : m + d - m * d, g = 2 * m - y;
                                return [
                                    e(255 * i(g, y, f + 1 / 3)),
                                    e(255 * i(g, y, f)),
                                    e(255 * i(g, y, f - 1 / 3)),
                                    p
                                ];
                            default:
                                return null;
                        }
                    }
                    return null;
                };
            } catch (t1) {}
            return Se;
        }();
        class Pe {
            constructor(t1, e, r, n = 1){
                this.r = t1, this.g = e, this.b = r, this.a = n;
            }
            static parse(t1) {
                if (!t1) return;
                if (t1 instanceof Pe) return t1;
                if ("string" != typeof t1) return;
                const e = Ie.parseCSSColor(t1);
                return e ? new Pe(e[0] / 255 * e[3], e[1] / 255 * e[3], e[2] / 255 * e[3], e[3]) : void 0;
            }
            toString() {
                const [t1, e, r, n] = 0 === this.a ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    255 * this.r / this.a,
                    255 * this.g / this.a,
                    255 * this.b / this.a,
                    this.a
                ];
                return `rgba(${Math.round(t1)},${Math.round(e)},${Math.round(r)},${n})`;
            }
            toRenderColor(t1) {
                const { r: e, g: r, b: n, a: i } = this;
                return new ze(t1, e, r, n, i);
            }
        }
        class ze {
            constructor(t1, e, r, n, i){
                if (t1) {
                    const s = t1.image.height, a = s * s;
                    e = 0 === i ? 0 : e / i * (s - 1), r = 0 === i ? 0 : r / i * (s - 1), n = 0 === i ? 0 : n / i * (s - 1);
                    const o = Math.floor(e), l = Math.floor(r), u = Math.floor(n), c = Math.ceil(e), h = Math.ceil(r), p = Math.ceil(n), f = e - o, d = r - l, m = n - u, y = t1.image.data, g = 4 * (o + l * a + u * s), x = 4 * (o + l * a + p * s), b = 4 * (o + h * a + u * s), v = 4 * (o + h * a + p * s), w = 4 * (c + l * a + u * s), _ = 4 * (c + l * a + p * s), M = 4 * (c + h * a + u * s), A = 4 * (c + h * a + p * s);
                    if (g < 0 || A >= y.length) throw new Error("out of range");
                    this.r = ke(ke(ke(y[g], y[x], m), ke(y[b], y[v], m), d), ke(ke(y[w], y[_], m), ke(y[M], y[A], m), d), f) / 255 * i, this.g = ke(ke(ke(y[g + 1], y[x + 1], m), ke(y[b + 1], y[v + 1], m), d), ke(ke(y[w + 1], y[_ + 1], m), ke(y[M + 1], y[A + 1], m), d), f) / 255 * i, this.b = ke(ke(ke(y[g + 2], y[x + 2], m), ke(y[b + 2], y[v + 2], m), d), ke(ke(y[w + 2], y[_ + 2], m), ke(y[M + 2], y[A + 2], m), d), f) / 255 * i, this.a = i;
                } else this.r = e, this.g = r, this.b = n, this.a = i;
            }
            toArray() {
                const { r: t1, g: e, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    255 * t1 / n,
                    255 * e / n,
                    255 * r / n,
                    n
                ];
            }
            toArray01() {
                const { r: t1, g: e, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    t1 / n,
                    e / n,
                    r / n,
                    n
                ];
            }
            toArray01Scaled(t1) {
                const { r: e, g: r, b: n, a: i } = this;
                return 0 === i ? [
                    0,
                    0,
                    0
                ] : [
                    e / i * t1,
                    r / i * t1,
                    n / i * t1
                ];
            }
            toArray01PremultipliedAlpha() {
                const { r: t1, g: e, b: r, a: n } = this;
                return [
                    t1,
                    e,
                    r,
                    n
                ];
            }
            toArray01Linear() {
                const { r: t1, g: e, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    Math.pow(t1 / n, 2.2),
                    Math.pow(e / n, 2.2),
                    Math.pow(r / n, 2.2),
                    n
                ];
            }
        }
        function ke(t1, e, r) {
            return t1 * (1 - r) + e * r;
        }
        function Te(t1, e, r) {
            return t1.map((t1, n)=>ke(t1, e[n], r));
        }
        Pe.black = new Pe(0, 0, 0, 1), Pe.white = new Pe(1, 1, 1, 1), Pe.transparent = new Pe(0, 0, 0, 0), Pe.red = new Pe(1, 0, 0, 1), Pe.blue = new Pe(0, 0, 1, 1);
        var Ee = Object.freeze({
            __proto__: null,
            array: Te,
            color: function(t1, e, r) {
                return new Pe(ke(t1.r, e.r, r), ke(t1.g, e.g, r), ke(t1.b, e.b, r), ke(t1.a, e.a, r));
            },
            number: ke
        });
        function Be(t1, ...e) {
            for (const r of e)for(const e in r)t1[e] = r[e];
            return t1;
        }
        class Ve extends Error {
            constructor(t1, e){
                super(e), this.message = e, this.key = t1;
            }
        }
        class Ce {
            constructor(t1, e = []){
                this.parent = t1, this.bindings = {};
                for (const [t1, r] of e)this.bindings[t1] = r;
            }
            concat(t1) {
                return new Ce(this, t1);
            }
            get(t1) {
                if (this.bindings[t1]) return this.bindings[t1];
                if (this.parent) return this.parent.get(t1);
                throw new Error(`${t1} not found in scope.`);
            }
            has(t1) {
                return !!this.bindings[t1] || !!this.parent && this.parent.has(t1);
            }
        }
        const Re = {
            kind: "null"
        }, De = {
            kind: "number"
        }, Le = {
            kind: "string"
        }, Fe = {
            kind: "boolean"
        }, Oe = {
            kind: "color"
        }, Ue = {
            kind: "object"
        }, je = {
            kind: "value"
        }, Ne = {
            kind: "collator"
        }, qe = {
            kind: "formatted"
        }, $e = {
            kind: "resolvedImage"
        };
        function Ge(t1, e) {
            return {
                kind: "array",
                itemType: t1,
                N: e
            };
        }
        function Xe(t1) {
            if ("array" === t1.kind) {
                const e = Xe(t1.itemType);
                return "number" == typeof t1.N ? `array<${e}, ${t1.N}>` : "value" === t1.itemType.kind ? "array" : `array<${e}>`;
            }
            return t1.kind;
        }
        const Ye = [
            Re,
            De,
            Le,
            Fe,
            Oe,
            qe,
            Ue,
            Ge(je),
            $e
        ];
        function Ze(t1, e) {
            if ("error" === e.kind) return null;
            if ("array" === t1.kind) {
                if ("array" === e.kind && (0 === e.N && "value" === e.itemType.kind || !Ze(t1.itemType, e.itemType)) && ("number" != typeof t1.N || t1.N === e.N)) return null;
            } else {
                if (t1.kind === e.kind) return null;
                if ("value" === t1.kind) {
                    for (const t1 of Ye)if (!Ze(t1, e)) return null;
                }
            }
            return `Expected ${Xe(t1)} but found ${Xe(e)} instead.`;
        }
        function We(t1, e) {
            return e.some((e)=>e.kind === t1.kind);
        }
        function He(t1, e) {
            return e.some((e)=>"null" === e ? null === t1 : "array" === e ? Array.isArray(t1) : "object" === e ? t1 && !Array.isArray(t1) && "object" == typeof t1 : e === typeof t1);
        }
        class Ke {
            constructor(t1, e, r){
                this.sensitivity = t1 ? e ? "variant" : "case" : e ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(t1, e) {
                return this.collator.compare(t1, e);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        class Je {
            constructor(t1, e, r, n, i){
                this.text = t1.normalize ? t1.normalize() : t1, this.image = e, this.scale = r, this.fontStack = n, this.textColor = i;
            }
        }
        class Qe {
            constructor(t1){
                this.sections = t1;
            }
            static fromString(t1) {
                return new Qe([
                    new Je(t1, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((t1)=>0 !== t1.text.length || t1.image && 0 !== t1.image.namePrimary.length);
            }
            static factory(t1) {
                return t1 instanceof Qe ? t1 : Qe.fromString(t1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((t1)=>t1.text).join("");
            }
            serialize() {
                const t1 = [
                    "format"
                ];
                for (const e of this.sections){
                    if (e.image) {
                        t1.push([
                            "image",
                            e.image.namePrimary
                        ]);
                        continue;
                    }
                    t1.push(e.text);
                    const r = {};
                    e.fontStack && (r["text-font"] = [
                        "literal",
                        e.fontStack.split(",")
                    ]), e.scale && (r["font-scale"] = e.scale), e.textColor && (r["text-color"] = [
                        "rgba"
                    ].concat(e.textColor.toRenderColor(null).toArray())), t1.push(r);
                }
                return t1;
            }
        }
        class tr {
            constructor(t1){
                this.namePrimary = t1.namePrimary, t1.nameSecondary && (this.nameSecondary = t1.nameSecondary), this.available = t1.available;
            }
            toString() {
                return this.nameSecondary ? `[${this.namePrimary},${this.nameSecondary}]` : this.namePrimary;
            }
            static fromString(t1, e) {
                return t1 ? new tr({
                    namePrimary: t1,
                    nameSecondary: e,
                    available: !1
                }) : null;
            }
            serialize() {
                return this.nameSecondary ? [
                    "image",
                    this.namePrimary,
                    this.nameSecondary
                ] : [
                    "image",
                    this.namePrimary
                ];
            }
        }
        function er(t1, e, r, n) {
            return "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                t1,
                e,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                t1,
                e,
                r,
                n
            ] : [
                t1,
                e,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function rr(t1) {
            if (null === t1) return !0;
            if ("string" == typeof t1) return !0;
            if ("boolean" == typeof t1) return !0;
            if ("number" == typeof t1) return !0;
            if (t1 instanceof Pe) return !0;
            if (t1 instanceof Ke) return !0;
            if (t1 instanceof Qe) return !0;
            if (t1 instanceof tr) return !0;
            if (Array.isArray(t1)) {
                for (const e of t1)if (!rr(e)) return !1;
                return !0;
            }
            if ("object" == typeof t1) {
                for(const e in t1)if (!rr(t1[e])) return !1;
                return !0;
            }
            return !1;
        }
        function nr(t1) {
            if (null === t1) return Re;
            if ("string" == typeof t1) return Le;
            if ("boolean" == typeof t1) return Fe;
            if ("number" == typeof t1) return De;
            if (t1 instanceof Pe) return Oe;
            if (t1 instanceof Ke) return Ne;
            if (t1 instanceof Qe) return qe;
            if (t1 instanceof tr) return $e;
            if (Array.isArray(t1)) {
                const e = t1.length;
                let r;
                for (const e of t1){
                    const t1 = nr(e);
                    if (r) {
                        if (r === t1) continue;
                        r = je;
                        break;
                    }
                    r = t1;
                }
                return Ge(r || je, e);
            }
            return Ue;
        }
        function ir(t1) {
            const e = typeof t1;
            return null === t1 ? "" : "string" === e || "number" === e || "boolean" === e ? String(t1) : t1 instanceof Pe || t1 instanceof Qe || t1 instanceof tr ? t1.toString() : JSON.stringify(t1);
        }
        class sr {
            constructor(t1, e){
                this.type = t1, this.value = e;
            }
            static parse(t1, e) {
                if (2 !== t1.length) return e.error(`'literal' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (!rr(t1[1])) return e.error("invalid value");
                const r = t1[1];
                let n = nr(r);
                const i = e.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new sr(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return "array" === this.type.kind || "object" === this.type.kind ? [
                    "literal",
                    this.value
                ] : this.value instanceof Pe ? [
                    "rgba"
                ].concat(this.value.toRenderColor(null).toArray()) : this.value instanceof Qe ? this.value.serialize() : this.value;
            }
        }
        class ar {
            constructor(t1){
                this.name = "ExpressionEvaluationError", this.message = t1;
            }
            toJSON() {
                return this.message;
            }
        }
        const or = {
            string: Le,
            number: De,
            boolean: Fe,
            object: Ue
        };
        class lr {
            constructor(t1, e){
                this.type = t1, this.args = e;
            }
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expected at least one argument.");
                let r, n = 1;
                const i = t1[0];
                if ("array" === i) {
                    let i, s;
                    if (t1.length > 2) {
                        const r = t1[1];
                        if ("string" != typeof r || !(r in or) || "object" === r) return e.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = or[r], n++;
                    } else i = je;
                    if (t1.length > 3) {
                        if (null !== t1[2] && ("number" != typeof t1[2] || t1[2] < 0 || t1[2] !== Math.floor(t1[2]))) return e.error('The length argument to "array" must be a positive integer literal', 2);
                        s = t1[2], n++;
                    }
                    r = Ge(i, s);
                } else r = or[i];
                const s = [];
                for(; n < t1.length; n++){
                    const r = e.parse(t1[n], n, je);
                    if (!r) return null;
                    s.push(r);
                }
                return new lr(r, s);
            }
            evaluate(t1) {
                for(let e = 0; e < this.args.length; e++){
                    const r = this.args[e].evaluate(t1);
                    if (!Ze(this.type, nr(r))) return r;
                    if (e === this.args.length - 1) throw new ar(`The expression ${JSON.stringify(this.args[e].serialize())} evaluated to ${Xe(nr(r))} but was expected to be of type ${Xe(this.type)}.`);
                }
                return null;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = this.type, e = [
                    t1.kind
                ];
                if ("array" === t1.kind) {
                    const r = t1.itemType;
                    if ("string" === r.kind || "number" === r.kind || "boolean" === r.kind) {
                        e.push(r.kind);
                        const n = t1.N;
                        ("number" == typeof n || this.args.length > 1) && e.push(n);
                    }
                }
                return e.concat(this.args.map((t1)=>t1.serialize()));
            }
        }
        class ur {
            constructor(t1){
                this.type = qe, this.sections = t1;
            }
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expected at least one argument.");
                const r = t1[1];
                if (!Array.isArray(r) && "object" == typeof r) return e.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= t1.length - 1; ++r){
                    const s = t1[r];
                    if (i && "object" == typeof s && !Array.isArray(s)) {
                        i = !1;
                        let t1 = null;
                        if (s["font-scale"] && (t1 = e.parseObjectValue(s["font-scale"], r, "font-scale", De), !t1)) return null;
                        let a = null;
                        if (s["text-font"] && (a = e.parseObjectValue(s["text-font"], r, "text-font", Ge(Le)), !a)) return null;
                        let o = null;
                        if (s["text-color"] && (o = e.parseObjectValue(s["text-color"], r, "text-color", Oe), !o)) return null;
                        const l = n[n.length - 1];
                        l.scale = t1, l.font = a, l.textColor = o;
                    } else {
                        const s = e.parse(t1[r], r, je);
                        if (!s) return null;
                        const a = s.type.kind;
                        if ("string" !== a && "value" !== a && "null" !== a && "resolvedImage" !== a) return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: s,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new ur(n);
            }
            evaluate(t1) {
                return new Qe(this.sections.map((e)=>{
                    const r = e.content.evaluate(t1);
                    return nr(r) === $e ? new Je("", r, null, null, null) : new Je(ir(r), null, e.scale ? e.scale.evaluate(t1) : null, e.font ? e.font.evaluate(t1).join(",") : null, e.textColor ? e.textColor.evaluate(t1) : null);
                }));
            }
            eachChild(t1) {
                for (const e of this.sections)t1(e.content), e.scale && t1(e.scale), e.font && t1(e.font), e.textColor && t1(e.textColor);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "format"
                ];
                for (const e of this.sections){
                    t1.push(e.content.serialize());
                    const r = {};
                    e.scale && (r["font-scale"] = e.scale.serialize()), e.font && (r["text-font"] = e.font.serialize()), e.textColor && (r["text-color"] = e.textColor.serialize()), t1.push(r);
                }
                return t1;
            }
        }
        class cr {
            constructor(t1, e){
                this.type = $e, this.inputPrimary = t1, this.inputSecondary = e;
            }
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expected two or more arguments.");
                const r = e.parse(t1[1], 1, Le);
                if (!r) return e.error("No image name provided.");
                if (2 === t1.length) return new cr(r);
                const n = e.parse(t1[2], 1, Le);
                return n ? new cr(r, n) : e.error("Secondary image variant is not a string.");
            }
            evaluate(t1) {
                const e = tr.fromString(this.inputPrimary.evaluate(t1), this.inputSecondary ? this.inputSecondary.evaluate(t1) : void 0);
                return e && t1.availableImages && (e.available = t1.availableImages.indexOf(e.namePrimary) > -1, e.nameSecondary && e.available && t1.availableImages && (e.available = t1.availableImages.indexOf(e.nameSecondary) > -1)), e;
            }
            eachChild(t1) {
                t1(this.inputPrimary), this.inputSecondary && t1(this.inputSecondary);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return this.inputSecondary ? [
                    "image",
                    this.inputPrimary.serialize(),
                    this.inputSecondary.serialize()
                ] : [
                    "image",
                    this.inputPrimary.serialize()
                ];
            }
        }
        function hr(t1) {
            return t1 instanceof Number ? "number" : t1 instanceof String ? "string" : t1 instanceof Boolean ? "boolean" : Array.isArray(t1) ? "array" : null === t1 ? "null" : typeof t1;
        }
        const pr = {
            "to-boolean": Fe,
            "to-color": Oe,
            "to-number": De,
            "to-string": Le
        };
        class fr {
            constructor(t1, e){
                this.type = t1, this.args = e;
            }
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expected at least one argument.");
                const r = t1[0], n = [];
                let i = Re;
                if ("to-array" === r) {
                    if (!Array.isArray(t1[1])) return null;
                    const r = t1[1].length;
                    if (e.expectedType) {
                        if ("array" !== e.expectedType.kind) return e.error(`Expected ${e.expectedType.kind} but found array.`);
                        i = Ge(e.expectedType.itemType, r);
                    } else {
                        if (!(r > 0 && rr(t1[1][0]))) return null;
                        i = Ge(nr(t1[1][0]), r);
                    }
                    for(let s = 0; s < r; s++){
                        const r = t1[1][s];
                        let a;
                        if ("array" === hr(r)) a = e.parse(r, void 0, i.itemType);
                        else {
                            const t1 = hr(r);
                            if (t1 !== i.itemType.kind) return e.error(`Expected ${i.itemType.kind} but found ${t1}.`);
                            a = e.registry.literal.parse([
                                "literal",
                                void 0 === r ? null : r
                            ], e);
                        }
                        if (!a) return null;
                        n.push(a);
                    }
                } else {
                    if (("to-boolean" === r || "to-string" === r) && 2 !== t1.length) return e.error("Expected one argument.");
                    i = pr[r];
                    for(let r = 1; r < t1.length; r++){
                        const i = e.parse(t1[r], r, je);
                        if (!i) return null;
                        n.push(i);
                    }
                }
                return new fr(i, n);
            }
            evaluate(t1) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t1));
                if ("color" === this.type.kind) {
                    let e, r;
                    for (const n of this.args){
                        if (e = n.evaluate(t1), r = null, e instanceof Pe) return e;
                        if ("string" == typeof e) {
                            const r = t1.parseColor(e);
                            if (r) return r;
                        } else if (Array.isArray(e) && (r = e.length < 3 || e.length > 4 ? `Invalid rbga value ${JSON.stringify(e)}: expected an array containing either three or four numeric values.` : er(e[0], e[1], e[2], e[3]), !r)) return new Pe(e[0] / 255, e[1] / 255, e[2] / 255, e[3]);
                    }
                    throw new ar(r || `Could not parse color from value '${"string" == typeof e ? e : String(JSON.stringify(e))}'`);
                }
                if ("number" === this.type.kind) {
                    let e = null;
                    for (const r of this.args){
                        if (e = r.evaluate(t1), null === e) return 0;
                        const n = Number(e);
                        if (!isNaN(n)) return n;
                    }
                    throw new ar(`Could not convert ${JSON.stringify(e)} to number.`);
                }
                return "formatted" === this.type.kind ? Qe.fromString(ir(this.args[0].evaluate(t1))) : "resolvedImage" === this.type.kind ? tr.fromString(ir(this.args[0].evaluate(t1))) : "array" === this.type.kind ? this.args.map((e)=>e.evaluate(t1)) : ir(this.args[0].evaluate(t1));
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                if ("formatted" === this.type.kind) return new ur([
                    {
                        content: this.args[0],
                        scale: null,
                        font: null,
                        textColor: null
                    }
                ]).serialize();
                if ("resolvedImage" === this.type.kind) return new cr(this.args[0]).serialize();
                const t1 = "array" === this.type.kind ? [] : [
                    `to-${this.type.kind}`
                ];
                return this.eachChild((e)=>{
                    t1.push(e.serialize());
                }), t1;
            }
        }
        const dr = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class mr {
            constructor(t1, e){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.scope = t1, this.options = e;
            }
            id() {
                return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? dr[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            measureLight(t1) {
                return this.globals.brightness || 0;
            }
            distanceFromCenter() {
                if (this.featureTileCoord && this.featureDistanceData) {
                    const t1 = this.featureDistanceData.center, e = this.featureDistanceData.scale, { x: r, y: n } = this.featureTileCoord;
                    return this.featureDistanceData.bearing[0] * (r * e - t1[0]) + this.featureDistanceData.bearing[1] * (n * e - t1[1]);
                }
                return 0;
            }
            parseColor(t1) {
                let e = this._parseColorCache[t1];
                return e || (e = this._parseColorCache[t1] = Pe.parse(t1)), e;
            }
            getConfig(t1) {
                return this.options ? this.options.get(t1) : null;
            }
        }
        class yr {
            constructor(t1, e, r, n, i){
                this.name = t1, this.type = e, this._evaluate = r, this.args = n, this._overloadIndex = i;
            }
            evaluate(t1) {
                if (!this._evaluate) {
                    const t1 = yr.definitions[this.name];
                    this._evaluate = Array.isArray(t1) ? t1[2] : t1.overloads[this._overloadIndex][1];
                }
                return this._evaluate(t1, this.args);
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    this.name
                ].concat(this.args.map((t1)=>t1.serialize()));
            }
            static parse(t1, e) {
                const r = t1[0], n = yr.definitions[r];
                if (!n) return e.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, s = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, a = [];
                let o = null, l = -1;
                for (const [n, u] of s){
                    if (Array.isArray(n) && n.length !== t1.length - 1) continue;
                    a.push(n), l++, o = new Ln(e.registry, e.path, null, e.scope, void 0, e._scope, e.options);
                    const s = [];
                    let c = !1;
                    for(let e = 1; e < t1.length; e++){
                        const r = t1[e], i = Array.isArray(n) ? n[e - 1] : n.type, a = o.parse(r, 1 + s.length, i);
                        if (!a) {
                            c = !0;
                            break;
                        }
                        s.push(a);
                    }
                    if (!c) {
                        if (Array.isArray(n) && n.length !== s.length) o.error(`Expected ${n.length} arguments, but found ${s.length} instead.`);
                        else {
                            for(let t1 = 0; t1 < s.length; t1++){
                                const e = Array.isArray(n) ? n[t1] : n.type, r = s[t1];
                                o.concat(t1 + 1).checkSubtype(e, r.type);
                            }
                            if (0 === o.errors.length) return new yr(r, i, u, s, l);
                        }
                    }
                }
                if (1 === a.length) e.errors.push(...o.errors);
                else {
                    const r = (a.length ? a : s.map(([t1])=>t1)).map(gr).join(" | "), n = [];
                    for(let r = 1; r < t1.length; r++){
                        const i = e.parse(t1[r], 1 + n.length);
                        if (!i) return null;
                        n.push(Xe(i.type));
                    }
                    e.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(t1, e) {
                yr.definitions = e;
                for(const r in e)t1[r] = yr;
            }
        }
        function gr(t1) {
            return Array.isArray(t1) ? `(${t1.map(Xe).join(", ")})` : `(${Xe(t1.type)}...)`;
        }
        class xr {
            constructor(t1, e, r){
                this.type = Ne, this.locale = r, this.caseSensitive = t1, this.diacriticSensitive = e;
            }
            static parse(t1, e) {
                if (2 !== t1.length) return e.error("Expected one argument.");
                const r = t1[1];
                if ("object" != typeof r || Array.isArray(r)) return e.error("Collator options argument must be an object.");
                const n = void 0 === r["case-sensitive"] ? e.parse(!1, 1, Fe) : e.parseObjectValue(r["case-sensitive"], 1, "case-sensitive", Fe);
                if (!n) return null;
                const i = void 0 === r["diacritic-sensitive"] ? e.parse(!1, 1, Fe) : e.parseObjectValue(r["diacritic-sensitive"], 1, "diacritic-sensitive", Fe);
                if (!i) return null;
                let s = null;
                return r.locale && (s = e.parseObjectValue(r.locale, 1, "locale", Le), !s) ? null : new xr(n, i, s);
            }
            evaluate(t1) {
                return new Ke(this.caseSensitive.evaluate(t1), this.diacriticSensitive.evaluate(t1), this.locale ? this.locale.evaluate(t1) : null);
            }
            eachChild(t1) {
                t1(this.caseSensitive), t1(this.diacriticSensitive), this.locale && t1(this.locale);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = {};
                return t1["case-sensitive"] = this.caseSensitive.serialize(), t1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t1.locale = this.locale.serialize()), [
                    "collator",
                    t1
                ];
            }
        }
        function br(t1, e, r = 0, n = t1.length - 1, i = wr) {
            for(; n > r;){
                if (n - r > 600) {
                    const s = n - r + 1, a = e - r + 1, o = Math.log(s), l = .5 * Math.exp(2 * o / 3), u = .5 * Math.sqrt(o * l * (s - l) / s) * (a - s / 2 < 0 ? -1 : 1);
                    br(t1, e, Math.max(r, Math.floor(e - a * l / s + u)), Math.min(n, Math.floor(e + (s - a) * l / s + u)), i);
                }
                const s = t1[e];
                let a = r, o = n;
                for(vr(t1, r, e), i(t1[n], s) > 0 && vr(t1, r, n); a < o;){
                    for(vr(t1, a, o), a++, o--; i(t1[a], s) < 0;)a++;
                    for(; i(t1[o], s) > 0;)o--;
                }
                0 === i(t1[r], s) ? vr(t1, r, o) : (o++, vr(t1, o, n)), o <= e && (r = o + 1), e <= o && (n = o - 1);
            }
        }
        function vr(t1, e, r) {
            const n = t1[e];
            t1[e] = t1[r], t1[r] = n;
        }
        function wr(t1, e) {
            return t1 < e ? -1 : t1 > e ? 1 : 0;
        }
        function _r(t1) {
            let e = 0;
            for(let r, n, i = 0, s = t1.length, a = s - 1; i < s; a = i++)r = t1[i], n = t1[a], e += (n.x - r.x) * (r.y + n.y);
            return e;
        }
        function Mr(t1, e) {
            t1[0] = Math.min(t1[0], e[0]), t1[1] = Math.min(t1[1], e[1]), t1[2] = Math.max(t1[2], e[0]), t1[3] = Math.max(t1[3], e[1]);
        }
        function Ar(t1, e) {
            return !(t1[0] <= e[0] || t1[2] >= e[2] || t1[1] <= e[1] || t1[3] >= e[3]);
        }
        function Sr(t1, e, r) {
            const n = t1[0] - e[0], i = t1[1] - e[1], s = t1[0] - r[0], a = t1[1] - r[1];
            return n * a - s * i == 0 && n * s <= 0 && i * a <= 0;
        }
        function Ir(t1, e, r = !1) {
            let n = !1;
            for(let o = 0, l = e.length; o < l; o++){
                const l = e[o];
                for(let e = 0, o = l.length, u = o - 1; e < o; u = e++){
                    const o = l[u], c = l[e];
                    if (Sr(t1, o, c)) return r;
                    (s = o)[1] > (i = t1)[1] != (a = c)[1] > i[1] && i[0] < (a[0] - s[0]) * (i[1] - s[1]) / (a[1] - s[1]) + s[0] && (n = !n);
                }
            }
            var i, s, a;
            return n;
        }
        function Pr(t1, e, r, n) {
            const i = n[0] - r[0], s = n[1] - r[1], a = (t1[0] - r[0]) * s - i * (t1[1] - r[1]), o = (e[0] - r[0]) * s - i * (e[1] - r[1]);
            return a > 0 && o < 0 || a < 0 && o > 0;
        }
        function zr(t1, e, r, n) {
            var i, s;
            return 0 != (i = [
                n[0] - r[0],
                n[1] - r[1]
            ])[0] * (s = [
                e[0] - t1[0],
                e[1] - t1[1]
            ])[1] - i[1] * s[0] && !(!Pr(t1, e, r, n) || !Pr(r, n, t1, e));
        }
        const kr = 8192;
        function Tr(t1, e) {
            const r = (180 + t1[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1[1] * Math.PI / 360))) / 360, i = Math.pow(2, e.z);
            return [
                Math.round(r * i * kr),
                Math.round(n * i * kr)
            ];
        }
        function Er(t1, e) {
            for(let r = 0; r < e.length; r++)if (Ir(t1, e[r])) return !0;
            return !1;
        }
        function Br(t1, e, r) {
            for (const n of r)for(let r = 0, i = n.length, s = i - 1; r < i; s = r++)if (zr(t1, e, n[s], n[r])) return !0;
            return !1;
        }
        function Vr(t1, e) {
            for(let r = 0; r < t1.length; ++r)if (!Ir(t1[r], e)) return !1;
            for(let r = 0; r < t1.length - 1; ++r)if (Br(t1[r], t1[r + 1], e)) return !1;
            return !0;
        }
        function Cr(t1, e) {
            for(let r = 0; r < e.length; r++)if (Vr(t1, e[r])) return !0;
            return !1;
        }
        function Rr(t1, e, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const s = [];
                for(let n = 0; n < t1[i].length; n++){
                    const a = Tr(t1[i][n], r);
                    Mr(e, a), s.push(a);
                }
                n.push(s);
            }
            return n;
        }
        function Dr(t1, e, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const s = Rr(t1[i], e, r);
                n.push(s);
            }
            return n;
        }
        function Lr(t1, e, r, n) {
            if (t1[0] < r[0] || t1[0] > r[2]) {
                const e = .5 * n;
                let i = t1[0] - r[0] > e ? -n : r[0] - t1[0] > e ? n : 0;
                0 === i && (i = t1[0] - r[2] > e ? -n : r[2] - t1[0] > e ? n : 0), t1[0] += i;
            }
            Mr(e, t1);
        }
        function Fr(t1, e, r, n) {
            const i = Math.pow(2, n.z) * kr, s = [
                n.x * kr,
                n.y * kr
            ], a = [];
            if (!t1) return a;
            for (const n of t1)for (const t1 of n){
                const n = [
                    t1.x + s[0],
                    t1.y + s[1]
                ];
                Lr(n, e, r, i), a.push(n);
            }
            return a;
        }
        function Or(t1, e, r, n) {
            const i = Math.pow(2, n.z) * kr, s = [
                n.x * kr,
                n.y * kr
            ], a = [];
            if (!t1) return a;
            for (const r of t1){
                const t1 = [];
                for (const n of r){
                    const r = [
                        n.x + s[0],
                        n.y + s[1]
                    ];
                    Mr(e, r), t1.push(r);
                }
                a.push(t1);
            }
            if (e[2] - e[0] <= i / 2) {
                (o = e)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                for (const t1 of a)for (const n of t1)Lr(n, e, r, i);
            }
            var o;
            return a;
        }
        class Ur {
            constructor(t1, e){
                this.type = Fe, this.geojson = t1, this.geometries = e;
            }
            static parse(t1, e) {
                if (2 !== t1.length) return e.error(`'within' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (rr(t1[1])) {
                    const e = t1[1];
                    if ("FeatureCollection" === e.type) for(let t1 = 0; t1 < e.features.length; ++t1){
                        const r = e.features[t1].geometry.type;
                        if ("Polygon" === r || "MultiPolygon" === r) return new Ur(e, e.features[t1].geometry);
                    }
                    else if ("Feature" === e.type) {
                        const t1 = e.geometry.type;
                        if ("Polygon" === t1 || "MultiPolygon" === t1) return new Ur(e, e.geometry);
                    } else if ("Polygon" === e.type || "MultiPolygon" === e.type) return new Ur(e, e);
                }
                return e.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t1) {
                if (null != t1.geometry() && null != t1.canonicalID()) {
                    if ("Point" === t1.geometryType()) return function(t1, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === e.type) {
                            const s = Rr(e.coordinates, n, i), a = Fr(t1.geometry(), r, n, i);
                            if (!Ar(r, n)) return !1;
                            for (const t1 of a)if (!Ir(t1, s)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const s = Dr(e.coordinates, n, i), a = Fr(t1.geometry(), r, n, i);
                            if (!Ar(r, n)) return !1;
                            for (const t1 of a)if (!Er(t1, s)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                    if ("LineString" === t1.geometryType()) return function(t1, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === e.type) {
                            const s = Rr(e.coordinates, n, i), a = Or(t1.geometry(), r, n, i);
                            if (!Ar(r, n)) return !1;
                            for (const t1 of a)if (!Vr(t1, s)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const s = Dr(e.coordinates, n, i), a = Or(t1.geometry(), r, n, i);
                            if (!Ar(r, n)) return !1;
                            for (const t1 of a)if (!Cr(t1, s)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "within",
                    this.geojson
                ];
            }
        }
        const jr = {
            kilometers: 1,
            miles: 1e3 / 1609.344,
            nauticalmiles: 1e3 / 1852,
            meters: 1e3,
            metres: 1e3,
            yards: 1e3 / .9144,
            feet: 1e3 / .3048,
            inches: 1e3 / .0254
        }, Nr = 1 / 298.257223563, qr = Nr * (2 - Nr), $r = Math.PI / 180;
        class Gr {
            static fromTile(t1, e, r) {
                const n = Math.PI * (1 - 2 * (t1 + .5) / Math.pow(2, e)), i = Math.atan(.5 * (Math.exp(n) - Math.exp(-n))) / $r;
                return new Gr(i, r);
            }
            static get units() {
                return jr;
            }
            constructor(t1, e){
                if (void 0 === t1) throw new Error("No latitude given.");
                if (e && !jr[e]) throw new Error(`Unknown unit ${e}. Use one of: ${Object.keys(jr).join(", ")}`);
                const r = 6378.137 * $r * (e ? jr[e] : 1), n = Math.cos(t1 * $r), i = 1 / (1 - qr * (1 - n * n)), s = Math.sqrt(i);
                this.kx = r * s * n, this.ky = r * s * i * (1 - qr);
            }
            distance(t1, e) {
                const r = Zr(t1[0] - e[0]) * this.kx, n = (t1[1] - e[1]) * this.ky;
                return Math.sqrt(r * r + n * n);
            }
            bearing(t1, e) {
                const r = Zr(e[0] - t1[0]) * this.kx;
                return Math.atan2(r, (e[1] - t1[1]) * this.ky) / $r;
            }
            destination(t1, e, r) {
                const n = r * $r;
                return this.offset(t1, Math.sin(n) * e, Math.cos(n) * e);
            }
            offset(t1, e, r) {
                return [
                    t1[0] + e / this.kx,
                    t1[1] + r / this.ky
                ];
            }
            lineDistance(t1) {
                let e = 0;
                for(let r = 0; r < t1.length - 1; r++)e += this.distance(t1[r], t1[r + 1]);
                return e;
            }
            area(t1) {
                let e = 0;
                for(let r = 0; r < t1.length; r++){
                    const n = t1[r];
                    for(let t1 = 0, i = n.length, s = i - 1; t1 < i; s = t1++)e += Zr(n[t1][0] - n[s][0]) * (n[t1][1] + n[s][1]) * (r ? -1 : 1);
                }
                return Math.abs(e) / 2 * this.kx * this.ky;
            }
            along(t1, e) {
                let r = 0;
                if (e <= 0) return t1[0];
                for(let n = 0; n < t1.length - 1; n++){
                    const i = t1[n], s = t1[n + 1], a = this.distance(i, s);
                    if (r += a, r > e) return Yr(i, s, (e - (r - a)) / a);
                }
                return t1[t1.length - 1];
            }
            pointToSegmentDistance(t1, e, r) {
                let [n, i] = e, s = Zr(r[0] - n) * this.kx, a = (r[1] - i) * this.ky;
                if (0 !== s || 0 !== a) {
                    const e = (Zr(t1[0] - n) * this.kx * s + (t1[1] - i) * this.ky * a) / (s * s + a * a);
                    e > 1 ? (n = r[0], i = r[1]) : e > 0 && (n += s / this.kx * e, i += a / this.ky * e);
                }
                return s = Zr(t1[0] - n) * this.kx, a = (t1[1] - i) * this.ky, Math.sqrt(s * s + a * a);
            }
            pointOnLine(t1, e) {
                let r = 1 / 0, n = t1[0][0], i = t1[0][1], s = 0, a = 0;
                for(let o = 0; o < t1.length - 1; o++){
                    let l = t1[o][0], u = t1[o][1], c = Zr(t1[o + 1][0] - l) * this.kx, h = (t1[o + 1][1] - u) * this.ky, p = 0;
                    0 === c && 0 === h || (p = (Zr(e[0] - l) * this.kx * c + (e[1] - u) * this.ky * h) / (c * c + h * h), p > 1 ? (l = t1[o + 1][0], u = t1[o + 1][1]) : p > 0 && (l += c / this.kx * p, u += h / this.ky * p)), c = Zr(e[0] - l) * this.kx, h = (e[1] - u) * this.ky;
                    const f = c * c + h * h;
                    f < r && (r = f, n = l, i = u, s = o, a = p);
                }
                return {
                    point: [
                        n,
                        i
                    ],
                    index: s,
                    t: Math.max(0, Math.min(1, a))
                };
            }
            lineSlice(t1, e, r) {
                let n = this.pointOnLine(r, t1), i = this.pointOnLine(r, e);
                if (n.index > i.index || n.index === i.index && n.t > i.t) {
                    const t1 = n;
                    n = i, i = t1;
                }
                const s = [
                    n.point
                ], a = n.index + 1, o = i.index;
                !Xr(r[a], s[0]) && a <= o && s.push(r[a]);
                for(let t1 = a + 1; t1 <= o; t1++)s.push(r[t1]);
                return Xr(r[o], i.point) || s.push(i.point), s;
            }
            lineSliceAlong(t1, e, r) {
                let n = 0;
                const i = [];
                for(let s = 0; s < r.length - 1; s++){
                    const a = r[s], o = r[s + 1], l = this.distance(a, o);
                    if (n += l, n > t1 && 0 === i.length && i.push(Yr(a, o, (t1 - (n - l)) / l)), n >= e) return i.push(Yr(a, o, (e - (n - l)) / l)), i;
                    n > t1 && i.push(o);
                }
                return i;
            }
            bufferPoint(t1, e) {
                const r = e / this.ky, n = e / this.kx;
                return [
                    t1[0] - n,
                    t1[1] - r,
                    t1[0] + n,
                    t1[1] + r
                ];
            }
            bufferBBox(t1, e) {
                const r = e / this.ky, n = e / this.kx;
                return [
                    t1[0] - n,
                    t1[1] - r,
                    t1[2] + n,
                    t1[3] + r
                ];
            }
            insideBBox(t1, e) {
                return Zr(t1[0] - e[0]) >= 0 && Zr(t1[0] - e[2]) <= 0 && t1[1] >= e[1] && t1[1] <= e[3];
            }
        }
        function Xr(t1, e) {
            return t1[0] === e[0] && t1[1] === e[1];
        }
        function Yr(t1, e, r) {
            const n = Zr(e[0] - t1[0]);
            return [
                t1[0] + n * r,
                t1[1] + (e[1] - t1[1]) * r
            ];
        }
        function Zr(t1) {
            for(; t1 < -180;)t1 += 360;
            for(; t1 > 180;)t1 -= 360;
            return t1;
        }
        class Wr {
            constructor(t1 = [], e = (t1, e)=>t1 < e ? -1 : t1 > e ? 1 : 0){
                if (this.data = t1, this.length = this.data.length, this.compare = e, this.length > 0) for(let t1 = (this.length >> 1) - 1; t1 >= 0; t1--)this._down(t1);
            }
            push(t1) {
                this.data.push(t1), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const t1 = this.data[0], e = this.data.pop();
                return --this.length > 0 && (this.data[0] = e, this._down(0)), t1;
            }
            peek() {
                return this.data[0];
            }
            _up(t1) {
                const { data: e, compare: r } = this, n = e[t1];
                for(; t1 > 0;){
                    const i = t1 - 1 >> 1, s = e[i];
                    if (r(n, s) >= 0) break;
                    e[t1] = s, t1 = i;
                }
                e[t1] = n;
            }
            _down(t1) {
                const { data: e, compare: r } = this, n = this.length >> 1, i = e[t1];
                for(; t1 < n;){
                    let n = 1 + (t1 << 1);
                    const s = n + 1;
                    if (s < this.length && r(e[s], e[n]) < 0 && (n = s), r(e[n], i) >= 0) break;
                    e[t1] = e[n], t1 = n;
                }
                e[t1] = i;
            }
        }
        var Hr = 8192;
        function Kr(t1, e) {
            return e.dist - t1.dist;
        }
        const Jr = 100, Qr = 50;
        function tn(t1) {
            const e = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (e.length !== t1.length) return !1;
            for(let r = 0; r < e.length; r++)if (e[r] !== t1[r]) return !1;
            return !0;
        }
        function en(t1) {
            return t1[1] - t1[0] + 1;
        }
        function rn(t1, e) {
            const r = t1[1] >= t1[0] && t1[1] < e;
            return r || console.warn("Distance Expression: Index is out of range"), r;
        }
        function nn(t1, e) {
            if (t1[0] > t1[1]) return [
                null,
                null
            ];
            const r = en(t1);
            if (e) {
                if (2 === r) return [
                    t1,
                    null
                ];
                const e = Math.floor(r / 2);
                return [
                    [
                        t1[0],
                        t1[0] + e
                    ],
                    [
                        t1[0] + e,
                        t1[1]
                    ]
                ];
            }
            {
                if (1 === r) return [
                    t1,
                    null
                ];
                const e = Math.floor(r / 2) - 1;
                return [
                    [
                        t1[0],
                        t1[0] + e
                    ],
                    [
                        t1[0] + e + 1,
                        t1[1]
                    ]
                ];
            }
        }
        function sn(t1, e) {
            const r = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (!rn(e, t1.length)) return r;
            for(let n = e[0]; n <= e[1]; ++n)Mr(r, t1[n]);
            return r;
        }
        function an(t1) {
            const e = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let r = 0; r < t1.length; ++r)for(let n = 0; n < t1[r].length; ++n)Mr(e, t1[r][n]);
            return e;
        }
        function on(t1, e, r) {
            if (tn(t1) || tn(e)) return NaN;
            let n = 0, i = 0;
            return t1[2] < e[0] && (n = e[0] - t1[2]), t1[0] > e[2] && (n = t1[0] - e[2]), t1[1] > e[3] && (i = t1[1] - e[3]), t1[3] < e[1] && (i = e[1] - t1[3]), r.distance([
                0,
                0
            ], [
                n,
                i
            ]);
        }
        function ln(t1) {
            return 360 * t1 - 180;
        }
        function un(t1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t1) * Math.PI / 180)) - 90;
        }
        function cn(t1, e) {
            const r = Math.pow(2, e.z), n = (t1.y / Hr + e.y) / r;
            return [
                ln((t1.x / Hr + e.x) / r),
                un(n)
            ];
        }
        function hn(t1, e) {
            const r = [];
            for(let n = 0; n < t1.length; ++n)r.push(cn(t1[n], e));
            return r;
        }
        function pn(t1, e, r) {
            const n = r.pointOnLine(e, t1).point;
            return r.distance(t1, n);
        }
        function fn(t1, e, r, n, i) {
            const s = r.slice(n[0], n[1] + 1);
            let a = 1 / 0;
            for(let r = e[0]; r <= e[1]; ++r)if (0 === (a = Math.min(a, pn(t1[r], s, i)))) return 0;
            return a;
        }
        function dn(t1, e, r, n, i) {
            const s = Math.min(i.pointToSegmentDistance(t1, r, n), i.pointToSegmentDistance(e, r, n)), a = Math.min(i.pointToSegmentDistance(r, t1, e), i.pointToSegmentDistance(n, t1, e));
            return Math.min(s, a);
        }
        function mn(t1, e, r, n, i) {
            if (!rn(e, t1.length) || !rn(n, r.length)) return NaN;
            let s = 1 / 0;
            for(let a = e[0]; a < e[1]; ++a)for(let e = n[0]; e < n[1]; ++e){
                if (zr(t1[a], t1[a + 1], r[e], r[e + 1])) return 0;
                s = Math.min(s, dn(t1[a], t1[a + 1], r[e], r[e + 1], i));
            }
            return s;
        }
        function yn(t1, e, r, n, i) {
            if (!rn(e, t1.length) || !rn(n, r.length)) return NaN;
            let s = 1 / 0;
            for(let a = e[0]; a <= e[1]; ++a)for(let e = n[0]; e <= n[1]; ++e)if (0 === (s = Math.min(s, i.distance(t1[a], r[e])))) return s;
            return s;
        }
        function gn(t1, e, r) {
            if (Ir(t1, e, !0)) return 0;
            let n = 1 / 0;
            for (const i of e){
                const e = i.length;
                if (e < 2) return console.warn("Distance Expression: Invalid polygon!"), NaN;
                if (i[0] !== i[e - 1] && 0 === (n = Math.min(n, r.pointToSegmentDistance(t1, i[e - 1], i[0])))) return n;
                if (0 === (n = Math.min(n, pn(t1, i, r)))) return n;
            }
            return n;
        }
        function xn(t1, e, r, n) {
            if (!rn(e, t1.length)) return NaN;
            for(let n = e[0]; n <= e[1]; ++n)if (Ir(t1[n], r, !0)) return 0;
            let i = 1 / 0;
            for(let s = e[0]; s < e[1]; ++s)for (const e of r)for(let r = 0, a = e.length, o = a - 1; r < a; o = r++){
                if (zr(t1[s], t1[s + 1], e[o], e[r])) return 0;
                i = Math.min(i, dn(t1[s], t1[s + 1], e[o], e[r], n));
            }
            return i;
        }
        function bn(t1, e) {
            for (const r of t1)for(let t1 = 0; t1 <= r.length - 1; ++t1)if (Ir(r[t1], e, !0)) return !0;
            return !1;
        }
        function vn(t1, e, r, n = 1 / 0) {
            const i = an(t1), s = an(e);
            if (n !== 1 / 0 && on(i, s, r) >= n) return n;
            if (Ar(i, s)) {
                if (bn(t1, e)) return 0;
            } else if (bn(e, t1)) return 0;
            let a = n;
            for (const n of t1)for(let t1 = 0, i = n.length, s = i - 1; t1 < i; s = t1++)for (const i of e)for(let e = 0, o = i.length, l = o - 1; e < o; l = e++){
                if (zr(n[s], n[t1], i[l], i[e])) return 0;
                a = Math.min(a, dn(n[s], n[t1], i[l], i[e], r));
            }
            return a;
        }
        function wn(t1, e, r, n, i, s, a) {
            if (null === s || null === a) return;
            const o = on(sn(n, s), sn(i, a), r);
            o < e && t1.push({
                dist: o,
                range1: s,
                range2: a
            });
        }
        function _n(t1, e, r, n, i = 1 / 0) {
            let s = Math.min(n.distance(t1[0], r[0][0]), i);
            if (0 === s) return s;
            const a = new Wr([
                {
                    dist: 0,
                    range1: [
                        0,
                        t1.length - 1
                    ],
                    range2: [
                        0,
                        0
                    ]
                }
            ], Kr), o = e ? Qr : Jr, l = an(r);
            for(; a.length;){
                const i = a.pop();
                if (i.dist >= s) continue;
                const u = i.range1;
                if (en(u) <= o) {
                    if (!rn(u, t1.length)) return NaN;
                    if (e) {
                        const e = xn(t1, u, r, n);
                        if (0 === (s = Math.min(s, e))) return s;
                    } else for(let e = u[0]; e <= u[1]; ++e){
                        const i = gn(t1[e], r, n);
                        if (0 === (s = Math.min(s, i))) return s;
                    }
                } else {
                    const r = nn(u, e);
                    if (null !== r[0]) {
                        const e = on(sn(t1, r[0]), l, n);
                        e < s && a.push({
                            dist: e,
                            range1: r[0],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                    if (null !== r[1]) {
                        const e = on(sn(t1, r[1]), l, n);
                        e < s && a.push({
                            dist: e,
                            range1: r[1],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                }
            }
            return s;
        }
        function Mn(t1, e, r, n, i, s = 1 / 0) {
            let a = Math.min(s, i.distance(t1[0], r[0]));
            if (0 === a) return a;
            const o = new Wr([
                {
                    dist: 0,
                    range1: [
                        0,
                        t1.length - 1
                    ],
                    range2: [
                        0,
                        r.length - 1
                    ]
                }
            ], Kr), l = e ? Qr : Jr, u = n ? Qr : Jr;
            for(; o.length;){
                const s = o.pop();
                if (s.dist >= a) continue;
                const c = s.range1, h = s.range2;
                if (en(c) <= l && en(h) <= u) {
                    if (!rn(c, t1.length) || !rn(h, r.length)) return NaN;
                    if (e && n ? a = Math.min(a, mn(t1, c, r, h, i)) : e || n ? e && !n ? a = Math.min(a, fn(r, h, t1, c, i)) : !e && n && (a = Math.min(a, fn(t1, c, r, h, i))) : a = Math.min(a, yn(t1, c, r, h, i)), 0 === a) return a;
                } else {
                    const s = nn(c, e), l = nn(h, n);
                    wn(o, a, i, t1, r, s[0], l[0]), wn(o, a, i, t1, r, s[0], l[1]), wn(o, a, i, t1, r, s[1], l[0]), wn(o, a, i, t1, r, s[1], l[1]);
                }
            }
            return a;
        }
        function An(t1, e, r, n, i = 1 / 0) {
            let s = i;
            const a = sn(t1, [
                0,
                t1.length - 1
            ]);
            for (const i of r)if (!(s !== 1 / 0 && on(a, sn(i, [
                0,
                i.length - 1
            ]), n) >= s) && (s = Math.min(s, Mn(t1, e, i, !0, n, s)), 0 === s)) return s;
            return s;
        }
        function Sn(t1, e, r, n, i = 1 / 0) {
            let s = i;
            const a = sn(t1, [
                0,
                t1.length - 1
            ]);
            for (const i of r){
                if (s !== 1 / 0 && on(a, an(i), n) >= s) continue;
                const r = _n(t1, e, i, n, s);
                if (isNaN(r)) return r;
                if (0 === (s = Math.min(s, r))) return s;
            }
            return s;
        }
        function In(t1) {
            return "Point" === t1 || "MultiPoint" === t1 || "LineString" === t1 || "MultiLineString" === t1 || "Polygon" === t1 || "MultiPolygon" === t1;
        }
        class Pn {
            constructor(t1, e){
                this.type = De, this.geojson = t1, this.geometries = e;
            }
            static parse(t1, e) {
                if (2 !== t1.length) return e.error(`'distance' expression requires either one argument, but found ' ${t1.length - 1} instead.`);
                if (rr(t1[1])) {
                    const e = t1[1];
                    if ("FeatureCollection" === e.type) {
                        for(let t1 = 0; t1 < e.features.length; ++t1)if (In(e.features[t1].geometry.type)) return new Pn(e, e.features[t1].geometry);
                    } else if ("Feature" === e.type) {
                        if (In(e.geometry.type)) return new Pn(e, e.geometry);
                    } else if (In(e.type)) return new Pn(e, e);
                }
                return e.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
            }
            evaluate(t1) {
                const e = t1.geometry(), r = t1.canonicalID();
                if (null != e && null != r) {
                    if ("Point" === t1.geometryType()) return function(t1, e, r) {
                        const n = [];
                        for (const r of t1)for (const t1 of r)n.push(cn(t1, e));
                        const i = new Gr(n[0][1], "meters");
                        return "Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type ? Mn(n, !1, "Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, i) : "MultiLineString" === r.type ? An(n, !1, r.coordinates, i) : "Polygon" === r.type || "MultiPolygon" === r.type ? Sn(n, !1, "Polygon" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, i) : null;
                    }(e, r, this.geometries);
                    if ("LineString" === t1.geometryType()) return function(t1, e, r) {
                        const n = [];
                        for (const r of t1){
                            const t1 = [];
                            for (const n of r)t1.push(cn(n, e));
                            n.push(t1);
                        }
                        const i = new Gr(n[0][0][1], "meters");
                        if ("Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type) return An("Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, n, i);
                        if ("MultiLineString" === r.type) {
                            let t1 = 1 / 0;
                            for(let e = 0; e < r.coordinates.length; e++){
                                const s = An(r.coordinates[e], !0, n, i, t1);
                                if (isNaN(s)) return s;
                                if (0 === (t1 = Math.min(t1, s))) return t1;
                            }
                            return t1;
                        }
                        if ("Polygon" === r.type || "MultiPolygon" === r.type) {
                            let t1 = 1 / 0;
                            for(let e = 0; e < n.length; e++){
                                const s = Sn(n[e], !0, "Polygon" === r.type ? [
                                    r.coordinates
                                ] : r.coordinates, i, t1);
                                if (isNaN(s)) return s;
                                if (0 === (t1 = Math.min(t1, s))) return t1;
                            }
                            return t1;
                        }
                        return null;
                    }(e, r, this.geometries);
                    if ("Polygon" === t1.geometryType()) return function(t1, e, r) {
                        const n = [];
                        for (const r of function(t1, e) {
                            const r = t1.length;
                            if (r <= 1) return [
                                t1
                            ];
                            const n = [];
                            let i, s;
                            for(let e = 0; e < r; e++){
                                const r = _r(t1[e]);
                                0 !== r && (t1[e].area = Math.abs(r), void 0 === s && (s = r < 0), s === r < 0 ? (i && n.push(i), i = [
                                    t1[e]
                                ]) : i.push(t1[e]));
                            }
                            return i && n.push(i), n;
                        }(t1)){
                            const t1 = [];
                            for(let n = 0; n < r.length; ++n)t1.push(hn(r[n], e));
                            n.push(t1);
                        }
                        const i = new Gr(n[0][0][0][1], "meters");
                        if ("Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type) return Sn("Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, n, i);
                        if ("MultiLineString" === r.type) {
                            let t1 = 1 / 0;
                            for(let e = 0; e < r.coordinates.length; e++){
                                const s = Sn(r.coordinates[e], !0, n, i, t1);
                                if (isNaN(s)) return s;
                                if (0 === (t1 = Math.min(t1, s))) return t1;
                            }
                            return t1;
                        }
                        return "Polygon" === r.type || "MultiPolygon" === r.type ? function(t1, e, r) {
                            let n = 1 / 0;
                            for (const i of t1)for (const t1 of e){
                                const e = vn(i, t1, r, n);
                                if (isNaN(e)) return e;
                                if (0 === (n = Math.min(n, e))) return n;
                            }
                            return n;
                        }("Polygon" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, n, i) : null;
                    }(e, r, this.geometries);
                    console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
                } else console.warn("Distance Expression: requirs valid feature and canonical information.");
                return null;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "distance",
                    this.geojson
                ];
            }
        }
        function zn(t1, e) {
            switch(t1){
                case "string":
                    return ir(e);
                case "number":
                    return +e;
                case "boolean":
                    return !!e;
                case "color":
                    return Pe.parse(e);
                case "formatted":
                    return Qe.fromString(ir(e));
                case "resolvedImage":
                    return tr.fromString(ir(e));
            }
            return e;
        }
        function kn(t1, e, r, n) {
            return void 0 !== n && (t1 = n * Math.round(t1 / n)), void 0 !== e && t1 < e && (t1 = e), void 0 !== r && t1 > r && (t1 = r), t1;
        }
        class Tn {
            constructor(t1, e, r){
                this.type = t1, this.key = e, this.scope = r;
            }
            static parse(t1, e) {
                let r = e.expectedType;
                if (null == r && (r = je), t1.length < 2 || t1.length > 3) return e.error("Invalid number of arguments for 'config' expression.");
                const n = e.parse(t1[1], 1);
                if (!(n instanceof sr)) return e.error("Key name of 'config' expression must be a string literal.");
                if (t1.length >= 3) {
                    const i = e.parse(t1[2], 2);
                    return i instanceof sr ? new Tn(r, ir(n.value), ir(i.value)) : e.error("Scope of 'config' expression must be a string literal.");
                }
                return new Tn(r, ir(n.value));
            }
            evaluate(t1) {
                const e = [
                    this.key,
                    this.scope,
                    t1.scope
                ].filter(Boolean).join("\x1f"), r = t1.getConfig(e);
                if (!r) return null;
                const { type: n, value: i, values: s, minValue: a, maxValue: o, stepValue: l } = r, u = r.default.evaluate(t1);
                let c = u;
                if (i) {
                    const e = t1.scope;
                    t1.scope = (e || "").split("\x1f").slice(1).join("\x1f"), c = i.evaluate(t1), t1.scope = e;
                }
                return n && (c = zn(n, c)), void 0 === c || void 0 === a && void 0 === o && void 0 === l || ("number" == typeof c ? c = kn(c, a, o, l) : Array.isArray(c) && (c = c.map((t1)=>"number" == typeof t1 ? kn(t1, a, o, l) : t1))), void 0 !== i && void 0 !== c && s && !s.includes(c) && (c = u, n && (c = zn(n, c))), (n && n !== this.type || void 0 !== c && nr(c) !== this.type) && (c = zn(this.type.kind, c)), c;
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "config",
                    this.key
                ];
                return this.scope && t1.concat(this.key), t1;
            }
        }
        function En(t1) {
            if (t1 instanceof yr) {
                if ("get" === t1.name && 1 === t1.args.length) return !1;
                if ("feature-state" === t1.name) return !1;
                if ("has" === t1.name && 1 === t1.args.length) return !1;
                if ("properties" === t1.name || "geometry-type" === t1.name || "id" === t1.name) return !1;
                if (/^filter-/.test(t1.name)) return !1;
            }
            if (t1 instanceof Ur) return !1;
            if (t1 instanceof Pn) return !1;
            let e = !0;
            return t1.eachChild((t1)=>{
                e && !En(t1) && (e = !1);
            }), e;
        }
        function Bn(t1) {
            if (t1 instanceof yr && "feature-state" === t1.name) return !1;
            let e = !0;
            return t1.eachChild((t1)=>{
                e && !Bn(t1) && (e = !1);
            }), e;
        }
        function Vn(t1) {
            if (t1 instanceof Tn) return new Set([
                t1.key
            ]);
            let e = new Set;
            return t1.eachChild((t1)=>{
                e = new Set([
                    ...e,
                    ...Vn(t1)
                ]);
            }), e;
        }
        function Cn(t1, e) {
            if (t1 instanceof yr && e.indexOf(t1.name) >= 0) return !1;
            let r = !0;
            return t1.eachChild((t1)=>{
                r && !Cn(t1, e) && (r = !1);
            }), r;
        }
        class Rn {
            constructor(t1, e){
                this.type = e.type, this.name = t1, this.boundExpression = e;
            }
            static parse(t1, e) {
                if (2 !== t1.length || "string" != typeof t1[1]) return e.error("'var' expression requires exactly one string literal argument.");
                const r = t1[1];
                return e.scope.has(r) ? new Rn(r, e.scope.get(r)) : e.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t1) {
                return this.boundExpression.evaluate(t1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "var",
                    this.name
                ];
            }
        }
        class Dn {
            constructor(t1, e = [], r, n = new Ce, i = [], s, a){
                this.registry = t1, this.path = e, this.key = e.map((t1)=>"string" == typeof t1 ? `['${t1}']` : `[${t1}]`).join(""), this.scope = n, this.errors = i, this.expectedType = r, this._scope = s, this.options = a;
            }
            parse(t1, e, r, n, i = {}) {
                return e || r ? this.concat(e, null, r, n)._parse(t1, i) : this._parse(t1, i);
            }
            parseObjectValue(t1, e, r, n, i, s = {}) {
                return this.concat(e, r, n, i)._parse(t1, s);
            }
            _parse(t1, e) {
                function r(t1, e, r) {
                    return "assert" === r ? new lr(e, [
                        t1
                    ]) : "coerce" === r ? new fr(e, [
                        t1
                    ]) : t1;
                }
                if (null !== t1 && "string" != typeof t1 && "boolean" != typeof t1 && "number" != typeof t1 || (t1 = [
                    "literal",
                    t1
                ]), Array.isArray(t1)) {
                    if (0 === t1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = "string" == typeof t1[0] ? this.registry[t1[0]] : void 0;
                    if (n) {
                        let i = n.parse(t1, this);
                        if (!i) return null;
                        if (this.expectedType) {
                            const t1 = this.expectedType, n = i.type;
                            if ("string" !== t1.kind && "number" !== t1.kind && "boolean" !== t1.kind && "object" !== t1.kind && "array" !== t1.kind || "value" !== n.kind) {
                                if ("color" !== t1.kind && "formatted" !== t1.kind && "resolvedImage" !== t1.kind || "value" !== n.kind && "string" !== n.kind) {
                                    if (this.checkSubtype(t1, n)) return null;
                                } else i = r(i, t1, e.typeAnnotation || "coerce");
                            } else i = r(i, t1, e.typeAnnotation || "assert");
                        }
                        if (!(i instanceof sr) && "resolvedImage" !== i.type.kind && Fn(i)) {
                            const t1 = new mr(this._scope, this.options);
                            try {
                                i = new sr(i.type, i.evaluate(t1));
                            } catch (t1) {
                                return this.error(t1.message), null;
                            }
                        }
                        return i;
                    }
                    return fr.parse([
                        "to-array",
                        t1
                    ], this);
                }
                return this.error(void 0 === t1 ? "'undefined' value invalid. Use null instead." : "object" == typeof t1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t1} instead.`);
            }
            concat(t1, e, r, n) {
                let i = "number" == typeof t1 ? this.path.concat(t1) : this.path;
                i = "string" == typeof e ? i.concat(e) : i;
                const s = n ? this.scope.concat(n) : this.scope;
                return new Dn(this.registry, i, r || null, s, this.errors, this._scope, this.options);
            }
            error(t1, ...e) {
                const r = `${this.key}${e.map((t1)=>`[${t1}]`).join("")}`;
                this.errors.push(new Ve(r, t1));
            }
            checkSubtype(t1, e) {
                const r = Ze(t1, e);
                return r && this.error(r), r;
            }
        }
        var Ln = Dn;
        function Fn(t1) {
            if (t1 instanceof Rn) return Fn(t1.boundExpression);
            if (t1 instanceof yr && "error" === t1.name) return !1;
            if (t1 instanceof xr) return !1;
            if (t1 instanceof Ur) return !1;
            if (t1 instanceof Pn) return !1;
            if (t1 instanceof Tn) return !1;
            const e = t1 instanceof fr || t1 instanceof lr;
            let r = !0;
            return t1.eachChild((t1)=>{
                r = e ? r && Fn(t1) : r && t1 instanceof sr;
            }), !!r && En(t1) && Cn(t1, [
                "zoom",
                "heatmap-density",
                "line-progress",
                "raster-value",
                "sky-radial-progress",
                "accumulated",
                "is-supported-script",
                "pitch",
                "distance-from-center",
                "measure-light",
                "raster-particle-speed"
            ]);
        }
        function On(t1, e) {
            const r = t1.length - 1;
            let n, i, s = 0, a = r, o = 0;
            for(; s <= a;)if (o = Math.floor((s + a) / 2), n = t1[o], i = t1[o + 1], n <= e) {
                if (o === r || e < i) return o;
                s = o + 1;
            } else {
                if (!(n > e)) throw new ar("Input is not a number.");
                a = o - 1;
            }
            return 0;
        }
        class Un {
            constructor(t1, e, r){
                this.type = t1, this.input = e, this.labels = [], this.outputs = [];
                for (const [t1, e] of r)this.labels.push(t1), this.outputs.push(e);
            }
            static parse(t1, e) {
                if (t1.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if ((t1.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                const r = e.parse(t1[1], 1, De);
                if (!r) return null;
                const n = [];
                let i = null;
                e.expectedType && "value" !== e.expectedType.kind && (i = e.expectedType);
                for(let r = 1; r < t1.length; r += 2){
                    const s = 1 === r ? -1 / 0 : t1[r], a = t1[r + 1], o = r, l = r + 1;
                    if ("number" != typeof s) return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
                    if (n.length && n[n.length - 1][0] >= s) return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
                    const u = e.parse(a, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        s,
                        u
                    ]);
                }
                return new Un(i, r, n);
            }
            evaluate(t1) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e[0]) return r[0].evaluate(t1);
                const i = e.length;
                return n >= e[i - 1] ? r[i - 1].evaluate(t1) : r[On(e, n)].evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input);
                for (const e of this.outputs)t1(e);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = [
                    "step",
                    this.input.serialize()
                ];
                for(let e = 0; e < this.labels.length; e++)e > 0 && t1.push(this.labels[e]), t1.push(this.outputs[e].serialize());
                return t1;
            }
        }
        const jn = .95047, Nn = 1.08883, qn = 4 / 29, $n = 6 / 29, Gn = 3 * $n * $n, Xn = $n * $n * $n, Yn = Math.PI / 180, Zn = 180 / Math.PI;
        function Wn(t1) {
            return t1 > Xn ? Math.pow(t1, 1 / 3) : t1 / Gn + qn;
        }
        function Hn(t1) {
            return t1 > $n ? t1 * t1 * t1 : Gn * (t1 - qn);
        }
        function Kn(t1) {
            return 255 * (t1 <= .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055);
        }
        function Jn(t1) {
            return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
        }
        function Qn(t1) {
            const e = Jn(t1.r), r = Jn(t1.g), n = Jn(t1.b), i = Wn((.4124564 * e + .3575761 * r + .1804375 * n) / jn), s = Wn((.2126729 * e + .7151522 * r + .072175 * n) / 1);
            return {
                l: 116 * s - 16,
                a: 500 * (i - s),
                b: 200 * (s - Wn((.0193339 * e + .119192 * r + .9503041 * n) / Nn)),
                alpha: t1.a
            };
        }
        function ti(t1) {
            let e = (t1.l + 16) / 116, r = isNaN(t1.a) ? e : e + t1.a / 500, n = isNaN(t1.b) ? e : e - t1.b / 200;
            return e = 1 * Hn(e), r = jn * Hn(r), n = Nn * Hn(n), new Pe(Kn(3.2404542 * r - 1.5371385 * e - .4985314 * n), Kn(-0.969266 * r + 1.8760108 * e + .041556 * n), Kn(.0556434 * r - .2040259 * e + 1.0572252 * n), t1.alpha);
        }
        function ei(t1, e, r) {
            const n = e - t1;
            return t1 + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
        }
        const ri = {
            forward: Qn,
            reverse: ti,
            interpolate: function(t1, e, r) {
                return {
                    l: ke(t1.l, e.l, r),
                    a: ke(t1.a, e.a, r),
                    b: ke(t1.b, e.b, r),
                    alpha: ke(t1.alpha, e.alpha, r)
                };
            }
        }, ni = {
            forward: function(t1) {
                const { l: e, a: r, b: n } = Qn(t1), i = Math.atan2(n, r) * Zn;
                return {
                    h: i < 0 ? i + 360 : i,
                    c: Math.sqrt(r * r + n * n),
                    l: e,
                    alpha: t1.a
                };
            },
            reverse: function(t1) {
                const e = t1.h * Yn, r = t1.c;
                return ti({
                    l: t1.l,
                    a: Math.cos(e) * r,
                    b: Math.sin(e) * r,
                    alpha: t1.alpha
                });
            },
            interpolate: function(t1, e, r) {
                return {
                    h: ei(t1.h, e.h, r),
                    c: ke(t1.c, e.c, r),
                    l: ke(t1.l, e.l, r),
                    alpha: ke(t1.alpha, e.alpha, r)
                };
            }
        };
        var ii = Object.freeze({
            __proto__: null,
            hcl: ni,
            lab: ri
        });
        class si {
            constructor(t1, e, r, n, i){
                this.type = t1, this.operator = e, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [t1, e] of i)this.labels.push(t1), this.outputs.push(e);
            }
            static interpolationFactor(t1, e, r, n) {
                let i = 0;
                if ("exponential" === t1.name) i = ai(e, t1.base, r, n);
                else if ("linear" === t1.name) i = ai(e, 1, r, n);
                else if ("cubic-bezier" === t1.name) {
                    const s = t1.controlPoints;
                    i = new j(s[0], s[1], s[2], s[3]).solve(ai(e, 1, r, n));
                }
                return i;
            }
            static parse(t1, e) {
                let [r, n, i, ...s] = t1;
                if (!Array.isArray(n) || 0 === n.length) return e.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const t1 = n[1];
                    if ("number" != typeof t1) return e.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: t1
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return e.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const t1 = n.slice(1);
                        if (4 !== t1.length || t1.some((t1)=>"number" != typeof t1 || t1 < 0 || t1 > 1)) return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: t1
                        };
                    }
                }
                if (t1.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if ((t1.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                if (i = e.parse(i, 2, De), !i) return null;
                const a = [];
                let o = null;
                "interpolate-hcl" === r || "interpolate-lab" === r ? o = Oe : e.expectedType && "value" !== e.expectedType.kind && (o = e.expectedType);
                for(let t1 = 0; t1 < s.length; t1 += 2){
                    const r = s[t1], n = s[t1 + 1], i = t1 + 3, l = t1 + 4;
                    if ("number" != typeof r) return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (a.length && a[a.length - 1][0] >= r) return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = e.parse(n, l, o);
                    if (!u) return null;
                    o = o || u.type, a.push([
                        r,
                        u
                    ]);
                }
                return "number" === o.kind || "color" === o.kind || "array" === o.kind && "number" === o.itemType.kind && "number" == typeof o.N ? new si(o, r, n, i, a) : e.error(`Type ${Xe(o)} is not interpolatable.`);
            }
            evaluate(t1) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e[0]) return r[0].evaluate(t1);
                const i = e.length;
                if (n >= e[i - 1]) return r[i - 1].evaluate(t1);
                const s = On(e, n), a = si.interpolationFactor(this.interpolation, n, e[s], e[s + 1]), o = r[s].evaluate(t1), l = r[s + 1].evaluate(t1);
                return "interpolate" === this.operator ? Ee[this.type.kind.toLowerCase()](o, l, a) : "interpolate-hcl" === this.operator ? ni.reverse(ni.interpolate(ni.forward(o), ni.forward(l), a)) : ri.reverse(ri.interpolate(ri.forward(o), ri.forward(l), a));
            }
            eachChild(t1) {
                t1(this.input);
                for (const e of this.outputs)t1(e);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
            serialize() {
                let t1;
                t1 = "linear" === this.interpolation.name ? [
                    "linear"
                ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                    "linear"
                ] : [
                    "exponential",
                    this.interpolation.base
                ] : [
                    "cubic-bezier"
                ].concat(this.interpolation.controlPoints);
                const e = [
                    this.operator,
                    t1,
                    this.input.serialize()
                ];
                for(let t1 = 0; t1 < this.labels.length; t1++)e.push(this.labels[t1], this.outputs[t1].serialize());
                return e;
            }
        }
        function ai(t1, e, r, n) {
            const i = n - r, s = t1 - r;
            return 0 === i ? 0 : 1 === e ? s / i : (Math.pow(e, s) - 1) / (Math.pow(e, i) - 1);
        }
        class oi {
            constructor(t1, e){
                this.type = t1, this.args = e;
            }
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expectected at least one argument.");
                let r = null;
                const n = e.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of t1.slice(1)){
                    const t1 = e.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!t1) return null;
                    r = r || t1.type, i.push(t1);
                }
                const s = n && i.some((t1)=>Ze(n, t1.type));
                return new oi(s ? je : r, i);
            }
            evaluate(t1) {
                let e, r = null, n = 0;
                for (const i of this.args){
                    if (n++, r = i.evaluate(t1), r && r instanceof tr && !r.available && (e || (e = r), r = null, n === this.args.length)) return e;
                    if (null !== r) break;
                }
                return r;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = [
                    "coalesce"
                ];
                return this.eachChild((e)=>{
                    t1.push(e.serialize());
                }), t1;
            }
        }
        class li {
            constructor(t1, e){
                this.type = e.type, this.bindings = [].concat(t1), this.result = e;
            }
            evaluate(t1) {
                return this.result.evaluate(t1);
            }
            eachChild(t1) {
                for (const e of this.bindings)t1(e[1]);
                t1(this.result);
            }
            static parse(t1, e) {
                if (t1.length < 4) return e.error(`Expected at least 3 arguments, but found ${t1.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < t1.length - 1; n += 2){
                    const i = t1[n];
                    if ("string" != typeof i) return e.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return e.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const s = e.parse(t1[n + 1], n + 1);
                    if (!s) return null;
                    r.push([
                        i,
                        s
                    ]);
                }
                const n = e.parse(t1[t1.length - 1], t1.length - 1, e.expectedType, r);
                return n ? new li(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
            serialize() {
                const t1 = [
                    "let"
                ];
                for (const [e, r] of this.bindings)t1.push(e, r.serialize());
                return t1.push(this.result.serialize()), t1;
            }
        }
        class ui {
            constructor(t1, e, r){
                this.type = t1, this.index = e, this.input = r;
            }
            static parse(t1, e) {
                if (3 !== t1.length) return e.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, De), n = e.parse(t1[2], 2, Ge(e.expectedType || je));
                return r && n ? new ui(n.type.itemType, r, n) : null;
            }
            evaluate(t1) {
                const e = this.index.evaluate(t1), r = this.input.evaluate(t1);
                if (e < 0) throw new ar(`Array index out of bounds: ${e} < 0.`);
                if (e >= r.length) throw new ar(`Array index out of bounds: ${e} > ${r.length - 1}.`);
                if (e !== Math.floor(e)) throw new ar(`Array index must be an integer, but found ${e} instead.`);
                return r[e];
            }
            eachChild(t1) {
                t1(this.index), t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        class ci {
            constructor(t1, e){
                this.type = Fe, this.needle = t1, this.haystack = e;
            }
            static parse(t1, e) {
                if (3 !== t1.length) return e.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, je), n = e.parse(t1[2], 2, je);
                return r && n ? We(r.type, [
                    Fe,
                    Le,
                    De,
                    Re,
                    je
                ]) ? new ci(r, n) : e.error(`Expected first argument to be of type boolean, string, number or null, but found ${Xe(r.type)} instead`) : null;
            }
            evaluate(t1) {
                const e = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (null == r) return !1;
                if (!He(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new ar(`Expected first argument to be of type boolean, string, number or null, but found ${Xe(nr(e))} instead.`);
                if (!He(r, [
                    "string",
                    "array"
                ])) throw new ar(`Expected second argument to be of type array or string, but found ${Xe(nr(r))} instead.`);
                return r.indexOf(e) >= 0;
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack);
            }
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "in",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
        }
        class hi {
            constructor(t1, e, r){
                this.type = De, this.needle = t1, this.haystack = e, this.fromIndex = r;
            }
            static parse(t1, e) {
                if (t1.length <= 2 || t1.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, je), n = e.parse(t1[2], 2, je);
                if (!r || !n) return null;
                if (!We(r.type, [
                    Fe,
                    Le,
                    De,
                    Re,
                    je
                ])) return e.error(`Expected first argument to be of type boolean, string, number or null, but found ${Xe(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e.parse(t1[3], 3, De);
                    return i ? new hi(r, n, i) : null;
                }
                return new hi(r, n);
            }
            evaluate(t1) {
                const e = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (!He(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new ar(`Expected first argument to be of type boolean, string, number or null, but found ${Xe(nr(e))} instead.`);
                if (!He(r, [
                    "string",
                    "array"
                ])) throw new ar(`Expected second argument to be of type array or string, but found ${Xe(nr(r))} instead.`);
                if (this.fromIndex) {
                    const n = this.fromIndex.evaluate(t1);
                    return r.indexOf(e, n);
                }
                return r.indexOf(e);
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack), this.fromIndex && t1(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.fromIndex && void 0 !== this.fromIndex) {
                    const t1 = this.fromIndex.serialize();
                    return [
                        "index-of",
                        this.needle.serialize(),
                        this.haystack.serialize(),
                        t1
                    ];
                }
                return [
                    "index-of",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
        }
        class pi {
            constructor(t1, e, r, n, i, s){
                this.inputType = t1, this.type = e, this.input = r, this.cases = n, this.outputs = i, this.otherwise = s;
            }
            static parse(t1, e) {
                if (t1.length < 5) return e.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 1) return e.error("Expected an even number of arguments.");
                let r, n;
                e.expectedType && "value" !== e.expectedType.kind && (n = e.expectedType);
                const i = {}, s = [];
                for(let a = 2; a < t1.length - 1; a += 2){
                    let o = t1[a];
                    const l = t1[a + 1];
                    Array.isArray(o) || (o = [
                        o
                    ]);
                    const u = e.concat(a);
                    if (0 === o.length) return u.error("Expected at least one branch label.");
                    for (const t1 of o){
                        if ("number" != typeof t1 && "string" != typeof t1) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof t1 && Math.abs(t1) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof t1 && Math.floor(t1) !== t1) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, nr(t1))) return null;
                        } else r = nr(t1);
                        if (void 0 !== i[String(t1)]) return u.error("Branch labels must be unique.");
                        i[String(t1)] = s.length;
                    }
                    const c = e.parse(l, a, n);
                    if (!c) return null;
                    n = n || c.type, s.push(c);
                }
                const a = e.parse(t1[1], 1, je);
                if (!a) return null;
                const o = e.parse(t1[t1.length - 1], t1.length - 1, n);
                return o ? "value" !== a.type.kind && e.concat(1).checkSubtype(r, a.type) ? null : new pi(r, n, a, i, s, o) : null;
            }
            evaluate(t1) {
                const e = this.input.evaluate(t1);
                return (nr(e) === this.inputType && this.outputs[this.cases[e]] || this.otherwise).evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input), this.outputs.forEach(t1), t1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const t1 = [
                    "match",
                    this.input.serialize()
                ], e = Object.keys(this.cases).sort(), r = [], n = {};
                for (const t1 of e){
                    const e = n[this.cases[t1]];
                    void 0 === e ? (n[this.cases[t1]] = r.length, r.push([
                        this.cases[t1],
                        [
                            t1
                        ]
                    ])) : r[e][1].push(t1);
                }
                const i = (t1)=>"number" === this.inputType.kind ? Number(t1) : t1;
                for (const [e, n] of r)t1.push(1 === n.length ? i(n[0]) : n.map(i)), t1.push(this.outputs[e].serialize());
                return t1.push(this.otherwise.serialize()), t1;
            }
        }
        class fi {
            constructor(t1, e, r){
                this.type = t1, this.branches = e, this.otherwise = r;
            }
            static parse(t1, e) {
                if (t1.length < 4) return e.error(`Expected at least 3 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 0) return e.error("Expected an odd number of arguments.");
                let r;
                e.expectedType && "value" !== e.expectedType.kind && (r = e.expectedType);
                const n = [];
                for(let i = 1; i < t1.length - 1; i += 2){
                    const s = e.parse(t1[i], i, Fe);
                    if (!s) return null;
                    const a = e.parse(t1[i + 1], i + 1, r);
                    if (!a) return null;
                    n.push([
                        s,
                        a
                    ]), r = r || a.type;
                }
                const i = e.parse(t1[t1.length - 1], t1.length - 1, r);
                return i ? new fi(r, n, i) : null;
            }
            evaluate(t1) {
                for (const [e, r] of this.branches)if (e.evaluate(t1)) return r.evaluate(t1);
                return this.otherwise.evaluate(t1);
            }
            eachChild(t1) {
                for (const [e, r] of this.branches)t1(e), t1(r);
                t1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([t1, e])=>e.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const t1 = [
                    "case"
                ];
                return this.eachChild((e)=>{
                    t1.push(e.serialize());
                }), t1;
            }
        }
        class di {
            constructor(t1, e, r, n){
                this.type = t1, this.input = e, this.beginIndex = r, this.endIndex = n;
            }
            static parse(t1, e) {
                if (t1.length <= 2 || t1.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, je), n = e.parse(t1[2], 2, De);
                if (!r || !n) return null;
                if (!We(r.type, [
                    Ge(je),
                    Le,
                    je
                ])) return e.error(`Expected first argument to be of type array or string, but found ${Xe(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e.parse(t1[3], 3, De);
                    return i ? new di(r.type, r, n, i) : null;
                }
                return new di(r.type, r, n);
            }
            evaluate(t1) {
                const e = this.input.evaluate(t1), r = this.beginIndex.evaluate(t1);
                if (!He(e, [
                    "string",
                    "array"
                ])) throw new ar(`Expected first argument to be of type array or string, but found ${Xe(nr(e))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(t1);
                    return e.slice(r, n);
                }
                return e.slice(r);
            }
            eachChild(t1) {
                t1(this.input), t1(this.beginIndex), this.endIndex && t1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.endIndex && void 0 !== this.endIndex) {
                    const t1 = this.endIndex.serialize();
                    return [
                        "slice",
                        this.input.serialize(),
                        this.beginIndex.serialize(),
                        t1
                    ];
                }
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize()
                ];
            }
        }
        function mi(t1, e) {
            return "==" === t1 || "!=" === t1 ? "boolean" === e.kind || "string" === e.kind || "number" === e.kind || "null" === e.kind || "value" === e.kind : "string" === e.kind || "number" === e.kind || "value" === e.kind;
        }
        function yi(t1, e, r, n) {
            return 0 === n.compare(e, r);
        }
        function gi(t1, e, r) {
            const n = "==" !== t1 && "!=" !== t1;
            return class i {
                constructor(t1, e, r){
                    this.type = Fe, this.lhs = t1, this.rhs = e, this.collator = r, this.hasUntypedArgument = "value" === t1.type.kind || "value" === e.type.kind;
                }
                static parse(t1, e) {
                    if (3 !== t1.length && 4 !== t1.length) return e.error("Expected two or three arguments.");
                    const r = t1[0];
                    let s = e.parse(t1[1], 1, je);
                    if (!s) return null;
                    if (!mi(r, s.type)) return e.concat(1).error(`"${r}" comparisons are not supported for type '${Xe(s.type)}'.`);
                    let a = e.parse(t1[2], 2, je);
                    if (!a) return null;
                    if (!mi(r, a.type)) return e.concat(2).error(`"${r}" comparisons are not supported for type '${Xe(a.type)}'.`);
                    if (s.type.kind !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e.error(`Cannot compare types '${Xe(s.type)}' and '${Xe(a.type)}'.`);
                    n && ("value" === s.type.kind && "value" !== a.type.kind ? s = new lr(a.type, [
                        s
                    ]) : "value" !== s.type.kind && "value" === a.type.kind && (a = new lr(s.type, [
                        a
                    ])));
                    let o = null;
                    if (4 === t1.length) {
                        if ("string" !== s.type.kind && "string" !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e.error("Cannot use collator to compare non-string types.");
                        if (o = e.parse(t1[3], 3, Ne), !o) return null;
                    }
                    return new i(s, a, o);
                }
                evaluate(i) {
                    const s = this.lhs.evaluate(i), a = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const e = nr(s), r = nr(a);
                        if (e.kind !== r.kind || "string" !== e.kind && "number" !== e.kind) throw new ar(`Expected arguments for "${t1}" to be (string, string) or (number, number), but found (${e.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const t1 = nr(s), r = nr(a);
                        if ("string" !== t1.kind || "string" !== r.kind) return e(i, s, a);
                    }
                    return this.collator ? r(i, s, a, this.collator.evaluate(i)) : e(i, s, a);
                }
                eachChild(t1) {
                    t1(this.lhs), t1(this.rhs), this.collator && t1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
                serialize() {
                    const e = [
                        t1
                    ];
                    return this.eachChild((t1)=>{
                        e.push(t1.serialize());
                    }), e;
                }
            };
        }
        const xi = gi("==", function(t1, e, r) {
            return e === r;
        }, yi), bi = gi("!=", function(t1, e, r) {
            return e !== r;
        }, function(t1, e, r, n) {
            return !yi(0, e, r, n);
        }), vi = gi("<", function(t1, e, r) {
            return e < r;
        }, function(t1, e, r, n) {
            return n.compare(e, r) < 0;
        }), wi = gi(">", function(t1, e, r) {
            return e > r;
        }, function(t1, e, r, n) {
            return n.compare(e, r) > 0;
        }), _i = gi("<=", function(t1, e, r) {
            return e <= r;
        }, function(t1, e, r, n) {
            return n.compare(e, r) <= 0;
        }), Mi = gi(">=", function(t1, e, r) {
            return e >= r;
        }, function(t1, e, r, n) {
            return n.compare(e, r) >= 0;
        });
        class Ai {
            constructor(t1, e, r, n, i, s){
                this.type = Le, this.number = t1, this.locale = e, this.currency = r, this.unit = n, this.minFractionDigits = i, this.maxFractionDigits = s;
            }
            static parse(t1, e) {
                if (3 !== t1.length) return e.error("Expected two arguments.");
                const r = e.parse(t1[1], 1, De);
                if (!r) return null;
                const n = t1[2];
                if ("object" != typeof n || Array.isArray(n)) return e.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = e.parseObjectValue(n.locale, 2, "locale", Le), !i)) return null;
                let s = null;
                if (n.currency && (s = e.parseObjectValue(n.currency, 2, "currency", Le), !s)) return null;
                let a = null;
                if (n.unit && (a = e.parseObjectValue(n.unit, 2, "unit", Le), !a)) return null;
                let o = null;
                if (n["min-fraction-digits"] && (o = e.parseObjectValue(n["min-fraction-digits"], 2, "min-fraction-digits", De), !o)) return null;
                let l = null;
                return n["max-fraction-digits"] && (l = e.parseObjectValue(n["max-fraction-digits"], 2, "max-fraction-digits", De), !l) ? null : new Ai(r, i, s, a, o, l);
            }
            evaluate(t1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t1) : [], {
                    style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                    currency: this.currency ? this.currency.evaluate(t1) : void 0,
                    unit: this.unit ? this.unit.evaluate(t1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t1) : void 0
                }).format(this.number.evaluate(t1));
            }
            eachChild(t1) {
                t1(this.number), this.locale && t1(this.locale), this.currency && t1(this.currency), this.unit && t1(this.unit), this.minFractionDigits && t1(this.minFractionDigits), this.maxFractionDigits && t1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = {};
                return this.locale && (t1.locale = this.locale.serialize()), this.currency && (t1.currency = this.currency.serialize()), this.unit && (t1.unit = this.unit.serialize()), this.minFractionDigits && (t1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                    "number-format",
                    this.number.serialize(),
                    t1
                ];
            }
        }
        class Si {
            constructor(t1){
                this.type = De, this.input = t1;
            }
            static parse(t1, e) {
                if (2 !== t1.length) return e.error(`Expected 1 argument, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e.error(`Expected argument of type string or array, but found ${Xe(r.type)} instead.`) : new Si(r) : null;
            }
            evaluate(t1) {
                const e = this.input.evaluate(t1);
                if ("string" == typeof e) return e.length;
                if (Array.isArray(e)) return e.length;
                throw new ar(`Expected value to be of type string or array, but found ${Xe(nr(e))} instead.`);
            }
            eachChild(t1) {
                t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "length"
                ];
                return this.eachChild((e)=>{
                    t1.push(e.serialize());
                }), t1;
            }
        }
        function Ii(t1) {
            return function() {
                t1 = 1831565813 + (t1 |= 0) | 0;
                let e = Math.imul(t1 ^ t1 >>> 15, 1 | t1);
                return e = e + Math.imul(e ^ e >>> 7, 61 | e) ^ e, ((e ^ e >>> 14) >>> 0) / 4294967296;
            };
        }
        const Pi = {
            "==": xi,
            "!=": bi,
            ">": wi,
            "<": vi,
            ">=": Mi,
            "<=": _i,
            array: lr,
            at: ui,
            boolean: lr,
            case: fi,
            coalesce: oi,
            collator: xr,
            format: ur,
            image: cr,
            in: ci,
            "index-of": hi,
            interpolate: si,
            "interpolate-hcl": si,
            "interpolate-lab": si,
            length: Si,
            let: li,
            literal: sr,
            match: pi,
            number: lr,
            "number-format": Ai,
            object: lr,
            slice: di,
            step: Un,
            string: lr,
            "to-boolean": fr,
            "to-color": fr,
            "to-number": fr,
            "to-string": fr,
            var: Rn,
            within: Ur,
            distance: Pn,
            config: Tn
        };
        function zi(t1, [e, r, n, i]) {
            e = e.evaluate(t1), r = r.evaluate(t1), n = n.evaluate(t1);
            const s = i ? i.evaluate(t1) : 1, a = er(e, r, n, s);
            if (a) throw new ar(a);
            return new Pe(e / 255 * s, r / 255 * s, n / 255 * s, s);
        }
        function ki(t1, [e, r, n, i]) {
            e = e.evaluate(t1), r = r.evaluate(t1), n = n.evaluate(t1);
            const s = i ? i.evaluate(t1) : 1, a = function(t1, e, r, n) {
                return "number" == typeof t1 && t1 >= 0 && t1 <= 360 ? "number" == typeof e && e >= 0 && e <= 100 && "number" == typeof r && r >= 0 && r <= 100 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid hsla value [${[
                    t1,
                    e,
                    r,
                    n
                ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${("number" == typeof n ? [
                    t1,
                    e,
                    r,
                    n
                ] : [
                    t1,
                    e,
                    r
                ]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${("number" == typeof n ? [
                    t1,
                    e,
                    r,
                    n
                ] : [
                    t1,
                    e,
                    r
                ]).join(", ")}]: 'h' must be between 0 and 360.`;
            }(e, r, n, s);
            if (a) throw new ar(a);
            const o = `hsla(${e}, ${r}%, ${n}%, ${s})`, l = Pe.parse(o);
            if (!l) throw new ar(`Failed to parse HSLA color: ${o}`);
            return l;
        }
        function Ti(t1, e) {
            return t1 in e;
        }
        function Ei(t1, e) {
            const r = e[t1];
            return void 0 === r ? null : r;
        }
        function Bi(t1) {
            return {
                type: t1
            };
        }
        function Vi(t1) {
            return {
                result: "success",
                value: t1
            };
        }
        function Ci(t1) {
            return {
                result: "error",
                value: t1
            };
        }
        function Ri(t1, e) {
            return !!t1 && !!t1.parameters && t1.parameters.indexOf(e) > -1;
        }
        function Di(t1) {
            return "data-driven" === t1["property-type"];
        }
        function Li(t1) {
            return Ri(t1.expression, "measure-light");
        }
        function Fi(t1) {
            return Ri(t1.expression, "zoom");
        }
        function Oi(t1) {
            return !!t1.expression && t1.expression.interpolated;
        }
        function Ui(t1) {
            return "object" == typeof t1 && null !== t1 && !Array.isArray(t1);
        }
        function ji(t1) {
            return t1;
        }
        function Ni(t1, e) {
            const r = "color" === e.type, n = t1.stops && "object" == typeof t1.stops[0][0], i = n || !(n || void 0 !== t1.property), s = t1.type || (Oi(e) ? "exponential" : "interval");
            if (r && ((t1 = Be({}, t1)).stops && (t1.stops = t1.stops.map((t1)=>[
                    t1[0],
                    Pe.parse(t1[1])
                ])), t1.default = Pe.parse(t1.default ? t1.default : e.default)), t1.colorSpace && "rgb" !== t1.colorSpace && !ii[t1.colorSpace]) throw new Error(`Unknown color space: ${t1.colorSpace}`);
            let a, o, l;
            if ("exponential" === s) a = Xi;
            else if ("interval" === s) a = Gi;
            else if ("categorical" === s) {
                a = $i, o = Object.create(null);
                for (const e of t1.stops)o[e[0]] = e[1];
                l = typeof t1.stops[0][0];
            } else {
                if ("identity" !== s) throw new Error(`Unknown function type "${s}"`);
                a = Yi;
            }
            if (n) {
                const r = {}, n = [];
                for(let e = 0; e < t1.stops.length; e++){
                    const i = t1.stops[e], s = i[0].zoom;
                    void 0 === r[s] && (r[s] = {
                        zoom: s,
                        type: t1.type,
                        property: t1.property,
                        default: t1.default,
                        stops: []
                    }, n.push(s)), r[s].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const t1 of n)i.push([
                    r[t1].zoom,
                    Ni(r[t1], e)
                ]);
                const s = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: s,
                    interpolationFactor: si.interpolationFactor.bind(void 0, s),
                    zoomStops: i.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r }, n)=>Xi({
                            stops: i,
                            base: t1.base
                        }, e, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === s ? {
                    name: "exponential",
                    base: void 0 !== t1.base ? t1.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: si.interpolationFactor.bind(void 0, r),
                    zoomStops: t1.stops.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r })=>a(t1, e, r, o, l)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[t1.property] : void 0;
                    return void 0 === i ? qi(t1.default, e.default) : a(t1, e, i, o, l);
                }
            };
        }
        function qi(t1, e, r) {
            return void 0 !== t1 ? t1 : void 0 !== e ? e : void 0 !== r ? r : void 0;
        }
        function $i(t1, e, r, n, i) {
            return qi(typeof r === i ? n[r] : void 0, t1.default, e.default);
        }
        function Gi(t1, e, r) {
            if ("number" !== hr(r)) return qi(t1.default, e.default);
            const n = t1.stops.length;
            if (1 === n) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[n - 1][0]) return t1.stops[n - 1][1];
            const i = On(t1.stops.map((t1)=>t1[0]), r);
            return t1.stops[i][1];
        }
        function Xi(t1, e, r) {
            const n = void 0 !== t1.base ? t1.base : 1;
            if ("number" !== hr(r)) return qi(t1.default, e.default);
            const i = t1.stops.length;
            if (1 === i) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[i - 1][0]) return t1.stops[i - 1][1];
            const s = On(t1.stops.map((t1)=>t1[0]), r), a = function(t1, e, r, n) {
                const i = n - r, s = t1 - r;
                return 0 === i ? 0 : 1 === e ? s / i : (Math.pow(e, s) - 1) / (Math.pow(e, i) - 1);
            }(r, n, t1.stops[s][0], t1.stops[s + 1][0]), o = t1.stops[s][1], l = t1.stops[s + 1][1];
            let u = Ee[e.type] || ji;
            if (t1.colorSpace && "rgb" !== t1.colorSpace) {
                const e = ii[t1.colorSpace];
                u = (t1, r)=>e.reverse(e.interpolate(e.forward(t1), e.forward(r), a));
            }
            return "function" == typeof o.evaluate ? {
                evaluate (...t1) {
                    const e = o.evaluate.apply(void 0, t1), r = l.evaluate.apply(void 0, t1);
                    if (void 0 !== e && void 0 !== r) return u(e, r, a);
                }
            } : u(o, l, a);
        }
        function Yi(t1, e, r) {
            return "color" === e.type ? r = Pe.parse(r) : "formatted" === e.type ? r = Qe.fromString(r.toString()) : "resolvedImage" === e.type ? r = tr.fromString(r.toString()) : hr(r) === e.type || "enum" === e.type && e.values[r] || (r = void 0), qi(r, t1.default, e.default);
        }
        yr.register(Pi, {
            error: [
                {
                    kind: "error"
                },
                [
                    Le
                ],
                (t1, [e])=>{
                    throw new ar(e.evaluate(t1));
                }
            ],
            typeof: [
                Le,
                [
                    je
                ],
                (t1, [e])=>Xe(nr(e.evaluate(t1)))
            ],
            "to-rgba": [
                Ge(De, 4),
                [
                    Oe
                ],
                (t1, [e])=>e.evaluate(t1).toRenderColor(null).toArray()
            ],
            rgb: [
                Oe,
                [
                    De,
                    De,
                    De
                ],
                zi
            ],
            rgba: [
                Oe,
                [
                    De,
                    De,
                    De,
                    De
                ],
                zi
            ],
            hsl: [
                Oe,
                [
                    De,
                    De,
                    De
                ],
                ki
            ],
            hsla: [
                Oe,
                [
                    De,
                    De,
                    De,
                    De
                ],
                ki
            ],
            has: {
                type: Fe,
                overloads: [
                    [
                        [
                            Le
                        ],
                        (t1, [e])=>Ti(e.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            Le,
                            Ue
                        ],
                        (t1, [e, r])=>Ti(e.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            get: {
                type: je,
                overloads: [
                    [
                        [
                            Le
                        ],
                        (t1, [e])=>Ei(e.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            Le,
                            Ue
                        ],
                        (t1, [e, r])=>Ei(e.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            "feature-state": [
                je,
                [
                    Le
                ],
                (t1, [e])=>Ei(e.evaluate(t1), t1.featureState || {})
            ],
            properties: [
                Ue,
                [],
                (t1)=>t1.properties()
            ],
            "geometry-type": [
                Le,
                [],
                (t1)=>t1.geometryType()
            ],
            id: [
                je,
                [],
                (t1)=>t1.id()
            ],
            zoom: [
                De,
                [],
                (t1)=>t1.globals.zoom
            ],
            pitch: [
                De,
                [],
                (t1)=>t1.globals.pitch || 0
            ],
            "distance-from-center": [
                De,
                [],
                (t1)=>t1.distanceFromCenter()
            ],
            "measure-light": [
                De,
                [
                    Le
                ],
                (t1, [e])=>t1.measureLight(e.evaluate(t1))
            ],
            "heatmap-density": [
                De,
                [],
                (t1)=>t1.globals.heatmapDensity || 0
            ],
            "line-progress": [
                De,
                [],
                (t1)=>t1.globals.lineProgress || 0
            ],
            "raster-value": [
                De,
                [],
                (t1)=>t1.globals.rasterValue || 0
            ],
            "raster-particle-speed": [
                De,
                [],
                (t1)=>t1.globals.rasterParticleSpeed || 0
            ],
            "sky-radial-progress": [
                De,
                [],
                (t1)=>t1.globals.skyRadialProgress || 0
            ],
            accumulated: [
                je,
                [],
                (t1)=>void 0 === t1.globals.accumulated ? null : t1.globals.accumulated
            ],
            "+": [
                De,
                Bi(De),
                (t1, e)=>{
                    let r = 0;
                    for (const n of e)r += n.evaluate(t1);
                    return r;
                }
            ],
            "*": [
                De,
                Bi(De),
                (t1, e)=>{
                    let r = 1;
                    for (const n of e)r *= n.evaluate(t1);
                    return r;
                }
            ],
            "-": {
                type: De,
                overloads: [
                    [
                        [
                            De,
                            De
                        ],
                        (t1, [e, r])=>e.evaluate(t1) - r.evaluate(t1)
                    ],
                    [
                        [
                            De
                        ],
                        (t1, [e])=>-e.evaluate(t1)
                    ]
                ]
            },
            "/": [
                De,
                [
                    De,
                    De
                ],
                (t1, [e, r])=>e.evaluate(t1) / r.evaluate(t1)
            ],
            "%": [
                De,
                [
                    De,
                    De
                ],
                (t1, [e, r])=>e.evaluate(t1) % r.evaluate(t1)
            ],
            ln2: [
                De,
                [],
                ()=>Math.LN2
            ],
            pi: [
                De,
                [],
                ()=>Math.PI
            ],
            e: [
                De,
                [],
                ()=>Math.E
            ],
            "^": [
                De,
                [
                    De,
                    De
                ],
                (t1, [e, r])=>Math.pow(e.evaluate(t1), r.evaluate(t1))
            ],
            sqrt: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.sqrt(e.evaluate(t1))
            ],
            log10: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.log(e.evaluate(t1)) / Math.LN10
            ],
            ln: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.log(e.evaluate(t1))
            ],
            log2: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.log(e.evaluate(t1)) / Math.LN2
            ],
            sin: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.sin(e.evaluate(t1))
            ],
            cos: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.cos(e.evaluate(t1))
            ],
            tan: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.tan(e.evaluate(t1))
            ],
            asin: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.asin(e.evaluate(t1))
            ],
            acos: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.acos(e.evaluate(t1))
            ],
            atan: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.atan(e.evaluate(t1))
            ],
            min: [
                De,
                Bi(De),
                (t1, e)=>Math.min(...e.map((e)=>e.evaluate(t1)))
            ],
            max: [
                De,
                Bi(De),
                (t1, e)=>Math.max(...e.map((e)=>e.evaluate(t1)))
            ],
            abs: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.abs(e.evaluate(t1))
            ],
            round: [
                De,
                [
                    De
                ],
                (t1, [e])=>{
                    const r = e.evaluate(t1);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.floor(e.evaluate(t1))
            ],
            ceil: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.ceil(e.evaluate(t1))
            ],
            "filter-==": [
                Fe,
                [
                    Le,
                    je
                ],
                (t1, [e, r])=>t1.properties()[e.value] === r.value
            ],
            "filter-id-==": [
                Fe,
                [
                    je
                ],
                (t1, [e])=>t1.id() === e.value
            ],
            "filter-type-==": [
                Fe,
                [
                    Le
                ],
                (t1, [e])=>t1.geometryType() === e.value
            ],
            "filter-<": [
                Fe,
                [
                    Le,
                    je
                ],
                (t1, [e, r])=>{
                    const n = t1.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                Fe,
                [
                    je
                ],
                (t1, [e])=>{
                    const r = t1.id(), n = e.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                Fe,
                [
                    Le,
                    je
                ],
                (t1, [e, r])=>{
                    const n = t1.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                Fe,
                [
                    je
                ],
                (t1, [e])=>{
                    const r = t1.id(), n = e.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                Fe,
                [
                    Le,
                    je
                ],
                (t1, [e, r])=>{
                    const n = t1.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                Fe,
                [
                    je
                ],
                (t1, [e])=>{
                    const r = t1.id(), n = e.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                Fe,
                [
                    Le,
                    je
                ],
                (t1, [e, r])=>{
                    const n = t1.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                Fe,
                [
                    je
                ],
                (t1, [e])=>{
                    const r = t1.id(), n = e.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                Fe,
                [
                    je
                ],
                (t1, [e])=>e.value in t1.properties()
            ],
            "filter-has-id": [
                Fe,
                [],
                (t1)=>null !== t1.id() && void 0 !== t1.id()
            ],
            "filter-type-in": [
                Fe,
                [
                    Ge(Le)
                ],
                (t1, [e])=>e.value.indexOf(t1.geometryType()) >= 0
            ],
            "filter-id-in": [
                Fe,
                [
                    Ge(je)
                ],
                (t1, [e])=>e.value.indexOf(t1.id()) >= 0
            ],
            "filter-in-small": [
                Fe,
                [
                    Le,
                    Ge(je)
                ],
                (t1, [e, r])=>r.value.indexOf(t1.properties()[e.value]) >= 0
            ],
            "filter-in-large": [
                Fe,
                [
                    Le,
                    Ge(je)
                ],
                (t1, [e, r])=>(function(t1, e, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (e[i] === t1) return !0;
                            e[i] > t1 ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(t1.properties()[e.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: Fe,
                overloads: [
                    [
                        [
                            Fe,
                            Fe
                        ],
                        (t1, [e, r])=>e.evaluate(t1) && r.evaluate(t1)
                    ],
                    [
                        Bi(Fe),
                        (t1, e)=>{
                            for (const r of e)if (!r.evaluate(t1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: Fe,
                overloads: [
                    [
                        [
                            Fe,
                            Fe
                        ],
                        (t1, [e, r])=>e.evaluate(t1) || r.evaluate(t1)
                    ],
                    [
                        Bi(Fe),
                        (t1, e)=>{
                            for (const r of e)if (r.evaluate(t1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                Fe,
                [
                    Fe
                ],
                (t1, [e])=>!e.evaluate(t1)
            ],
            "is-supported-script": [
                Fe,
                [
                    Le
                ],
                (t1, [e])=>{
                    const r = t1.globals && t1.globals.isSupportedScript;
                    return !r || r(e.evaluate(t1));
                }
            ],
            upcase: [
                Le,
                [
                    Le
                ],
                (t1, [e])=>e.evaluate(t1).toUpperCase()
            ],
            downcase: [
                Le,
                [
                    Le
                ],
                (t1, [e])=>e.evaluate(t1).toLowerCase()
            ],
            concat: [
                Le,
                Bi(je),
                (t1, e)=>e.map((e)=>ir(e.evaluate(t1))).join("")
            ],
            "resolved-locale": [
                Le,
                [
                    Ne
                ],
                (t1, [e])=>e.evaluate(t1).resolvedLocale()
            ],
            random: [
                De,
                [
                    De,
                    De,
                    je
                ],
                (t1, e)=>{
                    const [r, n, i] = e.map((e)=>e.evaluate(t1));
                    if (r > n) return r;
                    if (r === n) return r;
                    let s;
                    if ("string" == typeof i) s = function(t1) {
                        let e = 0;
                        if (0 === t1.length) return e;
                        for(let r = 0; r < t1.length; r++)e = (e << 5) - e + t1.charCodeAt(r), e |= 0;
                        return e;
                    }(i);
                    else {
                        if ("number" != typeof i) throw new ar(`Invalid seed input: ${i}`);
                        s = i;
                    }
                    return r + Ii(s)() * (n - r);
                }
            ]
        });
        class Zi {
            constructor(t1, e, r, n){
                this.expression = t1, this._warningHistory = {}, this._evaluator = new mr(r, n), this._defaultValue = e ? function(t1) {
                    return "color" === t1.type && (Ui(t1.default) || Array.isArray(t1.default)) ? new Pe(0, 0, 0, 0) : "color" === t1.type ? Pe.parse(t1.default) || null : void 0 === t1.default ? null : t1.default;
                }(e) : null, this._enumValues = e && "enum" === e.type ? e.values : null;
            }
            evaluateWithoutErrorHandling(t1, e, r, n, i, s, a, o) {
                return this._evaluator.globals = t1, this._evaluator.feature = e, this._evaluator.featureState = r, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = o || null, this.expression.evaluate(this._evaluator);
            }
            evaluate(t1, e, r, n, i, s, a, o) {
                this._evaluator.globals = t1, this._evaluator.feature = e || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s || null, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = o || null;
                try {
                    const t1 = this.expression.evaluate(this._evaluator);
                    if (null == t1 || "number" == typeof t1 && t1 != t1) return this._defaultValue;
                    if (this._enumValues && !(t1 in this._enumValues)) throw new ar(`Expected value to be one of ${Object.keys(this._enumValues).map((t1)=>JSON.stringify(t1)).join(", ")}, but found ${JSON.stringify(t1)} instead.`);
                    return t1;
                } catch (t1) {
                    return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(`Failed to evaluate expression "${JSON.stringify(this.expression.serialize())}". ${t1.message}`)), this._defaultValue;
                }
            }
        }
        function Wi(t1) {
            return Array.isArray(t1) && t1.length > 0 && "string" == typeof t1[0] && t1[0] in Pi;
        }
        function Hi(t1, e, r, n) {
            const i = new Ln(Pi, [], e ? function(t1) {
                const e = {
                    color: Oe,
                    string: Le,
                    number: De,
                    enum: Le,
                    boolean: Fe,
                    formatted: qe,
                    resolvedImage: $e
                };
                return "array" === t1.type ? Ge(e[t1.value] || je, t1.length) : e[t1.type];
            }(e) : void 0, void 0, void 0, r, n), s = i.parse(t1, void 0, void 0, void 0, e && "string" === e.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return s ? Vi(new Zi(s, e, r, n)) : Ci(i.errors);
        }
        class Ki {
            constructor(t1, e, r){
                this.kind = t1, this._styleExpression = e, this.isLightConstant = r, this.isStateDependent = "constant" !== t1 && !Bn(e.expression), this.configDependencies = Vn(e.expression);
            }
            evaluateWithoutErrorHandling(t1, e, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e, r, n, i, s);
            }
            evaluate(t1, e, r, n, i, s) {
                return this._styleExpression.evaluate(t1, e, r, n, i, s);
            }
        }
        class Ji {
            constructor(t1, e, r, n, i){
                this.kind = t1, this.zoomStops = r, this._styleExpression = e, this.isStateDependent = "camera" !== t1 && !Bn(e.expression), this.isLightConstant = i, this.configDependencies = Vn(e.expression), this.interpolationType = n;
            }
            evaluateWithoutErrorHandling(t1, e, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e, r, n, i, s);
            }
            evaluate(t1, e, r, n, i, s) {
                return this._styleExpression.evaluate(t1, e, r, n, i, s);
            }
            interpolationFactor(t1, e, r) {
                return this.interpolationType ? si.interpolationFactor(this.interpolationType, t1, e, r) : 0;
            }
        }
        function Qi(t1, e, r, n) {
            if ("error" === (t1 = Hi(t1, e, r, n)).result) return t1;
            const i = t1.value.expression, s = En(i);
            if (!s && !Di(e)) return Ci([
                new Ve("", "data expressions not supported")
            ]);
            const a = Cn(i, [
                "zoom",
                "pitch",
                "distance-from-center"
            ]);
            if (!a && !Fi(e)) return Ci([
                new Ve("", "zoom expressions not supported")
            ]);
            const o = Cn(i, [
                "measure-light"
            ]);
            if (!o && !Li(e)) return Ci([
                new Ve("", "measure-light expression not supported")
            ]);
            const l = e.expression && e.expression.relaxZoomRestriction, u = es(i);
            return u || a || l ? u instanceof Ve ? Ci([
                u
            ]) : u instanceof si && !Oi(e) ? Ci([
                new Ve("", '"interpolate" expressions cannot be used with this property')
            ]) : Vi(u ? new Ji(s ? "camera" : "composite", t1.value, u.labels, u instanceof si ? u.interpolation : void 0, o) : new Ki(s ? "constant" : "source", t1.value, o)) : Ci([
                new Ve("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')
            ]);
        }
        class ts {
            constructor(t1, e){
                this._parameters = t1, this._specification = e, Be(this, Ni(this._parameters, this._specification));
            }
            static deserialize(t1) {
                return new ts(t1._parameters, t1._specification);
            }
            static serialize(t1) {
                return {
                    _parameters: t1._parameters,
                    _specification: t1._specification
                };
            }
        }
        function es(t1) {
            let e = null;
            if (t1 instanceof li) e = es(t1.result);
            else if (t1 instanceof oi) {
                for (const r of t1.args)if (e = es(r), e) break;
            } else (t1 instanceof Un || t1 instanceof si) && t1.input instanceof yr && "zoom" === t1.input.name && (e = t1);
            return e instanceof Ve || t1.eachChild((t1)=>{
                const r = es(t1);
                r instanceof Ve ? e = r : e && r && e !== r && (e = new Ve("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e;
        }
        var rs, ns, is = function() {
            if (ns) return rs;
            ns = 1, rs = e;
            var t1 = 3;
            function e(e, r, n) {
                var i = this.cells = [];
                if (e instanceof ArrayBuffer) {
                    this.arrayBuffer = e;
                    var s = new Int32Array(this.arrayBuffer);
                    e = s[0], this.d = (r = s[1]) + 2 * (n = s[2]);
                    for(var a = 0; a < this.d * this.d; a++){
                        var o = s[t1 + a], l = s[t1 + a + 1];
                        i.push(o === l ? null : s.subarray(o, l));
                    }
                    var u = s[t1 + i.length + 1];
                    this.keys = s.subarray(s[t1 + i.length], u), this.bboxes = s.subarray(u), this.insert = this._insertReadonly;
                } else {
                    this.d = r + 2 * n;
                    for(var c = 0; c < this.d * this.d; c++)i.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = r, this.extent = e, this.padding = n, this.scale = r / e, this.uid = 0;
                var h = n / r * e;
                this.min = -h, this.max = e + h;
            }
            return e.prototype.insert = function(t1, e, r, n, i) {
                this._forEachCell(e, r, n, i, this._insertCell, this.uid++), this.keys.push(t1), this.bboxes.push(e), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
            }, e.prototype._insertReadonly = function() {
                throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
            }, e.prototype._insertCell = function(t1, e, r, n, i, s) {
                this.cells[i].push(s);
            }, e.prototype.query = function(t1, e, r, n, i) {
                var s = this.min, a = this.max;
                if (t1 <= s && e <= s && a <= r && a <= n && !i) return Array.prototype.slice.call(this.keys);
                var o = [];
                return this._forEachCell(t1, e, r, n, this._queryCell, o, {}, i), o;
            }, e.prototype._queryCell = function(t1, e, r, n, i, s, a, o) {
                var l = this.cells[i];
                if (null !== l) for(var u = this.keys, c = this.bboxes, h = 0; h < l.length; h++){
                    var p = l[h];
                    if (void 0 === a[p]) {
                        var f = 4 * p;
                        (o ? o(c[f + 0], c[f + 1], c[f + 2], c[f + 3]) : t1 <= c[f + 2] && e <= c[f + 3] && r >= c[f + 0] && n >= c[f + 1]) ? (a[p] = !0, s.push(u[p])) : a[p] = !1;
                    }
                }
            }, e.prototype._forEachCell = function(t1, e, r, n, i, s, a, o) {
                for(var l = this._convertToCellCoord(t1), u = this._convertToCellCoord(e), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n), p = l; p <= c; p++)for(var f = u; f <= h; f++){
                    var d = this.d * f + p;
                    if ((!o || o(this._convertFromCellCoord(p), this._convertFromCellCoord(f), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(f + 1))) && i.call(this, t1, e, r, n, d, s, a, o)) return;
                }
            }, e.prototype._convertFromCellCoord = function(t1) {
                return (t1 - this.padding) / this.scale;
            }, e.prototype._convertToCellCoord = function(t1) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(t1 * this.scale) + this.padding));
            }, e.prototype.toArrayBuffer = function() {
                if (this.arrayBuffer) return this.arrayBuffer;
                for(var e = this.cells, r = t1 + this.cells.length + 1 + 1, n = 0, i = 0; i < this.cells.length; i++)n += this.cells[i].length;
                var s = new Int32Array(r + n + this.keys.length + this.bboxes.length);
                s[0] = this.extent, s[1] = this.n, s[2] = this.padding;
                for(var a = r, o = 0; o < e.length; o++){
                    var l = e[o];
                    s[t1 + o] = a, s.set(l, a), a += l.length;
                }
                return s[t1 + e.length] = a, s.set(this.keys, a), s[t1 + e.length + 1] = a += this.keys.length, s.set(this.bboxes, a), a += this.bboxes.length, s.buffer;
            }, rs;
        }(), ss = e(is);
        const as = {};
        function os(t1, e, r = {}) {
            Object.defineProperty(t1, "_classRegistryKey", {
                value: e,
                writable: !1
            }), as[e] = {
                klass: t1,
                omit: r.omit || []
            };
        }
        os(Object, "Object"), ss.serialize = function(t1, e) {
            const r = t1.toArrayBuffer();
            return e && e.add(r), {
                buffer: r
            };
        }, ss.deserialize = function(t1) {
            return new ss(t1.buffer);
        }, Object.defineProperty(ss, "name", {
            value: "Grid"
        }), os(ss, "Grid"), os(Pe, "Color"), os(Error, "Error"), os(Qe, "Formatted"), os(Je, "FormattedSection"), os(re, "AJAXError"), os(tr, "ResolvedImage"), os(ts, "StylePropertyFunction"), os(Zi, "StyleExpression", {
            omit: [
                "_evaluator"
            ]
        }), os(Ji, "ZoomDependentExpression"), os(Ki, "ZoomConstantExpression"), os(yr, "CompoundExpression", {
            omit: [
                "_evaluate"
            ]
        });
        for(const t1 in Pi)as[Pi[t1]._classRegistryKey] || os(Pi[t1], `Expression${t1}`);
        function ls(t1) {
            return t1 && "undefined" != typeof ArrayBuffer && (t1 instanceof ArrayBuffer || t1.constructor && "ArrayBuffer" === t1.constructor.name);
        }
        function us(t1) {
            return self.ImageBitmap && t1 instanceof ImageBitmap;
        }
        function cs(t1, e) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp) return t1;
            if (ls(t1) || us(t1)) return e && e.add(t1), t1;
            if (ArrayBuffer.isView(t1)) {
                const r = t1;
                return e && e.add(r.buffer), r;
            }
            if (t1 instanceof ImageData) return e && e.add(t1.data.buffer), t1;
            if (Array.isArray(t1)) {
                const r = [];
                for (const n of t1)r.push(cs(n, e));
                return r;
            }
            if (t1 instanceof Map) {
                const e = {
                    $name: "Map"
                };
                for (const [r, n] of t1.entries())e[r] = cs(n);
                return e;
            }
            if (t1 instanceof Set) {
                const e = {
                    $name: "Set"
                };
                let r = 0;
                for (const n of t1.values())e[++r] = cs(n);
                return e;
            }
            if ("object" == typeof t1) {
                const r = t1.constructor, n = r._classRegistryKey;
                if (!n) throw new Error(`can't serialize object of unregistered class ${n}`);
                const i = r.serialize ? r.serialize(t1, e) : {};
                if (!r.serialize) {
                    for(const r in t1)t1.hasOwnProperty(r) && (as[n].omit.indexOf(r) >= 0 || (i[r] = cs(t1[r], e)));
                    t1 instanceof Error && (i.message = t1.message);
                }
                if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== n && (i.$name = n), i;
            }
            throw new Error("can't serialize object of type " + typeof t1);
        }
        function hs(t1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || ls(t1) || us(t1) || ArrayBuffer.isView(t1) || t1 instanceof ImageData) return t1;
            if (Array.isArray(t1)) return t1.map(hs);
            if ("object" == typeof t1) {
                const e = t1.$name || "Object";
                if ("Map" === e) {
                    const e = new Map;
                    for (const r of Object.keys(t1))"$name" !== r && e.set(r, hs(t1[r]));
                    return e;
                }
                if ("Set" === e) {
                    const e = new Set;
                    for (const r of Object.keys(t1))"$name" !== r && e.add(hs(t1[r]));
                    return e;
                }
                const { klass: r } = as[e];
                if (!r) throw new Error(`can't deserialize unregistered class ${e}`);
                if (r.deserialize) return r.deserialize(t1);
                const n = Object.create(r.prototype);
                for (const e of Object.keys(t1))"$name" !== e && (n[e] = hs(t1[e]));
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof t1);
        }
        const ps = {
            "Latin-1 Supplement": (t1)=>t1 >= 128 && t1 <= 255,
            Arabic: (t1)=>t1 >= 1536 && t1 <= 1791,
            "Arabic Supplement": (t1)=>t1 >= 1872 && t1 <= 1919,
            "Arabic Extended-A": (t1)=>t1 >= 2208 && t1 <= 2303,
            "Hangul Jamo": (t1)=>t1 >= 4352 && t1 <= 4607,
            "Unified Canadian Aboriginal Syllabics": (t1)=>t1 >= 5120 && t1 <= 5759,
            Khmer: (t1)=>t1 >= 6016 && t1 <= 6143,
            "Unified Canadian Aboriginal Syllabics Extended": (t1)=>t1 >= 6320 && t1 <= 6399,
            "General Punctuation": (t1)=>t1 >= 8192 && t1 <= 8303,
            "Letterlike Symbols": (t1)=>t1 >= 8448 && t1 <= 8527,
            "Number Forms": (t1)=>t1 >= 8528 && t1 <= 8591,
            "Miscellaneous Technical": (t1)=>t1 >= 8960 && t1 <= 9215,
            "Control Pictures": (t1)=>t1 >= 9216 && t1 <= 9279,
            "Optical Character Recognition": (t1)=>t1 >= 9280 && t1 <= 9311,
            "Enclosed Alphanumerics": (t1)=>t1 >= 9312 && t1 <= 9471,
            "Geometric Shapes": (t1)=>t1 >= 9632 && t1 <= 9727,
            "Miscellaneous Symbols": (t1)=>t1 >= 9728 && t1 <= 9983,
            "Miscellaneous Symbols and Arrows": (t1)=>t1 >= 11008 && t1 <= 11263,
            "CJK Radicals Supplement": (t1)=>t1 >= 11904 && t1 <= 12031,
            "Kangxi Radicals": (t1)=>t1 >= 12032 && t1 <= 12255,
            "Ideographic Description Characters": (t1)=>t1 >= 12272 && t1 <= 12287,
            "CJK Symbols and Punctuation": (t1)=>t1 >= 12288 && t1 <= 12351,
            Hiragana: (t1)=>t1 >= 12352 && t1 <= 12447,
            Katakana: (t1)=>t1 >= 12448 && t1 <= 12543,
            Bopomofo: (t1)=>t1 >= 12544 && t1 <= 12591,
            "Hangul Compatibility Jamo": (t1)=>t1 >= 12592 && t1 <= 12687,
            Kanbun: (t1)=>t1 >= 12688 && t1 <= 12703,
            "Bopomofo Extended": (t1)=>t1 >= 12704 && t1 <= 12735,
            "CJK Strokes": (t1)=>t1 >= 12736 && t1 <= 12783,
            "Katakana Phonetic Extensions": (t1)=>t1 >= 12784 && t1 <= 12799,
            "Enclosed CJK Letters and Months": (t1)=>t1 >= 12800 && t1 <= 13055,
            "CJK Compatibility": (t1)=>t1 >= 13056 && t1 <= 13311,
            "CJK Unified Ideographs Extension A": (t1)=>t1 >= 13312 && t1 <= 19903,
            "Yijing Hexagram Symbols": (t1)=>t1 >= 19904 && t1 <= 19967,
            "CJK Unified Ideographs": (t1)=>t1 >= 19968 && t1 <= 40959,
            "Yi Syllables": (t1)=>t1 >= 40960 && t1 <= 42127,
            "Yi Radicals": (t1)=>t1 >= 42128 && t1 <= 42191,
            "Hangul Jamo Extended-A": (t1)=>t1 >= 43360 && t1 <= 43391,
            "Hangul Syllables": (t1)=>t1 >= 44032 && t1 <= 55215,
            "Hangul Jamo Extended-B": (t1)=>t1 >= 55216 && t1 <= 55295,
            "Private Use Area": (t1)=>t1 >= 57344 && t1 <= 63743,
            "CJK Compatibility Ideographs": (t1)=>t1 >= 63744 && t1 <= 64255,
            "Arabic Presentation Forms-A": (t1)=>t1 >= 64336 && t1 <= 65023,
            "Vertical Forms": (t1)=>t1 >= 65040 && t1 <= 65055,
            "CJK Compatibility Forms": (t1)=>t1 >= 65072 && t1 <= 65103,
            "Small Form Variants": (t1)=>t1 >= 65104 && t1 <= 65135,
            "Arabic Presentation Forms-B": (t1)=>t1 >= 65136 && t1 <= 65279,
            "Halfwidth and Fullwidth Forms": (t1)=>t1 >= 65280 && t1 <= 65519,
            "CJK Unified Ideographs Extension B": (t1)=>t1 >= 131072 && t1 <= 173791
        };
        function fs(t1) {
            for (const e of t1)if (ys(e.charCodeAt(0))) return !0;
            return !1;
        }
        function ds(t1) {
            for (const e of t1)if (!ms(e.charCodeAt(0))) return !1;
            return !0;
        }
        function ms(t1) {
            return !(ps.Arabic(t1) || ps["Arabic Supplement"](t1) || ps["Arabic Extended-A"](t1) || ps["Arabic Presentation Forms-A"](t1) || ps["Arabic Presentation Forms-B"](t1));
        }
        function ys(t1) {
            return !(746 !== t1 && 747 !== t1 && (t1 < 4352 || !(ps["Bopomofo Extended"](t1) || ps.Bopomofo(t1) || ps["CJK Compatibility Forms"](t1) && !(t1 >= 65097 && t1 <= 65103) || ps["CJK Compatibility Ideographs"](t1) || ps["CJK Compatibility"](t1) || ps["CJK Radicals Supplement"](t1) || ps["CJK Strokes"](t1) || !(!ps["CJK Symbols and Punctuation"](t1) || t1 >= 12296 && t1 <= 12305 || t1 >= 12308 && t1 <= 12319 || 12336 === t1) || ps["CJK Unified Ideographs Extension A"](t1) || ps["CJK Unified Ideographs"](t1) || ps["Enclosed CJK Letters and Months"](t1) || ps["Hangul Compatibility Jamo"](t1) || ps["Hangul Jamo Extended-A"](t1) || ps["Hangul Jamo Extended-B"](t1) || ps["Hangul Jamo"](t1) || ps["Hangul Syllables"](t1) || ps.Hiragana(t1) || ps["Ideographic Description Characters"](t1) || ps.Kanbun(t1) || ps["Kangxi Radicals"](t1) || ps["Katakana Phonetic Extensions"](t1) || ps.Katakana(t1) && 12540 !== t1 || !(!ps["Halfwidth and Fullwidth Forms"](t1) || 65288 === t1 || 65289 === t1 || 65293 === t1 || t1 >= 65306 && t1 <= 65310 || 65339 === t1 || 65341 === t1 || 65343 === t1 || t1 >= 65371 && t1 <= 65503 || 65507 === t1 || t1 >= 65512 && t1 <= 65519) || !(!ps["Small Form Variants"](t1) || t1 >= 65112 && t1 <= 65118 || t1 >= 65123 && t1 <= 65126) || ps["Unified Canadian Aboriginal Syllabics"](t1) || ps["Unified Canadian Aboriginal Syllabics Extended"](t1) || ps["Vertical Forms"](t1) || ps["Yijing Hexagram Symbols"](t1) || ps["Yi Syllables"](t1) || ps["Yi Radicals"](t1))));
        }
        function gs(t1) {
            return !(ys(t1) || function(t1) {
                return !!(ps["Latin-1 Supplement"](t1) && (167 === t1 || 169 === t1 || 174 === t1 || 177 === t1 || 188 === t1 || 189 === t1 || 190 === t1 || 215 === t1 || 247 === t1) || ps["General Punctuation"](t1) && (8214 === t1 || 8224 === t1 || 8225 === t1 || 8240 === t1 || 8241 === t1 || 8251 === t1 || 8252 === t1 || 8258 === t1 || 8263 === t1 || 8264 === t1 || 8265 === t1 || 8273 === t1) || ps["Letterlike Symbols"](t1) || ps["Number Forms"](t1) || ps["Miscellaneous Technical"](t1) && (t1 >= 8960 && t1 <= 8967 || t1 >= 8972 && t1 <= 8991 || t1 >= 8996 && t1 <= 9e3 || 9003 === t1 || t1 >= 9085 && t1 <= 9114 || t1 >= 9150 && t1 <= 9165 || 9167 === t1 || t1 >= 9169 && t1 <= 9179 || t1 >= 9186 && t1 <= 9215) || ps["Control Pictures"](t1) && 9251 !== t1 || ps["Optical Character Recognition"](t1) || ps["Enclosed Alphanumerics"](t1) || ps["Geometric Shapes"](t1) || ps["Miscellaneous Symbols"](t1) && !(t1 >= 9754 && t1 <= 9759) || ps["Miscellaneous Symbols and Arrows"](t1) && (t1 >= 11026 && t1 <= 11055 || t1 >= 11088 && t1 <= 11097 || t1 >= 11192 && t1 <= 11243) || ps["CJK Symbols and Punctuation"](t1) || ps.Katakana(t1) || ps["Private Use Area"](t1) || ps["CJK Compatibility Forms"](t1) || ps["Small Form Variants"](t1) || ps["Halfwidth and Fullwidth Forms"](t1) || 8734 === t1 || 8756 === t1 || 8757 === t1 || t1 >= 9984 && t1 <= 10087 || t1 >= 10102 && t1 <= 10131 || 65532 === t1 || 65533 === t1);
            }(t1));
        }
        function xs(t1) {
            return t1 >= 1424 && t1 <= 2303 || ps["Arabic Presentation Forms-A"](t1) || ps["Arabic Presentation Forms-B"](t1);
        }
        function bs(t1, e) {
            return !(!e && xs(t1) || t1 >= 2304 && t1 <= 3583 || t1 >= 3840 && t1 <= 4255 || ps.Khmer(t1));
        }
        function vs(t1) {
            for (const e of t1)if (xs(e.charCodeAt(0))) return !0;
            return !1;
        }
        const ws = "deferred", _s = "loading", Ms = "loaded";
        let As = null, Ss = "unavailable", Is = null;
        const Ps = function(t1) {
            t1 && "string" == typeof t1 && t1.indexOf("NetworkError") > -1 && (Ss = "error"), As && As(t1);
        };
        function zs() {
            ks.fire(new be("pluginStateChange", {
                pluginStatus: Ss,
                pluginURL: Is
            }));
        }
        const ks = new Me, Ts = function() {
            return Ss;
        }, Es = function() {
            if (Ss !== ws || !Is) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            Ss = _s, zs(), Is && se({
                url: Is
            }, (t1)=>{
                t1 ? Ps(t1) : (Ss = Ms, zs());
            });
        }, Bs = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>Ss === Ms || null != Bs.applyArabicShaping,
            isLoading: ()=>Ss === _s,
            setState (t1) {
                Ss = t1.pluginStatus, Is = t1.pluginURL;
            },
            isParsed: ()=>null != Bs.applyArabicShaping && null != Bs.processBidirectionalText && null != Bs.processStyledBidirectionalText,
            getPluginURL: ()=>Is
        };
        class Vs {
            constructor(t1, e){
                this.zoom = t1, e ? (this.now = e.now, this.fadeDuration = e.fadeDuration, this.transition = e.transition, this.pitch = e.pitch, this.brightness = e.brightness) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
            }
            isSupportedScript(t1) {
                return function(t1, e) {
                    for (const r of t1)if (!bs(r.charCodeAt(0), e)) return !1;
                    return !0;
                }(t1, Bs.isLoaded());
            }
        }
        class Cs {
            constructor(t1, e, r, n){
                this.property = t1, this.value = e, this.expression = function(t1, e, r, n) {
                    if (Ui(t1)) return new ts(t1, e);
                    if (Wi(t1) || Array.isArray(t1) && t1.length > 0) {
                        const i = Qi(t1, e, r, n);
                        if ("error" === i.result) throw new Error(i.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                        return i.value;
                    }
                    {
                        let r = t1;
                        return "string" == typeof t1 && "color" === e.type && (r = Pe.parse(t1)), {
                            kind: "constant",
                            configDependencies: new Set,
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === e ? t1.specification.default : e, t1.specification, r, n);
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(t1, e, r) {
                return this.property.possiblyEvaluate(this, t1, e, r);
            }
        }
        class Rs {
            constructor(t1, e, r){
                this.property = t1, this.value = new Cs(t1, void 0, e, r);
            }
            transitioned(t1, e) {
                return new Ls(this.property, this.value, e, nt({}, t1.transition, this.transition), t1.now);
            }
            untransitioned() {
                return new Ls(this.property, this.value, null, {}, 0);
            }
        }
        class Ds {
            constructor(t1, e, r){
                this._properties = t1, this._values = Object.create(t1.defaultTransitionablePropertyValues), this._scope = e, this._options = r, this.configDependencies = new Set;
            }
            getValue(t1) {
                return ht(this._values[t1].value.value);
            }
            setValue(t1, e) {
                this._values.hasOwnProperty(t1) || (this._values[t1] = new Rs(this._values[t1].property, this._scope, this._options)), this._values[t1].value = new Cs(this._values[t1].property, null === e ? void 0 : ht(e), this._scope, this._options), this._values[t1].value.expression.configDependencies && (this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._values[t1].value.expression.configDependencies
                ]));
            }
            setTransitionOrValue(t1, e) {
                e && (this._options = e);
                const r = this._properties.properties;
                if (t1) for(const e in t1){
                    const n = t1[e];
                    if (lt(e, "-transition")) {
                        const t1 = e.slice(0, -11);
                        r[t1] && this.setTransition(t1, n);
                    } else r.hasOwnProperty(e) && this.setValue(e, n);
                }
            }
            getTransition(t1) {
                return ht(this._values[t1].transition);
            }
            setTransition(t1, e) {
                this._values.hasOwnProperty(t1) || (this._values[t1] = new Rs(this._values[t1].property)), this._values[t1].transition = ht(e) || void 0;
            }
            serialize() {
                const t1 = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t1[e] = r);
                    const n = this.getTransition(e);
                    void 0 !== n && (t1[`${e}-transition`] = n);
                }
                return t1;
            }
            transitioned(t1, e) {
                const r = new Fs(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(t1, e._values[n]);
                return r;
            }
            untransitioned() {
                const t1 = new Fs(this._properties);
                for (const e of Object.keys(this._values))t1._values[e] = this._values[e].untransitioned();
                return t1;
            }
        }
        class Ls {
            constructor(t1, e, r, n, i){
                const s = n.delay || 0, a = n.duration || 0;
                i = i || 0, this.property = t1, this.value = e, this.begin = i + s, this.end = this.begin + a, t1.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
            possiblyEvaluate(t1, e, r) {
                const n = t1.now || 0, i = this.value.possiblyEvaluate(t1, e, r), s = this.prior;
                if (s) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return s.possiblyEvaluate(t1, e, r);
                    {
                        const a = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(s.possiblyEvaluate(t1, e, r), i, H(a));
                    }
                }
                return i;
            }
        }
        class Fs {
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(t1, e, r) {
                const n = new js(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e, r);
                return n;
            }
            hasTransition() {
                for (const t1 of Object.keys(this._values))if (this._values[t1].prior) return !0;
                return !1;
            }
        }
        class Os {
            constructor(t1, e, r){
                this._properties = t1, this._values = Object.create(t1.defaultPropertyValues), this._scope = e, this._options = r, this.configDependencies = new Set;
            }
            getValue(t1) {
                return ht(this._values[t1].value);
            }
            setValue(t1, e) {
                this._values[t1] = new Cs(this._values[t1].property, null === e ? void 0 : ht(e), this._scope, this._options), this._values[t1].expression.configDependencies && (this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._values[t1].expression.configDependencies
                ]));
            }
            serialize() {
                const t1 = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t1[e] = r);
                }
                return t1;
            }
            possiblyEvaluate(t1, e, r) {
                const n = new js(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e, r);
                return n;
            }
        }
        class Us {
            constructor(t1, e, r){
                this.property = t1, this.value = e, this.parameters = r;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(t1) {
                return "constant" === this.value.kind ? this.value.value : t1;
            }
            evaluate(t1, e, r, n) {
                return this.property.evaluate(this.value, this.parameters, t1, e, r, n);
            }
        }
        class js {
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultPossiblyEvaluatedValues);
            }
            get(t1) {
                return this._values[t1];
            }
        }
        class Ns {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e) {
                return t1.expression.evaluate(e);
            }
            interpolate(t1, e, r) {
                const n = Ee[this.specification.type];
                return n ? n(t1, e, r) : t1;
            }
        }
        class qs {
            constructor(t1, e){
                this.specification = t1, this.overrides = e;
            }
            possiblyEvaluate(t1, e, r, n) {
                return new Us(this, "constant" === t1.expression.kind || "camera" === t1.expression.kind ? {
                    kind: "constant",
                    value: t1.expression.evaluate(e, null, {}, r, n)
                } : t1.expression, e);
            }
            interpolate(t1, e, r) {
                if ("constant" !== t1.value.kind || "constant" !== e.value.kind) return t1;
                if (void 0 === t1.value.value || void 0 === e.value.value) return new Us(this, {
                    kind: "constant",
                    value: void 0
                }, t1.parameters);
                const n = Ee[this.specification.type];
                return n ? new Us(this, {
                    kind: "constant",
                    value: n(t1.value.value, e.value.value, r)
                }, t1.parameters) : t1;
            }
            evaluate(t1, e, r, n, i, s) {
                return "constant" === t1.kind ? t1.value : t1.evaluate(e, r, n, i, s);
            }
        }
        class $s {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e, r, n) {
                return !!t1.expression.evaluate(e, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
        }
        class Gs {
            constructor(t1){
                this.properties = t1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                const e = new Vs(0, {});
                for(const r in t1){
                    const n = t1[r];
                    n.specification.overridable && this.overridableProperties.push(r);
                    const i = this.defaultPropertyValues[r] = new Cs(n, void 0), s = this.defaultTransitionablePropertyValues[r] = new Rs(n);
                    this.defaultTransitioningPropertyValues[r] = s.untransitioned(), this.defaultPossiblyEvaluatedValues[r] = i.possiblyEvaluate(e);
                }
            }
        }
        os(qs, "DataDrivenProperty"), os(Ns, "DataConstantProperty"), os($s, "ColorRampProperty");
        var Xs = JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"required":false,"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"camera":{"type":"camera"},"color-theme":{"type":"colorTheme"},"imports":{"type":"array","value":"import"},"schema":{"type":"schema"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"},"models":{"type":"models"},"featuresets":{"experimental":true,"type":"featuresets"}},"featuresets":{"experimental":true,"*":{"type":"featureset"}},"featureset":{"experimental":true,"selectors":{"type":"array","value":"selector"}},"selector":{"experimental":true,"layer":{"type":"string","required":true},"properties":{"type":"selectorProperty","required":false},"featureNamespace":{"type":"string","required":false}},"selectorProperty":{"experimental":true,"*":{"type":"*"}},"model":{"type":"string","required":true},"import":{"id":{"type":"string","required":true},"url":{"type":"string","required":true},"config":{"type":"config"},"data":{"type":"$root"}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"default":{"type":"*","property-type":"data-constant","expression":{},"required":true},"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"values":{"type":"array","value":"*"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"id":{"type":"string","required":true},"properties":{"type":"properties"},"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"cast-shadows":{"type":"boolean","default":false,"property-type":"data-constant"},"shadow-intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_ambient":{"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":1,"mapbox":1},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"experimental":true,"type":{"required":true,"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"},"dynamic":{"type":"boolean","default":false}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":1}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":1}},"url":{"required":false,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_model":{"type":{"required":true,"type":"enum","values":{"model":1,"batched-model":1}},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"raster-particle":{"experimental":true},"hillshade":{},"model":{"experimental":true},"background":{},"sky":{},"slot":{},"clip":{"experimental":true}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_clip","layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_raster-particle","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_model":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"model-id":{"type":"string","default":"","property-type":"data-driven","expression":{"parameters":["zoom","feature"]}}},"layout_clip":{"clip-layer-types":{"type":"array","value":"enum","values":{"model":1,"symbol":1},"default":[],"expression":{},"property-type":"data-constant","experimental":true},"clip-layer-scope":{"type":"array","value":"string","default":[],"expression":{},"property-type":"data-constant","experimental":true}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"fill-extrusion-edge-radius":{"type":"number","experimental":true,"default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":1,"round":1,"square":1},"default":"butt","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":1,"round":1,"miter":1,"none":1},"default":"miter","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-z-offset":{"type":"number","experimental":true,"expression":{"parameters":["zoom","feature","line-progress"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":1,"line":1,"line-center":1},"default":"point","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":1,"viewport-y":1,"source":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{"type":"enum","values":{"none":1,"width":1,"height":1,"both":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":1,"left":1,"center":1,"right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":1,"uppercase":1,"lowercase":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster-particle":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":1,"exponential":1,"interval":1,"categorical":1},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":1,"lab":1,"hcl":1},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"high-color":{"type":"color","property-type":"data-constant","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"space-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"star-intensity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"camera":{"camera-projection":{"type":"enum","values":{"perspective":1,"orthographic":1},"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"default":"perspective","property-type":"data-constant"}},"colorTheme":{"data":{"type":"string","property-type":"data-constant","expression":{}}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-180,-90],"maximum":[180,90]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-90,-90],"maximum":[90,90]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_raster-particle","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"fill-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-ambient-occlusion-intensity":{"property-type":"data-constant","type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"property-type":"data-constant","type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-wall-radius":{"property-type":"data-constant","type":"number","experimental":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-radius":{"property-type":"data-constant","type":"number","experimental":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-attenuation":{"property-type":"data-constant","type":"number","experimental":true,"default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-flood-light-color":{"property-type":"data-constant","type":"color","experimental":true,"default":"#ffffff","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-intensity":{"property-type":"data-constant","type":"number","experimental":true,"default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-wall-radius":{"property-type":"data-driven","type":"number","experimental":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-radius":{"property-type":"data-driven","type":"number","experimental":true,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-attenuation":{"property-type":"data-constant","type":"number","experimental":true,"default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-vertical-scale":{"property-type":"data-constant","type":"number","experimental":true,"default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-rounded-roof":{"property-type":"data-constant","type":"boolean","default":true,"experimental":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"fill-extrusion-line-width":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-cast-shadows":{"type":"boolean","default":true,"property-type":"data-constant"}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-gradient":{"type":"color","expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"property-type":"constant"},"line-trim-fade-range":{"type":"array","value":"number","experimental":true,"length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-trim-color":{"type":"color","experimental":true,"default":"transparent","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-border-width":{"type":"number","private":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-border-color":{"type":"color","private":true,"default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true,"property-type":"data-constant"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-image-cross-fade":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"transition":true},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-color-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"symbol-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-elevation-reference":{"type":"enum","values":{"sea":1,"ground":1},"default":"ground","experimental":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-value"]},"property-type":"color-ramp"},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color-range":{"type":"array","length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":1,"nearest":1},"default":"linear","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"raster-array-band":{"type":"string","required":false,"experimental":true,"property-type":"data-constant"},"raster-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_raster-particle":{"raster-particle-array-band":{"type":"string","required":false,"property-type":"data-constant"},"raster-particle-count":{"type":"number","default":512,"minimum":1,"property-type":"data-constant"},"raster-particle-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-particle-speed"]},"property-type":"color-ramp"},"raster-particle-max-speed":{"type":"number","default":1,"minimum":1,"property-type":"data-constant"},"raster-particle-speed-factor":{"type":"number","default":0.2,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-particle-fade-opacity-factor":{"type":"number","default":0.98,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-particle-reset-rate-factor":{"type":"number","default":0.8,"minimum":0,"maximum":1,"property-type":"data-constant"},"raster-particle-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_background":{"background-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":[]},"property-type":"data-constant"},"background-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":1,"atmosphere":1},"default":"atmosphere","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","value":"number","default":[0,0],"length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"model-rotation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-scale":{"type":"array","value":"number","length":3,"default":[1,1,1],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-translation":{"type":"array","value":"number","length":3,"default":[0,0,0],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-color":{"type":"color","default":"#ffffff","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":true},"model-color-mix-intensity":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-type":{"type":"enum","values":{"common-3d":1,"location-indicator":1},"default":"common-3d","property-type":"data-constant"},"model-cast-shadows":{"type":"boolean","default":true,"property-type":"data-constant"},"model-receive-shadows":{"type":"boolean","default":true,"property-type":"data-constant"},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant","transition":true},"model-emissive-strength":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state"]},"transition":true},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"model-front-cutoff":{"type":"array","private":true,"value":"number","property-type":"data-constant","expression":{"interpolated":true,"parameters":["zoom"]},"length":3,"default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1]}},"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"property-type":{"data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"string"}}}');
        function Ys(t1) {
            return t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean ? t1.valueOf() : t1;
        }
        function Zs(t1) {
            if (Array.isArray(t1)) return t1.map(Zs);
            if (t1 instanceof Object && !(t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean)) {
                const e = {};
                for(const r in t1)e[r] = Zs(t1[r]);
                return e;
            }
            return Ys(t1);
        }
        function Ws(t1) {
            if (!0 === t1 || !1 === t1) return !0;
            if (!Array.isArray(t1) || 0 === t1.length) return !1;
            switch(t1[0]){
                case "has":
                    return t1.length >= 2 && "$id" !== t1[1] && "$type" !== t1[1];
                case "in":
                    return t1.length >= 3 && ("string" != typeof t1[1] || Array.isArray(t1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t1.length || Array.isArray(t1[1]) || Array.isArray(t1[2]);
                case "any":
                case "all":
                    for (const e of t1.slice(1))if (!Ws(e) && "boolean" != typeof e) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        function Hs(t1, e = "", r = null, n = "fill") {
            if (null == t1) return {
                filter: ()=>!0,
                needGeometry: !1,
                needFeature: !1
            };
            Ws(t1) || (t1 = na(t1));
            const i = t1;
            let s = !0;
            try {
                s = function(t1) {
                    if (!Qs(t1)) return t1;
                    let e = Zs(t1);
                    return Js(e), e = Ks(e), e;
                }(i);
            } catch (t1) {
                console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(i, null, 2)}\n        `);
            }
            const a = Xs[`filter_${n}`], o = Hi(s, a, e, r);
            let l = null;
            if ("error" === o.result) throw new Error(o.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
            l = (t1, e, r)=>o.value.evaluate(t1, e, {}, r);
            let u = null, c = null;
            if (s !== i) {
                const t1 = Hi(i, a, e, r);
                if ("error" === t1.result) throw new Error(t1.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                u = (e, r, n, i, s)=>t1.value.evaluate(e, r, {}, n, void 0, void 0, i, s), c = !En(t1.value.expression);
            }
            return {
                filter: l,
                dynamicFilter: u || void 0,
                needGeometry: ra(s),
                needFeature: !!c
            };
        }
        function Ks(t1) {
            if (!Array.isArray(t1)) return t1;
            const e = function(t1) {
                if (ta.has(t1[0])) {
                    for(let e = 1; e < t1.length; e++)if (Qs(t1[e])) return !0;
                }
                return t1;
            }(t1);
            return !0 === e ? e : e.map((t1)=>Ks(t1));
        }
        function Js(t1) {
            let e = !1;
            const r = [];
            if ("case" === t1[0]) {
                for(let n = 1; n < t1.length - 1; n += 2)e = e || Qs(t1[n]), r.push(t1[n + 1]);
                r.push(t1[t1.length - 1]);
            } else if ("match" === t1[0]) {
                e = e || Qs(t1[1]);
                for(let e = 2; e < t1.length - 1; e += 2)r.push(t1[e + 1]);
                r.push(t1[t1.length - 1]);
            } else if ("step" === t1[0]) {
                e = e || Qs(t1[1]);
                for(let e = 1; e < t1.length - 1; e += 2)r.push(t1[e + 1]);
            }
            e && (t1.length = 0, t1.push("any", ...r));
            for(let e = 1; e < t1.length; e++)Js(t1[e]);
        }
        function Qs(t1) {
            if (!Array.isArray(t1)) return !1;
            if ("pitch" === (e = t1[0]) || "distance-from-center" === e) return !0;
            var e;
            for(let e = 1; e < t1.length; e++)if (Qs(t1[e])) return !0;
            return !1;
        }
        const ta = new Set([
            "in",
            "==",
            "!=",
            ">",
            ">=",
            "<",
            "<=",
            "to-boolean"
        ]);
        function ea(t1, e) {
            return t1 < e ? -1 : t1 > e ? 1 : 0;
        }
        function ra(t1) {
            if (!Array.isArray(t1)) return !1;
            if ("within" === t1[0] || "distance" === t1[0]) return !0;
            for(let e = 1; e < t1.length; e++)if (ra(t1[e])) return !0;
            return !1;
        }
        function na(t1) {
            if (!t1) return !0;
            const e = t1[0];
            var r;
            return t1.length <= 1 ? "any" !== e : "==" === e ? ia(t1[1], t1[2], "==") : "!=" === e ? oa(ia(t1[1], t1[2], "==")) : "<" === e || ">" === e || "<=" === e || ">=" === e ? ia(t1[1], t1[2], e) : "any" === e ? (r = t1.slice(1), [
                "any"
            ].concat(r.map(na))) : "all" === e ? [
                "all"
            ].concat(t1.slice(1).map(na)) : "none" === e ? [
                "all"
            ].concat(t1.slice(1).map(na).map(oa)) : "in" === e ? sa(t1[1], t1.slice(2)) : "!in" === e ? oa(sa(t1[1], t1.slice(2))) : "has" === e ? aa(t1[1]) : "!has" !== e || oa(aa(t1[1]));
        }
        function ia(t1, e, r) {
            switch(t1){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        e
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        e
                    ];
                default:
                    return [
                        `filter-${r}`,
                        t1,
                        e
                    ];
            }
        }
        function sa(t1, e) {
            if (0 === e.length) return !1;
            switch(t1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                default:
                    return e.length > 200 && !e.some((t1)=>typeof t1 != typeof e[0]) ? [
                        "filter-in-large",
                        t1,
                        [
                            "literal",
                            e.sort(ea)
                        ]
                    ] : [
                        "filter-in-small",
                        t1,
                        [
                            "literal",
                            e
                        ]
                    ];
            }
        }
        function aa(t1) {
            switch(t1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t1
                    ];
            }
        }
        function oa(t1) {
            return [
                "!",
                t1
            ];
        }
        const la = "\x1f";
        function ua(t1, e) {
            return e ? `${t1}${la}${e}` : t1;
        }
        const ca = "-transition", ha = new Set([
            "fill",
            "line",
            "background",
            "hillshade",
            "raster"
        ]);
        class pa extends Me {
            constructor(t1, e, r, n, i){
                if (super(), this.id = t1.id, this.fqid = ua(this.id, r), this.type = t1.type, this.scope = r, this.lut = n, this.options = i, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    needFeature: !1
                }, this._filterCompiled = !1, this.configDependencies = new Set, "custom" !== t1.type && (this.metadata = t1.metadata, this.minzoom = t1.minzoom, this.maxzoom = t1.maxzoom, "background" !== t1.type && "sky" !== t1.type && "slot" !== t1.type && (this.source = t1.source, this.sourceLayer = t1["source-layer"], this.filter = t1.filter), t1.slot && (this.slot = t1.slot), e.layout && (this._unevaluatedLayout = new Os(e.layout, this.scope, i), this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._unevaluatedLayout.configDependencies
                ])), e.paint)) {
                    this._transitionablePaint = new Ds(e.paint, this.scope, i);
                    for(const e in t1.paint)this.setPaintProperty(e, t1.paint[e]);
                    for(const e in t1.layout)this.setLayoutProperty(e, t1.layout[e]);
                    this.configDependencies = new Set([
                        ...this.configDependencies,
                        ...this._transitionablePaint.configDependencies
                    ]), this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new js(e.paint);
                }
            }
            onAdd(t1) {}
            onRemove(t1) {}
            isDraped(t1) {
                return !this.is3D() && ha.has(this.type);
            }
            getLayoutProperty(t1) {
                return "visibility" === t1 ? this.visibility : this._unevaluatedLayout.getValue(t1);
            }
            setLayoutProperty(t1, e) {
                if ("custom" === this.type && "visibility" === t1) return void (this.visibility = e);
                const r = this._unevaluatedLayout;
                r._properties.properties[t1] && (r.setValue(t1, e), this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...r.configDependencies
                ]), "visibility" === t1 && this.possiblyEvaluateVisibility());
            }
            possiblyEvaluateVisibility() {
                this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({
                    zoom: 0
                });
            }
            getPaintProperty(t1) {
                return lt(t1, ca) ? this._transitionablePaint.getTransition(t1.slice(0, -11)) : this._transitionablePaint.getValue(t1);
            }
            setPaintProperty(t1, e) {
                const r = this._transitionablePaint, n = r._properties.properties;
                if (lt(t1, ca)) {
                    const i = t1.slice(0, -11);
                    return n[i] && r.setTransition(i, e || void 0), !1;
                }
                if (!n[t1]) return !1;
                const i = r._values[t1], s = i.value.isDataDriven(), a = i.value;
                r.setValue(t1, e), this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...r.configDependencies
                ]), this._handleSpecialPaintPropertyUpdate(t1);
                const o = r._values[t1].value, l = o.isDataDriven(), u = lt(t1, "pattern") || "line-dasharray" === t1;
                return l || s || u || this._handleOverridablePaintPropertyUpdate(t1, a, o);
            }
            _handleSpecialPaintPropertyUpdate(t1) {}
            getProgramIds() {
                return null;
            }
            getDefaultProgramParams(t1, e, r) {
                return null;
            }
            _handleOverridablePaintPropertyUpdate(t1, e, r) {
                return !1;
            }
            isHidden(t1) {
                return !!(this.minzoom && t1 < this.minzoom) || !!(this.maxzoom && t1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(t1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t1, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(t1, e) {
                this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t1, void 0, e)), this.paint = this._transitioningPaint.possiblyEvaluate(t1, void 0, e);
            }
            serialize() {
                return ct({
                    id: this.id,
                    type: this.type,
                    slot: this.slot,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                }, (t1, e)=>!(void 0 === t1 || "layout" === e && !Object.keys(t1).length || "paint" === e && !Object.keys(t1).length));
            }
            is3D() {
                return !1;
            }
            isSky() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            hasShadowPass() {
                return !1;
            }
            canCastShadows() {
                return !1;
            }
            hasLightBeamPass() {
                return !1;
            }
            cutoffRange() {
                return 0;
            }
            tileCoverLift() {
                return 0;
            }
            resize() {}
            isStateDependent() {
                for(const t1 in this.paint._values){
                    const e = this.paint.get(t1);
                    if (e instanceof Us && Di(e.property.specification) && ("source" === e.value.kind || "composite" === e.value.kind) && e.value.isStateDependent) return !0;
                }
                return !1;
            }
            compileFilter(t1) {
                this._filterCompiled || (this._featureFilter = Hs(this.filter, this.scope, t1), this._filterCompiled = !0);
            }
            invalidateCompiledFilter() {
                this._filterCompiled = !1;
            }
            dynamicFilter() {
                return this._featureFilter.dynamicFilter;
            }
            dynamicFilterNeedsFeature() {
                return this._featureFilter.needFeature;
            }
            getLayerRenderingStats() {
                return this._stats;
            }
            resetLayerRenderingStats(t1) {
                this._stats && ("shadow" === t1.renderPass ? this._stats.numRenderedVerticesInShadowPass = 0 : this._stats.numRenderedVerticesInTransparentPass = 0);
            }
            queryRadius(t1) {}
            queryIntersectsFeature(t1, e, r, n, i, s, a, o, l) {}
            queryIntersectsMatchingFeature(t1, e, r, n) {}
        }
        const fa = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class da {
            constructor(t1, e){
                this._structArray = t1, this._pos1 = e * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class ma {
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
            static serialize(t1, e) {
                return t1._trim(), e && (t1.isTransferred = !0, e.add(t1.arrayBuffer)), {
                    length: t1.length,
                    arrayBuffer: t1.arrayBuffer
                };
            }
            static deserialize(t1) {
                const e = Object.create(this.prototype);
                return e.arrayBuffer = t1.arrayBuffer, e.length = t1.length, e.capacity = t1.arrayBuffer.byteLength / e.bytesPerElement, e._refreshViews(), e;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(t1) {
                this.reserve(t1), this.length = t1;
            }
            reserve(t1) {
                if (t1 > this.capacity) {
                    this.capacity = Math.max(t1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const e = this.uint8;
                    this._refreshViews(), e && this.uint8.set(e);
                }
            }
            _refreshViews() {
                throw new Error("StructArray#_refreshViews() must be implemented by each concrete StructArray layout");
            }
            emplace(...t1) {
                throw new Error("StructArray#emplace() must be implemented by each concrete StructArray layout");
            }
            emplaceBack(...t1) {
                throw new Error("StructArray#emplaceBack() must be implemented by each concrete StructArray layout");
            }
            destroy() {
                this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
            }
        }
        function ya(t1, e = 1) {
            let r = 0, n = 0;
            return {
                members: t1.map((t1)=>{
                    const i = fa[t1.type].BYTES_PER_ELEMENT, s = r = ga(r, Math.max(e, i)), a = t1.components || 1;
                    return n = Math.max(n, i), r += i * a, {
                        name: t1.name,
                        type: t1.type,
                        components: a,
                        offset: s
                    };
                }),
                size: ga(r, Math.max(n, e)),
                alignment: e
            };
        }
        function ga(t1, e) {
            return Math.ceil(t1 / e) * e;
        }
        class xa extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e);
            }
            emplace(t1, e, r) {
                const n = 2 * t1;
                return this.int16[n + 0] = e, this.int16[n + 1] = r, t1;
            }
        }
        xa.prototype.bytesPerElement = 4, os(xa, "StructArrayLayout2i4");
        class ba extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e, r);
            }
            emplace(t1, e, r, n) {
                const i = 3 * t1;
                return this.int16[i + 0] = e, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
            }
        }
        ba.prototype.bytesPerElement = 6, os(ba, "StructArrayLayout3i6");
        class va extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e, r, n);
            }
            emplace(t1, e, r, n, i) {
                const s = 4 * t1;
                return this.int16[s + 0] = e, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, t1;
            }
        }
        va.prototype.bytesPerElement = 8, os(va, "StructArrayLayout4i8");
        class wa extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e, r, n, i);
            }
            emplace(t1, e, r, n, i, s) {
                const a = 5 * t1;
                return this.int16[a + 0] = e, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, this.int16[a + 4] = s, t1;
            }
        }
        wa.prototype.bytesPerElement = 10, os(wa, "StructArrayLayout5i10");
        class _a extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, a) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e, r, n, i, s, a);
            }
            emplace(t1, e, r, n, i, s, a, o) {
                const l = 6 * t1, u = 12 * t1, c = 3 * t1;
                return this.int16[l + 0] = e, this.int16[l + 1] = r, this.uint8[u + 4] = n, this.uint8[u + 5] = i, this.uint8[u + 6] = s, this.uint8[u + 7] = a, this.float32[c + 2] = o, t1;
            }
        }
        _a.prototype.bytesPerElement = 12, os(_a, "StructArrayLayout2i4ub1f12");
        class Ma extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e, r, n);
            }
            emplace(t1, e, r, n, i) {
                const s = 4 * t1;
                return this.float32[s + 0] = e, this.float32[s + 1] = r, this.float32[s + 2] = n, this.float32[s + 3] = i, t1;
            }
        }
        Ma.prototype.bytesPerElement = 16, os(Ma, "StructArrayLayout4f16");
        class Aa extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e, r);
            }
            emplace(t1, e, r, n) {
                const i = 3 * t1;
                return this.float32[i + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t1;
            }
        }
        Aa.prototype.bytesPerElement = 12, os(Aa, "StructArrayLayout3f12");
        class Sa extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e, r, n, i);
            }
            emplace(t1, e, r, n, i, s) {
                const a = 6 * t1, o = 3 * t1;
                return this.uint16[a + 0] = e, this.uint16[a + 1] = r, this.uint16[a + 2] = n, this.uint16[a + 3] = i, this.float32[o + 2] = s, t1;
            }
        }
        Sa.prototype.bytesPerElement = 12, os(Sa, "StructArrayLayout4ui1f12");
        class Ia extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e, r, n);
            }
            emplace(t1, e, r, n, i) {
                const s = 4 * t1;
                return this.uint16[s + 0] = e, this.uint16[s + 1] = r, this.uint16[s + 2] = n, this.uint16[s + 3] = i, t1;
            }
        }
        Ia.prototype.bytesPerElement = 8, os(Ia, "StructArrayLayout4ui8");
        class Pa extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e, r, n, i, s);
            }
            emplace(t1, e, r, n, i, s, a) {
                const o = 6 * t1;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, this.int16[o + 5] = a, t1;
            }
        }
        Pa.prototype.bytesPerElement = 12, os(Pa, "StructArrayLayout6i12");
        class za extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, a, o, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, t1, e, r, n, i, s, a, o, l, u, c, h);
            }
            emplace(t1, e, r, n, i, s, a, o, l, u, c, h, p) {
                const f = 12 * t1;
                return this.int16[f + 0] = e, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = s, this.uint16[f + 5] = a, this.uint16[f + 6] = o, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t1;
            }
        }
        za.prototype.bytesPerElement = 24, os(za, "StructArrayLayout4i4ui4i24");
        class ka extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e, r, n, i, s);
            }
            emplace(t1, e, r, n, i, s, a) {
                const o = 10 * t1, l = 5 * t1;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.float32[l + 2] = i, this.float32[l + 3] = s, this.float32[l + 4] = a, t1;
            }
        }
        ka.prototype.bytesPerElement = 20, os(ka, "StructArrayLayout3i3f20");
        class Ta extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.uint32[1 * t1 + 0] = e, t1;
            }
        }
        Ta.prototype.bytesPerElement = 4, os(Ta, "StructArrayLayout1ul4");
        class Ea extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e);
            }
            emplace(t1, e, r) {
                const n = 2 * t1;
                return this.uint16[n + 0] = e, this.uint16[n + 1] = r, t1;
            }
        }
        Ea.prototype.bytesPerElement = 4, os(Ea, "StructArrayLayout2ui4");
        class Ba extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, a, o, l, u, c, h, p) {
                const f = this.length;
                return this.resize(f + 1), this.emplace(f, t1, e, r, n, i, s, a, o, l, u, c, h, p);
            }
            emplace(t1, e, r, n, i, s, a, o, l, u, c, h, p, f) {
                const d = 20 * t1, m = 10 * t1;
                return this.int16[d + 0] = e, this.int16[d + 1] = r, this.int16[d + 2] = n, this.int16[d + 3] = i, this.int16[d + 4] = s, this.float32[m + 3] = a, this.float32[m + 4] = o, this.float32[m + 5] = l, this.float32[m + 6] = u, this.int16[d + 14] = c, this.uint32[m + 8] = h, this.uint16[d + 18] = p, this.uint16[d + 19] = f, t1;
            }
        }
        Ba.prototype.bytesPerElement = 40, os(Ba, "StructArrayLayout5i4f1i1ul2ui40");
        class Va extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, a) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e, r, n, i, s, a);
            }
            emplace(t1, e, r, n, i, s, a, o) {
                const l = 8 * t1;
                return this.int16[l + 0] = e, this.int16[l + 1] = r, this.int16[l + 2] = n, this.int16[l + 4] = i, this.int16[l + 5] = s, this.int16[l + 6] = a, this.int16[l + 7] = o, t1;
            }
        }
        Va.prototype.bytesPerElement = 16, os(Va, "StructArrayLayout3i2i2i16");
        class Ca extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e, r, n, i);
            }
            emplace(t1, e, r, n, i, s) {
                const a = 4 * t1, o = 8 * t1;
                return this.float32[a + 0] = e, this.float32[a + 1] = r, this.float32[a + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = s, t1;
            }
        }
        Ca.prototype.bytesPerElement = 16, os(Ca, "StructArrayLayout2f1f2i16");
        class Ra extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e, r, n, i, s);
            }
            emplace(t1, e, r, n, i, s, a) {
                const o = 20 * t1, l = 5 * t1;
                return this.uint8[o + 0] = e, this.uint8[o + 1] = r, this.float32[l + 1] = n, this.float32[l + 2] = i, this.float32[l + 3] = s, this.float32[l + 4] = a, t1;
            }
        }
        Ra.prototype.bytesPerElement = 20, os(Ra, "StructArrayLayout2ub4f20");
        class Da extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e, r);
            }
            emplace(t1, e, r, n) {
                const i = 3 * t1;
                return this.uint16[i + 0] = e, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t1;
            }
        }
        Da.prototype.bytesPerElement = 6, os(Da, "StructArrayLayout3ui6");
        class La extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v) {
                const w = this.length;
                return this.resize(w + 1), this.emplace(w, t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v);
            }
            emplace(t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v, w) {
                const _ = 30 * t1, M = 15 * t1, A = 60 * t1;
                return this.int16[_ + 0] = e, this.int16[_ + 1] = r, this.int16[_ + 2] = n, this.float32[M + 2] = i, this.float32[M + 3] = s, this.uint16[_ + 8] = a, this.uint16[_ + 9] = o, this.uint32[M + 5] = l, this.uint32[M + 6] = u, this.uint32[M + 7] = c, this.uint16[_ + 16] = h, this.uint16[_ + 17] = p, this.uint16[_ + 18] = f, this.float32[M + 10] = d, this.float32[M + 11] = m, this.uint8[A + 48] = y, this.uint8[A + 49] = g, this.uint8[A + 50] = x, this.uint32[M + 13] = b, this.int16[_ + 28] = v, this.uint8[A + 58] = w, t1;
            }
        }
        La.prototype.bytesPerElement = 60, os(La, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
        class Fa extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v, w, _, M, A, S, I, P, z, k, T, E) {
                const B = this.length;
                return this.resize(B + 1), this.emplace(B, t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v, w, _, M, A, S, I, P, z, k, T, E);
            }
            emplace(t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v, w, _, M, A, S, I, P, z, k, T, E, B) {
                const V = 20 * t1, C = 40 * t1, R = 80 * t1;
                return this.float32[V + 0] = e, this.float32[V + 1] = r, this.int16[C + 4] = n, this.int16[C + 5] = i, this.int16[C + 6] = s, this.int16[C + 7] = a, this.int16[C + 8] = o, this.int16[C + 9] = l, this.int16[C + 10] = u, this.int16[C + 11] = c, this.int16[C + 12] = h, this.uint16[C + 13] = p, this.uint16[C + 14] = f, this.uint16[C + 15] = d, this.uint16[C + 16] = m, this.uint16[C + 17] = y, this.uint16[C + 18] = g, this.uint16[C + 19] = x, this.uint16[C + 20] = b, this.uint16[C + 21] = v, this.uint16[C + 22] = w, this.uint16[C + 23] = _, this.uint16[C + 24] = M, this.uint16[C + 25] = A, this.uint16[C + 26] = S, this.uint16[C + 27] = I, this.uint32[V + 14] = P, this.float32[V + 15] = z, this.float32[V + 16] = k, this.float32[V + 17] = T, this.float32[V + 18] = E, this.uint8[R + 76] = B, t1;
            }
        }
        Fa.prototype.bytesPerElement = 80, os(Fa, "StructArrayLayout2f9i15ui1ul4f1ub80");
        class Oa extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.float32[1 * t1 + 0] = e, t1;
            }
        }
        Oa.prototype.bytesPerElement = 4, os(Oa, "StructArrayLayout1f4");
        class Ua extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e, r, n, i);
            }
            emplace(t1, e, r, n, i, s) {
                const a = 5 * t1;
                return this.float32[a + 0] = e, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, this.float32[a + 4] = s, t1;
            }
        }
        Ua.prototype.bytesPerElement = 20, os(Ua, "StructArrayLayout5f20");
        class ja extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, a) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e, r, n, i, s, a);
            }
            emplace(t1, e, r, n, i, s, a, o) {
                const l = 7 * t1;
                return this.float32[l + 0] = e, this.float32[l + 1] = r, this.float32[l + 2] = n, this.float32[l + 3] = i, this.float32[l + 4] = s, this.float32[l + 5] = a, this.float32[l + 6] = o, t1;
            }
        }
        ja.prototype.bytesPerElement = 28, os(ja, "StructArrayLayout7f28");
        class Na extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e, r, n);
            }
            emplace(t1, e, r, n, i) {
                const s = 6 * t1;
                return this.uint32[3 * t1 + 0] = e, this.uint16[s + 2] = r, this.uint16[s + 3] = n, this.uint16[s + 4] = i, t1;
            }
        }
        Na.prototype.bytesPerElement = 12, os(Na, "StructArrayLayout1ul3ui12");
        class qa extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.uint16[1 * t1 + 0] = e, t1;
            }
        }
        qa.prototype.bytesPerElement = 2, os(qa, "StructArrayLayout1ui2");
        class $a extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e);
            }
            emplace(t1, e, r) {
                const n = 2 * t1;
                return this.float32[n + 0] = e, this.float32[n + 1] = r, t1;
            }
        }
        $a.prototype.bytesPerElement = 8, os($a, "StructArrayLayout2f8");
        class Ga extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m) {
                const y = this.length;
                return this.resize(y + 1), this.emplace(y, t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m);
            }
            emplace(t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y) {
                const g = 16 * t1;
                return this.float32[g + 0] = e, this.float32[g + 1] = r, this.float32[g + 2] = n, this.float32[g + 3] = i, this.float32[g + 4] = s, this.float32[g + 5] = a, this.float32[g + 6] = o, this.float32[g + 7] = l, this.float32[g + 8] = u, this.float32[g + 9] = c, this.float32[g + 10] = h, this.float32[g + 11] = p, this.float32[g + 12] = f, this.float32[g + 13] = d, this.float32[g + 14] = m, this.float32[g + 15] = y, t1;
            }
        }
        Ga.prototype.bytesPerElement = 64, os(Ga, "StructArrayLayout16f64");
        class Xa extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, s, a) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e, r, n, i, s, a);
            }
            emplace(t1, e, r, n, i, s, a, o) {
                const l = 10 * t1, u = 5 * t1;
                return this.uint16[l + 0] = e, this.uint16[l + 1] = r, this.uint16[l + 2] = n, this.uint16[l + 3] = i, this.float32[u + 2] = s, this.float32[u + 3] = a, this.float32[u + 4] = o, t1;
            }
        }
        Xa.prototype.bytesPerElement = 20, os(Xa, "StructArrayLayout4ui3f20");
        class Ya extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.int16[1 * t1 + 0] = e, t1;
            }
        }
        Ya.prototype.bytesPerElement = 2, os(Ya, "StructArrayLayout1i2");
        class Za extends ma {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.uint8[1 * t1 + 0] = e, t1;
            }
        }
        Za.prototype.bytesPerElement = 1, os(Za, "StructArrayLayout1ub1");
        class Wa extends da {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get tileAnchorY() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get x1() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get y1() {
                return this._structArray.float32[this._pos4 + 4];
            }
            get x2() {
                return this._structArray.float32[this._pos4 + 5];
            }
            get y2() {
                return this._structArray.float32[this._pos4 + 6];
            }
            get padding() {
                return this._structArray.int16[this._pos2 + 14];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 8];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
        }
        Wa.prototype.size = 40;
        class Ha extends Ba {
            get(t1) {
                return new Wa(this, t1);
            }
        }
        os(Ha, "CollisionBoxArray");
        class Ka extends da {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 5];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 6];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 7];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 10];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 11];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 48];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 49];
            }
            set placedOrientation(t1) {
                this._structArray.uint8[this._pos1 + 49] = t1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 50];
            }
            set hidden(t1) {
                this._structArray.uint8[this._pos1 + 50] = t1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 13];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 13] = t1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 28];
            }
            get flipState() {
                return this._structArray.uint8[this._pos1 + 58];
            }
            set flipState(t1) {
                this._structArray.uint8[this._pos1 + 58] = t1;
            }
        }
        Ka.prototype.size = 60;
        class Ja extends La {
            get(t1) {
                return new Ka(this, t1);
            }
        }
        os(Ja, "PlacedSymbolArray");
        class Qa extends da {
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 0];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 8];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 9];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 10];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 11];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 12];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 23];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 24];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 25];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 26];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 27];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 14];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 14] = t1;
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 15];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 16];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 17];
            }
            get zOffset() {
                return this._structArray.float32[this._pos4 + 18];
            }
            set zOffset(t1) {
                this._structArray.float32[this._pos4 + 18] = t1;
            }
            get hasIconTextFit() {
                return this._structArray.uint8[this._pos1 + 76];
            }
        }
        Qa.prototype.size = 80;
        class to extends Fa {
            get(t1) {
                return new Qa(this, t1);
            }
        }
        os(to, "SymbolInstanceArray");
        class eo extends Oa {
            getoffsetX(t1) {
                return this.float32[1 * t1 + 0];
            }
        }
        os(eo, "GlyphOffsetArray");
        class ro extends xa {
            getx(t1) {
                return this.int16[2 * t1 + 0];
            }
            gety(t1) {
                return this.int16[2 * t1 + 1];
            }
        }
        os(ro, "SymbolLineVertexArray");
        class no extends da {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get layoutVertexArrayOffset() {
                return this._structArray.uint16[this._pos2 + 4];
            }
        }
        no.prototype.size = 12;
        class io extends Na {
            get(t1) {
                return new no(this, t1);
            }
        }
        os(io, "FeatureIndexArray");
        class so extends Ea {
            geta_centroid_pos0(t1) {
                return this.uint16[2 * t1 + 0];
            }
            geta_centroid_pos1(t1) {
                return this.uint16[2 * t1 + 1];
            }
        }
        os(so, "FillExtrusionCentroidArray");
        class ao extends da {
            get a_join_normal_inside0() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get a_join_normal_inside1() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get a_join_normal_inside2() {
                return this._structArray.int16[this._pos2 + 2];
            }
        }
        ao.prototype.size = 6;
        class oo extends ba {
            get(t1) {
                return new ao(this, t1);
            }
        }
        os(oo, "FillExtrusionWallArray");
        const lo = ya([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), uo = ya([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]);
        class co {
            constructor(t1 = []){
                this.segments = t1;
            }
            _prepareSegment(t1, e, r, n) {
                let i = this.segments[this.segments.length - 1];
                return t1 > co.MAX_VERTEX_ARRAY_LENGTH && ft(`Max vertices per segment is ${co.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t1}`), (!i || i.vertexLength + t1 > co.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                    vertexOffset: e,
                    primitiveOffset: r,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
            }
            prepareSegment(t1, e, r, n) {
                return this._prepareSegment(t1, e.length, r.length, n);
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const t1 of this.segments)for(const e in t1.vaos)t1.vaos[e].destroy();
            }
            static simpleSegment(t1, e, r, n) {
                return new co([
                    {
                        vertexOffset: t1,
                        primitiveOffset: e,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function ho(t1, e) {
            return 256 * (t1 = Q(Math.floor(t1), 0, 255)) + Q(Math.floor(e), 0, 255);
        }
        co.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, os(co, "SegmentVector");
        const po = ya([
            {
                name: "a_pattern",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio",
                components: 1,
                type: "Float32"
            }
        ]), fo = ya([
            {
                name: "a_dash",
                components: 4,
                type: "Uint16"
            }
        ]);
        class mo {
            constructor(){
                this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = !1;
            }
            add(t1, e, r, n) {
                this.ids.push(yo(t1)), this.positions.push(e, r, n);
            }
            eachPosition(t1, e) {
                const r = yo(t1);
                let n = 0, i = this.ids.length - 1;
                for(; n < i;){
                    const t1 = n + i >> 1;
                    this.ids[t1] >= r ? i = t1 : n = t1 + 1;
                }
                for(; this.ids[n] === r;)e(this.positions[3 * n], this.positions[3 * n + 1], this.positions[3 * n + 2]), n++;
            }
            static serialize(t1, e) {
                const r = new Float64Array(t1.ids), n = new Uint32Array(t1.positions);
                return go(r, n, 0, r.length - 1), e && (e.add(r.buffer), e.add(n.buffer)), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(t1) {
                const e = new mo;
                let r;
                e.ids = t1.ids, e.positions = t1.positions;
                for (const t1 of e.ids)t1 !== r && e.uniqueIds.push(t1), r = t1;
                return e.indexed = !0, e;
            }
        }
        function yo(t1) {
            const e = +t1;
            return !isNaN(e) && Number.MIN_SAFE_INTEGER <= e && e <= Number.MAX_SAFE_INTEGER ? e : xe(String(t1));
        }
        function go(t1, e, r, n) {
            for(; r < n;){
                const i = t1[r + n >> 1];
                let s = r - 1, a = n + 1;
                for(;;){
                    do s++;
                    while (t1[s] < i);
                    do a--;
                    while (t1[a] > i);
                    if (s >= a) break;
                    xo(t1, s, a), xo(e, 3 * s, 3 * a), xo(e, 3 * s + 1, 3 * a + 1), xo(e, 3 * s + 2, 3 * a + 2);
                }
                a - r < n - a ? (go(t1, e, r, a), r = a + 1) : (go(t1, e, a + 1, n), n = a);
            }
        }
        function xo(t1, e, r) {
            const n = t1[e];
            t1[e] = t1[r], t1[r] = n;
        }
        os(mo, "FeaturePositionMap");
        class bo {
            constructor(t1){
                this.gl = t1.gl, this.initialized = !1;
            }
            fetchUniformLocation(t1, e) {
                return this.location || this.initialized || (this.location = this.gl.getUniformLocation(t1, e), this.initialized = !0), !!this.location;
            }
            set(t1, e, r) {
                throw new Error("Uniform#set() must be implemented by each concrete Uniform");
            }
        }
        class vo extends bo {
            constructor(t1){
                super(t1), this.current = 0;
            }
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && this.current !== r && (this.current = r, this.gl.uniform1i(this.location, r));
            }
        }
        class wo extends bo {
            constructor(t1){
                super(t1), this.current = 0;
            }
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && this.current !== r && (this.current = r, this.gl.uniform1f(this.location, r));
            }
        }
        class _o extends bo {
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0
                ];
            }
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && (r[0] === this.current[0] && r[1] === this.current[1] || (this.current = r, this.gl.uniform2f(this.location, r[0], r[1])));
            }
        }
        class Mo extends bo {
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] || (this.current = r, this.gl.uniform3f(this.location, r[0], r[1], r[2])));
            }
        }
        class Ao extends bo {
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] && r[3] === this.current[3] || (this.current = r, this.gl.uniform4f(this.location, r[0], r[1], r[2], r[3])));
            }
        }
        class So extends bo {
            constructor(t1){
                super(t1), this.current = Pe.transparent.toRenderColor(null);
            }
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && (r.r === this.current.r && r.g === this.current.g && r.b === this.current.b && r.a === this.current.a || (this.current = r, this.gl.uniform4f(this.location, r.r, r.g, r.b, r.a)));
            }
        }
        const Io = new Float32Array(16);
        class Po extends bo {
            constructor(t1){
                super(t1), this.current = Io;
            }
            set(t1, e, r) {
                if (this.fetchUniformLocation(t1, e)) {
                    if (r[12] !== this.current[12] || r[0] !== this.current[0]) return this.current = r, void this.gl.uniformMatrix4fv(this.location, !1, r);
                    for(let t1 = 1; t1 < 16; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix4fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }
        const zo = new Float32Array(9), ko = new Float32Array(4);
        class To extends bo {
            constructor(t1){
                super(t1), this.current = ko;
            }
            set(t1, e, r) {
                if (this.fetchUniformLocation(t1, e)) {
                    for(let t1 = 0; t1 < 4; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix2fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }
        function Eo(t1) {
            return [
                ho(255 * t1.r, 255 * t1.g),
                ho(255 * t1.b, 255 * t1.a)
            ];
        }
        class Bo {
            constructor(t1, e, r, n){
                this.value = t1, this.uniformNames = e.map((t1)=>`u_${t1}`), this.type = r, this.context = n;
            }
            setUniform(t1, e, r, n, i) {
                const s = n.constantOr(this.value);
                e.set(t1, i, s instanceof Pe ? s.toRenderColor(this.context.lut) : s);
            }
            getBinding(t1, e) {
                return "color" === this.type ? new So(t1) : new wo(t1);
            }
        }
        class Vo {
            constructor(t1, e){
                this.uniformNames = e.map((t1)=>`u_${t1}`), this.pattern = null, this.pixelRatio = 1;
            }
            setConstantPatternPositions(t1) {
                this.pixelRatio = t1.pixelRatio || 1, this.pattern = t1.tl.concat(t1.br);
            }
            setUniform(t1, e, r, n, i) {
                const s = "u_pattern" === i || "u_dash" === i ? this.pattern : "u_pixel_ratio" === i ? this.pixelRatio : null;
                s && e.set(t1, i, s);
            }
            getBinding(t1, e) {
                return "u_pattern" === e || "u_dash" === e ? new Ao(t1) : new wo(t1);
            }
        }
        class Co {
            constructor(t1, e, r, n){
                this.expression = t1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(t1, e, r, n, i, s, a) {
                const o = this.paintVertexArray.length, l = this.expression.evaluate(new Vs(0, {
                    brightness: s
                }), e, {}, i, n, a);
                this.paintVertexArray.resize(t1), this._setPaintValue(o, t1, l, this.context);
            }
            updatePaintArray(t1, e, r, n, i, s, a) {
                const o = this.expression.evaluate({
                    zoom: 0,
                    brightness: a
                }, r, n, void 0, i);
                this._setPaintValue(t1, e, o, this.context);
            }
            _setPaintValue(t1, e, r, n) {
                if ("color" === this.type) {
                    const i = Eo(r.toRenderColor(n.lut));
                    for(let r = t1; r < e; r++)this.paintVertexArray.emplace(r, i[0], i[1]);
                } else {
                    for(let n = t1; n < e; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class Ro {
            constructor(t1, e, r, n, i, s){
                this.expression = t1, this.uniformNames = e.map((t1)=>`u_${t1}_t`), this.type = r, this.useIntegerZoom = n, this.context = i, this.maxValue = 0, this.paintVertexAttributes = e.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new s;
            }
            populatePaintArray(t1, e, r, n, i, s, a) {
                const o = this.expression.evaluate(new Vs(this.context.zoom, {
                    brightness: s
                }), e, {}, i, n, a), l = this.expression.evaluate(new Vs(this.context.zoom + 1, {
                    brightness: s
                }), e, {}, i, n, a), u = this.paintVertexArray.length;
                this.paintVertexArray.resize(t1), this._setPaintValue(u, t1, o, l, this.context);
            }
            updatePaintArray(t1, e, r, n, i, s, a) {
                const o = this.expression.evaluate({
                    zoom: this.context.zoom,
                    brightness: a
                }, r, n, void 0, i), l = this.expression.evaluate({
                    zoom: this.context.zoom + 1,
                    brightness: a
                }, r, n, void 0, i);
                this._setPaintValue(t1, e, o, l, this.context);
            }
            _setPaintValue(t1, e, r, n, i) {
                if ("color" === this.type) {
                    const n = Eo(r.toRenderColor(i.lut)), s = Eo(r.toRenderColor(i.lut));
                    for(let r = t1; r < e; r++)this.paintVertexArray.emplace(r, n[0], n[1], s[0], s[1]);
                } else {
                    for(let i = t1; i < e; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t1, e, r, n, i) {
                const s = this.useIntegerZoom ? Math.floor(r.zoom) : r.zoom, a = Q(this.expression.interpolationFactor(s, this.context.zoom, this.context.zoom + 1), 0, 1);
                e.set(t1, i, a);
            }
            getBinding(t1, e) {
                return new wo(t1);
            }
        }
        class Do {
            constructor(t1, e, r, n, i){
                this.expression = t1, this.layerId = i, this.paintVertexAttributes = ("array" === r ? fo : po).members;
                for(let t1 = 0; t1 < e.length; ++t1);
                this.paintVertexArray = new n;
            }
            populatePaintArray(t1, e, r, n) {
                const i = this.paintVertexArray.length;
                this.paintVertexArray.resize(t1), this._setPaintValues(i, t1, e.patterns && e.patterns[this.layerId], r);
            }
            updatePaintArray(t1, e, r, n, i, s, a) {
                this._setPaintValues(t1, e, r.patterns && r.patterns[this.layerId], s);
            }
            _setPaintValues(t1, e, r, n) {
                if (!n || !r) return;
                const i = n[r];
                if (!i) return;
                const { tl: s, br: a, pixelRatio: o } = i;
                for(let r = t1; r < e; r++)this.paintVertexArray.emplace(r, s[0], s[1], a[0], a[1], o);
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class Lo {
            constructor(t1, e, r = ()=>!0){
                this.binders = {}, this._buffers = [], this.context = e;
                const n = [];
                for(const i in t1.paint._values){
                    const s = t1.paint.get(i);
                    if (!r(i)) continue;
                    if (!(s instanceof Us && Di(s.property.specification))) continue;
                    const a = Uo(i, t1.type), o = s.value, l = s.property.specification.type, u = !!s.property.useIntegerZoom, c = "line-dasharray" === i || i.endsWith("pattern"), h = "line-dasharray" === i && "constant" !== t1.layout.get("line-cap").value.kind;
                    if ("constant" !== o.kind || h) {
                        if ("source" === o.kind || h || c) {
                            const e = qo(i, l, "source");
                            this.binders[i] = c ? new Do(o, a, l, e, t1.id) : new Co(o, a, l, e), n.push(`/a_${i}`);
                        } else {
                            const t1 = qo(i, l, "composite");
                            this.binders[i] = new Ro(o, a, l, u, e, t1), n.push(`/z_${i}`);
                        }
                    } else this.binders[i] = c ? new Vo(o.value, a) : new Bo(o.value, a, l, e), n.push(`/u_${i}`);
                }
                this.cacheKey = n.sort().join("");
            }
            getMaxValue(t1) {
                const e = this.binders[t1];
                return e instanceof Co || e instanceof Ro ? e.maxValue : 0;
            }
            populatePaintArrays(t1, e, r, n, i, s, a) {
                for(const o in this.binders){
                    const l = this.binders[o];
                    l.context = this.context, (l instanceof Co || l instanceof Ro || l instanceof Do) && l.populatePaintArray(t1, e, r, n, i, s, a);
                }
            }
            setConstantPatternPositions(t1) {
                for(const e in this.binders){
                    const r = this.binders[e];
                    r instanceof Vo && r.setConstantPatternPositions(t1);
                }
            }
            updatePaintArrays(t1, e, r, n, i, s, a, o) {
                let l = !1;
                const u = Object.keys(t1), c = 0 !== u.length, h = c ? u : e.uniqueIds;
                this.context.lut = i.lut;
                for(const u in this.binders){
                    const p = this.binders[u];
                    if (p.context = this.context, (p instanceof Co || p instanceof Ro || p instanceof Do) && (!0 === p.expression.isStateDependent || !1 === p.expression.isLightConstant)) {
                        const f = i.paint.get(u);
                        p.expression = f.value;
                        for (const r of h){
                            const i = t1[r.toString()];
                            e.eachPosition(r, (t1, e, r)=>{
                                const l = n.feature(t1);
                                p.updatePaintArray(e, r, l, i, s, a, o);
                            });
                        }
                        if (!c) for (const e of r.uniqueIds){
                            const i = t1[e.toString()];
                            r.eachPosition(e, (t1, e, r)=>{
                                const l = n.feature(t1);
                                p.updatePaintArray(e, r, l, i, s, a, o);
                            });
                        }
                        l = !0;
                    }
                }
                return l;
            }
            defines() {
                const t1 = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof Bo || r instanceof Vo) && t1.push(...r.uniformNames.map((t1)=>`#define HAS_UNIFORM_${t1}`));
                }
                return t1;
            }
            getBinderAttributes() {
                const t1 = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof Co || r instanceof Ro || r instanceof Do) for(let e = 0; e < r.paintVertexAttributes.length; e++)t1.push(r.paintVertexAttributes[e].name);
                }
                return t1;
            }
            getBinderUniforms() {
                const t1 = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof Bo || r instanceof Vo || r instanceof Ro) for (const e of r.uniformNames)t1.push(e);
                }
                return t1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(t1) {
                const e = [];
                for(const r in this.binders){
                    const n = this.binders[r];
                    if (n instanceof Bo || n instanceof Vo || n instanceof Ro) for (const i of n.uniformNames)e.push({
                        name: i,
                        property: r,
                        binding: n.getBinding(t1, i)
                    });
                }
                return e;
            }
            setUniforms(t1, e, r, n, i) {
                for (const { name: e, property: s, binding: a } of r)this.binders[s].setUniform(t1, a, i, n.get(s), e);
            }
            updatePaintBuffers() {
                this._buffers = [];
                for(const t1 in this.binders){
                    const e = this.binders[t1];
                    (e instanceof Co || e instanceof Ro || e instanceof Do) && e.paintVertexBuffer && this._buffers.push(e.paintVertexBuffer);
                }
            }
            upload(t1) {
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof Co || r instanceof Ro || r instanceof Do) && r.upload(t1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const t1 in this.binders){
                    const e = this.binders[t1];
                    (e instanceof Co || e instanceof Ro || e instanceof Do) && e.destroy();
                }
            }
        }
        class Fo {
            constructor(t1, e, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of t1)this.programConfigurations[n.id] = new Lo(n, e, r);
                this.needsUpload = !1, this._featureMap = new mo, this._featureMapWithoutIds = new mo, this._bufferOffset = 0, this._idlessCounter = 0;
            }
            populatePaintArrays(t1, e, r, n, i, s, a, o) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t1, e, n, i, s, a, o);
                void 0 !== e.id ? this._featureMap.add(e.id, r, this._bufferOffset, t1) : (this._featureMapWithoutIds.add(this._idlessCounter, r, this._bufferOffset, t1), this._idlessCounter += 1), this._bufferOffset = t1, this.needsUpload = !0;
            }
            updatePaintArrays(t1, e, r, n, i, s) {
                for (const a of r)this.needsUpload = this.programConfigurations[a.id].updatePaintArrays(t1, this._featureMap, this._featureMapWithoutIds, e, a, n, i, s || 0) || this.needsUpload;
            }
            get(t1) {
                return this.programConfigurations[t1];
            }
            upload(t1) {
                if (this.needsUpload) {
                    for(const e in this.programConfigurations)this.programConfigurations[e].upload(t1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const t1 in this.programConfigurations)this.programConfigurations[t1].destroy();
            }
        }
        const Oo = {
            "text-opacity": [
                "opacity"
            ],
            "icon-opacity": [
                "opacity"
            ],
            "text-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "icon-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "text-color": [
                "fill_color"
            ],
            "icon-color": [
                "fill_color"
            ],
            "text-emissive-strength": [
                "emissive_strength"
            ],
            "icon-emissive-strength": [
                "emissive_strength"
            ],
            "text-halo-color": [
                "halo_color"
            ],
            "icon-halo-color": [
                "halo_color"
            ],
            "text-halo-blur": [
                "halo_blur"
            ],
            "icon-halo-blur": [
                "halo_blur"
            ],
            "text-halo-width": [
                "halo_width"
            ],
            "icon-halo-width": [
                "halo_width"
            ],
            "symbol-z-offset": [
                "z_offset"
            ],
            "line-gap-width": [
                "gapwidth"
            ],
            "line-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "fill-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "fill-extrusion-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "line-dasharray": [
                "dash"
            ]
        };
        function Uo(t1, e) {
            return Oo[t1] || [
                t1.replace(`${e}-`, "").replace(/-/g, "_")
            ];
        }
        const jo = {
            "line-pattern": {
                source: Sa,
                composite: Sa
            },
            "fill-pattern": {
                source: Sa,
                composite: Sa
            },
            "fill-extrusion-pattern": {
                source: Sa,
                composite: Sa
            },
            "line-dasharray": {
                source: Ia,
                composite: Ia
            }
        }, No = {
            color: {
                source: $a,
                composite: Ma
            },
            number: {
                source: Oa,
                composite: $a
            }
        };
        function qo(t1, e, r) {
            const n = jo[t1];
            return n && n[r] || No[e][r];
        }
        os(Bo, "ConstantBinder"), os(Vo, "PatternConstantBinder"), os(Co, "SourceExpressionBinder"), os(Do, "PatternCompositeBinder"), os(Ro, "CompositeExpressionBinder"), os(Lo, "ProgramConfiguration", {
            omit: [
                "_buffers"
            ]
        }), os(Fo, "ProgramConfigurationSet");
        const $o = Hr / Math.PI / 2, Go = 5, Xo = 6, Yo = 16383, Zo = 64, Wo = [
            Zo,
            32,
            16
        ], Ho = -$o, Ko = $o;
        function Jo(t1, e, r, n = $o) {
            return r = Y(r), [
                t1 * Math.sin(r) * n,
                -e * n,
                t1 * Math.cos(r) * n
            ];
        }
        function Qo(t1, e, r) {
            return Jo(Math.cos(Y(t1)), Math.sin(Y(t1)), e, r);
        }
        const tl = 6371008.8, el = 2 * Math.PI * tl;
        class rl {
            constructor(t1, e){
                if (isNaN(t1) || isNaN(e)) throw new Error(`Invalid LngLat object: (${t1}, ${e})`);
                if (this.lng = +t1, this.lat = +e, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new rl(et(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t1) {
                const e = Math.PI / 180, r = this.lat * e, n = t1.lat * e, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t1.lng - this.lng) * e);
                return tl * Math.acos(Math.min(i, 1));
            }
            toBounds(t1 = 0) {
                const e = 360 * t1 / 40075017, r = e / Math.cos(Math.PI / 180 * this.lat);
                return new nl({
                    lng: this.lng - r,
                    lat: this.lat - e
                }, {
                    lng: this.lng + r,
                    lat: this.lat + e
                });
            }
            toEcef(t1) {
                return Qo(this.lat, this.lng, $o + t1 * $o / tl);
            }
            static convert(t1) {
                if (t1 instanceof rl) return t1;
                if (Array.isArray(t1) && (2 === t1.length || 3 === t1.length)) return new rl(Number(t1[0]), Number(t1[1]));
                if (!Array.isArray(t1) && "object" == typeof t1 && null !== t1) return new rl(Number("lng" in t1 ? t1.lng : t1.lon), Number(t1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        class nl {
            constructor(t1, e){
                if (t1) {
                    if (e) this.setSouthWest(t1).setNorthEast(e);
                    else if (4 === t1.length) {
                        const e = t1;
                        this.setSouthWest([
                            e[0],
                            e[1]
                        ]).setNorthEast([
                            e[2],
                            e[3]
                        ]);
                    } else {
                        const e = t1;
                        this.setSouthWest(e[0]).setNorthEast(e[1]);
                    }
                }
            }
            setNorthEast(t1) {
                return this._ne = t1 instanceof rl ? new rl(t1.lng, t1.lat) : rl.convert(t1), this;
            }
            setSouthWest(t1) {
                return this._sw = t1 instanceof rl ? new rl(t1.lng, t1.lat) : rl.convert(t1), this;
            }
            extend(t1) {
                const e = this._sw, r = this._ne;
                let n, i;
                if (t1 instanceof rl) n = t1, i = t1;
                else {
                    if (!(t1 instanceof nl)) return Array.isArray(t1) ? 4 === t1.length || t1.every(Array.isArray) ? this.extend(nl.convert(t1)) : this.extend(rl.convert(t1)) : "object" == typeof t1 && null !== t1 && t1.hasOwnProperty("lat") && (t1.hasOwnProperty("lon") || t1.hasOwnProperty("lng")) ? this.extend(rl.convert(t1)) : this;
                    if (n = t1._sw, i = t1._ne, !n || !i) return this;
                }
                return e || r ? (e.lng = Math.min(n.lng, e.lng), e.lat = Math.min(n.lat, e.lat), r.lng = Math.max(i.lng, r.lng), r.lat = Math.max(i.lat, r.lat)) : (this._sw = new rl(n.lng, n.lat), this._ne = new rl(i.lng, i.lat)), this;
            }
            getCenter() {
                return new rl((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new rl(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new rl(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(t1) {
                const { lng: e, lat: r } = rl.convert(t1);
                let n = this._sw.lng <= e && e <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (n = this._sw.lng >= e && e >= this._ne.lng), this._sw.lat <= r && r <= this._ne.lat && n;
            }
            static convert(t1) {
                if (t1) return t1 instanceof nl ? t1 : new nl(t1);
            }
        }
        const il = 0, sl = 25.5;
        function al(t1) {
            return el * Math.cos(t1 * Math.PI / 180);
        }
        function ol(t1) {
            return (180 + t1) / 360;
        }
        function ll(t1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1 * Math.PI / 360))) / 360;
        }
        function ul(t1, e) {
            return t1 / al(e);
        }
        function cl(t1) {
            return 360 * t1 - 180;
        }
        function hl(t1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t1) * Math.PI / 180)) - 90;
        }
        function pl(t1, e) {
            return t1 * al(hl(e));
        }
        const fl = 85.051129;
        function dl(t1) {
            return Math.cos(Y(Q(t1, -fl, fl)));
        }
        function ml(t1, e) {
            const r = Q(e, il, sl), n = Math.pow(2, r);
            return dl(t1) * el / (512 * n);
        }
        function yl(t1) {
            return 1 / Math.cos(t1 * Math.PI / 180);
        }
        function gl(t1, e = 0) {
            const r = Math.exp(Math.PI * (1 - (t1.y + e / Hr) / (1 << t1.z) * 2));
            return 80150034 * r / (r * r + 1) / Hr / (1 << t1.z);
        }
        class xl {
            constructor(t1, e, r = 0){
                this.x = +t1, this.y = +e, this.z = +r;
            }
            static fromLngLat(t1, e = 0) {
                const r = rl.convert(t1);
                return new xl(ol(r.lng), ll(r.lat), ul(e, r.lat));
            }
            toLngLat() {
                return new rl(cl(this.x), hl(this.y));
            }
            toAltitude() {
                return pl(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                return 1 / el * yl(hl(this.y));
            }
        }
        function bl(t1, e, r, n, i, s, a, o, l) {
            const u = (e + n) / 2, c = (r + i) / 2, h = new q(u, c);
            o(h), function(t1, e, r, n, i, s) {
                const a = r - i, o = n - s;
                return Math.abs((n - e) * a - (r - t1) * o) / Math.hypot(a, o);
            }(h.x, h.y, s.x, s.y, a.x, a.y) >= l ? (bl(t1, e, r, u, c, s, h, o, l), bl(t1, u, c, n, i, h, a, o, l)) : t1.push(a);
        }
        function vl(t1, e, r) {
            let n = t1[0], i = n.x, s = n.y;
            e(n);
            const a = [
                n
            ];
            for(let o = 1; o < t1.length; o++){
                const l = t1[o], { x: u, y: c } = l;
                e(l), bl(a, i, s, u, c, n, l, e, r), i = u, s = c, n = l;
            }
            return a;
        }
        function wl(t1, e, r, n) {
            if (n(e, r)) {
                const i = e.add(r)._mult(.5);
                wl(t1, e, i, n), wl(t1, i, r, n);
            } else t1.push(r);
        }
        function _l(t1, e) {
            let r = t1[0];
            const n = [
                r
            ];
            for(let i = 1; i < t1.length; i++){
                const s = t1[i];
                wl(n, r, s, e), r = s;
            }
            return n;
        }
        const Ml = Math.pow(2, 14) - 1, Al = -Ml - 1;
        function Sl(t1, e) {
            const r = Math.round(t1.x * e), n = Math.round(t1.y * e);
            return t1.x = Q(r, Al, Ml), t1.y = Q(n, Al, Ml), (r < t1.x || r > t1.x + 1 || n < t1.y || n > t1.y + 1) && ft("Geometry exceeds allowed extent, reduce your vector tile buffer size"), t1;
        }
        function Il(t1, e, r) {
            const n = t1.loadGeometry(), i = t1.extent, s = Hr / i;
            if (e && r && r.projection.isReprojectedInTileSpace) {
                const s = 1 << e.z, { scale: a, x: o, y: l, projection: u } = r, c = (t1)=>{
                    const r = cl((e.x + t1.x / i) / s), n = hl((e.y + t1.y / i) / s), c = u.project(r, n);
                    t1.x = (c.x * a - o) * i, t1.y = (c.y * a - l) * i;
                };
                for(let e = 0; e < n.length; e++)if (1 !== t1.type) n[e] = vl(n[e], c, 1);
                else {
                    const t1 = [];
                    for (const r of n[e])r.x < 0 || r.x >= i || r.y < 0 || r.y >= i || (c(r), t1.push(r));
                    n[e] = t1;
                }
            }
            for (const t1 of n)for (const e of t1)Sl(e, s);
            return n;
        }
        function Pl(t1, e) {
            return {
                type: t1.type,
                id: t1.id,
                properties: t1.properties,
                geometry: e ? Il(t1) : []
            };
        }
        function zl(t1, e, r, n, i) {
            t1.emplaceBack(2 * e + (n + 1) / 2, 2 * r + (i + 1) / 2);
        }
        function kl(t1, e, r) {
            const n = 16384;
            t1.emplaceBack(e.x, e.y, e.z, r[0] * n, r[1] * n, r[2] * n);
        }
        class Tl {
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.hasPattern = !1, this.projection = t1.projection, this.layoutVertexArray = new xa, this.indexArray = new Da, this.segments = new co, this.programConfigurations = new Fo(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                const i = this.layers[0], s = [];
                let a = null;
                "circle" === i.type && (a = i.layout.get("circle-sort-key"));
                for (const { feature: e, id: i, index: o, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = Pl(e, t1);
                    if (!this.layers[0]._featureFilter.filter(new Vs(this.zoom), u, r)) continue;
                    const c = a ? a.evaluate(u, {}, r) : void 0, h = {
                        id: i,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t1 ? u.geometry : Il(e, r, n),
                        patterns: {},
                        sortKey: c
                    };
                    s.push(h);
                }
                a && s.sort((t1, e)=>t1.sortKey - e.sortKey);
                let o = null;
                "globe" === n.projection.name && (this.globeExtVertexArray = new Pa, o = n.projection);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n, l = t1[s].feature;
                    this.addFeature(n, i, s, e.availableImages, r, o, e.brightness), e.featureIndex.insert(l, i, s, a, this.index);
                }
            }
            update(t1, e, r, n, i) {
                const s = 0 !== Object.keys(t1).length;
                s && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(t1, e, s ? this.stateDependentLayers : this.layers, r, n, i);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, lo.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = t1.createVertexBuffer(this.globeExtVertexArray, uo.members))), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy());
            }
            addFeature(t1, e, r, n, i, s, a) {
                for (const r of e)for (const e of r){
                    const r = e.x, n = e.y;
                    if (r < 0 || r >= Hr || n < 0 || n >= Hr) continue;
                    if (s) {
                        const t1 = s.projectTilePoint(r, n, i), e = s.upVector(i, r, n), a = this.globeExtVertexArray;
                        kl(a, t1, e), kl(a, t1, e), kl(a, t1, e), kl(a, t1, e);
                    }
                    const a = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t1.sortKey), o = a.vertexLength;
                    zl(this.layoutVertexArray, r, n, -1, -1), zl(this.layoutVertexArray, r, n, 1, -1), zl(this.layoutVertexArray, r, n, 1, 1), zl(this.layoutVertexArray, r, n, -1, 1), this.indexArray.emplaceBack(o, o + 1, o + 2), this.indexArray.emplaceBack(o, o + 2, o + 3), a.vertexLength += 4, a.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, {}, n, i, a);
            }
        }
        function El(t1, e) {
            for(let r = 0; r < t1.length; r++)if (Ul(e, t1[r])) return !0;
            for(let r = 0; r < e.length; r++)if (Ul(t1, e[r])) return !0;
            return !!Rl(t1, e);
        }
        function Bl(t1, e, r) {
            return !!Ul(t1, e) || !!Ll(e, t1, r);
        }
        function Vl(t1, e) {
            if (1 === t1.length) return Ol(e, t1[0]);
            for(let r = 0; r < e.length; r++){
                const n = e[r];
                for(let e = 0; e < n.length; e++)if (Ul(t1, n[e])) return !0;
            }
            for(let r = 0; r < t1.length; r++)if (Ol(e, t1[r])) return !0;
            for(let r = 0; r < e.length; r++)if (Rl(t1, e[r])) return !0;
            return !1;
        }
        function Cl(t1, e, r) {
            if (t1.length > 1) {
                if (Rl(t1, e)) return !0;
                for(let n = 0; n < e.length; n++)if (Ll(e[n], t1, r)) return !0;
            }
            for(let n = 0; n < t1.length; n++)if (Ll(t1[n], e, r)) return !0;
            return !1;
        }
        function Rl(t1, e) {
            if (0 === t1.length || 0 === e.length) return !1;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1];
                for(let t1 = 0; t1 < e.length - 1; t1++)if (Dl(n, i, e[t1], e[t1 + 1])) return !0;
            }
            return !1;
        }
        function Dl(t1, e, r, n) {
            return dt(t1, r, n) !== dt(e, r, n) && dt(t1, e, r) !== dt(t1, e, n);
        }
        function Ll(t1, e, r) {
            const n = r * r;
            if (1 === e.length) return t1.distSqr(e[0]) < n;
            for(let r = 1; r < e.length; r++)if (Fl(t1, e[r - 1], e[r]) < n) return !0;
            return !1;
        }
        function Fl(t1, e, r) {
            const n = e.distSqr(r);
            if (0 === n) return t1.distSqr(e);
            const i = ((t1.x - e.x) * (r.x - e.x) + (t1.y - e.y) * (r.y - e.y)) / n;
            return t1.distSqr(i < 0 ? e : i > 1 ? r : r.sub(e)._mult(i)._add(e));
        }
        function Ol(t1, e) {
            let r, n, i, s = !1;
            for(let a = 0; a < t1.length; a++){
                r = t1[a];
                for(let t1 = 0, a = r.length - 1; t1 < r.length; a = t1++)n = r[t1], i = r[a], n.y > e.y != i.y > e.y && e.x < (i.x - n.x) * (e.y - n.y) / (i.y - n.y) + n.x && (s = !s);
            }
            return s;
        }
        function Ul(t1, e) {
            let r = !1;
            for(let n = 0, i = t1.length - 1; n < t1.length; i = n++){
                const s = t1[n], a = t1[i];
                s.y > e.y != a.y > e.y && e.x < (a.x - s.x) * (e.y - s.y) / (a.y - s.y) + s.x && (r = !r);
            }
            return r;
        }
        function jl(t1, e, r, n, i) {
            for (const s of t1)if (e <= s.x && r <= s.y && n >= s.x && i >= s.y) return !0;
            const s = [
                new q(e, r),
                new q(e, i),
                new q(n, i),
                new q(n, r)
            ];
            if (t1.length > 2) {
                for (const e of s)if (Ul(t1, e)) return !0;
            }
            for(let e = 0; e < t1.length - 1; e++)if (Nl(t1[e], t1[e + 1], s)) return !0;
            return !1;
        }
        function Nl(t1, e, r) {
            const n = r[0], i = r[2];
            if (t1.x < n.x && e.x < n.x || t1.x > i.x && e.x > i.x || t1.y < n.y && e.y < n.y || t1.y > i.y && e.y > i.y) return !1;
            const s = dt(t1, e, r[0]);
            return s !== dt(t1, e, r[1]) || s !== dt(t1, e, r[2]) || s !== dt(t1, e, r[3]);
        }
        function ql(t1, e, r, n, i, s) {
            let a = e.y - t1.y, o = t1.x - e.x;
            if (s = s || 0) {
                const t1 = a * a + o * o;
                if (0 === t1) return !0;
                const e = Math.sqrt(t1);
                a /= e, o /= e;
            }
            return !((r.x - t1.x) * a + (r.y - t1.y) * o - s < 0 || (n.x - t1.x) * a + (n.y - t1.y) * o - s < 0 || (i.x - t1.x) * a + (i.y - t1.y) * o - s < 0);
        }
        function $l(t1, e, r, n, i, s, a) {
            return !(ql(t1, e, n, i, s, a) || ql(e, r, n, i, s, a) || ql(r, t1, n, i, s, a) || ql(n, i, t1, e, r, a) || ql(i, s, t1, e, r, a) || ql(s, n, t1, e, r, a));
        }
        function Gl(t1, e, r) {
            const n = e.paint.get(t1).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e.id).getMaxValue(t1);
        }
        function Xl(t1) {
            return Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
        }
        function Yl(t1, e, r, n, i) {
            if (!e[0] && !e[1]) return t1;
            const s = q.convert(e)._mult(i);
            "viewport" === r && s._rotate(-n);
            const a = [];
            for(let e = 0; e < t1.length; e++)a.push(t1[e].sub(s));
            return a;
        }
        function Zl(t1, e, r, n) {
            const i = q.convert(t1)._mult(n);
            return "viewport" === e && i._rotate(-r), i;
        }
        let Wl, Hl;
        os(Tl, "CircleBucket", {
            omit: [
                "layers"
            ]
        });
        var Kl, Jl = {
            exports: {}
        }, Ql = (Kl || (Kl = 1, function(t1, e) {
            !function(t1) {
                function e(t1, e, n) {
                    var i = r(256 * t1, 256 * (e = Math.pow(2, n) - e - 1), n), s = r(256 * (t1 + 1), 256 * (e + 1), n);
                    return i[0] + "," + i[1] + "," + s[0] + "," + s[1];
                }
                function r(t1, e, r) {
                    var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
                    return [
                        t1 * n - 2 * Math.PI * 6378137 / 2,
                        e * n - 2 * Math.PI * 6378137 / 2
                    ];
                }
                t1.getURL = function(t1, r, n, i, s, a) {
                    return a = a || {}, t1 + "?" + [
                        "bbox=" + e(n, i, s),
                        "format=" + (a.format || "image/png"),
                        "service=" + (a.service || "WMS"),
                        "version=" + (a.version || "1.1.1"),
                        "request=" + (a.request || "GetMap"),
                        "srs=" + (a.srs || "EPSG:3857"),
                        "width=" + (a.width || 256),
                        "height=" + (a.height || 256),
                        "layers=" + r
                    ].join("&");
                }, t1.getTileBBox = e, t1.getMercCoords = r, Object.defineProperty(t1, "__esModule", {
                    value: !0
                });
            }(e);
        }(0, Jl.exports)), Jl.exports);
        class tu {
            constructor(t1, e, r){
                this.z = t1, this.x = e, this.y = r, this.key = nu(0, t1, t1, e, r);
            }
            equals(t1) {
                return this.z === t1.z && this.x === t1.x && this.y === t1.y;
            }
            url(t1, e) {
                const r = Ql.getTileBBox(this.x, this.y, this.z), n = function(t1, e, r) {
                    let n, i = "";
                    for(let s = t1; s > 0; s--)n = 1 << s - 1, i += (e & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return t1[(this.x + this.y) % t1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === e ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n).replace("{bbox-epsg-3857}", r);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class eu {
            constructor(t1, e){
                this.wrap = t1, this.canonical = e, this.key = nu(t1, e.z, e.z, e.x, e.y);
            }
        }
        class ru {
            constructor(t1, e, r, n, i){
                this.overscaledZ = t1, this.wrap = e, this.canonical = new tu(r, +n, +i), this.key = 0 === e && t1 === r ? this.canonical.key : nu(e, t1, r, n, i);
            }
            equals(t1) {
                return this.overscaledZ === t1.overscaledZ && this.wrap === t1.wrap && this.canonical.equals(t1.canonical);
            }
            scaledTo(t1) {
                const e = this.canonical.z - t1;
                return t1 > this.canonical.z ? new ru(t1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new ru(t1, this.wrap, t1, this.canonical.x >> e, this.canonical.y >> e);
            }
            calculateScaledKey(t1, e = !0) {
                if (this.overscaledZ === t1 && e) return this.key;
                if (t1 > this.canonical.z) return nu(this.wrap * +e, t1, this.canonical.z, this.canonical.x, this.canonical.y);
                {
                    const r = this.canonical.z - t1;
                    return nu(this.wrap * +e, t1, t1, this.canonical.x >> r, this.canonical.y >> r);
                }
            }
            isChildOf(t1) {
                if (t1.wrap !== this.wrap) return !1;
                const e = this.canonical.z - t1.canonical.z;
                return 0 === t1.overscaledZ || t1.overscaledZ < this.overscaledZ && t1.canonical.z < this.canonical.z && t1.canonical.x === this.canonical.x >> e && t1.canonical.y === this.canonical.y >> e;
            }
            children(t1) {
                if (this.overscaledZ >= t1) return [
                    new ru(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const e = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new ru(e, this.wrap, e, r, n),
                    new ru(e, this.wrap, e, r + 1, n),
                    new ru(e, this.wrap, e, r, n + 1),
                    new ru(e, this.wrap, e, r + 1, n + 1)
                ];
            }
            isLessThan(t1) {
                return this.wrap < t1.wrap || !(this.wrap > t1.wrap) && (this.overscaledZ < t1.overscaledZ || !(this.overscaledZ > t1.overscaledZ) && (this.canonical.x < t1.canonical.x || !(this.canonical.x > t1.canonical.x) && this.canonical.y < t1.canonical.y));
            }
            wrapped() {
                return new ru(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t1) {
                return new ru(this.overscaledZ, t1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new eu(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
        }
        function nu(t1, e, r, n, i) {
            const s = 1 << Math.min(r, 22);
            let a = s * (i % s) + n % s;
            return t1 && r < 22 && (a += s * s * ((t1 < 0 ? -2 * t1 - 1 : 2 * t1) % (1 << 2 * (22 - r)))), 16 * (32 * a + r) + (e - r);
        }
        const iu = [
            (t1)=>{
                let e = t1.canonical.x - 1, r = t1.wrap;
                return e < 0 && (e = (1 << t1.canonical.z) - 1, r--), new ru(t1.overscaledZ, r, t1.canonical.z, e, t1.canonical.y);
            },
            (t1)=>{
                let e = t1.canonical.x + 1, r = t1.wrap;
                return e === 1 << t1.canonical.z && (e = 0, r++), new ru(t1.overscaledZ, r, t1.canonical.z, e, t1.canonical.y);
            },
            (t1)=>new ru(t1.overscaledZ, t1.wrap, t1.canonical.z, t1.canonical.x, (0 === t1.canonical.y ? 1 << t1.canonical.z : t1.canonical.y) - 1),
            (t1)=>new ru(t1.overscaledZ, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y === (1 << t1.canonical.z) - 1 ? 0 : t1.canonical.y + 1)
        ];
        os(tu, "CanonicalTileID"), os(ru, "OverscaledTileID", {
            omit: [
                "projMatrix",
                "expandedProjMatrix"
            ]
        });
        const su = ya([
            {
                type: "Float32",
                name: "a_globe_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]), { members: au } = su, ou = ya([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            }
        ]);
        var lu = ya([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class uu {
            constructor(t1, e){
                this.pos = t1, this.dir = e;
            }
            intersectsPlane(t1, e, r) {
                const n = O.vec3.dot(e, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const i = ((t1[0] - this.pos[0]) * e[0] + (t1[1] - this.pos[1]) * e[1] + (t1[2] - this.pos[2]) * e[2]) / n;
                return r[0] = this.pos[0] + this.dir[0] * i, r[1] = this.pos[1] + this.dir[1] * i, r[2] = this.pos[2] + this.dir[2] * i, !0;
            }
            closestPointOnSphere(t1, e, r) {
                if (O.vec3.equals(this.pos, t1) || 0 === e) return r[0] = r[1] = r[2] = 0, !1;
                const [n, i, s] = this.dir, a = this.pos[0] - t1[0], o = this.pos[1] - t1[1], l = this.pos[2] - t1[2], u = n * n + i * i + s * s, c = 2 * (a * n + o * i + l * s), h = c * c - 4 * u * (a * a + o * o + l * l - e * e);
                if (h < 0) {
                    const t1 = Math.max(-c / 2, 0), u = a + n * t1, h = o + i * t1, p = l + s * t1, f = Math.hypot(u, h, p);
                    return r[0] = u * e / f, r[1] = h * e / f, r[2] = p * e / f, !1;
                }
                {
                    const t1 = (-c - Math.sqrt(h)) / (2 * u);
                    if (t1 < 0) {
                        const t1 = Math.hypot(a, o, l);
                        return r[0] = a * e / t1, r[1] = o * e / t1, r[2] = l * e / t1, !1;
                    }
                    return r[0] = a + n * t1, r[1] = o + i * t1, r[2] = l + s * t1, !0;
                }
            }
        }
        class cu {
            constructor(t1, e, r, n, i){
                this.TL = t1, this.TR = e, this.BR = r, this.BL = n, this.horizon = i;
            }
            static fromInvProjectionMatrix(t1, e, r) {
                const n = [
                    -1,
                    1,
                    1
                ], i = [
                    1,
                    1,
                    1
                ], s = [
                    1,
                    -1,
                    1
                ], a = [
                    -1,
                    -1,
                    1
                ], o = O.vec3.transformMat4(n, n, t1), l = O.vec3.transformMat4(i, i, t1), u = O.vec3.transformMat4(s, s, t1), c = O.vec3.transformMat4(a, a, t1);
                return new cu(o, l, u, c, e / r);
            }
        }
        function hu(t1, e, r) {
            let n = 1 / 0, i = -1 / 0;
            const s = [];
            for (const a of t1){
                O.vec3.sub(s, a, e);
                const t1 = O.vec3.dot(s, r);
                n = Math.min(n, t1), i = Math.max(i, t1);
            }
            return [
                n,
                i
            ];
        }
        function pu(t1, e) {
            let r = !0;
            for(let n = 0; n < t1.planes.length; n++){
                const i = t1.planes[n];
                let s = 0;
                for(let t1 = 0; t1 < e.length; t1++)s += O.vec3.dot(i, e[t1]) + i[3] >= 0;
                if (0 === s) return 0;
                s !== e.length && (r = !1);
            }
            return r ? 2 : 1;
        }
        function fu(t1, e) {
            for (const r of t1.projections){
                const n = hu(e, t1.points[0], r.axis);
                if (r.projection[1] < n[0] || r.projection[0] > n[1]) return 0;
            }
            return 1;
        }
        function du(t1, e) {
            let r = 0;
            const n = [
                0,
                0,
                0,
                0
            ];
            for(let i = 0; i < t1.length; i++)n[0] = t1[i][0], n[1] = t1[i][1], n[2] = t1[i][2], n[3] = 1, O.vec4.dot(n, e) >= 0 && r++;
            return r;
        }
        class mu {
            constructor(t1, e){
                this.points = t1 || new Array(8).fill([
                    0,
                    0,
                    0
                ]), this.planes = e || new Array(6).fill([
                    0,
                    0,
                    0,
                    0
                ]), this.bounds = yu.fromPoints(this.points), this.projections = [], this.frustumEdges = [
                    O.vec3.sub([], this.points[2], this.points[3]),
                    O.vec3.sub([], this.points[0], this.points[3]),
                    O.vec3.sub([], this.points[4], this.points[0]),
                    O.vec3.sub([], this.points[5], this.points[1]),
                    O.vec3.sub([], this.points[6], this.points[2]),
                    O.vec3.sub([], this.points[7], this.points[3])
                ];
                for (const t1 of this.frustumEdges){
                    const e = [
                        0,
                        -t1[2],
                        t1[1]
                    ], r = [
                        t1[2],
                        0,
                        -t1[0]
                    ];
                    this.projections.push({
                        axis: e,
                        projection: hu(this.points, this.points[0], e)
                    }), this.projections.push({
                        axis: r,
                        projection: hu(this.points, this.points[0], r)
                    });
                }
            }
            static fromInvProjectionMatrix(t1, e, r, n) {
                const i = Math.pow(2, r), s = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((r)=>{
                    const s = O.vec4.transformMat4([], r, t1), a = 1 / s[3] / e * i;
                    return O.vec4.mul(s, s, [
                        a,
                        a,
                        n ? 1 / s[3] : a,
                        a
                    ]);
                }), a = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((t1)=>{
                    const e = O.vec3.sub([], s[t1[0]], s[t1[1]]), r = O.vec3.sub([], s[t1[2]], s[t1[1]]), n = O.vec3.normalize([], O.vec3.cross([], e, r)), i = -O.vec3.dot(n, s[t1[1]]);
                    return n.concat(i);
                }), o = [];
                for(let t1 = 0; t1 < s.length; t1++)o.push([
                    s[t1][0],
                    s[t1][1],
                    s[t1][2]
                ]);
                return new mu(o, a);
            }
            intersectsPrecise(t1, e, r) {
                for(let r = 0; r < e.length; r++)if (!du(t1, e[r])) return 0;
                for(let e = 0; e < this.planes.length; e++)if (!du(t1, this.planes[e])) return 0;
                for (const e of r)for (const r of this.frustumEdges){
                    const n = O.vec3.cross([], e, r), i = O.vec3.length(n);
                    if (0 === i) continue;
                    O.vec3.scale(n, n, 1 / i);
                    const s = hu(this.points, this.points[0], n), a = hu(t1, this.points[0], n);
                    if (s[0] > a[1] || a[0] > s[1]) return 0;
                }
                return 1;
            }
            containsPoint(t1) {
                for (const e of this.planes){
                    const r = e[3];
                    if (O.vec3.dot([
                        e[0],
                        e[1],
                        e[2]
                    ], t1) + r < 0) return !1;
                }
                return !0;
            }
        }
        class yu {
            static fromPoints(t1) {
                const e = [
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], r = [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ];
                for (const n of t1)O.vec3.min(e, e, n), O.vec3.max(r, r, n);
                return new yu(e, r);
            }
            static fromTileIdAndHeight(t1, e, r) {
                const n = 1 << t1.canonical.z, i = t1.canonical.x, s = t1.canonical.y;
                return new yu([
                    i / n,
                    s / n,
                    e
                ], [
                    (i + 1) / n,
                    (s + 1) / n,
                    r
                ]);
            }
            static applyTransform(t1, e) {
                const r = t1.getCorners();
                for(let t1 = 0; t1 < r.length; ++t1)O.vec3.transformMat4(r[t1], r[t1], e);
                return yu.fromPoints(r);
            }
            static applyTransformFast(t1, e) {
                const r = [
                    e[12],
                    e[13],
                    e[14]
                ], n = [
                    ...r
                ];
                for(let i = 0; i < 3; i++)for(let s = 0; s < 3; s++){
                    const a = e[4 * s + i], o = a * t1.min[s], l = a * t1.max[s];
                    r[i] += Math.min(o, l), n[i] += Math.max(o, l);
                }
                return new yu(r, n);
            }
            static projectAabbCorners(t1, e) {
                const r = t1.getCorners();
                for(let t1 = 0; t1 < r.length; ++t1)O.vec3.transformMat4(r[t1], r[t1], e);
                return r;
            }
            constructor(t1, e){
                this.min = t1, this.max = e, this.center = O.vec3.scale([], O.vec3.add([], this.min, this.max), .5);
            }
            quadrant(t1) {
                const e = [
                    t1 % 2 == 0,
                    t1 < 2
                ], r = O.vec3.clone(this.min), n = O.vec3.clone(this.max);
                for(let t1 = 0; t1 < e.length; t1++)r[t1] = e[t1] ? this.min[t1] : this.center[t1], n[t1] = e[t1] ? this.center[t1] : this.max[t1];
                return n[2] = this.max[2], new yu(r, n);
            }
            distanceX(t1) {
                return Math.max(Math.min(this.max[0], t1[0]), this.min[0]) - t1[0];
            }
            distanceY(t1) {
                return Math.max(Math.min(this.max[1], t1[1]), this.min[1]) - t1[1];
            }
            distanceZ(t1) {
                return Math.max(Math.min(this.max[2], t1[2]), this.min[2]) - t1[2];
            }
            getCorners() {
                const t1 = this.min, e = this.max;
                return [
                    [
                        t1[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e[0],
                        e[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        e[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        e[2]
                    ],
                    [
                        e[0],
                        t1[1],
                        e[2]
                    ],
                    [
                        e[0],
                        e[1],
                        e[2]
                    ],
                    [
                        t1[0],
                        e[1],
                        e[2]
                    ]
                ];
            }
            intersects(t1) {
                return this.intersectsAabb(t1.bounds) ? pu(t1, this.getCorners()) : 0;
            }
            intersectsFlat(t1) {
                return this.intersectsAabb(t1.bounds) ? pu(t1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsPrecise(t1, e) {
                return e || this.intersects(t1) ? fu(t1, this.getCorners()) : 0;
            }
            intersectsPreciseFlat(t1, e) {
                return e || this.intersectsFlat(t1) ? fu(t1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsAabb(t1) {
                for(let e = 0; e < 3; ++e)if (this.min[e] > t1.max[e] || t1.min[e] > this.max[e]) return !1;
                return !0;
            }
            intersectsAabbXY(t1) {
                return !(this.min[0] > t1.max[0] || t1.min[0] > this.max[0] || this.min[1] > t1.max[1] || t1.min[1] > this.max[1]);
            }
            encapsulate(t1) {
                for(let e = 0; e < 3; e++)this.min[e] = Math.min(this.min[e], t1.min[e]), this.max[e] = Math.max(this.max[e], t1.max[e]);
            }
            encapsulatePoint(t1) {
                for(let e = 0; e < 3; e++)this.min[e] = Math.min(this.min[e], t1[e]), this.max[e] = Math.max(this.max[e], t1[e]);
            }
            closestPoint(t1) {
                return [
                    Math.max(Math.min(this.max[0], t1[0]), this.min[0]),
                    Math.max(Math.min(this.max[1], t1[1]), this.min[1]),
                    Math.max(Math.min(this.max[2], t1[2]), this.min[2])
                ];
            }
        }
        function gu(t1) {
            return t1 * $o / tl;
        }
        os(yu, "Aabb");
        const xu = [
            new yu([
                Ho,
                Ho,
                Ho
            ], [
                Ko,
                Ko,
                Ko
            ]),
            new yu([
                Ho,
                Ho,
                Ho
            ], [
                0,
                0,
                Ko
            ]),
            new yu([
                0,
                Ho,
                Ho
            ], [
                Ko,
                0,
                Ko
            ]),
            new yu([
                Ho,
                0,
                Ho
            ], [
                0,
                Ko,
                Ko
            ]),
            new yu([
                0,
                0,
                Ho
            ], [
                Ko,
                Ko,
                Ko
            ])
        ];
        function bu(t1, e, r, n = !0) {
            const i = O.vec3.scale([], t1._camera.position, t1.worldSize), s = [
                e,
                r,
                1,
                1
            ];
            O.vec4.transformMat4(s, s, t1.pixelMatrixInverse), O.vec4.scale(s, s, 1 / s[3]);
            const a = O.vec3.sub([], s, i), o = O.vec3.normalize([], a), l = t1.globeMatrix, u = [
                l[12],
                l[13],
                l[14]
            ], c = O.vec3.sub([], u, i), h = O.vec3.length(c), p = O.vec3.normalize([], c), f = t1.worldSize / (2 * Math.PI), d = O.vec3.dot(p, o), m = Math.asin(f / h);
            if (m < Math.acos(d)) {
                if (!n) return null;
                const t1 = [], e = [];
                O.vec3.scale(t1, o, h / d), O.vec3.normalize(e, O.vec3.sub(e, t1, c)), O.vec3.normalize(o, O.vec3.add(o, c, O.vec3.scale(o, e, Math.tan(m) * h)));
            }
            const y = [];
            new uu(i, o).closestPointOnSphere(u, f, y);
            const g = O.vec3.normalize([], wt(l, 0)), x = O.vec3.normalize([], wt(l, 1)), b = O.vec3.normalize([], wt(l, 2)), v = O.vec3.dot(g, y), w = O.vec3.dot(x, y), _ = O.vec3.dot(b, y), M = Z(Math.asin(-w / f));
            let A = Z(Math.atan2(v, _));
            A = t1.center.lng + function(t1, e) {
                const r = (e - t1 + 180) % 360 - 180;
                return r < -180 ? r + 360 : r;
            }(t1.center.lng, A);
            const S = ol(A), I = Q(ll(M), 0, 1);
            return new xl(S, I);
        }
        class vu {
            constructor(t1, e, r){
                this.a = O.vec3.sub([], t1, r), this.b = O.vec3.sub([], e, r), this.center = r;
                const n = O.vec3.normalize([], this.a), i = O.vec3.normalize([], this.b);
                this.angle = Math.acos(O.vec3.dot(n, i));
            }
        }
        function wu(t1, e) {
            if (0 === t1.angle) return null;
            let r;
            return r = 0 === t1.a[e] ? 1 / t1.angle * .5 * Math.PI : 1 / t1.angle * Math.atan(t1.b[e] / t1.a[e] / Math.sin(t1.angle) - 1 / Math.tan(t1.angle)), r < 0 || r > 1 ? null : function(t1, e, r, n) {
                const i = Math.sin(r);
                return t1 * (Math.sin((1 - n) * r) / i) + e * (Math.sin(n * r) / i);
            }(t1.a[e], t1.b[e], t1.angle, Q(r, 0, 1)) + t1.center[e];
        }
        function _u(t1) {
            if (t1.z <= 1) return xu[t1.z + 2 * t1.y + t1.x];
            const e = Pu(Iu(t1));
            return yu.fromPoints(e);
        }
        function Mu(t1, e, r) {
            return O.vec3.scale(t1, t1, 1 - r), O.vec3.scaleAndAdd(t1, t1, e, r);
        }
        function Au(t1, e, r) {
            for (const n of t1)O.vec3.transformMat4(n, n, e), O.vec3.scale(n, n, r);
        }
        function Su(t1, e, r, n) {
            const i = e / t1.worldSize, s = t1.globeMatrix;
            if (r.z <= 1) {
                const t1 = _u(r).getCorners();
                return Au(t1, s, i), yu.fromPoints(t1);
            }
            const a = Iu(r, n), o = Pu(a, $o + gu(t1._tileCoverLift));
            Au(o, s, i);
            const l = Number.MAX_VALUE, u = [
                -l,
                -l,
                -l
            ], c = [
                l,
                l,
                l
            ];
            if (a.contains(t1.center)) {
                for (const t1 of o)O.vec3.min(c, c, t1), O.vec3.max(u, u, t1);
                u[2] = 0;
                const e = t1.point, r = [
                    e.x * i,
                    e.y * i,
                    0
                ];
                return O.vec3.min(c, c, r), O.vec3.max(u, u, r), new yu(c, u);
            }
            if (t1._tileCoverLift > 0) {
                for (const t1 of o)O.vec3.min(c, c, t1), O.vec3.max(u, u, t1);
                return new yu(c, u);
            }
            const h = [
                s[12] * i,
                s[13] * i,
                s[14] * i
            ], p = a.getCenter(), f = Q(t1.center.lat, -fl, fl), d = Q(p.lat, -fl, fl), m = ol(t1.center.lng), y = ll(f);
            let g = m - ol(p.lng);
            const x = y - ll(d);
            g > .5 ? g -= 1 : g < -0.5 && (g += 1);
            let b = 0;
            if (Math.abs(g) > Math.abs(x)) b = g >= 0 ? 1 : 3;
            else {
                b = x >= 0 ? 0 : 2;
                const t1 = [
                    s[4] * i,
                    s[5] * i,
                    s[6] * i
                ], e = -Math.sin(Y(x >= 0 ? a.getSouth() : a.getNorth())) * $o;
                O.vec3.scaleAndAdd(h, h, t1, e);
            }
            const v = o[b], w = o[(b + 1) % 4], _ = new vu(v, w, h), M = [
                wu(_, 0) || v[0],
                wu(_, 1) || v[1],
                wu(_, 2) || v[2]
            ], A = Du(t1.zoom);
            if (A > 0) {
                const n = function({ x: t1, y: e, z: r }, n, i, s, a) {
                    const o = 1 / (1 << r);
                    let l = t1 * o, u = l + o, c = e * o, h = c + o, p = 0;
                    const f = (l + u) / 2 - s;
                    return f > .5 ? p = -1 : f < -0.5 && (p = 1), l = ((l + p) * n - (s *= n)) * i + s, u = ((u + p) * n - s) * i + s, c = (c * n - (a *= n)) * i + a, h = (h * n - a) * i + a, [
                        [
                            l,
                            h,
                            0
                        ],
                        [
                            u,
                            h,
                            0
                        ],
                        [
                            u,
                            c,
                            0
                        ],
                        [
                            l,
                            c,
                            0
                        ]
                    ];
                }(r, e, t1._pixelsPerMercatorPixel, m, y);
                for(let t1 = 0; t1 < o.length; t1++)Mu(o[t1], n[t1], A);
                const i = O.vec3.add([], n[b], n[(b + 1) % 4]);
                O.vec3.scale(i, i, .5), Mu(M, i, A);
            }
            for (const t1 of o)O.vec3.min(c, c, t1), O.vec3.max(u, u, t1);
            return c[2] = Math.min(v[2], w[2]), O.vec3.min(c, c, M), O.vec3.max(u, u, M), new yu(c, u);
        }
        function Iu({ x: t1, y: e, z: r }, n = !1) {
            const i = 1 / (1 << r), s = new rl(cl(t1 * i), e === (1 << r) - 1 && n ? -90 : hl((e + 1) * i)), a = new rl(cl((t1 + 1) * i), 0 === e && n ? 90 : hl(e * i));
            return new nl(s, a);
        }
        function Pu(t1, e = $o) {
            const r = Y(t1.getNorth()), n = Y(t1.getSouth()), i = Math.cos(r), s = Math.cos(n), a = Math.sin(r), o = Math.sin(n), l = t1.getWest(), u = t1.getEast();
            return [
                Jo(s, o, l, e),
                Jo(s, o, u, e),
                Jo(i, a, u, e),
                Jo(i, a, l, e)
            ];
        }
        function zu(t1, e, r, n) {
            const i = 1 << r.z, s = (t1 / Hr + r.x) / i;
            return Qo(hl((e / Hr + r.y) / i), cl(s), n);
        }
        function ku({ min: t1, max: e }) {
            return Yo / Math.max(e[0] - t1[0], e[1] - t1[1], e[2] - t1[2]);
        }
        const Tu = new Float64Array(16);
        function Eu(t1) {
            const e = ku(t1), r = O.mat4.fromScaling(Tu, [
                e,
                e,
                e
            ]);
            return O.mat4.translate(r, r, O.vec3.negate([], t1.min));
        }
        function Bu(t1) {
            const e = O.mat4.fromTranslation(Tu, t1.min), r = 1 / ku(t1);
            return O.mat4.scale(e, e, [
                r,
                r,
                r
            ]);
        }
        function Vu(t1) {
            const e = Hr / (2 * Math.PI);
            return t1 / (2 * Math.PI) / e;
        }
        function Cu(t1, e) {
            return Hr / (512 * Math.pow(2, t1)) * ku(_u(e));
        }
        function Ru(t1, e, r, n, i) {
            const s = Vu(r), a = [
                t1,
                e,
                -r / (2 * Math.PI)
            ], o = O.mat4.identity(new Float64Array(16));
            return O.mat4.translate(o, o, a), O.mat4.scale(o, o, [
                s,
                s,
                s
            ]), O.mat4.rotateX(o, o, Y(-i)), O.mat4.rotateY(o, o, Y(-n)), o;
        }
        function Du(t1) {
            return tt(Go, Xo, t1);
        }
        function Lu(t1, e) {
            const r = Qo(e.lat, e.lng), n = function(t1) {
                const e = Qo(t1._center.lat, t1._center.lng), r = O.vec3.fromValues(0, 1, 0);
                let n = O.vec3.cross([], r, e);
                const i = O.mat4.fromRotation([], -t1.angle, e);
                n = O.vec3.transformMat4(n, n, i), O.mat4.fromRotation(i, -t1._pitch, n);
                const s = O.vec3.normalize([], e);
                return O.vec3.scale(s, s, gu(t1.cameraToCenterDistance / t1.pixelsPerMeter)), O.vec3.transformMat4(s, s, i), O.vec3.add([], e, s);
            }(t1), i = O.vec3.subtract([], n, r);
            return O.vec3.angle(i, r);
        }
        function Fu(t1, e) {
            return Lu(t1, e) > Math.PI / 2 * 1.01;
        }
        const Ou = Y(85), Uu = Math.cos(Ou), ju = Math.sin(Ou), Nu = O.mat4.create(), qu = (t1)=>{
            const e = [];
            return "map" === t1.paint.get("circle-pitch-alignment") && e.push("PITCH_WITH_MAP"), "map" === t1.paint.get("circle-pitch-scale") && e.push("SCALE_WITH_MAP"), e;
        };
        function $u(t1, e, r, n, i, s, a, o, l) {
            if (s && t1.queryGeometry.isAboveHorizon) return !1;
            s && (l *= t1.pixelToTileUnitsFactor);
            const u = t1.tileID.canonical, c = r.projection.upVectorScale(u, r.center.lat, r.worldSize).metersToTile;
            for (const h of e)for (const e of h){
                const h = e.add(o), p = i && r.elevation ? r.elevation.exaggeration() * i.getElevationAt(h.x, h.y, !0) : 0, f = r.projection.projectTilePoint(h.x, h.y, u);
                if (p > 0) {
                    const t1 = r.projection.upVector(u, h.x, h.y);
                    f.x += t1[0] * c * p, f.y += t1[1] * c * p, f.z += t1[2] * c * p;
                }
                const d = s ? h : Gu(f.x, f.y, f.z, n), m = s ? t1.tilespaceRays.map((t1)=>Zu(t1, p)) : t1.queryGeometry.screenGeometry, y = O.vec4.transformMat4([], [
                    f.x,
                    f.y,
                    f.z,
                    1
                ], n);
                if (!a && s ? l *= y[3] / r.cameraToCenterDistance : a && !s && (l *= r.cameraToCenterDistance / y[3]), s) {
                    const t1 = hl((e.y / Hr + u.y) / (1 << u.z));
                    l /= r.projection.pixelsPerMeter(t1, 1) / ul(1, t1);
                }
                if (Bl(m, d, l)) return !0;
            }
            return !1;
        }
        function Gu(t1, e, r, n) {
            const i = O.vec4.transformMat4([], [
                t1,
                e,
                r,
                1
            ], n);
            return new q(i[0] / i[3], i[1] / i[3]);
        }
        const Xu = O.vec3.fromValues(0, 0, 0), Yu = O.vec3.fromValues(0, 0, 1);
        function Zu(t1, e) {
            const r = O.vec3.create();
            return Xu[2] = e, t1.intersectsPlane(Xu, Yu, r), new q(r[0], r[1]);
        }
        class Wu extends Tl {
        }
        let Hu, Ku, Ju, Qu;
        function tc(t1, { width: e, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== e * r * n) throw new RangeError("mismatched image size");
            } else i = new Uint8Array(e * r * n);
            return t1.width = e, t1.height = r, t1.data = i, t1;
        }
        function ec(t1, e, r) {
            const { width: n, height: i } = e;
            n === t1.width && i === t1.height || (rc(t1, e, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t1.width, n),
                height: Math.min(t1.height, i)
            }, r, null), t1.width = n, t1.height = i, t1.data = e.data);
        }
        function rc(t1, e, r, n, i, s, a, o) {
            if (0 === i.width || 0 === i.height) return e;
            if (i.width > t1.width || i.height > t1.height || r.x > t1.width - i.width || r.y > t1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e.width || i.height > e.height || n.x > e.width - i.width || n.y > e.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const l = t1.data, u = e.data, c = 4 === s && o;
            for(let o = 0; o < i.height; o++){
                const h = ((r.y + o) * t1.width + r.x) * s, p = ((n.y + o) * e.width + n.x) * s;
                if (c) for(let t1 = 0; t1 < i.width; t1++){
                    const e = h + t1 * s + 3, r = p + t1 * s;
                    u[r + 0] = 255, u[r + 1] = 255, u[r + 2] = 255, u[r + 3] = l[e];
                }
                else if (a) for(let t1 = 0; t1 < i.width; t1++){
                    const e = h + t1 * s, r = p + t1 * s, n = l[e + 3], i = new Pe(l[e + 0] / 255 * n, l[e + 1] / 255 * n, l[e + 2] / 255 * n, n).toRenderColor(a).toArray();
                    u[r + 0] = i[0], u[r + 1] = i[1], u[r + 2] = i[2], u[r + 3] = i[3];
                }
                else for(let t1 = 0; t1 < i.width * s; t1++)u[p + t1] = l[h + t1];
            }
            return e;
        }
        os(Wu, "HeatmapBucket", {
            omit: [
                "layers"
            ]
        });
        class nc {
            constructor(t1, e){
                tc(this, t1, 1, e);
            }
            resize(t1) {
                ec(this, new nc(t1), 1);
            }
            clone() {
                return new nc({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e, r, n, i) {
                rc(t1, e, r, n, i, 1, null);
            }
        }
        class ic {
            constructor(t1, e){
                tc(this, t1, 4, e);
            }
            resize(t1) {
                ec(this, new ic(t1), 4);
            }
            replace(t1, e) {
                e ? this.data.set(t1) : this.data = t1 instanceof Uint8ClampedArray ? new Uint8Array(t1.buffer) : t1;
            }
            clone() {
                return new ic({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e, r, n, i, s, a) {
                rc(t1, e, r, n, i, 4, s, a);
            }
        }
        class sc {
            constructor(t1, e){
                this.width = t1.width, this.height = t1.height, this.data = e instanceof Uint8Array ? new Float32Array(e.buffer) : e;
            }
        }
        function ac(t1) {
            const e = {}, r = t1.resolution || 256, n = t1.clips ? t1.clips.length : 1, i = t1.image || new ic({
                width: r,
                height: n
            }), s = (r, n, s)=>{
                e[t1.evaluationKey] = s;
                const a = t1.expression.evaluate(e);
                a && (i.data[r + n + 0] = Math.floor(255 * a.r / a.a), i.data[r + n + 1] = Math.floor(255 * a.g / a.a), i.data[r + n + 2] = Math.floor(255 * a.b / a.a), i.data[r + n + 3] = Math.floor(255 * a.a));
            };
            if (t1.clips) for(let e = 0, i = 0; e < n; ++e, i += 4 * r)for(let n = 0, a = 0; n < r; n++, a += 4){
                const o = n / (r - 1), { start: l, end: u } = t1.clips[e];
                s(i, a, l * (1 - o) + u * o);
            }
            else for(let t1 = 0, e = 0; t1 < r; t1++, e += 4)s(0, e, t1 / (r - 1));
            return i;
        }
        os(nc, "AlphaImage"), os(ic, "RGBAImage");
        const oc = ya([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: lc } = oc;
        function uc(t1, e, r = 2) {
            const n = e && e.length, i = n ? e[0] * r : t1.length;
            let s = cc(t1, 0, i, r, !0);
            const a = [];
            if (!s || s.next === s.prev) return a;
            let o, l, u;
            if (n && (s = function(t1, e, r, n) {
                const i = [];
                for(let r = 0, s = e.length; r < s; r++){
                    const a = cc(t1, e[r] * n, r < s - 1 ? e[r + 1] * n : t1.length, n, !1);
                    a === a.next && (a.steiner = !0), i.push(wc(a));
                }
                i.sort(gc);
                for(let t1 = 0; t1 < i.length; t1++)r = xc(i[t1], r);
                return r;
            }(t1, e, s, r)), t1.length > 80 * r) {
                o = 1 / 0, l = 1 / 0;
                let e = -1 / 0, n = -1 / 0;
                for(let s = r; s < i; s += r){
                    const r = t1[s], i = t1[s + 1];
                    r < o && (o = r), i < l && (l = i), r > e && (e = r), i > n && (n = i);
                }
                u = Math.max(e - o, n - l), u = 0 !== u ? 32767 / u : 0;
            }
            return pc(s, a, r, o, l, u, 0), a;
        }
        function cc(t1, e, r, n, i) {
            let s;
            if (i === function(t1, e, r, n) {
                let i = 0;
                for(let s = e, a = r - n; s < r; s += n)i += (t1[a] - t1[s]) * (t1[s + 1] + t1[a + 1]), a = s;
                return i;
            }(t1, e, r, n) > 0) for(let i = e; i < r; i += n)s = Ec(i / n | 0, t1[i], t1[i + 1], s);
            else for(let i = r - n; i >= e; i -= n)s = Ec(i / n | 0, t1[i], t1[i + 1], s);
            return s && Sc(s, s.next) && (Bc(s), s = s.next), s;
        }
        function hc(t1, e) {
            if (!t1) return t1;
            e || (e = t1);
            let r, n = t1;
            do if (r = !1, n.steiner || !Sc(n, n.next) && 0 !== Ac(n.prev, n, n.next)) n = n.next;
            else {
                if (Bc(n), n = e = n.prev, n === n.next) break;
                r = !0;
            }
            while (r || n !== e);
            return e;
        }
        function pc(t1, e, r, n, i, s, a) {
            if (!t1) return;
            !a && s && function(t1, e, r, n) {
                let i = t1;
                do 0 === i.z && (i.z = vc(i.x, i.y, e, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                while (i !== t1);
                i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                    let e, r = 1;
                    do {
                        let n, i = t1;
                        t1 = null;
                        let s = null;
                        for(e = 0; i;){
                            e++;
                            let a = i, o = 0;
                            for(let t1 = 0; t1 < r && (o++, a = a.nextZ, a); t1++);
                            let l = r;
                            for(; o > 0 || l > 0 && a;)0 !== o && (0 === l || !a || i.z <= a.z) ? (n = i, i = i.nextZ, o--) : (n = a, a = a.nextZ, l--), s ? s.nextZ = n : t1 = n, n.prevZ = s, s = n;
                            i = a;
                        }
                        s.nextZ = null, r *= 2;
                    }while (e > 1);
                }(i);
            }(t1, n, i, s);
            let o = t1;
            for(; t1.prev !== t1.next;){
                const l = t1.prev, u = t1.next;
                if (s ? dc(t1, n, i, s) : fc(t1)) e.push(l.i, t1.i, u.i), Bc(t1), t1 = u.next, o = u.next;
                else if ((t1 = u) === o) {
                    a ? 1 === a ? pc(t1 = mc(hc(t1), e), e, r, n, i, s, 2) : 2 === a && yc(t1, e, r, n, i, s) : pc(hc(t1), e, r, n, i, s, 1);
                    break;
                }
            }
        }
        function fc(t1) {
            const e = t1.prev, r = t1, n = t1.next;
            if (Ac(e, r, n) >= 0) return !1;
            const i = e.x, s = r.x, a = n.x, o = e.y, l = r.y, u = n.y, c = i < s ? i < a ? i : a : s < a ? s : a, h = o < l ? o < u ? o : u : l < u ? l : u, p = i > s ? i > a ? i : a : s > a ? s : a, f = o > l ? o > u ? o : u : l > u ? l : u;
            let d = n.next;
            for(; d !== e;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && _c(i, o, s, l, a, u, d.x, d.y) && Ac(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function dc(t1, e, r, n) {
            const i = t1.prev, s = t1, a = t1.next;
            if (Ac(i, s, a) >= 0) return !1;
            const o = i.x, l = s.x, u = a.x, c = i.y, h = s.y, p = a.y, f = o < l ? o < u ? o : u : l < u ? l : u, d = c < h ? c < p ? c : p : h < p ? h : p, m = o > l ? o > u ? o : u : l > u ? l : u, y = c > h ? c > p ? c : p : h > p ? h : p, g = vc(f, d, e, r, n), x = vc(m, y, e, r, n);
            let b = t1.prevZ, v = t1.nextZ;
            for(; b && b.z >= g && v && v.z <= x;){
                if (b.x >= f && b.x <= m && b.y >= d && b.y <= y && b !== i && b !== a && _c(o, c, l, h, u, p, b.x, b.y) && Ac(b.prev, b, b.next) >= 0) return !1;
                if (b = b.prevZ, v.x >= f && v.x <= m && v.y >= d && v.y <= y && v !== i && v !== a && _c(o, c, l, h, u, p, v.x, v.y) && Ac(v.prev, v, v.next) >= 0) return !1;
                v = v.nextZ;
            }
            for(; b && b.z >= g;){
                if (b.x >= f && b.x <= m && b.y >= d && b.y <= y && b !== i && b !== a && _c(o, c, l, h, u, p, b.x, b.y) && Ac(b.prev, b, b.next) >= 0) return !1;
                b = b.prevZ;
            }
            for(; v && v.z <= x;){
                if (v.x >= f && v.x <= m && v.y >= d && v.y <= y && v !== i && v !== a && _c(o, c, l, h, u, p, v.x, v.y) && Ac(v.prev, v, v.next) >= 0) return !1;
                v = v.nextZ;
            }
            return !0;
        }
        function mc(t1, e) {
            let r = t1;
            do {
                const n = r.prev, i = r.next.next;
                !Sc(n, i) && Ic(n, r, r.next, i) && kc(n, i) && kc(i, n) && (e.push(n.i, r.i, i.i), Bc(r), Bc(r.next), r = t1 = i), r = r.next;
            }while (r !== t1);
            return hc(r);
        }
        function yc(t1, e, r, n, i, s) {
            let a = t1;
            do {
                let t1 = a.next.next;
                for(; t1 !== a.prev;){
                    if (a.i !== t1.i && Mc(a, t1)) {
                        let o = Tc(a, t1);
                        return a = hc(a, a.next), o = hc(o, o.next), pc(a, e, r, n, i, s, 0), void pc(o, e, r, n, i, s, 0);
                    }
                    t1 = t1.next;
                }
                a = a.next;
            }while (a !== t1);
        }
        function gc(t1, e) {
            return t1.x - e.x;
        }
        function xc(t1, e) {
            const r = function(t1, e) {
                let r = e;
                const n = t1.x, i = t1.y;
                let s, a = -1 / 0;
                do {
                    if (i <= r.y && i >= r.next.y && r.next.y !== r.y) {
                        const t1 = r.x + (i - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                        if (t1 <= n && t1 > a && (a = t1, s = r.x < r.next.x ? r : r.next, t1 === n)) return s;
                    }
                    r = r.next;
                }while (r !== e);
                if (!s) return null;
                const o = s, l = s.x, u = s.y;
                let c = 1 / 0;
                r = s;
                do {
                    if (n >= r.x && r.x >= l && n !== r.x && _c(i < u ? n : a, i, l, u, i < u ? a : n, i, r.x, r.y)) {
                        const e = Math.abs(i - r.y) / (n - r.x);
                        kc(r, t1) && (e < c || e === c && (r.x > s.x || r.x === s.x && bc(s, r))) && (s = r, c = e);
                    }
                    r = r.next;
                }while (r !== o);
                return s;
            }(t1, e);
            if (!r) return e;
            const n = Tc(r, t1);
            return hc(n, n.next), hc(r, r.next);
        }
        function bc(t1, e) {
            return Ac(t1.prev, t1, e.prev) < 0 && Ac(e.next, t1, t1.next) < 0;
        }
        function vc(t1, e, r, n, i) {
            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - r) * i | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
        }
        function wc(t1) {
            let e = t1, r = t1;
            do (e.x < r.x || e.x === r.x && e.y < r.y) && (r = e), e = e.next;
            while (e !== t1);
            return r;
        }
        function _c(t1, e, r, n, i, s, a, o) {
            return (i - a) * (e - o) >= (t1 - a) * (s - o) && (t1 - a) * (n - o) >= (r - a) * (e - o) && (r - a) * (s - o) >= (i - a) * (n - o);
        }
        function Mc(t1, e) {
            return t1.next.i !== e.i && t1.prev.i !== e.i && !function(t1, e) {
                let r = t1;
                do {
                    if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e.i && r.next.i !== e.i && Ic(r, r.next, t1, e)) return !0;
                    r = r.next;
                }while (r !== t1);
                return !1;
            }(t1, e) && (kc(t1, e) && kc(e, t1) && function(t1, e) {
                let r = t1, n = !1;
                const i = (t1.x + e.x) / 2, s = (t1.y + e.y) / 2;
                do r.y > s != r.next.y > s && r.next.y !== r.y && i < (r.next.x - r.x) * (s - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t1);
                return n;
            }(t1, e) && (Ac(t1.prev, t1, e.prev) || Ac(t1, e.prev, e)) || Sc(t1, e) && Ac(t1.prev, t1, t1.next) > 0 && Ac(e.prev, e, e.next) > 0);
        }
        function Ac(t1, e, r) {
            return (e.y - t1.y) * (r.x - e.x) - (e.x - t1.x) * (r.y - e.y);
        }
        function Sc(t1, e) {
            return t1.x === e.x && t1.y === e.y;
        }
        function Ic(t1, e, r, n) {
            const i = zc(Ac(t1, e, r)), s = zc(Ac(t1, e, n)), a = zc(Ac(r, n, t1)), o = zc(Ac(r, n, e));
            return i !== s && a !== o || !(0 !== i || !Pc(t1, r, e)) || !(0 !== s || !Pc(t1, n, e)) || !(0 !== a || !Pc(r, t1, n)) || !(0 !== o || !Pc(r, e, n));
        }
        function Pc(t1, e, r) {
            return e.x <= Math.max(t1.x, r.x) && e.x >= Math.min(t1.x, r.x) && e.y <= Math.max(t1.y, r.y) && e.y >= Math.min(t1.y, r.y);
        }
        function zc(t1) {
            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
        }
        function kc(t1, e) {
            return Ac(t1.prev, t1, t1.next) < 0 ? Ac(t1, e, t1.next) >= 0 && Ac(t1, t1.prev, e) >= 0 : Ac(t1, e, t1.prev) < 0 || Ac(t1, t1.next, e) < 0;
        }
        function Tc(t1, e) {
            const r = Vc(t1.i, t1.x, t1.y), n = Vc(e.i, e.x, e.y), i = t1.next, s = e.prev;
            return t1.next = e, e.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, s.next = n, n.prev = s, n;
        }
        function Ec(t1, e, r, n) {
            const i = Vc(t1, e, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function Bc(t1) {
            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
        }
        function Vc(t1, e, r) {
            return {
                i: t1,
                x: e,
                y: r,
                prev: null,
                next: null,
                z: 0,
                prevZ: null,
                nextZ: null,
                steiner: !1
            };
        }
        function Cc(t1, e) {
            const r = t1.length;
            if (r <= 1) return [
                t1
            ];
            const n = [];
            let i, s;
            for(let e = 0; e < r; e++){
                const r = mt(t1[e]);
                0 !== r && (t1[e].area = Math.abs(r), void 0 === s && (s = r < 0), s === r < 0 ? (i && n.push(i), i = [
                    t1[e]
                ]) : i.push(t1[e]));
            }
            if (i && n.push(i), e > 1) for(let t1 = 0; t1 < n.length; t1++)n[t1].length <= e || (br(n[t1], e, 1, n[t1].length - 1, Rc), n[t1] = n[t1].slice(0, e));
            return n;
        }
        function Rc(t1, e) {
            return e.area - t1.area;
        }
        function Dc(t1, e, r) {
            const n = r.patternDependencies;
            let i = !1;
            for (const r of e){
                const e = r.paint.get(`${t1}-pattern`);
                e.isConstant() || (i = !0);
                const s = e.constantOr(null);
                s && (i = !0, n[s] = !0);
            }
            return i;
        }
        function Lc(t1, e, r, n, i) {
            const s = i.patternDependencies;
            for (const a of e){
                const e = a.paint.get(`${t1}-pattern`).value;
                if ("constant" !== e.kind) {
                    let t1 = e.evaluate({
                        zoom: n
                    }, r, {}, i.availableImages);
                    t1 = t1 && t1.name ? t1.name : t1, s[t1] = !0, r.patterns[a.id] = t1;
                }
            }
            return r;
        }
        class Fc {
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new xa, this.indexArray = new Da, this.indexArray2 = new Ea, this.programConfigurations = new Fo(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }), this.segments = new co, this.segments2 = new co, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.projection = t1.projection;
            }
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                this.hasPattern = Dc("fill", this.layers, e);
                const i = this.layers[0].layout.get("fill-sort-key"), s = [];
                for (const { feature: a, id: o, index: l, sourceLayerIndex: u } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, c = Pl(a, t1);
                    if (!this.layers[0]._featureFilter.filter(new Vs(this.zoom), c, r)) continue;
                    const h = i ? i.evaluate(c, {}, r, e.availableImages) : void 0, p = {
                        id: o,
                        properties: a.properties,
                        type: a.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: t1 ? c.geometry : Il(a, r, n),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(p);
                }
                i && s.sort((t1, e)=>t1.sortKey - e.sortKey);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n;
                    if (this.hasPattern) {
                        const t1 = Lc("fill", this.layers, n, this.zoom, e);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, s, r, {}, e.availableImages, e.brightness);
                    e.featureIndex.insert(t1[s].feature, i, s, a, this.index);
                }
            }
            update(t1, e, r, n, i) {
                const s = 0 !== Object.keys(t1).length;
                s && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(t1, e, s ? this.stateDependentLayers : this.layers, r, n, i);
            }
            addFeatures(t1, e, r, n, i, s) {
                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e, r, n, s);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, lc), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.indexBuffer2 = t1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(t1, e, r, n, i, s = [], a) {
                for (const t1 of Cc(e, 500)){
                    let e = 0;
                    for (const r of t1)e += r.length;
                    const r = this.segments.prepareSegment(e, this.layoutVertexArray, this.indexArray), n = r.vertexLength, i = [], s = [];
                    for (const e of t1){
                        if (0 === e.length) continue;
                        e !== t1[0] && s.push(i.length / 2);
                        const r = this.segments2.prepareSegment(e.length, this.layoutVertexArray, this.indexArray2), n = r.vertexLength;
                        this.layoutVertexArray.emplaceBack(e[0].x, e[0].y), this.indexArray2.emplaceBack(n + e.length - 1, n), i.push(e[0].x), i.push(e[0].y);
                        for(let t1 = 1; t1 < e.length; t1++)this.layoutVertexArray.emplaceBack(e[t1].x, e[t1].y), this.indexArray2.emplaceBack(n + t1 - 1, n + t1), i.push(e[t1].x), i.push(e[t1].y);
                        r.vertexLength += e.length, r.primitiveLength += e.length;
                    }
                    const a = uc(i, s);
                    for(let t1 = 0; t1 < a.length; t1 += 3)this.indexArray.emplaceBack(n + a[t1], n + a[t1 + 1], n + a[t1 + 2]);
                    r.vertexLength += e, r.primitiveLength += a.length / 3;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, s, n, a);
            }
        }
        let Oc, Uc, jc, Nc;
        os(Fc, "FillBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        class qc {
            constructor(t1, e, r, n){
                if (this.triangleCount = e.length / 3, this.min = new q(0, 0), this.max = new q(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], 0 === this.triangleCount || 0 === t1.length) return;
                const [i, s] = [
                    t1[0].clone(),
                    t1[0].clone()
                ];
                for(let e = 1; e < t1.length; ++e){
                    const r = t1[e];
                    i.x = Math.min(i.x, r.x), i.y = Math.min(i.y, r.y), s.x = Math.max(s.x, r.x), s.y = Math.max(s.y, r.y);
                }
                if (n) {
                    const t1 = Math.ceil(Math.max(s.x - i.x, s.y - i.y) / n);
                    r = Math.max(r, t1);
                }
                if (0 === r) return;
                this.min = i, this.max = s;
                const a = this.max.sub(this.min);
                a.x = Math.max(a.x, 1), a.y = Math.max(a.y, 1);
                const o = Math.max(a.x, a.y) / r;
                this.cellsX = Math.max(1, Math.ceil(a.x / o)), this.cellsY = Math.max(1, Math.ceil(a.y / o)), this.xScale = 1 / o, this.yScale = 1 / o;
                const l = [];
                for(let r = 0; r < this.triangleCount; r++){
                    const n = t1[e[3 * r + 0]].sub(this.min), i = t1[e[3 * r + 1]].sub(this.min), s = t1[e[3 * r + 2]].sub(this.min), a = $c(Math.floor(Math.min(n.x, i.x, s.x)), this.xScale, this.cellsX), u = $c(Math.floor(Math.max(n.x, i.x, s.x)), this.xScale, this.cellsX), c = $c(Math.floor(Math.min(n.y, i.y, s.y)), this.yScale, this.cellsY), h = $c(Math.floor(Math.max(n.y, i.y, s.y)), this.yScale, this.cellsY), p = new q(0, 0), f = new q(0, 0), d = new q(0, 0), m = new q(0, 0);
                    for(let t1 = c; t1 <= h; ++t1){
                        p.y = f.y = t1 * o, d.y = m.y = (t1 + 1) * o;
                        for(let e = a; e <= u; ++e)p.x = d.x = e * o, f.x = m.x = (e + 1) * o, ($l(n, i, s, p, f, m) || $l(n, i, s, p, m, d)) && l.push({
                            cellIdx: t1 * this.cellsX + e,
                            triIdx: r
                        });
                    }
                }
                if (0 === l.length) return;
                l.sort((t1, e)=>t1.cellIdx - e.cellIdx || t1.triIdx - e.triIdx);
                let u = 0;
                for(; u < l.length;){
                    const t1 = l[u].cellIdx, e = {
                        start: this.payload.length,
                        len: 0
                    };
                    for(; u < l.length && l[u].cellIdx === t1;)++e.len, this.payload.push(l[u++].triIdx);
                    this.cells[t1] = e;
                }
            }
            _lazyInitLookup() {
                this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8))), this.lookup.fill(0);
            }
            queryPoint(t1, e) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (t1.x > this.max.x || this.min.x > t1.x || t1.y > this.max.y || this.min.y > t1.y) return;
                const r = $c(t1.x - this.min.x, this.xScale, this.cellsX), n = $c(t1.y - this.min.y, this.yScale, this.cellsY), i = this.cells[n * this.cellsX + r];
                if (i) {
                    this._lazyInitLookup();
                    for(let t1 = 0; t1 < i.len; t1++){
                        const r = this.payload[i.start + t1], n = Math.floor(r / 8), s = 1 << r % 8;
                        if (!(this.lookup[n] & s) && (this.lookup[n] |= s, e.push(r), e.length === this.triangleCount)) return;
                    }
                }
            }
            query(t1, e, r) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (t1.x > this.max.x || this.min.x > e.x) return;
                if (t1.y > this.max.y || this.min.y > e.y) return;
                this._lazyInitLookup();
                const n = $c(t1.x - this.min.x, this.xScale, this.cellsX), i = $c(e.x - this.min.x, this.xScale, this.cellsX), s = $c(t1.y - this.min.y, this.yScale, this.cellsY), a = $c(e.y - this.min.y, this.yScale, this.cellsY);
                for(let t1 = s; t1 <= a; t1++)for(let e = n; e <= i; e++){
                    const n = this.cells[t1 * this.cellsX + e];
                    if (n) for(let t1 = 0; t1 < n.len; t1++){
                        const e = this.payload[n.start + t1], i = Math.floor(e / 8), s = 1 << e % 8;
                        if (!(this.lookup[i] & s) && (this.lookup[i] |= s, r.push(e), r.length === this.triangleCount)) return;
                    }
                }
            }
        }
        function $c(t1, e, r) {
            return Math.max(0, Math.min(r - 1, Math.floor(t1 * e)));
        }
        os(qc, "TriangleGridIndex");
        class Gc {
            constructor(t1){
                this.zoom = t1.zoom, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.hasPattern = !1, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.footprints = [];
            }
            updateFootprints(t1, e) {
                for (const r of this.footprints)e.push({
                    footprint: r,
                    id: t1
                });
            }
            populate(t1, e, r, n) {
                const i = [];
                for (const { feature: e, id: s, index: a, sourceLayerIndex: o } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, l = Pl(e, t1);
                    if (!this.layers[0]._featureFilter.filter(new Vs(this.zoom), l, r)) continue;
                    const u = {
                        id: s,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: o,
                        index: a,
                        geometry: t1 ? l.geometry : Il(e, r, n),
                        patterns: {}
                    };
                    i.push(u);
                }
                for (const n of i){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n;
                    this.addFeature(n, i, s, r, {}, e.availableImages, e.brightness), e.featureIndex.insert(t1[s].feature, i, s, a, this.index);
                }
            }
            isEmpty() {
                return 0 === this.footprints.length;
            }
            uploadPending() {
                return !1;
            }
            upload(t1) {}
            update(t1, e, r, n, i) {}
            destroy() {}
            addFeature(t1, e, r, n, i, s = [], a) {
                for (const t1 of Cc(e, 2)){
                    const e = [], r = [], n = [], i = new q(1 / 0, 1 / 0), s = new q(-1 / 0, -1 / 0);
                    for (const a of t1)if (0 !== a.length) {
                        a !== t1[0] && n.push(r.length / 2);
                        for(let t1 = 0; t1 < a.length; t1++)r.push(a[t1].x), r.push(a[t1].y), e.push(a[t1]), i.x = Math.min(i.x, a[t1].x), i.y = Math.min(i.y, a[t1].y), s.x = Math.max(s.x, a[t1].x), s.y = Math.max(s.y, a[t1].y);
                    }
                    const a = uc(r, n), o = new qc(e, a, 8, 256);
                    this.footprints.push({
                        vertices: e,
                        indices: a,
                        grid: o,
                        min: i,
                        max: s
                    });
                }
            }
        }
        os(Gc, "ClipBucket", {
            omit: [
                "layers"
            ]
        });
        const Xc = ya([
            {
                name: "a_pos_normal_ed",
                components: 4,
                type: "Int16"
            }
        ]), Yc = ya([
            {
                name: "a_pos_end",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_angular_offset_factor",
                components: 1,
                type: "Int16"
            }
        ]), Zc = ya([
            {
                name: "a_centroid_pos",
                components: 2,
                type: "Uint16"
            }
        ]), Wc = ya([
            {
                name: "a_join_normal_inside",
                components: 3,
                type: "Int16"
            }
        ]), Hc = ya([
            {
                name: "a_hidden_by_landmark",
                components: 1,
                type: "Uint8"
            }
        ]), Kc = ya([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), { members: Jc } = Xc;
        var Qc, th, eh, rh, nh, ih, sh, ah = {};
        function oh() {
            if (th) return Qc;
            th = 1;
            var t1 = N();
            function e(t1, e, n, i, s) {
                this.properties = {}, this.extent = n, this.type = 0, this._pbf = t1, this._geometry = -1, this._keys = i, this._values = s, t1.readFields(r, this, e);
            }
            function r(t1, e, r) {
                1 == t1 ? e.id = r.readVarint() : 2 == t1 ? function(t1, e) {
                    for(var r = t1.readVarint() + t1.pos; t1.pos < r;){
                        var n = e._keys[t1.readVarint()], i = e._values[t1.readVarint()];
                        e.properties[n] = i;
                    }
                }(r, e) : 3 == t1 ? e.type = r.readVarint() : 4 == t1 && (e._geometry = r.pos);
            }
            function n(t1) {
                for(var e, r, n = 0, i = 0, s = t1.length, a = s - 1; i < s; a = i++)n += ((r = t1[a]).x - (e = t1[i]).x) * (e.y + r.y);
                return n;
            }
            return Qc = e, e.types = [
                "Unknown",
                "Point",
                "LineString",
                "Polygon"
            ], e.prototype.loadGeometry = function() {
                var e = this._pbf;
                e.pos = this._geometry;
                for(var r, n = e.readVarint() + e.pos, i = 1, s = 0, a = 0, o = 0, l = []; e.pos < n;){
                    if (s <= 0) {
                        var u = e.readVarint();
                        i = 7 & u, s = u >> 3;
                    }
                    if (s--, 1 === i || 2 === i) a += e.readSVarint(), o += e.readSVarint(), 1 === i && (r && l.push(r), r = []), r.push(new t1(a, o));
                    else {
                        if (7 !== i) throw new Error("unknown command " + i);
                        r && r.push(r[0].clone());
                    }
                }
                return r && l.push(r), l;
            }, e.prototype.bbox = function() {
                var t1 = this._pbf;
                t1.pos = this._geometry;
                for(var e = t1.readVarint() + t1.pos, r = 1, n = 0, i = 0, s = 0, a = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0; t1.pos < e;){
                    if (n <= 0) {
                        var c = t1.readVarint();
                        r = 7 & c, n = c >> 3;
                    }
                    if (n--, 1 === r || 2 === r) (i += t1.readSVarint()) < a && (a = i), i > o && (o = i), (s += t1.readSVarint()) < l && (l = s), s > u && (u = s);
                    else if (7 !== r) throw new Error("unknown command " + r);
                }
                return [
                    a,
                    l,
                    o,
                    u
                ];
            }, e.prototype.toGeoJSON = function(t1, r, i) {
                var s, a, o = this.extent * Math.pow(2, i), l = this.extent * t1, u = this.extent * r, c = this.loadGeometry(), h = e.types[this.type];
                function p(t1) {
                    for(var e = 0; e < t1.length; e++){
                        var r = t1[e];
                        t1[e] = [
                            360 * (r.x + l) / o - 180,
                            360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + u) / o) * Math.PI / 180)) - 90
                        ];
                    }
                }
                switch(this.type){
                    case 1:
                        var f = [];
                        for(s = 0; s < c.length; s++)f[s] = c[s][0];
                        p(c = f);
                        break;
                    case 2:
                        for(s = 0; s < c.length; s++)p(c[s]);
                        break;
                    case 3:
                        for(c = function(t1) {
                            var e = t1.length;
                            if (e <= 1) return [
                                t1
                            ];
                            for(var r, i, s = [], a = 0; a < e; a++){
                                var o = n(t1[a]);
                                0 !== o && (void 0 === i && (i = o < 0), i === o < 0 ? (r && s.push(r), r = [
                                    t1[a]
                                ]) : r.push(t1[a]));
                            }
                            return r && s.push(r), s;
                        }(c), s = 0; s < c.length; s++)for(a = 0; a < c[s].length; a++)p(c[s][a]);
                }
                1 === c.length ? c = c[0] : h = "Multi" + h;
                var d = {
                    type: "Feature",
                    geometry: {
                        type: h,
                        coordinates: c
                    },
                    properties: this.properties
                };
                return "id" in this && (d.id = this.id), d;
            }, Qc;
        }
        function lh() {
            if (rh) return eh;
            rh = 1;
            var t1 = oh();
            function e(t1, e) {
                this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t1, this._keys = [], this._values = [], this._features = [], t1.readFields(r, this, e), this.length = this._features.length;
            }
            function r(t1, e, r) {
                15 === t1 ? e.version = r.readVarint() : 1 === t1 ? e.name = r.readString() : 5 === t1 ? e.extent = r.readVarint() : 2 === t1 ? e._features.push(r.pos) : 3 === t1 ? e._keys.push(r.readString()) : 4 === t1 && e._values.push(function(t1) {
                    for(var e = null, r = t1.readVarint() + t1.pos; t1.pos < r;){
                        var n = t1.readVarint() >> 3;
                        e = 1 === n ? t1.readString() : 2 === n ? t1.readFloat() : 3 === n ? t1.readDouble() : 4 === n ? t1.readVarint64() : 5 === n ? t1.readVarint() : 6 === n ? t1.readSVarint() : 7 === n ? t1.readBoolean() : null;
                    }
                    return e;
                }(r));
            }
            return eh = e, e.prototype.feature = function(e) {
                if (e < 0 || e >= this._features.length) throw new Error("feature index out of bounds");
                this._pbf.pos = this._features[e];
                var r = this._pbf.readVarint() + this._pbf.pos;
                return new t1(this._pbf, r, this.extent, this._keys, this._values);
            }, eh;
        }
        function uh() {
            return sh || (sh = 1, ah.VectorTile = function() {
                if (ih) return nh;
                ih = 1;
                var t1 = lh();
                function e(e, r, n) {
                    if (3 === e) {
                        var i = new t1(n, n.readVarint() + n.pos);
                        i.length && (r[i.name] = i);
                    }
                }
                return nh = function(t1, r) {
                    this.layers = t1.readFields(e, {}, r);
                }, nh;
            }(), ah.VectorTileFeature = oh(), ah.VectorTileLayer = lh()), ah;
        }
        var ch = uh();
        class hh extends q {
            constructor(t1, e, r){
                super(t1, e), this.z = r;
            }
        }
        class ph extends hh {
            constructor(t1, e, r, n){
                super(t1, e, r), this.w = n;
            }
        }
        function fh(t1, e, r, n) {
            const i = [], s = 0 === n ? (t1, e, r, n, i, s)=>{
                t1.push(new q(s, r + (s - e) / (n - e) * (i - r)));
            } : (t1, e, r, n, i, s)=>{
                t1.push(new q(e + (s - r) / (i - r) * (n - e), s));
            };
            for (const a of t1){
                const t1 = [];
                for (const i of a){
                    if (i.length <= 2) continue;
                    const a = [];
                    for(let t1 = 0; t1 < i.length - 1; t1++){
                        const o = i[t1].x, l = i[t1].y, u = i[t1 + 1].x, c = i[t1 + 1].y, h = 0 === n ? o : l, p = 0 === n ? u : c;
                        h < e ? p > e && s(a, o, l, u, c, e) : h > r ? p < r && s(a, o, l, u, c, r) : a.push(i[t1]), p < e && h >= e && s(a, o, l, u, c, e), p > r && h <= r && s(a, o, l, u, c, r);
                    }
                    let o = i[i.length - 1];
                    const l = 0 === n ? o.x : o.y;
                    l >= e && l <= r && a.push(o), a.length && (o = a[a.length - 1], a[0].x === o.x && a[0].y === o.y || a.push(a[0]), t1.push(a));
                }
                t1.length && i.push(t1);
            }
            return i;
        }
        function dh(t1, e, r, n) {
            const i = "x" === r ? "y" : "x", s = (n - t1[r]) / (e[r] - t1[r]);
            t1[i] = t1[i] + (e[i] - t1[i]) * s, t1[r] = n, t1.hasOwnProperty("z") && (t1.z = ke(t1.z, e.z, s)), t1.hasOwnProperty("w") && (t1.w = ke(t1.w, e.w, s));
        }
        function mh(t1, e, r, n) {
            const i = r, s = n;
            for (const r of [
                "x",
                "y"
            ]){
                let n = t1, a = e;
                n[r] >= a[r] && (n = e, a = t1), n[r] < i && a[r] > i && dh(n, a, r, i), n[r] < s && a[r] > s && dh(a, n, r, s);
            }
        }
        const yh = Number.MAX_SAFE_INTEGER;
        function gh(t1, e, r, n) {
            return t1.order < e || t1.order === yh || !(t1.clipMask & r) || function(t1, e) {
                return 0 !== e.length && void 0 === e.find((e)=>e === t1);
            }(n, t1.clipScope);
        }
        function xh(t1, e) {
            return t1.x - e.x || t1.y - e.y;
        }
        function bh(t1, e) {
            return 0 === xh(t1.min, e.min) && 0 === xh(t1.max, e.max);
        }
        function vh(t1, e) {
            return !(t1.min.x > e.max.x || t1.max.x < e.min.x || t1.min.y > e.max.y || t1.max.y < e.min.y);
        }
        function wh(t1, e) {
            if (t1.length !== e.length) return !1;
            for(let r = 0; r < t1.length; r++)if (t1[r].sourceId !== e[r].sourceId || !bh(t1[r], e[r]) || t1[r].order !== e[r].order || t1[r].clipMask !== e[r].clipMask || !$(t1[r].clipScope, e[r].clipScope)) return !1;
            return !0;
        }
        function _h(t1, e, r) {
            const n = 1 / Hr, i = 1 / (1 << r.canonical.z), s = (e.x * n + r.canonical.x) * i + r.wrap, a = (e.y * n + r.canonical.y) * i;
            return {
                min: new q((t1.x * n + r.canonical.x) * i + r.wrap, (t1.y * n + r.canonical.y) * i),
                max: new q(s, a)
            };
        }
        function Mh(t1, e, r) {
            const n = 1 << r.canonical.z, i = ((e.x - r.wrap) * n - r.canonical.x) * Hr, s = (e.y * n - r.canonical.y) * Hr;
            return {
                min: new q(((t1.x - r.wrap) * n - r.canonical.x) * Hr, (t1.y * n - r.canonical.y) * Hr),
                max: new q(i, s)
            };
        }
        function Ah(t1, e, r, n, i, s, a) {
            const o = t1.indices, l = t1.vertices, u = [];
            for(let c = n; c < n + i; c += 3){
                const n = e[r[c + 0] + s], i = e[r[c + 1] + s], h = e[r[c + 2] + s], p = Math.min(n.x, i.x, h.x), f = Math.max(n.x, i.x, h.x), d = Math.min(n.y, i.y, h.y), m = Math.max(n.y, i.y, h.y);
                u.length = 0, t1.grid.query(new q(p, d), new q(f, m), u);
                for(let t1 = 0; t1 < u.length; t1++){
                    const e = u[t1];
                    if ($l(l[o[3 * e + 0]], l[o[3 * e + 1]], l[o[3 * e + 2]], n, i, h, a)) return !0;
                }
            }
            return !1;
        }
        function Sh(t1, e, r, n) {
            if (!t1 || !r) return !1;
            let i = t1.vertices;
            if (!e.canonical.equals(n.canonical) || e.wrap !== n.wrap) {
                if (r.vertices.length < t1.vertices.length) return Sh(r, n, t1, e);
                const s = e.canonical, a = n.canonical, o = Math.pow(2, a.z - s.z);
                i = t1.vertices.map((t1)=>new q((t1.x + s.x * Hr) * o - a.x * Hr, (t1.y + s.y * Hr) * o - a.y * Hr));
            }
            return Ah(r, i, t1.indices, 0, t1.indices.length, 0, 0);
        }
        function Ih(t1, e, r, n) {
            const i = Math.pow(2, n.z - r.z);
            return new q((t1 + r.x * Hr) * i - n.x * Hr, (e + r.y * Hr) * i - n.y * Hr);
        }
        function Ph(t1, e) {
            const r = [];
            e.grid.queryPoint(t1, r);
            const n = e.indices, i = e.vertices;
            for(let e = 0; e < r.length; e++){
                const s = r[e];
                if (Ul([
                    i[n[3 * s + 0]],
                    i[n[3 * s + 1]],
                    i[n[3 * s + 2]]
                ], t1)) return !0;
            }
            return !1;
        }
        const zh = [
            new q(0, 0),
            new q(Hr, 0),
            new q(Hr, Hr),
            new q(0, Hr)
        ];
        function kh(t1, e) {
            const r = [];
            let n = [];
            if (!e || t1.length < 2) return [
                t1
            ];
            if (2 === t1.length) return Nl(t1[0], t1[1], zh) ? [
                t1
            ] : [];
            for(let e = 0; e < t1.length + 2; e++){
                const i = t1[e % t1.length], s = t1[(e + 1) % t1.length], a = Nl(0 === e ? t1[t1.length - 1] : t1[(e - 1) % t1.length], i, zh), o = Nl(i, s, zh), l = a || o;
                l && n.push(i), l && o || n.length > 0 && (n.length > 1 && r.push(n), n = []);
            }
            return n.length > 1 && r.push(n), r;
        }
        const Th = ch.VectorTileFeature.types, Eh = [
            "fill-extrusion-base",
            "fill-extrusion-height",
            "fill-extrusion-color",
            "fill-extrusion-pattern",
            "fill-extrusion-flood-light-wall-radius",
            "fill-extrusion-line-width",
            "fill-extrusion-emissive-strength"
        ], Bh = [
            "fill-extrusion-flood-light-ground-radius"
        ], Vh = Math.pow(2, 13), Ch = Math.pow(2, 15) - 1, Rh = new q(0, 1), Dh = 2147483648;
        function Lh(t1, e, r, n, i, s, a, o) {
            t1.emplaceBack((e << 1) + a, (r << 1) + s, (Math.floor(n * Vh) << 1) + i, Math.round(o));
        }
        function Fh(t1, e, r) {
            t1.emplaceBack(e.x * Hr, e.y * Hr, r ? 1 : 0);
        }
        function Oh(t1, e, r, n, i, s) {
            t1.emplaceBack(e.x, e.y, (r.x << 1) + n, (r.y << 1) + i, s);
        }
        function Uh(t1, e, r) {
            const n = 16384;
            t1.emplaceBack(e.x, e.y, e.z, r[0] * n, r[1] * n, r[2] * n);
        }
        class jh {
            constructor(){
                this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
            }
        }
        class Nh {
            constructor(){
                this.centroidXY = new q(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new q(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new q(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0;
            }
            span() {
                return new q(this.max.x - this.min.x, this.max.y - this.min.y);
            }
        }
        class qh {
            constructor(){
                this.acc = new q(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
            }
            startRing(t1, e) {
                t1.min.x === Number.MAX_VALUE && (t1.min.x = t1.max.x = e.x, t1.min.y = t1.max.y = e.y);
            }
            appendEdge(t1, e, r) {
                this.accCount++, this.acc._add(e);
                let n = !!this.borders;
                e.x < t1.min.x ? (t1.min.x = e.x, n = !0) : e.x > t1.max.x && (t1.max.x = e.x, n = !0), e.y < t1.min.y ? (t1.min.y = e.y, n = !0) : e.y > t1.max.y && (t1.max.y = e.y, n = !0), ((0 === e.x || e.x === Hr) && e.x === r.x) != ((0 === e.y || e.y === Hr) && e.y === r.y) && this.processBorderOverlap(e, r), n && this.checkBorderIntersection(e, r);
            }
            checkBorderIntersection(t1, e) {
                e.x < 0 != t1.x < 0 && this.addBorderIntersection(0, ke(e.y, t1.y, (0 - e.x) / (t1.x - e.x))), e.x > Hr != t1.x > Hr && this.addBorderIntersection(1, ke(e.y, t1.y, (Hr - e.x) / (t1.x - e.x))), e.y < 0 != t1.y < 0 && this.addBorderIntersection(2, ke(e.x, t1.x, (0 - e.y) / (t1.y - e.y))), e.y > Hr != t1.y > Hr && this.addBorderIntersection(3, ke(e.x, t1.x, (Hr - e.y) / (t1.y - e.y)));
            }
            addBorderIntersection(t1, e) {
                this.borders || (this.borders = [
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ]
                ]);
                const r = this.borders[t1];
                e < r[0] && (r[0] = e), e > r[1] && (r[1] = e);
            }
            processBorderOverlap(t1, e) {
                if (t1.x === e.x) {
                    if (t1.y === e.y) return;
                    const r = 0 === t1.x ? 0 : 1;
                    this.addBorderIntersection(r, e.y), this.addBorderIntersection(r, t1.y);
                } else {
                    const r = 0 === t1.y ? 2 : 3;
                    this.addBorderIntersection(r, e.x), this.addBorderIntersection(r, t1.x);
                }
            }
            centroid() {
                return 0 === this.accCount ? new q(0, 0) : new q(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
            }
            intersectsCount() {
                return this.borders ? this.borders.reduce((t1, e)=>t1 + +(e[0] !== Number.MAX_VALUE), 0) : 0;
            }
        }
        function $h(t1, e) {
            const r = t1.add(e)._unit(), n = Q(t1.x * r.x + t1.y * r.y, -1, 1);
            var i, s, a;
            return a = Math.acos(n), Math.min(4, Math.max(-4, Math.tan(a))) / 4 * Ch * ((i = t1).x * (s = e).y - i.y * s.x < 0 ? -1 : 1);
        }
        const Gh = [
            (t1)=>t1.x < 0,
            (t1)=>t1.x > Hr,
            (t1)=>t1.y < 0,
            (t1)=>t1.y > Hr
        ];
        function Xh(t1, e, r, n) {
            const i = [
                4
            ];
            if (0 === n) return i;
            r._mult(n);
            const s = t1.sub(r), a = e.sub(r), o = [
                t1,
                e,
                s,
                a
            ];
            for(let t1 = 0; t1 < 4; t1++)for (const e of o)if (Gh[t1](e)) {
                i.push(t1);
                break;
            }
            return i;
        }
        class Yh {
            constructor(t1){
                this.vertexArray = new wa, this.indexArray = new Da, this.programConfigurations = new Fo(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }, (t1)=>Bh.includes(t1)), this._segments = new co, this.hiddenByLandmarkVertexArray = new Za, this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [
                    0,
                    0,
                    0,
                    0,
                    0
                ], this.regionSegments = {}, this.regionSegments[4] = new co;
            }
            getDefaultSegment() {
                return this.regionSegments[4];
            }
            hasData() {
                return 0 !== this.vertexArray.length;
            }
            addData(t1, e, r, n = !1) {
                const i = t1.length;
                if (i > 2) {
                    let s = Math.max(0, this._segments.get().length - 1);
                    const a = this._segments._prepareSegment(4 * i, this.vertexArray.length, 2 * this._segmentToGroundQuads[s].length);
                    let o;
                    s !== this._segments.get().length - 1 && (s++, this._segmentToGroundQuads[s] = [], this._segmentToRegionTriCounts[s] = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ]);
                    {
                        const e = t1[0], r = t1[1];
                        o = $h(e.sub(t1[i - 1])._perp()._unit(), r.sub(e)._perp()._unit());
                    }
                    for(let l = 0; l < i; l++){
                        const u = l === i - 1 ? 0 : l + 1, c = t1[l], h = t1[u], p = t1[u === i - 1 ? 0 : u + 1], f = h.sub(c)._perp()._unit(), d = $h(f, p.sub(h)._perp()._unit()), m = o, y = d;
                        if (Jh(c, h, e) || n && Qh(c, e) && Qh(h, e)) {
                            o = d;
                            continue;
                        }
                        const g = a.vertexLength;
                        Oh(this.vertexArray, c, h, 1, 1, m), Oh(this.vertexArray, c, h, 1, 0, m), Oh(this.vertexArray, c, h, 0, 1, y), Oh(this.vertexArray, c, h, 0, 0, y), a.vertexLength += 4;
                        const x = Xh(c, h, f, r);
                        for (const t1 of x)this._segmentToGroundQuads[s].push({
                            id: g,
                            region: t1
                        }), this._segmentToRegionTriCounts[s][t1] += 2, a.primitiveLength += 2;
                        o = d;
                    }
                }
            }
            prepareBorderSegments() {
                if (!this.hasData()) return;
                const t1 = this._segments.get(), e = t1.length;
                for(let t1 = 0; t1 < e; t1++)this._segmentToGroundQuads[t1].sort((t1, e)=>t1.region - e.region);
                for(let r = 0; r < e; r++){
                    const e = this._segmentToGroundQuads[r], n = t1[r], i = this._segmentToRegionTriCounts[r];
                    i.reduce((t1, e)=>t1 + e, 0);
                    let s = 0;
                    for(let t1 = 0; t1 <= 4; t1++){
                        const e = i[t1];
                        if (0 !== e) {
                            let r = this.regionSegments[t1];
                            r || (r = this.regionSegments[t1] = new co);
                            const i = {
                                vertexOffset: n.vertexOffset,
                                primitiveOffset: n.primitiveOffset + s,
                                vertexLength: n.vertexLength,
                                primitiveLength: e
                            };
                            r.get().push(i);
                        }
                        s += e;
                    }
                    for(let t1 = 0; t1 < e.length; t1++){
                        const r = e[t1].id;
                        this.indexArray.emplaceBack(r, r + 1, r + 3), this.indexArray.emplaceBack(r, r + 3, r + 2);
                    }
                }
                this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
            }
            addPaintPropertiesData(t1, e, r, n, i, s) {
                this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, t1, e, r, n, i, s);
            }
            upload(t1) {
                this.hasData() && (this.vertexBuffer = t1.createVertexBuffer(this.vertexArray, Yc.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray));
            }
            uploadPaintProperties(t1) {
                this.hasData() && this.programConfigurations.upload(t1);
            }
            update(t1, e, r, n, i, s) {
                this.hasData() && this.programConfigurations.updatePaintArrays(t1, e, r, n, i, s);
            }
            updateHiddenByLandmark(t1) {
                if (!this.hasData()) return;
                const e = t1.groundVertexCount + t1.groundVertexArrayOffset;
                if (0 === t1.groundVertexCount) return;
                const r = t1.flags & Dh ? 1 : 0;
                for(let n = t1.groundVertexArrayOffset; n < e; ++n)this.hiddenByLandmarkVertexArray.emplace(n, r);
                this._needsHiddenByLandmarkUpdate = !0;
            }
            uploadHiddenByLandmark(t1) {
                this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = t1.createVertexBuffer(this.hiddenByLandmarkVertexArray, Hc.members, !0) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = !1);
            }
            destroy() {
                if (this.vertexBuffer) {
                    this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
                    for(let t1 = 0; t1 <= 4; t1++){
                        const e = this.regionSegments[t1];
                        e && e.destroy();
                    }
                }
            }
        }
        class Zh {
            constructor(t1){
                this.zoom = t1.zoom, this.canonical = t1.canonical, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = t1.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = [], this.footprintIndices = new Da, this.footprintVertices = new xa, this.footprintSegments = [], this.layoutVertexArray = new va, this.centroidVertexArray = new so, this.wallVertexArray = new oo, this.indexArray = new Da, this.programConfigurations = new Fo(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }, (t1)=>Eh.includes(t1)), this.segments = new co, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.groundEffect = new Yh(t1), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [];
            }
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                this.features = [], this.hasPattern = Dc("fill-extrusion", this.layers, e), this.featuresOnBorder = [], this.borderFeatureIndices = [
                    [],
                    [],
                    [],
                    []
                ], this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ], this.tileToMeter = gl(r), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter, this.wallMode = 0 !== this.layers[0].paint.get("fill-extrusion-line-width").constantOr(1);
                for (const { feature: i, id: s, index: a, sourceLayerIndex: o } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, l = Pl(i, t1);
                    if (!this.layers[0]._featureFilter.filter(new Vs(this.zoom), l, r)) continue;
                    const u = {
                        id: s,
                        sourceLayerIndex: o,
                        index: a,
                        geometry: t1 ? l.geometry : Il(i, r, n),
                        properties: i.properties,
                        type: i.type,
                        patterns: {}
                    }, c = this.layoutVertexArray.length, h = "Polygon" === Th[u.type];
                    if (this.hasPattern) this.features.push(Lc("fill-extrusion", this.layers, u, this.zoom, e));
                    else if (this.wallMode) for (const t1 of u.geometry)for (const i of kh(t1, h))this.addFeature(u, [
                        i
                    ], a, r, {}, e.availableImages, n, e.brightness);
                    else this.addFeature(u, u.geometry, a, r, {}, e.availableImages, n, e.brightness);
                    e.featureIndex.insert(i, u.geometry, a, o, this.index, c);
                }
                this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
            }
            addFeatures(t1, e, r, n, i, s) {
                for (const t1 of this.features){
                    const a = "Polygon" === Th[t1.type], { geometry: o } = t1;
                    if (this.wallMode) for (const l of o)for (const o of kh(l, a))this.addFeature(t1, [
                        o
                    ], t1.index, e, r, n, i, s);
                    else this.addFeature(t1, o, t1.index, e, r, n, i, s);
                }
                this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
            }
            update(t1, e, r, n, i) {
                const s = 0 !== Object.keys(t1).length;
                if (s && !this.stateDependentLayers.length) return;
                const a = s ? this.stateDependentLayers : this.layers;
                this.programConfigurations.updatePaintArrays(t1, e, a, r, n, i), this.groundEffect.update(t1, e, a, r, n, i);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Jc), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.wallVertexBuffer = t1.createVertexBuffer(this.wallVertexArray, Wc.members), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = t1.createVertexBuffer(this.layoutVertexExtArray, Kc.members, !0)), this.groundEffect.upload(t1)), this.groundEffect.uploadPaintProperties(t1), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            uploadCentroid(t1) {
                this.groundEffect.uploadHiddenByLandmark(t1), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = t1.createVertexBuffer(this.centroidVertexArray, Zc.members, !0) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = !1);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t1, e, r, n, i, s, a, o) {
                const l = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(t1, {}) / this.tileToMeter, u = [
                    new q(0, 0),
                    new q(Hr, Hr)
                ], c = a.projection, h = "globe" === c.name, p = this.wallMode || "Polygon" === Th[t1.type], f = new qh;
                f.centroidDataIndex = this.centroidData.length;
                const d = new Nh, m = this.layers[0].paint.get("fill-extrusion-base").evaluate(t1, {}, n) <= 0, y = this.layers[0].paint.get("fill-extrusion-height").evaluate(t1, {}, n);
                let g;
                if (d.height = y, d.vertexArrayOffset = this.layoutVertexArray.length, d.groundVertexArrayOffset = this.groundEffect.vertexArray.length, h && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new Pa), this.wallMode) {
                    if (h) return void ft("Non zero fill-extrusion-line-width is not yet supported on globe.");
                    if (1 !== e.length) return;
                    g = function(t1) {
                        const e = t1[0].x === t1[t1.length - 1].x && t1[0].y === t1[t1.length - 1].y, r = function(t1) {
                            let e = 0;
                            const r = t1.length;
                            for(let n = 0; n < r; n++)e += (t1[(n + 1) % r].x - t1[n].x) * (t1[(n + 1) % r].y + t1[n].y);
                            return e >= 0;
                        }(t1);
                        r || (t1 = t1.reverse());
                        const n = {
                            geometry: [],
                            joinNormals: [],
                            indices: []
                        }, i = [], s = [], a = [];
                        let o = t1.length;
                        if (o < (e ? 3 : 2)) return n;
                        for(; o >= 2 && t1[o - 1].equals(t1[o - 2]);)o--;
                        let l, u, c, h, p, f = 0;
                        for(; f < o - 1 && t1[f].equals(t1[f + 1]);)f++;
                        e && (l = t1[o - 2], p = t1[f].sub(l)._unit()._perp());
                        for(let r = f; r < o; r++){
                            if (c = r === o - 1 ? e ? t1[f + 1] : void 0 : t1[r + 1], c && t1[r].equals(c)) continue;
                            p && (h = p), l && (u = l), l = t1[r], p = c ? c.sub(l)._unit()._perp() : h, h = h || p;
                            let n = h.add(p);
                            0 === n.x && 0 === n.y || n._unit();
                            const d = n.x * p.x + n.y * p.y, m = 0 !== d ? 1 / d : 1 / 0, y = h.x * p.y - h.y * p.x > 0;
                            let g = "miter";
                            const x = 2;
                            "miter" === g && m > x && (g = "bevel"), "bevel" === g && (m > 100 && (g = "flipbevel"), m < x && (g = "miter"));
                            const b = (t1, e, r, n)=>{
                                const o = new q(t1.x, t1.y), l = new q(t1.x, t1.y);
                                o.x += e.x * n, o.y += e.y * n, l.x -= e.x * Math.max(r, 1), l.y -= e.y * Math.max(r, 1), a.push(e), i.push(o), s.push(l);
                            };
                            if ("miter" === g) n._mult(m), b(l, n, 0, 0);
                            else if ("flipbevel" === g) n = p.mult(-1), b(l, n, 0, 0), b(l, n.mult(-1), 0, 0);
                            else {
                                const t1 = -Math.sqrt(m * m - 1), e = y ? t1 : 0, r = y ? 0 : t1;
                                u && b(l, h, e, r), c && b(l, p, e, r);
                            }
                        }
                        n.geometry = [
                            ...i,
                            ...s.reverse(),
                            i[0]
                        ], n.joinNormals = [
                            ...a,
                            ...a.reverse(),
                            a[a.length - 1]
                        ];
                        const d = n.geometry.length - 1;
                        for(let t1 = 0; t1 < d / 2; t1++)if (t1 + 1 < d / 2) {
                            let e = t1, r = t1 + 1, i = d - 1 - t1, s = d - 2 - t1;
                            e = 0 === e ? d - 1 : e - 1, r = 0 === r ? d - 1 : r - 1, i = 0 === i ? d - 1 : i - 1, s = 0 === s ? d - 1 : s - 1, n.indices.push(i), n.indices.push(r), n.indices.push(e), n.indices.push(i), n.indices.push(s), n.indices.push(r);
                        }
                        return n;
                    }(e[0]), e = [
                        g.geometry
                    ];
                }
                const x = (t1, e)=>t1 < (e.length - 1) / 2 || t1 === e.length - 1, b = this.wallMode ? [
                    e
                ] : Cc(e, 500);
                for(let t1 = b.length - 1; t1 >= 0; t1--){
                    const e = b[t1];
                    (0 === e.length || (v = e[0]).every((t1)=>t1.x <= 0) || v.every((t1)=>t1.x >= Hr) || v.every((t1)=>t1.y <= 0) || v.every((t1)=>t1.y >= Hr)) && b.splice(t1, 1);
                }
                var v;
                let w;
                if (h) w = np(b, u, n);
                else {
                    w = [];
                    for (const t1 of b)w.push({
                        polygon: t1,
                        bounds: u
                    });
                }
                const _ = p ? this.edgeRadius : 0, M = _ > 0 && this.zoom < 17, A = (t1, e)=>{
                    if (0 === t1.length) return !1;
                    const r = t1[t1.length - 1];
                    return e.x === r.x && e.y === r.y;
                };
                for (const { polygon: t1, bounds: e } of w){
                    let r = 0, i = 0;
                    for (const e of t1)p && !e[0].equals(e[e.length - 1]) && e.push(e[0]), i += p ? e.length - 1 : e.length;
                    const s = this.segments.prepareSegment((p ? 5 : 4) * i, this.layoutVertexArray, this.indexArray);
                    d.footprintSegIdx < 0 && (d.footprintSegIdx = this.footprintSegments.length), d.polygonSegIdx < 0 && (d.polygonSegIdx = this.polygonSegments.length);
                    const a = {
                        triangleArrayOffset: this.indexArray.length,
                        triangleCount: 0,
                        triangleSegIdx: this.segments.segments.length - 1
                    }, o = new jh;
                    if (o.vertexOffset = this.footprintVertices.length, o.indexOffset = 3 * this.footprintIndices.length, o.ringIndices = [], p) {
                        const i = [], a = [];
                        r = s.vertexLength;
                        for(let r = 0; r < t1.length; r++){
                            const u = t1[r];
                            u.length && 0 !== r && a.push(i.length / 2);
                            const p = [];
                            let f, d;
                            f = u[1].sub(u[0])._perp()._unit(), o.ringIndices.push(u.length - 1);
                            for(let t1 = 1; t1 < u.length; t1++){
                                const e = u[t1], r = u[t1 === u.length - 1 ? 1 : t1 + 1], a = e.clone();
                                if (_) {
                                    d = r.sub(e)._perp()._unit();
                                    const t1 = f.add(d)._unit(), n = _ * Math.min(4, 1 / (f.x * t1.x + f.y * t1.y));
                                    a.x += n * t1.x, a.y += n * t1.y, a.x = Math.round(a.x), a.y = Math.round(a.y), f = d;
                                }
                                if (!m || 0 !== _ && !M || A(p, a) || p.push(a), Lh(this.layoutVertexArray, a.x, a.y, 0, 0, 1, 1, 0), this.wallMode) {
                                    const e = x(t1, u);
                                    Fh(this.wallVertexArray, g.joinNormals[t1], !e);
                                }
                                s.vertexLength++, this.footprintVertices.emplaceBack(e.x, e.y), i.push(e.x, e.y), h && Uh(this.layoutVertexExtArray, c.projectTilePoint(a.x, a.y, n), c.upVector(n, a.x, a.y));
                            }
                            m && (0 === _ || M) && (0 !== p.length && A(p, p[0]) && p.pop(), this.groundEffect.addData(p, e, l));
                        }
                        const u = this.wallMode ? g.indices : uc(i, a);
                        for(let t1 = 0; t1 < u.length; t1 += 3)this.footprintIndices.emplaceBack(o.vertexOffset + u[t1 + 0], o.vertexOffset + u[t1 + 1], o.vertexOffset + u[t1 + 2]), this.indexArray.emplaceBack(r + u[t1], r + u[t1 + 2], r + u[t1 + 1]), s.primitiveLength++;
                        o.indexCount += u.length, o.vertexCount += this.footprintVertices.length - o.vertexOffset;
                    }
                    for(let i = 0; i < t1.length; i++){
                        const a = t1[i];
                        f.startRing(d, a[0]);
                        let o = a.length > 4 && tp(a[a.length - 2], a[0], a[1]), u = _ ? Hh(a[a.length - 2], a[0], a[1], _) : 0;
                        const y = [];
                        let b, v, w;
                        v = a[1].sub(a[0])._perp()._unit();
                        let M = !0;
                        for(let t1 = 1, i = 0; t1 < a.length; t1++){
                            let l = a[t1 - 1], p = a[t1];
                            const S = a[t1 === a.length - 1 ? 1 : t1 + 1];
                            if (f.appendEdge(d, p, l), Jh(p, l, e)) {
                                _ && (v = S.sub(p)._perp()._unit(), M = !M);
                                continue;
                            }
                            const I = p.sub(l)._perp(), P = I.x / (Math.abs(I.x) + Math.abs(I.y)), z = I.y > 0 ? 1 : 0, k = l.dist(p);
                            if (i + k > 32768 && (i = 0), _) {
                                w = S.sub(p)._perp()._unit();
                                let t1 = Kh(l, p, S, Wh(v, w), _);
                                isNaN(t1) && (t1 = 0);
                                const e = p.sub(l)._unit();
                                l = l.add(e.mult(u))._round(), p = p.add(e.mult(-t1))._round(), u = t1, v = w, m && this.zoom >= 17 && (A(y, l) || y.push(l), A(y, p) || y.push(p));
                            }
                            const T = s.vertexLength, E = a.length > 4 && tp(l, p, S);
                            let B = ep(i, o, M);
                            if (Lh(this.layoutVertexArray, l.x, l.y, P, z, 0, 0, B), Lh(this.layoutVertexArray, l.x, l.y, P, z, 0, 1, B), this.wallMode) {
                                const e = x(t1 - 1, a), r = g.joinNormals[t1 - 1];
                                Fh(this.wallVertexArray, r, e), Fh(this.wallVertexArray, r, e);
                            }
                            if (i += k, B = ep(i, E, !M), o = E, Lh(this.layoutVertexArray, p.x, p.y, P, z, 0, 0, B), Lh(this.layoutVertexArray, p.x, p.y, P, z, 0, 1, B), this.wallMode) {
                                const e = x(t1, a), r = g.joinNormals[t1];
                                Fh(this.wallVertexArray, r, e), Fh(this.wallVertexArray, r, e);
                            }
                            if (s.vertexLength += 4, this.indexArray.emplaceBack(T + 0, T + 1, T + 2), this.indexArray.emplaceBack(T + 1, T + 3, T + 2), s.primitiveLength += 2, _) {
                                const n = r + (1 === t1 ? a.length - 2 : t1 - 2), i = 1 === t1 ? r : n + 1;
                                if (this.indexArray.emplaceBack(T + 1, n, T + 3), this.indexArray.emplaceBack(n, i, T + 3), s.primitiveLength += 2, void 0 === b && (b = T), !Jh(S, a[t1], e)) {
                                    const e = t1 === a.length - 1 ? b : s.vertexLength;
                                    this.indexArray.emplaceBack(T + 2, T + 3, e), this.indexArray.emplaceBack(T + 3, e + 1, e), this.indexArray.emplaceBack(T + 3, i, e + 1), s.primitiveLength += 3;
                                }
                                M = !M;
                            }
                            if (h) {
                                const t1 = this.layoutVertexExtArray, e = c.projectTilePoint(l.x, l.y, n), r = c.projectTilePoint(p.x, p.y, n), i = c.upVector(n, l.x, l.y), s = c.upVector(n, p.x, p.y);
                                Uh(t1, e, i), Uh(t1, e, i), Uh(t1, r, s), Uh(t1, r, s);
                            }
                        }
                        p && (r += a.length - 1), m && _ && this.zoom >= 17 && (0 !== y.length && A(y, y[0]) && y.pop(), this.groundEffect.addData(y, e, l, _ > 0));
                    }
                    this.footprintSegments.push(o), a.triangleCount = this.indexArray.length - a.triangleArrayOffset, this.polygonSegments.push(a), ++d.footprintSegLen, ++d.polygonSegLen;
                }
                if (d.vertexCount = this.layoutVertexArray.length - d.vertexArrayOffset, d.groundVertexCount = this.groundEffect.vertexArray.length - d.groundVertexArrayOffset, 0 !== d.vertexCount) {
                    if (d.centroidXY = f.borders ? Rh : this.encodeCentroid(f, d), this.centroidData.push(d), f.borders) {
                        this.featuresOnBorder.push(f);
                        const t1 = this.featuresOnBorder.length - 1;
                        for(let e = 0; e < f.borders.length; e++)f.borders[e][0] !== Number.MAX_VALUE && this.borderFeatureIndices[e].push(t1);
                    }
                    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, s, n, o), this.groundEffect.addPaintPropertiesData(t1, r, i, s, n, o), this.maxHeight = Math.max(this.maxHeight, y);
                }
            }
            sortBorders() {
                for(let t1 = 0; t1 < this.borderFeatureIndices.length; t1++)this.borderFeatureIndices[t1].sort((e, r)=>this.featuresOnBorder[e].borders[t1][0] - this.featuresOnBorder[r].borders[t1][0]);
            }
            splitToSubtiles() {
                const t1 = [];
                for(let e = 0; e < this.centroidData.length; e++){
                    const r = this.centroidData[e], n = +(r.min.y + r.max.y > Hr), i = 2 * n + (+(r.min.x + r.max.x > Hr) ^ n);
                    for(let n = 0; n < r.polygonSegLen; n++){
                        const s = r.polygonSegIdx + n;
                        t1.push({
                            centroidIdx: e,
                            subtile: i,
                            polygonSegmentIdx: s,
                            triangleSegmentIdx: this.polygonSegments[s].triangleSegIdx
                        });
                    }
                }
                const e = new Da;
                t1.sort((t1, e)=>t1.triangleSegmentIdx === e.triangleSegmentIdx ? t1.subtile - e.subtile : t1.triangleSegmentIdx - e.triangleSegmentIdx);
                let r = 0, n = 0, i = 0;
                for (const e of t1){
                    if (e.triangleSegmentIdx !== r) break;
                    i++;
                }
                const s = t1.length;
                for(; n !== t1.length;){
                    r = t1[n].triangleSegmentIdx;
                    let a = 0, o = n, l = n;
                    for(let e = o; e < i && t1[e].subtile === a; e++)l++;
                    for(; o !== i;){
                        const n = t1[o];
                        a = n.subtile;
                        const s = this.centroidData[n.centroidIdx].min.clone(), u = this.centroidData[n.centroidIdx].max.clone(), c = {
                            vertexOffset: this.segments.segments[r].vertexOffset,
                            primitiveOffset: e.length,
                            vertexLength: this.segments.segments[r].vertexLength,
                            primitiveLength: 0,
                            sortKey: void 0,
                            vaos: {}
                        };
                        for(let r = o; r < l; r++){
                            const n = t1[r], i = this.polygonSegments[n.polygonSegmentIdx], a = this.centroidData[n.centroidIdx].min, o = this.centroidData[n.centroidIdx].max, l = this.indexArray.uint16;
                            for(let t1 = i.triangleArrayOffset; t1 < i.triangleArrayOffset + i.triangleCount; t1++)e.emplaceBack(l[3 * t1], l[3 * t1 + 1], l[3 * t1 + 2]);
                            c.primitiveLength += i.triangleCount, s.x = Math.min(s.x, a.x), s.y = Math.min(s.y, a.y), u.x = Math.max(u.x, o.x), u.y = Math.max(u.y, o.y);
                        }
                        c.primitiveLength > 0 && this.triangleSubSegments.push({
                            segment: c,
                            min: s,
                            max: u
                        }), o = l;
                        for(let e = o; e < i && t1[e].subtile === t1[o].subtile; e++)l++;
                    }
                    n = i;
                    for(let e = n; e < s && t1[e].triangleSegmentIdx === t1[n].triangleSegmentIdx; e++)i++;
                }
                e._trim(), this.indexArray = e;
            }
            getVisibleSegments(t1, e, r) {
                const n = new co;
                if (this.wallMode) {
                    for (const t1 of this.triangleSubSegments)n.segments.push(t1.segment);
                    return n;
                }
                let i = 0, s = 0;
                const a = 1 << t1.canonical.z;
                if (e) {
                    const r = e.getMinMaxForTile(t1);
                    r && (i = r.min, s = r.max);
                }
                s += this.maxHeight;
                const o = t1.toUnwrapped();
                let l;
                const u = [
                    o.canonical.x / a + o.wrap,
                    o.canonical.y / a
                ], c = [
                    (o.canonical.x + 1) / a + o.wrap,
                    (o.canonical.y + 1) / a
                ], h = (t1, e, r)=>[
                        t1[0] * (1 - r[0]) + e[0] * r[0],
                        t1[1] * (1 - r[1]) + e[1] * r[1]
                    ], p = [], f = [];
                for (const t1 of this.triangleSubSegments){
                    p[0] = t1.min.x / Hr, p[1] = t1.min.y / Hr, f[0] = t1.max.x / Hr, f[1] = t1.max.y / Hr;
                    const e = h(u, c, p), a = h(u, c, f);
                    if (0 === new yu([
                        e[0],
                        e[1],
                        i
                    ], [
                        a[0],
                        a[1],
                        s
                    ]).intersectsPrecise(r)) {
                        l && (n.segments.push(l), l = void 0);
                        continue;
                    }
                    const o = t1.segment;
                    l && l.vertexOffset !== o.vertexOffset && (n.segments.push(l), l = void 0), l ? (l.vertexLength += o.vertexLength, l.primitiveLength += o.primitiveLength) : l = {
                        vertexOffset: o.vertexOffset,
                        primitiveLength: o.primitiveLength,
                        vertexLength: o.vertexLength,
                        primitiveOffset: o.primitiveOffset,
                        sortKey: void 0,
                        vaos: {}
                    };
                }
                return l && n.segments.push(l), n;
            }
            encodeCentroid(t1, e) {
                const r = t1.centroid(), n = e.span(), i = Math.min(7, Math.round(n.x * this.tileToMeter / 10)), s = Math.min(7, Math.round(n.y * this.tileToMeter / 10));
                return new q(Q(r.x, 1, Hr - 1) << 3 | i, Q(r.y, 1, Hr - 1) << 3 | s);
            }
            encodeBorderCentroid(t1) {
                if (!t1.borders) return new q(0, 0);
                const e = t1.borders, r = Number.MAX_VALUE;
                if (e[0][0] !== r || e[1][0] !== r) {
                    const t1 = e[0][0] !== r ? 0 : 1;
                    return new q(6 | (e[0][0] !== r ? 0 : 65528), (e[t1][0] + e[t1][1]) / 2 << 3 | 6);
                }
                {
                    const t1 = e[2][0] !== r ? 2 : 3;
                    return new q((e[t1][0] + e[t1][1]) / 2 << 3 | 6, 6 | (e[2][0] !== r ? 0 : 65528));
                }
            }
            showCentroid(t1) {
                const e = this.centroidData[t1.centroidDataIndex];
                e.flags &= Dh, e.centroidXY.x = 0, e.centroidXY.y = 0, this.writeCentroidToBuffer(e);
            }
            writeCentroidToBuffer(t1) {
                this.groundEffect.updateHiddenByLandmark(t1);
                const e = t1.vertexArrayOffset, r = t1.vertexCount + t1.vertexArrayOffset, n = t1.flags & Dh ? Rh : t1.centroidXY, i = this.centroidVertexArray.geta_centroid_pos0(e);
                if (this.centroidVertexArray.geta_centroid_pos1(e) !== n.y || i !== n.x) {
                    for(let t1 = e; t1 < r; ++t1)this.centroidVertexArray.emplace(t1, n.x, n.y);
                    this.needsCentroidUpdate = !0;
                }
            }
            createCentroidsBuffer() {
                this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const t1 of this.centroidData)this.writeCentroidToBuffer(t1);
            }
            updateReplacement(t1, e, r) {
                if (e.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = e.updateTime;
                const n = e.getReplacementRegionsForTile(t1.toUnwrapped());
                if (wh(this.activeReplacements, n)) return;
                if (this.activeReplacements = n, 0 === this.centroidVertexArray.length) this.createCentroidsBuffer();
                else for (const t1 of this.centroidData)t1.flags &= 2147483647;
                const i = [];
                for (const e of this.activeReplacements){
                    if (e.order < r) continue;
                    const n = Math.pow(2, e.footprintTileId.canonical.z - t1.canonical.z);
                    for (const r of this.centroidData)if (!(r.flags & Dh || e.min.x > r.max.x || r.min.x > e.max.x || e.min.y > r.max.y || r.min.y > e.max.y)) for(let s = 0; s < r.footprintSegLen; s++){
                        const a = this.footprintSegments[r.footprintSegIdx + s];
                        if (i.length = 0, ip(this.footprintVertices, a.vertexOffset, a.vertexCount, e.footprintTileId.canonical, t1.canonical, i), Ah(e.footprint, i, this.footprintIndices.uint16, a.indexOffset, a.indexCount, -a.vertexOffset, -n)) {
                            r.flags |= Dh;
                            break;
                        }
                    }
                }
                for (const t1 of this.centroidData)this.writeCentroidToBuffer(t1);
                this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ];
            }
            footprintContainsPoint(t1, e, r) {
                let n = !1;
                for(let i = 0; i < r.footprintSegLen; i++){
                    const s = this.footprintSegments[r.footprintSegIdx + i];
                    let a = 0;
                    for (const r of s.ringIndices){
                        for(let i = a, o = r + a - 1; i < r + a; o = i++){
                            const r = this.footprintVertices.int16[2 * (i + s.vertexOffset) + 0], a = this.footprintVertices.int16[2 * (i + s.vertexOffset) + 1], l = this.footprintVertices.int16[2 * (o + s.vertexOffset) + 1];
                            a > e != l > e && t1 < (this.footprintVertices.int16[2 * (o + s.vertexOffset) + 0] - r) * (e - a) / (l - a) + r && (n = !n);
                        }
                        a = r;
                    }
                }
                return n;
            }
            getHeightAtTileCoord(t1, e) {
                let r = Number.NEGATIVE_INFINITY, n = !0;
                const i = 4 * (t1 + Hr) * Hr + (e + Hr);
                if (this.partLookup.hasOwnProperty(i)) {
                    const t1 = this.partLookup[i];
                    return t1 ? {
                        height: t1.height,
                        hidden: !!(t1.flags & Dh)
                    } : void 0;
                }
                for (const s of this.centroidData)t1 > s.max.x || s.min.x > t1 || e > s.max.y || s.min.y > e || this.footprintContainsPoint(t1, e, s) && s && s.height > r && (r = s.height, this.partLookup[i] = s, n = !!(s.flags & Dh));
                if (r !== Number.NEGATIVE_INFINITY) return {
                    height: r,
                    hidden: n
                };
                this.partLookup[i] = void 0;
            }
        }
        function Wh(t1, e) {
            const r = t1.add(e)._unit();
            return t1.x * r.x + t1.y * r.y;
        }
        function Hh(t1, e, r, n) {
            const i = e.sub(t1)._perp()._unit(), s = r.sub(e)._perp()._unit();
            return Kh(t1, e, r, Wh(i, s), n);
        }
        function Kh(t1, e, r, n, i) {
            const s = Math.sqrt(1 - n * n);
            return Math.min(t1.dist(e) / 3, e.dist(r) / 3, i * s / n);
        }
        function Jh(t1, e, r) {
            return t1.x < r[0].x && e.x < r[0].x || t1.x > r[1].x && e.x > r[1].x || t1.y < r[0].y && e.y < r[0].y || t1.y > r[1].y && e.y > r[1].y;
        }
        function Qh(t1, e) {
            return t1.x < e[0].x || t1.x > e[1].x || t1.y < e[0].y || t1.y > e[1].y;
        }
        function tp(t1, e, r) {
            if (t1.x < 0 || t1.x >= Hr || e.x < 0 || e.x >= Hr || r.x < 0 || r.x >= Hr) return !1;
            const n = r.sub(e), i = n.perp(), s = t1.sub(e);
            return (n.x * s.x + n.y * s.y) / Math.sqrt((n.x * n.x + n.y * n.y) * (s.x * s.x + s.y * s.y)) > -0.866 && i.x * s.x + i.y * s.y < 0;
        }
        function ep(t1, e, r) {
            const n = e ? 2 | t1 : -3 & t1;
            return r ? 1 | n : -2 & n;
        }
        function rp() {
            const t1 = Math.PI / 32, e = Math.tan(t1), r = tl;
            return r * Math.sqrt(1 + 2 * e * e) - r;
        }
        function np(t1, e, r) {
            const n = 1 << r.z, i = cl(r.x / n), s = cl((r.x + 1) / n), a = hl(r.y / n), o = hl((r.y + 1) / n);
            return function(t1, e, r, n, i = 0, s) {
                const a = [];
                if (!t1.length || !r || !n) return a;
                const o = (t1, e)=>{
                    for (const r of t1)a.push({
                        polygon: r,
                        bounds: e
                    });
                }, l = Math.ceil(Math.log2(r)), u = Math.ceil(Math.log2(n)), c = l - u, h = [];
                for(let t1 = 0; t1 < Math.abs(c); t1++)h.push(c > 0 ? 0 : 1);
                for(let t1 = 0; t1 < Math.min(l, u); t1++)h.push(0), h.push(1);
                let p = t1;
                if (p = fh(p, e[0].y - i, e[1].y + i, 1), p = fh(p, e[0].x - i, e[1].x + i, 0), !p.length) return a;
                const f = [];
                for(h.length ? f.push({
                    polygons: p,
                    bounds: e,
                    depth: 0
                }) : o(p, e); f.length;){
                    const t1 = f.pop(), e = t1.depth, r = h[e], n = t1.bounds[0], a = t1.bounds[1], l = 0 === r ? n.x : n.y, u = 0 === r ? a.x : a.y, c = s ? s(r, l, u) : .5 * (l + u), p = fh(t1.polygons, l - i, c + i, r), d = fh(t1.polygons, c - i, u + i, r);
                    if (p.length) {
                        const t1 = [
                            n,
                            new q(0 === r ? c : a.x, 1 === r ? c : a.y)
                        ];
                        h.length > e + 1 ? f.push({
                            polygons: p,
                            bounds: t1,
                            depth: e + 1
                        }) : o(p, t1);
                    }
                    if (d.length) {
                        const t1 = [
                            new q(0 === r ? c : n.x, 1 === r ? c : n.y),
                            a
                        ];
                        h.length > e + 1 ? f.push({
                            polygons: d,
                            bounds: t1,
                            depth: e + 1
                        }) : o(d, t1);
                    }
                }
                return a;
            }(t1, e, Math.ceil((s - i) / 11.25), Math.ceil((a - o) / 11.25), 1, (t1, e, i)=>{
                if (0 === t1) return .5 * (e + i);
                {
                    const t1 = hl((r.y + e / Hr) / n);
                    return (ll(.5 * (hl((r.y + i / Hr) / n) + t1)) * n - r.y) * Hr;
                }
            });
        }
        function ip(t1, e, r, n, i, s) {
            const a = Math.pow(2, n.z - i.z);
            for(let o = 0; o < r; o++){
                let r = t1.int16[2 * (o + e) + 0], l = t1.int16[2 * (o + e) + 1];
                r = (r + i.x * Hr) * a - n.x * Hr, l = (l + i.y * Hr) * a - n.y * Hr, s.push(new q(r, l));
            }
        }
        let sp, ap;
        function op(t1, e) {
            return t1.x * e.x + t1.y * e.y;
        }
        function lp(t1, e) {
            if (1 === t1.length) {
                let r = 0;
                const n = e[r++];
                let i;
                for(; !i || n.equals(i);)if (i = e[r++], !i) return 1 / 0;
                for(; r < e.length; r++){
                    const s = e[r], a = t1[0], o = i.sub(n), l = s.sub(n), u = a.sub(n), c = op(o, o), h = op(o, l), p = op(l, l), f = op(u, o), d = op(u, l), m = c * p - h * h, y = (p * f - h * d) / m, g = (c * d - h * f) / m, x = n.z * (1 - y - g) + i.z * y + s.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let t1 = 1 / 0;
                for (const r of e)t1 = Math.min(t1, r.z);
                return t1;
            }
        }
        function up(t1, e, r, n, i, s, a, o) {
            const l = a * i.getElevationAt(t1, e, !0, !0), u = 0 !== s[0], c = u ? 0 === s[1] ? a * (s[0] / 7 - 450) : a * function(t1, e, r) {
                const n = Math.floor(e[0] / 8), i = Math.floor(e[1] / 8), s = 10 * (e[0] - 8 * n), a = 10 * (e[1] - 8 * i), o = t1.getElevationAt(n, i, !0, !0), l = t1.getMeterToDEM(r), u = Math.floor(.5 * (s * l - 1)), c = Math.floor(.5 * (a * l - 1)), h = t1.tileCoordToPixel(n, i), p = 2 * u + 1, f = 2 * c + 1, d = function(t1, e, r, n, i) {
                    return [
                        t1.getElevationAtPixel(e, r, !0),
                        t1.getElevationAtPixel(e + i, r, !0),
                        t1.getElevationAtPixel(e, r + i, !0),
                        t1.getElevationAtPixel(e + n, r + i, !0)
                    ];
                }(t1, h.x - u, h.y - c, p, f), m = Math.abs(d[0] - d[1]), y = Math.abs(d[2] - d[3]), g = Math.abs(d[0] - d[2]) + Math.abs(d[1] - d[3]), x = Math.min(.25, .5 * l * (m + y) / p), b = Math.min(.25, .5 * l * g / f);
                return o + Math.max(x * s, b * a);
            }(i, s, o) : l;
            return {
                base: l + (0 === r) ? -1 : r,
                top: u ? Math.max(c + n, l + r + 2) : l + n
            };
        }
        os(Zh, "FillExtrusionBucket", {
            omit: [
                "layers",
                "features"
            ]
        }), os(Nh, "PartData"), os(jh, "FootprintSegment"), os(qh, "BorderCentroidData"), os(Yh, "GroundEffect");
        const cp = ya([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            },
            {
                name: "a_linesofar",
                components: 1,
                type: "Float32"
            }
        ], 4), hp = ya([
            {
                name: "a_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), { members: pp } = cp, fp = ya([
            {
                name: "a_packed",
                components: 4,
                type: "Float32"
            }
        ]), { members: dp } = fp, mp = ya([
            {
                name: "a_pattern_data",
                components: 3,
                type: "Float32"
            }
        ]), { members: yp } = mp;
        class gp {
            constructor(t1, e){
                this.width = t1, this.height = e, this.nextRow = 0, this.image = new nc({
                    width: t1,
                    height: e
                }), this.positions = {}, this.uploaded = !1;
            }
            getDash(t1, e) {
                const r = this.getKey(t1, e);
                return this.positions[r];
            }
            trim() {
                const t1 = this.width, e = this.height = at(this.nextRow);
                this.image.resize({
                    width: t1,
                    height: e
                });
            }
            getKey(t1, e) {
                return t1.join(",") + e;
            }
            getDashRanges(t1, e, r) {
                const n = [];
                let i = t1.length % 2 == 1 ? -t1[t1.length - 1] * r : 0, s = t1[0] * r, a = !0;
                n.push({
                    left: i,
                    right: s,
                    isDash: a,
                    zeroLength: 0 === t1[0]
                });
                let o = t1[0];
                for(let e = 1; e < t1.length; e++){
                    a = !a;
                    const l = t1[e];
                    i = o * r, o += l, s = o * r, n.push({
                        left: i,
                        right: s,
                        isDash: a,
                        zeroLength: 0 === l
                    });
                }
                return n;
            }
            addRoundDash(t1, e, r) {
                const n = e / 2;
                for(let e = -r; e <= r; e++){
                    const i = this.width * (this.nextRow + r + e);
                    let s = 0, a = t1[s];
                    for(let o = 0; o < this.width; o++){
                        o / a.right > 1 && (a = t1[++s]);
                        const l = Math.abs(o - a.left), u = Math.abs(o - a.right), c = Math.min(l, u);
                        let h;
                        const p = e / r * (n + 1);
                        if (a.isDash) {
                            const t1 = n - Math.abs(p);
                            h = Math.sqrt(c * c + t1 * t1);
                        } else h = n - Math.sqrt(c * c + p * p);
                        this.image.data[i + o] = Math.max(0, Math.min(255, h + 128));
                    }
                }
            }
            addRegularDash(t1, e) {
                for(let e = t1.length - 1; e >= 0; --e){
                    const r = t1[e], n = t1[e + 1];
                    r.zeroLength ? t1.splice(e, 1) : n && n.isDash === r.isDash && (n.left = r.left, t1.splice(e, 1));
                }
                const r = t1[0], n = t1[t1.length - 1];
                r.isDash === n.isDash && (r.left = n.left - this.width, n.right = r.right + this.width);
                const i = this.width * this.nextRow;
                let s = 0, a = t1[s];
                for(let r = 0; r < this.width; r++){
                    r / a.right > 1 && (a = t1[++s]);
                    const n = Math.abs(r - a.left), o = Math.abs(r - a.right), l = Math.min(n, o);
                    this.image.data[i + r] = Math.max(0, Math.min(255, (a.isDash ? l : -l) + e + 128));
                }
            }
            addDash(t1, e) {
                const r = this.getKey(t1, e);
                if (this.positions[r]) return this.positions[r];
                const n = "round" === e, i = n ? 7 : 0, s = 2 * i + 1;
                if (this.nextRow + s > this.height) return ft("LineAtlas out of space"), null;
                0 === t1.length && t1.push(1);
                let a = 0;
                for(let e = 0; e < t1.length; e++)t1[e] < 0 && (ft("Negative value is found in line dasharray, replacing values with 0"), t1[e] = 0), a += t1[e];
                if (0 !== a) {
                    const r = this.width / a, s = this.getDashRanges(t1, this.width, r);
                    n ? this.addRoundDash(s, r, i) : this.addRegularDash(s, "square" === e ? .5 * r : 0);
                }
                const o = this.nextRow + i;
                this.nextRow += s;
                const l = {
                    tl: [
                        o,
                        i
                    ],
                    br: [
                        a,
                        0
                    ]
                };
                return this.positions[r] = l, l;
            }
        }
        os(gp, "LineAtlas");
        const xp = ch.VectorTileFeature.types, bp = Math.cos(Math.PI / 180 * 37.5), vp = Math.cos(Math.PI / 180 * 5);
        class wp {
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.projection = t1.projection, this.hasPattern = !1, this.hasZOffset = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t1)=>{
                    this.gradients[t1.id] = {};
                }), this.layoutVertexArray = new _a, this.layoutVertexArray2 = new Ma, this.patternVertexArray = new Aa, this.indexArray = new Da, this.programConfigurations = new Fo(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }), this.segments = new co, this.maxLineLength = 0, this.zOffsetVertexArray = new Oa, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.tessellationStep = t1.tessellationStep ? t1.tessellationStep : Hr / 64;
            }
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                this.hasPattern = Dc("line", this.layers, e);
                const i = this.layers[0].layout.get("line-sort-key"), s = this.layers[0].layout.get("line-z-offset");
                this.hasZOffset = !s.isConstant() || !!s.constantOr(0);
                const a = [];
                for (const { feature: e, id: s, index: o, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = Pl(e, t1);
                    if (!this.layers[0]._featureFilter.filter(new Vs(this.zoom), u, r)) continue;
                    const c = i ? i.evaluate(u, {}, r) : void 0, h = {
                        id: s,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t1 ? u.geometry : Il(e, r, n),
                        patterns: {},
                        sortKey: c
                    };
                    a.push(h);
                }
                i && a.sort((t1, e)=>t1.sortKey - e.sortKey);
                const { lineAtlas: o, featureIndex: l } = e, u = this.addConstantDashes(o);
                for (const n of a){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n;
                    if (u && this.addFeatureDashes(n, o), this.hasPattern) {
                        const t1 = Lc("line", this.layers, n, this.zoom, e);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, s, r, o.positions, e.availableImages, e.brightness);
                    l.insert(t1[s].feature, i, s, a, this.index);
                }
            }
            addConstantDashes(t1) {
                let e = !1;
                for (const r of this.layers){
                    const n = r.paint.get("line-dasharray").value, i = r.layout.get("line-cap").value;
                    if ("constant" !== n.kind || "constant" !== i.kind) e = !0;
                    else {
                        const e = i.value, r = n.value;
                        if (!r) continue;
                        t1.addDash(r, e);
                    }
                }
                return e;
            }
            addFeatureDashes(t1, e) {
                const r = this.zoom;
                for (const n of this.layers){
                    const i = n.paint.get("line-dasharray").value, s = n.layout.get("line-cap").value;
                    if ("constant" === i.kind && "constant" === s.kind) continue;
                    let a, o;
                    if ("constant" === i.kind) {
                        if (a = i.value, !a) continue;
                    } else a = i.evaluate({
                        zoom: r
                    }, t1);
                    o = "constant" === s.kind ? s.value : s.evaluate({
                        zoom: r
                    }, t1), e.addDash(a, o), t1.patterns[n.id] = e.getKey(a, o);
                }
            }
            update(t1, e, r, n, i) {
                const s = 0 !== Object.keys(t1).length;
                s && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(t1, e, s ? this.stateDependentLayers : this.layers, r, n, i);
            }
            addFeatures(t1, e, r, n, i, s) {
                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e, r, n, s);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t1.createVertexBuffer(this.layoutVertexArray2, dp)), 0 !== this.patternVertexArray.length && (this.patternVertexBuffer = t1.createVertexBuffer(this.patternVertexArray, yp)), !this.zOffsetVertexBuffer && this.zOffsetVertexArray.length > 0 && (this.zOffsetVertexBuffer = t1.createVertexBuffer(this.zOffsetVertexArray, hp.members, !0)), this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, pp), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t1) {
                if (t1.properties && t1.properties.hasOwnProperty("mapbox_clip_start") && t1.properties.hasOwnProperty("mapbox_clip_end")) return {
                    start: +t1.properties.mapbox_clip_start,
                    end: +t1.properties.mapbox_clip_end
                };
            }
            addFeature(t1, e, r, n, i, s, a) {
                const o = this.layers[0].layout, l = o.get("line-join").evaluate(t1, {}), u = o.get("line-cap").evaluate(t1, {}), c = o.get("line-miter-limit"), h = o.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(t1);
                for (const r of e)this.addLine(r, t1, n, l, u, c, h);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, s, n, a);
            }
            addLine(t1, e, r, n, i, s, a) {
                this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineSoFar = 0, this.currentVertex = void 0;
                const o = {
                    zoom: this.zoom,
                    lineProgress: void 0
                }, l = this.layers[0].layout, u = "none" === n;
                if (this.patternJoinNone = this.hasPattern && u, this.segmentStart = 0, this.segmentStartf32 = 0, this.segmentPoints = [], this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let e = 0; e < t1.length - 1; e++)this.totalDistance += t1[e].dist(t1[e + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const c = "Polygon" === xp[e.type];
                let h = t1.length;
                for(; h >= 2 && t1[h - 1].equals(t1[h - 2]);)h--;
                let p = 0;
                for(; p < h - 1 && t1[p].equals(t1[p + 1]);)p++;
                if (h < (c ? 3 : 2)) return;
                "bevel" === n && (s = 1.05);
                const f = this.overscaling <= 16 ? 15 * Hr / (512 * this.overscaling) : 0, d = this.segments.prepareSegment(10 * h, this.layoutVertexArray, this.indexArray);
                let m, y, g, x, b, v;
                this.e1 = this.e2 = -1, c && (m = t1[h - 2], b = t1[p].sub(m)._unit()._perp());
                for(let r = p; r < h; r++){
                    if (g = r === h - 1 ? c ? t1[p + 1] : void 0 : t1[r + 1], g && t1[r].equals(g)) continue;
                    if (b && (x = b), m && (y = m), m = t1[r], this.hasZOffset) {
                        const t1 = l.get("line-z-offset").value;
                        if ("constant" === t1.kind) v = t1.value;
                        else {
                            if (this.lineClips) {
                                const t1 = this.totalDistance / (this.lineClips.end - this.lineClips.start);
                                o.lineProgress = (t1 * this.lineClips.start + this.distance + (y ? y.dist(m) : 0)) / t1;
                            } else ft(`line-z-offset evaluation for ${this.layerIds[0]} requires enabling 'lineMetrics' for the source.`), o.lineProgress = 0;
                            v = t1.evaluate(o, e);
                        }
                        v = v || 0;
                    }
                    b = g ? g.sub(m)._unit()._perp() : x, x = x || b;
                    const w = y && g;
                    let _ = w ? n : c || u ? "butt" : i;
                    const M = x.x * b.x + x.y * b.y;
                    if (u) {
                        const t1 = function(t1) {
                            if (t1.patternJoinNone) {
                                const e = t1.segmentPoints.length / 2, r = t1.lineSoFar - t1.segmentStart;
                                for(let n = 0; n < e; ++n){
                                    const e = t1.segmentPoints[2 * n + 1], i = Math.round(t1.segmentPoints[2 * n]) + .5 + .25 * e;
                                    t1.patternVertexArray.emplaceBack(i, r, t1.segmentStart), t1.patternVertexArray.emplaceBack(i, r, t1.segmentStart);
                                }
                                t1.segmentPoints.length = 0;
                            }
                            t1.e1 = t1.e2 = -1;
                        };
                        if (w && M < vp) {
                            this.updateDistance(y, m), this.addCurrentVertex(m, x, 1, 1, d, v), t1(this), this.addCurrentVertex(m, b, -1, -1, d, v);
                            continue;
                        }
                        if (y) {
                            if (!g) {
                                this.updateDistance(y, m), this.addCurrentVertex(m, x, 1, 1, d, v), t1(this);
                                continue;
                            }
                            _ = "miter";
                        }
                    }
                    let A = x.add(b);
                    0 === A.x && 0 === A.y || A._unit();
                    const S = A.x * b.x + A.y * b.y, I = 0 !== S ? 1 / S : 1 / 0, P = 2 * Math.sqrt(2 - 2 * S), z = S < bp && y && g, k = x.x * b.y - x.y * b.x > 0;
                    if (z && r > p) {
                        const t1 = m.dist(y);
                        if (t1 > 2 * f) {
                            const e = m.sub(m.sub(y)._mult(f / t1)._round());
                            this.updateDistance(y, e), this.addCurrentVertex(e, x, 0, 0, d, v), y = e;
                        }
                    }
                    if (w && "round" === _ && (I < a ? _ = "miter" : I <= 2 && (_ = "fakeround")), "miter" === _ && I > s && (_ = "bevel"), "bevel" === _ && (I > 2 && (_ = "flipbevel"), I < s && (_ = "miter")), y && this.updateDistance(y, m), "miter" === _) A._mult(I), this.addCurrentVertex(m, A, 0, 0, d, v);
                    else if ("flipbevel" === _) {
                        if (I > 100) A = b.mult(-1);
                        else {
                            const t1 = I * x.add(b).mag() / x.sub(b).mag();
                            A._perp()._mult(t1 * (k ? -1 : 1));
                        }
                        this.addCurrentVertex(m, A, 0, 0, d, v), this.addCurrentVertex(m, A.mult(-1), 0, 0, d, v);
                    } else if ("bevel" === _ || "fakeround" === _) {
                        const t1 = -Math.sqrt(I * I - 1), e = k ? t1 : 0, r = k ? 0 : t1;
                        if (y && this.addCurrentVertex(m, x, e, r, d, v), "fakeround" === _) {
                            const t1 = Math.round(180 * P / Math.PI / 20);
                            for(let e = 1; e < t1; e++){
                                let r = e / t1;
                                if (.5 !== r) {
                                    const t1 = r - .5;
                                    r += r * t1 * (r - 1) * ((1.0904 + M * (M * (3.55645 - 1.43519 * M) - 3.2452)) * t1 * t1 + (.848013 + M * (.215638 * M - 1.06021)));
                                }
                                const n = b.sub(x)._mult(r)._add(x)._unit()._mult(k ? -1 : 1);
                                this.addHalfVertex(m, n.x, n.y, !1, k, 0, d, v);
                            }
                        }
                        g && this.addCurrentVertex(m, b, -e, -r, d, v);
                    } else "butt" === _ ? this.addCurrentVertex(m, A, 0, 0, d, v) : "square" === _ ? (y || this.addCurrentVertex(m, A, -1, -1, d, v), this.addCurrentVertex(m, A, 0, 0, d, v), y && this.addCurrentVertex(m, A, 1, 1, d, v)) : "round" === _ && (y && (this.addCurrentVertex(m, x, 0, 0, d, v), this.addCurrentVertex(m, x, 1, 1, d, v, !0)), g && (this.addCurrentVertex(m, b, -1, -1, d, v, !0), this.addCurrentVertex(m, b, 0, 0, d, v)));
                    if (z && r < h - 1) {
                        const t1 = m.dist(g);
                        if (t1 > 2 * f) {
                            const e = m.add(g.sub(m)._mult(f / t1)._round());
                            this.updateDistance(m, e), this.addCurrentVertex(e, b, 0, 0, d, v), m = e;
                        }
                    }
                }
            }
            addVerticesTo(t1, e, r, n, i, s, a, o, l, u) {
                const c = (e.w - t1.w) / this.tessellationStep | 0;
                if (c > 1) {
                    this.lineSoFar = t1.w;
                    const h = (e.x - t1.x) / c, p = (e.y - t1.y) / c, f = (e.z - t1.z) / c, d = (e.w - t1.w) / c;
                    for(let e = 1; e < c; ++e)t1.x += h, t1.y += p, t1.z += f, this.lineSoFar += d, this.addHalfVertex(t1, r, n, u, !1, a, l, t1.z), this.addHalfVertex(t1, i, s, u, !0, -o, l, t1.z);
                }
                this.lineSoFar = e.w, this.addHalfVertex(e, r, n, u, !1, a, l, e.z), this.addHalfVertex(e, i, s, u, !0, -o, l, e.z);
            }
            addCurrentVertex(t1, e, r, n, i, s, a = !1) {
                const o = e.x + e.y * r, l = e.y - e.x * r, u = e.y * n - e.x, c = -e.y - e.x * n;
                if (null != s) {
                    const e = -10, h = Hr + 10, p = s, f = new ph(t1.x, t1.y, p, this.lineSoFar), d = _p(t1, e, h), m = this.lineSoFar;
                    if (this.currentVertex) {
                        if (d) {
                            const s = this.currentVertexIsOutside, f = this.currentVertex, d = new ph(t1.x, t1.y, p, this.lineSoFar);
                            mh(f, d, e, h), _p(d, e, h) || (s && (this.e1 = this.e2 = -1, this.lineSoFar = f.w, this.addHalfVertex(f, o, l, a, !1, r, i, f.z), this.addHalfVertex(f, u, c, a, !0, -n, i, f.z)), this.addVerticesTo(f, d, o, l, u, c, r, n, i, a));
                        } else {
                            const t1 = this.currentVertex;
                            this.currentVertexIsOutside && (mh(t1, f, e, h), this.e1 = this.e2 = -1, this.lineSoFar = t1.w, this.addHalfVertex(t1, o, l, a, !1, r, i, t1.z), this.addHalfVertex(t1, u, c, a, !0, -n, i, t1.z)), this.addVerticesTo(t1, f, o, l, u, c, r, n, i, a);
                        }
                    } else d || (this.addHalfVertex(t1, o, l, a, !1, r, i, s), this.addHalfVertex(t1, u, c, a, !0, -n, i, s));
                    this.currentVertex = f, this.currentVertexIsOutside = d, this.lineSoFar = m;
                } else this.addHalfVertex(t1, o, l, a, !1, r, i, s), this.addHalfVertex(t1, u, c, a, !0, -n, i, s);
            }
            addHalfVertex({ x: t1, y: e }, r, n, i, s, a, o, l) {
                this.patternJoinNone && (0 === this.segmentPoints.length && (this.segmentStart = this.lineSoFar, this.segmentStartf32 = Math.fround(this.lineSoFar)), s || this.segmentPoints.push(this.lineSoFar - this.segmentStart, a)), this.layoutVertexArray.emplaceBack((t1 << 1) + (i ? 1 : 0), (e << 1) + (s ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1), 0, this.lineSoFar - this.segmentStartf32), this.lineClips && this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, this.lineClips.start, this.lineClips.end);
                const u = o.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), s ? this.e2 = u : this.e1 = u, null != l && this.zOffsetVertexArray.emplaceBack(l);
            }
            updateScaledDistance() {
                if (this.lineClips) {
                    const t1 = this.totalDistance / (this.lineClips.end - this.lineClips.start);
                    this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = t1 * this.lineClips.start + this.distance;
                } else this.lineSoFar = this.distance;
            }
            updateDistance(t1, e) {
                this.distance += t1.dist(e), this.updateScaledDistance();
            }
        }
        function _p(t1, e, r) {
            return t1.x < e || t1.x > r || t1.y < e || t1.y > r;
        }
        let Mp, Ap;
        function Sp(t1, e, r) {
            return e * (Hr / (t1.tileSize * Math.pow(2, r - t1.tileID.overscaledZ)));
        }
        function Ip(t1, e) {
            return 1 / Sp(t1, 1, e.tileZoom);
        }
        function Pp(t1, e, r, n) {
            return t1.translatePosMatrix(n || e.tileID.projMatrix, e, r.paint.get("line-translate"), r.paint.get("line-translate-anchor"));
        }
        os(wp, "LineBucket", {
            omit: [
                "layers",
                "patternFeatures",
                "currentVertex",
                "currentVertexIsOutside"
            ]
        });
        const zp = (t1)=>{
            const e = [];
            kp(t1) && e.push("RENDER_LINE_DASH"), t1.paint.get("line-gradient") && e.push("RENDER_LINE_GRADIENT");
            const r = t1.paint.get("line-trim-offset");
            0 === r[0] && 0 === r[1] || e.push("RENDER_LINE_TRIM_OFFSET"), 0 !== t1.paint.get("line-border-width").constantOr(1) && e.push("RENDER_LINE_BORDER");
            const n = "none" === t1.layout.get("line-join").constantOr("miter"), i = !!t1.paint.get("line-pattern").constantOr(1);
            return n && i && e.push("LINE_JOIN_NONE"), e;
        };
        function kp(t1) {
            const e = t1.paint.get("line-dasharray").value;
            return e.value || "constant" !== e.kind;
        }
        let Tp;
        const Ep = ()=>Tp || (Tp = {
                layout: Mp || (Mp = new Gs({
                    "line-cap": new qs(Xs.layout_line["line-cap"]),
                    "line-join": new qs(Xs.layout_line["line-join"]),
                    "line-miter-limit": new Ns(Xs.layout_line["line-miter-limit"]),
                    "line-round-limit": new Ns(Xs.layout_line["line-round-limit"]),
                    "line-sort-key": new qs(Xs.layout_line["line-sort-key"]),
                    "line-z-offset": new qs(Xs.layout_line["line-z-offset"]),
                    visibility: new Ns(Xs.layout_line.visibility)
                })),
                paint: Ap || (Ap = new Gs({
                    "line-opacity": new qs(Xs.paint_line["line-opacity"]),
                    "line-color": new qs(Xs.paint_line["line-color"]),
                    "line-translate": new Ns(Xs.paint_line["line-translate"]),
                    "line-translate-anchor": new Ns(Xs.paint_line["line-translate-anchor"]),
                    "line-width": new qs(Xs.paint_line["line-width"]),
                    "line-gap-width": new qs(Xs.paint_line["line-gap-width"]),
                    "line-offset": new qs(Xs.paint_line["line-offset"]),
                    "line-blur": new qs(Xs.paint_line["line-blur"]),
                    "line-dasharray": new qs(Xs.paint_line["line-dasharray"]),
                    "line-pattern": new qs(Xs.paint_line["line-pattern"]),
                    "line-gradient": new $s(Xs.paint_line["line-gradient"]),
                    "line-trim-offset": new Ns(Xs.paint_line["line-trim-offset"]),
                    "line-trim-fade-range": new Ns(Xs.paint_line["line-trim-fade-range"]),
                    "line-trim-color": new Ns(Xs.paint_line["line-trim-color"]),
                    "line-emissive-strength": new Ns(Xs.paint_line["line-emissive-strength"]),
                    "line-border-width": new qs(Xs.paint_line["line-border-width"]),
                    "line-border-color": new qs(Xs.paint_line["line-border-color"]),
                    "line-occlusion-opacity": new Ns(Xs.paint_line["line-occlusion-opacity"])
                }))
            }, Tp);
        class Bp extends qs {
            possiblyEvaluate(t1, e) {
                return e = new Vs(Math.floor(e.zoom), {
                    now: e.now,
                    fadeDuration: e.fadeDuration,
                    transition: e.transition
                }), super.possiblyEvaluate(t1, e);
            }
            evaluate(t1, e, r, n) {
                return e = nt({}, e, {
                    zoom: Math.floor(e.zoom)
                }), super.evaluate(t1, e, r, n);
            }
        }
        let Vp;
        function Cp(t1, e) {
            return e > 0 ? e + 2 * t1 : t1;
        }
        const Rp = ya([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_tex_size",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), Dp = ya([
            {
                name: "a_globe_anchor",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_globe_normal",
                components: 3,
                type: "Float32"
            }
        ], 4), Lp = ya([
            {
                name: "a_projected_pos",
                components: 4,
                type: "Float32"
            }
        ], 4);
        ya([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const Fp = ya([
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), Op = ya([
            {
                name: "a_texb",
                components: 2,
                type: "Uint16"
            }
        ]), Up = ya([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_elevation_from_sea",
                components: 2,
                type: "Float32"
            }
        ]), jp = ya([
            {
                name: "a_size_scale",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_padding",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ]);
        ya([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "tileAnchorX"
            },
            {
                type: "Int16",
                name: "tileAnchorY"
            },
            {
                type: "Float32",
                name: "x1"
            },
            {
                type: "Float32",
                name: "y1"
            },
            {
                type: "Float32",
                name: "x2"
            },
            {
                type: "Float32",
                name: "y2"
            },
            {
                type: "Int16",
                name: "padding"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const Np = ya([
            {
                name: "a_pos",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), qp = ya([
            {
                name: "a_pos_2f",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        ya([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), ya([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            },
            {
                type: "Uint8",
                name: "flipState"
            }
        ]), ya([
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Float32",
                name: "zOffset"
            },
            {
                type: "Uint8",
                name: "hasIconTextFit"
            }
        ]), ya([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), ya([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            }
        ]);
        var $p = 24;
        const Gp = 128;
        function Xp(t1, e) {
            const { expression: r } = e;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new Vs(t1 + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: e, interpolationType: n } = r;
                let i = 0;
                for(; i < e.length && e[i] <= t1;)i++;
                i = Math.max(0, i - 1);
                let s = i;
                for(; s < e.length && e[s] < t1 + 1;)s++;
                s = Math.min(e.length - 1, s);
                const a = e[i], o = e[s];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: a,
                    maxZoom: o,
                    interpolationType: n
                } : {
                    kind: "camera",
                    minZoom: a,
                    maxZoom: o,
                    minSize: r.evaluate(new Vs(a)),
                    maxSize: r.evaluate(new Vs(o)),
                    interpolationType: n
                };
            }
        }
        function Yp(t1, { uSize: e, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === t1.kind ? n / Gp : "composite" === t1.kind ? ke(n / Gp, i / Gp, r) : e;
        }
        function Zp(t1, e) {
            let r = 0, n = 0;
            if ("constant" === t1.kind) n = t1.layoutSize;
            else if ("source" !== t1.kind) {
                const { interpolationType: i, minZoom: s, maxZoom: a } = t1, o = i ? Q(si.interpolationFactor(i, e, s, a), 0, 1) : 0;
                "camera" === t1.kind ? n = ke(t1.minSize, t1.maxSize, o) : r = o;
            }
            return {
                uSizeT: r,
                uSize: n
            };
        }
        var Wp = Object.freeze({
            __proto__: null,
            SIZE_PACK_FACTOR: Gp,
            evaluateSizeForFeature: Yp,
            evaluateSizeForZoom: Zp,
            getSizeData: Xp
        });
        function Hp(t1, e, r) {
            return t1.sections.forEach((t1)=>{
                t1.text = function(t1, e, r) {
                    const n = e.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t1 = t1.toLocaleUpperCase() : "lowercase" === n && (t1 = t1.toLocaleLowerCase()), Bs.applyArabicShaping && (t1 = Bs.applyArabicShaping(t1)), t1;
                }(t1.text, e, r);
            }), t1;
        }
        const Kp = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42",
            "\u2190": "\u2191",
            "\u2192": "\u2193"
        };
        function Jp(t1) {
            return "\uFE36" === t1 || "\uFE48" === t1 || "\uFE38" === t1 || "\uFE44" === t1 || "\uFE42" === t1 || "\uFE3E" === t1 || "\uFE3C" === t1 || "\uFE3A" === t1 || "\uFE18" === t1 || "\uFE40" === t1 || "\uFE10" === t1 || "\uFE13" === t1 || "\uFE14" === t1 || "\uFF40" === t1 || "\uFFE3" === t1 || "\uFE11" === t1 || "\uFE12" === t1;
        }
        function Qp(t1) {
            return "\uFE35" === t1 || "\uFE47" === t1 || "\uFE37" === t1 || "\uFE43" === t1 || "\uFE41" === t1 || "\uFE3D" === t1 || "\uFE3B" === t1 || "\uFE39" === t1 || "\uFE17" === t1 || "\uFE3F" === t1;
        }
        var tf, ef, rf, nf = {};
        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ function sf() {
            return tf || (tf = 1, nf.read = function(t1, e, r, n, i) {
                var s, a, o = 8 * i - n - 1, l = (1 << o) - 1, u = l >> 1, c = -7, h = r ? i - 1 : 0, p = r ? -1 : 1, f = t1[e + h];
                for(h += p, s = f & (1 << -c) - 1, f >>= -c, c += o; c > 0; s = 256 * s + t1[e + h], h += p, c -= 8);
                for(a = s & (1 << -c) - 1, s >>= -c, c += n; c > 0; a = 256 * a + t1[e + h], h += p, c -= 8);
                if (0 === s) s = 1 - u;
                else {
                    if (s === l) return a ? NaN : 1 / 0 * (f ? -1 : 1);
                    a += Math.pow(2, n), s -= u;
                }
                return (f ? -1 : 1) * a * Math.pow(2, s - n);
            }, nf.write = function(t1, e, r, n, i, s) {
                var a, o, l, u = 8 * s - i - 1, c = (1 << u) - 1, h = c >> 1, p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : s - 1, d = n ? 1 : -1, m = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
                for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), (e += a + h >= 1 ? p / l : p * Math.pow(2, 1 - h)) * l >= 2 && (a++, l /= 2), a + h >= c ? (o = 0, a = c) : a + h >= 1 ? (o = (e * l - 1) * Math.pow(2, i), a += h) : (o = e * Math.pow(2, h - 1) * Math.pow(2, i), a = 0)); i >= 8; t1[r + f] = 255 & o, f += d, o /= 256, i -= 8);
                for(a = a << i | o, u += i; u > 0; t1[r + f] = 255 & a, f += d, a /= 256, u -= 8);
                t1[r + f - d] |= 128 * m;
            }), nf;
        }
        function af() {
            if (rf) return ef;
            rf = 1, ef = e;
            var t1 = sf();
            function e(t1) {
                this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t1) ? t1 : new Uint8Array(t1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
            }
            e.Varint = 0, e.Fixed64 = 1, e.Bytes = 2, e.Fixed32 = 5;
            var r = 4294967296, n = 1 / r, i = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
            function s(t1) {
                return t1.type === e.Bytes ? t1.readVarint() + t1.pos : t1.pos + 1;
            }
            function a(t1, e, r) {
                return r ? 4294967296 * e + (t1 >>> 0) : 4294967296 * (e >>> 0) + (t1 >>> 0);
            }
            function o(t1, e, r) {
                var n = e <= 16383 ? 1 : e <= 2097151 ? 2 : e <= 268435455 ? 3 : Math.floor(Math.log(e) / (7 * Math.LN2));
                r.realloc(n);
                for(var i = r.pos - 1; i >= t1; i--)r.buf[i + n] = r.buf[i];
            }
            function l(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeVarint(t1[r]);
            }
            function u(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeSVarint(t1[r]);
            }
            function c(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeFloat(t1[r]);
            }
            function h(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeDouble(t1[r]);
            }
            function p(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeBoolean(t1[r]);
            }
            function f(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeFixed32(t1[r]);
            }
            function d(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeSFixed32(t1[r]);
            }
            function m(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeFixed64(t1[r]);
            }
            function y(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeSFixed64(t1[r]);
            }
            function g(t1, e) {
                return (t1[e] | t1[e + 1] << 8 | t1[e + 2] << 16) + 16777216 * t1[e + 3];
            }
            function x(t1, e, r) {
                t1[r] = e, t1[r + 1] = e >>> 8, t1[r + 2] = e >>> 16, t1[r + 3] = e >>> 24;
            }
            function b(t1, e) {
                return (t1[e] | t1[e + 1] << 8 | t1[e + 2] << 16) + (t1[e + 3] << 24);
            }
            return e.prototype = {
                destroy: function() {
                    this.buf = null;
                },
                readFields: function(t1, e, r) {
                    for(r = r || this.length; this.pos < r;){
                        var n = this.readVarint(), i = n >> 3, s = this.pos;
                        this.type = 7 & n, t1(i, e, this), this.pos === s && this.skip(n);
                    }
                    return e;
                },
                readMessage: function(t1, e) {
                    return this.readFields(t1, e, this.readVarint() + this.pos);
                },
                readFixed32: function() {
                    var t1 = g(this.buf, this.pos);
                    return this.pos += 4, t1;
                },
                readSFixed32: function() {
                    var t1 = b(this.buf, this.pos);
                    return this.pos += 4, t1;
                },
                readFixed64: function() {
                    var t1 = g(this.buf, this.pos) + g(this.buf, this.pos + 4) * r;
                    return this.pos += 8, t1;
                },
                readSFixed64: function() {
                    var t1 = g(this.buf, this.pos) + b(this.buf, this.pos + 4) * r;
                    return this.pos += 8, t1;
                },
                readFloat: function() {
                    var e = t1.read(this.buf, this.pos, !0, 23, 4);
                    return this.pos += 4, e;
                },
                readDouble: function() {
                    var e = t1.read(this.buf, this.pos, !0, 52, 8);
                    return this.pos += 8, e;
                },
                readVarint: function(t1) {
                    var e, r, n = this.buf;
                    return e = 127 & (r = n[this.pos++]), r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e : function(t1, e, r) {
                        var n, i, s = r.buf;
                        if (n = (112 & (i = s[r.pos++])) >> 4, i < 128) return a(t1, n, e);
                        if (n |= (127 & (i = s[r.pos++])) << 3, i < 128) return a(t1, n, e);
                        if (n |= (127 & (i = s[r.pos++])) << 10, i < 128) return a(t1, n, e);
                        if (n |= (127 & (i = s[r.pos++])) << 17, i < 128) return a(t1, n, e);
                        if (n |= (127 & (i = s[r.pos++])) << 24, i < 128) return a(t1, n, e);
                        if (n |= (1 & (i = s[r.pos++])) << 31, i < 128) return a(t1, n, e);
                        throw new Error("Expected varint not more than 10 bytes");
                    }(e |= (15 & (r = n[this.pos])) << 28, t1, this))));
                },
                readVarint64: function() {
                    return this.readVarint(!0);
                },
                readSVarint: function() {
                    var t1 = this.readVarint();
                    return t1 % 2 == 1 ? (t1 + 1) / -2 : t1 / 2;
                },
                readBoolean: function() {
                    return Boolean(this.readVarint());
                },
                readString: function() {
                    var t1 = this.readVarint() + this.pos, e = this.pos;
                    return this.pos = t1, t1 - e >= 12 && i ? function(t1, e, r) {
                        return i.decode(t1.subarray(e, r));
                    }(this.buf, e, t1) : function(t1, e, r) {
                        for(var n = "", i = e; i < r;){
                            var s, a, o, l = t1[i], u = null, c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                            if (i + c > r) break;
                            1 === c ? l < 128 && (u = l) : 2 === c ? 128 == (192 & (s = t1[i + 1])) && (u = (31 & l) << 6 | 63 & s) <= 127 && (u = null) : 3 === c ? (a = t1[i + 2], 128 == (192 & (s = t1[i + 1])) && 128 == (192 & a) && ((u = (15 & l) << 12 | (63 & s) << 6 | 63 & a) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === c && (a = t1[i + 2], o = t1[i + 3], 128 == (192 & (s = t1[i + 1])) && 128 == (192 & a) && 128 == (192 & o) && ((u = (15 & l) << 18 | (63 & s) << 12 | (63 & a) << 6 | 63 & o) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, c = 1) : u > 65535 && (u -= 65536, n += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n += String.fromCharCode(u), i += c;
                        }
                        return n;
                    }(this.buf, e, t1);
                },
                readBytes: function() {
                    var t1 = this.readVarint() + this.pos, e = this.buf.subarray(this.pos, t1);
                    return this.pos = t1, e;
                },
                readPackedVarint: function(t1, r) {
                    if (this.type !== e.Bytes) return t1.push(this.readVarint(r));
                    var n = s(this);
                    for(t1 = t1 || []; this.pos < n;)t1.push(this.readVarint(r));
                    return t1;
                },
                readPackedSVarint: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readSVarint());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readSVarint());
                    return t1;
                },
                readPackedBoolean: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readBoolean());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readBoolean());
                    return t1;
                },
                readPackedFloat: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readFloat());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readFloat());
                    return t1;
                },
                readPackedDouble: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readDouble());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readDouble());
                    return t1;
                },
                readPackedFixed32: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readFixed32());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readFixed32());
                    return t1;
                },
                readPackedSFixed32: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readSFixed32());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readSFixed32());
                    return t1;
                },
                readPackedFixed64: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readFixed64());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readFixed64());
                    return t1;
                },
                readPackedSFixed64: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readSFixed64());
                    var r = s(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readSFixed64());
                    return t1;
                },
                skip: function(t1) {
                    var r = 7 & t1;
                    if (r === e.Varint) for(; this.buf[this.pos++] > 127;);
                    else if (r === e.Bytes) this.pos = this.readVarint() + this.pos;
                    else if (r === e.Fixed32) this.pos += 4;
                    else {
                        if (r !== e.Fixed64) throw new Error("Unimplemented type: " + r);
                        this.pos += 8;
                    }
                },
                writeTag: function(t1, e) {
                    this.writeVarint(t1 << 3 | e);
                },
                realloc: function(t1) {
                    for(var e = this.length || 16; e < this.pos + t1;)e *= 2;
                    if (e !== this.length) {
                        var r = new Uint8Array(e);
                        r.set(this.buf), this.buf = r, this.length = e;
                    }
                },
                finish: function() {
                    return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                },
                writeFixed32: function(t1) {
                    this.realloc(4), x(this.buf, t1, this.pos), this.pos += 4;
                },
                writeSFixed32: function(t1) {
                    this.realloc(4), x(this.buf, t1, this.pos), this.pos += 4;
                },
                writeFixed64: function(t1) {
                    this.realloc(8), x(this.buf, -1 & t1, this.pos), x(this.buf, Math.floor(t1 * n), this.pos + 4), this.pos += 8;
                },
                writeSFixed64: function(t1) {
                    this.realloc(8), x(this.buf, -1 & t1, this.pos), x(this.buf, Math.floor(t1 * n), this.pos + 4), this.pos += 8;
                },
                writeVarint: function(t1) {
                    (t1 = +t1 || 0) > 268435455 || t1 < 0 ? function(t1, e) {
                        var r, n;
                        if (t1 >= 0 ? (r = t1 % 4294967296 | 0, n = t1 / 4294967296 | 0) : (n = ~(-t1 / 4294967296), 4294967295 ^ (r = ~(-t1 % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t1 >= 0x10000000000000000 || t1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                        e.realloc(10), function(t1, e, r) {
                            r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, r.buf[r.pos] = 127 & (t1 >>>= 7);
                        }(r, 0, e), function(t1, e) {
                            var r = (7 & t1) << 4;
                            e.buf[e.pos++] |= r | ((t1 >>>= 3) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1)))));
                        }(n, e);
                    }(t1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t1 | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = t1 >>> 7 & 127))));
                },
                writeSVarint: function(t1) {
                    this.writeVarint(t1 < 0 ? 2 * -t1 - 1 : 2 * t1);
                },
                writeBoolean: function(t1) {
                    this.writeVarint(Boolean(t1));
                },
                writeString: function(t1) {
                    t1 = String(t1), this.realloc(4 * t1.length), this.pos++;
                    var e = this.pos;
                    this.pos = function(t1, e, r) {
                        for(var n, i, s = 0; s < e.length; s++){
                            if ((n = e.charCodeAt(s)) > 55295 && n < 57344) {
                                if (!i) {
                                    n > 56319 || s + 1 === e.length ? (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189) : i = n;
                                    continue;
                                }
                                if (n < 56320) {
                                    t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = n;
                                    continue;
                                }
                                n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                            } else i && (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = null);
                            n < 128 ? t1[r++] = n : (n < 2048 ? t1[r++] = n >> 6 | 192 : (n < 65536 ? t1[r++] = n >> 12 | 224 : (t1[r++] = n >> 18 | 240, t1[r++] = n >> 12 & 63 | 128), t1[r++] = n >> 6 & 63 | 128), t1[r++] = 63 & n | 128);
                        }
                        return r;
                    }(this.buf, t1, this.pos);
                    var r = this.pos - e;
                    r >= 128 && o(e, r, this), this.pos = e - 1, this.writeVarint(r), this.pos += r;
                },
                writeFloat: function(e) {
                    this.realloc(4), t1.write(this.buf, e, this.pos, !0, 23, 4), this.pos += 4;
                },
                writeDouble: function(e) {
                    this.realloc(8), t1.write(this.buf, e, this.pos, !0, 52, 8), this.pos += 8;
                },
                writeBytes: function(t1) {
                    var e = t1.length;
                    this.writeVarint(e), this.realloc(e);
                    for(var r = 0; r < e; r++)this.buf[this.pos++] = t1[r];
                },
                writeRawMessage: function(t1, e) {
                    this.pos++;
                    var r = this.pos;
                    t1(e, this);
                    var n = this.pos - r;
                    n >= 128 && o(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
                },
                writeMessage: function(t1, r, n) {
                    this.writeTag(t1, e.Bytes), this.writeRawMessage(r, n);
                },
                writePackedVarint: function(t1, e) {
                    e.length && this.writeMessage(t1, l, e);
                },
                writePackedSVarint: function(t1, e) {
                    e.length && this.writeMessage(t1, u, e);
                },
                writePackedBoolean: function(t1, e) {
                    e.length && this.writeMessage(t1, p, e);
                },
                writePackedFloat: function(t1, e) {
                    e.length && this.writeMessage(t1, c, e);
                },
                writePackedDouble: function(t1, e) {
                    e.length && this.writeMessage(t1, h, e);
                },
                writePackedFixed32: function(t1, e) {
                    e.length && this.writeMessage(t1, f, e);
                },
                writePackedSFixed32: function(t1, e) {
                    e.length && this.writeMessage(t1, d, e);
                },
                writePackedFixed64: function(t1, e) {
                    e.length && this.writeMessage(t1, m, e);
                },
                writePackedSFixed64: function(t1, e) {
                    e.length && this.writeMessage(t1, y, e);
                },
                writeBytesField: function(t1, r) {
                    this.writeTag(t1, e.Bytes), this.writeBytes(r);
                },
                writeFixed32Field: function(t1, r) {
                    this.writeTag(t1, e.Fixed32), this.writeFixed32(r);
                },
                writeSFixed32Field: function(t1, r) {
                    this.writeTag(t1, e.Fixed32), this.writeSFixed32(r);
                },
                writeFixed64Field: function(t1, r) {
                    this.writeTag(t1, e.Fixed64), this.writeFixed64(r);
                },
                writeSFixed64Field: function(t1, r) {
                    this.writeTag(t1, e.Fixed64), this.writeSFixed64(r);
                },
                writeVarintField: function(t1, r) {
                    this.writeTag(t1, e.Varint), this.writeVarint(r);
                },
                writeSVarintField: function(t1, r) {
                    this.writeTag(t1, e.Varint), this.writeSVarint(r);
                },
                writeStringField: function(t1, r) {
                    this.writeTag(t1, e.Bytes), this.writeString(r);
                },
                writeFloatField: function(t1, r) {
                    this.writeTag(t1, e.Fixed32), this.writeFloat(r);
                },
                writeDoubleField: function(t1, r) {
                    this.writeTag(t1, e.Fixed64), this.writeDouble(r);
                },
                writeBooleanField: function(t1, e) {
                    this.writeVarintField(t1, Boolean(e));
                }
            }, ef;
        }
        var of = e(af());
        const lf = 3;
        function uf(t1, e, r) {
            e.glyphs = [], 1 === t1 && r.readMessage(cf, e);
        }
        function cf(t1, e, r) {
            if (3 === t1) {
                const { id: t1, bitmap: n, width: i, height: s, left: a, top: o, advance: l } = r.readMessage(hf, {});
                e.glyphs.push({
                    id: t1,
                    bitmap: new nc({
                        width: i + 2 * lf,
                        height: s + 2 * lf
                    }, n),
                    metrics: {
                        width: i,
                        height: s,
                        left: a,
                        top: o,
                        advance: l
                    }
                });
            } else 4 === t1 ? e.ascender = r.readSVarint() : 5 === t1 && (e.descender = r.readSVarint());
        }
        function hf(t1, e, r) {
            1 === t1 ? e.id = r.readVarint() : 2 === t1 ? e.bitmap = r.readBytes() : 3 === t1 ? e.width = r.readVarint() : 4 === t1 ? e.height = r.readVarint() : 5 === t1 ? e.left = r.readSVarint() : 6 === t1 ? e.top = r.readSVarint() : 7 === t1 && (e.advance = r.readVarint());
        }
        const pf = lf, ff = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        };
        class df {
            constructor(){
                this.scale = 1, this.fontStack = "", this.imageName = null;
            }
            static forText(t1, e) {
                const r = new df;
                return r.scale = t1 || 1, r.fontStack = e, r;
            }
            static forImage(t1) {
                const e = new df;
                return e.imageName = t1, e;
            }
        }
        class mf {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(t1, e) {
                const r = new mf;
                for(let n = 0; n < t1.sections.length; n++){
                    const i = t1.sections[n];
                    i.image ? r.addImageSection(i) : r.addTextSection(i, e);
                }
                return r;
            }
            length() {
                return this.text.length;
            }
            getSection(t1) {
                return this.sections[this.sectionIndex[t1]];
            }
            getSections() {
                return this.sections;
            }
            getSectionIndex(t1) {
                return this.sectionIndex[t1];
            }
            getCodePoint(t1) {
                return this.text.codePointAt(t1);
            }
            verticalizePunctuation(t1) {
                this.text = function(t1, e) {
                    let r = "";
                    for(let n = 0; n < t1.length; n++){
                        const i = t1.charCodeAt(n + 1) || null, s = t1.charCodeAt(n - 1) || null;
                        r += !e && (i && gs(i) && !Kp[t1[n + 1]] || s && gs(s) && !Kp[t1[n - 1]]) || !Kp[t1[n]] ? t1[n] : Kp[t1[n]];
                    }
                    return r;
                }(this.text, t1);
            }
            trim() {
                let t1 = 0;
                for(let e = 0; e < this.text.length && gf[this.text.charCodeAt(e)]; e++)t1++;
                let e = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= t1 && gf[this.text.charCodeAt(r)]; r--)e--;
                this.text = this.text.substring(t1, e), this.sectionIndex = this.sectionIndex.slice(t1, e);
            }
            substring(t1, e) {
                const r = new mf;
                return r.text = this.text.substring(t1, e), r.sectionIndex = this.sectionIndex.slice(t1, e), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((t1, e)=>Math.max(t1, this.sections[e].scale), 0);
            }
            addTextSection(t1, e) {
                this.text += t1.text, this.sections.push(df.forText(t1.scale, t1.fontStack || e));
                const r = this.sections.length - 1;
                for(let e = 0; e < t1.text.length; ++e)this.sectionIndex.push(r);
            }
            addImageSection(t1) {
                const e = t1.image ? t1.image.namePrimary : "";
                if (0 === e.length) return void ft("Can't add FormattedSection with an empty image.");
                const r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCodePoint(r), this.sections.push(df.forImage(e)), this.sectionIndex.push(this.sections.length - 1)) : ft("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function yf(t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d) {
            const m = mf.fromFeature(t1, i);
            h === ff.vertical && m.verticalizePunctuation(p);
            let y = [];
            const g = function(t1, e, r, n, i, s) {
                if (!t1) return [];
                const a = [], o = function(t1, e, r, n, i, s) {
                    let a = 0;
                    for(let r = 0; r < t1.length(); r++){
                        const o = t1.getSection(r);
                        a += bf(t1.getCodePoint(r), o, n, i, e, s);
                    }
                    return a / Math.max(1, Math.ceil(a / r));
                }(t1, e, r, n, i, s), l = t1.text.indexOf("\u200B") >= 0;
                let u = 0;
                for(let r = 0; r < t1.length(); r++){
                    const h = t1.getSection(r), p = t1.getCodePoint(r);
                    if (gf[p] || (u += bf(p, h, n, i, e, s)), r < t1.length() - 1) {
                        const e = !((c = p) < 11904 || !(ps["Bopomofo Extended"](c) || ps.Bopomofo(c) || ps["CJK Compatibility Forms"](c) || ps["CJK Compatibility Ideographs"](c) || ps["CJK Compatibility"](c) || ps["CJK Radicals Supplement"](c) || ps["CJK Strokes"](c) || ps["CJK Symbols and Punctuation"](c) || ps["CJK Unified Ideographs Extension A"](c) || ps["CJK Unified Ideographs"](c) || ps["Enclosed CJK Letters and Months"](c) || ps["Halfwidth and Fullwidth Forms"](c) || ps.Hiragana(c) || ps["Ideographic Description Characters"](c) || ps["Kangxi Radicals"](c) || ps["Katakana Phonetic Extensions"](c) || ps.Katakana(c) || ps["Vertical Forms"](c) || ps["Yi Radicals"](c) || ps["Yi Syllables"](c)));
                        (xf[p] || e || h.imageName) && a.push(_f(r + 1, u, o, a, wf(p, t1.getCodePoint(r + 1), e && l), !1));
                    }
                }
                var c;
                return Mf(_f(t1.length(), u, o, a, 0, !0));
            }(m, u, s, e, n, f), { processBidirectionalText: x, processStyledBidirectionalText: b } = Bs;
            if (x && 1 === m.sections.length) {
                const t1 = x(m.toString(), g);
                for (const e of t1){
                    const t1 = new mf;
                    t1.text = e, t1.sections = m.sections;
                    for(let r = 0; r < e.length; r++)t1.sectionIndex.push(0);
                    y.push(t1);
                }
            } else if (b) {
                const t1 = b(m.text, m.sectionIndex, g);
                for (const e of t1){
                    const t1 = new mf;
                    t1.text = e[0], t1.sectionIndex = e[1], t1.sections = m.sections, y.push(t1);
                }
            } else y = function(t1, e) {
                const r = [], n = t1.text;
                let i = 0;
                for (const n of e)r.push(t1.substring(i, n)), i = n;
                return i < n.length && r.push(t1.substring(i, n.length)), r;
            }(m, g);
            const v = [], w = {
                positionedLines: v,
                text: m.toString(),
                top: c[1],
                bottom: c[1],
                left: c[0],
                right: c[0],
                writingMode: h,
                iconsInText: !1,
                verticalizable: !1,
                hasBaseline: !1
            };
            return function(t1, e, r, n, i, s, a, o, l, u, c, h) {
                let p = 0, f = 0, d = 0;
                const m = "right" === o ? 1 : "left" === o ? 0 : .5;
                let y = !1;
                for (const t1 of i){
                    const r = t1.getSections();
                    for (const t1 of r){
                        if (t1.imageName) continue;
                        const r = e[t1.fontStack];
                        if (r && (y = void 0 !== r.ascender && void 0 !== r.descender, !y)) break;
                    }
                    if (!y) break;
                }
                let g = 0;
                for (const a of i){
                    a.trim();
                    const i = a.getMaxScale(), o = (i - 1) * $p, b = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    t1.positionedLines[g] = b;
                    const v = b.positionedGlyphs;
                    let w = 0;
                    if (!a.length()) {
                        f += s, ++g;
                        continue;
                    }
                    let _ = 0, M = 0;
                    for(let s = 0; s < a.length(); s++){
                        const o = a.getSection(s), d = a.getSectionIndex(s), m = a.getCodePoint(s);
                        let g = o.scale, b = null, A = null, S = null, I = $p, P = 0;
                        const z = !(l === ff.horizontal || !c && !ys(m) || c && (gf[m] || (x = m, ps.Arabic(x) || ps["Arabic Supplement"](x) || ps["Arabic Extended-A"](x) || ps["Arabic Presentation Forms-A"](x) || ps["Arabic Presentation Forms-B"](x))));
                        if (o.imageName) {
                            const e = n[o.imageName];
                            if (!e) continue;
                            S = o.imageName, t1.iconsInText = t1.iconsInText || !0, A = e.paddedRect;
                            const r = e.displaySize;
                            g = g * $p / h, b = {
                                width: r[0],
                                height: r[1],
                                left: 0,
                                top: -pf,
                                advance: z ? r[1] : r[0],
                                localGlyph: !1
                            }, P = y ? -b.height * g : i * $p - 17 - r[1] * g, I = b.advance;
                            const s = (z ? r[0] : r[1]) * g - $p * i;
                            s > 0 && s > w && (w = s);
                        } else {
                            const t1 = r[o.fontStack];
                            if (!t1) continue;
                            t1[m] && (A = t1[m]);
                            const n = e[o.fontStack];
                            if (!n) continue;
                            const s = n.glyphs[m];
                            if (!s) continue;
                            if (b = s.metrics, I = 8203 !== m ? $p : 0, y) {
                                const t1 = void 0 !== n.ascender ? Math.abs(n.ascender) : 0, e = void 0 !== n.descender ? Math.abs(n.descender) : 0, r = (t1 + e) * g;
                                _ < r && (_ = r, M = (t1 - e) / 2 * g), P = -t1 * g;
                            } else P = (i - g) * $p - 17;
                        }
                        z ? (t1.verticalizable = !0, v.push({
                            glyph: m,
                            imageName: S,
                            x: p,
                            y: f + P,
                            vertical: z,
                            scale: g,
                            localGlyph: b.localGlyph,
                            fontStack: o.fontStack,
                            sectionIndex: d,
                            metrics: b,
                            rect: A
                        }), p += I * g + u) : (v.push({
                            glyph: m,
                            imageName: S,
                            x: p,
                            y: f + P,
                            vertical: z,
                            scale: g,
                            localGlyph: b.localGlyph,
                            fontStack: o.fontStack,
                            sectionIndex: d,
                            metrics: b,
                            rect: A
                        }), p += b.advance * g + u);
                    }
                    0 !== v.length && (d = Math.max(p - u, d), y ? Sf(v, m, w, M, s * i / 2) : Sf(v, m, w, 0, s / 2)), p = 0;
                    const A = s * i + w;
                    b.lineOffset = Math.max(w, o), f += A, ++g;
                }
                var x;
                const b = f, { horizontalAlign: v, verticalAlign: w } = Af(a);
                (function(t1, e, r, n, i, s) {
                    const a = (e - r) * i, o = -s * n;
                    for (const e of t1)for (const t1 of e.positionedGlyphs)t1.x += a, t1.y += o;
                })(t1.positionedLines, m, v, w, d, b), t1.top += -w * b, t1.bottom = t1.top + b, t1.left += -v * d, t1.right = t1.left + d, t1.hasBaseline = y;
            }(w, e, r, n, y, a, o, l, h, u, p, d), !function(t1) {
                for (const e of t1)if (0 !== e.positionedGlyphs.length) return !1;
                return !0;
            }(v) && w;
        }
        const gf = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, xf = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function bf(t1, e, r, n, i, s) {
            if (e.imageName) {
                const t1 = n[e.imageName];
                return t1 ? t1.displaySize[0] * e.scale * $p / s + i : 0;
            }
            {
                const n = r[e.fontStack], s = n && n.glyphs[t1];
                return s ? s.metrics.advance * e.scale + i : 0;
            }
        }
        function vf(t1, e, r, n) {
            const i = Math.pow(t1 - e, 2);
            return n ? t1 < e ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function wf(t1, e, r) {
            let n = 0;
            return 10 === t1 && (n -= 1e4), r && (n += 150), 40 !== t1 && 65288 !== t1 || (n += 50), 41 !== e && 65289 !== e || (n += 50), n;
        }
        function _f(t1, e, r, n, i, s) {
            let a = null, o = vf(e, r, i, s);
            for (const t1 of n){
                const n = vf(e - t1.x, r, i, s) + t1.badness;
                n <= o && (a = t1, o = n);
            }
            return {
                index: t1,
                x: e,
                priorBreak: a,
                badness: o
            };
        }
        function Mf(t1) {
            return t1 ? Mf(t1.priorBreak).concat(t1.index) : [];
        }
        function Af(t1) {
            let e = .5, r = .5;
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    e = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e = 0;
            }
            switch(t1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e,
                verticalAlign: r
            };
        }
        function Sf(t1, e, r, n, i) {
            if (!(e || r || n || i)) return;
            const s = t1.length - 1, a = t1[s], o = (a.x + a.metrics.advance * a.scale) * e;
            for(let e = 0; e <= s; e++)t1[e].x -= o, t1[e].y += r + n + i;
        }
        function If(t1, e, r, n) {
            const { horizontalAlign: i, verticalAlign: s } = Af(n), a = r[0] - t1.displaySize[0] * i, o = r[1] - t1.displaySize[1] * s;
            return {
                imagePrimary: t1,
                imageSecondary: e,
                top: o,
                bottom: o + t1.displaySize[1],
                left: a,
                right: a + t1.displaySize[0]
            };
        }
        function Pf(t1, e, r, n, i, s) {
            const a = t1.imagePrimary;
            let o;
            if (a.content) {
                const t1 = a.content, e = a.pixelRatio || 1;
                o = [
                    t1[0] / e,
                    t1[1] / e,
                    a.displaySize[0] - t1[2] / e,
                    a.displaySize[1] - t1[3] / e
                ];
            }
            const l = e.left * s, u = e.right * s;
            let c, h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - a.displaySize[0]) / 2, h = f + a.displaySize[0]);
            const d = e.top * s, m = e.bottom * s;
            return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + m + n[2]) : (c = i[1] + (d + m - a.displaySize[1]) / 2, p = c + a.displaySize[1]), {
                imagePrimary: a,
                imageSecondary: void 0,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: o
            };
        }
        class zf extends q {
            constructor(t1, e, r, n, i){
                super(t1, e), this.angle = n, this.z = r, void 0 !== i && (this.segment = i);
            }
            clone() {
                return new zf(this.x, this.y, this.z, this.angle, this.segment);
            }
        }
        function kf(t1, e, r, n, i) {
            if (void 0 === e.segment) return !0;
            let s = e, a = e.segment + 1, o = 0;
            for(; o > -r / 2;){
                if (a--, a < 0) return !1;
                o -= t1[a].dist(s), s = t1[a];
            }
            o += t1[a].dist(t1[a + 1]), a++;
            const l = [];
            let u = 0;
            for(; o < r / 2;){
                const e = t1[a], r = t1[a + 1];
                if (!r) return !1;
                let s = t1[a - 1].angleTo(e) - e.angleTo(r);
                for(s = Math.abs((s + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: o,
                    angleDelta: s
                }), u += s; o - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                a++, o += e.dist(r);
            }
            return !0;
        }
        function Tf(t1) {
            let e = 0;
            for(let r = 0; r < t1.length - 1; r++)e += t1[r].dist(t1[r + 1]);
            return e;
        }
        function Ef(t1, e, r) {
            return t1 ? .6 * e * r : 0;
        }
        function Bf(t1, e) {
            return Math.max(t1 ? t1.right - t1.left : 0, e ? e.right - e.left : 0);
        }
        function Vf(t1, e, r, n, i, s) {
            const a = Ef(r, i, s), o = Bf(r, n) * s;
            let l = 0;
            const u = Tf(t1) / 2;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1], s = n.dist(i);
                if (l + s > u) {
                    const c = (u - l) / s, h = ke(n.x, i.x, c), p = ke(n.y, i.y, c), f = new zf(h, p, 0, i.angleTo(n), r);
                    return !a || kf(t1, f, o, a, e) ? f : void 0;
                }
                l += s;
            }
        }
        function Cf(t1, e, r, n, i, s, a, o, l) {
            const u = Ef(n, s, a), c = Bf(n, i), h = c * a, p = 0 === t1[0].x || t1[0].x === l || 0 === t1[0].y || t1[0].y === l;
            return e - h < e / 4 && (e = h + e / 4), Rf(t1, p ? e / 2 * o % e : (c / 2 + 2 * s) * a * o % e, e, u, r, h, p, !1, l);
        }
        function Rf(t1, e, r, n, i, s, a, o, l) {
            const u = s / 2, c = Tf(t1);
            let h = 0, p = e - r, f = [];
            for(let e = 0; e < t1.length - 1; e++){
                const a = t1[e], o = t1[e + 1], d = a.dist(o), m = o.angleTo(a);
                for(; p + r < h + d;){
                    p += r;
                    const y = (p - h) / d, g = ke(a.x, o.x, y), x = ke(a.y, o.y, y);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new zf(g, x, 0, m, e);
                        n && !kf(t1, r, s, n, i) || f.push(r);
                    }
                }
                h += d;
            }
            return o || f.length || a || (f = Rf(t1, h / 2, r, n, i, s, a, !0, l)), f;
        }
        function Df(t1, e, r, n, i) {
            const s = [];
            for(let a = 0; a < t1.length; a++){
                const o = t1[a];
                let l;
                for(let t1 = 0; t1 < o.length - 1; t1++){
                    let a = o[t1], u = o[t1 + 1];
                    a.x < e && u.x < e || (a.x < e ? a = new q(e, a.y + (e - a.x) / (u.x - a.x) * (u.y - a.y))._round() : u.x < e && (u = new q(e, a.y + (e - a.x) / (u.x - a.x) * (u.y - a.y))._round()), a.y < r && u.y < r || (a.y < r ? a = new q(a.x + (r - a.y) / (u.y - a.y) * (u.x - a.x), r)._round() : u.y < r && (u = new q(a.x + (r - a.y) / (u.y - a.y) * (u.x - a.x), r)._round()), a.x >= n && u.x >= n || (a.x >= n ? a = new q(n, a.y + (n - a.x) / (u.x - a.x) * (u.y - a.y))._round() : u.x >= n && (u = new q(n, a.y + (n - a.x) / (u.x - a.x) * (u.y - a.y))._round()), a.y >= i && u.y >= i || (a.y >= i ? a = new q(a.x + (i - a.y) / (u.y - a.y) * (u.x - a.x), i)._round() : u.y >= i && (u = new q(a.x + (i - a.y) / (u.y - a.y) * (u.x - a.x), i)._round()), l && a.equals(l[l.length - 1]) || (l = [
                        a
                    ], s.push(l)), l.push(u)))));
                }
            }
            return s;
        }
        function Lf(t1) {
            let e = 0, r = 0;
            for (const n of t1)e += n.w * n.h, r = Math.max(r, n.w);
            t1.sort((t1, e)=>e.h - t1.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, s = 0;
            for (const e of t1)for(let t1 = n.length - 1; t1 >= 0; t1--){
                const r = n[t1];
                if (!(e.w > r.w || e.h > r.h)) {
                    if (e.x = r.x, e.y = r.y, s = Math.max(s, e.y + e.h), i = Math.max(i, e.x + e.w), e.w === r.w && e.h === r.h) {
                        const e = n.pop();
                        t1 < n.length && (n[t1] = e);
                    } else e.h === r.h ? (r.x += e.w, r.w -= e.w) : e.w === r.w ? (r.y += e.h, r.h -= e.h) : (n.push({
                        x: r.x + e.w,
                        y: r.y,
                        w: r.w - e.w,
                        h: e.h
                    }), r.y += e.h, r.h -= e.h);
                    break;
                }
            }
            return {
                w: i,
                h: s,
                fill: e / (i * s) || 0
            };
        }
        os(zf, "Anchor");
        const Ff = 1;
        class Of {
            constructor(t1, { pixelRatio: e, version: r, stretchX: n, stretchY: i, content: s }, a){
                this.paddedRect = t1, this.pixelRatio = e, this.stretchX = n, this.stretchY = i, this.content = s, this.version = r, this.padding = a;
            }
            get tl() {
                return [
                    this.paddedRect.x + this.padding,
                    this.paddedRect.y + this.padding
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - this.padding,
                    this.paddedRect.y + this.paddedRect.h - this.padding
                ];
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * this.padding) / this.pixelRatio,
                    (this.paddedRect.h - 2 * this.padding) / this.pixelRatio
                ];
            }
        }
        class Uf {
            constructor(t1, e, r){
                const n = {}, i = {};
                this.haveRenderCallbacks = [];
                const s = [];
                this.addImages(t1, n, Ff, s), this.addImages(e, i, 2, s);
                const { w: a, h: o } = Lf(s), l = new ic({
                    width: a || 1,
                    height: o || 1
                });
                for(const e in t1){
                    const i = t1[e], s = n[e].paddedRect;
                    ic.copy(i.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: s.x + Ff,
                        y: s.y + Ff
                    }, i.data, r, i.sdf);
                }
                for(const t1 in e){
                    const n = e[t1], s = i[t1].paddedRect;
                    let a = i[t1].padding;
                    const o = s.x + a, u = s.y + a, c = n.data.width, h = n.data.height;
                    a = a > 1 ? a - 1 : a, ic.copy(n.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: u
                    }, n.data, r), ic.copy(n.data, l, {
                        x: 0,
                        y: h - a
                    }, {
                        x: o,
                        y: u - a
                    }, {
                        width: c,
                        height: a
                    }, r), ic.copy(n.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: u + h
                    }, {
                        width: c,
                        height: a
                    }, r), ic.copy(n.data, l, {
                        x: c - a,
                        y: 0
                    }, {
                        x: o - a,
                        y: u
                    }, {
                        width: a,
                        height: h
                    }, r), ic.copy(n.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: o + c,
                        y: u
                    }, {
                        width: a,
                        height: h
                    }, r), ic.copy(n.data, l, {
                        x: c - a,
                        y: h - a
                    }, {
                        x: o - a,
                        y: u - a
                    }, {
                        width: a,
                        height: a
                    }, r), ic.copy(n.data, l, {
                        x: 0,
                        y: h - a
                    }, {
                        x: o + c,
                        y: u - a
                    }, {
                        width: a,
                        height: a
                    }, r), ic.copy(n.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: o + c,
                        y: u + h
                    }, {
                        width: a,
                        height: a
                    }, r), ic.copy(n.data, l, {
                        x: c - a,
                        y: 0
                    }, {
                        x: o - a,
                        y: u + h
                    }, {
                        width: a,
                        height: a
                    }, r);
                }
                this.image = l, this.iconPositions = n, this.patternPositions = i;
            }
            addImages(t1, e, r, n) {
                for(const i in t1){
                    const s = t1[i], a = {
                        x: 0,
                        y: 0,
                        w: s.data.width + 2 * r,
                        h: s.data.height + 2 * r
                    };
                    n.push(a), e[i] = new Of(a, s, r), s.hasRenderCallback && this.haveRenderCallbacks.push(i);
                }
            }
            patchUpdatedImages(t1, e, r) {
                this.haveRenderCallbacks = this.haveRenderCallbacks.filter((e)=>t1.hasImage(e, r)), t1.dispatchRenderCallbacks(this.haveRenderCallbacks, r);
                for(const n in t1.getUpdatedImages(r))this.patchUpdatedImage(this.iconPositions[n], t1.getImage(n, r), e), this.patchUpdatedImage(this.patternPositions[n], t1.getImage(n, r), e);
            }
            patchUpdatedImage(t1, e, r) {
                if (!t1 || !e) return;
                if (t1.version === e.version) return;
                t1.version = e.version;
                const [n, i] = t1.tl;
                r.update(e.data, {
                    position: {
                        x: n,
                        y: i
                    }
                });
            }
        }
        os(Of, "ImagePosition"), os(Uf, "ImageAtlas");
        const jf = 1e20;
        function Nf(t1, e, r, n, i, s, a, o, l) {
            for(let u = e; u < e + n; u++)qf(t1, r * s + u, s, i, a, o, l);
            for(let u = r; u < r + i; u++)qf(t1, u * s + e, 1, n, a, o, l);
        }
        function qf(t1, e, r, n, i, s, a) {
            s[0] = 0, a[0] = -jf, a[1] = jf, i[0] = t1[e];
            for(let o = 1, l = 0, u = 0; o < n; o++){
                i[o] = t1[e + o * r];
                const n = o * o;
                do {
                    const t1 = s[l];
                    u = (i[o] - i[t1] + n - t1 * t1) / (o - t1) / 2;
                }while (u <= a[l] && --l > -1);
                l++, s[l] = o, a[l] = u, a[l + 1] = jf;
            }
            for(let o = 0, l = 0; o < n; o++){
                for(; a[l + 1] < o;)l++;
                const n = s[l], u = o - n;
                t1[e + o * r] = i[n] + u * u;
            }
        }
        const $f = 2, Gf = {
            none: 0,
            ideographs: 1,
            all: 2
        };
        class Xf {
            constructor(t1, e, r){
                this.requestManager = t1, this.localGlyphMode = e, this.localFontFamily = r, this.urls = {}, this.entries = {}, this.localGlyphs = {
                    200: {},
                    400: {},
                    500: {},
                    900: {}
                };
            }
            setURL(t1, e) {
                this.urls[e] = t1;
            }
            getGlyphs(t1, e, r) {
                const n = [], i = this.urls[e] || It.GLYPHS_URL;
                for(const e in t1)for (const r of t1[e])n.push({
                    stack: e,
                    id: r
                });
                rt(n, ({ stack: t1, id: e }, r)=>{
                    let n = this.entries[t1];
                    n || (n = this.entries[t1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {},
                        ascender: void 0,
                        descender: void 0
                    });
                    let s = n.glyphs[e];
                    if (void 0 !== s) return void r(null, {
                        stack: t1,
                        id: e,
                        glyph: s
                    });
                    if (s = this._tinySDF(n, t1, e), s) return n.glyphs[e] = s, void r(null, {
                        stack: t1,
                        id: e,
                        glyph: s
                    });
                    const a = Math.floor(e / 256);
                    if (256 * a > 65535) return void r(new Error("glyphs > 65535 not supported"));
                    if (n.ranges[a]) return void r(null, {
                        stack: t1,
                        id: e,
                        glyph: s
                    });
                    let o = n.requests[a];
                    o || (o = n.requests[a] = [], Xf.loadGlyphRange(t1, a, i, this.requestManager, (t1, e)=>{
                        if (e) {
                            n.ascender = e.ascender, n.descender = e.descender;
                            for(const t1 in e.glyphs)this._doesCharSupportLocalGlyph(+t1) || (n.glyphs[+t1] = e.glyphs[+t1]);
                            n.ranges[a] = !0;
                        }
                        for (const r of o)r(t1, e);
                        delete n.requests[a];
                    })), o.push((n, i)=>{
                        n ? r(n) : i && r(null, {
                            stack: t1,
                            id: e,
                            glyph: i.glyphs[e] || null
                        });
                    });
                }, (t1, e)=>{
                    if (t1) r(t1);
                    else if (e) {
                        const t1 = {};
                        for (const { stack: r, id: n, glyph: i } of e)void 0 === t1[r] && (t1[r] = {}), void 0 === t1[r].glyphs && (t1[r].glyphs = {}), t1[r].glyphs[n] = i && {
                            id: i.id,
                            bitmap: i.bitmap.clone(),
                            metrics: i.metrics
                        }, t1[r].ascender = this.entries[r].ascender, t1[r].descender = this.entries[r].descender;
                        r(null, t1);
                    }
                });
            }
            _doesCharSupportLocalGlyph(t1) {
                return this.localGlyphMode !== Gf.none && (this.localGlyphMode === Gf.all ? !!this.localFontFamily : !!this.localFontFamily && (ps["CJK Unified Ideographs"](t1) || ps["Hangul Syllables"](t1) || ps.Hiragana(t1) || ps.Katakana(t1) || ps["CJK Symbols and Punctuation"](t1) || ps["CJK Unified Ideographs Extension A"](t1) || ps["CJK Unified Ideographs Extension B"](t1)));
            }
            _tinySDF(t1, e, r) {
                const n = this.localFontFamily;
                if (!n || !this._doesCharSupportLocalGlyph(r)) return;
                let i = t1.tinySDF;
                if (!i) {
                    let r = "400";
                    /bold/i.test(e) ? r = "900" : /medium/i.test(e) ? r = "500" : /light/i.test(e) && (r = "200"), i = t1.tinySDF = new Xf.TinySDF({
                        fontFamily: n,
                        fontWeight: r,
                        fontSize: 24 * $f,
                        buffer: 3 * $f,
                        radius: 8 * $f
                    }), i.fontWeight = r;
                }
                if (this.localGlyphs[i.fontWeight][r]) return this.localGlyphs[i.fontWeight][r];
                const s = String.fromCodePoint(r), { data: a, width: o, height: l, glyphWidth: u, glyphHeight: c, glyphLeft: h, glyphTop: p, glyphAdvance: f } = i.draw(s);
                return this.localGlyphs[i.fontWeight][r] = {
                    id: r,
                    bitmap: new nc({
                        width: o,
                        height: l
                    }, a),
                    metrics: {
                        width: u / $f,
                        height: c / $f,
                        left: h / $f,
                        top: p / $f - 27,
                        advance: f / $f,
                        localGlyph: !0
                    }
                };
            }
        }
        Xf.loadGlyphRange = function(t1, e, r, n, i) {
            const s = 256 * e, a = s + 255, o = n.transformRequest(n.normalizeGlyphsURL(r).replace("{fontstack}", t1).replace("{range}", `${s}-${a}`), ee.Glyphs);
            se(o, (t1, e)=>{
                if (t1) i(t1);
                else if (e) {
                    const t1 = {}, r = function(t1) {
                        return new of(t1).readFields(uf, {});
                    }(e);
                    for (const e of r.glyphs)t1[e.id] = e;
                    i(null, {
                        glyphs: t1,
                        ascender: r.ascender,
                        descender: r.descender
                    });
                }
            });
        }, Xf.TinySDF = class {
            constructor({ fontSize: t1 = 24, buffer: e = 3, radius: r = 8, cutoff: n = .25, fontFamily: i = "sans-serif", fontWeight: s = "normal", fontStyle: a = "normal" } = {}){
                this.buffer = e, this.cutoff = n, this.radius = r;
                const o = this.size = t1 + 4 * e, l = this._createCanvas(o), u = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                u.font = `${a} ${s} ${t1}px ${i}`, u.textBaseline = "alphabetic", u.textAlign = "left", u.fillStyle = "black", this.gridOuter = new Float64Array(o * o), this.gridInner = new Float64Array(o * o), this.f = new Float64Array(o), this.z = new Float64Array(o + 1), this.v = new Uint16Array(o);
            }
            _createCanvas(t1) {
                const e = document.createElement("canvas");
                return e.width = e.height = t1, e;
            }
            draw(t1) {
                const { width: e, actualBoundingBoxAscent: r, actualBoundingBoxDescent: n, actualBoundingBoxLeft: i, actualBoundingBoxRight: s } = this.ctx.measureText(t1), a = Math.ceil(r), o = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(s - i))), l = Math.min(this.size - this.buffer, a + Math.ceil(n)), u = o + 2 * this.buffer, c = l + 2 * this.buffer, h = Math.max(u * c, 0), p = new Uint8ClampedArray(h), f = {
                    data: p,
                    width: u,
                    height: c,
                    glyphWidth: o,
                    glyphHeight: l,
                    glyphTop: a,
                    glyphLeft: 0,
                    glyphAdvance: e
                };
                if (0 === o || 0 === l) return f;
                const { ctx: d, buffer: m, gridInner: y, gridOuter: g } = this;
                d.clearRect(m, m, o, l), d.fillText(t1, m, m + a);
                const x = d.getImageData(m, m, o, l);
                g.fill(jf, 0, h), y.fill(0, 0, h);
                for(let t1 = 0; t1 < l; t1++)for(let e = 0; e < o; e++){
                    const r = x.data[4 * (t1 * o + e) + 3] / 255;
                    if (0 === r) continue;
                    const n = (t1 + m) * u + e + m;
                    if (1 === r) g[n] = 0, y[n] = jf;
                    else {
                        const t1 = .5 - r;
                        g[n] = t1 > 0 ? t1 * t1 : 0, y[n] = t1 < 0 ? t1 * t1 : 0;
                    }
                }
                Nf(g, 0, 0, u, c, u, this.f, this.v, this.z), Nf(y, m, m, o, l, u, this.f, this.v, this.z);
                for(let t1 = 0; t1 < h; t1++){
                    const e = Math.sqrt(g[t1]) - Math.sqrt(y[t1]);
                    p[t1] = Math.round(255 - 255 * (e / this.radius + this.cutoff));
                }
                return f;
            }
        };
        const Yf = Ff;
        function Zf(t1, e, r, n) {
            const i = [], s = t1.imagePrimary, a = s.pixelRatio, o = s.paddedRect.w - 2 * Yf, l = s.paddedRect.h - 2 * Yf, u = t1.right - t1.left, c = t1.bottom - t1.top, h = s.stretchX || [
                [
                    0,
                    o
                ]
            ], p = s.stretchY || [
                [
                    0,
                    l
                ]
            ], f = (t1, e)=>t1 + e[1] - e[0], d = h.reduce(f, 0), m = p.reduce(f, 0), y = o - d, g = l - m;
            let x = 0, b = d, v = 0, w = m, _ = 0, M = y, A = 0, S = g;
            if (s.content && n) {
                const t1 = s.content;
                x = Wf(h, 0, t1[0]), v = Wf(p, 0, t1[1]), b = Wf(h, t1[0], t1[2]), w = Wf(p, t1[1], t1[3]), _ = t1[0] - x, A = t1[1] - v, M = t1[2] - t1[0] - b, S = t1[3] - t1[1] - w;
            }
            const I = (n, i, o, l)=>{
                const h = Kf(n.stretch - x, b, u, t1.left), p = Jf(n.fixed - _, M, n.stretch, d), f = Kf(i.stretch - v, w, c, t1.top), y = Jf(i.fixed - A, S, i.stretch, m), g = Kf(o.stretch - x, b, u, t1.left), I = Jf(o.fixed - _, M, o.stretch, d), P = Kf(l.stretch - v, w, c, t1.top), z = Jf(l.fixed - A, S, l.stretch, m), k = new q(h, f), T = new q(g, f), E = new q(g, P), B = new q(h, P), V = new q(p / a, y / a), C = new q(I / a, z / a), R = e * Math.PI / 180;
                if (R) {
                    const t1 = Math.sin(R), e = Math.cos(R), r = [
                        e,
                        -t1,
                        t1,
                        e
                    ];
                    k._matMult(r), T._matMult(r), B._matMult(r), E._matMult(r);
                }
                const D = n.stretch + n.fixed, L = o.stretch + o.fixed, F = i.stretch + i.fixed, O = l.stretch + l.fixed, U = t1.imageSecondary;
                return {
                    tl: k,
                    tr: T,
                    bl: B,
                    br: E,
                    texPrimary: {
                        x: s.paddedRect.x + Yf + D,
                        y: s.paddedRect.y + Yf + F,
                        w: L - D,
                        h: O - F
                    },
                    texSecondary: U ? {
                        x: U.paddedRect.x + Yf + D,
                        y: U.paddedRect.y + Yf + F,
                        w: L - D,
                        h: O - F
                    } : void 0,
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: V,
                    pixelOffsetBR: C,
                    minFontScaleX: M / a / u,
                    minFontScaleY: S / a / c,
                    isSDF: r
                };
            };
            if (n && (s.stretchX || s.stretchY)) {
                const t1 = Hf(h, y, d), e = Hf(p, g, m);
                for(let r = 0; r < t1.length - 1; r++){
                    const n = t1[r], s = t1[r + 1];
                    for(let t1 = 0; t1 < e.length - 1; t1++)i.push(I(n, e[t1], s, e[t1 + 1]));
                }
            } else i.push(I({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: o + 1
            }, {
                fixed: 0,
                stretch: l + 1
            }));
            return i;
        }
        function Wf(t1, e, r) {
            let n = 0;
            for (const i of t1)n += Math.max(e, Math.min(r, i[1])) - Math.max(e, Math.min(r, i[0]));
            return n;
        }
        function Hf(t1, e, r) {
            const n = [
                {
                    fixed: -Yf,
                    stretch: 0
                }
            ];
            for (const [e, r] of t1){
                const t1 = n[n.length - 1];
                n.push({
                    fixed: e - t1.stretch,
                    stretch: t1.stretch
                }), n.push({
                    fixed: e - t1.stretch,
                    stretch: t1.stretch + (r - e)
                });
            }
            return n.push({
                fixed: e + Yf,
                stretch: r
            }), n;
        }
        function Kf(t1, e, r, n) {
            return t1 / e * r + n;
        }
        function Jf(t1, e, r, n) {
            return t1 - e * r / n;
        }
        function Qf(t1, e, r, n) {
            const i = e + t1.positionedLines[n].lineOffset;
            return 0 === n ? r + i / 2 : r + (i + (e + t1.positionedLines[n - 1].lineOffset)) / 2;
        }
        function td(t1, e = 1, r = !1) {
            let n = 1 / 0, i = 1 / 0, s = -1 / 0, a = -1 / 0;
            const o = t1[0];
            for(let t1 = 0; t1 < o.length; t1++){
                const e = o[t1];
                (!t1 || e.x < n) && (n = e.x), (!t1 || e.y < i) && (i = e.y), (!t1 || e.x > s) && (s = e.x), (!t1 || e.y > a) && (a = e.y);
            }
            const l = Math.min(s - n, a - i);
            let u = l / 2;
            const c = new Wr([], ed);
            if (0 === l) return new q(n, i);
            for(let e = n; e < s; e += l)for(let r = i; r < a; r += l)c.push(new rd(e + u, r + u, u, t1));
            let h = function(t1) {
                let e = 0, r = 0, n = 0;
                const i = t1[0];
                for(let t1 = 0, s = i.length, a = s - 1; t1 < s; a = t1++){
                    const s = i[t1], o = i[a], l = s.x * o.y - o.x * s.y;
                    r += (s.x + o.x) * l, n += (s.y + o.y) * l, e += 3 * l;
                }
                return new rd(r / e, n / e, 0, t1);
            }(t1), p = c.length;
            for(; c.length;){
                const n = c.pop();
                (n.d > h.d || !h.d) && (h = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, p)), n.max - h.d <= e || (u = n.h / 2, c.push(new rd(n.p.x - u, n.p.y - u, u, t1)), c.push(new rd(n.p.x + u, n.p.y - u, u, t1)), c.push(new rd(n.p.x - u, n.p.y + u, u, t1)), c.push(new rd(n.p.x + u, n.p.y + u, u, t1)), p += 4);
            }
            return r && (console.log(`num probes: ${p}`), console.log(`best distance: ${h.d}`)), h.p;
        }
        function ed(t1, e) {
            return e.max - t1.max;
        }
        class rd {
            constructor(t1, e, r, n){
                this.p = new q(t1, e), this.h = r, this.d = function(t1, e) {
                    let r = !1, n = 1 / 0;
                    for(let i = 0; i < e.length; i++){
                        const s = e[i];
                        for(let e = 0, i = s.length, a = i - 1; e < i; a = e++){
                            const i = s[e], o = s[a];
                            i.y > t1.y != o.y > t1.y && t1.x < (o.x - i.x) * (t1.y - i.y) / (o.y - i.y) + i.x && (r = !r), n = Math.min(n, Fl(t1, i, o));
                        }
                    }
                    return (r ? 1 : -1) * Math.sqrt(n);
                }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
            }
        }
        const nd = Number.POSITIVE_INFINITY, id = Math.sqrt(2);
        function sd(t1, [e, r]) {
            let n = 0, i = 0;
            if (r === nd) {
                e < 0 && (e = 0);
                const r = e / id;
                switch(t1){
                    case "top-right":
                    case "top-left":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        i = 7 - r;
                        break;
                    case "bottom":
                        i = 7 - e;
                        break;
                    case "top":
                        i = e - 7;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                        n = -r;
                        break;
                    case "top-left":
                    case "bottom-left":
                        n = r;
                        break;
                    case "left":
                        n = e;
                        break;
                    case "right":
                        n = -e;
                }
            } else {
                switch(e = Math.abs(e), r = Math.abs(r), t1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e;
                }
            }
            return [
                n,
                i
            ];
        }
        function ad(t1) {
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function od(t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d) {
            let m = s.textMaxSize.evaluate(e, {}, h);
            void 0 === m && (m = a);
            const y = t1.layers[0].layout, g = y.get("icon-offset").evaluate(e, {}, h), x = hd(r.horizontal) || r.vertical, b = "globe" === p.name, v = $p, w = a / v, _ = t1.tilePixelRatio * m / v, M = (E = t1.overscaling, t1.zoom > 18 && E > 2 && (E >>= 1), Math.max(Hr / (512 * E), 1) * y.get("symbol-spacing")), A = y.get("text-padding") * t1.tilePixelRatio, S = y.get("icon-padding") * t1.tilePixelRatio, I = Y(y.get("text-max-angle")), P = "map" === y.get("text-rotation-alignment") && "point" !== y.get("symbol-placement"), z = "map" === y.get("icon-rotation-alignment") && "point" !== y.get("symbol-placement"), k = y.get("symbol-placement"), T = M / 2;
            var E;
            const B = y.get("icon-text-fit").evaluate(e, {}, h), V = y.get("icon-text-fit-padding").evaluate(e, {}, h), C = "none" !== B;
            let R;
            !1 === t1.hasAnyIconTextFit && C && (t1.hasAnyIconTextFit = !0), n && C && (t1.allowVerticalPlacement && r.vertical && (R = Pf(n, r.vertical, B, V, g, w)), x && (n = Pf(n, x, B, V, g, w)));
            const D = (a, o, m)=>{
                if (o.x < 0 || o.x >= Hr || o.y < 0 || o.y >= Hr) return;
                let y = null;
                if (b) {
                    const { x: t1, y: e, z: r } = p.projectTilePoint(o.x, o.y, m);
                    y = {
                        anchor: new zf(t1, e, r, 0, void 0),
                        up: p.upVector(m, o.x, o.y)
                    };
                }
                !function(t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v, w, _, M, A, S, I) {
                    const P = t1.addToLineVertexArray(e, n);
                    let z, k, T, E, B, V, C, R = 0, D = 0, L = 0, F = 0, O = -1, U = -1;
                    const j = {};
                    let N = xe("");
                    const q = r ? r.anchor : e, $ = "none" !== l.layout.get("icon-text-fit").evaluate(v, {}, A);
                    let G = 0, X = 0;
                    if (void 0 === l._unevaluatedLayout.getValue("text-radial-offset") ? [G, X] = l.layout.get("text-offset").evaluate(v, {}, A).map((t1)=>t1 * $p) : (G = l.layout.get("text-radial-offset").evaluate(v, {}, A) * $p, X = nd), t1.allowVerticalPlacement && i.vertical) {
                        const t1 = i.vertical;
                        if (d) V = fd(t1), o && (C = fd(o));
                        else {
                            const r = l.layout.get("text-rotate").evaluate(v, {}, A) + 90;
                            T = pd(u, q, e, c, h, p, t1, f, r, m), o && (E = pd(u, q, e, c, h, p, o, g, r));
                        }
                    }
                    if (s) {
                        const n = l.layout.get("icon-rotate").evaluate(v, {}, A), i = Zf(s, n, _, $), a = o ? Zf(o, n, _, $) : void 0;
                        k = pd(u, q, e, c, h, p, s, g, n), R = 4 * i.length;
                        const f = t1.iconSizeData;
                        let d = null;
                        "source" === f.kind ? (d = [
                            Gp * l.layout.get("icon-size").evaluate(v, {}, A)
                        ], d[0] > ud && ft(`${t1.layerIds[0]}: Value for "icon-size" is >= ${ld}. Reduce your "icon-size".`)) : "composite" === f.kind && (d = [
                            Gp * w.compositeIconSizes[0].evaluate(v, {}, A),
                            Gp * w.compositeIconSizes[1].evaluate(v, {}, A)
                        ], (d[0] > ud || d[1] > ud) && ft(`${t1.layerIds[0]}: Value for "icon-size" is >= ${ld}. Reduce your "icon-size".`)), t1.addSymbols(t1.icon, i, d, b, x, v, !1, r, e, P.lineStartIndex, P.lineLength, -1, M, A, S, I), O = t1.icon.placedSymbolArray.length - 1, a && (D = 4 * a.length, t1.addSymbols(t1.icon, a, d, b, x, v, ff.vertical, r, e, P.lineStartIndex, P.lineLength, -1, M, A, S, I), U = t1.icon.placedSymbolArray.length - 1);
                    }
                    for(const n in i.horizontal){
                        const s = i.horizontal[n];
                        z || (N = xe(s.text), d ? B = fd(s) : z = pd(u, q, e, c, h, p, s, f, l.layout.get("text-rotate").evaluate(v, {}, A), m));
                        const o = 1 === s.positionedLines.length;
                        if (L += cd(t1, r, e, s, a, l, d, v, m, P, i.vertical ? ff.horizontal : ff.horizontalOnly, o ? Object.keys(i.horizontal) : [
                            n
                        ], j, O, w, M, A, S), o) break;
                    }
                    i.vertical && (F += cd(t1, r, e, i.vertical, a, l, d, v, m, P, ff.vertical, [
                        "vertical"
                    ], j, U, w, M, A, S));
                    let Y = -1;
                    const Z = (t1, e)=>t1 ? Math.max(t1, e) : e;
                    Y = Z(B, Y), Y = Z(V, Y), Y = Z(C, Y);
                    const W = Y > -1 ? 1 : 0;
                    t1.glyphOffsetArray.length >= 65535 && ft("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== v.sortKey && t1.addToSortKeyRanges(t1.symbolInstances.length, v.sortKey), t1.symbolInstances.emplaceBack(e.x, e.y, q.x, q.y, q.z, j.right >= 0 ? j.right : -1, j.center >= 0 ? j.center : -1, j.left >= 0 ? j.left : -1, j.vertical >= 0 ? j.vertical : -1, O, U, N, void 0 !== z ? z : t1.collisionBoxArray.length, void 0 !== z ? z + 1 : t1.collisionBoxArray.length, void 0 !== T ? T : t1.collisionBoxArray.length, void 0 !== T ? T + 1 : t1.collisionBoxArray.length, void 0 !== k ? k : t1.collisionBoxArray.length, void 0 !== k ? k + 1 : t1.collisionBoxArray.length, E || t1.collisionBoxArray.length, E ? E + 1 : t1.collisionBoxArray.length, c, L, F, R, D, W, 0, G, X, Y, 0, $ ? 1 : 0);
                }(t1, o, y, a, r, n, i, R, t1.layers[0], t1.collisionBoxArray, e.index, e.sourceLayerIndex, t1.index, A, P, l, 0, S, z, g, e, s, u, c, h, f, d);
            };
            if ("line" === k) for (const i of Df(e.geometry, 0, 0, Hr, Hr)){
                const e = Cf(i, M, I, r.vertical || x, n, v, _, t1.overscaling, Hr);
                for (const r of e)x && dd(t1, x.text, T, r) || D(i, r, h);
            }
            else if ("line-center" === k) {
                for (const t1 of e.geometry)if (t1.length > 1) {
                    const e = Vf(t1, I, r.vertical || x, n, v, _);
                    e && D(t1, e, h);
                }
            } else if ("Polygon" === e.type) for (const t1 of Cc(e.geometry, 0)){
                const e = td(t1, 16);
                D(t1[0], new zf(e.x, e.y, 0, 0, void 0), h);
            }
            else if ("LineString" === e.type) for (const t1 of e.geometry)D(t1, new zf(t1[0].x, t1[0].y, 0, 0, void 0), h);
            else if ("Point" === e.type) for (const t1 of e.geometry)for (const e of t1)D([
                e
            ], new zf(e.x, e.y, 0, 0, void 0), h);
        }
        const ld = 255, ud = ld * Gp;
        function cd(t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g) {
            const x = function(t1, e, r, n, i, s, a, o) {
                const l = [];
                if (0 === e.positionedLines.length) return l;
                const u = n.layout.get("text-rotate").evaluate(s, {}) * Math.PI / 180, c = function(t1) {
                    const e = t1[0], r = t1[1], n = e * r;
                    return n > 0 ? [
                        e,
                        -r
                    ] : n < 0 ? [
                        -e,
                        r
                    ] : 0 === e ? [
                        r,
                        e
                    ] : [
                        r,
                        -e
                    ];
                }(r);
                let h = Math.abs(e.top - e.bottom);
                for (const t1 of e.positionedLines)h -= t1.lineOffset;
                const p = e.positionedLines.length, f = h / p;
                let d = e.top - r[1];
                for(let t1 = 0; t1 < p; ++t1){
                    const n = e.positionedLines[t1];
                    d = Qf(e, f, d, t1);
                    for (const t1 of n.positionedGlyphs){
                        if (!t1.rect) continue;
                        const n = t1.rect || {};
                        let s = pf + 1, h = !0, p = 1, f = 0;
                        if (t1.imageName) {
                            const e = a[t1.imageName];
                            if (!e) continue;
                            if (e.sdf) {
                                ft("SDF images are not supported in formatted text and will be ignored.");
                                continue;
                            }
                            h = !1, p = e.pixelRatio, s = Ff / p;
                        }
                        const m = (i || o) && t1.vertical, y = t1.metrics.advance * t1.scale / 2, g = t1.metrics, x = t1.rect;
                        if (null === x) continue;
                        o && e.verticalizable && (f = t1.imageName ? y - t1.metrics.width * t1.scale / 2 : 0);
                        const b = i ? [
                            t1.x + y,
                            t1.y
                        ] : [
                            0,
                            0
                        ];
                        let v = [
                            0,
                            0
                        ], w = [
                            0,
                            0
                        ], _ = !1;
                        i || (m ? (w = [
                            t1.x + y + c[0],
                            t1.y + c[1] - f
                        ], _ = !0) : v = [
                            t1.x + y + r[0],
                            t1.y + r[1] - f
                        ]);
                        const M = x.w * t1.scale / (p * (t1.localGlyph ? $f : 1)), A = x.h * t1.scale / (p * (t1.localGlyph ? $f : 1));
                        let S, I, P, z;
                        if (m) {
                            const e = t1.y - d, r = new q(-y, y - e), n = -Math.PI / 2, i = new q(...w);
                            S = new q(-y + v[0], v[1]), S._rotateAround(n, r)._add(i), S.x += -e + y, S.y -= (g.left - s) * t1.scale;
                            const a = t1.imageName ? g.advance * t1.scale : $p * t1.scale, o = String.fromCodePoint(t1.glyph);
                            Jp(o) ? S.x += (1 - s) * t1.scale : Qp(o) ? S.x += a - g.height * t1.scale + (-s - 1) * t1.scale : S.x += t1.imageName || g.width + 2 * s === x.w && g.height + 2 * s === x.h ? (a - A) / 2 : (a - (g.height + 2 * s) * t1.scale) / 2, I = new q(S.x, S.y - M), P = new q(S.x + A, S.y), z = new q(S.x + A, S.y - M);
                        } else {
                            const e = (g.left - s) * t1.scale - y + v[0], r = (-g.top - s) * t1.scale + v[1], n = e + M, i = r + A;
                            S = new q(e, r), I = new q(n, r), P = new q(e, i), z = new q(n, i);
                        }
                        if (u) {
                            let t1;
                            t1 = i ? new q(0, 0) : _ ? new q(c[0], c[1]) : new q(r[0], r[1]), S._rotateAround(u, t1), I._rotateAround(u, t1), P._rotateAround(u, t1), z._rotateAround(u, t1);
                        }
                        const k = new q(0, 0), T = new q(0, 0);
                        l.push({
                            tl: S,
                            tr: I,
                            bl: P,
                            br: z,
                            texPrimary: n,
                            texSecondary: void 0,
                            writingMode: e.writingMode,
                            glyphOffset: b,
                            sectionIndex: t1.sectionIndex,
                            isSDF: h,
                            pixelOffsetTL: k,
                            pixelOffsetBR: T,
                            minFontScaleX: 0,
                            minFontScaleY: 0
                        });
                    }
                }
                return l;
            }(0, n, l, s, a, o, i, t1.allowVerticalPlacement), b = t1.textSizeData;
            let v = null;
            "source" === b.kind ? (v = [
                Gp * s.layout.get("text-size").evaluate(o, {}, y)
            ], v[0] > ud && ft(`${t1.layerIds[0]}: Value for "text-size" is >= ${ld}. Reduce your "text-size".`)) : "composite" === b.kind && (v = [
                Gp * d.compositeTextSizes[0].evaluate(o, {}, y),
                Gp * d.compositeTextSizes[1].evaluate(o, {}, y)
            ], (v[0] > ud || v[1] > ud) && ft(`${t1.layerIds[0]}: Value for "text-size" is >= ${ld}. Reduce your "text-size".`)), t1.addSymbols(t1.text, x, v, l, a, o, c, e, r, u.lineStartIndex, u.lineLength, f, m, y, g, !1);
            for (const e of h)p[e] = t1.text.placedSymbolArray.length - 1;
            return 4 * x.length;
        }
        function hd(t1) {
            for(const e in t1)return t1[e];
            return null;
        }
        function pd(t1, e, r, n, i, s, a, o, l, u) {
            let c = a.top, h = a.bottom, p = a.left, f = a.right;
            const d = a.collisionPadding;
            if (d && (p -= d[0], c -= d[1], f += d[2], h += d[3]), l) {
                const t1 = new q(p, c), e = new q(f, c), r = new q(p, h), n = new q(f, h), i = Y(l);
                let s = new q(0, 0);
                u && (s = new q(u[0], u[1])), t1._rotateAround(i, s), e._rotateAround(i, s), r._rotateAround(i, s), n._rotateAround(i, s), p = Math.min(t1.x, e.x, r.x, n.x), f = Math.max(t1.x, e.x, r.x, n.x), c = Math.min(t1.y, e.y, r.y, n.y), h = Math.max(t1.y, e.y, r.y, n.y);
            }
            return t1.emplaceBack(e.x, e.y, e.z, r.x, r.y, p, c, f, h, o, n, i, s), t1.length - 1;
        }
        function fd(t1) {
            t1.collisionPadding && (t1.top -= t1.collisionPadding[1], t1.bottom += t1.collisionPadding[3]);
            const e = t1.bottom - t1.top;
            return e > 0 ? Math.max(10, e) : null;
        }
        function dd(t1, e, r, n) {
            const i = t1.compareText;
            if (e in i) {
                const t1 = i[e];
                for(let e = t1.length - 1; e >= 0; e--)if (n.dist(t1[e]) < r) return !0;
            } else i[e] = [];
            return i[e].push(n), !1;
        }
        function md(t1, e) {
            const r = t1.fovAboveCenter, n = t1.elevation ? t1.elevation.getMinElevationBelowMSL() * e : 0, i = (t1._camera.position[2] * t1.worldSize - n) / Math.cos(t1._pitch), s = Math.sin(r) * i / Math.sin(Math.max(Math.PI / 2 - t1._pitch - r, .01));
            let a = Math.sin(t1._pitch) * s + i;
            const o = i * (1 / t1._horizonShift);
            return t1.elevation && 0 !== t1.elevation.exaggeration() || (a *= 1 + Math.max(t1.zoom - 17, 0)), Math.min(1.01 * a, o);
        }
        function yd(t1, e) {
            if (!e.isReprojectedInTileSpace) return {
                scale: 1 << t1.z,
                x: t1.x,
                y: t1.y,
                x2: t1.x + 1,
                y2: t1.y + 1,
                projection: e
            };
            const r = Math.pow(2, -t1.z), n = t1.x * r, i = (t1.x + 1) * r, s = t1.y * r, a = (t1.y + 1) * r, o = cl(n), l = cl(i), u = hl(s), c = hl(a), h = e.project(o, u), p = e.project(l, u), f = e.project(l, c), d = e.project(o, c);
            let m = Math.min(h.x, p.x, f.x, d.x), y = Math.min(h.y, p.y, f.y, d.y), g = Math.max(h.x, p.x, f.x, d.x), x = Math.max(h.y, p.y, f.y, d.y);
            const b = r / 16;
            function v(t1, r, n, i, s, a) {
                const o = (n + s) / 2, l = (i + a) / 2, u = e.project(cl(o), hl(l)), c = Math.max(0, m - u.x, y - u.y, u.x - g, u.y - x);
                m = Math.min(m, u.x), g = Math.max(g, u.x), y = Math.min(y, u.y), x = Math.max(x, u.y), c > b && (v(t1, u, n, i, o, l), v(u, r, o, l, s, a));
            }
            v(h, p, n, s, i, s), v(p, f, i, s, i, a), v(f, d, i, a, n, a), v(d, h, n, a, n, s), m -= b, y -= b, g += b, x += b;
            const w = 1 / Math.max(g - m, x - y);
            return {
                scale: w,
                x: m * w,
                y: y * w,
                x2: g * w,
                y2: x * w,
                projection: e
            };
        }
        function gd(t1, { x: e, y: r }, n = 0) {
            return new q(((e - n) * t1.scale - t1.x) * Hr, (r * t1.scale - t1.y) * Hr);
        }
        const xd = O.mat4.identity(new Float32Array(16));
        class bd {
            constructor(t1){
                this.spec = t1, this.name = t1.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = [
                    "custom"
                ], this.center = [
                    0,
                    0
                ], this.range = [
                    3.5,
                    7
                ];
            }
            project(t1, e) {
                return {
                    x: 0,
                    y: 0,
                    z: 0
                };
            }
            unproject(t1, e) {
                return new rl(0, 0);
            }
            projectTilePoint(t1, e, r) {
                return {
                    x: t1,
                    y: e,
                    z: 0
                };
            }
            locationPoint(t1, e, r = !0) {
                return t1._coordinatePoint(t1.locationCoordinate(e), r);
            }
            pixelsPerMeter(t1, e) {
                return ul(1, t1) * e;
            }
            pixelSpaceConversion(t1, e, r) {
                return 1;
            }
            farthestPixelDistance(t1) {
                return md(t1, t1.pixelsPerMeter);
            }
            pointCoordinate(t1, e, r, n) {
                const i = t1.horizonLineFromTop(!1), s = new q(e, Math.max(i, r));
                return t1.rayIntersectionCoordinate(t1.pointRayIntersection(s, n));
            }
            pointCoordinate3D(t1, e, r) {
                const n = new q(e, r);
                if (t1.elevation) return t1.elevation.pointCoordinate(n);
                {
                    const e = this.pointCoordinate(t1, n.x, n.y, 0);
                    return [
                        e.x,
                        e.y,
                        e.z
                    ];
                }
            }
            isPointAboveHorizon(t1, e) {
                if (t1.elevation && t1.elevation.visibleDemTiles.length) return !this.pointCoordinate3D(t1, e.x, e.y);
                const r = t1.horizonLineFromTop();
                return e.y < r;
            }
            createInversionMatrix(t1, e) {
                return xd;
            }
            createTileMatrix(t1, e, r) {
                let n, i, s;
                const a = r.canonical, o = O.mat4.identity(new Float64Array(16));
                if (this.isReprojectedInTileSpace) {
                    const l = yd(a, this);
                    n = 1, i = l.x + r.wrap * l.scale, s = l.y, O.mat4.scale(o, o, [
                        n / l.scale,
                        n / l.scale,
                        t1.pixelsPerMeter / e
                    ]);
                } else n = e / t1.zoomScale(a.z), i = (a.x + Math.pow(2, a.z) * r.wrap) * n, s = a.y * n;
                return O.mat4.translate(o, o, [
                    i,
                    s,
                    0
                ]), O.mat4.scale(o, o, [
                    n / Hr,
                    n / Hr,
                    1
                ]), o;
            }
            upVector(t1, e, r) {
                return [
                    0,
                    0,
                    1
                ];
            }
            upVectorScale(t1, e, r) {
                return {
                    metersToTile: 1
                };
            }
        }
        class vd extends bd {
            constructor(t1){
                super(t1), this.range = [
                    4,
                    7
                ], this.center = t1.center || [
                    -96,
                    37.5
                ];
                const [e, r] = this.parallels = t1.parallels || [
                    29.5,
                    45.5
                ], n = Math.sin(Y(e));
                this.n = (n + Math.sin(Y(r))) / 2, this.c = 1 + n * (2 * this.n - n), this.r0 = Math.sqrt(this.c) / this.n;
            }
            project(t1, e) {
                const { n: r, c: n, r0: i } = this, s = Y(t1 - this.center[0]), a = Y(e), o = Math.sqrt(n - 2 * r * Math.sin(a)) / r;
                return {
                    x: o * Math.sin(s * r),
                    y: o * Math.cos(s * r) - i,
                    z: 0
                };
            }
            unproject(t1, e) {
                const { n: r, c: n, r0: i } = this, s = i + e;
                let a = Math.atan2(t1, Math.abs(s)) * Math.sign(s);
                s * r < 0 && (a -= Math.PI * Math.sign(t1) * Math.sign(s));
                const o = Y(this.center[0]) * r;
                a = et(a, -Math.PI - o, Math.PI - o);
                const l = Q(Z(a / r) + this.center[0], -180, 180), u = Math.asin(Q((n - (t1 * t1 + s * s) * r * r) / (2 * r), -1, 1)), c = Q(Z(u), -fl, fl);
                return new rl(l, c);
            }
        }
        const wd = 1.340264, _d = -0.081106, Md = 893e-6, Ad = .003796, Sd = Math.sqrt(3) / 2;
        class Id extends bd {
            project(t1, e) {
                e = e / 180 * Math.PI, t1 = t1 / 180 * Math.PI;
                const r = Math.asin(Sd * Math.sin(e)), n = r * r, i = n * n * n;
                return {
                    x: .5 * (t1 * Math.cos(r) / (Sd * (wd + 3 * _d * n + i * (7 * Md + 9 * Ad * n))) / Math.PI + .5),
                    y: 1 - .5 * (r * (wd + _d * n + i * (Md + Ad * n)) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e) {
                t1 = (2 * t1 - .5) * Math.PI;
                let r = e = (2 * (1 - e) - 1) * Math.PI, n = r * r, i = n * n * n;
                for(let t1, s, a, o = 0; o < 12 && (s = r * (wd + _d * n + i * (Md + Ad * n)) - e, a = wd + 3 * _d * n + i * (7 * Md + 9 * Ad * n), t1 = s / a, r = Q(r - t1, -Math.PI / 3, Math.PI / 3), n = r * r, i = n * n * n, !(Math.abs(t1) < 1e-12)); ++o);
                const s = Sd * t1 * (wd + 3 * _d * n + i * (7 * Md + 9 * Ad * n)) / Math.cos(r), a = Math.asin(Math.sin(r) / Sd), o = Q(180 * s / Math.PI, -180, 180), l = Q(180 * a / Math.PI, -fl, fl);
                return new rl(o, l);
            }
        }
        class Pd extends bd {
            constructor(t1){
                super(t1), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(t1, e) {
                return {
                    x: .5 + t1 / 360,
                    y: .5 - e / 360,
                    z: 0
                };
            }
            unproject(t1, e) {
                const r = 360 * (t1 - .5), n = Q(360 * (.5 - e), -fl, fl);
                return new rl(r, n);
            }
        }
        const zd = Math.PI / 2;
        function kd(t1) {
            return Math.tan((zd + t1) / 2);
        }
        class Td extends bd {
            constructor(t1){
                super(t1), this.center = t1.center || [
                    0,
                    30
                ];
                const [e, r] = this.parallels = t1.parallels || [
                    30,
                    30
                ];
                let n = Y(e), i = Y(r);
                this.southernCenter = n + i < 0, this.southernCenter && (n = -n, i = -i);
                const s = Math.cos(n), a = kd(n);
                this.n = n === i ? Math.sin(n) : Math.log(s / Math.cos(i)) / Math.log(kd(i) / a), this.f = s * Math.pow(kd(n), this.n) / this.n;
            }
            project(t1, e) {
                e = Y(e), this.southernCenter && (e = -e), t1 = Y(t1 - this.center[0]);
                const r = 1e-6, { n: n, f: i } = this;
                i > 0 ? e < -zd + r && (e = -zd + r) : e > zd - r && (e = zd - r);
                const s = i / Math.pow(kd(e), n);
                let a = s * Math.sin(n * t1), o = i - s * Math.cos(n * t1);
                return a = .5 * (a / Math.PI + .5), o = .5 * (o / Math.PI + .5), {
                    x: a,
                    y: this.southernCenter ? o : 1 - o,
                    z: 0
                };
            }
            unproject(t1, e) {
                t1 = (2 * t1 - .5) * Math.PI, this.southernCenter && (e = 1 - e), e = (2 * (1 - e) - .5) * Math.PI;
                const { n: r, f: n } = this, i = n - e, s = Math.sign(i), a = Math.sign(r) * Math.sqrt(t1 * t1 + i * i);
                let o = Math.atan2(t1, Math.abs(i)) * s;
                i * r < 0 && (o -= Math.PI * Math.sign(t1) * s);
                const l = Q(Z(o / r) + this.center[0], -180, 180), u = Q(Z(2 * Math.atan(Math.pow(n / a, 1 / r)) - zd), -fl, fl);
                return new rl(l, this.southernCenter ? -u : u);
            }
        }
        class Ed extends bd {
            constructor(t1){
                super(t1), this.wrap = !0, this.supportsWorldCopies = !0, this.supportsTerrain = !0, this.supportsFog = !0, this.supportsFreeCamera = !0, this.isReprojectedInTileSpace = !1, this.unsupportedLayers = [], this.range = null;
            }
            project(t1, e) {
                return {
                    x: ol(t1),
                    y: ll(e),
                    z: 0
                };
            }
            unproject(t1, e) {
                const r = cl(t1), n = hl(e);
                return new rl(r, n);
            }
        }
        const Bd = Y(fl);
        class Vd extends bd {
            project(t1, e) {
                const r = (e = Y(e)) * e, n = r * r;
                return {
                    x: .5 * ((t1 = Y(t1)) * (.8707 - .131979 * r + n * (n * (.003971 * r - .001529 * n) - .013791)) / Math.PI + .5),
                    y: 1 - .5 * (e * (1.007226 + r * (.015085 + n * (.028874 * r - .044475 - .005916 * n))) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e) {
                t1 = (2 * t1 - .5) * Math.PI;
                let r = e = (2 * (1 - e) - 1) * Math.PI, n = 25, i = 0, s = r * r;
                do {
                    s = r * r;
                    const t1 = s * s;
                    i = (r * (1.007226 + s * (.015085 + t1 * (.028874 * s - .044475 - .005916 * t1))) - e) / (1.007226 + s * (.045255 + t1 * (.259866 * s - .311325 - .005916 * 11 * t1))), r = Q(r - i, -Bd, Bd);
                }while (Math.abs(i) > 1e-6 && --n > 0);
                s = r * r;
                const a = Q(Z(t1 / (.8707 + s * (s * (s * s * s * (.003971 - .001529 * s) - .013791) - .131979))), -180, 180), o = Z(r);
                return new rl(a, o);
            }
        }
        const Cd = Y(fl);
        class Rd extends bd {
            project(t1, e) {
                e = Y(e), t1 = Y(t1);
                const r = Math.cos(e), n = 2 / Math.PI, i = Math.acos(r * Math.cos(t1 / 2)), s = Math.sin(i) / i, a = .5 * (t1 * n + 2 * r * Math.sin(t1 / 2) / s) || 0, o = .5 * (e + Math.sin(e) / s) || 0;
                return {
                    x: .5 * (a / Math.PI + .5),
                    y: 1 - .5 * (o / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e) {
                let r = t1 = (2 * t1 - .5) * Math.PI, n = e = (2 * (1 - e) - 1) * Math.PI, i = 25;
                const s = 1e-6;
                let a = 0, o = 0;
                do {
                    const i = Math.cos(n), s = Math.sin(n), l = 2 * s * i, u = s * s, c = i * i, h = Math.cos(r / 2), p = Math.sin(r / 2), f = 2 * h * p, d = p * p, m = 1 - c * h * h, y = m ? 1 / m : 0, g = m ? Math.acos(i * h) * Math.sqrt(1 / m) : 0, x = .5 * (2 * g * i * p + 2 * r / Math.PI) - t1, b = .5 * (g * s + n) - e, v = .5 * y * (c * d + g * i * h * u) + 1 / Math.PI, w = y * (f * l / 4 - g * s * p), _ = .125 * y * (l * p - g * s * c * f), M = .5 * y * (u * h + g * d * i) + .5, A = w * _ - M * v;
                    a = (b * w - x * M) / A, o = (x * _ - b * v) / A, r = Q(r - a, -Math.PI, Math.PI), n = Q(n - o, -Cd, Cd);
                }while ((Math.abs(a) > s || Math.abs(o) > s) && --i > 0);
                return new rl(Z(r), Z(n));
            }
        }
        class Dd extends bd {
            constructor(t1){
                super(t1), this.center = t1.center || [
                    0,
                    0
                ], this.parallels = t1.parallels || [
                    0,
                    0
                ], this.cosPhi = Math.max(.01, Math.cos(Y(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(t1, e) {
                const { scale: r, cosPhi: n } = this;
                return {
                    x: Y(t1) * n * r + .5,
                    y: -Math.sin(Y(e)) / n * r + .5,
                    z: 0
                };
            }
            unproject(t1, e) {
                const { scale: r, cosPhi: n } = this, i = -(e - .5) / r, s = Q(Z((t1 - .5) / r) / n, -180, 180), a = Math.asin(Q(i * n, -1, 1)), o = Q(Z(a), -fl, fl);
                return new rl(s, o);
            }
        }
        class Ld extends Ed {
            constructor(t1){
                super(t1), this.requiresDraping = !0, this.supportsWorldCopies = !1, this.supportsFog = !0, this.zAxisUnit = "pixels", this.unsupportedLayers = [
                    "debug"
                ], this.range = [
                    3,
                    5
                ];
            }
            projectTilePoint(t1, e, r) {
                const n = zu(t1, e, r), i = Eu(_u(r));
                return O.vec3.transformMat4(n, n, i), {
                    x: n[0],
                    y: n[1],
                    z: n[2]
                };
            }
            locationPoint(t1, e) {
                const r = Qo(e.lat, e.lng), n = O.vec3.normalize([], r), i = t1.elevation ? t1.elevation.getAtPointOrZero(t1.locationCoordinate(e), t1._centerAltitude) : t1._centerAltitude, s = ul(1, 0) * Hr * i;
                O.vec3.scaleAndAdd(r, r, n, s);
                const a = O.mat4.identity(new Float64Array(16));
                return O.mat4.multiply(a, t1.pixelMatrix, t1.globeMatrix), O.vec3.transformMat4(r, r, a), new q(r[0], r[1]);
            }
            pixelsPerMeter(t1, e) {
                return ul(1, 0) * e;
            }
            pixelSpaceConversion(t1, e, r) {
                const n = ul(1, t1) * e, i = ke(ul(1, 45) * e, n, r);
                return this.pixelsPerMeter(t1, e) / i;
            }
            createTileMatrix(t1, e, r) {
                const n = Bu(_u(r.canonical));
                return O.mat4.multiply(new Float64Array(16), t1.globeMatrix, n);
            }
            createInversionMatrix(t1, e) {
                const { center: r } = t1, n = Eu(_u(e));
                return O.mat4.rotateY(n, n, Y(r.lng)), O.mat4.rotateX(n, n, Y(r.lat)), O.mat4.scale(n, n, [
                    t1._pixelsPerMercatorPixel,
                    t1._pixelsPerMercatorPixel,
                    1
                ]), Float32Array.from(n);
            }
            pointCoordinate(t1, e, r, n) {
                return bu(t1, e, r, !0) || new xl(0, 0);
            }
            pointCoordinate3D(t1, e, r) {
                const n = this.pointCoordinate(t1, e, r, 0);
                return [
                    n.x,
                    n.y,
                    n.z
                ];
            }
            isPointAboveHorizon(t1, e) {
                return !bu(t1, e.x, e.y, !1);
            }
            farthestPixelDistance(t1) {
                const e = function(t1, e) {
                    const r = t1.cameraToCenterDistance, n = t1._centerAltitude * e, i = t1._camera, s = t1._camera.forward(), a = O.vec3.add([], O.vec3.scale([], s, -r), [
                        0,
                        0,
                        n
                    ]), o = t1.worldSize / (2 * Math.PI), l = [
                        0,
                        0,
                        -o
                    ], u = t1.width / t1.height, c = Math.tan(t1.fovAboveCenter), h = O.vec3.scale([], i.up(), c), p = O.vec3.scale([], i.right(), c * u), f = O.vec3.normalize([], O.vec3.add([], O.vec3.add([], s, h), p)), d = [];
                    let m;
                    if (new uu(a, f).closestPointOnSphere(l, o, d)) {
                        const e = O.vec3.add([], d, l), r = O.vec3.sub([], e, a);
                        m = Math.cos(t1.fovAboveCenter) * O.vec3.length(r);
                    } else {
                        const t1 = O.vec3.sub([], a, l), e = O.vec3.sub([], l, a);
                        O.vec3.normalize(e, e);
                        const r = O.vec3.length(t1) - o;
                        m = Math.sqrt(r * (r + 2 * o));
                        const n = Math.acos(m / (o + r)) - Math.acos(O.vec3.dot(s, e));
                        m *= Math.cos(n);
                    }
                    return 1.01 * m;
                }(t1, this.pixelsPerMeter(t1.center.lat, t1.worldSize)), r = Du(t1.zoom);
                if (r > 0) {
                    const n = md(t1, ul(1, t1.center.lat) * t1.worldSize), i = t1.worldSize / (2 * Math.PI), s = Math.max(t1.width, t1.height) / t1.worldSize * Math.PI;
                    return ke(e, n + i * (1 - Math.cos(s)), Math.pow(r, 10));
                }
                return e;
            }
            upVector(t1, e, r) {
                return zu(e, r, t1, 1);
            }
            upVectorScale(t1) {
                return {
                    metersToTile: gu(ku(_u(t1)))
                };
            }
        }
        function Fd(t1) {
            const e = t1.parallels, r = !!e && Math.abs(e[0] + e[1]) < .01;
            switch(t1.name){
                case "mercator":
                    return new Ed(t1);
                case "equirectangular":
                    return new Pd(t1);
                case "naturalEarth":
                    return new Vd(t1);
                case "equalEarth":
                    return new Id(t1);
                case "winkelTripel":
                    return new Rd(t1);
                case "albers":
                    return r ? new Dd(t1) : new vd(t1);
                case "lambertConformalConic":
                    return r ? new Dd(t1) : new Td(t1);
                case "globe":
                    return new Ld(t1);
            }
            throw new Error(`Invalid projection name: ${t1.name}`);
        }
        const Od = ch.VectorTileFeature.types, Ud = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function jd(t1, e, r, n, i, s, a, o, l, u, c, h, p) {
            const f = o ? Math.min(ud, Math.round(o[0])) : 0, d = o ? Math.min(ud, Math.round(o[1])) : 0;
            t1.emplaceBack(e, r, Math.round(32 * n), Math.round(32 * i), s, a, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function Nd(t1, e, r) {
            t1.emplaceBack(e, r);
        }
        function qd(t1, e, r, n, i, s, a) {
            t1.emplaceBack(e, r, n, i, s, a);
        }
        function $d(t1, e, r, n, i) {
            t1.emplaceBack(e, r, n, i), t1.emplaceBack(e, r, n, i), t1.emplaceBack(e, r, n, i), t1.emplaceBack(e, r, n, i);
        }
        function Gd(t1) {
            for (const e of t1.sections)if (vs(e.text)) return !0;
            return !1;
        }
        class Xd {
            constructor(t1){
                this.layoutVertexArray = new za, this.indexArray = new Da, this.programConfigurations = t1, this.segments = new co, this.dynamicLayoutVertexArray = new Ma, this.opacityVertexArray = new Ta, this.placedSymbolArray = new Ja, this.iconTransitioningVertexArray = new Ea, this.globeExtVertexArray = new ka, this.zOffsetVertexArray = new Oa;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
            }
            upload(t1, e, r, n, i) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Rp.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray, e), this.dynamicLayoutVertexBuffer = t1.createVertexBuffer(this.dynamicLayoutVertexArray, Lp.members, !0), this.opacityVertexBuffer = t1.createVertexBuffer(this.opacityVertexArray, Ud, !0), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = t1.createVertexBuffer(this.iconTransitioningVertexArray, Op.members, !0)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = t1.createVertexBuffer(this.globeExtVertexArray, Dp.members, !0)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || i) && (this.zOffsetVertexBuffer = t1.createVertexBuffer(this.zOffsetVertexArray, Fp.members, !0)), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t1));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy());
            }
        }
        os(Xd, "SymbolBuffers");
        class Yd {
            constructor(t1, e, r){
                this.layoutVertexArray = new t1, this.layoutAttributes = e, this.indexArray = new r, this.segments = new co, this.collisionVertexArray = new Ra, this.collisionVertexArrayExt = new Ma;
            }
            upload(t1) {
                this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t1.createVertexBuffer(this.collisionVertexArray, Up.members, !0), this.collisionVertexBufferExt = t1.createVertexBuffer(this.collisionVertexArrayExt, jp.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
            }
        }
        os(Yd, "CollisionBuffers");
        class Zd {
            constructor(t1){
                this.collisionBoxArray = t1.collisionBoxArray, this.zoom = t1.zoom, this.lut = t1.lut, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.pixelRatio = t1.pixelRatio, this.sourceLayerIndex = t1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.hasAnyIconTextFit = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = O.mat4.identity([]), this.placementViewportMatrix = O.mat4.identity([]);
                const e = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = Xp(this.zoom, e["text-size"]), this.iconSizeData = Xp(this.zoom, e["icon-size"]);
                const r = this.layers[0].layout, n = r.get("symbol-sort-key"), i = r.get("symbol-z-order");
                this.canOverlap = r.get("text-allow-overlap") || r.get("icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== i && void 0 !== n.constantOr(1), this.sortFeaturesByY = ("viewport-y" === i || "auto" === i && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = r.get("text-writing-mode").map((t1)=>ff[t1]), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.sourceID = t1.sourceID, this.projection = t1.projection, this.hasAnyZOffset = !1, this.zOffsetSortDirty = !1, this.zOffsetBuffersNeedUpload = r.get("symbol-z-elevate"), this.activeReplacements = [], this.replacementUpdateTime = 0;
            }
            createArrays() {
                this.text = new Xd(new Fo(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (t1)=>t1.startsWith("text") || t1.startsWith("symbol"))), this.icon = new Xd(new Fo(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (t1)=>t1.startsWith("icon") || t1.startsWith("symbol"))), this.glyphOffsetArray = new eo, this.lineVertexArray = new ro, this.symbolInstances = new to;
            }
            calculateGlyphDependencies(t1, e, r, n, i) {
                for(let r = 0; r < t1.length; r++){
                    const s = t1.codePointAt(r);
                    if (void 0 === s) break;
                    if (e[s] = !0, n && i && s <= 65535) {
                        const n = Kp[t1.charAt(r)];
                        n && (e[n.charCodeAt(0)] = !0);
                    }
                }
            }
            updateFootprints(t1, e) {}
            updateReplacement(t1, e) {
                if (e.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = e.updateTime;
                const r = e.getReplacementRegionsForTile(t1.toUnwrapped(), !0);
                return !wh(this.activeReplacements, r) && (this.activeReplacements = r, !0);
            }
            populate(t1, e, r, n) {
                const i = this.layers[0], s = i.layout, a = "globe" === this.projection.name, o = s.get("text-font"), l = s.get("text-field"), u = s.get("icon-image"), c = ("constant" !== l.value.kind || l.value.value instanceof Qe && !l.value.value.isEmpty() || l.value.value.toString().length > 0) && ("constant" !== o.value.kind || o.value.value.length > 0), h = "constant" !== u.value.kind || !!u.value.value || Object.keys(u.parameters).length > 0, p = s.get("symbol-sort-key");
                if (this.features = [], !c && !h) return;
                const f = e.iconDependencies, d = e.glyphDependencies, m = e.availableImages, y = new Vs(this.zoom);
                for (const { feature: e, id: l, index: u, sourceLayerIndex: g } of t1){
                    const t1 = i._featureFilter.needGeometry, x = Pl(e, t1);
                    if (!i._featureFilter.filter(y, x, r)) continue;
                    if (t1 || (x.geometry = Il(e, r, n)), a && 1 !== e.type && r.z <= 5) {
                        const t1 = x.geometry, e = .98078528056, n = (t1, n)=>{
                            const i = zu(t1.x, t1.y, r, 1), s = zu(n.x, n.y, r, 1);
                            return O.vec3.dot(i, s) < e;
                        };
                        for(let e = 0; e < t1.length; e++)t1[e] = _l(t1[e], n);
                    }
                    let b, v;
                    if (c) {
                        const t1 = i.getValueAndResolveTokens("text-field", x, r, m), e = Qe.factory(t1);
                        Gd(e) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === Ts() || this.hasRTLText && Bs.isParsed()) && (b = Hp(e, i, x));
                    }
                    if (h) {
                        const t1 = i.getValueAndResolveTokens("icon-image", x, r, m);
                        v = t1 instanceof tr ? t1 : tr.fromString(t1);
                    }
                    if (!b && !v) continue;
                    const w = this.sortFeaturesByKey ? p.evaluate(x, {}, r) : void 0;
                    if (this.features.push({
                        id: l,
                        text: b,
                        icon: v,
                        index: u,
                        sourceLayerIndex: g,
                        geometry: x.geometry,
                        properties: e.properties,
                        type: Od[e.type],
                        sortKey: w
                    }), v && (f[v.namePrimary] = !0, v.nameSecondary && (f[v.nameSecondary] = !0)), b) {
                        const t1 = o.evaluate(x, {}, r).join(","), e = "map" === s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(ff.vertical) >= 0;
                        for (const r of b.sections)if (r.image) f[r.image.namePrimary] = !0;
                        else {
                            const n = fs(b.toString()), i = r.fontStack || t1, s = d[i] = d[i] || {};
                            this.calculateGlyphDependencies(r.text, s, e, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === s.get("symbol-placement") && (this.features = function(t1) {
                    const e = {}, r = {}, n = [];
                    let i = 0;
                    function s(e) {
                        n.push(t1[e]), i++;
                    }
                    function a(t1, e, i) {
                        const s = r[t1];
                        return delete r[t1], r[e] = s, n[s].geometry[0].pop(), n[s].geometry[0] = n[s].geometry[0].concat(i[0]), s;
                    }
                    function o(t1, r, i) {
                        const s = e[r];
                        return delete e[r], e[t1] = s, n[s].geometry[0].shift(), n[s].geometry[0] = i[0].concat(n[s].geometry[0]), s;
                    }
                    function l(t1, e, r) {
                        const n = r ? e[0][e[0].length - 1] : e[0][0];
                        return `${t1}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < t1.length; u++){
                        const c = t1[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            s(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in r && d in e && r[f] !== e[d]) {
                            const t1 = o(f, d, h), i = a(f, d, n[t1].geometry);
                            delete e[f], delete r[d], r[l(p, n[i].geometry, !0)] = i, n[t1].geometry = null;
                        } else f in r ? a(f, d, h) : d in e ? o(f, d, h) : (s(u), e[f] = i - 1, r[d] = i - 1);
                    }
                    return n.filter((t1)=>t1.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((t1, e)=>t1.sortKey - e.sortKey);
            }
            update(t1, e, r, n, i) {
                const s = 0 !== Object.keys(t1).length;
                if (s && !this.stateDependentLayers.length) return;
                const a = s ? this.stateDependentLayers : this.layers;
                this.text.programConfigurations.updatePaintArrays(t1, e, a, r, n, i), this.icon.programConfigurations.updatePaintArrays(t1, e, a, r, n, i);
            }
            updateZOffset() {
                const t1 = (t1, e, n)=>{
                    r += e, r > t1.length && t1.resize(r);
                    for(let i = -e; i < 0; i++)t1.emplace(i + r, n);
                }, e = (t1, e, r)=>{
                    n += e, n > t1.length && t1.resize(n);
                    for(let i = -e; i < 0; i++)t1.emplace(i + n, r);
                };
                if (!this.zOffsetBuffersNeedUpload) return;
                this.zOffsetBuffersNeedUpload = !1;
                let r = 0, n = 0;
                for(let r = 0; r < this.symbolInstances.length; r++){
                    const n = this.symbolInstances.get(r), { numHorizontalGlyphVertices: i, numVerticalGlyphVertices: s, numIconVertices: a } = n, o = n.zOffset, l = a > 0;
                    if ((i > 0 || s > 0) && (t1(this.text.zOffsetVertexArray, i, o), t1(this.text.zOffsetVertexArray, s, o)), l) {
                        const { placedIconSymbolIndex: t1, verticalPlacedIconSymbolIndex: r } = n;
                        t1 >= 0 && e(this.icon.zOffsetVertexArray, a, o), r >= 0 && e(this.icon.zOffsetVertexArray, n.numVerticalIconVertices, o);
                    }
                }
                this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t1) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t1), this.iconCollisionBox.upload(t1)), this.text.upload(t1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.icon.upload(t1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            getProjection() {
                return this.projectionInstance || (this.projectionInstance = Fd(this.projection)), this.projectionInstance;
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t1, e) {
                const r = this.lineVertexArray.length;
                if (void 0 !== t1.segment) for (const { x: t1, y: r } of e)this.lineVertexArray.emplaceBack(t1, r);
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(t1, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m) {
                const y = t1.indexArray, g = t1.layoutVertexArray, x = t1.globeExtVertexArray, b = t1.segments.prepareSegment(4 * e.length, g, y, this.canOverlap ? s.sortKey : void 0), v = this.glyphOffsetArray.length, w = b.vertexLength, _ = this.allowVerticalPlacement && a === ff.vertical ? Math.PI / 2 : 0, M = s.text && s.text.sections;
                for(let n = 0; n < e.length; n++){
                    const { tl: i, tr: a, bl: u, br: c, texPrimary: h, texSecondary: v, pixelOffsetTL: w, pixelOffsetBR: A, minFontScaleX: S, minFontScaleY: I, glyphOffset: P, isSDF: z, sectionIndex: k } = e[n], T = b.vertexLength, E = P[1];
                    if (jd(g, l.x, l.y, i.x, E + i.y, h.x, h.y, r, z, w.x, w.y, S, I), jd(g, l.x, l.y, a.x, E + a.y, h.x + h.w, h.y, r, z, A.x, w.y, S, I), jd(g, l.x, l.y, u.x, E + u.y, h.x, h.y + h.h, r, z, w.x, A.y, S, I), jd(g, l.x, l.y, c.x, E + c.y, h.x + h.w, h.y + h.h, r, z, A.x, A.y, S, I), o) {
                        const { x: e, y: r, z: n } = o.anchor, [i, s, a] = o.up;
                        qd(x, e, r, n, i, s, a), qd(x, e, r, n, i, s, a), qd(x, e, r, n, i, s, a), qd(x, e, r, n, i, s, a), $d(t1.dynamicLayoutVertexArray, e, r, n, _);
                    } else $d(t1.dynamicLayoutVertexArray, l.x, l.y, l.z, _);
                    if (m) {
                        const e = v || h;
                        Nd(t1.iconTransitioningVertexArray, e.x, e.y), Nd(t1.iconTransitioningVertexArray, e.x + e.w, e.y), Nd(t1.iconTransitioningVertexArray, e.x, e.y + e.h), Nd(t1.iconTransitioningVertexArray, e.x + e.w, e.y + e.h);
                    }
                    y.emplaceBack(T, T + 1, T + 2), y.emplaceBack(T + 1, T + 2, T + 3), b.vertexLength += 4, b.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(P[0]), n !== e.length - 1 && k === e[n + 1].sectionIndex || t1.programConfigurations.populatePaintArrays(g.length, s, s.index, {}, p, f, d, M && M[k]);
                }
                const A = o ? o.anchor : l;
                t1.placedSymbolArray.emplaceBack(A.x, A.y, A.z, l.x, l.y, v, this.glyphOffsetArray.length - v, w, u, c, l.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], a, 0, !1, 0, h, 0);
            }
            _commitLayoutVertex(t1, e, r, n, i, s, a) {
                t1.emplaceBack(e, r, n, i, s, Math.round(a.x), Math.round(a.y));
            }
            _addCollisionDebugVertices(t1, e, r, n, i, s, a) {
                const o = r.segments.prepareSegment(4, r.layoutVertexArray, r.indexArray), l = o.vertexLength, u = a.tileAnchorX, c = a.tileAnchorY;
                for(let t1 = 0; t1 < 4; t1++)r.collisionVertexArray.emplaceBack(0, 0, 0, 0, 0, 0);
                this._commitDebugCollisionVertexUpdate(r.collisionVertexArrayExt, e, t1.padding, a.zOffset), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new q(t1.x1, t1.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new q(t1.x2, t1.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new q(t1.x2, t1.y2)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new q(t1.x1, t1.y2)), o.vertexLength += 4;
                const h = r.indexArray;
                h.emplaceBack(l, l + 1), h.emplaceBack(l + 1, l + 2), h.emplaceBack(l + 2, l + 3), h.emplaceBack(l + 3, l), o.primitiveLength += 4;
            }
            _addTextDebugCollisionBoxes(t1, e, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceTextSize(t1, s, e, a);
                    this._addCollisionDebugVertices(n, i, this.textCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, s);
                }
            }
            _addIconDebugCollisionBoxes(t1, e, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceIconSize(t1, e, s.placedIconSymbolIndex);
                    this._addCollisionDebugVertices(n, i, this.iconCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, s);
                }
            }
            generateCollisionDebugBuffers(t1, e) {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Yd(Va, Np.members, Ea), this.iconCollisionBox = new Yd(Va, Np.members, Ea);
                const r = Zp(this.iconSizeData, t1), n = Zp(this.textSizeData, t1);
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const s = this.symbolInstances.get(i);
                    this._addTextDebugCollisionBoxes(n, t1, e, s.textBoxStartIndex, s.textBoxEndIndex, s), this._addTextDebugCollisionBoxes(n, t1, e, s.verticalTextBoxStartIndex, s.verticalTextBoxEndIndex, s), this._addIconDebugCollisionBoxes(r, t1, e, s.iconBoxStartIndex, s.iconBoxEndIndex, s), this._addIconDebugCollisionBoxes(r, t1, e, s.verticalIconBoxStartIndex, s.verticalIconBoxEndIndex, s);
                }
            }
            getSymbolInstanceTextSize(t1, e, r, n) {
                const i = this.text.placedSymbolArray.get(e.rightJustifiedTextSymbolIndex >= 0 ? e.rightJustifiedTextSymbolIndex : e.centerJustifiedTextSymbolIndex >= 0 ? e.centerJustifiedTextSymbolIndex : e.leftJustifiedTextSymbolIndex >= 0 ? e.leftJustifiedTextSymbolIndex : e.verticalPlacedTextSymbolIndex >= 0 ? e.verticalPlacedTextSymbolIndex : n), s = Yp(this.textSizeData, t1, i) / $p;
                return this.tilePixelRatio * s;
            }
            getSymbolInstanceIconSize(t1, e, r) {
                const n = this.icon.placedSymbolArray.get(r), i = Yp(this.iconSizeData, t1, n);
                return this.tilePixelRatio * i;
            }
            _commitDebugCollisionVertexUpdate(t1, e, r, n) {
                t1.emplaceBack(e, -r, -r, n), t1.emplaceBack(e, r, -r, n), t1.emplaceBack(e, r, r, n), t1.emplaceBack(e, -r, r, n);
            }
            _updateTextDebugCollisionBoxes(t1, e, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceTextSize(t1, s, e, a);
                    this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, i, n.padding, s.zOffset);
                }
            }
            _updateIconDebugCollisionBoxes(t1, e, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceIconSize(t1, e, s.placedIconSymbolIndex);
                    this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, i, n.padding, s.zOffset);
                }
            }
            updateCollisionDebugBuffers(t1, e) {
                if (!this.hasDebugData()) return;
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
                const r = Zp(this.iconSizeData, t1), n = Zp(this.textSizeData, t1);
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const s = this.symbolInstances.get(i);
                    this._updateTextDebugCollisionBoxes(n, t1, e, s.textBoxStartIndex, s.textBoxEndIndex, s), this._updateTextDebugCollisionBoxes(n, t1, e, s.verticalTextBoxStartIndex, s.verticalTextBoxEndIndex, s), this._updateIconDebugCollisionBoxes(r, t1, e, s.iconBoxStartIndex, s.iconBoxEndIndex, s), this._updateIconDebugCollisionBoxes(r, t1, e, s.verticalIconBoxStartIndex, s.verticalIconBoxEndIndex, s);
                }
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
            }
            _deserializeCollisionBoxesForSymbol(t1, e, r, n, i, s, a, o, l) {
                const u = {};
                if (e < r) {
                    const { x1: r, y1: n, x2: i, y2: s, padding: a, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(e);
                    u.textBox = {
                        x1: r,
                        y1: n,
                        x2: i,
                        y2: s,
                        padding: a,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.textFeatureIndex = f;
                }
                if (n < i) {
                    const { x1: e, y1: r, x2: i, y2: s, padding: a, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(n);
                    u.verticalTextBox = {
                        x1: e,
                        y1: r,
                        x2: i,
                        y2: s,
                        padding: a,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.verticalTextFeatureIndex = f;
                }
                if (s < a) {
                    const { x1: e, y1: r, x2: n, y2: i, padding: a, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(s);
                    u.iconBox = {
                        x1: e,
                        y1: r,
                        x2: n,
                        y2: i,
                        padding: a,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.iconFeatureIndex = f;
                }
                if (o < l) {
                    const { x1: e, y1: r, x2: n, y2: i, padding: s, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(o);
                    u.verticalIconBox = {
                        x1: e,
                        y1: r,
                        x2: n,
                        y2: i,
                        padding: s,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.verticalIconFeatureIndex = f;
                }
                return u;
            }
            deserializeCollisionBoxes(t1) {
                this.collisionArrays = [];
                for(let e = 0; e < this.symbolInstances.length; e++){
                    const r = this.symbolInstances.get(e);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            hasIconTextFit() {
                return this.hasAnyIconTextFit;
            }
            addIndicesForPlacedSymbol(t1, e) {
                const r = t1.placedSymbolArray.get(e), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let e = r.vertexStartIndex; e < n; e += 4)t1.indexArray.emplaceBack(e, e + 1, e + 2), t1.indexArray.emplaceBack(e + 1, e + 2, e + 3);
            }
            getSortedSymbolIndexes(t1) {
                if (this.sortedAngle === t1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const e = Math.sin(t1), r = Math.cos(t1), n = [], i = [], s = [];
                for(let t1 = 0; t1 < this.symbolInstances.length; ++t1){
                    s.push(t1);
                    const a = this.symbolInstances.get(t1);
                    n.push(0 | Math.round(e * a.tileAnchorX + r * a.tileAnchorY)), i.push(a.featureIndex);
                }
                return s.sort((t1, e)=>n[t1] - n[e] || i[e] - i[t1]), s;
            }
            getSortedIndexesByZOffset() {
                if (!this.zOffsetSortDirty) return this.symbolInstanceIndexesSortedZOffset;
                if (!this.symbolInstanceIndexesSortedZOffset) {
                    this.symbolInstanceIndexesSortedZOffset = [];
                    for(let t1 = 0; t1 < this.symbolInstances.length; ++t1)this.symbolInstanceIndexesSortedZOffset.push(t1);
                }
                return this.zOffsetSortDirty = !1, this.symbolInstanceIndexesSortedZOffset.sort((t1, e)=>this.symbolInstances.get(e).zOffset - this.symbolInstances.get(t1).zOffset);
            }
            addToSortKeyRanges(t1, e) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === e ? r.symbolInstanceEnd = t1 + 1 : this.sortKeyRanges.push({
                    sortKey: e,
                    symbolInstanceStart: t1,
                    symbolInstanceEnd: t1 + 1
                });
            }
            sortFeatures(t1) {
                if (this.sortFeaturesByY && this.sortedAngle !== t1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t1), this.sortedAngle = t1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const t1 of this.symbolInstanceIndexes){
                        const e = this.symbolInstances.get(t1);
                        this.featureSortOrder.push(e.featureIndex);
                        const { rightJustifiedTextSymbolIndex: r, centerJustifiedTextSymbolIndex: n, leftJustifiedTextSymbolIndex: i, verticalPlacedTextSymbolIndex: s, placedIconSymbolIndex: a, verticalPlacedIconSymbolIndex: o } = e;
                        r >= 0 && this.addIndicesForPlacedSymbol(this.text, r), n >= 0 && n !== r && this.addIndicesForPlacedSymbol(this.text, n), i >= 0 && i !== n && i !== r && this.addIndicesForPlacedSymbol(this.text, i), s >= 0 && this.addIndicesForPlacedSymbol(this.text, s), a >= 0 && this.addIndicesForPlacedSymbol(this.icon, a), o >= 0 && this.addIndicesForPlacedSymbol(this.icon, o);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
        }
        let Wd, Hd, Kd;
        os(Zd, "SymbolBucket", {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), Zd.addDynamicAttributes = $d;
        class Jd {
            constructor(t1){
                this.type = t1.property.overrides ? t1.property.overrides.runtimeType : Re, this.defaultValue = t1;
            }
            evaluate(t1) {
                if (t1.formattedSection) {
                    const e = this.defaultValue.property.overrides;
                    if (e && e.hasOverride(t1.formattedSection)) return e.getOverride(t1.formattedSection);
                }
                return t1.feature && t1.featureState ? this.defaultValue.evaluate(t1.feature, t1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t1) {
                this.defaultValue.isConstant() || t1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        os(Jd, "FormatSectionOverride", {
            omit: [
                "defaultValue"
            ]
        });
        const Qd = ()=>Kd || (Kd = {
                layout: Wd || (Wd = new Gs({
                    "symbol-placement": new Ns(Xs.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new Ns(Xs.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new Ns(Xs.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new qs(Xs.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new Ns(Xs.layout_symbol["symbol-z-order"]),
                    "symbol-z-elevate": new Ns(Xs.layout_symbol["symbol-z-elevate"]),
                    "icon-allow-overlap": new Ns(Xs.layout_symbol["icon-allow-overlap"]),
                    "icon-ignore-placement": new Ns(Xs.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new Ns(Xs.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new Ns(Xs.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new qs(Xs.layout_symbol["icon-size"]),
                    "icon-text-fit": new qs(Xs.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new qs(Xs.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new qs(Xs.layout_symbol["icon-image"]),
                    "icon-rotate": new qs(Xs.layout_symbol["icon-rotate"]),
                    "icon-padding": new Ns(Xs.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new Ns(Xs.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new qs(Xs.layout_symbol["icon-offset"]),
                    "icon-anchor": new qs(Xs.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new Ns(Xs.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new Ns(Xs.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new Ns(Xs.layout_symbol["text-rotation-alignment"]),
                    "text-field": new qs(Xs.layout_symbol["text-field"]),
                    "text-font": new qs(Xs.layout_symbol["text-font"]),
                    "text-size": new qs(Xs.layout_symbol["text-size"]),
                    "text-max-width": new qs(Xs.layout_symbol["text-max-width"]),
                    "text-line-height": new qs(Xs.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new qs(Xs.layout_symbol["text-letter-spacing"]),
                    "text-justify": new qs(Xs.layout_symbol["text-justify"]),
                    "text-radial-offset": new qs(Xs.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new Ns(Xs.layout_symbol["text-variable-anchor"]),
                    "text-anchor": new qs(Xs.layout_symbol["text-anchor"]),
                    "text-max-angle": new Ns(Xs.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new Ns(Xs.layout_symbol["text-writing-mode"]),
                    "text-rotate": new qs(Xs.layout_symbol["text-rotate"]),
                    "text-padding": new Ns(Xs.layout_symbol["text-padding"]),
                    "text-keep-upright": new Ns(Xs.layout_symbol["text-keep-upright"]),
                    "text-transform": new qs(Xs.layout_symbol["text-transform"]),
                    "text-offset": new qs(Xs.layout_symbol["text-offset"]),
                    "text-allow-overlap": new Ns(Xs.layout_symbol["text-allow-overlap"]),
                    "text-ignore-placement": new Ns(Xs.layout_symbol["text-ignore-placement"]),
                    "text-optional": new Ns(Xs.layout_symbol["text-optional"]),
                    visibility: new Ns(Xs.layout_symbol.visibility)
                })),
                paint: Hd || (Hd = new Gs({
                    "icon-opacity": new qs(Xs.paint_symbol["icon-opacity"]),
                    "icon-occlusion-opacity": new qs(Xs.paint_symbol["icon-occlusion-opacity"]),
                    "icon-emissive-strength": new qs(Xs.paint_symbol["icon-emissive-strength"]),
                    "text-emissive-strength": new qs(Xs.paint_symbol["text-emissive-strength"]),
                    "icon-color": new qs(Xs.paint_symbol["icon-color"]),
                    "icon-halo-color": new qs(Xs.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new qs(Xs.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new qs(Xs.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new Ns(Xs.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new Ns(Xs.paint_symbol["icon-translate-anchor"]),
                    "icon-image-cross-fade": new qs(Xs.paint_symbol["icon-image-cross-fade"]),
                    "text-opacity": new qs(Xs.paint_symbol["text-opacity"]),
                    "text-occlusion-opacity": new qs(Xs.paint_symbol["text-occlusion-opacity"]),
                    "text-color": new qs(Xs.paint_symbol["text-color"], {
                        runtimeType: Oe,
                        getOverride: (t1)=>t1.textColor,
                        hasOverride: (t1)=>!!t1.textColor
                    }),
                    "text-halo-color": new qs(Xs.paint_symbol["text-halo-color"]),
                    "text-halo-width": new qs(Xs.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new qs(Xs.paint_symbol["text-halo-blur"]),
                    "text-translate": new Ns(Xs.paint_symbol["text-translate"]),
                    "text-translate-anchor": new Ns(Xs.paint_symbol["text-translate-anchor"]),
                    "icon-color-saturation": new Ns(Xs.paint_symbol["icon-color-saturation"]),
                    "icon-color-contrast": new Ns(Xs.paint_symbol["icon-color-contrast"]),
                    "icon-color-brightness-min": new Ns(Xs.paint_symbol["icon-color-brightness-min"]),
                    "icon-color-brightness-max": new Ns(Xs.paint_symbol["icon-color-brightness-max"]),
                    "symbol-z-offset": new qs(Xs.paint_symbol["symbol-z-offset"]),
                    "symbol-elevation-reference": new Ns(Xs.paint_symbol["symbol-elevation-reference"])
                }))
            }, Kd);
        class tm extends pa {
            constructor(t1, e, r, n){
                super(t1, Qd(), e, r, n), this._colorAdjustmentMatrix = O.mat4.identity([]), this.hasInitialOcclusionOpacityProperties = void 0 !== t1.paint && ("icon-occlusion-opacity" in t1.paint || "text-occlusion-opacity" in t1.paint);
            }
            recalculate(t1, e) {
                super.recalculate(t1, e), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
                const r = this.layout.get("text-writing-mode");
                if (r) {
                    const t1 = [];
                    for (const e of r)t1.indexOf(e) < 0 && t1.push(e);
                    this.layout._values["text-writing-mode"] = t1;
                } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? [
                    "horizontal"
                ] : [
                    "horizontal",
                    "vertical"
                ];
                this._setPaintOverrides();
            }
            getColorAdjustmentMatrix(t1, e, r, n) {
                return this._saturation === t1 && this._contrast === e && this._brightnessMin === r && this._brightnessMax === n || (this._colorAdjustmentMatrix = function(t1, e, r, n) {
                    t1 = St(t1), e = At(e);
                    const i = O.mat4.create(), s = t1 / 3, a = 1 - 2 * s, o = [
                        a,
                        s,
                        s,
                        0,
                        s,
                        a,
                        s,
                        0,
                        s,
                        s,
                        a,
                        0,
                        0,
                        0,
                        0,
                        1
                    ], l = .5 - .5 * e, u = n - r;
                    return O.mat4.multiply(i, [
                        u,
                        0,
                        0,
                        0,
                        0,
                        u,
                        0,
                        0,
                        0,
                        0,
                        u,
                        0,
                        r,
                        r,
                        r,
                        1
                    ], [
                        e,
                        0,
                        0,
                        0,
                        0,
                        e,
                        0,
                        0,
                        0,
                        0,
                        e,
                        0,
                        l,
                        l,
                        l,
                        1
                    ]), O.mat4.multiply(i, i, o), i;
                }(t1, e, r, n), this._saturation = t1, this._contrast = e, this._brightnessMin = r, this._brightnessMax = n), this._colorAdjustmentMatrix;
            }
            getValueAndResolveTokens(t1, e, r, n) {
                const i = this.layout.get(t1).evaluate(e, {}, r, n), s = this._unevaluatedLayout._values[t1];
                return s.isDataDriven() || Wi(s.value) || !i ? i : function(t1, e) {
                    return e.replace(/{([^{}]+)}/g, (e, r)=>r in t1 ? String(t1[r]) : "");
                }(e.properties, i);
            }
            createBucket(t1) {
                return new Zd(t1);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            _setPaintOverrides() {
                for (const t1 of Qd().paint.overridableProperties){
                    if (!tm.hasPaintOverride(this.layout, t1)) continue;
                    const e = this.paint.get(t1), r = new Jd(e), n = new Zi(r, e.property.specification, this.scope, this.options);
                    let i = null;
                    i = "constant" === e.value.kind || "source" === e.value.kind ? new Ki("source", n) : new Ji("composite", n, e.value.zoomStops, e.value._interpolationType), this.paint._values[t1] = new Us(e.property, i, e.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(t1, e, r) {
                return !(!this.layout || e.isDataDriven() || r.isDataDriven()) && tm.hasPaintOverride(this.layout, t1);
            }
            static hasPaintOverride(t1, e) {
                const r = t1.get("text-field"), n = Qd().paint.properties[e];
                let i = !1;
                const s = (t1)=>{
                    for (const e of t1)if (n.overrides && n.overrides.hasOverride(e)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof Qe) s(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const t1 = (e)=>{
                        i || (e instanceof sr && nr(e.value) === qe ? s(e.value.sections) : e instanceof ur ? s(e.sections) : e.eachChild(t1));
                    }, e = r.value;
                    e._styleExpression && t1(e._styleExpression.expression);
                }
                return i;
            }
            getProgramIds() {
                return [
                    "symbol"
                ];
            }
            getDefaultProgramParams(t1, e, r) {
                return {
                    config: new Lo(this, {
                        zoom: e,
                        lut: r
                    }),
                    overrideFog: !1
                };
            }
        }
        let em, rm, nm, im;
        var sm = ya([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        function am(t1) {
            switch(t1){
                case WebGL2RenderingContext.RGBA8:
                    return WebGL2RenderingContext.RGBA;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.DEPTH_COMPONENT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.DEPTH_STENCIL;
                case WebGL2RenderingContext.R8:
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.RED;
            }
        }
        function om(t1) {
            switch(t1){
                case WebGL2RenderingContext.RGBA8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.UNSIGNED_SHORT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.UNSIGNED_INT_24_8;
                case WebGL2RenderingContext.R8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.FLOAT;
            }
        }
        class lm {
            constructor(t1, e, r, n){
                this.context = t1, this.format = r, this.useMipmap = n && n.useMipmap, this.texture = t1.gl.createTexture(), this.update(e, {
                    premultiply: n && n.premultiply
                });
            }
            update(t1, e) {
                const r = t1 && t1 instanceof HTMLVideoElement && 0 === t1.width ? t1.videoWidth : t1.width, n = t1 && t1 instanceof HTMLVideoElement && 0 === t1.height ? t1.videoHeight : t1.height, { context: i } = this, { gl: s } = i, { x: a, y: o } = e && e.position ? e.position : {
                    x: 0,
                    y: 0
                }, l = Math.max(a + r, this.size ? this.size[0] : 0), u = Math.max(o + n, this.size ? this.size[1] : 0);
                !this.size || this.size[0] === l && this.size[1] === u || (s.bindTexture(s.TEXTURE_2D, null), s.deleteTexture(this.texture), this.texture = s.createTexture(), this.size = null), s.bindTexture(s.TEXTURE_2D, this.texture), i.pixelStoreUnpackFlipY.set(!1), i.pixelStoreUnpack.set(1), i.pixelStoreUnpackPremultiplyAlpha.set(this.format === s.RGBA8 && (!e || !1 !== e.premultiply));
                const c = t1 instanceof HTMLImageElement || t1 instanceof HTMLCanvasElement || t1 instanceof HTMLVideoElement || t1 instanceof ImageData || ImageBitmap && t1 instanceof ImageBitmap;
                if (!this.size && l > 0 && u > 0) {
                    const t1 = this.useMipmap ? Math.floor(Math.log2(Math.max(l, u))) + 1 : 1;
                    s.texStorage2D(s.TEXTURE_2D, t1, this.format, l, u), this.size = [
                        l,
                        u
                    ];
                }
                if (this.size) {
                    if (c) s.texSubImage2D(s.TEXTURE_2D, 0, a, o, am(this.format), om(this.format), t1);
                    else {
                        const e = t1.data;
                        e && s.texSubImage2D(s.TEXTURE_2D, 0, a, o, r, n, am(this.format), om(this.format), e);
                    }
                }
                this.useMipmap && s.generateMipmap(s.TEXTURE_2D);
            }
            bind(t1, e, r = !1) {
                const { context: n } = this, { gl: i } = n;
                i.bindTexture(i.TEXTURE_2D, this.texture), t1 !== this.minFilter && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, t1), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, this.useMipmap && !r ? t1 === i.NEAREST ? i.NEAREST_MIPMAP_NEAREST : i.LINEAR_MIPMAP_LINEAR : t1), this.minFilter = t1), e !== this.wrapS && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, e), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, e), this.wrapS = e);
            }
            bindExtraParam(t1, e, r, n) {
                const { context: i } = this, { gl: s } = i;
                s.bindTexture(s.TEXTURE_2D, this.texture), e !== this.magFilter && (s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, e), this.magFilter = e), t1 !== this.minFilter && (s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, this.useMipmap ? t1 === s.NEAREST ? s.NEAREST_MIPMAP_NEAREST : s.LINEAR_MIPMAP_LINEAR : t1), this.minFilter = t1), r !== this.wrapS && (s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, r), this.wrapS = r), n !== this.wrapT && (s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, n), this.wrapT = n);
            }
            destroy() {
                const { gl: t1 } = this.context;
                t1.deleteTexture(this.texture), this.texture = null;
            }
        }
        class um {
            constructor(t1, e){
                this.context = t1, this.texture = e;
            }
            bind(t1, e) {
                const { context: r } = this, { gl: n } = r;
                n.bindTexture(n.TEXTURE_2D, this.texture), t1 !== this.minFilter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, t1), this.minFilter = t1), e !== this.wrapS && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, e), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, e), this.wrapS = e);
            }
        }
        function cm(t1, e, r, n, i, s, a, o) {
            const l = [
                t1,
                e,
                1,
                r,
                n,
                1,
                i,
                s,
                1
            ], u = [
                a,
                o,
                1
            ], c = O.mat3.adjoint([], l), [h, p, f] = O.vec3.transformMat3(u, u, c);
            return O.mat3.multiply(l, l, [
                h,
                0,
                0,
                0,
                p,
                0,
                0,
                0,
                f
            ]);
        }
        function hm(t1, e, r, n, i, s, a, o) {
            const l = function(t1, e, r, n, i, s, a, o) {
                const l = cm(0, 0, 1, 0, 1, 1, 0, 1), u = cm(t1, e, r, n, i, s, a, o), c = O.mat3.adjoint([], l);
                return O.mat3.multiply(u, u, c);
            }(t1, e, r, n, i, s, a, o);
            return [
                l[2] / l[8] / Hr,
                l[5] / l[8] / Hr
            ];
        }
        function pm(t1) {
            return [
                t1[0],
                Math.min(Math.max(t1[1], -fl), fl)
            ];
        }
        class fm extends Me {
            constructor(t1, e, r, n){
                super(), this.id = t1, this.dispatcher = r, this.coordinates = e.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.onNorthPole = !1, this.onSouthPole = !1, this.setEventedParent(n), this.options = e, this._dirty = !1;
            }
            load(t1, e) {
                if (this._loaded = e || !1, this.fire(new be("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, !this.url) return t1 && (this.coordinates = t1), this._loaded = !0, void this._finishLoading();
                this._imageRequest = ce(this.map._requestManager.transformRequest(this.url, ee.Image), (e, r)=>{
                    this._imageRequest = null, this._loaded = !0, e ? this.fire(new ve(e)) : r && (this.image = r instanceof HTMLImageElement ? Dt.getImageData(r) : r, this._dirty = !0, this.width = this.image.width, this.height = this.image.height, t1 && (this.coordinates = t1), this._finishLoading());
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(t1) {
                return t1.url ? (this._imageRequest && t1.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = t1.url, this.load(t1.coordinates, this._loaded), this) : this;
            }
            setTexture(t1) {
                if (!(t1.handle instanceof WebGLTexture)) throw new Error("The provided handle is not a WebGLTexture instance");
                return this.texture = new um(this.map.painter.context, t1.handle), this.width = t1.dimensions[0], this.height = t1.dimensions[1], this._dirty = !1, this._loaded = !0, this._finishLoading(), this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new be("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(t1) {
                this.map = t1, this.load();
            }
            onRemove(t1) {
                this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), !this.texture || this.texture instanceof um || this.texture.destroy(), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy());
            }
            setCoordinates(t1) {
                if (this.coordinates = t1, this._boundsArray = void 0, this._unsupportedCoords = !1, !t1.length) return this;
                this.onNorthPole = !1, this.onSouthPole = !1;
                let e = t1[0][1], r = t1[0][1];
                for (const n of t1)n[1] > r && (r = n[1]), n[1] < e && (e = n[1]);
                const n = (r + e) / 2;
                if (n > fl ? this.onNorthPole = !0 : n < -fl && (this.onSouthPole = !0), !this.onNorthPole && !this.onSouthPole) {
                    const e = t1.map(xl.fromLngLat);
                    this.tileID = function(t1) {
                        let e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
                        for (const s of t1)e = Math.min(e, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
                        const s = Math.max(n - e, i - r), a = Math.max(0, Math.floor(-Math.log(s) / Math.LN2)), o = Math.pow(2, a);
                        let l = Math.floor((e + n) / 2 * o);
                        return l > 1 && (l -= 1), new tu(a, l, Math.floor((r + i) / 2 * o));
                    }(e), this.minzoom = this.maxzoom = this.tileID.z;
                }
                return this.fire(new be("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            _clear() {
                this._boundsArray = void 0, this._unsupportedCoords = !1;
            }
            _prepareData(t1) {
                for(const t1 in this.tiles){
                    const e = this.tiles[t1];
                    "loaded" !== e.state && (e.state = "loaded", e.texture = this.texture);
                }
                if (this._boundsArray || this.onNorthPole || this.onSouthPole || this._unsupportedCoords) return;
                const e = yd(new tu(0, 0, 0), this.map.transform.projection), r = [
                    e.projection.project(this.coordinates[0][0], this.coordinates[0][1]),
                    e.projection.project(this.coordinates[1][0], this.coordinates[1][1]),
                    e.projection.project(this.coordinates[2][0], this.coordinates[2][1]),
                    e.projection.project(this.coordinates[3][0], this.coordinates[3][1])
                ];
                if (!function(t1) {
                    const e = t1[1].x - t1[0].x, r = t1[1].y - t1[0].y, n = t1[2].x - t1[1].x, i = t1[2].y - t1[1].y, s = t1[3].x - t1[2].x, a = t1[3].y - t1[2].y, o = t1[0].x - t1[3].x, l = t1[0].y - t1[3].y, u = e * i - n * r, c = n * a - s * i, h = s * l - o * a, p = o * r - e * l;
                    return u > 0 && c > 0 && h > 0 && p > 0 || u < 0 && c < 0 && h < 0 && p < 0;
                }(r)) return console.warn("Image source coordinates are defining non-convex area in the Mercator projection"), void (this._unsupportedCoords = !0);
                const n = yd(this.tileID, this.map.transform.projection), [i, s, a, o] = this.coordinates.map((t1)=>{
                    const e = n.projection.project(t1[0], t1[1]);
                    return gd(n, e)._round();
                });
                this.perspectiveTransform = hm(i.x, i.y, s.x, s.y, a.x, a.y, o.x, o.y);
                const l = this._boundsArray = new va;
                l.emplaceBack(i.x, i.y, 0, 0), l.emplaceBack(s.x, s.y, Hr, 0), l.emplaceBack(o.x, o.y, 0, Hr), l.emplaceBack(a.x, a.y, Hr, Hr), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy()), this.boundsBuffer = t1.createVertexBuffer(l, sm.members), this.boundsSegments = co.simpleSegment(0, 0, 4, 2);
                const u = [], c = [
                    pm((h = this.coordinates)[0]),
                    pm(h[1]),
                    pm(h[2]),
                    pm(h[3])
                ];
                var h;
                const [p, f, d, m] = function(t1) {
                    let e = t1[0][0], r = e, n = t1[0][1], i = n;
                    for(let s = 1; s < t1.length; s++)t1[s][0] < e ? e = t1[s][0] : t1[s][0] > r && (r = t1[s][0]), t1[s][1] < n ? n = t1[s][1] : t1[s][1] > i && (i = t1[s][1]);
                    return [
                        e,
                        n,
                        r - e,
                        i - n
                    ];
                }(c);
                {
                    const n = new va, [i, s, a, o] = function(t1) {
                        let e = t1[0].x, r = e, n = t1[0].y, i = n;
                        for(let s = 1; s < t1.length; s++)t1[s].x < e ? e = t1[s].x : t1[s].x > r && (r = t1[s].x), t1[s].y < n ? n = t1[s].y : t1[s].y > i && (i = t1[s].y);
                        return [
                            e,
                            n,
                            r - e,
                            i - n
                        ];
                    }(r), l = (t1)=>[
                            (t1.x - i) / a,
                            (t1.y - s) / o
                        ], [c, h, y, g] = r.map(l), x = function(t1, e, r, n, i, s, a, o) {
                        const l = cm(0, 0, 1, 0, 1, 1, 0, 1), u = cm(t1, e, r, n, i, s, a, o), c = O.mat3.adjoint([], u);
                        return O.mat3.multiply(l, l, c);
                    }(c[0], c[1], h[0], h[1], y[0], y[1], g[0], g[1]);
                    this.elevatedGlobePerspectiveTransform = hm(c[0], c[1], h[0], h[1], y[0], y[1], g[0], g[1]);
                    const b = (t1, e)=>{
                        u.push(t1.lng);
                        const r = Math.round((t1.lng - p) / d * Hr), i = Math.round((t1.lat - f) / m * Hr), s = l(e), a = O.vec3.transformMat3([], [
                            s[0],
                            s[1],
                            1
                        ], x), o = Math.round(a[0] / a[2] * Hr), c = Math.round(a[1] / a[2] * Hr);
                        n.emplaceBack(r, i, o, c);
                    }, v = r[3].x - r[0].x, w = r[3].y - r[0].y, _ = r[2].x - r[1].x, M = r[2].y - r[1].y;
                    for(let t1 = 0; t1 < 65; t1++){
                        const n = t1 / 64, i = [
                            r[0].x + n * v,
                            r[0].y + n * w
                        ], s = [
                            r[1].x + n * _,
                            r[1].y + n * M
                        ], a = s[0] - i[0], o = s[1] - i[1];
                        for(let t1 = 0; t1 < 65; t1++){
                            const r = t1 / 64, n = {
                                x: i[0] + a * r,
                                y: i[1] + o * r,
                                z: 0
                            };
                            b(e.projection.unproject(n.x, n.y), n);
                        }
                    }
                    this.elevatedGlobeVertexBuffer = t1.createVertexBuffer(n, sm.members);
                }
                {
                    this.maxLongitudeTriangleSize = 0;
                    let e = [], r = new Da;
                    const n = (t1, n, i)=>{
                        r.emplaceBack(t1, n, i);
                        const s = u[t1], a = u[n], o = u[i], l = Math.min(Math.min(s, a), o), c = Math.max(Math.max(s, a), o) - l;
                        c > this.maxLongitudeTriangleSize && (this.maxLongitudeTriangleSize = c), e.push(l + c / 2);
                    };
                    for(let t1 = 0; t1 < 64; t1++)for(let e = 0; e < 64; e++){
                        const r = 65 * t1 + e, i = r + 1, s = r + 65, a = s + 1;
                        n(r, s, i), n(i, s, a);
                    }
                    [e, r] = function(t1, e) {
                        const r = Array.from({
                            length: t1.length
                        }, (t1, e)=>e);
                        r.sort((e, r)=>t1[e] - t1[r]);
                        const n = [], i = new Da;
                        for(let s = 0; s < r.length; s++){
                            const a = r[s];
                            n.push(t1[a]);
                            const o = 3 * a, l = o + 1;
                            i.emplaceBack(e.uint16[o], e.uint16[l], e.uint16[l + 1]);
                        }
                        return [
                            n,
                            i
                        ];
                    }(e, r), this.elevatedGlobeTrianglesCenterLongitudes = e, this.elevatedGlobeIndexBuffer = t1.createIndexBuffer(r);
                }
                this.elevatedGlobeSegments = co.simpleSegment(0, 0, 4225, 8192), this.elevatedGlobeGridMatrix = new Float32Array([
                    0,
                    d / Hr,
                    0,
                    m / Hr,
                    0,
                    0,
                    f,
                    p,
                    0
                ]);
            }
            prepare() {
                const t1 = 0 !== Object.keys(this.tiles).length;
                if (this.tileID && !t1) return;
                const e = this.map.painter.context, r = e.gl;
                !this._dirty || this.texture instanceof um || (this.texture ? this.texture.update(this.image) : (this.texture = new lm(e, this.image, r.RGBA8), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE)), this._dirty = !1), t1 && this._prepareData(e);
            }
            loadTile(t1, e) {
                this.tileID && this.tileID.equals(t1.tileID.canonical) ? (this.tiles[String(t1.tileID.wrap)] = t1, t1.buckets = {}, e(null)) : (t1.state = "errored", e(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            getSegmentsForLongitude(t1) {
                const e = this.elevatedGlobeSegments;
                if (!this.elevatedGlobeTrianglesCenterLongitudes || !e) return null;
                const r = this.elevatedGlobeTrianglesCenterLongitudes;
                let n = (i = t1 + 180) + 360 * Math.round((r[0] - i) / 360);
                var i;
                const s = new co, a = (t1, r)=>{
                    s.segments.push({
                        vertexOffset: 0,
                        primitiveOffset: t1,
                        vertexLength: e.segments[0].vertexLength,
                        primitiveLength: r,
                        sortKey: void 0,
                        vaos: {}
                    });
                }, o = .51 * this.maxLongitudeTriangleSize;
                if (Math.abs(r[0] - n) <= o) {
                    const t1 = Mt(r, 0, r.length, n + o);
                    return t1 === r.length || a(t1, _t(r, t1 + 1, r.length, n + 360 - o) - t1), s;
                }
                n < r[0] && (n += 360);
                const l = _t(r, 0, r.length, n - o);
                if (l === r.length) return a(0, r.length), s;
                a(0, l - 0);
                const u = Mt(r, l + 1, r.length, n + o);
                return u !== r.length && a(u, r.length - u), s;
            }
        }
        const dm = (Math.pow(256, 2) - 1) / 16907520;
        class mm extends pa {
            constructor(t1, e, r, n){
                super(t1, {
                    layout: nm || (nm = new Gs({
                        visibility: new Ns(Xs.layout_raster.visibility)
                    })),
                    paint: im || (im = new Gs({
                        "raster-opacity": new Ns(Xs.paint_raster["raster-opacity"]),
                        "raster-color": new $s(Xs.paint_raster["raster-color"]),
                        "raster-color-mix": new Ns(Xs.paint_raster["raster-color-mix"]),
                        "raster-color-range": new Ns(Xs.paint_raster["raster-color-range"]),
                        "raster-hue-rotate": new Ns(Xs.paint_raster["raster-hue-rotate"]),
                        "raster-brightness-min": new Ns(Xs.paint_raster["raster-brightness-min"]),
                        "raster-brightness-max": new Ns(Xs.paint_raster["raster-brightness-max"]),
                        "raster-saturation": new Ns(Xs.paint_raster["raster-saturation"]),
                        "raster-contrast": new Ns(Xs.paint_raster["raster-contrast"]),
                        "raster-resampling": new Ns(Xs.paint_raster["raster-resampling"]),
                        "raster-fade-duration": new Ns(Xs.paint_raster["raster-fade-duration"]),
                        "raster-emissive-strength": new Ns(Xs.paint_raster["raster-emissive-strength"]),
                        "raster-array-band": new Ns(Xs.paint_raster["raster-array-band"]),
                        "raster-elevation": new Ns(Xs.paint_raster["raster-elevation"])
                    }))
                }, e, r, n), this.updateColorRamp(), this._curRampRange = [
                    NaN,
                    NaN
                ];
            }
            getProgramIds() {
                return [
                    "raster"
                ];
            }
            hasColorMap() {
                return !!this._transitionablePaint._values["raster-color"].value.value;
            }
            tileCoverLift() {
                return this.paint.get("raster-elevation");
            }
            isDraped(t1) {
                return !(t1 && t1._source instanceof fm && (t1._source.onNorthPole || t1._source.onSouthPole)) && 0 === this.paint.get("raster-elevation");
            }
            _handleSpecialPaintPropertyUpdate(t1) {
                "raster-color" !== t1 && "raster-color-range" !== t1 || (this._curRampRange = [
                    NaN,
                    NaN
                ], this.updateColorRamp());
            }
            updateColorRamp(t1) {
                if (!this.hasColorMap()) return;
                if (!this._curRampRange) return;
                const e = this._transitionablePaint._values["raster-color"].value.expression, [r, n] = t1 || this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({
                    zoom: 0
                }) || [
                    NaN,
                    NaN
                ];
                isNaN(r) && isNaN(n) || r === this._curRampRange[0] && n === this._curRampRange[1] || (this.colorRamp = ac({
                    expression: e,
                    evaluationKey: "rasterValue",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: r,
                            end: n
                        }
                    ],
                    resolution: 256
                }), this.colorRampTexture = null, this._curRampRange = [
                    r,
                    n
                ]);
            }
        }
        let ym, gm, xm, bm, vm;
        class wm extends pa {
            constructor(t1, e, r, n){
                super(t1, {
                    layout: ym || (ym = new Gs({
                        visibility: new Ns(Xs["layout_raster-particle"].visibility)
                    })),
                    paint: gm || (gm = new Gs({
                        "raster-particle-array-band": new Ns(Xs["paint_raster-particle"]["raster-particle-array-band"]),
                        "raster-particle-count": new Ns(Xs["paint_raster-particle"]["raster-particle-count"]),
                        "raster-particle-color": new $s(Xs["paint_raster-particle"]["raster-particle-color"]),
                        "raster-particle-max-speed": new Ns(Xs["paint_raster-particle"]["raster-particle-max-speed"]),
                        "raster-particle-speed-factor": new Ns(Xs["paint_raster-particle"]["raster-particle-speed-factor"]),
                        "raster-particle-fade-opacity-factor": new Ns(Xs["paint_raster-particle"]["raster-particle-fade-opacity-factor"]),
                        "raster-particle-reset-rate-factor": new Ns(Xs["paint_raster-particle"]["raster-particle-reset-rate-factor"]),
                        "raster-particle-elevation": new Ns(Xs["paint_raster-particle"]["raster-particle-elevation"])
                    }))
                }, e, r, n), this._updateColorRamp(), this.lastInvalidatedAt = Dt.now();
            }
            onRemove(t1) {
                this.colorRampTexture && this.colorRampTexture.destroy(), this.tileFramebuffer && this.tileFramebuffer.destroy(), this.particleFramebuffer && this.particleFramebuffer.destroy();
            }
            hasColorMap() {
                return !!this._transitionablePaint._values["raster-particle-color"].value.value;
            }
            getProgramIds() {
                return [
                    "rasterParticle"
                ];
            }
            hasOffscreenPass() {
                return "none" !== this.visibility;
            }
            isDraped(t1) {
                return !1;
            }
            _handleSpecialPaintPropertyUpdate(t1) {
                "raster-particle-color" !== t1 && "raster-particle-max-speed" !== t1 || (this._updateColorRamp(), this._invalidateAnimationState()), "raster-particle-count" === t1 && this._invalidateAnimationState();
            }
            _updateColorRamp() {
                if (!this.hasColorMap()) return;
                const t1 = this._transitionablePaint._values["raster-particle-color"].value.expression, e = this._transitionablePaint._values["raster-particle-max-speed"].value.expression.evaluate({
                    zoom: 0
                });
                this.colorRamp = ac({
                    expression: t1,
                    evaluationKey: "rasterParticleSpeed",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: 0,
                            end: e
                        }
                    ],
                    resolution: 256
                }), this.colorRampTexture = null;
            }
            _invalidateAnimationState() {
                this.lastInvalidatedAt = Dt.now();
            }
            tileCoverLift() {
                return this.paint.get("raster-particle-elevation");
            }
        }
        class _m extends pa {
            constructor(t1, e){
                super(t1, {}, e, null), this.implementation = t1, t1.slot && (this.slot = t1.slot);
            }
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            isDraped(t1) {
                return void 0 !== this.implementation.renderToTile;
            }
            shouldRedrape() {
                return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {}
            onAdd(t1) {
                this.implementation.onAdd && this.implementation.onAdd(t1, t1.painter.context.gl);
            }
            onRemove(t1) {
                this.implementation.onRemove && this.implementation.onRemove(t1, t1.painter.context.gl);
            }
        }
        function Mm(t1, e, r) {
            const n = [
                0,
                0,
                1
            ], i = O.quat.identity([]);
            return O.quat.rotateY(i, i, r ? -Y(t1) + Math.PI : Y(t1)), O.quat.rotateX(i, i, -Y(e)), O.vec3.transformQuat(n, n, i), O.vec3.normalize(n, n);
        }
        function Am(t1, e) {
            const r = Im(t1.projection, t1.zoom, t1.width, t1.height), n = function(t1, e, r, n, i) {
                const s = new rl(r.lng - 180 * Pm, r.lat), a = new rl(r.lng + 180 * Pm, r.lat), o = t1.project(s.lng, s.lat), l = t1.project(a.lng, a.lat), u = -Math.atan2(l.y - o.y, l.x - o.x), c = xl.fromLngLat(r);
                c.y = Q(c.y, -1 + Pm, 1 - Pm);
                const h = c.toLngLat(), p = t1.project(h.lng, h.lat), f = xl.fromLngLat(h);
                f.x += Pm;
                const d = f.toLngLat(), m = t1.project(d.lng, d.lat), y = km(m.x - p.x, m.y - p.y, u), g = xl.fromLngLat(h);
                g.y += Pm;
                const x = g.toLngLat(), b = t1.project(x.lng, x.lat), v = km(b.x - p.x, b.y - p.y, u), w = Math.abs(y.x) / Math.abs(v.y), _ = O.mat4.identity([]);
                O.mat4.rotateZ(_, _, -u * (1 - (i ? 0 : n)));
                const M = O.mat4.identity([]);
                return O.mat4.scale(M, M, [
                    1,
                    1 - (1 - w) * n,
                    1
                ]), M[4] = -v.x / v.y * n, O.mat4.rotateZ(M, M, u), O.mat4.multiply(M, _, M), M;
            }(t1.projection, 0, t1.center, r, e), i = Sm(t1);
            return O.mat4.scale(n, n, [
                i,
                i,
                1
            ]), n;
        }
        function Sm(t1) {
            const e = t1.projection, r = Im(t1.projection, t1.zoom, t1.width, t1.height), n = zm(e, t1.center), i = zm(e, rl.convert(e.center));
            return Math.pow(2, n * r + (1 - r) * i);
        }
        function Im(t1, e, r, n, i = 1 / 0) {
            const s = t1.range;
            if (!s) return 0;
            const a = Math.min(i, Math.max(r, n)), o = Math.log(a / 1024) / Math.LN2;
            return tt(s[0] + o, s[1] + o, e);
        }
        const Pm = 1 / 4e4;
        function zm(t1, e) {
            const r = Q(e.lat, -fl, fl), n = new rl(e.lng - 180 * Pm, r), i = new rl(e.lng + 180 * Pm, r), s = t1.project(n.lng, r), a = t1.project(i.lng, r), o = xl.fromLngLat(n), l = xl.fromLngLat(i), u = a.x - s.x, c = a.y - s.y, h = l.x - o.x, p = l.y - o.y, f = Math.sqrt((h * h + p * p) / (u * u + c * c));
            return Math.log(f) / Math.LN2;
        }
        function km(t1, e, r) {
            const n = Math.cos(r), i = Math.sin(r);
            return {
                x: t1 * n - e * i,
                y: t1 * i + e * n
            };
        }
        function Tm(t1, e, r) {
            O.mat4.identity(t1), O.mat4.rotateZ(t1, t1, Y(e[2])), O.mat4.rotateX(t1, t1, Y(e[0])), O.mat4.rotateY(t1, t1, Y(e[1])), O.mat4.scale(t1, t1, r), O.mat4.multiply(t1, t1, [
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1
            ]);
        }
        function Em(t1, e, r, n, i, s, a, o) {
            const l = [
                r[0] - e[0],
                r[1] - e[1],
                0
            ], u = [
                n[0] - e[0],
                n[1] - e[1],
                0
            ];
            if (O.vec3.length(l) < 1e-12 || O.vec3.length(u) < 1e-12) return O.quat.identity(t1);
            const c = O.vec3.cross([], l, u);
            O.vec3.normalize(c, c), O.vec3.subtract(u, n, e), l[2] = (s - i) * o, u[2] = (a - i) * o;
            const h = l;
            return O.vec3.cross(h, l, u), O.vec3.normalize(h, h), O.quat.rotationTo(t1, c, h);
        }
        function Bm(t1, e, r = !1) {
            const n = Du(e.zoom), i = function(t1, e, r) {
                const n = e.worldSize, i = [
                    t1[12],
                    t1[13],
                    t1[14]
                ], s = hl(i[1] / n), a = cl(i[0] / n), o = O.mat4.identity([]), l = ul(1, s) * n, u = ul(1, 0) * n * ml(s, e.zoom), c = 1 / Vu(n);
                let h = u * c;
                if (r) {
                    const t1 = Im(e.projection, e.zoom, e.width, e.height, 1024);
                    h = c * e.projection.pixelSpaceConversion(e.center.lat, n, t1);
                }
                const p = Qo(s, a);
                O.vec3.add(p, p, O.vec3.scale([], O.vec3.normalize([], p), l * h * i[2]));
                const f = function(t1) {
                    const e = [
                        t1[0],
                        t1[1],
                        t1[2]
                    ];
                    let r = [
                        0,
                        1,
                        0
                    ];
                    const n = O.vec3.cross([], r, e);
                    return O.vec3.cross(r, e, n), 0 === O.vec3.squaredLength(r) && (r = [
                        0,
                        1,
                        0
                    ], O.vec3.cross(n, e, r)), O.vec3.normalize(n, n), O.vec3.normalize(r, r), O.vec3.normalize(e, e), [
                        n[0],
                        n[1],
                        n[2],
                        0,
                        r[0],
                        r[1],
                        r[2],
                        0,
                        e[0],
                        e[1],
                        e[2],
                        0,
                        t1[0],
                        t1[1],
                        t1[2],
                        1
                    ];
                }(p);
                O.mat4.scale(o, o, [
                    h,
                    h,
                    h * l
                ]), O.mat4.translate(o, o, [
                    -i[0],
                    -i[1],
                    -i[2]
                ]);
                const d = O.mat4.multiply([], e.globeMatrix, f);
                return O.mat4.multiply(d, d, o), O.mat4.multiply(d, d, t1), d;
            }(t1, e, r);
            if (n > 0) {
                const r = function(t1, e) {
                    const r = e.worldSize, n = ul(1, 0) * r * ml(e.center.lat, e.zoom) / Vu(r), i = ul(1, e.center.lat) * r, s = O.mat4.identity([]);
                    return O.mat4.rotateY(s, s, Y(e.center.lng)), O.mat4.rotateX(s, s, Y(e.center.lat)), O.mat4.translate(s, s, [
                        0,
                        0,
                        $o
                    ]), O.mat4.scale(s, s, [
                        n,
                        n,
                        n * i
                    ]), O.mat4.translate(s, s, [
                        e.point.x - .5 * r,
                        e.point.y - .5 * r,
                        0
                    ]), O.mat4.multiply(s, s, t1), O.mat4.multiply(s, e.globeMatrix, s);
                }(t1, e);
                return function(t1, e, r) {
                    const n = (t1, e, r)=>{
                        const n = O.vec3.length(t1), i = O.vec3.length(e), s = Mu(t1, e, r);
                        return O.vec3.scale(s, s, 1 / O.vec3.length(s) * ke(n, i, r));
                    }, i = n([
                        t1[0],
                        t1[1],
                        t1[2]
                    ], [
                        e[0],
                        e[1],
                        e[2]
                    ], r), s = n([
                        t1[4],
                        t1[5],
                        t1[6]
                    ], [
                        e[4],
                        e[5],
                        e[6]
                    ], r), a = n([
                        t1[8],
                        t1[9],
                        t1[10]
                    ], [
                        e[8],
                        e[9],
                        e[10]
                    ], r), o = Mu([
                        t1[12],
                        t1[13],
                        t1[14]
                    ], [
                        e[12],
                        e[13],
                        e[14]
                    ], r);
                    return [
                        i[0],
                        i[1],
                        i[2],
                        0,
                        s[0],
                        s[1],
                        s[2],
                        0,
                        a[0],
                        a[1],
                        a[2],
                        0,
                        o[0],
                        o[1],
                        o[2],
                        1
                    ];
                }(i, r, n);
            }
            return i;
        }
        function Vm(t1, e, r, n) {
            const i = yu.projectAabbCorners(n, r);
            let s = Number.MAX_VALUE, a = -1;
            for(let t1 = 0; t1 < i.length; ++t1){
                const r = i[t1];
                r[0] = (.5 * r[0] + .5) * e.width, r[1] = (.5 - .5 * r[1]) * e.height, r[2] < s && (a = t1, s = r[2]);
            }
            const o = (t1)=>new q(i[t1][0], i[t1][1]);
            let l;
            switch(a){
                case 0:
                case 6:
                    l = [
                        o(1),
                        o(5),
                        o(4),
                        o(7),
                        o(3),
                        o(2),
                        o(1)
                    ];
                    break;
                case 1:
                case 7:
                    l = [
                        o(0),
                        o(4),
                        o(5),
                        o(6),
                        o(2),
                        o(3),
                        o(0)
                    ];
                    break;
                case 3:
                case 5:
                    l = [
                        o(1),
                        o(0),
                        o(4),
                        o(7),
                        o(6),
                        o(2),
                        o(1)
                    ];
                    break;
                default:
                    l = [
                        o(1),
                        o(5),
                        o(6),
                        o(7),
                        o(3),
                        o(0),
                        o(1)
                    ];
            }
            if (El(t1, l)) return s;
        }
        const Cm = ya([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), Rm = ya([
            {
                name: "a_color_3f",
                components: 3,
                type: "Float32"
            }
        ]), Dm = ya([
            {
                name: "a_color_4f",
                components: 4,
                type: "Float32"
            }
        ]), Lm = ya([
            {
                name: "a_uv_2f",
                components: 2,
                type: "Float32"
            }
        ]), Fm = ya([
            {
                name: "a_normal_3f",
                components: 3,
                type: "Float32"
            }
        ]), Om = ya([
            {
                name: "a_normal_matrix0",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix1",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix2",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix3",
                components: 4,
                type: "Float32"
            }
        ]), Um = ya([
            {
                name: "a_pbr",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_heightBasedEmissiveStrength",
                components: 3,
                type: "Float32"
            }
        ]), jm = {
            None: 0,
            Model: 1,
            Symbol: 2,
            FillExtrusion: 4,
            All: 7
        };
        class Nm {
            constructor(t1, e, r, n){
                this.message = (t1 ? `${t1}: ` : "") + r, n && (this.identifier = n), null != e && e.__line__ && (this.line = e.__line__);
            }
        }
        function qm(t1, e) {
            const r = -1 === t1.indexOf("://");
            try {
                return new URL(t1, r && e ? "http://example.com" : void 0), !0;
            } catch (t1) {
                return !1;
            }
        }
        class $m {
            constructor(t1, e){
                this.feature = t1, this.instancedDataOffset = e, this.instancedDataCount = 0, this.rotation = [
                    0,
                    0,
                    0
                ], this.scale = [
                    1,
                    1,
                    1
                ], this.translation = [
                    0,
                    0,
                    0
                ];
            }
        }
        class Gm {
            constructor(){
                this.instancedDataArray = new Ga, this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
            }
        }
        class Xm {
            constructor(t1){
                this.zoom = t1.zoom, this.canonical = t1.canonical, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.projection = t1.projection, this.index = t1.index, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.hasPattern = !1, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = {
                    id: null,
                    timestamp: 0
                }, this.modelUris = [], this.modelsRequested = !1, this.activeReplacements = [], this.replacementUpdateTime = 0;
            }
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                this.tileToMeter = gl(r);
                const i = this.layers[0]._featureFilter.needGeometry;
                this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
                for (const { feature: s, id: a, index: o, sourceLayerIndex: l } of t1){
                    const t1 = null != a ? a : s.properties && s.properties.hasOwnProperty("id") ? s.properties.id : void 0, u = Pl(s, i);
                    if (!this.layers[0]._featureFilter.filter(new Vs(this.zoom), u, r)) continue;
                    const c = {
                        id: t1,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: i ? u.geometry : Il(s, r, n),
                        properties: s.properties,
                        type: s.type,
                        patterns: {}
                    }, h = this.addFeature(c, c.geometry, u);
                    h && e.featureIndex.insert(s, c.geometry, o, l, this.index, this.instancesPerModel[h].instancedDataArray.length, Hr / 32);
                }
                this.lookup = null;
            }
            update(t1, e, r, n) {
                for(const e in this.instancesPerModel){
                    const r = this.instancesPerModel[e];
                    for(const e in t1)r.idToFeaturesIndex.hasOwnProperty(e) && (this.evaluate(r.features[r.idToFeaturesIndex[e]], t1[e], r, !0), this.uploaded = !1);
                }
                this.maxHeight = 0;
            }
            updateZoomBasedPaintProperties() {
                if (!this.hasZoomDependentProperties) return !1;
                let t1 = !1;
                for(const e in this.instancesPerModel){
                    const r = this.instancesPerModel[e];
                    for (const e of r.features){
                        const n = this.layers[0], i = e.feature, s = this.canonical, a = n.paint.get("model-rotation").evaluate(i, {}, s), o = n.paint.get("model-scale").evaluate(i, {}, s), l = n.paint.get("model-translation").evaluate(i, {}, s);
                        O.vec3.exactEquals(e.rotation, a) && O.vec3.exactEquals(e.scale, o) && O.vec3.exactEquals(e.translation, l) || (this.evaluate(e, e.featureStates, r, !0), t1 = !0);
                    }
                }
                return t1;
            }
            updateReplacement(t1, e, r, n) {
                if (e.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = e.updateTime;
                const i = e.getReplacementRegionsForTile(t1.toUnwrapped(), !0);
                if (wh(this.activeReplacements, i)) return !1;
                this.activeReplacements = i;
                let s = !1;
                for(const e in this.instancesPerModel){
                    const i = this.instancesPerModel[e], a = i.instancedDataArray;
                    for (const e of i.features){
                        const i = e.instancedDataOffset, o = e.instancedDataCount;
                        for(let e = 0; e < o; e++){
                            const o = 16 * (e + i);
                            let l = a.float32[o + 0];
                            const u = l > Hr;
                            l = u ? l - Hr : l;
                            const c = Math.floor(l), h = a.float32[o + 1];
                            let p = !1;
                            for (const e of this.activeReplacements)if (!gh(e, r, jm.Model, n) && !(e.min.x > c || c > e.max.x || e.min.y > h || h > e.max.y) && (p = Ph(Ih(c, h, t1.canonical, e.footprintTileId.canonical), e.footprint), p)) break;
                            a.float32[o] = p ? l + Hr : l, s = s || p !== u;
                        }
                    }
                }
                return s;
            }
            isEmpty() {
                for(const t1 in this.instancesPerModel)if (0 !== this.instancesPerModel[t1].instancedDataArray.length) return !1;
                return !0;
            }
            uploadPending() {
                return !this.uploaded;
            }
            upload(t1) {
                if (!this.uploaded) for(const e in this.instancesPerModel){
                    const r = this.instancesPerModel[e];
                    r.instancedDataArray.length < 0 || 0 === r.instancedDataArray.length || (r.instancedDataBuffer ? r.instancedDataBuffer.updateData(r.instancedDataArray) : r.instancedDataBuffer = t1.createVertexBuffer(r.instancedDataArray, Om.members, !0, void 0, this.instanceCount));
                }
                this.uploaded = !0;
            }
            destroy() {
                for(const t1 in this.instancesPerModel){
                    const e = this.instancesPerModel[t1];
                    0 !== e.instancedDataArray.length && e.instancedDataBuffer && e.instancedDataBuffer.destroy();
                }
                const t1 = this.layers[0].modelManager;
                if (t1 && this.modelUris) for (const e of this.modelUris)t1.removeModel(e, "");
            }
            addFeature(t1, e, r) {
                const n = this.layers[0], i = n.layout.get("model-id").evaluate(r, {}, this.canonical);
                if (!i) return ft(`modelId is not evaluated for layer ${n.id} and it is not going to get rendered.`), i;
                qm(i, !1) && (this.modelUris.includes(i) || this.modelUris.push(i)), this.instancesPerModel[i] || (this.instancesPerModel[i] = new Gm);
                const s = this.instancesPerModel[i], a = s.instancedDataArray, o = new $m(r, a.length);
                for (const t1 of e)for (const e of t1){
                    if (e.x < 0 || e.x >= Hr || e.y < 0 || e.y >= Hr) continue;
                    const t1 = (this.lookupDim - 1) / Hr, r = this.lookupDim * (e.y * t1 | 0) + e.x * t1 | 0;
                    if (this.lookup) {
                        if (0 !== this.lookup[r]) continue;
                        this.lookup[r] = 1;
                    }
                    this.instanceCount++;
                    const n = a.length;
                    a.resize(n + 1), s.instancesEvaluatedElevation.push(0), a.float32[16 * n] = e.x, a.float32[16 * n + 1] = e.y;
                }
                return o.instancedDataCount = s.instancedDataArray.length - o.instancedDataOffset, o.instancedDataCount > 0 && (t1.id && (s.idToFeaturesIndex[t1.id] = s.features.length), s.features.push(o), this.evaluate(o, {}, s, !1)), i;
            }
            getModelUris() {
                return this.modelUris;
            }
            evaluate(t1, e, r, n) {
                const i = this.layers[0], s = t1.feature, a = this.canonical, o = t1.rotation = i.paint.get("model-rotation").evaluate(s, e, a), l = t1.scale = i.paint.get("model-scale").evaluate(s, e, a), u = t1.translation = i.paint.get("model-translation").evaluate(s, e, a), c = i.paint.get("model-color").evaluate(s, e, a);
                c.a = i.paint.get("model-color-mix-intensity").evaluate(s, e, a);
                const h = [];
                this.maxVerticalOffset < u[2] && (this.maxVerticalOffset = u[2]), this.maxScale = Math.max(Math.max(this.maxScale, l[0]), Math.max(l[1], l[2])), Tm(h, o, l);
                const p = Math.round(100 * c.a) + c.b / 1.05;
                for(let e = 0; e < t1.instancedDataCount; ++e){
                    const i = t1.instancedDataOffset + e, s = 16 * i, o = r.instancedDataArray.float32;
                    let l = 0;
                    n && (l = o[s + 6] - r.instancesEvaluatedElevation[i]);
                    const f = 0 | o[s + 1];
                    o[s] = (0 | o[s]) + c.r / 1.05, o[s + 1] = f + c.g / 1.05, o[s + 2] = p, o[s + 3] = 1 / (a.z > 10 ? this.tileToMeter : gl(a, f)), o[s + 4] = u[0], o[s + 5] = u[1], o[s + 6] = u[2] + l, o[s + 7] = h[0], o[s + 8] = h[1], o[s + 9] = h[2], o[s + 10] = h[4], o[s + 11] = h[5], o[s + 12] = h[6], o[s + 13] = h[8], o[s + 14] = h[9], o[s + 15] = h[10], r.instancesEvaluatedElevation[i] = u[2];
                }
            }
        }
        let Ym, Zm;
        os(Xm, "ModelBucket", {
            omit: [
                "layers"
            ]
        }), os(Gm, "PerModelAttributes"), os($m, "ModelFeature");
        const Wm = 64, Hm = {
            CoordinateSpaceTile: 1,
            CoordinateSpaceYUp: 2,
            HasMapboxMeshFeatures: 4,
            HasMeshoptCompression: 8
        };
        function Km(t1, e, r, n, i, s, a, o, l, u = !1) {
            const c = r.zoom, h = r.project(n), p = ml(n.lat, c), f = 1 / p;
            O.mat4.identity(t1), O.mat4.translate(t1, t1, [
                h.x + a[0] * f,
                h.y + a[1] * f,
                a[2]
            ]);
            let d = 1, m = 1;
            const y = r.worldSize;
            if (u) {
                if ("mercator" === r.projection.name) {
                    let t1 = 0;
                    r.elevation && (t1 = r.elevation.getAtPointOrZero(new xl(h.x / y, h.y / y), 0));
                    const e = O.vec4.transformMat4([], [
                        h.x,
                        h.y,
                        t1,
                        1
                    ], r.projMatrix)[3] / r.cameraToCenterDistance;
                    d = e, m = e * ml(r.center.lat, c);
                } else if ("globe" === r.projection.name) {
                    const e = Bm(t1, r), i = O.mat4.multiply([], r.projMatrix, e), s = [
                        0,
                        0,
                        0,
                        1
                    ];
                    O.vec4.transformMat4(s, s, i);
                    const a = s[3] / r.cameraToCenterDistance, o = Du(c), l = r.projection.pixelsPerMeter(n.lat, y) * ml(n.lat, c), u = r.projection.pixelsPerMeter(r.center.lat, y) * ml(r.center.lat, c);
                    d = a / ke(l, dl(r.center.lat), o), m = a * p / l, d *= u, m *= u;
                }
            } else d = f;
            O.mat4.scale(t1, t1, [
                d,
                d,
                m
            ]);
            const g = [
                ...t1
            ], x = e.orientation, b = [];
            if (Tm(b, [
                x[0] + i[0],
                x[1] + i[1],
                x[2] + i[2]
            ], s), O.mat4.multiply(t1, g, b), o && r.elevation) {
                let i = 0;
                const s = [];
                if (l && r.elevation) {
                    i = function(t1, e, r, n, i) {
                        const s = e.elevation;
                        if (!s) return 0;
                        const a = yu.projectAabbCorners(r, n), o = ul(1, i.lat) * e.worldSize, l = function(t1, e) {
                            const r = [
                                0,
                                0,
                                1
                            ], n = [
                                {
                                    corners: [
                                        0,
                                        1,
                                        3,
                                        2
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        1,
                                        5,
                                        2,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        4,
                                        1,
                                        5
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        2,
                                        6,
                                        3,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        4,
                                        7,
                                        5,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        3,
                                        4,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                }
                            ];
                            for (const i of n){
                                const n = t1[i.corners[0]], s = t1[i.corners[1]], a = t1[i.corners[2]], o = [
                                    s[0] - n[0],
                                    s[1] - n[1],
                                    e * (s[2] - n[2])
                                ], l = O.vec3.cross(o, o, [
                                    a[0] - n[0],
                                    a[1] - n[1],
                                    e * (a[2] - n[2])
                                ]);
                                O.vec3.normalize(l, l), i.dotProductWithUp = O.vec3.dot(l, r);
                            }
                            return n.sort((t1, e)=>t1.dotProductWithUp - e.dotProductWithUp), n[0].corners;
                        }(a, o), u = a[l[0]], c = a[l[1]], h = a[l[2]], p = a[l[3]], f = s.getAtPointOrZero(new xl(u[0] / e.worldSize, u[1] / e.worldSize), 0), d = s.getAtPointOrZero(new xl(c[0] / e.worldSize, c[1] / e.worldSize), 0), m = s.getAtPointOrZero(new xl(h[0] / e.worldSize, h[1] / e.worldSize), 0), y = s.getAtPointOrZero(new xl(p[0] / e.worldSize, p[1] / e.worldSize), 0), g = (f + y) / 2, x = (d + m) / 2;
                        return g > x ? d < m ? Em(t1, c, p, u, d, y, f, o) : Em(t1, h, u, p, m, f, y, o) : f < y ? Em(t1, u, c, h, f, d, m, o) : Em(t1, p, h, c, y, m, d, o), Math.max(g, x);
                    }(s, r, e.aabb, t1, n);
                    const a = O.mat4.fromQuat([], s), o = O.mat4.multiply([], a, b);
                    O.mat4.multiply(t1, g, o);
                } else i = r.elevation.getAtPointOrZero(new xl(h.x / y, h.y / y), 0);
                0 !== i && (t1[14] += i);
            }
        }
        function Jm(t1, e, r = !1) {
            t1.uploaded || (t1.gfxTexture = new lm(e, t1.image, r ? e.gl.R8 : e.gl.RGBA8, {
                useMipmap: t1.sampler.minFilter >= e.gl.NEAREST_MIPMAP_NEAREST
            }), t1.uploaded = !0, t1.image = null);
        }
        function Qm(t1, e, r) {
            t1.indexBuffer = e.createIndexBuffer(t1.indexArray, !1, !0), t1.vertexBuffer = e.createVertexBuffer(t1.vertexArray, Cm.members, !1, !0), t1.normalArray && (t1.normalBuffer = e.createVertexBuffer(t1.normalArray, Fm.members, !1, !0)), t1.texcoordArray && (t1.texcoordBuffer = e.createVertexBuffer(t1.texcoordArray, Lm.members, !1, !0)), t1.colorArray && (t1.colorBuffer = e.createVertexBuffer(t1.colorArray, (12 === t1.colorArray.bytesPerElement ? Rm : Dm).members, !1, !0)), t1.featureArray && (t1.pbrBuffer = e.createVertexBuffer(t1.featureArray, Um.members, !0)), t1.segments = co.simpleSegment(0, 0, t1.vertexArray.length, t1.indexArray.length);
            const n = t1.material;
            n.pbrMetallicRoughness.baseColorTexture && Jm(n.pbrMetallicRoughness.baseColorTexture, e), n.pbrMetallicRoughness.metallicRoughnessTexture && Jm(n.pbrMetallicRoughness.metallicRoughnessTexture, e), n.normalTexture && Jm(n.normalTexture, e), n.occlusionTexture && Jm(n.occlusionTexture, e, r), n.emissionTexture && Jm(n.emissionTexture, e);
        }
        function ty(t1, e, r) {
            if (t1.meshes) for (const n of t1.meshes)Qm(n, e, r);
            if (t1.children) for (const n of t1.children)ty(n, e, r);
        }
        function ey(t1) {
            if (t1.meshes) for (const e of t1.meshes)e.indexArray.destroy(), e.vertexArray.destroy(), e.colorArray && e.colorArray.destroy(), e.normalArray && e.normalArray.destroy(), e.texcoordArray && e.texcoordArray.destroy(), e.featureArray && e.featureArray.destroy();
            if (t1.children) for (const e of t1.children)ey(e);
        }
        function ry(t1) {
            if (t1.meshes) for (const r of t1.meshes)r.vertexBuffer && (r.vertexBuffer.destroy(), r.indexBuffer.destroy(), r.normalBuffer && r.normalBuffer.destroy(), r.texcoordBuffer && r.texcoordBuffer.destroy(), r.colorBuffer && r.colorBuffer.destroy(), r.pbrBuffer && r.pbrBuffer.destroy(), r.segments.destroy(), r.material && ((e = r.material).pbrMetallicRoughness.baseColorTexture && e.pbrMetallicRoughness.baseColorTexture.gfxTexture && e.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), e.pbrMetallicRoughness.metallicRoughnessTexture && e.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && e.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), e.normalTexture && e.normalTexture.gfxTexture && e.normalTexture.gfxTexture.destroy(), e.emissionTexture && e.emissionTexture.gfxTexture && e.emissionTexture.gfxTexture.destroy(), e.occlusionTexture && e.occlusionTexture.gfxTexture && e.occlusionTexture.gfxTexture.destroy()));
            var e;
            if (t1.children) for (const e of t1.children)ry(e);
        }
        class ny {
            constructor(t1, e, r){
                this._demTile = t1, this._dem = this._demTile.dem, this._scale = e, this._offset = r;
            }
            static create(t1, e, r) {
                const n = r || t1.findDEMTileFor(e);
                if (!n || !n.dem) return;
                const i = n.dem, s = n.tileID, a = 1 << e.canonical.z - s.canonical.z;
                return new ny(n, i.dim / Hr / a, [
                    (e.canonical.x / a - s.canonical.x) * i.dim,
                    (e.canonical.y / a - s.canonical.y) * i.dim
                ]);
            }
            tileCoordToPixel(t1, e) {
                const r = e * this._scale + this._offset[1], n = Math.floor(t1 * this._scale + this._offset[0]), i = Math.floor(r);
                return new q(n, i);
            }
            getElevationAt(t1, e, r, n) {
                const i = t1 * this._scale + this._offset[0], s = e * this._scale + this._offset[1], a = Math.floor(i), o = Math.floor(s), l = this._dem;
                return n = !!n, r ? ke(ke(l.get(a, o, n), l.get(a, o + 1, n), s - o), ke(l.get(a + 1, o, n), l.get(a + 1, o + 1, n), s - o), i - a) : l.get(a, o, n);
            }
            getElevationAtPixel(t1, e, r) {
                return this._dem.get(t1, e, !!r);
            }
            getMeterToDEM(t1) {
                return (1 << this._demTile.tileID.canonical.z) * ul(1, t1) * this._dem.stride;
            }
        }
        const iy = new Float32Array(262144), sy = new Uint8Array(262144);
        function ay(t1) {
            let e = 0;
            if (t1.meshes) for (const r of t1.meshes)e = Math.max(e, r.aabb.max[2]);
            if (t1.children) for (const r of t1.children)e = Math.max(e, ay(r));
            return e;
        }
        function oy(t1, e, r) {
            if (t1.meshes) for (const n of t1.meshes)n.aabb.min[0] !== 1 / 0 && r.insert(e, n.aabb.min[0], n.aabb.min[1], n.aabb.max[0], n.aabb.max[1]);
            if (t1.children) for (const n of t1.children)oy(n, e, r);
        }
        const ly = [
            "",
            "wall",
            "door",
            "roof",
            "window",
            "lamp",
            "logo"
        ];
        class uy {
            constructor(t1){
                this.node = t1, this.evaluatedRMEA = [
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        .4,
                        1,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ]
                ], this.hiddenByReplacement = !1, this.evaluatedScale = [
                    1,
                    1,
                    1
                ], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.cameraCollisionOpacity = 1, this.feature = {
                    type: "Point",
                    id: t1.id,
                    geometry: [],
                    properties: {
                        height: ay(t1)
                    }
                }, this.aabb = this._getLocalBounds();
            }
            _getLocalBounds() {
                if (!this.node.meshes) return new yu([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]);
                if (!this.aabb) {
                    let t1 = 0;
                    const e = new yu([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]);
                    for (const r of this.node.meshes)this.node.lightMeshIndex !== t1 && (r.transformedAabb = yu.applyTransformFast(r.aabb, this.node.matrix), e.encapsulate(r.transformedAabb)), t1++;
                    this.aabb = e;
                }
                return this.aabb;
            }
        }
        class cy {
            constructor(t1, e, r, n, i, s){
                this.id = e, this.modelTraits |= Hm.CoordinateSpaceTile, this.uploaded = !1, this.hasPattern = !1, r && (this.modelTraits |= Hm.HasMapboxMeshFeatures), n && (this.modelTraits |= Hm.HasMeshoptCompression), this.zoom = -1, this.terrainExaggeration = 1, this.projection = {
                    name: "mercator"
                }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = i, this.dirty = !0, this.needsUpload = !1, this.nodesInfo = [];
                for (const e of t1)this.nodesInfo.push(new uy(e)), oy(e, s.featureIndexArray.length, s.grid), s.featureIndexArray.emplaceBack(this.nodesInfo.length - 1, 0, s.bucketLayerIDs.length - 1, 0);
            }
            updateFootprints(t1, e) {
                for (const r of this.getNodesInfo()){
                    const n = r.node;
                    n.footprint && e.push({
                        footprint: n.footprint,
                        id: t1
                    });
                }
            }
            update() {
                console.log("Update 3D model bucket");
            }
            populate() {
                console.log("populate 3D model bucket");
            }
            uploadPending() {
                return !this.uploaded || this.needsUpload;
            }
            upload(t1) {
                if (!this.needsUpload) return;
                const e = this.getNodesInfo();
                for (const r of e){
                    const e = r.node;
                    this.uploaded ? this.updatePbrBuffer(e) : ty(e, t1, !0);
                }
                for (const t1 of e)ey(t1.node);
                this.uploaded = !0, this.needsUpload = !1;
            }
            updatePbrBuffer(t1) {
                let e = !1;
                if (!t1.meshes) return e;
                for (const r of t1.meshes)r.pbrBuffer && (r.pbrBuffer.updateData(r.featureArray), e = !0);
                return e;
            }
            needsReEvaluation(t1, e, r) {
                const n = t1.transform.projectionOptions, i = t1.style.getBrightness(), s = this.brightness !== i;
                return !!(!this.uploaded || this.dirty || n.name !== this.projection.name || hy(r.paint.get("model-color").value, s) || hy(r.paint.get("model-color-mix-intensity").value, s) || hy(r.paint.get("model-roughness").value, s) || hy(r.paint.get("model-emissive-strength").value, s) || hy(r.paint.get("model-height-based-emissive-strength-multiplier").value, s)) && (this.projection = n, this.brightness = i, !0);
            }
            evaluateScale(t1, e) {
                if (t1.transform.zoom === this.zoom) return;
                this.zoom = t1.transform.zoom;
                const r = this.getNodesInfo(), n = this.id.canonical;
                for (const t1 of r){
                    const r = t1.feature;
                    t1.evaluatedScale = e.paint.get("model-scale").evaluate(r, {}, n);
                }
            }
            evaluate(t1) {
                const e = this.getNodesInfo();
                for (const r of e){
                    if (!r.node.meshes) continue;
                    const e = r.feature, n = r.node.meshes && r.node.meshes[0].featureData, i = r.evaluatedColor[2], s = r.evaluatedRMEA[2], a = this.id.canonical;
                    if (r.hasTranslucentParts = !1, n) {
                        for(let n = 0; n < ly.length; n++){
                            const i = ly[n];
                            i.length && (e.properties.part = i);
                            const s = t1.paint.get("model-color").evaluate(e, {}, a).toRenderColor(null), o = t1.paint.get("model-color-mix-intensity").evaluate(e, {}, a);
                            r.evaluatedColor[n] = [
                                s.r,
                                s.g,
                                s.b,
                                o
                            ], r.evaluatedRMEA[n][0] = t1.paint.get("model-roughness").evaluate(e, {}, a), r.evaluatedRMEA[n][2] = t1.paint.get("model-emissive-strength").evaluate(e, {}, a), r.evaluatedRMEA[n][3] = s.a, r.emissionHeightBasedParams[n] = t1.paint.get("model-height-based-emissive-strength-multiplier").evaluate(e, {}, a), !r.hasTranslucentParts && s.a < 1 && (r.hasTranslucentParts = !0);
                        }
                        delete e.properties.part, fy(r, i !== r.evaluatedColor[2] || s !== r.evaluatedRMEA[2], this.modelTraits);
                    } else r.evaluatedRMEA[0][2] = t1.paint.get("model-emissive-strength").evaluate(e, {}, a);
                    r.evaluatedScale = t1.paint.get("model-scale").evaluate(e, {}, a), this.updatePbrBuffer(r.node) || (this.needsUpload = !0);
                }
                this.dirty = !1;
            }
            elevationUpdate(t1, e, r, n) {
                const i = t1.findDEMTileFor(r);
                if (i && (i.tileID.canonical !== this.terrainTile || e !== this.terrainExaggeration)) {
                    if (i.dem && i.tileID.overscaledZ !== this.elevationReadFromZ) {
                        this.elevationReadFromZ = i.tileID.overscaledZ;
                        const e = ny.create(t1, r, i);
                        if (!e) return;
                        this.modelTraits & Hm.HasMapboxMeshFeatures && this.updateDEM(t1, e, r, n);
                        for (const t1 of this.getNodesInfo()){
                            const r = t1.node;
                            if (!r.footprint || !r.footprint.vertices || !r.footprint.vertices.length) continue;
                            const n = r.footprint.vertices;
                            let i = e.getElevationAt(n[0].x, n[0].y, !0, !0);
                            for(let t1 = 1; t1 < n.length; t1++)i = Math.min(i, e.getElevationAt(n[t1].x, n[t1].y, !0, !0));
                            r.elevation = i;
                        }
                    }
                    this.terrainTile = i.tileID.canonical, this.terrainExaggeration = e;
                }
            }
            updateDEM(t1, e, r, n) {
                let i = e._dem._modifiedForSources[n];
                if (void 0 === i && (e._dem._modifiedForSources[n] = [], i = e._dem._modifiedForSources[n]), i.includes(r.canonical)) return;
                const s = e._dem.dim;
                i.push(r.canonical);
                let a = !1;
                for (const t1 of this.getNodesInfo()){
                    const r = t1.node;
                    if (!r.footprint || !r.footprint.grid) continue;
                    const n = r.footprint.grid, i = e.tileCoordToPixel(n.min.x, n.min.y), o = e.tileCoordToPixel(n.max.x, n.max.y), l = Math.min(Math.min(s - o.y, i.x), Math.min(i.y, s - o.x));
                    if (l < 0) continue;
                    const u = Q(l, 2, 5);
                    let c = Math.max(0, i.x - u), h = Math.max(0, i.y - u), p = Math.min(o.x + u, s - 1), f = Math.min(o.y + u, s - 1);
                    for(let t1 = h; t1 <= f; ++t1)for(let e = c; e <= p; ++e)sy[t1 * s + e] = 255;
                    let d = 0, m = 0;
                    for(let t1 = 0; t1 < n.cellsY; ++t1)for(let r = 0; r < n.cellsX; ++r){
                        if (!n.cells[t1 * n.cellsX + r]) continue;
                        const i = e.tileCoordToPixel(n.min.x + r / n.xScale, n.min.y + t1 / n.yScale), a = e.tileCoordToPixel(n.min.x + (r + 1) / n.xScale, n.min.y + (t1 + 1) / n.yScale);
                        for(let t1 = i.y; t1 <= Math.min(a.y + 1, s - 1); ++t1)for(let r = i.x; r <= Math.min(a.x + 1, s - 1); ++r)255 === sy[t1 * s + r] && (sy[t1 * s + r] = 0, d += e.getElevationAtPixel(r, t1), m++);
                    }
                    const y = d / m;
                    c = Math.max(1, i.x - u), h = Math.max(1, i.y - u), p = Math.min(o.x + u, s - 2), f = Math.min(o.y + u, s - 2), a = !0;
                    for(let t1 = h; t1 <= f; ++t1)for(let r = c; r <= p; ++r)0 === sy[t1 * s + r] && (iy[t1 * s + r] = e._dem.set(r, t1, y));
                    for(let t1 = 1; t1 < u; ++t1){
                        c = Math.max(1, i.x - t1), h = Math.max(1, i.y - t1), p = Math.min(o.x + t1, s - 2), f = Math.min(o.y + t1, s - 2);
                        for(let r = h; r <= f; ++r)for(let n = c; n <= p; ++n){
                            const i = r * s + n;
                            if (255 === sy[i]) {
                                let a = 0, o = 0, l = -1, c = -1;
                                for(let e = -1; e <= 1; ++e)for(let i = -1; i <= 1; ++i){
                                    const u = (r + e) * s + n + i;
                                    if (sy[u] >= t1) continue;
                                    const h = iy[u], p = Math.abs(h);
                                    p > o && (a = h, o = p, l = i, c = e);
                                }
                                if (o > .1) {
                                    const s = 1 - (t1 + .5 * Math.abs(l * c)) / u;
                                    let o = e._dem.get(n, r) + a * s;
                                    const h = e._dem.get(n + l, r + c), p = e._dem.get(n - l, r - c, !0);
                                    (o - h) * (o - p) > 0 && (o = (h + p) / 2), iy[i] = e._dem.set(n, r, o), sy[i] = t1;
                                }
                            }
                        }
                    }
                }
                a && (e._demTile.needsDEMTextureUpload = !0, e._dem._timestamp = Dt.now());
            }
            getNodesInfo() {
                return this.nodesInfo;
            }
            destroy() {
                const t1 = this.getNodesInfo();
                for (const e of t1)ey(e.node), ry(e.node);
            }
            isEmpty() {
                return !this.nodesInfo.length;
            }
            updateReplacement(t1, e) {
                if (e.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = e.updateTime;
                const r = e.getReplacementRegionsForTile(t1.toUnwrapped()), n = this.getNodesInfo();
                for(let t1 = 0; t1 < this.nodesInfo.length; t1++){
                    const e = n[t1].node;
                    n[t1].hiddenByReplacement = !!e.footprint && !r.find((t1)=>t1.footprint === e.footprint);
                }
            }
            getHeightAtTileCoord(t1, e) {
                const r = this.getNodesInfo(), n = [], i = [
                    0,
                    0,
                    0
                ], s = O.mat4.identity([]);
                for(let a = 0; a < this.nodesInfo.length; a++){
                    const o = r[a], l = o.node.meshes[0], u = l.transformedAabb;
                    if (t1 < u.min[0] || e < u.min[1] || t1 > u.max[0] || e > u.max[1]) continue;
                    if (!0 === o.node.hidden) return {
                        height: 1 / 0,
                        maxHeight: o.feature.properties.height,
                        hidden: !1,
                        verticalScale: o.evaluatedScale[2]
                    };
                    O.mat4.invert(s, o.node.matrix), i[0] = t1, i[1] = e, O.vec3.transformMat4(i, i, s);
                    const c = (i[0] - l.aabb.min[0]) / (l.aabb.max[0] - l.aabb.min[0]) * Wm | 0, h = Math.min(63, (i[1] - l.aabb.min[1]) / (l.aabb.max[1] - l.aabb.min[1]) * Wm | 0) * Wm + Math.min(63, c), p = l.heightmap[h];
                    if (!(p < 0 && o.node.footprint)) {
                        if (o.hiddenByReplacement) return;
                        return {
                            height: p,
                            maxHeight: o.feature.properties.height,
                            hidden: !1,
                            verticalScale: o.evaluatedScale[2]
                        };
                    }
                    if (o.node.footprint.grid.query(new q(t1, e), new q(t1, e), n), n.length > 0) return {
                        height: void 0,
                        maxHeight: o.feature.properties.height,
                        hidden: o.hiddenByReplacement,
                        verticalScale: o.evaluatedScale[2]
                    };
                }
            }
        }
        function hy(t1, e) {
            return !t1.isLightConstant && e;
        }
        function py(t1, e, r, n, i, s, a, o) {
            let l = (61440 & e | (61440 & e) >> 4) >> 8, u = (3840 & e | (3840 & e) >> 4) >> 4, c = 240 & e | (240 & e) >> 4;
            r[3] > 0 && (l = ke(l, 255 * r[0], r[3]), u = ke(u, 255 * r[1], r[3]), c = ke(c, 255 * r[2], r[3]));
            const h = l << 8 | u, p = c << 8 | Math.floor(255 * n[3]), f = function(t1) {
                const e = Q(t1, 0, 2);
                return Math.min(Math.round(.5 * e * 255), 255);
            }(n[2]) << 8 | 15 * n[0] << 4 | 15 * n[1], d = Q(i[0], 0, 1), m = Q(i[1], 0, 1), y = Q(i[2], 0, 1), g = Q(i[3], 0, 1);
            let x, b, v, w;
            if (d !== m && a !== s && m !== d) {
                const t1 = a - s;
                b = 1 / (t1 * (m - d)), v = -(s + t1 * d) / (t1 * (m - d));
                const e = Q(i[4], -1, 1);
                w = Math.pow(10, e), x = 255 * y << 8 | 255 * g;
            } else x = 65535, b = 0, v = 1, w = 1;
            if (t1.emplaceBack(h, p, f, x, b, v, w), o) {
                const t1 = o.length;
                o.clear();
                for(let e = 0; e < t1; e++)o.emplaceBack(h, p, f, x, b, v, w);
            }
        }
        function fy(t1, e, r) {
            const n = t1.node;
            let i = 0;
            const s = r & Hm.HasMeshoptCompression;
            for (const r of n.meshes){
                if (n.lights && n.lightMeshIndex === i) continue;
                if (!r.featureData) continue;
                r.featureArray = new Xa, r.featureArray.reserve(r.featureData.length);
                let a = e;
                for (const e of r.featureData){
                    const i = s ? 65535 & e : e >> 16 & 65535, o = s ? e >> 16 & 65535 : 65535 & e, l = (15 & o) < 8 ? 15 & o : 0, u = t1.evaluatedRMEA[l], c = t1.evaluatedColor[l], h = t1.emissionHeightBasedParams[l];
                    let p;
                    if (a && 2 === l && n.lights && (p = new Xa, p.resize(10 * n.lights.length)), py(r.featureArray, i, c, u, h, r.aabb.min[2], r.aabb.max[2], p), p && a) {
                        a = !1;
                        const t1 = n.meshes[n.lightMeshIndex];
                        t1.featureArray = p, t1.featureArray._trim();
                    }
                }
                r.featureArray._trim(), i++;
            }
        }
        function dy(t1, e, r, n) {
            const i = 1 << t1.z;
            e.lat = hl((n / Hr + t1.y) / i), e.lng = cl((r / Hr + t1.x) / i);
        }
        os(cy, "Tiled3dModelBucket", {
            omit: [
                "layers"
            ]
        }), os(uy, "Tiled3dModelFeature");
        const my = {
            circle: class extends pa {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: Wl || (Wl = new Gs({
                            "circle-sort-key": new qs(Xs.layout_circle["circle-sort-key"]),
                            visibility: new Ns(Xs.layout_circle.visibility)
                        })),
                        paint: Hl || (Hl = new Gs({
                            "circle-radius": new qs(Xs.paint_circle["circle-radius"]),
                            "circle-color": new qs(Xs.paint_circle["circle-color"]),
                            "circle-blur": new qs(Xs.paint_circle["circle-blur"]),
                            "circle-opacity": new qs(Xs.paint_circle["circle-opacity"]),
                            "circle-translate": new Ns(Xs.paint_circle["circle-translate"]),
                            "circle-translate-anchor": new Ns(Xs.paint_circle["circle-translate-anchor"]),
                            "circle-pitch-scale": new Ns(Xs.paint_circle["circle-pitch-scale"]),
                            "circle-pitch-alignment": new Ns(Xs.paint_circle["circle-pitch-alignment"]),
                            "circle-stroke-width": new qs(Xs.paint_circle["circle-stroke-width"]),
                            "circle-stroke-color": new qs(Xs.paint_circle["circle-stroke-color"]),
                            "circle-stroke-opacity": new qs(Xs.paint_circle["circle-stroke-opacity"]),
                            "circle-emissive-strength": new Ns(Xs.paint_circle["circle-emissive-strength"])
                        }))
                    }, e, r, n);
                }
                createBucket(t1) {
                    return new Tl(t1);
                }
                queryRadius(t1) {
                    const e = t1;
                    return Gl("circle-radius", this, e) + Gl("circle-stroke-width", this, e) + Xl(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(t1, e, r, n, i, s, a, o) {
                    const l = Zl(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), u = this.paint.get("circle-radius").evaluate(e, r) + this.paint.get("circle-stroke-width").evaluate(e, r);
                    return $u(t1, n, s, a, o, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l, u);
                }
                getProgramIds() {
                    return [
                        "circle"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    const n = qu(this);
                    return {
                        config: new Lo(this, {
                            zoom: e,
                            lut: r
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
            },
            heatmap: class extends pa {
                createBucket(t1) {
                    return new Wu(t1);
                }
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: Hu || (Hu = new Gs({
                            visibility: new Ns(Xs.layout_heatmap.visibility)
                        })),
                        paint: Ku || (Ku = new Gs({
                            "heatmap-radius": new qs(Xs.paint_heatmap["heatmap-radius"]),
                            "heatmap-weight": new qs(Xs.paint_heatmap["heatmap-weight"]),
                            "heatmap-intensity": new Ns(Xs.paint_heatmap["heatmap-intensity"]),
                            "heatmap-color": new $s(Xs.paint_heatmap["heatmap-color"]),
                            "heatmap-opacity": new Ns(Xs.paint_heatmap["heatmap-opacity"])
                        }))
                    }, e, r, n), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    "heatmap-color" === t1 && this._updateColorRamp();
                }
                _updateColorRamp() {
                    this.colorRamp = ac({
                        expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                queryRadius(t1) {
                    return Gl("heatmap-radius", this, t1);
                }
                queryIntersectsFeature(t1, e, r, n, i, s, a, o) {
                    const l = this.paint.get("heatmap-radius").evaluate(e, r);
                    return $u(t1, n, s, a, o, !0, !0, new q(0, 0), l);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "heatmap",
                        "heatmapTexture"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    return "heatmap" === t1 ? {
                        config: new Lo(this, {
                            zoom: e,
                            lut: r
                        }),
                        overrideFog: !1
                    } : {};
                }
            },
            hillshade: class extends pa {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: Ju || (Ju = new Gs({
                            visibility: new Ns(Xs.layout_hillshade.visibility)
                        })),
                        paint: Qu || (Qu = new Gs({
                            "hillshade-illumination-direction": new Ns(Xs.paint_hillshade["hillshade-illumination-direction"]),
                            "hillshade-illumination-anchor": new Ns(Xs.paint_hillshade["hillshade-illumination-anchor"]),
                            "hillshade-exaggeration": new Ns(Xs.paint_hillshade["hillshade-exaggeration"]),
                            "hillshade-shadow-color": new Ns(Xs.paint_hillshade["hillshade-shadow-color"]),
                            "hillshade-highlight-color": new Ns(Xs.paint_hillshade["hillshade-highlight-color"]),
                            "hillshade-accent-color": new Ns(Xs.paint_hillshade["hillshade-accent-color"]),
                            "hillshade-emissive-strength": new Ns(Xs.paint_hillshade["hillshade-emissive-strength"])
                        }))
                    }, e, r, n);
                }
                shouldRedrape() {
                    return this.hasOffscreenPass() && "viewport" === this.paint.get("hillshade-illumination-anchor");
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "hillshade",
                        "hillshadePrepare"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    return {
                        overrideFog: !1
                    };
                }
            },
            fill: class extends pa {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: Oc || (Oc = new Gs({
                            "fill-sort-key": new qs(Xs.layout_fill["fill-sort-key"]),
                            visibility: new Ns(Xs.layout_fill.visibility)
                        })),
                        paint: Uc || (Uc = new Gs({
                            "fill-antialias": new Ns(Xs.paint_fill["fill-antialias"]),
                            "fill-opacity": new qs(Xs.paint_fill["fill-opacity"]),
                            "fill-color": new qs(Xs.paint_fill["fill-color"]),
                            "fill-outline-color": new qs(Xs.paint_fill["fill-outline-color"]),
                            "fill-translate": new Ns(Xs.paint_fill["fill-translate"]),
                            "fill-translate-anchor": new Ns(Xs.paint_fill["fill-translate-anchor"]),
                            "fill-pattern": new qs(Xs.paint_fill["fill-pattern"]),
                            "fill-emissive-strength": new Ns(Xs.paint_fill["fill-emissive-strength"]),
                            "fill-z-offset": new qs(Xs.paint_fill["fill-z-offset"])
                        }))
                    }, e, r, n);
                }
                getProgramIds() {
                    const t1 = this.paint.get("fill-pattern"), e = t1 && t1.constantOr(1), r = [
                        e ? "fillPattern" : "fill"
                    ];
                    return this.paint.get("fill-antialias") && r.push(e && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), r;
                }
                getDefaultProgramParams(t1, e, r) {
                    return {
                        config: new Lo(this, {
                            zoom: e,
                            lut: r
                        }),
                        overrideFog: !1
                    };
                }
                recalculate(t1, e) {
                    super.recalculate(t1, e);
                    const r = this.paint._values["fill-outline-color"];
                    "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(t1) {
                    return new Fc(t1);
                }
                queryRadius() {
                    return Xl(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(t1, e, r, n, i, s) {
                    return !t1.queryGeometry.isAboveHorizon && Vl(Yl(t1.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), n);
                }
                isTileClipped() {
                    return !0;
                }
                is3D() {
                    return 0 !== this.paint.get("fill-z-offset").constantOr(1);
                }
            },
            "fill-extrusion": class extends pa {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: sp || (sp = new Gs({
                            visibility: new Ns(Xs["layout_fill-extrusion"].visibility),
                            "fill-extrusion-edge-radius": new Ns(Xs["layout_fill-extrusion"]["fill-extrusion-edge-radius"])
                        })),
                        paint: ap || (ap = new Gs({
                            "fill-extrusion-opacity": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                            "fill-extrusion-color": new qs(Xs["paint_fill-extrusion"]["fill-extrusion-color"]),
                            "fill-extrusion-translate": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-translate"]),
                            "fill-extrusion-translate-anchor": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                            "fill-extrusion-pattern": new qs(Xs["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                            "fill-extrusion-height": new qs(Xs["paint_fill-extrusion"]["fill-extrusion-height"]),
                            "fill-extrusion-base": new qs(Xs["paint_fill-extrusion"]["fill-extrusion-base"]),
                            "fill-extrusion-vertical-gradient": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
                            "fill-extrusion-ambient-occlusion-intensity": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),
                            "fill-extrusion-ambient-occlusion-radius": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]),
                            "fill-extrusion-ambient-occlusion-wall-radius": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-radius": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-attenuation": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]),
                            "fill-extrusion-flood-light-color": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]),
                            "fill-extrusion-flood-light-intensity": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]),
                            "fill-extrusion-flood-light-wall-radius": new qs(Xs["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]),
                            "fill-extrusion-flood-light-ground-radius": new qs(Xs["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]),
                            "fill-extrusion-flood-light-ground-attenuation": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]),
                            "fill-extrusion-vertical-scale": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]),
                            "fill-extrusion-rounded-roof": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]),
                            "fill-extrusion-cutoff-fade-range": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]),
                            "fill-extrusion-emissive-strength": new qs(Xs["paint_fill-extrusion"]["fill-extrusion-emissive-strength"]),
                            "fill-extrusion-line-width": new qs(Xs["paint_fill-extrusion"]["fill-extrusion-line-width"]),
                            "fill-extrusion-cast-shadows": new Ns(Xs["paint_fill-extrusion"]["fill-extrusion-cast-shadows"])
                        }))
                    }, e, r, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(t1) {
                    return new Zh(t1);
                }
                queryRadius() {
                    return Xl(this.paint.get("fill-extrusion-translate"));
                }
                is3D() {
                    return !0;
                }
                hasShadowPass() {
                    return this.paint.get("fill-extrusion-cast-shadows");
                }
                cutoffRange() {
                    return this.paint.get("fill-extrusion-cutoff-fade-range");
                }
                canCastShadows() {
                    return !0;
                }
                getProgramIds() {
                    return [
                        this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"
                    ];
                }
                queryIntersectsFeature(t1, e, r, n, i, s, a, o, l) {
                    const u = Zl(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), c = this.paint.get("fill-extrusion-height").evaluate(e, r), h = this.paint.get("fill-extrusion-base").evaluate(e, r), p = [
                        0,
                        0
                    ], f = o && s.elevation, d = s.elevation ? s.elevation.exaggeration() : 1, m = t1.tile.getBucket(this);
                    if (f && m instanceof Zh) {
                        const t1 = m.centroidVertexArray, e = l + 1;
                        e < t1.length && (p[0] = t1.geta_centroid_pos0(e), p[1] = t1.geta_centroid_pos1(e));
                    }
                    if (0 === p[0] && 1 === p[1]) return !1;
                    "globe" === s.projection.name && (n = np([
                        n
                    ], [
                        new q(0, 0),
                        new q(Hr, Hr)
                    ], t1.tileID.canonical).map((t1)=>t1.polygon).flat());
                    const y = f ? o : null, [g, x] = function(t1, e, r, n, i, s, a, o, l, u, c) {
                        return "globe" === t1.projection.name ? function(t1, e, r, n, i, s, a, o, l, u, c) {
                            const h = [], p = [], f = t1.projection.upVectorScale(c, t1.center.lat, t1.worldSize).metersToTile, d = [
                                0,
                                0,
                                0,
                                1
                            ], m = [
                                0,
                                0,
                                0,
                                1
                            ], y = (t1, e, r, n)=>{
                                t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = 1;
                            }, g = rp();
                            r > 0 && (r += g), n += g;
                            for (const g of e){
                                const e = [], x = [];
                                for (const h of g){
                                    const p = h.x + i.x, g = h.y + i.y, b = t1.projection.projectTilePoint(p, g, c), v = t1.projection.upVector(c, h.x, h.y);
                                    let w = r, _ = n;
                                    if (a) {
                                        const t1 = up(p, g, r, n, a, o, l, u);
                                        w += t1.base, _ += t1.top;
                                    }
                                    0 !== r ? y(d, b.x + v[0] * f * w, b.y + v[1] * f * w, b.z + v[2] * f * w) : y(d, b.x, b.y, b.z), y(m, b.x + v[0] * f * _, b.y + v[1] * f * _, b.z + v[2] * f * _), O.vec3.transformMat4(d, d, s), O.vec3.transformMat4(m, m, s), e.push(new hh(d[0], d[1], d[2])), x.push(new hh(m[0], m[1], m[2]));
                                }
                                h.push(e), p.push(x);
                            }
                            return [
                                h,
                                p
                            ];
                        }(t1, e, r, n, i, s, a, o, l, u, c) : a ? function(t1, e, r, n, i, s, a, o, l) {
                            const u = [], c = [], h = [
                                0,
                                0,
                                0,
                                1
                            ];
                            for (const p of t1){
                                const t1 = [], f = [];
                                for (const u of p){
                                    const c = u.x + n.x, p = u.y + n.y, d = up(c, p, e, r, s, a, o, l);
                                    h[0] = c, h[1] = p, h[2] = d.base, h[3] = 1, O.vec4.transformMat4(h, h, i), h[3] = Math.max(h[3], 1e-5);
                                    const m = new hh(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                                    h[0] = c, h[1] = p, h[2] = d.top, h[3] = 1, O.vec4.transformMat4(h, h, i), h[3] = Math.max(h[3], 1e-5);
                                    const y = new hh(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                                    t1.push(m), f.push(y);
                                }
                                u.push(t1), c.push(f);
                            }
                            return [
                                u,
                                c
                            ];
                        }(e, r, n, i, s, a, o, l, u) : function(t1, e, r, n, i) {
                            const s = [], a = [], o = i[8] * e, l = i[9] * e, u = i[10] * e, c = i[11] * e, h = i[8] * r, p = i[9] * r, f = i[10] * r, d = i[11] * r;
                            for (const e of t1){
                                const t1 = [], r = [];
                                for (const s of e){
                                    const e = s.x + n.x, a = s.y + n.y, m = i[0] * e + i[4] * a + i[12], y = i[1] * e + i[5] * a + i[13], g = i[2] * e + i[6] * a + i[14], x = i[3] * e + i[7] * a + i[15], b = m + o, v = y + l, w = g + u, _ = Math.max(x + c, 1e-5), M = m + h, A = y + p, S = g + f, I = Math.max(x + d, 1e-5);
                                    t1.push(new hh(b / _, v / _, w / _)), r.push(new hh(M / I, A / I, S / I));
                                }
                                s.push(t1), a.push(r);
                            }
                            return [
                                s,
                                a
                            ];
                        }(e, r, n, i, s);
                    }(s, n, h, c, u, a, y, p, d, s.center.lat, t1.tileID.canonical), b = t1.queryGeometry;
                    return function(t1, e, r) {
                        let n = 1 / 0;
                        Vl(r, e) && (n = lp(r, e[0]));
                        for(let i = 0; i < e.length; i++){
                            const s = e[i], a = t1[i];
                            for(let t1 = 0; t1 < s.length - 1; t1++){
                                const e = s[t1], i = [
                                    e,
                                    s[t1 + 1],
                                    a[t1 + 1],
                                    a[t1],
                                    e
                                ];
                                El(r, i) && (n = Math.min(n, lp(r, i)));
                            }
                        }
                        return n !== 1 / 0 && n;
                    }(g, x, b.isPointQuery() ? b.screenBounds : b.screenGeometry);
                }
            },
            line: class extends pa {
                constructor(t1, e, r, n){
                    const i = Ep();
                    super(t1, i, e, r, n), i.layout && (this.layout = new js(i.layout)), this.gradientVersion = 0;
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    if ("line-gradient" === t1) {
                        const t1 = this._transitionablePaint._values["line-gradient"].value.expression;
                        this.stepInterpolant = t1._styleExpression && t1._styleExpression.expression instanceof Un, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    }
                }
                gradientExpression() {
                    return this._transitionablePaint._values["line-gradient"].value.expression;
                }
                widthExpression() {
                    return this._transitionablePaint._values["line-width"].value.expression;
                }
                recalculate(t1, e) {
                    super.recalculate(t1, e), this.paint._values["line-floorwidth"] = (()=>{
                        if (Vp) return Vp;
                        const t1 = Ep();
                        return Vp = new Bp(t1.paint.properties["line-width"].specification), Vp.useIntegerZoom = !0, Vp;
                    })().possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t1);
                }
                createBucket(t1) {
                    return new wp(t1);
                }
                getProgramIds() {
                    return [
                        this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    const n = zp(this);
                    return {
                        config: new Lo(this, {
                            zoom: e,
                            lut: r
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                queryRadius(t1) {
                    const e = t1, r = Cp(Gl("line-width", this, e), Gl("line-gap-width", this, e)), n = Gl("line-offset", this, e);
                    return r / 2 + Math.abs(n) + Xl(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(t1, e, r, n, i, s) {
                    if (t1.queryGeometry.isAboveHorizon) return !1;
                    const a = Yl(t1.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), o = t1.pixelToTileUnitsFactor / 2 * Cp(this.paint.get("line-width").evaluate(e, r), this.paint.get("line-gap-width").evaluate(e, r)), l = this.paint.get("line-offset").evaluate(e, r);
                    return l && (n = function(t1, e) {
                        const r = [], n = new q(0, 0);
                        for(let i = 0; i < t1.length; i++){
                            const s = t1[i], a = [];
                            for(let t1 = 0; t1 < s.length; t1++){
                                const r = s[t1], i = s[t1 + 1], o = 0 === t1 ? n : r.sub(s[t1 - 1])._unit()._perp(), l = t1 === s.length - 1 ? n : i.sub(r)._unit()._perp(), u = o._add(l)._unit();
                                u._mult(1 / (u.x * l.x + u.y * l.y)), a.push(u._mult(e)._add(r));
                            }
                            r.push(a);
                        }
                        return r;
                    }(n, l * t1.pixelToTileUnitsFactor)), function(t1, e, r) {
                        for(let n = 0; n < e.length; n++){
                            const i = e[n];
                            if (t1.length >= 3) {
                                for(let e = 0; e < i.length; e++)if (Ul(t1, i[e])) return !0;
                            }
                            if (Cl(t1, i, r)) return !0;
                        }
                        return !1;
                    }(a, n, o);
                }
                isTileClipped() {
                    return !0;
                }
                isDraped(t1) {
                    const e = this.layout.get("line-z-offset");
                    return e.isConstant() && !e.constantOr(0);
                }
            },
            symbol: tm,
            background: class extends pa {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: em || (em = new Gs({
                            visibility: new Ns(Xs.layout_background.visibility)
                        })),
                        paint: rm || (rm = new Gs({
                            "background-pitch-alignment": new Ns(Xs.paint_background["background-pitch-alignment"]),
                            "background-color": new Ns(Xs.paint_background["background-color"]),
                            "background-pattern": new Ns(Xs.paint_background["background-pattern"]),
                            "background-opacity": new Ns(Xs.paint_background["background-opacity"]),
                            "background-emissive-strength": new Ns(Xs.paint_background["background-emissive-strength"])
                        }))
                    }, e, r, n);
                }
                getProgramIds() {
                    return [
                        this.paint.get("background-pattern") ? "backgroundPattern" : "background"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    return {
                        overrideFog: !1
                    };
                }
                is3D() {
                    return "viewport" === this.paint.get("background-pitch-alignment");
                }
            },
            raster: mm,
            "raster-particle": wm,
            sky: class extends pa {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: xm || (xm = new Gs({
                            visibility: new Ns(Xs.layout_sky.visibility)
                        })),
                        paint: bm || (bm = new Gs({
                            "sky-type": new Ns(Xs.paint_sky["sky-type"]),
                            "sky-atmosphere-sun": new Ns(Xs.paint_sky["sky-atmosphere-sun"]),
                            "sky-atmosphere-sun-intensity": new Ns(Xs.paint_sky["sky-atmosphere-sun-intensity"]),
                            "sky-gradient-center": new Ns(Xs.paint_sky["sky-gradient-center"]),
                            "sky-gradient-radius": new Ns(Xs.paint_sky["sky-gradient-radius"]),
                            "sky-gradient": new $s(Xs.paint_sky["sky-gradient"]),
                            "sky-atmosphere-halo-color": new Ns(Xs.paint_sky["sky-atmosphere-halo-color"]),
                            "sky-atmosphere-color": new Ns(Xs.paint_sky["sky-atmosphere-color"]),
                            "sky-opacity": new Ns(Xs.paint_sky["sky-opacity"])
                        }))
                    }, e, r, n), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    "sky-gradient" === t1 ? this._updateColorRamp() : "sky-atmosphere-sun" !== t1 && "sky-atmosphere-halo-color" !== t1 && "sky-atmosphere-color" !== t1 && "sky-atmosphere-sun-intensity" !== t1 || (this._skyboxInvalidated = !0);
                }
                _updateColorRamp() {
                    this.colorRamp = ac({
                        expression: this._transitionablePaint._values["sky-gradient"].value.expression,
                        evaluationKey: "skyRadialProgress"
                    }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                needsSkyboxCapture(t1) {
                    if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return !0;
                    if (!this.paint.get("sky-atmosphere-sun")) {
                        const e = t1.style.light.properties.get("position");
                        return this._lightPosition.azimuthal !== e.azimuthal || this._lightPosition.polar !== e.polar;
                    }
                    return !1;
                }
                getCenter(t1, e) {
                    if ("atmosphere" === this.paint.get("sky-type")) {
                        const r = this.paint.get("sky-atmosphere-sun"), n = !r, i = t1.style.light, s = i.properties.get("position");
                        return n && "viewport" === i.properties.get("anchor") && ft("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n ? Mm(s.azimuthal, 90 - s.polar, e) : Mm(r[0], 90 - r[1], e);
                    }
                    const r = this.paint.get("sky-gradient-center");
                    return Mm(r[0], 90 - r[1], e);
                }
                isSky() {
                    return !0;
                }
                markSkyboxValid(t1) {
                    this._skyboxInvalidated = !1, this._lightPosition = t1.style.light.properties.get("position");
                }
                hasOffscreenPass() {
                    return !0;
                }
                getProgramIds() {
                    const t1 = this.paint.get("sky-type");
                    return "atmosphere" === t1 ? [
                        "skyboxCapture",
                        "skybox"
                    ] : "gradient" === t1 ? [
                        "skyboxGradient"
                    ] : null;
                }
            },
            slot: class extends pa {
                constructor(t1, e, r, n){
                    super(t1, {
                        paint: vm || (vm = new Gs({}))
                    }, e, null);
                }
            },
            model: class extends pa {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: Ym || (Ym = new Gs({
                            visibility: new Ns(Xs.layout_model.visibility),
                            "model-id": new qs(Xs.layout_model["model-id"])
                        })),
                        paint: Zm || (Zm = new Gs({
                            "model-opacity": new Ns(Xs.paint_model["model-opacity"]),
                            "model-rotation": new qs(Xs.paint_model["model-rotation"]),
                            "model-scale": new qs(Xs.paint_model["model-scale"]),
                            "model-translation": new qs(Xs.paint_model["model-translation"]),
                            "model-color": new qs(Xs.paint_model["model-color"]),
                            "model-color-mix-intensity": new qs(Xs.paint_model["model-color-mix-intensity"]),
                            "model-type": new Ns(Xs.paint_model["model-type"]),
                            "model-cast-shadows": new Ns(Xs.paint_model["model-cast-shadows"]),
                            "model-receive-shadows": new Ns(Xs.paint_model["model-receive-shadows"]),
                            "model-ambient-occlusion-intensity": new Ns(Xs.paint_model["model-ambient-occlusion-intensity"]),
                            "model-emissive-strength": new qs(Xs.paint_model["model-emissive-strength"]),
                            "model-roughness": new qs(Xs.paint_model["model-roughness"]),
                            "model-height-based-emissive-strength-multiplier": new qs(Xs.paint_model["model-height-based-emissive-strength-multiplier"]),
                            "model-cutoff-fade-range": new Ns(Xs.paint_model["model-cutoff-fade-range"]),
                            "model-front-cutoff": new Ns(Xs.paint_model["model-front-cutoff"])
                        }))
                    }, e, r, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(t1) {
                    return new Xm(t1);
                }
                getProgramIds() {
                    return [
                        "model"
                    ];
                }
                is3D() {
                    return !0;
                }
                hasShadowPass() {
                    return !0;
                }
                canCastShadows() {
                    return !0;
                }
                hasLightBeamPass() {
                    return !0;
                }
                cutoffRange() {
                    return this.paint.get("model-cutoff-fade-range");
                }
                queryRadius(t1) {
                    return t1 instanceof cy ? Hr - 1 : 0;
                }
                queryIntersectsFeature(t1, e, r, n, i, s) {
                    if (!this.modelManager) return !1;
                    const a = this.modelManager, o = t1.tile.getBucket(this);
                    if (!(o && o instanceof Xm)) return !1;
                    const l = o;
                    for(const r in l.instancesPerModel){
                        const n = l.instancesPerModel[r], i = void 0 !== e.id ? e.id : e.properties && e.properties.hasOwnProperty("id") ? e.properties.id : void 0;
                        if (n.idToFeaturesIndex.hasOwnProperty(i)) {
                            const e = n.features[n.idToFeaturesIndex[i]], o = a.getModel(r, this.scope);
                            if (!o) return !1;
                            let u = O.mat4.create();
                            const c = new rl(0, 0), h = l.canonical;
                            let p = Number.MAX_VALUE;
                            for(let r = 0; r < e.instancedDataCount; ++r){
                                const i = 16 * (e.instancedDataOffset + r), a = n.instancedDataArray.float32, l = [
                                    a[i + 4],
                                    a[i + 5],
                                    a[i + 6]
                                ];
                                dy(h, c, a[i], 0 | a[i + 1]), Km(u, o, s, c, e.rotation, e.scale, l, !1, !1, !1), "globe" === s.projection.name && (u = Bm(u, s));
                                const f = O.mat4.multiply([], s.projMatrix, u), d = t1.queryGeometry, m = Vm(d.isPointQuery() ? d.screenBounds : d.screenGeometry, s, f, o.aabb);
                                null != m && (p = Math.min(m, p));
                            }
                            return p !== Number.MAX_VALUE && p;
                        }
                    }
                    return !1;
                }
                _handleOverridablePaintPropertyUpdate(t1, e, r) {
                    return !(!this.layout || e.isDataDriven() || r.isDataDriven() || "model-color" !== t1 && "model-color-mix-intensity" !== t1 && "model-rotation" !== t1 && "model-scale" !== t1 && "model-translation" !== t1 && "model-emissive-strength" !== t1);
                }
                _isPropertyZoomDependent(t1) {
                    const e = this._transitionablePaint._values[t1];
                    return null != e && null != e.value && null != e.value.expression && e.value.expression instanceof Ji;
                }
                isZoomDependent() {
                    return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
                }
                queryIntersectsMatchingFeature(t1, e, r, n) {
                    const i = t1.tile, s = i.getBucket(this);
                    let a = null, o = Number.MAX_VALUE;
                    if (!(s && s instanceof cy)) return {
                        queryFeature: a,
                        intersectionZ: o
                    };
                    const l = s.getNodesInfo()[e];
                    if (l.hiddenByReplacement || !l.node.meshes || !r.filter(new Vs(i.tileID.overscaledZ), l.feature, i.tileID.canonical)) return {
                        queryFeature: a,
                        intersectionZ: o
                    };
                    const u = l.node, c = n.calculatePosMatrix(i.tileID.toUnwrapped(), n.worldSize), h = l.evaluatedScale;
                    let p = 0;
                    n.elevation && u.elevation && (p = u.elevation * n.elevation.exaggeration()), O.mat4.translate(c, c, [
                        (u.anchor ? u.anchor[0] : 0) * (h[0] - 1),
                        (u.anchor ? u.anchor[1] : 0) * (h[1] - 1),
                        p
                    ]), O.mat4.scale(c, c, h), O.mat4.multiply(c, c, u.matrix);
                    const f = t1.queryGeometry, d = f.isPointQuery() ? f.screenBounds : f.screenGeometry, m = function(t1) {
                        const e = O.mat4.multiply([], c, t1.matrix), r = O.mat4.multiply(e, n.expandedFarZProjMatrix, e);
                        for(let e = 0; e < t1.meshes.length; ++e){
                            const i = t1.meshes[e];
                            if (e === t1.lightMeshIndex) continue;
                            const s = Vm(d, n, r, i.aabb);
                            null != s && (o = Math.min(s, o));
                        }
                        if (t1.children) for (const e of t1.children)m(e);
                    };
                    if (m(u), o === Number.MAX_VALUE) return {
                        queryFeature: a,
                        intersectionZ: o
                    };
                    const y = new rl(0, 0);
                    return dy(i.tileID.canonical, y, l.node.anchor[0], l.node.anchor[1]), a = {
                        type: "Feature",
                        geometry: {
                            type: "Point",
                            coordinates: [
                                y.lng,
                                y.lat
                            ]
                        },
                        properties: l.feature.properties,
                        id: l.feature.id,
                        state: {},
                        layer: this.serialize()
                    }, {
                        queryFeature: a,
                        intersectionZ: o
                    };
                }
            },
            clip: class extends pa {
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: jc || (jc = new Gs({
                            "clip-layer-types": new Ns(Xs.layout_clip["clip-layer-types"]),
                            "clip-layer-scope": new Ns(Xs.layout_clip["clip-layer-scope"])
                        })),
                        paint: Nc || (Nc = new Gs({}))
                    }, e, r, n);
                }
                recalculate(t1, e) {
                    super.recalculate(t1, e);
                }
                createBucket(t1) {
                    return new Gc(t1);
                }
                isTileClipped() {
                    return !0;
                }
                is3D() {
                    return !0;
                }
            }
        };
        class yy {
            constructor(t1){
                this._callback = t1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                this._channel = void 0, this._callback = ()=>{};
            }
        }
        class gy {
            constructor(){
                this.tasks = {}, this.taskQueue = [], ot([
                    "process"
                ], this), this.invoker = new yy(this.process), this.nextId = 0;
            }
            add(t1, e) {
                const r = this.nextId++, n = function({ type: t1, isSymbolTile: e, zoom: r }) {
                    return r = r || 0, "message" === t1 ? 0 : "maybePrepare" !== t1 || e ? "parseTile" !== t1 || e ? "parseTile" === t1 && e ? 300 - r : "maybePrepare" === t1 && e ? 400 - r : 500 : 200 - r : 100 - r;
                }(e);
                if (0 === n) {
                    t1();
                    return null;
                }
                return this.tasks[r] = {
                    fn: t1,
                    metadata: e,
                    priority: n,
                    id: r
                }, this.taskQueue.push(r), this.invoker.trigger(), {
                    cancel: ()=>{
                        delete this.tasks[r];
                    }
                };
            }
            process() {
                {
                    if (this.taskQueue = this.taskQueue.filter((t1)=>!!this.tasks[t1]), !this.taskQueue.length) return;
                    const t1 = this.pick();
                    if (null === t1) return;
                    const e = this.tasks[t1];
                    if (delete this.tasks[t1], this.taskQueue.length && this.invoker.trigger(), !e) return;
                    e.fn();
                }
            }
            pick() {
                let t1 = null, e = 1 / 0;
                for(let r = 0; r < this.taskQueue.length; r++){
                    const n = this.tasks[this.taskQueue[r]];
                    n.priority < e && (e = n.priority, t1 = r);
                }
                if (null === t1) return null;
                const r = this.taskQueue[t1];
                return this.taskQueue.splice(t1, 1), r;
            }
            remove() {
                this.invoker.remove();
            }
        }
        class xy {
            constructor(t1, e, r){
                this.target = t1, this.parent = e, this.mapId = r, this.callbacks = {}, this.cancelCallbacks = {}, ot([
                    "receive"
                ], this), this.target.addEventListener("message", this.receive, !1), this.scheduler = new gy;
            }
            send(t1, e, r, n, i = !1, s) {
                const a = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                r && (r.metadata = s, this.callbacks[a] = r);
                const o = new Set;
                return this.target.postMessage({
                    id: a,
                    type: t1,
                    hasCallback: !!r,
                    targetMapId: n,
                    mustQueue: i,
                    sourceMapId: this.mapId,
                    data: cs(e, o)
                }, o), {
                    cancel: ()=>{
                        r && delete this.callbacks[a], this.target.postMessage({
                            id: a,
                            type: "<cancel>",
                            targetMapId: n,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            receive(t1) {
                const e = t1.data, r = e.id;
                if (r && (!e.targetMapId || this.mapId === e.targetMapId)) {
                    if ("<cancel>" === e.type) {
                        const t1 = this.cancelCallbacks[r];
                        delete this.cancelCallbacks[r], t1 && t1.cancel();
                    } else if (e.mustQueue || gt()) {
                        const t1 = this.callbacks[r], n = this.scheduler.add(()=>this.processTask(r, e), t1 && t1.metadata || {
                            type: "message"
                        });
                        n && (this.cancelCallbacks[r] = n);
                    } else this.processTask(r, e);
                }
            }
            processTask(t1, e) {
                if (delete this.cancelCallbacks[t1], "<response>" === e.type) {
                    const r = this.callbacks[t1];
                    delete this.callbacks[t1], r && (e.error ? r(hs(e.error)) : r(null, hs(e.data)));
                } else {
                    const r = new Set, n = e.hasCallback ? (e, n)=>{
                        this.target.postMessage({
                            id: t1,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: e ? cs(e) : null,
                            data: cs(n, r)
                        }, r);
                    } : (t1)=>{}, i = hs(e.data);
                    if (this.parent[e.type]) this.parent[e.type](e.sourceMapId, i, n);
                    else if (this.parent.getWorkerSource) {
                        const t1 = e.type.split(".");
                        this.parent.getWorkerSource(e.sourceMapId, t1[0], i.source, i.scope)[t1[1]](i, n);
                    } else n(new Error(`Could not find function ${e.type}`));
                }
            }
            remove() {
                this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
        }
        class by {
            constructor(t1, e){
                this.workerPool = t1, this.actors = [], this.currentActor = 0, this.id = st();
                const r = this.workerPool.acquire(this.id);
                for(let t1 = 0; t1 < r.length; t1++){
                    const n = new by.Actor(r[t1], e, this.id);
                    n.name = `Worker ${t1}`, this.actors.push(n);
                }
                this.ready = !1, this.broadcast("checkIfReady", null, ()=>{
                    this.ready = !0;
                });
            }
            broadcast(t1, e, r) {
                rt(this.actors, (r, n)=>{
                    r.send(t1, e, n);
                }, r = r || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
                this.actors.forEach((t1)=>{
                    t1.remove();
                }), this.actors = [], this.workerPool.release(this.id);
            }
        }
        by.Actor = xy;
        class vy {
            constructor(t1){
                this.size = t1, this.minimums = [], this.maximums = [], this.leaves = [];
            }
            getElevation(t1, e) {
                const r = this.toIdx(t1, e);
                return {
                    min: this.minimums[r],
                    max: this.maximums[r]
                };
            }
            isLeaf(t1, e) {
                return this.leaves[this.toIdx(t1, e)];
            }
            toIdx(t1, e) {
                return e * this.size + t1;
            }
        }
        function wy(t1, e, r, n) {
            let i = 0, s = Number.MAX_VALUE;
            for(let a = 0; a < 3; a++)if (Math.abs(n[a]) < 1e-15) {
                if (r[a] < t1[a] || r[a] > e[a]) return null;
            } else {
                const o = 1 / n[a];
                let l = (t1[a] - r[a]) * o, u = (e[a] - r[a]) * o;
                if (l > u) {
                    const t1 = l;
                    l = u, u = t1;
                }
                if (l > i && (i = l), u < s && (s = u), i > s) return null;
            }
            return i;
        }
        function _y(t1, e, r, n, i, s, a, o, l, u, c) {
            const h = n - t1, p = i - e, f = s - r, d = a - t1, m = o - e, y = l - r, g = c[1] * y - c[2] * m, x = c[2] * d - c[0] * y, b = c[0] * m - c[1] * d, v = h * g + p * x + f * b;
            if (Math.abs(v) < 1e-15) return null;
            const w = 1 / v, _ = u[0] - t1, M = u[1] - e, A = u[2] - r, S = (_ * g + M * x + A * b) * w;
            if (S < 0 || S > 1) return null;
            const I = M * f - A * p, P = A * h - _ * f, z = _ * p - M * h, k = (c[0] * I + c[1] * P + c[2] * z) * w;
            return k < 0 || S + k > 1 ? null : (d * I + m * P + y * z) * w;
        }
        function My(t1, e, r) {
            return (t1 - e) / (r - e);
        }
        function Ay(t1, e, r, n, i, s, a, o, l) {
            const u = 1 << r, c = s - n, h = a - i, p = (t1 + 1) / u * c + n, f = (e + 0) / u * h + i, d = (e + 1) / u * h + i;
            o[0] = (t1 + 0) / u * c + n, o[1] = f, l[0] = p, l[1] = d;
        }
        class Sy {
            constructor(t1){
                if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = t1, this._siblingOffset = [
                    [
                        0,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        1
                    ]
                ], !this.dem) return;
                const e = function(t1) {
                    const e = Math.ceil(Math.log2(t1.dim / 8)), r = [];
                    let n = Math.ceil(Math.pow(2, e));
                    const i = 1 / n, s = (t1, e, r, n, i)=>{
                        const s = n ? 1 : 0, a = (t1 + 1) * r - s, o = e * r, l = (e + 1) * r - s;
                        i[0] = t1 * r, i[1] = o, i[2] = a, i[3] = l;
                    };
                    let a = new vy(n);
                    const o = [];
                    for(let e = 0; e < n * n; e++){
                        s(e % n, Math.floor(e / n), i, !1, o);
                        const r = Py(o[0], o[1], t1), l = Py(o[2], o[1], t1), u = Py(o[2], o[3], t1), c = Py(o[0], o[3], t1);
                        a.minimums.push(Math.min(r, l, u, c)), a.maximums.push(Math.max(r, l, u, c)), a.leaves.push(1);
                    }
                    for(r.push(a), n /= 2; n >= 1; n /= 2){
                        const t1 = r[r.length - 1];
                        a = new vy(n);
                        for(let e = 0; e < n * n; e++){
                            s(e % n, Math.floor(e / n), 2, !0, o);
                            const r = t1.getElevation(o[0], o[1]), i = t1.getElevation(o[2], o[1]), l = t1.getElevation(o[2], o[3]), u = t1.getElevation(o[0], o[3]), c = t1.isLeaf(o[0], o[1]), h = t1.isLeaf(o[2], o[1]), p = t1.isLeaf(o[2], o[3]), f = t1.isLeaf(o[0], o[3]), d = Math.min(r.min, i.min, l.min, u.min), m = Math.max(r.max, i.max, l.max, u.max), y = c && h && p && f;
                            a.maximums.push(m), a.minimums.push(d), a.leaves.push(m - d <= 5 && y ? 1 : 0);
                        }
                        r.push(a);
                    }
                    return r;
                }(this.dem), r = e.length - 1, n = e[r];
                this._addNode(n.minimums[0], n.maximums[0], n.leaves[0]), this._construct(e, 0, 0, r, 0);
            }
            raycastRoot(t1, e, r, n, i, s, a = 1) {
                return wy([
                    t1,
                    e,
                    -100
                ], [
                    r,
                    n,
                    this.maximums[0] * a
                ], i, s);
            }
            raycast(t1, e, r, n, i, s, a = 1) {
                if (!this.nodeCount) return null;
                const o = this.raycastRoot(t1, e, r, n, i, s, a);
                if (null == o) return null;
                const l = [], u = [], c = [], h = [], p = [
                    {
                        idx: 0,
                        t: o,
                        nodex: 0,
                        nodey: 0,
                        depth: 0
                    }
                ];
                for(; p.length > 0;){
                    const { idx: o, t: f, nodex: d, nodey: m, depth: y } = p.pop();
                    if (this.leaves[o]) {
                        Ay(d, m, y, t1, e, r, n, c, h);
                        const o = 1 << y, l = (d + 0) / o, u = (d + 1) / o, p = (m + 0) / o, g = (m + 1) / o, x = Py(l, p, this.dem) * a, b = Py(u, p, this.dem) * a, v = Py(u, g, this.dem) * a, w = Py(l, g, this.dem) * a, _ = _y(c[0], c[1], x, h[0], c[1], b, h[0], h[1], v, i, s), M = _y(h[0], h[1], v, c[0], h[1], w, c[0], c[1], x, i, s), A = Math.min(null !== _ ? _ : Number.MAX_VALUE, null !== M ? M : Number.MAX_VALUE);
                        if (A !== Number.MAX_VALUE) return A;
                        {
                            const t1 = O.vec3.scaleAndAdd([], i, s, f);
                            if (Iy(x, b, w, v, My(t1[0], c[0], h[0]), My(t1[1], c[1], h[1])) >= t1[2]) return f;
                        }
                        continue;
                    }
                    let g = 0;
                    for(let p = 0; p < this._siblingOffset.length; p++){
                        Ay((d << 1) + this._siblingOffset[p][0], (m << 1) + this._siblingOffset[p][1], y + 1, t1, e, r, n, c, h), c[2] = -100, h[2] = this.maximums[this.childOffsets[o] + p] * a;
                        const f = wy(c, h, i, s);
                        if (null != f) {
                            const t1 = f;
                            l[p] = t1;
                            let e = !1;
                            for(let r = 0; r < g && !e; r++)t1 >= l[u[r]] && (u.splice(r, 0, p), e = !0);
                            e || (u[g] = p), g++;
                        }
                    }
                    for(let t1 = 0; t1 < g; t1++){
                        const e = u[t1];
                        p.push({
                            idx: this.childOffsets[o] + e,
                            t: l[e],
                            nodex: (d << 1) + this._siblingOffset[e][0],
                            nodey: (m << 1) + this._siblingOffset[e][1],
                            depth: y + 1
                        });
                    }
                }
                return null;
            }
            _addNode(t1, e, r) {
                return this.minimums.push(t1), this.maximums.push(e), this.leaves.push(r), this.childOffsets.push(0), this.nodeCount++;
            }
            _construct(t1, e, r, n, i) {
                if (1 === t1[n].isLeaf(e, r)) return;
                this.childOffsets[i] || (this.childOffsets[i] = this.nodeCount);
                const s = n - 1, a = t1[s];
                let o = 0, l = 0;
                for(let t1 = 0; t1 < this._siblingOffset.length; t1++){
                    const n = 2 * e + this._siblingOffset[t1][0], i = 2 * r + this._siblingOffset[t1][1], s = a.getElevation(n, i), u = a.isLeaf(n, i), c = this._addNode(s.min, s.max, u);
                    u && (o |= 1 << t1), l || (l = c);
                }
                for(let n = 0; n < this._siblingOffset.length; n++)o & 1 << n || this._construct(t1, 2 * e + this._siblingOffset[n][0], 2 * r + this._siblingOffset[n][1], s, l + n);
            }
        }
        function Iy(t1, e, r, n, i, s) {
            return ke(ke(t1, r, s), ke(e, n, s), i);
        }
        function Py(t1, e, r) {
            const n = r.dim, i = Q(t1 * n - .5, 0, n - 1), s = Q(e * n - .5, 0, n - 1), a = Math.floor(i), o = Math.floor(s), l = Math.min(a + 1, n - 1), u = Math.min(o + 1, n - 1);
            return Iy(r.get(a, o), r.get(l, o), r.get(a, u), r.get(l, u), i - a, s - o);
        }
        const zy = {
            mapbox: [
                6553.6,
                25.6,
                .1,
                1e4
            ],
            terrarium: [
                256,
                1,
                1 / 256,
                32768
            ]
        };
        function ky(t1, e, r) {
            return (256 * t1 * 256 + 256 * e + r) / 10 - 1e4;
        }
        function Ty(t1, e, r) {
            return 256 * t1 + e + r / 256 - 32768;
        }
        class Ey {
            get tree() {
                return this._tree || this._buildQuadTree(), this._tree;
            }
            constructor(t1, e, r, n = !1){
                if (this.uid = t1, e.height !== e.width) throw new RangeError("DEM tiles must be square");
                if (r && "mapbox" !== r && "terrarium" !== r) return void ft(`"${r}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = e.height;
                const i = this.dim = e.height - 2, s = new Uint32Array(e.data.buffer);
                if (this.pixels = new Uint8Array(e.data.buffer), this.floatView = new Float32Array(e.data.buffer), this.borderReady = n, this._modifiedForSources = {}, !n) {
                    for(let t1 = 0; t1 < i; t1++)s[this._idx(-1, t1)] = s[this._idx(0, t1)], s[this._idx(i, t1)] = s[this._idx(i - 1, t1)], s[this._idx(t1, -1)] = s[this._idx(t1, 0)], s[this._idx(t1, i)] = s[this._idx(t1, i - 1)];
                    s[this._idx(-1, -1)] = s[this._idx(0, 0)], s[this._idx(i, -1)] = s[this._idx(i - 1, 0)], s[this._idx(-1, i)] = s[this._idx(0, i - 1)], s[this._idx(i, i)] = s[this._idx(i - 1, i - 1)];
                }
                const a = "terrarium" === r ? Ty : ky;
                for(let t1 = 0; t1 < s.length; ++t1){
                    const e = 4 * t1;
                    this.floatView[t1] = a(this.pixels[e], this.pixels[e + 1], this.pixels[e + 2]);
                }
                this._timestamp = Dt.now();
            }
            _buildQuadTree() {
                this._tree = new Sy(this);
            }
            get(t1, e, r = !1) {
                r && (t1 = Q(t1, -1, this.dim), e = Q(e, -1, this.dim));
                const n = this._idx(t1, e);
                return this.floatView[n];
            }
            set(t1, e, r) {
                const n = this._idx(t1, e), i = this.floatView[n];
                return this.floatView[n] = r, r - i;
            }
            static getUnpackVector(t1) {
                return zy[t1];
            }
            _idx(t1, e) {
                if (t1 < -1 || t1 >= this.dim + 1 || e < -1 || e >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (e + 1) * this.stride + (t1 + 1);
            }
            static pack(t1, e) {
                const r = [
                    0,
                    0,
                    0,
                    0
                ], n = Ey.getUnpackVector(e);
                let i = Math.floor((t1 + n[3]) / n[2]);
                return r[2] = i % 256, i = Math.floor(i / 256), r[1] = i % 256, i = Math.floor(i / 256), r[0] = i, r;
            }
            getPixels() {
                return new sc({
                    width: this.stride,
                    height: this.stride
                }, this.pixels);
            }
            backfillBorder(t1, e, r) {
                if (this.dim !== t1.dim) throw new Error("dem dimension mismatch");
                let n = e * this.dim, i = e * this.dim + this.dim, s = r * this.dim, a = r * this.dim + this.dim;
                switch(e){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        s = a - 1;
                        break;
                    case 1:
                        a = s + 1;
                }
                const o = -e * this.dim, l = -r * this.dim;
                for(let e = s; e < a; e++)for(let r = n; r < i; r++){
                    const n = 4 * this._idx(r, e), i = 4 * this._idx(r + o, e + l);
                    this.pixels[n + 0] = t1.pixels[i + 0], this.pixels[n + 1] = t1.pixels[i + 1], this.pixels[n + 2] = t1.pixels[i + 2], this.pixels[n + 3] = t1.pixels[i + 3];
                }
            }
            onDeserialize() {
                this._tree && (this._tree.dem = this);
            }
        }
        function By(t1, e, r) {
            1 === t1 ? e.header_length = r.readFixed32() : 2 === t1 ? e.x = r.readVarint() : 3 === t1 ? e.y = r.readVarint() : 4 === t1 ? e.z = r.readVarint() : 5 === t1 && e.layers.push(function(t1, e) {
                return t1.readFields(Ly, {
                    version: 0,
                    name: "",
                    units: "",
                    tilesize: 0,
                    buffer: 0,
                    pixel_format: 0,
                    data_index: []
                }, e);
            }(r, r.readVarint() + r.pos));
        }
        function Vy(t1, e, r) {
            1 === t1 ? (e.delta_filter = function(t1, e) {
                return t1.readFields(Cy, {
                    block_size: 0
                }, e);
            }(r, r.readVarint() + r.pos), e.filter = "delta_filter") : 2 === t1 ? (r.readVarint(), e.filter = "zigzag_filter") : 3 === t1 ? (r.readVarint(), e.filter = "bitshuffle_filter") : 4 === t1 && (r.readVarint(), e.filter = "byteshuffle_filter");
        }
        function Cy(t1, e, r) {
            1 === t1 && (e.block_size = r.readVarint());
        }
        function Ry(t1, e, r) {
            1 === t1 ? (r.readVarint(), e.codec = "gzip_data") : 2 === t1 ? (r.readVarint(), e.codec = "jpeg_image") : 3 === t1 ? (r.readVarint(), e.codec = "webp_image") : 4 === t1 && (r.readVarint(), e.codec = "png_image");
        }
        function Dy(t1, e, r) {
            1 === t1 ? e.first_byte = r.readFixed64() : 2 === t1 ? e.last_byte = r.readFixed64() : 3 === t1 ? e.filters.push(function(t1, e) {
                return t1.readFields(Vy, {}, e);
            }(r, r.readVarint() + r.pos)) : 4 === t1 ? e.codec = function(t1, e) {
                return t1.readFields(Ry, {}, e);
            }(r, r.readVarint() + r.pos) : 5 === t1 ? e.deprecated_offset = r.readFloat() : 6 === t1 ? e.deprecated_scale = r.readFloat() : 7 === t1 ? e.bands.push(r.readString()) : 8 === t1 ? e.offset = r.readDouble() : 9 === t1 && (e.scale = r.readDouble());
        }
        function Ly(t1, e, r) {
            1 === t1 ? e.version = r.readVarint() : 2 === t1 ? e.name = r.readString() : 3 === t1 ? e.units = r.readString() : 4 === t1 ? e.tilesize = r.readVarint() : 5 === t1 ? e.buffer = r.readVarint() : 6 === t1 ? e.pixel_format = r.readVarint() : 7 === t1 && e.data_index.push(function(t1, e) {
                return t1.readFields(Dy, {
                    first_byte: 0,
                    last_byte: 0,
                    filters: [],
                    codec: null,
                    offset: 0,
                    scale: 0,
                    deprecated_offset: 0,
                    deprecated_scale: 0,
                    bands: []
                }, e);
            }(r, r.readVarint() + r.pos));
        }
        function Fy(t1, e, r) {
            if (2 === t1) !function(t1, e, r) {
                t1.readFields(Oy, r, e);
            }(r, r.readVarint() + r.pos, e);
            else if (3 === t1) throw new Error("Not implemented");
        }
        function Oy(t1, e, r) {
            if (1 === t1) {
                let t1 = 0;
                const n = r.readVarint() + r.pos;
                for(; r.pos < n;)e[t1++] = r.readVarint();
            }
        }
        os(Ey, "DEMData"), os(Sy, "DemMinMaxQuadTree", {
            omit: [
                "dem"
            ]
        });
        class Uy {
            constructor(t1){
                this.capacity = t1, this.cache = new Map;
            }
            get(t1) {
                if (!this.cache.has(t1)) return;
                const e = this.cache.get(t1);
                return this.cache.delete(t1), this.cache.set(t1, e), e;
            }
            put(t1, e) {
                this.cache.has(t1) ? this.cache.delete(t1) : this.cache.size === this.capacity && this.cache.delete(this.cache.keys().next().value), this.cache.set(t1, e);
            }
        }
        function jy(t1, e) {
            if (4 !== e.length) throw new Error(`Expected data of dimension 4 but got ${e.length}.`);
            let r = e[3];
            for(let n = 2; n >= 1; n--){
                const i = 1 === n ? 1 : 0, s = 2 === n ? 1 : 0;
                for(let n = 0; n < e[0]; n++){
                    const a = e[1] * n;
                    for(let n = i; n < e[1]; n++){
                        const i = e[2] * (n + a);
                        for(let n = s; n < e[2]; n++){
                            const s = e[3] * (n + i);
                            for(let n = 0; n < e[3]; n++){
                                const e = s + n;
                                t1[e] += t1[e - r];
                            }
                        }
                    }
                }
                r *= e[n];
            }
            return t1;
        }
        function Ny(t1) {
            for(let e = 0, r = t1.length; e < r; e++)t1[e] = t1[e] >>> 1 ^ -(1 & t1[e]);
            return t1;
        }
        function qy(t1, e) {
            switch(e){
                case "uint32":
                    return t1;
                case "uint16":
                    for(let e = 0; e < t1.length; e += 2){
                        const r = t1[e], n = t1[e + 1];
                        t1[e] = (240 & r) >> 4 | (61440 & r) >> 8 | (240 & n) << 4 | 61440 & n, t1[e + 1] = 15 & r | (3840 & r) >> 4 | (15 & n) << 8 | (3840 & n) << 4;
                    }
                    return t1;
                case "uint8":
                    for(let e = 0; e < t1.length; e += 4){
                        const r = t1[e], n = t1[e + 1], i = t1[e + 2], s = t1[e + 3];
                        t1[e + 0] = (192 & r) >> 6 | (192 & n) >> 4 | (192 & i) >> 2 | 192 & s, t1[e + 1] = (48 & r) >> 4 | (48 & n) >> 2 | 48 & i | (48 & s) << 2, t1[e + 2] = (12 & r) >> 2 | 12 & n | (12 & i) << 2 | (12 & s) << 4, t1[e + 3] = 3 & r | (3 & n) << 2 | (3 & i) << 4 | (3 & s) << 6;
                    }
                    return t1;
                default:
                    throw new Error(`Invalid pixel format, "${e}"`);
            }
        }
        var $y = Uint8Array, Gy = Uint16Array, Xy = Int32Array, Yy = new $y([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), Zy = new $y([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), Wy = new $y([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), Hy = function(t1, e) {
            for(var r = new Gy(31), n = 0; n < 31; ++n)r[n] = e += 1 << t1[n - 1];
            var i = new Xy(r[30]);
            for(n = 1; n < 30; ++n)for(var s = r[n]; s < r[n + 1]; ++s)i[s] = s - r[n] << 5 | n;
            return {
                b: r,
                r: i
            };
        }, Ky = Hy(Yy, 2), Jy = Ky.b, Qy = Ky.r;
        Jy[28] = 258, Qy[258] = 28;
        for(var tg = Hy(Zy, 0).b, eg = new Gy(32768), rg = 0; rg < 32768; ++rg){
            var ng = (43690 & rg) >> 1 | (21845 & rg) << 1;
            eg[rg] = ((65280 & (ng = (61680 & (ng = (52428 & ng) >> 2 | (13107 & ng) << 2)) >> 4 | (3855 & ng) << 4)) >> 8 | (255 & ng) << 8) >> 1;
        }
        var ig = function(t1, e, r) {
            for(var n = t1.length, i = 0, s = new Gy(e); i < n; ++i)t1[i] && ++s[t1[i] - 1];
            var a, o = new Gy(e);
            for(i = 1; i < e; ++i)o[i] = o[i - 1] + s[i - 1] << 1;
            a = new Gy(1 << e);
            var l = 15 - e;
            for(i = 0; i < n; ++i)if (t1[i]) for(var u = i << 4 | t1[i], c = e - t1[i], h = o[t1[i] - 1]++ << c, p = h | (1 << c) - 1; h <= p; ++h)a[eg[h] >> l] = u;
            return a;
        }, sg = new $y(288);
        for(rg = 0; rg < 144; ++rg)sg[rg] = 8;
        for(rg = 144; rg < 256; ++rg)sg[rg] = 9;
        for(rg = 256; rg < 280; ++rg)sg[rg] = 7;
        for(rg = 280; rg < 288; ++rg)sg[rg] = 8;
        var ag = new $y(32);
        for(rg = 0; rg < 32; ++rg)ag[rg] = 5;
        var og = ig(sg, 9), lg = ig(ag, 5), ug = function(t1) {
            for(var e = t1[0], r = 1; r < t1.length; ++r)t1[r] > e && (e = t1[r]);
            return e;
        }, cg = function(t1, e, r) {
            var n = e / 8 | 0;
            return (t1[n] | t1[n + 1] << 8) >> (7 & e) & r;
        }, hg = function(t1, e) {
            var r = e / 8 | 0;
            return (t1[r] | t1[r + 1] << 8 | t1[r + 2] << 16) >> (7 & e);
        }, pg = [
            "unexpected EOF",
            "invalid block type",
            "invalid length/literal",
            "invalid distance",
            "stream finished",
            "no stream handler",
            ,
            "no callback",
            "invalid UTF-8 data",
            "extra field too long",
            "date not in range 1980-2099",
            "filename too long",
            "stream finishing",
            "invalid zip data"
        ], fg = function(t1, e, r) {
            var n = new Error(e || pg[t1]);
            if (n.code = t1, Error.captureStackTrace && Error.captureStackTrace(n, fg), !r) throw n;
            return n;
        }, dg = new $y(0), mg = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            mg.decode(dg, {
                stream: !0
            });
        } catch (t1) {}
        const yg = {
            gzip_data: "gzip"
        };
        class gg extends Error {
            constructor(t1){
                super(t1), this.name = "MRTError";
            }
        }
        const xg = {
            0: "uint32",
            1: "uint32",
            2: "uint16",
            3: "uint8"
        }, bg = {
            uint32: 1,
            uint16: 2,
            uint8: 4
        }, vg = {
            uint32: Uint32Array,
            uint16: Uint16Array,
            uint8: Uint8Array
        };
        let wg;
        class _g {
            constructor(t1 = 5){
                this.x = NaN, this.y = NaN, this.z = NaN, this.layers = {}, this._cacheSize = t1;
            }
            getLayer(t1) {
                const e = this.layers[t1];
                if (!e) throw new gg(`Layer '${t1}' not found`);
                return e;
            }
            getHeaderLength(t1) {
                const e = new Uint8Array(t1), r = new DataView(t1);
                if (13 !== e[0]) throw new gg("File is not a valid MRT.");
                return r.getUint32(1, !0);
            }
            parseHeader(t1) {
                const e = new Uint8Array(t1), r = this.getHeaderLength(t1);
                if (e.length < r) throw new gg(`Expected header with length >= ${r} but got buffer of length ${e.length}`);
                const n = function(t1, e) {
                    return t1.readFields(By, {
                        header_length: 0,
                        x: 0,
                        y: 0,
                        z: 0,
                        layers: []
                    }, void 0);
                }(new wg(e.subarray(0, r)));
                if (!isNaN(this.x) && (this.x !== n.x || this.y !== n.y || this.z !== n.z)) throw new gg(`Invalid attempt to parse header ${n.z}/${n.x}/${n.y} for tile ${this.z}/${this.x}/${this.y}`);
                this.x = n.x, this.y = n.y, this.z = n.z;
                for (const t1 of n.layers)this.layers[t1.name] = new Mg(t1, {
                    cacheSize: this._cacheSize
                });
                return this;
            }
            createDecodingTask(t1) {
                const e = [], r = this.getLayer(t1.layerName);
                for (let n of t1.blockIndices){
                    const i = r.dataIndex[n], s = i.first_byte - t1.firstByte, a = i.last_byte - t1.firstByte;
                    if (r._blocksInProgress.has(n)) continue;
                    const o = {
                        layerName: r.name,
                        firstByte: s,
                        lastByte: a,
                        pixelFormat: r.pixelFormat,
                        blockIndex: n,
                        blockShape: [
                            i.bands.length
                        ].concat(r.bandShape),
                        buffer: r.buffer,
                        codec: i.codec.codec,
                        filters: i.filters.map((t1)=>t1.filter)
                    };
                    r._blocksInProgress.add(n), e.push(o);
                }
                return new Ag(e, ()=>{
                    e.forEach((t1)=>r._blocksInProgress.delete(t1.blockIndex));
                }, (t1, n)=>{
                    if (e.forEach((t1)=>r._blocksInProgress.delete(t1.blockIndex)), t1) throw t1;
                    n.forEach((t1)=>{
                        this.getLayer(t1.layerName).processDecodedData(t1);
                    });
                });
            }
        }
        class Mg {
            constructor({ version: t1, name: e, units: r, tilesize: n, pixel_format: i, buffer: s, data_index: a }, o){
                if (this.version = t1, 1 !== this.version) throw new gg(`Cannot parse raster layer encoded with MRT version ${t1}`);
                this.name = e, this.units = r, this.tileSize = n, this.buffer = s, this.pixelFormat = xg[i], this.dataIndex = a, this.bandShape = [
                    n + 2 * s,
                    n + 2 * s,
                    bg[this.pixelFormat]
                ], this._decodedBlocks = new Uy(o ? o.cacheSize : 5), this._blocksInProgress = new Set;
            }
            get dimension() {
                return bg[this.pixelFormat];
            }
            get cacheSize() {
                return this._decodedBlocks.capacity;
            }
            getBandList() {
                return this.dataIndex.map(({ bands: t1 })=>t1).flat();
            }
            processDecodedData(t1) {
                const e = t1.blockIndex.toString();
                this._decodedBlocks.get(e) || this._decodedBlocks.put(e, t1.data);
            }
            getBlockForBand(t1) {
                let e = 0;
                switch(typeof t1){
                    case "string":
                        for (const [r, n] of this.dataIndex.entries()){
                            for (const [i, s] of n.bands.entries())if (s === t1) return {
                                bandIndex: e + i,
                                blockIndex: r,
                                blockBandIndex: i
                            };
                            e += n.bands.length;
                        }
                        break;
                    case "number":
                        for (const [r, n] of this.dataIndex.entries()){
                            if (t1 >= e && t1 < e + n.bands.length) return {
                                bandIndex: t1,
                                blockIndex: r,
                                blockBandIndex: t1 - e
                            };
                            e += n.bands.length;
                        }
                        break;
                    default:
                        throw new gg(`Invalid band \`${JSON.stringify(t1)}\`. Expected string or integer.`);
                }
                throw new gg(`Band not found: ${JSON.stringify(t1)}`);
            }
            getDataRange(t1) {
                let e = 1 / 0, r = -1 / 0;
                const n = [], i = new Set;
                for (const s of t1){
                    const { blockIndex: t1 } = this.getBlockForBand(s);
                    if (t1 < 0) throw new gg(`Invalid band: ${JSON.stringify(s)}`);
                    const a = this.dataIndex[t1];
                    n.includes(t1) || n.push(t1), i.add(t1), e = Math.min(e, a.first_byte), r = Math.max(r, a.last_byte);
                }
                if (i.size > this.cacheSize) throw new gg(`Number of blocks to decode (${i.size}) exceeds cache size (${this.cacheSize}).`);
                return {
                    layerName: this.name,
                    firstByte: e,
                    lastByte: r,
                    blockIndices: n
                };
            }
            hasBand(t1) {
                const { blockIndex: e } = this.getBlockForBand(t1);
                return e >= 0;
            }
            hasDataForBand(t1) {
                const { blockIndex: e } = this.getBlockForBand(t1);
                return e >= 0 && !!this._decodedBlocks.get(e.toString());
            }
            getBandView(t1) {
                const { blockIndex: e, blockBandIndex: r } = this.getBlockForBand(t1), n = this._decodedBlocks.get(e.toString());
                if (!n) throw new gg(`Data for band ${JSON.stringify(t1)} of layer "${this.name}" not decoded.`);
                const i = this.dataIndex[e], s = this.bandShape.reduce((t1, e)=>t1 * e, 1), a = r * s, o = n.subarray(a, a + s);
                return {
                    data: o,
                    bytes: new Uint8Array(o.buffer).subarray(o.byteOffset, o.byteOffset + o.byteLength),
                    tileSize: this.tileSize,
                    buffer: this.buffer,
                    pixelFormat: this.pixelFormat,
                    dimension: this.dimension,
                    offset: 0 !== i.offset ? i.offset : i.deprecated_offset,
                    scale: 0 !== i.scale ? i.scale : i.deprecated_scale
                };
            }
        }
        _g.setPbf = function(t1) {
            wg = t1;
        };
        class Ag {
            constructor(t1, e, r){
                this.tasks = t1, this._onCancel = e, this._onComplete = r, this._finalized = !1;
            }
            cancel() {
                this._finalized || (this._onCancel(), this._finalized = !0);
            }
            complete(t1, e) {
                this._finalized || (this._onComplete(t1, e), this._finalized = !0);
            }
        }
        _g.performDecoding = function(t1, e) {
            const r = new Uint8Array(t1);
            return Promise.all(e.tasks.map((t1)=>{
                const { layerName: e, firstByte: n, lastByte: i, pixelFormat: s, blockShape: a, blockIndex: o, filters: l, codec: u } = t1, c = r.subarray(n, i + 1), h = new Uint32Array(a[0] * a[1] * a[2]);
                let p;
                if ("gzip_data" !== u) throw new gg(`Unhandled codec: ${u}`);
                return p = (function(t1, e) {
                    if (!globalThis.DecompressionStream && "gzip_data" === e) return Promise.resolve(((s = function(t1) {
                        31 == t1[0] && 139 == t1[1] && 8 == t1[2] || fg(6, "invalid gzip data");
                        var e = t1[3], r = 10;
                        4 & e && (r += 2 + (t1[10] | t1[11] << 8));
                        for(var n = (e >> 3 & 1) + (e >> 4 & 1); n > 0; n -= !t1[r++]);
                        return r + (2 & e);
                    }(i = t1)) + 8 > i.length && fg(6, "invalid gzip data"), function(t1, e, r, n) {
                        var i = t1.length;
                        if (!i || e.f && !e.l) return r || new $y(0);
                        var s = !r, a = s || 2 != e.i, o = e.i;
                        s && (r = new $y(3 * i));
                        var l, u, c = function(t1) {
                            var e = r.length;
                            if (t1 > e) {
                                var n = new $y(Math.max(2 * e, t1));
                                n.set(r), r = n;
                            }
                        }, h = e.f || 0, p = e.p || 0, f = e.b || 0, d = e.l, m = e.d, y = e.m, g = e.n, x = 8 * i;
                        do {
                            if (!d) {
                                h = cg(t1, p, 1);
                                var b = cg(t1, p + 1, 3);
                                if (p += 3, !b) {
                                    var v = t1[(E = 4 + ((p + 7) / 8 | 0)) - 4] | t1[E - 3] << 8, w = E + v;
                                    if (w > i) {
                                        o && fg(0);
                                        break;
                                    }
                                    a && c(f + v), r.set(t1.subarray(E, w), f), e.b = f += v, e.p = p = 8 * w, e.f = h;
                                    continue;
                                }
                                if (1 == b) d = og, m = lg, y = 9, g = 5;
                                else if (2 == b) {
                                    var _ = cg(t1, p, 31) + 257, M = cg(t1, p + 10, 15) + 4, A = _ + cg(t1, p + 5, 31) + 1;
                                    p += 14;
                                    for(var S = new $y(A), I = new $y(19), P = 0; P < M; ++P)I[Wy[P]] = cg(t1, p + 3 * P, 7);
                                    p += 3 * M;
                                    var z = ug(I), k = (1 << z) - 1, T = ig(I, z);
                                    for(P = 0; P < A;){
                                        var E, B = T[cg(t1, p, k)];
                                        if (p += 15 & B, (E = B >> 4) < 16) S[P++] = E;
                                        else {
                                            var V = 0, C = 0;
                                            for(16 == E ? (C = 3 + cg(t1, p, 3), p += 2, V = S[P - 1]) : 17 == E ? (C = 3 + cg(t1, p, 7), p += 3) : 18 == E && (C = 11 + cg(t1, p, 127), p += 7); C--;)S[P++] = V;
                                        }
                                    }
                                    var R = S.subarray(0, _), D = S.subarray(_);
                                    y = ug(R), g = ug(D), d = ig(R, y), m = ig(D, g);
                                } else fg(1);
                                if (p > x) {
                                    o && fg(0);
                                    break;
                                }
                            }
                            a && c(f + 131072);
                            for(var L = (1 << y) - 1, F = (1 << g) - 1, O = p;; O = p){
                                var U = (V = d[hg(t1, p) & L]) >> 4;
                                if ((p += 15 & V) > x) {
                                    o && fg(0);
                                    break;
                                }
                                if (V || fg(2), U < 256) r[f++] = U;
                                else {
                                    if (256 == U) {
                                        O = p, d = null;
                                        break;
                                    }
                                    var j = U - 254;
                                    U > 264 && (j = cg(t1, p, (1 << ($ = Yy[P = U - 257])) - 1) + Jy[P], p += $);
                                    var N = m[hg(t1, p) & F], q = N >> 4;
                                    if (N || fg(3), p += 15 & N, D = tg[q], q > 3) {
                                        var $ = Zy[q];
                                        D += hg(t1, p) & (1 << $) - 1, p += $;
                                    }
                                    if (p > x) {
                                        o && fg(0);
                                        break;
                                    }
                                    a && c(f + 131072);
                                    var G = f + j;
                                    if (f < D) {
                                        var X = 0 - D, Y = Math.min(D, G);
                                        for(X + f < 0 && fg(3); f < Y; ++f)r[f] = (void 0)[X + f];
                                    }
                                    for(; f < G; ++f)r[f] = r[f - D];
                                }
                            }
                            e.l = d, e.p = O, e.b = f, e.f = h, d && (h = 1, e.m = y, e.d = m, e.n = g);
                        }while (!h);
                        return f != r.length && s ? (l = r, (null == (u = f) || u > l.length) && (u = l.length), new $y(l.subarray(0, u))) : r.subarray(0, f);
                    }(i.subarray(s, -8), {
                        i: 2
                    }, new $y(((r = i)[(n = r.length) - 4] | r[n - 3] << 8 | r[n - 2] << 16 | r[n - 1] << 24) >>> 0))));
                    var r, n, i, s;
                    const a = yg[e];
                    if (!a) throw new Error(`Unhandled codec: ${e}`);
                    const o = new globalThis.DecompressionStream(a);
                    return new Response(new Blob([
                        t1
                    ]).stream().pipeThrough(o)).arrayBuffer().then((t1)=>new Uint8Array(t1));
                })(c, u).then((t1)=>((function(t1, e) {
                        t1.readFields(Fy, e);
                    })(new wg(t1), h), new vg[s](h.buffer))), p.then((t1)=>{
                    for(let e = l.length - 1; e >= 0; e--)switch(l[e]){
                        case "delta_filter":
                            jy(t1, a);
                            break;
                        case "zigzag_filter":
                            Ny(t1);
                            break;
                        case "bitshuffle_filter":
                            qy(t1, s);
                            break;
                        default:
                            throw new gg(`Unhandled filter "${l[e]}"`);
                    }
                    return {
                        layerName: e,
                        blockIndex: o,
                        data: t1
                    };
                }).catch((t1)=>{
                    throw t1;
                });
            }));
        }, os(Ag, "MRTDecodingBatch", {
            omit: [
                "_onCancel",
                "_onComplete"
            ]
        });
        var Sg = {
            workerUrl: "",
            workerClass: null,
            workerParams: void 0
        };
        const Ig = "mapboxgl_preloaded_worker_pool";
        class Pg {
            constructor(){
                this.active = {};
            }
            acquire(t1) {
                if (!this.workers) for(this.workers = []; this.workers.length < Pg.workerCount;)this.workers.push(null != Sg.workerClass ? new Sg.workerClass : new self.Worker(Sg.workerUrl, Sg.workerParams));
                return this.active[t1] = !0, this.workers.slice();
            }
            release(t1) {
                delete this.active[t1], this.workers && 0 === this.numActive() && (this.workers.forEach((t1)=>{
                    t1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[Ig];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        let zg;
        function kg() {
            return zg || (zg = new Pg), zg;
        }
        Pg.workerCount = 2;
        let Tg, Eg, Bg, Vg, Cg, Rg = null;
        function Dg() {
            return gt() && self.worker && self.worker.dracoUrl ? self.worker.dracoUrl : Eg || It.DRACO_URL;
        }
        function Lg() {
            if (gt() && self.worker && self.worker.meshoptUrl) return self.worker.meshoptUrl;
            if (Vg) return Vg;
            const t1 = new Uint8Array([
                0,
                97,
                115,
                109,
                1,
                0,
                0,
                0,
                1,
                4,
                1,
                96,
                0,
                0,
                3,
                3,
                2,
                0,
                0,
                5,
                3,
                1,
                0,
                1,
                12,
                1,
                0,
                10,
                22,
                2,
                12,
                0,
                65,
                0,
                65,
                0,
                65,
                0,
                252,
                10,
                0,
                0,
                11,
                7,
                0,
                65,
                0,
                253,
                15,
                26,
                11
            ]);
            if ("object" != typeof WebAssembly) throw new Error("WebAssembly not supported, cannot instantiate meshoptimizer");
            return Vg = WebAssembly.validate(t1) ? It.MESHOPT_SIMD_URL : It.MESHOPT_URL, Vg;
        }
        const Fg = {
            5120: Int8Array,
            5121: Uint8Array,
            5122: Int16Array,
            5123: Uint16Array,
            5125: Uint32Array,
            5126: Float32Array
        }, Og = {
            5120: "DT_INT8",
            5121: "DT_UINT8",
            5122: "DT_INT16",
            5123: "DT_UINT16",
            5125: "DT_UINT32",
            5126: "DT_FLOAT32"
        }, Ug = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        };
        function jg(t1, e, r) {
            const n = r.json.bufferViews.length, i = r.buffers.length;
            e.bufferView = n, r.json.bufferViews[n] = {
                buffer: i,
                byteLength: t1.byteLength
            }, r.buffers[i] = t1;
        }
        const Ng = "KHR_draco_mesh_compression";
        function qg(t1, e) {
            const r = t1.extensions && t1.extensions[Ng];
            if (!r) return;
            const n = new Bg.Decoder, i = Hg(e, r.bufferView), s = new Bg.Mesh;
            if (!n.DecodeArrayToMesh(i, i.byteLength, s)) throw new Error("Failed to decode Draco mesh");
            const a = e.json.accessors[t1.indices], o = Fg[a.componentType], l = a.count * o.BYTES_PER_ELEMENT, u = Bg._malloc(l);
            o === Uint16Array ? n.GetTrianglesUInt16Array(s, l, u) : n.GetTrianglesUInt32Array(s, l, u), jg(Bg.memory.buffer.slice(u, u + l), a, e), Bg._free(u);
            for (const i of Object.keys(r.attributes)){
                const a = n.GetAttributeByUniqueId(s, r.attributes[i]), o = e.json.accessors[t1.attributes[i]], l = Og[o.componentType], u = o.count * Ug[o.type] * Fg[o.componentType].BYTES_PER_ELEMENT, c = Bg._malloc(u);
                n.GetAttributeDataArrayForAllPoints(s, a, Bg[l], u, c), jg(Bg.memory.buffer.slice(c, c + u), o, e), Bg._free(c);
            }
            n.destroy(), s.destroy(), delete t1.extensions[Ng];
        }
        const $g = "EXT_meshopt_compression";
        function Gg(t1, e) {
            if (!t1.extensions || !t1.extensions[$g]) return;
            const r = t1.extensions[$g], n = new Uint8Array(e.buffers[r.buffer], r.byteOffset || 0, r.byteLength || 0), i = new Uint8Array(r.count * r.byteStride);
            Cg.decodeGltfBuffer(i, r.count, r.byteStride, n, r.mode, r.filter), t1.buffer = e.buffers.length, t1.byteOffset = 0, e.buffers[t1.buffer] = i.buffer, delete t1.extensions[$g];
        }
        const Xg = 1179937895, Yg = new TextDecoder("utf8");
        function Zg(t1, e) {
            return new URL(t1, e).href;
        }
        function Wg(t1, e, r, n) {
            return fetch(Zg(t1.uri, n)).then((t1)=>t1.arrayBuffer()).then((t1)=>{
                e.buffers[r] = t1;
            });
        }
        function Hg(t1, e) {
            const r = t1.json.bufferViews[e];
            return new Uint8Array(t1.buffers[r.buffer], r.byteOffset || 0, r.byteLength);
        }
        function Kg(t1, e, r, n) {
            if (t1.uri) {
                const i = Zg(t1.uri, n);
                return fetch(i).then((t1)=>t1.blob()).then((t1)=>createImageBitmap(t1)).then((t1)=>{
                    e.images[r] = t1;
                });
            }
            if (void 0 !== t1.bufferView) {
                const n = Hg(e, t1.bufferView), i = new Blob([
                    n
                ], {
                    type: t1.mimeType
                });
                return createImageBitmap(i).then((t1)=>{
                    e.images[r] = t1;
                });
            }
        }
        function Jg(t1, e = 0, r) {
            const n = {
                json: null,
                images: [],
                buffers: []
            };
            if (new Uint32Array(t1, e, 1)[0] === Xg) {
                const r = new Uint32Array(t1, e);
                let i = 2;
                const s = (r[i++] >> 2) - 3, a = r[i++] >> 2;
                if (i++, n.json = JSON.parse(Yg.decode(r.subarray(i, i + a))), i += a, i < s) {
                    const s = r[i++];
                    i++;
                    const a = e + (i << 2);
                    n.buffers[0] = t1.slice(a, a + s);
                }
            } else n.json = JSON.parse(Yg.decode(new Uint8Array(t1, e)));
            const { buffers: i, images: s, meshes: a, extensionsUsed: o, bufferViews: l } = n.json;
            let u = Promise.resolve();
            if (i) {
                const t1 = [];
                for(let e = 0; e < i.length; e++){
                    const s = i[e];
                    s.uri ? t1.push(Wg(s, n, e, r)) : n.buffers[e] || (n.buffers[e] = null);
                }
                u = Promise.all(t1);
            }
            return u.then(()=>{
                const t1 = [], e = o && o.includes(Ng), i = o && o.includes($g);
                if (e && t1.push(function() {
                    if (!Bg) return null != Tg ? Tg : (Tg = function(t1) {
                        let e, r = null;
                        function n() {
                            e = new Uint8Array(r.buffer);
                        }
                        function i() {
                            throw new Error("Unexpected Draco error.");
                        }
                        const s = {
                            a: {
                                a: i,
                                d: function(t1, r, n) {
                                    return e.copyWithin(t1, r, r + n);
                                },
                                c: function(t1) {
                                    const i = e.length, s = Math.max(t1 >>> 0, Math.ceil(1.2 * i)), a = Math.ceil((s - i) / 65536);
                                    try {
                                        return r.grow(a), n(), !0;
                                    } catch (t1) {
                                        return !1;
                                    }
                                },
                                b: i
                            }
                        };
                        return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(t1, s) : t1.then((t1)=>t1.arrayBuffer()).then((t1)=>WebAssembly.instantiate(t1, s))).then((t1)=>{
                            const { Rb: i, Qb: s, P: a, T: o, X: l, Ja: u, La: c, Qa: h, Va: p, Wa: f, eb: d, jb: m, f: y, e: g, yb: x, zb: b, Ab: v, Bb: w, Db: _, Gb: M } = t1.instance.exports;
                            r = g;
                            const A = (()=>{
                                let t1 = 0, r = 0, n = 0, a = 0;
                                return (o)=>{
                                    n && (i(a), i(t1), r += n, n = t1 = 0), t1 || (r += 128, t1 = s(r));
                                    const l = o.length + 7 & -8;
                                    let u = t1;
                                    l >= r && (n = l, u = a = s(l));
                                    for(let t1 = 0; t1 < o.length; t1++)e[u + t1] = o[t1];
                                    return u;
                                };
                            })();
                            return n(), y(), {
                                memory: g,
                                _free: i,
                                _malloc: s,
                                Mesh: class {
                                    constructor(){
                                        this.ptr = a();
                                    }
                                    destroy() {
                                        o(this.ptr);
                                    }
                                },
                                Decoder: class {
                                    constructor(){
                                        this.ptr = u();
                                    }
                                    destroy() {
                                        m(this.ptr);
                                    }
                                    DecodeArrayToMesh(t1, e, r) {
                                        const n = A(t1), i = c(this.ptr, n, e, r.ptr);
                                        return !!l(i);
                                    }
                                    GetAttributeByUniqueId(t1, e) {
                                        return {
                                            ptr: h(this.ptr, t1.ptr, e)
                                        };
                                    }
                                    GetTrianglesUInt16Array(t1, e, r) {
                                        p(this.ptr, t1.ptr, e, r);
                                    }
                                    GetTrianglesUInt32Array(t1, e, r) {
                                        f(this.ptr, t1.ptr, e, r);
                                    }
                                    GetAttributeDataArrayForAllPoints(t1, e, r, n, i) {
                                        d(this.ptr, t1.ptr, e.ptr, r, n, i);
                                    }
                                },
                                DT_INT8: x(),
                                DT_UINT8: b(),
                                DT_INT16: v(),
                                DT_UINT16: w(),
                                DT_UINT32: _(),
                                DT_FLOAT32: M()
                            };
                        });
                    }(fetch(Dg())), Tg.then((t1)=>{
                        Bg = t1, Tg = void 0;
                    }));
                }()), i && t1.push(function() {
                    if (Cg) return;
                    const t1 = function(t1) {
                        let e;
                        const r = WebAssembly.instantiateStreaming(t1, {}).then((t1)=>{
                            e = t1.instance, e.exports.__wasm_call_ctors();
                        }), n = {
                            NONE: "",
                            OCTAHEDRAL: "meshopt_decodeFilterOct",
                            QUATERNION: "meshopt_decodeFilterQuat",
                            EXPONENTIAL: "meshopt_decodeFilterExp"
                        }, i = {
                            ATTRIBUTES: "meshopt_decodeVertexBuffer",
                            TRIANGLES: "meshopt_decodeIndexBuffer",
                            INDICES: "meshopt_decodeIndexSequence"
                        };
                        return {
                            ready: r,
                            supported: !0,
                            decodeGltfBuffer (t1, r, s, a, o, l) {
                                !function(t1, e, r, n, i, s, a) {
                                    const o = t1.exports.sbrk, l = n + 3 & -4, u = o(l * i), c = o(s.length), h = new Uint8Array(t1.exports.memory.buffer);
                                    h.set(s, c);
                                    const p = e(u, n, i, c, s.length);
                                    if (0 === p && a && a(u, l, i), r.set(h.subarray(u, u + n * i)), o(u - o(0)), 0 !== p) throw new Error(`Malformed buffer data: ${p}`);
                                }(e, e.exports[i[o]], t1, r, s, a, e.exports[n[l]]);
                            }
                        };
                    }(fetch(Lg()));
                    return t1.ready.then(()=>{
                        Cg = t1;
                    });
                }()), s) for(let e = 0; e < s.length; e++)t1.push(Kg(s[e], n, e, r));
                return (t1.length ? Promise.all(t1) : Promise.resolve()).then(()=>{
                    if (e && a) for (const { primitives: t1 } of a)for (const e of t1)qg(e, n);
                    if (i && a && l) for (const t1 of l)Gg(t1, n);
                    return n;
                });
            });
        }
        function Qg(t1, e) {
            const r = t1.json.bufferViews[e.bufferView], n = Fg[e.componentType];
            return new n(t1.buffers[r.buffer], (e.byteOffset || 0) + (r.byteOffset || 0), e.count * (r.byteStride && r.byteStride !== Ug[e.type] * n.BYTES_PER_ELEMENT ? r.byteStride / n.BYTES_PER_ELEMENT : Ug[e.type]));
        }
        function tx(t1, e, r, n) {
            const i = Fg[e.componentType], s = function(t1) {
                switch(t1){
                    case Int8Array:
                        return 1 / 127;
                    case Uint8Array:
                        return 1 / 255;
                    case Int16Array:
                        return 1 / 32767;
                    case Uint16Array:
                        return 1 / 65535;
                    default:
                        return 1;
                }
            }(i), a = t1.json.bufferViews[e.bufferView], o = a.byteStride ? a.byteStride / i.BYTES_PER_ELEMENT : Ug[e.type], l = r.float32, u = l.length / r.capacity;
            for(let t1 = 0, r = 0; t1 < e.count * o; t1 += o, r += u)for(let e = 0; e < u; e++)l[r + e] = n[t1 + e] * s;
            r._trim();
        }
        function ex(t1, e, r) {
            const n = t1.indices, i = t1.attributes, s = {};
            s.indexArray = new Da;
            const a = e.json.accessors[n], o = a.count / 3;
            s.indexArray.reserve(o);
            const l = Qg(e, a);
            for(let t1 = 0; t1 < o; t1++)s.indexArray.emplaceBack(l[3 * t1], l[3 * t1 + 1], l[3 * t1 + 2]);
            s.indexArray._trim(), s.vertexArray = new Aa;
            const u = e.json.accessors[i.POSITION];
            s.vertexArray.reserve(u.count);
            const c = Qg(e, u);
            for(let t1 = 0; t1 < u.count; t1++)s.vertexArray.emplaceBack(c[3 * t1], c[3 * t1 + 1], c[3 * t1 + 2]);
            if (s.vertexArray._trim(), s.aabb = new yu(u.min, u.max), s.centroid = function(t1, e) {
                const r = [
                    0,
                    0,
                    0
                ], n = t1.length;
                if (n > 0) {
                    for(let i = 0; i < n; i++){
                        const n = 3 * t1[i];
                        r[0] += e[n], r[1] += e[n + 1], r[2] += e[n + 2];
                    }
                    r[0] /= n, r[1] /= n, r[2] /= n;
                }
                return r;
            }(l, c), void 0 !== i.COLOR_0) {
                const t1 = e.json.accessors[i.COLOR_0], r = Ug[t1.type], n = Qg(e, t1);
                s.colorArray = 3 === r ? new Aa : new Ma, s.colorArray.resize(t1.count), tx(e, t1, s.colorArray, n);
            }
            if (void 0 !== i.NORMAL) {
                s.normalArray = new Aa;
                const t1 = e.json.accessors[i.NORMAL];
                s.normalArray.resize(t1.count);
                const r = Qg(e, t1);
                tx(e, t1, s.normalArray, r);
            }
            if (void 0 !== i.TEXCOORD_0 && r.length > 0) {
                s.texcoordArray = new $a;
                const t1 = e.json.accessors[i.TEXCOORD_0];
                s.texcoordArray.resize(t1.count);
                const r = Qg(e, t1);
                tx(e, t1, s.texcoordArray, r);
            }
            if (void 0 !== i._FEATURE_ID_RGBA4444) {
                const t1 = e.json.accessors[i._FEATURE_ID_RGBA4444];
                e.json.extensionsUsed && e.json.extensionsUsed.includes("EXT_meshopt_compression") && (s.featureData = Qg(e, t1));
            }
            void 0 !== i._FEATURE_RGBA4444 && (s.featureData = new Uint32Array(Qg(e, e.json.accessors[i._FEATURE_RGBA4444]).buffer));
            const h = t1.material;
            return s.material = function(t1, e) {
                const { emissiveFactor: r = [
                    0,
                    0,
                    0
                ], alphaMode: n = "OPAQUE", alphaCutoff: i = .5, normalTexture: s, occlusionTexture: a, emissiveTexture: o, doubleSided: l } = t1, { baseColorFactor: u = [
                    1,
                    1,
                    1,
                    1
                ], metallicFactor: c = 1, roughnessFactor: h = 1, baseColorTexture: p, metallicRoughnessTexture: f } = t1.pbrMetallicRoughness || {}, d = a ? e[a.index] : void 0;
                if (a && a.extensions && a.extensions.KHR_texture_transform && d) {
                    const t1 = a.extensions.KHR_texture_transform;
                    d.offsetScale = [
                        t1.offset[0],
                        t1.offset[1],
                        t1.scale[0],
                        t1.scale[1]
                    ];
                }
                return {
                    pbrMetallicRoughness: {
                        baseColorFactor: new Pe(...u),
                        metallicFactor: c,
                        roughnessFactor: h,
                        baseColorTexture: p ? e[p.index] : void 0,
                        metallicRoughnessTexture: f ? e[f.index] : void 0
                    },
                    doubleSided: l,
                    emissiveFactor: r,
                    alphaMode: n,
                    alphaCutoff: i,
                    normalTexture: s ? e[s.index] : void 0,
                    occlusionTexture: d,
                    emissionTexture: o ? e[o.index] : void 0,
                    defined: void 0 === t1.defined
                };
            }(void 0 !== h ? e.json.materials[h] : {
                defined: !1
            }, r), s;
        }
        function rx(t1, e, r) {
            const { matrix: n, rotation: i, translation: s, scale: a, mesh: o, extras: l, children: u } = t1, c = {};
            if (c.matrix = n || O.mat4.fromRotationTranslationScale([], i || [
                0,
                0,
                0,
                1
            ], s || [
                0,
                0,
                0
            ], a || [
                1,
                1,
                1
            ]), void 0 !== o) {
                c.meshes = r[o];
                const t1 = c.anchor = [
                    0,
                    0
                ];
                for (const e of c.meshes){
                    const { min: r, max: n } = e.aabb;
                    t1[0] += r[0] + n[0], t1[1] += r[1] + n[1];
                }
                t1[0] = Math.floor(t1[0] / c.meshes.length / 2), t1[1] = Math.floor(t1[1] / c.meshes.length / 2);
            }
            if (l && (l.id && (c.id = l.id), l.lights && (c.lights = function(t1) {
                if (!t1.length) return [];
                const e = function(t1) {
                    const e = atob(t1), r = new Uint8Array(e.length);
                    for(let t1 = 0; t1 < e.length; t1++)r[t1] = e.codePointAt(t1);
                    return r;
                }(t1), r = [], n = e.length / 24, i = new Uint16Array(e.buffer), s = new Float32Array(e.buffer);
                for(let t1 = 0; t1 < n; t1++){
                    const e = i[2 * t1 * 6] / 30, n = i[2 * t1 * 6 + 1] / 30, a = i[2 * t1 * 6 + 10] / 100, o = s[6 * t1 + 1], l = s[6 * t1 + 2], u = s[6 * t1 + 3], c = s[6 * t1 + 4], h = u - o, p = c - l, f = Math.hypot(h, p);
                    r.push({
                        pos: [
                            o + .5 * h,
                            l + .5 * p,
                            n
                        ],
                        normal: [
                            p / f,
                            -h / f,
                            0
                        ],
                        width: f,
                        height: e,
                        depth: a,
                        points: [
                            o,
                            l,
                            u,
                            c
                        ]
                    });
                }
                return r;
            }(l.lights))), u) {
                const t1 = [];
                for (const n of u)t1.push(rx(e.json.nodes[n], e, r));
                c.children = t1;
            }
            return c;
        }
        function nx(t1) {
            if (0 === t1.vertices.length || 0 === t1.indices.length) return null;
            const e = new qc(t1.vertices, t1.indices, 8, 256), [r, n] = [
                e.min.clone(),
                e.max.clone()
            ];
            return {
                vertices: t1.vertices,
                indices: t1.indices,
                grid: e,
                min: r,
                max: n
            };
        }
        function ix(t1) {
            if (!t1.extras || !t1.extras.ground) return null;
            const e = t1.extras.ground;
            if (!e || !Array.isArray(e) || 0 === e.length) return null;
            const r = e[0];
            if (!r || !Array.isArray(r) || 0 === r.length) return null;
            const n = [];
            for (const t1 of r){
                if (!Array.isArray(t1) || 2 !== t1.length) continue;
                const e = t1[0], r = t1[1];
                "number" == typeof e && "number" == typeof r && n.push(new q(e, r));
            }
            if (n.length < 3) return null;
            n.length > 1 && n[n.length - 1].equals(n[0]) && n.pop();
            let i = 0;
            for(let t1 = 0; t1 < n.length; t1++){
                const e = n[t1], r = n[(t1 + 1) % n.length], s = n[(t1 + 2) % n.length];
                i += (e.x - r.x) * (s.y - r.y) - (s.x - r.x) * (e.y - r.y);
            }
            i > 0 && n.reverse();
            const s = uc(n.flatMap((t1)=>[
                    t1.x,
                    t1.y
                ]), []);
            return 0 === s.length ? null : {
                vertices: n,
                indices: s
            };
        }
        function sx(t1, e) {
            const r = [], n = [];
            let i = 0;
            const s = [];
            for (const a of t1){
                i = r.length;
                const t1 = a.vertexArray.float32, o = a.indexArray.uint16;
                for(let n = 0; n < a.vertexArray.length; n++)s[0] = t1[3 * n + 0], s[1] = t1[3 * n + 1], s[2] = t1[3 * n + 2], O.vec3.transformMat4(s, s, e), r.push(new q(s[0], s[1]));
                for(let t1 = 0; t1 < 3 * a.indexArray.length; t1++)n.push(o[t1] + i);
            }
            if (n.length % 3 != 0) return null;
            for(let t1 = 0; t1 < n.length; t1 += 3){
                const e = r[n[t1 + 0]], i = r[n[t1 + 1]], s = r[n[t1 + 2]];
                (e.x - i.x) * (s.y - i.y) - (s.x - i.x) * (e.y - i.y) > 0 && ([n[t1 + 1], n[t1 + 2]] = [
                    n[t1 + 2],
                    n[t1 + 1]
                ]);
            }
            return {
                vertices: r,
                indices: n
            };
        }
        function ax(t1) {
            const e = function(t1, e) {
                const r = [], n = WebGL2RenderingContext;
                if (t1.json.textures) for (const i of t1.json.textures){
                    const s = {
                        magFilter: n.LINEAR,
                        minFilter: n.NEAREST,
                        wrapS: n.REPEAT,
                        wrapT: n.REPEAT
                    };
                    void 0 !== i.sampler && Object.assign(s, t1.json.samplers[i.sampler]), r.push({
                        image: e[i.source],
                        sampler: s,
                        uploaded: !1
                    });
                }
                return r;
            }(t1, t1.images), r = function(t1, e) {
                const r = [];
                for (const n of t1.json.meshes){
                    const i = [];
                    for (const r of n.primitives)i.push(ex(r, t1, e));
                    r.push(i);
                }
                return r;
            }(t1, e), { scenes: n, scene: i, nodes: s } = t1.json, a = n ? n[i || 0].nodes : s, o = [];
            for (const e of a)o.push(rx(s[e], t1, r));
            return function(t1, e, r) {
                const n = {}, i = new Set;
                for(let s = 0; s < t1.length; s++){
                    const t1 = r[e[s]];
                    if (!t1.extras) continue;
                    const a = t1.extras["mapbox:footprint:version"], o = t1.extras["mapbox:footprint:id"];
                    (a || o) && i.add(s), "1.0.0" === a && o && (n[o] = s);
                }
                for(let s = 0; s < t1.length; s++){
                    if (i.has(s)) continue;
                    const a = t1[s], o = r[e[s]];
                    if (!o.extras) continue;
                    let l = null;
                    a.id in n && (l = sx(t1[n[a.id]].meshes, a.matrix)), l || (l = ix(o)), l && (a.footprint = nx(l));
                }
                if (i.size > 0) {
                    const e = Array.from(i.values()).sort((t1, e)=>t1 - e);
                    for(let r = e.length - 1; r >= 0; r--)t1.splice(e[r], 1);
                }
            }(o, a, t1.json.nodes), o;
        }
        function ox(t1) {
            t1.heightmap = new Float32Array(4096), t1.heightmap.fill(-1);
            const e = t1.vertexArray.float32, r = t1.aabb.min[0] - 1, n = t1.aabb.min[1] - 1, i = Wm / (t1.aabb.max[0] - r + 2), s = Wm / (t1.aabb.max[1] - n + 2);
            for(let a = 0; a < e.length; a += 3){
                const o = e[a + 2], l = (e[a + 0] - r) * i | 0, u = (e[a + 1] - n) * s | 0;
                o > t1.heightmap[u * Wm + l] && (t1.heightmap[u * Wm + l] = o);
            }
        }
        function lx(t1, e) {
            const r = {};
            r.indexArray = new Da, r.indexArray.reserve(4 * t1.length), r.vertexArray = new Aa, r.vertexArray.reserve(10 * t1.length), r.colorArray = new Ma, r.vertexArray.reserve(10 * t1.length);
            let n = 0;
            for (const i of t1){
                const t1 = Math.min(10, Math.max(4, 1.3 * i.height)) * e, s = [
                    -i.normal[1],
                    i.normal[0],
                    0
                ], a = Math.min(.29, .1 * i.width / i.depth), o = i.width - 2 * i.depth * e * (a + .01), l = O.vec3.scaleAndAdd([], i.pos, s, o / 2), u = O.vec3.scaleAndAdd([], i.pos, s, -o / 2), c = [
                    l[0],
                    l[1],
                    l[2] + i.height
                ], h = [
                    u[0],
                    u[1],
                    u[2] + i.height
                ], p = O.vec3.scaleAndAdd([], i.normal, s, a);
                O.vec3.scale(p, p, t1);
                const f = O.vec3.scaleAndAdd([], i.normal, s, -a);
                O.vec3.scale(f, f, t1), O.vec3.add(p, l, p), O.vec3.add(f, u, f), l[2] += .1, u[2] += .1, r.vertexArray.emplaceBack(p[0], p[1], p[2]), r.vertexArray.emplaceBack(f[0], f[1], f[2]), r.vertexArray.emplaceBack(l[0], l[1], l[2]), r.vertexArray.emplaceBack(u[0], u[1], u[2]), r.vertexArray.emplaceBack(c[0], c[1], c[2]), r.vertexArray.emplaceBack(h[0], h[1], h[2]), r.vertexArray.emplaceBack(l[0], l[1], l[2]), r.vertexArray.emplaceBack(u[0], u[1], u[2]), r.vertexArray.emplaceBack(p[0], p[1], p[2]), r.vertexArray.emplaceBack(f[0], f[1], f[2]);
                const d = o / t1 / 2;
                r.colorArray.emplaceBack(-d - a, -1, d, .8), r.colorArray.emplaceBack(d + a, -1, d, .8), r.colorArray.emplaceBack(-d, 0, d, 1.3), r.colorArray.emplaceBack(d, 0, d, 1.3), r.colorArray.emplaceBack(d + a, -0.8, d, .7), r.colorArray.emplaceBack(d + a, -0.8, d, .7), r.colorArray.emplaceBack(0, 0, d, 1.3), r.colorArray.emplaceBack(0, 0, d, 1.3), r.colorArray.emplaceBack(d + a, -1.2, d, .8), r.colorArray.emplaceBack(d + a, -1.2, d, .8), r.indexArray.emplaceBack(6 + n, 4 + n, 8 + n), r.indexArray.emplaceBack(7 + n, 9 + n, 5 + n), r.indexArray.emplaceBack(0 + n, 1 + n, 2 + n), r.indexArray.emplaceBack(1 + n, 3 + n, 2 + n), n += 10;
            }
            const i = {
                defined: !0,
                emissiveFactor: [
                    0,
                    0,
                    0
                ]
            }, s = {};
            return s.baseColorFactor = Pe.white, i.pbrMetallicRoughness = s, r.material = i, r.aabb = new yu([
                1 / 0,
                1 / 0,
                1 / 0
            ], [
                -1 / 0,
                -1 / 0,
                -1 / 0
            ]), r;
        }
        class ux {
            constructor(t1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let e = 0; e < t1.length; e++){
                    const r = t1[e];
                    this._stringToNumber[r] = e, this._numberToString[e] = r;
                }
            }
            encode(t1) {
                return this._stringToNumber[t1];
            }
            decode(t1) {
                return this._numberToString[t1];
            }
        }
        const cx = [
            "id",
            "tile",
            "layer",
            "source",
            "sourceLayer",
            "state"
        ];
        class hx {
            constructor(t1, e, r, n, i){
                this.type = "Feature", this._vectorTileFeature = t1, this._z = e, this._x = r, this._y = n, this.properties = t1.properties, this.id = i;
            }
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
            }
            set geometry(t1) {
                this._geometry = t1;
            }
            toJSON() {
                const t1 = {
                    type: "Feature",
                    state: void 0,
                    geometry: this.geometry,
                    properties: this.properties
                };
                for (const e of cx)void 0 !== this[e] && (t1[e] = this[e]);
                return t1;
            }
        }
        class px {
            constructor(t1, e){
                this.tileID = t1, this.x = t1.canonical.x, this.y = t1.canonical.y, this.z = t1.canonical.z, this.grid = new ss(Hr, 16, 0), this.featureIndexArray = new io, this.promoteId = e, this.is3DTile = !1;
            }
            insert(t1, e, r, n, i, s = 0, a = 0) {
                const o = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i, s);
                const l = this.grid;
                for(let t1 = 0; t1 < e.length; t1++){
                    const r = e[t1], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let t1 = 0; t1 < r.length; t1++){
                        const e = r[t1];
                        n[0] = Math.min(n[0], e.x), n[1] = Math.min(n[1], e.y), n[2] = Math.max(n[2], e.x), n[3] = Math.max(n[3], e.y);
                    }
                    0 !== a && (n[0] -= a, n[1] -= a, n[2] += a, n[3] += a), n[0] < Hr && n[1] < Hr && n[2] >= 0 && n[3] >= 0 && l.insert(o, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                if (!this.vtLayers) {
                    this.vtLayers = new ch.VectorTile(new of(this.rawTileData)).layers, this.sourceLayerCoder = new ux(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                        "_geojsonTileLayer"
                    ]), this.vtFeatures = {};
                    for(const t1 in this.vtLayers)this.vtFeatures[t1] = [];
                }
                return this.vtLayers;
            }
            query(t1, e, r, n) {
                this.loadVTLayers();
                const i = t1.params || {}, s = Hs(i.filter), a = t1.tileResult, o = t1.transform, l = a.bufferedTilespaceBounds, u = this.grid.query(l.min.x, l.min.y, l.max.x, l.max.y, (t1, e, r, n)=>jl(a.bufferedTilespaceGeometry, t1, e, r, n));
                u.sort(dx);
                let c = null;
                o.elevation && u.length > 0 && (c = ny.create(o.elevation, this.tileID));
                const h = {};
                let p;
                for(let l = 0; l < u.length; l++){
                    const f = u[l];
                    if (f === p) continue;
                    p = f;
                    const d = this.featureIndexArray.get(f);
                    let m = null;
                    if (this.is3DTile) {
                        const t1 = this.bucketLayerIDs[0][0], r = e[t1];
                        if ("model" !== r.type) continue;
                        const { queryFeature: n, intersectionZ: i } = r.queryIntersectsMatchingFeature(a, d.featureIndex, s, o);
                        n && this.appendToResult(h, t1, d.featureIndex, n, i);
                    } else this.loadMatchingFeature(h, d, s, i.layers, i.availableImages, e, r, n, (e, r, n, i = 0)=>(m || (m = Il(e, this.tileID.canonical, t1.tileTransform)), r.queryIntersectsFeature(a, e, n, m, this.z, t1.transform, t1.pixelPosMatrix, c, i)));
                }
                return h;
            }
            loadMatchingFeature(t1, e, r, n, i, s, a, o, l) {
                const { featureIndex: u, bucketIndex: c, sourceLayerIndex: h, layoutVertexArrayOffset: p } = e, f = this.bucketLayerIDs[c];
                if (n && !function(t1, e) {
                    for(let r = 0; r < t1.length; r++)if (e.indexOf(t1[r]) >= 0) return !0;
                    return !1;
                }(n, f)) return;
                const d = this.sourceLayerCoder.decode(h), m = this.vtLayers[d].feature(u);
                if (r.needGeometry) {
                    const t1 = Pl(m, !0);
                    if (!r.filter(new Vs(this.tileID.overscaledZ), t1, this.tileID.canonical)) return;
                } else if (!r.filter(new Vs(this.tileID.overscaledZ), m)) return;
                const y = this.getId(m, d);
                for(let e = 0; e < f.length; e++){
                    const r = f[e];
                    if (n && n.indexOf(r) < 0) continue;
                    const c = s[r];
                    if (!c) continue;
                    let h = {};
                    void 0 !== y && o && (h = o.getState(c.sourceLayer || "_geojsonTileLayer", y));
                    const d = !l || l(m, c, h, p);
                    if (!d) continue;
                    const g = new hx(m, this.z, this.x, this.y, y), x = nt({}, a[r]);
                    x.paint = fx(x.paint, c.paint, m, h, i), x.layout = fx(x.layout, c.layout, m, h, i), g.layer = x, this.appendToResult(t1, r, u, g, d);
                }
            }
            appendToResult(t1, e, r, n, i) {
                let s = t1[e];
                void 0 === s && (s = t1[e] = []), s.push({
                    featureIndex: r,
                    feature: n,
                    intersectionZ: i
                });
            }
            lookupSymbolFeatures(t1, e, r, n, i, s, a, o) {
                const l = {};
                this.loadVTLayers();
                const u = Hs(i);
                for (const i of t1)this.loadMatchingFeature(l, {
                    bucketIndex: r,
                    sourceLayerIndex: n,
                    featureIndex: i,
                    layoutVertexArrayOffset: 0
                }, u, s, a, o, e);
                return l;
            }
            loadFeature(t1) {
                const { featureIndex: e, sourceLayerIndex: r } = t1;
                this.loadVTLayers();
                const n = this.sourceLayerCoder.decode(r), i = this.vtFeatures[n];
                if (i[e]) return i[e];
                const s = this.vtLayers[n].feature(e);
                return i[e] = s, s;
            }
            hasLayer(t1) {
                for (const e of this.bucketLayerIDs)for (const r of e)if (t1 === r) return !0;
                return !1;
            }
            getId(t1, e) {
                let r = t1.id;
                if (this.promoteId) {
                    const n = "string" == typeof this.promoteId ? this.promoteId : this.promoteId[e];
                    null != n && (r = t1.properties[n]), "boolean" == typeof r && (r = Number(r));
                }
                return r;
            }
        }
        function fx(t1, e, r, n, i) {
            return ut(t1, (t1, s)=>{
                const a = e instanceof js ? e.get(s) : null;
                return a && a.evaluate ? a.evaluate(r, n, i) : a;
            });
        }
        function dx(t1, e) {
            return e - t1;
        }
        os(px, "FeatureIndex", {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        const mx = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class yx {
            static from(t1) {
                if (!(t1 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [e, r] = new Uint8Array(t1, 0, 2);
                if (219 !== e) throw new Error("Data does not appear to be in a KDBush format.");
                const n = r >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const i = mx[15 & r];
                if (!i) throw new Error("Unrecognized array type.");
                const [s] = new Uint16Array(t1, 2, 1), [a] = new Uint32Array(t1, 4, 1);
                return new yx(a, s, i, t1);
            }
            constructor(t1, e = 64, r = Float64Array, n){
                if (isNaN(t1) || t1 < 0) throw new Error(`Unpexpected numItems value: ${t1}.`);
                this.numItems = +t1, this.nodeSize = Math.min(Math.max(+e, 2), 65535), this.ArrayType = r, this.IndexArrayType = t1 < 65536 ? Uint16Array : Uint32Array;
                const i = mx.indexOf(this.ArrayType), s = 2 * t1 * this.ArrayType.BYTES_PER_ELEMENT, a = t1 * this.IndexArrayType.BYTES_PER_ELEMENT, o = (8 - a % 8) % 8;
                if (i < 0) throw new Error(`Unexpected typed array class: ${r}.`);
                n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, t1), this.coords = new this.ArrayType(this.data, 8 + a + o, 2 * t1), this._pos = 2 * t1, this._finished = !0) : (this.data = new ArrayBuffer(8 + s + a + o), this.ids = new this.IndexArrayType(this.data, 8, t1), this.coords = new this.ArrayType(this.data, 8 + a + o, 2 * t1), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = e, new Uint32Array(this.data, 4, 1)[0] = t1);
            }
            add(t1, e) {
                const r = this._pos >> 1;
                return this.ids[r] = r, this.coords[this._pos++] = t1, this.coords[this._pos++] = e, r;
            }
            finish() {
                const t1 = this._pos >> 1;
                if (t1 !== this.numItems) throw new Error(`Added ${t1} items when expected ${this.numItems}.`);
                return gx(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(t1, e, r, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: i, coords: s, nodeSize: a } = this, o = [
                    0,
                    i.length - 1,
                    0
                ], l = [];
                for(; o.length;){
                    const u = o.pop() || 0, c = o.pop() || 0, h = o.pop() || 0;
                    if (c - h <= a) {
                        for(let a = h; a <= c; a++){
                            const o = s[2 * a], u = s[2 * a + 1];
                            o >= t1 && o <= r && u >= e && u <= n && l.push(i[a]);
                        }
                        continue;
                    }
                    const p = h + c >> 1, f = s[2 * p], d = s[2 * p + 1];
                    f >= t1 && f <= r && d >= e && d <= n && l.push(i[p]), (0 === u ? t1 <= f : e <= d) && (o.push(h), o.push(p - 1), o.push(1 - u)), (0 === u ? r >= f : n >= d) && (o.push(p + 1), o.push(c), o.push(1 - u));
                }
                return l;
            }
            within(t1, e, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: i, nodeSize: s } = this, a = [
                    0,
                    n.length - 1,
                    0
                ], o = [], l = r * r;
                for(; a.length;){
                    const u = a.pop() || 0, c = a.pop() || 0, h = a.pop() || 0;
                    if (c - h <= s) {
                        for(let r = h; r <= c; r++)wx(i[2 * r], i[2 * r + 1], t1, e) <= l && o.push(n[r]);
                        continue;
                    }
                    const p = h + c >> 1, f = i[2 * p], d = i[2 * p + 1];
                    wx(f, d, t1, e) <= l && o.push(n[p]), (0 === u ? t1 - r <= f : e - r <= d) && (a.push(h), a.push(p - 1), a.push(1 - u)), (0 === u ? t1 + r >= f : e + r >= d) && (a.push(p + 1), a.push(c), a.push(1 - u));
                }
                return o;
            }
        }
        function gx(t1, e, r, n, i, s) {
            if (i - n <= r) return;
            const a = n + i >> 1;
            xx(t1, e, a, n, i, s), gx(t1, e, r, n, a - 1, 1 - s), gx(t1, e, r, a + 1, i, 1 - s);
        }
        function xx(t1, e, r, n, i, s) {
            for(; i > n;){
                if (i - n > 600) {
                    const a = i - n + 1, o = r - n + 1, l = Math.log(a), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (a - u) / a) * (o - a / 2 < 0 ? -1 : 1);
                    xx(t1, e, r, Math.max(n, Math.floor(r - o * u / a + c)), Math.min(i, Math.floor(r + (a - o) * u / a + c)), s);
                }
                const a = e[2 * r + s];
                let o = n, l = i;
                for(bx(t1, e, n, r), e[2 * i + s] > a && bx(t1, e, n, i); o < l;){
                    for(bx(t1, e, o, l), o++, l--; e[2 * o + s] < a;)o++;
                    for(; e[2 * l + s] > a;)l--;
                }
                e[2 * n + s] === a ? bx(t1, e, n, l) : (l++, bx(t1, e, l, i)), l <= r && (n = l + 1), r <= l && (i = l - 1);
            }
        }
        function bx(t1, e, r, n) {
            vx(t1, r, n), vx(e, 2 * r, 2 * n), vx(e, 2 * r + 1, 2 * n + 1);
        }
        function vx(t1, e, r) {
            const n = t1[e];
            t1[e] = t1[r], t1[r] = n;
        }
        function wx(t1, e, r, n) {
            const i = t1 - r, s = e - n;
            return i * i + s * s;
        }
        t1.$ = Ds, t1.A = class extends Nm {
        }, t1.B = hr, t1.C = Be, t1.D = Ys, t1.E = Me, t1.F = Oi, t1.G = Di, t1.H = Fi, t1.I = Of, t1.J = Wi, t1.K = Zs, t1.L = Qi, t1.M = Hi, t1.N = Bn, t1.O = Cn, t1.P = q, t1.Q = En, t1.R = ee, t1.S = yr, t1.T = lm, t1.U = Ie, t1.V = Nm, t1.W = Ws, t1.X = Ui, t1.Y = Li, t1.Z = function(t1) {
            const e = t1.value;
            let r = [];
            if (!e) return r;
            const n = hr(e);
            return "string" !== n ? (r = r.concat([
                new Nm(t1.key, e, `string expected, "${n}" found`)
            ]), r) : (qm(e, !0) || (r = r.concat([
                new Nm(t1.key, e, `invalid url "${e}"`)
            ])), r);
        }, t1._ = Xs, t1.a = function(t1) {
            return It.API_CDN_URL_REGEX.test(t1);
        }, t1.a$ = qa, t1.a0 = Gs, t1.a1 = Ns, t1.a2 = class {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e) {
                return yt(t1.expression.evaluate(e));
            }
            interpolate(t1, e, r) {
                return {
                    x: ke(t1.x, e.x, r),
                    y: ke(t1.y, e.y, r),
                    z: ke(t1.z, e.z, r),
                    azimuthal: ke(t1.azimuthal, e.azimuthal, r),
                    polar: ke(t1.polar, e.polar, r)
                };
            }
        }, t1.a3 = Vs, t1.a4 = Ji, t1.a5 = xl, t1.a6 = O, t1.a7 = tt, t1.a8 = js, t1.a9 = Du, t1.aA = ru, t1.aB = mm, t1.aC = wm, t1.aD = fm, t1.aE = function(t1, e) {
            const r = document.createElement("video");
            r.muted = !0, r.onloadstart = function() {
                e(null, r);
            };
            for(let e = 0; e < t1.length; e++){
                const n = document.createElement("source");
                ae(t1[e]) || (r.crossOrigin = "Anonymous"), n.src = t1[e], r.appendChild(n);
            }
            return {
                cancel: ()=>{}
            };
        }, t1.aF = um, t1.aG = function(t1) {
            return fetch(t1).then((t1)=>t1.arrayBuffer()).then((e)=>Jg(e, 0, t1));
        }, t1.aH = ax, t1.aI = class {
            constructor(t1, e, r, n){
                this.id = t1, this.position = null != e ? new rl(e[0], e[1]) : new rl(0, 0), this.orientation = null != r ? r : [
                    0,
                    0,
                    0
                ], this.nodes = n, this.uploaded = !1, this.aabb = new yu([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]), this.matrix = [];
            }
            _applyTransformations(t1, e) {
                if (O.mat4.multiply(t1.matrix, e, t1.matrix), t1.meshes) for (const e of t1.meshes){
                    const r = yu.applyTransformFast(e.aabb, t1.matrix);
                    this.aabb.encapsulate(r);
                }
                if (t1.children) for (const e of t1.children)this._applyTransformations(e, t1.matrix);
            }
            computeBoundsAndApplyParent() {
                const t1 = O.mat4.identity([]);
                for (const e of this.nodes)this._applyTransformations(e, t1);
            }
            computeModelMatrix(t1, e, r, n, i, s, a = !1) {
                Km(this.matrix, this, t1.transform, this.position, e, r, n, i, s, a);
            }
            upload(t1) {
                if (!this.uploaded) {
                    for (const e of this.nodes)ty(e, t1);
                    for (const t1 of this.nodes)ey(t1);
                    this.uploaded = !0;
                }
            }
            destroy() {
                for (const t1 of this.nodes)ry(t1);
            }
        }, t1.aJ = ot, t1.aK = yd, t1.aL = cl, t1.aM = hl, t1.aN = va, t1.aO = Da, t1.aP = st, t1.aQ = Ha, t1.aR = Zd, t1.aS = function() {
            Bs.isLoading() || Bs.isLoaded() || "deferred" !== Ts() || Es();
        }, t1.aT = Hs, t1.aU = Pl, t1.aV = hx, t1.aW = xt, t1.aX = wp, t1.aY = Fc, t1.aZ = Il, t1.a_ = xa, t1.aa = ke, t1.ab = Hr, t1.ac = Te, t1.ad = class {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e) {
                return function([t1, e]) {
                    const r = yt([
                        1,
                        t1,
                        e
                    ]);
                    return {
                        x: r.x,
                        y: r.y,
                        z: r.z
                    };
                }(t1.expression.evaluate(e));
            }
            interpolate(t1, e, r) {
                return {
                    x: ke(t1.x, e.x, r),
                    y: ke(t1.y, e.y, r),
                    z: ke(t1.z, e.z, r)
                };
            }
        }, t1.ae = function(t1, e, r = 0, n = !0) {
            const i = new q(r, r), s = t1.sub(i), a = e.add(i), o = [
                s,
                new q(a.x, s.y),
                a,
                new q(s.x, a.y)
            ];
            return n && o.push(s.clone()), o;
        }, t1.af = function(t1, e) {
            const r = [];
            for(let n = 0; n < t1.length; n++){
                const i = et(n - 1, -1, t1.length - 1), s = et(n + 1, -1, t1.length - 1), a = t1[n], o = t1[s], l = t1[i].sub(a).unit(), u = o.sub(a).unit(), c = u.angleWithSep(l.x, l.y), h = l.add(u).unit().mult(-1 * e / Math.sin(c / 2));
                r.push(a.add(h));
            }
            return r;
        }, t1.ag = gd, t1.ah = jl, t1.ai = function(t1, e, r = 0) {
            return O.vec3.fromValues(((e.x - r) * t1.scale - t1.x) * Hr, (e.y * t1.scale - t1.y) * Hr, pl(e.z, e.y));
        }, t1.aj = uu, t1.ak = Sp, t1.al = function(t1) {
            let e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const s of t1)e = Math.min(e, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            return {
                min: new q(e, r),
                max: new q(n, i)
            };
        }, t1.am = ol, t1.an = Ul, t1.ao = vl, t1.ap = Q, t1.aq = $o, t1.ar = function(t1, e) {
            const r = {};
            for(let n = 0; n < e.length; n++){
                const i = e[n];
                i in t1 && (r[i] = t1[i]);
            }
            return r;
        }, t1.as = nl, t1.at = ll, t1.au = class {
            constructor(t1){
                this.entries = {}, this.scheduler = t1;
            }
            request(t1, e, r, n) {
                const i = this.entries[t1] = this.entries[t1] || {
                    callbacks: []
                };
                if (i.result) {
                    const [t1, r] = i.result;
                    return this.scheduler ? this.scheduler.add(()=>{
                        n(t1, r);
                    }, e) : n(t1, r), ()=>{};
                }
                return i.callbacks.push(n), i.cancel || (i.cancel = r((r, n)=>{
                    i.result = [
                        r,
                        n
                    ];
                    for (const t1 of i.callbacks)this.scheduler ? this.scheduler.add(()=>{
                        t1(r, n);
                    }, e) : t1(r, n);
                    setTimeout(()=>delete this.entries[t1], 3e3);
                })), ()=>{
                    i.result || (i.callbacks = i.callbacks.filter((t1)=>t1 !== n), i.callbacks.length || (i.cancel(), delete this.entries[t1]));
                };
            }
        }, t1.av = ua, t1.aw = function(t1, e, r) {
            const n = JSON.stringify(t1.request);
            return t1.data && (this.deduped.entries[n] = {
                result: [
                    null,
                    t1.data
                ]
            }), this.deduped.request(n, {
                type: "parseTile",
                isSymbolTile: t1.isSymbolTile,
                zoom: t1.tileZoom
            }, (e)=>{
                const n = se(t1.request, (t1, n, i, s)=>{
                    t1 ? e(t1) : n && e(null, {
                        vectorTile: r ? void 0 : new ch.VectorTile(new of(n)),
                        rawData: n,
                        cacheControl: i,
                        expires: s
                    });
                });
                return ()=>{
                    n.cancel(), e();
                };
            }, e);
        }, t1.ax = function(t1) {
            Yt++, Yt > jt && (t1.getActor().send("enforceCacheSizeLimit", Ut), Yt = 0);
        }, t1.ay = Rt, t1.az = function(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(t1) / Math.LN2));
        }, t1.b = function(t1) {
            return It.API_FONTS_REGEX.test(t1);
        }, t1.b$ = function(t1) {
            const { x: e, y: r } = t1.point, { lng: n, lat: i } = t1._center;
            return Ru(e, r, t1.worldSize, n, i);
        }, t1.b0 = lu, t1.b1 = co, t1.b2 = uc, t1.b3 = sm, t1.b4 = function(t1, e) {
            const r = Du(e.zoom);
            if (0 === r) return _u(t1);
            const n = Iu(t1), i = Pu(n), s = ol(n.getWest()) * e.worldSize, a = ol(n.getEast()) * e.worldSize, o = ll(n.getNorth()) * e.worldSize, l = ll(n.getSouth()) * e.worldSize, u = [
                s,
                o,
                0
            ], c = [
                a,
                o,
                0
            ], h = [
                s,
                l,
                0
            ], p = [
                a,
                l,
                0
            ], f = O.mat4.invert([], e.globeMatrix);
            return O.vec3.transformMat4(u, u, f), O.vec3.transformMat4(c, c, f), O.vec3.transformMat4(h, h, f), O.vec3.transformMat4(p, p, f), i[0] = Mu(i[0], h, r), i[1] = Mu(i[1], p, r), i[2] = Mu(i[2], c, r), i[3] = Mu(i[3], u, r), yu.fromPoints(i);
        }, t1.b5 = Eu, t1.b6 = zu, t1.b7 = Mu, t1.b8 = ba, t1.b9 = ou, t1.bA = et, t1.bB = Y, t1.bC = wt, t1.bD = ul, t1.bE = function(t1, e, r) {
            t1[4 * e + 0] = r[0], t1[4 * e + 1] = r[1], t1[4 * e + 2] = r[2], t1[4 * e + 3] = r[3];
        }, t1.bF = Po, t1.bG = _o, t1.bH = Mo, t1.bI = wo, t1.bJ = vo, t1.bK = rl, t1.bL = Fd, t1.bM = eu, t1.bN = mu, t1.bO = Sm, t1.bP = tu, t1.bQ = Su, t1.bR = function(t1, e, r, n, i, s, a, o, l) {
            if ("globe" === l.name) return Su(t1, e, new tu(r, n, i), !1);
            const u = yd({
                z: r,
                x: n,
                y: i
            }, l);
            return new yu([
                (s + u.x / u.scale) * e,
                e * (u.y / u.scale),
                a
            ], [
                (s + u.x2 / u.scale) * e,
                e * (u.y2 / u.scale),
                o
            ]);
        }, t1.bS = function(t1, e, r) {
            let n = 0;
            for(let r = 0; r < 2; ++r){
                const i = 0;
                t1[r] > i && (n += (t1[r] - i) * (t1[r] - i)), e[r] < i && (n += (i - e[r]) * (i - e[r]));
            }
            return n;
        }, t1.bT = fl, t1.bU = Xo, t1.bV = function(t1) {
            const e = O.mat4.identity(new Float64Array(16));
            O.mat4.multiply(e, t1.pixelMatrix, t1.globeMatrix);
            const r = [
                0,
                Ho,
                0
            ], n = [
                0,
                Ko,
                0
            ];
            return O.vec3.transformMat4(r, r, e), O.vec3.transformMat4(n, n, e), [
                r[0] > 0 && r[0] <= t1.width && r[1] > 0 && r[1] <= t1.height && !Fu(t1, new rl(t1.center.lat, 90)),
                n[0] > 0 && n[0] <= t1.width && n[1] > 0 && n[1] <= t1.height && !Fu(t1, new rl(t1.center.lat, -90))
            ];
        }, t1.bW = function(t1, e) {
            const { scale: r } = t1.tileTransform, n = r * Hr / (t1.tileSize * Math.pow(2, e.zoom - t1.tileID.overscaledZ + t1.tileID.canonical.z));
            return O.mat2.scale(new Float32Array(4), e.inverseAdjustmentMatrix, [
                n,
                n
            ]);
        }, t1.bX = Im, t1.bY = Am, t1.bZ = function(t1) {
            const e = Am(t1, !0);
            return O.mat2.invert([], [
                e[0],
                e[1],
                e[4],
                e[5]
            ]);
        }, t1.b_ = cu, t1.ba = _g, t1.bb = of, t1.bc = se, t1.bd = function(t1) {
            const e = [];
            for(const r in t1)e.push(t1[r]);
            return e;
        }, t1.be = function(t1, e) {
            const r = [];
            for(const n in t1)n in e || r.push(n);
            return r;
        }, t1.bf = rt, t1.bg = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ], t1.bh = $, t1.bi = function(t1, e) {
            const { x: r, y: n } = t1.point, i = Ru(r, n, t1.worldSize / t1._pixelsPerMercatorPixel, 0, 0);
            return O.mat4.multiply(i, i, Bu(_u(e)));
        }, t1.bj = Zp, t1.bk = ff, t1.bl = Yp, t1.bm = function(t1, e, r, n, i) {
            const s = 5 * e + 2;
            t1.float32[s + 0] = r, t1.float32[s + 1] = n, t1.float32[s + 2] = i;
        }, t1.bn = $d, t1.bo = Df, t1.bp = El, t1.bq = $p, t1.br = gh, t1.bs = jm, t1.bt = Ih, t1.bu = Ph, t1.bv = ad, t1.bw = sd, t1.bx = Af, t1.by = yx, t1.bz = Pe, t1.c = zt, t1.c$ = iu, t1.c0 = Z, t1.c1 = nu, t1.c2 = Go, t1.c3 = function(t1) {
            const e = Math.round((t1 + 45 + 360) % 360 / 90) % 4;
            return W[e];
        }, t1.c4 = 45, t1.c5 = al, t1.c6 = Ao, t1.c7 = function(t1, e, r) {
            const n = Math.sqrt(t1 * t1 + e * e + r * r), i = n > 0 ? Math.acos(r / n) * X : 0;
            let s = 0 !== t1 || 0 !== e ? Math.atan2(-e, -t1) * X + 90 : 0;
            return s < 0 && (s += 360), [
                n,
                s,
                i
            ];
        }, t1.c8 = gl, t1.c9 = yu, t1.cA = function(t1) {
            const e = fl - 5;
            t1 = Q(t1, -e, e) / e * 90;
            const r = Math.pow(Math.abs(Math.sin(Y(t1))), 3);
            return Math.round(r * (Wo.length - 1));
        }, t1.cB = function(t1, e, r, n) {
            const i = e.getNorth(), s = e.getSouth(), a = e.getWest(), o = e.getEast(), l = 1 << t1.z, u = o - a, c = i - s, h = u / Zo, p = -c / Wo[r], f = [
                0,
                h,
                0,
                p,
                0,
                0,
                i,
                a,
                0
            ];
            if (t1.z > 0) {
                const t1 = 180 / n;
                O.mat3.multiply(f, f, [
                    t1 / u + 1,
                    0,
                    0,
                    0,
                    t1 / c + 1,
                    0,
                    -0.5 * t1 / h,
                    .5 * t1 / p,
                    1
                ]);
            }
            return f[2] = l, f[5] = t1.x, f[8] = t1.y, f;
        }, t1.cC = _u, t1.cD = function(t1, e, r) {
            const n = O.mat4.identity(new Float64Array(16)), i = (e / (1 << t1) - .5) * Math.PI * 2;
            return O.mat4.rotateY(n, r.globeMatrix, i), Float32Array.from(n);
        }, t1.cE = class {
            isDataAvailableAtPoint(t1) {
                const e = this._source();
                if (this.isUsingMockSource() || !e || t1.y < 0 || t1.y > 1) return !1;
                const r = e.getSource().maxzoom, n = 1 << r, i = Math.floor(t1.x), s = Math.floor((t1.x - i) * n), a = Math.floor(t1.y * n), o = this.findDEMTileFor(new ru(r, i, r, s, a));
                return !(!o || !o.dem);
            }
            getAtPointOrZero(t1, e = 0) {
                return this.getAtPoint(t1, e) || 0;
            }
            getAtPoint(t1, e, r = !0) {
                if (this.isUsingMockSource()) return null;
                null == e && (e = null);
                const n = this._source();
                if (!n) return e;
                if (t1.y < 0 || t1.y > 1) return e;
                const i = n.getSource().maxzoom, s = 1 << i, a = Math.floor(t1.x), o = t1.x - a, l = new ru(i, a, i, Math.floor(o * s), Math.floor(t1.y * s)), u = this.findDEMTileFor(l);
                if (!u || !u.dem) return e;
                const c = u.dem, h = 1 << u.tileID.canonical.z, p = (o * h - u.tileID.canonical.x) * c.dim, f = (t1.y * h - u.tileID.canonical.y) * c.dim, d = Math.floor(p), m = Math.floor(f);
                return (r ? this.exaggeration() : 1) * ke(ke(c.get(d, m), c.get(d, m + 1), f - m), ke(c.get(d + 1, m), c.get(d + 1, m + 1), f - m), p - d);
            }
            getAtTileOffset(t1, e, r) {
                const n = 1 << t1.canonical.z;
                return this.getAtPointOrZero(new xl(t1.wrap + (t1.canonical.x + e / Hr) / n, (t1.canonical.y + r / Hr) / n));
            }
            getAtTileOffsetFunc(t1, e, r, n) {
                return (i)=>{
                    const s = this.getAtTileOffset(t1, i.x, i.y), a = n.upVector(t1.canonical, i.x, i.y), o = n.upVectorScale(t1.canonical, e, r).metersToTile;
                    return O.vec3.scale(a, a, s * o), a;
                };
            }
            getForTilePoints(t1, e, r, n) {
                if (this.isUsingMockSource()) return !1;
                const i = ny.create(this, t1, n);
                return !!i && (e.forEach((t1)=>{
                    t1[2] = this.exaggeration() * i.getElevationAt(t1[0], t1[1], r);
                }), !0);
            }
            getMinMaxForTile(t1) {
                if (this.isUsingMockSource()) return null;
                const e = this.findDEMTileFor(t1);
                if (!e || !e.dem) return null;
                const r = e.dem.tree, n = e.tileID, i = 1 << t1.canonical.z - n.canonical.z;
                let s = t1.canonical.x / i - n.canonical.x, a = t1.canonical.y / i - n.canonical.y, o = 0;
                for(let e = 0; e < t1.canonical.z - n.canonical.z && !r.leaves[o]; e++){
                    s *= 2, a *= 2;
                    const t1 = 2 * Math.floor(a) + Math.floor(s);
                    o = r.childOffsets[o] + t1, s %= 1, a %= 1;
                }
                return {
                    min: this.exaggeration() * r.minimums[o],
                    max: this.exaggeration() * r.maximums[o]
                };
            }
            getMinElevationBelowMSL() {
                throw new Error("Pure virtual method called.");
            }
            raycast(t1, e, r) {
                throw new Error("Pure virtual method called.");
            }
            pointCoordinate(t1) {
                throw new Error("Pure virtual method called.");
            }
            _source() {
                throw new Error("Pure virtual method called.");
            }
            isUsingMockSource() {
                throw new Error("Pure virtual method called.");
            }
            exaggeration() {
                throw new Error("Pure virtual method called.");
            }
            findDEMTileFor(t1) {
                throw new Error("Pure virtual method called.");
            }
            get visibleDemTiles() {
                throw new Error("Getter must be implemented in subclass.");
            }
            getMinMaxForVisibleTiles() {
                const t1 = this.visibleDemTiles;
                if (0 === t1.length) return null;
                let e = !1, r = Number.MAX_VALUE, n = Number.MIN_VALUE;
                for (const i of t1){
                    const t1 = this.getMinMaxForTile(i.tileID);
                    t1 && (r = Math.min(r, t1.min), n = Math.max(n, t1.max), e = !0);
                }
                return e ? {
                    min: r,
                    max: n
                } : null;
            }
        }, t1.cF = sc, t1.cG = gu, t1.cH = function(t1, e) {
            return [
                Math.pow(t1[0], 2.2) * e,
                Math.pow(t1[1], 2.2) * e,
                Math.pow(t1[2], 2.2) * e
            ];
        }, t1.cI = Cu, t1.cJ = St, t1.cK = At, t1.cL = 256, t1.cM = function(t1, e) {
            const r = [
                0,
                0,
                0
            ], n = Eu(_u(e.canonical));
            return O.vec3.transformMat4(r, r, n), O.vec3.transformMat4(r, r, t1), r;
        }, t1.cN = (t1)=>({
                u_camera_to_center_distance: new wo(t1),
                u_extrude_scale: new To(t1),
                u_device_pixel_ratio: new wo(t1),
                u_matrix: new Po(t1),
                u_inv_rot_matrix: new Po(t1),
                u_merc_center: new _o(t1),
                u_tile_id: new Mo(t1),
                u_zoom_transition: new wo(t1),
                u_up_dir: new Mo(t1),
                u_emissive_strength: new wo(t1)
            }), t1.cO = (t1)=>({
                u_matrix: new Po(t1),
                u_pixels_to_tile_units: new To(t1),
                u_device_pixel_ratio: new wo(t1),
                u_units_to_pixels: new _o(t1),
                u_dash_image: new vo(t1),
                u_gradient_image: new vo(t1),
                u_image_height: new wo(t1),
                u_texsize: new _o(t1),
                u_tile_units_to_pixels: new wo(t1),
                u_alpha_discard_threshold: new wo(t1),
                u_trim_offset: new _o(t1),
                u_trim_fade_range: new _o(t1),
                u_trim_color: new Ao(t1),
                u_emissive_strength: new wo(t1)
            }), t1.cP = (t1)=>({
                u_matrix: new Po(t1),
                u_texsize: new _o(t1),
                u_pixels_to_tile_units: new To(t1),
                u_device_pixel_ratio: new wo(t1),
                u_image: new vo(t1),
                u_units_to_pixels: new _o(t1),
                u_tile_units_to_pixels: new wo(t1),
                u_alpha_discard_threshold: new wo(t1),
                u_trim_offset: new _o(t1)
            }), t1.cQ = Ca, t1.cR = qp, t1.cS = Wp, t1.cT = qu, t1.cU = (t1, e, r, n, i, s)=>{
            const a = t1.transform, o = "globe" === a.projection.name;
            let l;
            if ("map" === s.paint.get("circle-pitch-alignment")) {
                if (o) {
                    const t1 = Cu(a.zoom, e.canonical) * a._pixelsPerMercatorPixel;
                    l = Float32Array.from([
                        t1,
                        0,
                        0,
                        t1
                    ]);
                } else l = a.calculatePixelsToTileUnitsMatrix(r);
            } else l = new Float32Array([
                a.pixelsToGLUnits[0],
                0,
                0,
                a.pixelsToGLUnits[1]
            ]);
            const u = {
                u_camera_to_center_distance: t1.transform.getCameraToCenterDistance(a.projection),
                u_matrix: t1.translatePosMatrix(e.projMatrix, r, s.paint.get("circle-translate"), s.paint.get("circle-translate-anchor")),
                u_device_pixel_ratio: Dt.devicePixelRatio,
                u_extrude_scale: l,
                u_inv_rot_matrix: Nu,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_emissive_strength: s.paint.get("circle-emissive-strength")
            };
            if (o) {
                u.u_inv_rot_matrix = n, u.u_merc_center = i, u.u_tile_id = [
                    e.canonical.x,
                    e.canonical.y,
                    1 << e.canonical.z
                ], u.u_zoom_transition = Du(a.zoom);
                const t1 = i[0] * Hr, r = i[1] * Hr;
                u.u_up_dir = a.projection.upVector(new tu(0, 0, 0), t1, r);
            }
            return u;
        }, t1.cV = zp, t1.cW = (t1, e, r, n, i, s)=>{
            const a = t1.transform;
            return {
                u_matrix: Pp(t1, e, r, n),
                u_texsize: e.imageAtlasTexture ? e.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_pixels_to_tile_units: a.calculatePixelsToTileUnitsMatrix(e),
                u_device_pixel_ratio: i,
                u_image: 0,
                u_tile_units_to_pixels: Ip(e, a),
                u_units_to_pixels: [
                    1 / a.pixelsToGLUnits[0],
                    1 / a.pixelsToGLUnits[1]
                ],
                u_alpha_discard_threshold: 0,
                u_trim_offset: s
            };
        }, t1.cX = (t1, e, r, n, i, s, a)=>{
            const o = t1.transform, l = o.calculatePixelsToTileUnitsMatrix(e);
            return {
                u_matrix: Pp(t1, e, r, n),
                u_pixels_to_tile_units: l,
                u_device_pixel_ratio: s,
                u_units_to_pixels: [
                    1 / o.pixelsToGLUnits[0],
                    1 / o.pixelsToGLUnits[1]
                ],
                u_dash_image: 0,
                u_gradient_image: 1,
                u_image_height: i,
                u_texsize: kp(r) && e.lineAtlasTexture ? e.lineAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: Ip(e, t1.transform),
                u_alpha_discard_threshold: 0,
                u_trim_offset: a,
                u_trim_fade_range: r.paint.get("line-trim-fade-range"),
                u_trim_color: r.paint.get("line-trim-color").toRenderColor(r.lut).toArray01(),
                u_emissive_strength: r.paint.get("line-emissive-strength")
            };
        }, t1.cY = at, t1.cZ = ac, t1.c_ = rp, t1.ca = yt, t1.cb = function(t1) {
            return [
                Math.pow(t1[0], 1 / 2.2),
                Math.pow(t1[1], 1 / 2.2),
                Math.pow(t1[2], 1 / 2.2)
            ];
        }, t1.cc = function(t1) {
            return t1({
                pluginStatus: Ss,
                pluginURL: Is
            }), ks.on("pluginStateChange", t1), t1;
        }, t1.cd = by, t1.ce = kg, t1.cf = Xf, t1.cg = Gf, t1.ch = ne, t1.ci = Ps, t1.cj = Ft, t1.ck = xe, t1.cl = ht, t1.cm = function(t1) {
            const e = t1.indexOf(la);
            return e >= 0 ? t1.slice(0, e) : t1;
        }, t1.cn = function(t1) {
            return t1.indexOf(la) >= 0;
        }, t1.co = function(t1) {
            const e = t1.indexOf(la);
            return e >= 0 ? t1.slice(e + 1) : "";
        }, t1.cp = function(t1) {
            const e = [], r = t1.id;
            return void 0 === r && e.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === t1.render && e.push({
                message: `layers.${r}: missing required method "render"`
            }), t1.renderingMode && "2d" !== t1.renderingMode && "3d" !== t1.renderingMode && e.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), e;
        }, t1.cq = function(t1, e, r, n) {
            return "custom" === t1.type ? new _m(t1, e) : new my[t1.type](t1, e, r, n);
        }, t1.cr = ct, t1.cs = ks, t1.ct = ie, t1.cu = So, t1.cv = class extends bo {
            constructor(t1){
                super(t1), this.current = zo;
            }
            set(t1, e, r) {
                if (this.fetchUniformLocation(t1, e)) {
                    for(let t1 = 0; t1 < 9; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix3fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }, t1.cw = H, t1.cx = function(t1, e, r) {
            const n = Du(r.zoom), i = t1.style.map._antialias, s = e.options.extStandardDerivativesForceOff || t1.terrain && t1.terrain.exaggeration() > 0;
            return 0 === n && !i && !s;
        }, t1.cy = function(t1) {
            const e = t1.pixelsPerMeter, r = e / ul(1, t1.center.lat), n = O.mat4.identity(new Float64Array(16));
            return O.mat4.translate(n, n, [
                t1.point.x,
                t1.point.y,
                0
            ]), O.mat4.scale(n, n, [
                r,
                r,
                e
            ]), Float32Array.from(n);
        }, t1.cz = Iu, t1.d = function(t1) {
            return It.API_TILEJSON_REGEX.test(t1);
        }, t1.d$ = e, t1.d0 = Zh, t1.d1 = Dh, t1.d2 = 450, t1.d3 = 7, t1.d4 = dm, t1.d5 = ya, t1.d6 = Ya, t1.d7 = 256, t1.d8 = Bu, t1.d9 = Aa, t1.dA = Lu, t1.dB = function(t1) {
            const e = [
                0,
                0,
                0
            ], r = O.mat4.identity(new Float64Array(16));
            return O.mat4.multiply(r, t1.pixelMatrix, t1.globeMatrix), O.vec3.transformMat4(e, e, r), new q(e[0], e[1]);
        }, t1.dC = function(t1, e, r = !1) {
            if (Ss === ws || Ss === _s || Ss === Ms) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            Is = Dt.resolveURL(t1), Ss = ws, As = e, zs(), r || Es();
        }, t1.dD = Ts, t1.dE = function() {
            kg().acquire(Ig);
        }, t1.dF = function() {
            const t1 = zg;
            t1 && (t1.isPreloaded() && 1 === t1.numActive() ? (t1.release(Ig), zg = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, t1.dG = Pg, t1.dH = function(t1) {
            const e = Gt();
            if (!e) return;
            const r = e.delete(Ot);
            t1 && r.catch(t1).then(()=>t1());
        }, t1.dI = Sg, t1.dJ = Dg, t1.dK = function(t1) {
            Eg = Dt.resolveURL(t1), Rg || (Rg = new by(kg(), new Me)), Rg.broadcast("setDracoUrl", Eg);
        }, t1.dL = Lg, t1.dM = function(t1) {
            Vg = Dt.resolveURL(t1), Rg || (Rg = new by(kg(), new Me)), Rg.broadcast("setMeshoptUrl", Vg);
        }, t1.dN = os, t1.dO = nc, t1.dP = $f, t1.dQ = ux, t1.dR = px, t1.dS = gp, t1.dT = ut, t1.dU = Uf, t1.dV = function(t1, e, r, n, i, s, a, o, l, u, c) {
            t1.createArrays(), t1.tilePixelRatio = Hr / (512 * t1.overscaling), t1.compareText = {}, t1.iconsNeedLinear = !1;
            const h = t1.layers[0].layout, p = t1.layers[0]._unevaluatedLayout._values, f = {};
            if ("composite" === t1.textSizeData.kind) {
                const { minZoom: e, maxZoom: r } = t1.textSizeData;
                f.compositeTextSizes = [
                    p["text-size"].possiblyEvaluate(new Vs(e), o),
                    p["text-size"].possiblyEvaluate(new Vs(r), o)
                ];
            }
            if ("composite" === t1.iconSizeData.kind) {
                const { minZoom: e, maxZoom: r } = t1.iconSizeData;
                f.compositeIconSizes = [
                    p["icon-size"].possiblyEvaluate(new Vs(e), o),
                    p["icon-size"].possiblyEvaluate(new Vs(r), o)
                ];
            }
            f.layoutTextSize = p["text-size"].possiblyEvaluate(new Vs(l + 1), o), f.layoutIconSize = p["icon-size"].possiblyEvaluate(new Vs(l + 1), o), f.textMaxSize = p["text-size"].possiblyEvaluate(new Vs(18), o);
            const d = "map" === h.get("text-rotation-alignment") && "point" !== h.get("symbol-placement"), m = h.get("text-size");
            let y = !1;
            for (const e of t1.features)if (e.icon && e.icon.nameSecondary) {
                y = !0;
                break;
            }
            for (const s of t1.features){
                const l = h.get("text-font").evaluate(s, {}, o).join(","), p = m.evaluate(s, {}, o), g = f.layoutTextSize.evaluate(s, {}, o), x = (f.layoutIconSize.evaluate(s, {}, o), {
                    horizontal: {},
                    vertical: void 0
                }), b = s.text;
                let v, w = [
                    0,
                    0
                ];
                if (b) {
                    const n = b.toString(), a = h.get("text-letter-spacing").evaluate(s, {}, o) * $p, u = h.get("text-line-height").evaluate(s, {}, o) * $p, c = ds(n) ? a : 0, f = h.get("text-anchor").evaluate(s, {}, o), m = h.get("text-variable-anchor");
                    if (!m) {
                        const t1 = h.get("text-radial-offset").evaluate(s, {}, o);
                        w = t1 ? sd(f, [
                            t1 * $p,
                            nd
                        ]) : h.get("text-offset").evaluate(s, {}, o).map((t1)=>t1 * $p);
                    }
                    let y = d ? "center" : h.get("text-justify").evaluate(s, {}, o);
                    const v = "point" === h.get("symbol-placement"), _ = v ? h.get("text-max-width").evaluate(s, {}, o) * $p : 1 / 0, M = (s)=>{
                        t1.allowVerticalPlacement && fs(n) && (x.vertical = yf(b, e, r, i, l, _, u, f, s, c, w, ff.vertical, !0, g, p));
                    };
                    if (!d && m) {
                        const t1 = "auto" === y ? m.map((t1)=>ad(t1)) : [
                            y
                        ];
                        let n = !1;
                        for(let s = 0; s < t1.length; s++){
                            const a = t1[s];
                            if (!x.horizontal[a]) {
                                if (n) x.horizontal[a] = x.horizontal[0];
                                else {
                                    const t1 = yf(b, e, r, i, l, _, u, "center", a, c, w, ff.horizontal, !1, g, p);
                                    t1 && (x.horizontal[a] = t1, n = 1 === t1.positionedLines.length);
                                }
                            }
                        }
                        M("left");
                    } else {
                        if ("auto" === y && (y = ad(f)), v || h.get("text-writing-mode").indexOf("horizontal") >= 0 || !fs(n)) {
                            const t1 = yf(b, e, r, i, l, _, u, f, y, c, w, ff.horizontal, !1, g, p);
                            t1 && (x.horizontal[y] = t1);
                        }
                        M(v ? "left" : y);
                    }
                }
                let _ = !1;
                if (s.icon && s.icon.namePrimary) {
                    const e = n[s.icon.namePrimary];
                    e && (v = If(i[s.icon.namePrimary], s.icon.nameSecondary ? i[s.icon.nameSecondary] : void 0, h.get("icon-offset").evaluate(s, {}, o), h.get("icon-anchor").evaluate(s, {}, o)), _ = e.sdf, void 0 === t1.sdfIcons ? t1.sdfIcons = e.sdf : t1.sdfIcons !== e.sdf && ft("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (e.pixelRatio !== t1.pixelRatio || 0 !== h.get("icon-rotate").constantOr(1)) && (t1.iconsNeedLinear = !0));
                }
                const M = hd(x.horizontal) || x.vertical;
                t1.iconsInText || (t1.iconsInText = !!M && M.iconsInText), (M || v) && od(t1, s, x, v, n, f, g, 0, w, _, a, o, u, c, y);
            }
            s && t1.generateCollisionDebugBuffers(l, t1.collisionBoxArray);
        }, t1.dW = ch, t1.dX = Ey, t1.dY = N, t1.dZ = uh, t1.d_ = af, t1.da = Ua, t1.db = ja, t1.dc = function(t1, e, r, n, i) {
            return Q((t1 - e) / (r - e) * (i - n) + n, n, i);
        }, t1.dd = Ii, t1.de = ml, t1.df = class {
            constructor(t1, e, r, n){
                this.context = t1, this.format = n, this.size = r, this.texture = t1.gl.createTexture();
                const [i, s, a] = this.size, { gl: o } = t1;
                o.bindTexture(o.TEXTURE_3D, this.texture), t1.pixelStoreUnpackFlipY.set(!1), t1.pixelStoreUnpack.set(1), t1.pixelStoreUnpackPremultiplyAlpha.set(!1), o.texImage3D(o.TEXTURE_3D, 0, this.format, i, s, a, 0, am(this.format), om(this.format), e.data);
            }
            bind(t1, e) {
                const { context: r } = this, { gl: n } = r;
                n.bindTexture(n.TEXTURE_3D, this.texture), t1 !== this.minFilter && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MAG_FILTER, t1), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MIN_FILTER, t1), this.minFilter = t1), e !== this.wrapS && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_S, e), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_T, e), this.wrapS = e);
            }
            destroy() {
                const { gl: t1 } = this.context;
                t1.deleteTexture(this.texture), this.texture = null;
            }
        }, t1.dg = Bm, t1.dh = [
            1,
            1,
            1
        ], t1.di = ny, t1.dj = Hm, t1.dk = Ea, t1.dl = class {
            constructor(){
                this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [], this._globalClipBounds = {
                    min: new q(1 / 0, 1 / 0),
                    max: new q(-1 / 0, -1 / 0)
                };
            }
            clear() {
                this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
            }
            get updateTime() {
                return this._updateTime;
            }
            getReplacementRegionsForTile(t1, e = !1) {
                const r = _h(new q(0, 0), new q(Hr, Hr), t1), n = [];
                if (e && !vh(r, this._globalClipBounds)) return n;
                for (const e of this._activeRegions){
                    if (e.hiddenByOverlap) continue;
                    if (!vh(r, e)) continue;
                    const i = Mh(e.min, e.max, t1);
                    n.push({
                        min: i.min,
                        max: i.max,
                        sourceId: this._sourceIds[e.priority],
                        footprint: e.footprint,
                        footprintTileId: e.tileId,
                        order: e.order,
                        clipMask: e.clipMask,
                        clipScope: e.clipScope
                    });
                }
                return n;
            }
            setSources(t1) {
                this._setSources(t1.map((t1)=>({
                        getSourceId: ()=>t1.cache.id,
                        getFootprints: ()=>{
                            const e = [];
                            for (const r of t1.cache.getVisibleCoordinates()){
                                const n = t1.cache.getTile(r).buckets[t1.layer];
                                n && n.updateFootprints(r.toUnwrapped(), e);
                            }
                            return e;
                        },
                        getOrder: ()=>t1.order,
                        getClipMask: ()=>t1.clipMask,
                        getClipScope: ()=>t1.clipScope
                    })));
            }
            _addSource(t1) {
                const e = t1.getFootprints();
                if (0 === e.length) return;
                const r = t1.getOrder(), n = t1.getClipMask(), i = t1.getClipScope();
                for (const t1 of e){
                    if (!t1.footprint) continue;
                    const e = _h(t1.footprint.min, t1.footprint.max, t1.id);
                    this._activeRegions.push({
                        min: e.min,
                        max: e.max,
                        hiddenByOverlap: !1,
                        priority: this._sourceIds.length,
                        tileId: t1.id,
                        footprint: t1.footprint,
                        order: r,
                        clipMask: n,
                        clipScope: i
                    });
                }
                this._sourceIds.push(t1.getSourceId());
            }
            _computeReplacement() {
                this._activeRegions.sort((t1, e)=>t1.priority - e.priority || xh(t1.min, e.min) || xh(t1.max, e.max) || t1.order - e.order || t1.clipMask - e.clipMask || function(t1, e) {
                        const r = (t1, e)=>t1 + e;
                        return t1.length - e.length || t1.reduce(r, "").localeCompare(e.reduce(r, ""));
                    }(t1.clipScope, e.clipScope));
                let t1 = this._activeRegions.length !== this._prevRegions.length;
                if (!t1) {
                    let e = 0;
                    for(; !t1 && e !== this._activeRegions.length;){
                        const r = this._activeRegions[e], n = this._prevRegions[e];
                        t1 = r.priority !== n.priority || !bh(r, n) || r.order !== n.order || r.clipMask !== n.clipMask || !$(r.clipScope, n.clipScope), ++e;
                    }
                }
                if (t1) {
                    ++this._updateTime;
                    for (const t1 of this._activeRegions)t1.order !== yh && (this._globalClipBounds.min.x = Math.min(this._globalClipBounds.min.x, t1.min.x), this._globalClipBounds.min.y = Math.min(this._globalClipBounds.min.y, t1.min.y), this._globalClipBounds.max.x = Math.max(this._globalClipBounds.max.x, t1.max.x), this._globalClipBounds.max.y = Math.max(this._globalClipBounds.max.y, t1.max.y));
                    const t1 = (t1)=>{
                        const e = this._activeRegions;
                        if (t1 >= e.length) return t1;
                        const r = e[t1].priority;
                        for(; t1 < e.length && e[t1].priority === r;)++t1;
                        return t1;
                    };
                    if (this._sourceIds.length > 1) {
                        let e = 0, r = t1(e);
                        for(; e !== r;){
                            let n = e;
                            const i = e;
                            for(; n !== r;){
                                const t1 = this._activeRegions[n];
                                t1.hiddenByOverlap = !1;
                                for(let e = 0; e < i; e++){
                                    const r = this._activeRegions[e];
                                    if (!r.hiddenByOverlap && t1.order === yh && vh(t1, r) && (t1.hiddenByOverlap = Sh(t1.footprint, t1.tileId, r.footprint, r.tileId), t1.hiddenByOverlap)) break;
                                }
                                ++n;
                            }
                            e = r, r = t1(e);
                        }
                    }
                }
            }
            _setSources(t1) {
                [this._prevRegions, this._activeRegions] = [
                    this._activeRegions,
                    []
                ], this._sourceIds = [];
                for(let e = t1.length - 1; e >= 0; e--)this._addSource(t1[e]);
                this._computeReplacement();
            }
        }, t1.dm = class {
            constructor(t1){
                this._createGrid(t1), this._createPoles(t1);
            }
            destroy() {
                this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
                for (const t1 of this._poleSegments)t1.destroy();
                for (const t1 of this._gridSegments)t1.withSkirts.destroy(), t1.withoutSkirts.destroy();
            }
            _fillGridMeshWithLods(t1, e) {
                const r = new xa, n = new Da, i = [], s = t1 + 1 + 2, a = e[0] + 1, o = e[0] + 1 + (1 + e.length), l = (t1, e, r)=>{
                    let n = t1 === s - 1 ? t1 - 2 : 0 === t1 ? t1 : t1 - 1;
                    return n += r ? 24575 : 0, [
                        n,
                        e
                    ];
                };
                for(let t1 = 0; t1 < s; ++t1)r.emplaceBack(...l(t1, 0, !0));
                for(let t1 = 0; t1 < a; ++t1)for(let e = 0; e < s; ++e)r.emplaceBack(...l(e, t1, (0 === e || e === s - 1) && !0));
                for(let t1 = 0; t1 < e.length; ++t1){
                    const n = e[t1];
                    for(let t1 = 0; t1 < s; ++t1)r.emplaceBack(...l(t1, n, !0));
                }
                for(let t1 = 0; t1 < e.length; ++t1){
                    const a = n.length, l = e[t1] + 1 + 2, u = new Da;
                    for(let r = 0; r < l - 1; r++){
                        const i = r === l - 2, a = i ? s * (o - e.length + t1 - r) : s;
                        for(let t1 = 0; t1 < s - 1; t1++){
                            const e = r * s + t1;
                            0 === r || i || 0 === t1 || t1 === s - 2 ? (u.emplaceBack(e + 1, e, e + a), u.emplaceBack(e + a, e + a + 1, e + 1)) : (n.emplaceBack(e + 1, e, e + a), n.emplaceBack(e + a, e + a + 1, e + 1));
                        }
                    }
                    const c = co.simpleSegment(0, a, r.length, n.length - a);
                    for(let t1 = 0; t1 < u.uint16.length; t1 += 3)n.emplaceBack(u.uint16[t1], u.uint16[t1 + 1], u.uint16[t1 + 2]);
                    const h = co.simpleSegment(0, a, r.length, n.length - a);
                    i.push({
                        withoutSkirts: c,
                        withSkirts: h
                    });
                }
                return {
                    vertices: r,
                    indices: n,
                    segments: i
                };
            }
            _createGrid(t1) {
                const e = this._fillGridMeshWithLods(Zo, Wo);
                this._gridSegments = e.segments, this._gridBuffer = t1.createVertexBuffer(e.vertices, lu.members), this._gridIndexBuffer = t1.createIndexBuffer(e.indices, !0);
            }
            _createPoles(t1) {
                const e = new Da;
                for(let t1 = 0; t1 <= Zo; t1++)e.emplaceBack(0, t1 + 1, t1 + 2);
                this._poleIndexBuffer = t1.createIndexBuffer(e, !0);
                const r = new Ua, n = new Ua, i = new Ua, s = new Ua;
                this._poleSegments = [];
                for(let t1 = 0, e = 0; t1 < Go; t1++){
                    const a = 360 / (1 << t1);
                    r.emplaceBack(0, -$o, 0, .5, 0), n.emplaceBack(0, -$o, 0, .5, 1), i.emplaceBack(0, -$o, 0, .5, .5), s.emplaceBack(0, -$o, 0, .5, .5);
                    for(let t1 = 0; t1 <= Zo; t1++){
                        let e = t1 / Zo, o = 0;
                        const l = ke(0, a, e), [u, c, h] = Jo(Uu, ju, l, $o);
                        r.emplaceBack(u, c, h, e, o), n.emplaceBack(u, c, h, e, 1 - o);
                        const p = Y(l);
                        e = .5 + .5 * Math.sin(p), o = .5 + .5 * Math.cos(p), i.emplaceBack(u, c, h, e, o), s.emplaceBack(u, c, h, e, 1 - o);
                    }
                    this._poleSegments.push(co.simpleSegment(e, 0, 66, 64)), e += 66;
                }
                this._poleNorthVertexBuffer = t1.createVertexBuffer(r, au, !1), this._poleSouthVertexBuffer = t1.createVertexBuffer(n, au, !1), this._texturedPoleNorthVertexBuffer = t1.createVertexBuffer(i, au, !1), this._texturedPoleSouthVertexBuffer = t1.createVertexBuffer(s, au, !1);
            }
            getGridBuffers(t1, e) {
                return [
                    this._gridBuffer,
                    this._gridIndexBuffer,
                    e ? this._gridSegments[t1].withSkirts : this._gridSegments[t1].withoutSkirts
                ];
            }
            getPoleBuffers(t1, e) {
                return [
                    e ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer,
                    e ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer,
                    this._poleIndexBuffer,
                    this._poleSegments[t1]
                ];
            }
        }, t1.dn = yh, t1.dp = K, t1.dq = function() {
            return !!document.fullscreenElement || !!document.webkitFullscreenElement;
        }, t1.dr = J, t1.ds = yl, t1.dt = Qo, t1.du = function([t1, e, r]) {
            const n = Math.hypot(t1, e, r), i = Math.atan2(t1, r), s = .5 * Math.PI - Math.acos(-e / n);
            return new rl(Z(i), Z(s));
        }, t1.dv = zm, t1.dw = tl, t1.dx = function(t1) {
            const e = t1.navigator ? t1.navigator.userAgent : null;
            return !!function(t1) {
                if (null == vt) {
                    const e = t1.navigator ? t1.navigator.userAgent : null;
                    vt = !!t1.safari || !(!e || !(/\b(iPad|iPhone|iPod)\b/.test(e) || e.match("Safari") && !e.match("Chrome")));
                }
                return vt;
            }(t1) && e && (e.match("Version/15.4") || e.match("Version/15.5") || e.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/));
        }, t1.dy = function(t1, e) {
            Ut = t1, jt = e;
        }, t1.dz = Fu, t1.e = It, t1.e0 = function(t1) {
            let e = 0;
            if (new Uint32Array(t1, 0, 1)[0] !== Xg) {
                const r = new Uint32Array(t1, 0, 7), [, , n, i, s, a] = r;
                e = r.byteLength + i + s + a + s, (n !== t1.byteLength || e >= t1.byteLength) && ft("Invalid b3dm header information.");
            }
            return Jg(t1, e);
        }, t1.e1 = function(t1, e) {
            const r = ax(t1);
            for (const t1 of r){
                for (const e of t1.meshes)ox(e);
                t1.lights && (t1.lightMeshIndex = t1.meshes.length, t1.meshes.push(lx(t1.lights, e)));
            }
            return r;
        }, t1.e2 = cy, t1.e3 = xy, t1.e4 = Bs, t1.e5 = function(t1) {
            Xt(), null != qt && qt.then((e)=>{
                e.keys().then((r)=>{
                    for(let n = 0; n < r.length - t1; n++)e.delete(r[n]);
                });
            });
        }, t1.f = function(t1) {
            return 0 === t1.indexOf("mapbox:");
        }, t1.g = function(t1, e) {
            return ie(nt(t1, {
                method: "GET"
            }), e);
        }, t1.h = Pt, t1.i = function(t1) {
            return It.API_STYLE_REGEX.test(t1) && !zt(t1);
        }, t1.j = function(t1) {
            return decodeURIComponent(atob(t1).split("").map((t1)=>"%" + ("00" + t1.charCodeAt(0).toString(16)).slice(-2)).join(""));
        }, t1.k = function(t1) {
            return btoa(encodeURIComponent(t1).replace(/%([0-9A-F]{2})/g, (t1, e)=>String.fromCharCode(Number("0x" + e))));
        }, t1.l = nt, t1.m = Zt, t1.n = function(t1, e) {
            return ie(nt(t1, {
                type: "json"
            }), e);
        }, t1.o = ce, t1.p = function(t1, e) {
            return ie(nt(t1, {
                method: "POST"
            }), e);
        }, t1.q = Dt, t1.r = ic, t1.s = function(t1) {
            try {
                const e = self[t1];
                return e.setItem("_mapbox_test_", 1), e.removeItem("_mapbox_test_"), !0;
            } catch (t1) {
                return !1;
            }
        }, t1.t = ve, t1.u = function() {
            return function t1(e) {
                return e ? (e ^ Math.random() * (16 >> e / 4)).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, t1);
            }();
        }, t1.v = function(t1) {
            return !!t1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t1);
        }, t1.w = ft, t1.x = be, t1.y = 2, t1.z = Lf;
    });
    define([
        "./shared"
    ], function(e) {
        function t1(e) {
            const t1 = e ? e.url.toString() : void 0;
            return t1 ? performance.getEntriesByName(t1) : [];
        }
        function o(e) {
            if ("number" == typeof e || "boolean" == typeof e || "string" == typeof e || null == e) return JSON.stringify(e);
            if (Array.isArray(e)) {
                let t1 = "[";
                for (const s of e)t1 += `${o(s)},`;
                return `${t1}]`;
            }
            let t1 = "{";
            for (const s of Object.keys(e).sort())t1 += `${s}:${o(e[s])},`;
            return `${t1}}`;
        }
        function s(t1) {
            let s = "";
            for (const i of e.bg)s += `/${o(t1[i])}`;
            return s;
        }
        class i {
            constructor(e){
                this.keyCache = {}, this._layers = {}, this._layerConfigs = {}, e && this.replace(e);
            }
            replace(e, t1) {
                this._layerConfigs = {}, this._layers = {}, this.update(e, [], t1);
            }
            update(t1, o, i) {
                this._options = i;
                for (const o of t1)this._layerConfigs[o.id] = o, (this._layers[o.id] = e.cq(o, this.scope, null, this._options)).compileFilter(i), this.keyCache[o.id] && delete this.keyCache[o.id];
                for (const e of o)delete this.keyCache[e], delete this._layerConfigs[e], delete this._layers[e];
                this.familiesBySource = {};
                const n = function(e, t1) {
                    const o = {};
                    for(let i = 0; i < e.length; i++){
                        const n = t1 && t1[e[i].id] || s(e[i]);
                        t1 && (t1[e[i].id] = n);
                        let r = o[n];
                        r || (r = o[n] = []), r.push(e[i]);
                    }
                    const i = [];
                    for(const e in o)i.push(o[e]);
                    return i;
                }(e.bd(this._layerConfigs), this.keyCache);
                for (const e of n){
                    const t1 = e.map((e)=>this._layers[e.id]), o = t1[0];
                    if ("none" === o.visibility) continue;
                    const s = o.source || "";
                    let i = this.familiesBySource[s];
                    i || (i = this.familiesBySource[s] = {});
                    const n = o.sourceLayer || "_geojsonTileLayer";
                    let r = i[n];
                    r || (r = i[n] = []), r.push(t1);
                }
            }
        }
        const n = 1 * e.dP;
        class r {
            constructor(t1){
                const o = {}, s = [];
                for(const e in t1){
                    const i = t1[e], r = o[e] = {};
                    for(const e in i.glyphs){
                        const t1 = i.glyphs[+e];
                        if (!t1 || 0 === t1.bitmap.width || 0 === t1.bitmap.height) continue;
                        const o = t1.metrics.localGlyph ? n : 1, a = {
                            x: 0,
                            y: 0,
                            w: t1.bitmap.width + 2 * o,
                            h: t1.bitmap.height + 2 * o
                        };
                        s.push(a), r[e] = a;
                    }
                }
                const { w: i, h: r } = e.z(s), a = new e.dO({
                    width: i || 1,
                    height: r || 1
                });
                for(const s in t1){
                    const i = t1[s];
                    for(const t1 in i.glyphs){
                        const r = i.glyphs[+t1];
                        if (!r || 0 === r.bitmap.width || 0 === r.bitmap.height) continue;
                        const l = o[s][t1], c = r.metrics.localGlyph ? n : 1;
                        e.dO.copy(r.bitmap, a, {
                            x: 0,
                            y: 0
                        }, {
                            x: l.x + c,
                            y: l.y + c
                        }, r.bitmap);
                    }
                }
                this.image = a, this.positions = o;
            }
        }
        e.dN(r, "GlyphAtlas");
        class a {
            constructor(t1){
                this.tileID = new e.aA(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.tileZoom = t1.tileZoom, this.uid = t1.uid, this.zoom = t1.zoom, this.lut = t1.lut, this.canonical = t1.tileID.canonical, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.scope = t1.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t1.showCollisionBoxes, this.collectResourceTiming = !!t1.collectResourceTiming, this.promoteId = t1.promoteId, this.isSymbolTile = t1.isSymbolTile, this.tileTransform = e.aK(t1.tileID.canonical, t1.projection), this.projection = t1.projection, this.brightness = t1.brightness, this.extraShadowCaster = !!t1.extraShadowCaster, this.tessellationStep = t1.tessellationStep;
            }
            parse(t1, o, s, i, n) {
                this.status = "parsing", this.data = t1, this.collisionBoxArray = new e.aQ;
                const a = new e.dQ(Object.keys(t1.layers).sort()), c = new e.dR(this.tileID, this.promoteId);
                c.bucketLayerIDs = [];
                const h = {}, u = new e.dS(256, 256), d = {
                    featureIndex: c,
                    iconDependencies: {},
                    patternDependencies: {},
                    glyphDependencies: {},
                    lineAtlas: u,
                    availableImages: s,
                    brightness: this.brightness
                }, f = o.familiesBySource[this.source];
                for(const o in f){
                    const i = t1.layers[o];
                    if (!i) continue;
                    let n = !1, r = !1, u = !1;
                    for (const e of f[o])"symbol" === e[0].type ? n = !0 : r = !0, e[0].is3D() && "model" !== e[0].type && (u = !0);
                    if (this.extraShadowCaster && !u) continue;
                    if (!0 === this.isSymbolTile && !n) continue;
                    if (!1 === this.isSymbolTile && !r) continue;
                    1 === i.version && e.w(`Vector tile source "${this.source}" layer "${o}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const p = a.encode(o), g = [];
                    for(let e = 0; e < i.length; e++){
                        const t1 = i.feature(e), s = c.getId(t1, o);
                        g.push({
                            feature: t1,
                            id: s,
                            index: e,
                            sourceLayerIndex: p
                        });
                    }
                    for (const e of f[o]){
                        const t1 = e[0];
                        (!this.extraShadowCaster || t1.is3D() && "model" !== t1.type) && (void 0 !== this.isSymbolTile && "symbol" === t1.type !== this.isSymbolTile || t1.minzoom && this.zoom < Math.floor(t1.minzoom) || t1.maxzoom && this.zoom >= t1.maxzoom || "none" !== t1.visibility && (l(e, this.zoom, d.brightness, s), (h[t1.id] = t1.createBucket({
                            index: c.bucketLayerIDs.length,
                            layers: e,
                            zoom: this.zoom,
                            lut: this.lut,
                            canonical: this.canonical,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: p,
                            sourceID: this.source,
                            projection: this.projection.spec,
                            tessellationStep: this.tessellationStep
                        })).populate(g, d, this.tileID.canonical, this.tileTransform), c.bucketLayerIDs.push(e.map((e)=>e.id))));
                    }
                }
                let p, g, m, y;
                u.trim();
                const x = {
                    type: "maybePrepare",
                    isSymbolTile: this.isSymbolTile,
                    zoom: this.zoom
                }, w = ()=>{
                    if (p) return this.status = "done", n(p);
                    if (this.extraShadowCaster) this.status = "done", n(null, {
                        buckets: e.bd(h).filter((e)=>!e.isEmpty()),
                        featureIndex: c,
                        collisionBoxArray: null,
                        glyphAtlasImage: null,
                        lineAtlas: null,
                        imageAtlas: null,
                        brightness: d.brightness,
                        glyphMap: null,
                        iconMap: null,
                        glyphPositions: null
                    });
                    else if (g && m && y) {
                        const t1 = new r(g), o = new e.dU(m, y, this.lut);
                        for(const i in h){
                            const n = h[i];
                            n instanceof e.aR ? (l(n.layers, this.zoom, d.brightness, s), e.dV(n, g, t1.positions, m, o.iconPositions, this.showCollisionBoxes, s, this.tileID.canonical, this.tileZoom, this.projection, this.brightness)) : n.hasPattern && (n instanceof e.aX || n instanceof e.aY || n instanceof e.d0) && (l(n.layers, this.zoom, d.brightness, s), n.addFeatures(d, this.tileID.canonical, o.patternPositions, s, this.tileTransform, this.brightness));
                        }
                        this.status = "done", n(null, {
                            buckets: e.bd(h).filter((e)=>!e.isEmpty()),
                            featureIndex: c,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: t1.image,
                            lineAtlas: u,
                            imageAtlas: o,
                            brightness: d.brightness
                        });
                    }
                };
                if (!this.extraShadowCaster) {
                    const t1 = e.dT(d.glyphDependencies, (e)=>Object.keys(e).map(Number));
                    Object.keys(t1).length ? i.send("getGlyphs", {
                        uid: this.uid,
                        stacks: t1,
                        scope: this.scope
                    }, (e, t1)=>{
                        p || (p = e, g = t1, w());
                    }, void 0, !1, x) : g = {};
                    const o = Object.keys(d.iconDependencies);
                    o.length ? i.send("getImages", {
                        icons: o,
                        source: this.source,
                        scope: this.scope,
                        tileID: this.tileID,
                        type: "icons"
                    }, (e, t1)=>{
                        p || (p = e, m = t1, w());
                    }, void 0, !1, x) : m = {};
                    const s = Object.keys(d.patternDependencies);
                    s.length ? i.send("getImages", {
                        icons: s,
                        source: this.source,
                        scope: this.scope,
                        tileID: this.tileID,
                        type: "patterns"
                    }, (e, t1)=>{
                        p || (p = e, y = t1, w());
                    }, void 0, !1, x) : y = {};
                }
                w();
            }
        }
        function l(t1, o, s, i) {
            const n = new e.a3(o, {
                brightness: s
            });
            for (const e of t1)e.recalculate(n, i);
        }
        class c extends e.E {
            constructor(t1, o, s, i, n, r){
                super(), this.actor = t1, this.layerIndex = o, this.availableImages = s, this.loadVectorData = n || e.aw, this.loading = {}, this.loaded = {}, this.deduped = new e.au(t1.scheduler), this.isSpriteLoaded = i, this.scheduler = t1.scheduler, this.brightness = r;
            }
            loadTile(o, s) {
                const i = o.uid, n = o && o.request, r = n && n.collectResourceTiming, l = this.loading[i] = new a(o);
                l.abort = this.loadVectorData(o, (a, c)=>{
                    const h = !this.loading[i];
                    if (delete this.loading[i], h || a || !c) return l.status = "done", h || (this.loaded[i] = l), s(a);
                    const u = c.rawData, d = {};
                    c.expires && (d.expires = c.expires), c.cacheControl && (d.cacheControl = c.cacheControl), l.vectorTile = c.vectorTile || new e.dW.VectorTile(new e.bb(u));
                    const f = ()=>{
                        l.parse(l.vectorTile, this.layerIndex, this.availableImages, this.actor, (o, i)=>{
                            if (o || !i) return s(o);
                            const a = {};
                            if (r) {
                                const e = t1(n);
                                e.length > 0 && (a.resourceTiming = JSON.parse(JSON.stringify(e)));
                            }
                            s(null, e.l({
                                rawTileData: u.slice(0)
                            }, i, d, a));
                        });
                    };
                    this.isSpriteLoaded ? f() : this.once("isSpriteLoaded", ()=>{
                        this.scheduler ? this.scheduler.add(f, {
                            type: "parseTile",
                            isSymbolTile: o.isSymbolTile,
                            zoom: o.tileZoom
                        }) : f();
                    }), this.loaded = this.loaded || {}, this.loaded[i] = l;
                });
            }
            reloadTile(t1, o) {
                const s = this.loaded, i = t1.uid;
                if (s && s[i]) {
                    const n = s[i];
                    n.showCollisionBoxes = t1.showCollisionBoxes, n.projection = t1.projection, n.brightness = t1.brightness, n.tileTransform = e.aK(t1.tileID.canonical, t1.projection), n.extraShadowCaster = t1.extraShadowCaster, n.lut = t1.lut;
                    const r = (e, t1)=>{
                        const s = n.reloadCallback;
                        s && (delete n.reloadCallback, n.parse(n.vectorTile, this.layerIndex, this.availableImages, this.actor, s)), o(e, t1);
                    };
                    "parsing" === n.status ? n.reloadCallback = r : "done" === n.status && (n.vectorTile ? n.parse(n.vectorTile, this.layerIndex, this.availableImages, this.actor, r) : r());
                } else o(null, void 0);
            }
            abortTile(e, t1) {
                const o = e.uid, s = this.loading[o];
                s && (s.abort && s.abort(), delete this.loading[o]), t1();
            }
            removeTile(e, t1) {
                const o = this.loaded, s = e.uid;
                o && o[s] && delete o[s], t1();
            }
        }
        class h {
            loadTile(t1, o) {
                const { uid: s, encoding: i, rawImageData: n, padding: r } = t1, a = ImageBitmap && n instanceof ImageBitmap ? this.getImageData(n, r) : n;
                o(null, new e.dX(s, a, i, r < 1));
            }
            getImageData(e, t1) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e.width, e.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", {
                    willReadFrequently: !0
                })), this.offscreenCanvas.width = e.width, this.offscreenCanvas.height = e.height, this.offscreenCanvasContext.drawImage(e, 0, 0, e.width, e.height);
                const o = this.offscreenCanvasContext.getImageData(-t1, -t1, e.width + 2 * t1, e.height + 2 * t1);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), o;
            }
        }
        e.ba.setPbf(e.bb);
        class u {
            decodeRasterArray({ task: t1, buffer: o }, s) {
                e.ba.performDecoding(o, t1).then((e)=>{
                    s(null, e);
                }, (e)=>{
                    s(e);
                });
            }
        }
        const d = e.dW.VectorTileFeature.prototype.toGeoJSON;
        class f {
            constructor(t1){
                this._feature = t1, this.extent = e.ab, this.type = t1.type, this.properties = t1.tags, "id" in t1 && !isNaN(t1.id) && (this.id = parseInt(t1.id, 10));
            }
            loadGeometry() {
                if (1 === this._feature.type) {
                    const t1 = [];
                    for (const o of this._feature.geometry)t1.push([
                        new e.P(o[0], o[1])
                    ]);
                    return t1;
                }
                {
                    const t1 = [];
                    for (const o of this._feature.geometry){
                        const s = [];
                        for (const t1 of o)s.push(new e.P(t1[0], t1[1]));
                        t1.push(s);
                    }
                    return t1;
                }
            }
            toGeoJSON(e, t1, o) {
                return d.call(this, e, t1, o);
            }
        }
        class p {
            constructor(t1){
                this.layers = {
                    _geojsonTileLayer: this
                }, this.name = "_geojsonTileLayer", this.extent = e.ab, this.length = t1.length, this._features = t1;
            }
            feature(e) {
                return new f(this._features[e]);
            }
        }
        const g = 64 / 4096, m = 128;
        class y {
            constructor(){
                this.features = new Map;
            }
            clear() {
                this.features.clear();
            }
            load(e = [], t1) {
                for (const o of e){
                    const e = o.id;
                    if (null == e) continue;
                    let s = this.features.get(e);
                    s && this.updateCache(s, t1), o.geometry ? (s = w(o), this.updateCache(s, t1), this.features.set(e, s)) : this.features.delete(e), this.updateCache(s, t1);
                }
            }
            updateCache(e, t1) {
                for (const { canonical: o, uid: s } of Object.values(t1)){
                    const { z: i, x: n, y: r } = o;
                    x(e, Math.pow(2, i), n, r) && delete t1[s];
                }
            }
            getTile(e, t1, o) {
                const s = Math.pow(2, e), i = [];
                for (const e of this.features.values())x(e, s, t1, o) && i.push(I(e, s, t1, o));
                return {
                    features: i
                };
            }
            getFeatures() {
                return [
                    ...this.features.values()
                ];
            }
        }
        function x({ minX: e, minY: t1, maxX: o, maxY: s }, i, n, r) {
            return e < (n + 1 + g) / i && t1 < (r + 1 + g) / i && o > (n - g) / i && s > (r - g) / i;
        }
        function w(e) {
            const { id: t1, geometry: o, properties: s } = e;
            if (!o) return;
            if ("GeometryCollection" === o.type) throw new Error("GeometryCollection not supported in dynamic mode.");
            const { type: i, coordinates: n } = o, r = {
                id: t1,
                type: 1,
                geometry: [],
                tags: s,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            }, a = r.geometry;
            if ("Point" === i) b(n, a, r);
            else if ("MultiPoint" === i) for (const e of n)b(e, a, r);
            else if ("LineString" === i) r.type = 2, S(n, a, r);
            else if ("MultiLineString" === i) r.type = 2, v(n, a, r);
            else if ("Polygon" === i) r.type = 3, v(n, a, r, !0);
            else {
                if ("MultiPolygon" !== i) throw new Error("Input data is not a valid GeoJSON object.");
                r.type = 3;
                for (const e of n)v(e, a, r, !0);
            }
            return r;
        }
        function b([t1, o], s, i) {
            const n = e.am(t1);
            let r = e.at(o);
            r = r < 0 ? 0 : r > 1 ? 1 : r, s.push(n, r), i.minX = Math.min(i.minX, n), i.minY = Math.min(i.minY, r), i.maxX = Math.max(i.maxX, n), i.maxY = Math.max(i.maxY, r);
        }
        function S(e, t1, o, s = !1, i = !1) {
            const n = [];
            for (const t1 of e)b(t1, n, o);
            t1.push(n), s && function(e, t1) {
                let o = 0;
                for(let t1 = 0, s = e.length, i = s - 2; t1 < s; i = t1, t1 += 2)o += (e[t1] - e[i]) * (e[t1 + 1] + e[i + 1]);
                if (o > 0 === t1) for(let t1 = 0, o = e.length; t1 < o / 2; t1 += 2){
                    const s = e[t1], i = e[t1 + 1];
                    e[t1] = e[o - 2 - t1], e[t1 + 1] = e[o - 1 - t1], e[o - 2 - t1] = s, e[o - 1 - t1] = i;
                }
            }(n, i);
        }
        function v(e, t1, o, s = !1) {
            for(let i = 0; i < e.length; i++)S(e[i], t1, o, s, 0 === i);
        }
        function I(t1, o, s, i) {
            const { id: n, type: r, geometry: a, tags: l } = t1, c = [];
            if (1 === r) !function(t1, o, s, i, n) {
                for(let r = 0; r < t1.length; r += 2){
                    const a = Math.round(e.ab * (t1[r + 0] * o - s)), l = Math.round(e.ab * (t1[r + 1] * o - i));
                    n.push([
                        a,
                        l
                    ]);
                }
            }(a, o, s, i, c);
            else for (const e of a)M(e, o, s, i, c);
            return {
                id: n,
                type: r,
                geometry: c,
                tags: l
            };
        }
        function M(t1, o, s, i, n) {
            const r = -m, a = e.ab + m;
            let l;
            for(let c = 0; c < t1.length - 2; c += 2){
                let h = Math.round(e.ab * (t1[c + 0] * o - s)), u = Math.round(e.ab * (t1[c + 1] * o - i)), d = Math.round(e.ab * (t1[c + 2] * o - s)), f = Math.round(e.ab * (t1[c + 3] * o - i));
                const p = d - h, g = f - u;
                h < r && d < r || (h < r ? (u += Math.round(g * ((r - h) / p)), h = r) : d < r && (f = u + Math.round(g * ((r - h) / p)), d = r), u < r && f < r || (u < r ? (h += Math.round(p * ((r - u) / g)), u = r) : f < r && (d = h + Math.round(p * ((r - u) / g)), f = r), h >= a && d >= a || (h >= a ? (u += Math.round(g * ((a - h) / p)), h = a) : d >= a && (f = u + Math.round(g * ((a - h) / p)), d = a), u >= a && f >= a || (u >= a ? (h += Math.round(p * ((a - u) / g)), u = a) : f >= a && (d = h + Math.round(p * ((a - u) / g)), f = a), l && h === l[l.length - 1][0] && u === l[l.length - 1][1] || (l = [
                    [
                        h,
                        u
                    ]
                ], n.push(l)), l.push([
                    d,
                    f
                ])))));
            }
        }
        var k, T, P, C = {
            exports: {}
        }, _ = function() {
            if (P) return C.exports;
            P = 1;
            var t1 = e.d_(), o = function() {
                if (T) return k;
                T = 1;
                var t1 = e.dY(), o = e.dZ().VectorTileFeature;
                function s(e, t1) {
                    this.options = t1 || {}, this.features = e, this.length = e.length;
                }
                function i(e, t1) {
                    this.id = "number" == typeof e.id ? e.id : void 0, this.type = e.type, this.rawGeometry = 1 === e.type ? [
                        e.geometry
                    ] : e.geometry, this.properties = e.tags, this.extent = t1 || 4096;
                }
                return k = s, s.prototype.feature = function(e) {
                    return new i(this.features[e], this.options.extent);
                }, i.prototype.loadGeometry = function() {
                    var e = this.rawGeometry;
                    this.geometry = [];
                    for(var o = 0; o < e.length; o++){
                        for(var s = e[o], i = [], n = 0; n < s.length; n++)i.push(new t1(s[n][0], s[n][1]));
                        this.geometry.push(i);
                    }
                    return this.geometry;
                }, i.prototype.bbox = function() {
                    this.geometry || this.loadGeometry();
                    for(var e = this.geometry, t1 = 1 / 0, o = -1 / 0, s = 1 / 0, i = -1 / 0, n = 0; n < e.length; n++)for(var r = e[n], a = 0; a < r.length; a++){
                        var l = r[a];
                        t1 = Math.min(t1, l.x), o = Math.max(o, l.x), s = Math.min(s, l.y), i = Math.max(i, l.y);
                    }
                    return [
                        t1,
                        s,
                        o,
                        i
                    ];
                }, i.prototype.toGeoJSON = o.prototype.toGeoJSON, k;
            }();
            function s(e) {
                var o = new t1;
                return function(e, t1) {
                    for(var o in e.layers)t1.writeMessage(3, i, e.layers[o]);
                }(e, o), o.finish();
            }
            function i(e, t1) {
                var o;
                t1.writeVarintField(15, e.version || 1), t1.writeStringField(1, e.name || ""), t1.writeVarintField(5, e.extent || 4096);
                var s = {
                    keys: [],
                    values: [],
                    keycache: {},
                    valuecache: {}
                };
                for(o = 0; o < e.length; o++)s.feature = e.feature(o), t1.writeMessage(2, n, s);
                var i = s.keys;
                for(o = 0; o < i.length; o++)t1.writeStringField(3, i[o]);
                var r = s.values;
                for(o = 0; o < r.length; o++)t1.writeMessage(4, h, r[o]);
            }
            function n(e, t1) {
                var o = e.feature;
                void 0 !== o.id && t1.writeVarintField(1, o.id), t1.writeMessage(2, r, e), t1.writeVarintField(3, o.type), t1.writeMessage(4, c, o);
            }
            function r(e, t1) {
                var o = e.feature, s = e.keys, i = e.values, n = e.keycache, r = e.valuecache;
                for(var a in o.properties){
                    var l = o.properties[a], c = n[a];
                    if (null !== l) {
                        void 0 === c && (s.push(a), n[a] = c = s.length - 1), t1.writeVarint(c);
                        var h = typeof l;
                        "string" !== h && "boolean" !== h && "number" !== h && (l = JSON.stringify(l));
                        var u = h + ":" + l, d = r[u];
                        void 0 === d && (i.push(l), r[u] = d = i.length - 1), t1.writeVarint(d);
                    }
                }
            }
            function a(e, t1) {
                return (t1 << 3) + (7 & e);
            }
            function l(e) {
                return e << 1 ^ e >> 31;
            }
            function c(e, t1) {
                for(var o = e.loadGeometry(), s = e.type, i = 0, n = 0, r = o.length, c = 0; c < r; c++){
                    var h = o[c], u = 1;
                    1 === s && (u = h.length), t1.writeVarint(a(1, u));
                    for(var d = 3 === s ? h.length - 1 : h.length, f = 0; f < d; f++){
                        1 === f && 1 !== s && t1.writeVarint(a(2, d - 1));
                        var p = h[f].x - i, g = h[f].y - n;
                        t1.writeVarint(l(p)), t1.writeVarint(l(g)), i += p, n += g;
                    }
                    3 === s && t1.writeVarint(a(7, 1));
                }
            }
            function h(e, t1) {
                var o = typeof e;
                "string" === o ? t1.writeStringField(1, e) : "boolean" === o ? t1.writeBooleanField(7, e) : "number" === o && (e % 1 != 0 ? t1.writeDoubleField(3, e) : e < 0 ? t1.writeSVarintField(6, e) : t1.writeVarintField(5, e));
            }
            return C.exports = s, C.exports.fromVectorTileJs = s, C.exports.fromGeojsonVt = function(e, t1) {
                t1 = t1 || {};
                var i = {};
                for(var n in e)i[n] = new o(e[n].features, t1), i[n].name = n, i[n].version = t1.version, i[n].extent = t1.extent;
                return s({
                    layers: i
                });
            }, C.exports.GeoJSONWrapper = o, C.exports;
        }(), L = e.d$(_);
        const D = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e)=>e
        }, j = Math.fround || (O = new Float32Array(1), (e)=>(O[0] = +e, O[0]));
        var O;
        const z = 3, A = 5, Z = 6;
        class E {
            constructor(e){
                this.options = Object.assign(Object.create(D), e), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e) {
                const { log: t1, minZoom: o, maxZoom: s } = this.options;
                t1 && console.time("total time");
                const i = `prepare ${e.length} points`;
                t1 && console.time(i), this.points = e;
                const n = [];
                for(let t1 = 0; t1 < e.length; t1++){
                    const o = e[t1];
                    if (!o.geometry) continue;
                    const [s, i] = o.geometry.coordinates, r = j(N(s)), a = j(X(i));
                    n.push(r, a, 1 / 0, t1, -1, 1), this.options.reduce && n.push(0);
                }
                let r = this.trees[s + 1] = this._createTree(n);
                t1 && console.timeEnd(i);
                for(let e = s; e >= o; e--){
                    const o = +Date.now();
                    r = this.trees[e] = this._createTree(this._cluster(r, e)), t1 && console.log("z%d: %d clusters in %dms", e, r.numItems, +Date.now() - o);
                }
                return t1 && console.timeEnd("total time"), this;
            }
            getClusters(e, t1) {
                let o = ((e[0] + 180) % 360 + 360) % 360 - 180;
                const s = Math.max(-90, Math.min(90, e[1]));
                let i = 180 === e[2] ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180;
                const n = Math.max(-90, Math.min(90, e[3]));
                if (e[2] - e[0] >= 360) o = -180, i = 180;
                else if (o > i) {
                    const e = this.getClusters([
                        o,
                        s,
                        180,
                        n
                    ], t1), r = this.getClusters([
                        -180,
                        s,
                        i,
                        n
                    ], t1);
                    return e.concat(r);
                }
                const r = this.trees[this._limitZoom(t1)], a = r.range(N(o), X(n), N(i), X(s)), l = r.data, c = [];
                for (const e of a){
                    const t1 = this.stride * e;
                    c.push(l[t1 + A] > 1 ? F(l, t1, this.clusterProps) : this.points[l[t1 + z]]);
                }
                return c;
            }
            getChildren(e) {
                const t1 = this._getOriginId(e), o = this._getOriginZoom(e), s = "No cluster with the specified id.", i = this.trees[o];
                if (!i) throw new Error(s);
                const n = i.data;
                if (t1 * this.stride >= n.length) throw new Error(s);
                const r = this.options.radius / (this.options.extent * Math.pow(2, o - 1)), a = i.within(n[t1 * this.stride], n[t1 * this.stride + 1], r), l = [];
                for (const t1 of a){
                    const o = t1 * this.stride;
                    n[o + 4] === e && l.push(n[o + A] > 1 ? F(n, o, this.clusterProps) : this.points[n[o + z]]);
                }
                if (0 === l.length) throw new Error(s);
                return l;
            }
            getLeaves(e, t1, o) {
                const s = [];
                return this._appendLeaves(s, e, t1 = t1 || 10, o = o || 0, 0), s;
            }
            getTile(e, t1, o) {
                const s = this.trees[this._limitZoom(e)], i = Math.pow(2, e), { extent: n, radius: r } = this.options, a = r / n, l = (o - a) / i, c = (o + 1 + a) / i, h = {
                    features: []
                };
                return this._addTileFeatures(s.range((t1 - a) / i, l, (t1 + 1 + a) / i, c), s.data, t1, o, i, h), 0 === t1 && this._addTileFeatures(s.range(1 - a / i, l, 1, c), s.data, i, o, i, h), t1 === i - 1 && this._addTileFeatures(s.range(0, l, a / i, c), s.data, -1, o, i, h), h.features.length ? h : null;
            }
            getClusterExpansionZoom(e) {
                let t1 = this._getOriginZoom(e) - 1;
                for(; t1 <= this.options.maxZoom;){
                    const o = this.getChildren(e);
                    if (t1++, 1 !== o.length) break;
                    e = o[0].properties.cluster_id;
                }
                return t1;
            }
            _appendLeaves(e, t1, o, s, i) {
                const n = this.getChildren(t1);
                for (const t1 of n){
                    const n = t1.properties;
                    if (n && n.cluster ? i + n.point_count <= s ? i += n.point_count : i = this._appendLeaves(e, n.cluster_id, o, s, i) : i < s ? i++ : e.push(t1), e.length === o) break;
                }
                return i;
            }
            _createTree(t1) {
                const o = new e.by(t1.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let e = 0; e < t1.length; e += this.stride)o.add(t1[e], t1[e + 1]);
                return o.finish(), o.data = t1, o;
            }
            _addTileFeatures(e, t1, o, s, i, n) {
                for (const r of e){
                    const e = r * this.stride, a = t1[e + A] > 1;
                    let l, c, h;
                    if (a) l = Y(t1, e, this.clusterProps), c = t1[e], h = t1[e + 1];
                    else {
                        const o = this.points[t1[e + z]];
                        l = o.properties;
                        const [s, i] = o.geometry.coordinates;
                        c = N(s), h = X(i);
                    }
                    const u = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * i - o)),
                                Math.round(this.options.extent * (h * i - s))
                            ]
                        ],
                        tags: l
                    };
                    let d;
                    d = a || this.options.generateId ? t1[e + z] : this.points[t1[e + z]].id, void 0 !== d && (u.id = d), n.features.push(u);
                }
            }
            _limitZoom(e) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
            }
            _cluster(e, t1) {
                const { radius: o, extent: s, reduce: i, minPoints: n } = this.options, r = o / (s * Math.pow(2, t1)), a = e.data, l = [], c = this.stride;
                for(let o = 0; o < a.length; o += c){
                    if (a[o + 2] <= t1) continue;
                    a[o + 2] = t1;
                    const s = a[o], h = a[o + 1], u = e.within(a[o], a[o + 1], r), d = a[o + A];
                    let f = d;
                    for (const e of u){
                        const o = e * c;
                        a[o + 2] > t1 && (f += a[o + A]);
                    }
                    if (f > d && f >= n) {
                        let e, n = s * d, r = h * d, p = -1;
                        const g = (o / c << 5) + (t1 + 1) + this.points.length;
                        for (const s of u){
                            const l = s * c;
                            if (a[l + 2] <= t1) continue;
                            a[l + 2] = t1;
                            const h = a[l + A];
                            n += a[l] * h, r += a[l + 1] * h, a[l + 4] = g, i && (e || (e = this._map(a, o, !0), p = this.clusterProps.length, this.clusterProps.push(e)), i(e, this._map(a, l)));
                        }
                        a[o + 4] = g, l.push(n / f, r / f, 1 / 0, g, -1, f), i && l.push(p);
                    } else {
                        for(let e = 0; e < c; e++)l.push(a[o + e]);
                        if (f > 1) for (const e of u){
                            const o = e * c;
                            if (!(a[o + 2] <= t1)) {
                                a[o + 2] = t1;
                                for(let e = 0; e < c; e++)l.push(a[o + e]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e) {
                return e - this.points.length >> 5;
            }
            _getOriginZoom(e) {
                return (e - this.points.length) % 32;
            }
            _map(e, t1, o) {
                if (e[t1 + A] > 1) {
                    const s = this.clusterProps[e[t1 + Z]];
                    return o ? Object.assign({}, s) : s;
                }
                const s = this.points[e[t1 + z]].properties, i = this.options.map(s);
                return o && i === s ? Object.assign({}, i) : i;
            }
        }
        function F(e, t1, o) {
            var s;
            return {
                type: "Feature",
                id: e[t1 + z],
                properties: Y(e, t1, o),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (s = e[t1], 360 * (s - .5)),
                        W(e[t1 + 1])
                    ]
                }
            };
        }
        function Y(e, t1, o) {
            const s = e[t1 + A], i = s >= 1e4 ? `${Math.round(s / 1e3)}k` : s >= 1e3 ? Math.round(s / 100) / 10 + "k" : s, n = e[t1 + Z], r = -1 === n ? {} : Object.assign({}, o[n]);
            return Object.assign(r, {
                cluster: !0,
                cluster_id: e[t1 + z],
                point_count: s,
                point_count_abbreviated: i
            });
        }
        function N(e) {
            return e / 360 + .5;
        }
        function X(e) {
            const t1 = Math.sin(e * Math.PI / 180), o = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function W(e) {
            const t1 = (180 - 360 * e) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t1)) / Math.PI - 90;
        }
        function G(e, t1, o, s) {
            let i = s;
            const n = t1 + (o - t1 >> 1);
            let r, a = o - t1;
            const l = e[t1], c = e[t1 + 1], h = e[o], u = e[o + 1];
            for(let s = t1 + 3; s < o; s += 3){
                const t1 = B(e[s], e[s + 1], l, c, h, u);
                if (t1 > i) r = s, i = t1;
                else if (t1 === i) {
                    const e = Math.abs(s - n);
                    e < a && (r = s, a = e);
                }
            }
            i > s && (r - t1 > 3 && G(e, t1, r, s), e[r + 2] = i, o - r > 3 && G(e, r, o, s));
        }
        function B(e, t1, o, s, i, n) {
            let r = i - o, a = n - s;
            if (0 !== r || 0 !== a) {
                const l = ((e - o) * r + (t1 - s) * a) / (r * r + a * a);
                l > 1 ? (o = i, s = n) : l > 0 && (o += r * l, s += a * l);
            }
            return r = e - o, a = t1 - s, r * r + a * a;
        }
        function J(e, t1, o, s) {
            const i = {
                id: e ?? null,
                type: t1,
                geometry: o,
                tags: s,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            if ("Point" === t1 || "MultiPoint" === t1 || "LineString" === t1) R(i, o);
            else if ("Polygon" === t1) R(i, o[0]);
            else if ("MultiLineString" === t1) for (const e of o)R(i, e);
            else if ("MultiPolygon" === t1) for (const e of o)R(i, e[0]);
            return i;
        }
        function R(e, t1) {
            for(let o = 0; o < t1.length; o += 3)e.minX = Math.min(e.minX, t1[o]), e.minY = Math.min(e.minY, t1[o + 1]), e.maxX = Math.max(e.maxX, t1[o]), e.maxY = Math.max(e.maxY, t1[o + 1]);
        }
        function V(e, t1, o, s) {
            if (!t1.geometry) return;
            const i = t1.geometry.coordinates;
            if (i && 0 === i.length) return;
            const n = t1.geometry.type, r = Math.pow(o.tolerance / ((1 << o.maxZoom) * o.extent), 2);
            let a = [], l = t1.id;
            if (o.promoteId ? l = t1.properties[o.promoteId] : o.generateId && (l = s || 0), "Point" === n) $(i, a);
            else if ("MultiPoint" === n) for (const e of i)$(e, a);
            else if ("LineString" === n) q(i, a, r, !1);
            else if ("MultiLineString" === n) {
                if (o.lineMetrics) {
                    for (const o of i)a = [], q(o, a, r, !1), e.push(J(l, "LineString", a, t1.properties));
                    return;
                }
                U(i, a, r, !1);
            } else if ("Polygon" === n) U(i, a, r, !0);
            else {
                if ("MultiPolygon" !== n) {
                    if ("GeometryCollection" === n) {
                        for (const i of t1.geometry.geometries)V(e, {
                            id: l,
                            geometry: i,
                            properties: t1.properties
                        }, o, s);
                        return;
                    }
                    throw new Error("Input data is not a valid GeoJSON object.");
                }
                for (const e of i){
                    const t1 = [];
                    U(e, t1, r, !0), a.push(t1);
                }
            }
            e.push(J(l, n, a, t1.properties));
        }
        function $(e, t1) {
            t1.push(K(e[0]), Q(e[1]), 0);
        }
        function q(e, t1, o, s) {
            let i, n, r = 0;
            for(let o = 0; o < e.length; o++){
                const a = K(e[o][0]), l = Q(e[o][1]);
                t1.push(a, l, 0), o > 0 && (r += s ? (i * l - a * n) / 2 : Math.sqrt(Math.pow(a - i, 2) + Math.pow(l - n, 2))), i = a, n = l;
            }
            const a = t1.length - 3;
            t1[2] = 1, G(t1, 0, a, o), t1[a + 2] = 1, t1.size = Math.abs(r), t1.start = 0, t1.end = t1.size;
        }
        function U(e, t1, o, s) {
            for(let i = 0; i < e.length; i++){
                const n = [];
                q(e[i], n, o, s), t1.push(n);
            }
        }
        function K(e) {
            return e / 360 + .5;
        }
        function Q(e) {
            const t1 = Math.sin(e * Math.PI / 180), o = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function H(e, t1, o, s, i, n, r, a) {
            if (s /= t1, n >= (o /= t1) && r < s) return e;
            if (r < o || n >= s) return null;
            const l = [];
            for (const t1 of e){
                const e = t1.geometry;
                let n = t1.type;
                const r = 0 === i ? t1.minX : t1.minY, c = 0 === i ? t1.maxX : t1.maxY;
                if (r >= o && c < s) {
                    l.push(t1);
                    continue;
                }
                if (c < o || r >= s) continue;
                let h = [];
                if ("Point" === n || "MultiPoint" === n) ee(e, h, o, s, i);
                else if ("LineString" === n) te(e, h, o, s, i, !1, a.lineMetrics);
                else if ("MultiLineString" === n) se(e, h, o, s, i, !1);
                else if ("Polygon" === n) se(e, h, o, s, i, !0);
                else if ("MultiPolygon" === n) for (const t1 of e){
                    const e = [];
                    se(t1, e, o, s, i, !0), e.length && h.push(e);
                }
                if (h.length) {
                    if (a.lineMetrics && "LineString" === n) {
                        for (const e of h)l.push(J(t1.id, n, e, t1.tags));
                        continue;
                    }
                    "LineString" !== n && "MultiLineString" !== n || (1 === h.length ? (n = "LineString", h = h[0]) : n = "MultiLineString"), "Point" !== n && "MultiPoint" !== n || (n = 3 === h.length ? "Point" : "MultiPoint"), l.push(J(t1.id, n, h, t1.tags));
                }
            }
            return l.length ? l : null;
        }
        function ee(e, t1, o, s, i) {
            for(let n = 0; n < e.length; n += 3){
                const r = e[n + i];
                r >= o && r <= s && ie(t1, e[n], e[n + 1], e[n + 2]);
            }
        }
        function te(e, t1, o, s, i, n, r) {
            let a = oe(e);
            const l = 0 === i ? ne : re;
            let c, h, u = e.start;
            for(let d = 0; d < e.length - 3; d += 3){
                const f = e[d], p = e[d + 1], g = e[d + 2], m = e[d + 3], y = e[d + 4], x = 0 === i ? f : p, w = 0 === i ? m : y;
                let b = !1;
                r && (c = Math.sqrt(Math.pow(f - m, 2) + Math.pow(p - y, 2))), x < o ? w > o && (h = l(a, f, p, m, y, o), r && (a.start = u + c * h)) : x > s ? w < s && (h = l(a, f, p, m, y, s), r && (a.start = u + c * h)) : ie(a, f, p, g), w < o && x >= o && (h = l(a, f, p, m, y, o), b = !0), w > s && x <= s && (h = l(a, f, p, m, y, s), b = !0), !n && b && (r && (a.end = u + c * h), t1.push(a), a = oe(e)), r && (u += c);
            }
            let d = e.length - 3;
            const f = e[d], p = e[d + 1], g = 0 === i ? f : p;
            g >= o && g <= s && ie(a, f, p, e[d + 2]), d = a.length - 3, n && d >= 3 && (a[d] !== a[0] || a[d + 1] !== a[1]) && ie(a, a[0], a[1], a[2]), a.length && t1.push(a);
        }
        function oe(e) {
            const t1 = [];
            return t1.size = e.size, t1.start = e.start, t1.end = e.end, t1;
        }
        function se(e, t1, o, s, i, n) {
            for (const r of e)te(r, t1, o, s, i, n, !1);
        }
        function ie(e, t1, o, s) {
            e.push(t1, o, s);
        }
        function ne(e, t1, o, s, i, n) {
            const r = (n - t1) / (s - t1);
            return ie(e, n, o + (i - o) * r, 1), r;
        }
        function re(e, t1, o, s, i, n) {
            const r = (n - o) / (i - o);
            return ie(e, t1 + (s - t1) * r, n, 1), r;
        }
        function ae(e, t1) {
            const o = [];
            for(let s = 0; s < e.length; s++){
                const i = e[s], n = i.type;
                let r;
                if ("Point" === n || "MultiPoint" === n || "LineString" === n) r = le(i.geometry, t1);
                else if ("MultiLineString" === n || "Polygon" === n) {
                    r = [];
                    for (const e of i.geometry)r.push(le(e, t1));
                } else if ("MultiPolygon" === n) {
                    r = [];
                    for (const e of i.geometry){
                        const o = [];
                        for (const s of e)o.push(le(s, t1));
                        r.push(o);
                    }
                }
                o.push(J(i.id, n, r, i.tags));
            }
            return o;
        }
        function le(e, t1) {
            const o = [];
            o.size = e.size, void 0 !== e.start && (o.start = e.start, o.end = e.end);
            for(let s = 0; s < e.length; s += 3)o.push(e[s] + t1, e[s + 1], e[s + 2]);
            return o;
        }
        function ce(e, t1) {
            if (e.transformed) return e;
            const o = 1 << e.z, s = e.x, i = e.y;
            for (const n of e.features){
                const e = n.geometry, r = n.type;
                if (n.geometry = [], 1 === r) for(let r = 0; r < e.length; r += 2)n.geometry.push(he(e[r], e[r + 1], t1, o, s, i));
                else for(let r = 0; r < e.length; r++){
                    const a = [];
                    for(let n = 0; n < e[r].length; n += 2)a.push(he(e[r][n], e[r][n + 1], t1, o, s, i));
                    n.geometry.push(a);
                }
            }
            return e.transformed = !0, e;
        }
        function he(e, t1, o, s, i, n) {
            return [
                Math.round(o * (e * s - i)),
                Math.round(o * (t1 * s - n))
            ];
        }
        function ue(e, t1, o, s, i) {
            const n = t1 === i.maxZoom ? 0 : i.tolerance / ((1 << t1) * i.extent), r = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: e.length,
                source: null,
                x: o,
                y: s,
                z: t1,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            };
            for (const t1 of e)de(r, t1, n, i);
            return r;
        }
        function de(e, t1, o, s) {
            const i = t1.geometry, n = t1.type, r = [];
            if (e.minX = Math.min(e.minX, t1.minX), e.minY = Math.min(e.minY, t1.minY), e.maxX = Math.max(e.maxX, t1.maxX), e.maxY = Math.max(e.maxY, t1.maxY), "Point" === n || "MultiPoint" === n) for(let t1 = 0; t1 < i.length; t1 += 3)r.push(i[t1], i[t1 + 1]), e.numPoints++, e.numSimplified++;
            else if ("LineString" === n) fe(r, i, e, o, !1, !1);
            else if ("MultiLineString" === n || "Polygon" === n) for(let t1 = 0; t1 < i.length; t1++)fe(r, i[t1], e, o, "Polygon" === n, 0 === t1);
            else if ("MultiPolygon" === n) for(let t1 = 0; t1 < i.length; t1++){
                const s = i[t1];
                for(let t1 = 0; t1 < s.length; t1++)fe(r, s[t1], e, o, !0, 0 === t1);
            }
            if (r.length) {
                let o = t1.tags || null;
                if ("LineString" === n && s.lineMetrics) {
                    o = {};
                    for(const e in t1.tags)o[e] = t1.tags[e];
                    o.mapbox_clip_start = i.start / i.size, o.mapbox_clip_end = i.end / i.size;
                }
                const a = {
                    geometry: r,
                    type: "Polygon" === n || "MultiPolygon" === n ? 3 : "LineString" === n || "MultiLineString" === n ? 2 : 1,
                    tags: o
                };
                null !== t1.id && (a.id = t1.id), e.features.push(a);
            }
        }
        function fe(e, t1, o, s, i, n) {
            const r = s * s;
            if (s > 0 && t1.size < (i ? r : s)) return void (o.numPoints += t1.length / 3);
            const a = [];
            for(let e = 0; e < t1.length; e += 3)(0 === s || t1[e + 2] > r) && (o.numSimplified++, a.push(t1[e], t1[e + 1])), o.numPoints++;
            i && function(e, t1) {
                let o = 0;
                for(let t1 = 0, s = e.length, i = s - 2; t1 < s; i = t1, t1 += 2)o += (e[t1] - e[i]) * (e[t1 + 1] + e[i + 1]);
                if (o > 0 === t1) for(let t1 = 0, o = e.length; t1 < o / 2; t1 += 2){
                    const s = e[t1], i = e[t1 + 1];
                    e[t1] = e[o - 2 - t1], e[t1 + 1] = e[o - 1 - t1], e[o - 2 - t1] = s, e[o - 1 - t1] = i;
                }
            }(a, n), e.push(a);
        }
        const pe = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        };
        class ge {
            constructor(e, t1){
                const o = (t1 = this.options = function(e, t1) {
                    for(const o in t1)e[o] = t1[o];
                    return e;
                }(Object.create(pe), t1)).debug;
                if (o && console.time("preprocess data"), t1.maxZoom < 0 || t1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (t1.promoteId && t1.generateId) throw new Error("promoteId and generateId cannot be used together.");
                let s = function(e, t1) {
                    const o = [];
                    if ("FeatureCollection" === e.type) for(let s = 0; s < e.features.length; s++)V(o, e.features[s], t1, s);
                    else V(o, "Feature" === e.type ? e : {
                        geometry: e
                    }, t1);
                    return o;
                }(e, t1);
                this.tiles = {}, this.tileCoords = [], o && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t1.indexMaxZoom, t1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), s = function(e, t1) {
                    const o = t1.buffer / t1.extent;
                    let s = e;
                    const i = H(e, 1, -1 - o, o, 0, -1, 2, t1), n = H(e, 1, 1 - o, 2 + o, 0, -1, 2, t1);
                    return (i || n) && (s = H(e, 1, -o, 1 + o, 0, -1, 2, t1) || [], i && (s = ae(i, 1).concat(s)), n && (s = s.concat(ae(n, -1)))), s;
                }(s, t1), s.length && this.splitTile(s, 0, 0, 0), o && (s.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            splitTile(e, t1, o, s, i, n, r) {
                const a = [
                    e,
                    t1,
                    o,
                    s
                ], l = this.options, c = l.debug;
                for(; a.length;){
                    s = a.pop(), o = a.pop(), t1 = a.pop(), e = a.pop();
                    const h = 1 << t1, u = me(t1, o, s);
                    let d = this.tiles[u];
                    if (!d && (c > 1 && console.time("creation"), d = this.tiles[u] = ue(e, t1, o, s, l), this.tileCoords.push({
                        z: t1,
                        x: o,
                        y: s
                    }), c)) {
                        c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t1, o, s, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                        const e = `z${t1}`;
                        this.stats[e] = (this.stats[e] || 0) + 1, this.total++;
                    }
                    if (d.source = e, null == i) {
                        if (t1 === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                    } else {
                        if (t1 === l.maxZoom || t1 === i) continue;
                        if (null != i) {
                            const e = i - t1;
                            if (o !== n >> e || s !== r >> e) continue;
                        }
                    }
                    if (d.source = null, 0 === e.length) continue;
                    c > 1 && console.time("clipping");
                    const f = .5 * l.buffer / l.extent, p = .5 - f, g = .5 + f, m = 1 + f;
                    let y = null, x = null, w = null, b = null, S = H(e, h, o - f, o + g, 0, d.minX, d.maxX, l), v = H(e, h, o + p, o + m, 0, d.minX, d.maxX, l);
                    e = null, S && (y = H(S, h, s - f, s + g, 1, d.minY, d.maxY, l), x = H(S, h, s + p, s + m, 1, d.minY, d.maxY, l), S = null), v && (w = H(v, h, s - f, s + g, 1, d.minY, d.maxY, l), b = H(v, h, s + p, s + m, 1, d.minY, d.maxY, l), v = null), c > 1 && console.timeEnd("clipping"), a.push(y || [], t1 + 1, 2 * o, 2 * s), a.push(x || [], t1 + 1, 2 * o, 2 * s + 1), a.push(w || [], t1 + 1, 2 * o + 1, 2 * s), a.push(b || [], t1 + 1, 2 * o + 1, 2 * s + 1);
                }
            }
            getTile(e, t1, o) {
                e = +e, t1 = +t1, o = +o;
                const s = this.options, { extent: i, debug: n } = s;
                if (e < 0 || e > 24) return null;
                const r = 1 << e, a = me(e, t1 = t1 + r & r - 1, o);
                if (this.tiles[a]) return ce(this.tiles[a], i);
                n > 1 && console.log("drilling down to z%d-%d-%d", e, t1, o);
                let l, c = e, h = t1, u = o;
                for(; !l && c > 0;)c--, h >>= 1, u >>= 1, l = this.tiles[me(c, h, u)];
                return l && l.source ? (n > 1 && (console.log("found parent tile z%d-%d-%d", c, h, u), console.time("drilling down")), this.splitTile(l.source, c, h, u, e, t1, o), n > 1 && console.timeEnd("drilling down"), this.tiles[a] ? ce(this.tiles[a], i) : null) : null;
            }
        }
        function me(e, t1, o) {
            return 32 * ((1 << e) * o + t1) + e;
        }
        function ye(e, t1) {
            const o = e.tileID.canonical;
            if (!this._geoJSONIndex) return void t1(null, null);
            const s = this._geoJSONIndex.getTile(o.z, o.x, o.y);
            if (!s) return void t1(null, null);
            const i = new p(s.features);
            let n = L(i);
            0 === n.byteOffset && n.byteLength === n.buffer.byteLength || (n = new Uint8Array(n)), t1(null, {
                vectorTile: i,
                rawData: n.buffer
            });
        }
        class xe extends c {
            constructor(e, t1, o, s, i, n){
                super(e, t1, o, s, ye, n), i && (this.loadGeoJSON = i), this._dynamicIndex = new y;
            }
            loadData(o, s) {
                const i = o && o.request, n = i && i.collectResourceTiming;
                this.loadGeoJSON(o, (r, a)=>{
                    if (r || !a) return s(r);
                    if ("object" != typeof a) return s(new Error(`Input data given to '${o.source}' is not a valid GeoJSON object.`));
                    {
                        try {
                            if (o.filter) {
                                const t1 = e.M(o.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === t1.result) throw new Error(t1.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                                a.features = a.features.filter((e)=>t1.value.evaluate({
                                        zoom: 0
                                    }, e));
                            }
                            o.dynamic ? ("Feature" === a.type && (a = {
                                type: "FeatureCollection",
                                features: [
                                    a
                                ]
                            }), o.append || (this._dynamicIndex.clear(), this.loaded = {}), this._dynamicIndex.load(a.features, this.loaded), o.cluster && (a.features = this._dynamicIndex.getFeatures())) : this.loaded = {}, this._geoJSONIndex = o.cluster ? new E(function({ superclusterOptions: t1, clusterProperties: o }) {
                                if (!o || !t1) return t1;
                                const s = {}, i = {}, n = {
                                    accumulated: null,
                                    zoom: 0
                                }, r = {
                                    properties: null
                                }, a = Object.keys(o);
                                for (const t1 of a){
                                    const [n, r] = o[t1], a = e.M(r), l = e.M("string" == typeof n ? [
                                        n,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            t1
                                        ]
                                    ] : n);
                                    s[t1] = a.value, i[t1] = l.value;
                                }
                                return t1.map = (e)=>{
                                    r.properties = e;
                                    const t1 = {};
                                    for (const e of a)t1[e] = s[e].evaluate(n, r);
                                    return t1;
                                }, t1.reduce = (e, t1)=>{
                                    r.properties = t1;
                                    for (const t1 of a)n.accumulated = e[t1], e[t1] = i[t1].evaluate(n, r);
                                }, t1;
                            }(o)).load(a.features) : o.dynamic ? this._dynamicIndex : function(e, t1) {
                                return new ge(e, t1);
                            }(a, o.geojsonVtOptions);
                        } catch (e) {
                            return s(e);
                        }
                        const r = {};
                        if (n) {
                            const e = t1(i);
                            e && (r.resourceTiming = {}, r.resourceTiming[o.source] = JSON.parse(JSON.stringify(e)));
                        }
                        s(null, r);
                    }
                });
            }
            reloadTile(e, t1) {
                const o = this.loaded;
                return o && o[e.uid] ? e.partial ? t1(null, void 0) : super.reloadTile(e, t1) : this.loadTile(e, t1);
            }
            loadGeoJSON(t1, o) {
                if (t1.request) e.n(t1.request, o);
                else {
                    if ("string" != typeof t1.data) return o(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    try {
                        return o(null, JSON.parse(t1.data));
                    } catch (e) {
                        return o(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    }
                }
            }
            getClusterExpansionZoom(e, t1) {
                try {
                    t1(null, this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));
                } catch (e) {
                    t1(e);
                }
            }
            getClusterChildren(e, t1) {
                try {
                    t1(null, this._geoJSONIndex.getChildren(e.clusterId));
                } catch (e) {
                    t1(e);
                }
            }
            getClusterLeaves(e, t1) {
                try {
                    t1(null, this._geoJSONIndex.getLeaves(e.clusterId, e.limit, e.offset));
                } catch (e) {
                    t1(e);
                }
            }
        }
        class we {
            constructor(t1, o){
                this.tileID = new e.aA(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.tileZoom = t1.tileZoom, this.uid = t1.uid, this.zoom = t1.zoom, this.canonical = t1.tileID.canonical, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = t1.projection, this.brightness = o;
            }
            parse(t1, o, s, i) {
                this.status = "parsing";
                const n = new e.aA(s.tileID.overscaledZ, s.tileID.wrap, s.tileID.canonical.z, s.tileID.canonical.x, s.tileID.canonical.y), r = {}, a = o.familiesBySource[s.source], l = new e.dR(n, s.promoteId);
                return l.bucketLayerIDs = [], l.is3DTile = !0, e.e0(t1).then((t1)=>{
                    if (!t1) return i(new Error("Could not parse tile"));
                    const o = e.e1(t1, 1 / e.c8(s.tileID.canonical)), c = t1.json.extensionsUsed && t1.json.extensionsUsed.includes("MAPBOX_mesh_features") || t1.json.asset.extras && t1.json.asset.extras.MAPBOX_mesh_features, h = t1.json.extensionsUsed && t1.json.extensionsUsed.includes("EXT_meshopt_compression"), u = new e.a3(this.zoom, {
                        brightness: this.brightness
                    });
                    for(const t1 in a)for (const s of a[t1]){
                        const t1 = s[0];
                        l.bucketLayerIDs.push(s.map((e)=>e.id)), t1.recalculate(u, []);
                        const i = new e.e2(o, n, c, h, this.brightness, l);
                        c || (i.needsUpload = !0), r[t1.fqid] = i, i.evaluate(t1);
                    }
                    this.status = "done", i(null, {
                        buckets: r,
                        featureIndex: l
                    });
                }).catch((e)=>i(new Error(e.message)));
            }
        }
        class be {
            constructor(e, t1, o, s, i, n){
                this.actor = e, this.layerIndex = t1, this.brightness = n, this.loading = {}, this.loaded = {};
            }
            loadTile(t1, o) {
                const s = t1.uid, i = this.loading[s] = new we(t1, this.brightness);
                e.bc(t1.request, (e, n)=>{
                    const r = !this.loading[s];
                    return delete this.loading[s], r || e ? (i.status = "done", r || (this.loaded[s] = i), o(e)) : n && 0 !== n.byteLength ? void i.parse(n, this.layerIndex, t1, (e, t1)=>{
                        i.status = "done", this.loaded = this.loaded || {}, this.loaded[s] = i, e || !t1 ? o(e) : o(null, t1);
                    }) : (i.status = "done", this.loaded[s] = i, o());
                });
            }
            reloadTile(e, t1) {
                const o = this.loaded, s = e.uid;
                if (o && o[s]) {
                    const i = o[s];
                    i.projection = e.projection, i.brightness = e.brightness;
                    const n = (o, s)=>{
                        i.reloadCallback && (delete i.reloadCallback, this.loadTile(e, t1)), t1(o, s);
                    };
                    "parsing" === i.status ? i.reloadCallback = n : "done" === i.status && this.loadTile(e, t1);
                }
            }
            abortTile(e, t1) {
                const o = e.uid;
                this.loading[o] && delete this.loading[o], t1();
            }
            removeTile(e, t1) {
                const o = this.loaded, s = e.uid;
                o && o[s] && delete o[s], t1();
            }
        }
        class Se {
            constructor(t1){
                this.self = t1, this.actor = new e.e3(t1, this), this.layerIndexes = {}, this.availableImages = {}, this.isSpriteLoaded = {}, this.projections = {}, this.defaultProjection = e.bL({
                    name: "mercator"
                }), this.workerSourceTypes = {
                    vector: c,
                    geojson: xe,
                    "batched-model": be
                }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e, t1)=>{
                    if (this.workerSourceTypes[e]) throw new Error(`Worker source with name "${e}" already registered.`);
                    this.workerSourceTypes[e] = t1;
                }, this.self.registerRTLTextPlugin = (t1)=>{
                    if (e.e4.isParsed()) throw new Error("RTL text plugin already registered.");
                    e.e4.applyArabicShaping = t1.applyArabicShaping, e.e4.processBidirectionalText = t1.processBidirectionalText, e.e4.processStyledBidirectionalText = t1.processStyledBidirectionalText;
                };
            }
            clearCaches(e, t1, o) {
                delete this.layerIndexes[e], delete this.availableImages[e], delete this.workerSources[e], delete this.demWorkerSources[e], delete this.rasterArrayWorkerSource, o();
            }
            checkIfReady(e, t1, o) {
                o();
            }
            setReferrer(e, t1) {
                this.referrer = t1;
            }
            spriteLoaded(t1, { scope: o, isLoaded: s }) {
                if (this.isSpriteLoaded[t1] || (this.isSpriteLoaded[t1] = {}), this.isSpriteLoaded[t1][o] = s, this.workerSources[t1] && this.workerSources[t1][o]) for(const i in this.workerSources[t1][o]){
                    const n = this.workerSources[t1][o][i];
                    for(const t1 in n){
                        const o = n[t1];
                        o instanceof c && (o.isSpriteLoaded = s, o.fire(new e.x("isSpriteLoaded")));
                    }
                }
            }
            setImages(e, { scope: t1, images: o }, s) {
                if (this.availableImages[e] || (this.availableImages[e] = {}), this.availableImages[e][t1] = o, this.workerSources[e] && this.workerSources[e][t1]) {
                    for(const s in this.workerSources[e][t1]){
                        const i = this.workerSources[e][t1][s];
                        for(const e in i)i[e].availableImages = o;
                    }
                    s();
                } else s();
            }
            setProjection(t1, o) {
                this.projections[t1] = e.bL(o);
            }
            setBrightness(e, t1, o) {
                this.brightness = t1, o();
            }
            setLayers(e, t1, o) {
                this.getLayerIndex(e, t1.scope).replace(t1.layers, t1.options), o();
            }
            updateLayers(e, t1, o) {
                this.getLayerIndex(e, t1.scope).update(t1.layers, t1.removedIds, t1.options), o();
            }
            loadTile(e, t1, o) {
                t1.projection = this.projections[e] || this.defaultProjection, this.getWorkerSource(e, t1.type, t1.source, t1.scope).loadTile(t1, o);
            }
            loadDEMTile(e, t1, o) {
                this.getDEMWorkerSource(e, t1.source, t1.scope).loadTile(t1, o);
            }
            decodeRasterArray(e, t1, o) {
                this.getRasterArrayWorkerSource().decodeRasterArray(t1, o);
            }
            reloadTile(e, t1, o) {
                t1.projection = this.projections[e] || this.defaultProjection, this.getWorkerSource(e, t1.type, t1.source, t1.scope).reloadTile(t1, o);
            }
            abortTile(e, t1, o) {
                this.getWorkerSource(e, t1.type, t1.source, t1.scope).abortTile(t1, o);
            }
            removeTile(e, t1, o) {
                this.getWorkerSource(e, t1.type, t1.source, t1.scope).removeTile(t1, o);
            }
            removeSource(e, t1, o) {
                if (!(this.workerSources[e] && this.workerSources[e][t1.scope] && this.workerSources[e][t1.scope][t1.type] && this.workerSources[e][t1.scope][t1.type][t1.source])) return;
                const s = this.workerSources[e][t1.scope][t1.type][t1.source];
                delete this.workerSources[e][t1.scope][t1.type][t1.source], void 0 !== s.removeSource ? s.removeSource(t1, o) : o();
            }
            loadWorkerSource(e, t1, o) {
                try {
                    this.self.importScripts(t1.url), o();
                } catch (e) {
                    o(e.toString());
                }
            }
            syncRTLPluginState(t1, o, s) {
                try {
                    e.e4.setState(o);
                    const t1 = e.e4.getPluginURL();
                    if (e.e4.isLoaded() && !e.e4.isParsed() && null != t1) {
                        this.self.importScripts(t1);
                        const o = e.e4.isParsed();
                        s(o ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t1}`), o);
                    }
                } catch (e) {
                    s(e.toString());
                }
            }
            setDracoUrl(e, t1) {
                this.dracoUrl = t1;
            }
            getAvailableImages(e, t1) {
                this.availableImages[e] || (this.availableImages[e] = {});
                let o = this.availableImages[e][t1];
                return o || (o = []), o;
            }
            getLayerIndex(e, t1) {
                this.layerIndexes[e] || (this.layerIndexes[e] = {});
                let o = this.layerIndexes[e][t1];
                return o || (o = this.layerIndexes[e][t1] = new i, o.scope = t1), o;
            }
            getWorkerSource(e, t1, o, s) {
                return this.workerSources[e] || (this.workerSources[e] = {}), this.workerSources[e][s] || (this.workerSources[e][s] = {}), this.workerSources[e][s][t1] || (this.workerSources[e][s][t1] = {}), this.isSpriteLoaded[e] || (this.isSpriteLoaded[e] = {}), this.workerSources[e][s][t1][o] || (this.workerSources[e][s][t1][o] = new this.workerSourceTypes[t1]({
                    send: (t1, o, s, i, n, r)=>{
                        this.actor.send(t1, o, s, e, n, r);
                    },
                    scheduler: this.actor.scheduler
                }, this.getLayerIndex(e, s), this.getAvailableImages(e, s), this.isSpriteLoaded[e][s], void 0, this.brightness)), this.workerSources[e][s][t1][o];
            }
            getDEMWorkerSource(e, t1, o) {
                return this.demWorkerSources[e] || (this.demWorkerSources[e] = {}), this.demWorkerSources[e][o] || (this.demWorkerSources[e][o] = {}), this.demWorkerSources[e][o][t1] || (this.demWorkerSources[e][o][t1] = new h), this.demWorkerSources[e][o][t1];
            }
            getRasterArrayWorkerSource() {
                return this.rasterArrayWorkerSource || (this.rasterArrayWorkerSource = new u), this.rasterArrayWorkerSource;
            }
            enforceCacheSizeLimit(t1, o) {
                e.e5(o);
            }
            getWorkerPerformanceMetrics(e, t1, o) {
                o(void 0, void 0);
            }
        }
        return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new Se(self)), Se;
    });
    define([
        "./shared"
    ], function(e) {
        var t1 = "3.7.0";
        const i = {
            create: "create",
            load: "load",
            fullLoad: "fullLoad"
        }, o = {
            mark (e) {
                performance.mark(e);
            },
            measure (e, t1, i) {
                performance.measure(e, t1, i);
            }
        };
        function r(t1) {
            const i = t1.name.split("?")[0];
            return e.a(i) && i.includes("mapbox-gl.js") ? "javascript" : e.a(i) && i.includes("mapbox-gl.css") ? "css" : e.b(i) ? "fontRange" : e.c(i) ? "sprite" : e.i(i) ? "style" : e.d(i) ? "tilejson" : "other";
        }
        var s, a = {}, n = function() {
            if (s) return a;
            function e(e) {
                return !t1(e);
            }
            function t1(t1) {
                var o;
                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : function() {
                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                    var e, t1, i = new Blob([
                        ""
                    ], {
                        type: "text/javascript"
                    }), o = URL.createObjectURL(i);
                    try {
                        t1 = new Worker(o), e = !0;
                    } catch (t1) {
                        e = !1;
                    }
                    return t1 && t1.terminate(), URL.revokeObjectURL(o), e;
                }() ? function() {
                    var e = document.createElement("canvas");
                    e.width = e.height = 1;
                    var t1 = e.getContext("2d");
                    if (!t1) return !1;
                    var i = t1.getImageData(0, 0, 1, 1);
                    return i && i.width === e.width;
                }() ? (void 0 === i[o = t1 && t1.failIfMajorPerformanceCaveat] && (i[o] = function(t1) {
                    var i, o = function(t1) {
                        var i = document.createElement("canvas"), o = Object.create(e.webGLContextAttributes);
                        return o.failIfMajorPerformanceCaveat = t1, i.getContext("webgl2", o);
                    }(t1);
                    if (!o) return !1;
                    try {
                        i = o.createShader(o.VERTEX_SHADER);
                    } catch (e) {
                        return !1;
                    }
                    return !(!i || o.isContextLost()) && (o.shaderSource(i, "void main() {}"), o.compileShader(i), !0 === o.getShaderParameter(i, o.COMPILE_STATUS));
                }(o)), i[o] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL2 support") : "insufficient Canvas/getImageData support" : "insufficient worker support";
            }
            s = 1, a.supported = e, a.notSupportedReason = t1;
            var i = {};
            return e.webGLContextAttributes = {
                antialias: !1,
                alpha: !0,
                stencil: !0,
                depth: !0
            }, a;
        }();
        function l(e, t1, i) {
            const o = document.createElement(e);
            return null != t1 && (o.className = t1), i && i.appendChild(o), o;
        }
        function c(e, t1, i) {
            const o = document.createElementNS("http://www.w3.org/2000/svg", e);
            for (const e of Object.keys(t1))o.setAttributeNS(null, e, String(t1[e]));
            return i && i.appendChild(o), o;
        }
        const h = "undefined" != typeof document ? document.documentElement && document.documentElement.style : null, u = h && void 0 !== h.userSelect ? "userSelect" : "WebkitUserSelect";
        let d;
        function _() {
            h && u && (d = h[u], h[u] = "none");
        }
        function p() {
            h && u && (h[u] = d);
        }
        function m(e) {
            e.preventDefault(), e.stopPropagation(), window.removeEventListener("click", m, !0);
        }
        function f() {
            window.addEventListener("click", m, !0), window.setTimeout(()=>{
                window.removeEventListener("click", m, !0);
            }, 0);
        }
        function g(e, t1) {
            const i = e.getBoundingClientRect();
            return y(e, i, t1);
        }
        function v(e, t1) {
            const i = e.getBoundingClientRect(), o = [];
            for(let r = 0; r < t1.length; r++)o.push(y(e, i, t1[r]));
            return o;
        }
        function x(e) {
            return void 0 !== window.InstallTrigger && 2 === e.button && e.ctrlKey && window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : e.button;
        }
        function y(t1, i, o) {
            const r = t1.offsetWidth === i.width ? 1 : t1.offsetWidth / i.width;
            return new e.P((o.clientX - i.left) * r, (o.clientY - i.top) * r);
        }
        const b = "01", w = "NO_ACCESS_TOKEN";
        class T {
            constructor(e, t1, i){
                this._transformRequestFn = e, this._customAccessToken = t1, this._silenceAuthErrors = !!i, this._createSkuToken();
            }
            _createSkuToken() {
                const e = function() {
                    let e = "";
                    for(let t1 = 0; t1 < 10; t1++)e += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                    return {
                        token: [
                            "1",
                            b,
                            e
                        ].join(""),
                        tokenExpiresAt: Date.now() + 432e5
                    };
                }();
                this._skuToken = e.token, this._skuTokenExpiresAt = e.tokenExpiresAt;
            }
            _isSkuTokenExpired() {
                return Date.now() > this._skuTokenExpiresAt;
            }
            transformRequest(e, t1) {
                return this._transformRequestFn && this._transformRequestFn(e, t1) || {
                    url: e
                };
            }
            normalizeStyleURL(i, o) {
                if (!e.f(i)) return i;
                const r = C(i);
                return r.params.push(`sdk=js-${t1}`), r.path = `/styles/v1${r.path}`, this._makeAPIURL(r, this._customAccessToken || o);
            }
            normalizeGlyphsURL(t1, i) {
                if (!e.f(t1)) return t1;
                const o = C(t1);
                return o.path = `/fonts/v1${o.path}`, this._makeAPIURL(o, this._customAccessToken || i);
            }
            normalizeModelURL(t1, i) {
                if (!e.f(t1)) return t1;
                const o = C(t1);
                return o.path = `/models/v1${o.path}`, this._makeAPIURL(o, this._customAccessToken || i);
            }
            normalizeSourceURL(t1, i, o, r) {
                if (!e.f(t1)) return t1;
                const s = C(t1);
                return s.path = `/v4/${s.authority}.json`, s.params.push("secure"), o && s.params.push(`language=${o}`), r && s.params.push(`worldview=${r}`), this._makeAPIURL(s, this._customAccessToken || i);
            }
            normalizeSpriteURL(t1, i, o, r) {
                const s = C(t1);
                return e.f(t1) ? (s.path = `/styles/v1${s.path}/sprite${i}${o}`, this._makeAPIURL(s, this._customAccessToken || r)) : (s.path += `${i}${o}`, S(s));
            }
            normalizeTileURL(t1, i, o) {
                if (this._isSkuTokenExpired() && this._createSkuToken(), t1 && !e.f(t1)) return t1;
                const r = C(t1);
                r.path = r.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${i || o && "raster" !== r.authority && 512 === o ? "@2x" : ""}${e.m.supported ? ".webp" : "$1"}`), "raster" === r.authority ? r.path = `/${e.e.RASTER_URL_PREFIX}${r.path}` : "rasterarrays" === r.authority ? r.path = `/${e.e.RASTERARRAYS_URL_PREFIX}${r.path}` : "3dtiles" === r.authority ? r.path = `/${e.e.TILES3D_URL_PREFIX}${r.path}` : (r.path = r.path.replace(/^.+\/v4\//, "/"), r.path = `/${e.e.TILE_URL_VERSION}${r.path}`);
                const s = this._customAccessToken || function(e) {
                    for (const t1 of e){
                        const e = t1.match(/^access_token=(.*)$/);
                        if (e) return e[1];
                    }
                    return null;
                }(r.params) || e.e.ACCESS_TOKEN;
                return e.e.REQUIRE_ACCESS_TOKEN && s && this._skuToken && r.params.push(`sku=${this._skuToken}`), this._makeAPIURL(r, s);
            }
            canonicalizeTileURL(t1, i) {
                const o = C(t1);
                if (!o.path.match(/^(\/v4\/|\/(raster|rasterarrays)\/v1\/)/) || !o.path.match(/\.[\w]+$/)) return t1;
                let r = "mapbox://";
                o.path.match(/^\/raster\/v1\//) ? r += `raster/${o.path.replace(`/${e.e.RASTER_URL_PREFIX}/`, "")}` : o.path.match(/^\/rasterarrays\/v1\//) ? r += `rasterarrays/${o.path.replace(`/${e.e.RASTERARRAYS_URL_PREFIX}/`, "")}` : r += `tiles/${o.path.replace(`/${e.e.TILE_URL_VERSION}/`, "")}`;
                let s = o.params;
                return i && (s = s.filter((e)=>!e.match(/^access_token=/))), s.length && (r += `?${s.join("&")}`), r;
            }
            canonicalizeTileset(t1, i) {
                const o = !!i && e.f(i), r = [];
                for (const i of t1.tiles || [])e.h(i) ? r.push(this.canonicalizeTileURL(i, o)) : r.push(i);
                return r;
            }
            _makeAPIURL(t1, i) {
                const o = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", r = C(e.e.API_URL);
                if (t1.protocol = r.protocol, t1.authority = r.authority, "http" === t1.protocol) {
                    const e = t1.params.indexOf("secure");
                    e >= 0 && t1.params.splice(e, 1);
                }
                if ("/" !== r.path && (t1.path = `${r.path}${t1.path}`), !e.e.REQUIRE_ACCESS_TOKEN) return S(t1);
                if (i = i || e.e.ACCESS_TOKEN, !this._silenceAuthErrors) {
                    if (!i) throw new Error(`An API access token is required to use Mapbox GL. ${o}`);
                    if ("s" === i[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${o}`);
                }
                return t1.params = t1.params.filter((e)=>-1 === e.indexOf("access_token")), t1.params.push(`access_token=${i || ""}`), S(t1);
            }
        }
        const E = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function C(e) {
            const t1 = e.match(E);
            if (!t1) throw new Error("Unable to parse URL object");
            return {
                protocol: t1[1],
                authority: t1[2],
                path: t1[3] || "/",
                params: t1[4] ? t1[4].split("&") : []
            };
        }
        function S(e) {
            const t1 = e.params.length ? `?${e.params.join("&")}` : "";
            return `${e.protocol}://${e.authority}${e.path}${t1}`;
        }
        const I = "mapbox.eventData";
        function D(t1) {
            if (!t1) return null;
            const i = t1.split(".");
            if (!i || 3 !== i.length) return null;
            try {
                return JSON.parse(e.j(i[1]));
            } catch (e) {
                return null;
            }
        }
        class R {
            constructor(e){
                this.type = e, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
            }
            getStorageKey(t1) {
                const i = D(e.e.ACCESS_TOKEN);
                let o = "";
                return o = i && i.u ? e.k(i.u) : e.e.ACCESS_TOKEN || "", t1 ? `${I}.${t1}:${o}` : `${I}:${o}`;
            }
            fetchEventData() {
                const t1 = e.s("localStorage"), i = this.getStorageKey(), o = this.getStorageKey("uuid");
                if (t1) try {
                    const e = localStorage.getItem(i);
                    e && (this.eventData = JSON.parse(e));
                    const t1 = localStorage.getItem(o);
                    t1 && (this.anonId = t1);
                } catch (t1) {
                    e.w("Unable to read from LocalStorage");
                }
            }
            saveEventData() {
                const t1 = e.s("localStorage"), i = this.getStorageKey(), o = this.getStorageKey("uuid"), r = this.anonId;
                if (t1 && r) try {
                    localStorage.setItem(o, r), Object.keys(this.eventData).length >= 1 && localStorage.setItem(i, JSON.stringify(this.eventData));
                } catch (t1) {
                    e.w("Unable to write to LocalStorage");
                }
            }
            processRequests(e) {}
            postEvent(t1, i, o, r) {
                if (!e.e.EVENTS_URL) return;
                const s = C(e.e.EVENTS_URL);
                s.params.push(`access_token=${r || e.e.ACCESS_TOKEN || ""}`);
                const a = {
                    event: this.type,
                    created: new Date(t1).toISOString()
                }, n = i ? e.l(a, i) : a, l = {
                    url: S(s),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        n
                    ])
                };
                this.pendingRequest = e.p(l, (e)=>{
                    this.pendingRequest = null, o(e), this.saveEventData(), this.processRequests(r);
                });
            }
            queueRequest(e, t1) {
                this.queue.push(e), this.processRequests(t1);
            }
        }
        const A = new class extends R {
            constructor(e){
                super("appUserTurnstile"), this._customAccessToken = e;
            }
            postTurnstileEvent(t1, i) {
                e.e.EVENTS_URL && e.e.ACCESS_TOKEN && Array.isArray(t1) && t1.some((t1)=>e.f(t1) || e.h(t1)) && this.queueRequest(Date.now(), i);
            }
            processRequests(i) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                const o = D(e.e.ACCESS_TOKEN), r = o ? o.u : e.e.ACCESS_TOKEN;
                let s = r !== this.eventData.tokenU;
                e.v(this.anonId) || (this.anonId = e.u(), s = !0);
                const a = this.queue.shift();
                if (this.eventData.lastSuccess) {
                    const e = new Date(this.eventData.lastSuccess), t1 = new Date(a), i = (a - this.eventData.lastSuccess) / 864e5;
                    s = s || i >= 1 || i < -1 || e.getDate() !== t1.getDate();
                } else s = !0;
                s ? this.postEvent(a, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: t1,
                    skuId: b,
                    "enabled.telemetry": !1,
                    userId: this.anonId
                }, (e)=>{
                    e || (this.eventData.lastSuccess = a, this.eventData.tokenU = r);
                }, i) : this.processRequests();
            }
        }, L = A.postTurnstileEvent.bind(A), P = new class extends R {
            constructor(){
                super("map.load"), this.success = {}, this.skuToken = "";
            }
            postMapLoadEvent(t1, i, o, r) {
                this.skuToken = i, this.errorCb = r, e.e.EVENTS_URL && (o || e.e.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, o) : this.errorCb(new Error(w)));
            }
            processRequests(i) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: o, timestamp: r } = this.queue.shift();
                o && this.success[o] || (this.anonId || this.fetchEventData(), e.v(this.anonId) || (this.anonId = e.u()), this.postEvent(r, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: t1,
                    skuId: b,
                    skuToken: this.skuToken,
                    userId: this.anonId
                }, (e)=>{
                    e ? this.errorCb(e) : o && (this.success[o] = !0);
                }, i));
            }
            remove() {
                this.errorCb = null;
            }
        }, M = P.postMapLoadEvent.bind(P), z = new class extends R {
            constructor(){
                super("style.load"), this.eventIdPerMapInstanceMap = new Map, this.mapInstanceIdMap = new WeakMap;
            }
            getMapInstanceId(t1) {
                let i = this.mapInstanceIdMap.get(t1);
                return i || (i = e.u(), this.mapInstanceIdMap.set(t1, i)), i;
            }
            getEventId(e) {
                const t1 = this.eventIdPerMapInstanceMap.get(e) || 0;
                return this.eventIdPerMapInstanceMap.set(e, t1 + 1), t1;
            }
            postStyleLoadEvent(t1, i) {
                const { map: o, style: r, importedStyles: s } = i;
                if (!e.e.EVENTS_URL || !t1 && !e.e.ACCESS_TOKEN) return;
                const a = this.getMapInstanceId(o), n = {
                    mapInstanceId: a,
                    eventId: this.getEventId(a),
                    style: r
                };
                s.length && (n.importedStyles = s), this.queueRequest({
                    timestamp: Date.now(),
                    payload: n
                }, t1);
            }
            processRequests(e) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: t1, payload: i } = this.queue.shift();
                this.postEvent(t1, i, ()=>{}, e);
            }
        }, O = z.postStyleLoadEvent.bind(z), F = new class extends R {
            constructor(){
                super("gljs.performance");
            }
            postPerformanceEvent(t1, i) {
                e.e.EVENTS_URL && (t1 || e.e.ACCESS_TOKEN) && this.queueRequest({
                    timestamp: Date.now(),
                    performanceData: i
                }, t1);
            }
            processRequests(o) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: s, performanceData: a } = this.queue.shift(), n = function(o) {
                    const s = performance.getEntriesByType("resource"), a = performance.getEntriesByType("mark"), n = function(e) {
                        const t1 = {};
                        if (e) {
                            for(const i in e)if ("other" !== i) for (const o of e[i]){
                                const e = `${i}ResolveRangeMin`, r = `${i}ResolveRangeMax`, s = `${i}RequestCount`, a = `${i}RequestCachedCount`;
                                t1[e] = Math.min(t1[e] || 1 / 0, o.startTime), t1[r] = Math.max(t1[r] || -1 / 0, o.responseEnd);
                                const n = (e)=>{
                                    void 0 === t1[e] && (t1[e] = 0), ++t1[e];
                                };
                                void 0 !== o.transferSize && 0 === o.transferSize && n(a), n(s);
                            }
                        }
                        return t1;
                    }(function(e, t1) {
                        const i = {};
                        if (e) for (const o of e){
                            const e = t1(o);
                            void 0 === i[e] && (i[e] = []), i[e].push(o);
                        }
                        return i;
                    }(s, r)), l = window.devicePixelRatio, c = navigator.connection || navigator.mozConnection || navigator.webkitConnection, h = c ? c.effectiveType : void 0, u = {
                        counters: [],
                        metadata: [],
                        attributes: []
                    }, d = (e, t1, i)=>{
                        null != i && e.push({
                            name: t1,
                            value: i.toString()
                        });
                    };
                    for(const e in n)d(u.counters, e, n[e]);
                    if (o.interactionRange[0] !== 1 / 0 && o.interactionRange[1] !== -1 / 0 && (d(u.counters, "interactionRangeMin", o.interactionRange[0]), d(u.counters, "interactionRangeMax", o.interactionRange[1])), a) for (const e of Object.keys(i)){
                        const t1 = i[e], o = a.find((e)=>e.name === t1);
                        o && d(u.counters, t1, o.startTime);
                    }
                    return d(u.counters, "visibilityHidden", o.visibilityHidden), d(u.attributes, "style", function(t1) {
                        if (t1) for (const i of t1){
                            const t1 = i.name.split("?")[0];
                            if (e.i(t1)) {
                                const e = t1.split("/").slice(-2);
                                if (2 === e.length) return `mapbox://styles/${e[0]}/${e[1]}`;
                            }
                        }
                    }(s)), d(u.attributes, "terrainEnabled", o.terrainEnabled ? "true" : "false"), d(u.attributes, "fogEnabled", o.fogEnabled ? "true" : "false"), d(u.attributes, "projection", o.projection), d(u.attributes, "zoom", o.zoom), d(u.metadata, "devicePixelRatio", l), d(u.metadata, "connectionEffectiveType", h), d(u.metadata, "navigatorUserAgent", navigator.userAgent), d(u.metadata, "screenWidth", window.screen.width), d(u.metadata, "screenHeight", window.screen.height), d(u.metadata, "windowWidth", window.innerWidth), d(u.metadata, "windowHeight", window.innerHeight), d(u.metadata, "mapWidth", o.width / l), d(u.metadata, "mapHeight", o.height / l), d(u.metadata, "webglRenderer", o.renderer), d(u.metadata, "webglVendor", o.vendor), d(u.metadata, "sdkVersion", t1), d(u.metadata, "sdkIdentifier", "mapbox-gl-js"), u;
                }(a);
                for (const e of n.metadata);
                for (const e of n.counters);
                for (const e of n.attributes);
                this.postEvent(s, n, ()=>{}, o);
            }
        }, k = F.postPerformanceEvent.bind(F), B = new class extends R {
            constructor(){
                super("map.auth"), this.success = {}, this.skuToken = "";
            }
            getSession(t1, i, o, r) {
                if (!e.e.API_URL || !e.e.SESSION_PATH) return;
                const s = C(e.e.API_URL + e.e.SESSION_PATH);
                s.params.push(`sku=${i || ""}`), s.params.push(`access_token=${r || e.e.ACCESS_TOKEN || ""}`);
                const a = {
                    url: S(s),
                    headers: {
                        "Content-Type": "text/plain"
                    }
                };
                this.pendingRequest = e.g(a, (e)=>{
                    this.pendingRequest = null, o(e), this.saveEventData(), this.processRequests(r);
                });
            }
            getSessionAPI(t1, i, o, r) {
                this.skuToken = i, this.errorCb = r, e.e.SESSION_PATH && e.e.API_URL && (o || e.e.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, o) : this.errorCb(new Error(w)));
            }
            processRequests(e) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: t1, timestamp: i } = this.queue.shift();
                t1 && this.success[t1] || this.getSession(i, this.skuToken, (e)=>{
                    e ? this.errorCb(e) : t1 && (this.success[t1] = !0);
                }, e);
            }
            remove() {
                this.errorCb = null;
            }
        }, N = B.getSessionAPI.bind(B), U = new Set;
        function G(e, t1) {
            t1 ? U.add(e) : U.delete(e);
        }
        class j {
            constructor(){
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps = new Set, this._updatedImages = new Set;
            }
            isDirty() {
                return this._changed;
            }
            setDirty() {
                this._changed = !0;
            }
            getUpdatedSourceCaches() {
                return this._updatedSourceCaches;
            }
            updateSourceCache(e, t1) {
                this._updatedSourceCaches[e] = t1, this.setDirty();
            }
            discardSourceCacheUpdate(e) {
                delete this._updatedSourceCaches[e];
            }
            updateLayer(e) {
                const t1 = e.scope;
                this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._updatedLayers[t1].add(e.id), this.setDirty();
            }
            removeLayer(e) {
                const t1 = e.scope;
                this._removedLayers[t1] = this._removedLayers[t1] || {}, this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._removedLayers[t1][e.id] = e, this._updatedLayers[t1].delete(e.id), this._updatedPaintProps.delete(e.fqid), this.setDirty();
            }
            getRemovedLayer(e) {
                return this._removedLayers[e.scope] ? this._removedLayers[e.scope][e.id] : null;
            }
            discardLayerRemoval(e) {
                this._removedLayers[e.scope] && delete this._removedLayers[e.scope][e.id];
            }
            getLayerUpdatesByScope() {
                const e = {};
                for(const t1 in this._updatedLayers)e[t1] = e[t1] || {}, e[t1].updatedIds = Array.from(this._updatedLayers[t1].values());
                for(const t1 in this._removedLayers)e[t1] = e[t1] || {}, e[t1].removedIds = Object.keys(this._removedLayers[t1]);
                return e;
            }
            getUpdatedPaintProperties() {
                return this._updatedPaintProps;
            }
            updatePaintProperties(e) {
                this._updatedPaintProps.add(e.fqid), this.setDirty();
            }
            getUpdatedImages() {
                return Array.from(this._updatedImages.values());
            }
            updateImage(e) {
                this._updatedImages.add(e), this.setDirty();
            }
            resetUpdatedImages() {
                this._updatedImages.clear();
            }
            reset() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps.clear(), this._updatedImages.clear();
            }
        }
        function V(e) {
            const { userImage: t1 } = e;
            return !!(t1 && t1.render && t1.render()) && (e.data.replace(new Uint8Array(t1.data.buffer)), !0);
        }
        class q extends e.E {
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = {}, this.requestors = [], this.patterns = {}, this.atlasImage = {}, this.atlasTexture = {}, this.dirty = !0;
            }
            createScope(t1) {
                this.images[t1] = {}, this.loaded[t1] = !1, this.updatedImages[t1] = {}, this.patterns[t1] = {}, this.callbackDispatchedThisFrame[t1] = {}, this.atlasImage[t1] = new e.r({
                    width: 1,
                    height: 1
                });
            }
            isLoaded() {
                for(const e in this.loaded)if (!this.loaded[e]) return !1;
                return !0;
            }
            setLoaded(e, t1) {
                if (this.loaded[t1] !== e && (this.loaded[t1] = e, e)) {
                    for (const { ids: e, callback: i } of this.requestors)this._notify(e, t1, i);
                    this.requestors = [];
                }
            }
            hasImage(e, t1) {
                return !!this.getImage(e, t1);
            }
            getImage(e, t1) {
                return this.images[t1][e];
            }
            addImage(e, t1, i) {
                this._validate(e, i) && (this.images[t1][e] = i);
            }
            _validate(t1, i) {
                let o = !0;
                return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new e.t(new Error(`Image "${t1}" has invalid "stretchX" value`))), o = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new e.t(new Error(`Image "${t1}" has invalid "stretchY" value`))), o = !1), this._validateContent(i.content, i) || (this.fire(new e.t(new Error(`Image "${t1}" has invalid "content" value`))), o = !1), o;
            }
            _validateStretch(e, t1) {
                if (!e) return !0;
                let i = 0;
                for (const o of e){
                    if (o[0] < i || o[1] < o[0] || t1 < o[1]) return !1;
                    i = o[1];
                }
                return !0;
            }
            _validateContent(e, t1) {
                return !(e && (4 !== e.length || e[0] < 0 || t1.data.width < e[0] || e[1] < 0 || t1.data.height < e[1] || e[2] < 0 || t1.data.width < e[2] || e[3] < 0 || t1.data.height < e[3] || e[2] < e[0] || e[3] < e[1]));
            }
            updateImage(e, t1, i) {
                i.version = this.images[t1][e].version + 1, this.images[t1][e] = i, this.updatedImages[t1][e] = !0;
            }
            removeImage(e, t1) {
                const i = this.images[t1][e];
                delete this.images[t1][e], delete this.patterns[t1][e], i.userImage && i.userImage.onRemove && i.userImage.onRemove();
            }
            listImages(e) {
                return Object.keys(this.images[e]);
            }
            getImages(e, t1, i) {
                let o = !0;
                const r = !!this.loaded[t1];
                if (!r) for (const i of e)this.images[t1][i] || (o = !1);
                r || o ? this._notify(e, t1, i) : this.requestors.push({
                    ids: e,
                    scope: t1,
                    callback: i
                });
            }
            getUpdatedImages(e) {
                return this.updatedImages[e];
            }
            _notify(t1, i, o) {
                const r = {};
                for (const o of t1){
                    this.images[i][o] || this.fire(new e.x("styleimagemissing", {
                        id: o
                    }));
                    const t1 = this.images[i][o];
                    t1 ? r[o] = {
                        data: t1.data.clone(),
                        pixelRatio: t1.pixelRatio,
                        sdf: t1.sdf,
                        version: t1.version,
                        stretchX: t1.stretchX,
                        stretchY: t1.stretchY,
                        content: t1.content,
                        hasRenderCallback: Boolean(t1.userImage && t1.userImage.render)
                    } : e.w(`Image "${o}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                o(null, r);
            }
            getPixelSize(e) {
                const { width: t1, height: i } = this.atlasImage[e];
                return {
                    width: t1,
                    height: i
                };
            }
            getPattern(t1, i, o) {
                const r = this.patterns[i][t1], s = this.getImage(t1, i);
                if (!s) return null;
                if (r && r.position.version === s.version) return r.position;
                if (r) r.position.version = s.version;
                else {
                    const o = {
                        w: s.data.width + 2 * e.y,
                        h: s.data.height + 2 * e.y,
                        x: 0,
                        y: 0
                    }, r = new e.I(o, s, e.y);
                    this.patterns[i][t1] = {
                        bin: o,
                        position: r
                    };
                }
                return this._updatePatternAtlas(i, o), this.patterns[i][t1].position;
            }
            bind(t1, i) {
                const o = t1.gl;
                let r = this.atlasTexture[i];
                r ? this.dirty && (r.update(this.atlasImage[i]), this.dirty = !1) : (r = new e.T(t1, this.atlasImage[i], o.RGBA8), this.atlasTexture[i] = r), r.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas(t1, i) {
                const o = [];
                for(const e in this.patterns[t1])o.push(this.patterns[t1][e].bin);
                const { w: r, h: s } = e.z(o), a = this.atlasImage[t1];
                a.resize({
                    width: r || 1,
                    height: s || 1
                });
                for(const o in this.patterns[t1]){
                    const { bin: r, position: s } = this.patterns[t1][o];
                    let n = s.padding;
                    const l = r.x + n, c = r.y + n, h = this.images[t1][o].data, u = h.width, d = h.height;
                    n = n > 1 ? n - 1 : n, e.r.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: l,
                        y: c
                    }, {
                        width: u,
                        height: d
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: d - n
                    }, {
                        x: l,
                        y: c - n
                    }, {
                        width: u,
                        height: n
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: l,
                        y: c + d
                    }, {
                        width: u,
                        height: n
                    }, i), e.r.copy(h, a, {
                        x: u - n,
                        y: 0
                    }, {
                        x: l - n,
                        y: c
                    }, {
                        width: n,
                        height: d
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: l + u,
                        y: c
                    }, {
                        width: n,
                        height: d
                    }, i), e.r.copy(h, a, {
                        x: u - n,
                        y: d - n
                    }, {
                        x: l - n,
                        y: c - n
                    }, {
                        width: n,
                        height: n
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: d - n
                    }, {
                        x: l + u,
                        y: c - n
                    }, {
                        width: n,
                        height: n
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: l + u,
                        y: c + d
                    }, {
                        width: n,
                        height: n
                    }, i), e.r.copy(h, a, {
                        x: u - n,
                        y: 0
                    }, {
                        x: l - n,
                        y: c + d
                    }, {
                        width: n,
                        height: n
                    }, i);
                }
                this.dirty = !0;
            }
            beginFrame() {
                for(const e in this.images)this.callbackDispatchedThisFrame[e] = {};
            }
            dispatchRenderCallbacks(e, t1) {
                for (const i of e){
                    if (this.callbackDispatchedThisFrame[t1][i]) continue;
                    this.callbackDispatchedThisFrame[t1][i] = !0;
                    const e = this.images[t1][i];
                    V(e) && this.updateImage(i, t1, e);
                }
            }
        }
        function Z(t1) {
            const i = t1.key, o = t1.value, r = t1.valueSpec || {}, s = t1.objectElementValidators || {}, a = t1.style, n = t1.styleSpec;
            let l = [];
            const c = e.B(o);
            if ("object" !== c) return [
                new e.V(i, o, `object expected, ${c} found`)
            ];
            for(const t1 in o){
                const c = t1.split(".")[0];
                let h;
                s[c] ? h = s[c] : r[c] ? h = _e : s["*"] ? h = s["*"] : r["*"] && (h = _e), h ? l = l.concat(h({
                    key: (i ? `${i}.` : i) + t1,
                    value: o[t1],
                    valueSpec: r[c] || r["*"],
                    style: a,
                    styleSpec: n,
                    object: o,
                    objectKey: t1
                }, o)) : l.push(new e.A(i, o[t1], `unknown property "${t1}"`));
            }
            for(const t1 in r)s[t1] || r[t1].required && void 0 === r[t1].default && void 0 === o[t1] && l.push(new e.V(i, o, `missing required property "${t1}"`));
            return l;
        }
        function H(t1) {
            const i = t1.value, o = t1.valueSpec, r = t1.style, s = t1.styleSpec, a = t1.key, n = t1.arrayElementValidator || _e;
            if ("array" !== e.B(i)) return [
                new e.V(a, i, `array expected, ${e.B(i)} found`)
            ];
            if (o.length && i.length !== o.length) return [
                new e.V(a, i, `array length ${o.length} expected, length ${i.length} found`)
            ];
            if (o["min-length"] && i.length < o["min-length"]) return [
                new e.V(a, i, `array length at least ${o["min-length"]} expected, length ${i.length} found`)
            ];
            let l = {
                type: o.value,
                values: o.values,
                minimum: o.minimum,
                maximum: o.maximum,
                function: void 0
            };
            s.$version < 7 && (l.function = o.function), "object" === e.B(o.value) && (l = o.value);
            let c = [];
            for(let e = 0; e < i.length; e++)c = c.concat(n({
                array: i,
                arrayIndex: e,
                value: i[e],
                valueSpec: l,
                style: r,
                styleSpec: s,
                key: `${a}[${e}]`
            }, !0));
            return c;
        }
        function W(t1) {
            const i = t1.key, o = t1.value, r = t1.valueSpec;
            let s = e.B(o);
            if ("number" === s && o != o && (s = "NaN"), "number" !== s) return [
                new e.V(i, o, `number expected, ${s} found`)
            ];
            if ("minimum" in r) {
                let s = r.minimum;
                if ("array" === e.B(r.minimum) && (s = r.minimum[t1.arrayIndex]), o < s) return [
                    new e.V(i, o, `${o} is less than the minimum value ${s}`)
                ];
            }
            if ("maximum" in r) {
                let s = r.maximum;
                if ("array" === e.B(r.maximum) && (s = r.maximum[t1.arrayIndex]), o > s) return [
                    new e.V(i, o, `${o} is greater than the maximum value ${s}`)
                ];
            }
            return [];
        }
        function $(t1) {
            const i = t1.valueSpec, o = e.D(t1.value.type);
            let r, s, a, n = {};
            const l = "categorical" !== o && void 0 === t1.value.property, c = !l, h = "array" === e.B(t1.value.stops) && "array" === e.B(t1.value.stops[0]) && "object" === e.B(t1.value.stops[0][0]), u = Z({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(t1) {
                        if ("identity" === o) return [
                            new e.V(t1.key, t1.value, 'identity function may not have a "stops" property')
                        ];
                        let i = [];
                        const r = t1.value;
                        return i = i.concat(H({
                            key: t1.key,
                            value: r,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: d
                        })), "array" === e.B(r) && 0 === r.length && i.push(new e.V(t1.key, r, "array must have at least one stop")), i;
                    },
                    default: function(e) {
                        return _e({
                            key: e.key,
                            value: e.value,
                            valueSpec: i,
                            style: e.style,
                            styleSpec: e.styleSpec
                        });
                    }
                }
            });
            return "identity" === o && l && u.push(new e.V(t1.key, t1.value, 'missing required property "property"')), "identity" === o || t1.value.stops || u.push(new e.V(t1.key, t1.value, 'missing required property "stops"')), "exponential" === o && t1.valueSpec.expression && !e.F(t1.valueSpec) && u.push(new e.V(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (c && !e.G(t1.valueSpec) ? u.push(new e.V(t1.key, t1.value, "property functions not supported")) : l && !e.H(t1.valueSpec) && u.push(new e.V(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== o && !h || void 0 !== t1.value.property || u.push(new e.V(t1.key, t1.value, '"property" property is required')), u;
            function d(t1) {
                let o = [];
                const r = t1.value, l = t1.key;
                if ("array" !== e.B(r)) return [
                    new e.V(l, r, `array expected, ${e.B(r)} found`)
                ];
                if (2 !== r.length) return [
                    new e.V(l, r, `array length 2 expected, length ${r.length} found`)
                ];
                if (h) {
                    if ("object" !== e.B(r[0])) return [
                        new e.V(l, r, `object expected, ${e.B(r[0])} found`)
                    ];
                    if (void 0 === r[0].zoom) return [
                        new e.V(l, r, "object stop key must have zoom")
                    ];
                    if (void 0 === r[0].value) return [
                        new e.V(l, r, "object stop key must have value")
                    ];
                    const i = e.D(r[0].zoom);
                    if ("number" != typeof i) return [
                        new e.V(l, r[0].zoom, "stop zoom values must be numbers")
                    ];
                    if (a && a > i) return [
                        new e.V(l, r[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    i !== a && (a = i, s = void 0, n = {}), o = o.concat(Z({
                        key: `${l}[0]`,
                        value: r[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: W,
                            value: _
                        }
                    }));
                } else o = o.concat(_({
                    key: `${l}[0]`,
                    value: r[0],
                    valueSpec: {},
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, r));
                return e.J(e.K(r[1])) ? o.concat([
                    new e.V(`${l}[1]`, r[1], "expressions are not allowed in function stops.")
                ]) : o.concat(_e({
                    key: `${l}[1]`,
                    value: r[1],
                    valueSpec: i,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function _(t1, a) {
                const l = e.B(t1.value), c = e.D(t1.value), h = null !== t1.value ? t1.value : a;
                if (r) {
                    if (l !== r) return [
                        new e.V(t1.key, h, `${l} stop domain type must match previous stop domain type ${r}`)
                    ];
                } else r = l;
                if ("number" !== l && "string" !== l && "boolean" !== l && "number" != typeof c && "string" != typeof c && "boolean" != typeof c) return [
                    new e.V(t1.key, h, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== l && "categorical" !== o) {
                    let r = `number expected, ${l} found`;
                    return e.G(i) && void 0 === o && (r += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new e.V(t1.key, h, r)
                    ];
                }
                return "categorical" !== o || "number" !== l || "number" == typeof c && isFinite(c) && Math.floor(c) === c ? "categorical" !== o && "number" === l && "number" == typeof c && "number" == typeof s && void 0 !== s && c < s ? [
                    new e.V(t1.key, h, "stop domain values must appear in ascending order")
                ] : (s = c, "categorical" === o && c in n ? [
                    new e.V(t1.key, h, "stop domain values must be unique")
                ] : (n[c] = !0, [])) : [
                    new e.V(t1.key, h, `integer expected, found ${String(c)}`)
                ];
            }
        }
        function X(t1) {
            const i = ("property" === t1.expressionContext ? e.L : e.M)(e.K(t1.value), t1.valueSpec);
            if ("error" === i.result) return i.value.map((i)=>new e.V(`${t1.key}${i.key}`, t1.value, i.message));
            const o = i.value.expression || i.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !o.outputDefined()) return [
                new e.V(t1.key, t1.value, `Invalid data expression for "${t1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !e.N(o)) return [
                new e.V(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext) return Y(o, t1);
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!e.O(o, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new e.V(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !e.Q(o)) return [
                    new e.V(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function Y(t1, i) {
            const o = new Set([
                "zoom",
                "feature-state",
                "pitch",
                "distance-from-center"
            ]);
            if (i.valueSpec && i.valueSpec.expression) for (const e of i.valueSpec.expression.parameters)o.delete(e);
            if (0 === o.size) return [];
            const r = [];
            return t1 instanceof e.S && o.has(t1.name) ? [
                new e.V(i.key, i.value, `["${t1.name}"] expression is not supported in a filter for a ${i.object.type} layer with id: ${i.object.id}`)
            ] : (t1.eachChild((e)=>{
                r.push(...Y(e, i));
            }), r);
        }
        function K(t1) {
            const i = t1.key, o = t1.value, r = t1.valueSpec, s = [];
            return Array.isArray(r.values) ? -1 === r.values.indexOf(e.D(o)) && s.push(new e.V(i, o, `expected one of [${r.values.join(", ")}], ${JSON.stringify(o)} found`)) : -1 === Object.keys(r.values).indexOf(e.D(o)) && s.push(new e.V(i, o, `expected one of [${Object.keys(r.values).join(", ")}], ${JSON.stringify(o)} found`)), s;
        }
        function J(t1) {
            return e.W(e.K(t1.value)) ? X(e.C({}, t1, {
                expressionContext: "filter",
                valueSpec: t1.styleSpec[`filter_${t1.layerType || "fill"}`]
            })) : Q(t1);
        }
        function Q(t1) {
            const i = t1.value, o = t1.key;
            if ("array" !== e.B(i)) return [
                new e.V(o, i, `array expected, ${e.B(i)} found`)
            ];
            const r = t1.styleSpec;
            let s, a = [];
            if (i.length < 1) return [
                new e.V(o, i, "filter array must have at least 1 element")
            ];
            switch(a = a.concat(K({
                key: `${o}[0]`,
                value: i[0],
                valueSpec: r.filter_operator,
                style: t1.style,
                styleSpec: t1.styleSpec
            })), e.D(i[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    i.length >= 2 && "$type" === e.D(i[1]) && a.push(new e.V(o, i, `"$type" cannot be use with operator "${i[0]}"`));
                case "==":
                case "!=":
                    3 !== i.length && a.push(new e.V(o, i, `filter array for operator "${i[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    i.length >= 2 && (s = e.B(i[1]), "string" !== s && a.push(new e.V(`${o}[1]`, i[1], `string expected, ${s} found`)));
                    for(let n = 2; n < i.length; n++)s = e.B(i[n]), "$type" === e.D(i[1]) ? a = a.concat(K({
                        key: `${o}[${n}]`,
                        value: i[n],
                        valueSpec: r.geometry_type,
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    })) : "string" !== s && "number" !== s && "boolean" !== s && a.push(new e.V(`${o}[${n}]`, i[n], `string, number, or boolean expected, ${s} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let e = 1; e < i.length; e++)a = a.concat(Q({
                        key: `${o}[${e}]`,
                        value: i[e],
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    s = e.B(i[1]), 2 !== i.length ? a.push(new e.V(o, i, `filter array for "${i[0]}" operator must have 2 elements`)) : "string" !== s && a.push(new e.V(`${o}[1]`, i[1], `string expected, ${s} found`));
            }
            return a;
        }
        function ee(t1, i) {
            const o = t1.key, r = t1.style, s = t1.layer, a = t1.styleSpec, n = t1.value, l = t1.objectKey, c = a[`${i}_${t1.layerType}`];
            if (!c) return [];
            const h = l.match(/^(.*)-transition$/);
            if ("paint" === i && h && c[h[1]] && c[h[1]].transition) return _e({
                key: o,
                value: n,
                valueSpec: a.transition,
                style: r,
                styleSpec: a
            });
            const u = t1.valueSpec || c[l];
            if (!u) return [
                new e.A(o, n, `unknown property "${l}"`)
            ];
            let d;
            if ("string" === e.B(n) && e.G(u) && !u.tokens && (d = /^{([^}]+)}$/.exec(n))) {
                const t1 = `\`{ "type": "identity", "property": ${d ? JSON.stringify(d[1]) : '"_"'} }\``;
                return [
                    new e.V(o, n, `"${l}" does not support interpolation syntax\nUse an identity property function instead: ${t1}.`)
                ];
            }
            const _ = [];
            if ("symbol" === t1.layerType) "text-field" !== l || !r || r.glyphs || r.imports || _.push(new e.V(o, n, 'use of "text-field" requires a style "glyphs" property')), "text-font" === l && e.X(e.K(n)) && "identity" === e.D(n.type) && _.push(new e.V(o, n, '"text-font" does not support identity functions'));
            else if ("model" === t1.layerType && "paint" === i && s && s.layout && s.layout.hasOwnProperty("model-id") && e.G(u) && (e.Y(u) || e.H(u))) {
                const t1 = e.L(e.K(n), u), i = t1.value.expression || t1.value._styleExpression.expression;
                i && !e.O(i, [
                    "measure-light"
                ]) && ("model-emissive-strength" === l && e.Q(i) && e.N(i) || _.push(new e.V(o, n, `${l} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
            }
            return _.concat(_e({
                key: t1.key,
                value: n,
                valueSpec: u,
                style: r,
                styleSpec: a,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            }));
        }
        function te(e) {
            return ee(e, "paint");
        }
        function ie(e) {
            return ee(e, "layout");
        }
        function oe(t1) {
            let i = [];
            const o = t1.value, r = t1.key, s = t1.style, a = t1.styleSpec;
            o.type || o.ref || i.push(new e.V(r, o, 'either "type" or "ref" is required'));
            let n = e.D(o.type);
            const l = e.D(o.ref);
            if (o.id) {
                const a = e.D(o.id);
                for(let n = 0; n < t1.arrayIndex; n++){
                    const t1 = s.layers[n];
                    e.D(t1.id) === a && i.push(new e.V(r, o.id, `duplicate layer id "${o.id}", previously used at line ${t1.id.__line__}`));
                }
            }
            if ("ref" in o) {
                let t1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t1)=>{
                    t1 in o && i.push(new e.V(r, o[t1], `"${t1}" is prohibited for ref layers`));
                }), s.layers.forEach((i)=>{
                    e.D(i.id) === l && (t1 = i);
                }), t1 ? t1.ref ? i.push(new e.V(r, o.ref, "ref cannot reference another ref layer")) : n = e.D(t1.type) : "string" == typeof l && i.push(new e.V(r, o.ref, `ref layer "${l}" not found`));
            } else if ("background" !== n && "sky" !== n && "slot" !== n) {
                if (o.source) {
                    const t1 = s.sources && s.sources[o.source], a = t1 && e.D(t1.type);
                    t1 ? "vector" === a && "raster" === n ? i.push(new e.V(r, o.source, `layer "${o.id}" requires a raster source`)) : "raster" === a && "raster" !== n ? i.push(new e.V(r, o.source, `layer "${o.id}" requires a vector source`)) : "vector" !== a || o["source-layer"] ? "raster-dem" === a && "hillshade" !== n ? i.push(new e.V(r, o.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "raster-array" !== a || [
                        "raster",
                        "raster-particle"
                    ].includes(n) ? "line" !== n || !o.paint || !o.paint["line-gradient"] && !o.paint["line-trim-offset"] || "geojson" === a && t1.lineMetrics ? "raster-particle" === n && "raster-array" !== a && i.push(new e.V(r, o.source, `layer "${o.id}" requires a 'raster-array' source.`)) : i.push(new e.V(r, o, `layer "${o.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : i.push(new e.V(r, o.source, "raster-array source can only be used with layer type 'raster'.")) : i.push(new e.V(r, o, `layer "${o.id}" must specify a "source-layer"`)) : i.push(new e.V(r, o.source, `source "${o.source}" not found`));
                } else i.push(new e.V(r, o, 'missing required property "source"'));
            }
            return i = i.concat(Z({
                key: r,
                value: o,
                valueSpec: a.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>_e({
                            key: `${r}.type`,
                            value: o.type,
                            valueSpec: a.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            object: o,
                            objectKey: "type"
                        }),
                    filter: (t1)=>J(e.C({
                            layerType: n
                        }, t1)),
                    layout: (t1)=>Z({
                            layer: o,
                            key: t1.key,
                            value: t1.value,
                            valueSpec: {},
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": (t1)=>ie(e.C({
                                        layerType: n
                                    }, t1))
                            }
                        }),
                    paint: (t1)=>Z({
                            layer: o,
                            key: t1.key,
                            value: t1.value,
                            valueSpec: {},
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": (t1)=>te(e.C({
                                        layerType: n,
                                        layer: o
                                    }, t1))
                            }
                        })
                }
            })), i;
        }
        function re(t1) {
            const i = t1.value, o = t1.key, r = e.B(i);
            return "string" !== r ? [
                new e.V(o, i, `string expected, ${r} found`)
            ] : [];
        }
        const se = {
            promoteId: function({ key: t1, value: i }) {
                if ("string" === e.B(i)) return re({
                    key: t1,
                    value: i
                });
                {
                    const e = [];
                    for(const o in i)e.push(...re({
                        key: `${t1}.${o}`,
                        value: i[o]
                    }));
                    return e;
                }
            }
        };
        function ae(t1) {
            const i = t1.value, o = t1.key, r = t1.styleSpec, s = t1.style;
            if (!i.type) return [
                new e.V(o, i, '"type" is required')
            ];
            const a = e.D(i.type);
            let n = [];
            switch([
                "vector",
                "raster",
                "raster-dem",
                "raster-array"
            ].includes(a) && (i.url || i.tiles || n.push(new e.A(o, i, 'Either "url" or "tiles" is required.'))), a){
                case "vector":
                case "raster":
                case "raster-dem":
                case "raster-array":
                    return n = n.concat(Z({
                        key: o,
                        value: i,
                        valueSpec: r[`source_${a.replace("-", "_")}`],
                        style: t1.style,
                        styleSpec: r,
                        objectElementValidators: se
                    })), n;
                case "geojson":
                    if (n = Z({
                        key: o,
                        value: i,
                        valueSpec: r.source_geojson,
                        style: s,
                        styleSpec: r,
                        objectElementValidators: se
                    }), i.cluster) for(const e in i.clusterProperties){
                        const [t1, r] = i.clusterProperties[e], s = "string" == typeof t1 ? [
                            t1,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                e
                            ]
                        ] : t1;
                        n.push(...X({
                            key: `${o}.${e}.map`,
                            value: r,
                            expressionContext: "cluster-map"
                        })), n.push(...X({
                            key: `${o}.${e}.reduce`,
                            value: s,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return n;
                case "video":
                    return Z({
                        key: o,
                        value: i,
                        valueSpec: r.source_video,
                        style: s,
                        styleSpec: r
                    });
                case "image":
                    return Z({
                        key: o,
                        value: i,
                        valueSpec: r.source_image,
                        style: s,
                        styleSpec: r
                    });
                case "canvas":
                    return [
                        new e.V(o, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return K({
                        key: `${o}.type`,
                        value: i.type,
                        valueSpec: {
                            values: ne(r)
                        },
                        style: s,
                        styleSpec: r
                    });
            }
        }
        function ne(e) {
            return e.source.reduce((t1, i)=>{
                const o = e[i];
                return "enum" === o.type.type && (t1 = t1.concat(Object.keys(o.type.values))), t1;
            }, []);
        }
        function le(t1) {
            const i = t1.value, o = t1.styleSpec, r = o.light, s = t1.style;
            let a = [];
            const n = e.B(i);
            if (void 0 === i) return a;
            if ("object" !== n) return a = a.concat([
                new e.V("light", i, `object expected, ${n} found`)
            ]), a;
            for(const t1 in i){
                const n = t1.match(/^(.*)-transition$/);
                a = a.concat(n && r[n[1]] && r[n[1]].transition ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: o.transition,
                    style: s,
                    styleSpec: o
                }) : r[t1] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: r[t1],
                    style: s,
                    styleSpec: o
                }) : [
                    new e.V(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return a;
        }
        function ce(t1) {
            const i = t1.value;
            let o = [];
            if (!i) return o;
            const r = e.B(i);
            if ("object" !== r) return o = o.concat([
                new e.V("light-3d", i, `object expected, ${r} found`)
            ]), o;
            const s = t1.styleSpec, a = s["light-3d"], n = t1.key, l = t1.style, c = t1.style.lights;
            for (const t1 of [
                "type",
                "id"
            ])if (!(t1 in i)) return o = o.concat([
                new e.V("light-3d", i, `missing property ${t1} on light`)
            ]), o;
            if (i.type && c) for(let r = 0; r < t1.arrayIndex; r++){
                const t1 = e.D(i.type), s = c[r];
                e.D(s.type) === t1 && o.push(new e.V(n, i.id, `duplicate light type "${i.type}", previously defined at line ${s.id.__line__}`));
            }
            const h = `properties_light_${i.type}`;
            if (!(h in s)) return o = o.concat([
                new e.V("light-3d", i, `Invalid light type ${i.type}`)
            ]), o;
            const u = s[h];
            for(const r in i)if ("properties" === r) {
                const a = i[r], n = e.B(a);
                if ("object" !== n) return o = o.concat([
                    new e.V("properties", a, `object expected, ${n} found`)
                ]), o;
                for(const i in a)o = o.concat(u[i] ? _e({
                    key: i,
                    value: a[i],
                    valueSpec: u[i],
                    style: l,
                    styleSpec: s
                }) : [
                    new e.A(t1.key, a[i], `unknown property "${i}"`)
                ]);
            } else {
                const t1 = r.match(/^(.*)-transition$/);
                o = o.concat(t1 && a[t1[1]] && a[t1[1]].transition ? _e({
                    key: r,
                    value: i[r],
                    valueSpec: s.transition,
                    style: l,
                    styleSpec: s
                }) : a[r] ? _e({
                    key: r,
                    value: i[r],
                    valueSpec: a[r],
                    style: l,
                    styleSpec: s
                }) : [
                    new e.A(r, i[r], `unknown property "${r}"`)
                ]);
            }
            return o;
        }
        function he(t1) {
            const i = t1.value, o = t1.key, r = t1.style, s = t1.styleSpec, a = s.terrain;
            let n = [];
            const l = e.B(i);
            if (void 0 === i) return n;
            if ("null" === l) return n;
            if ("object" !== l) return n = n.concat([
                new e.V("terrain", i, `object expected, ${l} found`)
            ]), n;
            for(const t1 in i){
                const o = t1.match(/^(.*)-transition$/);
                n = n.concat(o && a[o[1]] && a[o[1]].transition ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: s.transition,
                    style: r,
                    styleSpec: s
                }) : a[t1] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: a[t1],
                    style: r,
                    styleSpec: s
                }) : [
                    new e.A(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            if (i.source) {
                const t1 = r.sources && r.sources[i.source], s = t1 && e.D(t1.type);
                t1 ? "raster-dem" !== s && n.push(new e.V(o, i.source, `terrain cannot be used with a source of type ${String(s)}, it only be used with a "raster-dem" source type`)) : n.push(new e.V(o, i.source, `source "${i.source}" not found`));
            } else n.push(new e.V(o, i, 'terrain is missing required property "source"'));
            return n;
        }
        function ue(t1) {
            const i = t1.value, o = t1.style, r = t1.styleSpec, s = r.fog;
            let a = [];
            const n = e.B(i);
            if (void 0 === i) return a;
            if ("object" !== n) return a = a.concat([
                new e.V("fog", i, `object expected, ${n} found`)
            ]), a;
            for(const t1 in i){
                const n = t1.match(/^(.*)-transition$/);
                a = a.concat(n && s[n[1]] && s[n[1]].transition ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: r.transition,
                    style: o,
                    styleSpec: r
                }) : s[t1] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: s[t1],
                    style: o,
                    styleSpec: r
                }) : [
                    new e.A(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return a;
        }
        const de = {
            "*": ()=>[],
            array: H,
            boolean: function(t1) {
                const i = t1.value, o = t1.key, r = e.B(i);
                return "boolean" !== r ? [
                    new e.V(o, i, `boolean expected, ${r} found`)
                ] : [];
            },
            number: W,
            color: function(t1) {
                const i = t1.key, o = t1.value, r = e.B(o);
                return "string" !== r ? [
                    new e.V(i, o, `color expected, ${r} found`)
                ] : null === e.U.parseCSSColor(o) ? [
                    new e.V(i, o, `color expected, "${o}" found`)
                ] : [];
            },
            enum: K,
            filter: J,
            function: $,
            layer: oe,
            object: Z,
            source: ae,
            model: e.Z,
            light: le,
            "light-3d": ce,
            terrain: he,
            fog: ue,
            string: re,
            formatted: function(e) {
                return 0 === re(e).length ? [] : X(e);
            },
            resolvedImage: function(e) {
                return 0 === re(e).length ? [] : X(e);
            },
            projection: function(t1) {
                const i = t1.value, o = t1.styleSpec, r = o.projection, s = t1.style;
                let a = [];
                const n = e.B(i);
                if ("object" === n) for(const e in i)a = a.concat(_e({
                    key: e,
                    value: i[e],
                    valueSpec: r[e],
                    style: s,
                    styleSpec: o
                }));
                else "string" !== n && (a = a.concat([
                    new e.V("projection", i, `object or string expected, ${n} found`)
                ]));
                return a;
            },
            import: function(t1) {
                const { value: i, styleSpec: o } = t1, { data: r, ...s } = i;
                Object.defineProperty(s, "__line__", {
                    value: i.__line__,
                    enumerable: !1
                });
                let a = Z(e.C({}, t1, {
                    value: s,
                    valueSpec: o.import
                }));
                return "" === e.D(s.id) && a.push(new e.V(`${t1.key}.id`, s, "import id can't be an empty string")), r && (a = a.concat(me(r, o, {
                    key: `${t1.key}.data`
                }))), a;
            }
        };
        function _e(t1, i = !1) {
            const o = t1.value, r = t1.valueSpec, s = t1.styleSpec;
            if (r.expression && e.X(e.D(o))) return $(t1);
            if (r.expression && e.J(e.K(o))) return X(t1);
            if (r.type && de[r.type]) {
                const o = de[r.type](t1);
                return !0 === i && o.length > 0 && "array" === e.B(t1.value) ? X(t1) : o;
            }
            return Z(e.C({}, t1, {
                valueSpec: r.type ? s[r.type] : r
            }));
        }
        function pe(t1) {
            const i = t1.value, o = t1.key, r = re(t1);
            return r.length || (-1 === i.indexOf("{fontstack}") && r.push(new e.V(o, i, '"glyphs" url must include a "{fontstack}" token')), -1 === i.indexOf("{range}") && r.push(new e.V(o, i, '"glyphs" url must include a "{range}" token'))), r;
        }
        function me(t1, i = e._, o = {}) {
            return _e({
                key: o.key || "",
                value: t1,
                valueSpec: i.$root,
                styleSpec: i,
                style: t1,
                objectElementValidators: {
                    glyphs: pe,
                    "*": ()=>[]
                }
            });
        }
        function fe(t1, i = e._) {
            return Ie(me(t1, i));
        }
        const ge = (e)=>Ie(ae(e)), ve = (e)=>Ie(le(e)), xe = (e)=>Ie(ce(e)), ye = (e)=>Ie(he(e)), be = (e)=>Ie(ue(e)), we = (e)=>Ie(oe(e)), Te = (e)=>Ie(J(e)), Ee = (e)=>Ie(te(e)), Ce = (e)=>Ie(ie(e)), Se = (t1)=>Ie(e.Z(t1));
        function Ie(e) {
            return e.slice().sort((e, t1)=>e.line && t1.line ? e.line - t1.line : 0);
        }
        function De(t1, i) {
            let o = !1;
            if (i && i.length) for (const r of i)r instanceof e.A ? e.w(r.message) : (t1.fire(new e.t(new Error(r.message))), o = !0);
            return o;
        }
        let Re;
        class Ae extends e.E {
            constructor(t1, i = "flat"){
                super(), this._transitionable = new e.$(Re || (Re = new e.a0({
                    anchor: new e.a1(e._.light.anchor),
                    position: new e.a2(e._.light.position),
                    color: new e.a1(e._.light.color),
                    intensity: new e.a1(e._.light.intensity)
                }))), this.setLight(t1, i), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e, t1, i = {}) {
                this._validate(ve, e, i) || (this._transitionable.setTransitionOrValue(e), this.id = t1);
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && De(this, t1.call(fe, e.l({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e._
                })));
            }
        }
        const Le = new e.a0({
            source: new e.a1(e._.terrain.source),
            exaggeration: new e.a1(e._.terrain.exaggeration)
        });
        let Pe = class extends e.E {
            constructor(t1, i, o, r){
                super(), this.scope = o, this._transitionable = new e.$(Le, o, r), this._transitionable.setTransitionOrValue(t1, r), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = i;
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e, t1) {
                this._transitionable.setTransitionOrValue(e, t1);
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            getExaggeration(t1) {
                return this._transitioning.possiblyEvaluate(new e.a3(t1)).get("exaggeration");
            }
            isZoomDependent() {
                const t1 = this._transitionable._values.exaggeration;
                return null != t1 && null != t1.value && null != t1.value.expression && t1.value.expression instanceof e.a4;
            }
        };
        const Me = 45, ze = 65, Oe = .05;
        function Fe(t1, i, o, r) {
            const s = e.a7(Me, ze, o), [a, n] = ke(t1, r);
            let l = 1 - Math.min(1, Math.exp((i - a) / (n - a) * -6));
            return l *= l * l, l = Math.min(1, 1.00747 * l), l * s * t1.alpha;
        }
        function ke(e, t1) {
            const i = .5 / Math.tan(.5 * t1);
            return [
                e.range[0] + i,
                e.range[1] + i
            ];
        }
        function Be(t1, i, o, r, s) {
            const a = e.a6.vec3.transformMat4([], [
                i,
                o,
                r
            ], s.mercatorFogMatrix);
            return Fe(t1, e.a6.vec3.length(a), s.pitch, s._fov);
        }
        function Ne(t1, i, o, r, s, a, n) {
            const l = [
                [
                    o,
                    r,
                    0
                ],
                [
                    s,
                    r,
                    0
                ],
                [
                    s,
                    a,
                    0
                ],
                [
                    o,
                    a,
                    0
                ]
            ];
            let c = Number.MAX_VALUE, h = -Number.MAX_VALUE;
            for (const t1 of l){
                const o = e.a6.vec3.transformMat4([], t1, i), r = e.a6.vec3.length(o);
                c = Math.min(c, r), h = Math.max(h, r);
            }
            return [
                Fe(t1, c, n.pitch, n._fov),
                Fe(t1, h, n.pitch, n._fov)
            ];
        }
        const Ue = new e.a0({
            range: new e.a1(e._.fog.range),
            color: new e.a1(e._.fog.color),
            "high-color": new e.a1(e._.fog["high-color"]),
            "space-color": new e.a1(e._.fog["space-color"]),
            "horizon-blend": new e.a1(e._.fog["horizon-blend"]),
            "star-intensity": new e.a1(e._.fog["star-intensity"]),
            "vertical-range": new e.a1(e._.fog["vertical-range"])
        });
        class Ge extends e.E {
            constructor(t1, i, o, r){
                super(), this._transitionable = new e.$(Ue, o, new Map(r)), this.set(t1, r), this._transitioning = this._transitionable.untransitioned(), this._transform = i, this.properties = new e.a8(Ue), this.scope = o;
            }
            get state() {
                const t1 = this._transform, i = "globe" === t1.projection.name, o = e.a9(t1.zoom), r = this.properties.get("range"), s = [
                    .5,
                    3
                ];
                return {
                    range: i ? [
                        e.aa(s[0], r[0], o),
                        e.aa(s[1], r[1], o)
                    ] : r,
                    horizonBlend: this.properties.get("horizon-blend"),
                    alpha: this.properties.get("color").a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, o = {}) {
                if (this._validate(be, t1, o)) return;
                const r = e.l({}, t1);
                for (const t1 of Object.keys(e._.fog))void 0 === r[t1] && (r[t1] = e._.fog[t1].default);
                this._options = r, this._transitionable.setTransitionOrValue(this._options, i);
            }
            getOpacity(t1) {
                if (!this._transform.projection.supportsFog) return 0;
                const i = this.properties && this.properties.get("color") || 1;
                return ("globe" === this._transform.projection.name ? 1 : e.a7(Me, ze, t1)) * i.a;
            }
            getOpacityAtLatLng(t1, i) {
                return this._transform.projection.supportsFog ? function(t1, i, o) {
                    const r = e.a5.fromLngLat(i), s = o.elevation ? o.elevation.getAtPointOrZero(r) : 0;
                    return Be(t1, r.x, r.y, s, o);
                }(this.state, t1, i) : 0;
            }
            getOpacityForTile(t1) {
                if (!this._transform.projection.supportsFog) return [
                    1,
                    1
                ];
                const i = this._transform.calculateFogTileMatrix(t1.toUnwrapped());
                return Ne(this.state, i, 0, 0, e.ab, e.ab, this._transform);
            }
            getOpacityForBounds(e, t1, i, o, r) {
                return this._transform.projection.supportsFog ? Ne(this.state, e, t1, i, o, r, this._transform) : [
                    1,
                    1
                ];
            }
            getFovAdjustedRange(e) {
                return this._transform.projection.supportsFog ? ke(this.state, e) : [
                    0,
                    1
                ];
            }
            isVisibleOnFrustum(t1) {
                if (!this._transform.projection.supportsFog) return !1;
                const i = [
                    4,
                    5,
                    6,
                    7
                ];
                for (const o of i){
                    const i = t1.points[o];
                    let r;
                    if (i[2] >= 0) r = i;
                    else {
                        const s = t1.points[o - 4];
                        r = e.ac(s, i, s[2] / (s[2] - i[2]));
                    }
                    if (Be(this.state, r[0], r[1], 0, this._transform) >= Oe) return !0;
                }
                return !1;
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && De(this, t1.call(fe, e.l({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e._
                })));
            }
        }
        class je extends e.E {
            constructor(t1, i, o, r){
                super(), this.scope = o, this._options = t1, this.properties = new e.a8(i), this._transitionable = new e.$(i, o, new Map(r)), this._transitionable.setTransitionOrValue(t1.properties), this._transitioning = this._transitionable.untransitioned();
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options.properties, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            get() {
                return this._options.properties = this._transitionable.serialize(), this._options;
            }
            set(e, t1) {
                this._options = e, this._transitionable.setTransitionOrValue(e.properties, t1);
            }
            shadowsEnabled() {
                return !!this.properties && !0 === this.properties.get("cast-shadows");
            }
        }
        let Ve, qe;
        class Ze {
            constructor(e, t1, i, o){
                this.screenBounds = e, this.cameraPoint = t1, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = i, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, o);
            }
            static createFromScreenPoints(t1, i) {
                let o, r;
                if (t1 instanceof e.P || "number" == typeof t1[0]) {
                    const s = e.P.convert(t1);
                    o = [
                        s
                    ], r = i.isPointAboveHorizon(s);
                } else {
                    const s = e.P.convert(t1[0]), a = e.P.convert(t1[1]);
                    o = [
                        s,
                        a
                    ], r = e.ae(s, a).every((e)=>i.isPointAboveHorizon(e));
                }
                return new Ze(o, i.getCameraPoint(), r, i);
            }
            isPointQuery() {
                return 1 === this.screenBounds.length;
            }
            bufferedScreenGeometry(t1) {
                return e.ae(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t1);
            }
            bufferedCameraGeometry(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1], r = e.ae(i, o, 0, !1);
                return this.cameraPoint.y > o.y && (this.cameraPoint.x > i.x && this.cameraPoint.x < o.x ? r.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= o.x ? r[2] = this.cameraPoint : this.cameraPoint.x <= i.x && (r[3] = this.cameraPoint)), e.af(r, t1);
            }
            bufferedCameraGeometryGlobe(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1], r = e.ae(i, o, t1), s = this.cameraPoint.clone();
                switch(3 * ((s.y > i.y) + (s.y > o.y)) + ((s.x > i.x) + (s.x > o.x))){
                    case 0:
                        r[0] = s, r[4] = s.clone();
                        break;
                    case 1:
                        r.splice(1, 0, s);
                        break;
                    case 2:
                        r[1] = s;
                        break;
                    case 3:
                        r.splice(4, 0, s);
                        break;
                    case 5:
                        r.splice(2, 0, s);
                        break;
                    case 6:
                        r[3] = s;
                        break;
                    case 7:
                        r.splice(3, 0, s);
                        break;
                    case 8:
                        r[2] = s;
                }
                return r;
            }
            containsTile(t1, i, o, r = 0) {
                const s = t1.queryPadding / i._pixelsPerMercatorPixel + 1, a = o ? this._bufferedCameraMercator(s, i) : this._bufferedScreenMercator(s, i);
                let n = t1.tileID.wrap + (a.unwrapped ? r : 0);
                const l = a.polygon.map((i)=>e.ag(t1.tileTransform, i, n));
                if (!e.ah(l, 0, 0, e.ab, e.ab)) return;
                n = t1.tileID.wrap + (this.screenGeometryMercator.unwrapped ? r : 0);
                const c = this.screenGeometryMercator.polygon.map((i)=>e.ai(t1.tileTransform, i, n)), h = c.map((t1)=>new e.P(t1[0], t1[1])), u = i.getFreeCameraOptions().position || new e.a5(0, 0, 0), d = e.ai(t1.tileTransform, u, n), _ = c.map((t1)=>{
                    const i = e.a6.vec3.sub(t1, t1, d);
                    return e.a6.vec3.normalize(i, i), new e.aj(d, i);
                }), p = e.ak(t1, 1, i.zoom) * i._pixelsPerMercatorPixel;
                var m;
                return {
                    queryGeometry: this,
                    tilespaceGeometry: h,
                    tilespaceRays: _,
                    bufferedTilespaceGeometry: l,
                    bufferedTilespaceBounds: (m = e.al(l), m.min.x = e.ap(m.min.x, 0, e.ab), m.min.y = e.ap(m.min.y, 0, e.ab), m.max.x = e.ap(m.max.x, 0, e.ab), m.max.y = e.ap(m.max.y, 0, e.ab), m),
                    tile: t1,
                    tileID: t1.tileID,
                    pixelToTileUnitsFactor: p
                };
            }
            _bufferedScreenMercator(e, t1) {
                const i = $e(e);
                if (this._screenRaycastCache[i]) return this._screenRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e), t1) : {
                        polygon: this.bufferedScreenGeometry(e).map((e)=>t1.pointCoordinate3D(e)),
                        unwrapped: !0
                    }, this._screenRaycastCache[i] = o, o;
                }
            }
            _bufferedCameraMercator(e, t1) {
                const i = $e(e);
                if (this._cameraRaycastCache[i]) return this._cameraRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e), t1) : {
                        polygon: this.bufferedCameraGeometry(e).map((e)=>t1.pointCoordinate3D(e)),
                        unwrapped: !0
                    }, this._cameraRaycastCache[i] = o, o;
                }
            }
            _projectAndResample(t1, i) {
                const o = function(t1, i) {
                    const o = e.a6.mat4.multiply([], i.pixelMatrix, i.globeMatrix), r = [
                        0,
                        -e.aq,
                        0,
                        1
                    ], s = [
                        0,
                        e.aq,
                        0,
                        1
                    ], a = [
                        0,
                        0,
                        0,
                        1
                    ];
                    e.a6.vec4.transformMat4(r, r, o), e.a6.vec4.transformMat4(s, s, o), e.a6.vec4.transformMat4(a, a, o);
                    const n = new e.P(r[0] / r[3], r[1] / r[3]), l = new e.P(s[0] / s[3], s[1] / s[3]), c = e.an(t1, n) && r[3] < a[3], h = e.an(t1, l) && s[3] < a[3];
                    if (!c && !h) return null;
                    const u = function(e, t1, i) {
                        for(let o = 1; o < e.length; o++){
                            const r = We(t1.pointCoordinate3D(e[o - 1]).x), s = We(t1.pointCoordinate3D(e[o]).x);
                            if (i < 0) {
                                if (r < s) return {
                                    idx: o,
                                    t: -r / (s - 1 - r)
                                };
                            } else if (s < r) return {
                                idx: o,
                                t: (1 - r) / (s + 1 - r)
                            };
                        }
                        return null;
                    }(t1, i, c ? -1 : 1);
                    if (!u) return null;
                    const { idx: d, t: _ } = u;
                    let p = d > 1 ? He(t1.slice(0, d), i) : [], m = d < t1.length ? He(t1.slice(d), i) : [];
                    p = p.map((t1)=>new e.P(We(t1.x), t1.y)), m = m.map((t1)=>new e.P(We(t1.x), t1.y));
                    const f = [
                        ...p
                    ];
                    0 === f.length && f.push(m[m.length - 1]);
                    const g = e.aa(f[f.length - 1].y, (0 === m.length ? p[0] : m[0]).y, _);
                    let v;
                    return v = c ? [
                        new e.P(0, g),
                        new e.P(0, 0),
                        new e.P(1, 0),
                        new e.P(1, g)
                    ] : [
                        new e.P(1, g),
                        new e.P(1, 1),
                        new e.P(0, 1),
                        new e.P(0, g)
                    ], f.push(...v), 0 === m.length ? f.push(p[0]) : f.push(...m), {
                        polygon: f.map((t1)=>new e.a5(t1.x, t1.y)),
                        unwrapped: !1
                    };
                }(t1, i);
                if (o) return o;
                const r = function(t1, i) {
                    let o = !1, r = -1 / 0, s = 0;
                    for(let e = 0; e < t1.length - 1; e++)t1[e].x > r && (r = t1[e].x, s = e);
                    for(let e = 0; e < t1.length - 1; e++){
                        const i = (s + e) % (t1.length - 1), r = t1[i], a = t1[i + 1];
                        Math.abs(r.x - a.x) > .5 && (r.x < a.x ? (r.x += 1, 0 === i && (t1[t1.length - 1].x += 1)) : (a.x += 1, i + 1 === t1.length - 1 && (t1[0].x += 1)), o = !0);
                    }
                    const a = e.am(i.center.lng);
                    return o && a < Math.abs(a - 1) && t1.forEach((e)=>{
                        e.x -= 1;
                    }), {
                        polygon: t1,
                        unwrapped: o
                    };
                }(He(t1, i).map((t1)=>new e.P(We(t1.x), t1.y)), i);
                return {
                    polygon: r.polygon.map((t1)=>new e.a5(t1.x, t1.y)),
                    unwrapped: r.unwrapped
                };
            }
        }
        function He(t1, i) {
            return e.ao(t1, (e)=>{
                const t1 = i.pointCoordinate3D(e);
                e.x = t1.x, e.y = t1.y;
            }, 1 / 256);
        }
        function We(e) {
            return e < 0 ? 1 + e % 1 : e % 1;
        }
        function $e(e) {
            return 100 * e | 0;
        }
        function Xe(t1, i, o, r, s) {
            const a = function(o, r) {
                if (o) return s(o);
                if (r) {
                    if (t1.url && r.tiles && t1.tiles && delete t1.tiles, r.variants) {
                        if (!Array.isArray(r.variants)) return s(new Error("variants must be an array"));
                        for (const t1 of r.variants){
                            if (null == t1 || "object" != typeof t1 || t1.constructor !== Object) return s(new Error("variant must be an object"));
                            if (!Array.isArray(t1.capabilities)) return s(new Error("capabilities must be an array"));
                            if (1 === t1.capabilities.length && "meshopt" === t1.capabilities[0]) {
                                r = e.l(r, t1);
                                break;
                            }
                        }
                    }
                    const o = e.ar(e.l(r, t1), [
                        "tilejson",
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "mapbox_logo",
                        "bounds",
                        "scheme",
                        "tileSize",
                        "encoding"
                    ]);
                    r.vector_layers && (o.vectorLayers = r.vector_layers, o.vectorLayerIds = o.vectorLayers.map((e)=>e.id)), r.raster_layers && (o.rasterLayers = r.raster_layers, o.rasterLayerIds = o.rasterLayers.map((e)=>e.id)), o.tiles = i.canonicalizeTileset(o, t1.url), s(null, o);
                }
            }, n = function(e, t1, i) {
                if (!e) return null;
                if (!t1 && !i) return e;
                i = i || e.worldview_default;
                const o = Object.values(e.language || {});
                if (0 === o.length) return null;
                const r = Object.values(e.worldview || {});
                if (0 === r.length) return null;
                const s = o.every((e)=>e === t1), a = r.every((e)=>e === i);
                return s && a ? e : t1 in (e.language_options || {}) || i in (e.worldview_options || {}) ? null : e.language_options && e.worldview_options ? e : null;
            }(t1.data, o, r);
            return n ? e.q.frame(()=>a(null, n)) : t1.url ? e.n(i.transformRequest(i.normalizeSourceURL(t1.url, null, o, r), e.R.Source), a) : e.q.frame(()=>{
                const { data: e, ...i } = t1;
                a(null, i);
            });
        }
        class Ye {
            constructor(t1, i, o){
                this.bounds = e.as.convert(this.validateBounds(t1)), this.minzoom = i || 0, this.maxzoom = o || 24;
            }
            validateBounds(e) {
                return Array.isArray(e) && 4 === e.length ? [
                    Math.max(-180, e[0]),
                    Math.max(-90, e[1]),
                    Math.min(180, e[2]),
                    Math.min(90, e[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(t1) {
                const i = Math.pow(2, t1.z), o = Math.floor(e.am(this.bounds.getWest()) * i), r = Math.floor(e.at(this.bounds.getNorth()) * i), s = Math.ceil(e.am(this.bounds.getEast()) * i), a = Math.ceil(e.at(this.bounds.getSouth()) * i);
                return t1.x >= o && t1.x < s && t1.y >= r && t1.y < a;
            }
        }
        class Ke extends e.E {
            constructor(t1, i, o, r){
                if (super(), this.id = t1, this.dispatcher = o, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, e.l(this, e.ar(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = e.l({
                    type: "vector"
                }, i), this._collectResourceTiming = !!i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(r), this._tileWorkers = {}, this._deduped = new e.au;
            }
            load(t1) {
                this._loaded = !1, this.fire(new e.x("dataloading", {
                    dataType: "source"
                }));
                const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o = this.map._worldview;
                this._tileJSONRequest = Xe(this._options, this.map._requestManager, i, o, (r, s)=>{
                    this._tileJSONRequest = null, this._loaded = !0, r ? (i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), o && 2 !== o.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`), this.fire(new e.t(r))) : s && (e.l(this, s), s.bounds && (this.tileBounds = new Ye(s.bounds, this.minzoom, this.maxzoom)), L(s.tiles, this.map._requestManager._customAccessToken), this.fire(new e.x("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e.x("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), t1 && t1(r);
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(e) {
                return !this.tileBounds || this.tileBounds.contains(e.canonical);
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e.av(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e) {
                return this._options.tiles = e, this.reload(), this;
            }
            setUrl(e) {
                return this.url = e, this._options.url = e, this.reload(), this;
            }
            onRemove(e) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return e.l({}, this._options);
            }
            loadTile(t1, i) {
                const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme)), r = this.map._requestManager.transformRequest(o, e.R.Tile), s = this.map.style ? this.map.style.getLut(this.scope) : null, a = {
                    request: r,
                    data: void 0,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    tileZoom: t1.tileZoom,
                    zoom: t1.tileID.overscaledZ,
                    lut: s ? {
                        image: s.image.clone()
                    } : null,
                    tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    pixelRatio: e.q.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId,
                    isSymbolTile: t1.isSymbolTile,
                    brightness: this.map.style && this.map.style.getBrightness() || 0,
                    extraShadowCaster: t1.isExtraShadowCaster,
                    tessellationStep: this.map._tessellationStep
                };
                if (a.request.collectResourceTiming = this._collectResourceTiming, t1.actor && "expired" !== t1.state) "loading" === t1.state ? t1.reloadCallback = i : t1.request = t1.actor.send("reloadTile", a, n.bind(this));
                else if (t1.actor = this._tileWorkers[o] = this._tileWorkers[o] || this.dispatcher.getActor(), this.dispatcher.ready) t1.request = t1.actor.send("loadTile", a, n.bind(this), void 0, !0);
                else {
                    const i = e.aw.call({
                        deduped: this._deduped
                    }, a, (e, i)=>{
                        e || !i ? n.call(this, e) : (a.data = {
                            cacheControl: i.cacheControl,
                            expires: i.expires,
                            rawData: i.rawData.slice(0)
                        }, t1.actor && t1.actor.send("loadTile", a, n.bind(this), void 0, !0));
                    }, !0);
                    t1.request = {
                        cancel: i
                    };
                }
                function n(o, r) {
                    return delete t1.request, t1.aborted ? i(null) : o && 404 !== o.status ? i(o) : (r && r.resourceTiming && (t1.resourceTiming = r.resourceTiming), this.map._refreshExpiredTiles && r && t1.setExpiryData(r), t1.loadVectorData(r, this.map.painter), e.ax(this.dispatcher), i(null), void (t1.reloadCallback && (this.loadTile(t1, t1.reloadCallback), t1.reloadCallback = null)));
                }
            }
            abortTile(e) {
                e.request && (e.request.cancel(), delete e.request), e.actor && e.actor.send("abortTile", {
                    uid: e.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                });
            }
            unloadTile(e, t1) {
                e.actor && e.actor.send("removeTile", {
                    uid: e.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                }), e.destroy();
            }
            hasTransition() {
                return !1;
            }
            afterUpdate() {
                this._tileWorkers = {};
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        class Je extends e.E {
            constructor(t1, i, o, r){
                super(), this.id = t1, this.dispatcher = o, this.setEventedParent(r), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = e.l({
                    type: "raster"
                }, i), e.l(this, e.ar(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load(t1) {
                this._loaded = !1, this.fire(new e.x("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = Xe(this._options, this.map._requestManager, null, null, (i, o)=>{
                    this._tileJSONRequest = null, this._loaded = !0, i ? this.fire(new e.t(i)) : o && (e.l(this, o), o.bounds && (this.tileBounds = new Ye(o.bounds, this.minzoom, this.maxzoom)), L(o.tiles), this.fire(new e.x("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e.x("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), t1 && t1(i);
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e.av(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e) {
                return this._options.tiles = e, this.reload(), this;
            }
            setUrl(e) {
                return this.url = e, this._options.url = e, this.reload(), this;
            }
            onRemove(e) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return e.l({}, this._options);
            }
            hasTile(e) {
                return !this.tileBounds || this.tileBounds.contains(e.canonical);
            }
            loadTile(t1, i) {
                const o = e.q.devicePixelRatio >= 2, r = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), o, this.tileSize);
                t1.request = e.o(this.map._requestManager.transformRequest(r, e.R.Tile), (o, r, s, a)=>(delete t1.request, t1.aborted ? (t1.state = "unloaded", i(null)) : o ? (t1.state = "errored", i(o)) : r ? (this.map._refreshExpiredTiles && t1.setExpiryData({
                        cacheControl: s,
                        expires: a
                    }), t1.setTexture(r, this.map.painter), t1.state = "loaded", e.ax(this.dispatcher), void i(null)) : i(null)));
            }
            abortTile(e, t1) {
                e.request && (e.request.cancel(), delete e.request), t1 && t1();
            }
            unloadTile(t1, i) {
                t1.texture && t1.texture instanceof e.T ? (t1.destroy(!0), t1.texture && t1.texture instanceof e.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), i && i();
            }
            hasTransition() {
                return !1;
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        class Qe extends Je {
            constructor(t1, i, o, r){
                super(t1, i, o, r), this.type = "raster-array", this.maxzoom = 22, this._options = e.l({
                    type: "raster-array"
                }, i);
            }
            triggerRepaint(e) {
                const t1 = this.map.painter._terrain, i = this.map.style.getSourceCache(this.id);
                t1 && t1.enabled && i && t1._clearRenderCacheForTile(i.id, e.tileID), this.map.triggerRepaint();
            }
            loadTile(t1, i) {
                const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize), r = this.map._requestManager.transformRequest(o, e.R.Tile);
                t1.requestParams = r, t1.actor || (t1.actor = this.dispatcher.getActor()), t1.request = t1.fetchHeader(void 0, (e, o, r, s)=>{
                    if (delete t1.request, t1.aborted) return t1.state = "unloaded", i(null);
                    if (e) {
                        if (20 === e.code) return;
                        return t1.state = "errored", i(e);
                    }
                    this.map._refreshExpiredTiles && t1.setExpiryData({
                        cacheControl: r,
                        expires: s
                    }), t1.state = "empty", i(null);
                });
            }
            unloadTile(t1, i) {
                const o = t1.texture;
                o && o instanceof e.T ? (t1.destroy(!0), this.map.painter.saveTileTexture(o)) : (t1.destroy(), t1.flushQueues(), t1._isHeaderLoaded = !1, delete t1._mrt, delete t1.textureDescriptor), t1.fbo && (t1.fbo.destroy(), delete t1.fbo), delete t1.request, delete t1.requestParams, delete t1.neighboringTiles, t1.state = "unloaded";
            }
            prepareTile(t1, i, o) {
                t1._isHeaderLoaded && ("empty" !== t1.state && (t1.state = "reloading"), t1.fetchBand(i, o, (i, o)=>{
                    if (i) return t1.state = "errored", this.fire(new e.t(i)), void this.triggerRepaint(t1);
                    o && (t1.setTexture(o, this.map.painter), t1.state = "loaded", this.triggerRepaint(t1));
                }));
            }
            getInitialBand(e) {
                if (!this.rasterLayers) return 0;
                const t1 = this.rasterLayers.find(({ id: t1 })=>t1 === e), i = t1 && t1.fields, o = i && i.bands && i.bands;
                return o ? o[0] : 0;
            }
            getTextureDescriptor(t1, i, o) {
                if (!t1) return;
                const r = i.sourceLayer || this.rasterLayerIds && this.rasterLayerIds[0];
                if (!r) return;
                let s = null;
                i instanceof e.aB ? s = i.paint.get("raster-array-band") : i instanceof e.aC && (s = i.paint.get("raster-particle-array-band"));
                const a = s || this.getInitialBand(r);
                if (null != a) {
                    if (t1.textureDescriptor) {
                        if (!t1.updateNeeded(r, a) || o) return Object.assign({}, t1.textureDescriptor, {
                            texture: t1.texture
                        });
                    } else this.prepareTile(t1, r, a);
                }
            }
        }
        const et = {
            vector: Ke,
            raster: Je,
            "raster-dem": class extends Je {
                constructor(t1, i, o, r){
                    super(t1, i, o, r), this.type = "raster-dem", this.maxzoom = 22, this._options = e.l({
                        type: "raster-dem"
                    }, i), this.encoding = i.encoding || "mapbox";
                }
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    function r(e, o) {
                        e && (t1.state = "errored", i(e)), o && (t1.dem = o, t1.dem.onDeserialize(), t1.needsHillshadePrepare = !0, t1.needsDEMTextureUpload = !0, t1.state = "loaded", i(null));
                    }
                    t1.request = e.o(this.map._requestManager.transformRequest(o, e.R.Tile), (function(o, s, a, n) {
                        if (delete t1.request, t1.aborted) t1.state = "unloaded", i(null);
                        else if (o) t1.state = "errored", i(o);
                        else if (s) {
                            this.map._refreshExpiredTiles && t1.setExpiryData({
                                cacheControl: a,
                                expires: n
                            });
                            const i = ImageBitmap && s instanceof ImageBitmap && e.ay(), o = 1 - (s.width - e.az(s.width)) / 2;
                            o < 1 || t1.neighboringTiles || (t1.neighboringTiles = this._getNeighboringTiles(t1.tileID));
                            const l = i ? s : e.q.getImageData(s, o), c = {
                                uid: t1.uid,
                                coord: t1.tileID,
                                source: this.id,
                                scope: this.scope,
                                rawImageData: l,
                                encoding: this.encoding,
                                padding: o
                            };
                            t1.actor && "expired" !== t1.state || (t1.actor = this.dispatcher.getActor(), t1.actor.send("loadDEMTile", c, r.bind(this), void 0, !0));
                        }
                    }).bind(this));
                }
                _getNeighboringTiles(t1) {
                    const i = t1.canonical, o = Math.pow(2, i.z), r = (i.x - 1 + o) % o, s = 0 === i.x ? t1.wrap - 1 : t1.wrap, a = (i.x + 1 + o) % o, n = i.x + 1 === o ? t1.wrap + 1 : t1.wrap, l = {};
                    return l[new e.aA(t1.overscaledZ, s, i.z, r, i.y).key] = {
                        backfilled: !1
                    }, l[new e.aA(t1.overscaledZ, n, i.z, a, i.y).key] = {
                        backfilled: !1
                    }, i.y > 0 && (l[new e.aA(t1.overscaledZ, s, i.z, r, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e.aA(t1.overscaledZ, t1.wrap, i.z, i.x, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e.aA(t1.overscaledZ, n, i.z, a, i.y - 1).key] = {
                        backfilled: !1
                    }), i.y + 1 < o && (l[new e.aA(t1.overscaledZ, s, i.z, r, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e.aA(t1.overscaledZ, t1.wrap, i.z, i.x, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e.aA(t1.overscaledZ, n, i.z, a, i.y + 1).key] = {
                        backfilled: !1
                    }), l;
                }
            },
            "raster-array": Qe,
            geojson: class extends e.E {
                constructor(t1, i, o, r){
                    super(), this.id = t1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._loaded = !1, this.actor = o.getActor(), this.setEventedParent(r), this._data = i.data, this._options = e.l({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), void 0 !== i.minzoom && (this.minzoom = i.minzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                    const s = e.ab / this.tileSize;
                    this.workerOptions = e.l({
                        source: this.id,
                        scope: this.scope,
                        cluster: i.cluster || !1,
                        geojsonVtOptions: {
                            buffer: (void 0 !== i.buffer ? i.buffer : 128) * s,
                            tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * s,
                            extent: e.ab,
                            maxZoom: this.maxzoom,
                            lineMetrics: i.lineMetrics || !1,
                            generateId: i.generateId || !1
                        },
                        superclusterOptions: {
                            maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                            minPoints: Math.max(2, i.clusterMinPoints || 2),
                            extent: e.ab,
                            radius: (void 0 !== i.clusterRadius ? i.clusterRadius : 50) * s,
                            log: !1,
                            generateId: i.generateId || !1
                        },
                        clusterProperties: i.clusterProperties,
                        filter: i.filter,
                        dynamic: i.dynamic
                    }, i.workerOptions);
                }
                onAdd(e) {
                    this.map = e, this.setData(this._data);
                }
                setData(e) {
                    return this._data = e, this._updateWorkerData(), this;
                }
                updateData(t1) {
                    if (!this._options.dynamic) return this.fire(new e.t(new Error("Can't call updateData on a GeoJSON source with dynamic set to false.")));
                    if ("string" != typeof t1 && ("Feature" === t1.type && (t1 = {
                        type: "FeatureCollection",
                        features: [
                            t1
                        ]
                    }), "FeatureCollection" !== t1.type)) return this.fire(new e.t(new Error("Data to update should be a feature or a feature collection.")));
                    if (this._coalesce && "string" != typeof t1 && "string" != typeof this._data && "FeatureCollection" === this._data.type) {
                        const e = new Map;
                        for (const t1 of this._data.features)e.set(t1.id, t1);
                        for (const i of t1.features)e.set(i.id, i);
                        this._data.features = [
                            ...e.values()
                        ];
                    } else this._data = t1;
                    return this._updateWorkerData(!0), this;
                }
                getClusterExpansionZoom(e, t1) {
                    return this.actor.send("geojson.getClusterExpansionZoom", {
                        clusterId: e,
                        source: this.id,
                        scope: this.scope
                    }, t1), this;
                }
                getClusterChildren(e, t1) {
                    return this.actor.send("geojson.getClusterChildren", {
                        clusterId: e,
                        source: this.id,
                        scope: this.scope
                    }, t1), this;
                }
                getClusterLeaves(e, t1, i, o) {
                    return this.actor.send("geojson.getClusterLeaves", {
                        source: this.id,
                        scope: this.scope,
                        clusterId: e,
                        limit: t1,
                        offset: i
                    }, o), this;
                }
                _updateWorkerData(t1 = !1) {
                    if (this._pendingLoad) return void (this._coalesce = !0);
                    this.fire(new e.x("dataloading", {
                        dataType: "source"
                    })), this._loaded = !1;
                    const i = e.l({
                        append: t1
                    }, this.workerOptions);
                    i.scope = this.scope;
                    const o = this._data;
                    "string" == typeof o ? (i.request = this.map._requestManager.transformRequest(e.q.resolveURL(o), e.R.Source), i.request.collectResourceTiming = this._collectResourceTiming) : i.data = JSON.stringify(o), this._pendingLoad = this.actor.send(`${this.type}.loadData`, i, (i, o)=>{
                        if (this._loaded = !0, this._pendingLoad = null, i) this.fire(new e.t(i));
                        else {
                            const i = {
                                dataType: "source",
                                sourceDataType: this._metadataFired ? "content" : "metadata"
                            };
                            this._collectResourceTiming && o && o.resourceTiming && o.resourceTiming[this.id] && (i.resourceTiming = o.resourceTiming[this.id]), t1 && (this._partialReload = !0), this.fire(new e.x("data", i)), this._partialReload = !1, this._metadataFired = !0;
                        }
                        this._coalesce && (this._updateWorkerData(t1), this._coalesce = !1);
                    });
                }
                loaded() {
                    return this._loaded;
                }
                loadTile(t1, i) {
                    const o = t1.actor ? "reloadTile" : "loadTile";
                    t1.actor = this.actor;
                    const r = this.map.style ? this.map.style.getLut(this.scope) : null, s = this._partialReload, a = {
                        type: this.type,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        lut: r ? {
                            image: r.image.clone()
                        } : null,
                        scope: this.scope,
                        pixelRatio: e.q.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        brightness: this.map.style && this.map.style.getBrightness() || 0,
                        partial: s
                    };
                    t1.request = this.actor.send(o, a, (e, r)=>s && !r ? (t1.state = "loaded", i(null)) : (delete t1.request, t1.destroy(), t1.aborted ? i(null) : e ? i(e) : (t1.loadVectorData(r, this.map.painter, "reloadTile" === o), i(null))), void 0, "loadTile" === o);
                }
                abortTile(e) {
                    e.request && (e.request.cancel(), delete e.request), e.aborted = !0;
                }
                unloadTile(e, t1) {
                    this.actor.send("removeTile", {
                        uid: e.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    }), e.destroy();
                }
                onRemove(e) {
                    this._pendingLoad && this._pendingLoad.cancel();
                }
                serialize() {
                    return e.l({}, this._options, {
                        type: this.type,
                        data: this._data
                    });
                }
                hasTransition() {
                    return !1;
                }
            },
            video: class extends e.aD {
                constructor(e, t1, i, o){
                    super(e, t1, i, o), this.roundZoom = !0, this.type = "video", this.options = t1;
                }
                load() {
                    this._loaded = !1;
                    const t1 = this.options;
                    this.urls = [];
                    for (const i of t1.urls)this.urls.push(this.map._requestManager.transformRequest(i, e.R.Source).url);
                    e.aE(this.urls, (t1, i)=>{
                        this._loaded = !0, t1 ? this.fire(new e.t(t1)) : i && (this.video = i, this.video.loop = !0, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading());
                    });
                }
                pause() {
                    this.video && this.video.pause();
                }
                play() {
                    this.video && this.video.play();
                }
                seek(t1) {
                    if (this.video) {
                        const i = this.video.seekable;
                        t1 < i.start(0) || t1 > i.end(0) ? this.fire(new e.t(new e.V(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = t1;
                    }
                }
                getVideo() {
                    return this.video;
                }
                onAdd(e) {
                    this.map || (this.map = e, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                }
                prepare() {
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const t1 = this.map.painter.context, i = t1.gl;
                    this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new e.T(t1, this.video, i.RGBA8), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t1);
                }
                serialize() {
                    return {
                        type: "video",
                        urls: this.urls,
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this.video && !this.video.paused;
                }
            },
            image: e.aD,
            model: class extends e.E {
                constructor(e, t1, i, o){
                    super(), this.id = e, this.type = "model", this.models = [], this._loaded = !1, this._options = t1;
                }
                load() {
                    const t1 = [];
                    for(const i in this._options.models){
                        const o = this._options.models[i], r = e.aG(this.map._requestManager.transformRequest(o.uri, e.R.Model).url).then((t1)=>{
                            if (!t1) return;
                            const r = e.aH(t1), s = new e.aI(i, o.position, o.orientation, r);
                            s.computeBoundsAndApplyParent(), this.models.push(s);
                        }).catch((t1)=>{
                            this.fire(new e.t(new Error(`Could not load model ${i} from ${o.uri}: ${t1.message}`)));
                        });
                        t1.push(r);
                    }
                    return Promise.allSettled(t1).then(()=>{
                        this._loaded = !0, this.fire(new e.x("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        }));
                    }).catch((t1)=>{
                        this.fire(new e.t(new Error(`Could not load models: ${t1.message}`)));
                    });
                }
                onAdd(e) {
                    this.map = e, this.load();
                }
                hasTransition() {
                    return !1;
                }
                loaded() {
                    return this._loaded;
                }
                getModels() {
                    return this.models;
                }
                loadTile(e, t1) {}
                serialize() {
                    return {
                        type: "model"
                    };
                }
            },
            "batched-model": class extends e.E {
                constructor(e, t1, i, o){
                    super(), this.type = "batched-model", this.id = e, this.tileSize = 512, this._options = t1, this.tiles = this._options.tiles, this.maxzoom = t1.maxzoom || 19, this.minzoom = t1.minzoom || 0, this.roundZoom = !0, this.usedInConflation = !0, this.dispatcher = i, this.reparseOverscaled = !1, this.scheme = "xyz", this._loaded = !1, this.setEventedParent(o);
                }
                onAdd(e) {
                    this.map = e, this.load();
                }
                load(t1) {
                    this._loaded = !1, this.fire(new e.x("dataloading", {
                        dataType: "source"
                    }));
                    const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o = this.map._worldview;
                    this._tileJSONRequest = Xe(this._options, this.map._requestManager, i, o, (r, s)=>{
                        this._tileJSONRequest = null, this._loaded = !0, r ? (i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), o && 2 !== o.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`), this.fire(new e.t(r))) : s && (e.l(this, s), s.bounds && (this.tileBounds = new Ye(s.bounds, this.minzoom, this.maxzoom)), L(s.tiles, this.map._requestManager._customAccessToken), this.fire(new e.x("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new e.x("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }))), t1 && t1(r);
                    });
                }
                hasTransition() {
                    return !1;
                }
                hasTile(e) {
                    return !this.tileBounds || this.tileBounds.contains(e.canonical);
                }
                loaded() {
                    return this._loaded;
                }
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme)), r = {
                        request: this.map._requestManager.transformRequest(o, e.R.Tile),
                        data: void 0,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        scope: this.scope,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        isSymbolTile: t1.isSymbolTile,
                        brightness: this.map.style && this.map.style.getBrightness() || 0
                    };
                    if (t1.actor && "expired" !== t1.state) {
                        if ("loading" === t1.state) t1.reloadCallback = i;
                        else {
                            if (t1.buckets) {
                                const e = Object.values(t1.buckets);
                                for (const t1 of e)t1.dirty = !0;
                                return void (t1.state = "loaded");
                            }
                            t1.request = t1.actor.send("reloadTile", r, s.bind(this));
                        }
                    } else t1.actor = this.dispatcher.getActor(), t1.request = t1.actor.send("loadTile", r, s.bind(this), void 0, !0);
                    function s(e, o) {
                        return t1.aborted ? i(null) : e && 404 !== e.status ? i(e) : (o && (o.resourceTiming && (t1.resourceTiming = o.resourceTiming), this.map._refreshExpiredTiles && t1.setExpiryData(o), t1.buckets = {
                            ...t1.buckets,
                            ...o.buckets
                        }, o.featureIndex && (t1.latestFeatureIndex = o.featureIndex)), t1.state = "loaded", void i(null));
                    }
                }
                serialize() {
                    return e.l({}, this._options);
                }
            },
            canvas: class extends e.aD {
                constructor(t1, i, o, r){
                    super(t1, i, o, r), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e)=>!Array.isArray(e) || 2 !== e.length || e.some((e)=>"number" != typeof e)) || this.fire(new e.t(new e.V(`sources.${t1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e.t(new e.V(`sources.${t1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new e.t(new e.V(`sources.${t1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new e.t(new e.V(`sources.${t1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e.t(new e.V(`sources.${t1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
                }
                load() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e.t(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }
                getCanvas() {
                    return this.canvas;
                }
                onAdd(e) {
                    this.map = e, this.load(), this.canvas && this.animate && this.play();
                }
                onRemove(e) {
                    this.pause();
                }
                prepare() {
                    let t1 = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, t1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, t1 = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const i = this.map.painter.context;
                    this.texture ? !t1 && !this._playing || this.texture instanceof e.aF || this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new e.T(i, this.canvas, i.gl.RGBA8, {
                        premultiply: !0
                    }), this._prepareData(i);
                }
                serialize() {
                    return {
                        type: "canvas",
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this._playing;
                }
                _hasInvalidDimensions() {
                    for (const e of [
                        this.canvas.width,
                        this.canvas.height
                    ])if (isNaN(e) || e <= 0) return !0;
                    return !1;
                }
            },
            custom: class extends e.E {
                constructor(t1, i, o, r){
                    super(), this.id = t1, this.type = "custom", this._dataType = "raster", this._dispatcher = o, this._implementation = i, this.setEventedParent(r), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = !1, this.roundZoom = !0, this._implementation || this.fire(new e.t(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new e.t(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new Ye(this._implementation.bounds, this.minzoom, this.maxzoom)), i.update = this._update.bind(this), i.clearTiles = this._clearTiles.bind(this), i.coveringTiles = this._coveringTiles.bind(this), e.l(this, e.ar(i, [
                        "dataType",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution",
                        "minTileCacheSize",
                        "maxTileCacheSize"
                    ]));
                }
                serialize() {
                    return e.ar(this, [
                        "type",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution"
                    ]);
                }
                load() {
                    this._loaded = !0, this.fire(new e.x("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e.x("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                loaded() {
                    return this._loaded;
                }
                onAdd(t1) {
                    this.map = t1, this._loaded = !1, this.fire(new e.x("dataloading", {
                        dataType: "source"
                    })), this._implementation.onAdd && this._implementation.onAdd(t1), this.load();
                }
                onRemove(e) {
                    this._implementation.onRemove && this._implementation.onRemove(e);
                }
                hasTile(e) {
                    if (this._implementation.hasTile) {
                        const { x: t1, y: i, z: o } = e.canonical;
                        return this._implementation.hasTile({
                            x: t1,
                            y: i,
                            z: o
                        });
                    }
                    return !this.tileBounds || this.tileBounds.contains(e.canonical);
                }
                loadTile(e, t1) {
                    const { x: i, y: o, z: r } = e.tileID.canonical, s = new AbortController;
                    e.request = Promise.resolve(this._implementation.loadTile({
                        x: i,
                        y: o,
                        z: r
                    }, {
                        signal: s.signal
                    })).then((function(i) {
                        return delete e.request, e.aborted ? (e.state = "unloaded", t1(null)) : void 0 === i ? (e.state = "errored", t1(null)) : null === i ? (this.loadTileData(e, {
                            width: this.tileSize,
                            height: this.tileSize,
                            data: null
                        }), e.state = "loaded", t1(null)) : function(e) {
                            return e instanceof ImageData || e instanceof HTMLCanvasElement || e instanceof ImageBitmap || e instanceof HTMLImageElement;
                        }(i) ? (this.loadTileData(e, i), e.state = "loaded", void t1(null)) : (e.state = "errored", t1(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)));
                    }).bind(this)).catch((i)=>{
                        20 !== i.code && (e.state = "errored", t1(i));
                    }), e.request.cancel = ()=>s.abort();
                }
                loadTileData(e, t1) {
                    e.setTexture(t1, this.map.painter);
                }
                unloadTile(t1, i) {
                    if (t1.texture && t1.texture instanceof e.T ? (t1.destroy(!0), t1.texture && t1.texture instanceof e.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), this._implementation.unloadTile) {
                        const { x: e, y: i, z: o } = t1.tileID.canonical;
                        this._implementation.unloadTile({
                            x: e,
                            y: i,
                            z: o
                        });
                    }
                    i && i();
                }
                abortTile(e, t1) {
                    e.request && e.request.cancel && (e.request.cancel(), delete e.request), t1 && t1();
                }
                hasTransition() {
                    return !1;
                }
                _coveringTiles() {
                    return this.map.transform.coveringTiles({
                        tileSize: this.tileSize,
                        minzoom: this.minzoom,
                        maxzoom: this.maxzoom,
                        roundZoom: this.roundZoom
                    }).map((e)=>({
                            x: e.canonical.x,
                            y: e.canonical.y,
                            z: e.canonical.z
                        }));
                }
                _clearTiles() {
                    const t1 = e.av(this.id, this.scope);
                    this.map.style.clearSource(t1);
                }
                _update() {
                    this.fire(new e.x("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
            }
        }, tt = function(t1, i, o, r) {
            const s = new et[i.type](t1, i, o, r);
            if (s.id !== t1) throw new Error(`Expected Source id to be ${t1} instead of ${s.id}`);
            return e.aJ([
                "load",
                "abort",
                "unload",
                "serialize",
                "prepare"
            ], s), s;
        };
        function it(t1, i) {
            const o = e.a6.mat4.identity([]);
            return e.a6.mat4.scale(o, o, [
                .5 * t1.width,
                .5 * -t1.height,
                1
            ]), e.a6.mat4.translate(o, o, [
                1,
                -1,
                0
            ]), e.a6.mat4.multiply(o, o, t1.calculateProjMatrix(i.toUnwrapped())), Float32Array.from(o);
        }
        function ot(e, t1, i, o, r, s, a, n = !1) {
            const l = e.tilesIn(o, a, n);
            l.sort(st);
            const c = [];
            for (const o of l)c.push({
                wrappedTileID: o.tile.tileID.wrapped().key,
                queryResults: o.tile.queryRenderedFeatures(t1, i, e._state, o, r, s, it(e.transform, o.tile.tileID), n)
            });
            const h = function(e) {
                const t1 = {}, i = {};
                for (const o of e){
                    const e = o.queryResults, r = o.wrappedTileID, s = i[r] = i[r] || {};
                    for(const i in e){
                        const o = e[i], r = s[i] = s[i] || {}, a = t1[i] = t1[i] || [];
                        for (const e of o)r[e.featureIndex] || (r[e.featureIndex] = !0, a.push(e));
                    }
                }
                return t1;
            }(c);
            for(const t1 in h)h[t1].forEach((t1)=>{
                const i = t1.feature, o = i.layer;
                o && "background" !== o.type && "sky" !== o.type && "slot" !== o.type && (i.source = o.source, o["source-layer"] && (i.sourceLayer = o["source-layer"]), i.state = void 0 !== i.id ? e.getFeatureState(o["source-layer"], i.id) : {});
            });
            return h;
        }
        function rt(e, t1) {
            const i = e.getRenderableIds().map((t1)=>e.getTileByID(t1)), o = [], r = {};
            for(let e = 0; e < i.length; e++){
                const s = i[e], a = s.tileID.canonical.key;
                r[a] || (r[a] = !0, s.querySourceFeatures(o, t1));
            }
            return o;
        }
        function st(e, t1) {
            const i = e.tileID, o = t1.tileID;
            return i.overscaledZ - o.overscaledZ || i.canonical.y - o.canonical.y || i.wrap - o.wrap || i.canonical.x - o.canonical.x;
        }
        const at = 32, nt = 33, lt = new Uint16Array(8184);
        for(let e = 0; e < 2046; e++){
            let t1 = e + 2, i = 0, o = 0, r = 0, s = 0, a = 0, n = 0;
            for(1 & t1 ? r = s = a = at : i = o = n = at; (t1 >>= 1) > 1;){
                const e = i + r >> 1, l = o + s >> 1;
                1 & t1 ? (r = i, s = o, i = a, o = n) : (i = r, o = s, r = a, s = n), a = e, n = l;
            }
            const l = 4 * e;
            lt[l + 0] = i, lt[l + 1] = o, lt[l + 2] = r, lt[l + 3] = s;
        }
        const ct = new Uint16Array(2178), ht = new Uint8Array(1089), ut = new Uint16Array(1089);
        function dt(e) {
            return 0 === e ? -0.03125 : 32 === e ? .03125 : 0;
        }
        const _t = (()=>({
                type: 2,
                extent: e.ab,
                loadGeometry: ()=>[
                        [
                            new e.P(0, 0),
                            new e.P(e.ab + 1, 0),
                            new e.P(e.ab + 1, e.ab + 1),
                            new e.P(0, e.ab + 1),
                            new e.P(0, 0)
                        ]
                    ]
            }))();
        class pt {
            constructor(t1, i, o, r, s){
                this.tileID = t1, this.uid = e.aP(), this.uses = 0, this.tileSize = i, this.tileZoom = o, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.isRaster = s, r && r.style && (this._lastUpdatedBrightness = r.style.getBrightness()), this.expiredRequestCount = 0, this.state = "loading", r && r.transform && (this.projection = r.transform.projection);
            }
            registerFadeDuration(t1) {
                const i = t1 + this.timeAdded;
                i < e.q.now() || this.fadeEndTime && i < this.fadeEndTime || (this.fadeEndTime = i);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            get tileTransform() {
                return this._tileTransform || (this._tileTransform = e.aK(this.tileID.canonical, this.projection)), this._tileTransform;
            }
            loadVectorData(t1, i, o) {
                if (this.unloadVectorData(), this.state = "loaded", t1) {
                    t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = function(e, t1) {
                        const i = {};
                        if (!t1) return i;
                        for (const o of e){
                            const e = o.layerIds.map((e)=>t1.getLayer(e)).filter(Boolean);
                            if (0 !== e.length) {
                                o.layers = e, o.stateDependentLayerIds && (o.stateDependentLayers = o.stateDependentLayerIds.map((t1)=>e.filter((e)=>e.id === t1)[0]));
                                for (const t1 of e)i[t1.fqid] = o;
                            }
                        }
                        return i;
                    }(t1.buckets, i.style), this.hasSymbolBuckets = !1;
                    for(const t1 in this.buckets){
                        const i = this.buckets[t1];
                        if (i instanceof e.aR) {
                            if (this.hasSymbolBuckets = !0, !o) break;
                            i.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const t1 in this.buckets){
                        const i = this.buckets[t1];
                        if (i instanceof e.aR && i.hasRTLText) {
                            this.hasRTLText = !0, e.aS();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const e in this.buckets){
                        const t1 = this.buckets[e], o = i.style.getOwnLayer(e);
                        if (!o) continue;
                        const r = o.queryRadius(t1);
                        this.queryPadding = Math.max(this.queryPadding, r);
                    }
                    t1.imageAtlas && (this.imageAtlas = t1.imageAtlas), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage), t1.lineAtlas && (this.lineAtlas = t1.lineAtlas), this._lastUpdatedBrightness = t1.brightness;
                } else this.collisionBoxArray = new e.aQ;
            }
            unloadVectorData() {
                if (this.hasData()) {
                    for(const e in this.buckets)this.buckets[e].destroy();
                    this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
                }
            }
            getBucket(e) {
                return this.buckets[e.fqid];
            }
            upload(t1) {
                for(const e in this.buckets){
                    const i = this.buckets[e];
                    i.uploadPending() && i.upload(t1);
                }
                const i = t1.gl, o = this.imageAtlas;
                if (o && !o.uploaded) {
                    const r = !!Object.keys(o.patternPositions).length;
                    this.imageAtlasTexture = new e.T(t1, o.image, i.RGBA8, {
                        useMipmap: r
                    }), this.imageAtlas.uploaded = !0;
                }
                this.glyphAtlasImage && (this.glyphAtlasTexture = new e.T(t1, this.glyphAtlasImage, i.R8), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new e.T(t1, this.lineAtlas.image, i.R8), this.lineAtlas.uploaded = !0);
            }
            prepare(e, t1, i) {
                if (this.imageAtlas && this.imageAtlasTexture && this.imageAtlas.patchUpdatedImages(e, this.imageAtlasTexture, i), !t1 || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) return;
                const o = t1.style.getBrightness();
                (this._lastUpdatedBrightness || o) && (this._lastUpdatedBrightness && o && Math.abs(this._lastUpdatedBrightness - o) < .001 || (this._lastUpdatedBrightness = o, this.updateBuckets(t1)));
            }
            queryRenderedFeatures(e, t1, i, o, r, s, a, n) {
                return this.latestFeatureIndex && (this.latestFeatureIndex.rawTileData || this.latestFeatureIndex.is3DTile) ? this.latestFeatureIndex.query({
                    tileResult: o,
                    pixelPosMatrix: a,
                    transform: s,
                    params: r,
                    tileTransform: this.tileTransform
                }, e, t1, i) : {};
            }
            querySourceFeatures(t1, i) {
                const o = this.latestFeatureIndex;
                if (!o || !o.rawTileData) return;
                const r = o.loadVTLayers(), s = i ? i.sourceLayer : "", a = r._geojsonTileLayer || r[s];
                if (!a) return;
                const n = e.aT(i && i.filter), { z: l, x: c, y: h } = this.tileID.canonical, u = {
                    z: l,
                    x: c,
                    y: h
                };
                for(let i = 0; i < a.length; i++){
                    const r = a.feature(i);
                    if (n.needGeometry) {
                        const t1 = e.aU(r, !0);
                        if (!n.filter(new e.a3(this.tileID.overscaledZ), t1, this.tileID.canonical)) continue;
                    } else if (!n.filter(new e.a3(this.tileID.overscaledZ), r)) continue;
                    const d = o.getId(r, s), _ = new e.aV(r, l, c, h, d);
                    _.tile = u, t1.push(_);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return !!this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(t1) {
                const i = this.expirationTime;
                if (t1.cacheControl) {
                    const i = e.aW(t1.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
                if (this.expirationTime) {
                    const e = Date.now();
                    let t1 = !1;
                    if (this.expirationTime > e) t1 = !1;
                    else if (i) {
                        if (this.expirationTime < i) t1 = !0;
                        else {
                            const o = this.expirationTime - i;
                            o ? this.expirationTime = e + Math.max(o, 3e4) : t1 = !0;
                        }
                    } else t1 = !0;
                    t1 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(e, t1) {
                this.latestFeatureIndex && this.latestFeatureIndex.rawTileData && 0 !== Object.keys(e).length && t1 && this.updateBuckets(t1);
            }
            updateBuckets(t1) {
                if (!this.latestFeatureIndex) return;
                const i = this.latestFeatureIndex.loadVTLayers(), o = t1.style.listImages(), r = t1.style.getBrightness();
                for(const s in this.buckets){
                    if (!t1.style.hasLayer(s)) continue;
                    const a = this.buckets[s], n = a.layers[0].sourceLayer || "_geojsonTileLayer", l = i[n], c = t1.style.getOwnSourceCache(a.layers[0].source);
                    let h = {};
                    c && (h = c._state.getState(n, void 0)), a.update(h, l, o, this.imageAtlas && this.imageAtlas.patternPositions || {}, r), (a instanceof e.aX || a instanceof e.aY) && t1._terrain && t1._terrain.enabled && c && a.programConfigurations.needsUpload && t1._terrain._clearRenderCacheForTile(c.id, this.tileID);
                    const u = t1 && t1.style && t1.style.getOwnLayer(s);
                    u && (this.queryPadding = Math.max(this.queryPadding, u.queryRadius(a)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < e.q.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(t1) {
                this.symbolFadeHoldUntil = e.q.now() + t1;
            }
            setTexture(t1, i) {
                const o = i.context, r = o.gl;
                this.texture = this.texture || i.getTileTexture(t1.width), this.texture && this.texture instanceof e.T ? this.texture.update(t1) : (this.texture = new e.T(o, t1, r.RGBA8, {
                    useMipmap: !0
                }), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE));
            }
            setDependencies(e, t1) {
                const i = {};
                for (const e of t1)i[e] = !0;
                this.dependencies[e] = i;
            }
            hasDependency(e, t1) {
                for (const i of e){
                    const e = this.dependencies[i];
                    if (e) {
                        for (const i of t1)if (e[i]) return !0;
                    }
                }
                return !1;
            }
            clearQueryDebugViz() {}
            _makeDebugTileBoundsBuffers(t1, i) {
                if (!i || "mercator" === i.name || this._tileDebugBuffer) return;
                const o = e.aZ(_t, this.tileID.canonical, this.tileTransform)[0], r = new e.a_, s = new e.a$;
                for(let e = 0; e < o.length; e++){
                    const { x: t1, y: i } = o[e];
                    r.emplaceBack(t1, i), s.emplaceBack(e);
                }
                s.emplaceBack(0), this._tileDebugIndexBuffer = t1.createIndexBuffer(s), this._tileDebugBuffer = t1.createVertexBuffer(r, e.b0.members), this._tileDebugSegments = e.b1.simpleSegment(0, 0, r.length, s.length);
            }
            _makeTileBoundsBuffers(t1, i) {
                if (this._tileBoundsBuffer || !i || "mercator" === i.name) return;
                const o = e.aZ(_t, this.tileID.canonical, this.tileTransform)[0];
                let r, s;
                if (this.isRaster) {
                    const t1 = function(t1, i) {
                        const o = e.aK(t1, i), r = Math.pow(2, t1.z);
                        for(let s = 0; s < nt; s++)for(let a = 0; a < nt; a++){
                            const n = e.aL((t1.x + (a + dt(a)) / at) / r), l = e.aM((t1.y + (s + dt(s)) / at) / r), c = i.project(n, l), h = s * nt + a;
                            ct[2 * h + 0] = Math.round((c.x * o.scale - o.x) * e.ab), ct[2 * h + 1] = Math.round((c.y * o.scale - o.y) * e.ab);
                        }
                        ht.fill(0), ut.fill(0);
                        for(let e = 2045; e >= 0; e--){
                            const t1 = 4 * e, i = lt[t1 + 0], o = lt[t1 + 1], r = lt[t1 + 2], s = lt[t1 + 3], a = i + r >> 1, n = o + s >> 1, l = a + n - o, c = n + i - a, h = o * nt + i, u = s * nt + r, d = n * nt + a, _ = Math.hypot((ct[2 * h + 0] + ct[2 * u + 0]) / 2 - ct[2 * d + 0], (ct[2 * h + 1] + ct[2 * u + 1]) / 2 - ct[2 * d + 1]) >= 16;
                            ht[d] = ht[d] || (_ ? 1 : 0), e < 1022 && (ht[d] = ht[d] || ht[(o + c >> 1) * nt + (i + l >> 1)] || ht[(s + c >> 1) * nt + (r + l >> 1)]);
                        }
                        const s = new e.aN, a = new e.aO;
                        let n = 0;
                        function l(t1, i) {
                            const o = i * nt + t1;
                            return 0 === ut[o] && (s.emplaceBack(ct[2 * o + 0], ct[2 * o + 1], t1 * e.ab / at, i * e.ab / at), ut[o] = ++n), ut[o] - 1;
                        }
                        function c(e, t1, i, o, r, s) {
                            const n = e + i >> 1, h = t1 + o >> 1;
                            if (Math.abs(e - r) + Math.abs(t1 - s) > 1 && ht[h * nt + n]) c(r, s, e, t1, n, h), c(i, o, r, s, n, h);
                            else {
                                const n = l(e, t1), c = l(i, o), h = l(r, s);
                                a.emplaceBack(n, c, h);
                            }
                        }
                        return c(0, 0, at, at, at, 0), c(at, at, 0, 0, 0, at), {
                            vertices: s,
                            indices: a
                        };
                    }(this.tileID.canonical, i);
                    r = t1.vertices, s = t1.indices;
                } else {
                    r = new e.aN, s = new e.aO;
                    for (const { x: e, y: t1 } of o)r.emplaceBack(e, t1, 0, 0);
                    const t1 = e.b2(r.int16, void 0, 4);
                    for(let e = 0; e < t1.length; e += 3)s.emplaceBack(t1[e], t1[e + 1], t1[e + 2]);
                }
                this._tileBoundsBuffer = t1.createVertexBuffer(r, e.b3.members), this._tileBoundsIndexBuffer = t1.createIndexBuffer(s), this._tileBoundsSegments = e.b1.simpleSegment(0, 0, r.length, s.length);
            }
            _makeGlobeTileDebugBuffers(t1, i) {
                const o = i.projection;
                if (!o || "globe" !== o.name || i.freezeTileCoverage) return;
                const r = this.tileID.canonical, s = e.b4(r, i), a = e.b5(s), n = e.a9(i.zoom);
                let l;
                n > 0 && (l = e.a6.mat4.invert(new Float64Array(16), i.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(t1, r, i, a, l, n), this._makeGlobeTileDebugTextBuffer(t1, r, i, a, l, n);
            }
            _globePoint(t1, i, o, r, s, a, n) {
                let l = e.b6(t1, i, o);
                if (a) {
                    const s = 1 << o.z, c = e.am(r.center.lng), h = e.at(r.center.lat), u = (o.x + .5) / s - c;
                    let d = 0;
                    u > .5 ? d = -1 : u < -0.5 && (d = 1);
                    let _ = (t1 / e.ab + o.x) / s + d, p = (i / e.ab + o.y) / s;
                    _ = (_ - c) * r._pixelsPerMercatorPixel + c, p = (p - h) * r._pixelsPerMercatorPixel + h;
                    const m = [
                        _ * r.worldSize,
                        p * r.worldSize,
                        0
                    ];
                    e.a6.vec3.transformMat4(m, m, a), l = e.b7(l, m, n);
                }
                return e.a6.vec3.transformMat4(l, l, s);
            }
            _makeGlobeTileDebugBorderBuffer(t1, i, o, r, s, a) {
                const n = new e.a_, l = new e.a$, c = new e.b8, h = (e, t1, h, u, d)=>{
                    const _ = (h - e) / (d - 1), p = (u - t1) / (d - 1), m = n.length;
                    for(let h = 0; h < d; h++){
                        const u = e + h * _, d = t1 + h * p;
                        n.emplaceBack(u, d);
                        const f = this._globePoint(u, d, i, o, r, s, a);
                        c.emplaceBack(f[0], f[1], f[2]), l.emplaceBack(m + h);
                    }
                }, u = e.ab;
                h(0, 0, u, 0, 16), h(u, 0, u, u, 16), h(u, u, 0, u, 16), h(0, u, 0, 0, 16), this._tileDebugIndexBuffer = t1.createIndexBuffer(l), this._tileDebugBuffer = t1.createVertexBuffer(n, e.b0.members), this._globeTileDebugBorderBuffer = t1.createVertexBuffer(c, e.b9.members), this._tileDebugSegments = e.b1.simpleSegment(0, 0, n.length, l.length);
            }
            _makeGlobeTileDebugTextBuffer(t1, i, o, r, s, a) {
                const n = e.ab / 4, l = new e.a_, c = new e.aO, h = new e.b8, u = 25;
                c.reserve(32), l.reserve(u), h.reserve(u);
                const d = (e, t1)=>u * e + t1;
                for(let e = 0; e < u; e++){
                    const t1 = e * n;
                    for(let e = 0; e < u; e++){
                        const c = e * n;
                        l.emplaceBack(c, t1);
                        const u = this._globePoint(c, t1, i, o, r, s, a);
                        h.emplaceBack(u[0], u[1], u[2]);
                    }
                }
                for(let e = 0; e < 4; e++)for(let t1 = 0; t1 < 4; t1++){
                    const i = d(e, t1), o = d(e, t1 + 1), r = d(e + 1, t1), s = d(e + 1, t1 + 1);
                    c.emplaceBack(i, o, r), c.emplaceBack(r, o, s);
                }
                this._tileDebugTextIndexBuffer = t1.createIndexBuffer(c), this._tileDebugTextBuffer = t1.createVertexBuffer(l, e.b0.members), this._globeTileDebugTextBuffer = t1.createVertexBuffer(h, e.b9.members), this._tileDebugTextSegments = e.b1.simpleSegment(0, 0, u, 32);
            }
            destroy(t1 = !1) {
                for(const e in this.buckets)this.buckets[e].destroy();
                this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture.destroy(), delete this.imageAtlasTexture), this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), !t1 && this.texture && this.texture instanceof e.T && (this.texture.destroy(), delete this.texture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.rasterParticleState && (this.rasterParticleState.destroy(), delete this.rasterParticleState), this.latestFeatureIndex = null, this.state = "unloaded";
            }
        }
        e.ba.setPbf(e.bb);
        class mt extends pt {
            constructor(e, t1, i, o, r){
                super(e, t1, i, o, r), this._workQueue = [], this._fetchQueue = [], this._isHeaderLoaded = !1;
            }
            setTexture(t1, i) {
                const o = i.context, r = o.gl;
                this.texture = this.texture || i.getTileTexture(t1.width), this.texture && this.texture instanceof e.T ? this.texture.update(t1, {
                    premultiply: !1
                }) : this.texture = new e.T(o, t1, r.RGBA8, {
                    premultiply: !1
                });
            }
            flushQueues() {
                for(; this._workQueue.length;)this._workQueue.pop()();
                for(; this._fetchQueue.length;)this._fetchQueue.pop()();
            }
            fetchHeader(t1 = 16384, i) {
                const o = this._mrt = new e.ba(30), r = Object.assign({}, this.requestParams, {
                    headers: {
                        Range: "bytes=0-" + (t1 - 1)
                    }
                });
                return this.entireBuffer = null, this.request = e.bc(r, (e, r, s, a)=>{
                    if (e) i(e);
                    else try {
                        const e = o.getHeaderLength(r);
                        if (e > t1) return void (this.request = this.fetchHeader(e, i));
                        o.parseHeader(r), this._isHeaderLoaded = !0;
                        let n = 0;
                        for (const e of Object.values(o.layers))n = Math.max(n, e.dataIndex[e.dataIndex.length - 1].last_byte);
                        r.byteLength >= n && (this.entireBuffer = r), i(null, this.entireBuffer || r, s, a);
                    } catch (e) {
                        i(e);
                    }
                }), this.request;
            }
            fetchBand(t1, i, o) {
                const r = this._mrt;
                if (!this._isHeaderLoaded || !r) return void o(new Error("Tile header is not ready"));
                const s = this.actor;
                if (!s) return void o(new Error("Can't fetch tile band without an actor"));
                let a;
                const n = (e, r)=>{
                    a.complete(e, r), e ? o(e) : (this.updateTextureDescriptor(t1, i), o(null, this.textureDescriptor && this.textureDescriptor.img));
                }, l = (e, t1)=>{
                    if (e) return o(e);
                    const i = s.send("decodeRasterArray", {
                        buffer: t1,
                        task: a
                    }, n, void 0, !0);
                    this._workQueue.push(()=>{
                        i && i.cancel(), a.cancel();
                    });
                }, c = r.getLayer(t1);
                if (!c) return void o(new Error(`Unknown sourceLayer "${t1}"`));
                if (c.hasDataForBand(i)) return this.updateTextureDescriptor(t1, i), void o(null, this.textureDescriptor ? this.textureDescriptor.img : null);
                const h = c.getDataRange([
                    i
                ]);
                if (a = r.createDecodingTask(h), !a || a.tasks.length) {
                    if (this.flushQueues(), this.entireBuffer) l(null, this.entireBuffer.slice(h.firstByte, h.lastByte + 1));
                    else {
                        const t1 = Object.assign({}, this.requestParams, {
                            headers: {
                                Range: `bytes=${h.firstByte}-${h.lastByte}`
                            }
                        }), i = e.bc(t1, l);
                        this._fetchQueue.push(()=>{
                            i.cancel(), a.cancel();
                        });
                    }
                } else o(null);
            }
            updateNeeded(e, t1) {
                return (!this.textureDescriptor || this.textureDescriptor.band !== t1 || this.textureDescriptor.layer !== e) && "errored" !== this.state;
            }
            updateTextureDescriptor(t1, i) {
                if (!this._mrt) return;
                const o = this._mrt.getLayer(t1);
                if (!o || !o.hasBand(i) || !o.hasDataForBand(i)) return;
                const { bytes: r, tileSize: s, buffer: a, offset: n, scale: l } = o.getBandView(i), c = s + 2 * a, h = {
                    data: r,
                    width: c,
                    height: c
                }, u = this.texture;
                u && u instanceof e.T && u.update(h, {
                    premultiply: !1
                }), this.textureDescriptor = {
                    layer: t1,
                    band: i,
                    img: h,
                    buffer: a,
                    offset: n,
                    tileSize: s,
                    format: o.pixelFormat,
                    mix: [
                        l,
                        256 * l,
                        65536 * l,
                        16777216 * l
                    ]
                };
            }
        }
        class ft {
            constructor(e, t1){
                this.max = e, this.onRemove = t1, this.reset();
            }
            reset() {
                for(const e in this.data)for (const t1 of this.data[e])t1.timeout && clearTimeout(t1.timeout), this.onRemove(t1.value);
                return this.data = {}, this.order = [], this;
            }
            add(e, t1, i) {
                const o = e.wrapped().key;
                void 0 === this.data[o] && (this.data[o] = []);
                const r = {
                    value: t1,
                    timeout: void 0
                };
                if (void 0 !== i && (r.timeout = setTimeout(()=>{
                    this.remove(e, r);
                }, i)), this.data[o].push(r), this.order.push(o), this.order.length > this.max) {
                    const e = this._getAndRemoveByKey(this.order[0]);
                    e && this.onRemove(e);
                }
                return this;
            }
            has(e) {
                return e.wrapped().key in this.data;
            }
            getAndRemove(e) {
                return this.has(e) ? this._getAndRemoveByKey(e.wrapped().key) : null;
            }
            _getAndRemoveByKey(e) {
                const t1 = this.data[e].shift();
                return t1.timeout && clearTimeout(t1.timeout), 0 === this.data[e].length && delete this.data[e], this.order.splice(this.order.indexOf(e), 1), t1.value;
            }
            getByKey(e) {
                const t1 = this.data[e];
                return t1 ? t1[0].value : null;
            }
            get(e) {
                return this.has(e) ? this.data[e.wrapped().key][0].value : null;
            }
            remove(e, t1) {
                if (!this.has(e)) return this;
                const i = e.wrapped().key, o = void 0 === t1 ? 0 : this.data[i].indexOf(t1), r = this.data[i][o];
                return this.data[i].splice(o, 1), r.timeout && clearTimeout(r.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(r.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(e) {
                for(this.max = e; this.order.length > this.max;){
                    const e = this._getAndRemoveByKey(this.order[0]);
                    e && this.onRemove(e);
                }
                return this;
            }
            filter(e) {
                const t1 = [];
                for(const i in this.data)for (const o of this.data[i])e(o.value) || t1.push(o);
                for (const e of t1)this.remove(e.value.tileID, e);
            }
        }
        class gt {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(t1, i, o) {
                const r = String(i);
                if (this.stateChanges[t1] = this.stateChanges[t1] || {}, this.stateChanges[t1][r] = this.stateChanges[t1][r] || {}, e.l(this.stateChanges[t1][r], o), null === this.deletedStates[t1]) {
                    this.deletedStates[t1] = {};
                    for(const e in this.state[t1])e !== r && (this.deletedStates[t1][e] = null);
                } else if (this.deletedStates[t1] && null === this.deletedStates[t1][r]) {
                    this.deletedStates[t1][r] = {};
                    for(const e in this.state[t1][r])o[e] || (this.deletedStates[t1][r][e] = null);
                } else for(const e in o)this.deletedStates[t1] && this.deletedStates[t1][r] && null === this.deletedStates[t1][r][e] && delete this.deletedStates[t1][r][e];
            }
            removeFeatureState(e, t1, i) {
                if (null === this.deletedStates[e]) return;
                const o = String(t1);
                if (this.deletedStates[e] = this.deletedStates[e] || {}, i && void 0 !== t1) null !== this.deletedStates[e][o] && (this.deletedStates[e][o] = this.deletedStates[e][o] || {}, this.deletedStates[e][o][i] = null);
                else if (void 0 !== t1) {
                    if (this.stateChanges[e] && this.stateChanges[e][o]) for(i in this.deletedStates[e][o] = {}, this.stateChanges[e][o])this.deletedStates[e][o][i] = null;
                    else this.deletedStates[e][o] = null;
                } else this.deletedStates[e] = null;
            }
            getState(t1, i) {
                const o = this.state[t1] || {}, r = this.stateChanges[t1] || {}, s = this.deletedStates[t1];
                if (null === s) return {};
                if (void 0 !== i) {
                    const t1 = String(i), a = e.l({}, o[t1], r[t1]);
                    if (s) {
                        const e = s[i];
                        if (null === e) return {};
                        for(const t1 in e)delete a[t1];
                    }
                    return a;
                }
                const a = e.l({}, o, r);
                if (s) for(const e in s)delete a[e];
                return a;
            }
            initializeTileState(e, t1) {
                e.setFeatureState(this.state, t1);
            }
            coalesceChanges(t1, i) {
                const o = {};
                for(const t1 in this.stateChanges){
                    this.state[t1] = this.state[t1] || {};
                    const i = {};
                    for(const o in this.stateChanges[t1])this.state[t1][o] || (this.state[t1][o] = {}), e.l(this.state[t1][o], this.stateChanges[t1][o]), i[o] = this.state[t1][o];
                    o[t1] = i;
                }
                for(const t1 in this.deletedStates){
                    this.state[t1] = this.state[t1] || {};
                    const i = {};
                    if (null === this.deletedStates[t1]) for(const e in this.state[t1])i[e] = {}, this.state[t1][e] = {};
                    else for(const e in this.deletedStates[t1]){
                        if (null === this.deletedStates[t1][e]) this.state[t1][e] = {};
                        else if (this.state[t1][e]) for (const i of Object.keys(this.deletedStates[t1][e]))delete this.state[t1][e][i];
                        i[e] = this.state[t1][e];
                    }
                    o[t1] = o[t1] || {}, e.l(o[t1], i);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(o).length) for(const e in t1)t1[e].setFeatureState(o, i);
            }
        }
        class vt extends e.E {
            constructor(e, t1, i){
                super(), this.id = e, this._onlySymbols = i, t1.on("data", (e)=>{
                    "source" === e.dataType && "metadata" === e.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === e.dataType && "content" === e.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
                }), t1.on("error", ()=>{
                    this._sourceErrored = !0;
                }), this._source = t1, this._tiles = {}, this._cache = new ft(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._loadedParentTiles = {}, this.castsShadows = !1, this.tileCoverLift = 0, this._coveredTiles = {}, this._shadowCasterTiles = {}, this._state = new gt, this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "raster-array" === this._source.type || "custom" === this._source.type && "raster" === this._source._dataType;
            }
            onAdd(e) {
                this.map = e, this._minTileCacheSize = void 0 === this._minTileCacheSize && e ? e._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && e ? e._maxTileCacheSize : this._maxTileCacheSize;
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(const e in this._tiles){
                    const t1 = this._tiles[e];
                    if ("loaded" !== t1.state && "errored" !== t1.state) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const e = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, e && this.reload(), this.transform && this.update(this.transform);
            }
            _loadTile(e, t1) {
                return e.isSymbolTile = this._onlySymbols, e.isExtraShadowCaster = this._shadowCasterTiles[e.tileID.key], this._source.loadTile(e, t1);
            }
            _unloadTile(e) {
                if (this._source.unloadTile) return this._source.unloadTile(e);
            }
            _abortTile(e) {
                if (this._source.abortTile) return this._source.abortTile(e);
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(e) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const t1 in this._tiles){
                    const i = this._tiles[t1];
                    i.upload(e), i.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
                }
            }
            getIds() {
                return e.bd(this._tiles).map((e)=>e.tileID).sort(xt).map((e)=>e.key);
            }
            getRenderableIds(t1, i) {
                const o = [];
                for(const e in this._tiles)this._isIdRenderable(+e, t1, i) && o.push(this._tiles[e]);
                return t1 ? o.sort((t1, i)=>{
                    const o = t1.tileID, r = i.tileID, s = new e.P(o.canonical.x, o.canonical.y)._rotate(this.transform.angle), a = new e.P(r.canonical.x, r.canonical.y)._rotate(this.transform.angle);
                    return o.overscaledZ - r.overscaledZ || a.y - s.y || a.x - s.x;
                }).map((e)=>e.tileID.key) : o.map((e)=>e.tileID).sort(xt).map((e)=>e.key);
            }
            hasRenderableParent(e) {
                const t1 = this.findLoadedParent(e, 0);
                return !!t1 && this._isIdRenderable(t1.tileID.key);
            }
            _isIdRenderable(e, t1, i) {
                return this._tiles[e] && this._tiles[e].hasData() && !this._coveredTiles[e] && (t1 || !this._tiles[e].holdingForFade()) && (i || !this._shadowCasterTiles[e]);
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const e in this._tiles)"errored" !== this._tiles[e].state && this._reloadTile(+e, "reloading");
                }
            }
            _reloadTile(e, t1) {
                const i = this._tiles[e];
                i && ("loading" !== i.state && (i.state = t1), this._loadTile(i, this._tileLoaded.bind(this, i, e, t1)));
            }
            _tileLoaded(t1, i, o, r) {
                if (r) {
                    if (t1.state = "errored", 404 !== r.status) this._source.fire(new e.t(r, {
                        tile: t1
                    }));
                    else {
                        if (this._source.fire(new e.x("data", {
                            dataType: "source",
                            sourceDataType: "error",
                            sourceId: this._source.id,
                            tile: t1
                        })), !(t1.tileID.key in this._loadedParentTiles)) return;
                        if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                            const e = this.map.painter.terrain;
                            this.update(this.transform, e.getScaledDemTileSize(), !0), e.resetTileLookupCache(this.id);
                        } else this.update(this.transform);
                    }
                } else t1.timeAdded = e.q.now(), "expired" === o && (t1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, t1), "raster-dem" === this._source.type && t1.dem && this._backfillDEM(t1), this._state.initializeTileState(t1, this.map ? this.map.painter : null), this._source.fire(new e.x("data", {
                    dataType: "source",
                    tile: t1,
                    coord: t1.tileID,
                    sourceCacheId: this.id
                }));
            }
            _backfillDEM(e) {
                const t1 = this.getRenderableIds();
                for(let o = 0; o < t1.length; o++){
                    const r = t1[o];
                    if (e.neighboringTiles && e.neighboringTiles[r]) {
                        const t1 = this.getTileByID(r);
                        i(e, t1), i(t1, e);
                    }
                }
                function i(e, t1) {
                    if (!e.dem || e.dem.borderReady) return;
                    e.needsHillshadePrepare = !0, e.needsDEMTextureUpload = !0;
                    let i = t1.tileID.canonical.x - e.tileID.canonical.x;
                    const o = t1.tileID.canonical.y - e.tileID.canonical.y, r = Math.pow(2, e.tileID.canonical.z), s = t1.tileID.key;
                    0 === i && 0 === o || Math.abs(o) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + r) ? i += r : 1 === Math.abs(i - r) && (i -= r)), t1.dem && e.dem && (e.dem.backfillBorder(t1.dem, i, o), e.neighboringTiles && e.neighboringTiles[s] && (e.neighboringTiles[s].backfilled = !0)));
                }
            }
            getTile(e) {
                return this.getTileByID(e.key);
            }
            getTileByID(e) {
                return this._tiles[e];
            }
            _retainLoadedChildren(e, t1, i, o) {
                for(const r in this._tiles){
                    let s = this._tiles[r];
                    if (o[r] || !s.hasData() || s.tileID.overscaledZ <= t1 || s.tileID.overscaledZ > i) continue;
                    let a = s.tileID;
                    for(; s && s.tileID.overscaledZ > t1 + 1;){
                        const e = s.tileID.scaledTo(s.tileID.overscaledZ - 1);
                        s = this._tiles[e.key], s && s.hasData() && (a = e);
                    }
                    let n = a;
                    for(; n.overscaledZ > t1;)if (n = n.scaledTo(n.overscaledZ - 1), e[n.key]) {
                        o[a.key] = a;
                        break;
                    }
                }
            }
            findLoadedParent(e, t1) {
                if (e.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[e.key];
                    return i && i.tileID.overscaledZ >= t1 ? i : null;
                }
                for(let i = e.overscaledZ - 1; i >= t1; i--){
                    const t1 = e.scaledTo(i), o = this._getLoadedTile(t1);
                    if (o) return o;
                }
            }
            _getLoadedTile(e) {
                const t1 = this._tiles[e.key];
                return t1 && t1.hasData() ? t1 : this._cache.getByKey(this._source.reparseOverscaled ? e.wrapped().key : e.canonical.key);
            }
            updateCacheSize(e, t1) {
                t1 = t1 || this._source.tileSize;
                const i = Math.ceil(e.width / t1) + 1, o = Math.ceil(e.height / t1) + 1, r = Math.floor(i * o * 5), s = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, r) : r, a = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, s) : s;
                this._cache.setMaxSize(a);
            }
            handleWrapJump(e) {
                const t1 = Math.round((e - (void 0 === this._prevLng ? e : this._prevLng)) / 360);
                if (this._prevLng = e, t1) {
                    const e = {};
                    for(const i in this._tiles){
                        const o = this._tiles[i];
                        o.tileID = o.tileID.unwrapTo(o.tileID.wrap + t1), e[o.tileID.key] = o;
                    }
                    this._tiles = e;
                    for(const e in this._timers)clearTimeout(this._timers[e]), delete this._timers[e];
                    for(const e in this._tiles)this._setTileReloadTimer(+e, this._tiles[e]);
                }
            }
            update(t1, i, o, r) {
                if (this.transform = t1, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
                if (this.usedForTerrain && !o) return;
                this.updateCacheSize(t1, i), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {};
                const s = "batched-model" === this._source.type;
                let a;
                if (this.used || this.usedForTerrain) {
                    if (this._source.tileID) a = t1.getVisibleUnwrappedCoordinates(this._source.tileID).map((t1)=>new e.aA(t1.canonical.z, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y));
                    else if (0 !== this.tileCoverLift) {
                        const r = t1.clone();
                        r.tileCoverLift = this.tileCoverLift, a = r.coveringTiles({
                            tileSize: i || this._source.tileSize,
                            minzoom: this._source.minzoom,
                            maxzoom: this._source.maxzoom,
                            roundZoom: this._source.roundZoom && !o,
                            reparseOverscaled: this._source.reparseOverscaled,
                            isTerrainDEM: this.usedForTerrain,
                            calculateQuadrantVisibility: s
                        }), this._source.minzoom <= 1 && "globe" === t1.projection.name && (a.push(new e.aA(1, 0, 1, 0, 0)), a.push(new e.aA(1, 0, 1, 1, 0)), a.push(new e.aA(1, 0, 1, 0, 1)), a.push(new e.aA(1, 0, 1, 1, 1)));
                    } else if (a = t1.coveringTiles({
                        tileSize: i || this._source.tileSize,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom && !o,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain,
                        calculateQuadrantVisibility: s
                    }), this._source.hasTile) {
                        const e = this._source.hasTile.bind(this._source);
                        a = a.filter((t1)=>e(t1));
                    }
                } else a = [];
                if (a.length > 0 && this.castsShadows && r && "globe" !== this.transform.projection.name && !this.usedForTerrain && !yt(this._source.type)) {
                    const e = t1.coveringZoomLevel({
                        tileSize: i || this._source.tileSize,
                        roundZoom: this._source.roundZoom && !o
                    }), n = Math.min(e, this._source.maxzoom);
                    if (s) {
                        const e = t1.extendTileCover(a, n);
                        for (const t1 of e)a.push(t1);
                    } else {
                        const e = t1.extendTileCover(a, n, r);
                        for (const t1 of e)this._shadowCasterTiles[t1.key] = !0, a.push(t1);
                    }
                }
                const n = this._updateRetainedTiles(a);
                if (yt(this._source.type) && 0 !== a.length) {
                    const t1 = {}, i = {}, o = Object.keys(n);
                    for (const r of o){
                        const o = n[r], s = this._tiles[r];
                        if (!s || s.fadeEndTime && s.fadeEndTime <= e.q.now()) continue;
                        const a = this.findLoadedParent(o, Math.max(o.overscaledZ - vt.maxOverzooming, this._source.minzoom));
                        a && (this._addTile(a.tileID), t1[a.tileID.key] = a.tileID), i[r] = o;
                    }
                    const r = a[a.length - 1].overscaledZ;
                    for(const e in this._tiles){
                        const t1 = this._tiles[e];
                        if (n[e] || !t1.hasData()) continue;
                        let o = t1.tileID;
                        for(; o.overscaledZ > r;){
                            o = o.scaledTo(o.overscaledZ - 1);
                            const r = this._tiles[o.key];
                            if (r && r.hasData() && i[o.key]) {
                                n[e] = t1.tileID;
                                break;
                            }
                        }
                    }
                    for(const e in t1)n[e] || (this._coveredTiles[e] = !0, n[e] = t1[e]);
                }
                for(const e in n)this._tiles[e].clearFadeHold();
                const l = e.be(this._tiles, n);
                for (const e of l){
                    const t1 = this._tiles[e];
                    t1.hasSymbolBuckets && !t1.holdingForFade() ? t1.setHoldDuration(this.map._fadeDuration) : t1.hasSymbolBuckets && !t1.symbolFadeFinished() || this._removeTile(+e);
                }
                this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
            }
            releaseSymbolFadeTiles() {
                for(const e in this._tiles)this._tiles[e].holdingForFade() && this._removeTile(+e);
            }
            _updateRetainedTiles(e) {
                const t1 = {};
                if (0 === e.length) return t1;
                const i = {}, o = e.reduce((e, t1)=>Math.min(e, t1.overscaledZ), 1 / 0), r = e[0].overscaledZ, s = Math.max(r - vt.maxOverzooming, this._source.minzoom), a = Math.max(r + vt.maxUnderzooming, this._source.minzoom), n = {};
                for (const i of e){
                    const e = this._addTile(i);
                    t1[i.key] = i, e.hasData() || o < this._source.maxzoom && (n[i.key] = i);
                }
                this._retainLoadedChildren(n, o, a, t1);
                for (const o of e){
                    let e = this._tiles[o.key];
                    if (e.hasData()) continue;
                    if (o.canonical.z >= this._source.maxzoom) {
                        const e = o.children(this._source.maxzoom)[0], i = this.getTile(e);
                        if (i && i.hasData()) {
                            t1[e.key] = e;
                            continue;
                        }
                    } else {
                        const e = o.children(this._source.maxzoom);
                        if (t1[e[0].key] && t1[e[1].key] && t1[e[2].key] && t1[e[3].key]) continue;
                    }
                    let r = e.wasRequested();
                    for(let a = o.overscaledZ - 1; a >= s; --a){
                        const s = o.scaledTo(a);
                        if (i[s.key]) break;
                        if (i[s.key] = !0, e = this.getTile(s), !e && r && (e = this._addTile(s)), e && (t1[s.key] = s, r = e.wasRequested(), e.hasData())) break;
                    }
                }
                return t1;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const e in this._tiles){
                    const t1 = [];
                    let i, o = this._tiles[e].tileID;
                    for(; o.overscaledZ > 0;){
                        if (o.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[o.key];
                            break;
                        }
                        t1.push(o.key);
                        const e = o.scaledTo(o.overscaledZ - 1);
                        if (i = this._getLoadedTile(e), i) break;
                        o = e;
                    }
                    for (const e of t1)this._loadedParentTiles[e] = i;
                }
            }
            _addTile(t1) {
                let i = this._tiles[t1.key];
                if (i) return !0 !== i.isExtraShadowCaster || !!this._shadowCasterTiles[t1.key] || this._reloadTile(t1.key, "reloading"), i;
                i = this._cache.getAndRemove(t1), i && (this._setTileReloadTimer(t1.key, i), i.tileID = t1, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[t1.key] && (clearTimeout(this._cacheTimers[t1.key]), delete this._cacheTimers[t1.key], this._setTileReloadTimer(t1.key, i)));
                const o = Boolean(i);
                if (!o) {
                    const e = this.map ? this.map.painter : null, o = this._source.tileSize * t1.overscaleFactor();
                    i = "raster-array" === this._source.type ? new mt(t1, o, this.transform.tileZoom, e, this._isRaster) : new pt(t1, o, this.transform.tileZoom, e, this._isRaster), this._loadTile(i, this._tileLoaded.bind(this, i, t1.key, i.state));
                }
                return i ? (i.uses++, this._tiles[t1.key] = i, o || this._source.fire(new e.x("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i) : null;
            }
            _setTileReloadTimer(e, t1) {
                e in this._timers && (clearTimeout(this._timers[e]), delete this._timers[e]);
                const i = t1.getExpiryTimeout();
                i && (this._timers[e] = setTimeout(()=>{
                    this._reloadTile(e, "expired"), delete this._timers[e];
                }, i));
            }
            _removeTile(e) {
                const t1 = this._tiles[e];
                t1 && (t1.uses--, delete this._tiles[e], this._timers[e] && (clearTimeout(this._timers[e]), delete this._timers[e]), t1.uses > 0 || (t1.hasData() && "reloading" !== t1.state || "empty" === t1.state ? this._cache.add(t1.tileID, t1, t1.getExpiryTimeout()) : (t1.aborted = !0, this._abortTile(t1), this._unloadTile(t1))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const e in this._tiles)this._removeTile(+e);
                this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
            }
            tilesIn(t1, i, o) {
                const r = [], s = this.transform;
                if (!s) return r;
                const a = "globe" === s.projection.name, n = e.am(s.center.lng);
                for(const l in this._tiles){
                    const c = this._tiles[l];
                    if (o && c.clearQueryDebugViz(), c.holdingForFade()) continue;
                    let h;
                    if (a) {
                        const t1 = c.tileID.canonical;
                        if (0 === t1.z) {
                            const i = [
                                Math.abs(e.ap(n, ...bt(t1, -1)) - n),
                                Math.abs(e.ap(n, ...bt(t1, 1)) - n)
                            ];
                            h = [
                                0,
                                2 * i.indexOf(Math.min(...i)) - 1
                            ];
                        } else {
                            const i = [
                                Math.abs(e.ap(n, ...bt(t1, -1)) - n),
                                Math.abs(e.ap(n, ...bt(t1, 0)) - n),
                                Math.abs(e.ap(n, ...bt(t1, 1)) - n)
                            ];
                            h = [
                                i.indexOf(Math.min(...i)) - 1
                            ];
                        }
                    } else h = [
                        0
                    ];
                    for (const e of h){
                        const o = t1.containsTile(c, s, i, e);
                        o && r.push(o);
                    }
                }
                return r;
            }
            getShadowCasterCoordinates() {
                return this._getRenderableCoordinates(!1, !0);
            }
            getVisibleCoordinates(e) {
                return this._getRenderableCoordinates(e);
            }
            _getRenderableCoordinates(e, t1) {
                const i = this.getRenderableIds(e, t1).map((e)=>this._tiles[e].tileID), o = "globe" === this.transform.projection.name;
                for (const e of i)e.projMatrix = this.transform.calculateProjMatrix(e.toUnwrapped()), e.expandedProjMatrix = o ? this.transform.calculateProjMatrix(e.toUnwrapped(), !1, !0) : e.projMatrix;
                return i;
            }
            sortCoordinatesByDistance(e) {
                const t1 = e.slice(), i = this.transform._camera.position, o = this.transform._camera.forward(), r = {};
                for (const e of t1){
                    const t1 = 1 / (1 << e.canonical.z);
                    r[e.key] = ((e.canonical.x + .5) * t1 + e.wrap - i[0]) * o[0] + ((e.canonical.y + .5) * t1 - i[1]) * o[1] - i[2] * o[2];
                }
                return t1.sort((e, t1)=>r[e.key] - r[t1.key]), t1;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (yt(this._source.type)) for(const t1 in this._tiles){
                    const i = this._tiles[t1];
                    if (void 0 !== i.fadeEndTime && i.fadeEndTime >= e.q.now()) return !0;
                }
                return !1;
            }
            setFeatureState(e, t1, i) {
                this._state.updateState(e = e || "_geojsonTileLayer", t1, i);
            }
            removeFeatureState(e, t1, i) {
                this._state.removeFeatureState(e = e || "_geojsonTileLayer", t1, i);
            }
            getFeatureState(e, t1) {
                return this._state.getState(e = e || "_geojsonTileLayer", t1);
            }
            setDependencies(e, t1, i) {
                const o = this._tiles[e];
                o && o.setDependencies(t1, i);
            }
            reloadTilesForDependencies(e, t1) {
                for(const i in this._tiles)this._tiles[i].hasDependency(e, t1) && this._reloadTile(+i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(e, t1));
            }
            _preloadTiles(t1, i) {
                if (!this._sourceLoaded) {
                    const e = ()=>{
                        this._sourceLoaded && (this._source.off("data", e), this._preloadTiles(t1, i));
                    };
                    return void this._source.on("data", e);
                }
                const o = new Map, r = Array.isArray(t1) ? t1 : [
                    t1
                ], s = this.map.painter.terrain, a = this.usedForTerrain && s ? s.getScaledDemTileSize() : this._source.tileSize;
                for (const e of r){
                    const t1 = e.coveringTiles({
                        tileSize: a,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom && !this.usedForTerrain,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain
                    });
                    for (const e of t1)o.set(e.key, e);
                    this.usedForTerrain && e.updateElevation(!1);
                }
                const n = Array.from(o.values());
                e.bf(n, (e, t1)=>{
                    const i = new pt(e, this._source.tileSize * e.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster);
                    this._loadTile(i, (e)=>{
                        "raster-dem" === this._source.type && i.dem && this._backfillDEM(i), t1(e, i);
                    });
                }, i);
            }
        }
        function xt(e, t1) {
            const i = Math.abs(2 * e.wrap) - +(e.wrap < 0), o = Math.abs(2 * t1.wrap) - +(t1.wrap < 0);
            return e.overscaledZ - t1.overscaledZ || o - i || t1.canonical.y - e.canonical.y || t1.canonical.x - e.canonical.x;
        }
        function yt(e) {
            return "raster" === e || "image" === e || "video" === e || "custom" === e;
        }
        function bt(e, t1) {
            const i = 1 << e.z;
            return [
                e.x / i + t1,
                (e.x + 1) / i + t1
            ];
        }
        vt.maxOverzooming = 10, vt.maxUnderzooming = 3;
        class wt {
            constructor(e){
                this.style = e, this.layersGotHidden = !1, this.layers = [];
            }
            processLayersChanged() {
                this.layers = [];
                const e = !1, t1 = !1;
                for(const i in this.style._mergedLayers){
                    const o = this.style._mergedLayers[i];
                    if ("fill-extrusion" === o.type) this.layers.push({
                        layer: o,
                        visible: e,
                        visibilityChanged: t1
                    });
                    else if ("model" === o.type) {
                        const i = this.style.getLayerSource(o);
                        i && "batched-model" === i.type && this.layers.push({
                            layer: o,
                            visible: e,
                            visibilityChanged: t1
                        });
                    }
                }
            }
            onNewFrame(e) {
                this.layersGotHidden = !1;
                for (const t1 of this.layers){
                    const i = t1.layer;
                    let o = !1;
                    "fill-extrusion" === i.type ? o = !i.isHidden(e) && i.paint.get("fill-extrusion-opacity") > 0 : "model" === i.type && (o = !i.isHidden(e) && i.paint.get("model-opacity") > 0), this.layersGotHidden = this.layersGotHidden || !o && t1.visible, t1.visible = o;
                }
            }
            updateZOffset(e, t1) {
                this.currentBuildingBuckets = [];
                for (const e of this.layers){
                    const i = e.layer, o = this.style.getLayerSourceCache(i);
                    let r = 1;
                    "fill-extrusion" === i.type && (r = e.visible ? i.paint.get("fill-extrusion-vertical-scale") : 0);
                    let s = o ? o.getTile(t1) : null;
                    if (!s && o && t1.canonical.z > o.getSource().minzoom) {
                        let e = t1.scaledTo(Math.min(o.getSource().maxzoom, t1.overscaledZ - 1));
                        for(; e.overscaledZ >= o.getSource().minzoom && (s = o.getTile(e), !s && 0 !== e.overscaledZ);)e = e.scaledTo(e.overscaledZ - 1);
                    }
                    this.currentBuildingBuckets.push({
                        bucket: s ? s.getBucket(i) : null,
                        tileID: s ? s.tileID : t1,
                        verticalScale: r
                    });
                }
                e.hasAnyZOffset = !1;
                let i = !1;
                for(let o = 0; o < e.symbolInstances.length; o++){
                    const r = e.symbolInstances.get(o), s = r.zOffset, a = this._getHeightAtTileOffset(t1, r.tileAnchorX, r.tileAnchorY);
                    r.zOffset = a !== Number.NEGATIVE_INFINITY ? a : s, i || s === r.zOffset || (i = !0), e.hasAnyZOffset || 0 === r.zOffset || (e.hasAnyZOffset = !0);
                }
                i && (e.zOffsetBuffersNeedUpload = !0, e.zOffsetSortDirty = !0);
            }
            _mapCoordToOverlappingTile(t1, i, o, r) {
                let s = i, a = o;
                if (t1.canonical.z !== r.canonical.z) {
                    const n = r.canonical, l = 1 / (1 << t1.canonical.z - n.z);
                    s = (i + t1.canonical.x * e.ab) * l - n.x * e.ab | 0, a = (o + t1.canonical.y * e.ab) * l - n.y * e.ab | 0;
                }
                return {
                    tileX: s,
                    tileY: a
                };
            }
            _getHeightAtTileOffset(e, t1, i) {
                let o, r;
                for(let s = 0; s < this.layers.length; ++s){
                    if ("fill-extrusion" !== this.layers[s].layer.type) continue;
                    const { bucket: a, tileID: n, verticalScale: l } = this.currentBuildingBuckets[s];
                    if (!a) continue;
                    const { tileX: c, tileY: h } = this._mapCoordToOverlappingTile(e, t1, i, n), u = a.getHeightAtTileCoord(c, h);
                    u && void 0 !== u.height && (u.hidden ? o = u.height : r = Math.max(u.height * l, r || 0));
                }
                if (void 0 !== r) return r;
                for(let r = 0; r < this.layers.length; ++r){
                    const s = this.layers[r];
                    if ("model" !== s.layer.type || !s.visible) continue;
                    const { bucket: a, tileID: n } = this.currentBuildingBuckets[r];
                    if (!a) continue;
                    const { tileX: l, tileY: c } = this._mapCoordToOverlappingTile(e, t1, i, n), h = a.getHeightAtTileCoord(l, c);
                    if (h && !h.hidden) return void 0 === h.height && void 0 !== o ? Math.min(h.maxHeight, o) * h.verticalScale : h.height ? h.height * h.verticalScale : Number.NEGATIVE_INFINITY;
                }
                return this.layersGotHidden ? 0 : Number.NEGATIVE_INFINITY;
            }
        }
        function Tt(t1, i) {
            const o = {};
            for(const e in t1)"ref" !== e && (o[e] = t1[e]);
            return e.bg.forEach((e)=>{
                e in i && (o[e] = i[e]);
            }), o;
        }
        function Et(e) {
            e = e.slice();
            const t1 = Object.create(null);
            for(let i = 0; i < e.length; i++)t1[e[i].id] = e[i];
            for(let i = 0; i < e.length; i++)"ref" in e[i] && (e[i] = Tt(e[i], t1[e[i].ref]));
            return e;
        }
        const Ct = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setSlot: "setSlot",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight",
            setTerrain: "setTerrain",
            setFog: "setFog",
            setCamera: "setCamera",
            setLights: "setLights",
            setProjection: "setProjection",
            addImport: "addImport",
            removeImport: "removeImport",
            updateImport: "updateImport"
        };
        function St(e, t1, i) {
            i.push({
                command: Ct.addSource,
                args: [
                    e,
                    t1[e]
                ]
            });
        }
        function It(e, t1, i) {
            t1.push({
                command: Ct.removeSource,
                args: [
                    e
                ]
            }), i[e] = !0;
        }
        function Dt(e, t1, i, o) {
            It(e, i, o), St(e, t1, i);
        }
        function Rt(t1, i, o) {
            let r;
            for(r in t1[o])if (t1[o].hasOwnProperty(r) && "data" !== r && !e.bh(t1[o][r], i[o][r])) return !1;
            for(r in i[o])if (i[o].hasOwnProperty(r) && "data" !== r && !e.bh(t1[o][r], i[o][r])) return !1;
            return !0;
        }
        function At(t1, i, o, r, s, a) {
            let n;
            for(n in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(n) && (e.bh(t1[n], i[n]) || o.push({
                command: a,
                args: [
                    r,
                    n,
                    i[n],
                    s
                ]
            }));
            for(n in i)i.hasOwnProperty(n) && !t1.hasOwnProperty(n) && (e.bh(t1[n], i[n]) || o.push({
                command: a,
                args: [
                    r,
                    n,
                    i[n],
                    s
                ]
            }));
        }
        function Lt(e) {
            return e.id;
        }
        function Pt(e, t1) {
            return e[t1.id] = t1, e;
        }
        class Mt {
            constructor(e, t1){
                this.reset(e, t1);
            }
            reset(e, t1) {
                this.points = e || [], this._distances = [
                    0
                ];
                for(let e = 1; e < this.points.length; e++)this._distances[e] = this._distances[e - 1] + this.points[e].dist(this.points[e - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(t1) {
                if (1 === this.points.length) return this.points[0];
                t1 = e.ap(t1, 0, 1);
                let i = 1, o = this._distances[i];
                const r = t1 * this.paddedLength + this.padding;
                for(; o < r && i < this._distances.length;)o = this._distances[++i];
                const s = i - 1, a = this._distances[s], n = o - a, l = n > 0 ? (r - a) / n : 0;
                return this.points[s].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        class zt {
            constructor(e, t1, i){
                const o = this.boxCells = [], r = this.circleCells = [];
                this.xCellCount = Math.ceil(e / i), this.yCellCount = Math.ceil(t1 / i);
                for(let e = 0; e < this.xCellCount * this.yCellCount; e++)o.push([]), r.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e, this.height = t1, this.xScale = this.xCellCount / e, this.yScale = this.yCellCount / t1, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e, t1, i, o, r) {
                this._forEachCell(t1, i, o, r, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e), this.bboxes.push(t1), this.bboxes.push(i), this.bboxes.push(o), this.bboxes.push(r);
            }
            insertCircle(e, t1, i, o) {
                this._forEachCell(t1 - o, i - o, t1 + o, i + o, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e), this.circles.push(t1), this.circles.push(i), this.circles.push(o);
            }
            _insertBoxCell(e, t1, i, o, r, s) {
                this.boxCells[r].push(s);
            }
            _insertCircleCell(e, t1, i, o, r, s) {
                this.circleCells[r].push(s);
            }
            _query(e, t1, i, o, r, s) {
                if (i < 0 || e > this.width || o < 0 || t1 > this.height) return !r && [];
                const a = [];
                if (e <= 0 && t1 <= 0 && this.width <= i && this.height <= o) {
                    if (r) return !0;
                    for(let e = 0; e < this.boxKeys.length; e++)a.push({
                        key: this.boxKeys[e],
                        x1: this.bboxes[4 * e],
                        y1: this.bboxes[4 * e + 1],
                        x2: this.bboxes[4 * e + 2],
                        y2: this.bboxes[4 * e + 3]
                    });
                    for(let e = 0; e < this.circleKeys.length; e++){
                        const t1 = this.circles[3 * e], i = this.circles[3 * e + 1], o = this.circles[3 * e + 2];
                        a.push({
                            key: this.circleKeys[e],
                            x1: t1 - o,
                            y1: i - o,
                            x2: t1 + o,
                            y2: i + o
                        });
                    }
                    return s ? a.filter(s) : a;
                }
                return this._forEachCell(e, t1, i, o, this._queryCell, a, {
                    hitTest: r,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, s), r ? a.length > 0 : a;
            }
            _queryCircle(e, t1, i, o, r) {
                const s = e - i, a = e + i, n = t1 - i, l = t1 + i;
                if (a < 0 || s > this.width || l < 0 || n > this.height) return !o && [];
                const c = [];
                return this._forEachCell(s, n, a, l, this._queryCellCircle, c, {
                    hitTest: o,
                    circle: {
                        x: e,
                        y: t1,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, r), o ? c.length > 0 : c;
            }
            query(e, t1, i, o, r) {
                return this._query(e, t1, i, o, !1, r);
            }
            hitTest(e, t1, i, o, r) {
                return this._query(e, t1, i, o, !0, r);
            }
            hitTestCircle(e, t1, i, o) {
                return this._queryCircle(e, t1, i, !0, o);
            }
            _queryCell(e, t1, i, o, r, s, a, n) {
                const l = a.seenUids, c = this.boxCells[r];
                if (null !== c) {
                    const r = this.bboxes;
                    for (const h of c)if (!l.box[h]) {
                        l.box[h] = !0;
                        const c = 4 * h;
                        if (e <= r[c + 2] && t1 <= r[c + 3] && i >= r[c + 0] && o >= r[c + 1] && (!n || n(this.boxKeys[h]))) {
                            if (a.hitTest) return s.push(!0), !0;
                            s.push({
                                key: this.boxKeys[h],
                                x1: r[c],
                                y1: r[c + 1],
                                x2: r[c + 2],
                                y2: r[c + 3]
                            });
                        }
                    }
                }
                const h = this.circleCells[r];
                if (null !== h) {
                    const r = this.circles;
                    for (const c of h)if (!l.circle[c]) {
                        l.circle[c] = !0;
                        const h = 3 * c;
                        if (this._circleAndRectCollide(r[h], r[h + 1], r[h + 2], e, t1, i, o) && (!n || n(this.circleKeys[c]))) {
                            if (a.hitTest) return s.push(!0), !0;
                            {
                                const e = r[h], t1 = r[h + 1], i = r[h + 2];
                                s.push({
                                    key: this.circleKeys[c],
                                    x1: e - i,
                                    y1: t1 - i,
                                    x2: e + i,
                                    y2: t1 + i
                                });
                            }
                        }
                    }
                }
            }
            _queryCellCircle(e, t1, i, o, r, s, a, n) {
                const l = a.circle, c = a.seenUids, h = this.boxCells[r];
                if (null !== h) {
                    const e = this.bboxes;
                    for (const t1 of h)if (!c.box[t1]) {
                        c.box[t1] = !0;
                        const i = 4 * t1;
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, e[i + 0], e[i + 1], e[i + 2], e[i + 3]) && (!n || n(this.boxKeys[t1]))) return s.push(!0), !0;
                    }
                }
                const u = this.circleCells[r];
                if (null !== u) {
                    const e = this.circles;
                    for (const t1 of u)if (!c.circle[t1]) {
                        c.circle[t1] = !0;
                        const i = 3 * t1;
                        if (this._circlesCollide(e[i], e[i + 1], e[i + 2], l.x, l.y, l.radius) && (!n || n(this.circleKeys[t1]))) return s.push(!0), !0;
                    }
                }
            }
            _forEachCell(e, t1, i, o, r, s, a, n) {
                const l = this._convertToXCellCoord(e), c = this._convertToYCellCoord(t1), h = this._convertToXCellCoord(i), u = this._convertToYCellCoord(o);
                for(let d = l; d <= h; d++)for(let l = c; l <= u; l++)if (r.call(this, e, t1, i, o, this.xCellCount * l + d, s, a, n)) return;
            }
            _convertToXCellCoord(e) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e * this.xScale)));
            }
            _convertToYCellCoord(e) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e * this.yScale)));
            }
            _circlesCollide(e, t1, i, o, r, s) {
                const a = o - e, n = r - t1, l = i + s;
                return l * l > a * a + n * n;
            }
            _circleAndRectCollide(e, t1, i, o, r, s, a) {
                const n = (s - o) / 2, l = Math.abs(e - (o + n));
                if (l > n + i) return !1;
                const c = (a - r) / 2, h = Math.abs(t1 - (r + c));
                if (h > c + i) return !1;
                if (l <= n || h <= c) return !0;
                const u = l - n, d = h - c;
                return u * u + d * d <= i * i;
            }
        }
        const Ot = {
            unknown: 0,
            flipRequired: 1,
            flipNotRequired: 2
        }, Ft = Math.tan(85 * Math.PI / 180);
        function kt(t1, i, o, r, s, a, n) {
            const l = e.a6.mat4.create();
            if (o) {
                if ("globe" === a.name) {
                    const t1 = e.bi(s, i);
                    e.a6.mat4.multiply(l, l, t1);
                } else {
                    const t1 = e.a6.mat2.invert([], n);
                    l[0] = t1[0], l[1] = t1[1], l[4] = t1[2], l[5] = t1[3], r || e.a6.mat4.rotateZ(l, l, s.angle);
                }
            } else e.a6.mat4.multiply(l, s.labelPlaneMatrix, t1);
            return l;
        }
        function Bt(e, t1, i, o, r, s, a) {
            const n = kt(e, t1, i, o, r, s, a);
            return "globe" === s.name && i || (n[2] = n[6] = n[10] = n[14] = 0), n;
        }
        function Nt(t1, i, o, r, s, a, n) {
            if (o) {
                if ("globe" === a.name) {
                    const l = kt(t1, i, o, r, s, a, n);
                    return e.a6.mat4.invert(l, l), e.a6.mat4.multiply(l, t1, l), l;
                }
                {
                    const i = e.a6.mat4.clone(t1), o = e.a6.mat4.identity([]);
                    return o[0] = n[0], o[1] = n[1], o[4] = n[2], o[5] = n[3], e.a6.mat4.multiply(i, i, o), r || e.a6.mat4.rotateZ(i, i, -s.angle), i;
                }
            }
            return s.glCoordMatrix;
        }
        function Ut(t1, i, o, r) {
            const s = [
                t1,
                i,
                o,
                1
            ];
            o ? e.a6.vec4.transformMat4(s, s, r) : Kt(s, s, r);
            const a = s[3];
            return s[0] /= a, s[1] /= a, s[2] /= a, s;
        }
        function Gt(e, t1) {
            return Math.min(.5 + e / t1 * .5, 1.5);
        }
        function jt(e, t1) {
            const i = e[0] / e[3], o = e[1] / e[3];
            return i >= -t1[0] && i <= t1[0] && o >= -t1[1] && o <= t1[1];
        }
        function Vt(t1, i, o, r, s, a, n, l, c, h) {
            const u = o.transform, d = r ? t1.textSizeData : t1.iconSizeData, _ = e.bj(d, o.transform.zoom), p = "globe" === u.projection.name, m = [
                256 / o.width * 2 + 1,
                256 / o.height * 2 + 1
            ], f = r ? t1.text.dynamicLayoutVertexArray : t1.icon.dynamicLayoutVertexArray;
            f.clear();
            let g = null;
            p && (g = r ? t1.text.globeExtVertexArray : t1.icon.globeExtVertexArray);
            const v = t1.lineVertexArray, x = r ? t1.text.placedSymbolArray : t1.icon.placedSymbolArray, y = o.transform.width / o.transform.height;
            let b, w = !1;
            for(let r = 0; r < x.length; r++){
                const p = x.get(r), { numGlyphs: T, writingMode: E } = p;
                if (E !== e.bk.vertical || w || b === e.bk.horizontal || (w = !0), b = E, (p.hidden || E === e.bk.vertical) && !w) {
                    Yt(T, f);
                    continue;
                }
                w = !1;
                const C = new e.P(p.tileAnchorX, p.tileAnchorY);
                let { x: S, y: I, z: D } = u.projection.projectTilePoint(C.x, C.y, h.canonical);
                if (c) {
                    const [e, t1, i] = c(C);
                    S += e, I += t1, D += i;
                }
                const R = [
                    S,
                    I,
                    D,
                    1
                ];
                if (e.a6.vec4.transformMat4(R, R, i), !jt(R, m)) {
                    Yt(T, f);
                    continue;
                }
                const A = R[3], L = Gt(o.transform.getCameraToCenterDistance(u.projection), A), P = e.bl(d, _, p), M = n ? P / L : P * L, z = Ut(S, I, D, s);
                if (z[3] <= 0) {
                    Yt(T, f);
                    continue;
                }
                let O = {};
                const F = n ? null : c, k = Ht(p, M, !1, l, i, s, a, t1.glyphOffsetArray, v, f, g, z, C, O, y, F, u.projection, h, n);
                w = k.useVertical, F && k.needsFlipping && (O = {}), (k.notEnoughRoom || w || k.needsFlipping && Ht(p, M, !0, l, i, s, a, t1.glyphOffsetArray, v, f, g, z, C, O, y, F, u.projection, h, n).notEnoughRoom) && Yt(T, f);
            }
            r ? (t1.text.dynamicLayoutVertexBuffer.updateData(f), g && t1.text.globeExtVertexBuffer && t1.text.globeExtVertexBuffer.updateData(g)) : (t1.icon.dynamicLayoutVertexBuffer.updateData(f), g && t1.icon.globeExtVertexBuffer && t1.icon.globeExtVertexBuffer.updateData(g));
        }
        function qt(e, t1, i, o, r, s, a, n, l, c, h, u, d, _, p, m) {
            const { lineStartIndex: f, glyphStartIndex: g, segment: v } = n, x = g + n.numGlyphs, y = f + n.lineLength, b = t1.getoffsetX(g), w = t1.getoffsetX(x - 1), T = Xt(e * b, i, o, r, s, a, v, f, y, l, c, h, u, d, !0, _, p, m);
            if (!T) return null;
            const E = Xt(e * w, i, o, r, s, a, v, f, y, l, c, h, u, d, !0, _, p, m);
            return E ? {
                first: T,
                last: E
            } : null;
        }
        function Zt(t1, i, o, r) {
            return t1 === e.bk.horizontal && Math.abs(r) > Math.abs(o) ? {
                useVertical: !0
            } : t1 === e.bk.vertical ? r > 0 ? {
                needsFlipping: !0
            } : null : i !== Ot.unknown && function(e, t1) {
                return 0 === e || Math.abs(t1 / e) > Ft;
            }(o, r) ? i === Ot.flipRequired ? {
                needsFlipping: !0
            } : null : o < 0 ? {
                needsFlipping: !0
            } : null;
        }
        function Ht(t1, i, o, r, s, a, n, l, c, h, u, d, _, p, m, f, g, v, x) {
            const y = i / 24, b = t1.lineOffsetX * y, w = t1.lineOffsetY * y, { lineStartIndex: T, glyphStartIndex: E, numGlyphs: C, segment: S, writingMode: I, flipState: D } = t1, R = T + t1.lineLength, A = (t1)=>{
                if (u) {
                    const [i, o, r] = t1.up, s = h.length;
                    e.bm(u, s + 0, i, o, r), e.bm(u, s + 1, i, o, r), e.bm(u, s + 2, i, o, r), e.bm(u, s + 3, i, o, r);
                }
                const [i, o, r] = t1.point;
                e.bn(h, i, o, r, t1.angle);
            };
            if (C > 1) {
                const e = qt(y, l, b, w, o, d, _, t1, c, a, p, f, !1, g, v, x);
                if (!e) return {
                    notEnoughRoom: !0
                };
                if (r && !o) {
                    let [i, o, r] = e.first.point, [s, a, l] = e.last.point;
                    [i, o] = Ut(i, o, r, n), [s, a] = Ut(s, a, l, n);
                    const c = Zt(I, D, (s - i) * m, a - o);
                    if (t1.flipState = c && c.needsFlipping ? Ot.flipRequired : Ot.flipNotRequired, c) return c;
                }
                A(e.first);
                for(let e = E + 1; e < E + C - 1; e++){
                    const t1 = Xt(y * l.getoffsetX(e), b, w, o, d, _, S, T, R, c, a, p, f, !1, !1, g, v, x);
                    if (!t1) return h.length -= 4 * (e - E), {
                        notEnoughRoom: !0
                    };
                    A(t1);
                }
                A(e.last);
            } else {
                if (r && !o) {
                    const i = Ut(_.x, _.y, 0, s), o = T + S + 1, r = new e.P(c.getx(o), c.gety(o)), a = Ut(r.x, r.y, 0, s), n = a[3] > 0 ? a : $t(_, r, i, 1, s, void 0, g, v.canonical), l = Zt(I, D, (n[0] - i[0]) * m, n[1] - i[1]);
                    if (t1.flipState = l && l.needsFlipping ? Ot.flipRequired : Ot.flipNotRequired, l) return l;
                }
                const i = Xt(y * l.getoffsetX(E), b, w, o, d, _, S, T, R, c, a, p, f, !1, !1, g, v, x);
                if (!i) return {
                    notEnoughRoom: !0
                };
                A(i);
            }
            return {};
        }
        function Wt(e, t1, i, o, r) {
            const { x: s, y: a, z: n } = o.projectTilePoint(e.x, e.y, t1);
            if (!r) return Ut(s, a, n, i);
            const [l, c, h] = r(e);
            return Ut(s + l, a + c, n + h, i);
        }
        function $t(t1, i, o, r, s, a, n, l) {
            const c = Wt(t1.sub(i)._unit()._add(t1), l, s, n, a);
            return e.a6.vec3.sub(c, o, c), e.a6.vec3.normalize(c, c), e.a6.vec3.scaleAndAdd(c, o, c, r);
        }
        function Xt(t1, i, o, r, s, a, n, l, c, h, u, d, _, p, m, f, g, v) {
            const x = r ? t1 - i : t1 + i;
            let y = x > 0 ? 1 : -1, b = 0;
            r && (y *= -1, b = Math.PI), y < 0 && (b += Math.PI);
            let w = l + n + (y > 0 ? 0 : 1) | 0, T = s, E = s, C = 0, S = 0;
            const I = Math.abs(x), D = [], R = [];
            let A = a, L = A;
            const P = ()=>$t(L, A, E, I - C + 1, u, _, f, g.canonical);
            for(; C + S <= I;){
                if (w += y, w < l || w >= c) return null;
                if (E = T, L = A, D.push(E), p && R.push(L), A = new e.P(h.getx(w), h.gety(w)), T = d[w], !T) {
                    const e = Wt(A, g.canonical, u, f, _);
                    T = e[3] > 0 ? d[w] = e : P();
                }
                C += S, S = e.a6.vec3.distance(E, T);
            }
            m && _ && (d[w] && (T = P(), S = e.a6.vec3.distance(E, T)), d[w] = T);
            const M = (I - C) / S, z = A.sub(L)._mult(M)._add(L), O = e.a6.vec3.sub([], T, E), F = e.a6.vec3.scaleAndAdd([], E, O, M);
            let k = [
                0,
                0,
                1
            ], B = O[0], N = O[1];
            if (v && (k = f.upVector(g.canonical, z.x, z.y), 0 !== k[0] || 0 !== k[1] || 1 !== k[2])) {
                const t1 = [
                    k[2],
                    0,
                    -k[0]
                ], i = e.a6.vec3.cross([], k, t1);
                e.a6.vec3.normalize(t1, t1), e.a6.vec3.normalize(i, i), B = e.a6.vec3.dot(O, t1), N = e.a6.vec3.dot(O, i);
            }
            if (o) {
                const t1 = e.a6.vec3.cross([], k, O);
                e.a6.vec3.normalize(t1, t1), e.a6.vec3.scaleAndAdd(F, F, t1, o * y);
            }
            const U = b + Math.atan2(N, B);
            return D.push(F), p && R.push(z), {
                point: F,
                angle: U,
                path: D,
                tilePath: R,
                up: k
            };
        }
        function Yt(e, t1) {
            const i = t1.length, o = i + 4 * e;
            t1.resize(o), t1.float32.fill(-1 / 0, 4 * i, 4 * o);
        }
        function Kt(e, t1, i) {
            const o = t1[0], r = t1[1];
            return e[0] = i[0] * o + i[4] * r + i[12], e[1] = i[1] * o + i[5] * r + i[13], e[3] = i[3] * o + i[7] * r + i[15], e;
        }
        const Jt = 100;
        class Qt {
            constructor(e, t1, i = new zt(e.width + 200, e.height + 200, 25), o = new zt(e.width + 200, e.height + 200, 25)){
                this.transform = e, this.grid = i, this.ignoredGrid = o, this.pitchfactor = Math.cos(e._pitch) * e.cameraToCenterDistance, this.screenRightBoundary = e.width + Jt, this.screenBottomBoundary = e.height + Jt, this.gridRightBoundary = e.width + 200, this.gridBottomBoundary = e.height + 200, this.fogState = t1;
            }
            placeCollisionBox(e, t1, i, o, r, s, a, n) {
                let l = i.projectedAnchorX, c = i.projectedAnchorY, h = i.projectedAnchorZ;
                const u = i.elevation, d = i.tileID, _ = e.getProjection();
                if (u && d) {
                    const [e, t1, o] = _.upVector(d.canonical, i.tileAnchorX, i.tileAnchorY), r = _.upVectorScale(d.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
                    l += e * u * r, c += t1 * u * r, h += o * u * r;
                }
                const p = this.projectAndGetPerspectiveRatio(a, l, c, h, i.tileID, "globe" === _.name || !!u || this.transform.pitch > 0, _), m = s * p.perspectiveRatio, f = (i.x1 * t1 + o.x - i.padding) * m + p.point.x, g = (i.y1 * t1 + o.y - i.padding) * m + p.point.y, v = (i.x2 * t1 + o.x + i.padding) * m + p.point.x, x = (i.y2 * t1 + o.y + i.padding) * m + p.point.y, y = p.perspectiveRatio <= .55 || p.occluded;
                return !this.isInsideGrid(f, g, v, x) || !r && this.grid.hitTest(f, g, v, x, n) || y ? {
                    box: [],
                    offscreen: !1,
                    occluded: p.occluded
                } : {
                    box: [
                        f,
                        g,
                        v,
                        x
                    ],
                    offscreen: this.isOffscreen(f, g, v, x),
                    occluded: !1
                };
            }
            placeCollisionCircles(t1, i, o, r, s, a, n, l, c, h, u, d, _, p, m) {
                const f = [], g = this.transform.elevation, v = t1.getProjection(), x = g ? g.getAtTileOffsetFunc(m, this.transform.center.lat, this.transform.worldSize, v) : null, y = new e.P(o.tileAnchorX, o.tileAnchorY);
                let { x: b, y: w, z: T } = v.projectTilePoint(y.x, y.y, m.canonical);
                if (x) {
                    const [e, t1, i] = x(y);
                    b += e, w += t1, T += i;
                }
                const E = "globe" === v.name, C = this.projectAndGetPerspectiveRatio(n, b, w, T, m, E || !!g || this.transform.pitch > 0, v), { perspectiveRatio: S } = C, I = (u ? a / S : a * S) / e.bq, D = Ut(b, w, T, l), R = C.signedDistanceFromCamera > 0 ? qt(I, s, o.lineOffsetX * I, o.lineOffsetY * I, !1, D, y, o, r, l, {}, g && !u ? x : null, u && !!g, v, m, u) : null;
                let A = !1, L = !1, P = !0;
                if (R && !C.occluded) {
                    const t1 = .5 * _ * S + p, o = new e.P(-100, -100), r = new e.P(this.screenRightBoundary, this.screenBottomBoundary), s = new Mt, { first: a, last: n } = R, l = a.path.length;
                    let u = [];
                    for(let e = l - 1; e >= 1; e--)u.push(a.path[e]);
                    for(let e = 1; e < n.path.length; e++)u.push(n.path[e]);
                    const m = 2.5 * t1;
                    c && (u = u.map(([e, t1, i], o)=>(x && !E && (i = x(o < l - 1 ? a.tilePath[l - 1 - o] : n.tilePath[o - l + 2])[2]), Ut(e, t1, i, c))), u.some((e)=>e[3] <= 0) && (u = []));
                    let g = [];
                    if (u.length > 0) {
                        let t1 = 1 / 0, i = -1 / 0, s = 1 / 0, a = -1 / 0;
                        for (const e of u)t1 = Math.min(t1, e[0]), s = Math.min(s, e[1]), i = Math.max(i, e[0]), a = Math.max(a, e[1]);
                        i >= o.x && t1 <= r.x && a >= o.y && s <= r.y && (g = [
                            u.map((t1)=>new e.P(t1[0], t1[1]))
                        ], (t1 < o.x || i > r.x || s < o.y || a > r.y) && (g = e.bo(g, o.x, o.y, r.x, r.y)));
                    }
                    for (const e of g){
                        s.reset(e, .25 * t1);
                        let o = 0;
                        o = s.length <= .5 * t1 ? 1 : Math.ceil(s.paddedLength / m) + 1;
                        for(let e = 0; e < o; e++){
                            const r = e / Math.max(o - 1, 1), a = s.lerp(r), n = a.x + Jt, l = a.y + Jt;
                            f.push(n, l, t1, 0);
                            const c = n - t1, u = l - t1, _ = n + t1, p = l + t1;
                            if (P = P && this.isOffscreen(c, u, _, p), L = L || this.isInsideGrid(c, u, _, p), !i && this.grid.hitTestCircle(n, l, t1, d) && (A = !0, !h)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: A,
                                occluded: !1
                            };
                        }
                    }
                }
                return {
                    circles: !h && A || !L ? [] : f,
                    offscreen: P,
                    collisionDetected: A,
                    occluded: C.occluded
                };
            }
            queryRenderedSymbols(t1) {
                if (0 === t1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let o = 1 / 0, r = 1 / 0, s = -1 / 0, a = -1 / 0;
                for (const n of t1){
                    const t1 = new e.P(n.x + Jt, n.y + Jt);
                    o = Math.min(o, t1.x), r = Math.min(r, t1.y), s = Math.max(s, t1.x), a = Math.max(a, t1.y), i.push(t1);
                }
                const n = this.grid.query(o, r, s, a).concat(this.ignoredGrid.query(o, r, s, a)), l = {}, c = {};
                for (const t1 of n){
                    const o = t1.key;
                    if (void 0 === l[o.bucketInstanceId] && (l[o.bucketInstanceId] = {}), l[o.bucketInstanceId][o.featureIndex]) continue;
                    const r = [
                        new e.P(t1.x1, t1.y1),
                        new e.P(t1.x2, t1.y1),
                        new e.P(t1.x2, t1.y2),
                        new e.P(t1.x1, t1.y2)
                    ];
                    e.bp(i, r) && (l[o.bucketInstanceId][o.featureIndex] = !0, void 0 === c[o.bucketInstanceId] && (c[o.bucketInstanceId] = []), c[o.bucketInstanceId].push(o.featureIndex));
                }
                return c;
            }
            insertCollisionBox(e, t1, i, o, r) {
                (t1 ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: r
                }, e[0], e[1], e[2], e[3]);
            }
            insertCollisionCircles(e, t1, i, o, r) {
                const s = t1 ? this.ignoredGrid : this.grid, a = {
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: r
                };
                for(let t1 = 0; t1 < e.length; t1 += 4)s.insertCircle(a, e[t1], e[t1 + 1], e[t1 + 2]);
            }
            projectAndGetPerspectiveRatio(t1, i, o, r, s, a, n) {
                const l = [
                    i,
                    o,
                    r,
                    1
                ];
                let c = !1;
                if (r || this.transform.pitch > 0) {
                    if (e.a6.vec4.transformMat4(l, l, t1), this.fogState && s && "globe" !== n.name) {
                        const t1 = function(t1, i, o, r, s, a) {
                            const n = a.calculateFogTileMatrix(s), l = [
                                i,
                                o,
                                r
                            ];
                            return e.a6.vec3.transformMat4(l, l, n), Fe(t1, e.a6.vec3.length(l), a.pitch, a._fov);
                        }(this.fogState, i, o, r, s.toUnwrapped(), this.transform);
                        c = t1 > .9;
                    }
                } else Kt(l, l, t1);
                const h = l[3];
                return {
                    point: new e.P((l[0] / h + 1) / 2 * this.transform.width + Jt, (-l[1] / h + 1) / 2 * this.transform.height + Jt),
                    perspectiveRatio: Math.min(.5 + this.transform.getCameraToCenterDistance(n) / h * .5, 1.5),
                    signedDistanceFromCamera: h,
                    occluded: a && l[2] > h || c
                };
            }
            isOffscreen(e, t1, i, o) {
                return i < Jt || e >= this.screenRightBoundary || o < Jt || t1 > this.screenBottomBoundary;
            }
            isInsideGrid(e, t1, i, o) {
                return i >= 0 && e < this.gridRightBoundary && o >= 0 && t1 < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const t1 = e.a6.mat4.identity([]);
                return e.a6.mat4.translate(t1, t1, [
                    -100,
                    -100,
                    0
                ]), t1;
            }
        }
        function ei(t1, i, o) {
            const r = i.createTileMatrix(t1, t1.worldSize, o.toUnwrapped());
            return e.a6.mat4.multiply(new Float32Array(16), t1.projMatrix, r);
        }
        function ti(e, t1, i) {
            if (t1.projection.name === i.projection.name) return e.projMatrix;
            const o = i.clone();
            return o.setProjection(t1.projection), ei(o, t1.getProjection(), e);
        }
        function ii(e, t1, i) {
            return t1.name === i.projection.name ? e.projMatrix : ei(i, t1, e);
        }
        class oi {
            constructor(e, t1, i, o){
                this.opacity = e ? Math.max(0, Math.min(1, e.opacity + (e.placed ? t1 : -t1))) : o && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class ri {
            constructor(e, t1, i, o, r, s = !1){
                this.text = new oi(e ? e.text : null, t1, i, r), this.icon = new oi(e ? e.icon : null, t1, o, r), this.clipped = s;
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class si {
            constructor(e, t1, i, o = !1){
                this.text = e, this.icon = t1, this.skipFade = i, this.clipped = o;
            }
        }
        class ai {
            constructor(){
                this.invProjMatrix = e.a6.mat4.create(), this.viewportMatrix = e.a6.mat4.create(), this.circles = [];
            }
        }
        class ni {
            constructor(e, t1, i, o, r){
                this.bucketInstanceId = e, this.featureIndex = t1, this.sourceLayerIndex = i, this.bucketIndex = o, this.tileID = r;
            }
        }
        class li {
            constructor(e){
                this.crossSourceCollisions = e, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(e) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e]) {
                    const t1 = ++this.maxGroupID;
                    this.collisionGroups[e] = {
                        ID: t1,
                        predicate: (e)=>e.collisionGroupID === t1
                    };
                }
                return this.collisionGroups[e];
            }
        }
        function ci(t1, i, o, r, s) {
            const { horizontalAlign: a, verticalAlign: n } = e.bx(t1), l = -(a - .5) * i, c = -(n - .5) * o, h = e.bw(t1, r);
            return new e.P(l + h[0] * s, c + h[1] * s);
        }
        function hi(t1, i, o, r, s) {
            const a = new e.P(t1, i);
            return o && a._rotate(r ? s : -s), a;
        }
        class ui {
            constructor(e, t1, i, o, r, s){
                this.transform = e.clone(), this.projection = e.projection.name, this.collisionIndex = new Qt(this.transform, r), this.buildingIndex = s, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = t1, this.retainedQueryData = {}, this.collisionGroups = new li(i), this.collisionCircleArrays = {}, this.prevPlacement = o, o && (o.prevPlacement = void 0), this.placedOrientations = {};
            }
            getBucketParts(t1, i, o, r) {
                const s = o.getBucket(i), a = o.latestFeatureIndex;
                if (!s || !a || i.fqid !== s.layerIds[0]) return;
                const n = s.layers[0].layout, l = s.layers[0].paint, c = o.collisionBoxArray, h = Math.pow(2, this.transform.zoom - o.tileID.overscaledZ), u = o.tileSize / e.ab, d = o.tileID.toUnwrapped();
                this.transform.setProjection(s.projection);
                const _ = (p = o.tileID, m = s.getProjection(), f = this.transform, m.name === this.projection ? f.calculateProjMatrix(p.toUnwrapped()) : ei(f, m, p));
                var p, m, f;
                const g = "map" === n.get("text-pitch-alignment"), v = "map" === n.get("text-rotation-alignment");
                i.compileFilter();
                const x = i.dynamicFilter(), y = i.dynamicFilterNeedsFeature(), b = this.transform.calculatePixelsToTileUnitsMatrix(o), w = Bt(_, o.tileID.canonical, g, v, this.transform, s.getProjection(), b);
                let T = null;
                if (g) {
                    const t1 = Nt(_, o.tileID.canonical, g, v, this.transform, s.getProjection(), b);
                    T = e.a6.mat4.multiply([], this.transform.labelPlaneMatrix, t1);
                }
                let E = null;
                x && o.latestFeatureIndex && (E = {
                    unwrappedTileID: d,
                    dynamicFilter: x,
                    dynamicFilterNeedsFeature: y
                }), this.retainedQueryData[s.bucketInstanceId] = new ni(s.bucketInstanceId, a, s.sourceLayerIndex, s.index, o.tileID);
                const C = {
                    bucket: s,
                    layout: n,
                    paint: l,
                    posMatrix: _,
                    textLabelPlaneMatrix: w,
                    labelToScreenMatrix: T,
                    clippingData: E,
                    scale: h,
                    textPixelRatio: u,
                    holdingForFade: o.holdingForFade(),
                    collisionBoxArray: c,
                    partiallyEvaluatedTextSize: e.bj(s.textSizeData, this.transform.zoom),
                    partiallyEvaluatedIconSize: e.bj(s.iconSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(s.sourceID),
                    latestFeatureIndex: o.latestFeatureIndex
                };
                if (r) for (const e of s.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: o, symbolInstanceEnd: r } = e;
                    t1.push({
                        sortKey: i,
                        symbolInstanceStart: o,
                        symbolInstanceEnd: r,
                        parameters: C
                    });
                }
                else t1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: s.symbolInstances.length,
                    parameters: C
                });
            }
            attemptAnchorPlacement(e, t1, i, o, r, s, a, n, l, c, h, u, d, _, p, m, f, g) {
                const { textOffset0: v, textOffset1: x, crossTileID: y } = u, b = [
                    v,
                    x
                ], w = ci(e, i, o, b, r), T = this.collisionIndex.placeCollisionBox(_, r, t1, hi(w.x, w.y, s, a, this.transform.angle), h, n, l, c.predicate);
                if (m) {
                    const e = _.getSymbolInstanceIconSize(g, this.transform.zoom, u.placedIconSymbolIndex);
                    if (0 === this.collisionIndex.placeCollisionBox(_, e, m, hi(w.x, w.y, s, a, this.transform.angle), h, n, l, c.predicate).box.length) return;
                }
                if (T.box.length > 0) {
                    let t1;
                    return this.prevPlacement && this.prevPlacement.variableOffsets[y] && this.prevPlacement.placements[y] && this.prevPlacement.placements[y].text && (t1 = this.prevPlacement.variableOffsets[y].anchor), this.variableOffsets[y] = {
                        textOffset: b,
                        width: i,
                        height: o,
                        anchor: e,
                        textScale: r,
                        prevAnchor: t1
                    }, this.markUsedJustification(_, e, u, p), _.allowVerticalPlacement && (this.markUsedOrientation(_, p, u), this.placedOrientations[y] = p), {
                        shift: w,
                        placedGlyphBoxes: T
                    };
                }
            }
            placeLayerBucketPart(t1, i, o, r) {
                const { bucket: s, layout: a, paint: n, posMatrix: l, textLabelPlaneMatrix: c, labelToScreenMatrix: h, clippingData: u, textPixelRatio: d, holdingForFade: _, collisionBoxArray: p, partiallyEvaluatedTextSize: m, partiallyEvaluatedIconSize: f, collisionGroup: g, latestFeatureIndex: v } = t1.parameters, x = a.get("text-optional"), y = a.get("icon-optional"), b = a.get("text-allow-overlap"), w = a.get("icon-allow-overlap"), T = "map" === a.get("text-rotation-alignment"), E = "map" === a.get("text-pitch-alignment"), C = a.get("symbol-z-elevate"), S = n.get("symbol-z-offset"), I = "sea" === n.get("symbol-elevation-reference");
                this.transform.setProjection(s.projection);
                let D = b && (w || !s.hasIconData() || y), R = w && (b || !s.hasTextData() || x);
                const A = !S.isConstant();
                !s.collisionArrays && p && s.deserializeCollisionBoxes(p), o && r && s.updateCollisionDebugBuffers(this.transform.zoom, p);
                const L = (t1, r, n)=>{
                    const { crossTileID: p, numVerticalGlyphVertices: C } = t1;
                    let L = null;
                    if (u && u.dynamicFilterNeedsFeature || A) {
                        const e = this.retainedQueryData[s.bucketInstanceId];
                        L = v.loadFeature({
                            featureIndex: t1.featureIndex,
                            bucketIndex: e.bucketIndex,
                            sourceLayerIndex: e.sourceLayerIndex,
                            layoutVertexArrayOffset: 0
                        });
                    }
                    if (u && !(0, u.dynamicFilter)({
                        zoom: this.transform.zoom,
                        pitch: this.transform.pitch
                    }, L, this.retainedQueryData[s.bucketInstanceId].tileID.canonical, new e.P(t1.tileAnchorX, t1.tileAnchorY), this.transform.calculateDistanceTileData(u.unwrappedTileID))) return this.placements[p] = new si(!1, !1, !1, !0), void i.add(p);
                    const P = S.evaluate(L, {});
                    if (i.has(p)) return;
                    if (_) return void (this.placements[p] = new si(!1, !1, !1));
                    let M = !1, z = !1, O = !0, F = !1, k = !1, B = null, N = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, U = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, G = null, j = null, V = null, q = 0, Z = 0, H = 0;
                    n.textFeatureIndex ? q = n.textFeatureIndex : t1.useRuntimeCollisionCircles && (q = t1.featureIndex), n.verticalTextFeatureIndex && (Z = n.verticalTextFeatureIndex);
                    const W = (e)=>{
                        e.tileID = this.retainedQueryData[s.bucketInstanceId].tileID;
                        const i = this.transform.elevation;
                        e.elevation = I ? P : P + (i ? i.getAtTileOffset(e.tileID, e.tileAnchorX, e.tileAnchorY) : 0), e.elevation += t1.zOffset;
                    }, $ = n.textBox;
                    if ($) {
                        W($);
                        const i = (i)=>{
                            let o = e.bk.horizontal;
                            if (s.allowVerticalPlacement && !i && this.prevPlacement) {
                                const e = this.prevPlacement.placedOrientations[p];
                                e && (this.placedOrientations[p] = e, o = e, this.markUsedOrientation(s, o, t1));
                            }
                            return o;
                        }, o = (t1, i)=>{
                            if (s.allowVerticalPlacement && C > 0 && n.verticalTextBox) {
                                for (const o of s.writingModes)if (o === e.bk.vertical ? (N = i(), U = N) : N = t1(), N && N.box && N.box.length) break;
                            } else N = t1();
                        };
                        if (a.get("text-variable-anchor")) {
                            let c = a.get("text-variable-anchor");
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[p]) {
                                const e = this.prevPlacement.variableOffsets[p];
                                c.indexOf(e.anchor) > 0 && (c = c.filter((t1)=>t1 !== e.anchor), c.unshift(e.anchor));
                            }
                            const h = (e, i, o)=>{
                                const a = s.getSymbolInstanceTextSize(m, t1, this.transform.zoom, r), n = (e.x2 - e.x1) * a + 2 * e.padding, h = (e.y2 - e.y1) * a + 2 * e.padding, u = t1.hasIconTextFit && !w ? i : null;
                                u && W(u);
                                let _ = {
                                    box: [],
                                    offscreen: !1,
                                    occluded: !1
                                };
                                const p = b ? 2 * c.length : c.length;
                                for(let i = 0; i < p; ++i){
                                    const p = this.attemptAnchorPlacement(c[i % c.length], e, n, h, a, T, E, d, l, g, i >= c.length, t1, r, s, o, u, m, f);
                                    if (p && (_ = p.placedGlyphBoxes, _ && _.box && _.box.length)) {
                                        M = !0, B = p.shift;
                                        break;
                                    }
                                }
                                return _;
                            };
                            o(()=>h($, n.iconBox, e.bk.horizontal), ()=>{
                                const t1 = n.verticalTextBox;
                                return t1 && W(t1), s.allowVerticalPlacement && !(N && N.box && N.box.length) && C > 0 && t1 ? h(t1, n.verticalIconBox, e.bk.vertical) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), N && (M = N.box, O = N.offscreen, F = N.occluded);
                            const u = i(!(!N || !N.box));
                            if (!M && this.prevPlacement) {
                                const e = this.prevPlacement.variableOffsets[p];
                                e && (this.variableOffsets[p] = e, this.markUsedJustification(s, e.anchor, t1, u));
                            }
                        } else {
                            const a = (i, o)=>{
                                const a = s.getSymbolInstanceTextSize(m, t1, this.transform.zoom, r), n = this.collisionIndex.placeCollisionBox(s, a, i, new e.P(0, 0), b, d, l, g.predicate);
                                return n && n.box && n.box.length && (this.markUsedOrientation(s, o, t1), this.placedOrientations[p] = o), n;
                            };
                            o(()=>a($, e.bk.horizontal), ()=>{
                                const t1 = n.verticalTextBox;
                                return s.allowVerticalPlacement && C > 0 && t1 ? (W(t1), a(t1, e.bk.vertical)) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), i(!!(N && N.box && N.box.length));
                        }
                    }
                    if (G = N, M = G && G.box && G.box.length > 0, O = G && G.offscreen, F = G && G.occluded, t1.useRuntimeCollisionCircles) {
                        const i = s.text.placedSymbolArray.get(t1.centerJustifiedTextSymbolIndex >= 0 ? t1.centerJustifiedTextSymbolIndex : t1.verticalPlacedTextSymbolIndex), r = e.bl(s.textSizeData, m, i), n = a.get("text-padding");
                        j = this.collisionIndex.placeCollisionCircles(s, b, i, s.lineVertexArray, s.glyphOffsetArray, r, l, c, h, o, E, g.predicate, t1.collisionCircleDiameter * r / e.bq, n, this.retainedQueryData[s.bucketInstanceId].tileID), M = b || j.circles.length > 0 && !j.collisionDetected, O = O && j.offscreen, F = j.occluded;
                    }
                    if (n.iconFeatureIndex && (H = n.iconFeatureIndex), n.iconBox) {
                        const i = (i)=>{
                            W(i);
                            const o = t1.hasIconTextFit && B ? hi(B.x, B.y, T, E, this.transform.angle) : new e.P(0, 0), r = s.getSymbolInstanceIconSize(f, this.transform.zoom, t1.placedIconSymbolIndex);
                            return this.collisionIndex.placeCollisionBox(s, r, i, o, w, d, l, g.predicate);
                        };
                        U && U.box && U.box.length && n.verticalIconBox ? (V = i(n.verticalIconBox), z = V.box.length > 0) : (V = i(n.iconBox), z = V.box.length > 0), O = O && V.offscreen, k = V.occluded;
                    }
                    const X = x || 0 === t1.numHorizontalGlyphVertices && 0 === C, Y = y || 0 === t1.numIconVertices;
                    if (X || Y ? Y ? X || (z = z && M) : M = z && M : z = M = z && M, M && G && G.box && this.collisionIndex.insertCollisionBox(G.box, a.get("text-ignore-placement"), s.bucketInstanceId, U && U.box && Z ? Z : q, g.ID), z && V && this.collisionIndex.insertCollisionBox(V.box, a.get("icon-ignore-placement"), s.bucketInstanceId, H, g.ID), j && (M && this.collisionIndex.insertCollisionCircles(j.circles, a.get("text-ignore-placement"), s.bucketInstanceId, q, g.ID), o)) {
                        const e = s.bucketInstanceId;
                        let t1 = this.collisionCircleArrays[e];
                        void 0 === t1 && (t1 = this.collisionCircleArrays[e] = new ai);
                        for(let e = 0; e < j.circles.length; e += 4)t1.circles.push(j.circles[e + 0]), t1.circles.push(j.circles[e + 1]), t1.circles.push(j.circles[e + 2]), t1.circles.push(j.collisionDetected ? 1 : 0);
                    }
                    const K = "globe" !== s.projection.name;
                    D = D && (K || !F), R = R && (K || !k), this.placements[p] = new si(M || D, z || R, O || s.justReloaded), i.add(p);
                };
                if (C && this.buildingIndex && (this.buildingIndex.updateZOffset(s, this.retainedQueryData[s.bucketInstanceId].tileID), s.updateZOffset()), s.sortFeaturesByY) {
                    const t1 = s.getSortedSymbolIndexes(this.transform.angle);
                    for(let e = t1.length - 1; e >= 0; --e){
                        const i = t1[e];
                        L(s.symbolInstances.get(i), i, s.collisionArrays[i]);
                    }
                    s.hasAnyZOffset && e.w(`${s.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
                } else if (s.hasAnyZOffset) {
                    const e = s.getSortedIndexesByZOffset();
                    for(let t1 = 0; t1 < e.length; ++t1){
                        const i = e[t1];
                        L(s.symbolInstances.get(i), i, s.collisionArrays[i]);
                    }
                } else for(let e = t1.symbolInstanceStart; e < t1.symbolInstanceEnd; e++)L(s.symbolInstances.get(e), e, s.collisionArrays[e]);
                if (o && s.bucketInstanceId in this.collisionCircleArrays) {
                    const t1 = this.collisionCircleArrays[s.bucketInstanceId];
                    e.a6.mat4.invert(t1.invProjMatrix, l), t1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                s.justReloaded = !1;
            }
            markUsedJustification(t1, i, o, r) {
                const { leftJustifiedTextSymbolIndex: s, centerJustifiedTextSymbolIndex: a, rightJustifiedTextSymbolIndex: n, verticalPlacedTextSymbolIndex: l, crossTileID: c } = o, h = e.bv(i), u = r === e.bk.vertical ? l : "left" === h ? s : "center" === h ? a : "right" === h ? n : -1;
                s >= 0 && (t1.text.placedSymbolArray.get(s).crossTileID = u >= 0 && s !== u ? 0 : c), a >= 0 && (t1.text.placedSymbolArray.get(a).crossTileID = u >= 0 && a !== u ? 0 : c), n >= 0 && (t1.text.placedSymbolArray.get(n).crossTileID = u >= 0 && n !== u ? 0 : c), l >= 0 && (t1.text.placedSymbolArray.get(l).crossTileID = u >= 0 && l !== u ? 0 : c);
            }
            markUsedOrientation(t1, i, o) {
                const r = i === e.bk.horizontal || i === e.bk.horizontalOnly ? i : 0, s = i === e.bk.vertical ? i : 0, { leftJustifiedTextSymbolIndex: a, centerJustifiedTextSymbolIndex: n, rightJustifiedTextSymbolIndex: l, verticalPlacedTextSymbolIndex: c } = o, h = t1.text.placedSymbolArray;
                a >= 0 && (h.get(a).placedOrientation = r), n >= 0 && (h.get(n).placedOrientation = r), l >= 0 && (h.get(l).placedOrientation = r), c >= 0 && (h.get(c).placedOrientation = s);
            }
            commit(e) {
                this.commitTime = e, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t1 = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t1 ? t1.zoomAdjustment(this.transform.zoom) : 0;
                const o = t1 ? t1.symbolFadeChange(e) : 1, r = t1 ? t1.opacities : {}, s = t1 ? t1.variableOffsets : {}, a = t1 ? t1.placedOrientations : {};
                for(const e in this.placements){
                    const t1 = this.placements[e], s = r[e];
                    s ? (this.opacities[e] = new ri(s, o, t1.text, t1.icon, null, t1.clipped), i = i || t1.text !== s.text.placed || t1.icon !== s.icon.placed) : (this.opacities[e] = new ri(null, o, t1.text, t1.icon, t1.skipFade, t1.clipped), i = i || t1.text || t1.icon);
                }
                for(const e in r){
                    const t1 = r[e];
                    if (!this.opacities[e]) {
                        const r = new ri(t1, o, !1, !1);
                        r.isHidden() || (this.opacities[e] = r, i = i || t1.text.placed || t1.icon.placed);
                    }
                }
                for(const e in s)this.variableOffsets[e] || !this.opacities[e] || this.opacities[e].isHidden() || (this.variableOffsets[e] = s[e]);
                for(const e in a)this.placedOrientations[e] || !this.opacities[e] || this.opacities[e].isHidden() || (this.placedOrientations[e] = a[e]);
                i ? this.lastPlacementChangeTime = e : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t1 ? t1.lastPlacementChangeTime : e);
            }
            updateLayerOpacities(e, t1, i, o) {
                const r = new Set;
                for (const s of t1){
                    const t1 = s.getBucket(e);
                    t1 && s.latestFeatureIndex && e.fqid === t1.layerIds[0] && (this.updateBucketOpacities(t1, r, s, s.collisionBoxArray, i, o, s.tileID, e.scope), t1.layers[0].layout.get("symbol-z-elevate") && this.buildingIndex && (this.buildingIndex.updateZOffset(t1, s.tileID), t1.updateZOffset()));
                }
            }
            updateBucketOpacities(t1, i, o, r, s, a, n, l) {
                t1.hasTextData() && t1.text.opacityVertexArray.clear(), t1.hasIconData() && t1.icon.opacityVertexArray.clear(), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexArray.clear(), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexArray.clear();
                const c = t1.layers[0].layout, h = t1.layers[0].paint, u = !!t1.layers[0].dynamicFilter(), d = new ri(null, 0, !1, !1, !0), _ = c.get("text-allow-overlap"), p = c.get("icon-allow-overlap"), m = c.get("text-variable-anchor"), f = "map" === c.get("text-rotation-alignment"), g = "map" === c.get("text-pitch-alignment"), v = h.get("symbol-z-offset"), x = "sea" === h.get("symbol-elevation-reference"), y = !v.isConstant(), b = new ri(null, 0, _ && (p || !t1.hasIconData() || c.get("icon-optional")), p && (_ || !t1.hasTextData() || c.get("text-optional")), !0);
                !t1.collisionArrays && r && (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) && t1.deserializeCollisionBoxes(r);
                const w = (e, t1, i)=>{
                    for(let o = 0; o < t1 / 4; o++)e.opacityVertexArray.emplaceBack(i);
                };
                let T = 0;
                a && t1.updateReplacement(n, a);
                for(let r = 0; r < t1.symbolInstances.length; r++){
                    const c = t1.symbolInstances.get(r), { numHorizontalGlyphVertices: h, numVerticalGlyphVertices: _, crossTileID: p, numIconVertices: E, tileAnchorX: C, tileAnchorY: S } = c;
                    let I = null;
                    if (c && y) {
                        const e = this.retainedQueryData[t1.bucketInstanceId];
                        I = o.latestFeatureIndex.loadFeature({
                            featureIndex: c.featureIndex,
                            bucketIndex: e.bucketIndex,
                            sourceLayerIndex: e.sourceLayerIndex,
                            layoutVertexArrayOffset: 0
                        });
                    }
                    const D = v.evaluate(I, {}), R = i.has(p);
                    let A = this.opacities[p];
                    R ? A = d : A || (A = b, this.opacities[p] = A), i.add(p);
                    const L = h > 0 || _ > 0, P = E > 0, M = this.placedOrientations[p], z = M === e.bk.vertical, O = M === e.bk.horizontal || M === e.bk.horizontalOnly;
                    !L && !P || A.isHidden() || T++;
                    let F = !1;
                    if ((L || P) && a) for (const i of t1.activeReplacements){
                        if (e.br(i, s, e.bs.Symbol, l)) continue;
                        if (i.min.x > C || C > i.max.x || i.min.y > S || S > i.max.y) continue;
                        const t1 = e.bt(C, S, n.canonical, i.footprintTileId.canonical);
                        if (F = e.bu(t1, i.footprint), F) break;
                    }
                    if (L) {
                        const e = F ? bi : yi(A.text);
                        w(t1.text, h, z ? bi : e), w(t1.text, _, O ? bi : e);
                        const i = A.text.isHidden(), { leftJustifiedTextSymbolIndex: o, centerJustifiedTextSymbolIndex: r, rightJustifiedTextSymbolIndex: s, verticalPlacedTextSymbolIndex: a } = c, n = t1.text.placedSymbolArray, l = i || z ? 1 : 0;
                        o >= 0 && (n.get(o).hidden = l), r >= 0 && (n.get(r).hidden = l), s >= 0 && (n.get(s).hidden = l), a >= 0 && (n.get(a).hidden = i || O ? 1 : 0);
                        const u = this.variableOffsets[p];
                        u && this.markUsedJustification(t1, u.anchor, c, M);
                        const d = this.placedOrientations[p];
                        d && (this.markUsedJustification(t1, "left", c, d), this.markUsedOrientation(t1, d, c));
                    }
                    if (P) {
                        const e = F ? bi : yi(A.icon), { placedIconSymbolIndex: i, verticalPlacedIconSymbolIndex: o } = c, r = t1.icon.placedSymbolArray, s = A.icon.isHidden() ? 1 : 0;
                        i >= 0 && (w(t1.icon, E, z ? bi : e), r.get(i).hidden = s), o >= 0 && (w(t1.icon, c.numVerticalIconVertices, O ? bi : e), r.get(o).hidden = s);
                    }
                    if (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) {
                        const i = t1.collisionArrays[r];
                        if (i) {
                            let o = new e.P(0, 0), r = !0;
                            if (i.textBox || i.verticalTextBox) {
                                if (m) {
                                    const e = this.variableOffsets[p];
                                    e ? (o = ci(e.anchor, e.width, e.height, e.textOffset, e.textScale), f && o._rotate(g ? this.transform.angle : -this.transform.angle)) : r = !1;
                                }
                                u && (r = !A.clipped), i.textBox && di(t1.textCollisionBox.collisionVertexArray, A.text.placed, !r || z, D, x, o.x, o.y), i.verticalTextBox && di(t1.textCollisionBox.collisionVertexArray, A.text.placed, !r || O, D, x, o.x, o.y);
                            }
                            const s = r && Boolean(!O && i.verticalIconBox);
                            i.iconBox && di(t1.iconCollisionBox.collisionVertexArray, A.icon.placed, s, D, x, c.hasIconTextFit ? o.x : 0, c.hasIconTextFit ? o.y : 0), i.verticalIconBox && di(t1.iconCollisionBox.collisionVertexArray, A.icon.placed, !s, D, x, c.hasIconTextFit ? o.x : 0, c.hasIconTextFit ? o.y : 0);
                        }
                    }
                }
                if (t1.fullyClipped = 0 === T, t1.sortFeatures(this.transform.angle), this.retainedQueryData[t1.bucketInstanceId] && (this.retainedQueryData[t1.bucketInstanceId].featureSortOrder = t1.featureSortOrder), t1.hasTextData() && t1.text.opacityVertexBuffer && t1.text.opacityVertexBuffer.updateData(t1.text.opacityVertexArray), t1.hasIconData() && t1.icon.opacityVertexBuffer && t1.icon.opacityVertexBuffer.updateData(t1.icon.opacityVertexArray), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexBuffer && t1.iconCollisionBox.collisionVertexBuffer.updateData(t1.iconCollisionBox.collisionVertexArray), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexBuffer && t1.textCollisionBox.collisionVertexBuffer.updateData(t1.textCollisionBox.collisionVertexArray), t1.bucketInstanceId in this.collisionCircleArrays) {
                    const e = this.collisionCircleArrays[t1.bucketInstanceId];
                    t1.placementInvProjMatrix = e.invProjMatrix, t1.placementViewportMatrix = e.viewportMatrix, t1.collisionCircleArray = e.circles, delete this.collisionCircleArrays[t1.bucketInstanceId];
                }
            }
            symbolFadeChange(e) {
                return 0 === this.fadeDuration ? 1 : (e - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e) {
                return Math.max(0, (this.transform.zoom - e) / 1.5);
            }
            hasTransitions(e) {
                return this.stale || e - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e, t1) {
                const i = this.zoomAtLastRecencyCheck === t1 ? 1 - this.zoomAdjustment(t1) : 1;
                return this.zoomAtLastRecencyCheck = t1, this.commitTime + this.fadeDuration * i > e;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function di(e, t1, i, o, r, s, a) {
            e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, s || 0, a || 0, o, r ? 1 : 0), e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, s || 0, a || 0, o, r ? 1 : 0), e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, s || 0, a || 0, o, r ? 1 : 0), e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, s || 0, a || 0, o, r ? 1 : 0);
        }
        const _i = Math.pow(2, 25), pi = Math.pow(2, 24), mi = Math.pow(2, 17), fi = Math.pow(2, 16), gi = Math.pow(2, 9), vi = Math.pow(2, 8), xi = Math.pow(2, 1);
        function yi(e) {
            if (0 === e.opacity && !e.placed) return 0;
            if (1 === e.opacity && e.placed) return 4294967295;
            const t1 = e.placed ? 1 : 0, i = Math.floor(127 * e.opacity);
            return i * _i + t1 * pi + i * mi + t1 * fi + i * gi + t1 * vi + i * xi + t1;
        }
        const bi = 0;
        class wi {
            constructor(e){
                this._sortAcrossTiles = "viewport-y" !== e.layout.get("symbol-z-order") && void 0 !== e.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = new Set, this._bucketParts = [];
            }
            continuePlacement(e, t1, i, o, r) {
                const s = this._bucketParts;
                for(; this._currentTileIndex < e.length;)if (t1.getBucketParts(s, o, e[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, r()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, s.sort((e, t1)=>e.sortKey - t1.sortKey)); this._currentPartIndex < s.length;){
                    const e = s[this._currentPartIndex];
                    if (t1.placeLayerBucketPart(e, this._seenCrossTileIDs, i, 0 === e.symbolInstanceStart), this._currentPartIndex++, r()) return !0;
                }
                return !1;
            }
        }
        class Ti {
            constructor(e, t1, i, o, r, s, a, n, l){
                this.placement = new ui(e, r, s, a, n, l), this._currentPlacementIndex = t1.length - 1, this._forceFullPlacement = i, this._showCollisionBoxes = o, this._done = !1;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(t1, i, o, r) {
                const s = e.q.now(), a = ()=>{
                    const t1 = e.q.now() - s;
                    return !this._forceFullPlacement && t1 > 2;
                };
                for(; this._currentPlacementIndex >= 0;){
                    const s = i[t1[this._currentPlacementIndex]], n = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === s.type && (!s.minzoom || s.minzoom <= n) && (!s.maxzoom || s.maxzoom > n)) {
                        const t1 = s, i = t1.layout.get("symbol-z-elevate"), n = void 0 !== t1.layout.get("symbol-sort-key").constantOr(1), l = t1.layout.get("symbol-z-order"), c = "viewport-y" === l || "auto" === l && !("viewport-y" !== l && n), h = t1.layout.get("text-allow-overlap") || t1.layout.get("icon-allow-overlap") || t1.layout.get("text-ignore-placement") || t1.layout.get("icon-ignore-placement"), u = c && h, d = this._inProgressLayer = this._inProgressLayer || new wi(t1), _ = e.av(s.source, s.scope);
                        if (d.continuePlacement(i || u ? r[_] : o[_], this.placement, this._showCollisionBoxes, s, a)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(e) {
                return this.placement.commit(e), this.placement;
            }
        }
        const Ei = 512 / e.ab / 2;
        class Ci {
            constructor(t1, i, o){
                this.tileID = t1, this.bucketInstanceId = o, this.index = new e.by(i.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
                const r = t1.canonical.x * e.ab, s = t1.canonical.y * e.ab;
                for(let e = 0; e < i.length; e++){
                    const { key: t1, crossTileID: o, tileAnchorX: a, tileAnchorY: n } = i.get(e), l = Math.floor((r + a) * Ei), c = Math.floor((s + n) * Ei);
                    this.index.add(l, c), this.keys.push(t1), this.crossTileIDs.push(o);
                }
                this.index.finish();
            }
            findMatches(t1, i, o) {
                const r = this.tileID.canonical.z < i.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - i.canonical.z), s = Ei / Math.pow(2, i.canonical.z - this.tileID.canonical.z), a = i.canonical.x * e.ab, n = i.canonical.y * e.ab;
                for(let e = 0; e < t1.length; e++){
                    const i = t1.get(e);
                    if (i.crossTileID) continue;
                    const { key: l, tileAnchorX: c, tileAnchorY: h } = i, u = Math.floor((a + c) * s), d = Math.floor((n + h) * s), _ = this.index.range(u - r, d - r, u + r, d + r);
                    for (const e of _){
                        const t1 = this.crossTileIDs[e];
                        if (this.keys[e] === l && !o.has(t1)) {
                            o.add(t1), i.crossTileID = t1;
                            break;
                        }
                    }
                }
            }
        }
        class Si {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class Ii {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(e) {
                const t1 = Math.round((e - this.lng) / 360);
                if (0 !== t1) for(const e in this.indexes){
                    const i = this.indexes[e], o = {};
                    for(const e in i){
                        const r = i[e];
                        r.tileID = r.tileID.unwrapTo(r.tileID.wrap + t1), o[r.tileID.key] = r;
                    }
                    this.indexes[e] = o;
                }
                this.lng = e;
            }
            addBucket(e, t1, i) {
                if (this.indexes[e.overscaledZ] && this.indexes[e.overscaledZ][e.key]) {
                    if (this.indexes[e.overscaledZ][e.key].bucketInstanceId === t1.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e.overscaledZ, this.indexes[e.overscaledZ][e.key]);
                }
                for(let e = 0; e < t1.symbolInstances.length; e++)t1.symbolInstances.get(e).crossTileID = 0;
                this.usedCrossTileIDs[e.overscaledZ] || (this.usedCrossTileIDs[e.overscaledZ] = new Set);
                const o = this.usedCrossTileIDs[e.overscaledZ];
                for(const i in this.indexes){
                    const r = this.indexes[i];
                    if (Number(i) > e.overscaledZ) for(const i in r){
                        const s = r[i];
                        s.tileID.isChildOf(e) && s.findMatches(t1.symbolInstances, e, o);
                    }
                    else {
                        const s = r[e.scaledTo(Number(i)).key];
                        s && s.findMatches(t1.symbolInstances, e, o);
                    }
                }
                for(let e = 0; e < t1.symbolInstances.length; e++){
                    const r = t1.symbolInstances.get(e);
                    r.crossTileID || (r.crossTileID = i.generate(), o.add(r.crossTileID));
                }
                return void 0 === this.indexes[e.overscaledZ] && (this.indexes[e.overscaledZ] = {}), this.indexes[e.overscaledZ][e.key] = new Ci(e, t1.symbolInstances, t1.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e, t1) {
                for (const i of t1.crossTileIDs)this.usedCrossTileIDs[e].delete(i);
            }
            removeStaleBuckets(e) {
                let t1 = !1;
                for(const i in this.indexes){
                    const o = this.indexes[i];
                    for(const r in o)e[o[r].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, o[r]), delete o[r], t1 = !0);
                }
                return t1;
            }
        }
        class Di {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new Si, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(e, t1, i, o) {
                let r = this.layerIndexes[e.fqid];
                void 0 === r && (r = this.layerIndexes[e.fqid] = new Ii);
                let s = !1;
                const a = {};
                "globe" !== o.name && r.handleWrapJump(i);
                for (const i of t1){
                    const t1 = i.getBucket(e);
                    t1 && e.fqid === t1.layerIds[0] && (t1.bucketInstanceId || (t1.bucketInstanceId = ++this.maxBucketInstanceId), r.addBucket(i.tileID, t1, this.crossTileIDs) && (s = !0), a[t1.bucketInstanceId] = !0);
                }
                return r.removeStaleBuckets(a) && (s = !0), s;
            }
            pruneUnusedLayers(e) {
                const t1 = {};
                e.forEach((e)=>{
                    t1[e] = !0;
                });
                for(const e in this.layerIndexes)t1[e] || delete this.layerIndexes[e];
            }
        }
        const Ri = 771;
        class Ai {
            constructor(e, t1, i, o){
                this.blendFunction = e, this.blendColor = t1, this.mask = i, this.blendEquation = o;
            }
        }
        Ai.Replace = [
            1,
            0,
            1,
            0
        ], Ai.disabled = new Ai(Ai.Replace, e.bz.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Ai.unblended = new Ai(Ai.Replace, e.bz.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Ai.alphaBlended = new Ai([
            1,
            Ri,
            1,
            Ri
        ], e.bz.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Ai.alphaBlendedNonPremultiplied = new Ai([
            770,
            Ri,
            770,
            Ri
        ], e.bz.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Ai.multiply = new Ai([
            774,
            0,
            774,
            0
        ], e.bz.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        class Li {
            constructor(e, t1, i){
                this.func = e, this.mask = t1, this.range = i;
            }
        }
        Li.ReadOnly = !1, Li.ReadWrite = !0, Li.disabled = new Li(519, Li.ReadOnly, [
            0,
            1
        ]);
        const Pi = 7680;
        class Mi {
            constructor(e, t1, i, o, r, s){
                this.test = e, this.ref = t1, this.mask = i, this.fail = o, this.depthFail = r, this.pass = s;
            }
        }
        Mi.disabled = new Mi({
            func: 519,
            mask: 0
        }, 0, 0, Pi, Pi, Pi);
        const zi = 1029, Oi = 2305;
        class Fi {
            constructor(e, t1, i){
                this.enable = e, this.mode = t1, this.frontFace = i;
            }
        }
        function ki(t1, i) {
            const o = e.bC(t1, 3);
            e.a6.mat4.fromQuat(t1, i), e.bE(t1, 3, o);
        }
        function Bi(t1, i) {
            const o = e.a6.quat.identity([]);
            return e.a6.quat.rotateZ(o, o, -i), e.a6.quat.rotateX(o, o, -t1), o;
        }
        function Ni(t1, i) {
            const o = [
                t1[0],
                t1[1],
                0
            ], r = [
                i[0],
                i[1],
                0
            ];
            if (e.a6.vec3.length(o) >= 1e-15) {
                const t1 = e.a6.vec3.normalize([], o);
                e.a6.vec3.scale(r, t1, e.a6.vec3.dot(r, t1)), i[0] = r[0], i[1] = r[1];
            }
            const s = e.a6.vec3.cross([], i, t1);
            if (e.a6.vec3.len(s) < 1e-15) return null;
            const a = Math.atan2(-s[1], s[0]);
            return Bi(Math.atan2(Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]), -t1[2]), a);
        }
        Fi.disabled = new Fi(!1, zi, Oi), Fi.backCCW = new Fi(!0, zi, Oi), Fi.backCW = new Fi(!0, zi, 2304), Fi.frontCW = new Fi(!0, 1028, 2304), Fi.frontCCW = new Fi(!0, 1028, Oi);
        class Ui {
            constructor(e, t1){
                this.position = e, this.orientation = t1;
            }
            get position() {
                return this._position;
            }
            set position(t1) {
                if (t1) {
                    const i = t1 instanceof e.a5 ? t1 : new e.a5(t1[0], t1[1], t1[2]);
                    this._renderWorldCopies && (i.x = e.bA(i.x, 0, 1)), this._position = i;
                } else this._position = null;
            }
            lookAtPoint(t1, i) {
                if (this.orientation = null, !this.position) return;
                const o = this.position, r = this._elevation ? this._elevation.getAtPointOrZero(e.a5.fromLngLat(t1)) : 0, s = e.a5.fromLngLat(t1, r), a = [
                    s.x - o.x,
                    s.y - o.y,
                    s.z - o.z
                ];
                i || (i = [
                    0,
                    0,
                    1
                ]), i[2] = Math.abs(i[2]), this.orientation = Ni(a, i);
            }
            setPitchBearing(t1, i) {
                this.orientation = Bi(e.bB(t1), e.bB(-i));
            }
        }
        class Gi {
            constructor(t1, i){
                this._transform = e.a6.mat4.identity([]), this.orientation = i, this.position = t1;
            }
            get mercatorPosition() {
                const t1 = this.position;
                return new e.a5(t1[0], t1[1], t1[2]);
            }
            get position() {
                const t1 = e.bC(this._transform, 3);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            set position(t1) {
                var i;
                t1 && e.bE(this._transform, 3, [
                    (i = t1)[0],
                    i[1],
                    i[2],
                    1
                ]);
            }
            get orientation() {
                return this._orientation;
            }
            set orientation(t1) {
                this._orientation = t1 || e.a6.quat.identity([]), t1 && ki(this._transform, this._orientation);
            }
            getPitchBearing() {
                const e = this.forward(), t1 = this.right();
                return {
                    bearing: Math.atan2(-t1[1], t1[0]),
                    pitch: Math.atan2(Math.sqrt(e[0] * e[0] + e[1] * e[1]), -e[2])
                };
            }
            setPitchBearing(e, t1) {
                this._orientation = Bi(e, t1), ki(this._transform, this._orientation);
            }
            forward() {
                const t1 = e.bC(this._transform, 2);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            up() {
                const t1 = e.bC(this._transform, 1);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            right() {
                const t1 = e.bC(this._transform, 0);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            getCameraToWorld(t1, i) {
                const o = new Float64Array(16);
                return e.a6.mat4.invert(o, this.getWorldToCamera(t1, i)), o;
            }
            getCameraToWorldMercator() {
                return this._transform;
            }
            getWorldToCameraPosition(t1, i, o) {
                const r = this.position;
                e.a6.vec3.scale(r, r, -t1);
                const s = new Float64Array(16);
                return e.a6.mat4.fromScaling(s, [
                    o,
                    o,
                    o
                ]), e.a6.mat4.translate(s, s, r), s[10] *= i, s;
            }
            getWorldToCamera(t1, i) {
                const o = new Float64Array(16), r = new Float64Array(4), s = this.position;
                return e.a6.quat.conjugate(r, this._orientation), e.a6.vec3.scale(s, s, -t1), e.a6.mat4.fromQuat(o, r), e.a6.mat4.translate(o, o, s), o[1] *= -1, o[5] *= -1, o[9] *= -1, o[13] *= -1, o[8] *= i, o[9] *= i, o[10] *= i, o[11] *= i, o;
            }
            getCameraToClipPerspective(t1, i, o, r) {
                const s = new Float64Array(16);
                return e.a6.mat4.perspective(s, t1, i, o, r), s;
            }
            getCameraToClipOrthographic(t1, i, o, r, s, a) {
                const n = new Float64Array(16);
                return e.a6.mat4.ortho(n, t1, i, o, r, s, a), n;
            }
            getDistanceToElevation(t1, i = !1) {
                const o = 0 === t1 ? 0 : e.bD(t1, i ? e.aM(this.position[1]) : this.position[1]), r = this.forward();
                return (o - this.position[2]) / r[2];
            }
            clone() {
                return new Gi([
                    ...this.position
                ], [
                    ...this.orientation
                ]);
            }
        }
        const ji = {
            BaseColor: 5,
            MetallicRoughness: 6,
            Normal: 7,
            Occlusion: 8,
            Emission: 9,
            LUT: 10,
            ShadowMap0: 11
        };
        class Vi {
            constructor(e = 0, t1 = 0, i = 0, o = 0){
                if (isNaN(e) || e < 0 || isNaN(t1) || t1 < 0 || isNaN(i) || i < 0 || isNaN(o) || o < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e, this.bottom = t1, this.left = i, this.right = o;
            }
            interpolate(t1, i, o) {
                return null != i.top && null != t1.top && (this.top = e.aa(t1.top, i.top, o)), null != i.bottom && null != t1.bottom && (this.bottom = e.aa(t1.bottom, i.bottom, o)), null != i.left && null != t1.left && (this.left = e.aa(t1.left, i.left, o)), null != i.right && null != t1.right && (this.right = e.aa(t1.right, i.right, o)), this;
            }
            getCenter(t1, i) {
                const o = e.ap((this.left + t1 - this.right) / 2, 0, t1), r = e.ap((this.top + i - this.bottom) / 2, 0, i);
                return new e.P(o, r);
            }
            equals(e) {
                return this.top === e.top && this.bottom === e.bottom && this.left === e.left && this.right === e.right;
            }
            clone() {
                return new Vi(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        const qi = (e, t1, i)=>(1 - i) * e + i * t1, Zi = (e)=>e * e * e * e * e;
        class Hi {
            constructor(t1, i, o, r, s, a, n){
                this.tileSize = 512, this._renderWorldCopies = void 0 === s || s, this._minZoom = t1 || 0, this._maxZoom = i || 22, this._minPitch = o ?? 0, this._maxPitch = r ?? 60, this.setProjection(a), this.setMaxBounds(n), this.width = 0, this.height = 0, this._center = new e.bK(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = !0, this._edgeInsets = new Vi, this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new Gi, this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [
                    0,
                    0,
                    0
                ], this._tileCoverLift = 0, this.freezeTileCoverage = !1, this._horizonShift = .1, this._orthographicProjectionAtLowPitch = !1;
            }
            clone() {
                const e = new Hi(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection());
                return e._elevation = this._elevation, e._centerAltitude = this._centerAltitude, e._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e.tileSize = this.tileSize, e.mercatorFromTransition = this.mercatorFromTransition, e.width = this.width, e.height = this.height, e.cameraElevationReference = this.cameraElevationReference, e._center = this._center, e._setZoom(this.zoom), e._seaLevelZoom = this._seaLevelZoom, e.angle = this.angle, e._fov = this._fov, e._pitch = this._pitch, e._nearZ = this._nearZ, e._farZ = this._farZ, e._averageElevation = this._averageElevation, e._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e._unmodified = this._unmodified, e._edgeInsets = this._edgeInsets.clone(), e._camera = this._camera.clone(), e._calcMatrices(), e.freezeTileCoverage = this.freezeTileCoverage, e.frustumCorners = this.frustumCorners, e;
            }
            get isOrthographic() {
                return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < 15;
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(e) {
                this._elevation !== e && (this._elevation = e, this._updateCameraOnTerrain(), this._calcMatrices());
            }
            get depthOcclusionForSymbolsAndCircles() {
                return "globe" !== this.projection.name && !this.isOrthographic;
            }
            updateElevation(e, t1 = !1) {
                const i = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
                (null == this._seaLevelZoom || i) && this._updateCameraOnTerrain(), (e || i) && this._constrainCamera(t1), this._calcMatrices();
            }
            getProjection() {
                return e.ar(this.projection, [
                    "name",
                    "center",
                    "parallels"
                ]);
            }
            setProjection(t1) {
                this.projectionOptions = t1 || {
                    name: "mercator"
                };
                const i = this.projection ? this.getProjection() : void 0;
                this.projection = e.bL(this.projectionOptions);
                const o = this.getProjection(), r = !e.bh(i, o);
                return r && this._calcMatrices(), this.mercatorFromTransition = !1, r;
            }
            setOrthographicProjectionAtLowPitch(e) {
                return this._orthographicProjectionAtLowPitch !== e && (this._orthographicProjectionAtLowPitch = e, this._calcMatrices(), !0);
            }
            setMercatorFromTransition() {
                const t1 = this.projection.name;
                this.mercatorFromTransition = !0, this.projectionOptions = {
                    name: "mercator"
                }, this.projection = e.bL({
                    name: "mercator"
                });
                const i = t1 !== this.projection.name;
                return i && this._calcMatrices(), i;
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(e) {
                this._minZoom !== e && (this._minZoom = e, this.zoom = Math.max(this.zoom, e));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(e) {
                this._maxZoom !== e && (this._maxZoom = e, this.zoom = Math.min(this.zoom, e));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(e) {
                this._minPitch !== e && (this._minPitch = e, this.pitch = Math.max(this.pitch, e));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(e) {
                this._maxPitch !== e && (this._maxPitch = e, this.pitch = Math.min(this.pitch, e));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies && !0 === this.projection.supportsWorldCopies;
            }
            set renderWorldCopies(e) {
                void 0 === e ? e = !0 : null === e && (e = !1), this._renderWorldCopies = e;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get cameraWorldSizeForFog() {
                const e = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e));
            }
            get cameraWorldSize() {
                const e = Math.max(this._camera.getDistanceToElevation(this._averageElevation, !0), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e));
            }
            get pixelsPerMeter() {
                return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
            }
            get cameraPixelsPerMeter() {
                return e.bD(1, this.center.lat) * this.cameraWorldSizeForFog;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new e.P(this.width, this.height);
            }
            get bearing() {
                return e.bA(this.rotation, -180, 180);
            }
            set bearing(e) {
                this.rotation = e;
            }
            get rotation() {
                return -this.angle / Math.PI * 180;
            }
            set rotation(t1) {
                const i = -t1 * Math.PI / 180;
                this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = e.a6.mat2.create(), e.a6.mat2.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(t1) {
                const i = e.ap(t1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
            }
            get aspect() {
                return this.width / this.height;
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            get fovX() {
                return this._fov;
            }
            get fovY() {
                const e = 1 / Math.tan(.5 * this.fovX);
                return 2 * Math.atan(1 / this.aspect / e);
            }
            set fov(t1) {
                t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = e.bB(t1), this._calcMatrices());
            }
            get averageElevation() {
                return this._averageElevation;
            }
            set averageElevation(e) {
                this._averageElevation = e, this._calcFogMatrices(), this._distanceTileDataCache = {};
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(e) {
                const t1 = Math.min(Math.max(e, this.minZoom), this.maxZoom);
                this._zoom !== t1 && (this._unmodified = !1, this._setZoom(t1), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
            }
            _setZoom(e) {
                this._zoom = e, this.scale = this.zoomScale(e), this.tileZoom = Math.floor(e), this.zoomFraction = e - this.tileZoom;
            }
            get tileCoverLift() {
                return this._tileCoverLift;
            }
            set tileCoverLift(e) {
                this._tileCoverLift !== e && (this._tileCoverLift = e);
            }
            _updateCameraOnTerrain() {
                const e = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, t1 = this.elevation && e === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
                if (!this._elevation || e === Number.NEGATIVE_INFINITY && (!t1 || !this._centerAltitude)) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
                const i = this._elevation;
                t1 || this._centerAltitude && this._centerAltitudeValidForExaggeration && i.exaggeration() && this._centerAltitudeValidForExaggeration !== i.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i.exaggeration(), this._centerAltitudeValidForExaggeration = i.exaggeration()) : (this._centerAltitude = e || 0, this._centerAltitudeValidForExaggeration = i.exaggeration()), this._updateSeaLevelZoom();
            }
            _updateSeaLevelZoom() {
                void 0 !== this._centerAltitudeValidForExaggeration && (this._seaLevelZoom = this._zoomFromMercatorZ((this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize));
            }
            sampleAverageElevation() {
                if (!this._elevation) return 0;
                const t1 = this._elevation, i = [
                    [
                        .5,
                        .2
                    ],
                    [
                        .3,
                        .5
                    ],
                    [
                        .5,
                        .5
                    ],
                    [
                        .7,
                        .5
                    ],
                    [
                        .5,
                        .8
                    ]
                ], o = this.horizonLineFromTop();
                let r = 0, s = 0;
                for(let a = 0; a < i.length; a++){
                    const n = new e.P(i[a][0] * this.width, o + i[a][1] * (this.height - o)), l = t1.pointCoordinate(n);
                    if (!l) continue;
                    const c = 1 / Math.hypot(l[0] - this._camera.position[0], l[1] - this._camera.position[1]);
                    r += l[3] * c, s += c;
                }
                return 0 === s ? NaN : r / s;
            }
            get center() {
                return this._center;
            }
            set center(e) {
                e.lat === this._center.lat && e.lng === this._center.lng || (this._unmodified = !1, this._center = e, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
            }
            _updateZoomFromElevation() {
                if (null == this._seaLevelZoom || !this._elevation) return;
                const e = this._seaLevelZoom, t1 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i = this.pixelsPerMeter / this.worldSize * t1, o = this._mercatorZfromZoom(e), r = this._mercatorZfromZoom(this._maxZoom), s = Math.max(o - i, r);
                this._setZoom(this._zoomFromMercatorZ(s));
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(e) {
                this._edgeInsets.equals(e) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e, 1), this._calcMatrices());
            }
            computeZoomRelativeTo(t1) {
                const i = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, t1.toAltitude()));
                let o;
                o = t1.z < this._camera.position[2] ? [
                    i.x,
                    i.y,
                    i.z
                ] : [
                    t1.x,
                    t1.y,
                    t1.z
                ];
                const r = e.a6.vec3.length(e.a6.vec3.sub([], this._camera.position, o));
                return e.ap(this._zoomFromMercatorZ(r), this._minZoom, this._maxZoom);
            }
            setFreeCameraOptions(t1) {
                if (!this.height) return;
                if (!t1.position && !t1.orientation) return;
                this._updateCameraState();
                let i = !1;
                if (t1.orientation && !e.a6.quat.exactEquals(t1.orientation, this._camera.orientation) && (i = this._setCameraOrientation(t1.orientation)), t1.position) {
                    const o = [
                        t1.position.x,
                        t1.position.y,
                        t1.position.z
                    ];
                    e.a6.vec3.exactEquals(o, this._camera.position) || (this._setCameraPosition(o), i = !0);
                }
                i && (this._updateStateFromCamera(), this.recenterOnTerrain());
            }
            getFreeCameraOptions() {
                this._updateCameraState();
                const t1 = this._camera.position, i = new Ui;
                return i.position = new e.a5(t1[0], t1[1], t1[2]), i.orientation = this._camera.orientation, i._elevation = this.elevation, i._renderWorldCopies = this.renderWorldCopies, i;
            }
            _setCameraOrientation(t1) {
                if (!e.a6.quat.length(t1)) return !1;
                e.a6.quat.normalize(t1, t1);
                const i = e.a6.vec3.transformQuat([], [
                    0,
                    0,
                    -1
                ], t1), o = e.a6.vec3.transformQuat([], [
                    0,
                    -1,
                    0
                ], t1);
                if (o[2] < 0) return !1;
                const r = Ni(i, o);
                return !!r && (this._camera.orientation = r, !0);
            }
            _setCameraPosition(t1) {
                const i = this.zoomScale(this.minZoom) * this.tileSize, o = this.zoomScale(this.maxZoom) * this.tileSize, r = this.cameraToCenterDistance;
                t1[2] = e.ap(t1[2], r / o, r / i), this._camera.position = t1;
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            get fovAboveCenter() {
                return this._fov * (.5 + this.centerOffset.y / this.height);
            }
            isPaddingEqual(e) {
                return this._edgeInsets.equals(e);
            }
            interpolatePadding(e, t1, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e, t1, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(e) {
                const t1 = (e.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e.tileSize));
                return Math.max(0, t1);
            }
            getVisibleUnwrappedCoordinates(t1) {
                const i = [
                    new e.bM(0, t1)
                ];
                if (this.renderWorldCopies) {
                    const o = this.pointCoordinate(new e.P(0, 0)), r = this.pointCoordinate(new e.P(this.width, 0)), s = this.pointCoordinate(new e.P(this.width, this.height)), a = this.pointCoordinate(new e.P(0, this.height)), n = Math.floor(Math.min(o.x, r.x, s.x, a.x)), l = Math.floor(Math.max(o.x, r.x, s.x, a.x)), c = 1;
                    for(let o = n - c; o <= l + c; o++)0 !== o && i.push(new e.bM(o, t1));
                }
                return i;
            }
            isLODDisabled(e) {
                return (!e || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
            }
            extendTileCover(t1, i, o) {
                let r = [];
                const s = void 0 !== o, a = !s;
                if (a && this.zoom < i) return r;
                if (s && 0 === o[0] && 0 === o[1]) return r;
                const n = new Set, l = (t1, i, o, s, a)=>{
                    const l = e.c1(i, t1, o, s, a);
                    n.has(l) || (r.push(new e.aA(t1, i, o, s, a)), n.add(l));
                };
                for(let e = 0; e < t1.length; e++){
                    const r = t1[e];
                    if (a && r.canonical.z !== i) continue;
                    const n = r.canonical, c = r.overscaledZ, h = r.wrap, u = 1 << n.z, d = n.x + 1 < u, _ = n.x > 0, p = n.y + 1 < u, m = n.y > 0, f = r.wrap - (_ ? 0 : 1), g = r.wrap + (d ? 0 : 1), v = _ ? n.x - 1 : u - 1, x = d ? n.x + 1 : 0;
                    if (s) o[0] < 0 ? (l(c, g, n.z, x, n.y), o[1] < 0 && p && (l(c, h, n.z, n.x, n.y + 1), l(c, g, n.z, x, n.y + 1)), o[1] > 0 && m && (l(c, h, n.z, n.x, n.y - 1), l(c, g, n.z, x, n.y - 1))) : o[0] > 0 ? (l(c, f, n.z, v, n.y), o[1] < 0 && p && (l(c, h, n.z, n.x, n.y + 1), l(c, f, n.z, v, n.y + 1)), o[1] > 0 && m && (l(c, h, n.z, n.x, n.y - 1), l(c, f, n.z, v, n.y - 1))) : o[1] < 0 && p ? l(c, h, n.z, n.x, n.y + 1) : m && l(c, h, n.z, n.x, n.y - 1);
                    else {
                        const e = r.visibleQuadrants;
                        1 & e && (l(c, f, n.z, v, n.y), m && (l(c, h, n.z, n.x, n.y - 1), l(c, f, n.z, v, n.y - 1))), 2 & e && (l(c, g, n.z, x, n.y), m && (l(c, h, n.z, n.x, n.y - 1), l(c, g, n.z, x, n.y - 1))), 4 & e && (l(c, f, n.z, v, n.y), p && (l(c, h, n.z, n.x, n.y + 1), l(c, f, n.z, v, n.y + 1))), 8 & e && (l(c, g, n.z, x, n.y), p && (l(c, h, n.z, n.x, n.y + 1), l(c, g, n.z, x, n.y + 1)));
                    }
                }
                const c = [];
                for (const e of r)r.some((t1)=>e.isChildOf(t1)) || c.push(e);
                if (r = c.filter((e)=>!t1.some((t1)=>!!(e.overscaledZ < i && t1.isChildOf(e)) || e.equals(t1) || e.isChildOf(t1))), a) {
                    const e = 1 << i, t1 = "globe" === this.projection.name ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), o = [
                        e * t1.x,
                        e * t1.y
                    ], s = 4, a = s * s;
                    r = r.filter((e)=>{
                        const t1 = e.canonical.x + .5 - o[0], i = e.canonical.y + .5 - o[1];
                        return t1 * t1 + i * i < a;
                    });
                }
                return r;
            }
            coveringTiles(t1) {
                let i = this.coveringZoomLevel(t1);
                const o = i, r = this.elevation && this.elevation.exaggeration(), s = r && !t1.isTerrainDEM, a = "mercator" === this.projection.name;
                if (void 0 !== t1.minzoom && i < t1.minzoom) return [];
                void 0 !== t1.maxzoom && i > t1.maxzoom && (i = t1.maxzoom);
                const n = this.locationCoordinate(this.center), l = this.center.lat, c = 1 << i, h = [
                    c * n.x,
                    c * n.y,
                    0
                ], u = "globe" === this.projection.name, d = !u, _ = e.bN.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i, d), p = u ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), m = c * e.bD(1, this.center.lat), f = this._camera.position[2] / e.bD(1, this.center.lat), g = [
                    c * p.x,
                    c * p.y,
                    f * (d ? 1 : m)
                ], v = u || r, x = this.cameraToCenterDistance / t1.tileSize * (t1.roundZoom ? 1 : .502), y = this.isLODDisabled(!0) ? i : 0;
                let b;
                if (this._elevation && t1.isTerrainDEM) b = 1e4 * this._elevation.exaggeration();
                else if (this._elevation) {
                    const e = this._elevation.getMinMaxForVisibleTiles();
                    b = e ? e.max : this._centerAltitude;
                } else b = this._centerAltitude;
                const w = t1.isTerrainDEM ? -b : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, T = this.projection.isReprojectedInTileSpace ? e.bO(this) : 1, E = (t1)=>{
                    const i = 1 / 4e4, o = new e.a5(t1.x + i, t1.y, t1.z), r = new e.a5(t1.x, t1.y + i, t1.z), s = t1.toLngLat(), a = o.toLngLat(), n = r.toLngLat(), l = this.locationCoordinate(s), c = this.locationCoordinate(a), h = this.locationCoordinate(n), u = Math.hypot(c.x - l.x, c.y - l.y), d = Math.hypot(h.x - l.x, h.y - l.y);
                    return Math.sqrt(u * d) * T / i;
                }, C = (t1)=>{
                    const i = b, o = w;
                    return {
                        aabb: e.bR(this, c, 0, 0, 0, t1, o, i, this.projection),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        minZ: o,
                        maxZ: i,
                        wrap: t1,
                        fullyVisible: !1
                    };
                }, S = [];
                let I = [];
                const D = i, R = t1.reparseOverscaled ? o : i, A = (f - this._centerAltitude) * m, L = (e)=>{
                    if (!this._elevation || !e.tileID || !a) return;
                    const t1 = this._elevation.getMinMaxForTile(e.tileID), i = e.aabb;
                    t1 ? (i.min[2] = t1.min, i.max[2] = t1.max, i.center[2] = (i.min[2] + i.max[2]) / 2) : (e.shouldSplit = M(e), e.shouldSplit || (i.min[2] = i.max[2] = i.center[2] = this._centerAltitude));
                }, P = (e, t1)=>{
                    if (.707 * t1 < e) return 1;
                    const i = t1 / e;
                    return i / (1.4144271570014144 + (Math.pow(1.1, i - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
                }, M = (t1)=>{
                    if (t1.zoom < y) return !0;
                    if (t1.zoom === D) return !1;
                    if (null != t1.shouldSplit) return t1.shouldSplit;
                    const i = t1.aabb.distanceX(g), r = t1.aabb.distanceY(g);
                    let n = A, c = 1;
                    if (u) {
                        n = t1.aabb.distanceZ(g);
                        const i = Math.pow(2, t1.zoom), o = e.aM((t1.y + 1) / i), r = e.aM(t1.y / i), s = Math.min(Math.max(l, o), r), a = e.c5(s) / e.c5(l);
                        if (c = s === l ? 1 / Math.max(1, this._mercatorScaleRatio - .3) : Math.min(1, a / this._mercatorScaleRatio), this.zoom <= e.c2 && t1.zoom === D - 1 && a >= .9) return !0;
                    } else if (s && (n = t1.aabb.distanceZ(g) * m), this.projection.isReprojectedInTileSpace && o <= 5) {
                        const i = Math.pow(2, t1.zoom), o = E(new e.a5((t1.x + .5) / i, (t1.y + .5) / i));
                        c = o > .85 ? 1 : o;
                    }
                    if (!a) {
                        const e = Math.sqrt(i * i + r * r + n * n);
                        let o = (1 << D - t1.zoom) * x * c;
                        return o *= P(Math.max(n, A), e), e < o;
                    }
                    let d = Number.MAX_VALUE, _ = 0;
                    const p = t1.aabb.getCorners(), f = [];
                    for (const t1 of p){
                        e.a6.vec3.sub(f, t1, g), u || (s ? f[2] *= m : f[2] = A);
                        const i = e.a6.vec3.dot(f, this._camera.forward());
                        i < d && (d = i, _ = Math.abs(f[2]));
                    }
                    let v = (1 << D - t1.zoom) * x * c;
                    if (v *= P(Math.max(_, A), d), d < v) return !0;
                    const b = t1.aabb.closestPoint(h);
                    return b[0] === h[0] && b[1] === h[1];
                };
                if (this.renderWorldCopies) for(let e = 1; e <= 3; e++)S.push(C(-e)), S.push(C(e));
                for(S.push(C(0)); S.length > 0;){
                    const o = S.pop(), r = o.x, n = o.y;
                    let l = o.fullyVisible;
                    const d = ()=>"globe" === this.projection.name && (0 === o.y || o.y === (1 << o.zoom) - 1);
                    if (!l) {
                        let t1 = v ? o.aabb.intersects(_) : o.aabb.intersectsFlat(_);
                        if (0 === t1 && d()) {
                            const i = new e.bP(o.zoom, r, n);
                            t1 = e.bQ(this, c, i, !0).intersects(_);
                        }
                        if (0 === t1) continue;
                        l = 2 === t1;
                    }
                    if (o.zoom !== D && M(o)) for(let t1 = 0; t1 < 4; t1++){
                        const i = (r << 1) + t1 % 2, h = (n << 1) + (t1 >> 1), d = {
                            aabb: a ? o.aabb.quadrant(t1) : e.bR(this, c, o.zoom + 1, i, h, o.wrap, o.minZ, o.maxZ, this.projection),
                            zoom: o.zoom + 1,
                            x: i,
                            y: h,
                            wrap: o.wrap,
                            fullyVisible: l,
                            tileID: void 0,
                            shouldSplit: void 0,
                            minZ: o.minZ,
                            maxZ: o.maxZ
                        };
                        s && !u && (d.tileID = new e.aA(o.zoom + 1 === D ? R : o.zoom + 1, o.wrap, o.zoom + 1, i, h), L(d)), S.push(d);
                    }
                    else {
                        const s = o.zoom === D ? R : o.zoom;
                        if (t1.minzoom && t1.minzoom > s) continue;
                        let a = 0;
                        if (!l) {
                            let i = v ? o.aabb.intersectsPrecise(_) : o.aabb.intersectsPreciseFlat(_);
                            if (0 === i && d()) {
                                const t1 = new e.bP(o.zoom, r, n);
                                i = e.bQ(this, c, t1, !0).intersectsPrecise(_);
                            }
                            if (0 === i) continue;
                            if (t1.calculateQuadrantVisibility) {
                                if (_.containsPoint(o.aabb.center)) a = 15;
                                else for(let e = 0; e < 4; e++)0 !== o.aabb.quadrant(e).intersects(_) && (a |= 1 << e);
                            }
                        }
                        const u = h[0] - (.5 + r + (o.wrap << o.zoom)) * (1 << i - o.zoom), p = h[1] - .5 - n, m = o.tileID ? o.tileID : new e.aA(s, o.wrap, o.zoom, r, n);
                        t1.calculateQuadrantVisibility && (m.visibleQuadrants = a), I.push({
                            tileID: m,
                            distanceSq: u * u + p * p
                        });
                    }
                }
                if (this.fogCullDistSq) {
                    const i = this.fogCullDistSq, o = this.horizonLineFromTop();
                    I = I.filter((r)=>{
                        const s = [
                            0,
                            0,
                            0,
                            1
                        ], a = [
                            e.ab,
                            e.ab,
                            0,
                            1
                        ], n = this.calculateFogTileMatrix(r.tileID.toUnwrapped());
                        e.a6.vec4.transformMat4(s, s, n), e.a6.vec4.transformMat4(a, a, n);
                        const l = e.a6.vec4.min([], s, a), c = e.a6.vec4.max([], s, a), h = e.bS(l, c);
                        if (0 === h) return !0;
                        let u = !1;
                        const d = this._elevation;
                        if (d && h > i && 0 !== o) {
                            const i = this.calculateProjMatrix(r.tileID.toUnwrapped());
                            let s;
                            t1.isTerrainDEM || (s = d.getMinMaxForTile(r.tileID)), s || (s = {
                                min: w,
                                max: b
                            });
                            const a = e.c3(this.rotation), n = [
                                a[0] * e.ab,
                                a[1] * e.ab,
                                s.max
                            ];
                            e.a6.vec3.transformMat4(n, n, i), u = (1 - n[1]) * this.height * .5 < o;
                        }
                        return h < i || u;
                    });
                }
                return I.sort((e, t1)=>e.distanceSq - t1.distanceSq).map((e)=>e.tileID);
            }
            resize(e, t1) {
                this.width = e, this.height = t1, this.pixelsToGLUnits = [
                    2 / e,
                    -2 / t1
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(e) {
                return Math.pow(2, e);
            }
            scaleZoom(e) {
                return Math.log(e) / Math.LN2;
            }
            project(t1) {
                const i = e.ap(t1.lat, -e.bT, e.bT), o = this.projection.project(t1.lng, i);
                return new e.P(o.x * this.worldSize, o.y * this.worldSize);
            }
            unproject(e) {
                return this.projection.unproject(e.x / this.worldSize, e.y / this.worldSize);
            }
            get point() {
                return this.project(this.center);
            }
            get pointMerc() {
                return this.point._div(this.worldSize);
            }
            get pixelsPerMeterRatio() {
                return this.pixelsPerMeter / e.bD(1, this.center.lat) / this.worldSize;
            }
            setLocationAtPoint(t1, i) {
                let o, r;
                const s = this.centerPoint;
                if ("globe" === this.projection.name) {
                    const e = this.worldSize;
                    o = (i.x - s.x) / e, r = (i.y - s.y) / e;
                } else {
                    const e = this.pointCoordinate(i), t1 = this.pointCoordinate(s);
                    o = e.x - t1.x, r = e.y - t1.y;
                }
                const a = this.locationCoordinate(t1);
                this.setLocation(new e.a5(a.x - o, a.y - r));
            }
            setLocation(e) {
                this.center = this.coordinateLocation(e), this.projection.wrap && (this.center = this.center.wrap());
            }
            locationPoint(e) {
                return this.projection.locationPoint(this, e);
            }
            locationPoint3D(e) {
                return this.projection.locationPoint(this, e, !0);
            }
            pointLocation(e) {
                return this.coordinateLocation(this.pointCoordinate(e));
            }
            pointLocation3D(e) {
                return this.coordinateLocation(this.pointCoordinate3D(e));
            }
            locationCoordinate(t1, i) {
                const o = i ? e.bD(i, t1.lat) : void 0, r = this.projection.project(t1.lng, t1.lat);
                return new e.a5(r.x, r.y, o);
            }
            coordinateLocation(e) {
                return this.projection.unproject(e.x, e.y);
            }
            pointRayIntersection(t1, i) {
                const o = null != i ? i : this._centerAltitude, r = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], s = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e.a6.vec4.transformMat4(r, r, this.pixelMatrixInverse), e.a6.vec4.transformMat4(s, s, this.pixelMatrixInverse);
                const a = s[3];
                e.a6.vec4.scale(r, r, 1 / r[3]), e.a6.vec4.scale(s, s, 1 / a);
                const n = r[2], l = s[2];
                return {
                    p0: r,
                    p1: s,
                    t: n === l ? 0 : (o - n) / (l - n)
                };
            }
            screenPointToMercatorRay(t1) {
                const i = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                return e.a6.vec4.transformMat4(i, i, this.pixelMatrixInverse), e.a6.vec4.transformMat4(o, o, this.pixelMatrixInverse), e.a6.vec4.scale(i, i, 1 / i[3]), e.a6.vec4.scale(o, o, 1 / o[3]), i[2] = e.bD(i[2], this._center.lat) * this.worldSize, o[2] = e.bD(o[2], this._center.lat) * this.worldSize, e.a6.vec4.scale(i, i, 1 / this.worldSize), e.a6.vec4.scale(o, o, 1 / this.worldSize), new e.aj([
                    i[0],
                    i[1],
                    i[2]
                ], e.a6.vec3.normalize([], e.a6.vec3.sub([], o, i)));
            }
            rayIntersectionCoordinate(t1) {
                const { p0: i, p1: o, t: r } = t1, s = e.bD(i[2], this._center.lat), a = e.bD(o[2], this._center.lat);
                return new e.a5(e.aa(i[0], o[0], r) / this.worldSize, e.aa(i[1], o[1], r) / this.worldSize, e.aa(s, a, r));
            }
            pointCoordinate(e, t1 = this._centerAltitude) {
                return this.projection.pointCoordinate(this, e.x, e.y, t1);
            }
            pointCoordinate3D(t1) {
                if (!this.elevation) return this.pointCoordinate(t1);
                let i = this.projection.pointCoordinate3D(this, t1.x, t1.y);
                if (i) return new e.a5(i[0], i[1], i[2]);
                let o = 0, r = this.horizonLineFromTop();
                if (t1.y > r) return this.pointCoordinate(t1);
                const s = .02 * r, a = t1.clone();
                for(let t1 = 0; t1 < 10 && r - o > s; t1++){
                    a.y = e.aa(o, r, .66);
                    const t1 = this.projection.pointCoordinate3D(this, a.x, a.y);
                    t1 ? (r = a.y, i = t1) : o = a.y;
                }
                return i ? new e.a5(i[0], i[1], i[2]) : this.pointCoordinate(t1);
            }
            isPointAboveHorizon(e) {
                return this.projection.isPointAboveHorizon(this, e);
            }
            isPointOnSurface(t1) {
                if (t1.y < 0 || t1.y > this.height || t1.x < 0 || t1.x > this.width) return !1;
                if (this.elevation || this.zoom >= e.bU) return !this.isPointAboveHorizon(t1);
                const i = this.pointCoordinate(t1);
                return i.y >= 0 && i.y <= 1;
            }
            _coordinatePoint(t1, i) {
                const o = i && this.elevation ? this.elevation.getAtPointOrZero(t1, this._centerAltitude) : this._centerAltitude, r = [
                    t1.x * this.worldSize,
                    t1.y * this.worldSize,
                    o + t1.toAltitude(),
                    1
                ];
                return e.a6.vec4.transformMat4(r, r, this.pixelMatrix), r[3] > 0 ? new e.P(r[0] / r[3], r[1] / r[3]) : new e.P(Number.MAX_VALUE, Number.MAX_VALUE);
            }
            _getBoundsNonRectangular() {
                const { top: t1, left: i } = this._edgeInsets, o = this.height - this._edgeInsets.bottom, r = this.width - this._edgeInsets.right, s = this.pointLocation3D(new e.P(i, t1)), a = this.pointLocation3D(new e.P(r, t1)), n = this.pointLocation3D(new e.P(r, o)), l = this.pointLocation3D(new e.P(i, o));
                let c = Math.min(s.lng, a.lng, n.lng, l.lng), h = Math.max(s.lng, a.lng, n.lng, l.lng), u = Math.min(s.lat, a.lat, n.lat, l.lat), d = Math.max(s.lat, a.lat, n.lat, l.lat);
                const _ = Math.pow(2, -this.zoom) / 16 * 270, p = "globe" === this.projection.name ? 1 : 4, m = (t1, i, o, r, s)=>{
                    const a = (t1 + o) / 2, n = (i + r) / 2, l = new e.P(a, n), { lng: f, lat: g } = this.pointLocation3D(l), v = Math.max(0, c - f, u - g, f - h, g - d);
                    c = Math.min(c, f), h = Math.max(h, f), u = Math.min(u, g), d = Math.max(d, g), (s < p || v > _) && (m(t1, i, a, n, s + 1), m(a, n, o, r, s + 1));
                };
                if (m(i, t1, r, t1, 1), m(r, t1, r, o, 1), m(r, o, i, o, 1), m(i, o, i, t1, 1), "globe" === this.projection.name) {
                    const [t1, i] = e.bV(this);
                    t1 ? (d = 90, h = 180, c = -180) : i && (u = -90, h = 180, c = -180);
                }
                return new e.as(new e.bK(c, u), new e.bK(h, d));
            }
            _getBoundsRectangular(t1, i) {
                const { top: o, left: r } = this._edgeInsets, s = this.height - this._edgeInsets.bottom, a = this.width - this._edgeInsets.right, n = new e.P(r, o), l = new e.P(a, o), c = new e.P(a, s), h = new e.P(r, s);
                let u = this.pointCoordinate(n, t1), d = this.pointCoordinate(l, t1);
                const _ = this.pointCoordinate(c, i), p = this.pointCoordinate(h, i), m = (e, t1)=>(t1.y - e.y) / (t1.x - e.x);
                return u.y > 1 && d.y >= 0 ? u = new e.a5((1 - p.y) / m(p, u) + p.x, 1) : u.y < 0 && d.y <= 1 && (u = new e.a5(-p.y / m(p, u) + p.x, 0)), d.y > 1 && u.y >= 0 ? d = new e.a5((1 - _.y) / m(_, d) + _.x, 1) : d.y < 0 && u.y <= 1 && (d = new e.a5(-_.y / m(_, d) + _.x, 0)), (new e.as).extend(this.coordinateLocation(u)).extend(this.coordinateLocation(d)).extend(this.coordinateLocation(p)).extend(this.coordinateLocation(_));
            }
            _getBoundsRectangularTerrain() {
                const e = this.elevation;
                if (!e.visibleDemTiles.length || e.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
                const t1 = e.visibleDemTiles.reduce((e, t1)=>{
                    if (t1.dem) {
                        const i = t1.dem.tree;
                        e.min = Math.min(e.min, i.minimums[0]), e.max = Math.max(e.max, i.maximums[0]);
                    }
                    return e;
                }, {
                    min: Number.MAX_VALUE,
                    max: 0
                });
                return this._getBoundsRectangular(t1.min * e.exaggeration(), t1.max * e.exaggeration());
            }
            getBounds() {
                return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
            }
            horizonLineFromTop(e = !0) {
                const t1 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, .1)) - this.centerOffset.y, i = this.height / 2 - t1 * (1 - this._horizonShift);
                return e ? Math.max(0, i) : i;
            }
            getMaxBounds() {
                return this.maxBounds;
            }
            setMaxBounds(t1) {
                this.maxBounds = t1, this.minLat = -e.bT, this.maxLat = e.bT, this.minLng = -180, this.maxLng = 180, t1 && (this.minLat = t1.getSouth(), this.maxLat = t1.getNorth(), this.minLng = t1.getWest(), this.maxLng = t1.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = e.am(this.minLng) * this.tileSize, this.worldMaxX = e.am(this.maxLng) * this.tileSize, this.worldMinY = e.at(this.maxLat) * this.tileSize, this.worldMaxY = e.at(this.minLat) * this.tileSize, this._constrain();
            }
            calculatePosMatrix(e, t1) {
                return this.projection.createTileMatrix(this, t1, e);
            }
            calculateDistanceTileData(t1) {
                const i = t1.key, o = this._distanceTileDataCache;
                if (o[i]) return o[i];
                const r = t1.canonical, s = 1 / this.height, a = this.cameraWorldSize, n = a / this.zoomScale(r.z), l = (r.x + Math.pow(2, r.z) * t1.wrap) * n, c = r.y * n, h = this.point;
                h.x *= a / this.worldSize, h.y *= a / this.worldSize;
                const u = this.angle, d = Math.sin(-u), _ = -Math.cos(-u);
                return o[i] = {
                    bearing: [
                        d,
                        _
                    ],
                    center: [
                        (h.x - l) * s,
                        (h.y - c) * s
                    ],
                    scale: n / e.ab * s
                }, o[i];
            }
            calculateFogTileMatrix(t1) {
                const i = t1.key, o = this._fogTileMatrixCache;
                if (o[i]) return o[i];
                const r = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, t1);
                return e.a6.mat4.multiply(r, this.worldToFogMatrix, r), o[i] = new Float32Array(r), o[i];
            }
            calculateProjMatrix(t1, i = !1, o = !1) {
                const r = t1.key;
                let s;
                if (s = o ? this._expandedProjMatrixCache : i ? this._alignedProjMatrixCache : this._projMatrixCache, s[r]) return s[r];
                const a = this.calculatePosMatrix(t1, this.worldSize);
                let n;
                return n = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : o ? this.expandedFarZProjMatrix : i ? this.alignedProjMatrix : this.projMatrix, e.a6.mat4.multiply(a, n, a), s[r] = new Float32Array(a), s[r];
            }
            calculatePixelsToTileUnitsMatrix(t1) {
                const i = t1.tileID.key, o = this._pixelsToTileUnitsCache;
                if (o[i]) return o[i];
                const r = e.bW(t1, this);
                return o[i] = r, o[i];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            globeToMercatorMatrix() {
                if ("globe" === this.projection.name) {
                    const t1 = 1 / this.worldSize, i = e.a6.mat4.fromScaling([], [
                        t1,
                        t1,
                        t1
                    ]);
                    return e.a6.mat4.multiply(i, i, this.globeMatrix), i;
                }
            }
            recenterOnTerrain() {
                if (!this._elevation || "globe" === this.projection.name) return;
                const t1 = this._elevation;
                this._updateCameraState();
                const i = e.bD(1, this._center.lat) * this.worldSize, o = this._computeCameraPosition(i), r = this._camera.forward(), s = e.bD(1, this._center.lat);
                o[2] /= s, r[2] /= s, e.a6.vec3.normalize(r, r);
                const a = t1.raycast(o, r, t1.exaggeration());
                if (a) {
                    const t1 = e.a6.vec3.scaleAndAdd([], o, r, a), i = new e.a5(t1[0], t1[1], e.bD(t1[2], e.aM(t1[1]))), n = (i.z + e.a6.vec3.length([
                        i.x - o[0],
                        i.y - o[1],
                        i.z - o[2] * s
                    ])) * this._pixelsPerMercatorPixel;
                    this._seaLevelZoom = this._zoomFromMercatorZ(n), this._centerAltitude = i.toAltitude(), this._center = this.coordinateLocation(i), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
                }
            }
            _constrainCamera(t1 = !1) {
                if (!this._elevation) return;
                const i = this._elevation, o = e.bD(1, this._center.lat) * this.worldSize, r = this._computeCameraPosition(o), s = i.getAtPointOrZero(new e.a5(...r)), a = this.pixelsPerMeter / this.worldSize * s, n = this._minimumHeightOverTerrain(), l = r[2] - a;
                if (l <= n) {
                    if (l < 0 || t1) {
                        const t1 = this.locationCoordinate(this._center, this._centerAltitude), i = [
                            r[0],
                            r[1],
                            t1.z - r[2]
                        ], o = e.a6.vec3.length(i);
                        i[2] -= (n - l) / this._pixelsPerMercatorPixel;
                        const s = e.a6.vec3.length(i);
                        if (0 === s) return;
                        e.a6.vec3.scale(i, i, o / s * this._pixelsPerMercatorPixel), this._camera.position = [
                            r[0],
                            r[1],
                            t1.z * this._pixelsPerMercatorPixel - i[2]
                        ], this._updateStateFromCamera();
                    } else this._isCameraConstrained = !0;
                }
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                const t1 = "globe" === this.projection.name || this.mercatorFromTransition;
                if (this.projection.isReprojectedInTileSpace || t1) {
                    const i = this.center;
                    return i.lat = e.ap(i.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !t1) && (i.lng = e.ap(i.lng, this.minLng, this.maxLng)), this.center = i, void (this._constraining = !1);
                }
                const i = this._unmodified, { x: o, y: r } = this.point;
                let s = 0, a = o, n = r;
                const l = this.width / 2, c = this.height / 2, h = this.worldMinY * this.scale, u = this.worldMaxY * this.scale;
                if (r - c < h && (n = h + c), r + c > u && (n = u - c), u - h < this.height && (s = Math.max(s, this.height / (u - h)), n = (u + h) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
                    const e = this.worldMinX * this.scale, t1 = this.worldMaxX * this.scale, i = this.worldSize / 2 - (e + t1) / 2;
                    a = (o + i + this.worldSize) % this.worldSize - i, a - l < e && (a = e + l), a + l > t1 && (a = t1 - l), t1 - e < this.width && (s = Math.max(s, this.width / (t1 - e)), a = (t1 + e) / 2);
                }
                a === o && n === r || (this.center = this.unproject(new e.P(a, n))), s && (this.zoom += this.scaleZoom(s)), this._constrainCamera(), this._unmodified = i, this._constraining = !1;
            }
            _minZoomForBounds() {
                let e = Math.max(0, this.scaleZoom(this.height / (this.worldMaxY - this.worldMinY)));
                return this.maxBounds && (e = Math.max(e, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e;
            }
            _maxCameraBoundsDistance() {
                return this._mercatorZfromZoom(this._minZoomForBounds());
            }
            _calcMatrices() {
                if (!this.height) return;
                const t1 = this.centerOffset, i = "globe" === this.projection.name, o = this.pixelsPerMeter;
                "globe" === this.projection.name && (this._mercatorScaleRatio = e.bD(1, this.center.lat) / e.bD(1, e.c4));
                const r = e.bX(this.projection, this.zoom, this.width, this.height, 1024);
                this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, r), this.cameraToCenterDistance = .5 / Math.tan(.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
                const s = "meters" === this.projection.zAxisUnit ? o : 1, a = this._camera.getWorldToCamera(this.worldSize, s);
                let n;
                const l = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
                if (l[8] = 2 * -t1.x / this.width, l[9] = 2 * t1.y / this.height, this.isOrthographic) {
                    let e = .5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(.5 * this._fov), i = e * this.aspect, o = -i, r = -e;
                    i -= t1.x, o -= t1.x, e += t1.y, r += t1.y, n = this._camera.getCameraToClipOrthographic(o, i, r, e, this._nearZ, this._farZ), ((e, t1, i, o)=>{
                        for(let r = 0; r < 16; r++)e[r] = qi(t1[r], i[r], o);
                    })(n, n, l, Zi(this.pitch >= 15 ? 1 : this.pitch / 15));
                } else n = l;
                const c = e.a6.mat4.mul([], l, a);
                let h = e.a6.mat4.mul([], n, a);
                if (this.projection.isReprojectedInTileSpace) {
                    const t1 = this.locationCoordinate(this.center), i = e.a6.mat4.identity([]);
                    e.a6.mat4.translate(i, i, [
                        t1.x * this.worldSize,
                        t1.y * this.worldSize,
                        0
                    ]), e.a6.mat4.multiply(i, i, e.bY(this)), e.a6.mat4.translate(i, i, [
                        -t1.x * this.worldSize,
                        -t1.y * this.worldSize,
                        0
                    ]), e.a6.mat4.multiply(h, h, i), e.a6.mat4.multiply(c, c, i), this.inverseAdjustmentMatrix = e.bZ(this);
                } else this.inverseAdjustmentMatrix = [
                    1,
                    0,
                    0,
                    1
                ];
                if (this.mercatorMatrix = e.a6.mat4.scale([], h, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize / s,
                    1
                ]), this.projMatrix = h, this.invProjMatrix = e.a6.mat4.invert(new Float64Array(16), this.projMatrix), i) {
                    const i = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
                    i[8] = 2 * -t1.x / this.width, i[9] = 2 * t1.y / this.height, this.expandedFarZProjMatrix = e.a6.mat4.mul([], i, a);
                } else this.expandedFarZProjMatrix = this.projMatrix;
                const u = e.a6.mat4.invert([], n);
                this.frustumCorners = e.b_.fromInvProjectionMatrix(u, this.horizonLineFromTop(), this.height), this.cameraFrustum = e.bN.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !i);
                const d = new Float32Array(16);
                e.a6.mat4.identity(d), e.a6.mat4.scale(d, d, [
                    1,
                    -1,
                    1
                ]), e.a6.mat4.rotateX(d, d, this._pitch), e.a6.mat4.rotateZ(d, d, this.angle);
                const _ = e.a6.mat4.perspective(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ);
                this.starsProjMatrix = e.a6.mat4.clone(_);
                const p = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
                _[8] = 2 * -t1.x / this.width, _[9] = 2 * (t1.y + p) / this.height, this.skyboxMatrix = e.a6.mat4.multiply(d, _, d);
                const m = this.point, f = m.x, g = m.y, v = this.width % 2 / 2, x = this.height % 2 / 2, y = Math.cos(this.angle), b = Math.sin(this.angle), w = f - Math.round(f) + y * v + b * x, T = g - Math.round(g) + y * x + b * v, E = new Float64Array(h);
                if (e.a6.mat4.translate(E, E, [
                    w > .5 ? w - 1 : w,
                    T > .5 ? T - 1 : T,
                    0
                ]), this.alignedProjMatrix = E, h = e.a6.mat4.create(), e.a6.mat4.scale(h, h, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), e.a6.mat4.translate(h, h, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = h, h = e.a6.mat4.create(), e.a6.mat4.scale(h, h, [
                    1,
                    -1,
                    1
                ]), e.a6.mat4.translate(h, h, [
                    -1,
                    -1,
                    0
                ]), e.a6.mat4.scale(h, h, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = h, this.pixelMatrix = e.a6.mat4.multiply(new Float64Array(16), this.labelPlaneMatrix, c), this._calcFogMatrices(), this._distanceTileDataCache = {}, h = e.a6.mat4.invert(new Float64Array(16), this.pixelMatrix), !h) throw new Error("failed to invert matrix");
                if (this.pixelMatrixInverse = h, "globe" === this.projection.name || this.mercatorFromTransition) {
                    this.globeMatrix = e.b$(this);
                    const t1 = [
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ];
                    this.globeCenterInViewSpace = e.a6.vec3.transformMat4(t1, t1, a), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
                } else this.globeMatrix = h;
                this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
            }
            _calcFogMatrices() {
                this._fogTileMatrixCache = {};
                const t1 = this.cameraWorldSizeForFog, i = this.cameraPixelsPerMeter, o = this._camera.position, r = 1 / this.height / this._pixelsPerMercatorPixel, s = [
                    t1,
                    t1,
                    i
                ];
                e.a6.vec3.scale(s, s, r), e.a6.vec3.scale(o, o, -1), e.a6.vec3.multiply(o, o, s);
                const a = e.a6.mat4.create();
                e.a6.mat4.translate(a, a, o), e.a6.mat4.scale(a, a, s), this.mercatorFogMatrix = a, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(t1, i, r);
            }
            _computeCameraPosition(e) {
                const t1 = (e = e || this.pixelsPerMeter) / this.pixelsPerMeter, i = this._camera.forward(), o = this.point, r = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t1 - e / this.worldSize * this._centerAltitude;
                return [
                    o.x / this.worldSize - i[0] * r,
                    o.y / this.worldSize - i[1] * r,
                    e / this.worldSize * this._centerAltitude - i[2] * r
                ];
            }
            _updateCameraState() {
                this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
            }
            _translateCameraConstrained(t1) {
                const i = this._maxCameraBoundsDistance() * Math.cos(this._pitch), o = this._camera.position[2], r = t1[2];
                let s = 1;
                this.projection.wrap && (this.center = this.center.wrap()), r > 0 && (s = Math.min((i - o) / r, 1)), this._camera.position = e.a6.vec3.scaleAndAdd([], this._camera.position, t1, s), this._updateStateFromCamera();
            }
            _updateStateFromCamera() {
                const t1 = this._camera.position, i = this._camera.forward(), { pitch: o, bearing: r } = this._camera.getPitchBearing(), s = e.bD(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, a = this._mercatorZfromZoom(this._maxZoom) * Math.cos(e.bB(this._maxPitch)), n = Math.max((t1[2] - s) / Math.cos(o), a), l = this._zoomFromMercatorZ(n);
                e.a6.vec3.scaleAndAdd(t1, t1, i, n), this._pitch = e.ap(o, e.bB(this.minPitch), e.bB(this.maxPitch)), this.angle = e.bA(r, -Math.PI, Math.PI), this._setZoom(e.ap(l, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new e.a5(t1[0], t1[1], t1[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
            }
            _worldSizeFromZoom(e) {
                return Math.pow(2, e) * this.tileSize;
            }
            _mercatorZfromZoom(e) {
                return this.cameraToCenterDistance / this._worldSizeFromZoom(e);
            }
            _minimumHeightOverTerrain() {
                const e = Math.min(null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom, this._maxZoom) + 4;
                return this._mercatorZfromZoom(e);
            }
            _zoomFromMercatorZ(e) {
                return this.scaleZoom(this.cameraToCenterDistance / (e * this.tileSize));
            }
            zoomFromMercatorZAdjusted(t1) {
                let i = 0, o = e.bU, r = 0, s = 1 / 0;
                for(; o - i > 1e-6 && o > i;){
                    const e = i + .5 * (o - i), a = this.tileSize * Math.pow(2, e), n = this.getCameraToCenterDistance(this.projection, e, a), l = this.scaleZoom(n / (t1 * this.tileSize)), c = Math.abs(e - l);
                    c < s && (s = c, r = e), e < l ? i = e : o = e;
                }
                return r;
            }
            _terrainEnabled() {
                return !(!this._elevation || !this.projection.supportsTerrain && (e.w("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
            }
            anyCornerOffEdge(t1, i) {
                const o = Math.min(t1.x, i.x), r = Math.max(t1.x, i.x), s = Math.min(t1.y, i.y), a = Math.max(t1.y, i.y);
                if (s < this.horizonLineFromTop(!1)) return !0;
                if ("mercator" !== this.projection.name) return !1;
                const n = [
                    new e.P(o, s),
                    new e.P(r, a),
                    new e.P(o, a),
                    new e.P(r, s)
                ], l = this.renderWorldCopies ? -3 : 0, c = this.renderWorldCopies ? 4 : 1;
                for (const e of n){
                    const t1 = this.pointRayIntersection(e);
                    if (t1.t < 0) return !0;
                    const i = this.rayIntersectionCoordinate(t1);
                    if (i.x < l || i.y < 0 || i.x > c || i.y > 1) return !0;
                }
                return !1;
            }
            isHorizonVisible() {
                return this.pitch + e.c0(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new e.P(0, 0), new e.P(this.width, this.height));
            }
            zoomDeltaToMovement(t1, i) {
                const o = e.a6.vec3.length(e.a6.vec3.sub([], this._camera.position, t1)), r = this._zoomFromMercatorZ(o) + i;
                return o - this._mercatorZfromZoom(r);
            }
            getCameraPoint() {
                if ("globe" === this.projection.name) {
                    const t1 = function([t1, i, o], r) {
                        const s = [
                            t1,
                            i,
                            o,
                            1
                        ];
                        e.a6.vec4.transformMat4(s, s, r);
                        const a = s[3] = Math.max(s[3], 1e-6);
                        return s[0] /= a, s[1] /= a, s[2] /= a, s;
                    }([
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ], this.pixelMatrix);
                    return new e.P(t1[0], t1[1]);
                }
                {
                    const t1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                    return this.centerPoint.add(new e.P(0, t1));
                }
            }
            getCameraToCenterDistance(t1, i = this.zoom, o = this.worldSize) {
                const r = e.bX(t1, i, this.width, this.height, 1024), s = t1.pixelSpaceConversion(this.center.lat, o, r);
                let a = .5 / Math.tan(.5 * this._fov) * this.height * s;
                return this.isOrthographic && (a = qi(1, a, Zi(this.pitch >= 15 ? 1 : this.pitch / 15))), a;
            }
            getWorldToCameraMatrix() {
                const t1 = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
                return "globe" === this.projection.name && e.a6.mat4.multiply(t1, t1, this.globeMatrix), t1;
            }
            getFrustum(t1) {
                return e.bN.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, t1, "meters" === this.projection.zAxisUnit);
            }
        }
        const Wi = (t1, i)=>{
            if (i > 0 && t1.terrain && e.w("Cutoff is currently disabled on terrain"), i <= 0 || t1.terrain) return {
                shouldRenderCutoff: !1,
                uniformValues: {
                    u_cutoff_params: [
                        0,
                        0,
                        0,
                        1
                    ]
                }
            };
            const o = t1.transform, r = Math.max(Math.abs(o._zoom - (t1.minCutoffZoom - 1)), 1), s = o.isLODDisabled(!1) ? e.a7(60, 45, o.pitch) : e.a7(30, 15, o.pitch), a = o._farZ - o._nearZ, n = i * o.height, l = ((1 - (c = s)) * o.cameraToCenterDistance + c * (o._farZ + n)) * r;
            var c;
            return {
                shouldRenderCutoff: s < 1,
                uniformValues: {
                    u_cutoff_params: [
                        o._nearZ,
                        o._farZ,
                        (l - o._nearZ) / a,
                        (l - n - o._nearZ) / a
                    ]
                }
            };
        }, $i = {
            cascadeCount: 2,
            normalOffset: 3,
            shadowMapResolution: 2048
        };
        class Xi {
            constructor(e, t1){
                this.aabb = e, this.lastCascade = t1;
            }
        }
        class Yi {
            add(e, t1) {
                const i = this.receivers[e.key];
                void 0 !== i ? (i.aabb.min[0] = Math.min(i.aabb.min[0], t1.min[0]), i.aabb.min[1] = Math.min(i.aabb.min[1], t1.min[1]), i.aabb.min[2] = Math.min(i.aabb.min[2], t1.min[2]), i.aabb.max[0] = Math.max(i.aabb.max[0], t1.max[0]), i.aabb.max[1] = Math.max(i.aabb.max[1], t1.max[1]), i.aabb.max[2] = Math.max(i.aabb.max[2], t1.max[2])) : this.receivers[e.key] = new Xi(t1, null);
            }
            clear() {
                this.receivers = {};
            }
            get(e) {
                return this.receivers[e.key];
            }
            computeRequiredCascades(t1, i, o) {
                const r = e.c9.fromPoints(t1.points);
                let s = 0;
                for(const t1 in this.receivers){
                    const a = this.receivers[t1];
                    if (!a) continue;
                    if (!r.intersectsAabb(a.aabb)) continue;
                    a.aabb.min = r.closestPoint(a.aabb.min), a.aabb.max = r.closestPoint(a.aabb.max);
                    const n = a.aabb.getCorners();
                    for(let t1 = 0; t1 < o.length; t1++){
                        let r = !0;
                        for (const s of n){
                            const a = [
                                s[0] * i,
                                s[1] * i,
                                s[2]
                            ];
                            if (e.a6.vec3.transformMat4(a, a, o[t1].matrix), a[0] < -1 || a[0] > 1 || a[1] < -1 || a[1] > 1) {
                                r = !1;
                                break;
                            }
                        }
                        if (a.lastCascade = t1, s = Math.max(s, t1), r) break;
                    }
                }
                return s + 1;
            }
        }
        class Ki {
            constructor(e){
                this.painter = e, this._enabled = !1, this._shadowLayerCount = 0, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new Yi, this._depthMode = new Li(e.context.gl.LEQUAL, Li.ReadWrite, [
                    0,
                    1
                ]), this._uniformValues = {
                    u_light_matrix_0: new Float32Array(16),
                    u_light_matrix_1: new Float32Array(16),
                    u_shadow_intensity: 0,
                    u_fade_range: [
                        0,
                        0
                    ],
                    u_shadow_normal_offset: [
                        1,
                        1,
                        1
                    ],
                    u_shadow_texel_size: 1,
                    u_shadow_map_resolution: 1,
                    u_shadow_direction: [
                        0,
                        0,
                        1
                    ],
                    u_shadow_bias: [
                        36e-5,
                        .0012,
                        .012
                    ],
                    u_shadowmap_0: 0,
                    u_shadowmap_1: 0
                }, this._forceDisable = !1, this.useNormalOffset = !1, e.tp.registerParameter(this, [
                    "Shadows"
                ], "_forceDisable", {
                    label: "forceDisable"
                }, ()=>{
                    this.painter.style.map.triggerRepaint();
                }), e.tp.registerParameter($i, [
                    "Shadows"
                ], "cascadeCount", {
                    min: 1,
                    max: 2,
                    step: 1
                }), e.tp.registerParameter($i, [
                    "Shadows"
                ], "normalOffset", {
                    min: 0,
                    max: 10,
                    step: .05
                }), e.tp.registerParameter($i, [
                    "Shadows"
                ], "shadowMapResolution", {
                    min: 32,
                    max: 2048,
                    step: 32
                }), e.tp.registerBinding(this, [
                    "Shadows"
                ], "_numCascadesToRender", {
                    readonly: !0,
                    label: "numCascadesToRender"
                });
            }
            destroy() {
                for (const e of this._cascades)e.texture.destroy(), e.framebuffer.destroy();
                this._cascades = [];
            }
            updateShadowParameters(t1, i) {
                const o = this.painter;
                if (this._enabled = !1, this._shadowLayerCount = 0, this._receivers.clear(), !i || !i.properties) return;
                const r = i.properties.get("shadow-intensity");
                if (!i.shadowsEnabled() || r <= 0) return;
                if (this._shadowLayerCount = o.style.order.reduce((e, i)=>{
                    const r = o.style._mergedLayers[i];
                    return e + (r.hasShadowPass() && !r.isHidden(t1.zoom) ? 1 : 0);
                }, 0), this._enabled = this._shadowLayerCount > 0, !this.enabled) return;
                const s = o.context, a = $i.shadowMapResolution, n = $i.shadowMapResolution;
                if (0 === this._cascades.length || $i.shadowMapResolution !== this._cascades[0].texture.size[0]) {
                    this._cascades = [];
                    for(let t1 = 0; t1 < $i.cascadeCount; ++t1){
                        const t1 = o._shadowMapDebug, i = s.gl, r = s.createFramebuffer(a, n, t1, "texture"), l = new e.T(s, {
                            width: a,
                            height: n,
                            data: null
                        }, i.DEPTH_COMPONENT16);
                        if (r.depthAttachment.set(l.texture), t1) {
                            const t1 = new e.T(s, {
                                width: a,
                                height: n,
                                data: null
                            }, i.RGBA8);
                            r.colorAttachment.set(t1.texture);
                        }
                        this._cascades.push({
                            framebuffer: r,
                            texture: l,
                            matrix: [],
                            far: 0,
                            boundingSphereRadius: 0,
                            frustum: new e.bN,
                            scale: 0
                        });
                    }
                }
                this.shadowDirection = Qi(i);
                let l = 0;
                if (t1.elevation) {
                    const e = t1.elevation, i = [
                        1e4,
                        -10000
                    ];
                    e.visibleDemTiles.filter((e)=>e.dem).forEach((e)=>{
                        const t1 = e.dem.tree;
                        i[0] = Math.min(i[0], t1.minimums[0]), i[1] = Math.max(i[1], t1.maximums[0]);
                    }), 1e4 !== i[0] && (l = (i[1] - i[0]) * e.exaggeration());
                }
                const c = 1.5 * t1.cameraToCenterDistance, h = 3 * c, u = new Float64Array(16);
                for(let i = 0; i < this._cascades.length; ++i){
                    const o = this._cascades[i];
                    let r = t1.height / 50, s = 1;
                    1 === $i.cascadeCount ? s = h : 0 === i ? s = c : (r = c, s = h);
                    const [a, n] = to(t1, this.shadowDirection, r, s, $i.shadowMapResolution, l);
                    o.scale = t1.scale, o.matrix = a, o.boundingSphereRadius = n, e.a6.mat4.invert(u, o.matrix), o.frustum = e.bN.fromInvProjectionMatrix(u, 1, 0, !0), o.far = s;
                }
                const d = this._cascades.length - 1;
                this._uniformValues.u_fade_range = [
                    .75 * this._cascades[d].far,
                    this._cascades[d].far
                ], this._uniformValues.u_shadow_intensity = r, this._uniformValues.u_shadow_direction = [
                    this.shadowDirection[0],
                    this.shadowDirection[1],
                    this.shadowDirection[2]
                ], this._uniformValues.u_shadow_texel_size = 1 / $i.shadowMapResolution, this._uniformValues.u_shadow_map_resolution = $i.shadowMapResolution, this._uniformValues.u_shadowmap_0 = ji.ShadowMap0, this._uniformValues.u_shadowmap_1 = ji.ShadowMap0 + 1, this._groundShadowTiles = o.transform.coveringTiles({
                    tileSize: 512,
                    renderWorldCopies: !0
                });
                const _ = o.transform.elevation;
                for (const e of this._groundShadowTiles){
                    let t1 = {
                        min: 0,
                        max: 0
                    };
                    if (_) {
                        const i = _.getMinMaxForTile(e);
                        i && (t1 = i);
                    }
                    this.addShadowReceiver(e.toUnwrapped(), t1.min, t1.max);
                }
            }
            get enabled() {
                return this._enabled && !this._forceDisable;
            }
            set enabled(e) {
                this._enabled = e;
            }
            drawShadowPass(t1, i) {
                if (!this.enabled) return;
                const o = this.painter, r = o.context;
                this._numCascadesToRender = this._receivers.computeRequiredCascades(o.transform.getFrustum(0), o.transform.worldSize, this._cascades), r.viewport.set([
                    0,
                    0,
                    $i.shadowMapResolution,
                    $i.shadowMapResolution
                ]);
                for(let s = 0; s < this._numCascadesToRender; ++s){
                    o.currentShadowCascade = s, r.bindFramebuffer.set(this._cascades[s].framebuffer.framebuffer), r.clear({
                        color: e.bz.white,
                        depth: 1
                    });
                    for (const e of t1.order){
                        const r = t1._mergedLayers[e];
                        if (!r.hasShadowPass() || r.isHidden(o.transform.zoom)) continue;
                        const s = t1.getLayerSourceCache(r), a = s ? i[s.id] : void 0;
                        ("model" === r.type || a && a.length) && o.renderLayer(o, s, r, a);
                    }
                }
                o.currentShadowCascade = 0;
            }
            drawGroundShadows() {
                if (!this.enabled) return;
                const e = this.painter, t1 = e.style, i = e.context, o = t1.directionalLight, r = t1.ambientLight;
                if (!o || !r) return;
                const s = [], a = Wi(e, e.longestCutoffRange);
                a.shouldRenderCutoff && s.push("RENDER_CUTOFF");
                const n = eo(t1, o, r), l = new Li(i.gl.LEQUAL, Li.ReadOnly, e.depthRangeFor3D);
                for (const t1 of this._groundShadowTiles){
                    const o = t1.toUnwrapped(), r = e.isTileAffectedByFog(t1), c = e.getOrCreateProgram("groundShadow", {
                        defines: s,
                        overrideFog: r
                    });
                    this.setupShadows(o, c), e.uploadCommonUniforms(i, c, o, null, a);
                    const h = {
                        u_matrix: e.transform.calculateProjMatrix(o),
                        u_ground_shadow_factor: n
                    };
                    c.draw(e, i.gl.TRIANGLES, l, Mi.disabled, Ai.multiply, Fi.disabled, h, "ground_shadow", e.tileExtentBuffer, e.quadTriangleIndexBuffer, e.tileExtentSegments, {}, e.transform.zoom, null, null);
                }
            }
            getShadowPassColorMode() {
                return this.painter._shadowMapDebug ? Ai.unblended : Ai.disabled;
            }
            getShadowPassDepthMode() {
                return this._depthMode;
            }
            getShadowCastingLayerCount() {
                return this._shadowLayerCount;
            }
            calculateShadowPassMatrixFromTile(t1) {
                const i = this.painter.transform, o = i.calculatePosMatrix(t1, i.worldSize);
                return e.a6.mat4.multiply(o, this._cascades[this.painter.currentShadowCascade].matrix, o), Float32Array.from(o);
            }
            calculateShadowPassMatrixFromMatrix(t1) {
                return e.a6.mat4.multiply(t1, this._cascades[this.painter.currentShadowCascade].matrix, t1), Float32Array.from(t1);
            }
            setupShadows(t1, i, o, r = 0) {
                if (!this.enabled) return;
                const s = this.painter.transform, a = this.painter.context, n = a.gl, l = this._uniformValues, c = new Float64Array(16), h = s.calculatePosMatrix(t1, s.worldSize);
                for(let t1 = 0; t1 < this._cascades.length; t1++)e.a6.mat4.multiply(c, this._cascades[t1].matrix, h), l[0 === t1 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(c), a.activeTexture.set(n.TEXTURE0 + ji.ShadowMap0 + t1), this._cascades[t1].texture.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                if (this.useNormalOffset = !!o, this.useNormalOffset) {
                    const i = e.c8(t1.canonical), a = 2 / s.tileSize * e.ab / $i.shadowMapResolution, n = a * this._cascades[0].boundingSphereRadius, c = a * this._cascades[this._cascades.length - 1].boundingSphereRadius, h = ("vector-tile" === o ? 1 : 3) / Math.pow(2, r - t1.canonical.z - (1 - s.zoom + Math.floor(s.zoom)));
                    l.u_shadow_normal_offset = [
                        i,
                        n * h,
                        c * h
                    ], l.u_shadow_bias = [
                        6e-5,
                        .0012,
                        .012
                    ];
                } else l.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ];
                i.setShadowUniformValues(a, l);
            }
            setupShadowsFromMatrix(t1, i, o = !1) {
                if (!this.enabled) return;
                const r = this.painter.context, s = r.gl, a = this._uniformValues, n = new Float64Array(16);
                for(let i = 0; i < $i.cascadeCount; i++)e.a6.mat4.multiply(n, this._cascades[i].matrix, t1), a[0 === i ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(n), r.activeTexture.set(s.TEXTURE0 + ji.ShadowMap0 + i), this._cascades[i].texture.bind(s.NEAREST, s.CLAMP_TO_EDGE);
                if (this.useNormalOffset = o, o) {
                    const e = $i.normalOffset;
                    a.u_shadow_normal_offset = [
                        1,
                        e,
                        e
                    ], a.u_shadow_bias = [
                        6e-5,
                        .0012,
                        .012
                    ];
                } else a.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ];
                i.setShadowUniformValues(r, a);
            }
            getShadowUniformValues() {
                return this._uniformValues;
            }
            getCurrentCascadeFrustum() {
                return this._cascades[this.painter.currentShadowCascade].frustum;
            }
            computeSimplifiedTileShadowVolume(t1, i, o, r) {
                if (r[2] >= 0) return {};
                const s = (function(t1, i, o) {
                    const r = o / (1 << t1.canonical.z);
                    return new e.c9([
                        t1.canonical.x * r + t1.wrap * o,
                        t1.canonical.y * r + t1.wrap * o,
                        0
                    ], [
                        (t1.canonical.x + 1) * r + t1.wrap * o,
                        (t1.canonical.y + 1) * r + t1.wrap * o,
                        i
                    ]);
                })(t1, i, o).getCorners(), a = i / -r[2];
                r[0] < 0 ? (e.a6.vec3.add(s[0], s[0], [
                    r[0] * a,
                    0,
                    0
                ]), e.a6.vec3.add(s[3], s[3], [
                    r[0] * a,
                    0,
                    0
                ])) : r[0] > 0 && (e.a6.vec3.add(s[1], s[1], [
                    r[0] * a,
                    0,
                    0
                ]), e.a6.vec3.add(s[2], s[2], [
                    r[0] * a,
                    0,
                    0
                ])), r[1] < 0 ? (e.a6.vec3.add(s[0], s[0], [
                    0,
                    r[1] * a,
                    0
                ]), e.a6.vec3.add(s[1], s[1], [
                    0,
                    r[1] * a,
                    0
                ])) : r[1] > 0 && (e.a6.vec3.add(s[2], s[2], [
                    0,
                    r[1] * a,
                    0
                ]), e.a6.vec3.add(s[3], s[3], [
                    0,
                    r[1] * a,
                    0
                ]));
                const n = {};
                return n.vertices = s, n.planes = [
                    Ji(s[1], s[0], s[4]),
                    Ji(s[2], s[1], s[5]),
                    Ji(s[3], s[2], s[6]),
                    Ji(s[0], s[3], s[7])
                ], n;
            }
            addShadowReceiver(t1, i, o) {
                this._receivers.add(t1, e.c9.fromTileIdAndHeight(t1, i, o));
            }
            getMaxCascadeForTile(e) {
                const t1 = this._receivers.get(e);
                return t1 && t1.lastCascade ? t1.lastCascade : 0;
            }
        }
        function Ji(t1, i, o) {
            const r = e.a6.vec3.sub([], o, i), s = e.a6.vec3.sub([], t1, i), a = e.a6.vec3.cross([], r, s), n = e.a6.vec3.length(a);
            return 0 === n ? [
                0,
                0,
                1,
                0
            ] : (e.a6.vec3.scale(a, a, 1 / n), [
                a[0],
                a[1],
                a[2],
                -e.a6.vec3.dot(a, i)
            ]);
        }
        function Qi(t1) {
            const i = t1.properties.get("direction"), o = e.c7(i.x, i.y, i.z);
            o[2] = e.ap(o[2], 0, 75);
            const r = e.ca([
                o[0],
                o[1],
                o[2]
            ]);
            return e.a6.vec3.fromValues(r.x, r.y, r.z);
        }
        function eo(t1, i, o) {
            const r = i.properties.get("color"), s = i.properties.get("intensity"), a = i.properties.get("direction"), n = [
                a.x,
                a.y,
                a.z
            ], l = o.properties.get("color"), c = o.properties.get("intensity"), h = Math.max(e.a6.vec3.dot([
                0,
                0,
                1
            ], n), 0), u = [
                0,
                0,
                0
            ];
            e.a6.vec3.scale(u, l.toRenderColor(t1.getLut(i.scope)).toArray01Linear().slice(0, 3), c);
            const d = [
                0,
                0,
                0
            ];
            return e.a6.vec3.scale(d, r.toRenderColor(t1.getLut(o.scope)).toArray01Linear().slice(0, 3), h * s), e.cb([
                u[0] > 0 ? u[0] / (u[0] + d[0]) : 0,
                u[1] > 0 ? u[1] / (u[1] + d[1]) : 0,
                u[2] > 0 ? u[2] / (u[2] + d[2]) : 0
            ]);
        }
        function to(t1, i, o, r, s, a) {
            const n = t1.zoom, l = t1.scale, c = t1.worldSize, h = 1 / c, u = t1.aspect, d = Math.sqrt(1 + u * u) * Math.tan(.5 * t1.fovX), _ = d * d, p = r - o, m = r + o;
            let f, g;
            _ > p / m ? (f = r, g = r * d) : (f = .5 * m * (1 + _), g = .5 * Math.sqrt(p * p + 2 * (r * r + o * o) * _ + m * m * _ * _));
            const v = t1.projection.pixelsPerMeter(t1.center.lat, c), x = t1._camera.getCameraToWorldMercator(), y = [
                0,
                0,
                -f * h
            ];
            e.a6.vec3.transformMat4(y, y, x);
            let b = g * h;
            const w = t1._edgeInsets;
            if (!(0 === w.left && 0 === w.top && 0 === w.right && 0 === w.bottom || w.left === w.right && w.top === w.bottom)) {
                const i = t1._camera.getWorldToCamera(t1.worldSize, "meters" === t1.projection.zAxisUnit ? v : 1), s = t1._camera.getCameraToClipPerspective(t1._fov, t1.width / t1.height, o, r);
                s[8] = 2 * -t1.centerOffset.x / t1.width, s[9] = 2 * t1.centerOffset.y / t1.height;
                const a = new Float64Array(16);
                e.a6.mat4.mul(a, s, i);
                const h = new Float64Array(16);
                e.a6.mat4.invert(h, a);
                const u = e.bN.fromInvProjectionMatrix(h, c, n, !0);
                for (const i of u.points){
                    const o = ((T = i)[0] /= l, T[1] /= l, T[2] = e.bD(T[2], t1._center.lat), T);
                    b = Math.max(b, e.a6.vec3.len(e.a6.vec3.subtract([], y, o)));
                }
            }
            var T;
            b *= s / (s - 1);
            const E = Math.acos(i[2]), C = Math.atan2(-i[0], -i[1]), S = new Gi;
            S.position = y, S.setPitchBearing(E, C);
            const I = S.getWorldToCamera(c, v), D = b * c, R = Math.min(t1._mercatorZfromZoom(17) * c * -2, -2 * D), A = S.getCameraToClipOrthographic(-D, D, -D, D, R, (D + a * v) / i[2]), L = new Float64Array(16);
            e.a6.mat4.multiply(L, A, I);
            const P = e.a6.vec3.fromValues(Math.floor(1e6 * y[0]) / 1e6 * c, Math.floor(1e6 * y[1]) / 1e6 * c, 0), M = .5 * s, z = [
                0,
                0,
                0
            ];
            e.a6.vec3.transformMat4(z, P, L), e.a6.vec3.scale(z, z, M);
            const O = [
                Math.floor(z[0]),
                Math.floor(z[1]),
                Math.floor(z[2])
            ], F = [
                0,
                0,
                0
            ];
            e.a6.vec3.sub(F, z, O), e.a6.vec3.scale(F, F, -1 / M);
            const k = new Float64Array(16);
            return e.a6.mat4.identity(k), e.a6.mat4.translate(k, k, F), e.a6.mat4.multiply(L, k, L), [
                L,
                D
            ];
        }
        class io extends e.E {
            constructor(e){
                super(), this.requestManager = e, this.models = {
                    "": {}
                }, this.numModelsLoading = {};
            }
            loadModel(t1, i) {
                return e.aG(this.requestManager.transformRequest(i, e.R.Model).url).then((i)=>{
                    if (!i) return;
                    const o = e.aH(i), r = new e.aI(t1, void 0, void 0, o);
                    return r.computeBoundsAndApplyParent(), r;
                }).catch((o)=>{
                    if (o && 404 === o.status) return null;
                    this.fire(new e.t(new Error(`Could not load model ${t1} from ${i}: ${o.message}`)));
                });
            }
            load(t1, i) {
                this.models[i] || (this.models[i] = {});
                const o = Object.keys(t1);
                this.numModelsLoading[i] = (this.numModelsLoading[i] || 0) + o.length;
                const r = [];
                for (const e of o)r.push(this.loadModel(e, t1[e]));
                Promise.allSettled(r).then((t1)=>{
                    for(let e = 0; e < t1.length; e++){
                        const { status: r, value: s } = t1[e];
                        "fulfilled" === r && s && (this.models[i][o[e]] = {
                            model: s,
                            numReferences: 1
                        });
                    }
                    this.numModelsLoading[i] -= o.length, this.fire(new e.x("data", {
                        dataType: "style"
                    }));
                }).catch((t1)=>{
                    this.fire(new e.t(new Error(`Could not load models: ${t1.message}`)));
                });
            }
            isLoaded() {
                for(const e in this.numModelsLoading)if (this.numModelsLoading[e] > 0) return !1;
                return !0;
            }
            hasModel(e, t1) {
                return !!this.getModel(e, t1);
            }
            getModel(e, t1) {
                return this.models[t1] || (this.models[t1] = {}), this.models[t1][e] ? this.models[t1][e].model : void 0;
            }
            addModel(e, t1, i) {
                this.models[i] || (this.models[i] = {}), this.hasModel(e, i) && this.models[i][e].numReferences++, this.load({
                    [e]: this.requestManager.normalizeModelURL(t1)
                }, i);
            }
            addModels(e, t1) {
                this.models[t1] || (this.models[t1] = {});
                const i = {};
                for(const o in e)this.models[t1][o] = {}, i[o] = this.requestManager.normalizeModelURL(e[o]);
                this.load(i, t1);
            }
            addModelsFromBucket(e, t1) {
                this.models[t1] || (this.models[t1] = {});
                const i = {};
                for (const o of e)this.hasModel(o, t1) ? this.models[t1][o].numReferences++ : i[o] = this.requestManager.normalizeModelURL(o);
                this.load(i, t1);
            }
            removeModel(e, t1) {
                if (this.models[t1] && this.models[t1][e] && (this.models[t1][e].numReferences--, 0 === this.models[t1][e].numReferences)) {
                    const i = this.models[t1][e].model;
                    delete this.models[t1][e], i.destroy();
                }
            }
            listModels(e) {
                return this.models[e] || (this.models[e] = {}), Object.keys(this.models[e]);
            }
            upload(e, t1) {
                this.models[t1] || (this.models[t1] = {});
                for(const i in this.models[t1])this.models[t1][i].model && this.models[t1][i].model.upload(e.context);
            }
        }
        const oo = new e.a0({
            data: new e.a1(e._.colorTheme.data)
        }), ro = (e, t1)=>De(e, t1 && t1.filter((e)=>"source.canvas" !== e.identifier)), so = e.ar(Ct, [
            "addLayer",
            "removeLayer",
            "setLights",
            "setPaintProperty",
            "setLayoutProperty",
            "setSlot",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setTerrain",
            "setFog",
            "setProjection",
            "setCamera",
            "addImport",
            "removeImport",
            "updateImport"
        ]), ao = e.ar(Ct, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), no = {
            version: 8,
            layers: [],
            sources: {}
        }, lo = {
            duration: 300,
            delay: 0
        };
        class co extends e.E {
            constructor(t1, i = {}){
                super(), this.map = t1, this.scope = i.scope || "", this.globalId = null, this.fragments = [], this.importDepth = i.importDepth || 0, this.importsCache = i.importsCache || new Map, this.resolvedImports = i.resolvedImports || new Set, this.transition = e.l({}, lo), this._buildingIndex = new wt(this), this.crossTileSymbolIndex = new Di, this._mergedOrder = [], this._drapedFirstOrder = [], this._mergedLayers = {}, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = {}, this._mergedSymbolSourceCaches = {}, this._clipLayerPresent = !1, this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this._changes = i.styleChanges || new j, this.dispatcher = i.dispatcher ? i.dispatcher : new e.cd(e.ce(), this), i.imageManager ? this.imageManager = i.imageManager : (this.imageManager = new q, this.imageManager.setEventedParent(this)), this.imageManager.createScope(this.scope), this.glyphManager = i.glyphManager ? i.glyphManager : new e.cf(t1._requestManager, i.localFontFamily ? e.cg.all : i.localIdeographFontFamily ? e.cg.ideographs : e.cg.none, i.localFontFamily || i.localIdeographFontFamily), i.modelManager ? this.modelManager = i.modelManager : (this.modelManager = new io(t1._requestManager), this.modelManager.setEventedParent(this)), this._layers = {}, this._serializedLayers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this._loaded = !1, this._precompileDone = !1, this._shouldPrecompile = !1, this._availableImages = [], this._order = [], this._markersNeedUpdate = !1, this._styleColorTheme = {
                    lut: null,
                    lutLoading: !1,
                    lutLoadingCorrelationID: 0,
                    colorTheme: null
                }, this._styleColorThemeForScope = {}, this.options = i.configOptions ? i.configOptions : new Map, this._configDependentLayers = i.configDependentLayers ? i.configDependentLayers : new Set, this._config = i.config, this._initialConfig = i.initialConfig, this.dispatcher.broadcast("setReferrer", e.ch());
                const o = this;
                this._rtlTextPluginCallback = co.registerForPluginStateChange((t1)=>{
                    o.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: t1.pluginStatus,
                        pluginURL: t1.pluginURL
                    }, (t1, i)=>{
                        if (e.ci(t1), i && i.every((e)=>e)) for(const e in o._sourceCaches){
                            const t1 = o._sourceCaches[e], i = t1.getSource().type;
                            "vector" !== i && "geojson" !== i || t1.reload();
                        }
                    });
                }), this.on("data", (e)=>{
                    if ("source" !== e.dataType || "metadata" !== e.sourceDataType) return;
                    const t1 = this.getOwnSource(e.sourceId);
                    if (t1 && t1.vectorLayerIds) for(const e in this._layers){
                        const i = this._layers[e];
                        i.source === t1.id && this._validateLayer(i);
                    }
                });
            }
            load(e) {
                return e ? ("string" == typeof e ? this.loadURL(e) : this.loadJSON(e), this) : this;
            }
            _getGlobalId(t1) {
                if (!t1) return null;
                if ("string" == typeof t1) {
                    if (e.f(t1)) return t1;
                    const i = e.cj(t1);
                    if (!i.startsWith("http")) try {
                        return new URL(i, location.href).toString();
                    } catch (e) {
                        return i;
                    }
                    return i;
                }
                return `json://${e.ck(JSON.stringify(t1))}`;
            }
            _diffStyle(t1, i, o) {
                this.globalId = this._getGlobalId(t1);
                const r = (e, t1)=>{
                    try {
                        t1(null, this.setState(e, o));
                    } catch (e) {
                        t1(e, !1);
                    }
                };
                if ("string" == typeof t1) {
                    const o = this.map._requestManager.normalizeStyleURL(t1), s = this.map._requestManager.transformRequest(o, e.R.Style);
                    e.n(s, (t1, o)=>{
                        t1 ? this.fire(new e.t(t1)) : o && r(o, i);
                    });
                } else "object" == typeof t1 && r(t1, i);
            }
            loadURL(t1, i = {}) {
                this.fire(new e.x("dataloading", {
                    dataType: "style"
                }));
                const o = "boolean" == typeof i.validate ? i.validate : !e.f(t1);
                this.globalId = this._getGlobalId(t1), t1 = this.map._requestManager.normalizeStyleURL(t1, i.accessToken), this.resolvedImports.add(t1);
                const r = this.importsCache.get(t1);
                if (r) return this._load(r, o);
                const s = this.map._requestManager.transformRequest(t1, e.R.Style);
                this._request = e.n(s, (i, r)=>{
                    if (this._request = null, i) this.fire(new e.t(i));
                    else if (r) return this.importsCache.set(t1, r), this._load(r, o);
                });
            }
            loadJSON(t1, i = {}) {
                this.fire(new e.x("dataloading", {
                    dataType: "style"
                })), this.globalId = this._getGlobalId(t1), this._request = e.q.frame(()=>{
                    this._request = null, this._load(t1, !1 !== i.validate);
                });
            }
            loadEmpty() {
                this.fire(new e.x("dataloading", {
                    dataType: "style"
                })), this._load(no, !1);
            }
            _loadImports(t1, i, o) {
                if (this.importDepth >= 4) return e.w("Style doesn't support nesting deeper than 5"), Promise.resolve();
                const r = [];
                for (const e of t1){
                    const t1 = this._createFragmentStyle(e), s = new Promise((e)=>{
                        t1.once("style.import.load", e), t1.once("error", e);
                    }).then(()=>this.mergeAll());
                    if (r.push(s), this.resolvedImports.has(e.url)) {
                        t1.loadEmpty();
                        continue;
                    }
                    const a = e.data || this.importsCache.get(e.url);
                    a ? (t1.loadJSON(a, {
                        validate: i
                    }), this._isInternalStyle(a) && (t1.globalId = null)) : e.url ? t1.loadURL(e.url, {
                        validate: i
                    }) : t1.loadEmpty();
                    const n = {
                        style: t1,
                        id: e.id,
                        config: e.config
                    };
                    if (o) {
                        const e = this.fragments.findIndex(({ id: e })=>e === o);
                        this.fragments = this.fragments.slice(0, e).concat(n).concat(this.fragments.slice(e));
                    } else this.fragments.push(n);
                }
                return Promise.allSettled(r);
            }
            getImportGlobalIds(e = this, t1 = new Set) {
                for (const i of e.fragments)i.style.globalId && t1.add(i.style.globalId), this.getImportGlobalIds(i.style, t1);
                return [
                    ...t1.values()
                ];
            }
            _createFragmentStyle(t1) {
                const i = this.scope ? e.av(t1.id, this.scope) : t1.id;
                let o;
                const r = this._initialConfig && this._initialConfig[i];
                (t1.config || r) && (o = e.l({}, t1.config, r));
                const s = new co(this.map, {
                    scope: i,
                    styleChanges: this._changes,
                    importDepth: this.importDepth + 1,
                    importsCache: this.importsCache,
                    resolvedImports: new Set(this.resolvedImports),
                    dispatcher: this.dispatcher,
                    imageManager: this.imageManager,
                    glyphManager: this.glyphManager,
                    modelManager: this.modelManager,
                    config: o,
                    configOptions: this.options,
                    configDependentLayers: this._configDependentLayers
                });
                return s.setEventedParent(this.map, {
                    style: s
                }), s;
            }
            _reloadImports() {
                this.mergeAll(), this._updateMapProjection(), this.updateConfigDependencies(), this.map._triggerCameraUpdate(this.camera), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), this._shouldPrecompile = this.map._precompilePrograms && this.isRootStyle();
            }
            _isInternalStyle(e) {
                return this.isRootStyle() && (e.fragment || !!e.schema && !1 !== e.fragment);
            }
            _load(t1, i) {
                const o = t1.schema;
                if (this._isInternalStyle(t1)) {
                    const o = e.l({}, no, {
                        imports: [
                            {
                                id: "basemap",
                                data: t1,
                                url: ""
                            }
                        ]
                    });
                    return void this._load(o, i);
                }
                if (this.updateConfig(this._config, o), i && ro(this, fe(t1))) return;
                this._loaded = !0, this.stylesheet = e.cl(t1);
                const r = ()=>{
                    for(const e in t1.sources)this.addSource(e, t1.sources[e], {
                        validate: !1,
                        isInitialLoad: !0
                    });
                    t1.sprite ? this._loadSprite(t1.sprite) : (this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    })), this.glyphManager.setURL(t1.glyphs, this.scope);
                    const o = Et(this.stylesheet.layers);
                    if (this._order = o.map((e)=>e.id), this.stylesheet.light && e.w("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights) {
                        if (1 === this.stylesheet.lights.length && "flat" === this.stylesheet.lights[0].type) {
                            const e = this.stylesheet.lights[0];
                            this.light = new Ae(e.properties, e.id);
                        } else this.setLights(this.stylesheet.lights);
                    }
                    this.light || (this.light = new Ae(this.stylesheet.light)), this._layers = {}, this._serializedLayers = {};
                    for (const t1 of o){
                        const i = e.cq(t1, this.scope, this._styleColorTheme.lut, this.options);
                        0 !== i.configDependencies.size && this._configDependentLayers.add(i.fqid), i.setEventedParent(this, {
                            layer: {
                                id: i.id
                            }
                        }), this._layers[i.id] = i, this._serializedLayers[i.id] = i.serialize();
                        const o = this.getOwnLayerSourceCache(i), r = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                        o && i.canCastShadows() && r && (o.castsShadows = !0);
                    }
                    this.stylesheet.models && this.modelManager.addModels(this.stylesheet.models, this.scope);
                    const r = this.stylesheet.terrain;
                    r && (this.checkCanvasFingerprintNoise(), this.disableElevatedTerrain || this.terrainSetForDrapingOnly() || this._createTerrain(r, 1)), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new e.x("data", {
                        dataType: "style"
                    }));
                    const s = this.isRootStyle();
                    t1.imports ? this._loadImports(t1.imports, i).then(()=>{
                        this._reloadImports(), this.fire(new e.x(s ? "style.load" : "style.import.load"));
                    }) : (this._reloadImports(), this.fire(new e.x(s ? "style.load" : "style.import.load")));
                }, s = this.stylesheet["color-theme"];
                if (this._styleColorTheme.colorTheme = s, s) {
                    const t1 = this._evaluateColorThemeData(s);
                    this._loadColorTheme(t1).then(()=>{
                        r();
                    }).catch((t1)=>{
                        e.w(`Couldn't load color theme from the stylesheet: ${t1}`), r();
                    });
                } else this._styleColorTheme.lut = null, r();
            }
            isRootStyle() {
                return 0 === this.importDepth;
            }
            mergeAll() {
                let t1, i, o, r, s, a, n, l;
                const c = {};
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((e)=>{
                    if (e.stylesheet) {
                        if (null != e.light && (t1 = e.light), e.stylesheet.lights) for (const t1 of e.stylesheet.lights)"ambient" === t1.type && null != e.ambientLight && (i = e.ambientLight), "directional" === t1.type && null != e.directionalLight && (o = e.directionalLight);
                        r = this._prioritizeTerrain(r, e.terrain, e.stylesheet.terrain), e.stylesheet.fog && null != e.fog && (s = e.fog), null != e.stylesheet.camera && (l = e.stylesheet.camera), null != e.stylesheet.projection && (a = e.stylesheet.projection), null != e.stylesheet.transition && (n = e.stylesheet.transition), c[e.scope] = e._styleColorTheme;
                    }
                }), this.light = t1, this.ambientLight = i, this.directionalLight = o, this.fog = s, this._styleColorThemeForScope = c, null === r ? delete this.terrain : this.terrain = r, this.camera = l || {
                    "camera-projection": "perspective"
                }, this.projection = a || {
                    name: "mercator"
                }, this.transition = e.l({}, lo, n), this.mergeSources(), this.mergeLayers();
            }
            forEachFragmentStyle(e) {
                const t1 = (i)=>{
                    for (const e of i.fragments)t1(e.style);
                    e(i);
                };
                t1(this);
            }
            _prioritizeTerrain(e, t1, i) {
                const o = e && 0 === e.drapeRenderMode;
                return null === i ? t1 && 0 === t1.drapeRenderMode ? t1 : o ? e : null : null != t1 && (!e || o || t1 && 1 === t1.drapeRenderMode) ? t1 : e;
            }
            mergeTerrain() {
                let e;
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((t1)=>{
                    e = this._prioritizeTerrain(e, t1.terrain, t1.stylesheet.terrain);
                }), null === e ? delete this.terrain : this.terrain = e;
            }
            mergeProjection() {
                let e;
                this.forEachFragmentStyle((t1)=>{
                    null != t1.stylesheet.projection && (e = t1.stylesheet.projection);
                }), this.projection = e || {
                    name: "mercator"
                };
            }
            mergeSources() {
                const t1 = {}, i = {}, o = {};
                this.forEachFragmentStyle((r)=>{
                    for(const i in r._sourceCaches){
                        const o = e.av(i, r.scope);
                        t1[o] = r._sourceCaches[i];
                    }
                    for(const t1 in r._otherSourceCaches){
                        const o = e.av(t1, r.scope);
                        i[o] = r._otherSourceCaches[t1];
                    }
                    for(const t1 in r._symbolSourceCaches){
                        const i = e.av(t1, r.scope);
                        o[i] = r._symbolSourceCaches[t1];
                    }
                }), this._mergedSourceCaches = t1, this._mergedOtherSourceCaches = i, this._mergedSymbolSourceCaches = o;
            }
            mergeLayers() {
                const t1 = {}, i = [], o = {};
                this._mergedSlots = [], this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this.forEachFragmentStyle((o)=>{
                    for (const r of o._order){
                        const s = o._layers[r];
                        if ("slot" === s.type) {
                            const i = e.cm(r);
                            if (t1[i]) continue;
                            t1[i] = [];
                        }
                        s.slot && t1[s.slot] ? t1[s.slot].push(s) : i.push(s);
                    }
                }), this._mergedOrder = [];
                const r = (i = [])=>{
                    for (const s of i)if ("slot" === s.type) {
                        const i = e.cm(s.id);
                        t1[i] && r(t1[i]), this._mergedSlots.push(i);
                    } else {
                        const t1 = e.av(s.id, s.scope);
                        this._mergedOrder.push(t1), o[t1] = s, s.is3D() && (this._has3DLayers = !0), "circle" === s.type && (this._hasCircleLayers = !0), "symbol" === s.type && (this._hasSymbolLayers = !0), "clip" === s.type && (this._clipLayerPresent = !0);
                    }
                };
                r(i), this._mergedOrder.sort((e, t1)=>{
                    const i = o[e], r = o[t1];
                    return i.hasInitialOcclusionOpacityProperties ? r.is3D() ? 1 : 0 : i.is3D() && r.hasInitialOcclusionOpacityProperties ? -1 : 0;
                }), this._mergedLayers = o, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged();
            }
            terrainSetForDrapingOnly() {
                return !!this.terrain && 0 === this.terrain.drapeRenderMode;
            }
            getCamera() {
                return this.stylesheet.camera;
            }
            setCamera(t1) {
                return this.stylesheet.camera = e.l({}, this.stylesheet.camera, t1), this.camera = this.stylesheet.camera, this;
            }
            _evaluateColorThemeData(t1) {
                return t1.data ? (function(t1, i, o) {
                    const r = e.l({}, i);
                    for (const t1 of Object.keys(e._.colorTheme))void 0 === r[t1] && (r[t1] = e._.colorTheme[t1].default);
                    const s = new e.$(oo, t1, new Map(o));
                    return s.setTransitionOrValue(r, o), s.untransitioned().possiblyEvaluate(new e.a3(0));
                })(this.scope, t1, this.options).get("data") : null;
            }
            _loadColorTheme(t1) {
                this._styleColorTheme.lutLoading = !0, this._styleColorTheme.lutLoadingCorrelationID += 1;
                const i = this._styleColorTheme.lutLoadingCorrelationID;
                return new Promise((o, r)=>{
                    const s = "data:image/png;base64,";
                    if (!t1 || 0 === t1.length) return this._styleColorTheme.lut = null, this._styleColorTheme.lutLoading = !1, void o();
                    let a = t1;
                    a.startsWith(s) || (a = s + a);
                    const n = "mapbox-reserved-lut", l = new Image;
                    l.src = a, l.onerror = ()=>{
                        this._styleColorTheme.lutLoading = !1, r(new Error("Failed to load image data"));
                    }, l.onload = ()=>{
                        if (this._styleColorTheme.lutLoadingCorrelationID !== i) return void o();
                        this._styleColorTheme.lutLoading = !1;
                        const { width: s, height: a, data: c } = e.q.getImageData(l);
                        if (a > 32) return void r(new Error("The height of the image must be less than or equal to 32 pixels."));
                        if (s !== a * a) return void r(new Error("The width of the image must be equal to the height squared."));
                        this.getImage(n) && this.removeImage(n), this.addImage(n, {
                            data: new e.r({
                                width: s,
                                height: a
                            }, c),
                            pixelRatio: 1,
                            sdf: !1,
                            version: 0
                        });
                        const h = this.imageManager.getImage(n, this.scope);
                        h ? (this._styleColorTheme.lut = {
                            image: h.data,
                            data: t1
                        }, o()) : r(new Error("Missing LUT image."));
                    };
                });
            }
            getLut(e) {
                const t1 = this._styleColorThemeForScope[e];
                return t1 ? t1.lut : null;
            }
            setProjection(e) {
                e ? this.stylesheet.projection = e : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
            }
            applyProjectionUpdate() {
                this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? (this.getTerrain() || this.stylesheet.terrain) && !this.disableElevatedTerrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null, 0));
            }
            _updateMapProjection() {
                this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
            }
            _loadSprite(t1) {
                this._spriteRequest = function(t1, i, o) {
                    let r, s, a;
                    const n = e.q.devicePixelRatio > 1 ? "@2x" : "";
                    let l = e.n(i.transformRequest(i.normalizeSpriteURL(t1, n, ".json"), e.R.SpriteJSON), (e, t1)=>{
                        l = null, a || (a = e, r = t1, h());
                    }), c = e.o(i.transformRequest(i.normalizeSpriteURL(t1, n, ".png"), e.R.SpriteImage), (e, t1)=>{
                        c = null, a || (a = e, s = t1, h());
                    });
                    function h() {
                        if (a) o(a);
                        else if (r && s) {
                            const t1 = e.q.getImageData(s), i = {};
                            for(const o in r){
                                const { width: s, height: a, x: n, y: l, sdf: c, pixelRatio: h, stretchX: u, stretchY: d, content: _ } = r[o], p = new e.r({
                                    width: s,
                                    height: a
                                });
                                e.r.copy(t1, p, {
                                    x: n,
                                    y: l
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: s,
                                    height: a
                                }, null), i[o] = {
                                    data: p,
                                    pixelRatio: h,
                                    sdf: c,
                                    stretchX: u,
                                    stretchY: d,
                                    content: _
                                };
                            }
                            o(null, i);
                        }
                    }
                    return {
                        cancel () {
                            l && (l.cancel(), l = null), c && (c.cancel(), c = null);
                        }
                    };
                }(t1, this.map._requestManager, (t1, i)=>{
                    if (this._spriteRequest = null, t1) this.fire(new e.t(t1));
                    else if (i) for(const e in i)this.imageManager.addImage(e, this.scope, i[e]);
                    this.imageManager.setLoaded(!0, this.scope), this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", {
                        scope: this.scope,
                        images: this._availableImages
                    }), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    }), this.fire(new e.x("data", {
                        dataType: "style"
                    }));
                });
            }
            _validateLayer(t1) {
                const i = this.getOwnSource(t1.source);
                if (!i) return;
                const o = t1.sourceLayer;
                o && ("geojson" === i.type || i.vectorLayerIds && -1 === i.vectorLayerIds.indexOf(o)) && this.fire(new e.t(new Error(`Source layer "${o}" does not exist on source "${i.id}" as specified by style layer "${t1.id}"`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._changes.getUpdatedSourceCaches()).length) return !1;
                for(const e in this._sourceCaches)if (!this._sourceCaches[e].loaded()) return !1;
                if (!this.imageManager.isLoaded()) return !1;
                if (!this.modelManager.isLoaded()) return !1;
                if (this._styleColorTheme.lutLoading) return !1;
                for (const { style: e } of this.fragments)if (!e.loaded()) return !1;
                return !0;
            }
            _serializeImports() {
                if (this.stylesheet.imports) return this.stylesheet.imports.map((e, t1)=>{
                    const i = this.fragments[t1];
                    return i && i.style && (e.data = i.style.serialize()), e;
                });
            }
            _serializeSources() {
                const e = {};
                for(const t1 in this._sourceCaches){
                    const i = this._sourceCaches[t1].getSource();
                    e[i.id] || (e[i.id] = i.serialize());
                }
                return e;
            }
            _serializeLayers(e) {
                const t1 = [];
                for (const i of e){
                    const e = this._layers[i];
                    e && "custom" !== e.type && t1.push(e.serialize());
                }
                return t1;
            }
            hasLightTransitions() {
                return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
            }
            hasFogTransition() {
                return !!this.fog && this.fog.hasTransition();
            }
            hasTransitions() {
                if (this.hasLightTransitions()) return !0;
                if (this.hasFogTransition()) return !0;
                for(const e in this._sourceCaches)if (this._sourceCaches[e].hasTransition()) return !0;
                for(const e in this._layers)if (this._layers[e].hasTransition()) return !0;
                return !1;
            }
            get order() {
                return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
            }
            isLayerDraped(e) {
                return !!this.terrain && e.isDraped(this.getLayerSourceCache(e));
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }
            _checkLayer(t1) {
                const i = this.getOwnLayer(t1);
                if (i) return i;
                this.fire(new e.t(new Error(`The layer '${t1}' does not exist in the map's style.`)));
            }
            _checkSource(t1) {
                const i = this.getOwnSource(t1);
                if (i) return i;
                this.fire(new e.t(new Error(`The source '${t1}' does not exist in the map's style.`)));
            }
            precompilePrograms(e, t1) {
                const i = this.map.painter;
                if (i) for(let o = e.minzoom || 0; o < (e.maxzoom || 25.5); o++){
                    const o = e.getProgramIds();
                    if (o) for (const r of o){
                        const o = e.getDefaultProgramParams(r, t1.zoom, this._styleColorTheme.lut);
                        o && (i.style = this, this.fog && (i._fogVisible = !0, o.overrideFog = !0, i.getOrCreateProgram(r, o)), i._fogVisible = !1, o.overrideFog = !1, i.getOrCreateProgram(r, o), (this.stylesheet.terrain || this.stylesheet.projection && "globe" === this.stylesheet.projection.name) && (o.overrideRtt = !0, i.getOrCreateProgram(r, o)));
                    }
                }
            }
            update(t1) {
                if (!this._loaded) return;
                this.ambientLight && this.ambientLight.recalculate(t1), this.directionalLight && this.directionalLight.recalculate(t1);
                const i = this.calculateLightsBrightness();
                t1.brightness = i || 0, i !== this._brightness && (this._brightness = i, this.dispatcher.broadcast("setBrightness", i));
                const o = this._changes.isDirty();
                let r = !1;
                if (this._changes.isDirty()) {
                    const e = this._changes.getLayerUpdatesByScope();
                    for(const t1 in e){
                        const { updatedIds: i, removedIds: o } = e[t1];
                        (i || o) && (this._updateWorkerLayers(t1, i, o), r = !0);
                    }
                    this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(t1), this.light && this.light.updateTransitions(t1), this.ambientLight && this.ambientLight.updateTransitions(t1), this.directionalLight && this.directionalLight.updateTransitions(t1), this.fog && this.fog.updateTransitions(t1), this._changes.reset();
                }
                const s = {};
                for(const e in this._mergedSourceCaches){
                    const t1 = this._mergedSourceCaches[e];
                    s[e] = t1.used, t1.used = !1, t1.tileCoverLift = 0;
                }
                for (const e of this._mergedOrder){
                    const i = this._mergedLayers[e];
                    if (i.recalculate(t1, this._availableImages), !i.isHidden(t1.zoom)) {
                        const e = this.getLayerSourceCache(i);
                        e && (e.used = !0, e.tileCoverLift = Math.max(e.tileCoverLift, i.tileCoverLift()));
                    }
                    !this._precompileDone && this._shouldPrecompile && ("requestIdleCallback" in window ? requestIdleCallback(()=>{
                        this.precompilePrograms(i, t1);
                    }) : this.precompilePrograms(i, t1));
                }
                this._shouldPrecompile && (this._precompileDone = !0), this.terrain && r && this.mergeLayers();
                for(const t1 in s){
                    const i = this._mergedSourceCaches[t1];
                    s[t1] !== i.used && i.getSource().fire(new e.x("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: i.getSource().id
                    }));
                }
                this.light && this.light.recalculate(t1), this.terrain && this.terrain.recalculate(t1), this.fog && this.fog.recalculate(t1), this.z = t1.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), o && this.fire(new e.x("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const e = this._changes.getUpdatedImages();
                if (e.length) {
                    for(const t1 in this._sourceCaches)this._sourceCaches[t1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e);
                    this._changes.resetUpdatedImages();
                }
            }
            _updateWorkerLayers(e, t1, i) {
                const o = this.getFragmentStyle(e);
                o && this.dispatcher.broadcast("updateLayers", {
                    layers: t1 ? o._serializeLayers(t1) : [],
                    scope: e,
                    removedIds: i || [],
                    options: o.options
                });
            }
            setState(t1, i) {
                if (this._checkLoaded(), ro(this, fe(t1))) return !1;
                (t1 = e.cl(t1)).layers = Et(t1.layers);
                const o = (function(t1, i) {
                    if (!t1) return [
                        {
                            command: Ct.setStyle,
                            args: [
                                i
                            ]
                        }
                    ];
                    let o = [];
                    try {
                        if (!e.bh(t1.version, i.version)) return [
                            {
                                command: Ct.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        if (e.bh(t1.center, i.center) || o.push({
                            command: Ct.setCenter,
                            args: [
                                i.center
                            ]
                        }), e.bh(t1.zoom, i.zoom) || o.push({
                            command: Ct.setZoom,
                            args: [
                                i.zoom
                            ]
                        }), e.bh(t1.bearing, i.bearing) || o.push({
                            command: Ct.setBearing,
                            args: [
                                i.bearing
                            ]
                        }), e.bh(t1.pitch, i.pitch) || o.push({
                            command: Ct.setPitch,
                            args: [
                                i.pitch
                            ]
                        }), e.bh(t1.sprite, i.sprite) || o.push({
                            command: Ct.setSprite,
                            args: [
                                i.sprite
                            ]
                        }), e.bh(t1.glyphs, i.glyphs) || o.push({
                            command: Ct.setGlyphs,
                            args: [
                                i.glyphs
                            ]
                        }), e.bh(t1.imports, i.imports) || function(t1 = [], i = [], o) {
                            i = i || [];
                            const r = (t1 = t1 || []).map(Lt), s = i.map(Lt), a = t1.reduce(Pt, {}), n = i.reduce(Pt, {}), l = r.slice();
                            let c, h, u, d;
                            for(c = 0, h = 0; c < r.length; c++)u = r[c], n.hasOwnProperty(u) ? h++ : (o.push({
                                command: Ct.removeImport,
                                args: [
                                    u
                                ]
                            }), l.splice(l.indexOf(u, h), 1));
                            for(c = 0, h = 0; c < s.length; c++)u = s[s.length - 1 - c], l[l.length - 1 - c] !== u && (a.hasOwnProperty(u) ? (o.push({
                                command: Ct.removeImport,
                                args: [
                                    u
                                ]
                            }), l.splice(l.lastIndexOf(u, l.length - h), 1)) : h++, d = l[l.length - c], o.push({
                                command: Ct.addImport,
                                args: [
                                    n[u],
                                    d
                                ]
                            }), l.splice(l.length - c, 0, u));
                            for (const t1 of i){
                                const i = a[t1.id];
                                i && !e.bh(i, t1) && o.push({
                                    command: Ct.updateImport,
                                    args: [
                                        t1.id,
                                        t1
                                    ]
                                });
                            }
                        }(t1.imports, i.imports, o), e.bh(t1.transition, i.transition) || o.push({
                            command: Ct.setTransition,
                            args: [
                                i.transition
                            ]
                        }), e.bh(t1.light, i.light) || o.push({
                            command: Ct.setLight,
                            args: [
                                i.light
                            ]
                        }), e.bh(t1.fog, i.fog) || o.push({
                            command: Ct.setFog,
                            args: [
                                i.fog
                            ]
                        }), e.bh(t1.projection, i.projection) || o.push({
                            command: Ct.setProjection,
                            args: [
                                i.projection
                            ]
                        }), e.bh(t1.lights, i.lights) || o.push({
                            command: Ct.setLights,
                            args: [
                                i.lights
                            ]
                        }), e.bh(t1.camera, i.camera) || o.push({
                            command: Ct.setCamera,
                            args: [
                                i.camera
                            ]
                        }), !e.bh(t1["color-theme"], i["color-theme"])) return [
                            {
                                command: Ct.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        const r = {}, s = [];
                        !function(t1, i, o, r) {
                            let s;
                            for(s in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(s) && (i.hasOwnProperty(s) || It(s, o, r));
                            for(s in i){
                                if (!i.hasOwnProperty(s)) continue;
                                const a = i[s];
                                t1.hasOwnProperty(s) ? e.bh(t1[s], a) || ("geojson" === t1[s].type && "geojson" === a.type && Rt(t1, i, s) ? o.push({
                                    command: Ct.setGeoJSONSourceData,
                                    args: [
                                        s,
                                        a.data
                                    ]
                                }) : Dt(s, i, o, r)) : St(s, i, o);
                            }
                        }(t1.sources, i.sources, s, r);
                        const a = [];
                        t1.layers && t1.layers.forEach((e)=>{
                            e.source && r[e.source] ? o.push({
                                command: Ct.removeLayer,
                                args: [
                                    e.id
                                ]
                            }) : a.push(e);
                        });
                        let n = t1.terrain;
                        n && r[n.source] && (o.push({
                            command: Ct.setTerrain,
                            args: [
                                void 0
                            ]
                        }), n = void 0), o = o.concat(s), e.bh(n, i.terrain) || o.push({
                            command: Ct.setTerrain,
                            args: [
                                i.terrain
                            ]
                        }), function(t1, i, o) {
                            i = i || [];
                            const r = (t1 = t1 || []).map(Lt), s = i.map(Lt), a = t1.reduce(Pt, {}), n = i.reduce(Pt, {}), l = r.slice(), c = Object.create(null);
                            let h, u, d, _, p, m, f;
                            for(h = 0, u = 0; h < r.length; h++)d = r[h], n.hasOwnProperty(d) ? u++ : (o.push({
                                command: Ct.removeLayer,
                                args: [
                                    d
                                ]
                            }), l.splice(l.indexOf(d, u), 1));
                            for(h = 0, u = 0; h < s.length; h++)d = s[s.length - 1 - h], l[l.length - 1 - h] !== d && (a.hasOwnProperty(d) ? (o.push({
                                command: Ct.removeLayer,
                                args: [
                                    d
                                ]
                            }), l.splice(l.lastIndexOf(d, l.length - u), 1)) : u++, m = l[l.length - h], o.push({
                                command: Ct.addLayer,
                                args: [
                                    n[d],
                                    m
                                ]
                            }), l.splice(l.length - h, 0, d), c[d] = !0);
                            for(h = 0; h < s.length; h++)if (d = s[h], _ = a[d], p = n[d], !c[d] && !e.bh(_, p)) {
                                if (e.bh(_.source, p.source) && e.bh(_["source-layer"], p["source-layer"]) && e.bh(_.type, p.type)) {
                                    for(f in At(_.layout, p.layout, o, d, null, Ct.setLayoutProperty), At(_.paint, p.paint, o, d, null, Ct.setPaintProperty), e.bh(_.slot, p.slot) || o.push({
                                        command: Ct.setSlot,
                                        args: [
                                            d,
                                            p.slot
                                        ]
                                    }), e.bh(_.filter, p.filter) || o.push({
                                        command: Ct.setFilter,
                                        args: [
                                            d,
                                            p.filter
                                        ]
                                    }), e.bh(_.minzoom, p.minzoom) && e.bh(_.maxzoom, p.maxzoom) || o.push({
                                        command: Ct.setLayerZoomRange,
                                        args: [
                                            d,
                                            p.minzoom,
                                            p.maxzoom
                                        ]
                                    }), _)_.hasOwnProperty(f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && "slot" !== f && (0 === f.indexOf("paint.") ? At(_[f], p[f], o, d, f.slice(6), Ct.setPaintProperty) : e.bh(_[f], p[f]) || o.push({
                                        command: Ct.setLayerProperty,
                                        args: [
                                            d,
                                            f,
                                            p[f]
                                        ]
                                    }));
                                    for(f in p)p.hasOwnProperty(f) && !_.hasOwnProperty(f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && "slot" !== f && (0 === f.indexOf("paint.") ? At(_[f], p[f], o, d, f.slice(6), Ct.setPaintProperty) : e.bh(_[f], p[f]) || o.push({
                                        command: Ct.setLayerProperty,
                                        args: [
                                            d,
                                            f,
                                            p[f]
                                        ]
                                    }));
                                } else o.push({
                                    command: Ct.removeLayer,
                                    args: [
                                        d
                                    ]
                                }), m = l[l.lastIndexOf(d) + 1], o.push({
                                    command: Ct.addLayer,
                                    args: [
                                        p,
                                        m
                                    ]
                                });
                            }
                        }(a, i.layers, o);
                    } catch (e) {
                        console.warn("Unable to compute style diff:", e), o = [
                            {
                                command: Ct.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                    }
                    return o;
                })(this.serialize(), t1).filter((e)=>!(e.command in ao));
                if (0 === o.length) return !1;
                const r = o.filter((e)=>!(e.command in so));
                if (r.length > 0) throw new Error(`Unimplemented: ${r.map((e)=>e.command).join(", ")}.`);
                const s = [];
                return o.forEach((e)=>{
                    s.push(this[e.command].apply(this, e.args));
                }), i && Promise.all(s).then(i), this.stylesheet = t1, this.mergeAll(), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), !0;
            }
            addImage(t1, i) {
                return this.getImage(t1) ? this.fire(new e.t(new Error("An image with this name already exists."))) : (this.imageManager.addImage(t1, this.scope, i), this._afterImageUpdated(t1), this);
            }
            updateImage(e, t1) {
                this.imageManager.updateImage(e, this.scope, t1);
            }
            getImage(e) {
                return this.imageManager.getImage(e, this.scope);
            }
            removeImage(t1) {
                return this.getImage(t1) ? (this.imageManager.removeImage(t1, this.scope), this._afterImageUpdated(t1), this) : this.fire(new e.t(new Error("No image with this name exists.")));
            }
            _afterImageUpdated(t1) {
                this._availableImages = this.imageManager.listImages(this.scope), this._changes.updateImage(t1), this.dispatcher.broadcast("setImages", {
                    scope: this.scope,
                    images: this._availableImages
                }), this.fire(new e.x("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this._availableImages.slice();
            }
            addModel(e, t1, i = {}) {
                return this._checkLoaded(), this._validate(Se, `models.${e}`, t1, null, i) || (this.modelManager.addModel(e, t1, this.scope), this._changes.setDirty()), this;
            }
            hasModel(e) {
                return this.modelManager.hasModel(e, this.scope);
            }
            removeModel(t1) {
                return this.hasModel(t1) ? (this.modelManager.removeModel(t1, this.scope), this) : this.fire(new e.t(new Error("No model with this ID exists.")));
            }
            listModels() {
                return this._checkLoaded(), this.modelManager.listModels(this.scope);
            }
            addSource(t1, i, o = {}) {
                if (this._checkLoaded(), void 0 !== this.getOwnSource(t1)) throw new Error(`There is already a source with ID "${t1}".`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(ge, `sources.${t1}`, i, null, o)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const r = tt(t1, i, this.dispatcher, this);
                r.scope = this.scope, r.setEventedParent(this, ()=>({
                        isSourceLoaded: this._isSourceCacheLoaded(r.id),
                        source: r.serialize(),
                        sourceId: r.id
                    }));
                const s = (t1)=>{
                    const i = (t1 ? "symbol:" : "other:") + r.id, o = e.av(i, this.scope), s = this._sourceCaches[i] = new vt(o, r, t1);
                    (t1 ? this._symbolSourceCaches : this._otherSourceCaches)[r.id] = s, s.onAdd(this.map);
                };
                s(!1), "vector" !== i.type && "geojson" !== i.type || s(!0), r.onAdd && r.onAdd(this.map), o.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
            }
            removeSource(t1) {
                this._checkLoaded();
                const i = this.getOwnSource(t1);
                if (!i) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === t1) return this.fire(new e.t(new Error(`Source "${t1}" cannot be removed while layer "${i}" is using it.`)));
                if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === t1) return this.fire(new e.t(new Error(`Source "${t1}" cannot be removed while terrain is using it.`)));
                const o = this.getOwnSourceCaches(t1);
                for (const t1 of o){
                    const i = e.cm(t1.id);
                    delete this._sourceCaches[i], this._changes.discardSourceCacheUpdate(t1.id), t1.fire(new e.x("data", {
                        sourceDataType: "metadata",
                        dataType: "source",
                        sourceId: t1.getSource().id
                    })), t1.setEventedParent(null), t1.clearTiles();
                }
                return delete this._otherSourceCaches[t1], delete this._symbolSourceCaches[t1], this.mergeSources(), i.setEventedParent(null), i.onRemove && i.onRemove(this.map), this._changes.setDirty(), this;
            }
            setGeoJSONSourceData(e, t1) {
                this._checkLoaded(), this.getOwnSource(e).setData(t1), this._changes.setDirty();
            }
            getOwnSource(e) {
                const t1 = this.getOwnSourceCache(e);
                return t1 && t1.getSource();
            }
            getOwnSources() {
                const e = [];
                for(const t1 in this._otherSourceCaches){
                    const i = this.getOwnSourceCache(t1);
                    i && e.push(i.getSource());
                }
                return e;
            }
            areTilesLoaded() {
                const e = this._mergedSourceCaches;
                for(const t1 in e){
                    const i = e[t1]._tiles;
                    for(const e in i){
                        const t1 = i[e];
                        if ("loaded" !== t1.state && "errored" !== t1.state) return !1;
                    }
                }
                return !0;
            }
            setLights(t1) {
                if (this._checkLoaded(), !t1) return delete this.ambientLight, void delete this.directionalLight;
                const i = this._getTransitionParameters();
                for (const o of t1){
                    if (this._validate(xe, "lights", o)) return;
                    switch(o.type){
                        case "ambient":
                            if (this.ambientLight) {
                                const e = this.ambientLight;
                                e.set(o), e.updateTransitions(i);
                            } else this.ambientLight = new je(o, Ve || (Ve = new e.a0({
                                color: new e.a1(e._.properties_light_ambient.color),
                                intensity: new e.a1(e._.properties_light_ambient.intensity)
                            })), this.scope, this.options);
                            break;
                        case "directional":
                            if (this.directionalLight) {
                                const e = this.directionalLight;
                                e.set(o), e.updateTransitions(i);
                            } else this.directionalLight = new je(o, qe || (qe = new e.a0({
                                direction: new e.ad(e._.properties_light_directional.direction),
                                color: new e.a1(e._.properties_light_directional.color),
                                intensity: new e.a1(e._.properties_light_directional.intensity),
                                "cast-shadows": new e.a1(e._.properties_light_directional["cast-shadows"]),
                                "shadow-intensity": new e.a1(e._.properties_light_directional["shadow-intensity"])
                            })), this.scope, this.options);
                    }
                }
                const o = new e.a3(this.z || 0, i);
                this.ambientLight && this.ambientLight.recalculate(o), this.directionalLight && this.directionalLight.recalculate(o), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("setBrightness", this._brightness);
            }
            calculateLightsBrightness() {
                const t1 = this.directionalLight, i = this.ambientLight;
                if (!t1 || !i) return;
                const o = (e)=>.2126 * (e[0] <= .03928 ? e[0] / 12.92 : Math.pow((e[0] + .055) / 1.055, 2.4)) + .7152 * (e[1] <= .03928 ? e[1] / 12.92 : Math.pow((e[1] + .055) / 1.055, 2.4)) + .0722 * (e[2] <= .03928 ? e[2] / 12.92 : Math.pow((e[2] + .055) / 1.055, 2.4)), r = t1.properties.get("color").toRenderColor(null).toArray01(), s = t1.properties.get("intensity"), a = t1.properties.get("direction"), n = 1 - e.c7(a.x, a.y, a.z)[2] / 90, l = o(r) * s * n, c = i.properties.get("color").toRenderColor(null).toArray01(), h = i.properties.get("intensity");
                return (l + o(c) * h) / 2;
            }
            getBrightness() {
                return this._brightness;
            }
            getLights() {
                if (!this.enable3dLights()) return null;
                const e = [];
                return this.directionalLight && e.push(this.directionalLight.get()), this.ambientLight && e.push(this.ambientLight.get()), e;
            }
            enable3dLights() {
                return !!this.ambientLight && !!this.directionalLight;
            }
            getFragmentStyle(t1) {
                if (!t1) return this;
                if (e.cn(t1)) {
                    const i = e.co(t1), o = this.fragments.find(({ id: e })=>e === i);
                    if (!o) throw new Error(`Style import not found: ${t1}`);
                    const r = e.cm(t1);
                    return o.style.getFragmentStyle(r);
                }
                {
                    const e = this.fragments.find(({ id: e })=>e === t1);
                    if (!e) throw new Error(`Style import not found: ${t1}`);
                    return e.style;
                }
            }
            getConfigProperty(t1, i) {
                const o = this.getFragmentStyle(t1);
                if (!o) return null;
                const r = e.av(i, o.scope), s = o.options.get(r), a = s ? s.value || s.default : null;
                return a ? a.serialize() : null;
            }
            setConfigProperty(t1, i, o) {
                const r = this.getFragmentStyle(t1);
                if (!r) return;
                const s = r.stylesheet.schema;
                if (!s || !s[i]) return;
                const a = e.M(o);
                if ("success" !== a.result) return void ro(this, a.value);
                const n = a.value.expression, l = e.av(i, r.scope), c = r.options.get(l);
                if (!c) return;
                let h;
                const { minValue: u, maxValue: d, stepValue: _, type: p, values: m } = s[i], f = e.M(s[i].default);
                "success" === f.result && (h = f.value.expression), h ? (this.options.set(l, {
                    ...c,
                    value: n,
                    default: h,
                    minValue: u,
                    maxValue: d,
                    stepValue: _,
                    type: p,
                    values: m
                }), this.updateConfigDependencies(i)) : this.fire(new e.t(new Error(`No schema defined for the config option "${i}" in the "${t1}" fragment.`)));
            }
            getConfig(t1) {
                const i = this.getFragmentStyle(t1);
                if (!i) return null;
                const o = i.stylesheet.schema;
                if (!o) return null;
                const r = {};
                for(const t1 in o){
                    const o = e.av(t1, i.scope), s = i.options.get(o), a = s ? s.value || s.default : null;
                    r[t1] = a ? a.serialize() : null;
                }
                return r;
            }
            setConfig(e, t1) {
                const i = this.getFragmentStyle(e);
                i && (i.updateConfig(t1, i.stylesheet.schema), this.updateConfigDependencies());
            }
            getSchema(e) {
                const t1 = this.getFragmentStyle(e);
                return t1 ? t1.stylesheet.schema : null;
            }
            setSchema(e, t1) {
                const i = this.getFragmentStyle(e);
                i && (i.stylesheet.schema = t1, i.updateConfig(i._config, t1), this.updateConfigDependencies());
            }
            updateConfig(t1, i) {
                if (this._config = t1, t1 || i) {
                    if (i) for(const o in i){
                        let r, s;
                        const a = e.M(i[o].default);
                        if ("success" === a.result && (r = a.value.expression), t1 && void 0 !== t1[o]) {
                            const i = e.M(t1[o]);
                            "success" === i.result && (s = i.value.expression);
                        }
                        const { minValue: n, maxValue: l, stepValue: c, type: h, values: u } = i[o];
                        if (r) {
                            const t1 = e.av(o, this.scope);
                            this.options.set(t1, {
                                default: r,
                                value: s,
                                minValue: n,
                                maxValue: l,
                                stepValue: c,
                                type: h,
                                values: u
                            });
                        } else this.fire(new e.t(new Error(`No schema defined for config option "${o}".`)));
                    }
                    else this.fire(new e.t(new Error("Attempting to set config for a style without schema.")));
                }
            }
            updateConfigDependencies(e) {
                for (const t1 of this._configDependentLayers){
                    const i = this.getLayer(t1);
                    if (i) {
                        if (e && !i.configDependencies.has(e)) continue;
                        i.possiblyEvaluateVisibility(), this._updateLayer(i);
                    }
                }
                this.ambientLight && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.updateConfig(this.options), this.fog && this.fog.updateConfig(this.options), this.forEachFragmentStyle((e)=>{
                    if (e._styleColorTheme.colorTheme) {
                        const t1 = e._evaluateColorThemeData(e._styleColorTheme.colorTheme);
                        (!e._styleColorTheme.lut && "" !== t1 || e._styleColorTheme.lut && t1 !== e._styleColorTheme.lut.data) && e.setColorTheme(e._styleColorTheme.colorTheme);
                    }
                }), this._changes.setDirty();
            }
            addLayer(t1, i, o = {}) {
                this._checkLoaded();
                const r = t1.id;
                if (this._layers[r]) return void this.fire(new e.t(new Error(`Layer with id "${r}" already exists on this map`)));
                let s;
                if ("custom" === t1.type) {
                    if (ro(this, e.cp(t1))) return;
                    s = e.cq(t1, this.scope, this._styleColorTheme.lut, this.options);
                } else {
                    if ("object" == typeof t1.source && (this.addSource(r, t1.source), t1 = e.cl(t1), t1 = e.l(t1, {
                        source: r
                    })), this._validate(we, `layers.${r}`, t1, {
                        arrayIndex: -1
                    }, o)) return;
                    s = e.cq(t1, this.scope, this._styleColorTheme.lut, this.options), this._validateLayer(s), s.setEventedParent(this, {
                        layer: {
                            id: r
                        }
                    }), this._serializedLayers[s.id] = s.serialize();
                }
                0 !== s.configDependencies.size && this._configDependentLayers.add(s.fqid);
                let a = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e.t(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    s.slot === this._layers[i].slot ? a = t1 : e.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`);
                }
                this._order.splice(a, 0, r), this._layerOrderChanged = !0, this._layers[r] = s;
                const n = this.getOwnLayerSourceCache(s), l = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                n && s.canCastShadows() && l && (n.castsShadows = !0);
                const c = this._changes.getRemovedLayer(s);
                if (c && s.source && n && "custom" !== s.type) {
                    this._changes.discardLayerRemoval(s);
                    const t1 = e.av(s.source, s.scope);
                    c.type !== s.type ? this._changes.updateSourceCache(t1, "clear") : (this._changes.updateSourceCache(t1, "reload"), n.pause());
                }
                this._updateLayer(s), s.onAdd && s.onAdd(this.map), s.scope = this.scope, this.mergeLayers();
            }
            moveLayer(t1, i) {
                this._checkLoaded();
                const o = this._checkLayer(t1);
                if (!o) return;
                if (t1 === i) return;
                const r = this._order.indexOf(t1);
                this._order.splice(r, 1);
                let s = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e.t(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    o.slot === this._layers[i].slot ? s = t1 : e.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`);
                }
                this._order.splice(s, 0, t1), this._changes.setDirty(), this._layerOrderChanged = !0, this.mergeLayers();
            }
            removeLayer(e) {
                this._checkLoaded();
                const t1 = this._checkLayer(e);
                if (!t1) return;
                t1.setEventedParent(null);
                const i = this._order.indexOf(e);
                this._order.splice(i, 1), delete this._layers[e], delete this._serializedLayers[e], this._changes.setDirty(), this._layerOrderChanged = !0, this._configDependentLayers.delete(t1.fqid), this._changes.removeLayer(t1);
                const o = this.getOwnLayerSourceCache(t1);
                if (o && o.castsShadows) {
                    let e = !1;
                    for(const i in this._layers)if (this._layers[i].source === t1.source && this._layers[i].canCastShadows()) {
                        e = !0;
                        break;
                    }
                    o.castsShadows = e;
                }
                t1.onRemove && t1.onRemove(this.map), this.mergeLayers();
            }
            getOwnLayer(e) {
                return this._layers[e];
            }
            hasLayer(e) {
                return e in this._mergedLayers;
            }
            hasLayerType(e) {
                for(const t1 in this._layers)if (this._layers[t1].type === e) return !0;
                return !1;
            }
            setLayerZoomRange(e, t1, i) {
                this._checkLoaded();
                const o = this._checkLayer(e);
                o && (o.minzoom === t1 && o.maxzoom === i || (null != t1 && (o.minzoom = t1), null != i && (o.maxzoom = i), this._updateLayer(o)));
            }
            getSlots() {
                return this._checkLoaded(), this._mergedSlots;
            }
            setSlot(e, t1) {
                this._checkLoaded();
                const i = this._checkLayer(e);
                i && i.slot !== t1 && (i.slot = t1, this._updateLayer(i));
            }
            setFilter(t1, i, o = {}) {
                this._checkLoaded();
                const r = this._checkLayer(t1);
                if (r && !e.bh(r.filter, i)) return null == i ? (r.filter = void 0, void this._updateLayer(r)) : void (this._validate(Te, `layers.${r.id}.filter`, i, {
                    layerType: r.type
                }, o) || (r.filter = e.cl(i), this._updateLayer(r)));
            }
            getFilter(t1) {
                const i = this._checkLayer(t1);
                if (i) return e.cl(i.filter);
            }
            setLayoutProperty(t1, i, o, r = {}) {
                this._checkLoaded();
                const s = this._checkLayer(t1);
                if (s && !e.bh(s.getLayoutProperty(i), o)) {
                    if (null != o && (!r || !1 !== r.validate) && ro(s, Ce.call(fe, {
                        key: `layers.${t1}.layout.${i}`,
                        layerType: s.type,
                        objectKey: i,
                        value: o,
                        styleSpec: e._,
                        style: {
                            glyphs: !0,
                            sprite: !0
                        }
                    }))) return;
                    s.setLayoutProperty(i, o), 0 !== s.configDependencies.size && this._configDependentLayers.add(s.fqid), this._updateLayer(s);
                }
            }
            getLayoutProperty(e, t1) {
                const i = this._checkLayer(e);
                if (i) return i.getLayoutProperty(t1);
            }
            setPaintProperty(t1, i, o, r = {}) {
                this._checkLoaded();
                const s = this._checkLayer(t1);
                if (!s) return;
                if (e.bh(s.getPaintProperty(i), o)) return;
                if (null != o && (!r || !1 !== r.validate) && ro(s, Ee.call(fe, {
                    key: `layers.${t1}.paint.${i}`,
                    layerType: s.type,
                    objectKey: i,
                    value: o,
                    styleSpec: e._
                }))) return;
                const a = s.setPaintProperty(i, o);
                0 !== s.configDependencies.size && this._configDependentLayers.add(s.fqid), a && this._updateLayer(s), this._changes.updatePaintProperties(s);
            }
            getPaintProperty(e, t1) {
                const i = this._checkLayer(e);
                if (i) return i.getPaintProperty(t1);
            }
            setFeatureState(t1, i) {
                this._checkLoaded();
                const o = t1.source, r = t1.sourceLayer, s = this._checkSource(o);
                if (!s) return;
                const a = s.type;
                if ("geojson" === a && r) return void this.fire(new e.t(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
                if ("vector" === a && !r) return void this.fire(new e.t(new Error("The sourceLayer parameter must be provided for vector source types.")));
                void 0 === t1.id && this.fire(new e.t(new Error("The feature id parameter must be provided.")));
                const n = this.getOwnSourceCaches(o);
                for (const e of n)e.setFeatureState(r, t1.id, i);
            }
            removeFeatureState(t1, i) {
                this._checkLoaded();
                const o = t1.source, r = this._checkSource(o);
                if (!r) return;
                const s = r.type, a = "vector" === s ? t1.sourceLayer : void 0;
                if ("vector" === s && !a) return void this.fire(new e.t(new Error("The sourceLayer parameter must be provided for vector source types.")));
                if (i && "string" != typeof t1.id && "number" != typeof t1.id) return void this.fire(new e.t(new Error("A feature id is required to remove its specific state property.")));
                const n = this.getOwnSourceCaches(o);
                for (const e of n)e.removeFeatureState(a, t1.id, i);
            }
            getFeatureState(t1) {
                this._checkLoaded();
                const i = t1.source, o = t1.sourceLayer, r = this._checkSource(i);
                if (r) {
                    if ("vector" !== r.type || o) return void 0 === t1.id && this.fire(new e.t(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(i)[0].getFeatureState(o, t1.id);
                    this.fire(new e.t(new Error("The sourceLayer parameter must be provided for vector source types.")));
                }
            }
            setTransition(t1) {
                return this.stylesheet.transition = e.l({}, this.stylesheet.transition, t1), this.transition = this.stylesheet.transition, this;
            }
            getTransition() {
                return e.l({}, this.stylesheet.transition);
            }
            serialize() {
                this._checkLoaded();
                const t1 = this.getTerrain(), i = t1 && this.terrain && this.terrain.scope === this.scope ? t1 : this.stylesheet.terrain;
                return e.cr({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    fragment: this.stylesheet.fragment,
                    imports: this._serializeImports(),
                    schema: this.stylesheet.schema,
                    camera: this.stylesheet.camera,
                    light: this.stylesheet.light,
                    lights: this.stylesheet.lights,
                    terrain: i,
                    fog: this.stylesheet.fog,
                    center: this.stylesheet.center,
                    "color-theme": this.stylesheet["color-theme"],
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    projection: this.stylesheet.projection,
                    sources: this._serializeSources(),
                    layers: this._serializeLayers(this._order)
                }, (e)=>void 0 !== e);
            }
            _updateLayer(t1) {
                this._changes.updateLayer(t1);
                const i = this.getLayerSourceCache(t1), o = e.av(t1.source, t1.scope), r = this._changes.getUpdatedSourceCaches();
                t1.source && !r[o] && i && "raster" !== i.getSource().type && (this._changes.updateSourceCache(o, "reload"), i.pause()), t1.invalidateCompiledFilter();
            }
            _flattenAndSortRenderedFeatures(e) {
                const t1 = (e)=>this._mergedLayers[e].is3D(), i = this.order, o = {}, r = [];
                for(let s = i.length - 1; s >= 0; s--){
                    const a = i[s];
                    if (t1(a)) {
                        o[a] = s;
                        for (const t1 of e){
                            const e = t1[a];
                            if (e) for (const t1 of e)r.push(t1);
                        }
                    }
                }
                r.sort((e, t1)=>t1.intersectionZ - e.intersectionZ);
                const s = [];
                for(let a = i.length - 1; a >= 0; a--){
                    const n = i[a];
                    if (t1(n)) for(let e = r.length - 1; e >= 0; e--){
                        const t1 = r[e].feature;
                        if (t1.layer && o[t1.layer.id] < a) break;
                        s.push(t1), r.pop();
                    }
                    else for (const t1 of e){
                        const e = t1[n];
                        if (e) for (const t1 of e)s.push(t1.feature);
                    }
                }
                return s;
            }
            queryRenderedFeatures(t1, i, o) {
                i && i.filter && this._validate(Te, "queryRenderedFeatures.filter", i.filter, null, i), i.scope = this.scope, i.availableImages = this._availableImages, i.serializedLayers = this._serializedLayers;
                const r = {};
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new e.t(new Error("parameters.layers must be an Array."))), [];
                    for (const t1 of i.layers){
                        const i = this._mergedLayers[t1];
                        if (!i) return this.fire(new e.t(new Error(`The layer '${t1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        r[i.source] = !0;
                    }
                }
                const s = [], a = i.serializedLayers || {}, n = i && i.layers ? i.layers.some((e)=>{
                    const t1 = this.getLayer(e);
                    return t1 && t1.is3D();
                }) : this.has3DLayers(), l = Ze.createFromScreenPoints(t1, o);
                for(const e in this._mergedSourceCaches){
                    const t1 = this._mergedSourceCaches[e].getSource();
                    if (!t1 || t1.scope !== i.scope) continue;
                    const c = this._mergedSourceCaches[e].getSource().id;
                    i.layers && !r[c] || s.push(ot(this._mergedSourceCaches[e], this._mergedLayers, a, l, i, o, n, !!this.map._showQueryGeometry));
                }
                return this.placement && s.push(function(e, t1, i, o, r, s, a) {
                    const n = {}, l = s.queryRenderedSymbols(o), c = [];
                    for (const e of Object.keys(l).map(Number))c.push(a[e]);
                    c.sort(st);
                    for (const i of c){
                        const o = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], t1, i.bucketIndex, i.sourceLayerIndex, r.filter, r.layers, r.availableImages, e);
                        for(const e in o){
                            const t1 = n[e] = n[e] || [], r = o[e];
                            r.sort((e, t1)=>{
                                const o = i.featureSortOrder;
                                if (o) {
                                    const i = o.indexOf(e.featureIndex);
                                    return o.indexOf(t1.featureIndex) - i;
                                }
                                return t1.featureIndex - e.featureIndex;
                            });
                            for (const e of r)t1.push(e);
                        }
                    }
                    for(const t1 in n)n[t1].forEach((o)=>{
                        const r = o.feature, s = i(e[t1]);
                        if (!s) return;
                        const a = s.getFeatureState(r.layer["source-layer"], r.id);
                        r.source = r.layer.source, r.layer["source-layer"] && (r.sourceLayer = r.layer["source-layer"]), r.state = a;
                    });
                    return n;
                }(this._mergedLayers, a, this.getLayerSourceCache.bind(this), l.screenGeometry, i, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(s);
            }
            querySourceFeatures(e, t1) {
                t1 && t1.filter && this._validate(Te, "querySourceFeatures.filter", t1.filter, null, t1);
                const i = this.getOwnSourceCaches(e);
                let o = [];
                for (const e of i)o = o.concat(rt(e, t1));
                return o;
            }
            addSourceType(e, t1, i) {
                return co.getSourceType(e) ? i(new Error(`A source type called "${e}" already exists.`)) : (co.setSourceType(e, t1), t1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: e,
                    url: t1.workerSourceURL
                }, i) : i(null, null));
            }
            getFlatLight() {
                return this.light.getLight();
            }
            setFlatLight(t1, i, o = {}) {
                this._checkLoaded();
                const r = this.light.getLight();
                let s = !1;
                for(const i in t1)if (!e.bh(t1[i], r[i])) {
                    s = !0;
                    break;
                }
                if (!s) return;
                const a = this._getTransitionParameters();
                this.light.setLight(t1, i, o), this.light.updateTransitions(a);
            }
            getTerrain() {
                return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
            }
            setTerrainForDraping() {
                this.setTerrain({
                    source: "",
                    exaggeration: 0
                }, 0);
            }
            checkCanvasFingerprintNoise() {
                void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = e.q.hasCanvasFingerprintNoise(), this.disableElevatedTerrain && e.w("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode)."));
            }
            setTerrain(t1, i = 1) {
                if (this._checkLoaded(), !t1) return this.terrainSetForDrapingOnly() || (delete this.terrain, this.map.transform.projection.requiresDraping && this.setTerrainForDraping()), 0 === i && delete this.terrain, null === t1 ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
                this.checkCanvasFingerprintNoise();
                let o = t1;
                const r = null == t1.source;
                if (1 === i) {
                    if (this.disableElevatedTerrain) return;
                    if ("object" == typeof o.source) {
                        const t1 = "terrain-dem-src";
                        this.addSource(t1, o.source), o = e.cl(o), o = e.l(o, {
                            source: t1
                        });
                    }
                    const t1 = e.l({}, o), i = {};
                    if (this.terrain && r) {
                        t1.source = this.terrain.get().source;
                        const e = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
                        e && (i.style = e.serialize());
                    }
                    if (this._validate(ye, "terrain", t1, i)) return;
                }
                if (!this.terrain || this.terrain.scope !== this.scope && !r || this.terrain && i !== this.terrain.drapeRenderMode) {
                    if (!o) return;
                    this._createTerrain(o, i), this.fire(new e.x("data", {
                        dataType: "style"
                    }));
                } else {
                    const i = this.terrain, r = i.get();
                    for (const t1 of Object.keys(e._.terrain))!o.hasOwnProperty(t1) && e._.terrain[t1].default && (o[t1] = e._.terrain[t1].default);
                    for(const o in t1)if (!e.bh(t1[o], r[o])) {
                        i.set(t1, this.options), this.stylesheet.terrain = t1;
                        const o = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(o), this.fire(new e.x("data", {
                            dataType: "style"
                        }));
                        break;
                    }
                }
                this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
            }
            _createFog(e) {
                const t1 = this.fog = new Ge(e, this.map.transform, this.scope, this.options);
                this.stylesheet.fog = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _updateMarkersOpacity() {
                0 !== this.map._markers.length && this.map._requestDomTask(()=>{
                    for (const e of this.map._markers)e._evaluateOpacity();
                });
            }
            getFog() {
                return this.fog ? this.fog.get() : null;
            }
            setFog(t1) {
                if (this._checkLoaded(), !t1) return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = !0);
                if (this.fog) {
                    const i = this.fog;
                    if (!e.bh(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.fog = i.get();
                        const e = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e);
                    }
                } else this._createFog(t1);
                this._markersNeedUpdate = !0;
            }
            setColorTheme(t1) {
                this._checkLoaded();
                const i = ()=>{
                    for(const e in this._layers)this._layers[e].lut = this._styleColorTheme.lut;
                    for(const e in this._sourceCaches)this._sourceCaches[e].clearTiles();
                };
                if (this._styleColorTheme.colorTheme = t1, !t1) return this._styleColorTheme.lut = null, void i();
                const o = this._evaluateColorThemeData(t1);
                this._loadColorTheme(o).then(()=>{
                    this.fire(new e.x("colorthemeset")), i();
                }).catch((t1)=>{
                    e.w(`Couldn't set color theme: ${t1}`);
                });
            }
            _getTransitionParameters(t1) {
                return {
                    now: e.q.now(),
                    transition: e.l(this.transition, t1)
                };
            }
            updateDrapeFirstLayers() {
                if (!this.terrain) return;
                const e = [], t1 = [];
                for (const i of this._mergedOrder)this.isLayerDraped(this._mergedLayers[i]) ? e.push(i) : t1.push(i);
                this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e), this._drapedFirstOrder.push(...t1);
            }
            _createTerrain(e, t1) {
                const i = this.terrain = new Pe(e, t1, this.scope, this.options);
                1 === t1 && (this.stylesheet.terrain = e), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
                const o = this._getTransitionParameters({
                    duration: 0
                });
                i.updateTransitions(o);
            }
            _force3DLayerUpdate() {
                for(const e in this._layers){
                    const t1 = this._layers[e];
                    "fill-extrusion" === t1.type && this._updateLayer(t1);
                }
            }
            _forceSymbolLayerUpdate() {
                for(const e in this._layers){
                    const t1 = this._layers[e];
                    "symbol" === t1.type && this._updateLayer(t1);
                }
            }
            _validate(t1, i, o, r, s = {}) {
                if (s && !1 === s.validate) return !1;
                const a = e.l({}, this.serialize());
                return ro(this, t1.call(fe, e.l({
                    key: i,
                    style: a,
                    value: o,
                    styleSpec: e._
                }, r)));
            }
            _remove() {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), e.cs.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const e in this._mergedLayers)this._mergedLayers[e].setEventedParent(null);
                for(const e in this._mergedSourceCaches)this._mergedSourceCaches[e].clearTiles(), this._mergedSourceCaches[e].setEventedParent(null);
                this.setEventedParent(null), delete this.fog, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.isRootStyle() && (this.imageManager.setEventedParent(null), this.modelManager.setEventedParent(null), this.dispatcher.remove());
            }
            clearSource(e) {
                const t1 = this.getSourceCaches(e);
                for (const e of t1)e.clearTiles();
            }
            clearSources() {
                for(const e in this._mergedSourceCaches)this._mergedSourceCaches[e].clearTiles();
            }
            reloadSource(e) {
                const t1 = this.getSourceCaches(e);
                for (const e of t1)e.resume(), e.reload();
            }
            reloadSources() {
                for (const e of this.getSources())e.reload && e.reload();
            }
            updateSources(e) {
                let t1;
                this.directionalLight && (t1 = Qi(this.directionalLight));
                for(const i in this._mergedSourceCaches)this._mergedSourceCaches[i].update(e, void 0, void 0, t1);
            }
            _generateCollisionBoxes() {
                for(const e in this._sourceCaches){
                    const t1 = this._sourceCaches[e];
                    t1.resume(), t1.reload();
                }
            }
            _updatePlacement(t1, i, o, r, s, a, n = !1) {
                let l = !1, c = !1;
                const h = {}, u = {};
                for (const t1 of this._mergedOrder){
                    const o = this._mergedLayers[t1];
                    if ("symbol" !== o.type) continue;
                    const r = e.av(o.source, o.scope);
                    let s = h[r];
                    if (!s) {
                        const e = this.getLayerSourceCache(o);
                        if (!e) continue;
                        const t1 = e.getRenderableIds(!0).map((t1)=>e.getTileByID(t1));
                        u[r] = t1.slice(), s = h[r] = t1.sort((e, t1)=>t1.tileID.overscaledZ - e.tileID.overscaledZ || (e.tileID.isLessThan(t1.tileID) ? -1 : 1));
                    }
                    const a = this.crossTileSymbolIndex.addLayer(o, s, i.center.lng, i.projection);
                    l = l || a;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder), n = n || this._layerOrderChanged || 0 === r, this._layerOrderChanged && this.fire(new e.x("neworder")), (n || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(e.q.now(), i.zoom)) && (this.pauseablePlacement = new Ti(i, this._mergedOrder, n, o, r, s, this.placement, this.fog && i.projection.supportsFog ? this.fog.state : null, this._buildingIndex), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, h, u), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e.q.now()), c = !0), l && this.pauseablePlacement.placement.setStale()), c || l) {
                    this._buildingIndex.onNewFrame(i.zoom);
                    for(let t1 = 0; t1 < this._mergedOrder.length; t1++){
                        const i = this._mergedLayers[this._mergedOrder[t1]];
                        if ("symbol" !== i.type) continue;
                        const o = this.isLayerClipped(i);
                        this.placement.updateLayerOpacities(i, h[e.av(i.source, i.scope)], t1, o ? a : null);
                    }
                }
                return {
                    needsRerender: !this.pauseablePlacement.isDone() || this.placement.hasTransitions(e.q.now())
                };
            }
            _releaseSymbolFadeTiles() {
                for(const e in this._sourceCaches)this._sourceCaches[e].releaseSymbolFadeTiles();
            }
            addImport(t1, i) {
                this._checkLoaded();
                const o = this.stylesheet.imports = this.stylesheet.imports || [];
                if (-1 !== o.findIndex(({ id: e })=>e === t1.id)) return void this.fire(new e.t(new Error(`Import with id '${t1.id}' already exists in the map's style.`)));
                if (!i) return o.push(t1), this._loadImports([
                    t1
                ], !0);
                const r = o.findIndex(({ id: e })=>e === i);
                return -1 === r && this.fire(new e.t(new Error(`Import with id "${i}" does not exist on this map.`))), this.stylesheet.imports = o.slice(0, r).concat(t1).concat(o.slice(r)), this._loadImports([
                    t1
                ], !0, i);
            }
            updateImport(t1, i) {
                this._checkLoaded();
                const o = this.stylesheet.imports || [], r = this.getImportIndex(t1);
                return -1 === r ? this : "string" == typeof i ? (this.setImportUrl(t1, i), this) : (i.url && i.url !== o[r].url && this.setImportUrl(t1, i.url), e.bh(i.config, o[r].config) || this.setImportConfig(t1, i.config), e.bh(i.data, o[r].data) || this.setImportData(t1, i.data), this);
            }
            moveImport(e, t1) {
                this._checkLoaded();
                let i = this.stylesheet.imports || [];
                const o = this.getImportIndex(e);
                if (-1 === o) return this;
                const r = this.getImportIndex(t1);
                if (-1 === r) return this;
                const s = i[o], a = this.fragments[o];
                return i = i.filter(({ id: t1 })=>t1 !== e), this.fragments = this.fragments.filter(({ id: t1 })=>t1 !== e), this.stylesheet.imports = i.slice(0, r).concat(s).concat(i.slice(r)), this.fragments = this.fragments.slice(0, r).concat(a).concat(this.fragments.slice(r)), this.mergeLayers(), this;
            }
            setImportUrl(e, t1) {
                this._checkLoaded();
                const i = this.stylesheet.imports || [], o = this.getImportIndex(e);
                if (-1 === o) return this;
                i[o].url = t1;
                const r = this.fragments[o];
                return r.style = this._createFragmentStyle(i[o]), r.style.on("style.import.load", ()=>this.mergeAll()), r.style.loadURL(t1), this;
            }
            setImportData(e, t1) {
                this._checkLoaded();
                const i = this.getImportIndex(e), o = this.stylesheet.imports || [];
                return -1 === i ? this : t1 ? (this.fragments[i].style.setState(t1), this._reloadImports(), this) : (delete o[i].data, this.setImportUrl(e, o[i].url));
            }
            setImportConfig(e, t1) {
                this._checkLoaded();
                const i = this.getImportIndex(e), o = this.stylesheet.imports || [];
                if (-1 === i) return this;
                t1 ? o[i].config = t1 : delete o[i].config;
                const r = this.fragments[i], s = r.style.stylesheet && r.style.stylesheet.schema;
                return r.config = t1, r.style.updateConfig(t1, s), this.updateConfigDependencies(), this;
            }
            removeImport(e) {
                this._checkLoaded();
                const t1 = this.stylesheet.imports || [], i = this.getImportIndex(e);
                -1 !== i && (t1.splice(i, 1), this.fragments[i].style._remove(), this.fragments.splice(i, 1), this._reloadImports());
            }
            getImportIndex(t1) {
                const i = (this.stylesheet.imports || []).findIndex((e)=>e.id === t1);
                return -1 === i && this.fire(new e.t(new Error(`Import '${t1}' does not exist in the map's style and cannot be updated.`))), i;
            }
            getLayer(e) {
                return this._mergedLayers[e];
            }
            getSources() {
                const e = [];
                for(const t1 in this._mergedOtherSourceCaches){
                    const i = this._mergedOtherSourceCaches[t1];
                    i && e.push(i.getSource());
                }
                return e;
            }
            getSource(e, t1) {
                const i = this.getSourceCache(e, t1);
                return i && i.getSource();
            }
            getLayerSource(e) {
                const t1 = this.getLayerSourceCache(e);
                return t1 && t1.getSource();
            }
            getSourceCache(t1, i) {
                const o = e.av(t1, i);
                return this._mergedOtherSourceCaches[o];
            }
            getLayerSourceCache(t1) {
                const i = e.av(t1.source, t1.scope);
                return "symbol" === t1.type ? this._mergedSymbolSourceCaches[i] : this._mergedOtherSourceCaches[i];
            }
            getSourceCaches(e) {
                if (null == e) return Object.values(this._mergedSourceCaches);
                const t1 = [];
                return this._mergedOtherSourceCaches[e] && t1.push(this._mergedOtherSourceCaches[e]), this._mergedSymbolSourceCaches[e] && t1.push(this._mergedSymbolSourceCaches[e]), t1;
            }
            updateSourceCaches() {
                const e = this._changes.getUpdatedSourceCaches();
                for(const t1 in e){
                    const i = e[t1];
                    "reload" === i ? this.reloadSource(t1) : "clear" === i && this.clearSource(t1);
                }
            }
            updateLayers(e) {
                const t1 = this._changes.getUpdatedPaintProperties();
                for (const i of t1){
                    const t1 = this.getLayer(i);
                    t1 && t1.updateTransitions(e);
                }
            }
            getImages(e, t1, i) {
                this.imageManager.getImages(t1.icons, t1.scope, i), this._updateTilesForChangedImages();
                const o = (e)=>{
                    e && e.setDependencies(t1.tileID.key, t1.type, t1.icons);
                };
                o(this._otherSourceCaches[t1.source]), o(this._symbolSourceCaches[t1.source]);
            }
            getGlyphs(e, t1, i) {
                this.glyphManager.getGlyphs(t1.stacks, t1.scope, i);
            }
            getResource(t1, i, o) {
                return e.ct(i, o);
            }
            getOwnSourceCache(e) {
                return this._otherSourceCaches[e];
            }
            getOwnLayerSourceCache(e) {
                return "symbol" === e.type ? this._symbolSourceCaches[e.source] : this._otherSourceCaches[e.source];
            }
            getOwnSourceCaches(e) {
                const t1 = [];
                return this._otherSourceCaches[e] && t1.push(this._otherSourceCaches[e]), this._symbolSourceCaches[e] && t1.push(this._symbolSourceCaches[e]), t1;
            }
            _isSourceCacheLoaded(t1) {
                const i = this.getOwnSourceCaches(t1);
                return 0 === i.length ? (this.fire(new e.t(new Error(`There is no source with ID '${t1}'`))), !1) : i.every((e)=>e.loaded());
            }
            has3DLayers() {
                return this._has3DLayers;
            }
            hasSymbolLayers() {
                return this._hasSymbolLayers;
            }
            hasCircleLayers() {
                return this._hasCircleLayers;
            }
            isLayerClipped(e, t1) {
                if (!this._clipLayerPresent && "fill-extrusion" !== e.type) return !1;
                const i = "fill-extrusion" === e.type && "building" === e.sourceLayer;
                if (e.is3D()) {
                    if (i || t1 && "batched-model" === t1.type) return !0;
                    if ("model" === e.type) return !0;
                } else if ("symbol" === e.type) return !0;
                return !1;
            }
            _clearWorkerCaches() {
                this.dispatcher.broadcast("clearCaches");
            }
            destroy() {
                this._clearWorkerCaches(), this.fragments.forEach((e)=>{
                    e.style._remove();
                }), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
            }
        }
        co.getSourceType = function(e) {
            return et[e];
        }, co.setSourceType = function(e, t1) {
            et[e] = t1;
        }, co.registerForPluginStateChange = e.cc;
        var ho = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif", uo = "\nout vec4 glFragColor;highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}\n#ifdef INDICATOR_CUTOUT\nuniform vec2 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;\n#endif\nvec4 applyCutout(vec4 color) {\n#ifdef INDICATOR_CUTOUT\nfloat holeMinOpacity=u_indicator_cutout_params.x;float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);\n#else\nreturn color;\n#endif\n}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif\nvec4 textureLodCustom(sampler2D image,highp vec2 pos,highp vec2 lod_coord) {highp vec2 size=vec2(textureSize(image,0));highp vec2 dx=dFdx(lod_coord.xy*size);highp vec2 dy=dFdy(lod_coord.xy*size);highp float delta_max_sqr=max(dot(dx,dx),dot(dy,dy));highp float lod=0.5*log2(delta_max_sqr);return textureLod(image,pos,lod);}vec4 applyLUT(highp sampler3D lut,vec4 col) {vec3 size=vec3(textureSize(lut,0));vec3 uvw=(col.rbg*float(size-1.0)+0.5)/size;return vec4(texture(lut,uvw).rgb,col.a);}vec3 applyLUT(highp sampler3D lut,vec3 col) {return applyLUT(lut,vec4(col,1.0)).rgb;}", _o = "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const vec2 units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (units_to_pixels*pos+offset)/pattern_size;}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {return get_pattern_pos(pixel_coord_upper,pixel_coord_lower,pattern_size,vec2(tile_units_to_pixels),pos);}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)\n{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}", po = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", mo = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nvec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }\n#endif\n#ifdef DEPTH_OCCLUSION\nuniform highp sampler2D u_depth;uniform highp vec2 u_depth_size_inv;uniform highp vec2 u_depth_range_unpack;uniform highp float u_occluder_half_size;uniform highp float u_occlusion_depth_offset;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}vec4 unpack_depth4(vec4 depth) {return depth*u_depth_range_unpack.x+vec4(u_depth_range_unpack.y);}\n#else\nhighp float unpack_depth_rgba(vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;\n#ifdef DEPTH_D24\nfloat depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5).r);\n#else\nfloat depth=unpack_depth_rgba(texture(u_depth,(coord.xy+1.0)*0.5));\n#endif\nreturn coord.z+u_occlusion_depth_offset > depth;}highp vec4 getCornerDepths(vec2 coord) {highp vec3 df=vec3(u_occluder_half_size*u_depth_size_inv,0.0);highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef DEPTH_D24\nhighp vec4 depth=vec4(\ntexture(u_depth,uv-df.xz).r,texture(u_depth,uv+df.xz).r,texture(u_depth,uv-df.zy).r,texture(u_depth,uv+df.zy).r\n);depth=unpack_depth4(depth);\n#else\nhighp vec4 depth=vec4(\nunpack_depth_rgba(texture(u_depth,uv-df.xz)),unpack_depth_rgba(texture(u_depth,uv+df.xz)),unpack_depth_rgba(texture(u_depth,uv-df.zy)),unpack_depth_rgba(texture(u_depth,uv+df.zy))\n);\n#endif\nreturn depth;}highp float occlusionFadeMultiSample(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec2 uv=0.5*coord.xy+0.5;int NX=3;int NY=4;highp vec2 df=u_occluder_half_size*u_depth_size_inv;highp vec2 oneStep=2.0*u_occluder_half_size*u_depth_size_inv/vec2(NX-1,NY-1);highp float res=0.0;for (int y=0; y < NY;++y) {for (int x=0; x < NX;++x) {\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)));\n#endif\nres+=1.0-clamp(300.0*(coord.z+u_occlusion_depth_offset-depth),0.0,1.0);}}res=clamp(2.0*res/float(NX*NY)-0.5,0.0,1.0);return res;}highp float occlusionFade(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec4 depth=getCornerDepths(coord.xy);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z+u_occlusion_depth_offset)-depth),0.0,1.0));}\n#else\nbool isOccluded(vec4 frag) { return false; }highp float occlusionFade(vec4 frag) { return 1.0; }highp float occlusionFadeMultiSample(vec4 frag) { return 1.0; }\n#endif//DEPTH_OCCLUSION", fo = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", go = "highp vec3 hash(highp vec2 p) {highp vec3 p3=fract(p.xyx*vec3(443.8975,397.2973,491.1871));p3+=dot(p3,p3.yxz+19.19);return fract((p3.xxy+p3.yzz)*p3.zyx);}vec3 dither(vec3 color,highp vec2 seed) {vec3 rnd=hash(seed)+hash(seed+0.59374)-0.5;return color+rnd/255.0;}\n#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {\n#ifdef FOG_DITHERING\nvec2 dither_seed=gl_FragCoord.xy+u_fog_temporal_offset;return dither(color,dither_seed);\n#else\nreturn color;\n#endif\n}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", vo = "#ifdef RASTER_ARRAY\nuniform sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);ivec4 _raTexLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}vec2 _raTexLinearMix(highp vec2 fxy,highp vec4 colorMix,highp float colorOffset,highp vec4 t00,highp vec4 t10,highp vec4 t01,highp vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image0,c.yz,0),texelFetch(u_image0,c.xz,0),texelFetch(u_image0,c.yw,0),texelFetch(u_image0,c.xw,0)\n);}vec2 raTexture2D_image1_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image1,c.yz,0),texelFetch(u_image1,c.xz,0),texelFetch(u_image1,c.yw,0),texelFetch(u_image1,c.xw,0)\n);}vec2 raTexture2D_image0_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image0,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image1,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif", xo = "#ifdef RASTER_ARRAY\nuniform sampler2D u_velocity;uniform mediump vec2 u_velocity_res;uniform mediump float u_max_speed;const vec4 NO_DATA=vec4(1);const vec2 INVALID_VELOCITY=vec2(-1);uniform highp vec2 u_uv_offset;uniform highp float u_data_offset;uniform highp vec2 u_data_scale;ivec4 rasterArrayLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}highp vec2 lookup_velocity(highp vec2 uv) {uv=u_uv_offset.x+u_uv_offset.y*uv;highp vec2 fxy;ivec4 c=rasterArrayLinearCoord(uv,u_velocity_res,fxy);highp vec4 tl=texelFetch(u_velocity,c.yz,0);highp vec4 tr=texelFetch(u_velocity,c.xz,0);highp vec4 bl=texelFetch(u_velocity,c.yw,0);highp vec4 br=texelFetch(u_velocity,c.xw,0);if (tl==NO_DATA) {return INVALID_VELOCITY;}if (tr==NO_DATA) {return INVALID_VELOCITY;}if (bl==NO_DATA) {return INVALID_VELOCITY;}if (br==NO_DATA) {return INVALID_VELOCITY;}highp vec4 t=mix(mix(bl,br,fxy.x),mix(tl,tr,fxy.x),fxy.y);highp vec2 velocity=u_data_offset+vec2(dot(t.rg,u_data_scale),dot(t.ba,u_data_scale));velocity.y=-velocity.y;velocity/=max(u_max_speed,length(velocity));return velocity;}\n#endif\nuniform highp float u_particle_pos_scale;uniform highp vec2 u_particle_pos_offset;highp vec4 pack_pos_to_rgba(highp vec2 p) {highp vec2 v=(p+u_particle_pos_offset)/u_particle_pos_scale;highp vec4 r=vec4(v.x,fract(v.x*255.0),v.y,fract(v.y*255.0));return vec4(r.x-r.y/255.0,r.y,r.z-r.w/255.0,r.w);}highp vec2 unpack_pos_from_rgba(highp vec4 v) {v=floor(v*255.0+0.5)/255.0;highp vec2 p=vec2(v.x+(v.y/255.0),v.z+(v.w/255.0));return u_particle_pos_scale*p-u_particle_pos_offset;}", yo = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {vec3 transformed_normal=vec3(-normal.xy,normal.z);float NDotL=dot(normalize(transformed_normal),u_shadow_direction);float dotScale=min(1.0-NDotL,1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif//RENDER_SHADOWS", bo = "#ifdef RENDER_SHADOWS\n#ifdef DEPTH_TEXTURE\nuniform highp sampler2D u_shadowmap_0;uniform highp sampler2D u_shadowmap_1;\n#else\nuniform sampler2D u_shadowmap_0;uniform sampler2D u_shadowmap_1;\n#endif\nuniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;highp float shadow_sample_1(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_1,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_1,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}highp float shadow_sample_0(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_0,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_0,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}float shadow_occlusion_1(highp vec4 pos,highp float bias) {highp vec2 uv=pos.xy;return shadow_sample_1(uv,pos.z-bias);}float shadow_occlusion_0(highp vec4 pos,highp float bias) {highp float compare0=pos.z-bias;\n#ifdef NATIVE\nhighp vec2 uv=pos.xy;highp vec4 samples=textureGather(u_shadowmap_0,uv,0);lowp vec4 stepSamples=step(samples,vec4(compare0));\n#else\nhighp vec2 uv00=pos.xy-vec2(0.5*u_shadow_texel_size);highp vec2 uv10=uv00+vec2(u_shadow_texel_size,0.0);highp vec2 uv01=uv00+vec2(0.0,u_shadow_texel_size);highp vec2 uv11=uv01+vec2(u_shadow_texel_size,0.0);lowp vec4 stepSamples=vec4(\nshadow_sample_0(uv01,compare0),shadow_sample_0(uv11,compare0),shadow_sample_0(uv10,compare0),shadow_sample_0(uv00,compare0)\n);\n#endif\nvec2 f=fract(pos.xy*u_shadow_map_resolution-vec2(0.5));lowp vec2 lerpx=mix(stepSamples.wx,stepSamples.zy,f.xx);return mix(lerpx.x,lerpx.y,f.y);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {\n#ifdef SHADOWS_SINGLE_CASCADE\nlight_view_pos0.xyz=light_view_pos0.xyz/light_view_pos0.w*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);\n#else\nlight_view_pos0.xyz/=light_view_pos0.w;light_view_pos1.xyz/=light_view_pos1.w;vec4 uv=vec4(light_view_pos0.xy,light_view_pos1.xy);vec4 abs_bounds=abs(uv);if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {light_view_pos0.xyz=light_view_pos0.xyz*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}light_view_pos1.xyz=light_view_pos1.xyz*0.5+0.5;float occlusion1=shadow_occlusion_1(light_view_pos1,bias);return mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth));\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_opacity(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,float shadow_opacity) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias)*shadow_opacity;return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
        const wo = [];
        Do(ho, wo), Do(_o, wo), Do(uo, wo);
        const To = {
            "_prelude_fog.vertex.glsl": fo,
            "_prelude_terrain.vertex.glsl": mo,
            "_prelude_shadow.vertex.glsl": yo,
            "_prelude_fog.fragment.glsl": go,
            "_prelude_shadow.fragment.glsl": bo,
            "_prelude_lighting.glsl": "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif//LIGHTING_3D_MODE",
            "_prelude_raster_array.glsl": vo,
            "_prelude_raster_particle.glsl": xo
        }, Eo = {};
        Ro("", mo), Ro(go, fo), Ro(bo, yo), Ro(vo, ""), Ro(xo, "");
        const Co = Ro(uo, _o), So = ho;
        var Io = {
            background: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec4 u_color;uniform float u_opacity;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;uniform float u_emissive_strength;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            backgroundPattern: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in highp vec2 v_pos;void main() {highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=textureLodCustom(u_image,pos,v_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec2 u_pattern_units_to_pixels;in vec2 a_pos;out highp vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_pattern_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            circle: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float blur_positive=blur < 0.0 ? 0.0 : 1.0;lowp float antialiasblur=v_data.z;float extrude_length=length(extrude)+antialiasblur*(1.0-blur_positive);float antialiased_blur=-max(abs(blur),antialiasblur);float opacity_t=smoothstep((1.0-blur_positive)*antialiased_blur,blur_positive*antialiased_blur,extrude_length-1.0)-smoothstep(0.0,antialiasblur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'),
            clippingMask: Ro("void main() {glFragColor=vec4(1.0);}", "in vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: Ro('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            heatmapTexture: Ro("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"),
            collisionBox: Ro("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin vec3 a_pos;in vec2 a_anchor_pos;in vec2 a_extrude;in vec2 a_placed;in vec2 a_shift;in vec2 a_elevation_from_sea;in float a_size_scale;in vec2 a_padding;in float a_auto_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;out float v_placed;out float v_notUsed;void main() {float feature_elevation=a_elevation_from_sea.x+a_auto_z_offset;float terrain_elevation=(a_elevation_from_sea.y==1.0 ? 0.0 : elevation(a_anchor_pos));vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*(feature_elevation+terrain_elevation),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}'),
            collisionCircle: Ro("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: Ro("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}'),
            fill: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nin vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\nuniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillOutline: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nin vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\nuniform mat4 u_matrix;uniform vec2 u_world;out highp vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillOutlinePattern: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_emissive_strength;in highp vec2 v_pos;in highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\nout highp vec2 v_pos;out highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);v_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillPattern: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;in highp vec2 v_pos;uniform float u_emissive_strength;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\nout highp vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillExtrusion: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in vec4 v_flat;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\nuniform lowp float u_opacity;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nin float v_height;\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float emissive_strength\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor;\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\ncolor.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;uniform float u_width_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nuniform highp float u_vertical_scale;out vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp float emissive_strength\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);float attr_height=height;height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;float c_ele=0.0;vec3 pos;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat cutoff=1.0;vec3 scaled_pos=pos;\n#ifdef RENDER_CUTOFF\nvec3 centroid_random=vec3(centroid_pos.xy,centroid_pos.x+centroid_pos.y+1.0);vec3 ground_pos=centroid_pos.x==0.0 ? pos.xyz : (centroid_random/8.0);vec4 ground=u_matrix*vec4(ground_pos.xy,ele,1.0);cutoff=cutoff_opacity(u_cutoff_params,ground.z);if (centroid_pos.y !=0.0 && centroid_pos.x !=0.0) {vec3 g=floor(ground_pos);vec3 mod_=centroid_random-g*8.0;float seed=min(1.0,0.1*(min(3.5,max(mod_.x+mod_.y,0.2*attr_height))*0.35+mod_.z));if (cutoff < 0.8-seed) {cutoff=0.0;}}float cutoff_scale=cutoff;v_cutoff_opacity=cutoff;scaled_pos.z=mix(c_ele,h,cutoff_scale);\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (cutoff==0.0 && centroid_pos.x !=0.0) || (color.a==0.0));\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);scaled_pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;scaled_pos.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\ngl_Position=mix(u_matrix*vec4(scaled_pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);v_flat=vec4(linearProduct(color.rgb,vec3(calculate_NdotL(normal))),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            fillExtrusionDepth: Ro("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_width_scale;uniform float u_vertical_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp vec4 color\nout highp float v_depth;void main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp vec4 color\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;float ele=elevation(pos_nx.xy);float c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;float h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base);pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;pos.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);v_depth=gl_Position.z/gl_Position.w;}'),
            fillExtrusionPattern: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\nin highp vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_width_scale;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nout highp vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\n#pragma mapbox: define highp float line_width\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\n#pragma mapbox: initialize highp float line_width\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);p.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;p.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif \n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'),
            groundShadow: Ro('#include "_prelude_shadow.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\n#ifdef INDICATOR_CUTOUT\nshadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0)).r);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in vec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);v_fog_opacity=fog(v_fog_pos);\n#endif\n}'),
            fillExtrusionGroundEffect: Ro("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;\n#endif\nHANDLE_WIREFRAME_DEBUG;\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp vec4 a_pos_end;in highp float a_angular_offset_factor;in highp float a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp float u_dynamic_offset;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec2 p=a_pos_end.xy;vec2 q=floor(a_pos_end.zw*0.5);vec2 start_bottom=a_pos_end.zw-q*2.0;float fl_ground_radius=flood_light_ground_radius;fl_ground_radius=abs(flood_light_ground_radius);float direction=flood_light_ground_radius < 0.0 ?-1.0 : 1.0;float flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=a_angular_offset_factor/NORM*TANGENT_CUTOFF;float angular_offset=direction*angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(u_dynamic_offset,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=direction*perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=a_hidden_by_landmark;\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'),
            hillshadePrepare: Ro("precision highp float;uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            line: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform lowp float u_device_pixel_ratio;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;in vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture(u_dash_image,v_tex).r;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;alpha*=linearstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trim_alpha=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);out_color=mix(out_color,u_trim_color,transition_factor);trim_alpha=out_color.a;}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef RENDER_LINE_BORDER\nfloat edgeBlur=(border_width+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2.t-edgeBlur),v_width2.s-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);if (border_color.a==0.0) {float Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}} else {out_color.rgb=mix(border_color.rgb*border_color.a*trim_alpha,out_color.rgb,smoothAlpha);}}\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*opacity);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\nin float a_z_offset;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nin highp vec4 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nin float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);\n#ifdef ELEVATED_ROADS\ngl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset+0.01*step(0.01,a_z_offset),1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 halfCellProgress=normal.yx*32.0;float ele0=elevation(pos);float ele_line=max(ele0,max(elevation(pos+halfCellProgress),elevation(pos-halfCellProgress)));float ele1=elevation(pos+offsetTile);float ele2=elevation(pos-offsetTile);float ele_max=max(ele_line,0.5*(ele1+ele2));float ele=ele_max-ele0+ele1+a_z_offset ;gl_Position=u_matrix*vec4(pos+offsetTile,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*0.1*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nfloat a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec4(a_uv_x,a_split_index*texel_height-half_texel_height,a_clip_start,a_clip_end);\n#else\nv_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/floorwidth,(-normal.y*height+dash.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            linePattern: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform highp float u_device_pixel_ratio;uniform highp float u_alpha_discard_threshold;uniform highp vec2 u_texsize;uniform highp float u_tile_units_to_pixels;uniform highp vec2 u_trim_offset;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in highp float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec4 v_uv;\n#endif\n#ifdef LINE_JOIN_NONE\nin vec2 v_pattern_data;\n#endif\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;float pattern_size=display_size.x/u_tile_units_to_pixels;float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);highp float pattern_x=v_linesofar/pattern_size*aspect;highp float x=mod(pattern_x,1.0);highp float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;highp vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));highp vec2 lod_pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(pattern_x,y));vec4 color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {if (line_progress <=trim_end && line_progress >=trim_start) {color=vec4(0,0,0,0);}}\n#endif\n#ifdef LINE_JOIN_NONE\nfloat pattern_len=pattern_size/aspect;float segment_phase=pattern_len-mod(v_linesofar-v_pattern_data.x+pattern_len,pattern_len);float visible_start=segment_phase-step(pattern_len*0.5,segment_phase)*pattern_len;float visible_end=floor((v_pattern_data.y-segment_phase)/pattern_len)*pattern_len+segment_phase;visible_end+=step(pattern_len*0.5,v_pattern_data.y-visible_end)*pattern_len;if (v_pattern_data.x < visible_start || v_pattern_data.x >=visible_end) {color=vec4(0.0);}\n#endif\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_ground(color);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity);if (u_alpha_discard_threshold !=0.0) {if (color.a < u_alpha_discard_threshold) {discard;}}\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\nin float a_z_offset;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec4 a_packed;\n#endif\nin highp float a_linesofar;\n#ifdef LINE_JOIN_NONE\nin highp vec3 a_pattern_data;out vec2 v_pattern_data;\n#endif\nuniform mat4 u_matrix;uniform float u_tile_units_to_pixels;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out highp float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nout highp vec4 v_uv;\n#endif\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define mediump float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float floorwidth\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define mediump float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize mediump float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize mediump float pixel_ratio\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);vec2 dist=outset*a_extrude*scale;float u=0.5*a_direction;float t=1.0-abs(u);vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);\n#ifdef ELEVATED_ROADS\ngl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset+0.01*step(0.01,a_z_offset),1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 halfCellProgress=normal.yx*32.0;float ele0=elevation(pos);float ele_line=max(ele0,max(elevation(pos+halfCellProgress),elevation(pos-halfCellProgress)));float ele1=elevation(pos+offsetTile);float ele2=elevation(pos-offsetTile);float ele_max=max(ele_line,0.5*(ele1+ele2));float ele=ele_max-ele0+ele1+a_z_offset ;gl_Position=u_matrix*vec4(pos+offsetTile,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*0.1*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nfloat a_uv_x=a_packed[0];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];v_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;\n#ifdef LINE_JOIN_NONE\nv_width=floorwidth+ANTIALIASING;mediump float pixels_to_tile_units=1.0/u_tile_units_to_pixels;mediump float pixel_ratio_inverse=1.0/pixel_ratio;mediump float aspect=v_width/((pattern.w-pattern.y)*pixel_ratio_inverse);highp float subt_multiple=(pattern.z-pattern.x)*pixel_ratio_inverse*pixels_to_tile_units*aspect*32.0;highp float subt=floor(a_pattern_data.z/subt_multiple)*subt_multiple;float offset_sign=(fract(a_pattern_data.x)-0.5)*4.0;float line_progress_offset=offset_sign*v_width*0.5*pixels_to_tile_units;v_linesofar=(a_pattern_data.z-subt)+a_linesofar+line_progress_offset;v_pattern_data=vec2(a_pattern_data.x+line_progress_offset,a_pattern_data.y);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            raster: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;uniform highp float u_zoom_transition;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nin float v_split_fade;\n#endif\nuniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;\n#ifdef GLOBE_POLES\ncolor.a*=1.0-smoothstep(0.0,0.05,u_zoom_transition);\n#endif\nvec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef PROJECTION_GLOBE_VIEW\nglFragColor*=mix(1.0,1.0-smoothstep(0.0,0.05,u_zoom_transition),smoothstep(0.8,0.9,v_split_fade));\n#endif\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;in vec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nout float v_split_fade;\n#endif\nvoid main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos   ,1.0);uv=a_uv;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\nfloat w=1.0+dot(a_texture_pos,u_perspective_transform);uv=a_texture_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);    \nv_split_fade=0.0;if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;float opposite_merc_center=mod(u_merc_center.x+0.5,1.0);float dist_from_poles=(abs(mercatorY-0.5)*2.0);float range=0.1;v_split_fade=abs(opposite_merc_center-mercatorX);v_split_fade=clamp(1.0-v_split_fade,0.0,1.0);v_split_fade=max(smoothstep(1.0-range,1.0,dist_from_poles),max(smoothstep(1.0-range,1.0,v_split_fade),smoothstep(1.0-range,1.0,1.0-v_split_fade)));}float tiles=u_grid_matrix[0][2];if (tiles > 0.0) {float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvY=mercatorY*tiles-idy;float uvX=mercatorX*tiles-idx;uv=vec2(uvX,uvY);}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\ngl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef RENDER_CUTOFF\nv_depth=gl_Position.z;\n#endif\n}'),
            rasterParticle: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;uniform sampler2D u_image0;uniform sampler2D u_image1;void main() {vec4 color0,color1,color;color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 out_color=color.rgb;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),0.0).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\nin vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {float w=1.0;vec2 uv;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvX=mercatorX*tiles-idx;float uvY=mercatorY*tiles-idy;uv=vec2(uvX,uvY);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nuv=a_texture_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}'),
            rasterParticleDraw: Ro("uniform sampler2D u_color_ramp;in float v_particle_speed;void main() {glFragColor=texture(u_color_ramp,vec2(v_particle_speed,0.5));}", '#include "_prelude_raster_particle.glsl"\nin float a_index;uniform sampler2D u_particle_texture;uniform float u_particle_texture_side_len;uniform vec2 u_tile_offset;out float v_particle_speed;void main() {ivec2 pixel_coord=ivec2(\nmod(a_index,u_particle_texture_side_len),a_index/u_particle_texture_side_len);vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);vec2 pos=unpack_pos_from_rgba(pixel)+u_tile_offset;vec2 tex_coord=fract(pos);vec2 velocity=lookup_velocity(tex_coord);if (velocity==INVALID_VELOCITY) {gl_Position=AWAY;v_particle_speed=0.0;} else {gl_Position=vec4(2.0*pos-1.0,0,1);v_particle_speed=length(velocity);}gl_PointSize=1.0;}'),
            rasterParticleTexture: Ro("uniform sampler2D u_texture;uniform float u_opacity;in vec2 v_tex_pos;void main() {vec4 color=texture(u_texture,v_tex_pos);glFragColor=vec4(floor(255.0*color*u_opacity)/255.0);}", "in vec2 a_pos;out vec2 v_tex_pos;void main() {vec2 uv=0.5*a_pos+vec2(0.5);v_tex_pos=uv;gl_Position=vec4(a_pos,0.0,1.0);}"),
            rasterParticleUpdate: Ro('#include "_prelude_raster_particle.glsl"\nuniform sampler2D u_particle_texture;uniform mediump float u_particle_texture_side_len;uniform mediump float u_speed_factor;uniform highp float u_reset_rate;uniform highp float u_rand_seed;in highp vec2 v_tex_coord;vec2 linearstep(vec2 edge0,vec2 edge1,vec2 x) {return  clamp((x-edge0)/(edge1-edge0),vec2(0),vec2(1));}const highp vec3 rand_constants=vec3(12.9898,78.233,4375.85453);highp float rand(const highp vec2 co) {highp float t=dot(rand_constants.xy,co);return fract(sin(t)*(rand_constants.z+t));}void main() {ivec2 pixel_coord=ivec2(v_tex_coord*u_particle_texture_side_len);highp vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);highp vec2 pos=unpack_pos_from_rgba(pixel);highp vec2 velocity=lookup_velocity(clamp(pos,0.0,1.0));highp vec2 dp=velocity==INVALID_VELOCITY ? vec2(0) : velocity*u_speed_factor;pos=pos+dp;highp vec2 seed=(pos+v_tex_coord)*u_rand_seed;highp vec2 random_pos=vec2(rand(seed+1.3),rand(seed+2.1));highp vec2 persist_rate=pow(\nlinearstep(vec2(-u_particle_pos_offset),vec2(0),pos)*linearstep(vec2(1.0+u_particle_pos_offset),vec2(1),pos),vec2(4)\n);highp vec2 per_frame_persist=pow(persist_rate,abs(dp)/u_particle_pos_offset);highp float drop_rate=1.0-per_frame_persist.x*per_frame_persist.y;drop_rate=any(greaterThanEqual(abs(pos-0.5),vec2(0.5+u_particle_pos_offset))) ? 1.0 : drop_rate;highp float drop=step(1.0-drop_rate-u_reset_rate,rand(seed));highp vec2 next_pos=mix(pos,random_pos,drop);glFragColor=pack_pos_to_rgba(next_pos);}', "in vec2 a_pos;out vec2 v_tex_coord;void main() {v_tex_coord=0.5*(a_pos+vec2(1.0));gl_Position=vec4(a_pos,0.0,1.0);}"),
            symbol: Ro('#include "_prelude_lighting.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_halo;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\n#ifdef COLOR_ADJUSTMENT\nuniform mat4 u_color_adj_mat;\n#endif\nin vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\nin float v_draw_halo;in vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nin float is_sdf;in vec2 v_tex_a_icon;\n#endif\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nvec4 out_color;float fade_opacity=v_gamma_scale_size_fade_opacity[2];\n#ifdef RENDER_TEXT_AND_SYMBOL\nif (is_sdf==ICON) {vec2 tex_icon=v_tex_a_icon;lowp float alpha=opacity*fade_opacity;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}\n#endif\n#ifdef RENDER_SDF\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_gamma_scale_size_fade_opacity.x;float size=v_gamma_scale_size_fade_opacity.y;float fontScale=u_is_text ? size/24.0 : size;out_color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {out_color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,v_tex_a).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);out_color*=alpha;\n#else\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b);\n#else\nout_color=texture(u_texture,v_tex_a);\n#endif\n#ifdef COLOR_ADJUSTMENT\nout_color=u_color_adj_mat*out_color;\n#endif\n#endif\nout_color*=opacity*fade_opacity;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_auto_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin vec2 a_texb;\n#endif\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_elevation_from_sea;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_draw_halo;out vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nout float is_sdf;out vec2 v_tex_a_icon;\n#endif\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\n#pragma mapbox: define lowp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\n#pragma mapbox: initialize lowp float z_offset\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=u_elevation_from_sea ? z_offset : z_offset+elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_auto_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=a_globe_anchor+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\n#ifdef Z_OFFSET\nz+=u_pitch_with_map ? a_auto_z_offset+(u_elevation_from_sea ? z_offset : z_offset) : 0.0;\n#else\nz+=u_pitch_with_map ? (u_elevation_from_sea ? z_offset : z_offset) : 0.0;\n#endif\nfloat occlusion_fade=globe_occlusion_fade;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float out_fade_opacity=interpolated_fade_opacity*projection_transition_fade;\n#ifdef DEPTH_OCCLUSION\nfloat depth_occlusion=occlusionFadeMultiSample(projected_point);float depth_occlusion_multplier=mix(occlusion_opacity,1.0,depth_occlusion);out_fade_opacity*=depth_occlusion_multplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nfloat gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_gamma_scale_size_fade_opacity=vec3(gamma_scale,size,out_fade_opacity);v_tex_a=a_tex/u_texsize;\n#ifdef RENDER_TEXT_AND_SYMBOL\nis_sdf=a_size[0]-2.0*a_size_min;v_tex_a_icon=a_tex/u_texsize_icon;\n#endif\n#ifdef ICON_TRANSITION\nv_tex_b=a_texb/u_texsize;\n#endif\n}'),
            terrainRaster: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;in vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nvec3 unlit_base=image_color.rgb*(1.0-image_color.a);vec3 emissive_base=image_color.rgb*image_color.a;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor.rgb=mix(color.rgb,image_color.rgb,image_color.a);color.a=1.0;\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in vec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);\n#endif\n}'),
            terrainDepth: Ro("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;out float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'),
            skybox: Ro('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color.rgb=dither(sky_color.rgb,gl_FragCoord.xy+u_temporal_offset);sky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', po),
            skyboxGradient: Ro('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;color.rgb=dither(color.rgb,gl_FragCoord.xy+u_temporal_offset);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', po),
            skyboxCapture: Ro("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),
            globeRaster: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;uniform float u_far_z_cutoff;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nvec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);vec3 dir=normalize(ray_dir);vec3 closest_point=dot(u_globe_pos,dir)*dir;float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nraster=apply_lighting_with_emission_ground(raster,raster.a);color=vec4(raster.rgb*antialias,antialias);\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor=apply_lighting_with_emission_ground(color,color.a);color.a=1.0;\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=1.0-step(u_far_z_cutoff,1.0/gl_FragCoord.w);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}'),
            globeAtmosphere: Ro('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\n#ifdef NATIVE\nglFragColor=vec4(1,1,1,1);\n#else\nglFragColor=vec4(0,0,0,1);\n#endif\nreturn;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;\n#ifndef NATIVE\nc=dither(c,gl_FragCoord.xy+u_temporal_offset);\n#endif\nglFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"),
            model: Ro('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_opacity;uniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;uniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nuniform vec4 u_occlusionTextureTransform;\n#endif\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_pbr\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nin highp float v_depth;uniform highp sampler2D u_depthTexture;uniform highp vec2 u_inv_depth_size;uniform highp vec2 u_depth_range_unpack;\n#ifdef DEPTH_D24\nhighp float unpack_depth(highp float depth) {return  depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}\n#else\nhighp float unpack_depth_rgba(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded() {highp vec2 coord=gl_FragCoord.xy*u_inv_depth_size;\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depthTexture,coord).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depthTexture,coord));\n#endif\nreturn v_depth > depth+0.0005;}\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\nif(texColor.w > 0.0) {texColor.rgb/=texColor.w;}texColor.w=1.0;\n#endif\nif(u_baseTextureIsAlpha) {if (texColor.r < 0.5) {discard;}} else {texColor.rgb=sRGBToLinear(texColor.rgb);albedo*=texColor;}\n#endif\nvec4 color=vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\nreturn color;}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;highp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_3f\nn=normalize(normal_3f);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));n=normalize(cross(fdx,fdy))*-1.0;\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_pbr\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f) \nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nif (isOccluded()) {discard;}\n#endif\nvec3 lightDir=u_lightpos;vec3 lightColor=u_lightcolor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 baseColor=getBaseColor().rgb;vec3 diffuse=getDiffuseShadedColor(baseColor,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(mix(diffuse,baseColor,u_emissive_strength),1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nvec2 uv=uv_2f.xy*u_occlusionTextureTransform.zw+u_occlusionTextureTransform.xy;\n#else\nvec2 uv=uv_2f;\n#endif\nao=(texture(u_occlusionTexture,uv).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nfloat emissiveFactorLength=max(length(u_emissiveFactor.rgb),0.001);emissive.rgb=sRGBToLinear(applyLUT(u_lutTexture,linearTosRGB(emissive.rgb/emissiveFactorLength).rbg))*emissiveFactorLength;\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_pbr\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);vec3 color_mix=v_color_mix.rgb;\n#ifdef APPLY_LUT_ON_GPU\ncolor_mix=applyLUT(u_lutTexture,color_mix);\n#endif\ncolor=mix(color,color_mix,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nfinalColor=applyCutout(finalColor);\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp vec4 pbr\n#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength\nuniform mat4 u_matrix;uniform mat4 u_node_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nout highp float v_depth;\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp vec4 pbr\n#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float hidden=float(pos_a.x > EXTENT);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=mix(u_matrix*pos,AWAY,hidden);pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_pbr\nvec4 albedo_c=decode_color(pbr.xy);vec2 e_r_m=unpack_float(pbr.z);vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(pbr.w)/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);\n#else\nnormal_3f=vec3(normal_matrix*vec4(normal_3f,0));\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shadow_pos=u_node_matrix*vec4(local_pos,1.0);\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normal_3f);shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*shadow_pos;v_pos_light_view_1=u_light_matrix_1*shadow_pos;v_depth_shadows=gl_Position.w;\n#endif\n}'),
            modelDepth: Ro("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float hidden=float(pos_a.x > EXTENT);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=mix(u_matrix*pos,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\nv_depth=gl_Position.z/gl_Position.w;}"),
            stars: Ro("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_fade_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_fade_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}"),
            occlusion: Ro("uniform vec4 u_color;void main() {glFragColor=u_color;}", '#include "_prelude_terrain.vertex.glsl"\nin highp vec2 a_offset_xy;uniform highp vec3 u_anchorPos;uniform mat4 u_matrix;uniform vec2 u_screenSizePx;uniform vec2 u_occluderSizePx;void main() {vec3 world_pos=u_anchorPos;\n#ifdef TERRAIN\nfloat e=elevation(world_pos.xy);world_pos.z+=e;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1.0);projected_point.xy+=projected_point.w*a_offset_xy*0.5*u_occluderSizePx/u_screenSizePx;gl_Position=projected_point;}')
        };
        function Do(e, t1) {
            const i = e.replace(/\s*\/\/[^\n]*\n/g, "\n").split("\n");
            for (let e of i)if (e = e.trim(), "#" === e[0] && e.includes("if") && !e.includes("endif")) {
                e = e.replace("#", "").replace(/ifdef|ifndef|elif|if/g, "").replace(/!|defined|\(|\)|\|\||&&/g, "").replace(/\s+/g, " ").trim();
                const i = e.split(" ");
                for (const e of i)t1.includes(e) || t1.push(e);
            }
        }
        function Ro(e, t1) {
            const i = /#include\s+"([^"]+)"/g, o = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g;
            let r = t1.match(/(attribute(\S*)|(^\s*|;)in) (highp |mediump |lowp )?([\w]+) ([\w]+)/gm);
            r && (r = r.map((e)=>{
                const t1 = e.split(" ");
                return t1[t1.length - 1];
            }), r = [
                ...new Set(r)
            ]);
            const s = {}, a = [], n = [];
            if (e = e.replace(i, (e, t1)=>(n.push(t1), "")), (t1 = t1.replace(i, (e, t1)=>(a.push(t1), ""))).includes("flat out")) return void console.error('The usage of "flat" qualifier is disallowed, see: https://bugs.webkit.org/show_bug.cgi?id=268071');
            let l = [
                ...wo
            ];
            Do(e, l), Do(t1, l);
            for (const e of [
                ...a,
                ...n
            ])To[e] || console.error(`Undefined include: ${e}`), Eo[e] || (Eo[e] = [], Do(To[e], Eo[e])), l = [
                ...l,
                ...Eo[e]
            ];
            return {
                fragmentSource: e = e.replace(o, (e, t1, i, o, r)=>(s[r] = !0, "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${r}\nin ${i} ${o} ${r};\n#else\nuniform ${i} ${o} u_${r};\n#endif\n` : "initialize" === t1 ? `\n#ifdef HAS_UNIFORM_u_${r}\n    ${i} ${o} ${r} = u_${r};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${r}\n    in ${i} ${o} ${r};\n#endif\n` : "initialize-attribute" === t1 ? "" : void 0)),
                vertexSource: t1 = t1.replace(o, (e, t1, i, o, r)=>{
                    const a = "float" === o ? "vec2" : o, n = r.match(/color/) ? "color" : a;
                    return "define-attribute-vertex-shader-only" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${r}\nin ${i} ${o} a_${r};\n#endif\n` : s[r] ? "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${r}\nuniform lowp float u_${r}_t;\nin ${i} ${a} a_${r};\nout ${i} ${o} ${r};\n#else\nuniform ${i} ${o} u_${r};\n#endif\n` : "initialize" === t1 ? "vec4" === n ? `\n#ifndef HAS_UNIFORM_u_${r}\n    ${r} = a_${r};\n#else\n    ${i} ${o} ${r} = u_${r};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${r}\n    ${r} = unpack_mix_${n}(a_${r}, u_${r}_t);\n#else\n    ${i} ${o} ${r} = u_${r};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${r}\n    in ${i} ${o} a_${r};\n    out ${i} ${o} ${r};\n#endif\n` : "initialize-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${r}\n    ${r} = a_${r};\n#endif\n` : void 0 : "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${r}\nuniform lowp float u_${r}_t;\nin ${i} ${a} a_${r};\n#else\nuniform ${i} ${o} u_${r};\n#endif\n` : "define-instanced" === t1 ? "mat4" === n ? `\n#ifdef INSTANCED_ARRAYS\nin vec4 a_${r}0;\nin vec4 a_${r}1;\nin vec4 a_${r}2;\nin vec4 a_${r}3;\n#else\nuniform ${i} ${o} u_${r};\n#endif\n` : `\n#ifdef INSTANCED_ARRAYS\nin ${i} ${a} a_${r};\n#else\nuniform ${i} ${o} u_${r};\n#endif\n` : "initialize-attribute-custom" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${r}\n    ${i} ${o} ${r} = a_${r};\n#endif\n` : "vec4" === n ? `\n#ifndef HAS_UNIFORM_u_${r}\n    ${i} ${o} ${r} = a_${r};\n#else\n    ${i} ${o} ${r} = u_${r};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${r}\n    ${i} ${o} ${r} = unpack_mix_${n}(a_${r}, u_${r}_t);\n#else\n    ${i} ${o} ${r} = u_${r};\n#endif\n`;
                }),
                staticAttributes: r,
                usedDefines: l,
                vertexIncludes: a,
                fragmentIncludes: n
            };
        }
        class Ao {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
            }
            bind(e, t1, i, o, r, s, a, n) {
                this.context = e;
                let l = this.boundPaintVertexBuffers.length !== o.length;
                for(let e = 0; !l && e < o.length; e++)this.boundPaintVertexBuffers[e] !== o[e] && (l = !0);
                let c = this.boundDynamicVertexBuffers.length !== a.length;
                for(let e = 0; !c && e < a.length; e++)this.boundDynamicVertexBuffers[e] !== a[e] && (c = !0);
                if (!this.vao || this.boundProgram !== t1 || this.boundLayoutVertexBuffer !== i || l || c || this.boundIndexBuffer !== r || this.boundVertexOffset !== s) this.freshBind(t1, i, o, r, s, a, n);
                else {
                    e.bindVertexArrayOES.set(this.vao);
                    for (const i of a)i && (i.bind(), n && i.instanceCount && i.setVertexAttribDivisor(e.gl, t1, n));
                    r && r.dynamicDraw && r.bind();
                }
            }
            freshBind(e, t1, i, o, r, s, a) {
                const n = e.numAttributes, l = this.context, c = l.gl;
                this.vao && this.destroy(), this.vao = l.gl.createVertexArray(), l.bindVertexArrayOES.set(this.vao), this.boundProgram = e, this.boundLayoutVertexBuffer = t1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = o, this.boundVertexOffset = r, this.boundDynamicVertexBuffers = s, t1.enableAttributes(c, e), t1.bind(), t1.setVertexAttribPointers(c, e, r);
                for (const t1 of i)t1.enableAttributes(c, e), t1.bind(), t1.setVertexAttribPointers(c, e, r);
                for (const t1 of s)t1 && (t1.enableAttributes(c, e), t1.bind(), t1.setVertexAttribPointers(c, e, r), a && t1.instanceCount && t1.setVertexAttribDivisor(c, e, a));
                o && o.bind(), l.currentNumAttributes = n;
            }
            destroy() {
                this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        function Lo(t1, i) {
            const o = Math.pow(2, i.canonical.z), r = i.canonical.y;
            return [
                new e.a5(0, r / o).toLngLat().lat,
                new e.a5(0, (r + 1) / o).toLngLat().lat
            ];
        }
        function Po(t1, i, o, r, s, a, n) {
            const l = t1.context, c = l.gl, h = o.hillshadeFBO;
            if (!h) return;
            t1.prepareDrawTile();
            const u = t1.isTileAffectedByFog(i), d = t1.getOrCreateProgram("hillshade", {
                overrideFog: u
            });
            l.activeTexture.set(c.TEXTURE0), c.bindTexture(c.TEXTURE_2D, h.colorAttachment.get());
            const _ = ((t1, i, o, r)=>{
                const s = o.paint.get("hillshade-shadow-color"), a = o.paint.get("hillshade-highlight-color"), n = o.paint.get("hillshade-accent-color"), l = o.paint.get("hillshade-emissive-strength");
                let c = e.bB(o.paint.get("hillshade-illumination-direction"));
                if ("viewport" === o.paint.get("hillshade-illumination-anchor")) c -= t1.transform.angle;
                else if (t1.style && t1.style.enable3dLights() && t1.style.directionalLight) {
                    const i = t1.style.directionalLight.properties.get("direction"), o = e.c7(i.x, i.y, i.z);
                    c = e.bB(o[1]);
                }
                const h = !t1.options.moving;
                return {
                    u_matrix: r || t1.transform.calculateProjMatrix(i.tileID.toUnwrapped(), h),
                    u_image: 0,
                    u_latrange: Lo(0, i.tileID),
                    u_light: [
                        o.paint.get("hillshade-exaggeration"),
                        c
                    ],
                    u_shadow: s.toRenderColor(o.lut),
                    u_highlight: a.toRenderColor(o.lut),
                    u_emissive_strength: l,
                    u_accent: n.toRenderColor(o.lut)
                };
            })(t1, o, r, t1.terrain ? i.projMatrix : null);
            t1.uploadCommonUniforms(l, d, i.toUnwrapped());
            const { tileBoundsBuffer: p, tileBoundsIndexBuffer: m, tileBoundsSegments: f } = t1.getTileBoundsBuffers(o);
            d.draw(t1, c.TRIANGLES, s, a, n, Fi.disabled, _, r.id, p, m, f);
        }
        function Mo(t1, i, o) {
            if (!i.needsDEMTextureUpload) return;
            const r = t1.context, s = r.gl;
            r.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || t1.getTileTexture(o.stride);
            const a = o.getPixels();
            i.demTexture ? i.demTexture.update(a, {
                premultiply: !1
            }) : i.demTexture = new e.T(r, a, s.R32F, {
                premultiply: !1
            }), i.needsDEMTextureUpload = !1;
        }
        function zo(t1, i, o) {
            const r = t1.context, s = r.gl;
            if (!i.dem) return;
            const a = i.dem;
            if (r.activeTexture.set(s.TEXTURE1), Mo(t1, i, a), !i.demTexture) return;
            i.demTexture.bind(s.NEAREST, s.CLAMP_TO_EDGE);
            const n = a.dim;
            r.activeTexture.set(s.TEXTURE0);
            let l = i.hillshadeFBO;
            if (!l) {
                const t1 = new e.T(r, {
                    width: n,
                    height: n,
                    data: null
                }, s.RGBA8);
                t1.bind(s.LINEAR, s.CLAMP_TO_EDGE), l = i.hillshadeFBO = r.createFramebuffer(n, n, !0, "renderbuffer"), l.colorAttachment.set(t1.texture);
            }
            r.bindFramebuffer.set(l.framebuffer), r.viewport.set([
                0,
                0,
                n,
                n
            ]);
            const { tileBoundsBuffer: c, tileBoundsIndexBuffer: h, tileBoundsSegments: u } = t1.getMercatorTileBoundsBuffers(), d = [];
            t1.linearFloatFilteringSupported() && d.push("TERRAIN_DEM_FLOAT_FORMAT"), t1.getOrCreateProgram("hillshadePrepare", {
                defines: d
            }).draw(t1, s.TRIANGLES, Li.disabled, Mi.disabled, Ai.unblended, Fi.disabled, ((t1, i)=>{
                const o = i.stride, r = e.a6.mat4.create();
                return e.a6.mat4.ortho(r, 0, e.ab, -e.ab, 0, 0, 1), e.a6.mat4.translate(r, r, [
                    0,
                    -e.ab,
                    0
                ]), {
                    u_matrix: r,
                    u_image: 1,
                    u_dimension: [
                        o,
                        o
                    ],
                    u_zoom: t1.overscaledZ
                };
            })(i.tileID, a), o.id, c, h, u), i.needsHillshadePrepare = !1;
        }
        class Oo {
            constructor(e){
                this.gl = e.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(e) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class Fo extends Oo {
            getDefault() {
                return e.bz.transparent;
            }
            set(e) {
                const t1 = this.current;
                (e.r !== t1.r || e.g !== t1.g || e.b !== t1.b || e.a !== t1.a || this.dirty) && (this.gl.clearColor(e.r, e.g, e.b, e.a), this.current = e, this.dirty = !1);
            }
        }
        class ko extends Oo {
            getDefault() {
                return 1;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.clearDepth(e), this.current = e, this.dirty = !1);
            }
        }
        class Bo extends Oo {
            getDefault() {
                return 0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.clearStencil(e), this.current = e, this.dirty = !1);
            }
        }
        class No extends Oo {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || e[3] !== t1[3] || this.dirty) && (this.gl.colorMask(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class Uo extends Oo {
            getDefault() {
                return !0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.depthMask(e), this.current = e, this.dirty = !1);
            }
        }
        class Go extends Oo {
            getDefault() {
                return 255;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.stencilMask(e), this.current = e, this.dirty = !1);
            }
        }
        class jo extends Oo {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e) {
                const t1 = this.current;
                (e.func !== t1.func || e.ref !== t1.ref || e.mask !== t1.mask || this.dirty) && (this.gl.stencilFunc(e.func, e.ref, e.mask), this.current = e, this.dirty = !1);
            }
        }
        class Vo extends Oo {
            getDefault() {
                const e = this.gl;
                return [
                    e.KEEP,
                    e.KEEP,
                    e.KEEP
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || this.dirty) && (this.gl.stencilOp(e[0], e[1], e[2]), this.current = e, this.dirty = !1);
            }
        }
        class qo extends Oo {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.STENCIL_TEST) : t1.disable(t1.STENCIL_TEST), this.current = e, this.dirty = !1;
            }
        }
        class Zo extends Oo {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || this.dirty) && (this.gl.depthRange(e[0], e[1]), this.current = e, this.dirty = !1);
            }
        }
        class Ho extends Oo {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.DEPTH_TEST) : t1.disable(t1.DEPTH_TEST), this.current = e, this.dirty = !1;
            }
        }
        class Wo extends Oo {
            getDefault() {
                return this.gl.LESS;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.depthFunc(e), this.current = e, this.dirty = !1);
            }
        }
        class $o extends Oo {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.BLEND) : t1.disable(t1.BLEND), this.current = e, this.dirty = !1;
            }
        }
        class Xo extends Oo {
            getDefault() {
                const e = this.gl;
                return [
                    e.ONE,
                    e.ZERO,
                    e.ONE,
                    e.ZERO
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || e[3] !== t1[3] || this.dirty) && (this.gl.blendFuncSeparate(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class Yo extends Oo {
            getDefault() {
                return e.bz.transparent;
            }
            set(e) {
                const t1 = this.current;
                (e.r !== t1.r || e.g !== t1.g || e.b !== t1.b || e.a !== t1.a || this.dirty) && (this.gl.blendColor(e.r, e.g, e.b, e.a), this.current = e, this.dirty = !1);
            }
        }
        class Ko extends Oo {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e, e), this.current = e, this.dirty = !1);
            }
        }
        class Jo extends Oo {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.CULL_FACE) : t1.disable(t1.CULL_FACE), this.current = e, this.dirty = !1;
            }
        }
        class Qo extends Oo {
            getDefault() {
                return this.gl.BACK;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.cullFace(e), this.current = e, this.dirty = !1);
            }
        }
        class er extends Oo {
            getDefault() {
                return this.gl.CCW;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.frontFace(e), this.current = e, this.dirty = !1);
            }
        }
        let tr = class extends Oo {
            getDefault() {
                return null;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.useProgram(e), this.current = e, this.dirty = !1);
            }
        };
        class ir extends Oo {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.activeTexture(e), this.current = e, this.dirty = !1);
            }
        }
        class or extends Oo {
            getDefault() {
                const e = this.gl;
                return [
                    0,
                    0,
                    e.drawingBufferWidth,
                    e.drawingBufferHeight
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || e[3] !== t1[3] || this.dirty) && (this.gl.viewport(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class rr extends Oo {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindFramebuffer(t1.FRAMEBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class sr extends Oo {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindRenderbuffer(t1.RENDERBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class ar extends Oo {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindTexture(t1.TEXTURE_2D, e), this.current = e, this.dirty = !1;
            }
        }
        class nr extends Oo {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindBuffer(t1.ARRAY_BUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class lr extends Oo {
            getDefault() {
                return null;
            }
            set(e) {
                const t1 = this.gl;
                t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class cr extends Oo {
            getDefault() {
                return null;
            }
            set(e) {
                this.gl && (e !== this.current || this.dirty) && (this.gl.bindVertexArray(e), this.current = e, this.dirty = !1);
            }
        }
        class hr extends Oo {
            getDefault() {
                return 4;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_ALIGNMENT, e), this.current = e, this.dirty = !1;
            }
        }
        class ur extends Oo {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e), this.current = e, this.dirty = !1;
            }
        }
        class dr extends Oo {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, e), this.current = e, this.dirty = !1;
            }
        }
        class _r extends Oo {
            constructor(e, t1){
                super(e), this.context = e, this.parent = t1;
            }
            getDefault() {
                return null;
            }
        }
        class pr extends _r {
            setDirty() {
                this.dirty = !0;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0, t1.TEXTURE_2D, e, 0), this.current = e, this.dirty = !1;
            }
        }
        class mr extends _r {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferRenderbuffer(t1.FRAMEBUFFER, this.attachment(), t1.RENDERBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class fr extends _r {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, this.attachment(), t1.TEXTURE_2D, e, 0), this.current = e, this.dirty = !1;
            }
        }
        class gr extends mr {
            attachment() {
                return this.gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        const vr = (e, t1, i)=>({
                u_matrix: e,
                u_image0: 0,
                u_skirt_height: t1,
                u_ground_shadow_factor: i
            }), xr = (e, t1, i, o, r, s, a, n, l, c, h, u, d, _, p, m)=>({
                u_proj_matrix: Float32Array.from(e),
                u_globe_matrix: t1,
                u_normalize_matrix: Float32Array.from(o),
                u_merc_matrix: i,
                u_zoom_transition: r,
                u_merc_center: s,
                u_image0: 0,
                u_frustum_tl: a,
                u_frustum_tr: n,
                u_frustum_br: l,
                u_frustum_bl: c,
                u_globe_pos: h,
                u_globe_radius: u,
                u_viewport: d,
                u_grid_matrix: m ? Float32Array.from(m) : new Float32Array(9),
                u_skirt_height: _,
                u_far_z_cutoff: p
            });
        function yr(e, t1) {
            return null != e && null != t1 && !(!e.hasData() || !t1.hasData()) && null != e.demTexture && null != t1.demTexture && e.tileID.key !== t1.tileID.key;
        }
        const br = new class {
            constructor(){
                this.operations = {};
            }
            newMorphing(e, t1, i, o, r) {
                if (e in this.operations) {
                    const t1 = this.operations[e];
                    t1.to.tileID.key !== i.tileID.key && (t1.queued = i);
                } else this.operations[e] = {
                    startTime: o,
                    phase: 0,
                    duration: r,
                    from: t1,
                    to: i,
                    queued: null
                };
            }
            getMorphValuesForProxy(e) {
                if (!(e in this.operations)) return null;
                const t1 = this.operations[e];
                return {
                    from: t1.from,
                    to: t1.to,
                    phase: t1.phase
                };
            }
            update(e) {
                for(const t1 in this.operations){
                    const i = this.operations[t1];
                    for(i.phase = (e - i.startTime) / i.duration; i.phase >= 1 || !this._validOp(i);)if (!this._nextOp(i, e)) {
                        delete this.operations[t1];
                        break;
                    }
                }
            }
            _nextOp(e, t1) {
                return !!e.queued && (e.from = e.to, e.to = e.queued, e.queued = null, e.phase = 0, e.startTime = t1, !0);
            }
            _validOp(e) {
                return e.from.hasData() && e.to.hasData();
            }
        }, wr = {
            0: null,
            1: "TERRAIN_VERTEX_MORPHING"
        };
        function Tr(e, t1, i) {
            if (0 === t1) return 0;
            const o = t1 < 1 && 514 === i ? .25 / t1 : 1;
            return 6 * Math.pow(1.5, 22 - e) * Math.max(t1, 1) * o;
        }
        function Er(e, t1) {
            const i = 1 << e.z;
            return !t1 && (0 === e.x || e.x === i - 1) || 0 === e.y || e.y === i - 1;
        }
        const Cr = (e)=>({
                u_matrix: e
            });
        function Sr(t1, i, o, r, s) {
            if (s > 0) {
                const a = e.q.now(), n = (a - t1.timeAdded) / s, l = i ? (a - i.timeAdded) / s : -1, c = o.getSource(), h = r.coveringZoomLevel({
                    tileSize: c.tileSize,
                    roundZoom: c.roundZoom
                }), u = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(t1.tileID.overscaledZ - h), d = u && t1.refreshedUponExpiration ? 1 : e.ap(u ? n : 1 - l, 0, 1);
                return t1.refreshedUponExpiration && n >= 1 && (t1.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - d
                } : {
                    opacity: d,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        class Ir extends vt {
            constructor(t1){
                const i = {
                    type: "raster-dem",
                    maxzoom: t1.transform.maxZoom
                }, o = new e.cd(e.ce(), null), r = tt("mock-dem", i, o, t1.style);
                super("mock-dem", r, !1), r.setEventedParent(this), this._sourceLoaded = !0;
            }
            _loadTile(e, t1) {
                e.state = "loaded", t1(null);
            }
        }
        class Dr extends vt {
            constructor(t1){
                const i = tt("proxy", {
                    type: "geojson",
                    maxzoom: t1.transform.maxZoom
                }, new e.cd(e.ce(), null), t1.style);
                super("proxy", i, !1), i.setEventedParent(this), this.map = this.getSource().map = t1, this.used = this._sourceLoaded = !0, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
            update(e, t1, i) {
                if (e.freezeTileCoverage) return;
                this.transform = e;
                const o = e.coveringTiles({
                    tileSize: this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled
                }).reduce((t1, i)=>{
                    if (t1[i.key] = "", !this._tiles[i.key]) {
                        const t1 = new pt(i, this._source.tileSize * i.overscaleFactor(), e.tileZoom);
                        t1.state = "loaded", this._tiles[i.key] = t1;
                    }
                    return t1;
                }, {});
                for(const e in this._tiles)e in o || (this.freeFBO(e), this._tiles[e].unloadVectorData(), delete this._tiles[e]);
            }
            freeFBO(e) {
                const t1 = this.proxyCachedFBO[e];
                if (void 0 !== t1) {
                    const i = Object.values(t1);
                    this.renderCachePool.push(...i), delete this.proxyCachedFBO[e];
                }
            }
            deallocRenderCache() {
                this.renderCache.forEach((e)=>e.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
        }
        class Rr extends e.aA {
            constructor(e, t1, i){
                super(e.overscaledZ, e.wrap, e.canonical.z, e.canonical.x, e.canonical.y), this.proxyTileKey = t1, this.projMatrix = i;
            }
        }
        class Ar extends e.cE {
            constructor(t1, i){
                super(), this._debugParams = {
                    sortTilesHiZFirst: !0,
                    disableRenderCache: !1
                }, t1.tp.registerParameter(this._debugParams, [
                    "Terrain"
                ], "sortTilesHiZFirst", {}, ()=>{
                    this._style.map.triggerRepaint();
                }), t1.tp.registerParameter(this._debugParams, [
                    "Terrain"
                ], "disableRenderCache", {}, ()=>{
                    this._style.map.triggerRepaint();
                }), t1.tp.registerButton([
                    "Terrain"
                ], "Invalidate Render Cache", ()=>{
                    this.invalidateRenderCache = !0, this._style.map.triggerRepaint();
                }), this.painter = t1, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
                const [o, r, s] = function(t1) {
                    const i = new e.a_, o = new e.aO, r = 131;
                    i.reserve(17161), o.reserve(33800);
                    const s = e.ab / 128, a = e.ab + s / 2, n = a + s;
                    for(let t1 = -s; t1 < n; t1 += s)for(let o = -s; o < n; o += s){
                        const r = o < 0 || o > a || t1 < 0 || t1 > a ? 24575 : 0, s = e.ap(Math.round(o), 0, e.ab), n = e.ap(Math.round(t1), 0, e.ab);
                        i.emplaceBack(s + r, n);
                    }
                    const l = (e, t1)=>{
                        const i = t1 * r + e;
                        o.emplaceBack(i + 1, i, i + r), o.emplaceBack(i + r, i + r + 1, i + 1);
                    };
                    for(let e = 1; e < 129; e++)for(let t1 = 1; t1 < 129; t1++)l(t1, e);
                    return [
                        0,
                        129
                    ].forEach((e)=>{
                        for(let t1 = 0; t1 < 130; t1++)l(t1, e), l(e, t1);
                    }), [
                        i,
                        o,
                        32768
                    ];
                }(), a = t1.context;
                this.gridBuffer = a.createVertexBuffer(o, e.b0.members), this.gridIndexBuffer = a.createIndexBuffer(r), this.gridSegments = e.b1.simpleSegment(0, 0, o.length, r.length), this.gridNoSkirtSegments = e.b1.simpleSegment(0, 0, o.length, s), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new Dr(i.map), this.orthoMatrix = e.a6.mat4.create(), e.a6.mat4.ortho(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? .015 : 0, e.ab, 0, e.ab, 0, 1);
                const n = a.gl;
                this._overlapStencilMode = new Mi({
                    func: n.GEQUAL,
                    mask: 255
                }, 0, 255, n.KEEP, n.KEEP, n.REPLACE), this._previousZoom = t1.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i, this._useVertexMorphing = !0, this._exaggeration = 1, this._mockSourceCache = new Ir(i.map), this._pendingGroundEffectLayers = [];
            }
            set style(e) {
                e.on("data", this._onStyleDataEvent.bind(this)), this._style = e, this._style.map.on("moveend", ()=>{
                    this._clearLineLayersFromRenderCache();
                });
            }
            update(t1, i, o) {
                if (t1 && t1.terrain) {
                    this._style !== t1 && (this.style = t1, this._evaluationZoom = void 0);
                    const r = t1.terrain.properties, s = 0 === t1.terrain.drapeRenderMode, a = t1.terrain.isZoomDependent();
                    this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = e.q.now();
                    const n = t1.terrain && t1.terrain.scope, l = r.get("source"), c = s ? this._mockSourceCache : t1.getSourceCache(l, n);
                    if (!c) return void e.w(`Couldn't find terrain source "${l}".`);
                    if (this.sourceCache = c, this._exaggeration = a ? this.calculateExaggeration(i) : r.get("exaggeration"), !i.projection.requiresDraping && a && 0 === this._exaggeration) return void this._disable();
                    this.enabled = !0;
                    const h = ()=>{
                        this.sourceCache.used && e.w(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                        const t1 = this.getScaledDemTileSize();
                        this.sourceCache.update(i, t1, !0), this.resetTileLookupCache(this.sourceCache.id);
                    };
                    this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, h(), this._initializing = !0), h(), i.updateElevation(!0, o), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i), this._emptyDEMTextureDirty = !0, this._previousZoom = i.zoom;
                } else this._disable();
            }
            calculateExaggeration(t1) {
                const i = this._previousCameraAltitude, o = t1.getFreeCameraOptions().position.z / t1.pixelsPerMeter * t1.worldSize;
                this._previousCameraAltitude = o;
                const r = null != i ? o - i : Number.MAX_VALUE;
                if (Math.abs(r) < 2) return this._exaggeration;
                const s = t1.zoom, a = this._style.terrain;
                if (!this._previousUpdateTimestamp) return a.getExaggeration(s);
                let n = s - this._previousZoom;
                const l = this._previousUpdateTimestamp;
                let c = s;
                null != this._evaluationZoom && (c = this._evaluationZoom, Math.abs(s - c) > .5 && (n = .5 * (s - c + n)), n * r < 0 && (c += n)), this._evaluationZoom = c;
                const h = a.getExaggeration(c), u = h === a.getExaggeration(Math.max(0, c - .1));
                if (u && Math.abs(h - this._exaggeration) < .01) return h;
                let d = Math.min(.1, .00375 * (this._updateTimestamp - l));
                return (u || h < .1 || Math.abs(n) < 1e-4) && (d = Math.min(.2, 4 * d)), e.aa(this._exaggeration, h, d);
            }
            resetTileLookupCache(e) {
                this._findCoveringTileCache[e] = {};
            }
            getScaledDemTileSize() {
                return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
            }
            _onStyleDataEvent(e) {
                e.coord && "source" === e.dataType ? this._clearRenderCacheForTile(e.sourceCacheId, e.coord) : "style" === e.dataType && (this.invalidateRenderCache = !0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
            }
            _disable() {
                if (this.enabled && (this.enabled = !1, this._emptyDEMTextureDirty = !0, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for(const e in this._style._mergedSourceCaches)this._style._mergedSourceCaches[e].usedForTerrain = !1;
            }
            destroy() {
                this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this.pool.forEach((e)=>e.fb.destroy()), this.pool = [], this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
            }
            _source() {
                return this.enabled ? this.sourceCache : null;
            }
            isUsingMockSource() {
                return this.sourceCache === this._mockSourceCache;
            }
            exaggeration() {
                return this.enabled ? this._exaggeration : 0;
            }
            get visibleDemTiles() {
                return this._visibleDemTiles;
            }
            get drapeBufferSize() {
                const e = 2 * this.proxySourceCache.getSource().tileSize;
                return [
                    e,
                    e
                ];
            }
            set useVertexMorphing(e) {
                this._useVertexMorphing = e;
            }
            updateTileBinding(t1) {
                if (!this.enabled) return;
                this.prevTerrainTileForTile = this.terrainTileForTile;
                const i = this.proxySourceCache, o = this.painter.transform;
                this._initializing && (this._initializing = 0 === o._centerAltitude && -1 === this.getAtPointOrZero(e.a5.fromLngLat(o.center), -1), this._emptyDEMTextureDirty = !this._initializing);
                const r = this.proxyCoords = i.getIds().map((e)=>{
                    const t1 = i.getTileByID(e).tileID;
                    return t1.projMatrix = o.calculateProjMatrix(t1.toUnwrapped()), t1;
                });
                !function(t1, i) {
                    const o = i.transform.pointCoordinate(i.transform.getCameraPoint()), r = new e.P(o.x, o.y);
                    t1.sort((t1, i)=>{
                        if (i.overscaledZ - t1.overscaledZ) return i.overscaledZ - t1.overscaledZ;
                        const o = new e.P(t1.canonical.x + (1 << t1.canonical.z) * t1.wrap, t1.canonical.y), s = new e.P(i.canonical.x + (1 << i.canonical.z) * i.wrap, i.canonical.y), a = r.mult(1 << t1.canonical.z);
                        return a.x -= .5, a.y -= .5, a.distSqr(o) - a.distSqr(s);
                    });
                }(r, this.painter);
                const s = this.proxyToSource || {};
                this.proxyToSource = {}, r.forEach((e)=>{
                    this.proxyToSource[e.key] = {};
                }), this.terrainTileForTile = {};
                const a = this._style._mergedSourceCaches;
                for(const e in a){
                    const i = a[e];
                    if (!i.used) continue;
                    if (i !== this.sourceCache && this.resetTileLookupCache(i.id), this._setupProxiedCoordsForOrtho(i, t1[e], s), i.usedForTerrain) continue;
                    const o = t1[e];
                    i.getSource().reparseOverscaled && this._assignTerrainTiles(o);
                }
                this.proxiedCoords[i.id] = r.map((e)=>new Rr(e, e.key, this.orthoMatrix)), this._assignTerrainTiles(r), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(s), this.renderingToTexture = !1;
                const n = {};
                this._visibleDemTiles = [];
                for (const e of this.proxyCoords){
                    const t1 = this.terrainTileForTile[e.key];
                    if (!t1) continue;
                    const i = t1.tileID.key;
                    i in n || (this._visibleDemTiles.push(t1), n[i] = i);
                }
            }
            _assignTerrainTiles(e) {
                this._initializing || e.forEach((e)=>{
                    if (this.terrainTileForTile[e.key]) return;
                    const t1 = this._findTileCoveringTileID(e, this.sourceCache);
                    t1 && (this.terrainTileForTile[e.key] = t1);
                });
            }
            _prepareDEMTextures() {
                const e = this.painter.context, t1 = e.gl;
                for(const i in this.terrainTileForTile){
                    const o = this.terrainTileForTile[i], r = o.dem;
                    !r || o.demTexture && !o.needsDEMTextureUpload || (e.activeTexture.set(t1.TEXTURE1), Mo(this.painter, o, r));
                }
            }
            _prepareDemTileUniforms(e, t1, i, o) {
                if (!t1 || null == t1.demTexture) return !1;
                const r = e.tileID.canonical, s = Math.pow(2, t1.tileID.canonical.z - r.z), a = o || "";
                return i[`u_dem_tl${a}`] = [
                    r.x * s % 1,
                    r.y * s % 1
                ], i[`u_dem_scale${a}`] = s, !0;
            }
            get emptyDEMTexture() {
                return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
            }
            _getLoadedAreaMinimum() {
                if (!this.enabled) return 0;
                let e = 0;
                const t1 = this._visibleDemTiles.reduce((t1, i)=>{
                    if (!i.dem) return t1;
                    const o = i.dem.tree.minimums[0];
                    return o > 0 && e++, t1 + o;
                }, 0);
                return e ? t1 / e : 0;
            }
            _updateEmptyDEMTexture() {
                const t1 = this.painter.context, i = t1.gl;
                t1.activeTexture.set(i.TEXTURE2);
                const o = this._getLoadedAreaMinimum(), r = new e.cF({
                    width: 1,
                    height: 1
                }, new Float32Array([
                    o
                ]));
                this._emptyDEMTextureDirty = !1;
                let s = this._emptyDEMTexture;
                return s ? s.update(r, {
                    premultiply: !1
                }) : s = this._emptyDEMTexture = new e.T(t1, r, i.R32F, {
                    premultiply: !1
                }), s;
            }
            setupElevationDraw(t1, i, o) {
                const r = this.painter.context, s = r.gl, a = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                };
                a.u_exaggeration = this.exaggeration();
                let n = null, l = null, c = 1;
                if (o && o.morphing && this._useVertexMorphing) {
                    const e = o.morphing.srcDemTile, i = o.morphing.dstDemTile;
                    c = o.morphing.phase, e && i && (this._prepareDemTileUniforms(t1, e, a, "_prev") && (l = e), this._prepareDemTileUniforms(t1, i, a) && (n = i));
                }
                const h = (e)=>e && e.demTexture && this.painter.linearFloatFilteringSupported() ? s.LINEAR : s.NEAREST;
                let u = null;
                var d;
                if (this.enabled ? l && n ? (u = n.demTexture, r.activeTexture.set(s.TEXTURE4), l.demTexture.bind(h(l), s.CLAMP_TO_EDGE), a.u_dem_lerp = c) : (n = this.terrainTileForTile[t1.tileID.key], u = this._prepareDemTileUniforms(t1, n, a) ? n.demTexture : this.emptyDEMTexture) : u = this.emptyDEMTexture, r.activeTexture.set(s.TEXTURE2), u && (a.u_dem_size = 1 === (d = u).size[0] ? 1 : d.size[0] - 2, u.bind(h(n), s.CLAMP_TO_EDGE)), this.painter.setupDepthForOcclusion(o && o.useDepthForOcclusion, i, a), o && o.useMeterToDem && n) {
                    const t1 = (1 << n.tileID.canonical.z) * e.bD(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
                    a.u_meter_to_dem = t1;
                }
                if (o && o.labelPlaneMatrixInv && (a.u_label_plane_matrix_inv = o.labelPlaneMatrixInv), i.setTerrainUniformValues(r, a), "globe" === this.painter.transform.projection.name) {
                    const e = this.globeUniformValues(this.painter.transform, t1.tileID.canonical, o && o.useDenormalizedUpVectorScale);
                    i.setGlobeUniformValues(r, e);
                }
            }
            globeUniformValues(t1, i, o) {
                const r = t1.projection;
                return {
                    u_tile_tl_up: r.upVector(i, 0, 0),
                    u_tile_tr_up: r.upVector(i, e.ab, 0),
                    u_tile_br_up: r.upVector(i, e.ab, e.ab),
                    u_tile_bl_up: r.upVector(i, 0, e.ab),
                    u_tile_up_scale: o ? e.cG(1) : r.upVectorScale(i, t1.center.lat, t1.worldSize).metersToTile
                };
            }
            renderToBackBuffer(t1) {
                const i = this.painter, o = this.painter.context;
                0 !== t1.length && (o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), i.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function(t1, i, o, r, s) {
                    if ("globe" === t1.transform.projection.name) !function(t1, i, o, r, s) {
                        const a = t1.context, n = a.gl;
                        let l, c;
                        const h = t1.transform, u = e.cx(t1, a, h), d = (e, i)=>{
                            if (c === i) return;
                            const o = [
                                wr[i],
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            u && o.push("CUSTOM_ANTIALIASING");
                            const r = t1.isTileAffectedByFog(e);
                            l = t1.getOrCreateProgram("globeRaster", {
                                defines: o,
                                overrideFog: r
                            }), c = i;
                        }, _ = t1.colorModeForRenderPass(), p = new Li(n.LEQUAL, Li.ReadWrite, t1.depthRangeFor3D);
                        br.update(s);
                        const m = e.cy(h), f = [
                            e.am(h.center.lng),
                            e.at(h.center.lat)
                        ], g = t1.globeSharedBuffers, v = [
                            h.width * e.q.devicePixelRatio,
                            h.height * e.q.devicePixelRatio
                        ], x = Float32Array.from(h.globeMatrix), y = {
                            useDenormalizedUpVectorScale: !0
                        };
                        {
                            const h = t1.transform, u = Tr(h.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                            c = -1;
                            const b = n.TRIANGLES;
                            for (const c of r){
                                const r = o.getTile(c), w = Mi.disabled, T = i.prevTerrainTileForTile[c.key], E = i.terrainTileForTile[c.key];
                                yr(T, E) && br.newMorphing(c.key, T, E, s, 250), a.activeTexture.set(n.TEXTURE0), r.texture && r.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                                const C = br.getMorphValuesForProxy(c.key), S = C ? 1 : 0;
                                C && e.C(y, {
                                    morphing: {
                                        srcDemTile: C.from,
                                        dstDemTile: C.to,
                                        phase: e.cw(C.phase)
                                    }
                                });
                                const I = e.cz(c.canonical), D = e.cA(I.getCenter().lat), R = e.cB(c.canonical, I, D, h.worldSize / h._pixelsPerMercatorPixel), A = e.b5(e.cC(c.canonical)), L = xr(h.expandedFarZProjMatrix, x, m, A, e.a9(h.zoom), f, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, v, u, h._farZ, R);
                                if (d(c, S), l && (i.setupElevationDraw(r, l, y), t1.uploadCommonUniforms(a, l, c.toUnwrapped()), g)) {
                                    const [e, i, o] = g.getGridBuffers(D, 0 !== u);
                                    l.draw(t1, b, p, w, _, Fi.backCCW, L, "globe_raster", e, i, o);
                                }
                            }
                        }
                        if (g && (t1.renderDefaultNorthPole || t1.renderDefaultSouthPole)) {
                            const s = [
                                "GLOBE_POLES",
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            u && s.push("CUSTOM_ANTIALIASING"), l = t1.getOrCreateProgram("globeRaster", {
                                defines: s
                            });
                            for (const s of r){
                                const { x: r, y: c, z: u } = s.canonical, d = 0 === c, m = c === (1 << u) - 1, [x, b, w, T] = g.getPoleBuffers(u, !1);
                                if (T && (d || m)) {
                                    const c = o.getTile(s);
                                    a.activeTexture.set(n.TEXTURE0), c.texture && c.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                                    let g = e.cD(u, r, h);
                                    const E = e.b5(e.cC(s.canonical)), C = (e, i)=>e.draw(t1, n.TRIANGLES, p, Mi.disabled, _, Fi.disabled, xr(h.expandedFarZProjMatrix, g, g, E, 0, f, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, v, 0, h._farZ), "globe_pole_raster", i, w, T);
                                    i.setupElevationDraw(c, l, y), t1.uploadCommonUniforms(a, l, s.toUnwrapped()), d && t1.renderDefaultNorthPole && C(l, x), m && t1.renderDefaultSouthPole && (g = e.a6.mat4.scale(e.a6.mat4.create(), g, [
                                        1,
                                        -1,
                                        1
                                    ]), C(l, b));
                                }
                            }
                        }
                    }(t1, i, o, r, s);
                    else {
                        const a = t1.context, n = a.gl;
                        let l, c;
                        const h = t1.shadowRenderer, u = Wi(t1, t1.longestCutoffRange), d = (e)=>{
                            if (c === e) return;
                            const i = [];
                            i.push(wr[e]), u.shouldRenderCutoff && i.push("RENDER_CUTOFF"), l = t1.getOrCreateProgram("terrainRaster", {
                                defines: i
                            }), c = e;
                        }, _ = t1.colorModeForRenderPass(), p = new Li(n.LEQUAL, Li.ReadWrite, t1.depthRangeFor3D);
                        br.update(s);
                        const m = t1.transform, f = Tr(m.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                        let g = [
                            0,
                            0,
                            0
                        ];
                        if (h) {
                            const e = t1.style.directionalLight, i = t1.style.ambientLight;
                            e && i && (g = eo(t1.style, e, i));
                        }
                        {
                            c = -1;
                            const v = n.TRIANGLES, [x, y] = [
                                i.gridIndexBuffer,
                                i.gridSegments
                            ];
                            for (const c of r){
                                const r = o.getTile(c), b = Mi.disabled, w = i.prevTerrainTileForTile[c.key], T = i.terrainTileForTile[c.key];
                                yr(w, T) && br.newMorphing(c.key, w, T, s, 250), a.activeTexture.set(n.TEXTURE0), r.texture && r.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                                const E = br.getMorphValuesForProxy(c.key), C = E ? 1 : 0;
                                let S;
                                E && (S = {
                                    morphing: {
                                        srcDemTile: E.from,
                                        dstDemTile: E.to,
                                        phase: e.cw(E.phase)
                                    }
                                });
                                const I = vr(c.projMatrix, Er(c.canonical, m.renderWorldCopies) ? f / 10 : f, g);
                                if (d(C), !l) continue;
                                i.setupElevationDraw(r, l, S);
                                const D = c.toUnwrapped();
                                h && h.setupShadows(D, l), t1.uploadCommonUniforms(a, l, D, null, u), l.draw(t1, v, p, b, _, Fi.backCCW, I, "terrain_raster", i.gridBuffer, x, y);
                            }
                        }
                    }
                }(i, this, this.proxySourceCache, t1, this._updateTimestamp), this.renderingToTexture = !0, i.gpuTimingDeferredRenderEnd(), t1.splice(0, t1.length));
            }
            renderBatch(t1) {
                if (0 === this._drapedRenderBatches.length) return t1 + 1;
                this.renderingToTexture = !0;
                const i = this.painter, o = this.painter.context, r = this.proxySourceCache, s = this.proxiedCoords[r.id], a = this._drapedRenderBatches.shift(), n = i.style.order, l = [];
                let c = 0;
                for (const h of s){
                    const s = r.getTileByID(h.proxyTileKey), u = r.proxyCachedFBO[h.key] ? r.proxyCachedFBO[h.key][t1] : void 0, d = void 0 !== u ? r.renderCache[u] : this.pool[c++], _ = void 0 !== u;
                    if (s.texture = d.tex, _ && !d.dirty) {
                        l.push(s.tileID);
                        continue;
                    }
                    let p;
                    o.bindFramebuffer.set(d.fb.framebuffer), this.renderedToTile = !1, d.dirty && (o.clear({
                        color: e.bz.transparent,
                        stencil: 0
                    }), d.dirty = !1);
                    for(let e = a.start; e <= a.end; ++e){
                        const t1 = i.style._mergedLayers[n[e]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const r = i.style.getLayerSourceCache(t1), s = r ? this.proxyToSource[h.key][r.id] : [
                            h
                        ];
                        if (!s) continue;
                        const a = s;
                        o.viewport.set([
                            0,
                            0,
                            d.fb.width,
                            d.fb.height
                        ]), p !== (r ? r.id : null) && (this._setupStencil(d, s, t1, r), p = r ? r.id : null), i.renderLayer(i, r, t1, a);
                    }
                    if (0 === this._drapedRenderBatches.length) for (const e of this._pendingGroundEffectLayers){
                        const t1 = i.style._mergedLayers[n[e]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const r = i.style.getLayerSourceCache(t1), s = r ? this.proxyToSource[h.key][r.id] : [
                            h
                        ];
                        if (!s) continue;
                        const a = s;
                        o.viewport.set([
                            0,
                            0,
                            d.fb.width,
                            d.fb.height
                        ]), p !== (r ? r.id : null) && (this._setupStencil(d, s, t1, r), p = r ? r.id : null), i.renderLayer(i, r, t1, a);
                    }
                    this.renderedToTile ? (d.dirty = !0, l.push(s.tileID)) : _ || --c, 5 === c && (c = 0, this.renderToBackBuffer(l));
                }
                return this.renderToBackBuffer(l), this.renderingToTexture = !1, o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), a.end + 1;
            }
            postRender() {}
            isLayerOrderingCorrect(e) {
                const t1 = e.order.length;
                let i = -1, o = t1;
                for(let r = 0; r < t1; ++r)this._style.isLayerDraped(e._mergedLayers[e.order[r]]) ? i = Math.max(i, r) : o = Math.min(o, r);
                return o > i;
            }
            getMinElevationBelowMSL() {
                let e = 0;
                return this._visibleDemTiles.filter((e)=>e.dem).forEach((t1)=>{
                    e = Math.min(e, t1.dem.tree.minimums[0]);
                }), 0 === e ? e : (e - 30) * this._exaggeration;
            }
            raycast(e, t1, i) {
                if (!this._visibleDemTiles) return null;
                const o = this._visibleDemTiles.filter((e)=>e.dem).map((o)=>{
                    const r = o.tileID, s = 1 << r.overscaledZ, { x: a, y: n } = r.canonical, l = a / s, c = (a + 1) / s, h = n / s, u = (n + 1) / s;
                    return {
                        minx: l,
                        miny: h,
                        maxx: c,
                        maxy: u,
                        t: o.dem.tree.raycastRoot(l, h, c, u, e, t1, i),
                        tile: o
                    };
                });
                o.sort((e, t1)=>(null !== e.t ? e.t : Number.MAX_VALUE) - (null !== t1.t ? t1.t : Number.MAX_VALUE));
                for (const r of o){
                    if (null == r.t) return null;
                    const o = r.tile.dem.tree.raycast(r.minx, r.miny, r.maxx, r.maxy, e, t1, i);
                    if (null != o) return o;
                }
                return null;
            }
            _createFBO() {
                const t1 = this.painter.context, i = t1.gl, o = this.drapeBufferSize;
                t1.activeTexture.set(i.TEXTURE0);
                const r = new e.T(t1, {
                    width: o[0],
                    height: o[1],
                    data: null
                }, i.RGBA8);
                r.bind(i.LINEAR, i.CLAMP_TO_EDGE);
                const s = t1.createFramebuffer(o[0], o[1], !0, null);
                return s.colorAttachment.set(r.texture), s.depthAttachment = new gr(t1, s.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t1.createRenderbuffer(t1.gl.DEPTH_STENCIL, o[0], o[1]), this._stencilRef = 0, s.depthAttachment.set(this._sharedDepthStencil), t1.clear({
                    stencil: 0
                })) : s.depthAttachment.set(this._sharedDepthStencil), t1.extTextureFilterAnisotropic && i.texParameterf(i.TEXTURE_2D, t1.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t1.extTextureFilterAnisotropicMax), {
                    fb: s,
                    tex: r,
                    dirty: !1
                };
            }
            _initFBOPool() {
                for(; this.pool.length < Math.min(5, this.proxyCoords.length);)this.pool.push(this._createFBO());
            }
            _shouldDisableRenderCache() {
                if (this._debugParams.disableRenderCache) return !0;
                if (this._style.hasLightTransitions()) return !0;
                for(const e in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[e].hasTransition()) return !0;
                return this._style.order.some((e)=>{
                    const t1 = this._style._mergedLayers[e], i = t1.isHidden(this.painter.transform.zoom);
                    return "hillshade" === t1.type || "custom" === t1.type ? !i && t1.shouldRedrape() : !i && t1.hasTransition();
                });
            }
            _clearLineLayersFromRenderCache() {
                let t1 = !1;
                for (const e of this._style.getSources())if (e instanceof Ke) {
                    t1 = !0;
                    break;
                }
                if (!t1) return;
                const i = {};
                for(let t1 = 0; t1 < this._style.order.length; ++t1){
                    const o = this._style._mergedLayers[this._style.order[t1]], r = this._style.getLayerSourceCache(o);
                    if (r && !i[r.id] && !o.isHidden(this.painter.transform.zoom) && "line" === o.type && o.widthExpression() instanceof e.a4) {
                        i[r.id] = !0;
                        for (const e of this.proxyCoords){
                            const t1 = this.proxyToSource[e.key][r.id];
                            if (t1) for (const e of t1)this._clearRenderCacheForTile(r.id, e);
                        }
                    }
                }
            }
            _clearRasterLayersFromRenderCache() {
                let e = !1;
                for(const t1 in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[t1]._source instanceof Je) {
                    e = !0;
                    break;
                }
                if (!e) return;
                const t1 = {};
                for(let e = 0; e < this._style.order.length; ++e){
                    const i = this._style._mergedLayers[this._style.order[e]], o = this._style.getLayerSourceCache(i);
                    if (!o || t1[o.id]) continue;
                    if (i.isHidden(this.painter.transform.zoom) || "raster" !== i.type) continue;
                    const r = i.paint.get("raster-fade-duration");
                    for (const e of this.proxyCoords){
                        const t1 = this.proxyToSource[e.key][o.id];
                        if (t1) for (const e of t1){
                            const t1 = Sr(o.getTile(e), o.findLoadedParent(e, 0), o, this.painter.transform, r);
                            (1 !== t1.opacity || 0 !== t1.mix) && this._clearRenderCacheForTile(o.id, e);
                        }
                    }
                }
            }
            _setupDrapedRenderBatches() {
                const t1 = this._style.order, i = t1.length;
                if (0 === i) return;
                const o = [];
                this._pendingGroundEffectLayers = [];
                let r, s = 0, a = this._style._mergedLayers[t1[s]];
                for(; !this._style.isLayerDraped(a) && a.isHidden(this.painter.transform.zoom) && ++s < i;)a = this._style._mergedLayers[t1[s]];
                for(; s < i; ++s){
                    const e = this._style._mergedLayers[t1[s]];
                    e.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(e) ? void 0 === r && (r = s) : ("fill-extrusion" === e.type && this._pendingGroundEffectLayers.push(s), void 0 !== r && (o.push({
                        start: r,
                        end: s - 1
                    }), r = void 0)));
                }
                if (void 0 !== r && o.push({
                    start: r,
                    end: s - 1
                }), 0 !== o.length) {
                    const t1 = o[o.length - 1];
                    this._pendingGroundEffectLayers.every((e)=>e > t1.end) || e.w("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
                }
                this._drapedRenderBatches = o;
            }
            _setupRenderCache(e) {
                const t1 = this.proxySourceCache;
                if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
                    if (this.invalidateRenderCache = !1, t1.renderCache.length > t1.renderCachePool.length) {
                        const e = Object.values(t1.proxyCachedFBO);
                        t1.proxyCachedFBO = {};
                        for(let i = 0; i < e.length; ++i){
                            const o = Object.values(e[i]);
                            t1.renderCachePool.push(...o);
                        }
                    }
                    return;
                }
                this._clearRasterLayersFromRenderCache();
                const i = this.proxyCoords, o = this._tilesDirty;
                for(let r = i.length - 1; r >= 0; r--){
                    const s = i[r];
                    if (t1.getTileByID(s.key), void 0 !== t1.proxyCachedFBO[s.key]) {
                        const i = e[s.key], r = this.proxyToSource[s.key];
                        let a = 0;
                        for(const e in r){
                            const t1 = r[e], s = i[e];
                            if (!s || s.length !== t1.length || t1.some((t1, i)=>t1 !== s[i] || o[e] && o[e].hasOwnProperty(t1.key))) {
                                a = -1;
                                break;
                            }
                            ++a;
                        }
                        for(const e in t1.proxyCachedFBO[s.key])t1.renderCache[t1.proxyCachedFBO[s.key][e]].dirty = a < 0 || a !== Object.values(i).length;
                    }
                }
                const r = [
                    ...this._drapedRenderBatches
                ];
                r.sort((e, t1)=>t1.end - t1.start - (e.end - e.start));
                for (const e of r)for (const o of i){
                    if (t1.proxyCachedFBO[o.key]) continue;
                    let i = t1.renderCachePool.pop();
                    void 0 === i && t1.renderCache.length < 50 && (i = t1.renderCache.length, t1.renderCache.push(this._createFBO())), void 0 !== i && (t1.proxyCachedFBO[o.key] = {}, t1.proxyCachedFBO[o.key][e.start] = i, t1.renderCache[i].dirty = !0);
                }
                this._tilesDirty = {};
            }
            _setupStencil(e, t1, i, o) {
                if (!o || !this._sourceTilesOverlap[o.id]) return void (this._overlapStencilType && (this._overlapStencilType = !1));
                const r = this.painter.context, s = r.gl;
                if (t1.length <= 1) return void (this._overlapStencilType = !1);
                let a;
                if (i.isTileClipped()) a = t1.length, this._overlapStencilMode.test = {
                    func: s.EQUAL,
                    mask: 255
                }, this._overlapStencilType = "Clip";
                else {
                    if (!(t1[0].overscaledZ > t1[t1.length - 1].overscaledZ)) return void (this._overlapStencilType = !1);
                    a = 1, this._overlapStencilMode.test = {
                        func: s.GREATER,
                        mask: 255
                    }, this._overlapStencilType = "Mask";
                }
                this._stencilRef + a > 255 && (r.clear({
                    stencil: 0
                }), this._stencilRef = 0), this._stencilRef += a, this._overlapStencilMode.ref = this._stencilRef, i.isTileClipped() && this._renderTileClippingMasks(t1, this._overlapStencilMode.ref);
            }
            clipOrMaskOverlapStencilType() {
                return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
            }
            stencilModeForRTTOverlap(e) {
                return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[e.key]), this._overlapStencilMode) : Mi.disabled;
            }
            _renderTileClippingMasks(e, t1) {
                const i = this.painter, o = this.painter.context, r = o.gl;
                i._tileClippingMaskIDs = {}, o.setColorMode(Ai.disabled), o.setDepthMode(Li.disabled);
                const s = i.getOrCreateProgram("clippingMask");
                for (const o of e){
                    const e = i._tileClippingMaskIDs[o.key] = --t1;
                    s.draw(i, r.TRIANGLES, Li.disabled, new Mi({
                        func: r.ALWAYS,
                        mask: 0
                    }, e, 255, r.KEEP, r.KEEP, r.REPLACE), Ai.disabled, Fi.disabled, Cr(o.projMatrix), "$clipping", i.tileExtentBuffer, i.quadTriangleIndexBuffer, i.tileExtentSegments);
                }
            }
            pointCoordinate(t1) {
                const i = this.painter.transform;
                if (t1.x < 0 || t1.x > i.width || t1.y < 0 || t1.y > i.height) return null;
                const o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e.a6.vec4.transformMat4(o, o, i.pixelMatrixInverse), e.a6.vec4.scale(o, o, 1 / o[3]), o[0] /= i.worldSize, o[1] /= i.worldSize;
                const r = i._camera.position, s = e.bD(1, i.center.lat), a = [
                    r[0],
                    r[1],
                    r[2] / s,
                    0
                ], n = e.a6.vec3.subtract([], o.slice(0, 3), a);
                e.a6.vec3.normalize(n, n);
                const l = this.raycast(a, n, this._exaggeration);
                return null !== l && l ? (e.a6.vec3.scaleAndAdd(a, a, n, l), a[3] = a[2], a[2] *= s, a) : null;
            }
            _setupProxiedCoordsForOrtho(t1, i, o) {
                if (t1.getSource() instanceof e.aD) return this._setupProxiedCoordsForImageSource(t1, i, o);
                this._findCoveringTileCache[t1.id] = this._findCoveringTileCache[t1.id] || {};
                const r = this.proxiedCoords[t1.id] = [], s = this.proxyCoords;
                for(let e = 0; e < s.length; e++){
                    const i = s[e], a = this._findTileCoveringTileID(i, t1);
                    if (a) {
                        const e = this._createProxiedId(i, a, o[i.key] && o[i.key][t1.id]);
                        r.push(e), this.proxyToSource[i.key][t1.id] = [
                            e
                        ];
                    }
                }
                let a = !1;
                const n = new Set;
                for(let e = 0; e < i.length; e++){
                    const s = t1.getTile(i[e]);
                    if (!s || !s.hasData()) continue;
                    const l = this._findTileCoveringTileID(s.tileID, this.proxySourceCache);
                    if (l && l.tileID.canonical.z !== s.tileID.canonical.z) {
                        const e = this.proxyToSource[l.tileID.key][t1.id], i = this._createProxiedId(l.tileID, s, o[l.tileID.key] && o[l.tileID.key][t1.id]);
                        e ? e.splice(e.length - 1, 0, i) : this.proxyToSource[l.tileID.key][t1.id] = [
                            i
                        ];
                        const c = this.proxyToSource[l.tileID.key][t1.id];
                        n.has(c) || n.add(c), r.push(i), a = !0;
                    }
                }
                if (this._sourceTilesOverlap[t1.id] = a, a && this._debugParams.sortTilesHiZFirst) for (const e of n)e.sort((e, t1)=>t1.overscaledZ - e.overscaledZ);
            }
            _setupProxiedCoordsForImageSource(t1, i, o) {
                if (!t1.getSource().loaded()) return;
                const r = this.proxiedCoords[t1.id] = [], s = this.proxyCoords, a = t1.getSource(), n = a.tileID;
                if (!n) return;
                const l = new e.P(n.x, n.y)._div(1 << n.z), c = a.coordinates.map(e.a5.fromLngLat).reduce((e, t1)=>(e.min.x = Math.min(e.min.x, t1.x - l.x), e.min.y = Math.min(e.min.y, t1.y - l.y), e.max.x = Math.max(e.max.x, t1.x - l.x), e.max.y = Math.max(e.max.y, t1.y - l.y), e), {
                    min: new e.P(Number.MAX_VALUE, Number.MAX_VALUE),
                    max: new e.P(-Number.MAX_VALUE, -Number.MAX_VALUE)
                }), h = (t1, i)=>{
                    const o = t1.wrap + t1.canonical.x / (1 << t1.canonical.z), r = t1.canonical.y / (1 << t1.canonical.z), s = e.ab / (1 << t1.canonical.z), a = i.wrap + i.canonical.x / (1 << i.canonical.z), n = i.canonical.y / (1 << i.canonical.z);
                    return o + s < a + c.min.x || o > a + c.max.x || r + s < n + c.min.y || r > n + c.max.y;
                };
                for(let e = 0; e < s.length; e++){
                    const a = s[e];
                    for(let e = 0; e < i.length; e++){
                        const s = t1.getTile(i[e]);
                        if (!s || !s.hasData()) continue;
                        if (h(a, s.tileID)) continue;
                        const n = this._createProxiedId(a, s, o[a.key] && o[a.key][t1.id]), l = this.proxyToSource[a.key][t1.id];
                        l ? l.push(n) : this.proxyToSource[a.key][t1.id] = [
                            n
                        ], r.push(n);
                    }
                }
            }
            _createProxiedId(t1, i, o) {
                let r = this.orthoMatrix;
                if (o) {
                    const e = o.find((e)=>e.key === i.tileID.key);
                    if (e) return e;
                }
                if (i.tileID.key !== t1.key) {
                    const o = t1.canonical.z - i.tileID.canonical.z;
                    let s, a, n;
                    r = e.a6.mat4.create();
                    const l = i.tileID.wrap - t1.wrap << t1.overscaledZ;
                    o > 0 ? (s = e.ab >> o, a = s * ((i.tileID.canonical.x << o) - t1.canonical.x + l), n = s * ((i.tileID.canonical.y << o) - t1.canonical.y)) : (s = e.ab << -o, a = e.ab * (i.tileID.canonical.x - (t1.canonical.x + l << -o)), n = e.ab * (i.tileID.canonical.y - (t1.canonical.y << -o))), e.a6.mat4.ortho(r, 0, s, 0, s, 0, 1), e.a6.mat4.translate(r, r, [
                        a,
                        n,
                        0
                    ]);
                }
                return new Rr(i.tileID, t1.key, r);
            }
            _findTileCoveringTileID(t1, i) {
                let o = i.getTile(t1);
                if (o && o.hasData()) return o;
                const r = this._findCoveringTileCache[i.id], s = r[t1.key];
                if (o = s ? i.getTileByID(s) : null, o && o.hasData() || null === s) return o;
                let a = o ? o.tileID : t1, n = a.overscaledZ;
                const l = i.getSource().minzoom, c = [];
                if (!s) {
                    const r = i.getSource().maxzoom;
                    if (t1.canonical.z >= r) {
                        const o = t1.canonical.z - r;
                        i.getSource().reparseOverscaled ? (n = Math.max(t1.canonical.z + 2, i.transform.tileZoom), a = new e.aA(n, t1.wrap, r, t1.canonical.x >> o, t1.canonical.y >> o)) : 0 !== o && (n = r, a = new e.aA(n, t1.wrap, r, t1.canonical.x >> o, t1.canonical.y >> o));
                    }
                    a.key !== t1.key && (c.push(a.key), o = i.getTile(a));
                }
                const h = (e)=>{
                    c.forEach((t1)=>{
                        r[t1] = e;
                    }), c.length = 0;
                };
                for(n -= 1; n >= l && (!o || !o.hasData()); n--){
                    o && h(o.tileID.key);
                    const e = a.calculateScaledKey(n);
                    if (o = i.getTileByID(e), o && o.hasData()) break;
                    const t1 = r[e];
                    if (null === t1) break;
                    void 0 === t1 ? c.push(e) : o = i.getTileByID(t1);
                }
                return h(o ? o.tileID.key : null), o && o.hasData() ? o : null;
            }
            findDEMTileFor(e) {
                return this.enabled ? this._findTileCoveringTileID(e, this.sourceCache) : null;
            }
            prepareDrawTile() {
                this.renderedToTile = !0;
            }
            _clearRenderCacheForTile(e, t1) {
                let i = this._tilesDirty[e];
                i || (i = this._tilesDirty[e] = {}), i[t1.key] = !0;
            }
        }
        function Lr(t1, i, o) {
            const r = function(t1, i, o) {
                const r = e.a6.vec3.dot(i, t1), s = e.a6.vec3.dot(o, [
                    .2126,
                    .7152,
                    .0722
                ]), a = (e, t1, i)=>(1 - i) * e + i * t1, n = a(1 - .3 * Math.min(s, 1), 1, Math.min(r + 1, 1));
                return a(.92, 1, Math.asin(e.ap(i[2], -1, 1)) / Math.PI + .5) * n;
            }(t1, [
                0,
                0,
                1
            ], i), s = [
                0,
                0,
                0
            ];
            e.a6.vec3.scale(s, o.slice(0, 3), r);
            const a = [
                0,
                0,
                0
            ];
            e.a6.vec3.scale(a, i.slice(0, 3), t1[2]);
            const n = [
                0,
                0,
                0
            ];
            return e.a6.vec3.add(n, s, a), e.cb(n);
        }
        const Pr = [
            "fill",
            "fillOutline",
            "fillPattern",
            "line",
            "linePattern",
            "background",
            "backgroundPattern",
            "hillshade",
            "raster"
        ], Mr = [
            "stars",
            "fillExtrusion",
            "fillExtrusionGroundEffect",
            "model",
            "symbol"
        ];
        class zr {
            static cacheKey(e, t1, i, o) {
                let r = `${t1}${o ? o.cacheKey : ""}`;
                for (const t1 of i)e.usedDefines.includes(t1) && (r += `/${t1}`);
                return r;
            }
            constructor(t1, i, o, r, s, a){
                const n = t1.gl;
                this.program = n.createProgram(), this.configuration = r, this.name = i, this.fixedDefines = [
                    ...a
                ];
                const l = r ? r.getBinderAttributes() : [], c = (o.staticAttributes || []).concat(l);
                let h = r ? r.defines() : [];
                h = h.concat(a.map((e)=>`#define ${e}`));
                const u = "#version 300 es\n";
                let d = u + h.concat("precision mediump float;", So, Co.fragmentSource).join("\n");
                for (const e of o.fragmentIncludes)d += `\n${To[e]}`;
                d += `\n${o.fragmentSource}`;
                let _ = u + h.concat("precision highp float;", So, Co.vertexSource).join("\n");
                for (const e of o.vertexIncludes)_ += `\n${To[e]}`;
                _ += `\n${o.vertexSource}`;
                const p = n.createShader(n.FRAGMENT_SHADER);
                if (n.isContextLost()) return void (this.failedToCreate = !0);
                n.shaderSource(p, d), n.compileShader(p), n.attachShader(this.program, p);
                const m = n.createShader(n.VERTEX_SHADER);
                if (n.isContextLost()) this.failedToCreate = !0;
                else {
                    n.shaderSource(m, _), n.compileShader(m), n.attachShader(this.program, m), this.attributes = {}, this.numAttributes = c.length;
                    for(let e = 0; e < this.numAttributes; e++)if (c[e]) {
                        const t1 = c[e].startsWith("a_") ? c[e] : `a_${c[e]}`;
                        n.bindAttribLocation(this.program, e, t1), this.attributes[t1] = e;
                    }
                    n.linkProgram(this.program), n.deleteShader(m), n.deleteShader(p), this.fixedUniforms = s(t1), this.binderUniforms = r ? r.getUniforms(t1) : [], (a.includes("TERRAIN") || -1 !== i.indexOf("symbol") || -1 !== i.indexOf("circle")) && (this.terrainUniforms = ((t1)=>({
                            u_dem: new e.bJ(t1),
                            u_dem_prev: new e.bJ(t1),
                            u_dem_tl: new e.bG(t1),
                            u_dem_scale: new e.bI(t1),
                            u_dem_tl_prev: new e.bG(t1),
                            u_dem_scale_prev: new e.bI(t1),
                            u_dem_size: new e.bI(t1),
                            u_dem_lerp: new e.bI(t1),
                            u_exaggeration: new e.bI(t1),
                            u_depth: new e.bJ(t1),
                            u_depth_size_inv: new e.bG(t1),
                            u_depth_range_unpack: new e.bG(t1),
                            u_occluder_half_size: new e.bI(t1),
                            u_occlusion_depth_offset: new e.bI(t1),
                            u_meter_to_dem: new e.bI(t1),
                            u_label_plane_matrix_inv: new e.bF(t1)
                        }))(t1)), a.includes("GLOBE") && (this.globeUniforms = ((t1)=>({
                            u_tile_tl_up: new e.bH(t1),
                            u_tile_tr_up: new e.bH(t1),
                            u_tile_br_up: new e.bH(t1),
                            u_tile_bl_up: new e.bH(t1),
                            u_tile_up_scale: new e.bI(t1)
                        }))(t1)), a.includes("FOG") && (this.fogUniforms = ((t1)=>({
                            u_fog_matrix: new e.bF(t1),
                            u_fog_range: new e.bG(t1),
                            u_fog_color: new e.c6(t1),
                            u_fog_horizon_blend: new e.bI(t1),
                            u_fog_vertical_limit: new e.bG(t1),
                            u_fog_temporal_offset: new e.bI(t1),
                            u_frustum_tl: new e.bH(t1),
                            u_frustum_tr: new e.bH(t1),
                            u_frustum_br: new e.bH(t1),
                            u_frustum_bl: new e.bH(t1),
                            u_globe_pos: new e.bH(t1),
                            u_globe_radius: new e.bI(t1),
                            u_globe_transition: new e.bI(t1),
                            u_is_globe: new e.bJ(t1),
                            u_viewport: new e.bG(t1)
                        }))(t1)), a.includes("RENDER_CUTOFF") && (this.cutoffUniforms = ((t1)=>({
                            u_cutoff_params: new e.c6(t1)
                        }))(t1)), a.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((t1)=>({
                            u_lighting_ambient_color: new e.bH(t1),
                            u_lighting_directional_dir: new e.bH(t1),
                            u_lighting_directional_color: new e.bH(t1),
                            u_ground_radiance: new e.bH(t1)
                        }))(t1)), a.includes("RENDER_SHADOWS") && (this.shadowUniforms = ((t1)=>({
                            u_light_matrix_0: new e.bF(t1),
                            u_light_matrix_1: new e.bF(t1),
                            u_fade_range: new e.bG(t1),
                            u_shadow_normal_offset: new e.bH(t1),
                            u_shadow_intensity: new e.bI(t1),
                            u_shadow_texel_size: new e.bI(t1),
                            u_shadow_map_resolution: new e.bI(t1),
                            u_shadow_direction: new e.bH(t1),
                            u_shadow_bias: new e.bH(t1),
                            u_shadowmap_0: new e.bJ(t1),
                            u_shadowmap_1: new e.bJ(t1)
                        }))(t1));
                }
            }
            setTerrainUniformValues(e, t1) {
                if (!this.terrainUniforms) return;
                const i = this.terrainUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e] && i[e].set(this.program, e, t1[e]);
                }
            }
            setGlobeUniformValues(e, t1) {
                if (!this.globeUniforms) return;
                const i = this.globeUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e] && i[e].set(this.program, e, t1[e]);
                }
            }
            setFogUniformValues(e, t1) {
                if (!this.fogUniforms) return;
                const i = this.fogUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e].set(this.program, e, t1[e]);
                }
            }
            setCutoffUniformValues(e, t1) {
                if (!this.cutoffUniforms) return;
                const i = this.cutoffUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e].set(this.program, e, t1[e]);
                }
            }
            setLightsUniformValues(e, t1) {
                if (!this.lightsUniforms) return;
                const i = this.lightsUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e].set(this.program, e, t1[e]);
                }
            }
            setShadowUniformValues(e, t1) {
                if (this.failedToCreate || !this.shadowUniforms) return;
                const i = this.shadowUniforms;
                e.program.set(this.program);
                for(const e in t1)i[e].set(this.program, e, t1[e]);
            }
            _drawDebugWireframe(t1, i, o, r, s, a, n, l, c, h) {
                const u = t1.options.wireframe;
                if (!1 === u.terrain && !1 === u.layers2D && !1 === u.layers3D) return;
                const d = t1.context;
                if (!(()=>!(!u.terrain || "terrainRaster" !== this.name && "globeRaster" !== this.name) || !(!u.layers2D || t1._terrain && t1._terrain.renderingToTexture || !Pr.includes(this.name)) || !(!u.layers3D || !Mr.includes(this.name)))()) return;
                const _ = d.gl, p = t1.wireframeDebugCache.getLinesFromTrianglesBuffer(t1.frameCounter, s, d);
                if (!p) return;
                const m = [
                    ...this.fixedDefines
                ];
                m.push("DEBUG_WIREFRAME");
                const f = t1.getOrCreateProgram(this.name, {
                    config: this.configuration,
                    defines: m
                });
                d.program.set(f.program);
                const g = (e, t1, i)=>{
                    if (t1[e] && i[e]) for(const o in t1[e])i[e][o] && i[e][o].set(i.program, o, t1[e][o].current);
                };
                c && c.setUniforms(f.program, d, f.binderUniforms, n, {
                    zoom: l
                }), g("fixedUniforms", this, f), g("terrainUniforms", this, f), g("globeUniforms", this, f), g("fogUniforms", this, f), g("lightsUniforms", this, f), g("shadowUniforms", this, f), p.bind(), d.setColorMode(new Ai([
                    _.ONE,
                    _.ONE_MINUS_SRC_ALPHA,
                    _.ZERO,
                    _.ONE
                ], e.bz.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ])), d.setDepthMode(new Li(i.func === _.LESS ? _.LEQUAL : i.func, Li.ReadOnly, i.range)), d.setStencilMode(Mi.disabled);
                const v = 3 * a.primitiveLength * 2, x = 3 * a.primitiveOffset * 4;
                h && h > 1 ? _.drawElementsInstanced(_.LINES, v, _.UNSIGNED_SHORT, x, h) : _.drawElements(_.LINES, v, _.UNSIGNED_SHORT, x), s.bind(), d.program.set(this.program), d.setDepthMode(i), d.setStencilMode(o), d.setColorMode(r);
            }
            draw(e, t1, i, o, r, s, a, n, l, c, h, u, d, _, p, m) {
                const f = e.context, g = f.gl;
                if (this.failedToCreate) return;
                f.program.set(this.program), f.setDepthMode(i), f.setStencilMode(o), f.setColorMode(r), f.setCullFace(s);
                for (const e of Object.keys(this.fixedUniforms))this.fixedUniforms[e].set(this.program, e, a[e]);
                _ && _.setUniforms(this.program, f, this.binderUniforms, u, {
                    zoom: d
                });
                const v = {
                    [g.POINTS]: 1,
                    [g.LINES]: 2,
                    [g.TRIANGLES]: 3,
                    [g.LINE_STRIP]: 1
                }[t1], x = m && m > 0 ? 1 : void 0;
                for (const s of h.get()){
                    const a = s.vaos || (s.vaos = {});
                    (a[n] || (a[n] = new Ao)).bind(f, this, l, _ ? _.getPaintVertexBuffers() : [], c, s.vertexOffset, p || [], x), m && m > 1 ? g.drawElementsInstanced(t1, s.primitiveLength * v, g.UNSIGNED_SHORT, s.primitiveOffset * v * 2, m) : c ? g.drawElements(t1, s.primitiveLength * v, g.UNSIGNED_SHORT, s.primitiveOffset * v * 2) : g.drawArrays(t1, s.vertexOffset, s.vertexLength), t1 === g.TRIANGLES && c && this._drawDebugWireframe(e, i, o, r, c, s, u, d, _, m);
                }
            }
        }
        function Or(t1, i) {
            const o = Math.pow(2, i.tileID.overscaledZ), r = i.tileSize * Math.pow(2, t1.transform.tileZoom) / o, s = r * (i.tileID.canonical.x + i.tileID.wrap * o), a = r * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture ? i.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: 1 / e.ak(i, 1, t1.transform.tileZoom),
                u_pixel_coord_upper: [
                    s >> 16,
                    a >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & s,
                    65535 & a
                ]
            };
        }
        const Fr = e.a6.mat4.create(), kr = (t1, i, o, r, s, a, n, l, c, h, u, d, _, p, m, f)=>{
            const g = i.style.light, v = g.properties.get("position"), x = [
                v.x,
                v.y,
                v.z
            ], y = e.a6.mat3.create();
            "viewport" === g.properties.get("anchor") && (e.a6.mat3.fromRotation(y, -i.transform.angle), e.a6.vec3.transformMat3(x, x, y));
            const b = g.properties.get("color"), w = i.transform, T = {
                u_matrix: t1,
                u_lightpos: x,
                u_lightintensity: g.properties.get("intensity"),
                u_lightcolor: [
                    b.r,
                    b.g,
                    b.b
                ],
                u_vertical_gradient: +o,
                u_opacity: r,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: Fr,
                u_merc_center: [
                    0,
                    0
                ],
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_height_lift: 0,
                u_ao: s,
                u_edge_radius: a,
                u_width_scale: n,
                u_flood_light_color: _,
                u_vertical_scale: p,
                u_flood_light_intensity: m,
                u_ground_shadow_factor: f
            };
            return "globe" === w.projection.name && (T.u_tile_id = [
                l.canonical.x,
                l.canonical.y,
                1 << l.canonical.z
            ], T.u_zoom_transition = h, T.u_inv_rot_matrix = d, T.u_merc_center = u, T.u_up_dir = w.projection.upVector(new e.bP(0, 0, 0), u[0] * e.ab, u[1] * e.ab), T.u_height_lift = c), T;
        }, Br = (e, t1, i, o)=>({
                u_matrix: e,
                u_edge_radius: t1,
                u_width_scale: i,
                u_vertical_scale: o
            }), Nr = (t1, i, o, r, s, a, n, l, c, h, u, d, _, p, m)=>{
            const f = kr(t1, i, o, r, s, a, n, l, h, u, d, _, p, m, 1, [
                0,
                0,
                0
            ]), g = {
                u_height_factor: -Math.pow(2, l.overscaledZ) / c.tileSize / 8
            };
            return e.l(f, Or(i, c), g);
        }, Ur = (e, t1)=>({
                u_matrix: e,
                u_emissive_strength: t1
            }), Gr = (t1, i, o, r)=>e.l(Ur(t1, i), Or(o, r)), jr = (e, t1, i)=>({
                u_matrix: e,
                u_world: i,
                u_emissive_strength: t1
            }), Vr = (t1, i, o, r, s)=>e.l(Gr(t1, i, o, r), {
                u_world: s
            }), qr = (t1, i, o, r)=>{
            const s = e.ab / o.tileSize;
            return {
                u_matrix: t1,
                u_camera_to_center_distance: i.getCameraToCenterDistance(r),
                u_extrude_scale: [
                    i.pixelsToGLUnits[0] / s,
                    i.pixelsToGLUnits[1] / s
                ]
            };
        }, Zr = (e, t1, i = 1)=>({
                u_matrix: e,
                u_color: t1.toRenderColor(null),
                u_overlay: 0,
                u_overlay_scale: i
            }), Hr = e.a6.mat4.create(), Wr = (t1, i, o, r, s, a, n)=>{
            const l = t1.transform, c = "globe" === l.projection.name, h = c ? e.cI(l.zoom, i.canonical) * l._pixelsPerMercatorPixel : e.ak(o, 1, a), u = {
                u_matrix: i.projMatrix,
                u_extrude_scale: h,
                u_intensity: n,
                u_inv_rot_matrix: Hr,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (c) {
                u.u_inv_rot_matrix = r, u.u_merc_center = s, u.u_tile_id = [
                    i.canonical.x,
                    i.canonical.y,
                    1 << i.canonical.z
                ], u.u_zoom_transition = e.a9(l.zoom);
                const t1 = s[0] * e.ab, o = s[1] * e.ab;
                u.u_up_dir = l.projection.upVector(new e.bP(0, 0, 0), t1, o);
            }
            return u;
        };
        function $r(e, [t1, i, o, r], [s, a]) {
            if (s === a) return [
                0,
                0,
                0,
                0
            ];
            const n = 255 * (e - 1) / (e * (a - s));
            return [
                t1 * n,
                i * n,
                o * n,
                r * n
            ];
        }
        function Xr(e, t1, [i, o]) {
            return i === o ? 0 : .5 / e + (t1 - i) * (e - 1) / (e * (o - i));
        }
        const Yr = (t1, i, o, r, s, a, n, l, c, h, u, d, _, p, m, f, g, v, x, y, b)=>({
                u_matrix: t1,
                u_normalize_matrix: i,
                u_globe_matrix: o,
                u_merc_matrix: r,
                u_grid_matrix: s,
                u_tl_parent: a,
                u_scale_parent: h,
                u_fade_t: u.mix,
                u_opacity: u.opacity * d.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: d.paint.get("raster-brightness-min"),
                u_brightness_high: d.paint.get("raster-brightness-max"),
                u_saturation_factor: e.cJ(d.paint.get("raster-saturation")),
                u_contrast_factor: e.cK(d.paint.get("raster-contrast")),
                u_spin_weights: Kr(d.paint.get("raster-hue-rotate")),
                u_perspective_transform: _,
                u_raster_elevation: p,
                u_zoom_transition: n,
                u_merc_center: l,
                u_cutoff_params: c,
                u_colorization_mix: $r(e.cL, f, v),
                u_colorization_offset: Xr(e.cL, g, v),
                u_color_ramp: m,
                u_texture_offset: [
                    y / (x + 2 * y),
                    x / (x + 2 * y)
                ],
                u_texture_res: [
                    x + 2 * y,
                    x + 2 * y
                ],
                u_emissive_strength: b
            });
        function Kr(e) {
            e *= Math.PI / 180;
            const t1 = Math.sin(e), i = Math.cos(e);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t1 - i + 1) / 3,
                (Math.sqrt(3) * t1 - i + 1) / 3
            ];
        }
        const Jr = .05, Qr = (e, t1, i, o, r, s, a, n, l, c, h, u)=>({
                u_matrix: e,
                u_normalize_matrix: t1,
                u_globe_matrix: i,
                u_merc_matrix: o,
                u_grid_matrix: r,
                u_tl_parent: s,
                u_scale_parent: c,
                u_fade_t: h.mix,
                u_opacity: h.opacity,
                u_image0: 0,
                u_image1: 1,
                u_raster_elevation: u,
                u_zoom_transition: a,
                u_merc_center: n,
                u_cutoff_params: l
            }), es = (e, t1, i, o, r, s, a, n, l, c)=>({
                u_particle_texture: e,
                u_particle_texture_side_len: t1,
                u_tile_offset: i,
                u_velocity: o,
                u_color_ramp: s,
                u_velocity_res: r,
                u_max_speed: a,
                u_uv_offset: n,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    Jr,
                    Jr
                ]
            }), ts = (e, t1, i, o, r, s, a, n, l, c)=>({
                u_particle_texture: e,
                u_particle_texture_side_len: t1,
                u_velocity: i,
                u_velocity_res: o,
                u_max_speed: r,
                u_speed_factor: s,
                u_reset_rate: a,
                u_rand_seed: Math.random(),
                u_uv_offset: n,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    Jr,
                    Jr
                ]
            }), is = e.a6.mat4.create(), os = (t1, i, o, r, s, a, n, l, c, h, u, d, _, p, m, f, g, v, x, y, b)=>{
            const w = s.transform, T = {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: i ? i.uSizeT : 0,
                u_size: i ? i.uSize : 0,
                u_camera_to_center_distance: w.getCameraToCenterDistance(x),
                u_rotate_symbol: +o,
                u_aspect_ratio: w.width / w.height,
                u_fade_change: s.options.fadeDuration ? s.symbolFadeChange : 1,
                u_matrix: a,
                u_label_plane_matrix: n,
                u_coord_matrix: l,
                u_is_text: +h,
                u_elevation_from_sea: c ? 1 : 0,
                u_pitch_with_map: +r,
                u_texsize: u,
                u_texsize_icon: d,
                u_texture: 0,
                u_texture_icon: 1,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: is,
                u_merc_center: [
                    0,
                    0
                ],
                u_camera_forward: [
                    0,
                    0,
                    0
                ],
                u_ecef_origin: [
                    0,
                    0,
                    0
                ],
                u_tile_matrix: is,
                u_up_vector: [
                    0,
                    -1,
                    0
                ],
                u_color_adj_mat: y,
                u_icon_transition: b || 0,
                u_gamma_scale: r ? s.transform.getCameraToCenterDistance(x) * Math.cos(s.terrain ? 0 : s.transform._pitch) : 1,
                u_device_pixel_ratio: e.q.devicePixelRatio,
                u_is_halo: +_
            };
            return "globe" === x.name && (T.u_tile_id = [
                p.canonical.x,
                p.canonical.y,
                1 << p.canonical.z
            ], T.u_zoom_transition = m, T.u_inv_rot_matrix = g, T.u_merc_center = f, T.u_camera_forward = w._camera.forward(), T.u_ecef_origin = e.cM(w.globeMatrix, p.toUnwrapped()), T.u_tile_matrix = Float32Array.from(w.globeMatrix), T.u_up_vector = v), T;
        }, rs = (e, t1, i, o)=>({
                u_matrix: e,
                u_emissive_strength: t1,
                u_opacity: i,
                u_color: o
            }), ss = (t1, i, o, r, s, a, n, l, c)=>e.l(function(t1, i, o, r, s, a) {
                const { width: n, height: l } = r.imageManager.getPixelSize(i), c = Math.pow(2, a.tileID.overscaledZ), h = a.tileSize * Math.pow(2, r.transform.tileZoom) / c, u = h * (a.tileID.canonical.x + a.tileID.wrap * c), d = h * a.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl: o.tl,
                    u_pattern_br: o.br,
                    u_texsize: [
                        n,
                        l
                    ],
                    u_pattern_size: o.displaySize,
                    u_pattern_units_to_pixels: s ? [
                        r.transform.width,
                        -1 * r.transform.height
                    ] : [
                        1 / e.ak(a, 1, r.transform.tileZoom),
                        1 / e.ak(a, 1, r.transform.tileZoom)
                    ],
                    u_pixel_coord_upper: [
                        u >> 16,
                        d >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & u,
                        65535 & d
                    ]
                };
            }(0, a, n, r, l, c), {
                u_matrix: t1,
                u_emissive_strength: i,
                u_opacity: o
            }), as = new Float32Array(e.a6.mat4.identity([])), ns = (t1, i, o, r, s, a, n, l, c, h, u, d, _, p = [
            0,
            0,
            0
        ], m)=>{
            const f = s.style.light, g = f.properties.get("position"), v = [
                -g.x,
                -g.y,
                g.z
            ], x = e.a6.mat3.create();
            "viewport" === f.properties.get("anchor") && (e.a6.mat3.fromRotation(x, -s.transform.angle), e.a6.vec3.transformMat3(v, v, x));
            const y = "MASK" === u.alphaMode, b = f.properties.get("color").toRenderColor(null), w = _.paint.get("model-ambient-occlusion-intensity"), T = _.paint.get("model-color").constantOr(e.bz.white).toRenderColor(null), E = _.paint.get("model-color-mix-intensity").constantOr(0);
            return {
                u_matrix: t1,
                u_lighting_matrix: i,
                u_normal_matrix: o,
                u_node_matrix: r || as,
                u_lightpos: v,
                u_lightintensity: f.properties.get("intensity"),
                u_lightcolor: [
                    b.r,
                    b.g,
                    b.b
                ],
                u_camera_pos: p,
                u_opacity: a,
                u_baseTextureIsAlpha: 0,
                u_alphaMask: +y,
                u_alphaCutoff: u.alphaCutoff,
                u_baseColorFactor: [
                    n.r,
                    n.g,
                    n.b,
                    n.a
                ],
                u_emissiveFactor: [
                    l[0],
                    l[1],
                    l[2],
                    1
                ],
                u_metallicFactor: c,
                u_roughnessFactor: h,
                u_baseColorTexture: ji.BaseColor,
                u_metallicRoughnessTexture: ji.MetallicRoughness,
                u_normalTexture: ji.Normal,
                u_occlusionTexture: ji.Occlusion,
                u_emissionTexture: ji.Emission,
                u_lutTexture: ji.LUT,
                u_color_mix: [
                    T.r,
                    T.g,
                    T.b,
                    E
                ],
                u_aoIntensity: w,
                u_emissive_strength: d,
                u_occlusionTextureTransform: m || [
                    0,
                    0,
                    0,
                    0
                ]
            };
        }, ls = (e, t1 = as, i = as)=>({
                u_matrix: e,
                u_instance: t1,
                u_node_matrix: i
            }), cs = {
            fillExtrusion: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_lightpos: new e.bH(t1),
                    u_lightintensity: new e.bI(t1),
                    u_lightcolor: new e.bH(t1),
                    u_vertical_gradient: new e.bI(t1),
                    u_opacity: new e.bI(t1),
                    u_edge_radius: new e.bI(t1),
                    u_width_scale: new e.bI(t1),
                    u_ao: new e.bG(t1),
                    u_tile_id: new e.bH(t1),
                    u_zoom_transition: new e.bI(t1),
                    u_inv_rot_matrix: new e.bF(t1),
                    u_merc_center: new e.bG(t1),
                    u_up_dir: new e.bH(t1),
                    u_height_lift: new e.bI(t1),
                    u_flood_light_color: new e.bH(t1),
                    u_vertical_scale: new e.bI(t1),
                    u_flood_light_intensity: new e.bI(t1),
                    u_ground_shadow_factor: new e.bH(t1)
                }),
            fillExtrusionDepth: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_edge_radius: new e.bI(t1),
                    u_width_scale: new e.bI(t1),
                    u_vertical_scale: new e.bI(t1)
                }),
            fillExtrusionPattern: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_lightpos: new e.bH(t1),
                    u_lightintensity: new e.bI(t1),
                    u_lightcolor: new e.bH(t1),
                    u_vertical_gradient: new e.bI(t1),
                    u_height_factor: new e.bI(t1),
                    u_edge_radius: new e.bI(t1),
                    u_width_scale: new e.bI(t1),
                    u_ao: new e.bG(t1),
                    u_tile_id: new e.bH(t1),
                    u_zoom_transition: new e.bI(t1),
                    u_inv_rot_matrix: new e.bF(t1),
                    u_merc_center: new e.bG(t1),
                    u_up_dir: new e.bH(t1),
                    u_height_lift: new e.bI(t1),
                    u_image: new e.bJ(t1),
                    u_texsize: new e.bG(t1),
                    u_pixel_coord_upper: new e.bG(t1),
                    u_pixel_coord_lower: new e.bG(t1),
                    u_tile_units_to_pixels: new e.bI(t1),
                    u_opacity: new e.bI(t1)
                }),
            fillExtrusionGroundEffect: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_opacity: new e.bI(t1),
                    u_ao_pass: new e.bI(t1),
                    u_meter_to_tile: new e.bI(t1),
                    u_ao: new e.bG(t1),
                    u_flood_light_intensity: new e.bI(t1),
                    u_flood_light_color: new e.bH(t1),
                    u_attenuation: new e.bI(t1),
                    u_edge_radius: new e.bI(t1),
                    u_fb: new e.bJ(t1),
                    u_fb_size: new e.bI(t1),
                    u_dynamic_offset: new e.bI(t1)
                }),
            fill: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_emissive_strength: new e.bI(t1)
                }),
            fillPattern: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_emissive_strength: new e.bI(t1),
                    u_image: new e.bJ(t1),
                    u_texsize: new e.bG(t1),
                    u_pixel_coord_upper: new e.bG(t1),
                    u_pixel_coord_lower: new e.bG(t1),
                    u_tile_units_to_pixels: new e.bI(t1)
                }),
            fillOutline: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_emissive_strength: new e.bI(t1),
                    u_world: new e.bG(t1)
                }),
            fillOutlinePattern: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_emissive_strength: new e.bI(t1),
                    u_world: new e.bG(t1),
                    u_image: new e.bJ(t1),
                    u_texsize: new e.bG(t1),
                    u_pixel_coord_upper: new e.bG(t1),
                    u_pixel_coord_lower: new e.bG(t1),
                    u_tile_units_to_pixels: new e.bI(t1)
                }),
            circle: e.cN,
            collisionBox: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_camera_to_center_distance: new e.bI(t1),
                    u_extrude_scale: new e.bG(t1)
                }),
            collisionCircle: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_inv_matrix: new e.bF(t1),
                    u_camera_to_center_distance: new e.bI(t1),
                    u_viewport_size: new e.bG(t1)
                }),
            debug: (t1)=>({
                    u_color: new e.cu(t1),
                    u_matrix: new e.bF(t1),
                    u_overlay: new e.bJ(t1),
                    u_overlay_scale: new e.bI(t1)
                }),
            clippingMask: (t1)=>({
                    u_matrix: new e.bF(t1)
                }),
            heatmap: (t1)=>({
                    u_extrude_scale: new e.bI(t1),
                    u_intensity: new e.bI(t1),
                    u_matrix: new e.bF(t1),
                    u_inv_rot_matrix: new e.bF(t1),
                    u_merc_center: new e.bG(t1),
                    u_tile_id: new e.bH(t1),
                    u_zoom_transition: new e.bI(t1),
                    u_up_dir: new e.bH(t1)
                }),
            heatmapTexture: (t1)=>({
                    u_image: new e.bJ(t1),
                    u_color_ramp: new e.bJ(t1),
                    u_opacity: new e.bI(t1)
                }),
            hillshade: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_image: new e.bJ(t1),
                    u_latrange: new e.bG(t1),
                    u_light: new e.bG(t1),
                    u_shadow: new e.cu(t1),
                    u_highlight: new e.cu(t1),
                    u_emissive_strength: new e.bI(t1),
                    u_accent: new e.cu(t1)
                }),
            hillshadePrepare: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_image: new e.bJ(t1),
                    u_dimension: new e.bG(t1),
                    u_zoom: new e.bI(t1)
                }),
            line: e.cO,
            linePattern: e.cP,
            raster: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_normalize_matrix: new e.bF(t1),
                    u_globe_matrix: new e.bF(t1),
                    u_merc_matrix: new e.bF(t1),
                    u_grid_matrix: new e.cv(t1),
                    u_tl_parent: new e.bG(t1),
                    u_scale_parent: new e.bI(t1),
                    u_fade_t: new e.bI(t1),
                    u_opacity: new e.bI(t1),
                    u_image0: new e.bJ(t1),
                    u_image1: new e.bJ(t1),
                    u_brightness_low: new e.bI(t1),
                    u_brightness_high: new e.bI(t1),
                    u_saturation_factor: new e.bI(t1),
                    u_contrast_factor: new e.bI(t1),
                    u_spin_weights: new e.bH(t1),
                    u_perspective_transform: new e.bG(t1),
                    u_raster_elevation: new e.bI(t1),
                    u_zoom_transition: new e.bI(t1),
                    u_merc_center: new e.bG(t1),
                    u_cutoff_params: new e.c6(t1),
                    u_colorization_mix: new e.c6(t1),
                    u_colorization_offset: new e.bI(t1),
                    u_color_ramp: new e.bJ(t1),
                    u_texture_offset: new e.bG(t1),
                    u_texture_res: new e.bG(t1),
                    u_emissive_strength: new e.bI(t1)
                }),
            rasterParticle: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_normalize_matrix: new e.bF(t1),
                    u_globe_matrix: new e.bF(t1),
                    u_merc_matrix: new e.bF(t1),
                    u_grid_matrix: new e.cv(t1),
                    u_tl_parent: new e.bG(t1),
                    u_scale_parent: new e.bI(t1),
                    u_fade_t: new e.bI(t1),
                    u_opacity: new e.bI(t1),
                    u_image0: new e.bJ(t1),
                    u_image1: new e.bJ(t1),
                    u_raster_elevation: new e.bI(t1),
                    u_zoom_transition: new e.bI(t1),
                    u_merc_center: new e.bG(t1),
                    u_cutoff_params: new e.c6(t1)
                }),
            rasterParticleTexture: (t1)=>({
                    u_texture: new e.bJ(t1),
                    u_opacity: new e.bI(t1)
                }),
            rasterParticleDraw: (t1)=>({
                    u_particle_texture: new e.bJ(t1),
                    u_particle_texture_side_len: new e.bI(t1),
                    u_tile_offset: new e.bG(t1),
                    u_velocity: new e.bJ(t1),
                    u_color_ramp: new e.bJ(t1),
                    u_velocity_res: new e.bG(t1),
                    u_max_speed: new e.bI(t1),
                    u_uv_offset: new e.bG(t1),
                    u_data_scale: new e.bG(t1),
                    u_data_offset: new e.bI(t1),
                    u_particle_pos_scale: new e.bI(t1),
                    u_particle_pos_offset: new e.bG(t1)
                }),
            rasterParticleUpdate: (t1)=>({
                    u_particle_texture: new e.bJ(t1),
                    u_particle_texture_side_len: new e.bI(t1),
                    u_velocity: new e.bJ(t1),
                    u_velocity_res: new e.bG(t1),
                    u_max_speed: new e.bI(t1),
                    u_speed_factor: new e.bI(t1),
                    u_reset_rate: new e.bI(t1),
                    u_rand_seed: new e.bI(t1),
                    u_uv_offset: new e.bG(t1),
                    u_data_scale: new e.bG(t1),
                    u_data_offset: new e.bI(t1),
                    u_particle_pos_scale: new e.bI(t1),
                    u_particle_pos_offset: new e.bG(t1)
                }),
            symbol: (t1)=>({
                    u_is_size_zoom_constant: new e.bJ(t1),
                    u_is_size_feature_constant: new e.bJ(t1),
                    u_size_t: new e.bI(t1),
                    u_size: new e.bI(t1),
                    u_camera_to_center_distance: new e.bI(t1),
                    u_rotate_symbol: new e.bJ(t1),
                    u_aspect_ratio: new e.bI(t1),
                    u_fade_change: new e.bI(t1),
                    u_matrix: new e.bF(t1),
                    u_label_plane_matrix: new e.bF(t1),
                    u_coord_matrix: new e.bF(t1),
                    u_is_text: new e.bJ(t1),
                    u_elevation_from_sea: new e.bJ(t1),
                    u_pitch_with_map: new e.bJ(t1),
                    u_texsize: new e.bG(t1),
                    u_texsize_icon: new e.bG(t1),
                    u_texture: new e.bJ(t1),
                    u_texture_icon: new e.bJ(t1),
                    u_gamma_scale: new e.bI(t1),
                    u_device_pixel_ratio: new e.bI(t1),
                    u_tile_id: new e.bH(t1),
                    u_zoom_transition: new e.bI(t1),
                    u_inv_rot_matrix: new e.bF(t1),
                    u_merc_center: new e.bG(t1),
                    u_camera_forward: new e.bH(t1),
                    u_tile_matrix: new e.bF(t1),
                    u_up_vector: new e.bH(t1),
                    u_ecef_origin: new e.bH(t1),
                    u_is_halo: new e.bJ(t1),
                    u_icon_transition: new e.bI(t1),
                    u_color_adj_mat: new e.bF(t1)
                }),
            background: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_emissive_strength: new e.bI(t1),
                    u_opacity: new e.bI(t1),
                    u_color: new e.cu(t1)
                }),
            backgroundPattern: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_emissive_strength: new e.bI(t1),
                    u_opacity: new e.bI(t1),
                    u_image: new e.bJ(t1),
                    u_pattern_tl: new e.bG(t1),
                    u_pattern_br: new e.bG(t1),
                    u_texsize: new e.bG(t1),
                    u_pattern_size: new e.bG(t1),
                    u_pixel_coord_upper: new e.bG(t1),
                    u_pixel_coord_lower: new e.bG(t1),
                    u_pattern_units_to_pixels: new e.bG(t1)
                }),
            terrainRaster: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_image0: new e.bJ(t1),
                    u_skirt_height: new e.bI(t1),
                    u_ground_shadow_factor: new e.bH(t1)
                }),
            skybox: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_sun_direction: new e.bH(t1),
                    u_cubemap: new e.bJ(t1),
                    u_opacity: new e.bI(t1),
                    u_temporal_offset: new e.bI(t1)
                }),
            skyboxGradient: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_color_ramp: new e.bJ(t1),
                    u_center_direction: new e.bH(t1),
                    u_radius: new e.bI(t1),
                    u_opacity: new e.bI(t1),
                    u_temporal_offset: new e.bI(t1)
                }),
            skyboxCapture: (t1)=>({
                    u_matrix_3f: new e.cv(t1),
                    u_sun_direction: new e.bH(t1),
                    u_sun_intensity: new e.bI(t1),
                    u_color_tint_r: new e.c6(t1),
                    u_color_tint_m: new e.c6(t1),
                    u_luminance: new e.bI(t1)
                }),
            globeRaster: (t1)=>({
                    u_proj_matrix: new e.bF(t1),
                    u_globe_matrix: new e.bF(t1),
                    u_normalize_matrix: new e.bF(t1),
                    u_merc_matrix: new e.bF(t1),
                    u_zoom_transition: new e.bI(t1),
                    u_merc_center: new e.bG(t1),
                    u_image0: new e.bJ(t1),
                    u_grid_matrix: new e.cv(t1),
                    u_skirt_height: new e.bI(t1),
                    u_far_z_cutoff: new e.bI(t1),
                    u_frustum_tl: new e.bH(t1),
                    u_frustum_tr: new e.bH(t1),
                    u_frustum_br: new e.bH(t1),
                    u_frustum_bl: new e.bH(t1),
                    u_globe_pos: new e.bH(t1),
                    u_globe_radius: new e.bI(t1),
                    u_viewport: new e.bG(t1)
                }),
            globeAtmosphere: (t1)=>({
                    u_frustum_tl: new e.bH(t1),
                    u_frustum_tr: new e.bH(t1),
                    u_frustum_br: new e.bH(t1),
                    u_frustum_bl: new e.bH(t1),
                    u_horizon: new e.bI(t1),
                    u_transition: new e.bI(t1),
                    u_fadeout_range: new e.bI(t1),
                    u_color: new e.c6(t1),
                    u_high_color: new e.c6(t1),
                    u_space_color: new e.c6(t1),
                    u_temporal_offset: new e.bI(t1),
                    u_horizon_angle: new e.bI(t1)
                }),
            model: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_lighting_matrix: new e.bF(t1),
                    u_normal_matrix: new e.bF(t1),
                    u_node_matrix: new e.bF(t1),
                    u_lightpos: new e.bH(t1),
                    u_lightintensity: new e.bI(t1),
                    u_lightcolor: new e.bH(t1),
                    u_camera_pos: new e.bH(t1),
                    u_opacity: new e.bI(t1),
                    u_baseColorFactor: new e.c6(t1),
                    u_emissiveFactor: new e.c6(t1),
                    u_metallicFactor: new e.bI(t1),
                    u_roughnessFactor: new e.bI(t1),
                    u_baseTextureIsAlpha: new e.bJ(t1),
                    u_alphaMask: new e.bJ(t1),
                    u_alphaCutoff: new e.bI(t1),
                    u_baseColorTexture: new e.bJ(t1),
                    u_metallicRoughnessTexture: new e.bJ(t1),
                    u_normalTexture: new e.bJ(t1),
                    u_occlusionTexture: new e.bJ(t1),
                    u_emissionTexture: new e.bJ(t1),
                    u_lutTexture: new e.bJ(t1),
                    u_color_mix: new e.c6(t1),
                    u_aoIntensity: new e.bI(t1),
                    u_emissive_strength: new e.bI(t1),
                    u_occlusionTextureTransform: new e.c6(t1)
                }),
            modelDepth: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_instance: new e.bF(t1),
                    u_node_matrix: new e.bF(t1)
                }),
            groundShadow: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_ground_shadow_factor: new e.bH(t1)
                }),
            stars: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_up: new e.bH(t1),
                    u_right: new e.bH(t1),
                    u_intensity_multiplier: new e.bI(t1)
                }),
            occlusion: (t1)=>({
                    u_matrix: new e.bF(t1),
                    u_anchorPos: new e.bH(t1),
                    u_screenSizePx: new e.bG(t1),
                    u_occluderSizePx: new e.bG(t1),
                    u_color: new e.c6(t1)
                })
        };
        class hs {
            constructor(e, t1, i, o){
                this.id = hs.uniqueIdxCounter, hs.uniqueIdxCounter++, this.context = e;
                const r = e.gl;
                this.buffer = r.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e.bindElementBuffer.set(this.buffer), r.bufferData(r.ELEMENT_ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || o || t1.destroy();
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e) {
                this.id = hs.uniqueIdxCounter, hs.uniqueIdxCounter++;
                const t1 = this.context.gl;
                this.context.unbindVAO(), this.bind(), t1.bufferSubData(t1.ELEMENT_ARRAY_BUFFER, 0, e.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        hs.uniqueIdxCounter = 0;
        const us = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class ds {
            constructor(e, t1, i, o, r, s){
                this.length = t1.length, this.attributes = i, this.itemSize = t1.bytesPerElement, this.dynamicDraw = o, this.instanceCount = s, this.context = e;
                const a = e.gl;
                this.buffer = a.createBuffer(), e.bindVertexBuffer.set(this.buffer), a.bufferData(a.ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? a.DYNAMIC_DRAW : a.STATIC_DRAW), this.dynamicDraw || r || t1.destroy();
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e) {
                const t1 = this.context.gl;
                this.bind(), t1.bufferSubData(t1.ARRAY_BUFFER, 0, e.arrayBuffer);
            }
            enableAttributes(e, t1) {
                for(let i = 0; i < this.attributes.length; i++){
                    const o = t1.attributes[this.attributes[i].name];
                    void 0 !== o && e.enableVertexAttribArray(o);
                }
            }
            setVertexAttribPointers(e, t1, i) {
                for(let o = 0; o < this.attributes.length; o++){
                    const r = this.attributes[o], s = t1.attributes[r.name];
                    void 0 !== s && e.vertexAttribPointer(s, r.components, e[us[r.type]], !1, this.itemSize, r.offset + this.itemSize * (i || 0));
                }
            }
            setVertexAttribDivisor(e, t1, i) {
                for(let o = 0; o < this.attributes.length; o++){
                    const r = t1.attributes[this.attributes[o].name];
                    void 0 !== r && this.instanceCount && this.instanceCount > 0 && e.vertexAttribDivisor(r, i);
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        class _s {
            constructor(e, t1, i, o, r){
                this.context = e, this.width = t1, this.height = i;
                const s = this.framebuffer = e.gl.createFramebuffer();
                o && (this.colorAttachment = new pr(e, s)), r && (this.depthAttachmentType = r, this.depthAttachment = "renderbuffer" === r ? new mr(e, s) : new fr(e, s));
            }
            destroy() {
                const e = this.context.gl;
                if (this.colorAttachment) {
                    const t1 = this.colorAttachment.get();
                    t1 && e.deleteTexture(t1);
                }
                if (this.depthAttachment && this.depthAttachmentType) {
                    if ("renderbuffer" === this.depthAttachmentType) {
                        const t1 = this.depthAttachment.get();
                        t1 && e.deleteRenderbuffer(t1);
                    } else {
                        const t1 = this.depthAttachment.get();
                        t1 && e.deleteTexture(t1);
                    }
                }
                e.deleteFramebuffer(this.framebuffer);
            }
        }
        class ps {
            constructor(e, t1){
                this.gl = e, this.clearColor = new Fo(this), this.clearDepth = new ko(this), this.clearStencil = new Bo(this), this.colorMask = new No(this), this.depthMask = new Uo(this), this.stencilMask = new Go(this), this.stencilFunc = new jo(this), this.stencilOp = new Vo(this), this.stencilTest = new qo(this), this.depthRange = new Zo(this), this.depthTest = new Ho(this), this.depthFunc = new Wo(this), this.blend = new $o(this), this.blendFunc = new Xo(this), this.blendColor = new Yo(this), this.blendEquation = new Ko(this), this.cullFace = new Jo(this), this.cullFaceSide = new Qo(this), this.frontFace = new er(this), this.program = new tr(this), this.activeTexture = new ir(this), this.viewport = new or(this), this.bindFramebuffer = new rr(this), this.bindRenderbuffer = new sr(this), this.bindTexture = new ar(this), this.bindVertexBuffer = new nr(this), this.bindElementBuffer = new lr(this), this.bindVertexArrayOES = new cr(this), this.pixelStoreUnpack = new hr(this), this.pixelStoreUnpackPremultiplyAlpha = new ur(this), this.pixelStoreUnpackFlipY = new dr(this), this.options = t1 ? {
                    ...t1
                } : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e.getExtension("EXT_texture_filter_anisotropic") || e.getExtension("MOZ_EXT_texture_filter_anisotropic") || e.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e.getExtension("EXT_color_buffer_half_float"), this.extTimerQuery = e.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e.getParameter(e.MAX_TEXTURE_SIZE), this.maxPointSize = e.getParameter(e.ALIASED_POINT_SIZE_RANGE)[1];
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArrayOES.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e, t1, i) {
                return new hs(this, e, t1, i);
            }
            createVertexBuffer(e, t1, i, o, r) {
                return new ds(this, e, t1, i, o, r);
            }
            createRenderbuffer(e, t1, i) {
                const o = this.gl, r = o.createRenderbuffer();
                return this.bindRenderbuffer.set(r), o.renderbufferStorage(o.RENDERBUFFER, e, t1, i), this.bindRenderbuffer.set(null), r;
            }
            createFramebuffer(e, t1, i, o) {
                return new _s(this, e, t1, i, o);
            }
            clear({ color: e, depth: t1, stencil: i, colorMask: o }) {
                const r = this.gl;
                let s = 0;
                e && (s |= r.COLOR_BUFFER_BIT, this.clearColor.set(e), this.colorMask.set(o || [
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t1 && (s |= r.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t1), this.depthMask.set(!0)), void 0 !== i && (s |= r.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), r.clear(s);
            }
            setCullFace(e) {
                !1 === e.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e.mode), this.frontFace.set(e.frontFace));
            }
            setDepthMode(e) {
                e.func !== this.gl.ALWAYS || e.mask ? (this.depthTest.set(!0), this.depthFunc.set(e.func), this.depthMask.set(e.mask), this.depthRange.set(e.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e) {
                e.test.func !== this.gl.ALWAYS || e.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e.mask), this.stencilOp.set([
                    e.fail,
                    e.depthFail,
                    e.pass
                ]), this.stencilFunc.set({
                    func: e.test.func,
                    ref: e.ref,
                    mask: e.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(t1) {
                e.bh(t1.blendFunction, Ai.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(t1.blendFunction), this.blendColor.set(t1.blendColor), t1.blendEquation ? this.blendEquation.set(t1.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(t1.mask);
            }
            unbindVAO() {
                this.bindVertexArrayOES.set(null);
            }
        }
        let ms;
        function fs(t1, i, o, r, s, a, n) {
            const l = t1.context, c = l.gl, h = t1.transform, u = t1.getOrCreateProgram("collisionBox"), d = [];
            let _ = 0, p = 0;
            for(let l = 0; l < r.length; l++){
                const m = r[l], f = i.getTile(m), g = f.getBucket(o);
                if (!g) continue;
                const v = ti(m, g, h);
                let x = v;
                0 === s[0] && 0 === s[1] || (x = t1.translatePosMatrix(v, f, s, a));
                const y = n ? g.textCollisionBox : g.iconCollisionBox, b = g.collisionCircleArray;
                if (b.length > 0) {
                    const t1 = e.a6.mat4.create(), i = x;
                    e.a6.mat4.mul(t1, g.placementInvProjMatrix, h.glCoordMatrix), e.a6.mat4.mul(t1, t1, g.placementViewportMatrix), d.push({
                        circleArray: b,
                        circleOffset: p,
                        transform: i,
                        invTransform: t1,
                        projection: g.getProjection()
                    }), _ += b.length / 4, p = _;
                }
                y && (t1.terrain && t1.terrain.setupElevationDraw(f, u), u.draw(t1, c.LINES, Li.disabled, Mi.disabled, t1.colorModeForRenderPass(), Fi.disabled, qr(x, h, f, g.getProjection()), o.id, y.layoutVertexBuffer, y.indexBuffer, y.segments, null, h.zoom, null, [
                    y.collisionVertexBuffer,
                    y.collisionVertexBufferExt
                ]));
            }
            if (!n || !d.length) return;
            const m = t1.getOrCreateProgram("collisionCircle"), f = new e.cQ;
            f.resize(4 * _), f._trim();
            let g = 0;
            for (const e of d)for(let t1 = 0; t1 < e.circleArray.length / 4; t1++){
                const i = 4 * t1, o = e.circleArray[i + 0], r = e.circleArray[i + 1], s = e.circleArray[i + 2], a = e.circleArray[i + 3];
                f.emplace(g++, o, r, s, a, 0), f.emplace(g++, o, r, s, a, 1), f.emplace(g++, o, r, s, a, 2), f.emplace(g++, o, r, s, a, 3);
            }
            (!ms || ms.length < 2 * _) && (ms = function(t1) {
                const i = 2 * t1, o = new e.aO;
                o.resize(i), o._trim();
                for(let e = 0; e < i; e++){
                    const t1 = 6 * e;
                    o.uint16[t1 + 0] = 4 * e + 0, o.uint16[t1 + 1] = 4 * e + 1, o.uint16[t1 + 2] = 4 * e + 2, o.uint16[t1 + 3] = 4 * e + 2, o.uint16[t1 + 4] = 4 * e + 3, o.uint16[t1 + 5] = 4 * e + 0;
                }
                return o;
            }(_));
            const v = l.createIndexBuffer(ms, !0), x = l.createVertexBuffer(f, e.cR.members, !0);
            for (const i of d){
                const r = {
                    u_matrix: i.transform,
                    u_inv_matrix: i.invTransform,
                    u_camera_to_center_distance: (y = h).getCameraToCenterDistance(i.projection),
                    u_viewport_size: [
                        y.width,
                        y.height
                    ]
                };
                m.draw(t1, c.TRIANGLES, Li.disabled, Mi.disabled, t1.colorModeForRenderPass(), Fi.disabled, r, o.id, x, v, e.b1.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, h.zoom);
            }
            var y;
            x.destroy(), v.destroy();
        }
        const gs = e.a6.mat4.create();
        function vs(t1) {
            const i = t1._camera.getWorldToCamera(t1.worldSize, 1), o = e.a6.mat4.multiply([], i, t1.globeMatrix);
            e.a6.mat4.invert(o, o);
            const r = [
                0,
                0,
                0
            ], s = [
                0,
                1,
                0,
                0
            ];
            return e.a6.vec4.transformMat4(s, s, o), r[0] = s[0], r[1] = s[1], r[2] = s[2], e.a6.vec3.normalize(r, r), r;
        }
        function xs({ width: t1, height: i, anchor: o, textOffset: r, textScale: s }, a) {
            const { horizontalAlign: n, verticalAlign: l } = e.bx(o), c = -(n - .5) * t1, h = -(l - .5) * i, u = e.bw(o, r);
            return new e.P((c / s + u[0]) * a, (h / s + u[1]) * a);
        }
        function ys(t1, i, o, r, s, a, n, l, c, h, u) {
            const d = t1.text.placedSymbolArray, _ = t1.text.dynamicLayoutVertexArray, p = t1.icon.dynamicLayoutVertexArray, m = {}, f = t1.getProjection(), g = ii(l, f, a), v = a.elevation, x = f.upVectorScale(l.canonical, a.center.lat, a.worldSize).metersToTile;
            _.clear();
            for(let p = 0; p < d.length; p++){
                const y = d.get(p), { tileAnchorX: b, tileAnchorY: w, numGlyphs: T } = y, E = y.hidden || !y.crossTileID || t1.allowVerticalPlacement && !y.placedOrientation ? null : r[y.crossTileID];
                if (E) {
                    let r = 0, d = 0, p = 0;
                    if (v) {
                        const e = v ? v.getAtTileOffset(l, b, w) : 0, [t1, i, o] = f.upVector(l.canonical, b, w);
                        r = e * t1 * x, d = e * i * x, p = e * o * x;
                    }
                    let [C, S, I, D] = Ut(y.projectedAnchorX + r, y.projectedAnchorY + d, y.projectedAnchorZ + p, o ? g : n);
                    const R = Gt(a.getCameraToCenterDistance(f), D);
                    let A = s.evaluateSizeForFeature(t1.textSizeData, h, y) * R / e.bq;
                    o && (A *= t1.tilePixelRatio / c);
                    const L = xs(E, A);
                    o ? ({ x: C, y: S, z: I } = f.projectTilePoint(b + L.x, w + L.y, l.canonical), [C, S, I] = Ut(C + r, S + d, I + p, n)) : (i && L._rotate(-a.angle), C += L.x, S += L.y, I = 0);
                    const P = t1.allowVerticalPlacement && y.placedOrientation === e.bk.vertical ? Math.PI / 2 : 0;
                    for(let t1 = 0; t1 < T; t1++)e.bn(_, C, S, I, P);
                    u && y.associatedIconIndex >= 0 && (m[y.associatedIconIndex] = {
                        x: C,
                        y: S,
                        z: I,
                        angle: P
                    });
                } else Yt(T, _);
            }
            if (u) {
                p.clear();
                const i = t1.icon.placedSymbolArray;
                for(let t1 = 0; t1 < i.length; t1++){
                    const o = i.get(t1), { numGlyphs: r } = o, s = m[t1];
                    if (o.hidden || !s) Yt(r, p);
                    else {
                        const { x: t1, y: i, z: o, angle: a } = s;
                        for(let s = 0; s < r; s++)e.bn(p, t1, i, o, a);
                    }
                }
                t1.icon.dynamicLayoutVertexBuffer.updateData(p);
            }
            t1.text.dynamicLayoutVertexBuffer.updateData(_);
        }
        function bs(t1, i, o, r, s, a, n = {}) {
            const l = o.paint.get("icon-translate"), c = o.paint.get("text-translate"), h = o.paint.get("icon-translate-anchor"), u = o.paint.get("text-translate-anchor"), d = o.layout.get("icon-rotation-alignment"), _ = o.layout.get("text-rotation-alignment"), p = o.layout.get("icon-pitch-alignment"), m = o.layout.get("text-pitch-alignment"), f = o.layout.get("icon-keep-upright"), g = o.layout.get("text-keep-upright"), v = o.paint.get("icon-color-saturation"), x = o.paint.get("icon-color-contrast"), y = o.paint.get("icon-color-brightness-min"), b = o.paint.get("icon-color-brightness-max"), w = "sea" === o.paint.get("symbol-elevation-reference"), T = o.paint.get("text-occlusion-opacity").constantOr(0), E = t1.context, C = E.gl, S = t1.transform, I = "map" === d, D = "map" === _, R = "map" === p, A = "map" === m, L = void 0 !== o.layout.get("symbol-sort-key").constantOr(1);
            let P = !1;
            const M = t1.depthModeForSublayer(0, Li.ReadOnly), z = [
                e.am(S.center.lng),
                e.at(S.center.lat)
            ], O = o.layout.get("text-variable-anchor"), F = "globe" === S.projection.name, k = [], B = [
                0,
                -1,
                0
            ];
            for (const s of r){
                const r = i.getTile(s), a = r.getBucket(o);
                if (!a) continue;
                if ("mercator" === a.projection.name && F) continue;
                if (a.fullyClipped) continue;
                const d = "globe" === a.projection.name, _ = d ? e.a9(S.zoom) : 0, p = ii(s, a.getProjection(), S), m = S.calculatePixelsToTileUnitsMatrix(r), E = O && a.hasTextData(), M = a.hasIconTextFit() && E && a.hasIconData(), N = a.getProjection().createInversionMatrix(S, s.canonical), U = (e)=>{
                    S.depthOcclusionForSymbolsAndCircles && (o.hasInitialOcclusionOpacityProperties || t1.terrain) && (e.push("DEPTH_D24"), e.push("DEPTH_OCCLUSION"));
                }, G = ()=>{
                    const i = I && "point" !== o.layout.get("symbol-placement"), n = [];
                    U(n);
                    const c = i || M, u = o.paint.get("icon-image-cross-fade").constantOr(0);
                    t1.terrainRenderModeElevated() && R && n.push("PITCH_WITH_MAP_TERRAIN"), d && (n.push("PROJECTION_GLOBE_VIEW"), c && n.push("PROJECTED_POS_ON_VIEWPORT")), u > 0 && n.push("ICON_TRANSITION"), a.icon.zOffsetVertexBuffer && n.push("Z_OFFSET"), 0 === v && 0 === x && 0 === y && 1 === b || n.push("COLOR_ADJUSTMENT"), a.sdfIcons && n.push("RENDER_SDF");
                    const g = a.icon.programConfigurations.get(o.id), T = t1.getOrCreateProgram("symbol", {
                        config: g,
                        defines: n
                    }), E = r.imageAtlasTexture ? r.imageAtlasTexture.size : [
                        0,
                        0
                    ], D = a.iconSizeData, A = e.bj(D, S.zoom), L = R || 0 !== S.pitch, P = kt(p, r.tileID.canonical, R, I, S, a.getProjection(), m), O = Nt(p, r.tileID.canonical, R, I, S, a.getProjection(), m), k = t1.translatePosMatrix(O, r, l, h, !0), G = t1.translatePosMatrix(p, r, l, h), j = c ? gs : P, V = I && !R && !i;
                    let q = B;
                    !F && !S.mercatorFromTransition || I || (q = vs(S));
                    const Z = d ? q : B, H = o.getColorAdjustmentMatrix(v, x, y, b), W = os(D.kind, A, V, R, t1, G, j, k, w, !1, E, [
                        0,
                        0
                    ], !0, s, _, z, N, Z, a.getProjection(), H, u), $ = r.imageAtlasTexture ? r.imageAtlasTexture : null, X = 1 !== o.layout.get("icon-size").constantOr(0) || a.iconsNeedLinear, Y = a.sdfIcons || t1.options.rotating || t1.options.zooming || X || L ? C.LINEAR : C.NEAREST, K = a.sdfIcons && 0 !== o.paint.get("icon-halo-width").constantOr(1), J = t1.terrain && R && i ? e.a6.mat4.invert(e.a6.mat4.create(), P) : gs;
                    if (i && a.icon) {
                        const e = S.elevation, i = e ? e.getAtTileOffsetFunc(s, S.center.lat, S.worldSize, a.getProjection()) : null, o = Bt(p, r.tileID.canonical, R, I, S, a.getProjection(), m);
                        Vt(a, p, t1, !1, o, O, R, f, i, s);
                    }
                    return {
                        program: T,
                        buffers: a.icon,
                        uniformValues: W,
                        atlasTexture: $,
                        atlasTextureIcon: null,
                        atlasInterpolation: Y,
                        atlasInterpolationIcon: null,
                        isSDF: a.sdfIcons,
                        hasHalo: K,
                        tile: r,
                        labelPlaneMatrixInv: J
                    };
                }, j = ()=>{
                    const i = D && "point" !== o.layout.get("symbol-placement"), n = [], l = i || O || M;
                    t1.terrainRenderModeElevated() && A && n.push("PITCH_WITH_MAP_TERRAIN"), d && (n.push("PROJECTION_GLOBE_VIEW"), l && n.push("PROJECTED_POS_ON_VIEWPORT")), a.text.zOffsetVertexBuffer && n.push("Z_OFFSET"), a.iconsInText && n.push("RENDER_TEXT_AND_SYMBOL"), n.push("RENDER_SDF"), U(n);
                    const h = a.text.programConfigurations.get(o.id), f = t1.getOrCreateProgram("symbol", {
                        config: h,
                        defines: n
                    });
                    let v, x = [
                        0,
                        0
                    ], y = null;
                    const b = a.textSizeData;
                    a.iconsInText && (x = r.imageAtlasTexture ? r.imageAtlasTexture.size : [
                        0,
                        0
                    ], y = r.imageAtlasTexture ? r.imageAtlasTexture : null, v = A || 0 !== S.pitch || t1.options.rotating || t1.options.zooming || "composite" === b.kind || "camera" === b.kind ? C.LINEAR : C.NEAREST);
                    const E = r.glyphAtlasTexture ? r.glyphAtlasTexture.size : [
                        0,
                        0
                    ], I = e.bj(b, S.zoom), R = kt(p, r.tileID.canonical, A, D, S, a.getProjection(), m), L = Nt(p, r.tileID.canonical, A, D, S, a.getProjection(), m), P = t1.translatePosMatrix(L, r, c, u, !0), k = t1.translatePosMatrix(p, r, c, u), G = l ? gs : R, j = D && !A && !i;
                    let V = B;
                    !F && !S.mercatorFromTransition || D || (V = vs(S));
                    const q = os(b.kind, I, j, A, t1, k, G, P, w, !0, E, x, !0, s, _, z, N, d ? V : B, a.getProjection(), T), Z = r.glyphAtlasTexture ? r.glyphAtlasTexture : null, H = C.LINEAR, W = 0 !== o.paint.get("text-halo-width").constantOr(1), $ = t1.terrain && A && i ? e.a6.mat4.invert(e.a6.mat4.create(), R) : gs;
                    if (i && a.text) {
                        const e = S.elevation, i = e ? e.getAtTileOffsetFunc(s, S.center.lat, S.worldSize, a.getProjection()) : null, o = Bt(p, r.tileID.canonical, A, D, S, a.getProjection(), m);
                        Vt(a, p, t1, !0, o, L, A, g, i, s);
                    }
                    return {
                        program: f,
                        buffers: a.text,
                        uniformValues: q,
                        atlasTexture: Z,
                        atlasTextureIcon: y,
                        atlasInterpolation: H,
                        atlasInterpolationIcon: v,
                        isSDF: !0,
                        hasHalo: W,
                        tile: r,
                        labelPlaneMatrixInv: $
                    };
                }, V = a.icon.segments.get().length, q = a.text.segments.get().length, Z = V && !n.onlyText ? G() : null, H = q && !n.onlyIcons ? j() : null, W = o.paint.get("icon-opacity").constantOr(1), $ = o.paint.get("text-opacity").constantOr(1);
                if (L && a.canOverlap) {
                    P = !0;
                    const t1 = W && !n.onlyText ? a.icon.segments.get() : [], i = $ && !n.onlyIcons ? a.text.segments.get() : [];
                    for (const i of t1)k.push({
                        segments: new e.b1([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: Z
                    });
                    for (const t1 of i)k.push({
                        segments: new e.b1([
                            t1
                        ]),
                        sortKey: t1.sortKey,
                        state: H
                    });
                } else n.onlyText || k.push({
                    segments: W ? a.icon.segments : new e.b1([]),
                    sortKey: 0,
                    state: Z
                }), n.onlyIcons || k.push({
                    segments: $ ? a.text.segments : new e.b1([]),
                    sortKey: 0,
                    state: H
                });
            }
            P && k.sort((e, t1)=>e.sortKey - t1.sortKey);
            for (const e of k){
                const i = e.state;
                if (i) {
                    if (t1.terrain ? t1.terrain.setupElevationDraw(i.tile, i.program, {
                        useDepthForOcclusion: S.depthOcclusionForSymbolsAndCircles,
                        labelPlaneMatrixInv: i.labelPlaneMatrixInv
                    }) : t1.setupDepthForOcclusion(S.depthOcclusionForSymbolsAndCircles, i.program), E.activeTexture.set(C.TEXTURE0), i.atlasTexture && i.atlasTexture.bind(i.atlasInterpolation, C.CLAMP_TO_EDGE, !0), i.atlasTextureIcon && (E.activeTexture.set(C.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, C.CLAMP_TO_EDGE, !0)), t1.uploadCommonLightUniforms(t1.context, i.program), i.hasHalo) {
                        const r = i.uniformValues;
                        r.u_is_halo = 1, ws(i.buffers, e.segments, o, t1, i.program, M, s, a, r, 2), r.u_is_halo = 0;
                    } else {
                        if (i.isSDF) {
                            const r = i.uniformValues;
                            i.hasHalo && (r.u_is_halo = 1, ws(i.buffers, e.segments, o, t1, i.program, M, s, a, r, 1)), r.u_is_halo = 0;
                        }
                        ws(i.buffers, e.segments, o, t1, i.program, M, s, a, i.uniformValues, 1);
                    }
                }
            }
        }
        function ws(e, t1, i, o, r, s, a, n, l, c) {
            const h = [
                e.dynamicLayoutVertexBuffer,
                e.opacityVertexBuffer,
                e.iconTransitioningVertexBuffer,
                e.globeExtVertexBuffer,
                e.zOffsetVertexBuffer
            ];
            r.draw(o, o.context.gl.TRIANGLES, s, a, n, Fi.disabled, l, i.id, e.layoutVertexBuffer, e.indexBuffer, t1, i.paint, o.transform.zoom, e.programConfigurations.get(i.id), h, c);
        }
        function Ts(e, t1, i, o, r, s, a) {
            const n = e.context.gl, l = i.paint.get("fill-pattern"), c = i.is3D(), h = c ? e.stencilModeFor3D() : Mi.disabled, u = l && l.constantOr(1);
            let d, _, p, m, f;
            a ? (_ = u && !i.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", d = n.LINES) : (_ = u ? "fillPattern" : "fill", d = n.TRIANGLES);
            for (const g of o){
                const o = t1.getTile(g);
                if (u && !o.patternsLoaded()) continue;
                const v = o.getBucket(i);
                if (!v) continue;
                e.prepareDrawTile();
                const x = v.programConfigurations.get(i.id), y = e.isTileAffectedByFog(g), b = e.getOrCreateProgram(_, {
                    config: x,
                    overrideFog: y
                });
                u && (e.context.activeTexture.set(n.TEXTURE0), o.imageAtlasTexture && o.imageAtlasTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), x.updatePaintBuffers());
                const w = l.constantOr(null);
                if (w && o.imageAtlas) {
                    const e = o.imageAtlas.patternPositions[w.toString()];
                    e && x.setConstantPatternPositions(e);
                }
                const T = e.translatePosMatrix(g.projMatrix, o, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor")), E = i.paint.get("fill-emissive-strength");
                if (a) {
                    m = v.indexBuffer2, f = v.segments2;
                    const t1 = e.terrain && e.terrain.renderingToTexture ? e.terrain.drapeBufferSize : [
                        n.drawingBufferWidth,
                        n.drawingBufferHeight
                    ];
                    p = "fillOutlinePattern" === _ && u ? Vr(T, E, e, o, t1) : jr(T, E, t1);
                } else m = v.indexBuffer, f = v.segments, p = u ? Gr(T, E, e, o) : Ur(T, E);
                e.uploadCommonUniforms(e.context, b, g.toUnwrapped()), b.draw(e, d, r, c ? h : e.stencilModeForClipping(g), s, Fi.disabled, p, i.id, v.layoutVertexBuffer, m, f, i.paint, e.transform.zoom, x, void 0);
            }
        }
        function Es(t1, i, o, r, s, a, n, l) {
            o.resetLayerRenderingStats(t1);
            const c = t1.context, h = c.gl, u = t1.transform, d = o.paint.get("fill-extrusion-pattern"), _ = d.constantOr(1), p = o.paint.get("fill-extrusion-opacity"), m = t1.style.enable3dLights(), f = o.paint.get(m && !_ ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), g = [
                o.paint.get("fill-extrusion-ambient-occlusion-intensity"),
                f
            ], v = o.layout.get("fill-extrusion-edge-radius"), x = v > 0 && !o.paint.get("fill-extrusion-rounded-roof"), y = x ? 0 : v, b = "globe" === u.projection.name ? e.c_() : 0, w = "globe" === u.projection.name, T = w ? e.a9(u.zoom) : 0, E = [
                e.am(u.center.lng),
                e.at(u.center.lat)
            ], C = o.paint.get("fill-extrusion-flood-light-color").toRenderColor(o.lut).toArray01().slice(0, 3), S = o.paint.get("fill-extrusion-flood-light-intensity"), I = o.paint.get("fill-extrusion-vertical-scale"), D = 0 !== o.paint.get("fill-extrusion-line-width").constantOr(1), R = Wi(t1, o.paint.get("fill-extrusion-cutoff-fade-range")), A = [];
            let L;
            w && A.push("PROJECTION_GLOBE_VIEW"), g[0] > 0 && A.push("FAUX_AO"), x && A.push("ZERO_ROOF_RADIUS"), l && A.push("HAS_CENTROID"), S > 0 && A.push("FLOOD_LIGHT"), R.shouldRenderCutoff && A.push("RENDER_CUTOFF"), D && A.push("RENDER_WALL_MODE");
            const P = "shadow" === t1.renderPass, M = t1.shadowRenderer, z = P && !!M;
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !0);
            let O = [
                0,
                0,
                0
            ];
            if (M) {
                const e = t1.style.directionalLight, i = t1.style.ambientLight;
                e && i && (O = eo(t1.style, e, i)), L = A.concat([
                    "SHADOWS_SINGLE_CASCADE"
                ]);
            }
            const F = z ? "fillExtrusionDepth" : _ ? "fillExtrusionPattern" : "fillExtrusion", k = o.getLayerRenderingStats();
            for (const e of r){
                const r = i.getTile(e), m = r.getBucket(o);
                if (!m || m.projection.name !== u.projection.name) continue;
                let f = !1;
                M && (f = 0 === M.getMaxCascadeForTile(e.toUnwrapped()));
                const v = t1.isTileAffectedByFog(e), x = m.programConfigurations.get(o.id), z = t1.getOrCreateProgram(F, {
                    config: x,
                    defines: f ? L : A,
                    overrideFog: v
                });
                if (t1.terrain && t1.terrain.setupElevationDraw(r, z, {
                    useMeterToDem: !0
                }), !m.centroidVertexBuffer) {
                    const e = z.attributes.a_centroid_pos;
                    void 0 !== e && h.vertexAttrib2f(e, 0, 0);
                }
                !P && M && M.setupShadows(r.tileID.toUnwrapped(), z, "vector-tile", r.tileID.overscaledZ), _ && (t1.context.activeTexture.set(h.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), x.updatePaintBuffers());
                const B = d.constantOr(null);
                if (B && r.imageAtlas) {
                    const e = r.imageAtlas.patternPositions[B.toString()];
                    e && x.setConstantPatternPositions(e);
                }
                const N = o.paint.get("fill-extrusion-vertical-gradient"), U = 1 / m.tileToMeter;
                let G;
                if (P && M) {
                    if (As(r.tileID, m, t1)) continue;
                    const e = M.calculateShadowPassMatrixFromTile(r.tileID.toUnwrapped());
                    G = Br(e, y, U, I);
                } else {
                    const i = t1.translatePosMatrix(e.expandedProjMatrix, r, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), s = u.projection.createInversionMatrix(u, e.canonical);
                    G = _ ? Nr(i, t1, N, p, g, y, U, e, r, b, T, E, s, C, I) : kr(i, t1, N, p, g, y, U, e, b, T, E, s, C, I, S, O);
                }
                t1.uploadCommonUniforms(c, z, e.toUnwrapped(), null, R);
                let j = m.segments;
                if ("mercator" === u.projection.name && !P && (j = m.getVisibleSegments(r.tileID, t1.terrain, t1.transform.getFrustum(0)), !j.get().length)) continue;
                if (k) {
                    if (P) for (const e of j.get())k.numRenderedVerticesInShadowPass += e.primitiveLength;
                    else for (const e of j.get())k.numRenderedVerticesInTransparentPass += e.primitiveLength;
                }
                const V = [];
                (t1.terrain || l) && V.push(m.centroidVertexBuffer), w && V.push(m.layoutVertexExtBuffer), D && V.push(m.wallVertexBuffer), z.draw(t1, c.gl.TRIANGLES, s, a, n, Fi.backCCW, G, o.id, m.layoutVertexBuffer, m.indexBuffer, j, o.paint, t1.transform.zoom, x, V);
            }
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !1);
        }
        function Cs(t1, i, o, r, s, a, n, l, c, h, u, d, _, p, m, f, g, v, x) {
            const y = t1.context, b = y.gl, w = t1.transform, T = t1.transform.zoom, E = [], C = Wi(t1, o.paint.get("fill-extrusion-cutoff-fade-range"));
            "clear" === h ? (E.push("CLEAR_SUBPASS"), x && (E.push("CLEAR_FROM_TEXTURE"), y.activeTexture.set(b.TEXTURE0), x.bind(b.LINEAR, b.CLAMP_TO_EDGE))) : "sdf" === h && E.push("SDF_SUBPASS"), g && E.push("HAS_CENTROID"), C.shouldRenderCutoff && E.push("RENDER_CUTOFF");
            const S = o.layout.get("fill-extrusion-edge-radius"), I = (e, i, r, h, v)=>{
                const b = i.programConfigurations.get(o.id), w = t1.isTileAffectedByFog(e), I = t1.getOrCreateProgram("fillExtrusionGroundEffect", {
                    config: b,
                    defines: E,
                    overrideFog: w
                }), D = ((e, t1, i, o, r, s, a, n, l, c, h)=>({
                        u_matrix: t1,
                        u_opacity: i,
                        u_ao_pass: o ? 1 : 0,
                        u_meter_to_tile: r,
                        u_ao: s,
                        u_flood_light_intensity: a,
                        u_flood_light_color: n,
                        u_attenuation: l,
                        u_edge_radius: c,
                        u_fb: 0,
                        u_fb_size: h,
                        u_dynamic_offset: 1
                    }))(0, h, u, c, v, [
                    d,
                    _ * v
                ], p, m, f, T >= 17 ? 0 : S * v, x ? x.size[0] : 0), R = [];
                g && R.push(i.hiddenByLandmarkVertexBuffer), t1.uploadCommonUniforms(y, I, e.toUnwrapped(), null, C), I.draw(t1, y.gl.TRIANGLES, s, a, n, l, D, o.id, i.vertexBuffer, i.indexBuffer, r, o.paint, T, b, R);
            };
            for (const s of r){
                const r = i.getTile(s), a = r.getBucket(o);
                if (!a || a.projection.name !== w.projection.name || !a.groundEffect || a.groundEffect && !a.groundEffect.hasData()) continue;
                const n = a.groundEffect, l = 1 / a.tileToMeter;
                {
                    const e = t1.translatePosMatrix(s.projMatrix, r, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), i = n.getDefaultSegment();
                    I(s, n, i, e, l);
                }
                if (v) for(let a = 0; a < 4; a++){
                    const n = e.c$[a](s), c = i.getTile(n);
                    if (!c) continue;
                    const h = c.getBucket(o);
                    if (!h || h.projection.name !== w.projection.name || !h.groundEffect || h.groundEffect && !h.groundEffect.hasData()) continue;
                    const u = h.groundEffect;
                    let d, _;
                    0 === a ? (d = [
                        -e.ab,
                        0,
                        0
                    ], _ = 1) : 1 === a ? (d = [
                        e.ab,
                        0,
                        0
                    ], _ = 0) : 2 === a ? (d = [
                        0,
                        -e.ab,
                        0
                    ], _ = 3) : (d = [
                        0,
                        e.ab,
                        0
                    ], _ = 2);
                    const p = u.regionSegments[_];
                    if (!p) continue;
                    const m = new Float32Array(16);
                    e.a6.mat4.translate(m, s.projMatrix, d), I(s, u, p, t1.translatePosMatrix(m, r, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), l);
                }
            }
        }
        function Ss(t1, i, o, r, s, a, n) {
            0 === r.centroidVertexArray.length && r.createCentroidsBuffer();
            const l = a ? a.findDEMTileFor(o) : null;
            if (!(l && l.dem || n)) return;
            const c = (t1)=>new e.P(Math.ceil((t1 + e.d2) * e.d3), 0), h = (e)=>{
                const t1 = i.getSource().minzoom, o = (e)=>{
                    const t1 = i.getTileByID(e);
                    if (t1 && t1.hasData()) return t1.getBucket(s);
                }, r = [
                    0,
                    -1,
                    1
                ];
                for (const i of r){
                    if (e.overscaledZ + i < t1) continue;
                    const r = o(e.calculateScaledKey(e.overscaledZ + i));
                    if (r) return r;
                }
            }, u = [
                0,
                0,
                0
            ], d = (t1, i)=>(u[0] = Math.min(t1.min.y, i.min.y), u[1] = Math.max(t1.max.y, i.max.y), u[2] = e.ab - i.min.x > t1.max.x ? i.min.x - e.ab : t1.max.x, u), _ = (t1, i)=>(u[0] = Math.min(t1.min.x, i.min.x), u[1] = Math.max(t1.max.x, i.max.x), u[2] = e.ab - i.min.y > t1.max.y ? i.min.y - e.ab : t1.max.y, u), p = [
                (e, t1)=>d(e, t1),
                (e, t1)=>d(t1, e),
                (e, t1)=>_(e, t1),
                (e, t1)=>_(t1, e)
            ], m = (t1, i, r, s, n, c, h)=>{
                if (!a) return 0;
                const u = [
                    [
                        c ? r : t1,
                        c ? t1 : r,
                        0
                    ],
                    [
                        c ? r : i,
                        c ? i : r,
                        0
                    ]
                ], d = h < 0 ? e.ab + h : h, _ = [
                    c ? d : (t1 + i) / 2,
                    c ? (t1 + i) / 2 : d,
                    0
                ];
                return 0 === r && h < 0 || 0 !== r && h > 0 ? a.getForTilePoints(n, [
                    _
                ], !0, s) : u.push(_), a.getForTilePoints(o, u, !0, l), Math.max(u[0][2], u[1][2], _[2]) / a.exaggeration();
            };
            for(let t1 = 0; t1 < 4; t1++){
                const i = r.borderFeatureIndices[t1];
                if (0 === i.length) continue;
                const s = e.c$[t1](o), l = h(s);
                if (!(l && l instanceof e.d0)) continue;
                if (r.borderDoneWithNeighborZ[t1] === l.canonical.z) continue;
                0 === l.centroidVertexArray.length && l.createCentroidsBuffer();
                const u = a ? a.findDEMTileFor(s) : null;
                if (!(u && u.dem || n)) continue;
                const d = (t1 < 2 ? 1 : 5) - t1, _ = l.borderDoneWithNeighborZ[d] !== r.canonical.z, v = l.borderFeatureIndices[d];
                let x = 0;
                if (r.canonical.z !== l.canonical.z) {
                    for (const e of i)r.showCentroid(r.featuresOnBorder[e]);
                    if (_) for (const e of v)l.showCentroid(l.featuresOnBorder[e]);
                    r.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[d] = r.canonical.z;
                }
                for (const o of i){
                    const i = r.featuresOnBorder[o], a = r.centroidData[i.centroidDataIndex], h = i.borders[t1];
                    let _;
                    for(; x < v.length;){
                        _ = l.featuresOnBorder[v[x]];
                        const e = _.borders[d];
                        if (e[1] > h[0] + 3 || e[0] > h[0] - 3) break;
                        l.showCentroid(_), x++;
                    }
                    if (_ && x < v.length) {
                        const o = x;
                        let y = 0;
                        for(; !(_.borders[d][0] > h[1] - 3) && (y++, ++x !== v.length);)_ = l.featuresOnBorder[v[x]];
                        _ = l.featuresOnBorder[v[o]];
                        let b = !1;
                        if (y >= 1) {
                            const e = _.borders[d];
                            Math.abs(h[0] - e[0]) < 3 && Math.abs(h[1] - e[1]) < 3 && (y = 1, b = !0, x = o + 1);
                        } else if (0 === y) {
                            r.showCentroid(i);
                            continue;
                        }
                        const w = l.centroidData[_.centroidDataIndex];
                        n && b && (((f = a).flags | (g = w).flags) & e.d1 ? (f.flags |= e.d1, g.flags |= e.d1) : (f.flags &= ~e.d1, g.flags &= ~e.d1));
                        const T = i.intersectsCount() > 1 || _.intersectsCount() > 1;
                        if (y > 1) x = o, a.centroidXY = w.centroidXY = new e.P(0, 0);
                        else if (u && u.dem && !T) {
                            const i = p[t1](a, w), o = t1 % 2 ? e.ab - 1 : 0, r = m(i[0], Math.min(e.ab - 1, i[1]), o, u, s, t1 < 2, i[2]);
                            a.centroidXY = w.centroidXY = c(r);
                        } else T ? a.centroidXY = w.centroidXY = new e.P(0, 0) : (a.centroidXY = r.encodeBorderCentroid(i), w.centroidXY = l.encodeBorderCentroid(_));
                        r.writeCentroidToBuffer(a), l.writeCentroidToBuffer(w);
                    } else r.showCentroid(i);
                }
                r.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[d] = r.canonical.z;
            }
            var f, g;
            (r.needsCentroidUpdate || !r.centroidVertexBuffer && 0 !== r.centroidVertexArray.length) && r.uploadCentroid(t1);
        }
        const Is = [
            1,
            0,
            0
        ], Ds = [
            0,
            1,
            0
        ], Rs = [
            0,
            0,
            1
        ];
        function As(t1, i, o) {
            const r = o.transform, s = o.shadowRenderer;
            if (!s) return !0;
            const a = t1.toUnwrapped(), n = r.tileSize * s._cascades[o.currentShadowCascade].scale;
            let l = i.maxHeight;
            if (r.elevation) {
                const e = r.elevation.getMinMaxForTile(t1);
                e && (l += e.max);
            }
            const c = [
                ...s.shadowDirection
            ];
            c[2] = -c[2];
            const h = s.computeSimplifiedTileShadowVolume(a, l, n, c);
            if (!h) return !1;
            const u = [
                Is,
                Ds,
                Rs,
                c,
                [
                    c[0],
                    0,
                    c[2]
                ],
                [
                    0,
                    c[1],
                    c[2]
                ]
            ], d = "globe" === r.projection.name, _ = r.scaleZoom(n), p = e.bN.fromInvProjectionMatrix(r.invProjMatrix, r.worldSize, _, !d), m = s.getCurrentCascadeFrustum();
            return 0 === p.intersectsPrecise(h.vertices, h.planes, u) || 0 === m.intersectsPrecise(h.vertices, h.planes, u);
        }
        function Ls(t1) {
            return [
                t1[0] * e.d4,
                t1[1] * e.d4,
                t1[2] * e.d4,
                0
            ];
        }
        function Ps(t1, i, o, r, s, a, n, l, c) {
            const h = r.getSource(), u = o.globeSharedBuffers;
            if (!u) return;
            let d, _, p;
            if (i && (d = r.getTile(i)), h instanceof e.aD ? (_ = h.texture, p = e.cD(0, 0, o.transform)) : d && i && (_ = d.texture, p = e.cD(i.canonical.z, i.canonical.x, o.transform)), !_ || !p) return;
            t1 || (p = e.a6.mat4.scale(e.a6.mat4.create(), p, [
                1,
                -1,
                1
            ]));
            const m = o.context, f = m.gl, g = "nearest" === s.paint.get("raster-resampling") ? f.NEAREST : f.LINEAR, v = o.colorModeForDrapableLayerRenderPass(a), x = n.defines;
            x.push("GLOBE_POLES");
            const y = new Li(f.LEQUAL, Li.ReadWrite, o.depthRangeFor3D), b = Float32Array.from(o.transform.expandedFarZProjMatrix), w = Float32Array.from(e.b5(e.cC(new e.bP(0, 0, 0))));
            o.terrain && o.terrain.prepareDrawTile(), m.activeTexture.set(f.TEXTURE0), _.bind(g, f.CLAMP_TO_EDGE), m.activeTexture.set(f.TEXTURE1), _.bind(g, f.CLAMP_TO_EDGE), _.useMipmap && m.extTextureFilterAnisotropic && o.transform.pitch > 20 && f.texParameterf(f.TEXTURE_2D, m.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, m.extTextureFilterAnisotropicMax);
            const [T, E, C, S] = i ? u.getPoleBuffers(i.canonical.z, !1) : u.getPoleBuffers(0, !0), I = s.paint.get("raster-elevation");
            let D;
            t1 ? (D = T, o.renderDefaultNorthPole = 0 !== I) : (D = E, o.renderDefaultSouthPole = 0 !== I);
            const R = Ls(n.mix), A = ((e, t1, i, o, r, s, a, n, l, c, h, u, d)=>Yr(e, t1, i, new Float32Array(16), new Float32Array(9), [
                    0,
                    0
                ], o, [
                    0,
                    0
                ], [
                    0,
                    0,
                    0,
                    0
                ], 1, {
                    opacity: 1,
                    mix: 0
                }, s, [
                    0,
                    0
                ], n, 2, c, h, u, 1, 0, d))(b, w, p, e.a9(o.transform.zoom), 0, s, 0, I, 0, R, n.offset, n.range, a), L = o.getOrCreateProgram("raster", {
                defines: x
            });
            o.uploadCommonUniforms(m, L, null), L.draw(o, f.TRIANGLES, y, c, v, l, A, s.id, D, C, S);
        }
        function Ms(e) {
            const t1 = e._nearZ, i = e.projection.farthestPixelDistance(e), o = i - t1, r = .2 * e.height, s = t1 + r;
            return [
                t1,
                i,
                (s - r - t1) / o,
                (s - t1) / o
            ];
        }
        function zs(e, t1, i, o) {
            if (e) return t1 instanceof Qe && e instanceof mt ? t1.getTextureDescriptor(e, i, !0) : {
                texture: e.texture,
                mix: Ls(o.mix),
                offset: o.offset,
                buffer: 0,
                tileSize: 1
            };
        }
        var Os = e.d5([
            {
                name: "a_index",
                type: "Int16",
                components: 1
            }
        ]);
        class Fs {
            constructor(t1, i, o, r){
                const s = {
                    width: o[0],
                    height: o[1],
                    data: null
                }, a = t1.gl;
                this.targetColorTexture = new e.T(t1, s, a.RGBA8, {
                    useMipmap: !1
                }), this.backgroundColorTexture = new e.T(t1, s, a.RGBA8, {
                    useMipmap: !1
                }), this.context = t1, this.updateParticleTexture(i, r), this.lastInvalidatedAt = 0;
            }
            updateParticleTexture(t1, i) {
                if (this.particleTextureDimension === i.width) return;
                (this.particleTexture0 || this.particleTexture1 || this.particleIndexBuffer || this.particleSegment) && (this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleIndexBuffer.destroy(), this.particleSegment.destroy());
                const o = this.context.gl, r = i.width * i.height;
                this.particleTexture0 = new e.T(this.context, i, o.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                }), this.particleTexture1 = new e.T(this.context, i, o.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                });
                const s = new e.d6;
                s.reserve(r);
                for(let e = 0; e < r; e++)s.emplaceBack(e);
                this.particleIndexBuffer = this.context.createVertexBuffer(s, Os.members, !0), this.particleSegment = e.b1.simpleSegment(0, 0, this.particleIndexBuffer.length, 0), this.particleTextureDimension = i.width;
            }
            update(t1) {
                return !(this.lastInvalidatedAt < t1 && (this.lastInvalidatedAt = e.q.now(), 1));
            }
            destroy() {
                this.targetColorTexture.destroy(), this.backgroundColorTexture.destroy(), this.particleIndexBuffer.destroy(), this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleSegment.destroy();
            }
        }
        function ks(t1, i, o) {
            if (!t1) return null;
            const r = i.getTextureDescriptor(t1, o, !0);
            if (!r) return null;
            let { texture: s, mix: a, offset: n, tileSize: l, buffer: c, format: h } = r;
            if (!s || !h) return null;
            let u = !1;
            return "uint32" === h && (u = !0, a[3] = 0, a = $r(e.d7, a, [
                0,
                o.paint.get("raster-particle-max-speed")
            ]), n = Xr(e.d7, n, [
                0,
                o.paint.get("raster-particle-max-speed")
            ])), {
                texture: s,
                textureOffset: [
                    c / (l + 2 * c),
                    l / (l + 2 * c)
                ],
                tileSize: l,
                scalarData: u,
                scale: a,
                offset: n,
                defines: [
                    "RASTER_ARRAY",
                    {
                        uint8: "DATA_FORMAT_UINT8",
                        uint16: "DATA_FORMAT_UINT16",
                        uint32: "DATA_FORMAT_UINT32"
                    }[h]
                ]
            };
        }
        function Bs(e) {
            const t1 = e._nearZ, i = e.projection.farthestPixelDistance(e), o = i - t1, r = .2 * e.height, s = t1 + r;
            return [
                t1,
                i,
                (s - r - t1) / o,
                (s - t1) / o
            ];
        }
        const Ns = new e.bz(1, 0, 0, 1), Us = new e.bz(0, 1, 0, 1), Gs = new e.bz(0, 0, 1, 1), js = new e.bz(1, 0, 1, 1), Vs = new e.bz(0, 1, 1, 1);
        function qs(t1, i, o, r, s, a, n) {
            const l = t1.context, c = t1.transform, h = l.gl, u = "globe" === c.projection.name, d = u ? [
                "PROJECTION_GLOBE_VIEW"
            ] : [];
            let _ = e.a6.mat4.clone(o.projMatrix);
            if (u && e.a9(c.zoom) > 0) {
                const t1 = e.b4(o.canonical, c), i = e.d8(t1);
                _ = e.a6.mat4.multiply(new Float32Array(16), c.globeMatrix, i), e.a6.mat4.multiply(_, c.projMatrix, _);
            }
            const p = e.a6.mat4.create();
            p[12] += 2 * s / (e.q.devicePixelRatio * c.width), p[13] += 2 * a / (e.q.devicePixelRatio * c.height), e.a6.mat4.multiply(_, p, _);
            const m = t1.getOrCreateProgram("debug", {
                defines: d
            }), f = i.getTileByID(o.key);
            t1.terrain && t1.terrain.setupElevationDraw(f, m);
            const g = Li.disabled, v = Mi.disabled, x = t1.colorModeForRenderPass(), y = "$debug";
            l.activeTexture.set(h.TEXTURE0), t1.emptyTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), u ? f._makeGlobeTileDebugBuffers(t1.context, c) : f._makeDebugTileBoundsBuffers(t1.context, c.projection);
            const b = f._tileDebugBuffer || t1.debugBuffer, w = f._tileDebugIndexBuffer || t1.debugIndexBuffer, T = f._tileDebugSegments || t1.debugSegments;
            if (m.draw(t1, h.LINE_STRIP, g, v, x, Fi.disabled, Zr(_, r), y, b, w, T, null, null, null, [
                f._globeTileDebugBorderBuffer
            ]), n) {
                const e = f.latestRawTileData, i = Math.floor((e && e.byteLength || 0) / 1024);
                let r = o.canonical.toString();
                o.overscaledZ !== o.canonical.z && (r += ` => ${o.overscaledZ}`), r += ` ${f.state}`, r += ` ${i}kb`, function(e, t1) {
                    e.initDebugOverlayCanvas();
                    const i = e.debugOverlayCanvas, o = e.context.gl, r = e.debugOverlayCanvas.getContext("2d");
                    r.clearRect(0, 0, i.width, i.height), r.shadowColor = "white", r.shadowBlur = 2, r.lineWidth = 1.5, r.strokeStyle = "white", r.textBaseline = "top", r.font = "bold 36px Open Sans, sans-serif", r.fillText(t1, 5, 5), r.strokeText(t1, 5, 5), e.debugOverlayTexture.update(i), e.debugOverlayTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
                }(t1, r);
            }
            const E = i.getTile(o).tileSize, C = 512 / Math.min(E, 512) * (o.overscaledZ / c.zoom) * .5, S = f._tileDebugTextBuffer || t1.debugBuffer, I = f._tileDebugTextIndexBuffer || t1.quadTriangleIndexBuffer, D = f._tileDebugTextSegments || t1.debugSegments;
            m.draw(t1, h.TRIANGLES, g, v, Ai.alphaBlended, Fi.disabled, Zr(_, e.bz.transparent, C), y, S, I, D, null, null, null, [
                f._globeTileDebugTextBuffer
            ]);
        }
        function Zs(e, t1, i, o) {
            Ws(e, 0, t1 + i / 2, e.transform.width, i, o);
        }
        function Hs(e, t1, i, o) {
            Ws(e, t1 - i / 2, 0, i, e.transform.height, o);
        }
        function Ws(t1, i, o, r, s, a) {
            const n = t1.context, l = n.gl;
            l.enable(l.SCISSOR_TEST), l.scissor(i * e.q.devicePixelRatio, o * e.q.devicePixelRatio, r * e.q.devicePixelRatio, s * e.q.devicePixelRatio), n.clear({
                color: a
            }), l.disable(l.SCISSOR_TEST);
        }
        const $s = e.d5([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), { members: Xs } = $s;
        function Ys(e, t1, i, o) {
            e.emplaceBack(t1, i, o);
        }
        class Ks {
            constructor(t1){
                this.vertexArray = new e.d9, this.indices = new e.aO, Ys(this.vertexArray, -1, -1, 1), Ys(this.vertexArray, 1, -1, 1), Ys(this.vertexArray, -1, 1, 1), Ys(this.vertexArray, 1, 1, 1), Ys(this.vertexArray, -1, -1, -1), Ys(this.vertexArray, 1, -1, -1), Ys(this.vertexArray, -1, 1, -1), Ys(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t1.createVertexBuffer(this.vertexArray, Xs), this.indexBuffer = t1.createIndexBuffer(this.indices), this.segment = e.b1.simpleSegment(0, 0, 36, 12);
            }
        }
        function Js(t1, i, o, r, s, a) {
            const n = t1.context.gl, l = i.paint.get("sky-atmosphere-color"), c = i.paint.get("sky-atmosphere-halo-color"), h = i.paint.get("sky-atmosphere-sun-intensity"), u = ((e, t1, i, o, r)=>({
                    u_matrix_3f: e,
                    u_sun_direction: t1,
                    u_sun_intensity: i,
                    u_color_tint_r: [
                        o.r,
                        o.g,
                        o.b,
                        o.a
                    ],
                    u_color_tint_m: [
                        r.r,
                        r.g,
                        r.b,
                        r.a
                    ],
                    u_luminance: 5e-5
                }))(e.a6.mat3.fromMat4(e.a6.mat3.create(), r), s, h, l, c);
            n.framebufferTexture2D(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.TEXTURE_CUBE_MAP_POSITIVE_X + a, i.skyboxTexture, 0), o.draw(t1, n.TRIANGLES, Li.disabled, Mi.disabled, Ai.unblended, Fi.frontCW, u, "skyboxCapture", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
        }
        const Qs = e.d5([
            {
                type: "Float32",
                name: "a_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]);
        class ea {
            constructor(t1){
                const i = new e.da;
                i.emplaceBack(-1, 1, 1, 0, 0), i.emplaceBack(1, 1, 1, 1, 0), i.emplaceBack(1, -1, 1, 1, 1), i.emplaceBack(-1, -1, 1, 0, 1);
                const o = new e.aO;
                o.emplaceBack(0, 1, 2), o.emplaceBack(2, 3, 0), this.vertexBuffer = t1.createVertexBuffer(i, Qs.members), this.indexBuffer = t1.createIndexBuffer(o), this.segments = e.b1.simpleSegment(0, 0, 4, 2);
            }
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
            }
        }
        const ta = e.d5([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_size_scale",
                components: 1
            },
            {
                type: "Float32",
                name: "a_fade_opacity",
                components: 1
            }
        ]);
        class ia {
            constructor(){
                this.starsCount = 16e3, this.sizeMultiplier = .15, this.sizeRange = 100, this.intensityRange = 200;
            }
        }
        class oa {
            constructor(t1){
                this.colorModeAlphaBlendedWriteRGB = new Ai([
                    1,
                    Ri,
                    1,
                    Ri
                ], e.bz.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ]), this.colorModeWriteAlpha = new Ai([
                    1,
                    0,
                    1,
                    0
                ], e.bz.transparent, [
                    !1,
                    !1,
                    !1,
                    !0
                ]), this.params = new ia, this.updateNeeded = !0, t1.tp.registerParameter(this.params, [
                    "Stars"
                ], "starsCount", {
                    min: 100,
                    max: 16e3,
                    step: 1
                }, ()=>{
                    this.updateNeeded = !0;
                }), t1.tp.registerParameter(this.params, [
                    "Stars"
                ], "sizeMultiplier", {
                    min: .01,
                    max: 2,
                    step: .01
                }), t1.tp.registerParameter(this.params, [
                    "Stars"
                ], "sizeRange", {
                    min: 0,
                    max: 200,
                    step: 1
                }, ()=>{
                    this.updateNeeded = !0;
                }), t1.tp.registerParameter(this.params, [
                    "Stars"
                ], "intensityRange", {
                    min: 0,
                    max: 200,
                    step: 1
                }, ()=>{
                    this.updateNeeded = !0;
                });
            }
            update(t1) {
                const i = t1.context;
                if (!this.atmosphereBuffer || this.updateNeeded) {
                    this.updateNeeded = !1, this.atmosphereBuffer = new ea(i);
                    const t1 = this.params.sizeRange, o = this.params.intensityRange, r = function(t1) {
                        const i = e.dd(30), o = [];
                        for(let r = 0; r < t1; ++r){
                            const t1 = 2 * Math.PI * i(), r = Math.acos(1 - 2 * i()) - .5 * Math.PI;
                            o.push(e.a6.vec3.fromValues(Math.cos(r) * Math.cos(t1), Math.cos(r) * Math.sin(t1), Math.sin(r)));
                        }
                        return o;
                    }(this.params.starsCount), s = e.dd(300), a = new e.db, n = new e.aO;
                    let l = 0;
                    for(let i = 0; i < r.length; ++i){
                        const c = e.a6.vec3.scale([], r[i], 200), h = Math.max(0, 1 + .01 * t1 * (1 * s() - .5)), u = Math.max(0, 1 + .01 * o * (1 * s() - .5));
                        a.emplaceBack(c[0], c[1], c[2], -1, -1, h, u), a.emplaceBack(c[0], c[1], c[2], 1, -1, h, u), a.emplaceBack(c[0], c[1], c[2], 1, 1, h, u), a.emplaceBack(c[0], c[1], c[2], -1, 1, h, u), n.emplaceBack(l + 0, l + 1, l + 2), n.emplaceBack(l + 0, l + 2, l + 3), l += 4;
                    }
                    this.starsVx = i.createVertexBuffer(a, ta.members), this.starsIdx = i.createIndexBuffer(n), this.starsSegments = e.b1.simpleSegment(0, 0, a.length, n.length);
                }
            }
            destroy() {
                this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy();
            }
            drawAtmosphereGlow(t1, i) {
                const o = t1.context, r = o.gl, s = t1.transform, a = new Li(r.LEQUAL, Li.ReadOnly, [
                    0,
                    1
                ]), n = e.a9(s.zoom), l = t1.style.getLut(i.scope), c = i.properties.get("color").toRenderColor(l).toArray01(), h = i.properties.get("high-color").toRenderColor(l).toArray01(), u = i.properties.get("space-color").toRenderColor(l).toArray01PremultipliedAlpha(), d = 5e-4, _ = e.dc(i.properties.get("horizon-blend"), 0, 1, d, .25), p = e.cx(t1, o, s) && _ === d ? s.worldSize / (2 * Math.PI * 1.025) - 1 : s.globeRadius, m = t1.frameCounter / 1e3 % 1, f = e.a6.vec3.length(s.globeCenterInViewSpace), g = Math.sqrt(Math.pow(f, 2) - Math.pow(p, 2)), v = Math.acos(g / f), x = (e)=>{
                    const i = "globe" === s.projection.name ? [
                        "PROJECTION_GLOBE_VIEW",
                        "FOG"
                    ] : [
                        "FOG"
                    ];
                    e && i.push("ALPHA_PASS");
                    const l = t1.getOrCreateProgram("globeAtmosphere", {
                        defines: i
                    }), d = ((e, t1, i, o, r, s, a, n, l, c, h, u)=>({
                            u_frustum_tl: e,
                            u_frustum_tr: t1,
                            u_frustum_br: i,
                            u_frustum_bl: o,
                            u_horizon: r,
                            u_transition: s,
                            u_fadeout_range: a,
                            u_color: n,
                            u_high_color: l,
                            u_space_color: c,
                            u_temporal_offset: h,
                            u_horizon_angle: u
                        }))(s.frustumCorners.TL, s.frustumCorners.TR, s.frustumCorners.BR, s.frustumCorners.BL, s.frustumCorners.horizon, n, _, c, h, u, m, v);
                    t1.uploadCommonUniforms(o, l);
                    const p = this.atmosphereBuffer;
                    p && l.draw(t1, r.TRIANGLES, a, Mi.disabled, e ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, Fi.backCW, d, e ? "atmosphere_glow_alpha" : "atmosphere_glow", p.vertexBuffer, p.indexBuffer, p.segments);
                };
                x(!1), x(!0);
            }
            drawStars(t1, i) {
                const o = e.ap(i.properties.get("star-intensity"), 0, 1);
                if (0 === o) return;
                const r = t1.context, s = r.gl, a = t1.transform, n = t1.getOrCreateProgram("stars"), l = e.a6.quat.identity([]);
                e.a6.quat.rotateX(l, l, -a._pitch), e.a6.quat.rotateZ(l, l, -a.angle), e.a6.quat.rotateX(l, l, e.bB(a._center.lat)), e.a6.quat.rotateY(l, l, -e.bB(a._center.lng));
                const c = e.a6.mat4.fromQuat(new Float32Array(16), l), h = e.a6.mat4.multiply([], a.starsProjMatrix, c), u = e.a6.mat3.fromMat4([], c), d = e.a6.mat3.invert([], u), _ = [
                    0,
                    1,
                    0
                ];
                e.a6.vec3.transformMat3(_, _, d), e.a6.vec3.scale(_, _, this.params.sizeMultiplier);
                const p = [
                    1,
                    0,
                    0
                ];
                e.a6.vec3.transformMat3(p, p, d), e.a6.vec3.scale(p, p, this.params.sizeMultiplier);
                const m = (f = _, g = p, v = o, {
                    u_matrix: Float32Array.from(h),
                    u_up: f,
                    u_right: g,
                    u_intensity_multiplier: v
                });
                var f, g, v;
                t1.uploadCommonUniforms(r, n), this.starsVx && this.starsIdx && n.draw(t1, s.TRIANGLES, Li.disabled, Mi.disabled, this.colorModeAlphaBlendedWriteRGB, Fi.disabled, m, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
            }
        }
        function ra(t1, i) {
            const o = [
                ...t1
            ], r = i.cameraWorldSizeForFog / i.worldSize, s = e.a6.mat4.identity([]);
            return e.a6.mat4.scale(s, s, [
                r,
                r,
                1
            ]), e.a6.mat4.multiply(o, s, o), e.a6.mat4.multiply(o, i.worldToFogMatrix, o), o;
        }
        function sa(t1, i, o, r, s) {
            const a = o.material, n = r.context, { baseColorTexture: l, metallicRoughnessTexture: c } = a.pbrMetallicRoughness, { normalTexture: h, occlusionTexture: u, emissionTexture: d } = a;
            function _(e, i, o) {
                if (e && (t1.push(i), n.activeTexture.set(n.gl.TEXTURE0 + o), e.gfxTexture)) {
                    const { minFilter: t1, magFilter: i, wrapS: o, wrapT: r } = e.sampler;
                    e.gfxTexture.bindExtraParam(t1, i, o, r);
                }
            }
            _(l, "HAS_TEXTURE_u_baseColorTexture", ji.BaseColor), _(c, "HAS_TEXTURE_u_metallicRoughnessTexture", ji.MetallicRoughness), _(h, "HAS_TEXTURE_u_normalTexture", ji.Normal), _(u, "HAS_TEXTURE_u_occlusionTexture", ji.Occlusion), _(d, "HAS_TEXTURE_u_emissionTexture", ji.Emission), s && (s.texture || (s.texture = new e.df(r.context, s.image, [
                s.image.height,
                s.image.height,
                s.image.height
            ], n.gl.RGBA8)), n.activeTexture.set(n.gl.TEXTURE0 + ji.LUT), s.texture && s.texture.bind(n.gl.LINEAR, n.gl.CLAMP_TO_EDGE), t1.push("APPLY_LUT_ON_GPU")), o.texcoordBuffer && (t1.push("HAS_ATTRIBUTE_a_uv_2f"), i.push(o.texcoordBuffer)), o.colorBuffer && (t1.push(12 === o.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), i.push(o.colorBuffer)), o.normalBuffer && (t1.push("HAS_ATTRIBUTE_a_normal_3f"), i.push(o.normalBuffer)), o.pbrBuffer && (t1.push("HAS_ATTRIBUTE_a_pbr"), t1.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), i.push(o.pbrBuffer)), "OPAQUE" !== a.alphaMode && "MASK" !== a.alphaMode || t1.push("UNPREMULT_TEXTURE_IN_SHADER"), a.defined || t1.push("DIFFUSE_SHADED"), t1.push("USE_STANDARD_DERIVATIVES");
        }
        function aa(t1, i, o, r, s, a) {
            const n = o.paint.get("model-opacity"), l = i.context, c = new Li(i.context.gl.LEQUAL, Li.ReadWrite, i.depthRangeFor3D), h = i.transform, u = t1.mesh, d = u.material, _ = d.pbrMetallicRoughness, p = i.style.fog;
            let m;
            m = "pixels" === i.transform.projection.zAxisUnit ? [
                ...t1.nodeModelMatrix
            ] : e.a6.mat4.multiply([], r.zScaleMatrix, t1.nodeModelMatrix), e.a6.mat4.multiply(m, r.negCameraPosMatrix, m);
            const f = e.a6.mat4.invert([], m);
            e.a6.mat4.transpose(f, f);
            const g = o.paint.get("model-emissive-strength").constantOr(0), v = ns(new Float32Array(t1.worldViewProjection), new Float32Array(m), new Float32Array(f), null, i, n, _.baseColorFactor.toRenderColor(null), d.emissiveFactor, _.metallicFactor, _.roughnessFactor, d, g, o), x = {
                defines: []
            }, y = [];
            sa(x.defines, y, u, i, o.lut);
            const b = i.shadowRenderer;
            b && (b.useNormalOffset = !1);
            let w = null;
            if (p) {
                const e = ra(t1.nodeModelMatrix, i.transform);
                if (w = new Float32Array(e), "globe" !== h.projection.name) {
                    const t1 = u.aabb.min, i = u.aabb.max, [o, r] = p.getOpacityForBounds(e, t1[0], t1[1], i[0], i[1]);
                    x.overrideFog = o >= Oe || r >= Oe;
                }
            }
            const T = Wi(i, o.paint.get("model-cutoff-fade-range"));
            T.shouldRenderCutoff && x.defines.push("RENDER_CUTOFF");
            const E = i.getOrCreateProgram("model", x);
            i.uploadCommonUniforms(l, E, null, w, T), "shadow" !== i.renderPass && b && b.setupShadowsFromMatrix(t1.nodeModelMatrix, E), E.draw(i, l.gl.TRIANGLES, c, s, a, u.material.doubleSided ? Fi.disabled : Fi.backCCW, v, o.id, u.vertexBuffer, u.indexBuffer, u.segments, o.paint, i.transform.zoom, void 0, y);
        }
        function na(t1, i, o, r, s, a, n) {
            let l;
            l = "globe" === t1.projection.name ? e.dg(o, t1) : [
                ...o
            ], e.a6.mat4.multiply(l, l, i.matrix);
            const c = e.a6.mat4.multiply([], r, l);
            if (i.meshes) for (const t1 of i.meshes){
                if ("BLEND" !== t1.material.alphaMode) {
                    n.push({
                        mesh: t1,
                        depth: 0,
                        modelIndex: s,
                        worldViewProjection: c,
                        nodeModelMatrix: l
                    });
                    continue;
                }
                const i = e.a6.vec3.transformMat4([], t1.centroid, c);
                i[2] > 0 && a.push({
                    mesh: t1,
                    depth: i[2],
                    modelIndex: s,
                    worldViewProjection: c,
                    nodeModelMatrix: l
                });
            }
            if (i.children) for (const e of i.children)na(t1, e, o, r, s, a, n);
        }
        function la(e, t1, i, o) {
            const r = i.shadowRenderer;
            if (!r) return;
            const s = r.getShadowPassDepthMode(), a = r.getShadowPassColorMode(), n = r.calculateShadowPassMatrixFromMatrix(t1), l = ls(n);
            i.getOrCreateProgram("modelDepth", {
                defines: i._shadowMapDebug ? [] : [
                    "DEPTH_TEXTURE"
                ]
            }).draw(i, i.context.gl.TRIANGLES, s, Mi.disabled, a, Fi.backCCW, l, o.id, e.vertexBuffer, e.indexBuffer, e.segments, o.paint, i.transform.zoom, void 0, void 0);
        }
        function ca(t1, i, o) {
            const r = i.updateZoomBasedPaintProperties(), s = function(t1, i, o) {
                let r, s, a, n = t1.terrain ? t1.terrain.exaggeration() : 0;
                if (t1.terrain && n > 0) {
                    const i = t1.terrain, s = i.findDEMTileFor(o);
                    s && s.dem ? r = e.di.create(i, o, s) : n = 0;
                }
                if (0 === n && (i.terrainElevationMin = 0, i.terrainElevationMax = 0), n === i.validForExaggeration && (0 === n || r && r._demTile && r._demTile.tileID === i.validForDEMTile.id && r._dem._timestamp === i.validForDEMTile.timestamp)) return !1;
                for(const e in i.instancesPerModel){
                    const t1 = i.instancesPerModel[e];
                    for(let e = 0; e < t1.instancedDataArray.length; ++e){
                        const o = (r ? n * r.getElevationAt(0 | t1.instancedDataArray.float32[16 * e], 0 | t1.instancedDataArray.float32[16 * e + 1], !0, !0) : 0) + t1.instancesEvaluatedElevation[e];
                        t1.instancedDataArray.float32[16 * e + 6] = o, s = s ? Math.min(i.terrainElevationMin, o) : o, a = a ? Math.max(i.terrainElevationMax, o) : o;
                    }
                }
                return i.terrainElevationMin = s || 0, i.terrainElevationMax = a || 0, i.validForExaggeration = n, i.validForDEMTile = r && r._demTile ? {
                    id: r._demTile.tileID,
                    timestamp: r._dem._timestamp
                } : {
                    id: void 0,
                    timestamp: 0
                }, !0;
            }(t1, i, o);
            (r || s) && (i.uploaded = !1, i.upload(t1.context));
        }
        const ha = {
            shadowUniformsInitialized: !1,
            useSingleShadowCascade: !1,
            tileMatrix: new Float64Array(16),
            shadowTileMatrix: new Float32Array(16),
            aabb: new e.c9([
                0,
                0,
                0
            ], [
                e.ab,
                e.ab,
                0
            ])
        };
        function ua(t1, i) {
            const o = 1 << t1.canonical.z, r = i.getFreeCameraOptions().position, s = i.elevation, a = t1.canonical.x / o, n = (t1.canonical.x + 1) / o, l = t1.canonical.y / o, c = (t1.canonical.y + 1) / o;
            let h = i._centerAltitude;
            if (s) {
                const e = s.getMinMaxForTile(t1);
                e && e.max > h && (h = e.max);
            }
            const u = e.ap(r.x, a, n) - r.x, d = e.ap(r.y, l, c) - r.y, _ = e.bD(h, i.center.lat) - r.z;
            return i._zoomFromMercatorZ(Math.sqrt(u * u + d * d + _ * _));
        }
        function da(e, t1, i, o, r, s, a) {
            const n = e.context, l = "shadow" === e.renderPass, c = e.shadowRenderer, h = l && c ? c.getShadowPassDepthMode() : new Li(n.gl.LEQUAL, Li.ReadWrite, e.depthRangeFor3D), u = e.isTileAffectedByFog(s);
            if (i.meshes) for (const d of i.meshes){
                const _ = [
                    "MODEL_POSITION_ON_GPU"
                ], p = [];
                let m, f, g;
                o.instancedDataArray.length > 20 && _.push("INSTANCED_ARRAYS");
                const v = Wi(e, t1.paint.get("model-cutoff-fade-range"));
                if (v.shouldRenderCutoff && _.push("RENDER_CUTOFF"), l && c) m = e.getOrCreateProgram("modelDepth", {
                    defines: _
                }), f = ls(a.shadowTileMatrix, a.shadowTileMatrix, Float32Array.from(i.matrix)), g = c.getShadowPassColorMode();
                else {
                    sa(_, p, d, e, t1.lut), m = e.getOrCreateProgram("model", {
                        defines: _,
                        overrideFog: u
                    });
                    const o = d.material, l = o.pbrMetallicRoughness, h = t1.paint.get("model-opacity"), x = t1.paint.get("model-emissive-strength").constantOr(0);
                    f = ns(s.expandedProjMatrix, Float32Array.from(i.matrix), new Float32Array(16), null, e, h, l.baseColorFactor.toRenderColor(null), o.emissiveFactor, l.metallicFactor, l.roughnessFactor, o, x, t1, r), c && (a.shadowUniformsInitialized ? m.setShadowUniformValues(n, c.getShadowUniformValues()) : (c.setupShadows(s.toUnwrapped(), m, "model-tile", s.overscaledZ), a.shadowUniformsInitialized = !0)), g = v.shouldRenderCutoff || h < 1 || "OPAQUE" !== o.alphaMode ? Ai.alphaBlended : Ai.unblended;
                }
                e.uploadCommonUniforms(n, m, s.toUnwrapped(), null, v);
                const x = d.material.doubleSided ? Fi.disabled : Fi.backCCW;
                if (o.instancedDataArray.length > 20) p.push(o.instancedDataBuffer), m.draw(e, n.gl.TRIANGLES, h, Mi.disabled, g, x, f, t1.id, d.vertexBuffer, d.indexBuffer, d.segments, t1.paint, e.transform.zoom, void 0, p, o.instancedDataArray.length);
                else {
                    const i = l ? "u_instance" : "u_normal_matrix";
                    for(let r = 0; r < o.instancedDataArray.length; ++r)f[i] = new Float32Array(o.instancedDataArray.arrayBuffer, 64 * r, 16), m.draw(e, n.gl.TRIANGLES, h, Mi.disabled, g, x, f, t1.id, d.vertexBuffer, d.indexBuffer, d.segments, t1.paint, e.transform.zoom, void 0, p);
                }
            }
            if (i.children) for (const n of i.children)da(e, t1, n, o, r, s, a);
        }
        const _a = [
            1,
            -1,
            1
        ];
        function pa(t1, i, o, r) {
            if (!o.modelManager) return !0;
            const s = o.modelManager;
            if (!o.shadowRenderer) return !0;
            const a = o.shadowRenderer, n = i.aabb;
            let l = !0, c = t1.maxHeight;
            if (0 === c) {
                let e = 0;
                for(const i in t1.instancesPerModel){
                    const t1 = s.getModel(i, r);
                    t1 ? e = Math.max(e, Math.max(Math.max(t1.aabb.max[0], t1.aabb.max[1]), t1.aabb.max[2])) : l = !1;
                }
                c = t1.maxScale * e * 1.41 + t1.maxVerticalOffset, l && (t1.maxHeight = c);
            }
            n.max[2] = c, n.min[2] += t1.terrainElevationMin, n.max[2] += t1.terrainElevationMax, e.a6.vec3.transformMat4(n.min, n.min, i.tileMatrix), e.a6.vec3.transformMat4(n.max, n.max, i.tileMatrix);
            const h = n.intersects(a.getCurrentCascadeFrustum());
            return 0 === o.currentShadowCascade && (t1.isInsideFirstShadowMapFrustum = 2 === h), 0 === h;
        }
        function ma(t1, i) {
            const o = t1.uniformValues.u_cutoff_params[0], r = t1.uniformValues.u_cutoff_params[1], s = t1.uniformValues.u_cutoff_params[2], a = t1.uniformValues.u_cutoff_params[3];
            return r === o || a === s ? 1 : e.ap(((i - o) / (r - o) - s) / (a - s), 0, 1);
        }
        function fa(t1, i, o, r) {
            if (i.pitch < 20) return 1;
            const s = i.getWorldToCameraMatrix();
            e.a6.mat4.multiply(s, s, t1);
            const a = e.a6.vec4.fromValues(o.min[0], o.min[1], o.min[2], 1);
            let n = e.a6.vec4.transformMat4(e.a6.vec4.create(), a, s), l = n, c = n;
            a[1] = o.max[1], n = e.a6.vec4.transformMat4(e.a6.vec4.create(), a, s), l = n[1] < l[1] ? n : l, c = n[1] > c[1] ? n : c, a[0] = o.max[0], n = e.a6.vec4.transformMat4(e.a6.vec4.create(), a, s), l = n[1] < l[1] ? n : l, c = n[1] > c[1] ? n : c, a[1] = o.min[1], n = e.a6.vec4.transformMat4(e.a6.vec4.create(), a, s), l = n[1] < l[1] ? n : l, c = n[1] > c[1] ? n : c;
            const h = e.ap(r[0], 0, 1), u = 100 * i.pixelsPerMeter * e.ap(r[1], 0, 1), d = e.ap(r[2], 0, 1), _ = e.a6.vec4.lerp(e.a6.vec4.create(), l, c, h), p = Math.tan(.5 * i.fovX), m = -_[2] * p;
            if (0 === u) return _[1] < -Math.abs(m) ? d : 1;
            const f = (-Math.abs(m) - _[1]) / u, g = (e, t1, i)=>(1 - i) * e + i * t1, v = e.ap(g(1, d, f), d, 1);
            return g(1, v, e.ap((i.pitch - 20) / 20, 0, 1));
        }
        class ga {
        }
        class va {
            constructor(){
                this._storage = new Map;
            }
            getLinesFromTrianglesBuffer(t1, i, o) {
                {
                    const e = this._storage.get(i.id);
                    if (e) return e.lastUsedFrameIdx = t1, e.buf;
                }
                const r = o.gl, s = r.getBufferParameter(r.ELEMENT_ARRAY_BUFFER, r.BUFFER_SIZE), a = new ArrayBuffer(s), n = new Int16Array(a);
                r.getBufferSubData(r.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(a));
                const l = new e.dk;
                for(let e = 0; e < s / 2; e += 3){
                    const t1 = n[e], i = n[e + 1], o = n[e + 2];
                    l.emplaceBack(t1, i), l.emplaceBack(i, o), l.emplaceBack(o, t1);
                }
                const c = o.bindVertexArrayOES.current, h = new ga;
                return h.buf = new hs(o, l), h.lastUsedFrameIdx = t1, this._storage.set(i.id, h), o.bindVertexArrayOES.set(c), h.buf;
            }
            update(e) {
                for (const [t1, i] of this._storage)e - i.lastUsedFrameIdx > 30 && (i.buf.destroy(), this._storage.delete(t1));
            }
            destroy() {
                for (const [e, t1] of this._storage)t1.buf.destroy(), this._storage.delete(e);
            }
        }
        class xa {
            constructor(e){
                this.occluderSize = 30, this.depthOffset = -0.0001, e.registerParameter(this, [
                    "Occlusion"
                ], "occluderSize", {
                    min: 1,
                    max: 100,
                    step: 1
                }), e.registerParameter(this, [
                    "Occlusion"
                ], "depthOffset", {
                    min: -0.05,
                    max: 0,
                    step: 1e-5
                });
            }
        }
        const ya = {
            symbol: function(t1, i, o, r, s) {
                if ("translucent" !== t1.renderPass) return;
                const a = Mi.disabled, n = t1.colorModeForRenderPass();
                o.layout.get("text-variable-anchor") && function(t1, i, o, r, s, a, n) {
                    const l = i.transform, c = "map" === s, h = "map" === a;
                    for (const i of t1){
                        const t1 = r.getTile(i), s = t1.getBucket(o);
                        if (!s || !s.text || !s.text.segments.get().length) continue;
                        const a = e.bj(s.textSizeData, l.zoom), u = ii(i, s.getProjection(), l), d = l.calculatePixelsToTileUnitsMatrix(t1), _ = kt(u, t1.tileID.canonical, h, c, l, s.getProjection(), d), p = s.hasIconTextFit() && s.hasIconData();
                        if (a) {
                            const o = Math.pow(2, l.zoom - t1.tileID.overscaledZ);
                            ys(s, c, h, n, e.cS, l, _, i, o, a, p);
                        }
                    }
                }(r, t1, o, i, o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), s);
                const l = 0 !== o.paint.get("icon-opacity").constantOr(1), c = 0 !== o.paint.get("text-opacity").constantOr(1);
                void 0 !== o.layout.get("symbol-sort-key").constantOr(1) && (l || c) ? bs(t1, i, o, r, a, n) : (l && bs(t1, i, o, r, a, n, {
                    onlyIcons: !0
                }), c && bs(t1, i, o, r, a, n, {
                    onlyText: !0
                })), i.map.showCollisionBoxes && (fs(t1, i, o, r, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), !0), fs(t1, i, o, r, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(t1, i, o, r) {
                if ("translucent" !== t1.renderPass) return;
                const s = o.paint.get("circle-opacity"), a = o.paint.get("circle-stroke-width"), n = o.paint.get("circle-stroke-opacity"), l = void 0 !== o.layout.get("circle-sort-key").constantOr(1), c = o.paint.get("circle-emissive-strength");
                if (0 === s.constantOr(1) && (0 === a.constantOr(1) || 0 === n.constantOr(1))) return;
                const h = t1.context, u = h.gl, d = t1.transform, _ = t1.depthModeForSublayer(0, Li.ReadOnly), p = Mi.disabled, m = t1.colorModeForDrapableLayerRenderPass(c), f = "globe" === d.projection.name, g = [
                    e.am(d.center.lng),
                    e.at(d.center.lat)
                ], v = [];
                for(let s = 0; s < r.length; s++){
                    const a = r[s], n = i.getTile(a), c = n.getBucket(o);
                    if (!c || c.projection.name !== d.projection.name) continue;
                    const h = c.programConfigurations.get(o.id), u = e.cT(o), _ = t1.isTileAffectedByFog(a);
                    f && u.push("PROJECTION_GLOBE_VIEW"), u.push("DEPTH_D24"), t1.terrain && d.depthOcclusionForSymbolsAndCircles && u.push("DEPTH_OCCLUSION");
                    const p = t1.getOrCreateProgram("circle", {
                        config: h,
                        defines: u,
                        overrideFog: _
                    }), m = c.layoutVertexBuffer, x = c.globeExtVertexBuffer, y = c.indexBuffer, b = d.projection.createInversionMatrix(d, a.canonical), w = {
                        programConfiguration: h,
                        program: p,
                        layoutVertexBuffer: m,
                        globeExtVertexBuffer: x,
                        indexBuffer: y,
                        uniformValues: e.cU(t1, a, n, b, g, o),
                        tile: n
                    };
                    if (l) {
                        const t1 = c.segments.get();
                        for (const i of t1)v.push({
                            segments: new e.b1([
                                i
                            ]),
                            sortKey: i.sortKey,
                            state: w
                        });
                    } else v.push({
                        segments: c.segments,
                        sortKey: 0,
                        state: w
                    });
                }
                l && v.sort((e, t1)=>e.sortKey - t1.sortKey);
                const x = {
                    useDepthForOcclusion: d.depthOcclusionForSymbolsAndCircles
                };
                for (const e of v){
                    const { programConfiguration: i, program: r, layoutVertexBuffer: s, globeExtVertexBuffer: a, indexBuffer: n, uniformValues: l, tile: c } = e.state, f = e.segments;
                    t1.terrain && t1.terrain.setupElevationDraw(c, r, x), t1.uploadCommonUniforms(h, r, c.tileID.toUnwrapped()), r.draw(t1, u.TRIANGLES, _, p, m, Fi.disabled, l, o.id, s, n, f, o.paint, d.zoom, i, [
                        a
                    ]);
                }
            },
            heatmap: function(t1, i, o, r) {
                if (0 !== o.paint.get("heatmap-opacity")) {
                    if ("offscreen" === t1.renderPass) {
                        const s = t1.context, a = s.gl, n = Mi.disabled, l = new Ai([
                            a.ONE,
                            a.ONE,
                            a.ONE,
                            a.ONE
                        ], e.bz.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        !function(e, t1, i, o) {
                            const r = e.gl, s = t1.width * o, a = t1.height * o;
                            e.activeTexture.set(r.TEXTURE1), e.viewport.set([
                                0,
                                0,
                                s,
                                a
                            ]);
                            let n = i.heatmapFbo;
                            if (!n || n && (n.width !== s || n.height !== a)) {
                                n && n.destroy();
                                const t1 = r.createTexture();
                                r.bindTexture(r.TEXTURE_2D, t1), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), n = i.heatmapFbo = e.createFramebuffer(s, a, !0, null), function(e, t1, i, o, r, s) {
                                    const a = e.gl;
                                    a.texImage2D(a.TEXTURE_2D, 0, e.extRenderToTextureHalfFloat ? a.RGBA16F : a.RGBA, r, s, 0, a.RGBA, e.extRenderToTextureHalfFloat ? a.HALF_FLOAT : a.UNSIGNED_BYTE, null), o.colorAttachment.set(i);
                                }(e, 0, t1, n, s, a);
                            } else r.bindTexture(r.TEXTURE_2D, n.colorAttachment.get()), e.bindFramebuffer.set(n.framebuffer);
                        }(s, t1, o, "globe" === t1.transform.projection.name ? .5 : .25), s.clear({
                            color: e.bz.transparent
                        });
                        const c = t1.transform, h = "globe" === c.projection.name, u = h ? [
                            "PROJECTION_GLOBE_VIEW"
                        ] : [], d = h ? Fi.frontCCW : Fi.disabled, _ = [
                            e.am(c.center.lng),
                            e.at(c.center.lat)
                        ];
                        for(let e = 0; e < r.length; e++){
                            const p = r[e];
                            if (i.hasRenderableParent(p)) continue;
                            const m = i.getTile(p), f = m.getBucket(o);
                            if (!f || f.projection.name !== c.projection.name) continue;
                            const g = t1.isTileAffectedByFog(p), v = f.programConfigurations.get(o.id), x = t1.getOrCreateProgram("heatmap", {
                                config: v,
                                defines: u,
                                overrideFog: g
                            }), { zoom: y } = t1.transform;
                            t1.terrain && t1.terrain.setupElevationDraw(m, x), t1.uploadCommonUniforms(s, x, p.toUnwrapped());
                            const b = c.projection.createInversionMatrix(c, p.canonical);
                            x.draw(t1, a.TRIANGLES, Li.disabled, n, l, d, Wr(t1, p, m, b, _, y, o.paint.get("heatmap-intensity")), o.id, f.layoutVertexBuffer, f.indexBuffer, f.segments, o.paint, t1.transform.zoom, v, h ? [
                                f.globeExtVertexBuffer
                            ] : null);
                        }
                        s.viewport.set([
                            0,
                            0,
                            t1.width,
                            t1.height
                        ]);
                    } else "translucent" === t1.renderPass && (t1.context.setColorMode(t1.colorModeForRenderPass()), function(t1, i) {
                        const o = t1.context, r = o.gl, s = i.heatmapFbo;
                        if (!s) return;
                        o.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, s.colorAttachment.get()), o.activeTexture.set(r.TEXTURE1);
                        let a = i.colorRampTexture;
                        a || (a = i.colorRampTexture = new e.T(o, i.colorRamp, r.RGBA8)), a.bind(r.LINEAR, r.CLAMP_TO_EDGE), t1.getOrCreateProgram("heatmapTexture").draw(t1, r.TRIANGLES, Li.disabled, Mi.disabled, t1.colorModeForRenderPass(), Fi.disabled, ((e, t1, i, o)=>({
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: t1.paint.get("heatmap-opacity")
                            }))(0, i), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom);
                    }(t1, o));
                }
            },
            line: function(t1, i, o, r) {
                if ("translucent" !== t1.renderPass) return;
                const s = o.paint.get("line-opacity"), a = o.paint.get("line-width");
                if (0 === s.constantOr(1) || 0 === a.constantOr(1)) return;
                const n = o.paint.get("line-emissive-strength"), l = o.paint.get("line-occlusion-opacity"), c = t1.context, h = c.gl, u = o.layout.get("line-z-offset"), d = !u.isConstant() || !!u.constantOr(0), _ = d ? new Li(t1.depthOcclusion ? h.GREATER : h.LEQUAL, Li.ReadOnly, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, Li.ReadOnly), p = t1.colorModeForDrapableLayerRenderPass(n), m = t1.terrain && t1.terrain.renderingToTexture, f = m ? 1 : e.q.devicePixelRatio, g = o.paint.get("line-dasharray"), v = g.constantOr(1), x = o.layout.get("line-cap"), y = g.constantOr(null), b = x.constantOr(null), w = o.paint.get("line-pattern"), T = w.constantOr(1), E = w.constantOr(null), C = o.paint.get("line-opacity").constantOr(1);
                let S = !T && 1 !== C || t1.depthOcclusion && l > 0 && l < 1;
                const I = o.paint.get("line-gradient"), D = T ? "linePattern" : "line", R = e.cV(o);
                let A;
                if (m && t1.terrain && t1.terrain.clipOrMaskOverlapStencilType() && (S = !1), 0 !== l && t1.depthOcclusion) {
                    const t1 = o.paint._values["line-opacity"];
                    t1 && t1.value && "constant" === t1.value.kind ? A = t1.value : e.w(`Occlusion opacity for layer ${o.id} is supported only when line-opacity isn't data-driven.`);
                }
                if (d && (t1.forceTerrainMode = !0), !d && 0 !== l && t1.terrain && !m) return void e.w(`Occlusion opacity for layer ${o.id} is supported on terrain only if the layer has non-zero line-z-offset.`);
                const L = S && d ? t1.stencilModeFor3D() : Mi.disabled;
                for (const s of r){
                    const r = i.getTile(s);
                    if (T && !r.patternsLoaded()) continue;
                    const a = r.getBucket(o);
                    if (!a) continue;
                    t1.prepareDrawTile();
                    const n = a.programConfigurations.get(o.id), u = t1.isTileAffectedByFog(s), g = t1.getOrCreateProgram(D, {
                        config: n,
                        defines: d ? [
                            ...R,
                            "ELEVATED"
                        ] : R,
                        overrideFog: u
                    });
                    if (E && r.imageAtlas) {
                        const e = r.imageAtlas.patternPositions[E.toString()];
                        e && n.setConstantPatternPositions(e);
                    }
                    if (!T && y && b && r.lineAtlas) {
                        const e = r.lineAtlas.getDash(y, b);
                        e && n.setConstantPatternPositions(e);
                    }
                    let [x, w] = o.paint.get("line-trim-offset");
                    if ("round" === b || "square" === b) {
                        const e = 1;
                        x !== w && (0 === x && (x -= e), 1 === w && (w += e));
                    }
                    const P = m ? s.projMatrix : null, M = T ? e.cW(t1, r, o, P, f, [
                        x,
                        w
                    ]) : e.cX(t1, r, o, P, a.lineClipsArray.length, f, [
                        x,
                        w
                    ]);
                    if (I) {
                        const r = a.gradients[o.id];
                        let n = r.texture;
                        if (o.gradientVersion !== r.version) {
                            let l = 256;
                            if (o.stepInterpolant) {
                                const o = i.getSource().maxzoom, r = s.canonical.z === o ? Math.ceil(1 << t1.transform.maxZoom - s.canonical.z) : 1;
                                l = e.ap(e.cY(a.maxLineLength / e.ab * 1024 * r), 256, c.maxTextureSize);
                            }
                            r.gradient = e.cZ({
                                expression: o.gradientExpression(),
                                evaluationKey: "lineProgress",
                                resolution: l,
                                image: r.gradient || void 0,
                                clips: a.lineClipsArray
                            }), r.texture ? r.texture.update(r.gradient) : r.texture = new e.T(c, r.gradient, h.RGBA8), r.version = o.gradientVersion, n = r.texture;
                        }
                        c.activeTexture.set(h.TEXTURE1), n.bind(o.stepInterpolant ? h.NEAREST : h.LINEAR, h.CLAMP_TO_EDGE);
                    }
                    v && (c.activeTexture.set(h.TEXTURE0), r.lineAtlasTexture && r.lineAtlasTexture.bind(h.LINEAR, h.REPEAT), n.updatePaintBuffers()), T && (c.activeTexture.set(h.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), n.updatePaintBuffers()), d && t1.terrain.setupElevationDraw(r, g), t1.uploadCommonUniforms(c, g, s.toUnwrapped());
                    const z = (e)=>{
                        null != A && (A.value = C * l), g.draw(t1, h.TRIANGLES, _, e, p, Fi.disabled, M, o.id, a.layoutVertexBuffer, a.indexBuffer, a.segments, o.paint, t1.transform.zoom, n, [
                            a.layoutVertexBuffer2,
                            a.patternVertexBuffer,
                            a.zOffsetVertexBuffer
                        ]), null != A && (A.value = C);
                    };
                    if (S && !d) {
                        const e = t1.stencilModeForClipping(s).ref;
                        0 === e && m && c.clear({
                            stencil: 0
                        });
                        const i = {
                            func: h.EQUAL,
                            mask: 255
                        };
                        M.u_alpha_discard_threshold = .8, z(new Mi(i, e, 255, h.KEEP, h.KEEP, h.INVERT)), M.u_alpha_discard_threshold = 0, z(new Mi(i, e, 255, h.KEEP, h.KEEP, h.KEEP));
                    } else S && d && (M.u_alpha_discard_threshold = .001), z(d ? L : t1.stencilModeForClipping(s));
                }
                S && (t1.resetStencilClippingMasks(), m && c.clear({
                    stencil: 0
                })), 0 === l || t1.depthOcclusion || m || t1.layersWithOcclusionOpacity.push(t1.currentLayer), d && (t1.forceTerrainMode = !1);
            },
            fill: function(t1, i, o, r) {
                const s = o.paint.get("fill-color"), a = o.paint.get("fill-opacity"), n = o.is3D(), l = new Li(t1.context.gl.LEQUAL, Li.ReadWrite, t1.depthRangeFor3D);
                if (0 === a.constantOr(1)) return;
                const c = o.paint.get("fill-emissive-strength"), h = t1.colorModeForDrapableLayerRenderPass(c), u = o.paint.get("fill-pattern"), d = t1.opaquePassEnabledForLayer() && !u.constantOr(1) && 1 === s.constantOr(e.bz.transparent).a && 1 === a.constantOr(0) ? "opaque" : "translucent";
                if (t1.renderPass === d) {
                    const e = n ? l : t1.depthModeForSublayer(1, "opaque" === t1.renderPass ? Li.ReadWrite : Li.ReadOnly);
                    Ts(t1, i, o, r, e, h, !1);
                }
                if (!n && "translucent" === t1.renderPass && o.paint.get("fill-antialias")) {
                    const e = n ? l : t1.depthModeForSublayer(o.getPaintProperty("fill-outline-color") ? 2 : 0, Li.ReadOnly);
                    Ts(t1, i, o, r, e, h, !0);
                }
            },
            "fill-extrusion": function(t1, i, o, r) {
                const s = o.paint.get("fill-extrusion-opacity"), a = t1.context, n = a.gl, l = t1.terrain, c = l && l.renderingToTexture;
                if (0 === s) return;
                const h = t1.conflationActive && t1.style.isLayerClipped(o, i.getSource()), u = t1.style.order.indexOf(o.fqid);
                if (h && function(e, t1, i, o, r) {
                    for (const s of o){
                        const o = t1.getTile(s).getBucket(i);
                        o && (o.updateReplacement(s, e.replacementSource, r), o.uploadCentroid(e.context));
                    }
                }(t1, i, o, r, u), l || h) for (const e of r){
                    const r = i.getTile(e).getBucket(o);
                    r && Ss(t1.context, i, e, r, o, l, h);
                }
                if ("shadow" === t1.renderPass && t1.shadowRenderer) {
                    const a = t1.shadowRenderer;
                    if (l && s < .65 && o._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof e.a4) return;
                    const n = a.getShadowPassDepthMode(), c = a.getShadowPassColorMode();
                    Es(t1, i, o, r, n, Mi.disabled, c, h);
                } else if ("translucent" === t1.renderPass) {
                    const u = !o.paint.get("fill-extrusion-pattern").constantOr(1), d = o.paint.get("fill-extrusion-color").constantOr(e.bz.white);
                    if (!c && 0 !== d.a) {
                        const e = new Li(t1.context.gl.LEQUAL, Li.ReadWrite, t1.depthRangeFor3D);
                        1 === s && u ? Es(t1, i, o, r, e, Mi.disabled, Ai.unblended, h) : (Es(t1, i, o, r, e, Mi.disabled, Ai.disabled, h), Es(t1, i, o, r, e, t1.stencilModeFor3D(), t1.colorModeForRenderPass(), h), t1.resetStencilClippingMasks());
                    }
                    if (t1.style.enable3dLights() && u && (!l && "globe" !== t1.transform.projection.name || c)) {
                        const s = o.paint.get("fill-extrusion-opacity"), u = o.paint.get("fill-extrusion-ambient-occlusion-intensity"), d = o.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), _ = o.paint.get("fill-extrusion-flood-light-intensity"), p = o.paint.get("fill-extrusion-flood-light-color").toRenderColor(o.lut).toArray01().slice(0, 3), m = u > 0 && d > 0, f = _ > 0, g = (e, t1, i)=>(1 - i) * e + i * t1, v = (a)=>{
                            const l = t1.depthModeForSublayer(1, Li.ReadOnly, n.LEQUAL, !0), c = o.paint.get(a ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), m = g(.1, 3, c), f = t1._showOverdrawInspector;
                            if (!f) {
                                const c = new Mi({
                                    func: n.ALWAYS,
                                    mask: 255
                                }, 255, 255, n.KEEP, n.KEEP, n.REPLACE), f = new Ai([
                                    n.ONE,
                                    n.ONE,
                                    n.ONE,
                                    n.ONE
                                ], e.bz.transparent, [
                                    !1,
                                    !1,
                                    !1,
                                    !0
                                ], n.MIN);
                                Cs(t1, i, o, r, l, c, f, Fi.disabled, a, "sdf", s, u, d, _, p, m, h, !1);
                            }
                            {
                                const c = f ? Mi.disabled : new Mi({
                                    func: n.EQUAL,
                                    mask: 255
                                }, 255, 255, n.KEEP, n.DECR, n.DECR), g = f ? t1.colorModeForRenderPass() : new Ai([
                                    n.ONE_MINUS_DST_ALPHA,
                                    n.DST_ALPHA,
                                    n.ONE,
                                    n.ONE
                                ], e.bz.transparent, [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]);
                                Cs(t1, i, o, r, l, c, g, Fi.disabled, a, "color", s, u, d, _, p, m, h, !1);
                            }
                        };
                        if (c) {
                            const c = (a, l, c)=>{
                                const m = t1.depthModeForSublayer(1, Li.ReadOnly, n.LEQUAL, !1), f = o.paint.get(a ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), v = g(.1, 3, f);
                                {
                                    const c = new Ai([
                                        n.ONE,
                                        n.ONE,
                                        n.ONE,
                                        n.ONE
                                    ], e.bz.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ]);
                                    Cs(t1, i, o, r, m, Mi.disabled, c, Fi.disabled, a, "clear", s, u, d, _, p, v, h, l);
                                }
                                {
                                    const c = new Mi({
                                        func: n.ALWAYS,
                                        mask: 255
                                    }, 255, 255, n.KEEP, n.KEEP, n.REPLACE), f = new Ai([
                                        n.ONE,
                                        n.ONE,
                                        n.ONE,
                                        n.ONE
                                    ], e.bz.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], n.MIN);
                                    Cs(t1, i, o, r, m, c, f, Fi.disabled, a, "sdf", s, u, d, _, p, v, h, l);
                                }
                                {
                                    const c = a ? n.ZERO : n.ONE_MINUS_DST_ALPHA, f = new Mi({
                                        func: n.EQUAL,
                                        mask: 255
                                    }, 255, 255, n.KEEP, n.DECR, n.DECR), g = new Ai([
                                        c,
                                        n.DST_ALPHA,
                                        n.ONE_MINUS_DST_ALPHA,
                                        n.ZERO
                                    ], e.bz.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    Cs(t1, i, o, r, m, f, g, Fi.disabled, a, "color", s, u, d, _, p, v, h, l);
                                }
                                {
                                    const f = new Ai([
                                        n.ONE,
                                        n.ONE,
                                        n.ONE,
                                        a ? n.ZERO : n.ONE
                                    ], e.bz.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], a ? n.FUNC_ADD : n.MAX);
                                    Cs(t1, i, o, r, m, Mi.disabled, f, Fi.disabled, a, "clear", s, u, d, _, p, v, h, l, c);
                                }
                            };
                            if (m || f) {
                                let i;
                                if (t1.prepareDrawTile(), l) {
                                    const t1 = l.drapeBufferSize[0], o = l.drapeBufferSize[1];
                                    i = l.framebufferCopyTexture, i && (!i || i.size[0] === t1 && i.size[1] === o) || (i && i.destroy(), i = l.framebufferCopyTexture = new e.T(a, new e.r({
                                        width: t1,
                                        height: o
                                    }), n.RGBA8)), i.bind(n.LINEAR, n.CLAMP_TO_EDGE), n.copyTexImage2D(n.TEXTURE_2D, 0, n.RGBA, 0, 0, t1, o, 0);
                                }
                                m && c(!0, !1, i), f && c(!1, !0, i);
                            }
                        } else m && v(!0), f && v(!1), (m || f) && t1.resetStencilClippingMasks();
                    }
                }
            },
            hillshade: function(e, t1, i, o) {
                if ("offscreen" !== e.renderPass && "translucent" !== e.renderPass) return;
                if (e.style.disableElevatedTerrain) return;
                const r = e.context, s = e.terrain && e.terrain.renderingToTexture, [a, n] = "translucent" !== e.renderPass || s ? [
                    {},
                    o
                ] : e.stencilConfigForOverlap(o);
                for (const o of n){
                    const r = t1.getTile(o);
                    if (r.needsHillshadePrepare && "offscreen" === e.renderPass) zo(e, r, i);
                    else if ("translucent" === e.renderPass) {
                        const t1 = e.depthModeForSublayer(0, Li.ReadOnly), n = i.paint.get("hillshade-emissive-strength"), l = e.colorModeForDrapableLayerRenderPass(n), c = s && e.terrain ? e.terrain.stencilModeForRTTOverlap(o) : a[o.overscaledZ];
                        Po(e, o, r, i, t1, c, l);
                    }
                }
                r.viewport.set([
                    0,
                    0,
                    e.width,
                    e.height
                ]), e.resetStencilClippingMasks();
            },
            raster: function(t1, i, o, r, s, a) {
                if ("translucent" !== t1.renderPass) return;
                if (0 === o.paint.get("raster-opacity")) return;
                const n = "globe" === t1.transform.projection.name, l = 0 !== o.paint.get("raster-elevation"), c = l && n;
                if (t1.renderElevatedRasterBackface && !c) return;
                const h = t1.context, u = h.gl, d = i.getSource(), _ = function(t1, i, o, r) {
                    const s = i.paint.get("raster-color"), a = "raster-array" === t1.type, n = [], l = i.paint.get("raster-resampling"), c = i.paint.get("raster-color-mix");
                    let h = i.paint.get("raster-color-range");
                    const u = [
                        c[0],
                        c[1],
                        c[2],
                        0
                    ], d = c[3];
                    let _ = "nearest" === l ? r.NEAREST : r.LINEAR;
                    if (a && (n.push("RASTER_ARRAY"), s || n.push("RASTER_COLOR"), "linear" === l && n.push("RASTER_ARRAY_LINEAR"), _ = r.NEAREST, !h && t1.rasterLayers)) {
                        const e = t1.rasterLayers.find(({ id: e })=>e === i.sourceLayer);
                        e && e.fields && e.fields.range && (h = e.fields.range);
                    }
                    if (h = h || [
                        0,
                        1
                    ], s) {
                        n.push("RASTER_COLOR"), o.activeTexture.set(r.TEXTURE2), i.updateColorRamp(h);
                        let t1 = i.colorRampTexture;
                        t1 || (t1 = i.colorRampTexture = new e.T(o, i.colorRamp, r.RGBA8)), t1.bind(r.LINEAR, r.CLAMP_TO_EDGE);
                    }
                    return {
                        mix: u,
                        range: h,
                        offset: d,
                        defines: n,
                        resampling: _
                    };
                }(d, o, h, u);
                if (d instanceof e.aD && !r.length && !n) return;
                const p = o.paint.get("raster-emissive-strength"), m = t1.colorModeForDrapableLayerRenderPass(p), f = t1.terrain && t1.terrain.renderingToTexture, g = !t1.options.moving, v = "nearest" === o.paint.get("raster-resampling") ? u.NEAREST : u.LINEAR;
                if (d instanceof e.aD && !r.length && (d.onNorthPole || d.onSouthPole)) {
                    const e = l ? t1.stencilModeFor3D() : Mi.disabled;
                    return void Ps(!!d.onNorthPole, null, t1, i, o, p, _, Fi.disabled, e);
                }
                if (!r.length) return;
                const [x, y] = d instanceof e.aD || f ? [
                    {},
                    r
                ] : t1.stencilConfigForOverlap(r), b = y[y.length - 1].overscaledZ;
                c && _.defines.push("PROJECTION_GLOBE_VIEW"), l && _.defines.push("RENDER_CUTOFF");
                const w = (r, s, y)=>{
                    for (const w of r){
                        const r = w.toUnwrapped(), T = i.getTile(w);
                        if (f && (!T || !T.hasData())) continue;
                        h.activeTexture.set(u.TEXTURE0);
                        const E = zs(T, d, o, _);
                        if (!E || !E.texture) continue;
                        const { texture: C, mix: S, offset: I, tileSize: D, buffer: R } = E;
                        let A, L;
                        f ? (A = Li.disabled, L = w.projMatrix) : l ? (A = new Li(u.LEQUAL, Li.ReadWrite, t1.depthRangeFor3D), L = n ? Float32Array.from(t1.transform.expandedFarZProjMatrix) : t1.transform.calculateProjMatrix(r, g)) : (A = t1.depthModeForSublayer(w.overscaledZ - b, 1 === o.paint.get("raster-opacity") ? Li.ReadWrite : Li.ReadOnly, u.LESS), L = t1.transform.calculateProjMatrix(r, g));
                        const P = t1.terrain && f ? t1.terrain.stencilModeForRTTOverlap(w) : x[w.overscaledZ], M = a ? 0 : o.paint.get("raster-fade-duration");
                        T.registerFadeDuration(M);
                        const z = i.findLoadedParent(w, 0), O = Sr(T, z, i, t1.transform, M);
                        let F, k;
                        t1.terrain && t1.terrain.prepareDrawTile(), h.activeTexture.set(u.TEXTURE0), C.bind(v, u.CLAMP_TO_EDGE), h.activeTexture.set(u.TEXTURE1), z ? (z.texture && z.texture.bind(v, u.CLAMP_TO_EDGE), F = Math.pow(2, z.tileID.overscaledZ - T.tileID.overscaledZ), k = [
                            T.tileID.canonical.x * F % 1,
                            T.tileID.canonical.y * F % 1
                        ]) : C.bind(v, u.CLAMP_TO_EDGE), C.useMipmap && h.extTextureFilterAnisotropic && t1.transform.pitch > 20 && u.texParameterf(u.TEXTURE_2D, h.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, h.extTextureFilterAnisotropicMax);
                        const B = t1.transform;
                        let N;
                        const U = l ? Ms(B) : [
                            0,
                            0,
                            0,
                            0
                        ];
                        let G, j, V, q, Z, H = 0;
                        if (c && d instanceof e.aD && d.coordinates.length > 3) G = Float32Array.from(e.b5(e.cC(new e.bP(0, 0, 0)))), j = Float32Array.from(B.globeMatrix), V = Float32Array.from(e.cy(B)), q = [
                            e.am(B.center.lng),
                            e.at(B.center.lat)
                        ], N = d.elevatedGlobePerspectiveTransform, Z = d.elevatedGlobeGridMatrix || new Float32Array(9);
                        else if (c) {
                            const t1 = e.cz(w.canonical);
                            H = e.cA(t1.getCenter().lat), G = Float32Array.from(e.b5(e.cC(w.canonical))), j = Float32Array.from(B.globeMatrix), V = Float32Array.from(e.cy(B)), q = [
                                e.am(B.center.lng),
                                e.at(B.center.lat)
                            ], N = [
                                0,
                                0
                            ], Z = Float32Array.from(e.cB(w.canonical, t1, H, B.worldSize / B._pixelsPerMercatorPixel));
                        } else N = d instanceof e.aD ? d.perspectiveTransform : [
                            0,
                            0
                        ], G = new Float32Array(16), j = new Float32Array(9), V = new Float32Array(16), q = [
                            0,
                            0
                        ], Z = new Float32Array(9);
                        const W = Yr(L, G, j, V, Z, k || [
                            0,
                            0
                        ], e.a9(t1.transform.zoom), q, U, F || 1, O, o, N, l ? o.paint.get("raster-elevation") : 0, 2, S, I, _.range, D, R, p), $ = t1.isTileAffectedByFog(w), X = t1.getOrCreateProgram("raster", {
                            defines: _.defines,
                            overrideFog: $
                        });
                        if (t1.uploadCommonUniforms(h, X, r), d instanceof e.aD) {
                            const i = d.elevatedGlobeVertexBuffer, r = d.elevatedGlobeIndexBuffer;
                            if (f || !n) d.boundsBuffer && d.boundsSegments && X.draw(t1, u.TRIANGLES, A, Mi.disabled, m, Fi.disabled, W, o.id, d.boundsBuffer, t1.quadTriangleIndexBuffer, d.boundsSegments);
                            else if (i && r) {
                                const a = B.zoom <= e.c2 ? d.elevatedGlobeSegments : d.getSegmentsForLongitude(B.center.lng);
                                a && X.draw(t1, u.TRIANGLES, A, Mi.disabled, m, s, W, o.id, i, r, a);
                            }
                        } else if (c) {
                            A = new Li(u.LEQUAL, Li.ReadOnly, t1.depthRangeFor3D);
                            const e = t1.globeSharedBuffers;
                            if (e) {
                                const [i, r, a] = e.getGridBuffers(H, !1);
                                X.draw(t1, u.TRIANGLES, A, y || P, t1.colorModeForRenderPass(), s, W, o.id, i, r, a);
                            }
                        } else {
                            const { tileBoundsBuffer: e, tileBoundsIndexBuffer: i, tileBoundsSegments: r } = t1.getTileBoundsBuffers(T);
                            X.draw(t1, u.TRIANGLES, A, P, m, Fi.disabled, W, o.id, e, i, r);
                        }
                    }
                    if (!(d instanceof e.aD) && c) for (const e of r){
                        const r = e.canonical.y === (1 << e.canonical.z) - 1;
                        0 === e.canonical.y && Ps(!0, e, t1, i, o, p, _, s, y || Mi.disabled), r && Ps(!1, e, t1, i, o, p, _, s === Fi.frontCW ? Fi.backCW : Fi.frontCW, y || Mi.disabled);
                    }
                };
                c ? w(y, t1.renderElevatedRasterBackface ? Fi.backCW : Fi.frontCW, t1.stencilModeFor3D()) : w(y, Fi.disabled, void 0), t1.resetStencilClippingMasks();
            },
            "raster-particle": function(t1, i, o, r, s, a) {
                "offscreen" === t1.renderPass && function(t1, i, o, r) {
                    if (!r.length) return;
                    const s = t1.context, a = s.gl, n = i.getSource();
                    if (!(n instanceof Qe)) return;
                    const l = Math.ceil(Math.sqrt(o.paint.get("raster-particle-count")));
                    let c = o.particlePositionRGBAImage;
                    if (!c || c.width !== l) {
                        const t1 = function(e) {
                            const t1 = e * e, i = new Uint8Array(4 * t1), o = function(e) {
                                return e |= 0, e = Math.imul(2747636419 ^ e, 2654435769), e = Math.imul(e ^ e >>> 16, 2654435769), ((e = Math.imul(e ^ e >>> 16, 2654435769)) >>> 0) / 4294967296;
                            }, r = 1 / 1.1;
                            for(let e = 0; e < t1; e++){
                                const t1 = r * (o(2 * e + 0) + Jr), s = r * (o(2 * e + 1) + Jr), a = 255 * t1 % 1, n = 255 * s % 1, l = a, c = s - n / 255, h = n;
                                i[4 * e + 0] = 255 * (t1 - a / 255), i[4 * e + 1] = 255 * l, i[4 * e + 2] = 255 * c, i[4 * e + 3] = 255 * h;
                            }
                            return i;
                        }(l);
                        c = o.particlePositionRGBAImage = new e.r({
                            width: l,
                            height: l
                        }, t1);
                    }
                    let h = o.particleFramebuffer;
                    h ? h.width !== l && (h.destroy(), h = o.particleFramebuffer = s.createFramebuffer(l, l, !0, null)) : h = o.particleFramebuffer = s.createFramebuffer(l, l, !0, null);
                    const u = [];
                    for (const e of r){
                        const t1 = i.getTile(e);
                        if (!(t1 instanceof mt)) continue;
                        const r = ks(t1, n, o);
                        if (!r) continue;
                        const a = [
                            t1.tileSize,
                            t1.tileSize
                        ];
                        let h = o.tileFramebuffer;
                        h || (h = o.tileFramebuffer = s.createFramebuffer(a[0], a[1], !0, null));
                        let d = t1.rasterParticleState;
                        d || (d = t1.rasterParticleState = new Fs(s, e, a, c));
                        const _ = d.update(o.lastInvalidatedAt);
                        d.particleTextureDimension !== l && d.updateParticleTexture(e, c);
                        const p = d.targetColorTexture;
                        d.targetColorTexture = d.backgroundColorTexture, d.backgroundColorTexture = p;
                        const m = d.particleTexture0;
                        d.particleTexture0 = d.particleTexture1, d.particleTexture1 = m, u.push([
                            e,
                            r,
                            d,
                            _
                        ]);
                    }
                    if (0 === u.length) return;
                    const d = e.q.now(), _ = o.previousDrawTimestamp ? .001 * (d - o.previousDrawTimestamp) : .0167;
                    if (o.previousDrawTimestamp = d, o.hasColorMap()) {
                        s.activeTexture.set(a.TEXTURE0 + 2);
                        let t1 = o.colorRampTexture;
                        t1 || (t1 = o.colorRampTexture = new e.T(s, o.colorRamp, a.RGBA8)), t1.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                    }
                    s.bindFramebuffer.set(o.tileFramebuffer.framebuffer), function(t1, i, o) {
                        const r = t1.context, s = r.gl, a = i.tileFramebuffer;
                        r.activeTexture.set(s.TEXTURE0);
                        const n = {
                            u_texture: 0,
                            u_opacity: 1.05 * (c = i.paint.get("raster-particle-fade-opacity-factor")) / (c + .05)
                        }, l = t1.getOrCreateProgram("rasterParticleTexture", {
                            defines: [],
                            overrideFog: !1
                        });
                        var c;
                        for (const c of o){
                            const [, , o, h] = c;
                            a.colorAttachment.set(o.targetColorTexture.texture), r.viewport.set([
                                0,
                                0,
                                a.width,
                                a.height
                            ]), r.clear({
                                color: e.bz.transparent
                            }), h && (o.backgroundColorTexture.bind(s.NEAREST, s.CLAMP_TO_EDGE), l.draw(t1, s.TRIANGLES, Li.disabled, Mi.disabled, Ai.alphaBlended, Fi.disabled, n, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments));
                        }
                    }(t1, o, u), function(t1, i, o, r) {
                        const s = t1.context, a = s.gl, n = o.tileFramebuffer, l = "globe" === t1.transform.projection.name, c = o.paint.get("raster-particle-max-speed");
                        for (const h of r){
                            const [r, u, d] = h;
                            s.activeTexture.set(a.TEXTURE0 + 0), u.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE), n.colorAttachment.set(d.targetColorTexture.texture);
                            const _ = t1.getOrCreateProgram("rasterParticleDraw", {
                                defines: u.defines,
                                overrideFog: !1
                            });
                            s.activeTexture.set(a.TEXTURE0 + 1);
                            const p = u.scalarData ? [] : [
                                0,
                                1,
                                2,
                                3
                            ].map((t1)=>e.c$[t1](r));
                            p.push(r);
                            const m = r.canonical.x, f = r.canonical.y;
                            for (const e of p){
                                const s = i.getTile(l ? e.wrapped() : e);
                                if (!s) continue;
                                const n = s.rasterParticleState;
                                if (!n) continue;
                                const h = e.canonical.x + (1 << e.canonical.z) * (e.wrap - r.wrap), d = e.canonical.y;
                                n.particleTexture0.bind(a.NEAREST, a.CLAMP_TO_EDGE);
                                const p = es(1, n.particleTexture0.size[0], [
                                    h - m,
                                    d - f
                                ], 0, u.texture.size, 2, c, u.textureOffset, u.scale, u.offset);
                                _.draw(t1, a.POINTS, Li.disabled, Mi.disabled, Ai.alphaBlended, Fi.disabled, p, o.id, n.particleIndexBuffer, void 0, n.particleSegment);
                            }
                        }
                    }(t1, i, o, u), s.bindFramebuffer.set(o.particleFramebuffer.framebuffer), function(t1, i, o, r) {
                        const s = t1.context, a = s.gl, n = i.paint.get("raster-particle-max-speed"), l = r * i.paint.get("raster-particle-speed-factor") * .15, c = function(e) {
                            return Math.pow(e, 6);
                        }(.01 + 1 * i.paint.get("raster-particle-reset-rate-factor")), h = i.particleFramebuffer;
                        s.viewport.set([
                            0,
                            0,
                            h.width,
                            h.height
                        ]);
                        for (const r of o){
                            const [, o, u] = r;
                            s.activeTexture.set(a.TEXTURE0 + 0), o.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE), s.activeTexture.set(a.TEXTURE0 + 1);
                            const d = u.particleTexture0;
                            d.bind(a.NEAREST, a.CLAMP_TO_EDGE);
                            const _ = ts(1, d.size[0], 0, o.texture.size, n, l, c, o.textureOffset, o.scale, o.offset);
                            h.colorAttachment.set(u.particleTexture1.texture), s.clear({
                                color: e.bz.transparent
                            }), t1.getOrCreateProgram("rasterParticleUpdate", {
                                defines: o.defines
                            }).draw(t1, a.TRIANGLES, Li.disabled, Mi.disabled, Ai.unblended, Fi.disabled, _, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                        }
                    }(t1, o, u, _);
                }(t1, i, o, r), "translucent" === t1.renderPass && (function(t1, i, o, r, s) {
                    const a = t1.context, n = a.gl, l = i.getSource().tileSize, c = 5 * (1 - e.a7(e.bU, e.bU + 1, t1.transform.zoom)) * l + o.paint.get("raster-particle-elevation"), h = !t1.options.moving, u = "globe" === t1.transform.projection.name;
                    if (!r.length) return;
                    const [d, _] = t1.stencilConfigForOverlap(r), p = [];
                    u && p.push("PROJECTION_GLOBE_VIEW");
                    const m = t1.stencilModeFor3D();
                    for (const r of _){
                        const s = r.toUnwrapped(), l = i.getTile(r);
                        if (!l.rasterParticleState) continue;
                        const _ = l.rasterParticleState, f = 100;
                        l.registerFadeDuration(f);
                        const g = i.findLoadedParent(r, 0), v = Sr(l, g, i, t1.transform, f);
                        let x, y;
                        t1.terrain && t1.terrain.prepareDrawTile(), a.activeTexture.set(n.TEXTURE0), _.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), a.activeTexture.set(n.TEXTURE1), g && g.rasterParticleState ? (g.rasterParticleState.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), x = Math.pow(2, g.tileID.overscaledZ - l.tileID.overscaledZ), y = [
                            l.tileID.canonical.x * x % 1,
                            l.tileID.canonical.y * x % 1
                        ]) : _.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                        const b = u ? Float32Array.from(t1.transform.expandedFarZProjMatrix) : t1.transform.calculateProjMatrix(s, h), w = t1.transform, T = Bs(w), E = e.cz(r.canonical), C = e.cA(E.getCenter().lat);
                        let S, I, D, R, A;
                        u ? (S = Float32Array.from(e.b5(e.cC(r.canonical))), I = Float32Array.from(w.globeMatrix), D = Float32Array.from(e.cy(w)), R = [
                            e.am(w.center.lng),
                            e.at(w.center.lat)
                        ], A = Float32Array.from(e.cB(r.canonical, E, C, w.worldSize / w._pixelsPerMercatorPixel))) : (S = new Float32Array(16), I = new Float32Array(9), D = new Float32Array(16), R = [
                            0,
                            0
                        ], A = new Float32Array(9));
                        const L = Qr(b, S, I, D, A, y || [
                            0,
                            0
                        ], e.a9(t1.transform.zoom), R, T, x || 1, v, c), P = t1.isTileAffectedByFog(r), M = t1.getOrCreateProgram("rasterParticle", {
                            defines: p,
                            overrideFog: P
                        });
                        if (t1.uploadCommonUniforms(a, M, s), u) {
                            const e = new Li(n.LEQUAL, Li.ReadOnly, t1.depthRangeFor3D), i = 0, r = t1.globeSharedBuffers;
                            if (r) {
                                const [s, a, l] = r.getGridBuffers(C, 0 !== i);
                                M.draw(t1, n.TRIANGLES, e, m, Ai.alphaBlended, t1.renderElevatedRasterBackface ? Fi.frontCCW : Fi.backCCW, L, o.id, s, a, l);
                            }
                        } else {
                            const e = t1.depthModeForSublayer(0, Li.ReadOnly), i = d[r.overscaledZ], { tileBoundsBuffer: s, tileBoundsIndexBuffer: a, tileBoundsSegments: c } = t1.getTileBoundsBuffers(l);
                            M.draw(t1, n.TRIANGLES, e, i, Ai.alphaBlended, Fi.disabled, L, o.id, s, a, c);
                        }
                    }
                    t1.resetStencilClippingMasks();
                }(t1, i, o, r), t1.style.map.triggerRepaint());
            },
            background: function(t1, i, o, r) {
                const s = o.paint.get("background-color"), a = o.paint.get("background-opacity"), n = o.paint.get("background-emissive-strength"), l = "viewport" === o.paint.get("background-pitch-alignment");
                if (0 === a) return;
                const c = t1.context, h = c.gl, u = t1.transform, d = u.tileSize, _ = o.paint.get("background-pattern");
                let p;
                if (void 0 !== _) {
                    if (null === _) return;
                    if (p = t1.imageManager.getPattern(_.toString(), o.scope, t1.style.getLut(o.scope)), !p) return;
                }
                const m = !_ && 1 === s.a && 1 === a && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (t1.renderPass !== m) return;
                const f = Mi.disabled, g = t1.depthModeForSublayer(0, "opaque" === m ? Li.ReadWrite : Li.ReadOnly), v = t1.colorModeForDrapableLayerRenderPass(n), x = _ ? "backgroundPattern" : "background";
                let y, b = r;
                if (b || (y = t1.getBackgroundTiles(), b = Object.values(y).map((e)=>e.tileID)), _ && (c.activeTexture.set(h.TEXTURE0), t1.imageManager.bind(t1.context, o.scope)), l) {
                    const i = t1.getOrCreateProgram(x, {
                        overrideFog: !1,
                        overrideRtt: !0
                    }), r = new Float32Array(e.a6.mat4.identity([])), c = new e.aA(0, 0, 0, 0, 0), u = _ ? ss(r, n, a, t1, 0, o.scope, p, l, {
                        tileID: c,
                        tileSize: d
                    }) : rs(r, n, a, s.toRenderColor(o.lut));
                    i.draw(t1, h.TRIANGLES, g, f, v, Fi.disabled, u, o.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                } else for (const e of b){
                    const m = t1.isTileAffectedByFog(e), b = t1.getOrCreateProgram(x, {
                        overrideFog: m
                    }), w = e.toUnwrapped(), T = r ? e.projMatrix : t1.transform.calculateProjMatrix(w);
                    t1.prepareDrawTile();
                    const E = i ? i.getTile(e) : y ? y[e.key] : new pt(e, d, u.zoom, t1), C = _ ? ss(T, n, a, t1, 0, o.scope, p, l, {
                        tileID: e,
                        tileSize: d
                    }) : rs(T, n, a, s.toRenderColor(o.lut));
                    t1.uploadCommonUniforms(c, b, w);
                    const { tileBoundsBuffer: S, tileBoundsIndexBuffer: I, tileBoundsSegments: D } = t1.getTileBoundsBuffers(E);
                    b.draw(t1, h.TRIANGLES, g, f, v, Fi.disabled, C, o.id, S, I, D);
                }
            },
            sky: function(t1, i, o) {
                const r = t1._atmosphere ? e.a9(t1.transform.zoom) : 1, s = o.paint.get("sky-opacity") * r;
                if (0 === s) return;
                const a = t1.context, n = o.paint.get("sky-type"), l = new Li(a.gl.LEQUAL, Li.ReadOnly, [
                    0,
                    1
                ]), c = t1.frameCounter / 1e3 % 1;
                "atmosphere" === n ? "offscreen" === t1.renderPass ? o.needsSkyboxCapture(t1) && (function(t1, i, o, r) {
                    const s = t1.context, a = s.gl;
                    let n = i.skyboxFbo;
                    if (!n) {
                        n = i.skyboxFbo = s.createFramebuffer(32, 32, !0, null), i.skyboxGeometry = new Ks(s), i.skyboxTexture = s.gl.createTexture(), a.bindTexture(a.TEXTURE_CUBE_MAP, i.skyboxTexture), a.texParameteri(a.TEXTURE_CUBE_MAP, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_CUBE_MAP, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_CUBE_MAP, a.TEXTURE_MIN_FILTER, a.LINEAR), a.texParameteri(a.TEXTURE_CUBE_MAP, a.TEXTURE_MAG_FILTER, a.LINEAR);
                        for(let e = 0; e < 6; ++e)a.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, a.RGBA, 32, 32, 0, a.RGBA, a.UNSIGNED_BYTE, null);
                    }
                    s.bindFramebuffer.set(n.framebuffer), s.viewport.set([
                        0,
                        0,
                        32,
                        32
                    ]);
                    const l = i.getCenter(t1, !0), c = t1.getOrCreateProgram("skyboxCapture"), h = new Float64Array(16);
                    e.a6.mat4.identity(h), e.a6.mat4.rotateY(h, h, .5 * -Math.PI), Js(t1, i, c, h, l, 0), e.a6.mat4.identity(h), e.a6.mat4.rotateY(h, h, .5 * Math.PI), Js(t1, i, c, h, l, 1), e.a6.mat4.identity(h), e.a6.mat4.rotateX(h, h, .5 * -Math.PI), Js(t1, i, c, h, l, 2), e.a6.mat4.identity(h), e.a6.mat4.rotateX(h, h, .5 * Math.PI), Js(t1, i, c, h, l, 3), e.a6.mat4.identity(h), Js(t1, i, c, h, l, 4), e.a6.mat4.identity(h), e.a6.mat4.rotateY(h, h, Math.PI), Js(t1, i, c, h, l, 5), s.viewport.set([
                        0,
                        0,
                        t1.width,
                        t1.height
                    ]);
                }(t1, o), o.markSkyboxValid(t1)) : "sky" === t1.renderPass && function(e, t1, i, o, r) {
                    const s = e.context, a = s.gl, n = e.transform, l = e.getOrCreateProgram("skybox");
                    s.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_CUBE_MAP, t1.skyboxTexture);
                    const c = ((e, t1, i, o, r)=>({
                            u_matrix: e,
                            u_sun_direction: t1,
                            u_cubemap: 0,
                            u_opacity: o,
                            u_temporal_offset: r
                        }))(n.skyboxMatrix, t1.getCenter(e, !1), 0, o, r);
                    e.uploadCommonUniforms(s, l), l.draw(e, a.TRIANGLES, i, Mi.disabled, e.colorModeForRenderPass(), Fi.backCW, c, "skybox", t1.skyboxGeometry.vertexBuffer, t1.skyboxGeometry.indexBuffer, t1.skyboxGeometry.segment);
                }(t1, o, l, s, c) : "gradient" === n && "sky" === t1.renderPass && function(t1, i, o, r, s) {
                    const a = t1.context, n = a.gl, l = t1.transform, c = t1.getOrCreateProgram("skyboxGradient");
                    i.skyboxGeometry || (i.skyboxGeometry = new Ks(a)), a.activeTexture.set(n.TEXTURE0);
                    let h = i.colorRampTexture;
                    h || (h = i.colorRampTexture = new e.T(a, i.colorRamp, n.RGBA8)), h.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                    const u = ((t1, i, o, r, s)=>({
                            u_matrix: t1,
                            u_color_ramp: 0,
                            u_center_direction: i,
                            u_radius: e.bB(o),
                            u_opacity: r,
                            u_temporal_offset: s
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), i.paint.get("sky-gradient-radius"), r, s);
                    t1.uploadCommonUniforms(a, c), c.draw(t1, n.TRIANGLES, o, Mi.disabled, t1.colorModeForRenderPass(), Fi.backCW, u, "skyboxGradient", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, o, l, s, c);
            },
            debug: function(t1, i, o, r, s, a) {
                for(let n = 0; n < o.length; n++)if (s) {
                    const s = 1, l = .8, c = new e.bz(r.r * l, r.g * l, r.b * l, 1);
                    qs(t1, i, o[n], r, -s, -s, a), qs(t1, i, o[n], r, -s, s, a), qs(t1, i, o[n], r, s, s, a), qs(t1, i, o[n], r, s, -s, a), qs(t1, i, o[n], c, 0, 0, a);
                } else qs(t1, i, o[n], r, 0, 0, a);
            },
            custom: function(t1, i, o, r) {
                const s = t1.context, a = o.implementation;
                if (!t1.transform.projection.unsupportedLayers || !t1.transform.projection.unsupportedLayers.includes("custom") || t1.terrain && (t1.terrain.renderingToTexture || "offscreen" === t1.renderPass) && o.isDraped(i)) {
                    if ("offscreen" === t1.renderPass) {
                        const i = a.prerender;
                        if (i) {
                            if (t1.setCustomLayerDefaults(), s.setColorMode(t1.colorModeForRenderPass()), "globe" === t1.transform.projection.name) {
                                const o = t1.transform.pointMerc;
                                i.call(a, s.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e.a9(t1.transform.zoom), [
                                    o.x,
                                    o.y
                                ], t1.transform.pixelsPerMeterRatio);
                            } else i.call(a, s.gl, t1.transform.customLayerMatrix());
                            s.setDirty(), t1.setBaseState();
                        }
                    } else if ("translucent" === t1.renderPass) {
                        if (t1.terrain && t1.terrain.renderingToTexture) {
                            const i = a.renderToTile;
                            if (i) {
                                const o = r[0].canonical, n = new e.a5(o.x + r[0].wrap * (1 << o.z), o.y, o.z);
                                s.setDepthMode(Li.disabled), s.setStencilMode(Mi.disabled), s.setColorMode(t1.colorModeForRenderPass()), t1.setCustomLayerDefaults(), i.call(a, s.gl, n), s.setDirty(), t1.setBaseState();
                            }
                            return;
                        }
                        t1.setCustomLayerDefaults(), s.setColorMode(t1.colorModeForRenderPass()), s.setStencilMode(Mi.disabled);
                        const i = "3d" === a.renderingMode ? new Li(t1.context.gl.LEQUAL, Li.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, Li.ReadOnly);
                        if (s.setDepthMode(i), "globe" === t1.transform.projection.name) {
                            const i = t1.transform.pointMerc;
                            a.render(s.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e.a9(t1.transform.zoom), [
                                i.x,
                                i.y
                            ], t1.transform.pixelsPerMeterRatio);
                        } else a.render(s.gl, t1.transform.customLayerMatrix());
                        s.setDirty(), t1.setBaseState(), s.bindFramebuffer.set(null);
                    }
                } else e.w("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
            },
            model: function(t1, i, o, r) {
                if ("opaque" === t1.renderPass) return;
                const s = o.paint.get("model-opacity");
                if (0 === s) return;
                const a = o.paint.get("model-cast-shadows");
                if ("shadow" === t1.renderPass) {
                    if (!a) return;
                    if (t1.terrain && s < .65 && o._transitionablePaint._values["model-opacity"].value.expression instanceof e.a4) return;
                }
                const n = t1.shadowRenderer, l = o.paint.get("model-receive-shadows");
                n && (n.useNormalOffset = !0, l || (n.enabled = !1));
                const c = ()=>{
                    n && (n.useNormalOffset = !0, l || (n.enabled = !0));
                }, h = i.getSource();
                if ("light-beam" === t1.renderPass && "batched-model" !== h.type) return;
                if ("vector" === h.type || "geojson" === h.type) return function(t1, i, o, r, s) {
                    const a = t1.transform;
                    if ("mercator" !== a.projection.name) return void e.w(`Drawing 3D models for ${a.projection.name} projection is not yet implemented`);
                    const n = a.getFreeCameraOptions().position;
                    if (!t1.modelManager) return;
                    const l = t1.modelManager;
                    o.modelManager = l;
                    const c = t1.shadowRenderer;
                    if (!o._unevaluatedLayout._values.hasOwnProperty("model-id")) return;
                    const h = o._unevaluatedLayout._values["model-id"], u = {
                        ...o.layout.get("model-id").parameters
                    }, d = t1.style.order.indexOf(o.fqid);
                    for (const _ of r){
                        const r = i.getTile(_).getBucket(o);
                        if (!r || r.projection.name !== a.projection.name) continue;
                        const p = r.getModelUris();
                        p && !r.modelsRequested && (l.addModelsFromBucket(p, s), r.modelsRequested = !0);
                        const m = ua(_, a);
                        u.zoom = m;
                        const f = h.possiblyEvaluate(u);
                        if (ca(t1, r, _), ha.shadowUniformsInitialized = !1, ha.useSingleShadowCascade = !!c && 0 === c.getMaxCascadeForTile(_.toUnwrapped()), "shadow" === t1.renderPass && c) {
                            if (1 === t1.currentShadowCascade && r.isInsideFirstShadowMapFrustum) continue;
                            const i = a.calculatePosMatrix(_.toUnwrapped(), a.worldSize);
                            if (ha.tileMatrix.set(i), ha.shadowTileMatrix = Float32Array.from(c.calculateShadowPassMatrixFromMatrix(i)), ha.aabb.min.fill(0), ha.aabb.max[0] = ha.aabb.max[1] = e.ab, ha.aabb.max[2] = 0, pa(r, ha, t1, o.scope)) continue;
                        }
                        const g = 1 << _.canonical.z, v = [
                            ((n.x - _.wrap) * g - _.canonical.x) * e.ab,
                            (n.y * g - _.canonical.y) * e.ab,
                            n.z * g * e.ab
                        ];
                        t1.conflationActive && Object.keys(r.instancesPerModel).length > 0 && t1.style.isLayerClipped(o, i.getSource()) && r.updateReplacement(_, t1.replacementSource, d, s) && (r.uploaded = !1, r.upload(t1.context));
                        for(let e in r.instancesPerModel){
                            const i = r.instancesPerModel[e];
                            i.features.length > 0 && (e = f.evaluate(i.features[0].feature, {}));
                            const a = l.getModel(e, s);
                            if (a && a.uploaded) for (const e of a.nodes)da(t1, o, e, i, v, _, ha);
                        }
                    }
                }(t1, i, o, r, "vector" === h.type ? o.scope : ""), void c();
                if (!h.loaded()) return;
                if ("batched-model" === h.type) return function(t1, i, o, r) {
                    o.resetLayerRenderingStats(t1);
                    const s = t1.context, a = t1.transform, n = t1.style.fog, l = t1.shadowRenderer;
                    if ("mercator" !== a.projection.name) return void e.w(`Drawing 3D landmark models for ${a.projection.name} projection is not yet implemented`);
                    const c = t1.transform.getFreeCameraOptions().position, h = e.a6.vec3.scale([], [
                        c.x,
                        c.y,
                        c.z
                    ], t1.transform.worldSize), u = e.a6.vec3.negate([], h), d = e.a6.mat4.identity([]), _ = e.de(a.center.lat, a.zoom), p = e.a6.mat4.fromScaling([], [
                        1,
                        1,
                        1 / _
                    ]);
                    e.a6.mat4.translate(d, d, u);
                    const m = o.paint.get("model-opacity"), f = new Li(s.gl.LEQUAL, Li.ReadWrite, t1.depthRangeFor3D), g = new Li(s.gl.LEQUAL, Li.ReadOnly, t1.depthRangeFor3D), v = new e.c9([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]), x = "shadow" === t1.renderPass, y = x && l ? l.getCurrentCascadeFrustum() : a.getFrustum(a.scaleZoom(a.worldSize)), b = o.paint.get("model-front-cutoff"), w = b[2] < 1, T = Wi(t1, o.paint.get("model-cutoff-fade-range")), E = o.getLayerRenderingStats();
                    (function(e, t1, i, o) {
                        const r = e.terrain ? e.terrain.exaggeration() : 0, s = e.transform.zoom;
                        for (const a of o){
                            const o = t1.getTile(a).getBucket(i);
                            o && (e.conflationActive && o.updateReplacement(a, e.replacementSource), o.evaluateScale(e, i), e.terrain && r > 0 && o.elevationUpdate(e.terrain, r, a, i.source), o.needsReEvaluation(e, s, i) && o.evaluate(i));
                        }
                    })(t1, i, o, r), function() {
                        let c, u, C;
                        w ? (c = r.length - 1, u = -1, C = -1) : (c = 0, u = r.length, C = 1);
                        const S = new Float64Array(16), I = e.a6.vec3.create(), D = new e.P(0, 0);
                        for(let R = c; R !== u; R += C){
                            const c = r[R], u = i.getTile(c).getBucket(o);
                            if (!u || !u.uploaded) continue;
                            let C = !1;
                            l && (C = 0 === l.getMaxCascadeForTile(c.toUnwrapped()));
                            const A = a.calculatePosMatrix(c.toUnwrapped(), a.worldSize), L = u.modelTraits;
                            !x && w && (e.a6.mat4.invert(S, A), e.a6.vec3.transformMat4(I, h, S), D.x = I[0], D.y = I[1]);
                            const P = [];
                            for (const i of u.getNodesInfo()){
                                if (i.hiddenByReplacement) continue;
                                if (!i.node.meshes) continue;
                                const o = i.node;
                                let r = 0;
                                t1.terrain && o.elevation && (r = o.elevation * t1.terrain.exaggeration());
                                const s = (()=>{
                                    const t1 = i.aabb;
                                    return v.min = [
                                        ...t1.min
                                    ], v.max = [
                                        ...t1.max
                                    ], v.min[2] += r, v.max[2] += r, e.a6.vec3.transformMat4(v.min, v.min, A), e.a6.vec3.transformMat4(v.max, v.max, A), v;
                                })(), n = i.evaluatedScale;
                                if (n[0] <= 1 && n[1] <= 1 && n[2] <= 1 && 0 === s.intersects(y)) continue;
                                if (!x && w) {
                                    const t1 = 1 / 6;
                                    i.cameraCollisionOpacity = h[0] > s.min[0] && h[0] < s.max[0] && h[1] > s.min[1] && h[1] < s.max[1] && h[2] * _ < s.max[2] && o.footprint && e.bu(D, o.footprint) ? Math.max(i.cameraCollisionOpacity - t1, 0) : Math.min(1, i.cameraCollisionOpacity + t1);
                                }
                                const l = [
                                    ...A
                                ], c = o.anchor ? o.anchor[0] : 0, u = o.anchor ? o.anchor[1] : 0;
                                e.a6.mat4.translate(l, l, [
                                    c * (n[0] - 1),
                                    u * (n[1] - 1),
                                    r
                                ]), e.a6.vec3.exactEquals(n, e.dh) || e.a6.mat4.scale(l, l, n);
                                const d = e.a6.mat4.multiply([], l, o.matrix), p = e.a6.mat4.multiply([], a.expandedFarZProjMatrix, d), f = e.a6.mat4.multiply([], a.expandedFarZProjMatrix, l), g = e.a6.vec4.transformMat4([], [
                                    c,
                                    u,
                                    r,
                                    1
                                ], p)[2];
                                o.hidden = !1;
                                let E = m;
                                x || (w && (E *= i.cameraCollisionOpacity, E *= fa(l, a, i.aabb, b)), E *= ma(T, g)), 0 !== E ? P.push({
                                    nodeInfo: i,
                                    depth: g,
                                    opacity: E,
                                    wvpForNode: p,
                                    wvpForTile: f,
                                    nodeModelMatrix: d,
                                    tileModelMatrix: l
                                }) : o.hidden = !0;
                            }
                            x || P.sort((e, t1)=>!w || 1 === e.opacity && 1 === t1.opacity ? e.depth < t1.depth ? -1 : 1 : 1 === e.opacity ? -1 : 1 === t1.opacity ? 1 : e.depth > t1.depth ? -1 : 1);
                            for (const i of P){
                                const r = i.nodeInfo, c = r.node;
                                let h = e.a6.mat4.multiply([], p, i.tileModelMatrix);
                                e.a6.mat4.multiply(h, d, h);
                                const u = e.a6.mat4.invert([], h);
                                e.a6.mat4.transpose(u, u), e.a6.mat4.scale(u, u, _a), h = e.a6.mat4.multiply(h, h, c.matrix);
                                const _ = "light-beam" === t1.renderPass, m = L & e.dj.HasMapboxMeshFeatures, v = m ? 0 : r.evaluatedRMEA[0][2];
                                for(let e = 0; e < c.meshes.length; ++e){
                                    const d = c.meshes[e], p = e === c.lightMeshIndex;
                                    let y = i.wvpForNode;
                                    if (p) {
                                        if (!_ && !t1.terrain && t1.shadowRenderer) {
                                            t1.currentLayer < t1.firstLightBeamLayer && (t1.firstLightBeamLayer = t1.currentLayer);
                                            continue;
                                        }
                                        y = i.wvpForTile;
                                    } else if (_) continue;
                                    const b = {
                                        defines: []
                                    }, w = [];
                                    if (sa(b.defines, w, d, t1, o.lut), m || b.defines.push("DIFFUSE_SHADED"), C && b.defines.push("SHADOWS_SINGLE_CASCADE"), E && (x ? E.numRenderedVerticesInShadowPass += d.vertexArray.length : E.numRenderedVerticesInTransparentPass += d.vertexArray.length), x) {
                                        la(d, i.nodeModelMatrix, t1, o);
                                        continue;
                                    }
                                    let T = null;
                                    if (n) {
                                        const e = ra(i.nodeModelMatrix, t1.transform);
                                        if (T = new Float32Array(e), "globe" !== a.projection.name) {
                                            const t1 = d.aabb.min, i = d.aabb.max, [o, r] = n.getOpacityForBounds(e, t1[0], t1[1], i[0], i[1]);
                                            b.overrideFog = o >= Oe || r >= Oe;
                                        }
                                    }
                                    const S = d.material;
                                    let I;
                                    S.occlusionTexture && S.occlusionTexture.offsetScale && (I = S.occlusionTexture.offsetScale, b.defines.push("OCCLUSION_TEXTURE_TRANSFORM")), !x && l && (l.useNormalOffset = !!d.normalBuffer);
                                    const D = t1.getOrCreateProgram("model", b);
                                    !x && l && l.setupShadowsFromMatrix(i.tileModelMatrix, D, l.useNormalOffset), t1.uploadCommonUniforms(s, D, null, T);
                                    const R = S.pbrMetallicRoughness;
                                    R.metallicFactor = .9, R.roughnessFactor = .5;
                                    const A = ns(new Float32Array(y), new Float32Array(h), new Float32Array(u), new Float32Array(c.matrix), t1, i.opacity, R.baseColorFactor.toRenderColor(null), S.emissiveFactor, R.metallicFactor, R.roughnessFactor, S, v, o, [
                                        0,
                                        0,
                                        0
                                    ], I);
                                    !p && (r.hasTranslucentParts || i.opacity < 1) && D.draw(t1, s.gl.TRIANGLES, f, Mi.disabled, Ai.disabled, Fi.backCCW, A, o.id, d.vertexBuffer, d.indexBuffer, d.segments, o.paint, t1.transform.zoom, void 0, w), D.draw(t1, s.gl.TRIANGLES, p ? g : f, Mi.disabled, p || i.opacity < 1 || r.hasTranslucentParts ? Ai.alphaBlended : Ai.unblended, Fi.backCCW, A, o.id, d.vertexBuffer, d.indexBuffer, d.segments, o.paint, t1.transform.zoom, void 0, w);
                                }
                            }
                        }
                    }();
                }(t1, i, o, r), void c();
                if ("model" !== h.type) return;
                const u = h.getModels(), d = [], _ = t1.transform.getFreeCameraOptions().position, p = e.a6.vec3.scale([], [
                    _.x,
                    _.y,
                    _.z
                ], t1.transform.worldSize);
                e.a6.vec3.negate(p, p);
                const m = [], f = [];
                let g = 0;
                for (const i of u){
                    const r = o.paint.get("model-rotation").constantOr(null), s = o.paint.get("model-scale").constantOr(null), a = o.paint.get("model-translation").constantOr(null);
                    i.computeModelMatrix(t1, r, s, a, !0, !0, !1);
                    const n = e.a6.mat4.identity([]), l = e.de(i.position.lat, t1.transform.zoom), c = e.a6.mat4.fromScaling([], [
                        1,
                        1,
                        1 / l
                    ]);
                    e.a6.mat4.translate(n, n, p), d.push({
                        zScaleMatrix: c,
                        negCameraPosMatrix: n
                    });
                    for (const e of i.nodes)na(t1.transform, e, i.matrix, t1.transform.expandedFarZProjMatrix, g, m, f);
                    g++;
                }
                if (m.sort((e, t1)=>t1.depth - e.depth), "shadow" !== t1.renderPass) {
                    if (1 === s) for (const e of f)aa(e, t1, o, d[e.modelIndex], Mi.disabled, t1.colorModeForRenderPass());
                    else {
                        for (const e of f)aa(e, t1, o, d[e.modelIndex], Mi.disabled, Ai.disabled);
                        for (const e of f)aa(e, t1, o, d[e.modelIndex], t1.stencilModeFor3D(), t1.colorModeForRenderPass());
                        t1.resetStencilClippingMasks();
                    }
                    for (const e of m)aa(e, t1, o, d[e.modelIndex], Mi.disabled, t1.colorModeForRenderPass());
                    c();
                } else {
                    for (const e of f)la(e.mesh, e.nodeModelMatrix, t1, o);
                    for (const e of m)la(e.mesh, e.nodeModelMatrix, t1, o);
                    c();
                }
            }
        }, ba = {
            model: function(e, t1, i) {
                const o = t1.getSource();
                if (!o.loaded()) return;
                if ("vector" === o.type || "geojson" === o.type) return void (i.modelManager && i.modelManager.upload(i, "vector" === o.type ? e.scope : ""));
                if ("batched-model" === o.type) return;
                if ("model" !== o.type) return;
                const r = o.getModels();
                for (const e of r)e.upload(i.context);
            },
            raster: function(e, t1, i) {
                const o = t1.getSource();
                if (!(o instanceof Qe && o.loaded())) return;
                const r = e.sourceLayer || o.rasterLayerIds && o.rasterLayerIds[0];
                if (!r) return;
                const s = e.paint.get("raster-array-band") || o.getInitialBand(r);
                if (null == s) return;
                const a = t1.getIds().map((e)=>t1.getTileByID(e));
                for (const e of a)e.updateNeeded(r, s) && o.prepareTile(e, r, s);
            },
            "raster-particle": function(e, t1, i) {
                const o = t1.getSource();
                if (!(o instanceof Qe && o.loaded())) return;
                const r = e.sourceLayer || o.rasterLayerIds && o.rasterLayerIds[0];
                if (!r) return;
                const s = e.paint.get("raster-particle-array-band") || o.getInitialBand(r);
                if (null == s) return;
                const a = t1.getIds().map((e)=>t1.getTileByID(e));
                for (const e of a)e.updateNeeded(r, s) && o.prepareTile(e, r, s);
            }
        };
        class wa {
            constructor(t1, i, o, r){
                this.context = new ps(t1, i), this.transform = o, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.tp = r, this._timeStamp = e.q.now(), this._averageFPS = 0, this._fpsHistory = [], this._dt = 0, this._debugParams = {
                    showTerrainProxyTiles: !1,
                    fpsWindow: 30,
                    continousRedraw: !1,
                    enabledLayers: {}
                };
                const s = [
                    "fill",
                    "line",
                    "symbol",
                    "circle",
                    "heatmap",
                    "fill-extrusion",
                    "raster",
                    "raster-particle",
                    "hillshade",
                    "model",
                    "background",
                    "sky"
                ];
                for (const e of s)this._debugParams.enabledLayers[e] = !0;
                r.registerParameter(this._debugParams, [
                    "Terrain"
                ], "showTerrainProxyTiles", {}, ()=>{
                    this.style.map.triggerRepaint();
                }), r.registerParameter(this._debugParams, [
                    "FPS"
                ], "fpsWindow", {
                    min: 1,
                    max: 100,
                    step: 1
                }), r.registerBinding(this._debugParams, [
                    "FPS"
                ], "continousRedraw", {
                    readonly: !0,
                    label: "continuous redraw"
                }), r.registerBinding(this, [
                    "FPS"
                ], "_averageFPS", {
                    readonly: !0,
                    label: "value"
                }), r.registerBinding(this, [
                    "FPS"
                ], "_averageFPS", {
                    readonly: !0,
                    label: "graph",
                    view: "graph",
                    min: 0,
                    max: 200
                });
                for (const e of s)r.registerParameter(this._debugParams.enabledLayers, [
                    "Debug",
                    "Layers"
                ], e);
                this.occlusionParams = new xa(r), this.setup(), this.numSublayers = vt.maxUnderzooming + vt.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {}, this.conflationActive = !1, this.replacementSource = new e.dl, this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = !1, this._cachedTileFogOpacities = {}, this._shadowRenderer = new Ki(this), this._wireframeDebugCache = new va, this.renderDefaultNorthPole = !0, this.renderDefaultSouthPole = !0, this.layersWithOcclusionOpacity = [];
                const a = new e.r({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0));
                this.emptyDepthTexture = new e.T(this.context, a, t1.RGBA8), this._clippingActiveLastFrame = !1;
            }
            updateTerrain(e, t1) {
                const i = !!e && !!e.terrain && this.transform.projection.supportsTerrain;
                if (!(i || this._terrain && this._terrain.enabled)) return;
                this._terrain || (this._terrain = new Ar(this, e));
                const o = this._terrain;
                this.transform.elevation = i ? o : null, o.update(e, this.transform, t1), this.transform.elevation && !o.enabled && (this.transform.elevation = null);
            }
            _updateFog(e) {
                const t1 = e.fog;
                if (!t1 || "globe" === this.transform.projection.name || t1.getOpacity(this.transform.pitch) < 1 || t1.properties.get("horizon-blend") < .03) return void (this.transform.fogCullDistSq = null);
                const [i, o] = t1.getFovAdjustedRange(this.transform._fov);
                if (i > o) return void (this.transform.fogCullDistSq = null);
                const r = i + .78 * (o - i);
                this.transform.fogCullDistSq = r * r;
            }
            get terrain() {
                return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled || this._forceTerrainMode ? this._terrain : null;
            }
            get forceTerrainMode() {
                return this._forceTerrainMode;
            }
            set forceTerrainMode(e) {
                e && !this._terrain && (this._terrain = new Ar(this, this.style)), this._forceTerrainMode = e;
            }
            get shadowRenderer() {
                return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
            }
            get wireframeDebugCache() {
                return this._wireframeDebugCache;
            }
            resize(t1, i) {
                if (this.width = t1 * e.q.devicePixelRatio, this.height = i * e.q.devicePixelRatio, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e of this.style.order)this.style._mergedLayers[e].resize();
            }
            setup() {
                const t1 = this.context, i = new e.a_;
                i.emplaceBack(0, 0), i.emplaceBack(e.ab, 0), i.emplaceBack(0, e.ab), i.emplaceBack(e.ab, e.ab), this.tileExtentBuffer = t1.createVertexBuffer(i, e.b0.members), this.tileExtentSegments = e.b1.simpleSegment(0, 0, 4, 2);
                const o = new e.a_;
                o.emplaceBack(0, 0), o.emplaceBack(e.ab, 0), o.emplaceBack(0, e.ab), o.emplaceBack(e.ab, e.ab), this.debugBuffer = t1.createVertexBuffer(o, e.b0.members), this.debugSegments = e.b1.simpleSegment(0, 0, 4, 5);
                const r = new e.a_;
                r.emplaceBack(-1, -1), r.emplaceBack(1, -1), r.emplaceBack(-1, 1), r.emplaceBack(1, 1), this.viewportBuffer = t1.createVertexBuffer(r, e.b0.members), this.viewportSegments = e.b1.simpleSegment(0, 0, 4, 2);
                const s = new e.aN;
                s.emplaceBack(0, 0, 0, 0), s.emplaceBack(e.ab, 0, e.ab, 0), s.emplaceBack(0, e.ab, 0, e.ab), s.emplaceBack(e.ab, e.ab, e.ab, e.ab), this.mercatorBoundsBuffer = t1.createVertexBuffer(s, e.b3.members), this.mercatorBoundsSegments = e.b1.simpleSegment(0, 0, 4, 2);
                const a = new e.aO;
                a.emplaceBack(0, 1, 2), a.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t1.createIndexBuffer(a);
                const n = new e.a$;
                for (const e of [
                    0,
                    1,
                    3,
                    2,
                    0
                ])n.emplaceBack(e);
                this.debugIndexBuffer = t1.createIndexBuffer(n), this.emptyTexture = new e.T(t1, new e.r({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0)), t1.gl.RGBA8), this.identityMat = e.a6.mat4.create();
                const l = this.context.gl;
                this.stencilClearMode = new Mi({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.loadTimeStamps.push(performance.now());
            }
            getMercatorTileBoundsBuffers() {
                return {
                    tileBoundsBuffer: this.mercatorBoundsBuffer,
                    tileBoundsIndexBuffer: this.quadTriangleIndexBuffer,
                    tileBoundsSegments: this.mercatorBoundsSegments
                };
            }
            getTileBoundsBuffers(e) {
                return e._makeTileBoundsBuffers(this.context, this.transform.projection), e._tileBoundsBuffer ? {
                    tileBoundsBuffer: e._tileBoundsBuffer,
                    tileBoundsIndexBuffer: e._tileBoundsIndexBuffer,
                    tileBoundsSegments: e._tileBoundsSegments
                } : this.getMercatorTileBoundsBuffers();
            }
            clearStencil() {
                const e = this.context.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, e.TRIANGLES, Li.disabled, this.stencilClearMode, Ai.disabled, Fi.disabled, Cr(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            resetStencilClippingMasks() {
                this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
            }
            _renderTileClippingMasks(e, t1, i) {
                if (!t1 || this.currentStencilSource === t1.id || !e.isTileClipped() || !i || 0 === i.length) return;
                if (this._tileClippingMaskIDs && !this.terrain) {
                    let e = !1;
                    for (const t1 of i)if (void 0 === this._tileClippingMaskIDs[t1.key]) {
                        e = !0;
                        break;
                    }
                    if (!e) return;
                }
                this.currentStencilSource = t1.id;
                const o = this.context, r = o.gl;
                this.nextStencilID + i.length > 256 && this.clearStencil(), o.setColorMode(Ai.disabled), o.setDepthMode(Li.disabled);
                const s = this.getOrCreateProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const e of i){
                    const i = t1.getTile(e), o = this._tileClippingMaskIDs[e.key] = this.nextStencilID++, { tileBoundsBuffer: a, tileBoundsIndexBuffer: n, tileBoundsSegments: l } = this.getTileBoundsBuffers(i);
                    s.draw(this, r.TRIANGLES, Li.disabled, new Mi({
                        func: r.ALWAYS,
                        mask: 0
                    }, o, 255, r.KEEP, r.KEEP, r.REPLACE), Ai.disabled, Fi.disabled, Cr(e.projMatrix), "$clipping", a, n, l);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const e = this.nextStencilID++, t1 = this.context.gl;
                return new Mi({
                    func: t1.NOTEQUAL,
                    mask: 255
                }, e, 255, t1.KEEP, t1.KEEP, t1.REPLACE);
            }
            stencilModeForClipping(e) {
                if (this.terrain) return this.terrain.stencilModeForRTTOverlap(e);
                const t1 = this.context.gl;
                return new Mi({
                    func: t1.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[e.key], 0, t1.KEEP, t1.KEEP, t1.REPLACE);
            }
            stencilConfigForOverlap(e) {
                const t1 = this.context.gl, i = e.sort((e, t1)=>t1.overscaledZ - e.overscaledZ), o = i[i.length - 1].overscaledZ, r = i[0].overscaledZ - o + 1;
                if (r > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + r > 256 && this.clearStencil();
                    const e = {};
                    for(let i = 0; i < r; i++)e[i + o] = new Mi({
                        func: t1.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, t1.KEEP, t1.KEEP, t1.REPLACE);
                    return this.nextStencilID += r, [
                        e,
                        i
                    ];
                }
                return [
                    {
                        [o]: Mi.disabled
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const t1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new Ai([
                        t1.CONSTANT_COLOR,
                        t1.ONE,
                        t1.CONSTANT_COLOR,
                        t1.ONE
                    ], new e.bz(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? Ai.unblended : Ai.alphaBlended;
            }
            colorModeForDrapableLayerRenderPass(t1) {
                const i = this.context.gl;
                return (()=>this.style && this.style.enable3dLights() && this.terrain && this.terrain.renderingToTexture)() && "translucent" === this.renderPass ? new Ai([
                    i.ONE,
                    i.ONE_MINUS_SRC_ALPHA,
                    i.CONSTANT_ALPHA,
                    i.ONE_MINUS_SRC_ALPHA
                ], new e.bz(0, 0, 0, void 0 === t1 ? 0 : t1), [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : this.colorModeForRenderPass();
            }
            depthModeForSublayer(e, t1, i, o = !1) {
                if (this.depthOcclusion) return new Li(this.context.gl.GREATER, Li.ReadOnly, this.depthRangeFor3D);
                if (!this.opaquePassEnabledForLayer() && !o) return Li.disabled;
                const r = 1 - ((1 + this.currentLayer) * this.numSublayers + e) * this.depthEpsilon;
                return new Li(i || this.context.gl.LEQUAL, t1, [
                    r,
                    r
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            blitDepth() {
                const t1 = this.context.gl, i = Math.ceil(this.width), o = Math.ceil(this.height), r = this.context.bindFramebuffer.get(), s = t1.getParameter(t1.TEXTURE_BINDING_2D);
                this.depthFBO && this.depthFBO.width === i && this.depthFBO.height === o || (this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), 0 !== i && 0 !== o && (this.depthFBO = new _s(this.context, i, o, !1, "texture"), this.depthTexture = new e.T(this.context, {
                    width: i,
                    height: o,
                    data: null
                }, t1.DEPTH24_STENCIL8), this.depthFBO.depthAttachment.set(this.depthTexture.texture))), this.context.bindFramebuffer.set(r), t1.bindTexture(t1.TEXTURE_2D, s), this.depthFBO && (t1.bindFramebuffer(t1.READ_FRAMEBUFFER, null), t1.bindFramebuffer(t1.DRAW_FRAMEBUFFER, this.depthFBO.framebuffer), t1.blitFramebuffer(0, 0, i, o, 0, 0, i, o, t1.DEPTH_BUFFER_BIT, t1.NEAREST), t1.bindFramebuffer(t1.FRAMEBUFFER, this.context.bindFramebuffer.current));
            }
            updateAverageFPS() {
                this._fpsHistory.push(0 === this._dt ? 0 : 1e3 / this._dt), this._fpsHistory.length > this._debugParams.fpsWindow && this._fpsHistory.splice(0, this._fpsHistory.length - this._debugParams.fpsWindow), this._averageFPS = Math.round(this._fpsHistory.reduce((e, t1)=>e + t1 / this._fpsHistory.length, 0));
            }
            render(t1, i) {
                const o = e.q.now();
                this._dt = o - this._timeStamp, this._timeStamp = o, this._wireframeDebugCache.update(this.frameCounter), this._debugParams.continousRedraw = t1.map.repaint, this.style = t1, this.options = i;
                const r = this.style._mergedLayers, s = this.style.order.filter((e)=>{
                    const t1 = r[e];
                    return !(t1.type in this._debugParams.enabledLayers) || this._debugParams.enabledLayers[t1.type];
                });
                let a = !1, n = !1;
                for (const e of s){
                    const t1 = r[e];
                    "circle" === t1.type && (a = !0), "symbol" === t1.type && (t1.hasInitialOcclusionOpacityProperties ? n = !0 : a = !0);
                }
                const l = s.map((e)=>r[e]), c = this.style._mergedSourceCaches;
                this.imageManager = t1.imageManager, this.modelManager = t1.modelManager, this.symbolFadeChange = t1.placement.symbolFadeChange(e.q.now()), this.imageManager.beginFrame();
                let h = 0, u = !1;
                for(const e in c){
                    const t1 = c[e];
                    t1.used && (t1.prepare(this.context), t1.getSource().usedInConflation && ++h);
                }
                let d = !1;
                for (const e of l)e.isHidden(this.transform.zoom) || ("clip" === e.type && (d = !0), this.prepareLayer(e));
                const _ = {}, p = {}, m = {}, f = {}, g = {};
                for(const e in c){
                    const t1 = c[e];
                    _[e] = t1.getVisibleCoordinates(), p[e] = _[e].slice().reverse(), m[e] = t1.getVisibleCoordinates(!0).reverse(), f[e] = t1.getShadowCasterCoordinates(), g[e] = t1.sortCoordinatesByDistance(_[e]);
                }
                const v = (e)=>{
                    const t1 = this.style.getLayerSourceCache(e);
                    return t1 && t1.used ? t1.getSource() : null;
                };
                if (h || d || this._clippingActiveLastFrame) {
                    const t1 = [], i = [];
                    let o = 0;
                    for (const e of l)this.isSourceForClippingOrConflation(e, v(e)) && (t1.push(e), i.push(o)), o++;
                    if (t1 && (d || t1.length > 1) || this._clippingActiveLastFrame) {
                        d = !1;
                        const o = [];
                        for(let r = 0; r < t1.length; r++){
                            const s = t1[r], a = i[r], n = this.style.getLayerSourceCache(s);
                            if (!n || !n.used || !n.getSource().usedInConflation && "clip" !== s.type) continue;
                            let l = e.dn, c = e.bs.None;
                            const h = [];
                            let u = !0;
                            if ("clip" === s.type) {
                                l = a;
                                for (const t1 of s.layout.get("clip-layer-types"))c |= "model" === t1 ? e.bs.Model : "symbol" === t1 ? e.bs.Symbol : e.bs.FillExtrusion;
                                for (const e of s.layout.get("clip-layer-scope"))h.push(e);
                                s.isHidden(this.transform.zoom) ? u = !1 : d = !0;
                            }
                            u && o.push({
                                layer: s.fqid,
                                cache: n,
                                order: l,
                                clipMask: c,
                                clipScope: h
                            });
                        }
                        this.replacementSource.setSources(o), u = !0;
                    }
                }
                this._clippingActiveLastFrame = d, u || this.replacementSource.clear(), this.conflationActive = u, this.minCutoffZoom = 0, this.longestCutoffRange = 0, this.opaquePassCutoff = 1 / 0, this._lastOcclusionLayer = -1, this.layersWithOcclusionOpacity = [];
                for(let e = 0; e < l.length; e++){
                    const t1 = l[e], i = t1.cutoffRange();
                    if (this.longestCutoffRange = Math.max(i, this.longestCutoffRange), i > 0) {
                        const e = v(t1);
                        e && (this.minCutoffZoom = Math.max(e.minzoom, this.minCutoffZoom)), t1.minzoom && (this.minCutoffZoom = Math.max(t1.minzoom, this.minCutoffZoom));
                    }
                    t1.is3D() && (this.opaquePassCutoff === 1 / 0 && (this.opaquePassCutoff = e), this._lastOcclusionLayer = e);
                }
                const x = this.style && this.style.fog;
                x ? (this._fogVisible = 0 !== x.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = x.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = !1, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(m), this.opaquePassCutoff = 0);
                const y = this._shadowRenderer;
                if (y) {
                    y.updateShadowParameters(this.transform, this.style.directionalLight);
                    for(const e in c)for (const t1 of _[e]){
                        let e = {
                            min: 0,
                            max: 0
                        };
                        this.terrain && (e = this.terrain.getMinMaxForTile(t1) || e), y.addShadowReceiver(t1.toUnwrapped(), e.min, e.max);
                    }
                }
                if ("globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e.dm(this.context)), this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new oa(this)), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), !U.has(this.context.gl)) return;
                this.renderPass = "offscreen";
                for (const e of l){
                    const i = t1.getLayerSourceCache(e);
                    if (!e.hasOffscreenPass() || e.isHidden(this.transform.zoom)) continue;
                    const o = i ? p[i.id] : void 0;
                    ("custom" === e.type || "raster" === e.type || "raster-particle" === e.type || e.isSky() || o && o.length) && this.renderLayer(this, i, e, o);
                }
                this.depthRangeFor3D = [
                    0,
                    1 - (l.length + 2) * this.numSublayers * this.depthEpsilon
                ], this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, f)), this.context.bindFramebuffer.set(null), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]);
                const b = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(), w = (()=>{
                    if (i.showOverdrawInspector) return e.bz.black;
                    const t1 = this.style.fog;
                    if (t1 && this.transform.projection.supportsFog) {
                        const i = this.style.getLut(t1.scope);
                        if (!b) {
                            const o = t1.properties.get("color").toRenderColor(i).toArray01();
                            return new e.bz(...o);
                        }
                        if (b) {
                            const o = t1.properties.get("space-color").toRenderColor(i).toArray01();
                            return new e.bz(...o);
                        }
                    }
                    return e.bz.transparent;
                })();
                if (this.context.clear({
                    color: w,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && b && this._atmosphere.drawStars(this, this.style.fog), !this.terrain) for(this.currentLayer = s.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const e = l[this.currentLayer], i = t1.getLayerSourceCache(e);
                    if (e.isSky()) continue;
                    const o = i ? (e.is3D() ? g : p)[i.id] : void 0;
                    this._renderTileClippingMasks(e, i, o), this.renderLayer(this, i, e, o);
                }
                if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && b && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || e.a9(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible())) for(this.currentLayer = 0; this.currentLayer < s.length; this.currentLayer++){
                    const e = l[this.currentLayer], i = t1.getLayerSourceCache(e);
                    e.isSky() && this.renderLayer(this, i, e, i ? p[i.id] : void 0);
                }
                function T(e, t1) {
                    let i;
                    return t1 && (i = ("symbol" === e.type ? m : e.is3D() ? g : p)[t1.id]), i;
                }
                if (this.renderPass = "translucent", "globe" === this.transform.projection.name) {
                    for(this.renderElevatedRasterBackface = !0, this.currentLayer = 0; this.currentLayer < s.length;){
                        const e = l[this.currentLayer];
                        if ("raster" === e.type || "raster-particle" === e.type) {
                            const i = t1.getLayerSourceCache(e);
                            this.renderLayer(this, i, e, T(e, i));
                        }
                        ++this.currentLayer;
                    }
                    this.renderElevatedRasterBackface = !1;
                }
                this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
                let E = 0;
                y && (E = y.getShadowCastingLayerCount());
                let C = !1, S = -1;
                for(let e = 0; e < s.length; ++e){
                    const t1 = l[e];
                    t1.isHidden(this.transform.zoom) || t1.is3D() && (S = e);
                }
                for(n && -1 === S && (a = !0); this.currentLayer < s.length;){
                    const e = l[this.currentLayer], i = t1.getLayerSourceCache(e);
                    if (e.isSky()) ++this.currentLayer;
                    else if (this.terrain && this.style.isLayerDraped(e)) {
                        if (e.isHidden(this.transform.zoom)) {
                            ++this.currentLayer;
                            continue;
                        }
                        this.currentLayer = this.terrain.renderBatch(this.currentLayer), this._lastOcclusionLayer = Math.max(this.currentLayer, this._lastOcclusionLayer);
                    } else {
                        if (a && !C && this.terrain && !this.transform.isOrthographic && (C = !0, this.blitDepth()), n && -1 !== S && this.currentLayer === S + 1 && !this.transform.isOrthographic && this.blitDepth(), e.is3D() || this.terrain || this._renderTileClippingMasks(e, i, i ? _[i.id] : void 0), this.renderLayer(this, i, e, T(e, i)), !this.terrain && y && E > 0 && e.hasShadowPass() && 0 == --E && (y.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer)) {
                            const e = this.currentLayer;
                            for(this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= e; this.currentLayer++){
                                const e = l[this.currentLayer];
                                if (!e.hasLightBeamPass()) continue;
                                const i = t1.getLayerSourceCache(e);
                                this.renderLayer(this, i, e, i ? p[i.id] : void 0);
                            }
                            this.currentLayer = e, this.renderPass = "translucent";
                        }
                        if (this.currentLayer >= this._lastOcclusionLayer && this.layersWithOcclusionOpacity.length > 0) {
                            const e = this.currentLayer;
                            this.depthOcclusion = !0;
                            for (const e of this.layersWithOcclusionOpacity){
                                this.currentLayer = e;
                                const i = l[this.currentLayer], o = t1.getLayerSourceCache(i), r = o ? p[o.id] : void 0;
                                i.is3D() || this.terrain || this._renderTileClippingMasks(i, o, o ? _[o.id] : void 0), this.renderLayer(this, o, i, r);
                            }
                            this.depthOcclusion = !1, this.currentLayer = e, this.renderPass = "translucent", this.layersWithOcclusionOpacity = [];
                        }
                        ++this.currentLayer;
                    }
                }
                if (this.terrain && this.terrain.postRender(), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
                    let i = null;
                    l.forEach((e)=>{
                        const o = t1.getLayerSourceCache(e);
                        o && !e.isHidden(this.transform.zoom) && o.getVisibleCoordinates().length && (!i || i.getSource().maxzoom < o.getSource().maxzoom) && (i = o);
                    }), i && this.options.showTileBoundaries && ya.debug(this, i, i.getVisibleCoordinates(), e.bz.red, !1, this.options.showParseStatus);
                }
                this.terrain && this._debugParams.showTerrainProxyTiles && ya.debug(this, this.terrain.proxySourceCache, this.terrain.proxyCoords, new e.bz(1, .8, .1, 1), !0, this.options.showParseStatus), this.options.showPadding && function(e) {
                    const t1 = e.transform.padding;
                    Zs(e, e.transform.height - (t1.top || 0), 3, Ns), Zs(e, t1.bottom || 0, 3, Us), Hs(e, t1.left || 0, 3, Gs), Hs(e, e.transform.width - (t1.right || 0), 3, js);
                    const i = e.transform.centerPoint;
                    !function(e, t1, i, o) {
                        Ws(e, t1 - 1, i - 10, 2, 20, o), Ws(e, t1 - 10, i - 1, 20, 2, o);
                    }(e, i.x, e.transform.height - i.y, Vs);
                }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(performance.now()), this.saveCanvasCopy()), u || (this.conflationActive = !1);
            }
            prepareLayer(e) {
                this.gpuTimingStart(e);
                const { unsupportedLayers: t1 } = this.transform.projection, i = !t1 || !t1.includes(e.type);
                if (ba[e.type] && (i || this.terrain && "custom" === e.type)) {
                    const t1 = this.style.getLayerSourceCache(e);
                    ba[e.type](e, t1, this);
                }
                this.gpuTimingEnd();
            }
            renderLayer(e, t1, i, o) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "sky" === i.type || "custom" === i.type || "model" === i.type || "raster" === i.type || "raster-particle" === i.type || o && o.length) && (this.id = i.id, this.gpuTimingStart(i), e.transform.projection.unsupportedLayers && e.transform.projection.unsupportedLayers.includes(i.type) && (!e.terrain || "custom" !== i.type) || "clip" === i.type || ya[i.type](e, t1, i, o, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
            }
            gpuTimingStart(e) {
                if (!this.options.gpuTiming) return;
                const t1 = this.context.extTimerQuery, i = this.context.gl;
                let o = this.gpuTimers[e.id];
                o || (o = this.gpuTimers[e.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: i.createQuery()
                }), o.calls++, i.beginQuery(t1.TIME_ELAPSED_EXT, o.query);
            }
            gpuTimingDeferredRenderStart() {
                if (this.options.gpuTimingDeferredRender) {
                    const e = this.context.extTimerQuery, t1 = this.context.gl, i = t1.createQuery();
                    this.deferredRenderGpuTimeQueries.push(i), t1.beginQuery(e.TIME_ELAPSED_EXT, i);
                }
            }
            gpuTimingDeferredRenderEnd() {
                this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            gpuTimingEnd() {
                this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
                const e = this.gpuTimers;
                return this.gpuTimers = {}, e;
            }
            collectDeferredRenderGpuQueries() {
                const e = this.deferredRenderGpuTimeQueries;
                return this.deferredRenderGpuTimeQueries = [], e;
            }
            queryGpuTimers(e) {
                const t1 = {};
                for(const i in e){
                    const o = e[i], r = this.context.extTimerQuery, s = r.getQueryParameter(o.query, this.context.gl.QUERY_RESULT) / 1e6;
                    r.deleteQueryEXT(o.query), t1[i] = s;
                }
                return t1;
            }
            queryGpuTimeDeferredRender(e) {
                if (!this.options.gpuTimingDeferredRender) return 0;
                const t1 = this.context.extTimerQuery, i = this.context.gl;
                let o = 0;
                for (const r of e)o += t1.getQueryParameter(r, i.QUERY_RESULT) / 1e6, t1.deleteQueryEXT(r);
                return o;
            }
            translatePosMatrix(t1, i, o, r, s) {
                if (!o[0] && !o[1]) return t1;
                const a = s ? "map" === r ? this.transform.angle : 0 : "viewport" === r ? -this.transform.angle : 0;
                if (a) {
                    const e = Math.sin(a), t1 = Math.cos(a);
                    o = [
                        o[0] * t1 - o[1] * e,
                        o[0] * e + o[1] * t1
                    ];
                }
                const n = [
                    s ? o[0] : e.ak(i, o[0], this.transform.zoom),
                    s ? o[1] : e.ak(i, o[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return e.a6.mat4.translate(l, t1, n), l;
            }
            saveTileTexture(e) {
                const t1 = e.size[0], i = this._tileTextures[t1];
                i ? i.push(e) : this._tileTextures[t1] = [
                    e
                ];
            }
            getTileTexture(e) {
                const t1 = this._tileTextures[e];
                return t1 && t1.length > 0 ? t1.pop() : null;
            }
            terrainRenderModeElevated() {
                return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture || this.forceTerrainMode;
            }
            linearFloatFilteringSupported() {
                return null != this.context.extTextureFloatLinear;
            }
            currentGlobalDefines(e, t1, i) {
                const o = void 0 === i ? this.terrain && this.terrain.renderingToTexture : i, r = [];
                return this.style && this.style.enable3dLights() && ("globeRaster" === e || "terrainRaster" === e ? (r.push("LIGHTING_3D_MODE"), r.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : o || r.push("LIGHTING_3D_MODE")), "shadow" === this.renderPass ? this._shadowMapDebug || r.push("DEPTH_TEXTURE") : this.shadowRenderer && (this.shadowRenderer.useNormalOffset ? r.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET") : r.push("RENDER_SHADOWS", "DEPTH_TEXTURE")), this.terrainRenderModeElevated() && (r.push("TERRAIN"), this.linearFloatFilteringSupported() && r.push("TERRAIN_DEM_FLOAT_FORMAT")), "globe" === this.transform.projection.name && r.push("GLOBE"), !this._fogVisible || o || void 0 !== t1 && !t1 || r.push("FOG", "FOG_DITHERING"), o && r.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && r.push("OVERDRAW_INSPECTOR"), r;
            }
            getOrCreateProgram(e, t1) {
                this.cache = this.cache || {};
                const i = t1 && t1.defines || [], o = t1 && t1.config, r = this.currentGlobalDefines(e, t1 && t1.overrideFog, t1 && t1.overrideRtt).concat(i), s = zr.cacheKey(Io[e], e, r, o);
                return this.cache[s] || (this.cache[s] = new zr(this.context, e, Io[e], o, cs[e], r)), this.cache[s];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA8));
            }
            destroy() {
                this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy(), this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), this.emptyDepthTexture && this.emptyDepthTexture.destroy();
            }
            prepareDrawTile() {
                this.terrain && this.terrain.prepareDrawTile();
            }
            uploadCommonLightUniforms(t1, i) {
                if (this.style.enable3dLights()) {
                    const o = this.style.directionalLight, r = this.style.ambientLight;
                    if (o && r) {
                        const s = ((t1, i, o)=>{
                            const r = t1.properties.get("direction"), s = t1.properties.get("color").toRenderColor(o.getLut(t1.scope)).toArray01(), a = t1.properties.get("intensity"), n = i.properties.get("color").toRenderColor(o.getLut(i.scope)).toArray01(), l = i.properties.get("intensity"), c = [
                                r.x,
                                r.y,
                                r.z
                            ], h = e.cH(n, l), u = e.cH(s, a);
                            return {
                                u_lighting_ambient_color: h,
                                u_lighting_directional_dir: c,
                                u_lighting_directional_color: u,
                                u_ground_radiance: Lr(c, u, h)
                            };
                        })(o, r, this.style);
                        i.setLightsUniformValues(t1, s);
                    }
                }
            }
            uploadCommonUniforms(t1, i, o, r, s) {
                if (this.uploadCommonLightUniforms(t1, i), this.terrain && this.terrain.renderingToTexture) return;
                const a = this.style.fog;
                if (a) {
                    const s = a.getOpacity(this.transform.pitch), n = ((t1, i, o, r, s, a, n, l, c, h, u, d)=>{
                        const _ = t1.transform, p = i.properties.get("color").toRenderColor(t1.style.getLut(i.scope)).toArray01();
                        p[3] = r;
                        const m = t1.frameCounter / 1e3 % 1, [f, g] = i.properties.get("vertical-range");
                        return {
                            u_fog_matrix: o ? _.calculateFogTileMatrix(o) : d || t1.identityMat,
                            u_fog_range: i.getFovAdjustedRange(_._fov),
                            u_fog_color: p,
                            u_fog_horizon_blend: i.properties.get("horizon-blend"),
                            u_fog_vertical_limit: [
                                Math.min(f, g),
                                g
                            ],
                            u_fog_temporal_offset: m,
                            u_frustum_tl: s,
                            u_frustum_tr: a,
                            u_frustum_br: n,
                            u_frustum_bl: l,
                            u_globe_pos: c,
                            u_globe_radius: h,
                            u_viewport: u,
                            u_globe_transition: e.a9(_.zoom),
                            u_is_globe: +("globe" === _.projection.name)
                        };
                    })(this, a, o, s, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [
                        this.transform.width * e.q.devicePixelRatio,
                        this.transform.height * e.q.devicePixelRatio
                    ], r);
                    i.setFogUniformValues(t1, n);
                }
                s && i.setCutoffUniformValues(t1, s.uniformValues);
            }
            setTileLoadedFlag(e) {
                this.tileLoaded = e;
            }
            saveCanvasCopy() {
                const e = this.canvasCopy();
                e && (this.frameCopies.push(e), this.tileLoaded = !1);
            }
            canvasCopy() {
                const e = this.context.gl, t1 = e.createTexture();
                return e.bindTexture(e.TEXTURE_2D, t1), e.copyTexImage2D(e.TEXTURE_2D, 0, e.RGBA, 0, 0, e.drawingBufferWidth, e.drawingBufferHeight, 0), t1;
            }
            getCanvasCopiesAndTimestamps() {
                return {
                    canvasCopies: this.frameCopies,
                    timeStamps: this.loadTimeStamps
                };
            }
            averageElevationNeedsEasing() {
                if (!this.transform._elevation) return !1;
                const e = this.style && this.style.fog;
                return !!e && 0 !== e.getOpacity(this.transform.pitch);
            }
            getBackgroundTiles() {
                const e = this._backgroundTiles, t1 = this._backgroundTiles = {}, i = this.transform.coveringTiles({
                    tileSize: 512
                });
                for (const o of i)t1[o.key] = e[o.key] || new pt(o, 512, this.transform.tileZoom, this);
                return t1;
            }
            clearBackgroundTiles() {
                this._backgroundTiles = {};
            }
            isSourceForClippingOrConflation(e, t1) {
                return !(!e.is3D() || "clip" !== e.type && (e.minzoom && e.minzoom > this.transform.zoom || (this.style._clipLayerPresent || "building" !== e.sourceLayer) && (!t1 || "batched-model" !== t1.type)));
            }
            isTileAffectedByFog(e) {
                if (!this.style || !this.style.fog) return !1;
                if ("globe" === this.transform.projection.name) return !0;
                let t1 = this._cachedTileFogOpacities[e.key];
                return t1 || (this._cachedTileFogOpacities[e.key] = t1 = this.style.fog.getOpacityForTile(e)), t1[0] >= Oe || t1[1] >= Oe;
            }
            setupDepthForOcclusion(e, t1, i) {
                const o = this.context, r = o.gl, s = !!i;
                var a;
                i || (i = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                }), o.activeTexture.set(r.TEXTURE3), e && this.depthFBO && this.depthTexture ? (this.depthTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), i.u_depth_size_inv = [
                    1 / this.depthFBO.width,
                    1 / this.depthFBO.height
                ], i.u_depth_range_unpack = [
                    2 / ((a = this.depthRangeFor3D)[1] - a[0]),
                    -1 - 2 * a[0] / (a[1] - a[0])
                ], i.u_occluder_half_size = .5 * this.occlusionParams.occluderSize, i.u_occlusion_depth_offset = this.occlusionParams.depthOffset) : this.emptyDepthTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), o.activeTexture.set(r.TEXTURE0), s || t1.setTerrainUniformValues(o, i);
            }
        }
        function Ta(e, t1) {
            let i = !1, o = null;
            const r = ()=>{
                o = null, i && (e(), o = setTimeout(r, t1), i = !1);
            };
            return ()=>(i = !0, o || r(), o);
        }
        class Ea {
            constructor(t1){
                this._hashName = t1 && encodeURIComponent(t1), e.aJ([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = Ta(this._updateHashUnthrottled.bind(this), 300);
            }
            addTo(e) {
                return this._map = e, window.addEventListener("hashchange", this._onHashChange, !1), e.on("moveend", this._updateHash), this;
            }
            remove() {
                return this._map ? (this._map.off("moveend", this._updateHash), window.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
            }
            getHashString() {
                const e = this._map;
                if (!e) return "";
                const t1 = Ca(e);
                if (this._hashName) {
                    const e = this._hashName;
                    let i = !1;
                    const o = location.hash.slice(1).split("&").map((o)=>{
                        const r = o.split("=")[0];
                        return r === e ? (i = !0, `${r}=${t1}`) : o;
                    }).filter((e)=>e);
                    return i || o.push(`${e}=${t1}`), `#${o.join("&")}`;
                }
                return `#${t1}`;
            }
            _getCurrentHash() {
                const e = location.hash.replace("#", "");
                if (this._hashName) {
                    let t1;
                    return e.split("&").map((e)=>e.split("=")).forEach((e)=>{
                        e[0] === this._hashName && (t1 = e);
                    }), (t1 && t1[1] || "").split("/");
                }
                return e.split("/");
            }
            _onHashChange() {
                const e = this._map;
                if (!e) return !1;
                const t1 = this._getCurrentHash();
                if (t1.length >= 3 && !t1.some((e)=>isNaN(e))) {
                    const i = e.dragRotate.isEnabled() && e.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : e.getBearing();
                    return e.jumpTo({
                        center: [
                            +t1[2],
                            +t1[1]
                        ],
                        zoom: +t1[0],
                        bearing: i,
                        pitch: +(t1[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                history.replaceState(history.state, "", location.href.replace(/(#.+)?$/, this.getHashString()));
            }
        }
        function Ca(e, t1) {
            const i = e.getCenter(), o = Math.round(100 * e.getZoom()) / 100, r = Math.ceil((o * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), s = Math.pow(10, r), a = Math.round(i.lng * s) / s, n = Math.round(i.lat * s) / s, l = e.getBearing(), c = e.getPitch();
            let h = t1 ? `/${a}/${n}/${o}` : `${o}/${n}/${a}`;
            return (l || c) && (h += "/" + Math.round(10 * l) / 10), c && (h += `/${Math.round(c)}`), h;
        }
        const Sa = {
            linearity: .3,
            easing: e.dp(0, 0, .3, 1)
        }, Ia = e.l({
            deceleration: 2500,
            maxSpeed: 1400
        }, Sa), Da = e.l({
            deceleration: 20,
            maxSpeed: 1400
        }, Sa), Ra = e.l({
            deceleration: 1e3,
            maxSpeed: 360
        }, Sa), Aa = e.l({
            deceleration: 1e3,
            maxSpeed: 90
        }, Sa);
        class La {
            constructor(e){
                this._map = e, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(t1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: e.q.now(),
                    settings: t1
                });
            }
            _drainInertiaBuffer() {
                const t1 = this._inertiaBuffer, i = e.q.now();
                for(; t1.length > 0 && i - t1[0].time > 160;)t1.shift();
            }
            _onMoveEnd(t1) {
                if (this._map._prefersReducedMotion()) return;
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new e.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e } of this._inertiaBuffer)i.zoom += e.zoomDelta || 0, i.bearing += e.bearingDelta || 0, i.pitch += e.pitchDelta || 0, e.panDelta && i.pan._add(e.panDelta), e.around && (i.around = e.around), e.pinchAround && (i.pinchAround = e.pinchAround);
                const o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, r = {};
                if (i.pan.mag()) {
                    const s = Ma(i.pan.mag(), o, e.l({}, Ia, t1 || {}));
                    r.offset = i.pan.mult(s.amount / i.pan.mag()), r.center = this._map.transform.center, Pa(r, s);
                }
                if (i.zoom) {
                    const e = Ma(i.zoom, o, Da);
                    r.zoom = this._map.transform.zoom + e.amount, Pa(r, e);
                }
                if (i.bearing) {
                    const t1 = Ma(i.bearing, o, Ra);
                    r.bearing = this._map.transform.bearing + e.ap(t1.amount, -179, 179), Pa(r, t1);
                }
                if (i.pitch) {
                    const e = Ma(i.pitch, o, Aa);
                    r.pitch = this._map.transform.pitch + e.amount, Pa(r, e);
                }
                if (r.zoom || r.bearing) {
                    const e = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    r.around = e ? this._map.unproject(e) : this._map.getCenter();
                }
                return this.clear(), r.noMoveStart = !0, r;
            }
        }
        function Pa(e, t1) {
            (!e.duration || e.duration < t1.duration) && (e.duration = t1.duration, e.easing = t1.easing);
        }
        function Ma(t1, i, o) {
            const { maxSpeed: r, linearity: s, deceleration: a } = o, n = e.ap(t1 * s / (i / 1e3), -r, r), l = Math.abs(n) / (a * s);
            return {
                easing: o.easing,
                duration: 1e3 * l,
                amount: n * (l / 2)
            };
        }
        class za extends e.x {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, o, r = {}){
                const s = g(i.getCanvasContainer(), o), a = i.unproject(s);
                super(t1, e.l({
                    point: s,
                    lngLat: a,
                    originalEvent: o
                }, r)), this._defaultPrevented = !1, this.target = i;
            }
        }
        class Oa extends e.x {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, o){
                const r = "touchend" === t1 ? o.changedTouches : o.touches, s = v(i.getCanvasContainer(), r), a = s.map((e)=>i.unproject(e)), n = s.reduce((e, t1, i, o)=>e.add(t1.div(o.length)), new e.P(0, 0));
                super(t1, {
                    points: s,
                    point: n,
                    lngLats: a,
                    lngLat: i.unproject(n),
                    originalEvent: o
                }), this._defaultPrevented = !1;
            }
        }
        class Fa extends e.x {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e, t1){
                super("wheel", {
                    originalEvent: t1
                }), this._defaultPrevented = !1;
            }
        }
        class ka {
            constructor(e, t1){
                this._map = e, this._clickTolerance = t1.clickTolerance;
            }
            reset() {
                this._mousedownPos = void 0;
            }
            wheel(e) {
                return this._firePreventable(new Fa(this._map, e));
            }
            mousedown(e, t1) {
                return this._mousedownPos = t1, this._firePreventable(new za(e.type, this._map, e));
            }
            mouseup(e) {
                this._map.fire(new za(e.type, this._map, e));
            }
            preclick(t1) {
                const i = e.l({}, t1);
                i.type = "preclick", this._map.fire(new za(i.type, this._map, i));
            }
            click(e, t1) {
                this._mousedownPos && this._mousedownPos.dist(t1) >= this._clickTolerance || (this.preclick(e), this._map.fire(new za(e.type, this._map, e)));
            }
            dblclick(e) {
                return this._firePreventable(new za(e.type, this._map, e));
            }
            mouseover(e) {
                this._map.fire(new za(e.type, this._map, e));
            }
            mouseout(e) {
                this._map.fire(new za(e.type, this._map, e));
            }
            touchstart(e) {
                return this._firePreventable(new Oa(e.type, this._map, e));
            }
            touchmove(e) {
                this._map.fire(new Oa(e.type, this._map, e));
            }
            touchend(e) {
                this._map.fire(new Oa(e.type, this._map, e));
            }
            touchcancel(e) {
                this._map.fire(new Oa(e.type, this._map, e));
            }
            _firePreventable(e) {
                if (this._map.fire(e), e.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class Ba {
            constructor(e){
                this._map = e;
            }
            reset() {
                this._delayContextMenu = !1, this._contextMenuEvent = void 0;
            }
            mousemove(e) {
                this._map.fire(new za(e.type, this._map, e));
            }
            mousedown() {
                this._delayContextMenu = !0;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new za("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e) {
                this._delayContextMenu ? this._contextMenuEvent = e : this._map.fire(new za(e.type, this._map, e)), this._map.listens("contextmenu") && e.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class Na {
            constructor(e, t1){
                this._map = e, this._el = e.getCanvasContainer(), this._container = e.getContainer(), this._clickTolerance = t1.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e, t1) {
                this.isEnabled() && e.shiftKey && 0 === e.button && (_(), this._startPos = this._lastPos = t1, this._active = !0);
            }
            mousemoveWindow(e, t1) {
                if (!this._active) return;
                const i = t1, o = this._startPos, r = this._lastPos;
                if (!o || !r || r.equals(i) || !this._box && i.dist(o) < this._clickTolerance) return;
                this._lastPos = i, this._box || (this._box = l("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e));
                const s = Math.min(o.x, i.x), a = Math.max(o.x, i.x), n = Math.min(o.y, i.y), c = Math.max(o.y, i.y);
                this._map._requestDomTask(()=>{
                    this._box && (this._box.style.transform = `translate(${s}px,${n}px)`, this._box.style.width = a - s + "px", this._box.style.height = c - n + "px");
                });
            }
            mouseupWindow(t1, i) {
                if (!this._active) return;
                const o = this._startPos, r = i;
                if (o && 0 === t1.button) {
                    if (this.reset(), f(), o.x !== r.x || o.y !== r.y) return this._map.fire(new e.x("boxzoomend", {
                        originalEvent: t1
                    })), {
                        cameraAnimation: (e)=>e.fitScreenCoordinates(o, r, this._map.getBearing(), {
                                linear: !1
                            })
                    };
                    this._fireEvent("boxzoomcancel", t1);
                }
            }
            keydown(e) {
                this._active && 27 === e.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e));
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), p(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(t1, i) {
                return this._map.fire(new e.x(t1, {
                    originalEvent: i
                }));
            }
        }
        function Ua(e, t1) {
            const i = {};
            for(let o = 0; o < e.length; o++)i[e[o].identifier] = t1[o];
            return i;
        }
        class Ga {
            constructor(e){
                this.reset(), this.numTouches = e.numTouches;
            }
            reset() {
                this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
            }
            touchstart(t1, i, o) {
                (this.centroid || o.length > this.numTouches) && (this.aborted = !0), this.aborted || (0 === this.startTime && (this.startTime = t1.timeStamp), o.length === this.numTouches && (this.centroid = function(t1) {
                    const i = new e.P(0, 0);
                    for (const e of t1)i._add(e);
                    return i.div(t1.length);
                }(i), this.touches = Ua(o, i)));
            }
            touchmove(e, t1, i) {
                if (this.aborted || !this.centroid) return;
                const o = Ua(i, t1);
                for(const e in this.touches){
                    const t1 = o[e];
                    (!t1 || t1.dist(this.touches[e]) > 30) && (this.aborted = !0);
                }
            }
            touchend(e, t1, i) {
                if ((!this.centroid || e.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e = !this.aborted && this.centroid;
                    if (this.reset(), e) return e;
                }
            }
        }
        class ja {
            constructor(e){
                this.singleTap = new Ga(e), this.numTaps = e.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
            }
            touchstart(e, t1, i) {
                this.singleTap.touchstart(e, t1, i);
            }
            touchmove(e, t1, i) {
                this.singleTap.touchmove(e, t1, i);
            }
            touchend(e, t1, i) {
                const o = this.singleTap.touchend(e, t1, i);
                if (o) {
                    const t1 = e.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(o) < 30;
                    if (t1 && i || this.reset(), this.count++, this.lastTime = e.timeStamp, this.lastTap = o, this.count === this.numTaps) return this.reset(), o;
                }
            }
        }
        class Va {
            constructor(){
                this._zoomIn = new ja({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new ja({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e, t1, i) {
                this._zoomIn.touchstart(e, t1, i), this._zoomOut.touchstart(e, t1, i);
            }
            touchmove(e, t1, i) {
                this._zoomIn.touchmove(e, t1, i), this._zoomOut.touchmove(e, t1, i);
            }
            touchend(e, t1, i) {
                const o = this._zoomIn.touchend(e, t1, i), r = this._zoomOut.touchend(e, t1, i);
                return o ? (this._active = !0, e.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() + 1,
                            around: t1.unproject(o)
                        }, {
                            originalEvent: e
                        })
                }) : r ? (this._active = !0, e.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() - 1,
                            around: t1.unproject(r)
                        }, {
                            originalEvent: e
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        const qa = {
            0: 1,
            2: 2
        };
        class Za {
            constructor(e){
                this.reset(), this._clickTolerance = e.clickTolerance || 1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
            }
            _correctButton(e, t1) {
                return !1;
            }
            _move(e, t1) {
                return {};
            }
            mousedown(e, t1) {
                if (this._lastPoint) return;
                const i = x(e);
                this._correctButton(e, i) && (this._lastPoint = t1, this._eventButton = i);
            }
            mousemoveWindow(e, t1) {
                const i = this._lastPoint;
                if (i) {
                    if (e.preventDefault(), null != this._eventButton && function(e, t1) {
                        const i = qa[t1];
                        return void 0 === e.buttons || (e.buttons & i) !== i;
                    }(e, this._eventButton)) this.reset();
                    else if (this._moved || !(t1.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = t1, this._move(i, t1);
                }
            }
            mouseupWindow(e) {
                this._lastPoint && x(e) === this._eventButton && (this._moved && f(), this.reset());
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Ha extends Za {
            mousedown(e, t1) {
                super.mousedown(e, t1), this._lastPoint && (this._active = !0);
            }
            _correctButton(e, t1) {
                return 0 === t1 && !e.ctrlKey;
            }
            _move(e, t1) {
                return {
                    around: t1,
                    panDelta: t1.sub(e)
                };
            }
        }
        class Wa extends Za {
            _correctButton(e, t1) {
                return 0 === t1 && e.ctrlKey || 2 === t1;
            }
            _move(e, t1) {
                const i = .8 * (t1.x - e.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }
            contextmenu(e) {
                e.preventDefault();
            }
        }
        class $a extends Za {
            _correctButton(e, t1) {
                return 0 === t1 && e.ctrlKey || 2 === t1;
            }
            _move(e, t1) {
                const i = -0.5 * (t1.y - e.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }
            contextmenu(e) {
                e.preventDefault();
            }
        }
        class Xa {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i.clickTolerance || 1, this.reset(), e.aJ([
                    "_addTouchPanBlocker",
                    "_showTouchPanBlockerAlert"
                ], this);
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new e.P(0, 0);
            }
            touchstart(e, t1, i) {
                return this._calculateTransform(e, t1, i);
            }
            touchmove(t1, i, o) {
                if (this._active && !(o.length < this._minTouches)) {
                    if (this._map._cooperativeGestures && !this._map.isMoving()) {
                        if (1 === o.length && !e.dq()) return void this._showTouchPanBlockerAlert();
                        "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                    }
                    return t1.cancelable && t1.preventDefault(), this._calculateTransform(t1, i, o);
                }
            }
            touchend(e, t1, i) {
                this._calculateTransform(e, t1, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(t1, i, o) {
                o.length > 0 && (this._active = !0);
                const r = Ua(o, i), s = new e.P(0, 0), a = new e.P(0, 0);
                let n = 0;
                for(const e in r){
                    const t1 = r[e], i = this._touches[e];
                    i && (s._add(t1), a._add(t1.sub(i)), n++, r[e] = t1);
                }
                if (this._touches = r, n < this._minTouches || !a.mag()) return;
                const l = a.div(n);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: s.div(n),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
            }
            disable() {
                this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            _addTouchPanBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = l("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showTouchPanBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 500);
            }
        }
        class Ya {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, this._firstTwoTouches = void 0;
            }
            _start(e) {}
            _move(e, t1, i) {
                return {};
            }
            touchstart(e, t1, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t1[0],
                    t1[1]
                ]));
            }
            touchmove(e, t1, i) {
                const o = this._firstTwoTouches;
                if (!o) return;
                e.preventDefault();
                const [r, s] = o, a = Ka(i, t1, r), n = Ka(i, t1, s);
                if (!a || !n) return;
                const l = this._aroundCenter ? null : a.add(n).div(2);
                return this._move([
                    a,
                    n
                ], l, e);
            }
            touchend(e, t1, i) {
                if (!this._firstTwoTouches) return;
                const [o, r] = this._firstTwoTouches, s = Ka(i, t1, o), a = Ka(i, t1, r);
                s && a || (this._active && f(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e) {
                this._enabled = !0, this._aroundCenter = !!e && "center" === e.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        function Ka(e, t1, i) {
            for(let o = 0; o < e.length; o++)if (e[o].identifier === i) return t1[o];
        }
        function Ja(e, t1) {
            return Math.log(e / t1) / Math.LN2;
        }
        class Qa extends Ya {
            reset() {
                super.reset(), this._distance = 0, this._startDistance = 0;
            }
            _start(e) {
                this._startDistance = this._distance = e[0].dist(e[1]);
            }
            _move(e, t1) {
                const i = this._distance;
                if (this._distance = e[0].dist(e[1]), this._active || !(Math.abs(Ja(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Ja(this._distance, i),
                    pinchAround: t1
                };
            }
        }
        function en(e, t1) {
            return 180 * e.angleWith(t1) / Math.PI;
        }
        class tn extends Ya {
            reset() {
                super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
            }
            _start(e) {
                this._startVector = this._vector = e[0].sub(e[1]), this._minDiameter = e[0].dist(e[1]);
            }
            _move(e, t1) {
                const i = this._vector;
                if (this._vector = e[0].sub(e[1]), i && (this._active || !this._isBelowThreshold(this._vector))) return this._active = !0, {
                    bearingDelta: en(this._vector, i),
                    pinchAround: t1
                };
            }
            _isBelowThreshold(e) {
                this._minDiameter = Math.min(this._minDiameter, e.mag());
                const t1 = 25 / (Math.PI * this._minDiameter) * 360, i = this._startVector;
                if (!i) return !1;
                const o = en(e, i);
                return Math.abs(o) < t1;
            }
        }
        function on(e) {
            return Math.abs(e.y) > Math.abs(e.x);
        }
        class rn extends Ya {
            constructor(e){
                super(), this._map = e;
            }
            reset() {
                super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
            }
            _start(e) {
                this._lastPoints = e, on(e[0].sub(e[1])) && (this._valid = !1);
            }
            _move(t1, i, o) {
                const r = this._lastPoints;
                if (!r) return;
                const s = t1[0].sub(r[0]), a = t1[1].sub(r[1]);
                return this._map._cooperativeGestures && !e.dq() && o.touches.length < 3 || (this._valid = this.gestureBeginsVertically(s, a, o.timeStamp), !this._valid) ? void 0 : (this._lastPoints = t1, this._active = !0, {
                    pitchDelta: (s.y + a.y) / 2 * -0.5
                });
            }
            gestureBeginsVertically(e, t1, i) {
                if (void 0 !== this._valid) return this._valid;
                const o = e.mag() >= 2, r = t1.mag() >= 2;
                if (!o && !r) return;
                if (!o || !r) return null == this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const s = e.y > 0 == t1.y > 0;
                return on(e) && on(t1) && s;
            }
        }
        const sn = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class an {
            constructor(){
                const e = sn;
                this._panStep = e.panStep, this._bearingStep = e.bearingStep, this._pitchStep = e.pitchStep, this._rotationDisabled = !1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            keydown(e) {
                if (e.altKey || e.ctrlKey || e.metaKey) return;
                let t1 = 0, i = 0, o = 0, r = 0, s = 0;
                switch(e.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t1 = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t1 = -1;
                        break;
                    case 37:
                        e.shiftKey ? i = -1 : (e.preventDefault(), r = -1);
                        break;
                    case 39:
                        e.shiftKey ? i = 1 : (e.preventDefault(), r = 1);
                        break;
                    case 38:
                        e.shiftKey ? o = 1 : (e.preventDefault(), s = -1);
                        break;
                    case 40:
                        e.shiftKey ? o = -1 : (e.preventDefault(), s = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, o = 0), {
                    cameraAnimation: (a)=>{
                        const n = a.getZoom();
                        a.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: nn,
                            zoom: t1 ? Math.round(n) + t1 * (e.shiftKey ? 2 : 1) : n,
                            bearing: a.getBearing() + i * this._bearingStep,
                            pitch: a.getPitch() + o * this._pitchStep,
                            offset: [
                                -r * this._panStep,
                                -s * this._panStep
                            ],
                            center: a.getCenter()
                        }, {
                            originalEvent: e
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function nn(e) {
            return e * (2 - e);
        }
        const ln = 4.000244140625, cn = 1 / 450;
        class hn {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._handler = i, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = cn, e.aJ([
                    "_onTimeout",
                    "_addScrollZoomBlocker",
                    "_showBlockerAlert"
                ], this);
            }
            setZoomRate(e) {
                this._defaultZoomRate = e;
            }
            setWheelZoomRate(e) {
                this._wheelZoomRate = e;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e && "center" === e.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
            }
            disable() {
                this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
            }
            wheel(t1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!(t1.ctrlKey || t1.metaKey || this.isZooming() || e.dq())) return void this._showBlockerAlert();
                    "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                }
                let i = t1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t1.deltaY : t1.deltaY;
                const o = e.q.now(), r = o - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = o, 0 !== i && i % ln == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : r > 400 ? (this._type = null, this._lastValue = i, this._timeout = window.setTimeout(this._onTimeout, 40, t1)) : this._type || (this._type = Math.abs(r * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), t1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = t1, this._delta -= i, this._active || this._start(t1)), t1.preventDefault();
            }
            _onTimeout(e) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e);
            }
            _start(e) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const t1 = g(this._el, e);
                this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t1, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const t1 = this._map.transform;
                "wheel" === this._type && t1.projection.wrap && (t1._center.lng >= 180 || t1._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
                const i = ()=>t1._terrainEnabled() && this._aroundCoord ? t1.computeZoomRelativeTo(this._aroundCoord) : t1.zoom;
                if (0 !== this._delta) {
                    const e = "wheel" === this._type && Math.abs(this._delta) > ln ? this._wheelZoomRate : this._defaultZoomRate;
                    let o = 2 / (1 + Math.exp(-Math.abs(this._delta * e)));
                    this._delta < 0 && 0 !== o && (o = 1 / o);
                    const r = i(), s = Math.pow(2, r), a = "number" == typeof this._targetZoom ? t1.zoomScale(this._targetZoom) : s;
                    this._targetZoom = Math.min(t1.maxZoom, Math.max(t1.minZoom, t1.scaleZoom(a * o))), "wheel" === this._type && (this._startZoom = r, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
                }
                const o = "number" == typeof this._targetZoom ? this._targetZoom : i(), r = this._startZoom, s = this._easing;
                let a, n = !1;
                if ("wheel" === this._type && r && s) {
                    const t1 = Math.min((e.q.now() - this._lastWheelEventTime) / 200, 1), i = s(t1);
                    a = e.aa(r, o, i), t1 < 1 ? this._frameId || (this._frameId = !0) : n = !0;
                } else a = o, n = !0;
                this._active = !0, n && (this._active = !1, this._finishTimeout = window.setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200));
                let l = a - i();
                return l * this._lastDelta < 0 && (l = 0), {
                    noInertia: !0,
                    needsRenderFrame: !n,
                    zoomDelta: l,
                    around: this._aroundPoint,
                    aroundCoord: this._aroundCoord,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(t1) {
                let i = e.dr;
                if (this._prevEase) {
                    const t1 = this._prevEase, o = (e.q.now() - t1.start) / t1.duration, r = t1.easing(o + .01) - t1.easing(o), s = .27 / Math.sqrt(r * r + 1e-4) * .01, a = Math.sqrt(.0729 - s * s);
                    i = e.dp(s, a, .25, 1);
                }
                return this._prevEase = {
                    start: e.q.now(),
                    duration: t1,
                    easing: i
                }, i;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            _addScrollZoomBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = l("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 200);
            }
        }
        class un {
            constructor(e, t1){
                this._clickZoom = e, this._tapZoom = t1;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class dn {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            blur() {
                this.reset();
            }
            dblclick(e, t1) {
                return e.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: i.getZoom() + (e.shiftKey ? -1 : 1),
                            around: i.unproject(t1)
                        }, {
                            originalEvent: e
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class _n {
            constructor(){
                this._tap = new ja({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
            }
            touchstart(e, t1, i) {
                this._swipePoint || (this._tapTime && e.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = t1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(e, t1, i));
            }
            touchmove(e, t1, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const o = t1[0], r = o.y - this._swipePoint.y;
                        return this._swipePoint = o, e.preventDefault(), this._active = !0, {
                            zoomDelta: r / 128
                        };
                    }
                } else this._tap.touchmove(e, t1, i);
            }
            touchend(e, t1, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(e, t1, i) && (this._tapTime = e.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class pn {
            constructor(e, t1, i){
                this._el = e, this._mousePan = t1, this._touchPan = i;
            }
            enable(e) {
                this._inertiaOptions = e || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class mn {
            constructor(e, t1, i){
                this._pitchWithRotate = e.pitchWithRotate, this._mouseRotate = t1, this._mousePitch = i;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
        }
        class fn {
            constructor(e, t1, i, o){
                this._el = e, this._touchZoom = t1, this._touchRotate = i, this._tapDragZoom = o, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(e) {
                this._touchZoom.enable(e), this._rotationDisabled || this._touchRotate.enable(e), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        const gn = (e)=>e.zoom || e.drag || e.pitch || e.rotate;
        class vn extends e.x {
        }
        class xn {
            constructor(){
                this.constants = [
                    1,
                    1,
                    .01
                ], this.radius = 0;
            }
            setup(t1, i) {
                const o = e.a6.vec3.sub([], i, t1);
                this.radius = e.a6.vec3.length(o[2] < 0 ? e.a6.vec3.div([], o, this.constants) : [
                    o[0],
                    o[1],
                    0
                ]);
            }
            projectRay(t1) {
                e.a6.vec3.div(t1, t1, this.constants), e.a6.vec3.normalize(t1, t1), e.a6.vec3.mul(t1, t1, this.constants);
                const i = e.a6.vec3.scale([], t1, this.radius);
                if (i[2] > 0) {
                    const t1 = e.a6.vec3.scale([], [
                        0,
                        0,
                        1
                    ], e.a6.vec3.dot(i, [
                        0,
                        0,
                        1
                    ])), o = e.a6.vec3.scale([], e.a6.vec3.normalize([], [
                        i[0],
                        i[1],
                        0
                    ]), this.radius), r = e.a6.vec3.add([], i, e.a6.vec3.scale([], e.a6.vec3.sub([], e.a6.vec3.add([], o, t1), i), 2));
                    i[0] = r[0], i[1] = r[1];
                }
                return i;
            }
        }
        function yn(e) {
            return e.panDelta && e.panDelta.mag() || e.zoomDelta || e.bearingDelta || e.pitchDelta;
        }
        class bn {
            constructor(t1, i){
                this._map = t1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new La(t1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new xn, this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i), e.aJ([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const o = this._el;
                this._listeners = [
                    [
                        o,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        o,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "touchend",
                        void 0
                    ],
                    [
                        o,
                        "touchcancel",
                        void 0
                    ],
                    [
                        o,
                        "mousedown",
                        void 0
                    ],
                    [
                        o,
                        "mousemove",
                        void 0
                    ],
                    [
                        o,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        o,
                        "mouseover",
                        void 0
                    ],
                    [
                        o,
                        "mouseout",
                        void 0
                    ],
                    [
                        o,
                        "dblclick",
                        void 0
                    ],
                    [
                        o,
                        "click",
                        void 0
                    ],
                    [
                        o,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        o,
                        "keyup",
                        void 0
                    ],
                    [
                        o,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [e, t1, i] of this._listeners){
                    const o = e === document ? this.handleWindowEvent : this.handleEvent;
                    e.addEventListener(t1, o, i);
                }
            }
            destroy() {
                for (const [e, t1, i] of this._listeners){
                    const o = e === document ? this.handleWindowEvent : this.handleEvent;
                    e.removeEventListener(t1, o, i);
                }
            }
            _addDefaultHandlers(e) {
                const t1 = this._map, i = t1.getCanvasContainer();
                this._add("mapEvent", new ka(t1, e));
                const o = t1.boxZoom = new Na(t1, e);
                this._add("boxZoom", o);
                const r = new Va, s = new dn;
                t1.doubleClickZoom = new un(s, r), this._add("tapZoom", r), this._add("clickZoom", s);
                const a = new _n;
                this._add("tapDragZoom", a);
                const n = t1.touchPitch = new rn(t1);
                this._add("touchPitch", n);
                const l = new Wa(e), c = new $a(e);
                t1.dragRotate = new mn(e, l, c), this._add("mouseRotate", l, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]);
                const h = new Ha(e), u = new Xa(t1, e);
                t1.dragPan = new pn(i, h, u), this._add("mousePan", h), this._add("touchPan", u, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const d = new tn, _ = new Qa;
                t1.touchZoomRotate = new fn(i, _, d, a), this._add("touchRotate", d, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", _, [
                    "touchPan",
                    "touchRotate"
                ]), this._add("blockableMapEvent", new Ba(t1));
                const p = t1.scrollZoom = new hn(t1, this);
                this._add("scrollZoom", p, [
                    "mousePan"
                ]);
                const m = t1.keyboard = new an;
                this._add("keyboard", m);
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])e.interactive && e[i] && t1[i].enable(e[i]);
            }
            _add(e, t1, i) {
                this._handlers.push({
                    handlerName: e,
                    handler: t1,
                    allowed: i
                }), this._handlersById[e] = t1;
            }
            stop(e) {
                if (!this._updatingCamera) {
                    for (const { handler: e } of this._handlers)e.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, e), this._changes = [], this._originalZoom = void 0;
                }
            }
            isActive() {
                for (const { handler: e } of this._handlers)if (e.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return !!gn(this._eventsInProgress) || this.isZooming();
            }
            _isDragging() {
                return !!this._eventsInProgress.drag;
            }
            _blockedByActive(e, t1, i) {
                for(const o in e)if (o !== i && (!t1 || t1.indexOf(o) < 0)) return !0;
                return !1;
            }
            handleWindowEvent(e) {
                this.handleEvent(e, `${e.type}Window`);
            }
            _getMapTouches(e) {
                const t1 = [];
                for (const i of e)this._el.contains(i.target) && t1.push(i);
                return t1;
            }
            handleEvent(e, t1) {
                this._updatingCamera = !0;
                const i = "renderFrame" === e.type, o = i ? void 0 : e, r = {
                    needsRenderFrame: !1
                }, s = {}, a = {}, n = e.touches ? this._getMapTouches(e.touches) : void 0, l = n ? v(this._el, n) : i ? void 0 : g(this._el, e);
                for (const { handlerName: i, handler: c, allowed: h } of this._handlers){
                    if (!c.isEnabled()) continue;
                    let u;
                    this._blockedByActive(a, h, i) ? c.reset() : c[t1 || e.type] && (u = c[t1 || e.type](e, l, n), this.mergeHandlerResult(r, s, u, i, o), u && u.needsRenderFrame && this._triggerRenderFrame()), (u || c.isActive()) && (a[i] = c);
                }
                const c = {};
                for(const e in this._previousActiveHandlers)a[e] || (c[e] = o);
                this._previousActiveHandlers = a, (Object.keys(c).length || yn(r)) && (this._changes.push([
                    r,
                    s,
                    c
                ]), this._triggerRenderFrame()), (Object.keys(a).length || yn(r)) && this._map._stop(!0), this._updatingCamera = !1;
                const { cameraAnimation: h } = r;
                h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
            }
            mergeHandlerResult(t1, i, o, r, s) {
                if (!o) return;
                e.l(t1, o);
                const a = {
                    handlerName: r,
                    originalEvent: o.originalEvent || s
                };
                void 0 !== o.zoomDelta && (i.zoom = a), void 0 !== o.panDelta && (i.drag = a), void 0 !== o.pitchDelta && (i.pitch = a), void 0 !== o.bearingDelta && (i.rotate = a);
            }
            _applyChanges() {
                const t1 = {}, i = {}, o = {};
                for (const [r, s, a] of this._changes)r.panDelta && (t1.panDelta = (t1.panDelta || new e.P(0, 0))._add(r.panDelta)), r.zoomDelta && (t1.zoomDelta = (t1.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (t1.bearingDelta = (t1.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (t1.pitchDelta = (t1.pitchDelta || 0) + r.pitchDelta), void 0 !== r.around && (t1.around = r.around), void 0 !== r.aroundCoord && (t1.aroundCoord = r.aroundCoord), void 0 !== r.pinchAround && (t1.pinchAround = r.pinchAround), r.noInertia && (t1.noInertia = r.noInertia), e.l(i, s), e.l(o, a);
                this._updateMapTransform(t1, i, o), this._changes = [];
            }
            _updateMapTransform(t1, i, o) {
                const r = this._map, s = r.transform, a = (e)=>[
                        e.x,
                        e.y,
                        e.z
                    ];
                if (((e)=>{
                    const t1 = this._eventsInProgress.drag;
                    return t1 && !this._handlersById[t1.handlerName].isActive();
                })() && !yn(t1)) {
                    const e = s.zoom;
                    s.cameraElevationReference = "sea", null != this._originalZoom && s._orthographicProjectionAtLowPitch && "globe" !== s.projection.name && 0 === s.pitch ? (s.cameraElevationReference = "ground", s.zoom = this._originalZoom) : (s.recenterOnTerrain(), s.cameraElevationReference = "ground"), e !== s.zoom && this._map._update(!0);
                }
                if (s._isCameraConstrained && r._stop(!0), !yn(t1)) return void this._fireEvents(i, o, !0);
                let { panDelta: n, zoomDelta: l, bearingDelta: c, pitchDelta: h, around: u, aroundCoord: d, pinchAround: _ } = t1;
                s._isCameraConstrained && (l > 0 && (l = 0), s._isCameraConstrained = !1), void 0 !== _ && (u = _), (l || ((e)=>i[e] && !this._eventsInProgress[e])("drag")) && u && (this._dragOrigin = a(s.pointCoordinate3D(u)), this._originalZoom = s.zoom, this._trackingEllipsoid.setup(s._camera.position, this._dragOrigin)), s.cameraElevationReference = "sea", r._stop(!0), u = u || r.transform.centerPoint, c && (s.bearing += c), h && (s.pitch += h), s._updateCameraState();
                const p = [
                    0,
                    0,
                    0
                ];
                if (n) {
                    if ("mercator" === s.projection.name) {
                        const e = this._trackingEllipsoid.projectRay(s.screenPointToMercatorRay(u).dir), t1 = this._trackingEllipsoid.projectRay(s.screenPointToMercatorRay(u.sub(n)).dir);
                        p[0] = t1[0] - e[0], p[1] = t1[1] - e[1];
                    } else {
                        const t1 = s.pointCoordinate(u);
                        if ("globe" === s.projection.name) {
                            n = n.rotate(-s.angle);
                            const i = s._pixelsPerMercatorPixel / s.worldSize;
                            p[0] = -n.x * e.ds(e.aM(t1.y)) * i, p[1] = -n.y * e.ds(s.center.lat) * i;
                        } else {
                            const e = s.pointCoordinate(u.sub(n));
                            t1 && e && (p[0] = e.x - t1.x, p[1] = e.y - t1.y);
                        }
                    }
                }
                const m = s.zoom, f = [
                    0,
                    0,
                    0
                ];
                if (l) {
                    const t1 = a(d || s.pointCoordinate3D(u)), i = {
                        dir: e.a6.vec3.normalize([], e.a6.vec3.sub([], t1, s._camera.position))
                    };
                    if (i.dir[2] < 0) {
                        const o = s.zoomDeltaToMovement(t1, l);
                        e.a6.vec3.scale(f, i.dir, o);
                    }
                }
                const g = e.a6.vec3.add(p, p, f);
                s._translateCameraConstrained(g), l && Math.abs(s.zoom - m) > 1e-4 && s.recenterOnTerrain(), s.cameraElevationReference = "ground", this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(i, o, !0);
            }
            _fireEvents(t1, i, o) {
                const r = gn(this._eventsInProgress), s = gn(t1), a = {};
                for(const e in t1){
                    const { originalEvent: i } = t1[e];
                    this._eventsInProgress[e] || (a[`${e}start`] = i), this._eventsInProgress[e] = t1[e];
                }
                !r && s && this._fireEvent("movestart", s.originalEvent);
                for(const e in a)this._fireEvent(e, a[e]);
                s && this._fireEvent("move", s.originalEvent);
                for(const e in t1){
                    const { originalEvent: i } = t1[e];
                    this._fireEvent(e, i);
                }
                const n = {};
                let l;
                for(const e in this._eventsInProgress){
                    const { handlerName: t1, originalEvent: o } = this._eventsInProgress[e];
                    this._handlersById[t1].isActive() || (delete this._eventsInProgress[e], l = i[t1] || o, n[`${e}end`] = l);
                }
                for(const e in n)this._fireEvent(e, n[e]);
                const c = gn(this._eventsInProgress);
                if (o && (r || s) && !c) {
                    this._updatingCamera = !0;
                    const t1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (e)=>0 !== e && -this._bearingSnap < e && e < this._bearingSnap;
                    t1 ? (i(t1.bearing || this._map.getBearing()) && (t1.bearing = 0), this._map.easeTo(t1, {
                        originalEvent: l
                    })) : (this._map.fire(new e.x("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(t1, i) {
                this._map.fire(new e.x(t1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e)=>{
                    this._frameId = void 0, this.handleEvent(new vn("renderFrame", {
                        timeStamp: e
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        const wn = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
        class Tn extends e.E {
            constructor(t1, i){
                super(), this._moving = !1, this._zooming = !1, this.transform = t1, this._bearingSnap = i.bearingSnap, this._respectPrefersReducedMotion = !1 !== i.respectPrefersReducedMotion, e.aJ([
                    "_renderFrameCallback"
                ], this);
            }
            getCenter() {
                return new e.bK(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e, t1) {
                return this.jumpTo({
                    center: e
                }, t1);
            }
            panBy(t1, i, o) {
                return t1 = e.P.convert(t1).mult(-1), this.panTo(this.transform.center, e.l({
                    offset: t1
                }, i), o);
            }
            panTo(t1, i, o) {
                return this.easeTo(e.l({
                    center: t1
                }, i), o);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e, t1) {
                return this.jumpTo({
                    zoom: e
                }, t1), this;
            }
            zoomTo(t1, i, o) {
                return this.easeTo(e.l({
                    zoom: t1
                }, i), o);
            }
            zoomIn(e, t1) {
                return this.zoomTo(this.getZoom() + 1, e, t1), this;
            }
            zoomOut(e, t1) {
                return this.zoomTo(this.getZoom() - 1, e, t1), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e, t1) {
                return this.jumpTo({
                    bearing: e
                }, t1), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e, t1) {
                return this.jumpTo({
                    padding: e
                }, t1), this;
            }
            rotateTo(t1, i, o) {
                return this.easeTo(e.l({
                    bearing: t1
                }, i), o);
            }
            resetNorth(t1, i) {
                return this.rotateTo(0, e.l({
                    duration: 1e3
                }, t1), i), this;
            }
            resetNorthPitch(t1, i) {
                return this.easeTo(e.l({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, t1), i), this;
            }
            snapToNorth(e, t1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e, t1) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e, t1) {
                return this.jumpTo({
                    pitch: e
                }, t1), this;
            }
            cameraForBounds(t1, i) {
                t1 = e.as.convert(t1);
                const o = i && i.bearing || 0, r = i && i.pitch || 0, s = t1.getNorthWest(), a = t1.getSouthEast();
                return this._cameraForBounds(this.transform, s, a, o, r, i);
            }
            _extendPadding(t1) {
                const i = {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                };
                return null == t1 ? e.l({}, i, this.transform.padding) : "number" == typeof t1 ? {
                    top: t1,
                    bottom: t1,
                    right: t1,
                    left: t1
                } : e.l({}, i, t1);
            }
            _extendCameraOptions(t1) {
                return (t1 = e.l({
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, t1)).padding = this._extendPadding(t1.padding), t1;
            }
            _minimumAABBFrustumDistance(e, t1) {
                const i = t1.max[0] - t1.min[0], o = t1.max[1] - t1.min[1];
                return i / o > e.aspect ? i / (2 * Math.tan(.5 * e.fovX) * e.aspect) : o / (2 * Math.tan(.5 * e.fovY) * e.aspect);
            }
            _cameraForBoundsOnGlobe(t1, i, o, r, s, a) {
                const n = t1.clone(), l = this._extendCameraOptions(a);
                n.bearing = r, n.pitch = s;
                const c = e.bK.convert(i), h = e.bK.convert(o), u = .5 * (c.lat + h.lat), d = .5 * (c.lng + h.lng), _ = e.dt(u, d), p = e.a6.vec3.normalize([], _), m = e.a6.vec3.normalize([], e.a6.vec3.cross([], p, [
                    0,
                    1,
                    0
                ])), f = e.a6.vec3.cross([], m, p), g = [
                    m[0],
                    m[1],
                    m[2],
                    0,
                    f[0],
                    f[1],
                    f[2],
                    0,
                    p[0],
                    p[1],
                    p[2],
                    0,
                    0,
                    0,
                    0,
                    1
                ], v = [
                    _,
                    e.dt(c.lat, c.lng),
                    e.dt(h.lat, c.lng),
                    e.dt(h.lat, h.lng),
                    e.dt(c.lat, h.lng),
                    e.dt(u, c.lng),
                    e.dt(u, h.lng),
                    e.dt(c.lat, d),
                    e.dt(h.lat, d)
                ];
                let x = e.c9.fromPoints(v.map((t1)=>[
                        e.a6.vec3.dot(m, t1),
                        e.a6.vec3.dot(f, t1),
                        e.a6.vec3.dot(p, t1)
                    ]));
                const y = e.a6.vec3.transformMat4([], x.center, g);
                0 === e.a6.vec3.squaredLength(y) && e.a6.vec3.set(y, 0, 0, 1), e.a6.vec3.normalize(y, y), e.a6.vec3.scale(y, y, e.aq), n.center = e.du(y);
                const b = n.getWorldToCameraMatrix(), w = e.a6.mat4.invert(new Float64Array(16), b);
                x = e.c9.applyTransform(x, e.a6.mat4.multiply([], b, g));
                const T = this._extendAABB(x, n, l, r);
                if (!T) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                x = T, e.a6.vec3.transformMat4(y, y, b);
                const E = .5 * (x.max[2] - x.min[2]), C = this._minimumAABBFrustumDistance(n, x), S = e.a6.vec3.scale([], [
                    0,
                    0,
                    1
                ], E), I = e.a6.vec3.add(S, y, S), D = C + (0 === n.pitch ? 0 : e.a6.vec3.distance(y, I)), R = n.globeCenterInViewSpace, A = e.a6.vec3.sub([], y, [
                    R[0],
                    R[1],
                    R[2]
                ]);
                e.a6.vec3.normalize(A, A), e.a6.vec3.scale(A, A, D);
                const L = e.a6.vec3.add([], y, A);
                e.a6.vec3.transformMat4(L, L, w);
                const P = e.dw / e.aq, M = e.a6.vec3.length(L), z = e.bD(Math.max(M * P - e.dw, Number.EPSILON), 0), O = Math.min(n.zoomFromMercatorZAdjusted(z), l.maxZoom);
                return O > .5 * (e.c2 + e.bU) ? (n.setProjection({
                    name: "mercator"
                }), n.zoom = O, this._cameraForBounds(n, i, o, r, s, a)) : {
                    center: n.center,
                    zoom: O,
                    bearing: r,
                    pitch: s
                };
            }
            _extendAABB(t1, i, o, r) {
                const s = .5 * ((o.padding.left || 0) + (o.padding.right || 0)), a = .5 * ((o.padding.top || 0) + (o.padding.bottom || 0)), n = a, l = s, c = s, h = a, u = i.width - (l + c), d = i.height - (n + h), _ = e.a6.vec3.sub([], t1.max, t1.min), p = Math.min(u / _[0], d / _[1]), m = Math.min(i.scaleZoom(i.scale * p), o.maxZoom);
                if (isNaN(m)) return null;
                const f = i.scale / i.zoomScale(m), g = new e.c9([
                    t1.min[0] - l * f,
                    t1.min[1] - h * f,
                    t1.min[2]
                ], [
                    t1.max[0] + c * f,
                    t1.max[1] + n * f,
                    t1.max[2]
                ]), v = ("number" == typeof o.offset.x && "number" == typeof o.offset.y ? new e.P(o.offset.x, o.offset.y) : e.P.convert(o.offset)).rotate(-e.bB(r));
                return g.center[0] -= v.x * f, g.center[1] += v.y * f, g;
            }
            queryTerrainElevation(t1, i) {
                const o = this.transform.elevation;
                return o ? (i = e.l({}, {
                    exaggerated: !0
                }, i), o.getAtPoint(e.a5.fromLngLat(t1), null, i.exaggerated)) : null;
            }
            _cameraForBounds(t1, i, o, r, s, a) {
                if ("globe" === t1.projection.name) return this._cameraForBoundsOnGlobe(t1, i, o, r, s, a);
                const n = t1.clone(), l = this._extendCameraOptions(a);
                n.bearing = r, n.pitch = s;
                const c = e.bK.convert(i), h = e.bK.convert(o), u = new e.bK(c.lng, h.lat), d = new e.bK(h.lng, c.lat), _ = n.project(c), p = n.project(h), m = this.queryTerrainElevation(c), f = this.queryTerrainElevation(h), g = this.queryTerrainElevation(u), v = this.queryTerrainElevation(d), x = [
                    [
                        _.x,
                        _.y,
                        Math.min(m || 0, f || 0, g || 0, v || 0)
                    ],
                    [
                        p.x,
                        p.y,
                        Math.max(m || 0, f || 0, g || 0, v || 0)
                    ]
                ];
                let y = e.c9.fromPoints(x);
                const b = n.getWorldToCameraMatrix(), w = e.a6.mat4.invert(new Float64Array(16), b);
                y = e.c9.applyTransform(y, b);
                const T = this._extendAABB(y, n, l, r);
                if (!T) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                y = T;
                const E = .5 * e.a6.vec3.sub([], y.max, y.min)[2], C = this._minimumAABBFrustumDistance(n, y), S = [
                    0,
                    0,
                    1,
                    0
                ];
                e.a6.vec4.transformMat4(S, S, b), e.a6.vec4.normalize(S, S);
                const I = e.a6.vec3.scale([], S, C + E), D = e.a6.vec3.add([], y.center, I);
                e.a6.vec3.transformMat4(y.center, y.center, w), e.a6.vec3.transformMat4(D, D, w);
                const R = n.unproject(new e.P(y.center[0], y.center[1])), A = e.dv(n.projection, R), L = Math.pow(2, A), P = Math.min(n._zoomFromMercatorZ(D[2] * n.pixelsPerMeter * L / n.worldSize), l.maxZoom);
                return n.mercatorFromTransition && P < .5 * (e.c2 + e.bU) ? (n.setProjection({
                    name: "globe"
                }), n.zoom = P, this._cameraForBounds(n, i, o, r, s, a)) : {
                    center: R,
                    zoom: P,
                    bearing: r,
                    pitch: s
                };
            }
            fitBounds(e, t1, i) {
                const o = this.cameraForBounds(e, t1);
                return this._fitInternal(o, t1, i);
            }
            fitScreenCoordinates(t1, i, o, r, s) {
                const a = e.P.convert(t1), n = e.P.convert(i), l = new e.P(Math.min(a.x, n.x), Math.min(a.y, n.y)), c = new e.P(Math.max(a.x, n.x), Math.max(a.y, n.y));
                if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(a, n)) return this;
                const h = this.transform.pointLocation3D(l), u = this.transform.pointLocation3D(c), d = this.transform.pointLocation3D(new e.P(l.x, c.y)), _ = this.transform.pointLocation3D(new e.P(c.x, l.y)), p = [
                    Math.min(h.lng, u.lng, d.lng, _.lng),
                    Math.min(h.lat, u.lat, d.lat, _.lat)
                ], m = [
                    Math.max(h.lng, u.lng, d.lng, _.lng),
                    Math.max(h.lat, u.lat, d.lat, _.lat)
                ], f = r && r.pitch ? r.pitch : this.getPitch(), g = this._cameraForBounds(this.transform, p, m, o, f, r);
                return this._fitInternal(g, r, s);
            }
            _fitInternal(t1, i, o) {
                return t1 ? (i = e.l(t1, i)).linear ? this.easeTo(i, o) : this.flyTo(i, o) : this;
            }
            jumpTo(t1, i) {
                this.stop();
                const o = t1.preloadOnly ? this.transform.clone() : this.transform;
                let r = !1, s = !1, a = !1;
                "zoom" in t1 && o.zoom !== +t1.zoom && (r = !0, o.zoom = +t1.zoom), void 0 !== t1.center && (o.center = e.bK.convert(t1.center)), "bearing" in t1 && o.bearing !== +t1.bearing && (s = !0, o.bearing = +t1.bearing), "pitch" in t1 && o.pitch !== +t1.pitch && (a = !0, o.pitch = +t1.pitch);
                const n = "number" == typeof t1.padding ? this._extendPadding(t1.padding) : t1.padding;
                if (null != t1.padding && !o.isPaddingEqual(n)) {
                    if (!1 === t1.retainPadding) {
                        const e = o.clone();
                        e.padding = n, o.setLocationAtPoint(o.center, e.centerPoint);
                    } else o.padding = n;
                }
                return t1.preloadOnly ? (this._preloadTiles(o), this) : (this.fire(new e.x("movestart", i)).fire(new e.x("move", i)), r && this.fire(new e.x("zoomstart", i)).fire(new e.x("zoom", i)).fire(new e.x("zoomend", i)), s && this.fire(new e.x("rotatestart", i)).fire(new e.x("rotate", i)).fire(new e.x("rotateend", i)), a && this.fire(new e.x("pitchstart", i)).fire(new e.x("pitch", i)).fire(new e.x("pitchend", i)), this.fire(new e.x("moveend", i)));
            }
            getFreeCameraOptions() {
                return this.transform.projection.supportsFreeCamera || e.w(wn), this.transform.getFreeCameraOptions();
            }
            setFreeCameraOptions(t1, i) {
                const o = this.transform;
                if (!o.projection.supportsFreeCamera) return e.w(wn), this;
                this.stop();
                const r = o.zoom, s = o.pitch, a = o.bearing;
                o.setFreeCameraOptions(t1);
                const n = r !== o.zoom, l = s !== o.pitch, c = a !== o.bearing;
                return this.fire(new e.x("movestart", i)).fire(new e.x("move", i)), n && this.fire(new e.x("zoomstart", i)).fire(new e.x("zoom", i)).fire(new e.x("zoomend", i)), c && this.fire(new e.x("rotatestart", i)).fire(new e.x("rotate", i)).fire(new e.x("rotateend", i)), l && this.fire(new e.x("pitchstart", i)).fire(new e.x("pitch", i)).fire(new e.x("pitchend", i)), this.fire(new e.x("moveend", i)), this;
            }
            easeTo(t1, i) {
                this._stop(!1, t1.easeId), (!1 === (t1 = e.l({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: e.dr
                }, t1)).animate || this._prefersReducedMotion(t1)) && (t1.duration = 0);
                const o = this.transform, r = this.getZoom(), s = this.getBearing(), a = this.getPitch(), n = this.getPadding(), l = "zoom" in t1 ? +t1.zoom : r, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, s) : s, h = "pitch" in t1 ? +t1.pitch : a, u = this._extendPadding(t1.padding), d = e.P.convert(t1.offset);
                let _, p, m;
                if ("globe" === o.projection.name) {
                    const i = e.a5.fromLngLat(o.center), r = d.rotate(-o.angle);
                    i.x += r.x / o.worldSize, i.y += r.y / o.worldSize;
                    const s = i.toLngLat(), a = e.bK.convert(t1.center || s);
                    this._normalizeCenter(a), _ = o.centerPoint.add(r), p = new e.P(i.x, i.y).mult(o.worldSize), m = new e.P(e.am(a.lng), e.at(a.lat)).mult(o.worldSize).sub(p);
                } else {
                    _ = o.centerPoint.add(d);
                    const i = o.pointLocation(_), r = e.bK.convert(t1.center || i);
                    this._normalizeCenter(r), p = o.project(i), m = o.project(r).sub(p);
                }
                const f = o.zoomScale(l - r);
                let g, v;
                t1.around && (g = e.bK.convert(t1.around), v = o.locationPoint(g));
                const x = this._zooming || l !== r, y = this._rotating || s !== c, b = this._pitching || h !== a, w = !o.isPaddingEqual(u), T = !1 === t1.retainPadding ? o.clone() : o, E = (o)=>(E)=>{
                        if (x && (o.zoom = e.aa(r, l, E)), y && (o.bearing = e.aa(s, c, E)), b && (o.pitch = e.aa(a, h, E)), w && (T.interpolatePadding(n, u, E), _ = T.centerPoint.add(d)), g) o.setLocationAtPoint(g, v);
                        else {
                            const e = o.zoomScale(o.zoom - r), t1 = l > r ? Math.min(2, f) : Math.max(.5, f), i = Math.pow(t1, 1 - E), s = o.unproject(p.add(m.mult(E * i)).mult(e));
                            o.setLocationAtPoint(o.renderWorldCopies ? s.wrap() : s, _);
                        }
                        return t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e = this._emulate(E, t1.duration, o);
                    return this._preloadTiles(e), this;
                }
                const C = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = x, this._rotating = y, this._pitching = b, this._padding = w, this._easeId = t1.easeId, this._prepareEase(i, t1.noMoveStart, C), this._ease(E(o), (e)=>{
                    "sea" === o.cameraElevationReference && o.recenterOnTerrain(), this._afterEase(i, e);
                }, t1), this;
            }
            _prepareEase(t1, i, o = {}) {
                this._moving = !0, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), i || o.moving || this.fire(new e.x("movestart", t1)), this._zooming && !o.zooming && this.fire(new e.x("zoomstart", t1)), this._rotating && !o.rotating && this.fire(new e.x("rotatestart", t1)), this._pitching && !o.pitching && this.fire(new e.x("pitchstart", t1));
            }
            _fireMoveEvents(t1) {
                this.fire(new e.x("move", t1)), this._zooming && this.fire(new e.x("zoom", t1)), this._rotating && this.fire(new e.x("rotate", t1)), this._pitching && this.fire(new e.x("pitch", t1));
            }
            _afterEase(t1, i) {
                if (this._easeId && i && this._easeId === i) return;
                this._easeId = void 0, this.transform.cameraElevationReference = "ground";
                const o = this._zooming, r = this._rotating, s = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, o && this.fire(new e.x("zoomend", t1)), r && this.fire(new e.x("rotateend", t1)), s && this.fire(new e.x("pitchend", t1)), this.fire(new e.x("moveend", t1));
            }
            flyTo(t1, i) {
                if (this._prefersReducedMotion(t1)) {
                    const o = e.ar(t1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around",
                        "padding",
                        "retainPadding"
                    ]);
                    return this.jumpTo(o, i);
                }
                this.stop(), t1 = e.l({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: e.dr
                }, t1);
                const o = this.transform, r = this.getZoom(), s = this.getBearing(), a = this.getPitch(), n = this.getPadding(), l = "zoom" in t1 ? e.ap(+t1.zoom, o.minZoom, o.maxZoom) : r, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, s) : s, h = "pitch" in t1 ? +t1.pitch : a, u = this._extendPadding(t1.padding), d = o.zoomScale(l - r), _ = e.P.convert(t1.offset);
                let p = o.centerPoint.add(_);
                const m = o.pointLocation(p), f = e.bK.convert(t1.center || m);
                this._normalizeCenter(f);
                const g = o.project(m), v = o.project(f).sub(g);
                let x = t1.curve;
                const y = Math.max(o.width, o.height), b = y / d, w = v.mag();
                if ("minZoom" in t1) {
                    const i = e.ap(Math.min(t1.minZoom, r, l), o.minZoom, o.maxZoom), s = y / o.zoomScale(i - r);
                    x = Math.sqrt(s / w * 2);
                }
                const T = x * x;
                function E(e) {
                    const t1 = (b * b - y * y + (e ? -1 : 1) * T * T * w * w) / (2 * (e ? b : y) * T * w);
                    return Math.log(Math.sqrt(t1 * t1 + 1) - t1);
                }
                function C(e) {
                    return (Math.exp(e) - Math.exp(-e)) / 2;
                }
                function S(e) {
                    return (Math.exp(e) + Math.exp(-e)) / 2;
                }
                const I = E(0);
                let D = function(e) {
                    return S(I) / S(I + x * e);
                }, R = function(e) {
                    var t1;
                    return y * ((S(I) * (C(t1 = I + x * e) / S(t1)) - C(I)) / T) / w;
                }, A = (E(1) - I) / x;
                if (Math.abs(w) < 1e-6 || !isFinite(A)) {
                    if (Math.abs(y - b) < 1e-6) return this.easeTo(t1, i);
                    const e = b < y ? -1 : 1;
                    A = Math.abs(Math.log(b / y)) / x, R = function() {
                        return 0;
                    }, D = function(t1) {
                        return Math.exp(e * x * t1);
                    };
                }
                t1.duration = "duration" in t1 ? +t1.duration : 1e3 * A / ("screenSpeed" in t1 ? +t1.screenSpeed / x : +t1.speed), t1.maxDuration && t1.duration > t1.maxDuration && (t1.duration = 0);
                const L = s !== c, P = h !== a, M = !o.isPaddingEqual(u), z = !1 === t1.retainPadding ? o.clone() : o, O = (o)=>(d)=>{
                        const m = d * A, x = 1 / D(m);
                        o.zoom = 1 === d ? l : r + o.scaleZoom(x), L && (o.bearing = e.aa(s, c, d)), P && (o.pitch = e.aa(a, h, d)), M && (z.interpolatePadding(n, u, d), p = z.centerPoint.add(_));
                        const y = 1 === d ? f : o.unproject(g.add(v.mult(R(m))).mult(x));
                        return o.setLocationAtPoint(o.renderWorldCopies ? y.wrap() : y, p), o._updateCameraOnTerrain(), t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e = this._emulate(O, t1.duration, o);
                    return this._preloadTiles(e), this;
                }
                return this._zooming = !0, this._rotating = L, this._pitching = P, this._padding = M, this._prepareEase(i, !1), this._ease(O(o), ()=>this._afterEase(i), t1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _requestRenderFrame(e) {}
            _cancelRenderFrame(e) {}
            _stop(e, t1) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
                    const e = this._onEaseEnd;
                    this._onEaseEnd = void 0, e.call(this, t1);
                }
                if (!e) {
                    const e = this.handlers;
                    e && e.stop(!1);
                }
                return this;
            }
            _ease(t1, i, o) {
                !1 === o.animate || 0 === o.duration ? (t1(1), i()) : (this._easeStart = e.q.now(), this._easeOptions = o, this._onEaseFrame = t1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const t1 = Math.min((e.q.now() - this._easeStart) / this._easeOptions.duration, 1), i = this._onEaseFrame;
                i && i(this._easeOptions.easing(t1)), t1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(t1, i) {
                t1 = e.bA(t1, -180, 180);
                const o = Math.abs(t1 - i);
                return Math.abs(t1 - 360 - i) < o && (t1 -= 360), Math.abs(t1 + 360 - i) < o && (t1 += 360), t1;
            }
            _normalizeCenter(e) {
                const t1 = this.transform;
                if (t1.maxBounds) return;
                if ("globe" !== t1.projection.name && !t1.renderWorldCopies) return;
                const i = e.lng - t1.center.lng;
                e.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            _prefersReducedMotion(t1) {
                return this._respectPrefersReducedMotion && e.q.prefersReducedMotion && !(t1 && t1.essential);
            }
            _emulate(e, t1, i) {
                const o = Math.ceil(15 * t1 / 1e3), r = [], s = e(i.clone());
                for(let e = 0; e <= o; e++){
                    const t1 = s(e / o);
                    r.push(t1.clone());
                }
                return r;
            }
            _preloadTiles(e, t1) {}
        }
        class En {
            constructor(t1 = {}){
                this.options = t1, e.aJ([
                    "_toggleAttribution",
                    "_updateEditLink",
                    "_updateData",
                    "_updateCompact"
                ], this);
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e) {
                const t1 = this.options && this.options.compact, i = e._getUIString("AttributionControl.ToggleAttribution");
                this._map = e, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = l("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._compactButton.setAttribute("aria-label", i);
                const o = l("span", "mapboxgl-ctrl-icon", this._compactButton);
                return o.setAttribute("aria-hidden", "true"), o.setAttribute("title", i), this._innerContainer = l("div", "mapboxgl-ctrl-attrib-inner", this._container), t1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
            }
            _toggleAttribution() {
                this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
            }
            _updateEditLink() {
                let t1 = this._editLink;
                t1 || (t1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                const i = [
                    {
                        key: "owner",
                        value: this.styleOwner
                    },
                    {
                        key: "id",
                        value: this.styleId
                    },
                    {
                        key: "access_token",
                        value: this._map._requestManager._customAccessToken || e.e.ACCESS_TOKEN
                    }
                ];
                if (t1) {
                    const o = i.reduce((e, t1, o)=>(t1.value && (e += `${t1.key}=${t1.value}${o < i.length - 1 ? "&" : ""}`), e), "?");
                    t1.href = `${e.e.FEEDBACK_URL}/${o}#${Ca(this._map, !0)}`, t1.rel = "noopener nofollow";
                }
            }
            _updateData(e) {
                !e || "metadata" !== e.sourceDataType && "visibility" !== e.sourceDataType && "style" !== e.dataType || (this._updateAttributions(), this._updateEditLink());
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e = [];
                if (this._map.style.stylesheet) {
                    const e = this._map.style.stylesheet;
                    this.styleOwner = e.owner, this.styleId = e.id;
                }
                const t1 = this._map.style._mergedSourceCaches;
                for(const i in t1){
                    const o = t1[i];
                    if (o.used) {
                        const t1 = o.getSource();
                        t1.attribution && e.indexOf(t1.attribution) < 0 && e.push(t1.attribution);
                    }
                }
                e.sort((e, t1)=>e.length - t1.length), e = e.filter((t1, i)=>{
                    for(let o = i + 1; o < e.length; o++)if (e[o].indexOf(t1) >= 0) return !1;
                    return !0;
                }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e = [
                    ...this.options.customAttribution,
                    ...e
                ] : e.unshift(this.options.customAttribution));
                const i = e.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
            }
        }
        class Cn {
            constructor(){
                e.aJ([
                    "_updateLogo",
                    "_updateCompact"
                ], this);
            }
            onAdd(e) {
                this._map = e, this._container = l("div", "mapboxgl-ctrl");
                const t1 = l("a", "mapboxgl-ctrl-logo");
                return t1.target = "_blank", t1.rel = "noopener nofollow", t1.href = "https://www.mapbox.com/", t1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            _updateLogo(e) {
                e && "metadata" !== e.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
            }
            _logoRequired() {
                if (!this._map.style) return !0;
                const e = this._map.style._sourceCaches;
                if (0 === Object.entries(e).length) return !0;
                for(const t1 in e){
                    const i = e[t1].getSource();
                    if (i.hasOwnProperty("mapbox_logo") && !i.mapbox_logo) return !1;
                }
                return !0;
            }
            _updateCompact() {
                const e = this._container.children;
                if (e.length) {
                    const t1 = e[0];
                    this._map.getCanvasContainer().offsetWidth < 250 ? t1.classList.add("mapboxgl-compact") : t1.classList.remove("mapboxgl-compact");
                }
            }
        }
        class Sn {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(e) {
                const t1 = ++this._id;
                return this._queue.push({
                    callback: e,
                    id: t1,
                    cancelled: !1
                }), t1;
            }
            remove(e) {
                const t1 = this._currentlyRunning, i = t1 ? this._queue.concat(t1) : this._queue;
                for (const t1 of i)if (t1.id === e) return void (t1.cancelled = !0);
            }
            run(e = 0) {
                const t1 = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t1)if (!i.cancelled && (i.callback(e), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        class In {
            constructor(e){
                this.jumpTo(e);
            }
            getValue(t1) {
                if (t1 <= this._startTime) return this._start;
                if (t1 >= this._endTime) return this._end;
                const i = e.cw((t1 - this._startTime) / (this._endTime - this._startTime));
                return this._start * (1 - i) + this._end * i;
            }
            isEasing(e) {
                return e >= this._startTime && e <= this._endTime;
            }
            jumpTo(e) {
                this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e, this._end = e;
            }
            easeTo(e, t1, i) {
                this._start = this.getValue(t1), this._end = e, this._startTime = t1, this._endTime = t1 + i;
            }
        }
        const Dn = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox homepage",
            "Map.Title": "Map",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map",
            "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map",
            "TouchPanBlocker.Message": "Use two fingers to move the map"
        };
        class Rn {
            registerParameter() {}
            registerButton() {}
            registerBinding() {}
            refreshUI() {}
        }
        class An {
            constructor(e){
                this.map = e, this.interactionsByType = new Map, this.typeById = new Map, this.filters = new Map, this.handleType = this.handleType.bind(this);
            }
            add(t1, i) {
                if (this.typeById.has(t1)) throw new Error(`Interaction id "${t1}" already exists.`);
                const { type: o, filter: r } = i;
                if (r) {
                    const i = e.M(r, {
                        type: "boolean",
                        "property-type": "data-driven",
                        overridable: !1,
                        transition: !1
                    });
                    if ("error" === i.result) throw new Error(i.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                    this.filters.set(t1, i.value);
                }
                const s = this.interactionsByType.get(o) || new Map;
                0 === s.size && (this.map.on(o, this.handleType), this.interactionsByType.set(o, s)), s.set(t1, i), this.typeById.set(t1, o);
            }
            remove(e) {
                const t1 = this.typeById.get(e);
                if (!t1) return;
                this.typeById.delete(e), this.filters.delete(e);
                const i = this.interactionsByType.get(t1);
                i && (i.delete(e), 0 === i.size && this.map.off(t1, this.handleType));
            }
            handleType(e) {
                const t1 = e.features || this.map.queryRenderedFeatures(e.point);
                if (!t1) return;
                const i = this.interactionsByType.get(e.type), o = {
                    zoom: 0
                };
                for (const [e, r] of i){
                    const i = this.filters.get(e), { handler: s, layers: a } = r;
                    for (const n of t1)if ((!a || a.includes(n.layer.id)) && (!i || i.evaluate(o, n)) && !1 !== s({
                        id: e,
                        feature: n,
                        interaction: r
                    })) break;
                }
            }
        }
        const Ln = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 85,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            performanceMetricsCollection: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            antialias: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            minTileCacheSize: null,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            localFontFamily: null,
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            respectPrefersReducedMotion: !0,
            crossSourceCollisions: !0,
            collectResourceTiming: !1,
            testMode: !1,
            precompilePrograms: !0
        }, Pn = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class Mn {
            constructor(t1, i, o = !1){
                this._clickTolerance = 10, this.element = i, this.mouseRotate = new Wa({
                    clickTolerance: t1.dragRotate._mouseRotate._clickTolerance
                }), this.map = t1, o && (this.mousePitch = new $a({
                    clickTolerance: t1.dragRotate._mousePitch._clickTolerance
                })), e.aJ([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), i.addEventListener("mousedown", this.mousedown), i.addEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener("touchmove", this.touchmove), i.addEventListener("touchend", this.touchend), i.addEventListener("touchcancel", this.reset);
            }
            down(e, t1) {
                this.mouseRotate.mousedown(e, t1), this.mousePitch && this.mousePitch.mousedown(e, t1), _();
            }
            move(e, t1) {
                const i = this.map, o = this.mouseRotate.mousemoveWindow(e, t1), r = o && o.bearingDelta;
                if (r && i.setBearing(i.getBearing() + r), this.mousePitch) {
                    const o = this.mousePitch.mousemoveWindow(e, t1), r = o && o.pitchDelta;
                    r && i.setPitch(i.getPitch() + r);
                }
            }
            off() {
                const e = this.element;
                e.removeEventListener("mousedown", this.mousedown), e.removeEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), e.removeEventListener("touchmove", this.touchmove), e.removeEventListener("touchend", this.touchend), e.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                p(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup);
            }
            mousedown(t1) {
                this.down(e.l({}, t1, {
                    ctrlKey: !0,
                    preventDefault: ()=>t1.preventDefault()
                }), g(this.element, t1)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
            }
            mousemove(e) {
                this.move(e, g(this.element, e));
            }
            mouseup(e) {
                this.mouseRotate.mouseupWindow(e), this.mousePitch && this.mousePitch.mouseupWindow(e), this.offTemp();
            }
            touchstart(e) {
                1 !== e.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = v(this.element, e.targetTouches)[0], this.down({
                    type: "mousedown",
                    button: 0,
                    ctrlKey: !0,
                    preventDefault: ()=>e.preventDefault()
                }, this._startPos));
            }
            touchmove(e) {
                1 !== e.targetTouches.length ? this.reset() : (this._lastPos = v(this.element, e.targetTouches)[0], this.move({
                    preventDefault: ()=>e.preventDefault()
                }, this._lastPos));
            }
            touchend(e) {
                0 === e.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
        }
        function zn(t1, i, o) {
            if (t1 = new e.bK(t1.lng, t1.lat), i) {
                const r = new e.bK(t1.lng - 360, t1.lat), s = new e.bK(t1.lng + 360, t1.lat), a = 360 * Math.ceil(Math.abs(t1.lng - o.center.lng) / 360), n = o.locationPoint(t1).distSqr(i), l = i.x < 0 || i.y < 0 || i.x > o.width || i.y > o.height;
                o.locationPoint(r).distSqr(i) < n && (l || Math.abs(r.lng - o.center.lng) < a) ? t1 = r : o.locationPoint(s).distSqr(i) < n && (l || Math.abs(s.lng - o.center.lng) < a) && (t1 = s);
            }
            for(; Math.abs(t1.lng - o.center.lng) > 180;){
                const e = o.locationPoint(t1);
                if (e.x >= 0 && e.y >= 0 && e.x <= o.width && e.y <= o.height) break;
                t1.lng > o.center.lng ? t1.lng -= 360 : t1.lng += 360;
            }
            return t1;
        }
        const On = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        class Fn extends e.E {
            constructor(t1, i){
                if (super(), (t1 instanceof HTMLElement || i) && (t1 = e.l({
                    element: t1
                }, i)), e.aJ([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress",
                    "_clearFadeTimer"
                ], this), this._anchor = t1 && t1.anchor || "center", this._color = t1 && t1.color || "#3FB1CE", this._scale = t1 && t1.scale || 1, this._draggable = t1 && t1.draggable || !1, this._clickTolerance = t1 && t1.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = t1 && t1.rotation || 0, this._rotationAlignment = t1 && t1.rotationAlignment || "auto", this._pitchAlignment = t1 && t1.pitchAlignment && t1.pitchAlignment || "auto", this._updateMoving = ()=>this._update(!0), this._occludedOpacity = t1 && t1.occludedOpacity || .2, t1 && t1.element) this._element = t1.element, this._offset = e.P.convert(t1 && t1.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = l("div");
                    const i = 41, o = 27, r = c("svg", {
                        display: "block",
                        height: i * this._scale + "px",
                        width: o * this._scale + "px",
                        viewBox: `0 0 ${o} ${i}`
                    }, this._element), s = c("radialGradient", {
                        id: "shadowGradient"
                    }, c("defs", {}, r));
                    c("stop", {
                        offset: "10%",
                        "stop-opacity": .4
                    }, s), c("stop", {
                        offset: "100%",
                        "stop-opacity": .05
                    }, s), c("ellipse", {
                        cx: 13.5,
                        cy: 34.8,
                        rx: 10.5,
                        ry: 5.25,
                        fill: "url(#shadowGradient)"
                    }, r), c("path", {
                        fill: this._color,
                        d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"
                    }, r), c("path", {
                        opacity: .25,
                        d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"
                    }, r), c("circle", {
                        fill: "white",
                        cx: 13.5,
                        cy: 13.5,
                        r: 5.5
                    }, r), this._offset = e.P.convert(t1 && t1.offset || [
                        0,
                        -14
                    ]);
                }
                this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e)=>{
                    e.preventDefault();
                }), this._element.addEventListener("mousedown", (e)=>{
                    e.preventDefault();
                });
                const o = this._element.classList;
                for(const e in On)o.remove(`mapboxgl-marker-anchor-${e}`);
                o.add(`mapboxgl-marker-anchor-${this._anchor}`);
                const r = t1 && t1.className ? t1.className.trim().split(/\s+/) : [];
                o.add(...r), this._popup = null;
            }
            addTo(e) {
                return e === this._map || (this.remove(), this._map = e, e.getCanvasContainer().appendChild(this._element), e.on("move", this._updateMoving), e.on("moveend", this._update), e.on("remove", this._clearFadeTimer), e._addMarker(this), this.setDraggable(this._draggable), this._update(), e.on("click", this._onMapClick)), this;
            }
            remove() {
                const e = this._map;
                return e && (e.off("click", this._onMapClick), e.off("move", this._updateMoving), e.off("moveend", this._update), e.off("mousedown", this._addDragHandler), e.off("touchstart", this._addDragHandler), e.off("mouseup", this._onUp), e.off("touchend", this._onUp), e.off("mousemove", this._onMove), e.off("touchmove", this._onMove), e.off("remove", this._clearFadeTimer), e._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(t1) {
                return this._lngLat = e.bK.convert(t1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(e) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e) {
                    if (!("offset" in e.options)) {
                        const t1 = 38.1, i = 13.5, o = Math.sqrt(Math.pow(i, 2) / 2);
                        e.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -t1
                            ],
                            "bottom-left": [
                                o,
                                -1 * (t1 - i + o)
                            ],
                            "bottom-right": [
                                -o,
                                -1 * (t1 - i + o)
                            ],
                            left: [
                                i,
                                -1 * (t1 - i)
                            ],
                            right: [
                                -i,
                                -1 * (t1 - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e, e._marker = this, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
                }
                return this;
            }
            _onKeyPress(e) {
                const t1 = e.code, i = e.charCode || e.keyCode;
                "Space" !== t1 && "Enter" !== t1 && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(e) {
                const t1 = e.originalEvent.target, i = this._element;
                this._popup && (t1 === i || i.contains(t1)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e = this._popup;
                return e ? (e.isOpen() ? (e.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
            }
            _behindTerrain() {
                const e = this._map, t1 = this._pos;
                if (!e || !t1) return !1;
                const i = e.unproject(t1), o = e.getFreeCameraOptions();
                if (!o.position) return !1;
                const r = o.position.toLngLat();
                return r.distanceTo(i) < .9 * r.distanceTo(this._lngLat);
            }
            _evaluateOpacity() {
                const t1 = this._map;
                if (!t1) return;
                const i = this._pos;
                if (!i || i.x < 0 || i.x > t1.transform.width || i.y < 0 || i.y > t1.transform.height) return void this._clearFadeTimer();
                const o = t1.unproject(i);
                let r;
                t1._showingGlobe() && e.dz(t1.transform, this._lngLat) ? r = 0 : (r = 1 - t1._queryFogOpacity(o), t1.transform._terrainEnabled() && t1.getTerrain() && this._behindTerrain() && (r *= this._occludedOpacity)), this._element.style.opacity = `${r}`, this._element.style.pointerEvents = r > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(r), this._fadeTimer = null;
            }
            _clearFadeTimer() {
                this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
            }
            _updateDOM() {
                const e = this._pos;
                if (!e || !this._map) return;
                const t1 = this._offset.mult(this._scale);
                this._element.style.transform = `\n            translate(${e.x}px,${e.y}px)\n            ${On[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t1.x}px,${t1.y}px)\n        `;
            }
            _calculateXYTransform() {
                const t1 = this._pos, i = this._map, o = this.getPitchAlignment();
                if (!i || !t1 || "map" !== o) return "";
                if (!i._showingGlobe()) {
                    const e = i.getPitch();
                    return e ? `rotateX(${e}deg)` : "";
                }
                const r = e.c0(e.dA(i.transform, this._lngLat)), s = t1.sub(e.dB(i.transform)), a = Math.abs(s.x) + Math.abs(s.y);
                if (0 === a) return "";
                const n = r / a;
                return `rotateX(${-s.y * n}deg) rotateY(${s.x * n}deg)`;
            }
            _calculateZTransform() {
                const t1 = this._pos, i = this._map;
                if (!i || !t1) return "";
                let o = 0;
                const r = this.getRotationAlignment();
                if ("map" === r) {
                    if (i._showingGlobe()) {
                        const t1 = i.project(new e.bK(this._lngLat.lng, this._lngLat.lat + .001)), r = i.project(new e.bK(this._lngLat.lng, this._lngLat.lat - .001)).sub(t1);
                        o = e.c0(Math.atan2(r.y, r.x)) - 90;
                    } else o = -i.getBearing();
                } else if ("horizon" === r) {
                    const r = e.a7(4, 6, i.getZoom()), s = e.dB(i.transform);
                    s.y += r * i.transform.height;
                    const a = t1.sub(s), n = e.c0(Math.atan2(a.y, a.x));
                    o = (n > 90 ? n - 270 : n + 90) * (1 - r);
                }
                return o += this._rotation, o ? `rotateZ(${o}deg)` : "";
            }
            _update(e) {
                cancelAnimationFrame(this._updateFrameId);
                const t1 = this._map;
                t1 && (t1.transform.renderWorldCopies && (this._lngLat = zn(this._lngLat, this._pos, t1.transform)), this._pos = t1.project(this._lngLat), !0 === e ? this._updateFrameId = requestAnimationFrame(()=>{
                    this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
                }) : this._pos = this._pos.round(), t1._requestDomTask(()=>{
                    this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (t1._showingGlobe() || t1.getTerrain() || t1.getFog()) && !this._fadeTimer && (this._fadeTimer = window.setTimeout(this._evaluateOpacity.bind(this), 60)));
                }));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(t1) {
                return this._offset = e.P.convert(t1), this._update(), this;
            }
            addClassName(e) {
                return this._element.classList.add(e), this;
            }
            removeClassName(e) {
                return this._element.classList.remove(e), this;
            }
            toggleClassName(e) {
                return this._element.classList.toggle(e);
            }
            _onMove(t1) {
                const i = this._map;
                if (!i) return;
                const o = this._pointerdownPos, r = this._positionDelta;
                if (o && r) {
                    if (!this._isDragging) {
                        const e = this._clickTolerance || i._clickTolerance;
                        if (t1.point.dist(o) < e) return;
                        this._isDragging = !0;
                    }
                    this._pos = t1.point.sub(r), this._lngLat = i.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e.x("dragstart"))), this.fire(new e.x("drag"));
                }
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
                const t1 = this._map;
                t1 && (t1.off("mousemove", this._onMove), t1.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e.x("dragend")), this._state = "inactive";
            }
            _addDragHandler(e) {
                const t1 = this._map, i = this._pos;
                t1 && i && this._element.contains(e.originalEvent.target) && (e.preventDefault(), this._positionDelta = e.point.sub(i), this._pointerdownPos = e.point, this._state = "pending", t1.on("mousemove", this._onMove), t1.on("touchmove", this._onMove), t1.once("mouseup", this._onUp), t1.once("touchend", this._onUp));
            }
            setDraggable(e) {
                this._draggable = !!e;
                const t1 = this._map;
                return t1 && (e ? (t1.on("mousedown", this._addDragHandler), t1.on("touchstart", this._addDragHandler)) : (t1.off("mousedown", this._addDragHandler), t1.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e) {
                return this._rotation = e || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e) {
                return this._rotationAlignment = e || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
            }
            setPitchAlignment(e) {
                return this._pitchAlignment = e || "auto", this._update(), this;
            }
            getPitchAlignment() {
                return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
            }
            setOccludedOpacity(e) {
                return this._occludedOpacity = e || .2, this._update(), this;
            }
            getOccludedOpacity() {
                return this._occludedOpacity;
            }
        }
        const kn = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0,
            showUserHeading: !1
        }, Bn = {
            maxWidth: 100,
            unit: "metric"
        }, Nn = {
            kilometer: "km",
            meter: "m",
            mile: "mi",
            foot: "ft",
            "nautical-mile": "nm"
        }, Un = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px"
        }, Gn = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function jn(t1 = new e.P(0, 0), i = "bottom") {
            if ("number" == typeof t1) {
                const o = Math.round(Math.sqrt(.5 * Math.pow(t1, 2)));
                switch(i){
                    case "top":
                        return new e.P(0, t1);
                    case "top-left":
                        return new e.P(o, o);
                    case "top-right":
                        return new e.P(-o, o);
                    case "bottom":
                        return new e.P(0, -t1);
                    case "bottom-left":
                        return new e.P(o, -o);
                    case "bottom-right":
                        return new e.P(-o, -o);
                    case "left":
                        return new e.P(t1, 0);
                    case "right":
                        return new e.P(-t1, 0);
                }
                return new e.P(0, 0);
            }
            return t1 instanceof e.P || Array.isArray(t1) ? e.P.convert(t1) : e.P.convert(t1[i] || [
                0,
                0
            ]);
        }
        return {
            version: t1,
            supported: n.supported,
            setRTLTextPlugin: e.dC,
            getRTLTextPluginStatus: e.dD,
            Map: class extends Tn {
                constructor(t1){
                    o.mark(i.create);
                    const r = t1;
                    if (null != (t1 = e.l({}, Ln, t1)).minZoom && null != t1.maxZoom && t1.minZoom > t1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != t1.minPitch && null != t1.maxPitch && t1.minPitch > t1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != t1.minPitch && t1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != t1.maxPitch && t1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1.antialias && e.dx(window) && (t1.antialias = !1, e.w("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new Hi(t1.minZoom, t1.maxZoom, t1.minPitch, t1.maxPitch, t1.renderWorldCopies), t1), this._repaint = !!t1.repaint, this._interactive = t1.interactive, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t1.preserveDrawingBuffer, this._antialias = t1.antialias, this._trackResize = t1.trackResize, this._bearingSnap = t1.bearingSnap, this._refreshExpiredTiles = t1.refreshExpiredTiles, this._fadeDuration = t1.fadeDuration, this._isInitialLoad = !0, this._crossSourceCollisions = t1.crossSourceCollisions, this._collectResourceTiming = t1.collectResourceTiming, this._language = this._parseLanguage(t1.language), this._worldview = t1.worldview, this._renderTaskQueue = new Sn, this._domRenderTaskQueue = new Sn, this._controls = [], this._markers = [], this._popups = [], this._mapId = e.aP(), this._locale = e.l({}, Dn, t1.locale), this._clickTolerance = t1.clickTolerance, this._cooperativeGestures = t1.cooperativeGestures, this._performanceMetricsCollection = t1.performanceMetricsCollection, this._tessellationStep = t1.tessellationStep, this._containerWidth = 0, this._containerHeight = 0, this._showParseStatus = !0, this._precompilePrograms = t1.precompilePrograms, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new In(0), this._interactionRange = [
                        1 / 0,
                        -1 / 0
                    ], this._visibilityHidden = 0, this._useExplicitProjection = !1, this._frameId = 0, this._requestManager = new T(t1.transformRequest, t1.accessToken, t1.testMode), this._silenceAuthErrors = !!t1.testMode, this._contextCreateOptions = t1.contextCreateOptions ? {
                        ...t1.contextCreateOptions
                    } : {}, "string" == typeof t1.container) {
                        const e = document.getElementById(t1.container);
                        if (!e) throw new Error(`Container '${t1.container.toString()}' not found.`);
                        this._container = e;
                    } else {
                        if (!(t1.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = t1.container;
                    }
                    if (this._container.childNodes.length > 0 && e.w("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t1.maxBounds && this.setMaxBounds(t1.maxBounds), e.aJ([
                        "_onWindowOnline",
                        "_onWindowResize",
                        "_onVisibilityChange",
                        "_onMapScroll",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._tp || (this._tp = new Rn), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showOverdrawInspector"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showTileBoundaries"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showParseStatus"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "repaint"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showTileAABBs"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showPadding"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showCollisionBoxes", {
                        noSave: !0
                    }), this._tp.registerParameter(this.transform, [
                        "Debug"
                    ], "freezeTileCoverage", {
                        noSave: !0
                    }, ()=>{
                        this._update();
                    }), this._tp.registerParameter(this, [
                        "Debug",
                        "Wireframe"
                    ], "showTerrainWireframe"), this._tp.registerParameter(this, [
                        "Debug",
                        "Wireframe"
                    ], "showLayers2DWireframe"), this._tp.registerParameter(this, [
                        "Debug",
                        "Wireframe"
                    ], "showLayers3DWireframe"), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                    if (this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this._fullscreenchangeEvent = "onfullscreenchange" in document ? "fullscreenchange" : "webkitfullscreenchange", window.addEventListener("online", this._onWindowOnline, !1), window.addEventListener("resize", this._onWindowResize, !1), window.addEventListener("orientationchange", this._onWindowResize, !1), window.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.addEventListener("visibilitychange", this._onVisibilityChange, !1), this.handlers = new bn(this, t1), this._localFontFamily = t1.localFontFamily, this._localIdeographFontFamily = t1.localIdeographFontFamily, (t1.style || !t1.testMode) && this.setStyle(t1.style || e.e.DEFAULT_STYLE, {
                        config: t1.config,
                        localFontFamily: this._localFontFamily,
                        localIdeographFontFamily: this._localIdeographFontFamily
                    }), t1.projection && this.setProjection(t1.projection), t1.hash && (this._hash = new Ea("string" == typeof t1.hash && t1.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
                        null == r.center && null == r.zoom || (this.transform._unmodified = !1), this.jumpTo({
                            center: t1.center,
                            zoom: t1.zoom,
                            bearing: t1.bearing,
                            pitch: t1.pitch
                        });
                        const i = t1.bounds;
                        i && (this.resize(), this.fitBounds(i, e.l({}, t1.fitBoundsOptions, {
                            duration: 0
                        })));
                    }
                    this.resize(), t1.attributionControl && this.addControl(new En({
                        customAttribution: t1.customAttribution
                    })), this._logoControl = new Cn, this.addControl(this._logoControl, t1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet), this._postStyleLoadEvent();
                    }), this.on("data", (t1)=>{
                        this._update("style" === t1.dataType), this.fire(new e.x(`${t1.dataType}data`, t1));
                    }), this.on("dataloading", (t1)=>{
                        this.fire(new e.x(`${t1.dataType}dataloading`, t1));
                    }), this._interactions = new An(this);
                }
                _getMapId() {
                    return this._mapId;
                }
                addControl(t1, i) {
                    if (void 0 === i && (i = t1.getDefaultPosition ? t1.getDefaultPosition() : "top-right"), !t1 || !t1.onAdd) return this.fire(new e.t(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const o = t1.onAdd(this);
                    this._controls.push(t1);
                    const r = this._controlPositions[i];
                    return -1 !== i.indexOf("bottom") ? r.insertBefore(o, r.firstChild) : r.appendChild(o), this;
                }
                removeControl(t1) {
                    if (!t1 || !t1.onRemove) return this.fire(new e.t(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = this._controls.indexOf(t1);
                    return i > -1 && this._controls.splice(i, 1), t1.onRemove(this), this;
                }
                hasControl(e) {
                    return this._controls.indexOf(e) > -1;
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                resize(t1) {
                    if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
                    this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
                    const i = !this._moving;
                    return i && this.fire(new e.x("movestart", t1)).fire(new e.x("move", t1)), this.fire(new e.x("resize", t1)), i && this.fire(new e.x("moveend", t1)), this;
                }
                getBounds() {
                    return this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds() || null;
                }
                setMaxBounds(t1) {
                    return this.transform.setMaxBounds(e.as.convert(t1)), this._update();
                }
                setMinZoom(t1) {
                    if ((t1 = t1 ?? -2) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 ? this.setZoom(t1) : this.fire(new e.x("zoomstart")).fire(new e.x("zoom")).fire(new e.x("zoomend")), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(t1) {
                    if ((t1 = t1 ?? 22) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 ? this.setZoom(t1) : this.fire(new e.x("zoomstart")).fire(new e.x("zoom")).fire(new e.x("zoomend")), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(t1) {
                    if ((t1 = t1 ?? 0) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 ? this.setPitch(t1) : this.fire(new e.x("pitchstart")).fire(new e.x("pitch")).fire(new e.x("pitchend")), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(t1) {
                    if ((t1 = t1 ?? 85) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 ? this.setPitch(t1) : this.fire(new e.x("pitchstart")).fire(new e.x("pitch")).fire(new e.x("pitchend")), this;
                    throw new Error("maxPitch must be greater than or equal to minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(e) {
                    return this.transform.renderWorldCopies = e, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(!0), this._update();
                }
                getLanguage() {
                    return this._language;
                }
                _parseLanguage(e) {
                    return "auto" === e ? navigator.language : Array.isArray(e) ? 0 === e.length ? void 0 : e.map((e)=>"auto" === e ? navigator.language : e) : e;
                }
                setLanguage(e) {
                    const t1 = this._parseLanguage(e);
                    if (!this.style || t1 === this._language) return this;
                    this._language = t1, this.style.reloadSources();
                    for (const e of this._controls)e._setLanguage && e._setLanguage(this._language);
                    return this;
                }
                getWorldview() {
                    return this._worldview;
                }
                setWorldview(e) {
                    return this.style && e !== this._worldview ? (this._worldview = e, this.style.reloadSources(), this) : this;
                }
                getProjection() {
                    return this.transform.mercatorFromTransition ? {
                        name: "globe",
                        center: [
                            0,
                            0
                        ]
                    } : this.transform.getProjection();
                }
                _showingGlobe() {
                    return "globe" === this.transform.projection.name;
                }
                setProjection(e) {
                    return this._lazyInitEmptyStyle(), e ? "string" == typeof e && (e = {
                        name: e
                    }) : e = null, this._useExplicitProjection = !!e, this._prioritizeAndUpdateProjection(e, this.style.projection);
                }
                _updateProjectionTransition() {
                    if ("globe" !== this.getProjection().name) return;
                    const t1 = this.transform, i = t1.projection.name;
                    let o;
                    "globe" === i && t1.zoom >= e.bU ? (t1.setMercatorFromTransition(), o = !0) : "mercator" === i && t1.zoom < e.bU && (t1.setProjection({
                        name: "globe"
                    }), o = !0), o && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate());
                }
                _prioritizeAndUpdateProjection(e, t1) {
                    return this._updateProjection(e || t1 || {
                        name: "mercator"
                    });
                }
                _updateProjection(t1) {
                    let i;
                    return i = "globe" === t1.name && this.transform.zoom >= e.bU ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t1), this.style.applyProjectionUpdate(), i && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(!0), this._forceMarkerAndPopupUpdate(!0)), this;
                }
                project(t1) {
                    return this.transform.locationPoint3D(e.bK.convert(t1));
                }
                unproject(t1) {
                    return this.transform.pointLocation3D(e.P.convert(t1));
                }
                isMoving() {
                    return this._moving || this.handlers && this.handlers.isMoving() || !1;
                }
                isZooming() {
                    return this._zooming || this.handlers && this.handlers.isZooming() || !1;
                }
                isRotating() {
                    return this._rotating || this.handlers && this.handlers.isRotating() || !1;
                }
                _isDragging() {
                    return this.handlers && this.handlers._isDragging() || !1;
                }
                _createDelegatedListener(e, t1, i) {
                    if ("mouseenter" === e || "mouseover" === e) {
                        let o = !1;
                        const r = (r)=>{
                            const s = t1.filter((e)=>this.getLayer(e)), a = s.length ? this.queryRenderedFeatures(r.point, {
                                layers: s
                            }) : [];
                            a.length ? o || (o = !0, i.call(this, new za(e, this, r.originalEvent, {
                                features: a
                            }))) : o = !1;
                        }, s = ()=>{
                            o = !1;
                        };
                        return {
                            layers: new Set(t1),
                            listener: i,
                            delegates: {
                                mousemove: r,
                                mouseout: s
                            }
                        };
                    }
                    if ("mouseleave" === e || "mouseout" === e) {
                        let o = !1;
                        const r = (r)=>{
                            const s = t1.filter((e)=>this.getLayer(e));
                            (s.length ? this.queryRenderedFeatures(r.point, {
                                layers: s
                            }) : []).length ? o = !0 : o && (o = !1, i.call(this, new za(e, this, r.originalEvent)));
                        }, s = (t1)=>{
                            o && (o = !1, i.call(this, new za(e, this, t1.originalEvent)));
                        };
                        return {
                            layers: new Set(t1),
                            listener: i,
                            delegates: {
                                mousemove: r,
                                mouseout: s
                            }
                        };
                    }
                    {
                        const o = (e)=>{
                            const o = t1.filter((e)=>this.getLayer(e)), r = o.length ? this.queryRenderedFeatures(e.point, {
                                layers: o
                            }) : [];
                            r.length && (e.features = r, i.call(this, e), delete e.features);
                        };
                        return {
                            layers: new Set(t1),
                            listener: i,
                            delegates: {
                                [e]: o
                            }
                        };
                    }
                }
                on(e, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.on(e, t1);
                    if (Array.isArray(t1) || (t1 = [
                        t1
                    ]), t1) {
                        for (const e of t1)if (!this._isValidId(e)) return this;
                    }
                    const o = this._createDelegatedListener(e, t1, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e] = this._delegatedListeners[e] || [], this._delegatedListeners[e].push(o);
                    for(const e in o.delegates)this.on(e, o.delegates[e]);
                    return this;
                }
                once(e, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.once(e, t1);
                    if (Array.isArray(t1) || (t1 = [
                        t1
                    ]), t1) {
                        for (const e of t1)if (!this._isValidId(e)) return this;
                    }
                    const o = this._createDelegatedListener(e, t1, i);
                    for(const e in o.delegates)this.once(e, o.delegates[e]);
                    return this;
                }
                off(e, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.off(e, t1);
                    const o = new Set(Array.isArray(t1) ? t1 : [
                        t1
                    ]);
                    for (const e of o)if (!this._isValidId(e)) return this;
                    const r = (e, t1)=>{
                        if (e.size !== t1.size) return !1;
                        for (const i of e)if (!t1.has(i)) return !1;
                        return !0;
                    }, s = this._delegatedListeners ? this._delegatedListeners[e] : void 0;
                    return s && ((e)=>{
                        for(let t1 = 0; t1 < e.length; t1++){
                            const s = e[t1];
                            if (s.listener === i && r(s.layers, o)) {
                                for(const e in s.delegates)this.off(e, s.delegates[e]);
                                return e.splice(t1, 1), this;
                            }
                        }
                    })(s), this;
                }
                queryRenderedFeatures(t1, i) {
                    if (!this.style) return [];
                    if (void 0 !== i || void 0 === t1 || t1 instanceof e.P || Array.isArray(t1) || (i = t1, t1 = void 0), t1 = t1 || [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ], (i = i || {}).layers && Array.isArray(i.layers)) {
                        for (const e of i.layers)if (!this._isValidId(e)) return [];
                    }
                    return this.style.queryRenderedFeatures(t1, i, this.transform);
                }
                querySourceFeatures(e, t1) {
                    return this._isValidId(e) ? this.style.querySourceFeatures(e, t1) : [];
                }
                isPointOnSurface(t1) {
                    const { name: i } = this.transform.projection;
                    return "globe" !== i && "mercator" !== i && e.w(`${i} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(e.P.convert(t1));
                }
                addInteraction(e, t1) {
                    return this._interactions.add(e, t1), this;
                }
                removeInteraction(e) {
                    return this._interactions.remove(e), this;
                }
                setStyle(t1, i) {
                    return i = e.l({}, {
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        localFontFamily: this._localFontFamily
                    }, i), this.style && t1 && !1 !== i.diff && i.localFontFamily === this._localFontFamily && i.localIdeographFontFamily === this._localIdeographFontFamily && !i.config ? (this.style._diffStyle(t1, (o, r)=>{
                        o ? (e.w(`Unable to perform style diff: ${String(o.message || o.error || o)}. Rebuilding the style from scratch.`), this._updateStyle(t1, i)) : r && this._update(!0);
                    }, ()=>{
                        this._postStyleLoadEvent();
                    }), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._localFontFamily = i.localFontFamily, this._updateStyle(t1, i));
                }
                _getUIString(e) {
                    const t1 = this._locale[e];
                    if (null == t1) throw new Error(`Missing UI string '${e}'`);
                    return t1;
                }
                _updateStyle(t1, i) {
                    if (this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), t1) {
                        const o = e.l({}, i);
                        i && i.config && (o.initialConfig = i.config, delete o.config), this.style = new co(this, o).load(t1), this.style.setEventedParent(this, {
                            style: this.style
                        });
                    }
                    return this._updateTerrain(), this;
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new co(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : (e.w("There is no style added to the map."), !1);
                }
                _isValidId(t1) {
                    return null == t1 ? (this.fire(new e.t(new Error("IDs can't be empty."))), !1) : !e.cn(t1) || (this.fire(new e.t(new Error(`IDs can't contain special symbols: "${t1}".`))), !1);
                }
                addSource(e, t1) {
                    return this._isValidId(e) ? (this._lazyInitEmptyStyle(), this.style.addSource(e, t1), this._update(!0)) : this;
                }
                isSourceLoaded(e) {
                    return !!this._isValidId(e) && !!this.style && this.style._isSourceCacheLoaded(e);
                }
                areTilesLoaded() {
                    return this.style.areTilesLoaded();
                }
                addSourceType(e, t1, i) {
                    this._lazyInitEmptyStyle(), this.style.addSourceType(e, t1, i);
                }
                removeSource(e) {
                    return this._isValidId(e) ? (this.style.removeSource(e), this._updateTerrain(), this._update(!0)) : this;
                }
                getSource(e) {
                    return this._isValidId(e) ? this.style.getOwnSource(e) : null;
                }
                addImage(t1, i, { pixelRatio: o = 1, sdf: r = !1, stretchX: s, stretchY: a, content: n } = {}) {
                    if (this._lazyInitEmptyStyle(), i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap) {
                        const { width: l, height: c, data: h } = e.q.getImageData(i);
                        this.style.addImage(t1, {
                            data: new e.r({
                                width: l,
                                height: c
                            }, h),
                            pixelRatio: o,
                            stretchX: s,
                            stretchY: a,
                            content: n,
                            sdf: r,
                            version: 0
                        });
                    } else if (void 0 === i.width || void 0 === i.height) this.fire(new e.t(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    else {
                        const { width: l, height: c } = i, h = i;
                        this.style.addImage(t1, {
                            data: new e.r({
                                width: l,
                                height: c
                            }, new Uint8Array(h.data)),
                            pixelRatio: o,
                            stretchX: s,
                            stretchY: a,
                            content: n,
                            sdf: r,
                            version: 0,
                            userImage: h
                        }), h.onAdd && h.onAdd(this, t1);
                    }
                }
                updateImage(t1, i) {
                    this._lazyInitEmptyStyle();
                    const o = this.style.getImage(t1);
                    if (!o) return void this.fire(new e.t(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const r = i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap ? e.q.getImageData(i) : i, { width: s, height: a, data: n } = r;
                    if (void 0 === s || void 0 === a) return void this.fire(new e.t(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    if (s !== o.data.width || a !== o.data.height) return void this.fire(new e.t(new Error(`The width and height of the updated image (${s}, ${a})\n                must be that same as the previous version of the image\n                (${o.data.width}, ${o.data.height})`)));
                    const l = !(i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap);
                    o.data.replace(n, l), this.style.updateImage(t1, o);
                }
                hasImage(t1) {
                    return t1 ? !!this.style && !!this.style.getImage(t1) : (this.fire(new e.t(new Error("Missing required image id"))), !1);
                }
                removeImage(e) {
                    this.style.removeImage(e);
                }
                loadImage(t1, i) {
                    e.o(this._requestManager.transformRequest(t1, e.R.Image), (t1, o)=>{
                        i(t1, o instanceof HTMLImageElement ? e.q.getImageData(o) : o);
                    });
                }
                listImages() {
                    return this.style.listImages();
                }
                addModel(e, t1) {
                    this._lazyInitEmptyStyle(), this.style.addModel(e, t1);
                }
                hasModel(t1) {
                    return t1 ? this.style.hasModel(t1) : (this.fire(new e.t(new Error("Missing required model id"))), !1);
                }
                removeModel(e) {
                    this.style.removeModel(e);
                }
                listModels() {
                    return this.style.listModels();
                }
                addLayer(e, t1) {
                    return this._isValidId(e.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e, t1), this._update(!0)) : this;
                }
                getSlot(e) {
                    const t1 = this.getLayer(e);
                    return t1 && t1.slot || null;
                }
                setSlot(e, t1) {
                    return this.style.setSlot(e, t1), this.style.mergeLayers(), this._update(!0);
                }
                addImport(e, t1) {
                    return this.style.addImport(e, t1), this;
                }
                updateImport(e, t1) {
                    return "string" != typeof t1 && t1.id !== e ? (this.removeImport(e), this.addImport(t1)) : (this.style.updateImport(e, t1), this._update(!0));
                }
                removeImport(e) {
                    return this.style.removeImport(e), this;
                }
                moveImport(e, t1) {
                    return this.style.moveImport(e, t1), this._update(!0);
                }
                moveLayer(e, t1) {
                    return this._isValidId(e) ? (this.style.moveLayer(e, t1), this._update(!0)) : this;
                }
                removeLayer(e) {
                    return this._isValidId(e) ? (this.style.removeLayer(e), this._update(!0)) : this;
                }
                getLayer(e) {
                    if (!this._isValidId(e)) return null;
                    const t1 = this.style.getOwnLayer(e);
                    return t1 ? "custom" === t1.type ? t1.implementation : t1.serialize() : void 0;
                }
                getSlots() {
                    return this.style.getSlots();
                }
                setLayerZoomRange(e, t1, i) {
                    return this._isValidId(e) ? (this.style.setLayerZoomRange(e, t1, i), this._update(!0)) : this;
                }
                setFilter(e, t1, i = {}) {
                    return this._isValidId(e) ? (this.style.setFilter(e, t1, i), this._update(!0)) : this;
                }
                getFilter(e) {
                    return this._isValidId(e) ? this.style.getFilter(e) : null;
                }
                setPaintProperty(e, t1, i, o = {}) {
                    return this._isValidId(e) ? (this.style.setPaintProperty(e, t1, i, o), this._update(!0)) : this;
                }
                getPaintProperty(e, t1) {
                    return this._isValidId(e) ? this.style.getPaintProperty(e, t1) : null;
                }
                setLayoutProperty(e, t1, i, o = {}) {
                    return this._isValidId(e) ? (this.style.setLayoutProperty(e, t1, i, o), this._update(!0)) : this;
                }
                getLayoutProperty(e, t1) {
                    return this._isValidId(e) ? this.style.getLayoutProperty(e, t1) : null;
                }
                getSchema(e) {
                    return this.style.getSchema(e);
                }
                setSchema(e, t1) {
                    return this.style.setSchema(e, t1), this._update(!0);
                }
                getConfig(e) {
                    return this.style.getConfig(e);
                }
                setConfig(e, t1) {
                    return this.style.setConfig(e, t1), this._update(!0);
                }
                getConfigProperty(e, t1) {
                    return this.style.getConfigProperty(e, t1);
                }
                setConfigProperty(e, t1, i) {
                    return this.style.setConfigProperty(e, t1, i), this._update(!0);
                }
                setLights(e) {
                    if (this._lazyInitEmptyStyle(), e && 1 === e.length && "flat" === e[0].type) {
                        const t1 = e[0];
                        t1.properties ? this.style.setFlatLight(t1.properties, t1.id, {}) : this.style.setFlatLight({}, "flat");
                    } else this.style.setLights(e), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = !0);
                    return this._update(!0);
                }
                getLights() {
                    const e = this.style.getLights() || [];
                    return 0 === e.length && e.push({
                        id: this.style.light.id,
                        type: "flat",
                        properties: this.style.getFlatLight()
                    }), e;
                }
                setLight(e, t1 = {}) {
                    return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([
                        {
                            id: "flat",
                            type: "flat",
                            properties: e
                        }
                    ]);
                }
                getLight() {
                    return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
                }
                setTerrain(e) {
                    return this._lazyInitEmptyStyle(), !e && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
                }
                getTerrain() {
                    return this.style ? this.style.getTerrain() : null;
                }
                setFog(e) {
                    return this._lazyInitEmptyStyle(), this.style.setFog(e), this._update(!0);
                }
                getFog() {
                    return this.style ? this.style.getFog() : null;
                }
                setColorTheme(e) {
                    return this._lazyInitEmptyStyle(), this.style.setColorTheme(e), this._update(!0);
                }
                setCamera(e) {
                    return this.style.setCamera(e), this._triggerCameraUpdate(e);
                }
                _triggerCameraUpdate(e) {
                    return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e["camera-projection"]));
                }
                getCamera() {
                    return this.style.camera;
                }
                _queryFogOpacity(t1) {
                    return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e.bK.convert(t1), this.transform) : 0;
                }
                setFeatureState(e, t1) {
                    return this._isValidId(e.source) ? (this.style.setFeatureState(e, t1), this._update()) : this;
                }
                removeFeatureState(e, t1) {
                    return this._isValidId(e.source) ? (this.style.removeFeatureState(e, t1), this._update()) : this;
                }
                getFeatureState(e) {
                    return this._isValidId(e.source) ? this.style.getFeatureState(e) : null;
                }
                _updateContainerDimensions() {
                    if (!this._container) return;
                    const e = this._container.getBoundingClientRect().width || 400, t1 = this._container.getBoundingClientRect().height || 300;
                    let i, o, r, s = this._container;
                    for(; s && (!o || !r);){
                        const e = window.getComputedStyle(s).transform;
                        e && "none" !== e && (i = e.match(/matrix.*\((.+)\)/)[1].split(", "), i[0] && "0" !== i[0] && "1" !== i[0] && (o = i[0]), i[3] && "0" !== i[3] && "1" !== i[3] && (r = i[3])), s = s.parentElement;
                    }
                    this._containerWidth = o ? Math.abs(e / o) : e, this._containerHeight = r ? Math.abs(t1 / r) : t1;
                }
                _detectMissingCSS() {
                    "rgb(250, 128, 114)" !== window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e.w("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                }
                _setupContainer() {
                    const e = this._container;
                    e.classList.add("mapboxgl-map"), (this._missingCSSCanary = l("div", "mapboxgl-canary", e)).style.visibility = "hidden", this._detectMissingCSS();
                    const t1 = this._canvasContainer = l("div", "mapboxgl-canvas-container", e);
                    this._canvas = l("canvas", "mapboxgl-canvas", t1), this._interactive && (t1.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
                    const i = this._controlContainer = l("div", "mapboxgl-control-container", e), o = this._controlPositions = {};
                    [
                        "top-left",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left"
                    ].forEach((e)=>{
                        o[e] = l("div", `mapboxgl-ctrl-${e}`, i);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _resizeCanvas(t1, i) {
                    const o = e.q.devicePixelRatio || 1;
                    this._canvas.width = o * Math.ceil(t1), this._canvas.height = o * Math.ceil(i), this._canvas.style.width = `${t1}px`, this._canvas.style.height = `${i}px`;
                }
                _addMarker(e) {
                    this._markers.push(e);
                }
                _removeMarker(e) {
                    const t1 = this._markers.indexOf(e);
                    -1 !== t1 && this._markers.splice(t1, 1);
                }
                _addPopup(e) {
                    this._popups.push(e);
                }
                _removePopup(e) {
                    const t1 = this._popups.indexOf(e);
                    -1 !== t1 && this._popups.splice(t1, 1);
                }
                _setupPainter() {
                    const t1 = e.l({}, n.supported.webGLContextAttributes, {
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    }), i = this._canvas.getContext("webgl2", t1);
                    i ? (G(i, !0), this.painter = new wa(i, this._contextCreateOptions, this.transform, this._tp), this.on("data", (e)=>{
                        "source" === e.dataType && this.painter.setTileLoadedFlag(!0);
                    }), e.m.testSupport(i)) : this.fire(new e.t(new Error("Failed to initialize WebGL")));
                }
                _contextLost(t1) {
                    t1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new e.x("webglcontextlost", {
                        originalEvent: t1
                    }));
                }
                _contextRestored(t1) {
                    this._setupPainter(), this.resize(), this._update(), this.fire(new e.x("webglcontextrestored", {
                        originalEvent: t1
                    }));
                }
                _onMapScroll(e) {
                    if (e.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                idle() {
                    return !this.isMoving() && this.loaded();
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                frameReady() {
                    return this.loaded() && !this._placementDirty;
                }
                _update(e) {
                    return this.style ? (this._styleDirty = this._styleDirty || e, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(e) {
                    return this._update(), this._renderTaskQueue.add(e);
                }
                _cancelRenderFrame(e) {
                    this._renderTaskQueue.remove(e);
                }
                _requestDomTask(e) {
                    !this.loaded() || this.loaded() && !this.isMoving() ? e() : this._domRenderTaskQueue.add(e);
                }
                _render(t1) {
                    let r;
                    this.fire(new e.x("renderstart")), ++this._frameId;
                    const s = this.painter.context.extTimerQuery, a = e.q.now(), n = this.painter.context.gl;
                    if (this.listens("gpu-timing-frame") && (r = n.createQuery(), n.beginQuery(s.TIME_ELAPSED_EXT, r)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], performance.now())), this._renderTaskQueue.run(t1), this._domRenderTaskQueue.run(t1), this._removed) return;
                    this._updateProjectionTransition();
                    const l = this._isInitialLoad ? 0 : this._fadeDuration;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const t1 = this.transform.zoom, i = this.transform.pitch, o = e.q.now(), r = new e.a3(t1, {
                            now: o,
                            fadeDuration: l,
                            pitch: i,
                            transition: this.style.transition
                        });
                        this.style.update(r);
                    }
                    this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
                    let c = !1;
                    this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), c = this._updateAverageElevation(a), this.style.updateSources(this.transform), this._forceMarkerAndPopupUpdate()) : c = this._updateAverageElevation(a);
                    const h = this.style && this.style._updatePlacement(this.painter, this.painter.transform, this.showCollisionBoxes, l, this._crossSourceCollisions, this.painter.replacementSource);
                    if (h && (this._placementDirty = h.needsRerender), this.style && this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showParseStatus: this.showParseStatus,
                        wireframe: {
                            terrain: this.showTerrainWireframe,
                            layers2D: this.showLayers2DWireframe,
                            layers3D: this.showLayers3DWireframe
                        },
                        showOverdrawInspector: this._showOverdrawInspector,
                        showQueryGeometry: !!this._showQueryGeometry,
                        showTileAABBs: this.showTileAABBs,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: l,
                        isInitialLoad: this._isInitialLoad,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer"),
                        gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"),
                        speedIndexTiming: this.speedIndexTiming
                    }), this.fire(new e.x("render")), this.loaded() && !this._loaded && (this._loaded = !0, o.mark(i.load), this.fire(new e.x("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), r) {
                        const t1 = e.q.now() - a;
                        n.endQuery(s.TIME_ELAPSED_EXT), setTimeout(()=>{
                            const i = n.getQueryParameter(r, n.QUERY_RESULT) / 1e6;
                            n.deleteQuery(r), this.fire(new e.x("gpu-timing-frame", {
                                cpuTime: t1,
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        const t1 = this.painter.collectGpuTimers();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimers(t1);
                            this.fire(new e.x("gpu-timing-layer", {
                                layerTimes: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-deferred-render")) {
                        const t1 = this.painter.collectDeferredRenderGpuQueries();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimeDeferredRender(t1);
                            this.fire(new e.x("gpu-timing-deferred-render", {
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    const u = this._sourcesDirty || this._styleDirty || this._placementDirty || c;
                    if (u || this._repaint) this.triggerRepaint();
                    else {
                        const t1 = this.idle();
                        if (t1 && (c = this._updateAverageElevation(a, !0)), c) this.triggerRepaint();
                        else if (this._triggerFrame(!1), t1 && (this.fire(new e.x("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
                            const t1 = this._calculateSpeedIndex();
                            this.fire(new e.x("speedindexcompleted", {
                                speedIndex: t1
                            })), this.speedIndexTiming = !1;
                        }
                    }
                    !this._loaded || this._fullyLoaded || u || (this._fullyLoaded = !0, o.mark(i.fullLoad), this._performanceMetricsCollection && k(this._requestManager._customAccessToken, {
                        width: this.painter.width,
                        height: this.painter.height,
                        interactionRange: this._interactionRange,
                        visibilityHidden: this._visibilityHidden,
                        terrainEnabled: !!this.painter.style.getTerrain(),
                        fogEnabled: !!this.painter.style.getFog(),
                        projection: this.getProjection().name,
                        zoom: this.transform.zoom,
                        renderer: this.painter.context.renderer,
                        vendor: this.painter.context.vendor
                    }), this._authenticate());
                }
                _forceMarkerAndPopupUpdate(e) {
                    for (const t1 of this._markers)e && !this.getRenderWorldCopies() && (t1._lngLat = t1._lngLat.wrap()), t1._update();
                    for (const t1 of this._popups)!e || this.getRenderWorldCopies() || t1._trackPointer || (t1._lngLat = t1._lngLat.wrap()), t1._update();
                }
                _updateAverageElevation(e, t1 = !1) {
                    const i = (e)=>(this.transform.averageElevation = e, this._update(!1), !0);
                    if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i(0);
                    const o = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
                    if (o || (t1 || e - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e)) {
                        const t1 = this.transform.averageElevation;
                        let r = this.transform.sampleAverageElevation();
                        null != this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(r) ? r = 0 : this._averageElevationLastSampledAt = e;
                        const s = Math.abs(t1 - r);
                        if (s > 1) {
                            if (this._isInitialLoad || o) return this._averageElevation.jumpTo(r), i(r);
                            this._averageElevation.easeTo(r, e, 300);
                        } else if (s > 1e-4) return this._averageElevation.jumpTo(r), i(r);
                    }
                    return !!this._averageElevation.isEasing(e) && i(this._averageElevation.getValue(e));
                }
                _authenticate() {
                    N(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t1)=>{
                        if (t1 && (t1.message === w || 401 === t1.status)) {
                            const t1 = this.painter.context.gl;
                            G(t1, !1), this._logoControl instanceof Cn && this._logoControl._updateLogo(), t1 && t1.clear(t1.DEPTH_BUFFER_BIT | t1.COLOR_BUFFER_BIT | t1.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e.t(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                        }
                    }), M(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, ()=>{});
                }
                _postStyleLoadEvent() {
                    this.style.globalId && O(this._requestManager._customAccessToken, {
                        map: this,
                        skuToken: this._requestManager._skuToken,
                        style: this.style.globalId,
                        importedStyles: this.style.getImportGlobalIds()
                    });
                }
                _updateTerrain() {
                    const e = this._isDragging();
                    this.painter.updateTerrain(this.style, e);
                }
                _calculateSpeedIndex() {
                    const e = this.painter.canvasCopy(), t1 = this.painter.getCanvasCopiesAndTimestamps();
                    t1.timeStamps.push(performance.now());
                    const i = this.painter.context.gl, o = i.createFramebuffer();
                    function r(e) {
                        i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e, 0);
                        const t1 = new Uint8Array(i.drawingBufferWidth * i.drawingBufferHeight * 4);
                        return i.readPixels(0, 0, i.drawingBufferWidth, i.drawingBufferHeight, i.RGBA, i.UNSIGNED_BYTE, t1), t1;
                    }
                    return i.bindFramebuffer(i.FRAMEBUFFER, o), this._canvasPixelComparison(r(e), t1.canvasCopies.map(r), t1.timeStamps);
                }
                _canvasPixelComparison(e, t1, i) {
                    let o = i[1] - i[0];
                    const r = e.length / 4;
                    for(let s = 0; s < t1.length; s++){
                        const a = t1[s];
                        let n = 0;
                        for(let t1 = 0; t1 < a.length; t1 += 4)a[t1] === e[t1] && a[t1 + 1] === e[t1 + 1] && a[t1 + 2] === e[t1 + 2] && a[t1 + 3] === e[t1 + 3] && (n += 1);
                        o += (i[s + 2] - i[s + 1]) * (1 - n / r);
                    }
                    return o;
                }
                remove() {
                    this._hash && this._hash.remove();
                    for (const e of this._controls)e.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), window.removeEventListener("resize", this._onWindowResize, !1), window.removeEventListener("orientationchange", this._onWindowResize, !1), window.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.removeEventListener("online", this._onWindowOnline, !1), window.removeEventListener("visibilitychange", this._onVisibilityChange, !1);
                    const t1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    t1 && t1.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, !1), U.delete(this.painter.context.gl), B.remove(), P.remove(), this._removed = !0, this.fire(new e.x("remove"));
                }
                triggerRepaint() {
                    this._triggerFrame(!0);
                }
                _triggerFrame(t1) {
                    this._renderNextFrame = this._renderNextFrame || t1, this.style && !this._frame && (this._frame = e.q.frame((e)=>{
                        const t1 = !!this._renderNextFrame;
                        this._frame = null, this._renderNextFrame = null, t1 && this._render(e);
                    }));
                }
                _preloadTiles(t1) {
                    const i = this.style ? this.style.getSourceCaches() : [];
                    return e.bf(i, (e, i)=>e._preloadTiles(t1, i), ()=>{
                        this.triggerRepaint();
                    }), this;
                }
                _onWindowOnline() {
                    this._update();
                }
                _onWindowResize(e) {
                    this._trackResize && this.resize({
                        originalEvent: e
                    })._update();
                }
                _onVisibilityChange() {
                    "hidden" === document.visibilityState && this._visibilityHidden++;
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(e) {
                    this._showTileBoundaries !== e && (this._showTileBoundaries = e, this._tp.refreshUI(), this._update());
                }
                get showParseStatus() {
                    return !!this._showParseStatus;
                }
                set showParseStatus(e) {
                    this._showParseStatus !== e && (this._showParseStatus = e, this._tp.refreshUI(), this._update());
                }
                get showTerrainWireframe() {
                    return !!this._showTerrainWireframe;
                }
                set showTerrainWireframe(e) {
                    this._showTerrainWireframe !== e && (this._showTerrainWireframe = e, this._tp.refreshUI(), this._update());
                }
                get showLayers2DWireframe() {
                    return !!this._showLayers2DWireframe;
                }
                set showLayers2DWireframe(e) {
                    this._showLayers2DWireframe !== e && (this._showLayers2DWireframe = e, this._tp.refreshUI(), this._update());
                }
                get showLayers3DWireframe() {
                    return !!this._showLayers3DWireframe;
                }
                set showLayers3DWireframe(e) {
                    this._showLayers3DWireframe !== e && (this._showLayers3DWireframe = e, this._tp.refreshUI(), this._update());
                }
                get speedIndexTiming() {
                    return !!this._speedIndexTiming;
                }
                set speedIndexTiming(e) {
                    this._speedIndexTiming !== e && (this._speedIndexTiming = e, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(e) {
                    this._showPadding !== e && (this._showPadding = e, this._tp.refreshUI(), this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(e) {
                    this._showCollisionBoxes !== e && (this._showCollisionBoxes = e, this._tp.refreshUI(), e ? this.style._generateCollisionBoxes() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(e) {
                    this._showOverdrawInspector !== e && (this._showOverdrawInspector = e, this._tp.refreshUI(), this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(e) {
                    this._repaint !== e && (this._repaint = e, this._tp.refreshUI(), this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(e) {
                    this._vertices = e, this._update();
                }
                get showTileAABBs() {
                    return !!this._showTileAABBs;
                }
                set showTileAABBs(e) {
                    this._showTileAABBs !== e && (this._showTileAABBs = e, this._tp.refreshUI(), e && this._update());
                }
                _setCacheLimits(t1, i) {
                    e.dy(t1, i);
                }
                get version() {
                    return t1;
                }
            },
            NavigationControl: class {
                constructor(t1 = {}){
                    this.options = e.l({}, Pn, t1), this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e)=>e.preventDefault()), this.options.showZoom && (e.aJ([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e)=>{
                        this._map && this._map.zoomIn({}, {
                            originalEvent: e
                        });
                    }), l("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e)=>{
                        this._map && this._map.zoomOut({}, {
                            originalEvent: e
                        });
                    }), l("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e.aJ([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e)=>{
                        const t1 = this._map;
                        t1 && (this.options.visualizePitch ? t1.resetNorthPitch({}, {
                            originalEvent: e
                        }) : t1.resetNorth({}, {
                            originalEvent: e
                        }));
                    }), this._compassIcon = l("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
                _updateZoomButtons() {
                    const e = this._map;
                    if (!e) return;
                    const t1 = e.getZoom(), i = t1 === e.getMaxZoom(), o = t1 === e.getMinZoom();
                    this._zoomInButton.disabled = i, this._zoomOutButton.disabled = o, this._zoomInButton.setAttribute("aria-disabled", i.toString()), this._zoomOutButton.setAttribute("aria-disabled", o.toString());
                }
                _rotateCompassArrow() {
                    const e = this._map;
                    if (!e) return;
                    const t1 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${e.transform.pitch}deg) rotateZ(${e.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e.transform.angle * (180 / Math.PI)}deg)`;
                    e._requestDomTask(()=>{
                        this._compassIcon && (this._compassIcon.style.transform = t1);
                    });
                }
                onAdd(e) {
                    return this._map = e, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e.on("pitch", this._rotateCompassArrow), e.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Mn(e, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    const e = this._map;
                    e && (this._container.remove(), this.options.showZoom && e.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e.off("pitch", this._rotateCompassArrow), e.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
                }
                _createButton(e, t1) {
                    const i = l("button", e, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e, t1) {
                    if (!this._map) return;
                    const i = this._map._getUIString(`NavigationControl.${t1}`);
                    e.setAttribute("aria-label", i), e.firstElementChild && e.firstElementChild.setAttribute("title", i);
                }
            },
            GeolocateControl: class extends e.E {
                constructor(t1 = {}){
                    super();
                    const i = navigator.geolocation;
                    this.options = e.l({
                        geolocation: i
                    }, kn, t1), e.aJ([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker",
                        "_updateMarkerRotation",
                        "_onDeviceOrientation"
                    ], this), this._updateMarkerRotationThrottled = Ta(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
                }
                onAdd(e) {
                    return this._map = e, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
                }
                onRemove() {
                    void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
                }
                _checkGeolocationSupport(e) {
                    const t1 = (t1 = !!this.options.geolocation)=>{
                        this._supportsGeolocation = t1, e(t1);
                    };
                    void 0 !== this._supportsGeolocation ? e(this._supportsGeolocation) : void 0 !== navigator.permissions ? navigator.permissions.query({
                        name: "geolocation"
                    }).then((e)=>t1("denied" !== e.state)).catch(()=>t1()) : t1();
                }
                _isOutOfMapMaxBounds(e) {
                    const t1 = this._map.getMaxBounds(), i = e.coords;
                    return !!t1 && (i.longitude < t1.getWest() || i.longitude > t1.getEast() || i.latitude < t1.getSouth() || i.latitude > t1.getNorth());
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                            break;
                        case "ACTIVE_LOCK":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                            break;
                        case "BACKGROUND":
                            this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                    }
                }
                _onSuccess(t1) {
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(t1)) return this._setErrorState(), this.fire(new e.x("outofmaxbounds", t1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = t1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(t1), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.x("geolocate", t1)), this._finish();
                    }
                }
                _updateCamera(t1) {
                    const i = new e.bK(t1.coords.longitude, t1.coords.latitude), o = t1.coords.accuracy, r = this._map.getBearing(), s = e.l({
                        bearing: r
                    }, this.options.fitBoundsOptions);
                    this._map.fitBounds(i.toBounds(o), s, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(t1) {
                    if (t1) {
                        const i = new e.bK(t1.coords.longitude, t1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = t1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const t1 = this._map.transform, i = e.bD(1, t1._center.lat) * t1.worldSize, o = Math.ceil(2 * this._accuracy * i);
                    this._circleElement.style.width = `${o}px`, this._circleElement.style.height = `${o}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _updateMarkerRotation() {
                    this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
                }
                _onError(t1) {
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === t1.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const e = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.setAttribute("aria-label", e), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === t1.code && this._noTimeout) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.x("error", t1)), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _setupUI(t1) {
                    if (void 0 !== this._map) {
                        if (this._container.addEventListener("contextmenu", (e)=>e.preventDefault()), this._geolocateButton = l("button", "mapboxgl-ctrl-geolocate", this._container), l("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === t1) {
                            e.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const t1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.setAttribute("aria-label", t1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t1);
                        } else {
                            const e = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.setAttribute("aria-label", e), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = l("div", "mapboxgl-user-location"), this._dotElement.appendChild(l("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(l("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new Fn({
                            element: this._dotElement,
                            rotationAlignment: "map",
                            pitchAlignment: "map"
                        }), this._circleElement = l("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Fn({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (t1)=>{
                            t1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t1.originalEvent && "resize" === t1.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new e.x("trackuserlocationend")));
                        });
                    }
                }
                _onDeviceOrientation(e) {
                    this._userLocationDotMarker && (e.webkitCompassHeading ? this._heading = e.webkitCompassHeading : !0 === e.absolute && (this._heading = -1 * e.alpha), this._updateMarkerRotationThrottled());
                }
                trigger() {
                    if (!this._setup) return e.w("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._watchState = "WAITING_ACTIVE", this.fire(new e.x("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                this._numberOfWatches--, this._noTimeout = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new e.x("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e.x("trackuserlocationstart"));
                        }
                        switch(this._watchState){
                            case "WAITING_ACTIVE":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_LOCK":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                break;
                            case "BACKGROUND":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                break;
                            case "BACKGROUND_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let e;
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, this._noTimeout = !0) : (e = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e), this.options.showUserHeading && this._addDeviceOrientationListener();
                        }
                    } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = window.setTimeout(this._finish, 1e4);
                    return !0;
                }
                _addDeviceOrientationListener() {
                    const e = ()=>{
                        "ondeviceorientationabsolute" in window ? window.addEventListener("deviceorientationabsolute", this._onDeviceOrientation) : window.addEventListener("deviceorientation", this._onDeviceOrientation);
                    };
                    "undefined" != typeof DeviceMotionEvent && "function" == typeof DeviceMotionEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((t1)=>{
                        "granted" === t1 && e();
                    }).catch(console.error) : e();
                }
                _clearWatch() {
                    this.options.geolocation.clearWatch(this._geolocationWatchID), window.removeEventListener("deviceorientation", this._onDeviceOrientation), window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
            },
            AttributionControl: En,
            ScaleControl: class {
                constructor(t1 = {}){
                    this.options = e.l({}, Bn, t1), this._isNumberFormatSupported = function() {
                        try {
                            return new Intl.NumberFormat("en", {
                                style: "unit",
                                unitDisplay: "short",
                                unit: "meter"
                            }), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), e.aJ([
                        "_update",
                        "_setScale",
                        "setUnit"
                    ], this);
                }
                getDefaultPosition() {
                    return "bottom-left";
                }
                _update() {
                    const e = this.options.maxWidth || 100, t1 = this._map, i = t1._containerHeight / 2, o = t1._containerWidth / 2 - e / 2, r = t1.unproject([
                        o,
                        i
                    ]), s = t1.unproject([
                        o + e,
                        i
                    ]), a = r.distanceTo(s);
                    if ("imperial" === this.options.unit) {
                        const t1 = 3.2808 * a;
                        t1 > 5280 ? this._setScale(e, t1 / 5280, "mile") : this._setScale(e, t1, "foot");
                    } else "nautical" === this.options.unit ? this._setScale(e, a / 1852, "nautical-mile") : a >= 1e3 ? this._setScale(e, a / 1e3, "kilometer") : this._setScale(e, a, "meter");
                }
                _setScale(e, t1, i) {
                    this._map._requestDomTask(()=>{
                        const o = function(e) {
                            const t1 = Math.pow(10, `${Math.floor(e)}`.length - 1);
                            let i = e / t1;
                            return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e) {
                                const t1 = Math.pow(10, Math.ceil(-Math.log(e) / Math.LN10));
                                return Math.round(e * t1) / t1;
                            }(i), t1 * i;
                        }(t1), r = o / t1;
                        this._container.innerHTML = this._isNumberFormatSupported && "nautical-mile" !== i ? new Intl.NumberFormat(this._language, {
                            style: "unit",
                            unitDisplay: "short",
                            unit: i
                        }).format(o) : `${o}&nbsp;${Nn[i]}`, this._container.style.width = e * r + "px";
                    });
                }
                onAdd(e) {
                    return this._map = e, this._language = e.getLanguage(), this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
                }
                onRemove() {
                    this._container.remove(), this._map.off("move", this._update), this._map = void 0;
                }
                _setLanguage(e) {
                    this._language = e, this._update();
                }
                setUnit(e) {
                    this.options.unit = e, this._update();
                }
            },
            FullscreenControl: class {
                constructor(t1 = {}){
                    this._fullscreen = !1, t1 && t1.container && (t1.container instanceof HTMLElement ? this._container = t1.container : e.w("Full screen control 'container' must be a DOM element.")), e.aJ([
                        "_onClickFullscreen",
                        "_changeIcon"
                    ], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in document && (this._fullscreenchange = "webkitfullscreenchange");
                }
                onAdd(t1) {
                    return this._map = t1, this._container || (this._container = this._map.getContainer()), this._controlContainer = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e.w("This device does not support fullscreen mode.")), this._controlContainer;
                }
                onRemove() {
                    this._controlContainer.remove(), this._map = null, document.removeEventListener(this._fullscreenchange, this._changeIcon);
                }
                _checkFullscreenSupport() {
                    return !(!document.fullscreenEnabled && !document.webkitFullscreenEnabled);
                }
                _setupUI() {
                    const e = this._fullscreenButton = l("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                    l("span", "mapboxgl-ctrl-icon", e).setAttribute("aria-hidden", "true"), e.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), document.addEventListener(this._fullscreenchange, this._changeIcon);
                }
                _updateTitle() {
                    const e = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", e), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e);
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _changeIcon() {
                    (document.fullscreenElement || document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                }
                _onClickFullscreen() {
                    this._isFullscreen() ? document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                }
            },
            Popup: class extends e.E {
                constructor(t1){
                    super(), this.options = e.l(Object.create(Un), t1), e.aJ([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseEvent"
                    ], this), this._classList = new Set(t1 && t1.className ? t1.className.trim().split(/\s+/) : []);
                }
                addTo(t1) {
                    return this._map && this.remove(), this._map = t1, this.options.closeOnClick && t1.on("preclick", this._onClose), this.options.closeOnMove && t1.on("move", this._onClose), t1.on("remove", this.remove), this._update(), t1._addPopup(this), this._focusFirstElement(), this._trackPointer ? (t1.on("mousemove", this._onMouseEvent), t1.on("mouseup", this._onMouseEvent), t1._canvasContainer.classList.add("mapboxgl-track-pointer")) : t1.on("move", this._update), this.fire(new e.x("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
                    const t1 = this._map;
                    return t1 && (t1.off("move", this._update), t1.off("move", this._onClose), t1.off("preclick", this._onClose), t1.off("click", this._onClose), t1.off("remove", this.remove), t1.off("mousemove", this._onMouseEvent), t1.off("mouseup", this._onMouseEvent), t1.off("drag", this._onMouseEvent), t1._canvasContainer && t1._canvasContainer.classList.remove("mapboxgl-track-pointer"), t1._removePopup(this), this._map = void 0), this.fire(new e.x("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(t1) {
                    this._lngLat = e.bK.convert(t1), this._pos = null, this._trackPointer = !1, this._update();
                    const i = this._map;
                    return i && (i.on("move", this._update), i.off("mousemove", this._onMouseEvent), i._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                }
                trackPointer() {
                    this._trackPointer = !0, this._pos = null, this._update();
                    const e = this._map;
                    return e && (e.off("move", this._update), e.on("mousemove", this._onMouseEvent), e.on("drag", this._onMouseEvent), e._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(e) {
                    return this.setDOMContent(document.createTextNode(e));
                }
                setHTML(e) {
                    const t1 = document.createDocumentFragment(), i = document.createElement("body");
                    let o;
                    for(i.innerHTML = e; o = i.firstChild, o;)t1.appendChild(o);
                    return this.setDOMContent(t1);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(e) {
                    return this.options.maxWidth = e, this._update(), this;
                }
                setDOMContent(e) {
                    let t1 = this._content;
                    if (t1) for(; t1.hasChildNodes();)t1.firstChild && t1.removeChild(t1.firstChild);
                    else t1 = this._content = l("div", "mapboxgl-popup-content", this._container || void 0);
                    if (t1.appendChild(e), this.options.closeButton) {
                        const e = this._closeButton = l("button", "mapboxgl-popup-close-button", t1);
                        e.type = "button", e.setAttribute("aria-label", "Close popup"), e.setAttribute("aria-hidden", "true"), e.innerHTML = "&#215;", e.addEventListener("click", this._onClose);
                    }
                    return this._update(), this._focusFirstElement(), this;
                }
                addClassName(e) {
                    return this._classList.add(e), this._updateClassList(), this;
                }
                removeClassName(e) {
                    return this._classList.delete(e), this._updateClassList(), this;
                }
                setOffset(e) {
                    return this.options.offset = e, this._update(), this;
                }
                toggleClassName(e) {
                    let t1;
                    return this._classList.delete(e) ? t1 = !1 : (this._classList.add(e), t1 = !0), this._updateClassList(), t1;
                }
                _onMouseEvent(e) {
                    this._update(e.point);
                }
                _getAnchor(e) {
                    if (this.options.anchor) return this.options.anchor;
                    const t1 = this._map, i = this._container, o = this._pos;
                    if (!t1 || !i || !o) return "bottom";
                    const r = i.offsetWidth, s = i.offsetHeight, a = o.x < r / 2, n = o.x > t1.transform.width - r / 2;
                    if (o.y + e < s) return a ? "top-left" : n ? "top-right" : "top";
                    if (o.y > t1.transform.height - s) {
                        if (a) return "bottom-left";
                        if (n) return "bottom-right";
                    }
                    return a ? "left" : n ? "right" : "bottom";
                }
                _updateClassList() {
                    const e = this._container;
                    if (!e) return;
                    const t1 = [
                        ...this._classList
                    ];
                    t1.push("mapboxgl-popup"), this._anchor && t1.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t1.push("mapboxgl-popup-track-pointer"), e.className = t1.join(" ");
                }
                _update(t1) {
                    const i = this._map, o = this._content;
                    if (!i || !this._lngLat && !this._trackPointer || !o) return;
                    let r = this._container;
                    if (r || (r = this._container = l("div", "mapboxgl-popup", i.getContainer()), this._tip = l("div", "mapboxgl-popup-tip", r), r.appendChild(o)), this.options.maxWidth && r.style.maxWidth !== this.options.maxWidth && (r.style.maxWidth = this.options.maxWidth), i.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = zn(this._lngLat, this._pos, i.transform)), !this._trackPointer || t1) {
                        const o = this._pos = this._trackPointer && t1 instanceof e.P ? t1 : i.project(this._lngLat), r = jn(this.options.offset), s = this._anchor = this._getAnchor(r.y), a = jn(this.options.offset, s), n = o.add(a).round();
                        i._requestDomTask(()=>{
                            this._container && s && (this._container.style.transform = `${On[s]} translate(${n.x}px,${n.y}px)`);
                        });
                    }
                    if (!this._marker && i._showingGlobe()) {
                        const t1 = e.dz(i.transform, this._lngLat) ? 0 : 1;
                        this._setOpacity(t1);
                    }
                    this._updateClassList();
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const e = this._container.querySelector(Gn);
                    e && e.focus();
                }
                _onClose() {
                    this.remove();
                }
                _setOpacity(e) {
                    this._container && (this._container.style.opacity = `${e}`), this._content && (this._content.style.pointerEvents = e ? "auto" : "none");
                }
            },
            Marker: Fn,
            Style: co,
            LngLat: e.bK,
            LngLatBounds: e.as,
            Point: e.P,
            MercatorCoordinate: e.a5,
            FreeCameraOptions: Ui,
            Evented: e.E,
            config: e.e,
            prewarm: e.dE,
            clearPrewarmedResources: e.dF,
            get accessToken () {
                return e.e.ACCESS_TOKEN;
            },
            set accessToken (t){
                e.e.ACCESS_TOKEN = t;
            },
            get baseApiUrl () {
                return e.e.API_URL;
            },
            set baseApiUrl (t){
                e.e.API_URL = t;
            },
            get workerCount () {
                return e.dG.workerCount;
            },
            set workerCount (t){
                e.dG.workerCount = t;
            },
            get maxParallelImageRequests () {
                return e.e.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (t){
                e.e.MAX_PARALLEL_IMAGE_REQUESTS = t;
            },
            clearStorage (t1) {
                e.dH(t1);
            },
            get workerUrl () {
                return e.dI.workerUrl;
            },
            set workerUrl (t){
                e.dI.workerUrl = t;
            },
            get workerClass () {
                return e.dI.workerClass;
            },
            set workerClass (t){
                e.dI.workerClass = t;
            },
            get workerParams () {
                return e.dI.workerParams;
            },
            set workerParams (t){
                e.dI.workerParams = t;
            },
            get dracoUrl () {
                return e.dJ();
            },
            set dracoUrl (t){
                e.dK(t);
            },
            get meshoptUrl () {
                return e.dL();
            },
            set meshoptUrl (t){
                e.dM(t);
            },
            setNow: e.q.setNow,
            restoreNow: e.q.restoreNow
        };
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'mapboxgl'
    var mapboxgl$1 = mapboxgl;
    return mapboxgl$1;
});


const $6f40c3a58f594b58$var$choices = new (0, $a72ba5db1effc4ca$export$2e2bcd8739ae039)("#location-filter", {
    searchEnabled: false,
    itemSelectText: ""
});
(0, (/*@__PURE__*/$parcel$interopDefault($01f711fe40ba0e9e$exports))).accessToken = "pk.eyJ1IjoibnlybmdyczI0IiwiYSI6ImNtMnV0Y3EzazA0bncyaXB6NHUzdHFoYWIifQ.SjXsvugZq6DM5ZAPauS0_Q";
const $6f40c3a58f594b58$var$map = new (0, (/*@__PURE__*/$parcel$interopDefault($01f711fe40ba0e9e$exports))).Map({
    container: "map",
    zoom: 1.5,
    center: [
        5,
        30
    ],
    style: "mapbox://styles/nyrngrs24/cm2uxzz56004i01qk0m3sh3cm",
    antialias: true,
    renderWorldCopies: false,
    dragRotate: false,
    minZoom: 1.5
});
// hide mapbox attribution
$6f40c3a58f594b58$var$map.addControl(new (0, (/*@__PURE__*/$parcel$interopDefault($01f711fe40ba0e9e$exports))).AttributionControl({
    compact: true,
    customAttribution: ""
}));
$6f40c3a58f594b58$var$map.addControl(new (0, (/*@__PURE__*/$parcel$interopDefault($01f711fe40ba0e9e$exports))).NavigationControl());
const $6f40c3a58f594b58$var$geolocate = new (0, (/*@__PURE__*/$parcel$interopDefault($01f711fe40ba0e9e$exports))).GeolocateControl({
    positionOptions: {
        enableHighAccuracy: true
    },
    trackUserLocation: true,
    fitBoundsOptions: {
        maxZoom: 8
    }
});
// Add the control to the map.
$6f40c3a58f594b58$var$map.addControl($6f40c3a58f594b58$var$geolocate);
function $6f40c3a58f594b58$var$flyToCountry(countryCode) {
    if (countryCode === "world") {
        $6f40c3a58f594b58$var$map.flyTo({
            center: [
                5,
                30
            ],
            zoom: 1.5
        });
        return;
    }
    fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${countryCode}.json?country=${countryCode}&types=country&access_token=${(0, (/*@__PURE__*/$parcel$interopDefault($01f711fe40ba0e9e$exports))).accessToken}`).then((response)=>response.json()).then((data)=>{
        if (data.features.length) {
            // const [longitude, latitude] = data.features[0].center;
            // map.flyTo({
            //     center: [longitude, latitude],
            //     zoom: 4,
            // });
            const bounds = data.features[0].bbox;
            $6f40c3a58f594b58$var$map.fitBounds([
                [
                    bounds[0],
                    bounds[1]
                ],
                [
                    bounds[2],
                    bounds[3]
                ] // northeastern corner
            ], {
                padding: 50 // adds padding around the bounds
            });
        } else console.error("Country not found");
    }).catch((error)=>console.error("Error with geocoding request:", error));
}
function $6f40c3a58f594b58$var$formatAddress(address) {
    if (!address) return "";
    // Common street abbreviations that need periods
    const streetAbbreviations = {
        " St": " St.",
        " Rd": " Rd.",
        " Dr": " Dr.",
        " Ave": " Ave.",
        " Blvd": " Blvd.",
        " Ln": " Ln.",
        " Ct": " Ct.",
        " Pl": " Pl."
    };
    // Add periods to street abbreviations
    let formattedAddress = address;
    Object.entries(streetAbbreviations).forEach(([abbr, replacement])=>{
        formattedAddress = formattedAddress.replace(new RegExp(abbr + "(?=[,]|$)", "g"), replacement);
    });
    // Split into parts
    const parts = formattedAddress.split(",");
    // Street address is first line
    const streetAddress = parts[0].trim();
    // Combine remaining parts on second line
    const locationLine = parts.slice(1).map((part)=>part.trim()).join(", ");
    return [
        streetAddress,
        locationLine
    ].filter((part)=>part.length > 0).join("<br>");
}
function $6f40c3a58f594b58$var$showIndicator(map, features) {
    // Set filter to show shadow for both hovered and active points
    map.setFilter("juggling-clubs-layer-shadow", [
        "any",
        [
            "==",
            [
                "get",
                "name"
            ],
            features.hoveredFeature
        ],
        [
            "==",
            [
                "get",
                "name"
            ],
            features.activeFeature
        ]
    ]);
    // Set dynamic circle radius based on state
    map.setPaintProperty("juggling-clubs-layer-shadow", "circle-radius", [
        "case",
        [
            "==",
            [
                "get",
                "name"
            ],
            features.activeFeature
        ],
        15,
        [
            "==",
            [
                "get",
                "name"
            ],
            features.hoveredFeature
        ],
        12,
        10 // Default radius
    ]);
    // map.setPaintProperty('juggling-clubs-layer-shadow', 'circle-opacity',
    //     ['case',
    //         ['==', ['get', 'name'], features.activeFeature], 0.35,
    //         ['==', ['get', 'name'], features.hoveredFeature], 0.25,
    //         0
    //     ]
    // );
    // Set dynamic blur based on state
    map.setPaintProperty("juggling-clubs-layer-shadow", "circle-blur", [
        "case",
        [
            "==",
            [
                "get",
                "name"
            ],
            features.activeFeature
        ],
        0.6,
        [
            "==",
            [
                "get",
                "name"
            ],
            features.hoveredFeature
        ],
        0.5,
        0.5
    ]);
}
let $6f40c3a58f594b58$var$activeFeatureIndex = null;
let $6f40c3a58f594b58$var$hoveredFeatureIndex = null;
$6f40c3a58f594b58$var$map.on("load", ()=>{
    $6f40c3a58f594b58$var$geolocate.trigger();
    $6f40c3a58f594b58$var$map.setLayoutProperty("water-point-label", "visibility", "none");
    $6f40c3a58f594b58$var$map.setLayoutProperty("water-line-label", "visibility", "none");
    $6f40c3a58f594b58$var$map.setLayoutProperty("continent-label", "visibility", "none");
    $6f40c3a58f594b58$var$map.setLayoutProperty("country-label", "visibility", "none");
    $6f40c3a58f594b58$var$map.on("zoom", ()=>{
        if ($6f40c3a58f594b58$var$map.getZoom() > 3) $6f40c3a58f594b58$var$map.setLayoutProperty("country-label", "visibility", "visible");
        else $6f40c3a58f594b58$var$map.setLayoutProperty("country-label", "visibility", "none");
    });
    $6f40c3a58f594b58$var$map.addSource("juggling-clubs", {
        type: "geojson",
        data: "data/jugglingclubs.geojson"
    });
    $6f40c3a58f594b58$var$map.addLayer({
        "id": "juggling-clubs-layer-shadow",
        "type": "circle",
        "source": "juggling-clubs",
        "paint": {
            "circle-radius": 12,
            "circle-color": "rgba(0, 0, 0, 0.25)",
            "circle-blur": 0.5,
            "circle-translate": [
                0,
                0
            ],
            "circle-radius-transition": {
                duration: 300,
                delay: 0
            },
            "circle-blur-transition": {
                duration: 300,
                delay: 0
            }
        }
    });
    $6f40c3a58f594b58$var$map.addLayer({
        "id": "juggling-clubs-layer",
        "type": "circle",
        "source": "juggling-clubs",
        "paint": {
            "circle-radius": [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "zoom"
                ],
                // zoom level : circle radius
                1.5,
                8,
                4,
                12,
                8,
                16
            ],
            "circle-color": [
                "get",
                "color"
            ],
            "circle-stroke-width": 1,
            "circle-stroke-color": "#ffffff",
            "circle-opacity": 0.9
        }
    });
    $6f40c3a58f594b58$var$map.on("mouseenter", "juggling-clubs-layer", (e)=>{
        $6f40c3a58f594b58$var$map.getCanvas().style.cursor = "pointer";
        $6f40c3a58f594b58$var$hoveredFeatureIndex = e.features[0].properties.name;
        $6f40c3a58f594b58$var$showIndicator($6f40c3a58f594b58$var$map, {
            hoveredFeature: $6f40c3a58f594b58$var$hoveredFeatureIndex,
            activeFeature: $6f40c3a58f594b58$var$activeFeatureIndex
        });
    });
    $6f40c3a58f594b58$var$map.on("click", "juggling-clubs-layer", (e)=>{
        const coordinates = e.features[0].geometry.coordinates.slice();
        const details = e.features[0].properties;
        const address = $6f40c3a58f594b58$var$formatAddress(details.address);
        const popup = `
            <header class="popup__header">
                <h3 class="popup__title">${details.name}</h3>
            </header>
            <div class="popup__body">
                <div class="popup__address">${address}</div>
                <div class="links">
                    <a class="button button--small" href="${details.website}" target="_blank">View Website</a>
                </div>
                <div class="popup__last_updated"><strong>Last reported active</strong>: <br/>${details.last_updated}</div>
            </div>`;
        if ([
            "mercator",
            "equirectangular"
        ].includes($6f40c3a58f594b58$var$map.getProjection().name)) while(Math.abs(e.lngLat.lng - coordinates[0]) > 180)coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        $6f40c3a58f594b58$var$activeFeatureIndex = e.features[0].properties.name;
        $6f40c3a58f594b58$var$showIndicator($6f40c3a58f594b58$var$map, {
            hoveredFeature: $6f40c3a58f594b58$var$hoveredFeatureIndex,
            activeFeature: $6f40c3a58f594b58$var$activeFeatureIndex
        });
        new (0, (/*@__PURE__*/$parcel$interopDefault($01f711fe40ba0e9e$exports))).Popup({
            maxWidth: 400
        }).setLngLat(coordinates).setHTML(popup).on("close", ()=>{
            $6f40c3a58f594b58$var$activeFeatureIndex = null;
            $6f40c3a58f594b58$var$showIndicator($6f40c3a58f594b58$var$map, {
                hoveredFeature: $6f40c3a58f594b58$var$hoveredFeatureIndex,
                activeFeature: null
            });
        }).addTo($6f40c3a58f594b58$var$map);
    });
    // Change it back to a pointer when it leaves.
    $6f40c3a58f594b58$var$map.on("mouseleave", "juggling-clubs-layer", (e)=>{
        $6f40c3a58f594b58$var$map.getCanvas().style.cursor = "";
        $6f40c3a58f594b58$var$map.getCanvas().style.cursor = "";
        $6f40c3a58f594b58$var$hoveredFeatureIndex = null;
        $6f40c3a58f594b58$var$showIndicator($6f40c3a58f594b58$var$map, {
            hoveredFeature: null,
            activeFeature: $6f40c3a58f594b58$var$activeFeatureIndex
        });
    });
    const $countrySelect = document.getElementById("location-filter");
    const selectedCountryCode = $countrySelect.value;
    if (selectedCountryCode) $6f40c3a58f594b58$var$flyToCountry(selectedCountryCode);
    document.getElementById("location-filter").addEventListener("change", (e)=>{
        $6f40c3a58f594b58$var$flyToCountry(e.target.value);
    });
});


//# sourceMappingURL=index.b6ba87d6.js.map
